'use client';
var ja = Object.defineProperty;
var Ra = (Kt) => {
  throw TypeError(Kt);
};
var Da = (Kt, uo, ho) => uo in Kt ? ja(Kt, uo, { enumerable: !0, configurable: !0, writable: !0, value: ho }) : Kt[uo] = ho;
var ba = (Kt, uo, ho) => Da(Kt, typeof uo != "symbol" ? uo + "" : uo, ho), _a = (Kt, uo, ho) => uo.has(Kt) || Ra("Cannot " + ho);
var xs = (Kt, uo, ho) => (_a(Kt, uo, "read from private field"), ho ? ho.call(Kt) : uo.get(Kt)), ra = (Kt, uo, ho) => uo.has(Kt) ? Ra("Cannot add the same private member more than once") : uo instanceof WeakSet ? uo.add(Kt) : uo.set(Kt, ho), As = (Kt, uo, ho, go) => (_a(Kt, uo, "write to private field"), go ? go.call(Kt, ho) : uo.set(Kt, ho), ho);
import * as React$1 from "react";
import React__default, { useLayoutEffect, useEffect, useState, forwardRef as forwardRef$1, useContext, Children, isValidElement, cloneElement, createElement, useRef, useMemo, Fragment, PureComponent, useImperativeHandle, useCallback, createContext, Component } from "react";
import * as ReactDOM from "react-dom";
import ReactDOM__default from "react-dom";
import { utils, IovCollection } from "@skylineos/clsp-player";
import ReactHlsPlayer from "react-hls-player";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function getDefaultExportFromCjs(Kt) {
  return Kt && Kt.__esModule && Object.prototype.hasOwnProperty.call(Kt, "default") ? Kt.default : Kt;
}
var jsxRuntime = { exports: {} }, reactJsxRuntime_production = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var Kt = Symbol.for("react.transitional.element"), uo = Symbol.for("react.fragment");
  function ho(go, bo, vo) {
    var Po = null;
    if (vo !== void 0 && (Po = "" + vo), bo.key !== void 0 && (Po = "" + bo.key), "key" in bo) {
      vo = {};
      for (var Co in bo)
        Co !== "key" && (vo[Co] = bo[Co]);
    } else vo = bo;
    return bo = vo.ref, {
      $$typeof: Kt,
      type: go,
      key: Po,
      ref: bo !== void 0 ? bo : null,
      props: vo
    };
  }
  return reactJsxRuntime_production.Fragment = uo, reactJsxRuntime_production.jsx = ho, reactJsxRuntime_production.jsxs = ho, reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  return hasRequiredReactJsxRuntime_development || (hasRequiredReactJsxRuntime_development = 1, process.env.NODE_ENV !== "production" && function() {
    function Kt(Ti) {
      if (Ti == null) return null;
      if (typeof Ti == "function")
        return Ti.$$typeof === ui ? null : Ti.displayName || Ti.name || null;
      if (typeof Ti == "string") return Ti;
      switch (Ti) {
        case Jo:
          return "Fragment";
        case No:
          return "Portal";
        case oi:
          return "Profiler";
        case ti:
          return "StrictMode";
        case ii:
          return "Suspense";
        case ai:
          return "SuspenseList";
      }
      if (typeof Ti == "object")
        switch (typeof Ti.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), Ti.$$typeof) {
          case Zo:
            return (Ti.displayName || "Context") + ".Provider";
          case Qo:
            return (Ti._context.displayName || "Context") + ".Consumer";
          case ei:
            var _i = Ti.render;
            return Ti = Ti.displayName, Ti || (Ti = _i.displayName || _i.name || "", Ti = Ti !== "" ? "ForwardRef(" + Ti + ")" : "ForwardRef"), Ti;
          case ri:
            return _i = Ti.displayName || null, _i !== null ? _i : Kt(Ti.type) || "Memo";
          case ni:
            _i = Ti._payload, Ti = Ti._init;
            try {
              return Kt(Ti(_i));
            } catch {
            }
        }
      return null;
    }
    function uo(Ti) {
      return "" + Ti;
    }
    function ho(Ti) {
      try {
        uo(Ti);
        var _i = !1;
      } catch {
        _i = !0;
      }
      if (_i) {
        _i = console;
        var Vi = _i.error, Bi = typeof Symbol == "function" && Symbol.toStringTag && Ti[Symbol.toStringTag] || Ti.constructor.name || "Object";
        return Vi.call(
          _i,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          Bi
        ), uo(Ti);
      }
    }
    function go() {
    }
    function bo() {
      if (bi === 0) {
        xi = console.log, $i = console.info, Ci = console.warn, Si = console.error, vi = console.group, Pi = console.groupCollapsed, wi = console.groupEnd;
        var Ti = {
          configurable: !0,
          enumerable: !0,
          value: go,
          writable: !0
        };
        Object.defineProperties(console, {
          info: Ti,
          log: Ti,
          warn: Ti,
          error: Ti,
          group: Ti,
          groupCollapsed: Ti,
          groupEnd: Ti
        });
      }
      bi++;
    }
    function vo() {
      if (bi--, bi === 0) {
        var Ti = { configurable: !0, enumerable: !0, writable: !0 };
        Object.defineProperties(console, {
          log: yi({}, Ti, { value: xi }),
          info: yi({}, Ti, { value: $i }),
          warn: yi({}, Ti, { value: Ci }),
          error: yi({}, Ti, { value: Si }),
          group: yi({}, Ti, { value: vi }),
          groupCollapsed: yi({}, Ti, { value: Pi }),
          groupEnd: yi({}, Ti, { value: wi })
        });
      }
      0 > bi && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function Po(Ti) {
      if (gi === void 0)
        try {
          throw Error();
        } catch (Vi) {
          var _i = Vi.stack.trim().match(/\n( *(at )?)/);
          gi = _i && _i[1] || "", Ri = -1 < Vi.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < Vi.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return `
` + gi + Ti + Ri;
    }
    function Co(Ti, _i) {
      if (!Ti || Ei) return "";
      var Vi = Ni.get(Ti);
      if (Vi !== void 0) return Vi;
      Ei = !0, Vi = Error.prepareStackTrace, Error.prepareStackTrace = void 0;
      var Bi = null;
      Bi = ci.H, ci.H = null, bo();
      try {
        var Ji = {
          DetermineComponentFrameRoot: function() {
            try {
              if (_i) {
                var Hi = function() {
                  throw Error();
                };
                if (Object.defineProperty(Hi.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                }), typeof Reflect == "object" && Reflect.construct) {
                  try {
                    Reflect.construct(Hi, []);
                  } catch (Zi) {
                    var Xi = Zi;
                  }
                  Reflect.construct(Ti, [], Hi);
                } else {
                  try {
                    Hi.call();
                  } catch (Zi) {
                    Xi = Zi;
                  }
                  Ti.call(Hi.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (Zi) {
                  Xi = Zi;
                }
                (Hi = Ti()) && typeof Hi.catch == "function" && Hi.catch(function() {
                });
              }
            } catch (Zi) {
              if (Zi && Xi && typeof Zi.stack == "string")
                return [Zi.stack, Xi.stack];
            }
            return [null, null];
          }
        };
        Ji.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var Ki = Object.getOwnPropertyDescriptor(
          Ji.DetermineComponentFrameRoot,
          "name"
        );
        Ki && Ki.configurable && Object.defineProperty(
          Ji.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var qi = Ji.DetermineComponentFrameRoot(), rs = qi[0], os = qi[1];
        if (rs && os) {
          var ps = rs.split(`
`), Mi = os.split(`
`);
          for (qi = Ki = 0; Ki < ps.length && !ps[Ki].includes(
            "DetermineComponentFrameRoot"
          ); )
            Ki++;
          for (; qi < Mi.length && !Mi[qi].includes(
            "DetermineComponentFrameRoot"
          ); )
            qi++;
          if (Ki === ps.length || qi === Mi.length)
            for (Ki = ps.length - 1, qi = Mi.length - 1; 1 <= Ki && 0 <= qi && ps[Ki] !== Mi[qi]; )
              qi--;
          for (; 1 <= Ki && 0 <= qi; Ki--, qi--)
            if (ps[Ki] !== Mi[qi]) {
              if (Ki !== 1 || qi !== 1)
                do
                  if (Ki--, qi--, 0 > qi || ps[Ki] !== Mi[qi]) {
                    var Wi = `
` + ps[Ki].replace(
                      " at new ",
                      " at "
                    );
                    return Ti.displayName && Wi.includes("<anonymous>") && (Wi = Wi.replace("<anonymous>", Ti.displayName)), typeof Ti == "function" && Ni.set(Ti, Wi), Wi;
                  }
                while (1 <= Ki && 0 <= qi);
              break;
            }
        }
      } finally {
        Ei = !1, ci.H = Bi, vo(), Error.prepareStackTrace = Vi;
      }
      return ps = (ps = Ti ? Ti.displayName || Ti.name : "") ? Po(ps) : "", typeof Ti == "function" && Ni.set(Ti, ps), ps;
    }
    function So(Ti) {
      if (Ti == null) return "";
      if (typeof Ti == "function") {
        var _i = Ti.prototype;
        return Co(
          Ti,
          !(!_i || !_i.isReactComponent)
        );
      }
      if (typeof Ti == "string") return Po(Ti);
      switch (Ti) {
        case ii:
          return Po("Suspense");
        case ai:
          return Po("SuspenseList");
      }
      if (typeof Ti == "object")
        switch (Ti.$$typeof) {
          case ei:
            return Ti = Co(Ti.render, !1), Ti;
          case ri:
            return So(Ti.type);
          case ni:
            _i = Ti._payload, Ti = Ti._init;
            try {
              return So(Ti(_i));
            } catch {
            }
        }
      return "";
    }
    function wo() {
      var Ti = ci.A;
      return Ti === null ? null : Ti.getOwner();
    }
    function Eo(Ti) {
      if (fi.call(Ti, "key")) {
        var _i = Object.getOwnPropertyDescriptor(Ti, "key").get;
        if (_i && _i.isReactWarning) return !1;
      }
      return Ti.key !== void 0;
    }
    function Ro(Ti, _i) {
      function Vi() {
        Yi || (Yi = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          _i
        ));
      }
      Vi.isReactWarning = !0, Object.defineProperty(Ti, "key", {
        get: Vi,
        configurable: !0
      });
    }
    function _o() {
      var Ti = Kt(this.type);
      return Ui[Ti] || (Ui[Ti] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), Ti = this.props.ref, Ti !== void 0 ? Ti : null;
    }
    function Io(Ti, _i, Vi, Bi, Ji, Ki) {
      return Vi = Ki.ref, Ti = {
        $$typeof: Ko,
        type: Ti,
        key: _i,
        props: Ki,
        _owner: Ji
      }, (Vi !== void 0 ? Vi : null) !== null ? Object.defineProperty(Ti, "ref", {
        enumerable: !1,
        get: _o
      }) : Object.defineProperty(Ti, "ref", { enumerable: !1, value: null }), Ti._store = {}, Object.defineProperty(Ti._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(Ti, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.freeze && (Object.freeze(Ti.props), Object.freeze(Ti)), Ti;
    }
    function Ao(Ti, _i, Vi, Bi, Ji, Ki) {
      if (typeof Ti == "string" || typeof Ti == "function" || Ti === Jo || Ti === oi || Ti === ti || Ti === ii || Ti === ai || Ti === si || typeof Ti == "object" && Ti !== null && (Ti.$$typeof === ni || Ti.$$typeof === ri || Ti.$$typeof === Zo || Ti.$$typeof === Qo || Ti.$$typeof === ei || Ti.$$typeof === hi || Ti.getModuleId !== void 0)) {
        var qi = _i.children;
        if (qi !== void 0)
          if (Bi)
            if (mi(qi)) {
              for (Bi = 0; Bi < qi.length; Bi++)
                Oo(qi[Bi], Ti);
              Object.freeze && Object.freeze(qi);
            } else
              console.error(
                "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
              );
          else Oo(qi, Ti);
      } else
        qi = "", (Ti === void 0 || typeof Ti == "object" && Ti !== null && Object.keys(Ti).length === 0) && (qi += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports."), Ti === null ? Bi = "null" : mi(Ti) ? Bi = "array" : Ti !== void 0 && Ti.$$typeof === Ko ? (Bi = "<" + (Kt(Ti.type) || "Unknown") + " />", qi = " Did you accidentally export a JSX literal instead of a component?") : Bi = typeof Ti, console.error(
          "React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s",
          Bi,
          qi
        );
      if (fi.call(_i, "key")) {
        qi = Kt(Ti);
        var rs = Object.keys(_i).filter(function(ps) {
          return ps !== "key";
        });
        Bi = 0 < rs.length ? "{key: someKey, " + rs.join(": ..., ") + ": ...}" : "{key: someKey}", us[qi + Bi] || (rs = 0 < rs.length ? "{" + rs.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          Bi,
          qi,
          rs,
          qi
        ), us[qi + Bi] = !0);
      }
      if (qi = null, Vi !== void 0 && (ho(Vi), qi = "" + Vi), Eo(_i) && (ho(_i.key), qi = "" + _i.key), "key" in _i) {
        Vi = {};
        for (var os in _i)
          os !== "key" && (Vi[os] = _i[os]);
      } else Vi = _i;
      return qi && Ro(
        Vi,
        typeof Ti == "function" ? Ti.displayName || Ti.name || "Unknown" : Ti
      ), Io(Ti, qi, Ki, Ji, wo(), Vi);
    }
    function Oo(Ti, _i) {
      if (typeof Ti == "object" && Ti && Ti.$$typeof !== Ai) {
        if (mi(Ti))
          for (var Vi = 0; Vi < Ti.length; Vi++) {
            var Bi = Ti[Vi];
            jo(Bi) && Do(Bi, _i);
          }
        else if (jo(Ti))
          Ti._store && (Ti._store.validated = 1);
        else if (Ti === null || typeof Ti != "object" ? Vi = null : (Vi = li && Ti[li] || Ti["@@iterator"], Vi = typeof Vi == "function" ? Vi : null), typeof Vi == "function" && Vi !== Ti.entries && (Vi = Vi.call(Ti), Vi !== Ti))
          for (; !(Ti = Vi.next()).done; )
            jo(Ti.value) && Do(Ti.value, _i);
      }
    }
    function jo(Ti) {
      return typeof Ti == "object" && Ti !== null && Ti.$$typeof === Ko;
    }
    function Do(Ti, _i) {
      if (Ti._store && !Ti._store.validated && Ti.key == null && (Ti._store.validated = 1, _i = Lo(_i), !ns[_i])) {
        ns[_i] = !0;
        var Vi = "";
        Ti && Ti._owner != null && Ti._owner !== wo() && (Vi = null, typeof Ti._owner.tag == "number" ? Vi = Kt(Ti._owner.type) : typeof Ti._owner.name == "string" && (Vi = Ti._owner.name), Vi = " It was passed a child from " + Vi + ".");
        var Bi = ci.getCurrentStack;
        ci.getCurrentStack = function() {
          var Ji = So(Ti.type);
          return Bi && (Ji += Bi() || ""), Ji;
        }, console.error(
          'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
          _i,
          Vi
        ), ci.getCurrentStack = Bi;
      }
    }
    function Lo(Ti) {
      var _i = "", Vi = wo();
      return Vi && (Vi = Kt(Vi.type)) && (_i = `

Check the render method of \`` + Vi + "`."), _i || (Ti = Kt(Ti)) && (_i = `

Check the top-level render call using <` + Ti + ">."), _i;
    }
    var ko = React__default, Ko = Symbol.for("react.transitional.element"), No = Symbol.for("react.portal"), Jo = Symbol.for("react.fragment"), ti = Symbol.for("react.strict_mode"), oi = Symbol.for("react.profiler"), Qo = Symbol.for("react.consumer"), Zo = Symbol.for("react.context"), ei = Symbol.for("react.forward_ref"), ii = Symbol.for("react.suspense"), ai = Symbol.for("react.suspense_list"), ri = Symbol.for("react.memo"), ni = Symbol.for("react.lazy"), si = Symbol.for("react.offscreen"), li = Symbol.iterator, ui = Symbol.for("react.client.reference"), ci = ko.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, fi = Object.prototype.hasOwnProperty, yi = Object.assign, hi = Symbol.for("react.client.reference"), mi = Array.isArray, bi = 0, xi, $i, Ci, Si, vi, Pi, wi;
    go.__reactDisabledLog = !0;
    var gi, Ri, Ei = !1, Ni = new (typeof WeakMap == "function" ? WeakMap : Map)(), Ai = Symbol.for("react.client.reference"), Yi, Ui = {}, us = {}, ns = {};
    reactJsxRuntime_development.Fragment = Jo, reactJsxRuntime_development.jsx = function(Ti, _i, Vi, Bi, Ji) {
      return Ao(Ti, _i, Vi, !1, Bi, Ji);
    }, reactJsxRuntime_development.jsxs = function(Ti, _i, Vi, Bi, Ji) {
      return Ao(Ti, _i, Vi, !0, Bi, Ji);
    };
  }()), reactJsxRuntime_development;
}
process.env.NODE_ENV === "production" ? jsxRuntime.exports = requireReactJsxRuntime_production() : jsxRuntime.exports = requireReactJsxRuntime_development();
var jsxRuntimeExports = jsxRuntime.exports, propTypes = { exports: {} }, reactIs$4 = { exports: {} }, reactIs_production_min$1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min$1;
function requireReactIs_production_min$1() {
  if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  hasRequiredReactIs_production_min$1 = 1;
  var Kt = typeof Symbol == "function" && Symbol.for, uo = Kt ? Symbol.for("react.element") : 60103, ho = Kt ? Symbol.for("react.portal") : 60106, go = Kt ? Symbol.for("react.fragment") : 60107, bo = Kt ? Symbol.for("react.strict_mode") : 60108, vo = Kt ? Symbol.for("react.profiler") : 60114, Po = Kt ? Symbol.for("react.provider") : 60109, Co = Kt ? Symbol.for("react.context") : 60110, So = Kt ? Symbol.for("react.async_mode") : 60111, wo = Kt ? Symbol.for("react.concurrent_mode") : 60111, Eo = Kt ? Symbol.for("react.forward_ref") : 60112, Ro = Kt ? Symbol.for("react.suspense") : 60113, _o = Kt ? Symbol.for("react.suspense_list") : 60120, Io = Kt ? Symbol.for("react.memo") : 60115, Ao = Kt ? Symbol.for("react.lazy") : 60116, Oo = Kt ? Symbol.for("react.block") : 60121, jo = Kt ? Symbol.for("react.fundamental") : 60117, Do = Kt ? Symbol.for("react.responder") : 60118, Lo = Kt ? Symbol.for("react.scope") : 60119;
  function ko(No) {
    if (typeof No == "object" && No !== null) {
      var Jo = No.$$typeof;
      switch (Jo) {
        case uo:
          switch (No = No.type, No) {
            case So:
            case wo:
            case go:
            case vo:
            case bo:
            case Ro:
              return No;
            default:
              switch (No = No && No.$$typeof, No) {
                case Co:
                case Eo:
                case Ao:
                case Io:
                case Po:
                  return No;
                default:
                  return Jo;
              }
          }
        case ho:
          return Jo;
      }
    }
  }
  function Ko(No) {
    return ko(No) === wo;
  }
  return reactIs_production_min$1.AsyncMode = So, reactIs_production_min$1.ConcurrentMode = wo, reactIs_production_min$1.ContextConsumer = Co, reactIs_production_min$1.ContextProvider = Po, reactIs_production_min$1.Element = uo, reactIs_production_min$1.ForwardRef = Eo, reactIs_production_min$1.Fragment = go, reactIs_production_min$1.Lazy = Ao, reactIs_production_min$1.Memo = Io, reactIs_production_min$1.Portal = ho, reactIs_production_min$1.Profiler = vo, reactIs_production_min$1.StrictMode = bo, reactIs_production_min$1.Suspense = Ro, reactIs_production_min$1.isAsyncMode = function(No) {
    return Ko(No) || ko(No) === So;
  }, reactIs_production_min$1.isConcurrentMode = Ko, reactIs_production_min$1.isContextConsumer = function(No) {
    return ko(No) === Co;
  }, reactIs_production_min$1.isContextProvider = function(No) {
    return ko(No) === Po;
  }, reactIs_production_min$1.isElement = function(No) {
    return typeof No == "object" && No !== null && No.$$typeof === uo;
  }, reactIs_production_min$1.isForwardRef = function(No) {
    return ko(No) === Eo;
  }, reactIs_production_min$1.isFragment = function(No) {
    return ko(No) === go;
  }, reactIs_production_min$1.isLazy = function(No) {
    return ko(No) === Ao;
  }, reactIs_production_min$1.isMemo = function(No) {
    return ko(No) === Io;
  }, reactIs_production_min$1.isPortal = function(No) {
    return ko(No) === ho;
  }, reactIs_production_min$1.isProfiler = function(No) {
    return ko(No) === vo;
  }, reactIs_production_min$1.isStrictMode = function(No) {
    return ko(No) === bo;
  }, reactIs_production_min$1.isSuspense = function(No) {
    return ko(No) === Ro;
  }, reactIs_production_min$1.isValidElementType = function(No) {
    return typeof No == "string" || typeof No == "function" || No === go || No === wo || No === vo || No === bo || No === Ro || No === _o || typeof No == "object" && No !== null && (No.$$typeof === Ao || No.$$typeof === Io || No.$$typeof === Po || No.$$typeof === Co || No.$$typeof === Eo || No.$$typeof === jo || No.$$typeof === Do || No.$$typeof === Lo || No.$$typeof === Oo);
  }, reactIs_production_min$1.typeOf = ko, reactIs_production_min$1;
}
var reactIs_development$3 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$3;
function requireReactIs_development$3() {
  return hasRequiredReactIs_development$3 || (hasRequiredReactIs_development$3 = 1, process.env.NODE_ENV !== "production" && function() {
    var Kt = typeof Symbol == "function" && Symbol.for, uo = Kt ? Symbol.for("react.element") : 60103, ho = Kt ? Symbol.for("react.portal") : 60106, go = Kt ? Symbol.for("react.fragment") : 60107, bo = Kt ? Symbol.for("react.strict_mode") : 60108, vo = Kt ? Symbol.for("react.profiler") : 60114, Po = Kt ? Symbol.for("react.provider") : 60109, Co = Kt ? Symbol.for("react.context") : 60110, So = Kt ? Symbol.for("react.async_mode") : 60111, wo = Kt ? Symbol.for("react.concurrent_mode") : 60111, Eo = Kt ? Symbol.for("react.forward_ref") : 60112, Ro = Kt ? Symbol.for("react.suspense") : 60113, _o = Kt ? Symbol.for("react.suspense_list") : 60120, Io = Kt ? Symbol.for("react.memo") : 60115, Ao = Kt ? Symbol.for("react.lazy") : 60116, Oo = Kt ? Symbol.for("react.block") : 60121, jo = Kt ? Symbol.for("react.fundamental") : 60117, Do = Kt ? Symbol.for("react.responder") : 60118, Lo = Kt ? Symbol.for("react.scope") : 60119;
    function ko(gi) {
      return typeof gi == "string" || typeof gi == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      gi === go || gi === wo || gi === vo || gi === bo || gi === Ro || gi === _o || typeof gi == "object" && gi !== null && (gi.$$typeof === Ao || gi.$$typeof === Io || gi.$$typeof === Po || gi.$$typeof === Co || gi.$$typeof === Eo || gi.$$typeof === jo || gi.$$typeof === Do || gi.$$typeof === Lo || gi.$$typeof === Oo);
    }
    function Ko(gi) {
      if (typeof gi == "object" && gi !== null) {
        var Ri = gi.$$typeof;
        switch (Ri) {
          case uo:
            var Ei = gi.type;
            switch (Ei) {
              case So:
              case wo:
              case go:
              case vo:
              case bo:
              case Ro:
                return Ei;
              default:
                var Ni = Ei && Ei.$$typeof;
                switch (Ni) {
                  case Co:
                  case Eo:
                  case Ao:
                  case Io:
                  case Po:
                    return Ni;
                  default:
                    return Ri;
                }
            }
          case ho:
            return Ri;
        }
      }
    }
    var No = So, Jo = wo, ti = Co, oi = Po, Qo = uo, Zo = Eo, ei = go, ii = Ao, ai = Io, ri = ho, ni = vo, si = bo, li = Ro, ui = !1;
    function ci(gi) {
      return ui || (ui = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), fi(gi) || Ko(gi) === So;
    }
    function fi(gi) {
      return Ko(gi) === wo;
    }
    function yi(gi) {
      return Ko(gi) === Co;
    }
    function hi(gi) {
      return Ko(gi) === Po;
    }
    function mi(gi) {
      return typeof gi == "object" && gi !== null && gi.$$typeof === uo;
    }
    function bi(gi) {
      return Ko(gi) === Eo;
    }
    function xi(gi) {
      return Ko(gi) === go;
    }
    function $i(gi) {
      return Ko(gi) === Ao;
    }
    function Ci(gi) {
      return Ko(gi) === Io;
    }
    function Si(gi) {
      return Ko(gi) === ho;
    }
    function vi(gi) {
      return Ko(gi) === vo;
    }
    function Pi(gi) {
      return Ko(gi) === bo;
    }
    function wi(gi) {
      return Ko(gi) === Ro;
    }
    reactIs_development$3.AsyncMode = No, reactIs_development$3.ConcurrentMode = Jo, reactIs_development$3.ContextConsumer = ti, reactIs_development$3.ContextProvider = oi, reactIs_development$3.Element = Qo, reactIs_development$3.ForwardRef = Zo, reactIs_development$3.Fragment = ei, reactIs_development$3.Lazy = ii, reactIs_development$3.Memo = ai, reactIs_development$3.Portal = ri, reactIs_development$3.Profiler = ni, reactIs_development$3.StrictMode = si, reactIs_development$3.Suspense = li, reactIs_development$3.isAsyncMode = ci, reactIs_development$3.isConcurrentMode = fi, reactIs_development$3.isContextConsumer = yi, reactIs_development$3.isContextProvider = hi, reactIs_development$3.isElement = mi, reactIs_development$3.isForwardRef = bi, reactIs_development$3.isFragment = xi, reactIs_development$3.isLazy = $i, reactIs_development$3.isMemo = Ci, reactIs_development$3.isPortal = Si, reactIs_development$3.isProfiler = vi, reactIs_development$3.isStrictMode = Pi, reactIs_development$3.isSuspense = wi, reactIs_development$3.isValidElementType = ko, reactIs_development$3.typeOf = Ko;
  }()), reactIs_development$3;
}
var hasRequiredReactIs;
function requireReactIs() {
  return hasRequiredReactIs || (hasRequiredReactIs = 1, process.env.NODE_ENV === "production" ? reactIs$4.exports = requireReactIs_production_min$1() : reactIs$4.exports = requireReactIs_development$3()), reactIs$4.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var objectAssign, hasRequiredObjectAssign;
function requireObjectAssign() {
  if (hasRequiredObjectAssign) return objectAssign;
  hasRequiredObjectAssign = 1;
  var Kt = Object.getOwnPropertySymbols, uo = Object.prototype.hasOwnProperty, ho = Object.prototype.propertyIsEnumerable;
  function go(vo) {
    if (vo == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(vo);
  }
  function bo() {
    try {
      if (!Object.assign)
        return !1;
      var vo = new String("abc");
      if (vo[5] = "de", Object.getOwnPropertyNames(vo)[0] === "5")
        return !1;
      for (var Po = {}, Co = 0; Co < 10; Co++)
        Po["_" + String.fromCharCode(Co)] = Co;
      var So = Object.getOwnPropertyNames(Po).map(function(Eo) {
        return Po[Eo];
      });
      if (So.join("") !== "0123456789")
        return !1;
      var wo = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(Eo) {
        wo[Eo] = Eo;
      }), Object.keys(Object.assign({}, wo)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return objectAssign = bo() ? Object.assign : function(vo, Po) {
    for (var Co, So = go(vo), wo, Eo = 1; Eo < arguments.length; Eo++) {
      Co = Object(arguments[Eo]);
      for (var Ro in Co)
        uo.call(Co, Ro) && (So[Ro] = Co[Ro]);
      if (Kt) {
        wo = Kt(Co);
        for (var _o = 0; _o < wo.length; _o++)
          ho.call(Co, wo[_o]) && (So[wo[_o]] = Co[wo[_o]]);
      }
    }
    return So;
  }, objectAssign;
}
var ReactPropTypesSecret_1, hasRequiredReactPropTypesSecret;
function requireReactPropTypesSecret() {
  if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  hasRequiredReactPropTypesSecret = 1;
  var Kt = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return ReactPropTypesSecret_1 = Kt, ReactPropTypesSecret_1;
}
var has, hasRequiredHas;
function requireHas() {
  return hasRequiredHas || (hasRequiredHas = 1, has = Function.call.bind(Object.prototype.hasOwnProperty)), has;
}
var checkPropTypes_1, hasRequiredCheckPropTypes;
function requireCheckPropTypes() {
  if (hasRequiredCheckPropTypes) return checkPropTypes_1;
  hasRequiredCheckPropTypes = 1;
  var Kt = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var uo = requireReactPropTypesSecret(), ho = {}, go = requireHas();
    Kt = function(vo) {
      var Po = "Warning: " + vo;
      typeof console < "u" && console.error(Po);
      try {
        throw new Error(Po);
      } catch {
      }
    };
  }
  function bo(vo, Po, Co, So, wo) {
    if (process.env.NODE_ENV !== "production") {
      for (var Eo in vo)
        if (go(vo, Eo)) {
          var Ro;
          try {
            if (typeof vo[Eo] != "function") {
              var _o = Error(
                (So || "React class") + ": " + Co + " type `" + Eo + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof vo[Eo] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw _o.name = "Invariant Violation", _o;
            }
            Ro = vo[Eo](Po, Eo, So, Co, null, uo);
          } catch (Ao) {
            Ro = Ao;
          }
          if (Ro && !(Ro instanceof Error) && Kt(
            (So || "React class") + ": type specification of " + Co + " `" + Eo + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof Ro + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), Ro instanceof Error && !(Ro.message in ho)) {
            ho[Ro.message] = !0;
            var Io = wo ? wo() : "";
            Kt(
              "Failed " + Co + " type: " + Ro.message + (Io ?? "")
            );
          }
        }
    }
  }
  return bo.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (ho = {});
  }, checkPropTypes_1 = bo, checkPropTypes_1;
}
var factoryWithTypeCheckers, hasRequiredFactoryWithTypeCheckers;
function requireFactoryWithTypeCheckers() {
  if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
  hasRequiredFactoryWithTypeCheckers = 1;
  var Kt = requireReactIs(), uo = requireObjectAssign(), ho = requireReactPropTypesSecret(), go = requireHas(), bo = requireCheckPropTypes(), vo = function() {
  };
  process.env.NODE_ENV !== "production" && (vo = function(Co) {
    var So = "Warning: " + Co;
    typeof console < "u" && console.error(So);
    try {
      throw new Error(So);
    } catch {
    }
  });
  function Po() {
    return null;
  }
  return factoryWithTypeCheckers = function(Co, So) {
    var wo = typeof Symbol == "function" && Symbol.iterator, Eo = "@@iterator";
    function Ro(fi) {
      var yi = fi && (wo && fi[wo] || fi[Eo]);
      if (typeof yi == "function")
        return yi;
    }
    var _o = "<<anonymous>>", Io = {
      array: Do("array"),
      bigint: Do("bigint"),
      bool: Do("boolean"),
      func: Do("function"),
      number: Do("number"),
      object: Do("object"),
      string: Do("string"),
      symbol: Do("symbol"),
      any: Lo(),
      arrayOf: ko,
      element: Ko(),
      elementType: No(),
      instanceOf: Jo,
      node: Zo(),
      objectOf: oi,
      oneOf: ti,
      oneOfType: Qo,
      shape: ii,
      exact: ai
    };
    function Ao(fi, yi) {
      return fi === yi ? fi !== 0 || 1 / fi === 1 / yi : fi !== fi && yi !== yi;
    }
    function Oo(fi, yi) {
      this.message = fi, this.data = yi && typeof yi == "object" ? yi : {}, this.stack = "";
    }
    Oo.prototype = Error.prototype;
    function jo(fi) {
      if (process.env.NODE_ENV !== "production")
        var yi = {}, hi = 0;
      function mi(xi, $i, Ci, Si, vi, Pi, wi) {
        if (Si = Si || _o, Pi = Pi || Ci, wi !== ho) {
          if (So) {
            var gi = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw gi.name = "Invariant Violation", gi;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Ri = Si + ":" + Ci;
            !yi[Ri] && // Avoid spamming the console because they are often not actionable except for lib authors
            hi < 3 && (vo(
              "You are manually calling a React.PropTypes validation function for the `" + Pi + "` prop on `" + Si + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), yi[Ri] = !0, hi++);
          }
        }
        return $i[Ci] == null ? xi ? $i[Ci] === null ? new Oo("The " + vi + " `" + Pi + "` is marked as required " + ("in `" + Si + "`, but its value is `null`.")) : new Oo("The " + vi + " `" + Pi + "` is marked as required in " + ("`" + Si + "`, but its value is `undefined`.")) : null : fi($i, Ci, Si, vi, Pi);
      }
      var bi = mi.bind(null, !1);
      return bi.isRequired = mi.bind(null, !0), bi;
    }
    function Do(fi) {
      function yi(hi, mi, bi, xi, $i, Ci) {
        var Si = hi[mi], vi = si(Si);
        if (vi !== fi) {
          var Pi = li(Si);
          return new Oo(
            "Invalid " + xi + " `" + $i + "` of type " + ("`" + Pi + "` supplied to `" + bi + "`, expected ") + ("`" + fi + "`."),
            { expectedType: fi }
          );
        }
        return null;
      }
      return jo(yi);
    }
    function Lo() {
      return jo(Po);
    }
    function ko(fi) {
      function yi(hi, mi, bi, xi, $i) {
        if (typeof fi != "function")
          return new Oo("Property `" + $i + "` of component `" + bi + "` has invalid PropType notation inside arrayOf.");
        var Ci = hi[mi];
        if (!Array.isArray(Ci)) {
          var Si = si(Ci);
          return new Oo("Invalid " + xi + " `" + $i + "` of type " + ("`" + Si + "` supplied to `" + bi + "`, expected an array."));
        }
        for (var vi = 0; vi < Ci.length; vi++) {
          var Pi = fi(Ci, vi, bi, xi, $i + "[" + vi + "]", ho);
          if (Pi instanceof Error)
            return Pi;
        }
        return null;
      }
      return jo(yi);
    }
    function Ko() {
      function fi(yi, hi, mi, bi, xi) {
        var $i = yi[hi];
        if (!Co($i)) {
          var Ci = si($i);
          return new Oo("Invalid " + bi + " `" + xi + "` of type " + ("`" + Ci + "` supplied to `" + mi + "`, expected a single ReactElement."));
        }
        return null;
      }
      return jo(fi);
    }
    function No() {
      function fi(yi, hi, mi, bi, xi) {
        var $i = yi[hi];
        if (!Kt.isValidElementType($i)) {
          var Ci = si($i);
          return new Oo("Invalid " + bi + " `" + xi + "` of type " + ("`" + Ci + "` supplied to `" + mi + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return jo(fi);
    }
    function Jo(fi) {
      function yi(hi, mi, bi, xi, $i) {
        if (!(hi[mi] instanceof fi)) {
          var Ci = fi.name || _o, Si = ci(hi[mi]);
          return new Oo("Invalid " + xi + " `" + $i + "` of type " + ("`" + Si + "` supplied to `" + bi + "`, expected ") + ("instance of `" + Ci + "`."));
        }
        return null;
      }
      return jo(yi);
    }
    function ti(fi) {
      if (!Array.isArray(fi))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? vo(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : vo("Invalid argument supplied to oneOf, expected an array.")), Po;
      function yi(hi, mi, bi, xi, $i) {
        for (var Ci = hi[mi], Si = 0; Si < fi.length; Si++)
          if (Ao(Ci, fi[Si]))
            return null;
        var vi = JSON.stringify(fi, function(wi, gi) {
          var Ri = li(gi);
          return Ri === "symbol" ? String(gi) : gi;
        });
        return new Oo("Invalid " + xi + " `" + $i + "` of value `" + String(Ci) + "` " + ("supplied to `" + bi + "`, expected one of " + vi + "."));
      }
      return jo(yi);
    }
    function oi(fi) {
      function yi(hi, mi, bi, xi, $i) {
        if (typeof fi != "function")
          return new Oo("Property `" + $i + "` of component `" + bi + "` has invalid PropType notation inside objectOf.");
        var Ci = hi[mi], Si = si(Ci);
        if (Si !== "object")
          return new Oo("Invalid " + xi + " `" + $i + "` of type " + ("`" + Si + "` supplied to `" + bi + "`, expected an object."));
        for (var vi in Ci)
          if (go(Ci, vi)) {
            var Pi = fi(Ci, vi, bi, xi, $i + "." + vi, ho);
            if (Pi instanceof Error)
              return Pi;
          }
        return null;
      }
      return jo(yi);
    }
    function Qo(fi) {
      if (!Array.isArray(fi))
        return process.env.NODE_ENV !== "production" && vo("Invalid argument supplied to oneOfType, expected an instance of array."), Po;
      for (var yi = 0; yi < fi.length; yi++) {
        var hi = fi[yi];
        if (typeof hi != "function")
          return vo(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ui(hi) + " at index " + yi + "."
          ), Po;
      }
      function mi(bi, xi, $i, Ci, Si) {
        for (var vi = [], Pi = 0; Pi < fi.length; Pi++) {
          var wi = fi[Pi], gi = wi(bi, xi, $i, Ci, Si, ho);
          if (gi == null)
            return null;
          gi.data && go(gi.data, "expectedType") && vi.push(gi.data.expectedType);
        }
        var Ri = vi.length > 0 ? ", expected one of type [" + vi.join(", ") + "]" : "";
        return new Oo("Invalid " + Ci + " `" + Si + "` supplied to " + ("`" + $i + "`" + Ri + "."));
      }
      return jo(mi);
    }
    function Zo() {
      function fi(yi, hi, mi, bi, xi) {
        return ri(yi[hi]) ? null : new Oo("Invalid " + bi + " `" + xi + "` supplied to " + ("`" + mi + "`, expected a ReactNode."));
      }
      return jo(fi);
    }
    function ei(fi, yi, hi, mi, bi) {
      return new Oo(
        (fi || "React class") + ": " + yi + " type `" + hi + "." + mi + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + bi + "`."
      );
    }
    function ii(fi) {
      function yi(hi, mi, bi, xi, $i) {
        var Ci = hi[mi], Si = si(Ci);
        if (Si !== "object")
          return new Oo("Invalid " + xi + " `" + $i + "` of type `" + Si + "` " + ("supplied to `" + bi + "`, expected `object`."));
        for (var vi in fi) {
          var Pi = fi[vi];
          if (typeof Pi != "function")
            return ei(bi, xi, $i, vi, li(Pi));
          var wi = Pi(Ci, vi, bi, xi, $i + "." + vi, ho);
          if (wi)
            return wi;
        }
        return null;
      }
      return jo(yi);
    }
    function ai(fi) {
      function yi(hi, mi, bi, xi, $i) {
        var Ci = hi[mi], Si = si(Ci);
        if (Si !== "object")
          return new Oo("Invalid " + xi + " `" + $i + "` of type `" + Si + "` " + ("supplied to `" + bi + "`, expected `object`."));
        var vi = uo({}, hi[mi], fi);
        for (var Pi in vi) {
          var wi = fi[Pi];
          if (go(fi, Pi) && typeof wi != "function")
            return ei(bi, xi, $i, Pi, li(wi));
          if (!wi)
            return new Oo(
              "Invalid " + xi + " `" + $i + "` key `" + Pi + "` supplied to `" + bi + "`.\nBad object: " + JSON.stringify(hi[mi], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(fi), null, "  ")
            );
          var gi = wi(Ci, Pi, bi, xi, $i + "." + Pi, ho);
          if (gi)
            return gi;
        }
        return null;
      }
      return jo(yi);
    }
    function ri(fi) {
      switch (typeof fi) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !fi;
        case "object":
          if (Array.isArray(fi))
            return fi.every(ri);
          if (fi === null || Co(fi))
            return !0;
          var yi = Ro(fi);
          if (yi) {
            var hi = yi.call(fi), mi;
            if (yi !== fi.entries) {
              for (; !(mi = hi.next()).done; )
                if (!ri(mi.value))
                  return !1;
            } else
              for (; !(mi = hi.next()).done; ) {
                var bi = mi.value;
                if (bi && !ri(bi[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function ni(fi, yi) {
      return fi === "symbol" ? !0 : yi ? yi["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && yi instanceof Symbol : !1;
    }
    function si(fi) {
      var yi = typeof fi;
      return Array.isArray(fi) ? "array" : fi instanceof RegExp ? "object" : ni(yi, fi) ? "symbol" : yi;
    }
    function li(fi) {
      if (typeof fi > "u" || fi === null)
        return "" + fi;
      var yi = si(fi);
      if (yi === "object") {
        if (fi instanceof Date)
          return "date";
        if (fi instanceof RegExp)
          return "regexp";
      }
      return yi;
    }
    function ui(fi) {
      var yi = li(fi);
      switch (yi) {
        case "array":
        case "object":
          return "an " + yi;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + yi;
        default:
          return yi;
      }
    }
    function ci(fi) {
      return !fi.constructor || !fi.constructor.name ? _o : fi.constructor.name;
    }
    return Io.checkPropTypes = bo, Io.resetWarningCache = bo.resetWarningCache, Io.PropTypes = Io, Io;
  }, factoryWithTypeCheckers;
}
var factoryWithThrowingShims, hasRequiredFactoryWithThrowingShims;
function requireFactoryWithThrowingShims() {
  if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  hasRequiredFactoryWithThrowingShims = 1;
  var Kt = requireReactPropTypesSecret();
  function uo() {
  }
  function ho() {
  }
  return ho.resetWarningCache = uo, factoryWithThrowingShims = function() {
    function go(Po, Co, So, wo, Eo, Ro) {
      if (Ro !== Kt) {
        var _o = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw _o.name = "Invariant Violation", _o;
      }
    }
    go.isRequired = go;
    function bo() {
      return go;
    }
    var vo = {
      array: go,
      bigint: go,
      bool: go,
      func: go,
      number: go,
      object: go,
      string: go,
      symbol: go,
      any: go,
      arrayOf: bo,
      element: go,
      elementType: go,
      instanceOf: bo,
      node: go,
      objectOf: bo,
      oneOf: bo,
      oneOfType: bo,
      shape: bo,
      exact: bo,
      checkPropTypes: ho,
      resetWarningCache: uo
    };
    return vo.PropTypes = vo, vo;
  }, factoryWithThrowingShims;
}
if (process.env.NODE_ENV !== "production") {
  var ReactIs = requireReactIs(), throwOnDirectAccess = !0;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else
  propTypes.exports = requireFactoryWithThrowingShims()();
var propTypesExports = propTypes.exports;
const PropTypes = /* @__PURE__ */ getDefaultExportFromCjs(propTypesExports);
function isHostComponent$2(Kt) {
  return typeof Kt == "string";
}
function appendOwnerState(Kt, uo, ho) {
  return Kt === void 0 || isHostComponent$2(Kt) ? uo : {
    ...uo,
    ownerState: {
      ...uo.ownerState,
      ...ho
    }
  };
}
function areArraysEqual$1(Kt, uo, ho = (go, bo) => go === bo) {
  return Kt.length === uo.length && Kt.every((go, bo) => ho(go, uo[bo]));
}
const defaultContextValue = {
  disableDefaultClasses: !1
}, ClassNameConfiguratorContext = /* @__PURE__ */ React$1.createContext(defaultContextValue);
process.env.NODE_ENV !== "production" && (ClassNameConfiguratorContext.displayName = "ClassNameConfiguratorContext");
function useClassNamesOverride(Kt) {
  const {
    disableDefaultClasses: uo
  } = React$1.useContext(ClassNameConfiguratorContext);
  return (ho) => uo ? "" : Kt(ho);
}
function extractEventHandlers(Kt, uo = []) {
  if (Kt === void 0)
    return {};
  const ho = {};
  return Object.keys(Kt).filter((go) => go.match(/^on[A-Z]/) && typeof Kt[go] == "function" && !uo.includes(go)).forEach((go) => {
    ho[go] = Kt[go];
  }), ho;
}
function isHostComponent$1(Kt) {
  return typeof Kt == "string";
}
function useRootElementName(Kt) {
  const {
    rootElementName: uo = "",
    componentName: ho
  } = Kt, [go, bo] = React$1.useState(uo.toUpperCase());
  process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    uo && go !== uo.toUpperCase() && console.error(`useRootElementName: the \`rootElementName\` prop of ${ho ? `the ${ho} component` : "a component"} expected the '${uo}' element, but a '${go.toLowerCase()}' was rendered instead`, "This may cause hydration issues in an SSR context, for example in a Next.js app");
  }, [uo, go, ho]);
  const vo = React$1.useCallback((Po) => {
    bo((Po == null ? void 0 : Po.tagName) ?? "");
  }, []);
  return [go, vo];
}
function setRef(Kt, uo) {
  typeof Kt == "function" ? Kt(uo) : Kt && (Kt.current = uo);
}
function useForkRef(...Kt) {
  return React$1.useMemo(() => Kt.every((uo) => uo == null) ? null : (uo) => {
    Kt.forEach((ho) => {
      setRef(ho, uo);
    });
  }, Kt);
}
function r$3(Kt) {
  var uo, ho, go = "";
  if (typeof Kt == "string" || typeof Kt == "number") go += Kt;
  else if (typeof Kt == "object") if (Array.isArray(Kt)) {
    var bo = Kt.length;
    for (uo = 0; uo < bo; uo++) Kt[uo] && (ho = r$3(Kt[uo])) && (go && (go += " "), go += ho);
  } else for (ho in Kt) Kt[ho] && (go && (go += " "), go += ho);
  return go;
}
function clsx() {
  for (var Kt, uo, ho = 0, go = "", bo = arguments.length; ho < bo; ho++) (Kt = arguments[ho]) && (uo = r$3(Kt)) && (go && (go += " "), go += uo);
  return go;
}
function omitEventHandlers(Kt) {
  if (Kt === void 0)
    return {};
  const uo = {};
  return Object.keys(Kt).filter((ho) => !(ho.match(/^on[A-Z]/) && typeof Kt[ho] == "function")).forEach((ho) => {
    uo[ho] = Kt[ho];
  }), uo;
}
function mergeSlotProps(Kt) {
  const {
    getSlotProps: uo,
    additionalProps: ho,
    externalSlotProps: go,
    externalForwardedProps: bo,
    className: vo
  } = Kt;
  if (!uo) {
    const Io = clsx(ho == null ? void 0 : ho.className, vo, bo == null ? void 0 : bo.className, go == null ? void 0 : go.className), Ao = {
      ...ho == null ? void 0 : ho.style,
      ...bo == null ? void 0 : bo.style,
      ...go == null ? void 0 : go.style
    }, Oo = {
      ...ho,
      ...bo,
      ...go
    };
    return Io.length > 0 && (Oo.className = Io), Object.keys(Ao).length > 0 && (Oo.style = Ao), {
      props: Oo,
      internalRef: void 0
    };
  }
  const Po = extractEventHandlers({
    ...bo,
    ...go
  }), Co = omitEventHandlers(go), So = omitEventHandlers(bo), wo = uo(Po), Eo = clsx(wo == null ? void 0 : wo.className, ho == null ? void 0 : ho.className, vo, bo == null ? void 0 : bo.className, go == null ? void 0 : go.className), Ro = {
    ...wo == null ? void 0 : wo.style,
    ...ho == null ? void 0 : ho.style,
    ...bo == null ? void 0 : bo.style,
    ...go == null ? void 0 : go.style
  }, _o = {
    ...wo,
    ...ho,
    ...So,
    ...Co
  };
  return Eo.length > 0 && (_o.className = Eo), Object.keys(Ro).length > 0 && (_o.style = Ro), {
    props: _o,
    internalRef: wo.ref
  };
}
function resolveComponentProps(Kt, uo, ho) {
  return typeof Kt == "function" ? Kt(uo, ho) : Kt;
}
function useSlotProps(Kt) {
  var Ro;
  const {
    elementType: uo,
    externalSlotProps: ho,
    ownerState: go,
    skipResolvingSlotProps: bo = !1,
    ...vo
  } = Kt, Po = bo ? {} : resolveComponentProps(ho, go), {
    props: Co,
    internalRef: So
  } = mergeSlotProps({
    ...vo,
    externalSlotProps: Po
  }), wo = useForkRef(So, Po == null ? void 0 : Po.ref, (Ro = Kt.additionalProps) == null ? void 0 : Ro.ref);
  return appendOwnerState(uo, {
    ...Co,
    ref: wo
  }, go);
}
function chainPropTypes(Kt, uo) {
  return process.env.NODE_ENV === "production" ? () => null : function(...go) {
    return Kt(...go) || uo(...go);
  };
}
function isPlainObject$2(Kt) {
  if (typeof Kt != "object" || Kt === null)
    return !1;
  const uo = Object.getPrototypeOf(Kt);
  return (uo === null || uo === Object.prototype || Object.getPrototypeOf(uo) === null) && !(Symbol.toStringTag in Kt) && !(Symbol.iterator in Kt);
}
function deepClone$1(Kt) {
  if (/* @__PURE__ */ React$1.isValidElement(Kt) || !isPlainObject$2(Kt))
    return Kt;
  const uo = {};
  return Object.keys(Kt).forEach((ho) => {
    uo[ho] = deepClone$1(Kt[ho]);
  }), uo;
}
function deepmerge(Kt, uo, ho = {
  clone: !0
}) {
  const go = ho.clone ? {
    ...Kt
  } : Kt;
  return isPlainObject$2(Kt) && isPlainObject$2(uo) && Object.keys(uo).forEach((bo) => {
    /* @__PURE__ */ React$1.isValidElement(uo[bo]) ? go[bo] = uo[bo] : isPlainObject$2(uo[bo]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(Kt, bo) && isPlainObject$2(Kt[bo]) ? go[bo] = deepmerge(Kt[bo], uo[bo], ho) : ho.clone ? go[bo] = isPlainObject$2(uo[bo]) ? deepClone$1(uo[bo]) : uo[bo] : go[bo] = uo[bo];
  }), go;
}
function isClassComponent$1(Kt) {
  const {
    prototype: uo = {}
  } = Kt;
  return !!uo.isReactComponent;
}
function acceptingRef(Kt, uo, ho, go, bo) {
  const vo = Kt[uo], Po = bo || uo;
  if (vo == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let Co;
  const So = vo.type;
  return typeof So == "function" && !isClassComponent$1(So) && (Co = "Did you accidentally use a plain function component for an element instead?"), Co !== void 0 ? new Error(`Invalid ${go} \`${Po}\` supplied to \`${ho}\`. Expected an element that can hold a ref. ${Co} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementAcceptingRef = chainPropTypes(PropTypes.element, acceptingRef);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired, acceptingRef);
function isClassComponent(Kt) {
  const {
    prototype: uo = {}
  } = Kt;
  return !!uo.isReactComponent;
}
function elementTypeAcceptingRef(Kt, uo, ho, go, bo) {
  const vo = Kt[uo], Po = bo || uo;
  if (vo == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let Co;
  return typeof vo == "function" && !isClassComponent(vo) && (Co = "Did you accidentally provide a plain function component instead?"), Co !== void 0 ? new Error(`Invalid ${go} \`${Po}\` supplied to \`${ho}\`. Expected an element type that can hold a ref. ${Co} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const elementTypeAcceptingRef$1 = chainPropTypes(PropTypes.elementType, elementTypeAcceptingRef), specialProperty = "exact-prop: ​";
function exactProp(Kt) {
  return process.env.NODE_ENV === "production" ? Kt : {
    ...Kt,
    [specialProperty]: (uo) => {
      const ho = Object.keys(uo).filter((go) => !Kt.hasOwnProperty(go));
      return ho.length > 0 ? new Error(`The following props are not supported: ${ho.map((go) => `\`${go}\``).join(", ")}. Please remove them.`) : null;
    }
  };
}
function formatMuiErrorMessage(Kt, ...uo) {
  const ho = new URL(`https://mui.com/production-error/?code=${Kt}`);
  return uo.forEach((go) => ho.searchParams.append("args[]", go)), `Minified MUI error #${Kt}; visit ${ho} for the full message.`;
}
var reactIs$3 = { exports: {} }, reactIs_production$1 = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production$1;
function requireReactIs_production$1() {
  if (hasRequiredReactIs_production$1) return reactIs_production$1;
  hasRequiredReactIs_production$1 = 1;
  var Kt = Symbol.for("react.transitional.element"), uo = Symbol.for("react.portal"), ho = Symbol.for("react.fragment"), go = Symbol.for("react.strict_mode"), bo = Symbol.for("react.profiler"), vo = Symbol.for("react.consumer"), Po = Symbol.for("react.context"), Co = Symbol.for("react.forward_ref"), So = Symbol.for("react.suspense"), wo = Symbol.for("react.suspense_list"), Eo = Symbol.for("react.memo"), Ro = Symbol.for("react.lazy"), _o = Symbol.for("react.offscreen"), Io = Symbol.for("react.client.reference");
  function Ao(Oo) {
    if (typeof Oo == "object" && Oo !== null) {
      var jo = Oo.$$typeof;
      switch (jo) {
        case Kt:
          switch (Oo = Oo.type, Oo) {
            case ho:
            case bo:
            case go:
            case So:
            case wo:
              return Oo;
            default:
              switch (Oo = Oo && Oo.$$typeof, Oo) {
                case Po:
                case Co:
                case Ro:
                case Eo:
                  return Oo;
                case vo:
                  return Oo;
                default:
                  return jo;
              }
          }
        case uo:
          return jo;
      }
    }
  }
  return reactIs_production$1.ContextConsumer = vo, reactIs_production$1.ContextProvider = Po, reactIs_production$1.Element = Kt, reactIs_production$1.ForwardRef = Co, reactIs_production$1.Fragment = ho, reactIs_production$1.Lazy = Ro, reactIs_production$1.Memo = Eo, reactIs_production$1.Portal = uo, reactIs_production$1.Profiler = bo, reactIs_production$1.StrictMode = go, reactIs_production$1.Suspense = So, reactIs_production$1.SuspenseList = wo, reactIs_production$1.isContextConsumer = function(Oo) {
    return Ao(Oo) === vo;
  }, reactIs_production$1.isContextProvider = function(Oo) {
    return Ao(Oo) === Po;
  }, reactIs_production$1.isElement = function(Oo) {
    return typeof Oo == "object" && Oo !== null && Oo.$$typeof === Kt;
  }, reactIs_production$1.isForwardRef = function(Oo) {
    return Ao(Oo) === Co;
  }, reactIs_production$1.isFragment = function(Oo) {
    return Ao(Oo) === ho;
  }, reactIs_production$1.isLazy = function(Oo) {
    return Ao(Oo) === Ro;
  }, reactIs_production$1.isMemo = function(Oo) {
    return Ao(Oo) === Eo;
  }, reactIs_production$1.isPortal = function(Oo) {
    return Ao(Oo) === uo;
  }, reactIs_production$1.isProfiler = function(Oo) {
    return Ao(Oo) === bo;
  }, reactIs_production$1.isStrictMode = function(Oo) {
    return Ao(Oo) === go;
  }, reactIs_production$1.isSuspense = function(Oo) {
    return Ao(Oo) === So;
  }, reactIs_production$1.isSuspenseList = function(Oo) {
    return Ao(Oo) === wo;
  }, reactIs_production$1.isValidElementType = function(Oo) {
    return typeof Oo == "string" || typeof Oo == "function" || Oo === ho || Oo === bo || Oo === go || Oo === So || Oo === wo || Oo === _o || typeof Oo == "object" && Oo !== null && (Oo.$$typeof === Ro || Oo.$$typeof === Eo || Oo.$$typeof === Po || Oo.$$typeof === vo || Oo.$$typeof === Co || Oo.$$typeof === Io || Oo.getModuleId !== void 0);
  }, reactIs_production$1.typeOf = Ao, reactIs_production$1;
}
var reactIs_development$2 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$2;
function requireReactIs_development$2() {
  return hasRequiredReactIs_development$2 || (hasRequiredReactIs_development$2 = 1, process.env.NODE_ENV !== "production" && function() {
    function Kt(Oo) {
      if (typeof Oo == "object" && Oo !== null) {
        var jo = Oo.$$typeof;
        switch (jo) {
          case uo:
            switch (Oo = Oo.type, Oo) {
              case go:
              case vo:
              case bo:
              case wo:
              case Eo:
                return Oo;
              default:
                switch (Oo = Oo && Oo.$$typeof, Oo) {
                  case Co:
                  case So:
                  case _o:
                  case Ro:
                    return Oo;
                  case Po:
                    return Oo;
                  default:
                    return jo;
                }
            }
          case ho:
            return jo;
        }
      }
    }
    var uo = Symbol.for("react.transitional.element"), ho = Symbol.for("react.portal"), go = Symbol.for("react.fragment"), bo = Symbol.for("react.strict_mode"), vo = Symbol.for("react.profiler"), Po = Symbol.for("react.consumer"), Co = Symbol.for("react.context"), So = Symbol.for("react.forward_ref"), wo = Symbol.for("react.suspense"), Eo = Symbol.for("react.suspense_list"), Ro = Symbol.for("react.memo"), _o = Symbol.for("react.lazy"), Io = Symbol.for("react.offscreen"), Ao = Symbol.for("react.client.reference");
    reactIs_development$2.ContextConsumer = Po, reactIs_development$2.ContextProvider = Co, reactIs_development$2.Element = uo, reactIs_development$2.ForwardRef = So, reactIs_development$2.Fragment = go, reactIs_development$2.Lazy = _o, reactIs_development$2.Memo = Ro, reactIs_development$2.Portal = ho, reactIs_development$2.Profiler = vo, reactIs_development$2.StrictMode = bo, reactIs_development$2.Suspense = wo, reactIs_development$2.SuspenseList = Eo, reactIs_development$2.isContextConsumer = function(Oo) {
      return Kt(Oo) === Po;
    }, reactIs_development$2.isContextProvider = function(Oo) {
      return Kt(Oo) === Co;
    }, reactIs_development$2.isElement = function(Oo) {
      return typeof Oo == "object" && Oo !== null && Oo.$$typeof === uo;
    }, reactIs_development$2.isForwardRef = function(Oo) {
      return Kt(Oo) === So;
    }, reactIs_development$2.isFragment = function(Oo) {
      return Kt(Oo) === go;
    }, reactIs_development$2.isLazy = function(Oo) {
      return Kt(Oo) === _o;
    }, reactIs_development$2.isMemo = function(Oo) {
      return Kt(Oo) === Ro;
    }, reactIs_development$2.isPortal = function(Oo) {
      return Kt(Oo) === ho;
    }, reactIs_development$2.isProfiler = function(Oo) {
      return Kt(Oo) === vo;
    }, reactIs_development$2.isStrictMode = function(Oo) {
      return Kt(Oo) === bo;
    }, reactIs_development$2.isSuspense = function(Oo) {
      return Kt(Oo) === wo;
    }, reactIs_development$2.isSuspenseList = function(Oo) {
      return Kt(Oo) === Eo;
    }, reactIs_development$2.isValidElementType = function(Oo) {
      return typeof Oo == "string" || typeof Oo == "function" || Oo === go || Oo === vo || Oo === bo || Oo === wo || Oo === Eo || Oo === Io || typeof Oo == "object" && Oo !== null && (Oo.$$typeof === _o || Oo.$$typeof === Ro || Oo.$$typeof === Co || Oo.$$typeof === Po || Oo.$$typeof === So || Oo.$$typeof === Ao || Oo.getModuleId !== void 0);
    }, reactIs_development$2.typeOf = Kt;
  }()), reactIs_development$2;
}
process.env.NODE_ENV === "production" ? reactIs$3.exports = requireReactIs_production$1() : reactIs$3.exports = requireReactIs_development$2();
var reactIsExports$2 = reactIs$3.exports;
function getFunctionComponentName(Kt, uo = "") {
  return Kt.displayName || Kt.name || uo;
}
function getWrappedName(Kt, uo, ho) {
  const go = getFunctionComponentName(uo);
  return Kt.displayName || (go !== "" ? `${ho}(${go})` : ho);
}
function getDisplayName$1(Kt) {
  if (Kt != null) {
    if (typeof Kt == "string")
      return Kt;
    if (typeof Kt == "function")
      return getFunctionComponentName(Kt, "Component");
    if (typeof Kt == "object")
      switch (Kt.$$typeof) {
        case reactIsExports$2.ForwardRef:
          return getWrappedName(Kt, Kt.render, "ForwardRef");
        case reactIsExports$2.Memo:
          return getWrappedName(Kt, Kt.type, "memo");
        default:
          return;
      }
  }
}
function HTMLElementType(Kt, uo, ho, go, bo) {
  if (process.env.NODE_ENV === "production")
    return null;
  const vo = Kt[uo], Po = bo || uo;
  return vo == null ? null : vo && vo.nodeType !== 1 ? new Error(`Invalid ${go} \`${Po}\` supplied to \`${ho}\`. Expected an HTMLElement.`) : null;
}
const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
function capitalize(Kt) {
  if (typeof Kt != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : formatMuiErrorMessage(7));
  return Kt.charAt(0).toUpperCase() + Kt.slice(1);
}
function createChainedFunction(...Kt) {
  return Kt.reduce((uo, ho) => ho == null ? uo : function(...bo) {
    uo.apply(this, bo), ho.apply(this, bo);
  }, () => {
  });
}
function debounce$3(Kt, uo = 166) {
  let ho;
  function go(...bo) {
    const vo = () => {
      Kt.apply(this, bo);
    };
    clearTimeout(ho), ho = setTimeout(vo, uo);
  }
  return go.clear = () => {
    clearTimeout(ho);
  }, go;
}
function isMuiElement(Kt, uo) {
  var ho, go, bo;
  return /* @__PURE__ */ React$1.isValidElement(Kt) && uo.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    Kt.type.muiName ?? ((bo = (go = (ho = Kt.type) == null ? void 0 : ho._payload) == null ? void 0 : go.value) == null ? void 0 : bo.muiName)
  ) !== -1;
}
function ownerDocument(Kt) {
  return Kt && Kt.ownerDocument || document;
}
function ownerWindow(Kt) {
  return ownerDocument(Kt).defaultView || window;
}
const useEnhancedEffect = typeof window < "u" ? React$1.useLayoutEffect : React$1.useEffect;
let globalId$1 = 0;
function useGlobalId(Kt) {
  const [uo, ho] = React$1.useState(Kt), go = Kt || uo;
  return React$1.useEffect(() => {
    uo == null && (globalId$1 += 1, ho(`mui-${globalId$1}`));
  }, [uo]), go;
}
const safeReact = {
  ...React$1
}, maybeReactUseId = safeReact.useId;
function useId(Kt) {
  if (maybeReactUseId !== void 0) {
    const uo = maybeReactUseId();
    return Kt ?? uo;
  }
  return useGlobalId(Kt);
}
function unsupportedProp(Kt, uo, ho, go, bo) {
  if (process.env.NODE_ENV === "production")
    return null;
  const vo = bo || uo;
  return typeof Kt[uo] < "u" ? new Error(`The prop \`${vo}\` is not supported. Please remove it.`) : null;
}
function useControlled({
  controlled: Kt,
  default: uo,
  name: ho,
  state: go = "value"
}) {
  const {
    current: bo
  } = React$1.useRef(Kt !== void 0), [vo, Po] = React$1.useState(uo), Co = bo ? Kt : vo;
  if (process.env.NODE_ENV !== "production") {
    React$1.useEffect(() => {
      bo !== (Kt !== void 0) && console.error([`MUI: A component is changing the ${bo ? "" : "un"}controlled ${go} state of ${ho} to be ${bo ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${ho} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [go, ho, Kt]);
    const {
      current: wo
    } = React$1.useRef(uo);
    React$1.useEffect(() => {
      !bo && !Object.is(wo, uo) && console.error([`MUI: A component is changing the default ${go} state of an uncontrolled ${ho} after being initialized. To suppress this warning opt to use a controlled ${ho}.`].join(`
`));
    }, [JSON.stringify(uo)]);
  }
  const So = React$1.useCallback((wo) => {
    bo || Po(wo);
  }, []);
  return [Co, So];
}
function useEventCallback(Kt) {
  const uo = React$1.useRef(Kt);
  return useEnhancedEffect(() => {
    uo.current = Kt;
  }), React$1.useRef((...ho) => (
    // @ts-expect-error hide `this`
    (0, uo.current)(...ho)
  )).current;
}
const UNINITIALIZED = {};
function useLazyRef(Kt, uo) {
  const ho = React$1.useRef(UNINITIALIZED);
  return ho.current === UNINITIALIZED && (ho.current = Kt(uo)), ho;
}
const EMPTY = [];
function useOnMount(Kt) {
  React$1.useEffect(Kt, EMPTY);
}
class Timeout {
  constructor() {
    ba(this, "currentId", null);
    ba(this, "clear", () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    });
    ba(this, "disposeEffect", () => this.clear);
  }
  static create() {
    return new Timeout();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(uo, ho) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, ho();
    }, uo);
  }
}
function useTimeout() {
  const Kt = useLazyRef(Timeout.create).current;
  return useOnMount(Kt.disposeEffect), Kt;
}
function isFocusVisible(Kt) {
  try {
    return Kt.matches(":focus-visible");
  } catch {
    process.env.NODE_ENV !== "production" && !/jsdom/.test(window.navigator.userAgent) && console.warn(["MUI: The `:focus-visible` pseudo class is not supported in this browser.", "Some components rely on this feature to work properly."].join(`
`));
  }
  return !1;
}
function getScrollbarSize(Kt = window) {
  const uo = Kt.document.documentElement.clientWidth;
  return Kt.innerWidth - uo;
}
const usePreviousProps = (Kt) => {
  const uo = React$1.useRef({});
  return React$1.useEffect(() => {
    uo.current = Kt;
  }), uo.current;
}, visuallyHidden = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function getTypeByValue(Kt) {
  const uo = typeof Kt;
  switch (uo) {
    case "number":
      return Number.isNaN(Kt) ? "NaN" : Number.isFinite(Kt) ? Kt !== Math.floor(Kt) ? "float" : "number" : "Infinity";
    case "object":
      return Kt === null ? "null" : Kt.constructor.name;
    default:
      return uo;
  }
}
function requiredInteger(Kt, uo, ho, go) {
  const bo = Kt[uo];
  if (bo == null || !Number.isInteger(bo)) {
    const vo = getTypeByValue(bo);
    return new RangeError(`Invalid ${go} \`${uo}\` of type \`${vo}\` supplied to \`${ho}\`, expected \`integer\`.`);
  }
  return null;
}
function validator(Kt, uo, ...ho) {
  return Kt[uo] === void 0 ? null : requiredInteger(Kt, uo, ...ho);
}
function validatorNoop() {
  return null;
}
validator.isRequired = requiredInteger;
validatorNoop.isRequired = validatorNoop;
const integerPropType = process.env.NODE_ENV === "production" ? validatorNoop : validator;
function resolveProps(Kt, uo) {
  const ho = {
    ...uo
  };
  for (const go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      const bo = go;
      if (bo === "components" || bo === "slots")
        ho[bo] = {
          ...Kt[bo],
          ...ho[bo]
        };
      else if (bo === "componentsProps" || bo === "slotProps") {
        const vo = Kt[bo], Po = uo[bo];
        if (!Po)
          ho[bo] = vo || {};
        else if (!vo)
          ho[bo] = Po;
        else {
          ho[bo] = {
            ...Po
          };
          for (const Co in vo)
            if (Object.prototype.hasOwnProperty.call(vo, Co)) {
              const So = Co;
              ho[bo][So] = resolveProps(vo[So], Po[So]);
            }
        }
      } else ho[bo] === void 0 && (ho[bo] = Kt[bo]);
    }
  return ho;
}
function composeClasses(Kt, uo, ho = void 0) {
  const go = {};
  for (const bo in Kt) {
    const vo = Kt[bo];
    let Po = "", Co = !0;
    for (let So = 0; So < vo.length; So += 1) {
      const wo = vo[So];
      wo && (Po += (Co === !0 ? "" : " ") + uo(wo), Co = !1, ho && ho[wo] && (Po += " " + ho[wo]));
    }
    go[bo] = Po;
  }
  return go;
}
const defaultGenerator = (Kt) => Kt, createClassNameGenerator = () => {
  let Kt = defaultGenerator;
  return {
    configure(uo) {
      Kt = uo;
    },
    generate(uo) {
      return Kt(uo);
    },
    reset() {
      Kt = defaultGenerator;
    }
  };
}, ClassNameGenerator = createClassNameGenerator(), globalStateClasses = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function generateUtilityClass$1(Kt, uo, ho = "Mui") {
  const go = globalStateClasses[uo];
  return go ? `${ho}-${go}` : `${ClassNameGenerator.generate(Kt)}-${uo}`;
}
function generateUtilityClasses$1(Kt, uo, ho = "Mui") {
  const go = {};
  return uo.forEach((bo) => {
    go[bo] = generateUtilityClass$1(Kt, bo, ho);
  }), go;
}
function clamp$3(Kt, uo = Number.MIN_SAFE_INTEGER, ho = Number.MAX_SAFE_INTEGER) {
  return Math.max(uo, Math.min(Kt, ho));
}
function getReactElementRef(Kt) {
  var uo;
  return parseInt(React$1.version, 10) >= 19 ? ((uo = Kt == null ? void 0 : Kt.props) == null ? void 0 : uo.ref) || null : (Kt == null ? void 0 : Kt.ref) || null;
}
const GLOBAL_CLASS_PREFIX = "base";
function buildStateClass(Kt) {
  return `${GLOBAL_CLASS_PREFIX}--${Kt}`;
}
function buildSlotClass(Kt, uo) {
  return `${GLOBAL_CLASS_PREFIX}-${Kt}-${uo}`;
}
function generateUtilityClass(Kt, uo) {
  const ho = globalStateClasses[uo];
  return ho ? buildStateClass(ho) : buildSlotClass(Kt, uo);
}
function generateUtilityClasses(Kt, uo) {
  const ho = {};
  return uo.forEach((go) => {
    ho[go] = generateUtilityClass(Kt, go);
  }), ho;
}
const COMPONENT_NAME$b = "Button";
function getButtonUtilityClass$1(Kt) {
  return generateUtilityClass(COMPONENT_NAME$b, Kt);
}
generateUtilityClasses(COMPONENT_NAME$b, ["root", "active", "disabled", "focusVisible"]);
function useButton(Kt = {}) {
  const {
    disabled: uo = !1,
    focusableWhenDisabled: ho,
    href: go,
    rootRef: bo,
    tabIndex: vo,
    to: Po,
    type: Co,
    rootElementName: So
  } = Kt, wo = React$1.useRef(null), [Eo, Ro] = React$1.useState(!1), [_o, Io] = React$1.useState(!1);
  uo && !ho && _o && Io(!1);
  const [Ao, Oo] = useRootElementName({
    rootElementName: So ?? (go || Po ? "a" : void 0),
    componentName: "Button"
  }), jo = (ei) => (ii) => {
    var ai;
    _o && ii.preventDefault(), (ai = ei.onMouseLeave) == null || ai.call(ei, ii);
  }, Do = (ei) => (ii) => {
    var ai;
    isFocusVisible(ii.target) || Io(!1), (ai = ei.onBlur) == null || ai.call(ei, ii);
  }, Lo = (ei) => (ii) => {
    var ai, ri;
    wo.current || (wo.current = ii.currentTarget), isFocusVisible(ii.target) && (Io(!0), (ai = ei.onFocusVisible) == null || ai.call(ei, ii)), (ri = ei.onFocus) == null || ri.call(ei, ii);
  }, ko = () => {
    const ei = wo.current;
    return Ao === "BUTTON" || Ao === "INPUT" && ["button", "submit", "reset"].includes(ei == null ? void 0 : ei.type) || Ao === "A" && (ei == null ? void 0 : ei.href);
  }, Ko = (ei) => (ii) => {
    var ai;
    uo || (ai = ei.onClick) == null || ai.call(ei, ii);
  }, No = (ei) => (ii) => {
    var ai;
    uo || (Ro(!0), document.addEventListener("mouseup", () => {
      Ro(!1);
    }, {
      once: !0
    })), (ai = ei.onMouseDown) == null || ai.call(ei, ii);
  }, Jo = (ei) => (ii) => {
    var ai, ri;
    (ai = ei.onKeyDown) == null || ai.call(ei, ii), !ii.defaultMuiPrevented && (ii.target === ii.currentTarget && !ko() && ii.key === " " && ii.preventDefault(), ii.target === ii.currentTarget && ii.key === " " && !uo && Ro(!0), ii.target === ii.currentTarget && !ko() && ii.key === "Enter" && !uo && ((ri = ei.onClick) == null || ri.call(ei, ii), ii.preventDefault()));
  }, ti = (ei) => (ii) => {
    var ai, ri;
    ii.target === ii.currentTarget && Ro(!1), (ai = ei.onKeyUp) == null || ai.call(ei, ii), ii.target === ii.currentTarget && !ko() && !uo && ii.key === " " && !ii.defaultMuiPrevented && ((ri = ei.onClick) == null || ri.call(ei, ii));
  }, oi = useForkRef(Oo, bo, wo), Qo = {};
  return vo !== void 0 && (Qo.tabIndex = vo), Ao === "BUTTON" ? (Qo.type = Co ?? "button", ho ? Qo["aria-disabled"] = uo : Qo.disabled = uo) : Ao === "INPUT" ? Co && ["button", "submit", "reset"].includes(Co) && (ho ? Qo["aria-disabled"] = uo : Qo.disabled = uo) : Ao !== "" && (!go && !Po && (Qo.role = "button", Qo.tabIndex = vo ?? 0), uo && (Qo["aria-disabled"] = uo, Qo.tabIndex = ho ? vo ?? 0 : -1)), {
    getRootProps: (ei = {}) => {
      const ii = {
        ...extractEventHandlers(Kt),
        ...extractEventHandlers(ei)
      }, ai = {
        type: Co,
        ...ii,
        ...Qo,
        ...ei,
        onBlur: Do(ii),
        onClick: Ko(ii),
        onFocus: Lo(ii),
        onKeyDown: Jo(ii),
        onKeyUp: ti(ii),
        onMouseDown: No(ii),
        onMouseLeave: jo(ii),
        ref: oi
      };
      return delete ai.onFocusVisible, ai;
    },
    focusVisible: _o,
    setFocusVisible: Io,
    active: Eo,
    rootRef: oi
  };
}
const useUtilityClasses$1A = (Kt) => {
  const {
    active: uo,
    disabled: ho,
    focusVisible: go
  } = Kt;
  return composeClasses({
    root: ["root", ho && "disabled", go && "focusVisible", uo && "active"]
  }, useClassNamesOverride(getButtonUtilityClass$1));
}, Button$2 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    action: go,
    children: bo,
    disabled: vo,
    focusableWhenDisabled: Po = !1,
    onFocusVisible: Co,
    slotProps: So = {},
    slots: wo = {},
    rootElementName: Eo = "button",
    ...Ro
  } = uo, _o = React$1.useRef(null);
  let Io = Eo;
  typeof wo.root == "string" ? Io = wo.root : (Ro.href || Ro.to) && (Io = "a");
  const {
    active: Ao,
    focusVisible: Oo,
    setFocusVisible: jo,
    getRootProps: Do
  } = useButton({
    ...uo,
    focusableWhenDisabled: Po,
    rootElementName: Io
  });
  React$1.useImperativeHandle(go, () => ({
    focusVisible: () => {
      jo(!0), _o.current.focus();
    }
  }), [jo]);
  const Lo = {
    ...uo,
    active: Ao,
    focusableWhenDisabled: Po,
    focusVisible: Oo
  }, ko = useUtilityClasses$1A(Lo), Ko = Ro.href || Ro.to ? "a" : "button", No = wo.root ?? Ko, Jo = useSlotProps({
    elementType: No,
    getSlotProps: Do,
    externalForwardedProps: Ro,
    externalSlotProps: So.root,
    additionalProps: {
      ref: ho
    },
    ownerState: Lo,
    className: ko.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(No, {
    ...Jo,
    children: bo
  });
});
process.env.NODE_ENV !== "production" && (Button$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions. It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, allows a disabled button to receive focus.
   * @default false
   */
  focusableWhenDisabled: PropTypes.bool,
  /**
   * @ignore
   */
  href: PropTypes.string,
  /**
   * @ignore
   */
  onFocusVisible: PropTypes.func,
  /**
   * The HTML element that is ultimately rendered, for example 'button' or 'a'
   * @default 'button'
   */
  rootElementName: PropTypes.string,
  /**
   * The props used for each slot inside the Button.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Button.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * @ignore
   */
  to: PropTypes.string
});
const DropdownContext = /* @__PURE__ */ React$1.createContext(null);
process.env.NODE_ENV !== "production" && (DropdownContext.displayName = "DropdownContext");
function areEqual(Kt, uo) {
  return Kt === uo;
}
const EMPTY_OBJECT$1 = {}, NOOP$1 = () => {
};
function getControlledState(Kt, uo) {
  const ho = {
    ...Kt
  };
  return Object.keys(uo).forEach((go) => {
    uo[go] !== void 0 && (ho[go] = uo[go]);
  }), ho;
}
function useStateChangeDetection(Kt) {
  const {
    nextState: uo,
    initialState: ho,
    stateComparers: go,
    onStateChange: bo,
    controlledProps: vo,
    lastActionRef: Po
  } = Kt, Co = React$1.useRef(ho);
  React$1.useEffect(() => {
    if (Po.current === null)
      return;
    const So = getControlledState(Co.current, vo);
    Object.keys(uo).forEach((wo) => {
      const Eo = go[wo] ?? areEqual, Ro = uo[wo], _o = So[wo];
      (_o == null && Ro != null || _o != null && Ro == null || _o != null && Ro != null && !Eo(Ro, _o)) && (bo == null || bo(Po.current.event ?? null, wo, Ro, Po.current.type ?? "", uo));
    }), Co.current = uo, Po.current = null;
  }, [Co, uo, Po, bo, go, vo]);
}
function useControllableReducer(Kt) {
  const uo = React$1.useRef(null), {
    reducer: ho,
    initialState: go,
    controlledProps: bo = EMPTY_OBJECT$1,
    stateComparers: vo = EMPTY_OBJECT$1,
    onStateChange: Po = NOOP$1,
    actionContext: Co,
    componentName: So = ""
  } = Kt, wo = React$1.useRef(bo);
  process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    Object.keys(bo).forEach((Ao) => {
      wo.current[Ao] !== void 0 && bo[Ao] === void 0 && console.error(`useControllableReducer: ${So ? `The ${So} component` : "A component"} is changing a controlled prop to be uncontrolled: ${Ao}`), wo.current[Ao] === void 0 && bo[Ao] !== void 0 && console.error(`useControllableReducer: ${So ? `The ${So} component` : "A component"} is changing an uncontrolled prop to be controlled: ${Ao}`);
    });
  }, [bo, So]);
  const Eo = React$1.useCallback((Ao, Oo) => {
    uo.current = Oo;
    const jo = getControlledState(Ao, bo);
    return ho(jo, Oo);
  }, [bo, ho]), [Ro, _o] = React$1.useReducer(Eo, go), Io = React$1.useCallback((Ao) => {
    _o({
      ...Ao,
      context: Co
    });
  }, [Co]);
  return useStateChangeDetection({
    nextState: Ro,
    initialState: go,
    stateComparers: vo ?? EMPTY_OBJECT$1,
    onStateChange: Po ?? NOOP$1,
    controlledProps: bo,
    lastActionRef: uo
  }), [getControlledState(Ro, bo), Io];
}
const DropdownActionTypes = {
  blur: "dropdown:blur",
  escapeKeyDown: "dropdown:escapeKeyDown",
  toggle: "dropdown:toggle",
  open: "dropdown:open",
  close: "dropdown:close"
};
function dropdownReducer(Kt, uo) {
  switch (uo.type) {
    case DropdownActionTypes.blur:
      return {
        open: !1,
        changeReason: uo.event
      };
    case DropdownActionTypes.escapeKeyDown:
      return {
        open: !1,
        changeReason: uo.event
      };
    case DropdownActionTypes.toggle:
      return {
        open: !Kt.open,
        changeReason: uo.event
      };
    case DropdownActionTypes.open:
      return {
        open: !0,
        changeReason: uo.event
      };
    case DropdownActionTypes.close:
      return {
        open: !1,
        changeReason: uo.event
      };
    default:
      throw new Error("Unhandled action");
  }
}
function useDropdown(Kt = {}) {
  const {
    defaultOpen: uo,
    onOpenChange: ho,
    open: go,
    componentName: bo = "useDropdown"
  } = Kt, [vo, Po] = React$1.useState(""), [Co, So] = React$1.useState(null), wo = React$1.useRef(null), Eo = React$1.useCallback((Oo, jo, Do, Lo) => {
    jo === "open" && (ho == null || ho(Oo, Do)), wo.current = Lo;
  }, [ho]), Ro = React$1.useMemo(() => go !== void 0 ? {
    open: go
  } : {}, [go]), [_o, Io] = useControllableReducer({
    controlledProps: Ro,
    initialState: uo ? {
      open: !0,
      changeReason: null
    } : {
      open: !1,
      changeReason: null
    },
    onStateChange: Eo,
    reducer: dropdownReducer,
    componentName: bo
  });
  return React$1.useEffect(() => {
    !_o.open && wo.current !== null && wo.current !== DropdownActionTypes.blur && (Co == null || Co.focus());
  }, [_o.open, Co]), {
    contextValue: {
      state: _o,
      dispatch: Io,
      popupId: vo,
      registerPopup: Po,
      registerTrigger: So,
      triggerElement: Co
    },
    open: _o.open
  };
}
function Dropdown(Kt) {
  const {
    children: uo,
    open: ho,
    defaultOpen: go,
    onOpenChange: bo
  } = Kt, {
    contextValue: vo
  } = useDropdown({
    defaultOpen: go,
    onOpenChange: bo,
    open: ho
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DropdownContext.Provider, {
    value: vo,
    children: uo
  });
}
process.env.NODE_ENV !== "production" && (Dropdown.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * If `true`, the dropdown is initially open.
   */
  defaultOpen: PropTypes.bool,
  /**
   * Callback fired when the component requests to be opened or closed.
   */
  onOpenChange: PropTypes.func,
  /**
   * Allows to control whether the dropdown is open.
   * This is a controlled counterpart of `defaultOpen`.
   */
  open: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Dropdown.propTypes = exactProp(Dropdown.propTypes));
const candidatesSelector$1 = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex$1(Kt) {
  const uo = parseInt(Kt.getAttribute("tabindex") || "", 10);
  return Number.isNaN(uo) ? Kt.contentEditable === "true" || (Kt.nodeName === "AUDIO" || Kt.nodeName === "VIDEO" || Kt.nodeName === "DETAILS") && Kt.getAttribute("tabindex") === null ? 0 : Kt.tabIndex : uo;
}
function isNonTabbableRadio$1(Kt) {
  if (Kt.tagName !== "INPUT" || Kt.type !== "radio" || !Kt.name)
    return !1;
  const uo = (go) => Kt.ownerDocument.querySelector(`input[type="radio"]${go}`);
  let ho = uo(`[name="${Kt.name}"]:checked`);
  return ho || (ho = uo(`[name="${Kt.name}"]`)), ho !== Kt;
}
function isNodeMatchingSelectorFocusable$1(Kt) {
  return !(Kt.disabled || Kt.tagName === "INPUT" && Kt.type === "hidden" || isNonTabbableRadio$1(Kt));
}
function defaultGetTabbable$1(Kt) {
  const uo = [], ho = [];
  return Array.from(Kt.querySelectorAll(candidatesSelector$1)).forEach((go, bo) => {
    const vo = getTabIndex$1(go);
    vo === -1 || !isNodeMatchingSelectorFocusable$1(go) || (vo === 0 ? uo.push(go) : ho.push({
      documentOrder: bo,
      tabIndex: vo,
      node: go
    }));
  }), ho.sort((go, bo) => go.tabIndex === bo.tabIndex ? go.documentOrder - bo.documentOrder : go.tabIndex - bo.tabIndex).map((go) => go.node).concat(uo);
}
function defaultIsEnabled$1() {
  return !0;
}
function FocusTrap$1(Kt) {
  const {
    children: uo,
    disableAutoFocus: ho = !1,
    disableEnforceFocus: go = !1,
    disableRestoreFocus: bo = !1,
    getTabbable: vo = defaultGetTabbable$1,
    isEnabled: Po = defaultIsEnabled$1,
    open: Co
  } = Kt, So = React$1.useRef(!1), wo = React$1.useRef(null), Eo = React$1.useRef(null), Ro = React$1.useRef(null), _o = React$1.useRef(null), Io = React$1.useRef(!1), Ao = React$1.useRef(null), Oo = useForkRef(getReactElementRef(uo), Ao), jo = React$1.useRef(null);
  React$1.useEffect(() => {
    !Co || !Ao.current || (Io.current = !ho);
  }, [ho, Co]), React$1.useEffect(() => {
    if (!Co || !Ao.current)
      return;
    const ko = ownerDocument(Ao.current);
    return Ao.current.contains(ko.activeElement) || (Ao.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), Ao.current.setAttribute("tabIndex", "-1")), Io.current && Ao.current.focus()), () => {
      bo || (Ro.current && Ro.current.focus && (So.current = !0, Ro.current.focus()), Ro.current = null);
    };
  }, [Co]), React$1.useEffect(() => {
    if (!Co || !Ao.current)
      return;
    const ko = ownerDocument(Ao.current), Ko = (ti) => {
      jo.current = ti, !(go || !Po() || ti.key !== "Tab") && ko.activeElement === Ao.current && ti.shiftKey && (So.current = !0, Eo.current && Eo.current.focus());
    }, No = () => {
      var Qo, Zo;
      const ti = Ao.current;
      if (ti === null)
        return;
      if (!ko.hasFocus() || !Po() || So.current) {
        So.current = !1;
        return;
      }
      if (ti.contains(ko.activeElement) || go && ko.activeElement !== wo.current && ko.activeElement !== Eo.current)
        return;
      if (ko.activeElement !== _o.current)
        _o.current = null;
      else if (_o.current !== null)
        return;
      if (!Io.current)
        return;
      let oi = [];
      if ((ko.activeElement === wo.current || ko.activeElement === Eo.current) && (oi = vo(Ao.current)), oi.length > 0) {
        const ei = !!((Qo = jo.current) != null && Qo.shiftKey && ((Zo = jo.current) == null ? void 0 : Zo.key) === "Tab"), ii = oi[0], ai = oi[oi.length - 1];
        typeof ii != "string" && typeof ai != "string" && (ei ? ai.focus() : ii.focus());
      } else
        ti.focus();
    };
    ko.addEventListener("focusin", No), ko.addEventListener("keydown", Ko, !0);
    const Jo = setInterval(() => {
      ko.activeElement && ko.activeElement.tagName === "BODY" && No();
    }, 50);
    return () => {
      clearInterval(Jo), ko.removeEventListener("focusin", No), ko.removeEventListener("keydown", Ko, !0);
    };
  }, [ho, go, bo, Po, Co, vo]);
  const Do = (ko) => {
    Ro.current === null && (Ro.current = ko.relatedTarget), Io.current = !0, _o.current = ko.target;
    const Ko = uo.props.onFocus;
    Ko && Ko(ko);
  }, Lo = (ko) => {
    Ro.current === null && (Ro.current = ko.relatedTarget), Io.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: Co ? 0 : -1,
      onFocus: Lo,
      ref: wo,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React$1.cloneElement(uo, {
      ref: Oo,
      onFocus: Do
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: Co ? 0 : -1,
      onFocus: Lo,
      ref: Eo,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (FocusTrap$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
process.env.NODE_ENV !== "production" && (FocusTrap$1.propTypes = exactProp(FocusTrap$1.propTypes));
const FormControlContext$1 = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (FormControlContext$1.displayName = "FormControlContext");
function useFormControlContext() {
  return React$1.useContext(FormControlContext$1);
}
const COMPONENT_NAME$a = "Input";
function getInputUtilityClass$1(Kt) {
  return generateUtilityClass(COMPONENT_NAME$a, Kt);
}
generateUtilityClasses(COMPONENT_NAME$a, ["root", "formControl", "focused", "disabled", "error", "multiline", "input", "inputMultiline", "inputTypeSearch", "adornedStart", "adornedEnd"]);
function useInput(Kt = {}) {
  const {
    defaultValue: uo,
    disabled: ho = !1,
    error: go = !1,
    onBlur: bo,
    onChange: vo,
    onFocus: Po,
    required: Co = !1,
    value: So,
    inputRef: wo
  } = Kt, Eo = useFormControlContext();
  let Ro, _o, Io, Ao, Oo;
  if (Eo) {
    if (Ro = void 0, _o = Eo.disabled ?? !1, Io = Eo.error ?? !1, Ao = Eo.required ?? !1, Oo = Eo.value, process.env.NODE_ENV !== "production") {
      const ii = ["defaultValue", "disabled", "error", "required", "value"].filter((ai) => Kt[ai] !== void 0);
      ii.length > 0 && console.warn(["MUI: You have set props on an input that is inside a FormControl.", "Set these props on a FormControl instead. Otherwise they will be ignored.", `Ignored props: ${ii.join(", ")}`].join(`
`));
    }
  } else
    Ro = uo, _o = ho, Io = go, Ao = Co, Oo = So;
  const {
    current: jo
  } = React$1.useRef(Oo != null), Do = React$1.useCallback((ii) => {
    process.env.NODE_ENV !== "production" && ii && ii.nodeName !== "INPUT" && !ii.focus && console.error(["MUI: You have provided a `slots.input` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), Lo = React$1.useRef(null), ko = useForkRef(Lo, wo, Do), [Ko, No] = React$1.useState(!1);
  React$1.useEffect(() => {
    !Eo && _o && Ko && (No(!1), bo == null || bo());
  }, [Eo, _o, Ko, bo]);
  const Jo = (ii) => (ai) => {
    var ri, ni;
    if (Eo != null && Eo.disabled) {
      ai.stopPropagation();
      return;
    }
    (ri = ii.onFocus) == null || ri.call(ii, ai), Eo && Eo.onFocus ? (ni = Eo == null ? void 0 : Eo.onFocus) == null || ni.call(Eo) : No(!0);
  }, ti = (ii) => (ai) => {
    var ri;
    (ri = ii.onBlur) == null || ri.call(ii, ai), Eo && Eo.onBlur ? Eo.onBlur() : No(!1);
  }, oi = (ii) => (ai, ...ri) => {
    var ni, si;
    if (!jo && (ai.target || Lo.current) == null)
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `slots.input` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage(17));
    (ni = Eo == null ? void 0 : Eo.onChange) == null || ni.call(Eo, ai), (si = ii.onChange) == null || si.call(ii, ai, ...ri);
  }, Qo = (ii) => (ai) => {
    var ri;
    Lo.current && ai.currentTarget === ai.target && Lo.current.focus(), (ri = ii.onClick) == null || ri.call(ii, ai);
  };
  return {
    disabled: _o,
    error: Io,
    focused: Ko,
    formControlContext: Eo,
    getInputProps: (ii = {}) => {
      const ri = {
        ...{
          onBlur: bo,
          onChange: vo,
          onFocus: Po
        },
        ...extractEventHandlers(ii)
      }, ni = {
        ...ri,
        onBlur: ti(ri),
        onChange: oi(ri),
        onFocus: Jo(ri)
      };
      return {
        ...ni,
        "aria-invalid": Io || void 0,
        defaultValue: Ro,
        value: Oo,
        required: Ao,
        disabled: _o,
        ...ii,
        ref: ko,
        ...ni
      };
    },
    getRootProps: (ii = {}) => {
      const ri = {
        ...extractEventHandlers(Kt, ["onBlur", "onChange", "onFocus"]),
        ...extractEventHandlers(ii)
      };
      return {
        ...ii,
        ...ri,
        onClick: Qo(ri)
      };
    },
    inputRef: ko,
    required: Ao,
    value: Oo
  };
}
const useUtilityClasses$1z = (Kt) => {
  const {
    disabled: uo,
    error: ho,
    focused: go,
    formControlContext: bo,
    multiline: vo,
    startAdornment: Po,
    endAdornment: Co
  } = Kt;
  return composeClasses({
    root: ["root", uo && "disabled", ho && "error", go && "focused", !!bo && "formControl", vo && "multiline", !!Po && "adornedStart", !!Co && "adornedEnd"],
    input: ["input", uo && "disabled", vo && "multiline"]
  }, useClassNamesOverride(getInputUtilityClass$1));
}, Input$2 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    "aria-describedby": go,
    "aria-label": bo,
    "aria-labelledby": vo,
    autoComplete: Po,
    autoFocus: Co,
    className: So,
    defaultValue: wo,
    disabled: Eo,
    endAdornment: Ro,
    error: _o,
    id: Io,
    multiline: Ao = !1,
    name: Oo,
    onClick: jo,
    onChange: Do,
    onKeyDown: Lo,
    onKeyUp: ko,
    onFocus: Ko,
    onBlur: No,
    placeholder: Jo,
    readOnly: ti,
    required: oi,
    startAdornment: Qo,
    value: Zo,
    type: ei,
    rows: ii,
    slotProps: ai = {},
    slots: ri = {},
    minRows: ni,
    maxRows: si,
    ...li
  } = uo, {
    getRootProps: ui,
    getInputProps: ci,
    focused: fi,
    formControlContext: yi,
    error: hi,
    disabled: mi
  } = useInput({
    disabled: Eo,
    defaultValue: wo,
    error: _o,
    onBlur: No,
    onClick: jo,
    onChange: Do,
    onFocus: Ko,
    required: oi,
    value: Zo
  }), bi = Ao ? void 0 : ei ?? "text", xi = {
    ...uo,
    disabled: mi,
    error: hi,
    focused: fi,
    formControlContext: yi,
    multiline: Ao,
    type: bi
  }, $i = useUtilityClasses$1z(xi), Ci = {
    "aria-describedby": go,
    "aria-label": bo,
    "aria-labelledby": vo,
    autoComplete: Po,
    autoFocus: Co,
    id: Io,
    onKeyDown: Lo,
    onKeyUp: ko,
    name: Oo,
    placeholder: Jo,
    readOnly: ti,
    type: bi
  }, Si = ri.root ?? "div", vi = useSlotProps({
    elementType: Si,
    getSlotProps: ui,
    externalSlotProps: ai.root,
    externalForwardedProps: li,
    additionalProps: {
      ref: ho
    },
    ownerState: xi,
    className: [$i.root, So]
  }), Pi = Ao ? ri.textarea ?? "textarea" : ri.input ?? "input", wi = useSlotProps({
    elementType: Pi,
    getSlotProps: (gi) => ci({
      ...Ci,
      ...gi
    }),
    externalSlotProps: ai.input,
    additionalProps: {
      rows: Ao ? ii : void 0,
      ...Ao && !isHostComponent$1(Pi) && {
        minRows: ii || ni,
        maxRows: ii || si
      }
    },
    ownerState: xi,
    className: $i.input
  });
  return process.env.NODE_ENV !== "production" && Ao && ii && (ni || si) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), /* @__PURE__ */ jsxRuntimeExports.jsxs(Si, {
    ...vi,
    children: [Qo, /* @__PURE__ */ jsxRuntimeExports.jsx(Pi, {
      ...wi
    }), Ro]
  });
});
process.env.NODE_ENV !== "production" && (Input$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  "aria-labelledby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * Trailing adornment for this input.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error by setting the `aria-invalid` attribute on the input and the `baseui--error` class on the root element.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * @ignore
   */
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.object
  })]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.number,
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.number,
  /**
   * If `true`, a `textarea` element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.number,
  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the InputBase.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType,
    textarea: PropTypes.elementType
  }),
  /**
   * Leading adornment for this input.
   */
  startAdornment: PropTypes.node,
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.oneOf(["button", "checkbox", "color", "date", "datetime-local", "email", "file", "hidden", "image", "month", "number", "password", "radio", "range", "reset", "search", "submit", "tel", "text", "time", "url", "week"]),
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
const COMPONENT_NAME$9 = "Menu";
function getMenuUtilityClass$1(Kt) {
  return generateUtilityClass(COMPONENT_NAME$9, Kt);
}
generateUtilityClasses(COMPONENT_NAME$9, ["root", "listbox", "expanded"]);
const ListActionTypes = {
  blur: "list:blur",
  focus: "list:focus",
  itemClick: "list:itemClick",
  itemHover: "list:itemHover",
  itemsChange: "list:itemsChange",
  keyDown: "list:keyDown",
  resetHighlight: "list:resetHighlight",
  highlightLast: "list:highlightLast",
  textNavigation: "list:textNavigation",
  clearSelection: "list:clearSelection"
};
function findValidItemToHighlight(Kt, uo, ho, go, bo, vo) {
  if (ho.length === 0 || !go && ho.every((Co, So) => bo(Co, So)))
    return -1;
  let Po = Kt;
  for (; ; ) {
    if (!vo && uo === "next" && Po === ho.length || !vo && uo === "previous" && Po === -1)
      return -1;
    if (go ? !1 : bo(ho[Po], Po))
      Po += uo === "next" ? 1 : -1, vo && (Po = (Po + ho.length) % ho.length);
    else
      return Po;
  }
}
function moveHighlight(Kt, uo, ho) {
  const {
    items: go,
    isItemDisabled: bo,
    disableListWrap: vo,
    disabledItemsFocusable: Po,
    itemComparer: Co,
    focusManagement: So
  } = ho, wo = So === "DOM" ? 0 : -1, Eo = go.length - 1, Ro = Kt == null ? -1 : go.findIndex((jo) => Co(jo, Kt));
  let _o, Io, Ao = !vo;
  switch (uo) {
    case "reset":
      if (wo === -1)
        return null;
      _o = 0, Io = "next", Ao = !1;
      break;
    case "start":
      _o = 0, Io = "next", Ao = !1;
      break;
    case "end":
      _o = Eo, Io = "previous", Ao = !1;
      break;
    default: {
      const jo = Ro + uo;
      jo < 0 ? !Ao && Ro !== -1 || Math.abs(uo) > 1 ? (_o = 0, Io = "next") : (_o = Eo, Io = "previous") : jo > Eo ? !Ao || Math.abs(uo) > 1 ? (_o = Eo, Io = "previous") : (_o = 0, Io = "next") : (_o = jo, Io = uo >= 0 ? "next" : "previous");
    }
  }
  const Oo = findValidItemToHighlight(_o, Io, go, Po, bo, Ao);
  return Oo === -1 && Kt !== null && !bo(Kt, Ro) ? Kt : go[Oo] ?? null;
}
function toggleSelection(Kt, uo, ho, go) {
  return ho === "none" ? [] : ho === "single" ? go(uo[0], Kt) ? uo : [Kt] : uo.some((bo) => go(bo, Kt)) ? uo.filter((bo) => !go(bo, Kt)) : [...uo, Kt];
}
function handleItemSelection(Kt, uo, ho) {
  const {
    itemComparer: go,
    isItemDisabled: bo,
    selectionMode: vo,
    items: Po
  } = ho, {
    selectedValues: Co
  } = uo, So = Po.findIndex((Eo) => go(Kt, Eo));
  if (bo(Kt, So))
    return uo;
  const wo = toggleSelection(Kt, Co, vo, go);
  return {
    ...uo,
    selectedValues: wo,
    highlightedValue: Kt
  };
}
function handleKeyDown(Kt, uo, ho) {
  const go = uo.highlightedValue, {
    orientation: bo,
    pageSize: vo
  } = ho;
  switch (Kt) {
    case "Home":
      return {
        ...uo,
        highlightedValue: moveHighlight(go, "start", ho)
      };
    case "End":
      return {
        ...uo,
        highlightedValue: moveHighlight(go, "end", ho)
      };
    case "PageUp":
      return {
        ...uo,
        highlightedValue: moveHighlight(go, -vo, ho)
      };
    case "PageDown":
      return {
        ...uo,
        highlightedValue: moveHighlight(go, vo, ho)
      };
    case "ArrowUp":
      if (bo !== "vertical")
        break;
      return {
        ...uo,
        highlightedValue: moveHighlight(go, -1, ho)
      };
    case "ArrowDown":
      if (bo !== "vertical")
        break;
      return {
        ...uo,
        highlightedValue: moveHighlight(go, 1, ho)
      };
    case "ArrowLeft": {
      if (bo === "vertical")
        break;
      return {
        ...uo,
        highlightedValue: moveHighlight(go, bo === "horizontal-ltr" ? -1 : 1, ho)
      };
    }
    case "ArrowRight": {
      if (bo === "vertical")
        break;
      return {
        ...uo,
        highlightedValue: moveHighlight(go, bo === "horizontal-ltr" ? 1 : -1, ho)
      };
    }
    case "Enter":
    case " ":
      return uo.highlightedValue === null ? uo : handleItemSelection(uo.highlightedValue, uo, ho);
  }
  return uo;
}
function handleBlur(Kt, uo) {
  return uo.focusManagement === "DOM" ? Kt : {
    ...Kt,
    highlightedValue: null
  };
}
function textCriteriaMatches$1(Kt, uo, ho) {
  var bo;
  const go = (bo = ho(Kt)) == null ? void 0 : bo.trim().toLowerCase();
  return !go || go.length === 0 ? !1 : go.startsWith(uo);
}
function handleTextNavigation(Kt, uo, ho) {
  const {
    items: go,
    isItemDisabled: bo,
    disabledItemsFocusable: vo,
    getItemAsString: Po
  } = ho, Co = uo.length > 1;
  let So = Co ? Kt.highlightedValue : moveHighlight(Kt.highlightedValue, 1, ho);
  for (let wo = 0; wo < go.length; wo += 1) {
    if (!So || !Co && Kt.highlightedValue === So)
      return Kt;
    if (textCriteriaMatches$1(So, uo, Po) && (!bo(So, go.indexOf(So)) || vo))
      return {
        ...Kt,
        highlightedValue: So
      };
    So = moveHighlight(So, 1, ho);
  }
  return Kt;
}
function handleItemsChange(Kt, uo, ho, go) {
  const {
    itemComparer: bo,
    focusManagement: vo
  } = go;
  let Po = null;
  ho.highlightedValue != null ? Po = Kt.find((wo) => bo(wo, ho.highlightedValue)) ?? null : vo === "DOM" && uo.length === 0 && (Po = moveHighlight(null, "reset", go));
  const So = (ho.selectedValues ?? []).filter((wo) => Kt.some((Eo) => bo(Eo, wo)));
  return {
    ...ho,
    highlightedValue: Po,
    selectedValues: So
  };
}
function handleResetHighlight(Kt, uo) {
  return {
    ...Kt,
    highlightedValue: moveHighlight(null, "reset", uo)
  };
}
function handleHighlightLast(Kt, uo) {
  return {
    ...Kt,
    highlightedValue: moveHighlight(null, "end", uo)
  };
}
function handleClearSelection(Kt, uo) {
  return {
    ...Kt,
    selectedValues: [],
    highlightedValue: moveHighlight(null, "reset", uo)
  };
}
function listReducer(Kt, uo) {
  const {
    type: ho,
    context: go
  } = uo;
  switch (ho) {
    case ListActionTypes.keyDown:
      return handleKeyDown(uo.key, Kt, go);
    case ListActionTypes.itemClick:
      return handleItemSelection(uo.item, Kt, go);
    case ListActionTypes.blur:
      return handleBlur(Kt, go);
    case ListActionTypes.textNavigation:
      return handleTextNavigation(Kt, uo.searchString, go);
    case ListActionTypes.itemsChange:
      return handleItemsChange(uo.items, uo.previousItems, Kt, go);
    case ListActionTypes.resetHighlight:
      return handleResetHighlight(Kt, go);
    case ListActionTypes.highlightLast:
      return handleHighlightLast(Kt, go);
    case ListActionTypes.clearSelection:
      return handleClearSelection(Kt, go);
    default:
      return Kt;
  }
}
const TEXT_NAVIGATION_RESET_TIMEOUT = 500;
function useTextNavigation(Kt) {
  const uo = React$1.useRef({
    searchString: "",
    lastTime: null
  });
  return React$1.useCallback((ho) => {
    if (ho.key.length === 1 && ho.key !== " ") {
      const go = uo.current, bo = ho.key.toLowerCase(), vo = performance.now();
      go.searchString.length > 0 && go.lastTime && vo - go.lastTime > TEXT_NAVIGATION_RESET_TIMEOUT ? go.searchString = bo : (go.searchString.length !== 1 || bo !== go.searchString) && (go.searchString += bo), go.lastTime = vo, Kt(go.searchString, ho);
    }
  }, [Kt]);
}
const EMPTY_OBJECT = {}, NOOP = () => {
}, defaultItemComparer = (Kt, uo) => Kt === uo, defaultIsItemDisabled = () => !1, defaultItemStringifier = (Kt) => typeof Kt == "string" ? Kt : String(Kt), defaultGetInitialState = () => ({
  highlightedValue: null,
  selectedValues: []
});
function useList(Kt) {
  const {
    controlledProps: uo = EMPTY_OBJECT,
    disabledItemsFocusable: ho = !1,
    disableListWrap: go = !1,
    focusManagement: bo = "activeDescendant",
    getInitialState: vo = defaultGetInitialState,
    getItemDomElement: Po,
    getItemId: Co,
    isItemDisabled: So = defaultIsItemDisabled,
    rootRef: wo,
    onStateChange: Eo = NOOP,
    items: Ro,
    itemComparer: _o = defaultItemComparer,
    getItemAsString: Io = defaultItemStringifier,
    onChange: Ao,
    onHighlightChange: Oo,
    onItemsChange: jo,
    orientation: Do = "vertical",
    pageSize: Lo = 5,
    reducerActionContext: ko = EMPTY_OBJECT,
    selectionMode: Ko = "single",
    stateReducer: No,
    componentName: Jo = "useList"
  } = Kt;
  if (process.env.NODE_ENV !== "production") {
    if (bo === "DOM" && Po == null)
      throw new Error("useList: The `getItemDomElement` prop is required when using the `DOM` focus management.");
    if (bo === "activeDescendant" && Co == null)
      throw new Error("useList: The `getItemId` prop is required when using the `activeDescendant` focus management.");
  }
  const ti = React$1.useRef(null), oi = useForkRef(wo, ti), Qo = React$1.useCallback((Ci, Si, vi) => {
    var Pi;
    Oo == null || Oo(Ci, Si, vi), bo === "DOM" && Si != null && (vi === ListActionTypes.itemClick || vi === ListActionTypes.keyDown || vi === ListActionTypes.textNavigation) && ((Pi = Po == null ? void 0 : Po(Si)) == null || Pi.focus());
  }, [Po, Oo, bo]), Zo = React$1.useMemo(() => ({
    highlightedValue: _o,
    selectedValues: (Ci, Si) => areArraysEqual$1(Ci, Si, _o)
  }), [_o]), ei = React$1.useCallback((Ci, Si, vi, Pi, wi) => {
    switch (Eo == null || Eo(Ci, Si, vi, Pi, wi), Si) {
      case "highlightedValue":
        Qo(Ci, vi, Pi);
        break;
      case "selectedValues":
        Ao == null || Ao(Ci, vi, Pi);
        break;
    }
  }, [Qo, Ao, Eo]), ii = React$1.useMemo(() => ({
    disabledItemsFocusable: ho,
    disableListWrap: go,
    focusManagement: bo,
    isItemDisabled: So,
    itemComparer: _o,
    items: Ro,
    getItemAsString: Io,
    onHighlightChange: Qo,
    orientation: Do,
    pageSize: Lo,
    selectionMode: Ko,
    stateComparers: Zo
  }), [ho, go, bo, So, _o, Ro, Io, Qo, Do, Lo, Ko, Zo]), ai = vo(), ri = No ?? listReducer, ni = React$1.useMemo(() => ({
    ...ko,
    ...ii
  }), [ko, ii]), [si, li] = useControllableReducer({
    reducer: ri,
    actionContext: ni,
    initialState: ai,
    controlledProps: uo,
    stateComparers: Zo,
    onStateChange: ei,
    componentName: Jo
  }), {
    highlightedValue: ui,
    selectedValues: ci
  } = si, fi = useTextNavigation((Ci, Si) => li({
    type: ListActionTypes.textNavigation,
    event: Si,
    searchString: Ci
  })), yi = React$1.useRef([]);
  React$1.useEffect(() => {
    areArraysEqual$1(yi.current, Ro, _o) || (li({
      type: ListActionTypes.itemsChange,
      event: null,
      items: Ro,
      previousItems: yi.current
    }), yi.current = Ro, jo == null || jo(Ro));
  }, [Ro, _o, li, jo]);
  const hi = (Ci) => (Si) => {
    var Pi;
    if ((Pi = Ci.onKeyDown) == null || Pi.call(Ci, Si), Si.defaultMuiPrevented)
      return;
    const vi = ["Home", "End", "PageUp", "PageDown"];
    Do === "vertical" ? vi.push("ArrowUp", "ArrowDown") : vi.push("ArrowLeft", "ArrowRight"), bo === "activeDescendant" && vi.push(" ", "Enter"), vi.includes(Si.key) && Si.preventDefault(), li({
      type: ListActionTypes.keyDown,
      key: Si.key,
      event: Si
    }), fi(Si);
  }, mi = (Ci) => (Si) => {
    var vi, Pi;
    (vi = Ci.onBlur) == null || vi.call(Ci, Si), !Si.defaultMuiPrevented && ((Pi = ti.current) != null && Pi.contains(Si.relatedTarget) || li({
      type: ListActionTypes.blur,
      event: Si
    }));
  }, bi = (Ci = {}) => {
    const Si = extractEventHandlers(Ci);
    return {
      ...Ci,
      "aria-activedescendant": bo === "activeDescendant" && ui != null ? Co(ui) : void 0,
      tabIndex: bo === "DOM" ? -1 : 0,
      ref: oi,
      ...Si,
      onBlur: mi(Si),
      onKeyDown: hi(Si)
    };
  }, xi = React$1.useCallback((Ci) => {
    const Si = (ci ?? []).some((wi) => wi != null && _o(Ci, wi)), vi = ui != null && _o(Ci, ui);
    return {
      focusable: bo === "DOM",
      highlighted: vi,
      selected: Si
    };
  }, [_o, ci, ui, bo]), $i = React$1.useMemo(() => ({
    dispatch: li,
    getItemState: xi
  }), [li, xi]);
  return React$1.useDebugValue({
    state: si
  }), {
    contextValue: $i,
    dispatch: li,
    getRootProps: bi,
    rootRef: oi,
    state: si
  };
}
const ListContext$1 = /* @__PURE__ */ React$1.createContext(null);
process.env.NODE_ENV !== "production" && (ListContext$1.displayName = "ListContext");
function useListItem(Kt) {
  const {
    handlePointerOverEvents: uo = !1,
    item: ho
  } = Kt, go = React$1.useContext(ListContext$1);
  if (!go)
    throw new Error("useListItem must be used within a ListProvider");
  const {
    dispatch: bo,
    getItemState: vo
  } = go, {
    highlighted: Po,
    selected: Co,
    focusable: So
  } = vo(ho), wo = React$1.useCallback((Io) => (Ao) => {
    var Oo;
    if ((Oo = Io.onClick) == null || Oo.call(Io, Ao), !Ao.defaultPrevented) {
      if (process.env.NODE_ENV !== "production" && ho === void 0)
        throw new Error(["MUI: The `item` provided to useListItem() is undefined.", "This should happen only during server-side rendering under React 17."].join(`
`));
      bo({
        type: ListActionTypes.itemClick,
        item: ho,
        event: Ao
      });
    }
  }, [bo, ho]), Eo = React$1.useCallback((Io) => (Ao) => {
    var Oo;
    if ((Oo = Io.onMouseOver) == null || Oo.call(Io, Ao), !Ao.defaultPrevented) {
      if (process.env.NODE_ENV !== "production" && ho === void 0)
        throw new Error(["MUI: The `item` provided to useListItem() is undefined.", "This should happen only during server-side rendering under React 17."].join(`
`));
      bo({
        type: ListActionTypes.itemHover,
        item: ho,
        event: Ao
      });
    }
  }, [bo, ho]);
  let Ro;
  return So && (Ro = Po ? 0 : -1), {
    getRootProps: (Io = {}) => {
      const Ao = extractEventHandlers(Io);
      return {
        ...Io,
        onClick: wo(Ao),
        onPointerOver: uo ? Eo(Ao) : void 0,
        tabIndex: Ro
      };
    },
    highlighted: Po,
    selected: Co
  };
}
function menuReducer(Kt, uo) {
  var go, bo, vo;
  if (uo.type === ListActionTypes.itemHover)
    return {
      ...Kt,
      highlightedValue: uo.item
    };
  const ho = listReducer(Kt, uo);
  if (ho.highlightedValue === null && uo.context.items.length > 0)
    return {
      ...ho,
      highlightedValue: uo.context.items[0]
    };
  if (uo.type === ListActionTypes.keyDown && uo.event.key === "Escape")
    return {
      ...ho,
      open: !1
    };
  if (uo.type === ListActionTypes.blur && !((go = uo.context.listboxRef.current) != null && go.contains(uo.event.relatedTarget))) {
    const Po = (bo = uo.context.listboxRef.current) == null ? void 0 : bo.getAttribute("id"), Co = (vo = uo.event.relatedTarget) == null ? void 0 : vo.getAttribute("aria-controls");
    return Po && Co && Po === Co ? ho : {
      ...ho,
      open: !1,
      highlightedValue: uo.context.items[0]
    };
  }
  return ho;
}
const CompoundComponentContext = /* @__PURE__ */ React$1.createContext(null);
process.env.NODE_ENV !== "production" && (CompoundComponentContext.displayName = "CompoundComponentContext");
function sortSubitems(Kt) {
  const uo = Array.from(Kt.keys()).map((ho) => {
    const go = Kt.get(ho);
    return {
      key: ho,
      subitem: go
    };
  });
  return uo.sort((ho, go) => {
    const bo = ho.subitem.ref.current, vo = go.subitem.ref.current;
    return bo === null || vo === null || bo === vo ? 0 : bo.compareDocumentPosition(vo) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
  }), new Map(uo.map((ho) => [ho.key, ho.subitem]));
}
function useCompoundParent() {
  const [Kt, uo] = React$1.useState(/* @__PURE__ */ new Map()), ho = React$1.useRef(/* @__PURE__ */ new Set()), go = React$1.useCallback(function(wo) {
    ho.current.delete(wo), uo((Eo) => {
      const Ro = new Map(Eo);
      return Ro.delete(wo), Ro;
    });
  }, []), bo = React$1.useCallback(function(wo, Eo) {
    let Ro;
    return typeof wo == "function" ? Ro = wo(ho.current) : Ro = wo, ho.current.add(Ro), uo((_o) => {
      const Io = new Map(_o);
      return Io.set(Ro, Eo), Io;
    }), {
      id: Ro,
      deregister: () => go(Ro)
    };
  }, [go]), vo = React$1.useMemo(() => sortSubitems(Kt), [Kt]), Po = React$1.useCallback(function(wo) {
    return Array.from(vo.keys()).indexOf(wo);
  }, [vo]);
  return {
    contextValue: React$1.useMemo(() => ({
      getItemIndex: Po,
      registerItem: bo,
      totalSubitemCount: Kt.size
    }), [Po, bo, Kt.size]),
    subitems: vo
  };
}
function useCompoundItem(Kt, uo) {
  const ho = React$1.useContext(CompoundComponentContext);
  if (ho === null)
    throw new Error("useCompoundItem must be used within a useCompoundParent");
  const {
    registerItem: go
  } = ho, [bo, vo] = React$1.useState(typeof Kt == "function" ? void 0 : Kt);
  return useEnhancedEffect(() => {
    const {
      id: Po,
      deregister: Co
    } = go(Kt, uo);
    return vo(Po), Co;
  }, [go, uo, Kt]), {
    id: bo,
    index: bo !== void 0 ? ho.getItemIndex(bo) : -1,
    totalItemCount: ho.totalSubitemCount
  };
}
function combineHooksSlotProps(Kt, uo) {
  return function(go = {}) {
    const bo = {
      ...go,
      ...Kt(go)
    };
    return {
      ...bo,
      ...uo(bo)
    };
  };
}
const FALLBACK_MENU_CONTEXT = {
  dispatch: () => {
  },
  popupId: "",
  registerPopup: () => {
  },
  registerTrigger: () => {
  },
  state: {
    open: !0,
    changeReason: null
  },
  triggerElement: null
};
function useMenu(Kt = {}) {
  const {
    listboxRef: uo,
    onItemsChange: ho,
    id: go,
    disabledItemsFocusable: bo = !0,
    disableListWrap: vo = !1,
    autoFocus: Po = !0,
    componentName: Co = "useMenu"
  } = Kt, So = React$1.useRef(null), wo = useForkRef(So, uo), Eo = useId(go) ?? "", {
    state: {
      open: Ro,
      changeReason: _o
    },
    dispatch: Io,
    triggerElement: Ao,
    registerPopup: Oo
  } = React$1.useContext(DropdownContext) ?? FALLBACK_MENU_CONTEXT, jo = React$1.useRef(Ro), {
    subitems: Do,
    contextValue: Lo
  } = useCompoundParent(), ko = React$1.useMemo(() => Array.from(Do.keys()), [Do]), Ko = React$1.useCallback((li) => {
    var ui;
    return li == null ? null : ((ui = Do.get(li)) == null ? void 0 : ui.ref.current) ?? null;
  }, [Do]), No = React$1.useCallback((li) => {
    var ui;
    return ((ui = Do == null ? void 0 : Do.get(li)) == null ? void 0 : ui.disabled) || !1;
  }, [Do]), Jo = React$1.useCallback((li) => {
    var ui, ci, fi;
    return ((ui = Do.get(li)) == null ? void 0 : ui.label) || ((fi = (ci = Do.get(li)) == null ? void 0 : ci.ref.current) == null ? void 0 : fi.innerText);
  }, [Do]), ti = React$1.useMemo(() => ({
    listboxRef: So
  }), [So]), {
    dispatch: oi,
    getRootProps: Qo,
    contextValue: Zo,
    state: {
      highlightedValue: ei
    },
    rootRef: ii
  } = useList({
    disabledItemsFocusable: bo,
    disableListWrap: vo,
    focusManagement: "DOM",
    getItemDomElement: Ko,
    getInitialState: () => ({
      selectedValues: [],
      highlightedValue: null
    }),
    isItemDisabled: No,
    items: ko,
    getItemAsString: Jo,
    rootRef: wo,
    onItemsChange: ho,
    reducerActionContext: ti,
    selectionMode: "none",
    stateReducer: menuReducer,
    componentName: Co
  });
  useEnhancedEffect(() => {
    Oo(Eo);
  }, [Eo, Oo]), useEnhancedEffect(() => {
    Ro && (_o == null ? void 0 : _o.type) === "keydown" && _o.key === "ArrowUp" && oi({
      type: ListActionTypes.highlightLast,
      event: _o
    });
  }, [Ro, _o, oi]), React$1.useEffect(() => {
    var li, ui, ci;
    Ro && Po && ei && !jo.current && ((ci = (ui = (li = Do.get(ei)) == null ? void 0 : li.ref) == null ? void 0 : ui.current) == null || ci.focus());
  }, [Ro, Po, ei, Do, ko]), React$1.useEffect(() => {
    var li, ui, ci;
    (li = So.current) != null && li.contains(document.activeElement) && ei !== null && ((ci = (ui = Do == null ? void 0 : Do.get(ei)) == null ? void 0 : ui.ref.current) == null || ci.focus());
  }, [ei, Do]);
  const ai = (li) => (ui) => {
    var ci, fi;
    (ci = li.onBlur) == null || ci.call(li, ui), !ui.defaultMuiPrevented && ((fi = So.current) != null && fi.contains(ui.relatedTarget) || ui.relatedTarget === Ao || Io({
      type: DropdownActionTypes.blur,
      event: ui
    }));
  }, ri = (li) => (ui) => {
    var ci;
    (ci = li.onKeyDown) == null || ci.call(li, ui), !ui.defaultMuiPrevented && ui.key === "Escape" && Io({
      type: DropdownActionTypes.escapeKeyDown,
      event: ui
    });
  }, ni = (li = {}) => ({
    onBlur: ai(li),
    onKeyDown: ri(li)
  }), si = (li = {}) => {
    const ui = combineHooksSlotProps(ni, Qo), ci = extractEventHandlers(li);
    return {
      ...li,
      ...ci,
      ...ui(ci),
      id: Eo,
      role: "menu"
    };
  };
  return React$1.useDebugValue({
    subitems: Do,
    highlightedValue: ei
  }), {
    contextValue: {
      ...Lo,
      ...Zo
    },
    dispatch: oi,
    getListboxProps: si,
    highlightedValue: ei,
    listboxRef: ii,
    menuItems: Do,
    open: Ro,
    triggerElement: Ao
  };
}
function MenuProvider(Kt) {
  const {
    value: uo,
    children: ho
  } = Kt, {
    dispatch: go,
    getItemIndex: bo,
    getItemState: vo,
    registerItem: Po,
    totalSubitemCount: Co
  } = uo, So = React$1.useMemo(() => ({
    dispatch: go,
    getItemState: vo,
    getItemIndex: bo
  }), [go, bo, vo]), wo = React$1.useMemo(() => ({
    getItemIndex: bo,
    registerItem: Po,
    totalSubitemCount: Co
  }), [Po, bo, Co]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: wo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
      value: So,
      children: ho
    })
  });
}
const min$4 = Math.min, max$4 = Math.max, round$4 = Math.round, floor = Math.floor, createCoords = (Kt) => ({
  x: Kt,
  y: Kt
}), oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp$2(Kt, uo, ho) {
  return max$4(Kt, min$4(uo, ho));
}
function evaluate(Kt, uo) {
  return typeof Kt == "function" ? Kt(uo) : Kt;
}
function getSide(Kt) {
  return Kt.split("-")[0];
}
function getAlignment(Kt) {
  return Kt.split("-")[1];
}
function getOppositeAxis(Kt) {
  return Kt === "x" ? "y" : "x";
}
function getAxisLength(Kt) {
  return Kt === "y" ? "height" : "width";
}
function getSideAxis(Kt) {
  return ["top", "bottom"].includes(getSide(Kt)) ? "y" : "x";
}
function getAlignmentAxis(Kt) {
  return getOppositeAxis(getSideAxis(Kt));
}
function getAlignmentSides(Kt, uo, ho) {
  ho === void 0 && (ho = !1);
  const go = getAlignment(Kt), bo = getAlignmentAxis(Kt), vo = getAxisLength(bo);
  let Po = bo === "x" ? go === (ho ? "end" : "start") ? "right" : "left" : go === "start" ? "bottom" : "top";
  return uo.reference[vo] > uo.floating[vo] && (Po = getOppositePlacement$1(Po)), [Po, getOppositePlacement$1(Po)];
}
function getExpandedPlacements(Kt) {
  const uo = getOppositePlacement$1(Kt);
  return [getOppositeAlignmentPlacement(Kt), uo, getOppositeAlignmentPlacement(uo)];
}
function getOppositeAlignmentPlacement(Kt) {
  return Kt.replace(/start|end/g, (uo) => oppositeAlignmentMap[uo]);
}
function getSideList(Kt, uo, ho) {
  const go = ["left", "right"], bo = ["right", "left"], vo = ["top", "bottom"], Po = ["bottom", "top"];
  switch (Kt) {
    case "top":
    case "bottom":
      return ho ? uo ? bo : go : uo ? go : bo;
    case "left":
    case "right":
      return uo ? vo : Po;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(Kt, uo, ho, go) {
  const bo = getAlignment(Kt);
  let vo = getSideList(getSide(Kt), ho === "start", go);
  return bo && (vo = vo.map((Po) => Po + "-" + bo), uo && (vo = vo.concat(vo.map(getOppositeAlignmentPlacement)))), vo;
}
function getOppositePlacement$1(Kt) {
  return Kt.replace(/left|right|bottom|top/g, (uo) => oppositeSideMap[uo]);
}
function expandPaddingObject(Kt) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...Kt
  };
}
function getPaddingObject(Kt) {
  return typeof Kt != "number" ? expandPaddingObject(Kt) : {
    top: Kt,
    right: Kt,
    bottom: Kt,
    left: Kt
  };
}
function rectToClientRect$1(Kt) {
  const {
    x: uo,
    y: ho,
    width: go,
    height: bo
  } = Kt;
  return {
    width: go,
    height: bo,
    top: ho,
    left: uo,
    right: uo + go,
    bottom: ho + bo,
    x: uo,
    y: ho
  };
}
function computeCoordsFromPlacement(Kt, uo, ho) {
  let {
    reference: go,
    floating: bo
  } = Kt;
  const vo = getSideAxis(uo), Po = getAlignmentAxis(uo), Co = getAxisLength(Po), So = getSide(uo), wo = vo === "y", Eo = go.x + go.width / 2 - bo.width / 2, Ro = go.y + go.height / 2 - bo.height / 2, _o = go[Co] / 2 - bo[Co] / 2;
  let Io;
  switch (So) {
    case "top":
      Io = {
        x: Eo,
        y: go.y - bo.height
      };
      break;
    case "bottom":
      Io = {
        x: Eo,
        y: go.y + go.height
      };
      break;
    case "right":
      Io = {
        x: go.x + go.width,
        y: Ro
      };
      break;
    case "left":
      Io = {
        x: go.x - bo.width,
        y: Ro
      };
      break;
    default:
      Io = {
        x: go.x,
        y: go.y
      };
  }
  switch (getAlignment(uo)) {
    case "start":
      Io[Po] -= _o * (ho && wo ? -1 : 1);
      break;
    case "end":
      Io[Po] += _o * (ho && wo ? -1 : 1);
      break;
  }
  return Io;
}
const computePosition$1 = async (Kt, uo, ho) => {
  const {
    placement: go = "bottom",
    strategy: bo = "absolute",
    middleware: vo = [],
    platform: Po
  } = ho, Co = vo.filter(Boolean), So = await (Po.isRTL == null ? void 0 : Po.isRTL(uo));
  let wo = await Po.getElementRects({
    reference: Kt,
    floating: uo,
    strategy: bo
  }), {
    x: Eo,
    y: Ro
  } = computeCoordsFromPlacement(wo, go, So), _o = go, Io = {}, Ao = 0;
  for (let Oo = 0; Oo < Co.length; Oo++) {
    const {
      name: jo,
      fn: Do
    } = Co[Oo], {
      x: Lo,
      y: ko,
      data: Ko,
      reset: No
    } = await Do({
      x: Eo,
      y: Ro,
      initialPlacement: go,
      placement: _o,
      strategy: bo,
      middlewareData: Io,
      rects: wo,
      platform: Po,
      elements: {
        reference: Kt,
        floating: uo
      }
    });
    Eo = Lo ?? Eo, Ro = ko ?? Ro, Io = {
      ...Io,
      [jo]: {
        ...Io[jo],
        ...Ko
      }
    }, No && Ao <= 50 && (Ao++, typeof No == "object" && (No.placement && (_o = No.placement), No.rects && (wo = No.rects === !0 ? await Po.getElementRects({
      reference: Kt,
      floating: uo,
      strategy: bo
    }) : No.rects), {
      x: Eo,
      y: Ro
    } = computeCoordsFromPlacement(wo, _o, So)), Oo = -1);
  }
  return {
    x: Eo,
    y: Ro,
    placement: _o,
    strategy: bo,
    middlewareData: Io
  };
};
async function detectOverflow$1(Kt, uo) {
  var ho;
  uo === void 0 && (uo = {});
  const {
    x: go,
    y: bo,
    platform: vo,
    rects: Po,
    elements: Co,
    strategy: So
  } = Kt, {
    boundary: wo = "clippingAncestors",
    rootBoundary: Eo = "viewport",
    elementContext: Ro = "floating",
    altBoundary: _o = !1,
    padding: Io = 0
  } = evaluate(uo, Kt), Ao = getPaddingObject(Io), jo = Co[_o ? Ro === "floating" ? "reference" : "floating" : Ro], Do = rectToClientRect$1(await vo.getClippingRect({
    element: (ho = await (vo.isElement == null ? void 0 : vo.isElement(jo))) == null || ho ? jo : jo.contextElement || await (vo.getDocumentElement == null ? void 0 : vo.getDocumentElement(Co.floating)),
    boundary: wo,
    rootBoundary: Eo,
    strategy: So
  })), Lo = Ro === "floating" ? {
    x: go,
    y: bo,
    width: Po.floating.width,
    height: Po.floating.height
  } : Po.reference, ko = await (vo.getOffsetParent == null ? void 0 : vo.getOffsetParent(Co.floating)), Ko = await (vo.isElement == null ? void 0 : vo.isElement(ko)) ? await (vo.getScale == null ? void 0 : vo.getScale(ko)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, No = rectToClientRect$1(vo.convertOffsetParentRelativeRectToViewportRelativeRect ? await vo.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: Co,
    rect: Lo,
    offsetParent: ko,
    strategy: So
  }) : Lo);
  return {
    top: (Do.top - No.top + Ao.top) / Ko.y,
    bottom: (No.bottom - Do.bottom + Ao.bottom) / Ko.y,
    left: (Do.left - No.left + Ao.left) / Ko.x,
    right: (No.right - Do.right + Ao.right) / Ko.x
  };
}
const flip$4 = function(Kt) {
  return Kt === void 0 && (Kt = {}), {
    name: "flip",
    options: Kt,
    async fn(uo) {
      var ho, go;
      const {
        placement: bo,
        middlewareData: vo,
        rects: Po,
        initialPlacement: Co,
        platform: So,
        elements: wo
      } = uo, {
        mainAxis: Eo = !0,
        crossAxis: Ro = !0,
        fallbackPlacements: _o,
        fallbackStrategy: Io = "bestFit",
        fallbackAxisSideDirection: Ao = "none",
        flipAlignment: Oo = !0,
        ...jo
      } = evaluate(Kt, uo);
      if ((ho = vo.arrow) != null && ho.alignmentOffset)
        return {};
      const Do = getSide(bo), Lo = getSideAxis(Co), ko = getSide(Co) === Co, Ko = await (So.isRTL == null ? void 0 : So.isRTL(wo.floating)), No = _o || (ko || !Oo ? [getOppositePlacement$1(Co)] : getExpandedPlacements(Co)), Jo = Ao !== "none";
      !_o && Jo && No.push(...getOppositeAxisPlacements(Co, Oo, Ao, Ko));
      const ti = [Co, ...No], oi = await detectOverflow$1(uo, jo), Qo = [];
      let Zo = ((go = vo.flip) == null ? void 0 : go.overflows) || [];
      if (Eo && Qo.push(oi[Do]), Ro) {
        const ri = getAlignmentSides(bo, Po, Ko);
        Qo.push(oi[ri[0]], oi[ri[1]]);
      }
      if (Zo = [...Zo, {
        placement: bo,
        overflows: Qo
      }], !Qo.every((ri) => ri <= 0)) {
        var ei, ii;
        const ri = (((ei = vo.flip) == null ? void 0 : ei.index) || 0) + 1, ni = ti[ri];
        if (ni)
          return {
            data: {
              index: ri,
              overflows: Zo
            },
            reset: {
              placement: ni
            }
          };
        let si = (ii = Zo.filter((li) => li.overflows[0] <= 0).sort((li, ui) => li.overflows[1] - ui.overflows[1])[0]) == null ? void 0 : ii.placement;
        if (!si)
          switch (Io) {
            case "bestFit": {
              var ai;
              const li = (ai = Zo.filter((ui) => {
                if (Jo) {
                  const ci = getSideAxis(ui.placement);
                  return ci === Lo || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  ci === "y";
                }
                return !0;
              }).map((ui) => [ui.placement, ui.overflows.filter((ci) => ci > 0).reduce((ci, fi) => ci + fi, 0)]).sort((ui, ci) => ui[1] - ci[1])[0]) == null ? void 0 : ai[0];
              li && (si = li);
              break;
            }
            case "initialPlacement":
              si = Co;
              break;
          }
        if (bo !== si)
          return {
            reset: {
              placement: si
            }
          };
      }
      return {};
    }
  };
};
async function convertValueToCoords(Kt, uo) {
  const {
    placement: ho,
    platform: go,
    elements: bo
  } = Kt, vo = await (go.isRTL == null ? void 0 : go.isRTL(bo.floating)), Po = getSide(ho), Co = getAlignment(ho), So = getSideAxis(ho) === "y", wo = ["left", "top"].includes(Po) ? -1 : 1, Eo = vo && So ? -1 : 1, Ro = evaluate(uo, Kt);
  let {
    mainAxis: _o,
    crossAxis: Io,
    alignmentAxis: Ao
  } = typeof Ro == "number" ? {
    mainAxis: Ro,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: Ro.mainAxis || 0,
    crossAxis: Ro.crossAxis || 0,
    alignmentAxis: Ro.alignmentAxis
  };
  return Co && typeof Ao == "number" && (Io = Co === "end" ? Ao * -1 : Ao), So ? {
    x: Io * Eo,
    y: _o * wo
  } : {
    x: _o * wo,
    y: Io * Eo
  };
}
const offset$4 = function(Kt) {
  return Kt === void 0 && (Kt = 0), {
    name: "offset",
    options: Kt,
    async fn(uo) {
      var ho, go;
      const {
        x: bo,
        y: vo,
        placement: Po,
        middlewareData: Co
      } = uo, So = await convertValueToCoords(uo, Kt);
      return Po === ((ho = Co.offset) == null ? void 0 : ho.placement) && (go = Co.arrow) != null && go.alignmentOffset ? {} : {
        x: bo + So.x,
        y: vo + So.y,
        data: {
          ...So,
          placement: Po
        }
      };
    }
  };
}, shift$2 = function(Kt) {
  return Kt === void 0 && (Kt = {}), {
    name: "shift",
    options: Kt,
    async fn(uo) {
      const {
        x: ho,
        y: go,
        placement: bo
      } = uo, {
        mainAxis: vo = !0,
        crossAxis: Po = !1,
        limiter: Co = {
          fn: (jo) => {
            let {
              x: Do,
              y: Lo
            } = jo;
            return {
              x: Do,
              y: Lo
            };
          }
        },
        ...So
      } = evaluate(Kt, uo), wo = {
        x: ho,
        y: go
      }, Eo = await detectOverflow$1(uo, So), Ro = getSideAxis(getSide(bo)), _o = getOppositeAxis(Ro);
      let Io = wo[_o], Ao = wo[Ro];
      if (vo) {
        const jo = _o === "y" ? "top" : "left", Do = _o === "y" ? "bottom" : "right", Lo = Io + Eo[jo], ko = Io - Eo[Do];
        Io = clamp$2(Lo, Io, ko);
      }
      if (Po) {
        const jo = Ro === "y" ? "top" : "left", Do = Ro === "y" ? "bottom" : "right", Lo = Ao + Eo[jo], ko = Ao - Eo[Do];
        Ao = clamp$2(Lo, Ao, ko);
      }
      const Oo = Co.fn({
        ...uo,
        [_o]: Io,
        [Ro]: Ao
      });
      return {
        ...Oo,
        data: {
          x: Oo.x - ho,
          y: Oo.y - go,
          enabled: {
            [_o]: vo,
            [Ro]: Po
          }
        }
      };
    }
  };
};
function hasWindow() {
  return typeof window < "u";
}
function getNodeName$1(Kt) {
  return isNode(Kt) ? (Kt.nodeName || "").toLowerCase() : "#document";
}
function getWindow$1(Kt) {
  var uo;
  return (Kt == null || (uo = Kt.ownerDocument) == null ? void 0 : uo.defaultView) || window;
}
function getDocumentElement$1(Kt) {
  var uo;
  return (uo = (isNode(Kt) ? Kt.ownerDocument : Kt.document) || window.document) == null ? void 0 : uo.documentElement;
}
function isNode(Kt) {
  return hasWindow() ? Kt instanceof Node || Kt instanceof getWindow$1(Kt).Node : !1;
}
function isElement$1(Kt) {
  return hasWindow() ? Kt instanceof Element || Kt instanceof getWindow$1(Kt).Element : !1;
}
function isHTMLElement$2(Kt) {
  return hasWindow() ? Kt instanceof HTMLElement || Kt instanceof getWindow$1(Kt).HTMLElement : !1;
}
function isShadowRoot$1(Kt) {
  return !hasWindow() || typeof ShadowRoot > "u" ? !1 : Kt instanceof ShadowRoot || Kt instanceof getWindow$1(Kt).ShadowRoot;
}
function isOverflowElement(Kt) {
  const {
    overflow: uo,
    overflowX: ho,
    overflowY: go,
    display: bo
  } = getComputedStyle$2(Kt);
  return /auto|scroll|overlay|hidden|clip/.test(uo + go + ho) && !["inline", "contents"].includes(bo);
}
function isTableElement$1(Kt) {
  return ["table", "td", "th"].includes(getNodeName$1(Kt));
}
function isTopLayer(Kt) {
  return [":popover-open", ":modal"].some((uo) => {
    try {
      return Kt.matches(uo);
    } catch {
      return !1;
    }
  });
}
function isContainingBlock(Kt) {
  const uo = isWebKit(), ho = isElement$1(Kt) ? getComputedStyle$2(Kt) : Kt;
  return ho.transform !== "none" || ho.perspective !== "none" || (ho.containerType ? ho.containerType !== "normal" : !1) || !uo && (ho.backdropFilter ? ho.backdropFilter !== "none" : !1) || !uo && (ho.filter ? ho.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((go) => (ho.willChange || "").includes(go)) || ["paint", "layout", "strict", "content"].some((go) => (ho.contain || "").includes(go));
}
function getContainingBlock$1(Kt) {
  let uo = getParentNode$1(Kt);
  for (; isHTMLElement$2(uo) && !isLastTraversableNode(uo); ) {
    if (isContainingBlock(uo))
      return uo;
    if (isTopLayer(uo))
      return null;
    uo = getParentNode$1(uo);
  }
  return null;
}
function isWebKit() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function isLastTraversableNode(Kt) {
  return ["html", "body", "#document"].includes(getNodeName$1(Kt));
}
function getComputedStyle$2(Kt) {
  return getWindow$1(Kt).getComputedStyle(Kt);
}
function getNodeScroll$1(Kt) {
  return isElement$1(Kt) ? {
    scrollLeft: Kt.scrollLeft,
    scrollTop: Kt.scrollTop
  } : {
    scrollLeft: Kt.scrollX,
    scrollTop: Kt.scrollY
  };
}
function getParentNode$1(Kt) {
  if (getNodeName$1(Kt) === "html")
    return Kt;
  const uo = (
    // Step into the shadow DOM of the parent of a slotted node.
    Kt.assignedSlot || // DOM Element detected.
    Kt.parentNode || // ShadowRoot detected.
    isShadowRoot$1(Kt) && Kt.host || // Fallback.
    getDocumentElement$1(Kt)
  );
  return isShadowRoot$1(uo) ? uo.host : uo;
}
function getNearestOverflowAncestor(Kt) {
  const uo = getParentNode$1(Kt);
  return isLastTraversableNode(uo) ? Kt.ownerDocument ? Kt.ownerDocument.body : Kt.body : isHTMLElement$2(uo) && isOverflowElement(uo) ? uo : getNearestOverflowAncestor(uo);
}
function getOverflowAncestors(Kt, uo, ho) {
  var go;
  uo === void 0 && (uo = []), ho === void 0 && (ho = !0);
  const bo = getNearestOverflowAncestor(Kt), vo = bo === ((go = Kt.ownerDocument) == null ? void 0 : go.body), Po = getWindow$1(bo);
  if (vo) {
    const Co = getFrameElement(Po);
    return uo.concat(Po, Po.visualViewport || [], isOverflowElement(bo) ? bo : [], Co && ho ? getOverflowAncestors(Co) : []);
  }
  return uo.concat(bo, getOverflowAncestors(bo, [], ho));
}
function getFrameElement(Kt) {
  return Kt.parent && Object.getPrototypeOf(Kt.parent) ? Kt.frameElement : null;
}
function getCssDimensions(Kt) {
  const uo = getComputedStyle$2(Kt);
  let ho = parseFloat(uo.width) || 0, go = parseFloat(uo.height) || 0;
  const bo = isHTMLElement$2(Kt), vo = bo ? Kt.offsetWidth : ho, Po = bo ? Kt.offsetHeight : go, Co = round$4(ho) !== vo || round$4(go) !== Po;
  return Co && (ho = vo, go = Po), {
    width: ho,
    height: go,
    $: Co
  };
}
function unwrapElement(Kt) {
  return isElement$1(Kt) ? Kt : Kt.contextElement;
}
function getScale$1(Kt) {
  const uo = unwrapElement(Kt);
  if (!isHTMLElement$2(uo))
    return createCoords(1);
  const ho = uo.getBoundingClientRect(), {
    width: go,
    height: bo,
    $: vo
  } = getCssDimensions(uo);
  let Po = (vo ? round$4(ho.width) : ho.width) / go, Co = (vo ? round$4(ho.height) : ho.height) / bo;
  return (!Po || !Number.isFinite(Po)) && (Po = 1), (!Co || !Number.isFinite(Co)) && (Co = 1), {
    x: Po,
    y: Co
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(Kt) {
  const uo = getWindow$1(Kt);
  return !isWebKit() || !uo.visualViewport ? noOffsets : {
    x: uo.visualViewport.offsetLeft,
    y: uo.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(Kt, uo, ho) {
  return uo === void 0 && (uo = !1), !ho || uo && ho !== getWindow$1(Kt) ? !1 : uo;
}
function getBoundingClientRect$1(Kt, uo, ho, go) {
  uo === void 0 && (uo = !1), ho === void 0 && (ho = !1);
  const bo = Kt.getBoundingClientRect(), vo = unwrapElement(Kt);
  let Po = createCoords(1);
  uo && (go ? isElement$1(go) && (Po = getScale$1(go)) : Po = getScale$1(Kt));
  const Co = shouldAddVisualOffsets(vo, ho, go) ? getVisualOffsets(vo) : createCoords(0);
  let So = (bo.left + Co.x) / Po.x, wo = (bo.top + Co.y) / Po.y, Eo = bo.width / Po.x, Ro = bo.height / Po.y;
  if (vo) {
    const _o = getWindow$1(vo), Io = go && isElement$1(go) ? getWindow$1(go) : go;
    let Ao = _o, Oo = getFrameElement(Ao);
    for (; Oo && go && Io !== Ao; ) {
      const jo = getScale$1(Oo), Do = Oo.getBoundingClientRect(), Lo = getComputedStyle$2(Oo), ko = Do.left + (Oo.clientLeft + parseFloat(Lo.paddingLeft)) * jo.x, Ko = Do.top + (Oo.clientTop + parseFloat(Lo.paddingTop)) * jo.y;
      So *= jo.x, wo *= jo.y, Eo *= jo.x, Ro *= jo.y, So += ko, wo += Ko, Ao = getWindow$1(Oo), Oo = getFrameElement(Ao);
    }
  }
  return rectToClientRect$1({
    width: Eo,
    height: Ro,
    x: So,
    y: wo
  });
}
function getWindowScrollBarX$1(Kt, uo) {
  const ho = getNodeScroll$1(Kt).scrollLeft;
  return uo ? uo.left + ho : getBoundingClientRect$1(getDocumentElement$1(Kt)).left + ho;
}
function getHTMLOffset(Kt, uo, ho) {
  ho === void 0 && (ho = !1);
  const go = Kt.getBoundingClientRect(), bo = go.left + uo.scrollLeft - (ho ? 0 : (
    // RTL <body> scrollbar.
    getWindowScrollBarX$1(Kt, go)
  )), vo = go.top + uo.scrollTop;
  return {
    x: bo,
    y: vo
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(Kt) {
  let {
    elements: uo,
    rect: ho,
    offsetParent: go,
    strategy: bo
  } = Kt;
  const vo = bo === "fixed", Po = getDocumentElement$1(go), Co = uo ? isTopLayer(uo.floating) : !1;
  if (go === Po || Co && vo)
    return ho;
  let So = {
    scrollLeft: 0,
    scrollTop: 0
  }, wo = createCoords(1);
  const Eo = createCoords(0), Ro = isHTMLElement$2(go);
  if ((Ro || !Ro && !vo) && ((getNodeName$1(go) !== "body" || isOverflowElement(Po)) && (So = getNodeScroll$1(go)), isHTMLElement$2(go))) {
    const Io = getBoundingClientRect$1(go);
    wo = getScale$1(go), Eo.x = Io.x + go.clientLeft, Eo.y = Io.y + go.clientTop;
  }
  const _o = Po && !Ro && !vo ? getHTMLOffset(Po, So, !0) : createCoords(0);
  return {
    width: ho.width * wo.x,
    height: ho.height * wo.y,
    x: ho.x * wo.x - So.scrollLeft * wo.x + Eo.x + _o.x,
    y: ho.y * wo.y - So.scrollTop * wo.y + Eo.y + _o.y
  };
}
function getClientRects(Kt) {
  return Array.from(Kt.getClientRects());
}
function getDocumentRect$1(Kt) {
  const uo = getDocumentElement$1(Kt), ho = getNodeScroll$1(Kt), go = Kt.ownerDocument.body, bo = max$4(uo.scrollWidth, uo.clientWidth, go.scrollWidth, go.clientWidth), vo = max$4(uo.scrollHeight, uo.clientHeight, go.scrollHeight, go.clientHeight);
  let Po = -ho.scrollLeft + getWindowScrollBarX$1(Kt);
  const Co = -ho.scrollTop;
  return getComputedStyle$2(go).direction === "rtl" && (Po += max$4(uo.clientWidth, go.clientWidth) - bo), {
    width: bo,
    height: vo,
    x: Po,
    y: Co
  };
}
function getViewportRect$1(Kt, uo) {
  const ho = getWindow$1(Kt), go = getDocumentElement$1(Kt), bo = ho.visualViewport;
  let vo = go.clientWidth, Po = go.clientHeight, Co = 0, So = 0;
  if (bo) {
    vo = bo.width, Po = bo.height;
    const wo = isWebKit();
    (!wo || wo && uo === "fixed") && (Co = bo.offsetLeft, So = bo.offsetTop);
  }
  return {
    width: vo,
    height: Po,
    x: Co,
    y: So
  };
}
function getInnerBoundingClientRect$1(Kt, uo) {
  const ho = getBoundingClientRect$1(Kt, !0, uo === "fixed"), go = ho.top + Kt.clientTop, bo = ho.left + Kt.clientLeft, vo = isHTMLElement$2(Kt) ? getScale$1(Kt) : createCoords(1), Po = Kt.clientWidth * vo.x, Co = Kt.clientHeight * vo.y, So = bo * vo.x, wo = go * vo.y;
  return {
    width: Po,
    height: Co,
    x: So,
    y: wo
  };
}
function getClientRectFromClippingAncestor(Kt, uo, ho) {
  let go;
  if (uo === "viewport")
    go = getViewportRect$1(Kt, ho);
  else if (uo === "document")
    go = getDocumentRect$1(getDocumentElement$1(Kt));
  else if (isElement$1(uo))
    go = getInnerBoundingClientRect$1(uo, ho);
  else {
    const bo = getVisualOffsets(Kt);
    go = {
      x: uo.x - bo.x,
      y: uo.y - bo.y,
      width: uo.width,
      height: uo.height
    };
  }
  return rectToClientRect$1(go);
}
function hasFixedPositionAncestor(Kt, uo) {
  const ho = getParentNode$1(Kt);
  return ho === uo || !isElement$1(ho) || isLastTraversableNode(ho) ? !1 : getComputedStyle$2(ho).position === "fixed" || hasFixedPositionAncestor(ho, uo);
}
function getClippingElementAncestors(Kt, uo) {
  const ho = uo.get(Kt);
  if (ho)
    return ho;
  let go = getOverflowAncestors(Kt, [], !1).filter((Co) => isElement$1(Co) && getNodeName$1(Co) !== "body"), bo = null;
  const vo = getComputedStyle$2(Kt).position === "fixed";
  let Po = vo ? getParentNode$1(Kt) : Kt;
  for (; isElement$1(Po) && !isLastTraversableNode(Po); ) {
    const Co = getComputedStyle$2(Po), So = isContainingBlock(Po);
    !So && Co.position === "fixed" && (bo = null), (vo ? !So && !bo : !So && Co.position === "static" && !!bo && ["absolute", "fixed"].includes(bo.position) || isOverflowElement(Po) && !So && hasFixedPositionAncestor(Kt, Po)) ? go = go.filter((Eo) => Eo !== Po) : bo = Co, Po = getParentNode$1(Po);
  }
  return uo.set(Kt, go), go;
}
function getClippingRect$1(Kt) {
  let {
    element: uo,
    boundary: ho,
    rootBoundary: go,
    strategy: bo
  } = Kt;
  const Po = [...ho === "clippingAncestors" ? isTopLayer(uo) ? [] : getClippingElementAncestors(uo, this._c) : [].concat(ho), go], Co = Po[0], So = Po.reduce((wo, Eo) => {
    const Ro = getClientRectFromClippingAncestor(uo, Eo, bo);
    return wo.top = max$4(Ro.top, wo.top), wo.right = min$4(Ro.right, wo.right), wo.bottom = min$4(Ro.bottom, wo.bottom), wo.left = max$4(Ro.left, wo.left), wo;
  }, getClientRectFromClippingAncestor(uo, Co, bo));
  return {
    width: So.right - So.left,
    height: So.bottom - So.top,
    x: So.left,
    y: So.top
  };
}
function getDimensions(Kt) {
  const {
    width: uo,
    height: ho
  } = getCssDimensions(Kt);
  return {
    width: uo,
    height: ho
  };
}
function getRectRelativeToOffsetParent(Kt, uo, ho) {
  const go = isHTMLElement$2(uo), bo = getDocumentElement$1(uo), vo = ho === "fixed", Po = getBoundingClientRect$1(Kt, !0, vo, uo);
  let Co = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const So = createCoords(0);
  if (go || !go && !vo)
    if ((getNodeName$1(uo) !== "body" || isOverflowElement(bo)) && (Co = getNodeScroll$1(uo)), go) {
      const _o = getBoundingClientRect$1(uo, !0, vo, uo);
      So.x = _o.x + uo.clientLeft, So.y = _o.y + uo.clientTop;
    } else bo && (So.x = getWindowScrollBarX$1(bo));
  const wo = bo && !go && !vo ? getHTMLOffset(bo, Co) : createCoords(0), Eo = Po.left + Co.scrollLeft - So.x - wo.x, Ro = Po.top + Co.scrollTop - So.y - wo.y;
  return {
    x: Eo,
    y: Ro,
    width: Po.width,
    height: Po.height
  };
}
function isStaticPositioned(Kt) {
  return getComputedStyle$2(Kt).position === "static";
}
function getTrueOffsetParent$1(Kt, uo) {
  if (!isHTMLElement$2(Kt) || getComputedStyle$2(Kt).position === "fixed")
    return null;
  if (uo)
    return uo(Kt);
  let ho = Kt.offsetParent;
  return getDocumentElement$1(Kt) === ho && (ho = ho.ownerDocument.body), ho;
}
function getOffsetParent$1(Kt, uo) {
  const ho = getWindow$1(Kt);
  if (isTopLayer(Kt))
    return ho;
  if (!isHTMLElement$2(Kt)) {
    let bo = getParentNode$1(Kt);
    for (; bo && !isLastTraversableNode(bo); ) {
      if (isElement$1(bo) && !isStaticPositioned(bo))
        return bo;
      bo = getParentNode$1(bo);
    }
    return ho;
  }
  let go = getTrueOffsetParent$1(Kt, uo);
  for (; go && isTableElement$1(go) && isStaticPositioned(go); )
    go = getTrueOffsetParent$1(go, uo);
  return go && isLastTraversableNode(go) && isStaticPositioned(go) && !isContainingBlock(go) ? ho : go || getContainingBlock$1(Kt) || ho;
}
const getElementRects = async function(Kt) {
  const uo = this.getOffsetParent || getOffsetParent$1, ho = this.getDimensions, go = await ho(Kt.floating);
  return {
    reference: getRectRelativeToOffsetParent(Kt.reference, await uo(Kt.floating), Kt.strategy),
    floating: {
      x: 0,
      y: 0,
      width: go.width,
      height: go.height
    }
  };
};
function isRTL(Kt) {
  return getComputedStyle$2(Kt).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement: getDocumentElement$1,
  getClippingRect: getClippingRect$1,
  getOffsetParent: getOffsetParent$1,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale: getScale$1,
  isElement: isElement$1,
  isRTL
};
function observeMove(Kt, uo) {
  let ho = null, go;
  const bo = getDocumentElement$1(Kt);
  function vo() {
    var Co;
    clearTimeout(go), (Co = ho) == null || Co.disconnect(), ho = null;
  }
  function Po(Co, So) {
    Co === void 0 && (Co = !1), So === void 0 && (So = 1), vo();
    const {
      left: wo,
      top: Eo,
      width: Ro,
      height: _o
    } = Kt.getBoundingClientRect();
    if (Co || uo(), !Ro || !_o)
      return;
    const Io = floor(Eo), Ao = floor(bo.clientWidth - (wo + Ro)), Oo = floor(bo.clientHeight - (Eo + _o)), jo = floor(wo), Lo = {
      rootMargin: -Io + "px " + -Ao + "px " + -Oo + "px " + -jo + "px",
      threshold: max$4(0, min$4(1, So)) || 1
    };
    let ko = !0;
    function Ko(No) {
      const Jo = No[0].intersectionRatio;
      if (Jo !== So) {
        if (!ko)
          return Po();
        Jo ? Po(!1, Jo) : go = setTimeout(() => {
          Po(!1, 1e-7);
        }, 1e3);
      }
      ko = !1;
    }
    try {
      ho = new IntersectionObserver(Ko, {
        ...Lo,
        // Handle <iframe>s
        root: bo.ownerDocument
      });
    } catch {
      ho = new IntersectionObserver(Ko, Lo);
    }
    ho.observe(Kt);
  }
  return Po(!0), vo;
}
function autoUpdate(Kt, uo, ho, go) {
  go === void 0 && (go = {});
  const {
    ancestorScroll: bo = !0,
    ancestorResize: vo = !0,
    elementResize: Po = typeof ResizeObserver == "function",
    layoutShift: Co = typeof IntersectionObserver == "function",
    animationFrame: So = !1
  } = go, wo = unwrapElement(Kt), Eo = bo || vo ? [...wo ? getOverflowAncestors(wo) : [], ...getOverflowAncestors(uo)] : [];
  Eo.forEach((Do) => {
    bo && Do.addEventListener("scroll", ho, {
      passive: !0
    }), vo && Do.addEventListener("resize", ho);
  });
  const Ro = wo && Co ? observeMove(wo, ho) : null;
  let _o = -1, Io = null;
  Po && (Io = new ResizeObserver((Do) => {
    let [Lo] = Do;
    Lo && Lo.target === wo && Io && (Io.unobserve(uo), cancelAnimationFrame(_o), _o = requestAnimationFrame(() => {
      var ko;
      (ko = Io) == null || ko.observe(uo);
    })), ho();
  }), wo && !So && Io.observe(wo), Io.observe(uo));
  let Ao, Oo = So ? getBoundingClientRect$1(Kt) : null;
  So && jo();
  function jo() {
    const Do = getBoundingClientRect$1(Kt);
    Oo && (Do.x !== Oo.x || Do.y !== Oo.y || Do.width !== Oo.width || Do.height !== Oo.height) && ho(), Oo = Do, Ao = requestAnimationFrame(jo);
  }
  return ho(), () => {
    var Do;
    Eo.forEach((Lo) => {
      bo && Lo.removeEventListener("scroll", ho), vo && Lo.removeEventListener("resize", ho);
    }), Ro == null || Ro(), (Do = Io) == null || Do.disconnect(), Io = null, So && cancelAnimationFrame(Ao);
  };
}
const offset$3 = offset$4, shift$1 = shift$2, flip$3 = flip$4, computePosition = (Kt, uo, ho) => {
  const go = /* @__PURE__ */ new Map(), bo = {
    platform,
    ...ho
  }, vo = {
    ...bo.platform,
    _c: go
  };
  return computePosition$1(Kt, uo, {
    ...bo,
    platform: vo
  });
};
var index = typeof document < "u" ? useLayoutEffect : useEffect;
function deepEqual$1(Kt, uo) {
  if (Kt === uo)
    return !0;
  if (typeof Kt != typeof uo)
    return !1;
  if (typeof Kt == "function" && Kt.toString() === uo.toString())
    return !0;
  let ho, go, bo;
  if (Kt && uo && typeof Kt == "object") {
    if (Array.isArray(Kt)) {
      if (ho = Kt.length, ho !== uo.length) return !1;
      for (go = ho; go-- !== 0; )
        if (!deepEqual$1(Kt[go], uo[go]))
          return !1;
      return !0;
    }
    if (bo = Object.keys(Kt), ho = bo.length, ho !== Object.keys(uo).length)
      return !1;
    for (go = ho; go-- !== 0; )
      if (!{}.hasOwnProperty.call(uo, bo[go]))
        return !1;
    for (go = ho; go-- !== 0; ) {
      const vo = bo[go];
      if (!(vo === "_owner" && Kt.$$typeof) && !deepEqual$1(Kt[vo], uo[vo]))
        return !1;
    }
    return !0;
  }
  return Kt !== Kt && uo !== uo;
}
function getDPR(Kt) {
  return typeof window > "u" ? 1 : (Kt.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(Kt, uo) {
  const ho = getDPR(Kt);
  return Math.round(uo * ho) / ho;
}
function useLatestRef(Kt) {
  const uo = React$1.useRef(Kt);
  return index(() => {
    uo.current = Kt;
  }), uo;
}
function useFloating(Kt) {
  Kt === void 0 && (Kt = {});
  const {
    placement: uo = "bottom",
    strategy: ho = "absolute",
    middleware: go = [],
    platform: bo,
    elements: {
      reference: vo,
      floating: Po
    } = {},
    transform: Co = !0,
    whileElementsMounted: So,
    open: wo
  } = Kt, [Eo, Ro] = React$1.useState({
    x: 0,
    y: 0,
    strategy: ho,
    placement: uo,
    middlewareData: {},
    isPositioned: !1
  }), [_o, Io] = React$1.useState(go);
  deepEqual$1(_o, go) || Io(go);
  const [Ao, Oo] = React$1.useState(null), [jo, Do] = React$1.useState(null), Lo = React$1.useCallback((ui) => {
    ui !== Jo.current && (Jo.current = ui, Oo(ui));
  }, []), ko = React$1.useCallback((ui) => {
    ui !== ti.current && (ti.current = ui, Do(ui));
  }, []), Ko = vo || Ao, No = Po || jo, Jo = React$1.useRef(null), ti = React$1.useRef(null), oi = React$1.useRef(Eo), Qo = So != null, Zo = useLatestRef(So), ei = useLatestRef(bo), ii = useLatestRef(wo), ai = React$1.useCallback(() => {
    if (!Jo.current || !ti.current)
      return;
    const ui = {
      placement: uo,
      strategy: ho,
      middleware: _o
    };
    ei.current && (ui.platform = ei.current), computePosition(Jo.current, ti.current, ui).then((ci) => {
      const fi = {
        ...ci,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: ii.current !== !1
      };
      ri.current && !deepEqual$1(oi.current, fi) && (oi.current = fi, ReactDOM.flushSync(() => {
        Ro(fi);
      }));
    });
  }, [_o, uo, ho, ei, ii]);
  index(() => {
    wo === !1 && oi.current.isPositioned && (oi.current.isPositioned = !1, Ro((ui) => ({
      ...ui,
      isPositioned: !1
    })));
  }, [wo]);
  const ri = React$1.useRef(!1);
  index(() => (ri.current = !0, () => {
    ri.current = !1;
  }), []), index(() => {
    if (Ko && (Jo.current = Ko), No && (ti.current = No), Ko && No) {
      if (Zo.current)
        return Zo.current(Ko, No, ai);
      ai();
    }
  }, [Ko, No, ai, Zo, Qo]);
  const ni = React$1.useMemo(() => ({
    reference: Jo,
    floating: ti,
    setReference: Lo,
    setFloating: ko
  }), [Lo, ko]), si = React$1.useMemo(() => ({
    reference: Ko,
    floating: No
  }), [Ko, No]), li = React$1.useMemo(() => {
    const ui = {
      position: ho,
      left: 0,
      top: 0
    };
    if (!si.floating)
      return ui;
    const ci = roundByDPR(si.floating, Eo.x), fi = roundByDPR(si.floating, Eo.y);
    return Co ? {
      ...ui,
      transform: "translate(" + ci + "px, " + fi + "px)",
      ...getDPR(si.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: ho,
      left: ci,
      top: fi
    };
  }, [ho, Co, si.floating, Eo.x, Eo.y]);
  return React$1.useMemo(() => ({
    ...Eo,
    update: ai,
    refs: ni,
    elements: si,
    floatingStyles: li
  }), [Eo, ai, ni, si, li]);
}
const offset$2 = (Kt, uo) => ({
  ...offset$3(Kt),
  options: [Kt, uo]
}), shift = (Kt, uo) => ({
  ...shift$1(Kt),
  options: [Kt, uo]
}), flip$2 = (Kt, uo) => ({
  ...flip$3(Kt),
  options: [Kt, uo]
});
function getContainer$3(Kt) {
  return typeof Kt == "function" ? Kt() : Kt;
}
const Portal$1 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    children: go,
    container: bo,
    disablePortal: vo = !1
  } = uo, [Po, Co] = React$1.useState(null), So = useForkRef(/* @__PURE__ */ React$1.isValidElement(go) ? getReactElementRef(go) : null, ho);
  if (useEnhancedEffect(() => {
    vo || Co(getContainer$3(bo) || document.body);
  }, [bo, vo]), useEnhancedEffect(() => {
    if (Po && !vo)
      return setRef(ho, Po), () => {
        setRef(ho, null);
      };
  }, [ho, Po, vo]), vo) {
    if (/* @__PURE__ */ React$1.isValidElement(go)) {
      const wo = {
        ref: So
      };
      return /* @__PURE__ */ React$1.cloneElement(go, wo);
    }
    return go;
  }
  return Po && /* @__PURE__ */ ReactDOM.createPortal(go, Po);
});
process.env.NODE_ENV !== "production" && (Portal$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Portal$1.propTypes = exactProp(Portal$1.propTypes));
const COMPONENT_NAME$8 = "Popup";
function getPopupUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME$8, Kt);
}
generateUtilityClasses(COMPONENT_NAME$8, ["root", "open"]);
const TransitionContext = /* @__PURE__ */ React$1.createContext(null);
process.env.NODE_ENV !== "production" && (TransitionContext.displayName = "TransitionContext");
function useTransitionTrigger(Kt) {
  const [uo, ho] = React$1.useState(!0), go = React$1.useRef(!1), bo = React$1.useRef(0), [vo, Po] = React$1.useState(!1), Co = React$1.useRef(Kt);
  React$1.useEffect(() => {
    !Kt && // checking registeredTransitions.current instead of hasTransition to avoid this effect re-firing whenever hasTransition changes
    bo.current > 0 && // prevents waiting for a pending transition right after mounting
    Co.current !== Kt && (go.current = !0, ho(!1)), Co.current = Kt;
  }, [Kt]);
  const So = React$1.useCallback(() => {
    go.current = !1, ho(!0);
  }, []), wo = React$1.useCallback(() => (bo.current += 1, Po(!0), () => {
    bo.current -= 1, bo.current === 0 && Po(!1);
  }), []);
  let Eo;
  return vo ? Kt ? Eo = !1 : Eo = !go.current && uo : Eo = !Kt, {
    contextValue: React$1.useMemo(() => ({
      requestedEnter: Kt,
      onExited: So,
      registerTransition: wo,
      hasExited: Eo
    }), [So, Kt, wo, Eo]),
    hasExited: Eo
  };
}
const PopupContext = /* @__PURE__ */ React$1.createContext(null);
process.env.NODE_ENV !== "production" && (PopupContext.displayName = "PopupContext");
function useUtilityClasses$1y(Kt) {
  const {
    open: uo
  } = Kt;
  return composeClasses({
    root: ["root", uo && "open"]
  }, useClassNamesOverride(getPopupUtilityClass));
}
function resolveAnchor(Kt) {
  return typeof Kt == "function" ? Kt() : Kt;
}
const Popup = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    anchor: go,
    children: bo,
    container: vo,
    disablePortal: Po = !1,
    keepMounted: Co = !1,
    middleware: So,
    offset: wo = 0,
    open: Eo = !1,
    placement: Ro = "bottom",
    slotProps: _o = {},
    slots: Io = {},
    strategy: Ao = "absolute",
    ...Oo
  } = uo, {
    refs: jo,
    elements: Do,
    floatingStyles: Lo,
    update: ko,
    placement: Ko
  } = useFloating({
    elements: {
      reference: resolveAnchor(go)
    },
    open: Eo,
    middleware: So ?? [offset$2(wo ?? 0), flip$2(), shift()],
    placement: Ro,
    strategy: Ao,
    whileElementsMounted: Co ? void 0 : autoUpdate
  }), No = useForkRef(jo.setFloating, ho);
  useEnhancedEffect(() => {
    if (Co && Eo && Do.reference && Do.floating)
      return autoUpdate(Do.reference, Do.floating, ko);
  }, [Co, Eo, Do, ko]);
  const Jo = {
    ...uo,
    disablePortal: Po,
    keepMounted: Co,
    offset: offset$2,
    open: Eo,
    placement: Ro,
    finalPlacement: Ko,
    strategy: Ao
  }, {
    contextValue: ti,
    hasExited: oi
  } = useTransitionTrigger(Eo), Qo = Co && oi ? "hidden" : void 0, Zo = useUtilityClasses$1y(Jo), ei = (Io == null ? void 0 : Io.root) ?? "div", ii = useSlotProps({
    elementType: ei,
    externalSlotProps: _o.root,
    externalForwardedProps: Oo,
    ownerState: Jo,
    className: Zo.root,
    additionalProps: {
      ref: No,
      role: "tooltip",
      style: {
        ...Lo,
        visibility: Qo
      }
    }
  }), ai = React$1.useMemo(() => ({
    placement: Ko
  }), [Ko]);
  return Co || !oi ? /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$1, {
    disablePortal: Po,
    container: vo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopupContext.Provider, {
      value: ai,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionContext.Provider, {
        value: ti,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ei, {
          ...ii,
          children: bo
        })
      })
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Popup.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtual element](https://floating-ui.com/docs/virtual-elements),
   * or a function that returns either.
   * It's used to set the position of the popup.
   */
  anchor: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * @ignore
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one. The container will have the portal children appended to it.
   * By default, it uses the body of the top-level document object, so it's `document.body` in these cases.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the popup will be rendered where it is defined, without the use of portals.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the popup will exist in the DOM even if it's closed.
   * Its visibility will be controlled by the `visibility` CSS property.
   *
   * Otherwise, a closed popup will be removed from the DOM.
   *
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Collection of Floating UI middleware to use when positioning the popup.
   * If not provided, the [`offset`](https://floating-ui.com/docs/offset)
   * and [`flip`](https://floating-ui.com/docs/flip) functions will be used.
   *
   * @see https://floating-ui.com/docs/computePosition#middleware
   */
  middleware: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf([!1]), PropTypes.shape({
    fn: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.any
  })])),
  /**
   * Distance between a popup and the trigger element.
   * This prop is ignored when custom `middleware` is provided.
   *
   * @default 0
   * @see https://floating-ui.com/docs/offset
   */
  offset: PropTypes.oneOfType([PropTypes.func, PropTypes.number, PropTypes.shape({
    alignmentAxis: PropTypes.number,
    crossAxis: PropTypes.number,
    mainAxis: PropTypes.number
  })]),
  /**
   * If `true`, the popup is visible.
   *
   * @default false
   */
  open: PropTypes.bool,
  /**
   * Determines where to place the popup relative to the trigger element.
   *
   * @default 'bottom'
   * @see https://floating-ui.com/docs/computePosition#placement
   */
  placement: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The props used for each slot inside the Popup.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popup.
   * Either a string to use a HTML element or a component.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The type of CSS position property to use (absolute or fixed).
   *
   * @default 'absolute'
   * @see https://floating-ui.com/docs/computePosition#strategy
   */
  strategy: PropTypes.oneOf(["absolute", "fixed"])
});
function useUtilityClasses$1x(Kt) {
  const {
    open: uo
  } = Kt;
  return composeClasses({
    root: ["root", uo && "expanded"],
    listbox: ["listbox", uo && "expanded"]
  }, useClassNamesOverride(getMenuUtilityClass$1));
}
const Menu$1 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    actions: go,
    anchor: bo,
    children: vo,
    onItemsChange: Po,
    slotProps: Co = {},
    slots: So = {},
    ...wo
  } = uo, {
    contextValue: Eo,
    getListboxProps: Ro,
    dispatch: _o,
    open: Io,
    triggerElement: Ao
  } = useMenu({
    onItemsChange: Po,
    componentName: "Menu"
  }), Oo = bo ?? Ao;
  React$1.useImperativeHandle(go, () => ({
    dispatch: _o,
    resetHighlight: () => _o({
      type: ListActionTypes.resetHighlight,
      event: null
    })
  }), [_o]);
  const jo = {
    ...uo,
    open: Io
  }, Do = useUtilityClasses$1x(jo), Lo = So.root ?? "div", ko = useSlotProps({
    elementType: Lo,
    externalSlotProps: Co.root,
    externalForwardedProps: wo,
    additionalProps: {
      ref: ho,
      role: void 0
    },
    className: Do.root,
    ownerState: jo
  }), Ko = So.listbox ?? "ul", No = useSlotProps({
    elementType: Ko,
    getSlotProps: Ro,
    externalSlotProps: Co.listbox,
    className: Do.listbox,
    ownerState: jo
  });
  return Io === !0 && Oo == null ? /* @__PURE__ */ jsxRuntimeExports.jsx(Lo, {
    ...ko,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ko, {
      ...No,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuProvider, {
        value: Eo,
        children: vo
      })
    })
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Popup, {
    keepMounted: !0,
    ...ko,
    open: Io,
    anchor: Oo,
    slots: {
      root: Lo
    },
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ko, {
      ...No,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuProvider, {
        value: Eo,
        children: vo
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Menu$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref with imperative actions that can be performed on the menu.
   */
  actions: refType,
  /**
   * The element based on which the menu is positioned.
   */
  anchor: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Function called when the items displayed in the menu change.
   */
  onItemsChange: PropTypes.func,
  /**
   * The props used for each slot inside the Menu.
   * @default {}
   */
  slotProps: PropTypes.shape({
    listbox: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Menu.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    listbox: PropTypes.elementType,
    root: PropTypes.elementType
  })
});
function useMenuButton(Kt = {}) {
  const {
    disabled: uo = !1,
    focusableWhenDisabled: ho,
    rootRef: go
  } = Kt, bo = React$1.useContext(DropdownContext);
  if (bo === null)
    throw new Error("useMenuButton: no menu context available.");
  const {
    state: vo,
    dispatch: Po,
    registerTrigger: Co,
    popupId: So
  } = bo, {
    getRootProps: wo,
    rootRef: Eo,
    active: Ro
  } = useButton({
    disabled: uo,
    focusableWhenDisabled: ho,
    rootRef: go
  }), _o = useForkRef(Eo, Co), Io = (Do) => (Lo) => {
    var ko;
    (ko = Do.onClick) == null || ko.call(Do, Lo), !Lo.defaultMuiPrevented && Po({
      type: DropdownActionTypes.toggle,
      event: Lo
    });
  }, Ao = (Do) => (Lo) => {
    var ko;
    (ko = Do.onKeyDown) == null || ko.call(Do, Lo), !Lo.defaultMuiPrevented && (Lo.key === "ArrowDown" || Lo.key === "ArrowUp") && (Lo.preventDefault(), Po({
      type: DropdownActionTypes.open,
      event: Lo
    }));
  }, Oo = (Do = {}) => ({
    onClick: Io(Do),
    onKeyDown: Ao(Do)
  });
  return {
    active: Ro,
    getRootProps: (Do = {}) => {
      const Lo = extractEventHandlers(Do), ko = combineHooksSlotProps(Oo, wo);
      return {
        "aria-haspopup": "menu",
        "aria-expanded": vo.open,
        "aria-controls": So,
        ...Do,
        ...Lo,
        ...ko(Lo),
        tabIndex: 0,
        // this is needed to make the button focused after click in Safari
        ref: _o
      };
    },
    open: vo.open,
    rootRef: _o
  };
}
const COMPONENT_NAME$7 = "MenuButton";
function getMenuButtonUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME$7, Kt);
}
generateUtilityClasses(COMPONENT_NAME$7, ["root", "active", "disabled", "expanded"]);
const useUtilityClasses$1w = (Kt) => {
  const {
    active: uo,
    disabled: ho,
    open: go
  } = Kt;
  return composeClasses({
    root: ["root", ho && "disabled", uo && "active", go && "expanded"]
  }, useClassNamesOverride(getMenuButtonUtilityClass));
}, MenuButton = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    children: go,
    disabled: bo = !1,
    label: vo,
    slots: Po = {},
    slotProps: Co = {},
    focusableWhenDisabled: So = !1,
    ...wo
  } = uo, {
    getRootProps: Eo,
    open: Ro,
    active: _o
  } = useMenuButton({
    disabled: bo,
    focusableWhenDisabled: So,
    rootRef: ho
  }), Io = {
    ...uo,
    open: Ro,
    active: _o,
    disabled: bo,
    focusableWhenDisabled: So
  }, Ao = useUtilityClasses$1w(Io), Oo = Po.root || "button", jo = useSlotProps({
    elementType: Oo,
    getSlotProps: Eo,
    externalForwardedProps: wo,
    externalSlotProps: Co.root,
    additionalProps: {
      ref: ho,
      type: "button"
    },
    ownerState: Io,
    className: Ao.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Oo, {
    ...jo,
    children: go
  });
});
process.env.NODE_ENV !== "production" && (MenuButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Class name applied to the root element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, allows a disabled button to receive focus.
   * @default false
   */
  focusableWhenDisabled: PropTypes.bool,
  /**
   * Label of the button
   */
  label: PropTypes.string,
  /**
   * The components used for each slot inside the MenuButton.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The props used for each slot inside the MenuButton.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  })
});
function isOverflowing$1(Kt) {
  const uo = ownerDocument(Kt);
  return uo.body === Kt ? ownerWindow(Kt).innerWidth > uo.documentElement.clientWidth : Kt.scrollHeight > Kt.clientHeight;
}
function ariaHidden$1(Kt, uo) {
  uo ? Kt.setAttribute("aria-hidden", "true") : Kt.removeAttribute("aria-hidden");
}
function getPaddingRight$1(Kt) {
  return parseInt(ownerWindow(Kt).getComputedStyle(Kt).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement$1(Kt) {
  const ho = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(Kt.tagName), go = Kt.tagName === "INPUT" && Kt.getAttribute("type") === "hidden";
  return ho || go;
}
function ariaHiddenSiblings$1(Kt, uo, ho, go, bo) {
  const vo = [uo, ho, ...go];
  [].forEach.call(Kt.children, (Po) => {
    const Co = !vo.includes(Po), So = !isAriaHiddenForbiddenOnElement$1(Po);
    Co && So && ariaHidden$1(Po, bo);
  });
}
function findIndexOf$1(Kt, uo) {
  let ho = -1;
  return Kt.some((go, bo) => uo(go) ? (ho = bo, !0) : !1), ho;
}
function handleContainer$1(Kt, uo) {
  const ho = [], go = Kt.container;
  if (!uo.disableScrollLock) {
    if (isOverflowing$1(go)) {
      const Po = getScrollbarSize(ownerWindow(go));
      ho.push({
        value: go.style.paddingRight,
        property: "padding-right",
        el: go
      }), go.style.paddingRight = `${getPaddingRight$1(go) + Po}px`;
      const Co = ownerDocument(go).querySelectorAll(".mui-fixed");
      [].forEach.call(Co, (So) => {
        ho.push({
          value: So.style.paddingRight,
          property: "padding-right",
          el: So
        }), So.style.paddingRight = `${getPaddingRight$1(So) + Po}px`;
      });
    }
    let vo;
    if (go.parentNode instanceof DocumentFragment)
      vo = ownerDocument(go).body;
    else {
      const Po = go.parentElement, Co = ownerWindow(go);
      vo = (Po == null ? void 0 : Po.nodeName) === "HTML" && Co.getComputedStyle(Po).overflowY === "scroll" ? Po : go;
    }
    ho.push({
      value: vo.style.overflow,
      property: "overflow",
      el: vo
    }, {
      value: vo.style.overflowX,
      property: "overflow-x",
      el: vo
    }, {
      value: vo.style.overflowY,
      property: "overflow-y",
      el: vo
    }), vo.style.overflow = "hidden";
  }
  return () => {
    ho.forEach(({
      value: vo,
      el: Po,
      property: Co
    }) => {
      vo ? Po.style.setProperty(Co, vo) : Po.style.removeProperty(Co);
    });
  };
}
function getHiddenSiblings$1(Kt) {
  const uo = [];
  return [].forEach.call(Kt.children, (ho) => {
    ho.getAttribute("aria-hidden") === "true" && uo.push(ho);
  }), uo;
}
let ModalManager$1 = class {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(uo, ho) {
    let go = this.modals.indexOf(uo);
    if (go !== -1)
      return go;
    go = this.modals.length, this.modals.push(uo), uo.modalRef && ariaHidden$1(uo.modalRef, !1);
    const bo = getHiddenSiblings$1(ho);
    ariaHiddenSiblings$1(ho, uo.mount, uo.modalRef, bo, !0);
    const vo = findIndexOf$1(this.containers, (Po) => Po.container === ho);
    return vo !== -1 ? (this.containers[vo].modals.push(uo), go) : (this.containers.push({
      modals: [uo],
      container: ho,
      restore: null,
      hiddenSiblings: bo
    }), go);
  }
  mount(uo, ho) {
    const go = findIndexOf$1(this.containers, (vo) => vo.modals.includes(uo)), bo = this.containers[go];
    bo.restore || (bo.restore = handleContainer$1(bo, ho));
  }
  remove(uo, ho = !0) {
    const go = this.modals.indexOf(uo);
    if (go === -1)
      return go;
    const bo = findIndexOf$1(this.containers, (Po) => Po.modals.includes(uo)), vo = this.containers[bo];
    if (vo.modals.splice(vo.modals.indexOf(uo), 1), this.modals.splice(go, 1), vo.modals.length === 0)
      vo.restore && vo.restore(), uo.modalRef && ariaHidden$1(uo.modalRef, ho), ariaHiddenSiblings$1(vo.container, uo.mount, uo.modalRef, vo.hiddenSiblings, !1), this.containers.splice(bo, 1);
    else {
      const Po = vo.modals[vo.modals.length - 1];
      Po.modalRef && ariaHidden$1(Po.modalRef, !1);
    }
    return go;
  }
  isTopModal(uo) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === uo;
  }
};
function getContainer$2(Kt) {
  return typeof Kt == "function" ? Kt() : Kt;
}
function getHasTransition$1(Kt) {
  return Kt ? Kt.props.hasOwnProperty("in") : !1;
}
const defaultManager = new ModalManager$1();
function useModal$1(Kt) {
  const {
    container: uo,
    disableEscapeKeyDown: ho = !1,
    disableScrollLock: go = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: bo = defaultManager,
    closeAfterTransition: vo = !1,
    onTransitionEnter: Po,
    onTransitionExited: Co,
    children: So,
    onClose: wo,
    open: Eo,
    rootRef: Ro
  } = Kt, _o = React$1.useRef({}), Io = React$1.useRef(null), Ao = React$1.useRef(null), Oo = useForkRef(Ao, Ro), [jo, Do] = React$1.useState(!Eo), Lo = getHasTransition$1(So);
  let ko = !0;
  (Kt["aria-hidden"] === "false" || Kt["aria-hidden"] === !1) && (ko = !1);
  const Ko = () => ownerDocument(Io.current), No = () => (_o.current.modalRef = Ao.current, _o.current.mount = Io.current, _o.current), Jo = () => {
    bo.mount(No(), {
      disableScrollLock: go
    }), Ao.current && (Ao.current.scrollTop = 0);
  }, ti = useEventCallback(() => {
    const si = getContainer$2(uo) || Ko().body;
    bo.add(No(), si), Ao.current && Jo();
  }), oi = React$1.useCallback(() => bo.isTopModal(No()), [bo]), Qo = useEventCallback((si) => {
    Io.current = si, si && (Eo && oi() ? Jo() : Ao.current && ariaHidden$1(Ao.current, ko));
  }), Zo = React$1.useCallback(() => {
    bo.remove(No(), ko);
  }, [ko, bo]);
  React$1.useEffect(() => () => {
    Zo();
  }, [Zo]), React$1.useEffect(() => {
    Eo ? ti() : (!Lo || !vo) && Zo();
  }, [Eo, Zo, Lo, vo, ti]);
  const ei = (si) => (li) => {
    var ui;
    (ui = si.onKeyDown) == null || ui.call(si, li), !(li.key !== "Escape" || li.which === 229 || // Wait until IME is settled.
    !oi()) && (ho || (li.stopPropagation(), wo && wo(li, "escapeKeyDown")));
  }, ii = (si) => (li) => {
    var ui;
    (ui = si.onClick) == null || ui.call(si, li), li.target === li.currentTarget && wo && wo(li, "backdropClick");
  };
  return {
    getRootProps: (si = {}) => {
      const li = extractEventHandlers(Kt);
      delete li.onTransitionEnter, delete li.onTransitionExited;
      const ui = {
        ...li,
        ...si
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...ui,
        onKeyDown: ei(ui),
        ref: Oo
      };
    },
    getBackdropProps: (si = {}) => {
      const li = si;
      return {
        "aria-hidden": !0,
        ...li,
        onClick: ii(li),
        open: Eo
      };
    },
    getTransitionProps: () => {
      const si = () => {
        Do(!1), Po && Po();
      }, li = () => {
        Do(!0), Co && Co(), vo && Zo();
      };
      return {
        onEnter: createChainedFunction(si, So == null ? void 0 : So.props.onEnter),
        onExited: createChainedFunction(li, So == null ? void 0 : So.props.onExited)
      };
    },
    rootRef: Oo,
    portalRef: Qo,
    isTopModal: oi,
    exited: jo,
    hasTransition: Lo
  };
}
const COMPONENT_NAME$6 = "Modal";
function getModalUtilityClass$1(Kt) {
  return generateUtilityClass(COMPONENT_NAME$6, Kt);
}
generateUtilityClasses(COMPONENT_NAME$6, ["root", "hidden", "backdrop"]);
const useUtilityClasses$1v = (Kt) => {
  const {
    open: uo,
    exited: ho
  } = Kt;
  return composeClasses({
    root: ["root", !uo && ho && "hidden"],
    backdrop: ["backdrop"]
  }, useClassNamesOverride(getModalUtilityClass$1));
}, Modal$2 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    children: go,
    closeAfterTransition: bo = !1,
    container: vo,
    disableAutoFocus: Po = !1,
    disableEnforceFocus: Co = !1,
    disableEscapeKeyDown: So = !1,
    disablePortal: wo = !1,
    disableRestoreFocus: Eo = !1,
    disableScrollLock: Ro = !1,
    hideBackdrop: _o = !1,
    keepMounted: Io = !1,
    onBackdropClick: Ao,
    onClose: Oo,
    onKeyDown: jo,
    open: Do,
    onTransitionEnter: Lo,
    onTransitionExited: ko,
    slotProps: Ko = {},
    slots: No = {},
    ...Jo
  } = uo, ti = {
    ...uo,
    closeAfterTransition: bo,
    disableAutoFocus: Po,
    disableEnforceFocus: Co,
    disableEscapeKeyDown: So,
    disablePortal: wo,
    disableRestoreFocus: Eo,
    disableScrollLock: Ro,
    hideBackdrop: _o,
    keepMounted: Io
  }, {
    getRootProps: oi,
    getBackdropProps: Qo,
    getTransitionProps: Zo,
    portalRef: ei,
    isTopModal: ii,
    exited: ai,
    hasTransition: ri
  } = useModal$1({
    ...ti,
    rootRef: ho
  }), ni = {
    ...ti,
    exited: ai,
    hasTransition: ri
  }, si = useUtilityClasses$1v(ni), li = {};
  if (go.props.tabIndex === void 0 && (li.tabIndex = "-1"), ri) {
    const {
      onEnter: hi,
      onExited: mi
    } = Zo();
    li.onEnter = hi, li.onExited = mi;
  }
  const ui = No.root ?? "div", ci = useSlotProps({
    elementType: ui,
    externalSlotProps: Ko.root,
    externalForwardedProps: Jo,
    getSlotProps: oi,
    className: si.root,
    ownerState: ni
  }), fi = No.backdrop, yi = useSlotProps({
    elementType: fi,
    externalSlotProps: Ko.backdrop,
    getSlotProps: (hi) => Qo({
      ...hi,
      onClick: (mi) => {
        Ao && Ao(mi), hi != null && hi.onClick && hi.onClick(mi);
      }
    }),
    className: si.backdrop,
    ownerState: ni
  });
  return !Io && !Do && (!ri || ai) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal$1, {
    ref: ei,
    container: vo,
    disablePortal: wo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ui, {
      ...ci,
      children: [!_o && fi ? /* @__PURE__ */ jsxRuntimeExports.jsx(fi, {
        ...yi
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap$1, {
        disableEnforceFocus: Co,
        disableAutoFocus: Po,
        disableRestoreFocus: Eo,
        isEnabled: ii,
        open: Do,
        children: /* @__PURE__ */ React$1.cloneElement(go, li)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Modal$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  })
});
const COMPONENT_NAME$5 = "Option";
function getOptionUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME$5, Kt);
}
generateUtilityClasses(COMPONENT_NAME$5, ["root", "disabled", "selected", "highlighted"]);
function useOption(Kt) {
  const {
    value: uo,
    label: ho,
    disabled: go,
    rootRef: bo,
    id: vo
  } = Kt, {
    getRootProps: Po,
    highlighted: Co,
    selected: So
  } = useListItem({
    item: uo
  }), {
    getRootProps: wo,
    rootRef: Eo
  } = useButton({
    disabled: go,
    focusableWhenDisabled: !0
  }), Ro = useId(vo), _o = React$1.useRef(null), Io = React$1.useMemo(() => ({
    disabled: go,
    label: ho,
    value: uo,
    ref: _o,
    id: Ro
  }), [go, ho, uo, Ro]), {
    index: Ao
  } = useCompoundItem(uo, Io), Oo = useForkRef(bo, _o, Eo), jo = (Lo) => (ko) => {
    var Ko;
    (Ko = Lo.onKeyDown) == null || Ko.call(Lo, ko), !ko.defaultMuiPrevented && [" ", "Enter"].includes(ko.key) && (ko.defaultMuiPrevented = !0);
  }, Do = (Lo = {}) => ({
    onKeyDown: jo(Lo)
  });
  return {
    getRootProps: (Lo = {}) => {
      const ko = extractEventHandlers(Lo), Ko = combineHooksSlotProps(Po, combineHooksSlotProps(wo, Do));
      return {
        ...Lo,
        ...ko,
        ...Ko(ko),
        id: Ro,
        ref: Oo,
        role: "option",
        "aria-selected": So
      };
    },
    highlighted: Co,
    index: Ao,
    selected: So,
    rootRef: Oo
  };
}
function useOptionContextStabilizer(Kt) {
  const uo = React$1.useContext(ListContext$1);
  if (!uo)
    throw new Error("Option: ListContext was not found.");
  const {
    getItemState: ho,
    dispatch: go
  } = uo, {
    highlighted: bo,
    selected: vo,
    focusable: Po
  } = ho(Kt), Co = React$1.useCallback((wo) => {
    if (wo !== Kt)
      throw new Error(["Base UI Option: Tried to access the state of another Option.", "This is unsupported when the Option uses the OptionContextStabilizer as a performance optimization."].join("/n"));
    return {
      highlighted: bo,
      selected: vo,
      focusable: Po
    };
  }, [bo, vo, Po, Kt]);
  return {
    contextValue: React$1.useMemo(() => ({
      dispatch: go,
      getItemState: Co
    }), [go, Co])
  };
}
function useUtilityClasses$1u(Kt) {
  const {
    disabled: uo,
    highlighted: ho,
    selected: go
  } = Kt;
  return composeClasses({
    root: ["root", uo && "disabled", ho && "highlighted", go && "selected"]
  }, useClassNamesOverride(getOptionUtilityClass));
}
const InnerOption = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  var No, Jo;
  const {
    children: go,
    disabled: bo = !1,
    label: vo,
    slotProps: Po = {},
    slots: Co = {},
    value: So,
    ...wo
  } = uo, Eo = Co.root ?? "li", Ro = React$1.useRef(null), _o = useForkRef(Ro, ho), Io = vo ?? (typeof go == "string" ? go : (Jo = (No = Ro.current) == null ? void 0 : No.textContent) == null ? void 0 : Jo.trim()), {
    getRootProps: Ao,
    selected: Oo,
    highlighted: jo,
    index: Do
  } = useOption({
    disabled: bo,
    label: Io,
    rootRef: _o,
    value: So
  }), Lo = {
    ...uo,
    disabled: bo,
    highlighted: jo,
    index: Do,
    selected: Oo
  }, ko = useUtilityClasses$1u(Lo), Ko = useSlotProps({
    getSlotProps: Ao,
    elementType: Eo,
    externalSlotProps: Po.root,
    externalForwardedProps: wo,
    className: ko.root,
    ownerState: Lo
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Eo, {
    ...Ko,
    children: go
  });
});
process.env.NODE_ENV !== "production" && (InnerOption.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  children: PropTypes.node,
  className: PropTypes.string,
  /**
   * If `true`, the option will be disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * A text representation of the option's content.
   * Used for keyboard text navigation matching.
   */
  label: PropTypes.string,
  /**
   * The props used for each slot inside the Option.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Option.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the option.
   */
  value: PropTypes.any.isRequired
});
const InnerOptionMemo = /* @__PURE__ */ React$1.memo(InnerOption), Option = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    value: go
  } = uo, {
    contextValue: bo
  } = useOptionContextStabilizer(go);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
    value: bo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InnerOptionMemo, {
      ...uo,
      ref: ho
    })
  });
});
process.env.NODE_ENV !== "production" && (Option.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the option will be disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * A text representation of the option's content.
   * Used for keyboard text navigation matching.
   */
  label: PropTypes.string,
  /**
   * The props used for each slot inside the Option.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Option.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the option.
   */
  value: PropTypes.any.isRequired
});
var top = "top", bottom = "bottom", right = "right", left = "left", auto = "auto", basePlacements = [top, bottom, right, left], start = "start", end = "end", clippingParents = "clippingParents", viewport = "viewport", popper = "popper", reference = "reference", variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(Kt, uo) {
  return Kt.concat([uo + "-" + start, uo + "-" + end]);
}, []), placements = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(Kt, uo) {
  return Kt.concat([uo, uo + "-" + start, uo + "-" + end]);
}, []), beforeRead = "beforeRead", read = "read", afterRead = "afterRead", beforeMain = "beforeMain", main = "main", afterMain = "afterMain", beforeWrite = "beforeWrite", write = "write", afterWrite = "afterWrite", modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function getNodeName(Kt) {
  return Kt ? (Kt.nodeName || "").toLowerCase() : null;
}
function getWindow(Kt) {
  if (Kt == null)
    return window;
  if (Kt.toString() !== "[object Window]") {
    var uo = Kt.ownerDocument;
    return uo && uo.defaultView || window;
  }
  return Kt;
}
function isElement(Kt) {
  var uo = getWindow(Kt).Element;
  return Kt instanceof uo || Kt instanceof Element;
}
function isHTMLElement$1(Kt) {
  var uo = getWindow(Kt).HTMLElement;
  return Kt instanceof uo || Kt instanceof HTMLElement;
}
function isShadowRoot(Kt) {
  if (typeof ShadowRoot > "u")
    return !1;
  var uo = getWindow(Kt).ShadowRoot;
  return Kt instanceof uo || Kt instanceof ShadowRoot;
}
function applyStyles$1(Kt) {
  var uo = Kt.state;
  Object.keys(uo.elements).forEach(function(ho) {
    var go = uo.styles[ho] || {}, bo = uo.attributes[ho] || {}, vo = uo.elements[ho];
    !isHTMLElement$1(vo) || !getNodeName(vo) || (Object.assign(vo.style, go), Object.keys(bo).forEach(function(Po) {
      var Co = bo[Po];
      Co === !1 ? vo.removeAttribute(Po) : vo.setAttribute(Po, Co === !0 ? "" : Co);
    }));
  });
}
function effect$2(Kt) {
  var uo = Kt.state, ho = {
    popper: {
      position: uo.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(uo.elements.popper.style, ho.popper), uo.styles = ho, uo.elements.arrow && Object.assign(uo.elements.arrow.style, ho.arrow), function() {
    Object.keys(uo.elements).forEach(function(go) {
      var bo = uo.elements[go], vo = uo.attributes[go] || {}, Po = Object.keys(uo.styles.hasOwnProperty(go) ? uo.styles[go] : ho[go]), Co = Po.reduce(function(So, wo) {
        return So[wo] = "", So;
      }, {});
      !isHTMLElement$1(bo) || !getNodeName(bo) || (Object.assign(bo.style, Co), Object.keys(vo).forEach(function(So) {
        bo.removeAttribute(So);
      }));
    });
  };
}
const applyStyles$2 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: applyStyles$1,
  effect: effect$2,
  requires: ["computeStyles"]
};
function getBasePlacement(Kt) {
  return Kt.split("-")[0];
}
var max$3 = Math.max, min$3 = Math.min, round$3 = Math.round;
function getUAString() {
  var Kt = navigator.userAgentData;
  return Kt != null && Kt.brands && Array.isArray(Kt.brands) ? Kt.brands.map(function(uo) {
    return uo.brand + "/" + uo.version;
  }).join(" ") : navigator.userAgent;
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function getBoundingClientRect(Kt, uo, ho) {
  uo === void 0 && (uo = !1), ho === void 0 && (ho = !1);
  var go = Kt.getBoundingClientRect(), bo = 1, vo = 1;
  uo && isHTMLElement$1(Kt) && (bo = Kt.offsetWidth > 0 && round$3(go.width) / Kt.offsetWidth || 1, vo = Kt.offsetHeight > 0 && round$3(go.height) / Kt.offsetHeight || 1);
  var Po = isElement(Kt) ? getWindow(Kt) : window, Co = Po.visualViewport, So = !isLayoutViewport() && ho, wo = (go.left + (So && Co ? Co.offsetLeft : 0)) / bo, Eo = (go.top + (So && Co ? Co.offsetTop : 0)) / vo, Ro = go.width / bo, _o = go.height / vo;
  return {
    width: Ro,
    height: _o,
    top: Eo,
    right: wo + Ro,
    bottom: Eo + _o,
    left: wo,
    x: wo,
    y: Eo
  };
}
function getLayoutRect(Kt) {
  var uo = getBoundingClientRect(Kt), ho = Kt.offsetWidth, go = Kt.offsetHeight;
  return Math.abs(uo.width - ho) <= 1 && (ho = uo.width), Math.abs(uo.height - go) <= 1 && (go = uo.height), {
    x: Kt.offsetLeft,
    y: Kt.offsetTop,
    width: ho,
    height: go
  };
}
function contains(Kt, uo) {
  var ho = uo.getRootNode && uo.getRootNode();
  if (Kt.contains(uo))
    return !0;
  if (ho && isShadowRoot(ho)) {
    var go = uo;
    do {
      if (go && Kt.isSameNode(go))
        return !0;
      go = go.parentNode || go.host;
    } while (go);
  }
  return !1;
}
function getComputedStyle$1(Kt) {
  return getWindow(Kt).getComputedStyle(Kt);
}
function isTableElement(Kt) {
  return ["table", "td", "th"].indexOf(getNodeName(Kt)) >= 0;
}
function getDocumentElement(Kt) {
  return ((isElement(Kt) ? Kt.ownerDocument : (
    // $FlowFixMe[prop-missing]
    Kt.document
  )) || window.document).documentElement;
}
function getParentNode(Kt) {
  return getNodeName(Kt) === "html" ? Kt : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    Kt.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    Kt.parentNode || // DOM Element detected
    (isShadowRoot(Kt) ? Kt.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(Kt)
  );
}
function getTrueOffsetParent(Kt) {
  return !isHTMLElement$1(Kt) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(Kt).position === "fixed" ? null : Kt.offsetParent;
}
function getContainingBlock(Kt) {
  var uo = /firefox/i.test(getUAString()), ho = /Trident/i.test(getUAString());
  if (ho && isHTMLElement$1(Kt)) {
    var go = getComputedStyle$1(Kt);
    if (go.position === "fixed")
      return null;
  }
  var bo = getParentNode(Kt);
  for (isShadowRoot(bo) && (bo = bo.host); isHTMLElement$1(bo) && ["html", "body"].indexOf(getNodeName(bo)) < 0; ) {
    var vo = getComputedStyle$1(bo);
    if (vo.transform !== "none" || vo.perspective !== "none" || vo.contain === "paint" || ["transform", "perspective"].indexOf(vo.willChange) !== -1 || uo && vo.willChange === "filter" || uo && vo.filter && vo.filter !== "none")
      return bo;
    bo = bo.parentNode;
  }
  return null;
}
function getOffsetParent(Kt) {
  for (var uo = getWindow(Kt), ho = getTrueOffsetParent(Kt); ho && isTableElement(ho) && getComputedStyle$1(ho).position === "static"; )
    ho = getTrueOffsetParent(ho);
  return ho && (getNodeName(ho) === "html" || getNodeName(ho) === "body" && getComputedStyle$1(ho).position === "static") ? uo : ho || getContainingBlock(Kt) || uo;
}
function getMainAxisFromPlacement(Kt) {
  return ["top", "bottom"].indexOf(Kt) >= 0 ? "x" : "y";
}
function within(Kt, uo, ho) {
  return max$3(Kt, min$3(uo, ho));
}
function withinMaxClamp(Kt, uo, ho) {
  var go = within(Kt, uo, ho);
  return go > ho ? ho : go;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(Kt) {
  return Object.assign({}, getFreshSideObject(), Kt);
}
function expandToHashMap(Kt, uo) {
  return uo.reduce(function(ho, go) {
    return ho[go] = Kt, ho;
  }, {});
}
var toPaddingObject = function(uo, ho) {
  return uo = typeof uo == "function" ? uo(Object.assign({}, ho.rects, {
    placement: ho.placement
  })) : uo, mergePaddingObject(typeof uo != "number" ? uo : expandToHashMap(uo, basePlacements));
};
function arrow(Kt) {
  var uo, ho = Kt.state, go = Kt.name, bo = Kt.options, vo = ho.elements.arrow, Po = ho.modifiersData.popperOffsets, Co = getBasePlacement(ho.placement), So = getMainAxisFromPlacement(Co), wo = [left, right].indexOf(Co) >= 0, Eo = wo ? "height" : "width";
  if (!(!vo || !Po)) {
    var Ro = toPaddingObject(bo.padding, ho), _o = getLayoutRect(vo), Io = So === "y" ? top : left, Ao = So === "y" ? bottom : right, Oo = ho.rects.reference[Eo] + ho.rects.reference[So] - Po[So] - ho.rects.popper[Eo], jo = Po[So] - ho.rects.reference[So], Do = getOffsetParent(vo), Lo = Do ? So === "y" ? Do.clientHeight || 0 : Do.clientWidth || 0 : 0, ko = Oo / 2 - jo / 2, Ko = Ro[Io], No = Lo - _o[Eo] - Ro[Ao], Jo = Lo / 2 - _o[Eo] / 2 + ko, ti = within(Ko, Jo, No), oi = So;
    ho.modifiersData[go] = (uo = {}, uo[oi] = ti, uo.centerOffset = ti - Jo, uo);
  }
}
function effect$1(Kt) {
  var uo = Kt.state, ho = Kt.options, go = ho.element, bo = go === void 0 ? "[data-popper-arrow]" : go;
  bo != null && (typeof bo == "string" && (bo = uo.elements.popper.querySelector(bo), !bo) || contains(uo.elements.popper, bo) && (uo.elements.arrow = bo));
}
const arrow$1 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: arrow,
  effect: effect$1,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getVariation(Kt) {
  return Kt.split("-")[1];
}
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsetsByDPR(Kt, uo) {
  var ho = Kt.x, go = Kt.y, bo = uo.devicePixelRatio || 1;
  return {
    x: round$3(ho * bo) / bo || 0,
    y: round$3(go * bo) / bo || 0
  };
}
function mapToStyles(Kt) {
  var uo, ho = Kt.popper, go = Kt.popperRect, bo = Kt.placement, vo = Kt.variation, Po = Kt.offsets, Co = Kt.position, So = Kt.gpuAcceleration, wo = Kt.adaptive, Eo = Kt.roundOffsets, Ro = Kt.isFixed, _o = Po.x, Io = _o === void 0 ? 0 : _o, Ao = Po.y, Oo = Ao === void 0 ? 0 : Ao, jo = typeof Eo == "function" ? Eo({
    x: Io,
    y: Oo
  }) : {
    x: Io,
    y: Oo
  };
  Io = jo.x, Oo = jo.y;
  var Do = Po.hasOwnProperty("x"), Lo = Po.hasOwnProperty("y"), ko = left, Ko = top, No = window;
  if (wo) {
    var Jo = getOffsetParent(ho), ti = "clientHeight", oi = "clientWidth";
    if (Jo === getWindow(ho) && (Jo = getDocumentElement(ho), getComputedStyle$1(Jo).position !== "static" && Co === "absolute" && (ti = "scrollHeight", oi = "scrollWidth")), Jo = Jo, bo === top || (bo === left || bo === right) && vo === end) {
      Ko = bottom;
      var Qo = Ro && Jo === No && No.visualViewport ? No.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        Jo[ti]
      );
      Oo -= Qo - go.height, Oo *= So ? 1 : -1;
    }
    if (bo === left || (bo === top || bo === bottom) && vo === end) {
      ko = right;
      var Zo = Ro && Jo === No && No.visualViewport ? No.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        Jo[oi]
      );
      Io -= Zo - go.width, Io *= So ? 1 : -1;
    }
  }
  var ei = Object.assign({
    position: Co
  }, wo && unsetSides), ii = Eo === !0 ? roundOffsetsByDPR({
    x: Io,
    y: Oo
  }, getWindow(ho)) : {
    x: Io,
    y: Oo
  };
  if (Io = ii.x, Oo = ii.y, So) {
    var ai;
    return Object.assign({}, ei, (ai = {}, ai[Ko] = Lo ? "0" : "", ai[ko] = Do ? "0" : "", ai.transform = (No.devicePixelRatio || 1) <= 1 ? "translate(" + Io + "px, " + Oo + "px)" : "translate3d(" + Io + "px, " + Oo + "px, 0)", ai));
  }
  return Object.assign({}, ei, (uo = {}, uo[Ko] = Lo ? Oo + "px" : "", uo[ko] = Do ? Io + "px" : "", uo.transform = "", uo));
}
function computeStyles(Kt) {
  var uo = Kt.state, ho = Kt.options, go = ho.gpuAcceleration, bo = go === void 0 ? !0 : go, vo = ho.adaptive, Po = vo === void 0 ? !0 : vo, Co = ho.roundOffsets, So = Co === void 0 ? !0 : Co, wo = {
    placement: getBasePlacement(uo.placement),
    variation: getVariation(uo.placement),
    popper: uo.elements.popper,
    popperRect: uo.rects.popper,
    gpuAcceleration: bo,
    isFixed: uo.options.strategy === "fixed"
  };
  uo.modifiersData.popperOffsets != null && (uo.styles.popper = Object.assign({}, uo.styles.popper, mapToStyles(Object.assign({}, wo, {
    offsets: uo.modifiersData.popperOffsets,
    position: uo.options.strategy,
    adaptive: Po,
    roundOffsets: So
  })))), uo.modifiersData.arrow != null && (uo.styles.arrow = Object.assign({}, uo.styles.arrow, mapToStyles(Object.assign({}, wo, {
    offsets: uo.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: So
  })))), uo.attributes.popper = Object.assign({}, uo.attributes.popper, {
    "data-popper-placement": uo.placement
  });
}
const computeStyles$1 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
var passive = {
  passive: !0
};
function effect(Kt) {
  var uo = Kt.state, ho = Kt.instance, go = Kt.options, bo = go.scroll, vo = bo === void 0 ? !0 : bo, Po = go.resize, Co = Po === void 0 ? !0 : Po, So = getWindow(uo.elements.popper), wo = [].concat(uo.scrollParents.reference, uo.scrollParents.popper);
  return vo && wo.forEach(function(Eo) {
    Eo.addEventListener("scroll", ho.update, passive);
  }), Co && So.addEventListener("resize", ho.update, passive), function() {
    vo && wo.forEach(function(Eo) {
      Eo.removeEventListener("scroll", ho.update, passive);
    }), Co && So.removeEventListener("resize", ho.update, passive);
  };
}
const eventListeners = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect,
  data: {}
};
var hash$2 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(Kt) {
  return Kt.replace(/left|right|bottom|top/g, function(uo) {
    return hash$2[uo];
  });
}
var hash$1 = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(Kt) {
  return Kt.replace(/start|end/g, function(uo) {
    return hash$1[uo];
  });
}
function getWindowScroll(Kt) {
  var uo = getWindow(Kt), ho = uo.pageXOffset, go = uo.pageYOffset;
  return {
    scrollLeft: ho,
    scrollTop: go
  };
}
function getWindowScrollBarX(Kt) {
  return getBoundingClientRect(getDocumentElement(Kt)).left + getWindowScroll(Kt).scrollLeft;
}
function getViewportRect(Kt, uo) {
  var ho = getWindow(Kt), go = getDocumentElement(Kt), bo = ho.visualViewport, vo = go.clientWidth, Po = go.clientHeight, Co = 0, So = 0;
  if (bo) {
    vo = bo.width, Po = bo.height;
    var wo = isLayoutViewport();
    (wo || !wo && uo === "fixed") && (Co = bo.offsetLeft, So = bo.offsetTop);
  }
  return {
    width: vo,
    height: Po,
    x: Co + getWindowScrollBarX(Kt),
    y: So
  };
}
function getDocumentRect(Kt) {
  var uo, ho = getDocumentElement(Kt), go = getWindowScroll(Kt), bo = (uo = Kt.ownerDocument) == null ? void 0 : uo.body, vo = max$3(ho.scrollWidth, ho.clientWidth, bo ? bo.scrollWidth : 0, bo ? bo.clientWidth : 0), Po = max$3(ho.scrollHeight, ho.clientHeight, bo ? bo.scrollHeight : 0, bo ? bo.clientHeight : 0), Co = -go.scrollLeft + getWindowScrollBarX(Kt), So = -go.scrollTop;
  return getComputedStyle$1(bo || ho).direction === "rtl" && (Co += max$3(ho.clientWidth, bo ? bo.clientWidth : 0) - vo), {
    width: vo,
    height: Po,
    x: Co,
    y: So
  };
}
function isScrollParent(Kt) {
  var uo = getComputedStyle$1(Kt), ho = uo.overflow, go = uo.overflowX, bo = uo.overflowY;
  return /auto|scroll|overlay|hidden/.test(ho + bo + go);
}
function getScrollParent(Kt) {
  return ["html", "body", "#document"].indexOf(getNodeName(Kt)) >= 0 ? Kt.ownerDocument.body : isHTMLElement$1(Kt) && isScrollParent(Kt) ? Kt : getScrollParent(getParentNode(Kt));
}
function listScrollParents(Kt, uo) {
  var ho;
  uo === void 0 && (uo = []);
  var go = getScrollParent(Kt), bo = go === ((ho = Kt.ownerDocument) == null ? void 0 : ho.body), vo = getWindow(go), Po = bo ? [vo].concat(vo.visualViewport || [], isScrollParent(go) ? go : []) : go, Co = uo.concat(Po);
  return bo ? Co : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    Co.concat(listScrollParents(getParentNode(Po)))
  );
}
function rectToClientRect(Kt) {
  return Object.assign({}, Kt, {
    left: Kt.x,
    top: Kt.y,
    right: Kt.x + Kt.width,
    bottom: Kt.y + Kt.height
  });
}
function getInnerBoundingClientRect(Kt, uo) {
  var ho = getBoundingClientRect(Kt, !1, uo === "fixed");
  return ho.top = ho.top + Kt.clientTop, ho.left = ho.left + Kt.clientLeft, ho.bottom = ho.top + Kt.clientHeight, ho.right = ho.left + Kt.clientWidth, ho.width = Kt.clientWidth, ho.height = Kt.clientHeight, ho.x = ho.left, ho.y = ho.top, ho;
}
function getClientRectFromMixedType(Kt, uo, ho) {
  return uo === viewport ? rectToClientRect(getViewportRect(Kt, ho)) : isElement(uo) ? getInnerBoundingClientRect(uo, ho) : rectToClientRect(getDocumentRect(getDocumentElement(Kt)));
}
function getClippingParents(Kt) {
  var uo = listScrollParents(getParentNode(Kt)), ho = ["absolute", "fixed"].indexOf(getComputedStyle$1(Kt).position) >= 0, go = ho && isHTMLElement$1(Kt) ? getOffsetParent(Kt) : Kt;
  return isElement(go) ? uo.filter(function(bo) {
    return isElement(bo) && contains(bo, go) && getNodeName(bo) !== "body";
  }) : [];
}
function getClippingRect(Kt, uo, ho, go) {
  var bo = uo === "clippingParents" ? getClippingParents(Kt) : [].concat(uo), vo = [].concat(bo, [ho]), Po = vo[0], Co = vo.reduce(function(So, wo) {
    var Eo = getClientRectFromMixedType(Kt, wo, go);
    return So.top = max$3(Eo.top, So.top), So.right = min$3(Eo.right, So.right), So.bottom = min$3(Eo.bottom, So.bottom), So.left = max$3(Eo.left, So.left), So;
  }, getClientRectFromMixedType(Kt, Po, go));
  return Co.width = Co.right - Co.left, Co.height = Co.bottom - Co.top, Co.x = Co.left, Co.y = Co.top, Co;
}
function computeOffsets(Kt) {
  var uo = Kt.reference, ho = Kt.element, go = Kt.placement, bo = go ? getBasePlacement(go) : null, vo = go ? getVariation(go) : null, Po = uo.x + uo.width / 2 - ho.width / 2, Co = uo.y + uo.height / 2 - ho.height / 2, So;
  switch (bo) {
    case top:
      So = {
        x: Po,
        y: uo.y - ho.height
      };
      break;
    case bottom:
      So = {
        x: Po,
        y: uo.y + uo.height
      };
      break;
    case right:
      So = {
        x: uo.x + uo.width,
        y: Co
      };
      break;
    case left:
      So = {
        x: uo.x - ho.width,
        y: Co
      };
      break;
    default:
      So = {
        x: uo.x,
        y: uo.y
      };
  }
  var wo = bo ? getMainAxisFromPlacement(bo) : null;
  if (wo != null) {
    var Eo = wo === "y" ? "height" : "width";
    switch (vo) {
      case start:
        So[wo] = So[wo] - (uo[Eo] / 2 - ho[Eo] / 2);
        break;
      case end:
        So[wo] = So[wo] + (uo[Eo] / 2 - ho[Eo] / 2);
        break;
    }
  }
  return So;
}
function detectOverflow(Kt, uo) {
  uo === void 0 && (uo = {});
  var ho = uo, go = ho.placement, bo = go === void 0 ? Kt.placement : go, vo = ho.strategy, Po = vo === void 0 ? Kt.strategy : vo, Co = ho.boundary, So = Co === void 0 ? clippingParents : Co, wo = ho.rootBoundary, Eo = wo === void 0 ? viewport : wo, Ro = ho.elementContext, _o = Ro === void 0 ? popper : Ro, Io = ho.altBoundary, Ao = Io === void 0 ? !1 : Io, Oo = ho.padding, jo = Oo === void 0 ? 0 : Oo, Do = mergePaddingObject(typeof jo != "number" ? jo : expandToHashMap(jo, basePlacements)), Lo = _o === popper ? reference : popper, ko = Kt.rects.popper, Ko = Kt.elements[Ao ? Lo : _o], No = getClippingRect(isElement(Ko) ? Ko : Ko.contextElement || getDocumentElement(Kt.elements.popper), So, Eo, Po), Jo = getBoundingClientRect(Kt.elements.reference), ti = computeOffsets({
    reference: Jo,
    element: ko,
    strategy: "absolute",
    placement: bo
  }), oi = rectToClientRect(Object.assign({}, ko, ti)), Qo = _o === popper ? oi : Jo, Zo = {
    top: No.top - Qo.top + Do.top,
    bottom: Qo.bottom - No.bottom + Do.bottom,
    left: No.left - Qo.left + Do.left,
    right: Qo.right - No.right + Do.right
  }, ei = Kt.modifiersData.offset;
  if (_o === popper && ei) {
    var ii = ei[bo];
    Object.keys(Zo).forEach(function(ai) {
      var ri = [right, bottom].indexOf(ai) >= 0 ? 1 : -1, ni = [top, bottom].indexOf(ai) >= 0 ? "y" : "x";
      Zo[ai] += ii[ni] * ri;
    });
  }
  return Zo;
}
function computeAutoPlacement(Kt, uo) {
  uo === void 0 && (uo = {});
  var ho = uo, go = ho.placement, bo = ho.boundary, vo = ho.rootBoundary, Po = ho.padding, Co = ho.flipVariations, So = ho.allowedAutoPlacements, wo = So === void 0 ? placements : So, Eo = getVariation(go), Ro = Eo ? Co ? variationPlacements : variationPlacements.filter(function(Ao) {
    return getVariation(Ao) === Eo;
  }) : basePlacements, _o = Ro.filter(function(Ao) {
    return wo.indexOf(Ao) >= 0;
  });
  _o.length === 0 && (_o = Ro);
  var Io = _o.reduce(function(Ao, Oo) {
    return Ao[Oo] = detectOverflow(Kt, {
      placement: Oo,
      boundary: bo,
      rootBoundary: vo,
      padding: Po
    })[getBasePlacement(Oo)], Ao;
  }, {});
  return Object.keys(Io).sort(function(Ao, Oo) {
    return Io[Ao] - Io[Oo];
  });
}
function getExpandedFallbackPlacements(Kt) {
  if (getBasePlacement(Kt) === auto)
    return [];
  var uo = getOppositePlacement(Kt);
  return [getOppositeVariationPlacement(Kt), uo, getOppositeVariationPlacement(uo)];
}
function flip(Kt) {
  var uo = Kt.state, ho = Kt.options, go = Kt.name;
  if (!uo.modifiersData[go]._skip) {
    for (var bo = ho.mainAxis, vo = bo === void 0 ? !0 : bo, Po = ho.altAxis, Co = Po === void 0 ? !0 : Po, So = ho.fallbackPlacements, wo = ho.padding, Eo = ho.boundary, Ro = ho.rootBoundary, _o = ho.altBoundary, Io = ho.flipVariations, Ao = Io === void 0 ? !0 : Io, Oo = ho.allowedAutoPlacements, jo = uo.options.placement, Do = getBasePlacement(jo), Lo = Do === jo, ko = So || (Lo || !Ao ? [getOppositePlacement(jo)] : getExpandedFallbackPlacements(jo)), Ko = [jo].concat(ko).reduce(function(bi, xi) {
      return bi.concat(getBasePlacement(xi) === auto ? computeAutoPlacement(uo, {
        placement: xi,
        boundary: Eo,
        rootBoundary: Ro,
        padding: wo,
        flipVariations: Ao,
        allowedAutoPlacements: Oo
      }) : xi);
    }, []), No = uo.rects.reference, Jo = uo.rects.popper, ti = /* @__PURE__ */ new Map(), oi = !0, Qo = Ko[0], Zo = 0; Zo < Ko.length; Zo++) {
      var ei = Ko[Zo], ii = getBasePlacement(ei), ai = getVariation(ei) === start, ri = [top, bottom].indexOf(ii) >= 0, ni = ri ? "width" : "height", si = detectOverflow(uo, {
        placement: ei,
        boundary: Eo,
        rootBoundary: Ro,
        altBoundary: _o,
        padding: wo
      }), li = ri ? ai ? right : left : ai ? bottom : top;
      No[ni] > Jo[ni] && (li = getOppositePlacement(li));
      var ui = getOppositePlacement(li), ci = [];
      if (vo && ci.push(si[ii] <= 0), Co && ci.push(si[li] <= 0, si[ui] <= 0), ci.every(function(bi) {
        return bi;
      })) {
        Qo = ei, oi = !1;
        break;
      }
      ti.set(ei, ci);
    }
    if (oi)
      for (var fi = Ao ? 3 : 1, yi = function(xi) {
        var $i = Ko.find(function(Ci) {
          var Si = ti.get(Ci);
          if (Si)
            return Si.slice(0, xi).every(function(vi) {
              return vi;
            });
        });
        if ($i)
          return Qo = $i, "break";
      }, hi = fi; hi > 0; hi--) {
        var mi = yi(hi);
        if (mi === "break") break;
      }
    uo.placement !== Qo && (uo.modifiersData[go]._skip = !0, uo.placement = Qo, uo.reset = !0);
  }
}
const flip$1 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function getSideOffsets(Kt, uo, ho) {
  return ho === void 0 && (ho = {
    x: 0,
    y: 0
  }), {
    top: Kt.top - uo.height - ho.y,
    right: Kt.right - uo.width + ho.x,
    bottom: Kt.bottom - uo.height + ho.y,
    left: Kt.left - uo.width - ho.x
  };
}
function isAnySideFullyClipped(Kt) {
  return [top, right, bottom, left].some(function(uo) {
    return Kt[uo] >= 0;
  });
}
function hide(Kt) {
  var uo = Kt.state, ho = Kt.name, go = uo.rects.reference, bo = uo.rects.popper, vo = uo.modifiersData.preventOverflow, Po = detectOverflow(uo, {
    elementContext: "reference"
  }), Co = detectOverflow(uo, {
    altBoundary: !0
  }), So = getSideOffsets(Po, go), wo = getSideOffsets(Co, bo, vo), Eo = isAnySideFullyClipped(So), Ro = isAnySideFullyClipped(wo);
  uo.modifiersData[ho] = {
    referenceClippingOffsets: So,
    popperEscapeOffsets: wo,
    isReferenceHidden: Eo,
    hasPopperEscaped: Ro
  }, uo.attributes.popper = Object.assign({}, uo.attributes.popper, {
    "data-popper-reference-hidden": Eo,
    "data-popper-escaped": Ro
  });
}
const hide$1 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
function distanceAndSkiddingToXY(Kt, uo, ho) {
  var go = getBasePlacement(Kt), bo = [left, top].indexOf(go) >= 0 ? -1 : 1, vo = typeof ho == "function" ? ho(Object.assign({}, uo, {
    placement: Kt
  })) : ho, Po = vo[0], Co = vo[1];
  return Po = Po || 0, Co = (Co || 0) * bo, [left, right].indexOf(go) >= 0 ? {
    x: Co,
    y: Po
  } : {
    x: Po,
    y: Co
  };
}
function offset(Kt) {
  var uo = Kt.state, ho = Kt.options, go = Kt.name, bo = ho.offset, vo = bo === void 0 ? [0, 0] : bo, Po = placements.reduce(function(Eo, Ro) {
    return Eo[Ro] = distanceAndSkiddingToXY(Ro, uo.rects, vo), Eo;
  }, {}), Co = Po[uo.placement], So = Co.x, wo = Co.y;
  uo.modifiersData.popperOffsets != null && (uo.modifiersData.popperOffsets.x += So, uo.modifiersData.popperOffsets.y += wo), uo.modifiersData[go] = Po;
}
const offset$1 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
function popperOffsets(Kt) {
  var uo = Kt.state, ho = Kt.name;
  uo.modifiersData[ho] = computeOffsets({
    reference: uo.rects.reference,
    element: uo.rects.popper,
    strategy: "absolute",
    placement: uo.placement
  });
}
const popperOffsets$1 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
function getAltAxis(Kt) {
  return Kt === "x" ? "y" : "x";
}
function preventOverflow(Kt) {
  var uo = Kt.state, ho = Kt.options, go = Kt.name, bo = ho.mainAxis, vo = bo === void 0 ? !0 : bo, Po = ho.altAxis, Co = Po === void 0 ? !1 : Po, So = ho.boundary, wo = ho.rootBoundary, Eo = ho.altBoundary, Ro = ho.padding, _o = ho.tether, Io = _o === void 0 ? !0 : _o, Ao = ho.tetherOffset, Oo = Ao === void 0 ? 0 : Ao, jo = detectOverflow(uo, {
    boundary: So,
    rootBoundary: wo,
    padding: Ro,
    altBoundary: Eo
  }), Do = getBasePlacement(uo.placement), Lo = getVariation(uo.placement), ko = !Lo, Ko = getMainAxisFromPlacement(Do), No = getAltAxis(Ko), Jo = uo.modifiersData.popperOffsets, ti = uo.rects.reference, oi = uo.rects.popper, Qo = typeof Oo == "function" ? Oo(Object.assign({}, uo.rects, {
    placement: uo.placement
  })) : Oo, Zo = typeof Qo == "number" ? {
    mainAxis: Qo,
    altAxis: Qo
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Qo), ei = uo.modifiersData.offset ? uo.modifiersData.offset[uo.placement] : null, ii = {
    x: 0,
    y: 0
  };
  if (Jo) {
    if (vo) {
      var ai, ri = Ko === "y" ? top : left, ni = Ko === "y" ? bottom : right, si = Ko === "y" ? "height" : "width", li = Jo[Ko], ui = li + jo[ri], ci = li - jo[ni], fi = Io ? -oi[si] / 2 : 0, yi = Lo === start ? ti[si] : oi[si], hi = Lo === start ? -oi[si] : -ti[si], mi = uo.elements.arrow, bi = Io && mi ? getLayoutRect(mi) : {
        width: 0,
        height: 0
      }, xi = uo.modifiersData["arrow#persistent"] ? uo.modifiersData["arrow#persistent"].padding : getFreshSideObject(), $i = xi[ri], Ci = xi[ni], Si = within(0, ti[si], bi[si]), vi = ko ? ti[si] / 2 - fi - Si - $i - Zo.mainAxis : yi - Si - $i - Zo.mainAxis, Pi = ko ? -ti[si] / 2 + fi + Si + Ci + Zo.mainAxis : hi + Si + Ci + Zo.mainAxis, wi = uo.elements.arrow && getOffsetParent(uo.elements.arrow), gi = wi ? Ko === "y" ? wi.clientTop || 0 : wi.clientLeft || 0 : 0, Ri = (ai = ei == null ? void 0 : ei[Ko]) != null ? ai : 0, Ei = li + vi - Ri - gi, Ni = li + Pi - Ri, Ai = within(Io ? min$3(ui, Ei) : ui, li, Io ? max$3(ci, Ni) : ci);
      Jo[Ko] = Ai, ii[Ko] = Ai - li;
    }
    if (Co) {
      var Yi, Ui = Ko === "x" ? top : left, us = Ko === "x" ? bottom : right, ns = Jo[No], Ti = No === "y" ? "height" : "width", _i = ns + jo[Ui], Vi = ns - jo[us], Bi = [top, left].indexOf(Do) !== -1, Ji = (Yi = ei == null ? void 0 : ei[No]) != null ? Yi : 0, Ki = Bi ? _i : ns - ti[Ti] - oi[Ti] - Ji + Zo.altAxis, qi = Bi ? ns + ti[Ti] + oi[Ti] - Ji - Zo.altAxis : Vi, rs = Io && Bi ? withinMaxClamp(Ki, ns, qi) : within(Io ? Ki : _i, ns, Io ? qi : Vi);
      Jo[No] = rs, ii[No] = rs - ns;
    }
    uo.modifiersData[go] = ii;
  }
}
const preventOverflow$1 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function getHTMLElementScroll(Kt) {
  return {
    scrollLeft: Kt.scrollLeft,
    scrollTop: Kt.scrollTop
  };
}
function getNodeScroll(Kt) {
  return Kt === getWindow(Kt) || !isHTMLElement$1(Kt) ? getWindowScroll(Kt) : getHTMLElementScroll(Kt);
}
function isElementScaled(Kt) {
  var uo = Kt.getBoundingClientRect(), ho = round$3(uo.width) / Kt.offsetWidth || 1, go = round$3(uo.height) / Kt.offsetHeight || 1;
  return ho !== 1 || go !== 1;
}
function getCompositeRect(Kt, uo, ho) {
  ho === void 0 && (ho = !1);
  var go = isHTMLElement$1(uo), bo = isHTMLElement$1(uo) && isElementScaled(uo), vo = getDocumentElement(uo), Po = getBoundingClientRect(Kt, bo, ho), Co = {
    scrollLeft: 0,
    scrollTop: 0
  }, So = {
    x: 0,
    y: 0
  };
  return (go || !go && !ho) && ((getNodeName(uo) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  isScrollParent(vo)) && (Co = getNodeScroll(uo)), isHTMLElement$1(uo) ? (So = getBoundingClientRect(uo, !0), So.x += uo.clientLeft, So.y += uo.clientTop) : vo && (So.x = getWindowScrollBarX(vo))), {
    x: Po.left + Co.scrollLeft - So.x,
    y: Po.top + Co.scrollTop - So.y,
    width: Po.width,
    height: Po.height
  };
}
function order(Kt) {
  var uo = /* @__PURE__ */ new Map(), ho = /* @__PURE__ */ new Set(), go = [];
  Kt.forEach(function(vo) {
    uo.set(vo.name, vo);
  });
  function bo(vo) {
    ho.add(vo.name);
    var Po = [].concat(vo.requires || [], vo.requiresIfExists || []);
    Po.forEach(function(Co) {
      if (!ho.has(Co)) {
        var So = uo.get(Co);
        So && bo(So);
      }
    }), go.push(vo);
  }
  return Kt.forEach(function(vo) {
    ho.has(vo.name) || bo(vo);
  }), go;
}
function orderModifiers(Kt) {
  var uo = order(Kt);
  return modifierPhases.reduce(function(ho, go) {
    return ho.concat(uo.filter(function(bo) {
      return bo.phase === go;
    }));
  }, []);
}
function debounce$2(Kt) {
  var uo;
  return function() {
    return uo || (uo = new Promise(function(ho) {
      Promise.resolve().then(function() {
        uo = void 0, ho(Kt());
      });
    })), uo;
  };
}
function mergeByName(Kt) {
  var uo = Kt.reduce(function(ho, go) {
    var bo = ho[go.name];
    return ho[go.name] = bo ? Object.assign({}, bo, go, {
      options: Object.assign({}, bo.options, go.options),
      data: Object.assign({}, bo.data, go.data)
    }) : go, ho;
  }, {});
  return Object.keys(uo).map(function(ho) {
    return uo[ho];
  });
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var Kt = arguments.length, uo = new Array(Kt), ho = 0; ho < Kt; ho++)
    uo[ho] = arguments[ho];
  return !uo.some(function(go) {
    return !(go && typeof go.getBoundingClientRect == "function");
  });
}
function popperGenerator(Kt) {
  Kt === void 0 && (Kt = {});
  var uo = Kt, ho = uo.defaultModifiers, go = ho === void 0 ? [] : ho, bo = uo.defaultOptions, vo = bo === void 0 ? DEFAULT_OPTIONS : bo;
  return function(Co, So, wo) {
    wo === void 0 && (wo = vo);
    var Eo = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, vo),
      modifiersData: {},
      elements: {
        reference: Co,
        popper: So
      },
      attributes: {},
      styles: {}
    }, Ro = [], _o = !1, Io = {
      state: Eo,
      setOptions: function(Do) {
        var Lo = typeof Do == "function" ? Do(Eo.options) : Do;
        Oo(), Eo.options = Object.assign({}, vo, Eo.options, Lo), Eo.scrollParents = {
          reference: isElement(Co) ? listScrollParents(Co) : Co.contextElement ? listScrollParents(Co.contextElement) : [],
          popper: listScrollParents(So)
        };
        var ko = orderModifiers(mergeByName([].concat(go, Eo.options.modifiers)));
        return Eo.orderedModifiers = ko.filter(function(Ko) {
          return Ko.enabled;
        }), Ao(), Io.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!_o) {
          var Do = Eo.elements, Lo = Do.reference, ko = Do.popper;
          if (areValidElements(Lo, ko)) {
            Eo.rects = {
              reference: getCompositeRect(Lo, getOffsetParent(ko), Eo.options.strategy === "fixed"),
              popper: getLayoutRect(ko)
            }, Eo.reset = !1, Eo.placement = Eo.options.placement, Eo.orderedModifiers.forEach(function(Zo) {
              return Eo.modifiersData[Zo.name] = Object.assign({}, Zo.data);
            });
            for (var Ko = 0; Ko < Eo.orderedModifiers.length; Ko++) {
              if (Eo.reset === !0) {
                Eo.reset = !1, Ko = -1;
                continue;
              }
              var No = Eo.orderedModifiers[Ko], Jo = No.fn, ti = No.options, oi = ti === void 0 ? {} : ti, Qo = No.name;
              typeof Jo == "function" && (Eo = Jo({
                state: Eo,
                options: oi,
                name: Qo,
                instance: Io
              }) || Eo);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function() {
        return new Promise(function(jo) {
          Io.forceUpdate(), jo(Eo);
        });
      }),
      destroy: function() {
        Oo(), _o = !0;
      }
    };
    if (!areValidElements(Co, So))
      return Io;
    Io.setOptions(wo).then(function(jo) {
      !_o && wo.onFirstUpdate && wo.onFirstUpdate(jo);
    });
    function Ao() {
      Eo.orderedModifiers.forEach(function(jo) {
        var Do = jo.name, Lo = jo.options, ko = Lo === void 0 ? {} : Lo, Ko = jo.effect;
        if (typeof Ko == "function") {
          var No = Ko({
            state: Eo,
            name: Do,
            instance: Io,
            options: ko
          }), Jo = function() {
          };
          Ro.push(No || Jo);
        }
      });
    }
    function Oo() {
      Ro.forEach(function(jo) {
        return jo();
      }), Ro = [];
    }
    return Io;
  };
}
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$2, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1], createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
const SelectActionTypes = {
  buttonClick: "buttonClick",
  browserAutoFill: "browserAutoFill"
}, defaultOptionStringifier = (Kt) => {
  const {
    label: uo,
    value: ho
  } = Kt;
  return typeof uo == "string" ? uo : typeof ho == "string" ? ho : String(Kt);
};
function selectReducer(Kt, uo) {
  const {
    open: ho
  } = Kt, {
    context: {
      selectionMode: go
    }
  } = uo;
  if (uo.type === SelectActionTypes.buttonClick) {
    const vo = Kt.selectedValues[0] ?? moveHighlight(null, "start", uo.context);
    return {
      ...Kt,
      open: !ho,
      highlightedValue: ho ? null : vo
    };
  }
  if (uo.type === SelectActionTypes.browserAutoFill)
    return handleItemSelection(uo.item, Kt, uo.context);
  const bo = listReducer(Kt, uo);
  switch (uo.type) {
    case ListActionTypes.keyDown:
      if (Kt.open) {
        if (uo.event.key === "Escape")
          return {
            ...bo,
            open: !1
          };
      } else {
        if (uo.event.key === "ArrowDown")
          return {
            ...Kt,
            open: !0,
            highlightedValue: Kt.selectedValues[0] ?? moveHighlight(null, "start", uo.context)
          };
        if (uo.event.key === "ArrowUp")
          return {
            ...Kt,
            open: !0,
            highlightedValue: Kt.selectedValues[0] ?? moveHighlight(null, "end", uo.context)
          };
      }
      break;
    case ListActionTypes.itemClick:
      if (go === "single")
        return {
          ...bo,
          open: !1
        };
      break;
    case ListActionTypes.blur:
      return {
        ...bo,
        open: !1
      };
    default:
      return bo;
  }
  return bo;
}
function defaultFormValueProvider(Kt) {
  return Array.isArray(Kt) ? Kt.length === 0 ? "" : JSON.stringify(Kt.map((uo) => uo.value)) : (Kt == null ? void 0 : Kt.value) == null ? "" : typeof Kt.value == "string" || typeof Kt.value == "number" ? Kt.value : JSON.stringify(Kt.value);
}
function useSelect(Kt) {
  const {
    areOptionsEqual: uo,
    buttonRef: ho,
    defaultOpen: go = !1,
    defaultValue: bo,
    disabled: vo = !1,
    listboxId: Po,
    listboxRef: Co,
    multiple: So = !1,
    name: wo,
    required: Eo,
    onChange: Ro,
    onHighlightChange: _o,
    onOpenChange: Io,
    open: Ao,
    options: Oo,
    getOptionAsString: jo = defaultOptionStringifier,
    getSerializedValue: Do = defaultFormValueProvider,
    value: Lo,
    componentName: ko = "useSelect"
  } = Kt, Ko = React$1.useRef(null), No = useForkRef(ho, Ko), Jo = React$1.useRef(null), ti = useId(Po);
  let oi;
  Lo === void 0 && bo === void 0 ? oi = [] : bo !== void 0 && (So ? oi = bo : oi = bo == null ? [] : [bo]);
  const Qo = React$1.useMemo(() => {
    if (Lo !== void 0)
      return So ? Lo : Lo == null ? [] : [Lo];
  }, [Lo, So]), {
    subitems: Zo,
    contextValue: ei
  } = useCompoundParent(), ii = React$1.useMemo(() => Oo != null ? new Map(Oo.map((Mi, Wi) => [Mi.value, {
    value: Mi.value,
    label: Mi.label,
    disabled: Mi.disabled,
    ref: /* @__PURE__ */ React$1.createRef(),
    id: `${ti}_${Wi}`
  }])) : Zo, [Oo, Zo, ti]), ai = useForkRef(Co, Jo), {
    getRootProps: ri,
    active: ni,
    focusVisible: si,
    rootRef: li
  } = useButton({
    disabled: vo,
    rootRef: No
  }), ui = React$1.useMemo(() => Array.from(ii.keys()), [ii]), ci = React$1.useCallback((Mi) => {
    if (uo !== void 0) {
      const Wi = ui.find((Hi) => uo(Hi, Mi));
      return ii.get(Wi);
    }
    return ii.get(Mi);
  }, [ii, uo, ui]), fi = React$1.useCallback((Mi) => {
    const Wi = ci(Mi);
    return (Wi == null ? void 0 : Wi.disabled) ?? !1;
  }, [ci]), yi = React$1.useCallback((Mi) => {
    const Wi = ci(Mi);
    return Wi ? jo(Wi) : "";
  }, [ci, jo]), hi = React$1.useMemo(() => ({
    selectedValues: Qo,
    open: Ao
  }), [Qo, Ao]), mi = React$1.useCallback((Mi) => {
    var Wi;
    return (Wi = ii.get(Mi)) == null ? void 0 : Wi.id;
  }, [ii]), bi = React$1.useCallback((Mi, Wi) => {
    So ? Ro == null || Ro(Mi, Wi) : Ro == null || Ro(Mi, Wi[0] ?? null);
  }, [So, Ro]), xi = React$1.useCallback((Mi, Wi) => {
    _o == null || _o(Mi, Wi ?? null);
  }, [_o]), $i = React$1.useCallback((Mi, Wi, Hi) => {
    var Xi;
    Wi === "open" && (Io == null || Io(Hi), Hi === !1 && (Mi == null ? void 0 : Mi.type) !== "blur" && ((Xi = Ko.current) == null || Xi.focus()));
  }, [Io]), Ci = React$1.useCallback((Mi) => {
    var Wi;
    return Mi == null ? null : ((Wi = Zo.get(Mi)) == null ? void 0 : Wi.ref.current) ?? null;
  }, [Zo]), Si = {
    getInitialState: () => ({
      highlightedValue: null,
      selectedValues: oi ?? [],
      open: go
    }),
    getItemId: mi,
    controlledProps: hi,
    focusManagement: "DOM",
    getItemDomElement: Ci,
    itemComparer: uo,
    isItemDisabled: fi,
    rootRef: ai,
    onChange: bi,
    onHighlightChange: xi,
    onStateChange: $i,
    reducerActionContext: React$1.useMemo(() => ({
      multiple: So
    }), [So]),
    items: ui,
    getItemAsString: yi,
    selectionMode: So ? "multiple" : "single",
    stateReducer: selectReducer,
    componentName: ko
  }, {
    dispatch: vi,
    getRootProps: Pi,
    contextValue: wi,
    state: {
      open: gi,
      highlightedValue: Ri,
      selectedValues: Ei
    },
    rootRef: Ni
  } = useList(Si), Ai = React$1.useRef(gi);
  useEnhancedEffect(() => {
    var Mi;
    if (gi && Ri !== null) {
      const Wi = (Mi = ci(Ri)) == null ? void 0 : Mi.ref;
      if (!Jo.current || !(Wi != null && Wi.current))
        return;
      Ai.current || Wi.current.focus({
        preventScroll: !0
      });
      const Hi = Jo.current.getBoundingClientRect(), Xi = Wi.current.getBoundingClientRect();
      Xi.top < Hi.top ? Jo.current.scrollTop -= Hi.top - Xi.top : Xi.bottom > Hi.bottom && (Jo.current.scrollTop += Xi.bottom - Hi.bottom);
    }
  }, [gi, Ri, ci]);
  const Yi = React$1.useCallback((Mi) => ci(Mi), [ci]), Ui = (Mi) => (Wi) => {
    var Hi;
    if ((Hi = Mi == null ? void 0 : Mi.onClick) == null || Hi.call(Mi, Wi), !Wi.defaultMuiPrevented) {
      const Xi = {
        type: SelectActionTypes.buttonClick,
        event: Wi
      };
      vi(Xi);
    }
  }, us = (Mi) => (Wi) => {
    var Hi;
    (Hi = Mi.onKeyDown) == null || Hi.call(Mi, Wi), !Wi.defaultMuiPrevented && (Wi.key === "ArrowDown" || Wi.key === "ArrowUp") && (Wi.preventDefault(), vi({
      type: ListActionTypes.keyDown,
      key: Wi.key,
      event: Wi
    }));
  }, ns = (Mi = {}) => ({
    onClick: Ui(Mi),
    onKeyDown: us(Mi)
  }), Ti = (Mi = {}) => ({
    ...Mi,
    ...ns(Mi),
    role: "combobox",
    "aria-expanded": gi,
    "aria-controls": ti
  }), _i = (Mi = {}) => {
    const Wi = extractEventHandlers(Mi), Hi = combineHooksSlotProps(Ti, ri);
    return {
      ...Mi,
      ...Hi(Wi)
    };
  }, Vi = (Mi) => (Wi) => {
    var Hi, Xi;
    (Hi = Mi.onBlur) == null || Hi.call(Mi, Wi), !Wi.defaultMuiPrevented && ((Xi = Jo.current) != null && Xi.contains(Wi.relatedTarget) || Wi.relatedTarget === Ko.current) && (Wi.defaultMuiPrevented = !0);
  }, Bi = (Mi = {}) => ({
    onBlur: Vi(Mi)
  }), Ji = (Mi = {}) => {
    const Wi = extractEventHandlers(Mi), Hi = combineHooksSlotProps(Bi, Pi);
    return {
      id: ti,
      role: "listbox",
      "aria-multiselectable": So ? "true" : void 0,
      ...Mi,
      ...Hi(Wi)
    };
  };
  React$1.useDebugValue({
    selectedOptions: Ei,
    highlightedOption: Ri,
    open: gi
  });
  const Ki = React$1.useMemo(() => ({
    ...wi,
    ...ei
  }), [wi, ei]);
  let qi;
  Kt.multiple ? qi = Ei : qi = Ei.length > 0 ? Ei[0] : null;
  let rs;
  So ? rs = qi.map((Mi) => Yi(Mi)).filter((Mi) => Mi !== void 0) : rs = Yi(qi) ?? null;
  const os = (Mi) => (Wi) => {
    var Xi;
    if ((Xi = Mi == null ? void 0 : Mi.onChange) == null || Xi.call(Mi, Wi), Wi.defaultMuiPrevented)
      return;
    const Hi = ii.get(Wi.target.value);
    Wi.target.value === "" ? vi({
      type: ListActionTypes.clearSelection
    }) : Hi !== void 0 && vi({
      type: SelectActionTypes.browserAutoFill,
      item: Hi.value,
      event: Wi
    });
  };
  return {
    buttonActive: ni,
    buttonFocusVisible: si,
    buttonRef: li,
    contextValue: Ki,
    disabled: vo,
    dispatch: vi,
    getButtonProps: _i,
    getHiddenInputProps: (Mi = {}) => {
      const Wi = extractEventHandlers(Mi);
      return {
        name: wo,
        tabIndex: -1,
        "aria-hidden": !0,
        required: Eo ? !0 : void 0,
        value: Do(rs),
        style: visuallyHidden,
        ...Mi,
        onChange: os(Wi)
      };
    },
    getListboxProps: Ji,
    getOptionMetadata: Yi,
    listboxRef: Ni,
    open: gi,
    options: ui,
    value: qi,
    highlightedOption: Ri
  };
}
function SelectProvider(Kt) {
  const {
    value: uo,
    children: ho
  } = Kt, {
    dispatch: go,
    getItemIndex: bo,
    getItemState: vo,
    registerItem: Po,
    totalSubitemCount: Co
  } = uo, So = React$1.useMemo(() => ({
    dispatch: go,
    getItemState: vo,
    getItemIndex: bo
  }), [go, bo, vo]), wo = React$1.useMemo(() => ({
    getItemIndex: bo,
    registerItem: Po,
    totalSubitemCount: Co
  }), [Po, bo, Co]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: wo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
      value: So,
      children: ho
    })
  });
}
const COMPONENT_NAME$4 = "Select";
function getSelectUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME$4, Kt);
}
generateUtilityClasses(COMPONENT_NAME$4, ["root", "button", "listbox", "popup", "active", "expanded", "disabled", "focusVisible"]);
var _span$4;
function defaultRenderValue(Kt) {
  return Array.isArray(Kt) ? /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
    children: Kt.map((uo) => uo.label).join(", ")
  }) : (Kt == null ? void 0 : Kt.label) ?? null;
}
function useUtilityClasses$1t(Kt) {
  const {
    active: uo,
    disabled: ho,
    open: go,
    focusVisible: bo
  } = Kt;
  return composeClasses({
    root: ["root", ho && "disabled", bo && "focusVisible", uo && "active", go && "expanded"],
    listbox: ["listbox", ho && "disabled"],
    popup: ["popup"]
  }, useClassNamesOverride(getSelectUtilityClass));
}
const Select$2 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    areOptionsEqual: go,
    autoComplete: bo,
    autoFocus: vo,
    children: Po,
    defaultValue: Co,
    defaultListboxOpen: So = !1,
    disabled: wo,
    getSerializedValue: Eo,
    listboxId: Ro,
    listboxOpen: _o,
    multiple: Io = !1,
    name: Ao,
    required: Oo = !1,
    onChange: jo,
    onListboxOpenChange: Do,
    getOptionAsString: Lo = defaultOptionStringifier,
    renderValue: ko,
    placeholder: Ko,
    slotProps: No = {},
    slots: Jo = {},
    value: ti,
    ...oi
  } = uo, Qo = ko ?? defaultRenderValue, [Zo, ei] = React$1.useState(!1), ii = React$1.useRef(null), ai = React$1.useRef(null), ri = Jo.root ?? "button", ni = Jo.listbox ?? "ul", si = Jo.popup ?? "div", li = React$1.useCallback((Ni) => {
    ei(Ni != null);
  }, []), ui = useForkRef(ho, ii, li);
  React$1.useEffect(() => {
    vo && ii.current.focus();
  }, [vo]);
  const {
    buttonActive: ci,
    buttonFocusVisible: fi,
    contextValue: yi,
    disabled: hi,
    getButtonProps: mi,
    getListboxProps: bi,
    getHiddenInputProps: xi,
    getOptionMetadata: $i,
    value: Ci,
    open: Si
  } = useSelect({
    name: Ao,
    required: Oo,
    getSerializedValue: Eo,
    areOptionsEqual: go,
    buttonRef: ui,
    defaultOpen: So,
    defaultValue: Co,
    disabled: wo,
    listboxId: Ro,
    multiple: Io,
    open: _o,
    onChange: jo,
    onOpenChange: Do,
    getOptionAsString: Lo,
    value: ti,
    componentName: "Select"
  }), vi = {
    ...uo,
    active: ci,
    defaultListboxOpen: So,
    disabled: hi,
    focusVisible: fi,
    open: Si,
    multiple: Io,
    renderValue: Qo,
    value: Ci
  }, Pi = useUtilityClasses$1t(vi), wi = useSlotProps({
    elementType: ri,
    getSlotProps: mi,
    externalSlotProps: No.root,
    externalForwardedProps: oi,
    ownerState: vi,
    className: Pi.root
  }), gi = useSlotProps({
    elementType: ni,
    getSlotProps: bi,
    externalSlotProps: No.listbox,
    additionalProps: {
      ref: ai
    },
    ownerState: vi,
    className: Pi.listbox
  }), Ri = useSlotProps({
    elementType: si,
    externalSlotProps: No.popup,
    additionalProps: {
      anchor: ii.current,
      keepMounted: !0,
      open: Si,
      placement: "bottom-start",
      role: void 0
    },
    ownerState: vi,
    className: Pi.popup
  });
  let Ei;
  return Io ? Ei = Ci.map((Ni) => $i(Ni)).filter((Ni) => Ni !== void 0) : Ei = $i(Ci) ?? null, /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ri, {
      ...wi,
      children: Qo(Ei) ?? Ko ?? // fall back to a zero-width space to prevent layout shift
      // from https://github.com/mui/material-ui/pull/24563
      (_span$4 || (_span$4 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      })))
    }), Zo && /* @__PURE__ */ jsxRuntimeExports.jsx(Popup, {
      slots: {
        root: si
      },
      ...Ri,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ni, {
        ...gi,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(SelectProvider, {
          value: yi,
          children: Po
        })
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("input", {
      ...xi(),
      autoComplete: bo
    })]
  });
});
process.env.NODE_ENV !== "production" && (Select$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A function used to determine if two options' values are equal.
   * By default, reference equality is used.
   *
   * There is a performance impact when using the `areOptionsEqual` prop (proportional to the number of options).
   * Therefore, it's recommented to use the default reference equality comparison whenever possible.
   */
  areOptionsEqual: PropTypes.func,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the select element is focused during the first mount
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the select will be initially open.
   * @default false
   */
  defaultListboxOpen: PropTypes.bool,
  /**
   * The default selected value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * A function used to convert the option label to a string.
   * It's useful when labels are elements and need to be converted to plain text
   * to enable navigation using character keys on a keyboard.
   *
   * @default defaultOptionStringifier
   */
  getOptionAsString: PropTypes.func,
  /**
   * A function to convert the currently selected value to a string.
   * Used to set a value of a hidden input associated with the select,
   * so that the selected value can be posted with a form.
   */
  getSerializedValue: PropTypes.func,
  /**
   * `id` attribute of the listbox element.
   */
  listboxId: PropTypes.string,
  /**
   * Controls the open state of the select's listbox.
   * @default undefined
   */
  listboxOpen: PropTypes.bool,
  /**
   * If `true`, selecting multiple values is allowed.
   * This affects the type of the `value`, `defaultValue`, and `onChange` props.
   *
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * Name of the element. For example used by the server to identify the fields in form submits.
   */
  name: PropTypes.string,
  /**
   * Callback fired when an option is selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see listboxOpen).
   */
  onListboxOpenChange: PropTypes.func,
  /**
   * Text to show when there is no selected value.
   */
  placeholder: PropTypes.node,
  /**
   * Function that customizes the rendering of the selected value.
   */
  renderValue: PropTypes.func,
  /**
   * If `true`, the Select cannot be empty when submitting form.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside the Input.
   * @default {}
   */
  slotProps: PropTypes.shape({
    listbox: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popup: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Select.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    listbox: PropTypes.elementType,
    popup: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The selected value.
   * Set to `null` to deselect all options.
   */
  value: PropTypes.any
});
const COMPONENT_NAME$3 = "TabPanel";
function getTabPanelUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME$3, Kt);
}
generateUtilityClasses(COMPONENT_NAME$3, ["root", "hidden"]);
const COMPONENT_NAME$2 = "Tabs";
function getTabsUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME$2, Kt);
}
generateUtilityClasses(COMPONENT_NAME$2, ["root", "horizontal", "vertical"]);
function useTabs(Kt) {
  const {
    value: uo,
    defaultValue: ho,
    onChange: go,
    orientation: bo = "horizontal",
    direction: vo = "ltr",
    selectionFollowsFocus: Po = !1
  } = Kt, [Co, So] = useControlled({
    controlled: uo,
    default: ho,
    name: "Tabs",
    state: "value"
  }), wo = React$1.useCallback((jo, Do) => {
    So(Do), go == null || go(jo, Do);
  }, [go, So]), {
    subitems: Eo,
    contextValue: Ro
  } = useCompoundParent(), _o = React$1.useRef(() => {
  }), Io = React$1.useCallback((jo) => {
    var Do;
    return (Do = Eo.get(jo)) == null ? void 0 : Do.id;
  }, [Eo]), Ao = React$1.useCallback((jo) => _o.current(jo), []), Oo = React$1.useCallback((jo) => {
    _o.current = jo;
  }, []);
  return {
    contextValue: {
      direction: vo,
      getTabId: Ao,
      getTabPanelId: Io,
      onSelected: wo,
      orientation: bo,
      registerTabIdLookup: Oo,
      selectionFollowsFocus: Po,
      value: Co,
      ...Ro
    }
  };
}
const TabsContext = /* @__PURE__ */ React$1.createContext(null);
process.env.NODE_ENV !== "production" && (TabsContext.displayName = "TabsContext");
function useTabsContext() {
  const Kt = React$1.useContext(TabsContext);
  if (Kt == null)
    throw new Error("No TabsContext provided");
  return Kt;
}
function TabsProvider(Kt) {
  const {
    value: uo,
    children: ho
  } = Kt, {
    direction: go,
    getItemIndex: bo,
    onSelected: vo,
    orientation: Po,
    registerItem: Co,
    registerTabIdLookup: So,
    selectionFollowsFocus: wo,
    totalSubitemCount: Eo,
    value: Ro,
    getTabId: _o,
    getTabPanelId: Io
  } = uo, Ao = React$1.useMemo(() => ({
    getItemIndex: bo,
    registerItem: Co,
    totalSubitemCount: Eo
  }), [Co, bo, Eo]), Oo = React$1.useMemo(() => ({
    direction: go,
    getTabId: _o,
    getTabPanelId: Io,
    onSelected: vo,
    orientation: Po,
    registerTabIdLookup: So,
    selectionFollowsFocus: wo,
    value: Ro
  }), [go, _o, Io, vo, Po, So, wo, Ro]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: Ao,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabsContext.Provider, {
      value: Oo,
      children: ho
    })
  });
}
const useUtilityClasses$1s = (Kt) => {
  const {
    orientation: uo
  } = Kt;
  return composeClasses({
    root: ["root", uo]
  }, useClassNamesOverride(getTabsUtilityClass));
}, Tabs = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    children: go,
    value: bo,
    defaultValue: vo,
    orientation: Po = "horizontal",
    direction: Co = "ltr",
    onChange: So,
    selectionFollowsFocus: wo,
    slotProps: Eo = {},
    slots: Ro = {},
    ..._o
  } = uo, Io = {
    ...uo,
    orientation: Po,
    direction: Co
  }, {
    contextValue: Ao
  } = useTabs(Io), Oo = useUtilityClasses$1s(Io), jo = Ro.root ?? "div", Do = useSlotProps({
    elementType: jo,
    externalSlotProps: Eo.root,
    externalForwardedProps: _o,
    additionalProps: {
      ref: ho
    },
    ownerState: Io,
    className: Oo.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jo, {
    ...Do,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TabsProvider, {
      value: Ao,
      children: go
    })
  });
});
process.env.NODE_ENV !== "production" && (Tabs.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * Callback invoked when new value is being set.
   */
  onChange: PropTypes.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: PropTypes.bool,
  /**
   * The props used for each slot inside the Tabs.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Tabs.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `null`.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
function tabPanelValueGenerator(Kt) {
  return Kt.size;
}
function useTabPanel(Kt) {
  const {
    value: uo,
    id: ho,
    rootRef: go
  } = Kt, bo = useTabsContext();
  if (bo === null)
    throw new Error("No TabContext provided");
  const {
    value: vo,
    getTabId: Po
  } = bo, Co = useId(ho), So = React$1.useRef(null), wo = useForkRef(So, go), Eo = React$1.useMemo(() => ({
    id: Co,
    ref: So
  }), [Co]), {
    id: Ro
  } = useCompoundItem(uo ?? tabPanelValueGenerator, Eo), _o = Ro !== vo, Io = Ro !== void 0 ? Po(Ro) : void 0;
  return {
    hidden: _o,
    getRootProps: (Oo = {}) => ({
      "aria-labelledby": Io ?? void 0,
      hidden: _o,
      id: Co ?? void 0,
      ...Oo,
      ref: wo
    }),
    rootRef: wo
  };
}
const useUtilityClasses$1r = (Kt) => {
  const {
    hidden: uo
  } = Kt;
  return composeClasses({
    root: ["root", uo && "hidden"]
  }, useClassNamesOverride(getTabPanelUtilityClass));
}, TabPanel = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    children: go,
    value: bo,
    slotProps: vo = {},
    slots: Po = {},
    ...Co
  } = uo, {
    hidden: So,
    getRootProps: wo
  } = useTabPanel(uo), Eo = {
    ...uo,
    hidden: So
  }, Ro = useUtilityClasses$1r(Eo), _o = Po.root ?? "div", Io = useSlotProps({
    elementType: _o,
    getSlotProps: wo,
    externalSlotProps: vo.root,
    externalForwardedProps: Co,
    additionalProps: {
      role: "tabpanel",
      ref: ho
    },
    ownerState: Eo,
    className: Ro.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(_o, {
    ...Io,
    children: !So && go
  });
});
process.env.NODE_ENV !== "production" && (TabPanel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside the TabPanel.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the TabPanel.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The value of the TabPanel. It will be shown when the Tab with the corresponding value is selected.
   * If not provided, it will fall back to the index of the panel.
   * It is recommended to explicitly provide it, as it's required for the tab panel to be rendered on the server.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
const COMPONENT_NAME$1 = "TabsList";
function getTabsListUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME$1, Kt);
}
generateUtilityClasses(COMPONENT_NAME$1, ["root", "horizontal", "vertical"]);
const TabsListActionTypes = {
  valueChange: "valueChange"
};
function tabsListReducer(Kt, uo) {
  if (uo.type === TabsListActionTypes.valueChange)
    return {
      ...Kt,
      highlightedValue: uo.value
    };
  const ho = listReducer(Kt, uo), {
    context: {
      selectionFollowsFocus: go
    }
  } = uo;
  if (uo.type === ListActionTypes.itemsChange) {
    if (ho.selectedValues.length > 0)
      return {
        ...ho,
        highlightedValue: ho.selectedValues[0]
      };
    moveHighlight(null, "reset", uo.context);
  }
  return go && ho.highlightedValue != null ? {
    ...ho,
    selectedValues: [ho.highlightedValue]
  } : ho;
}
function useTabsList(Kt) {
  const {
    rootRef: uo
  } = Kt, {
    direction: ho = "ltr",
    onSelected: go,
    orientation: bo = "horizontal",
    value: vo,
    registerTabIdLookup: Po,
    selectionFollowsFocus: Co
  } = useTabsContext(), {
    subitems: So,
    contextValue: wo
  } = useCompoundParent(), Eo = React$1.useCallback((Zo) => {
    var ei;
    return (ei = So.get(Zo)) == null ? void 0 : ei.id;
  }, [So]);
  Po(Eo);
  const Ro = React$1.useMemo(() => Array.from(So.keys()), [So]), _o = React$1.useCallback((Zo) => {
    var ei;
    return Zo == null ? null : ((ei = So.get(Zo)) == null ? void 0 : ei.ref.current) ?? null;
  }, [So]), Io = ho === "rtl";
  let Ao;
  bo === "vertical" ? Ao = "vertical" : Ao = Io ? "horizontal-rtl" : "horizontal-ltr";
  const Oo = React$1.useCallback((Zo, ei) => {
    go(Zo, ei[0] ?? null);
  }, [go]), jo = React$1.useMemo(() => vo === void 0 ? {} : vo != null ? {
    selectedValues: [vo]
  } : {
    selectedValues: []
  }, [vo]), Do = React$1.useCallback((Zo) => {
    var ei;
    return ((ei = So.get(Zo)) == null ? void 0 : ei.disabled) ?? !1;
  }, [So]), {
    contextValue: Lo,
    dispatch: ko,
    getRootProps: Ko,
    state: {
      highlightedValue: No,
      selectedValues: Jo
    },
    rootRef: ti
  } = useList({
    controlledProps: jo,
    disabledItemsFocusable: !Co,
    focusManagement: "DOM",
    getItemDomElement: _o,
    isItemDisabled: Do,
    items: Ro,
    rootRef: uo,
    onChange: Oo,
    orientation: Ao,
    reducerActionContext: React$1.useMemo(() => ({
      selectionFollowsFocus: Co || !1
    }), [Co]),
    selectionMode: "single",
    stateReducer: tabsListReducer
  });
  React$1.useEffect(() => {
    vo !== void 0 && vo != null && ko({
      type: TabsListActionTypes.valueChange,
      value: vo
    });
  }, [ko, vo]);
  const oi = (Zo = {}) => ({
    ...Zo,
    ...Ko(Zo),
    "aria-orientation": bo === "vertical" ? "vertical" : void 0,
    role: "tablist"
  });
  return {
    contextValue: React$1.useMemo(() => ({
      ...wo,
      ...Lo
    }), [wo, Lo]),
    dispatch: ko,
    getRootProps: oi,
    highlightedValue: No,
    isRtl: Io,
    orientation: bo,
    rootRef: ti,
    selectedValue: Jo[0] ?? null
  };
}
function TabsListProvider(Kt) {
  const {
    value: uo,
    children: ho
  } = Kt, {
    dispatch: go,
    getItemIndex: bo,
    getItemState: vo,
    registerItem: Po,
    totalSubitemCount: Co
  } = uo, So = React$1.useMemo(() => ({
    dispatch: go,
    getItemState: vo,
    getItemIndex: bo
  }), [go, bo, vo]), wo = React$1.useMemo(() => ({
    getItemIndex: bo,
    registerItem: Po,
    totalSubitemCount: Co
  }), [Po, bo, Co]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CompoundComponentContext.Provider, {
    value: wo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext$1.Provider, {
      value: So,
      children: ho
    })
  });
}
const useUtilityClasses$1q = (Kt) => {
  const {
    orientation: uo
  } = Kt;
  return composeClasses({
    root: ["root", uo]
  }, useClassNamesOverride(getTabsListUtilityClass));
}, TabsList = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    children: go,
    slotProps: bo = {},
    slots: vo = {},
    ...Po
  } = uo, {
    isRtl: Co,
    orientation: So,
    getRootProps: wo,
    contextValue: Eo
  } = useTabsList({
    rootRef: ho
  }), Ro = {
    ...uo,
    isRtl: Co,
    orientation: So
  }, _o = useUtilityClasses$1q(Ro), Io = vo.root ?? "div", Ao = useSlotProps({
    elementType: Io,
    getSlotProps: wo,
    externalSlotProps: bo.root,
    externalForwardedProps: Po,
    ownerState: Ro,
    className: _o.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TabsListProvider, {
    value: Eo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Io, {
      ...Ao,
      children: go
    })
  });
});
process.env.NODE_ENV !== "production" && (TabsList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside the TabsList.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the TabsList.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  })
});
const COMPONENT_NAME = "Tab";
function getTabUtilityClass(Kt) {
  return generateUtilityClass(COMPONENT_NAME, Kt);
}
generateUtilityClasses(COMPONENT_NAME, ["root", "selected", "disabled"]);
function tabValueGenerator(Kt) {
  return Kt.size;
}
function useTab(Kt) {
  const {
    value: uo,
    rootRef: ho,
    disabled: go = !1,
    id: bo
  } = Kt, vo = React$1.useRef(null), Po = useId(bo), {
    value: Co,
    selectionFollowsFocus: So,
    getTabPanelId: wo
  } = useTabsContext(), Eo = React$1.useMemo(() => ({
    disabled: go,
    ref: vo,
    id: Po
  }), [go, vo, Po]), {
    id: Ro,
    index: _o,
    totalItemCount: Io
  } = useCompoundItem(uo ?? tabValueGenerator, Eo), {
    getRootProps: Ao,
    highlighted: Oo,
    selected: jo
  } = useListItem({
    item: Ro
  }), {
    getRootProps: Do,
    rootRef: Lo,
    active: ko,
    focusVisible: Ko,
    setFocusVisible: No
  } = useButton({
    disabled: go,
    focusableWhenDisabled: !So,
    type: "button"
  }), Jo = useForkRef(vo, ho, Lo), ti = Ro !== void 0 ? wo(Ro) : void 0;
  return {
    getRootProps: (Qo = {}) => {
      const Zo = extractEventHandlers(Qo), ei = combineHooksSlotProps(Ao, Do);
      return {
        ...Qo,
        ...ei(Zo),
        role: "tab",
        "aria-controls": ti,
        "aria-selected": jo,
        id: Po,
        ref: Jo
      };
    },
    active: ko,
    focusVisible: Ko,
    highlighted: Oo,
    index: _o,
    rootRef: Jo,
    // the `selected` state isn't set on the server (it relies on effects to be calculated),
    // so we fall back to checking the `value` prop with the selectedValue from the TabsContext
    selected: jo || Ro === Co,
    setFocusVisible: No,
    totalTabsCount: Io
  };
}
const useUtilityClasses$1p = (Kt) => {
  const {
    selected: uo,
    disabled: ho
  } = Kt;
  return composeClasses({
    root: ["root", uo && "selected", ho && "disabled"]
  }, useClassNamesOverride(getTabUtilityClass));
}, Tab = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    action: go,
    children: bo,
    disabled: vo = !1,
    onChange: Po,
    onClick: Co,
    onFocus: So,
    slotProps: wo = {},
    slots: Eo = {},
    value: Ro,
    ..._o
  } = uo, Io = React$1.useRef(null), Ao = useForkRef(Io, ho), {
    active: Oo,
    highlighted: jo,
    selected: Do,
    getRootProps: Lo
  } = useTab({
    ...uo,
    rootRef: Ao,
    value: Ro
  }), ko = {
    ...uo,
    active: Oo,
    disabled: vo,
    highlighted: jo,
    selected: Do
  }, Ko = useUtilityClasses$1p(ko), No = Eo.root ?? "button", Jo = useSlotProps({
    elementType: No,
    getSlotProps: Lo,
    externalSlotProps: wo.root,
    externalForwardedProps: _o,
    additionalProps: {
      ref: ho
    },
    ownerState: ko,
    className: Ko.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(No, {
    ...Jo,
    children: bo
  });
});
process.env.NODE_ENV !== "production" && (Tab.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions. It currently only supports `focusVisible()` action.
   */
  action: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focusVisible: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Callback invoked when new value is being set.
   */
  onChange: PropTypes.func,
  /**
   * The props used for each slot inside the Tab.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Tab.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * You can provide your own value. Otherwise, it falls back to the child position index.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
const Button$1 = (Kt) => {
  const {
    label: uo,
    type: ho = "outlined",
    state: go = "default",
    handleClick: bo = () => {
    },
    iconLeft: vo,
    iconRight: Po,
    ...Co
  } = Kt;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-button", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
    Button$2,
    {
      className: [ho, go].join(" ").replace(/\s+/, " ").trim(),
      disabled: go === "disabled",
      focusableWhenDisabled: !0,
      onClick: bo,
      ...Co,
      children: [
        vo && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": !0, className: `icon-left ${vo}` }),
        uo,
        Po && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": !0, className: `icon-right ${Po}` })
      ]
    }
  ) });
};
Button$1.propTypes = {
  /**
  * Callback on a click of the button
   * @default () => {}
  */
  handleClick: PropTypes.func,
  /**
  * Icon to display on the left side of the label
  */
  iconLeft: PropTypes.string,
  /**
  * Icon to display on the right side of the label
  */
  iconRight: PropTypes.string,
  /**
   * Text to display in the button. The text will default to be all uppercase
  */
  label: PropTypes.string.isRequired,
  /**
  * State of the button
   * @default default
  */
  state: PropTypes.oneOf([
    "default",
    "active",
    "disabled"
  ]),
  /**
  * Styling type for the button
   * @default outlined
  */
  type: PropTypes.oneOf([
    "browse",
    "filled",
    "outlined",
    "text"
  ])
};
const Input$1 = (Kt) => {
  const {
    buttonText: uo,
    children: ho,
    checked: go,
    clearTextButton: bo = !1,
    editableLabel: vo = {},
    errorMessage: Po,
    id: Co = "inputId1",
    inputLabel: So,
    multiline: wo = !1,
    type: Eo = "text",
    onChange: Ro,
    onBlur: _o,
    useWarning: Io,
    warningMessage: Ao,
    clearTextIcon: Oo = "fa-solid fa-circle-xmark",
    ...jo
  } = Kt, Do = "This field is required.", [Lo, ko] = useState(!1), [Ko, No] = useState(!1), [Jo, ti] = useState(!0), [oi, Qo] = useState(vo.placeholder), Zo = (ai) => {
    ko(ai.target.value.length === 0 && jo.required), _o && _o(ai);
  }, ei = (ai) => {
    const ri = ai.target.value;
    ri.length > 0 ? No(!0) : No(!1), ko(ri.length === 0 && jo.required), Ro && Ro(ai);
  }, ii = (ai) => {
    const ri = !!document.getElementById(`${Co}-label`).value.length;
    ti(!ri);
    const ni = ri ? ai.currentTarget.textContent : vo.placeholder;
    Qo(ni);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-input", { children: [
    So && !Object.keys(vo).length && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "label",
      {
        className: [Lo || Po ? "errorContainer" : ""].join(" ").replace(/\s+/g, " ").trim(),
        title: So,
        htmlFor: Co,
        "aria-labelledby": Co,
        children: So
      }
    ),
    !!Object.keys(vo).length && /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: [
          "editable-label-container",
          vo.error || vo.errorMessage ? "errorContainer" : "",
          vo.useWarning ? "warningContainer" : ""
        ].join(" ").replace(/\s+/g, " ").trim(),
        "data-testid": "editable-label-container",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$2,
            {
              id: `${Co}-label`,
              className: `editable-label ${Jo ? "edit" : ""}`,
              "aria-labelledby": Co,
              onBlur: Zo,
              onChange: (ai) => {
                vo.onChange && Ro(ai), ii(ai);
              },
              placeholder: oi,
              type: "text",
              error: vo.error,
              "data-testid": `${Co}-label`
            }
          ),
          vo.errorMessage && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "errorMessage", children: vo.errorMessage }),
          vo.useWarning && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "warningMessage", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: "fa-solid fa-circle-exclamation" }),
            vo.warningMessage
          ] })
        ]
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "inputContainer", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(
        "div",
        {
          className: [
            Lo || Po ? "errorContainer" : "",
            Io ? "warningContainer" : "",
            "inputColumn"
          ].join(" ").replace(/\s+/g, " ").trim(),
          "data-testid": "container",
          children: [
            ho || /* @__PURE__ */ jsxRuntimeExports.jsx(
              Input$2,
              {
                id: Co,
                "aria-label": "Input",
                checked: Eo === "checkbox" ? go : void 0,
                multiline: wo,
                name: Co,
                type: Eo,
                title: jo.placeholder,
                error: Lo,
                onBlur: Zo,
                onChange: ei,
                endAdornment: bo && Eo !== "checkbox" && Ko && /* @__PURE__ */ jsxRuntimeExports.jsx("button", { "aria-label": "Delete Input", onClick: (ai) => {
                  ai.preventDefault(), Ro && Ro({ target: { value: "" } }), document.getElementById(Co).value = "", No(!1);
                }, children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: Oo }) }),
                ...jo
              }
            ),
            Po && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "errorMessage", children: Po }),
            Lo && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "errorMessage", children: Do }),
            Io && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "warningMessage", children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: "fa-solid fa-circle-exclamation" }),
              Ao
            ] })
          ]
        }
      ),
      uo && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          iconLeft: "fa-solid fa-circle-plus",
          label: uo,
          type: "text",
          handleClick: () => {
            jo.onClick && typeof jo.onClick == "function" && jo.onClick();
          },
          ...jo
        }
      ),
      vo.endAdornment && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "action-button", children: vo.endAdornment })
    ] })
  ] });
};
Input$1.propTypes = {
  /**
   * Text the optional button should have
  */
  buttonText: PropTypes.string,
  /**
   * Whether to show the delete text button upon entering text
   */
  clearTextButton: PropTypes.bool,
  /**
   * Properties used for editable labels
   */
  editableLabel: PropTypes.shape({
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    useWarning: PropTypes.bool,
    warningMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    endAdornment: PropTypes.node
  }),
  /**
   * The message that should be displayed when there's an error
   */
  errorMessage: PropTypes.string,
  /**
   * The unique identifier for the input
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Label next to the input
   */
  inputLabel: PropTypes.string,
  /**
   * Whether the input area needs to allow for multiple lines
   * @default false
  */
  multiline: PropTypes.bool,
  /**
   * Callback function when state of element changes focus
   */
  onBlur: PropTypes.func,
  /**
   * Callback function for when state of elements change
   */
  onChange: PropTypes.func,
  /**
   * All props are available from Base UI Input: https://mui.com/base-ui/react-input/components-api/
   */
  /**
   * Placeholder text in the input
  */
  placeholder: PropTypes.string,
  /**
   * Whether the input field is required or not
   */
  required: PropTypes.bool,
  /**
   * The type the input should accept
   * @default text
   */
  type: PropTypes.oneOf([
    "email",
    "number",
    "tel",
    "text",
    "time",
    "url",
    "password",
    "hidden",
    "checkbox",
    "file"
  ]),
  /**
   * Whether the input validation has a warning pattern.
   */
  useWarning: PropTypes.bool,
  /**
  * The message that should be displayed when there's a warning.
  */
  warningMessage: PropTypes.string,
  /**
   * The Fontawesome icon to display as the delete icon for the input.
   *
   * Defaults to 'fa-solid fa-circle-exclamation'
   */
  clearTextIcon: PropTypes.string
};
const Title = (Kt) => {
  const {
    title: uo,
    backgroundColor: ho = "var(--vp-dark-blue)",
    textColor: go = "var(--vp-white)",
    children: bo
  } = Kt;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-title", { style: {
    backgroundColor: ho,
    color: go
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: uo }),
    bo
  ] });
};
Title.propTypes = {
  /**
   * The background color of the title container.
   */
  backgroundColor: PropTypes.string,
  /**
   * The slot content of title container.
   */
  children: PropTypes.node,
  /**
   * The text color of the title.
   */
  textColor: PropTypes.string,
  /**
   * The text content of the title.
   */
  title: PropTypes.string.isRequired
};
const GridApiContext = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (GridApiContext.displayName = "GridApiContext");
function useGridApiContext() {
  const Kt = React$1.useContext(GridApiContext);
  if (Kt === void 0)
    throw new Error(["MUI X: Could not find the Data Grid context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return Kt;
}
const GridRootPropsContext = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (GridRootPropsContext.displayName = "GridRootPropsContext");
const useGridRootProps = () => {
  const Kt = React$1.useContext(GridRootPropsContext);
  if (!Kt)
    throw new Error("MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.");
  return Kt;
};
function _extends$q() {
  return _extends$q = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho) ({}).hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$q.apply(null, arguments);
}
const reactMajor$1 = parseInt(React$1.version, 10), forwardRef = (Kt) => {
  if (reactMajor$1 >= 19) {
    const uo = (ho) => Kt(ho, ho.ref ?? null);
    return uo.displayName = Kt.displayName ?? Kt.name, uo;
  }
  return /* @__PURE__ */ React$1.forwardRef(Kt);
};
var isDevelopment$1 = !1;
function sheetForTag(Kt) {
  if (Kt.sheet)
    return Kt.sheet;
  for (var uo = 0; uo < document.styleSheets.length; uo++)
    if (document.styleSheets[uo].ownerNode === Kt)
      return document.styleSheets[uo];
}
function createStyleElement(Kt) {
  var uo = document.createElement("style");
  return uo.setAttribute("data-emotion", Kt.key), Kt.nonce !== void 0 && uo.setAttribute("nonce", Kt.nonce), uo.appendChild(document.createTextNode("")), uo.setAttribute("data-s", ""), uo;
}
var StyleSheet = /* @__PURE__ */ function() {
  function Kt(ho) {
    var go = this;
    this._insertTag = function(bo) {
      var vo;
      go.tags.length === 0 ? go.insertionPoint ? vo = go.insertionPoint.nextSibling : go.prepend ? vo = go.container.firstChild : vo = go.before : vo = go.tags[go.tags.length - 1].nextSibling, go.container.insertBefore(bo, vo), go.tags.push(bo);
    }, this.isSpeedy = ho.speedy === void 0 ? !isDevelopment$1 : ho.speedy, this.tags = [], this.ctr = 0, this.nonce = ho.nonce, this.key = ho.key, this.container = ho.container, this.prepend = ho.prepend, this.insertionPoint = ho.insertionPoint, this.before = null;
  }
  var uo = Kt.prototype;
  return uo.hydrate = function(go) {
    go.forEach(this._insertTag);
  }, uo.insert = function(go) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(createStyleElement(this));
    var bo = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var vo = sheetForTag(bo);
      try {
        vo.insertRule(go, vo.cssRules.length);
      } catch {
      }
    } else
      bo.appendChild(document.createTextNode(go));
    this.ctr++;
  }, uo.flush = function() {
    this.tags.forEach(function(go) {
      var bo;
      return (bo = go.parentNode) == null ? void 0 : bo.removeChild(go);
    }), this.tags = [], this.ctr = 0;
  }, Kt;
}(), MS = "-ms-", MOZ = "-moz-", WEBKIT = "-webkit-", COMMENT = "comm", RULESET = "rule", DECLARATION = "decl", IMPORT = "@import", KEYFRAMES = "@keyframes", LAYER = "@layer", abs = Math.abs, from = String.fromCharCode, assign$1 = Object.assign;
function hash(Kt, uo) {
  return charat(Kt, 0) ^ 45 ? (((uo << 2 ^ charat(Kt, 0)) << 2 ^ charat(Kt, 1)) << 2 ^ charat(Kt, 2)) << 2 ^ charat(Kt, 3) : 0;
}
function trim(Kt) {
  return Kt.trim();
}
function match(Kt, uo) {
  return (Kt = uo.exec(Kt)) ? Kt[0] : Kt;
}
function replace(Kt, uo, ho) {
  return Kt.replace(uo, ho);
}
function indexof(Kt, uo) {
  return Kt.indexOf(uo);
}
function charat(Kt, uo) {
  return Kt.charCodeAt(uo) | 0;
}
function substr(Kt, uo, ho) {
  return Kt.slice(uo, ho);
}
function strlen(Kt) {
  return Kt.length;
}
function sizeof(Kt) {
  return Kt.length;
}
function append$1(Kt, uo) {
  return uo.push(Kt), Kt;
}
function combine(Kt, uo) {
  return Kt.map(uo).join("");
}
var line = 1, column = 1, length = 0, position = 0, character = 0, characters = "";
function node(Kt, uo, ho, go, bo, vo, Po) {
  return { value: Kt, root: uo, parent: ho, type: go, props: bo, children: vo, line, column, length: Po, return: "" };
}
function copy$2(Kt, uo) {
  return assign$1(node("", null, null, "", null, null, 0), Kt, { length: -Kt.length }, uo);
}
function char() {
  return character;
}
function prev() {
  return character = position > 0 ? charat(characters, --position) : 0, column--, character === 10 && (column = 1, line--), character;
}
function next() {
  return character = position < length ? charat(characters, position++) : 0, column++, character === 10 && (column = 1, line++), character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(Kt, uo) {
  return substr(characters, Kt, uo);
}
function token(Kt) {
  switch (Kt) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(Kt) {
  return line = column = 1, length = strlen(characters = Kt), position = 0, [];
}
function dealloc(Kt) {
  return characters = "", Kt;
}
function delimit(Kt) {
  return trim(slice(position - 1, delimiter(Kt === 91 ? Kt + 2 : Kt === 40 ? Kt + 1 : Kt)));
}
function whitespace(Kt) {
  for (; (character = peek()) && character < 33; )
    next();
  return token(Kt) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(Kt, uo) {
  for (; --uo && next() && !(character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97); )
    ;
  return slice(Kt, caret() + (uo < 6 && peek() == 32 && next() == 32));
}
function delimiter(Kt) {
  for (; next(); )
    switch (character) {
      case Kt:
        return position;
      case 34:
      case 39:
        Kt !== 34 && Kt !== 39 && delimiter(character);
        break;
      case 40:
        Kt === 41 && delimiter(Kt);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(Kt, uo) {
  for (; next() && Kt + character !== 57; )
    if (Kt + character === 84 && peek() === 47)
      break;
  return "/*" + slice(uo, position - 1) + "*" + from(Kt === 47 ? Kt : next());
}
function identifier(Kt) {
  for (; !token(peek()); )
    next();
  return slice(Kt, position);
}
function compile(Kt) {
  return dealloc(parse("", null, null, null, [""], Kt = alloc(Kt), 0, [0], Kt));
}
function parse(Kt, uo, ho, go, bo, vo, Po, Co, So) {
  for (var wo = 0, Eo = 0, Ro = Po, _o = 0, Io = 0, Ao = 0, Oo = 1, jo = 1, Do = 1, Lo = 0, ko = "", Ko = bo, No = vo, Jo = go, ti = ko; jo; )
    switch (Ao = Lo, Lo = next()) {
      case 40:
        if (Ao != 108 && charat(ti, Ro - 1) == 58) {
          indexof(ti += replace(delimit(Lo), "&", "&\f"), "&\f") != -1 && (Do = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        ti += delimit(Lo);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        ti += whitespace(Ao);
        break;
      case 92:
        ti += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append$1(comment(commenter(next(), caret()), uo, ho), So);
            break;
          default:
            ti += "/";
        }
        break;
      case 123 * Oo:
        Co[wo++] = strlen(ti) * Do;
      case 125 * Oo:
      case 59:
      case 0:
        switch (Lo) {
          case 0:
          case 125:
            jo = 0;
          case 59 + Eo:
            Do == -1 && (ti = replace(ti, /\f/g, "")), Io > 0 && strlen(ti) - Ro && append$1(Io > 32 ? declaration(ti + ";", go, ho, Ro - 1) : declaration(replace(ti, " ", "") + ";", go, ho, Ro - 2), So);
            break;
          case 59:
            ti += ";";
          default:
            if (append$1(Jo = ruleset(ti, uo, ho, wo, Eo, bo, Co, ko, Ko = [], No = [], Ro), vo), Lo === 123)
              if (Eo === 0)
                parse(ti, uo, Jo, Jo, Ko, vo, Ro, Co, No);
              else
                switch (_o === 99 && charat(ti, 3) === 110 ? 100 : _o) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(Kt, Jo, Jo, go && append$1(ruleset(Kt, Jo, Jo, 0, 0, bo, Co, ko, bo, Ko = [], Ro), No), bo, No, Ro, Co, go ? Ko : No);
                    break;
                  default:
                    parse(ti, Jo, Jo, Jo, [""], No, 0, Co, No);
                }
        }
        wo = Eo = Io = 0, Oo = Do = 1, ko = ti = "", Ro = Po;
        break;
      case 58:
        Ro = 1 + strlen(ti), Io = Ao;
      default:
        if (Oo < 1) {
          if (Lo == 123)
            --Oo;
          else if (Lo == 125 && Oo++ == 0 && prev() == 125)
            continue;
        }
        switch (ti += from(Lo), Lo * Oo) {
          case 38:
            Do = Eo > 0 ? 1 : (ti += "\f", -1);
            break;
          case 44:
            Co[wo++] = (strlen(ti) - 1) * Do, Do = 1;
            break;
          case 64:
            peek() === 45 && (ti += delimit(next())), _o = peek(), Eo = Ro = strlen(ko = ti += identifier(caret())), Lo++;
            break;
          case 45:
            Ao === 45 && strlen(ti) == 2 && (Oo = 0);
        }
    }
  return vo;
}
function ruleset(Kt, uo, ho, go, bo, vo, Po, Co, So, wo, Eo) {
  for (var Ro = bo - 1, _o = bo === 0 ? vo : [""], Io = sizeof(_o), Ao = 0, Oo = 0, jo = 0; Ao < go; ++Ao)
    for (var Do = 0, Lo = substr(Kt, Ro + 1, Ro = abs(Oo = Po[Ao])), ko = Kt; Do < Io; ++Do)
      (ko = trim(Oo > 0 ? _o[Do] + " " + Lo : replace(Lo, /&\f/g, _o[Do]))) && (So[jo++] = ko);
  return node(Kt, uo, ho, bo === 0 ? RULESET : Co, So, wo, Eo);
}
function comment(Kt, uo, ho) {
  return node(Kt, uo, ho, COMMENT, from(char()), substr(Kt, 2, -2), 0);
}
function declaration(Kt, uo, ho, go) {
  return node(Kt, uo, ho, DECLARATION, substr(Kt, 0, go), substr(Kt, go + 1, -1), go);
}
function serialize(Kt, uo) {
  for (var ho = "", go = sizeof(Kt), bo = 0; bo < go; bo++)
    ho += uo(Kt[bo], bo, Kt, uo) || "";
  return ho;
}
function stringify(Kt, uo, ho, go) {
  switch (Kt.type) {
    case LAYER:
      if (Kt.children.length) break;
    case IMPORT:
    case DECLARATION:
      return Kt.return = Kt.return || Kt.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return Kt.return = Kt.value + "{" + serialize(Kt.children, go) + "}";
    case RULESET:
      Kt.value = Kt.props.join(",");
  }
  return strlen(ho = serialize(Kt.children, go)) ? Kt.return = Kt.value + "{" + ho + "}" : "";
}
function middleware(Kt) {
  var uo = sizeof(Kt);
  return function(ho, go, bo, vo) {
    for (var Po = "", Co = 0; Co < uo; Co++)
      Po += Kt[Co](ho, go, bo, vo) || "";
    return Po;
  };
}
function rulesheet(Kt) {
  return function(uo) {
    uo.root || (uo = uo.return) && Kt(uo);
  };
}
function memoize$5(Kt) {
  var uo = /* @__PURE__ */ Object.create(null);
  return function(ho) {
    return uo[ho] === void 0 && (uo[ho] = Kt(ho)), uo[ho];
  };
}
var identifierWithPointTracking = function(uo, ho, go) {
  for (var bo = 0, vo = 0; bo = vo, vo = peek(), bo === 38 && vo === 12 && (ho[go] = 1), !token(vo); )
    next();
  return slice(uo, position);
}, toRules = function(uo, ho) {
  var go = -1, bo = 44;
  do
    switch (token(bo)) {
      case 0:
        bo === 38 && peek() === 12 && (ho[go] = 1), uo[go] += identifierWithPointTracking(position - 1, ho, go);
        break;
      case 2:
        uo[go] += delimit(bo);
        break;
      case 4:
        if (bo === 44) {
          uo[++go] = peek() === 58 ? "&\f" : "", ho[go] = uo[go].length;
          break;
        }
      default:
        uo[go] += from(bo);
    }
  while (bo = next());
  return uo;
}, getRules = function(uo, ho) {
  return dealloc(toRules(alloc(uo), ho));
}, fixedElements = /* @__PURE__ */ new WeakMap(), compat = function(uo) {
  if (!(uo.type !== "rule" || !uo.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  uo.length < 1)) {
    for (var ho = uo.value, go = uo.parent, bo = uo.column === go.column && uo.line === go.line; go.type !== "rule"; )
      if (go = go.parent, !go) return;
    if (!(uo.props.length === 1 && ho.charCodeAt(0) !== 58 && !fixedElements.get(go)) && !bo) {
      fixedElements.set(uo, !0);
      for (var vo = [], Po = getRules(ho, vo), Co = go.props, So = 0, wo = 0; So < Po.length; So++)
        for (var Eo = 0; Eo < Co.length; Eo++, wo++)
          uo.props[wo] = vo[So] ? Po[So].replace(/&\f/g, Co[Eo]) : Co[Eo] + " " + Po[So];
    }
  }
}, removeLabel = function(uo) {
  if (uo.type === "decl") {
    var ho = uo.value;
    // charcode for l
    ho.charCodeAt(0) === 108 && // charcode for b
    ho.charCodeAt(2) === 98 && (uo.return = "", uo.value = "");
  }
};
function prefix$1(Kt, uo) {
  switch (hash(Kt, uo)) {
    case 5103:
      return WEBKIT + "print-" + Kt + Kt;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return WEBKIT + Kt + Kt;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return WEBKIT + Kt + MOZ + Kt + MS + Kt + Kt;
    case 6828:
    case 4268:
      return WEBKIT + Kt + MS + Kt + Kt;
    case 6165:
      return WEBKIT + Kt + MS + "flex-" + Kt + Kt;
    case 5187:
      return WEBKIT + Kt + replace(Kt, /(\w+).+(:[^]+)/, WEBKIT + "box-$1$2" + MS + "flex-$1$2") + Kt;
    case 5443:
      return WEBKIT + Kt + MS + "flex-item-" + replace(Kt, /flex-|-self/, "") + Kt;
    case 4675:
      return WEBKIT + Kt + MS + "flex-line-pack" + replace(Kt, /align-content|flex-|-self/, "") + Kt;
    case 5548:
      return WEBKIT + Kt + MS + replace(Kt, "shrink", "negative") + Kt;
    case 5292:
      return WEBKIT + Kt + MS + replace(Kt, "basis", "preferred-size") + Kt;
    case 6060:
      return WEBKIT + "box-" + replace(Kt, "-grow", "") + WEBKIT + Kt + MS + replace(Kt, "grow", "positive") + Kt;
    case 4554:
      return WEBKIT + replace(Kt, /([^-])(transform)/g, "$1" + WEBKIT + "$2") + Kt;
    case 6187:
      return replace(replace(replace(Kt, /(zoom-|grab)/, WEBKIT + "$1"), /(image-set)/, WEBKIT + "$1"), Kt, "") + Kt;
    case 5495:
    case 3959:
      return replace(Kt, /(image-set\([^]*)/, WEBKIT + "$1$`$1");
    case 4968:
      return replace(replace(Kt, /(.+:)(flex-)?(.*)/, WEBKIT + "box-pack:$3" + MS + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + WEBKIT + Kt + Kt;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return replace(Kt, /(.+)-inline(.+)/, WEBKIT + "$1$2") + Kt;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (strlen(Kt) - 1 - uo > 6) switch (charat(Kt, uo + 1)) {
        case 109:
          if (charat(Kt, uo + 4) !== 45) break;
        case 102:
          return replace(Kt, /(.+:)(.+)-([^]+)/, "$1" + WEBKIT + "$2-$3$1" + MOZ + (charat(Kt, uo + 3) == 108 ? "$3" : "$2-$3")) + Kt;
        case 115:
          return ~indexof(Kt, "stretch") ? prefix$1(replace(Kt, "stretch", "fill-available"), uo) + Kt : Kt;
      }
      break;
    case 4949:
      if (charat(Kt, uo + 1) !== 115) break;
    case 6444:
      switch (charat(Kt, strlen(Kt) - 3 - (~indexof(Kt, "!important") && 10))) {
        case 107:
          return replace(Kt, ":", ":" + WEBKIT) + Kt;
        case 101:
          return replace(Kt, /(.+:)([^;!]+)(;|!.+)?/, "$1" + WEBKIT + (charat(Kt, 14) === 45 ? "inline-" : "") + "box$3$1" + WEBKIT + "$2$3$1" + MS + "$2box$3") + Kt;
      }
      break;
    case 5936:
      switch (charat(Kt, uo + 11)) {
        case 114:
          return WEBKIT + Kt + MS + replace(Kt, /[svh]\w+-[tblr]{2}/, "tb") + Kt;
        case 108:
          return WEBKIT + Kt + MS + replace(Kt, /[svh]\w+-[tblr]{2}/, "tb-rl") + Kt;
        case 45:
          return WEBKIT + Kt + MS + replace(Kt, /[svh]\w+-[tblr]{2}/, "lr") + Kt;
      }
      return WEBKIT + Kt + MS + Kt + Kt;
  }
  return Kt;
}
var prefixer = function(uo, ho, go, bo) {
  if (uo.length > -1 && !uo.return) switch (uo.type) {
    case DECLARATION:
      uo.return = prefix$1(uo.value, uo.length);
      break;
    case KEYFRAMES:
      return serialize([copy$2(uo, {
        value: replace(uo.value, "@", "@" + WEBKIT)
      })], bo);
    case RULESET:
      if (uo.length) return combine(uo.props, function(vo) {
        switch (match(vo, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return serialize([copy$2(uo, {
              props: [replace(vo, /:(read-\w+)/, ":" + MOZ + "$1")]
            })], bo);
          case "::placeholder":
            return serialize([copy$2(uo, {
              props: [replace(vo, /:(plac\w+)/, ":" + WEBKIT + "input-$1")]
            }), copy$2(uo, {
              props: [replace(vo, /:(plac\w+)/, ":" + MOZ + "$1")]
            }), copy$2(uo, {
              props: [replace(vo, /:(plac\w+)/, MS + "input-$1")]
            })], bo);
        }
        return "";
      });
  }
}, defaultStylisPlugins = [prefixer], createCache = function(uo) {
  var ho = uo.key;
  if (ho === "css") {
    var go = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(go, function(Oo) {
      var jo = Oo.getAttribute("data-emotion");
      jo.indexOf(" ") !== -1 && (document.head.appendChild(Oo), Oo.setAttribute("data-s", ""));
    });
  }
  var bo = uo.stylisPlugins || defaultStylisPlugins, vo = {}, Po, Co = [];
  Po = uo.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + ho + ' "]'),
    function(Oo) {
      for (var jo = Oo.getAttribute("data-emotion").split(" "), Do = 1; Do < jo.length; Do++)
        vo[jo[Do]] = !0;
      Co.push(Oo);
    }
  );
  var So, wo = [compat, removeLabel];
  {
    var Eo, Ro = [stringify, rulesheet(function(Oo) {
      Eo.insert(Oo);
    })], _o = middleware(wo.concat(bo, Ro)), Io = function(jo) {
      return serialize(compile(jo), _o);
    };
    So = function(jo, Do, Lo, ko) {
      Eo = Lo, Io(jo ? jo + "{" + Do.styles + "}" : Do.styles), ko && (Ao.inserted[Do.name] = !0);
    };
  }
  var Ao = {
    key: ho,
    sheet: new StyleSheet({
      key: ho,
      container: Po,
      nonce: uo.nonce,
      speedy: uo.speedy,
      prepend: uo.prepend,
      insertionPoint: uo.insertionPoint
    }),
    nonce: uo.nonce,
    inserted: vo,
    registered: {},
    insert: So
  };
  return Ao.sheet.hydrate(Co), Ao;
}, reactIs$2 = requireReactIs(), FORWARD_REF_STATICS = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MEMO_STATICS = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, TYPE_STATICS = {};
TYPE_STATICS[reactIs$2.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$2.Memo] = MEMO_STATICS;
var isBrowser = !0;
function getRegisteredStyles(Kt, uo, ho) {
  var go = "";
  return ho.split(" ").forEach(function(bo) {
    Kt[bo] !== void 0 ? uo.push(Kt[bo] + ";") : bo && (go += bo + " ");
  }), go;
}
var registerStyles = function(uo, ho, go) {
  var bo = uo.key + "-" + ho.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (go === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser === !1) && uo.registered[bo] === void 0 && (uo.registered[bo] = ho.styles);
}, insertStyles = function(uo, ho, go) {
  registerStyles(uo, ho, go);
  var bo = uo.key + "-" + ho.name;
  if (uo.inserted[ho.name] === void 0) {
    var vo = ho;
    do
      uo.insert(ho === vo ? "." + bo : "", vo, uo.sheet, !0), vo = vo.next;
    while (vo !== void 0);
  }
};
function murmur2(Kt) {
  for (var uo = 0, ho, go = 0, bo = Kt.length; bo >= 4; ++go, bo -= 4)
    ho = Kt.charCodeAt(go) & 255 | (Kt.charCodeAt(++go) & 255) << 8 | (Kt.charCodeAt(++go) & 255) << 16 | (Kt.charCodeAt(++go) & 255) << 24, ho = /* Math.imul(k, m): */
    (ho & 65535) * 1540483477 + ((ho >>> 16) * 59797 << 16), ho ^= /* k >>> r: */
    ho >>> 24, uo = /* Math.imul(k, m): */
    (ho & 65535) * 1540483477 + ((ho >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (uo & 65535) * 1540483477 + ((uo >>> 16) * 59797 << 16);
  switch (bo) {
    case 3:
      uo ^= (Kt.charCodeAt(go + 2) & 255) << 16;
    case 2:
      uo ^= (Kt.charCodeAt(go + 1) & 255) << 8;
    case 1:
      uo ^= Kt.charCodeAt(go) & 255, uo = /* Math.imul(h, m): */
      (uo & 65535) * 1540483477 + ((uo >>> 16) * 59797 << 16);
  }
  return uo ^= uo >>> 13, uo = /* Math.imul(h, m): */
  (uo & 65535) * 1540483477 + ((uo >>> 16) * 59797 << 16), ((uo ^ uo >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, hyphenateRegex = /[A-Z]|^ms/g, animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g, isCustomProperty = function(uo) {
  return uo.charCodeAt(1) === 45;
}, isProcessableValue = function(uo) {
  return uo != null && typeof uo != "boolean";
}, processStyleName = /* @__PURE__ */ memoize$5(function(Kt) {
  return isCustomProperty(Kt) ? Kt : Kt.replace(hyphenateRegex, "-$&").toLowerCase();
}), processStyleValue = function(uo, ho) {
  switch (uo) {
    case "animation":
    case "animationName":
      if (typeof ho == "string")
        return ho.replace(animationRegex, function(go, bo, vo) {
          return cursor = {
            name: bo,
            styles: vo,
            next: cursor
          }, bo;
        });
  }
  return unitlessKeys[uo] !== 1 && !isCustomProperty(uo) && typeof ho == "number" && ho !== 0 ? ho + "px" : ho;
};
function handleInterpolation(Kt, uo, ho) {
  if (ho == null)
    return "";
  var go = ho;
  if (go.__emotion_styles !== void 0)
    return go;
  switch (typeof ho) {
    case "boolean":
      return "";
    case "object": {
      var bo = ho;
      if (bo.anim === 1)
        return cursor = {
          name: bo.name,
          styles: bo.styles,
          next: cursor
        }, bo.name;
      var vo = ho;
      if (vo.styles !== void 0) {
        var Po = vo.next;
        if (Po !== void 0)
          for (; Po !== void 0; )
            cursor = {
              name: Po.name,
              styles: Po.styles,
              next: cursor
            }, Po = Po.next;
        var Co = vo.styles + ";";
        return Co;
      }
      return createStringFromObject(Kt, uo, ho);
    }
    case "function": {
      if (Kt !== void 0) {
        var So = cursor, wo = ho(Kt);
        return cursor = So, handleInterpolation(Kt, uo, wo);
      }
      break;
    }
  }
  var Eo = ho;
  if (uo == null)
    return Eo;
  var Ro = uo[Eo];
  return Ro !== void 0 ? Ro : Eo;
}
function createStringFromObject(Kt, uo, ho) {
  var go = "";
  if (Array.isArray(ho))
    for (var bo = 0; bo < ho.length; bo++)
      go += handleInterpolation(Kt, uo, ho[bo]) + ";";
  else
    for (var vo in ho) {
      var Po = ho[vo];
      if (typeof Po != "object") {
        var Co = Po;
        uo != null && uo[Co] !== void 0 ? go += vo + "{" + uo[Co] + "}" : isProcessableValue(Co) && (go += processStyleName(vo) + ":" + processStyleValue(vo, Co) + ";");
      } else if (Array.isArray(Po) && typeof Po[0] == "string" && (uo == null || uo[Po[0]] === void 0))
        for (var So = 0; So < Po.length; So++)
          isProcessableValue(Po[So]) && (go += processStyleName(vo) + ":" + processStyleValue(vo, Po[So]) + ";");
      else {
        var wo = handleInterpolation(Kt, uo, Po);
        switch (vo) {
          case "animation":
          case "animationName": {
            go += processStyleName(vo) + ":" + wo + ";";
            break;
          }
          default:
            go += vo + "{" + wo + "}";
        }
      }
    }
  return go;
}
var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g, cursor;
function serializeStyles(Kt, uo, ho) {
  if (Kt.length === 1 && typeof Kt[0] == "object" && Kt[0] !== null && Kt[0].styles !== void 0)
    return Kt[0];
  var go = !0, bo = "";
  cursor = void 0;
  var vo = Kt[0];
  if (vo == null || vo.raw === void 0)
    go = !1, bo += handleInterpolation(ho, uo, vo);
  else {
    var Po = vo;
    bo += Po[0];
  }
  for (var Co = 1; Co < Kt.length; Co++)
    if (bo += handleInterpolation(ho, uo, Kt[Co]), go) {
      var So = vo;
      bo += So[Co];
    }
  labelPattern.lastIndex = 0;
  for (var wo = "", Eo; (Eo = labelPattern.exec(bo)) !== null; )
    wo += "-" + Eo[1];
  var Ro = murmur2(bo) + wo;
  return {
    name: Ro,
    styles: bo,
    next: cursor
  };
}
var syncFallback = function(uo) {
  return uo();
}, useInsertionEffect = React$1.useInsertionEffect ? React$1.useInsertionEffect : !1, useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback, useInsertionEffectWithLayoutFallback = useInsertionEffect || React$1.useLayoutEffect, isDevelopment = !1, EmotionCacheContext = /* @__PURE__ */ React$1.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ createCache({
    key: "css"
  }) : null
);
EmotionCacheContext.Provider;
var withEmotionCache = function(uo) {
  return /* @__PURE__ */ forwardRef$1(function(ho, go) {
    var bo = useContext(EmotionCacheContext);
    return uo(ho, bo, go);
  });
}, ThemeContext = /* @__PURE__ */ React$1.createContext({}), hasOwn$2 = {}.hasOwnProperty, typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", createEmotionProps = function(uo, ho) {
  var go = {};
  for (var bo in ho)
    hasOwn$2.call(ho, bo) && (go[bo] = ho[bo]);
  return go[typePropName] = uo, go;
}, Insertion$1 = function(uo) {
  var ho = uo.cache, go = uo.serialized, bo = uo.isStringTag;
  return registerStyles(ho, go, bo), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(ho, go, bo);
  }), null;
}, Emotion = /* @__PURE__ */ withEmotionCache(function(Kt, uo, ho) {
  var go = Kt.css;
  typeof go == "string" && uo.registered[go] !== void 0 && (go = uo.registered[go]);
  var bo = Kt[typePropName], vo = [go], Po = "";
  typeof Kt.className == "string" ? Po = getRegisteredStyles(uo.registered, vo, Kt.className) : Kt.className != null && (Po = Kt.className + " ");
  var Co = serializeStyles(vo, void 0, React$1.useContext(ThemeContext));
  Po += uo.key + "-" + Co.name;
  var So = {};
  for (var wo in Kt)
    hasOwn$2.call(Kt, wo) && wo !== "css" && wo !== typePropName && !isDevelopment && (So[wo] = Kt[wo]);
  return So.className = Po, ho && (So.ref = ho), /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, /* @__PURE__ */ React$1.createElement(Insertion$1, {
    cache: uo,
    serialized: Co,
    isStringTag: typeof bo == "string"
  }), /* @__PURE__ */ React$1.createElement(bo, So));
}), Emotion$1 = Emotion, jsx = function(uo, ho) {
  var go = arguments;
  if (ho == null || !hasOwn$2.call(ho, "css"))
    return React$1.createElement.apply(void 0, go);
  var bo = go.length, vo = new Array(bo);
  vo[0] = Emotion$1, vo[1] = createEmotionProps(uo, ho);
  for (var Po = 2; Po < bo; Po++)
    vo[Po] = go[Po];
  return React$1.createElement.apply(null, vo);
};
(function(Kt) {
  var uo;
  uo || (uo = Kt.JSX || (Kt.JSX = {}));
})(jsx);
var Global$1 = /* @__PURE__ */ withEmotionCache(function(Kt, uo) {
  var ho = Kt.styles, go = serializeStyles([ho], void 0, React$1.useContext(ThemeContext)), bo = React$1.useRef();
  return useInsertionEffectWithLayoutFallback(function() {
    var vo = uo.key + "-global", Po = new uo.sheet.constructor({
      key: vo,
      nonce: uo.sheet.nonce,
      container: uo.sheet.container,
      speedy: uo.sheet.isSpeedy
    }), Co = !1, So = document.querySelector('style[data-emotion="' + vo + " " + go.name + '"]');
    return uo.sheet.tags.length && (Po.before = uo.sheet.tags[0]), So !== null && (Co = !0, So.setAttribute("data-emotion", vo), Po.hydrate([So])), bo.current = [Po, Co], function() {
      Po.flush();
    };
  }, [uo]), useInsertionEffectWithLayoutFallback(function() {
    var vo = bo.current, Po = vo[0], Co = vo[1];
    if (Co) {
      vo[1] = !1;
      return;
    }
    if (go.next !== void 0 && insertStyles(uo, go.next, !0), Po.tags.length) {
      var So = Po.tags[Po.tags.length - 1].nextElementSibling;
      Po.before = So, Po.flush();
    }
    uo.insert("", go, Po, !1);
  }, [uo, go.name]), null;
});
function css() {
  for (var Kt = arguments.length, uo = new Array(Kt), ho = 0; ho < Kt; ho++)
    uo[ho] = arguments[ho];
  return serializeStyles(uo);
}
function keyframes() {
  var Kt = css.apply(void 0, arguments), uo = "animation-" + Kt.name;
  return {
    name: uo,
    styles: "@keyframes " + uo + "{" + Kt.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, isPropValid = /* @__PURE__ */ memoize$5(
  function(Kt) {
    return reactPropsRegex.test(Kt) || Kt.charCodeAt(0) === 111 && Kt.charCodeAt(1) === 110 && Kt.charCodeAt(2) < 91;
  }
  /* Z+1 */
), testOmitPropsOnStringTag = isPropValid, testOmitPropsOnComponent = function(uo) {
  return uo !== "theme";
}, getDefaultShouldForwardProp = function(uo) {
  return typeof uo == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  uo.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
}, composeShouldForwardProps = function(uo, ho, go) {
  var bo;
  if (ho) {
    var vo = ho.shouldForwardProp;
    bo = uo.__emotion_forwardProp && vo ? function(Po) {
      return uo.__emotion_forwardProp(Po) && vo(Po);
    } : vo;
  }
  return typeof bo != "function" && go && (bo = uo.__emotion_forwardProp), bo;
}, Insertion = function(uo) {
  var ho = uo.cache, go = uo.serialized, bo = uo.isStringTag;
  return registerStyles(ho, go, bo), useInsertionEffectAlwaysWithSyncFallback(function() {
    return insertStyles(ho, go, bo);
  }), null;
}, createStyled$1 = function Kt(uo, ho) {
  var go = uo.__emotion_real === uo, bo = go && uo.__emotion_base || uo, vo, Po;
  ho !== void 0 && (vo = ho.label, Po = ho.target);
  var Co = composeShouldForwardProps(uo, ho, go), So = Co || getDefaultShouldForwardProp(bo), wo = !So("as");
  return function() {
    var Eo = arguments, Ro = go && uo.__emotion_styles !== void 0 ? uo.__emotion_styles.slice(0) : [];
    if (vo !== void 0 && Ro.push("label:" + vo + ";"), Eo[0] == null || Eo[0].raw === void 0)
      Ro.push.apply(Ro, Eo);
    else {
      var _o = Eo[0];
      Ro.push(_o[0]);
      for (var Io = Eo.length, Ao = 1; Ao < Io; Ao++)
        Ro.push(Eo[Ao], _o[Ao]);
    }
    var Oo = withEmotionCache(function(jo, Do, Lo) {
      var ko = wo && jo.as || bo, Ko = "", No = [], Jo = jo;
      if (jo.theme == null) {
        Jo = {};
        for (var ti in jo)
          Jo[ti] = jo[ti];
        Jo.theme = React$1.useContext(ThemeContext);
      }
      typeof jo.className == "string" ? Ko = getRegisteredStyles(Do.registered, No, jo.className) : jo.className != null && (Ko = jo.className + " ");
      var oi = serializeStyles(Ro.concat(No), Do.registered, Jo);
      Ko += Do.key + "-" + oi.name, Po !== void 0 && (Ko += " " + Po);
      var Qo = wo && Co === void 0 ? getDefaultShouldForwardProp(ko) : So, Zo = {};
      for (var ei in jo)
        wo && ei === "as" || Qo(ei) && (Zo[ei] = jo[ei]);
      return Zo.className = Ko, Lo && (Zo.ref = Lo), /* @__PURE__ */ React$1.createElement(React$1.Fragment, null, /* @__PURE__ */ React$1.createElement(Insertion, {
        cache: Do,
        serialized: oi,
        isStringTag: typeof ko == "string"
      }), /* @__PURE__ */ React$1.createElement(ko, Zo));
    });
    return Oo.displayName = vo !== void 0 ? vo : "Styled(" + (typeof bo == "string" ? bo : bo.displayName || bo.name || "Component") + ")", Oo.defaultProps = uo.defaultProps, Oo.__emotion_real = Oo, Oo.__emotion_base = bo, Oo.__emotion_styles = Ro, Oo.__emotion_forwardProp = Co, Object.defineProperty(Oo, "toString", {
      value: function() {
        return "." + Po;
      }
    }), Oo.withComponent = function(jo, Do) {
      var Lo = Kt(jo, _extends$q({}, ho, Do, {
        shouldForwardProp: composeShouldForwardProps(Oo, Do, !0)
      }));
      return Lo.apply(void 0, Ro);
    }, Oo;
  };
}, tags = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], newStyled = createStyled$1.bind(null);
tags.forEach(function(Kt) {
  newStyled[Kt] = newStyled(Kt);
});
function isEmpty$2(Kt) {
  return Kt == null || Object.keys(Kt).length === 0;
}
function GlobalStyles$2(Kt) {
  const {
    styles: uo,
    defaultTheme: ho = {}
  } = Kt, go = typeof uo == "function" ? (bo) => uo(isEmpty$2(bo) ? ho : bo) : uo;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Global$1, {
    styles: go
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles$2.propTypes = {
  defaultTheme: PropTypes.object,
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object, PropTypes.func])
});
/**
 * @mui/styled-engine v6.3.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$2(Kt, uo) {
  const ho = newStyled(Kt, uo);
  return process.env.NODE_ENV !== "production" ? (...go) => {
    const bo = typeof Kt == "string" ? `"${Kt}"` : "component";
    return go.length === 0 ? console.error([`MUI: Seems like you called \`styled(${bo})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : go.some((vo) => vo === void 0) && console.error(`MUI: the styled(${bo})(...args) API requires all its args to be defined.`), ho(...go);
  } : ho;
}
function internal_mutateStyles(Kt, uo) {
  Array.isArray(Kt.__emotion_styles) && (Kt.__emotion_styles = uo(Kt.__emotion_styles));
}
const wrapper = [];
function internal_serializeStyles(Kt) {
  return wrapper[0] = Kt, serializeStyles(wrapper);
}
const sortBreakpointsValues = (Kt) => {
  const uo = Object.keys(Kt).map((ho) => ({
    key: ho,
    val: Kt[ho]
  })) || [];
  return uo.sort((ho, go) => ho.val - go.val), uo.reduce((ho, go) => ({
    ...ho,
    [go.key]: go.val
  }), {});
};
function createBreakpoints(Kt) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: uo = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: ho = "px",
    step: go = 5,
    ...bo
  } = Kt, vo = sortBreakpointsValues(uo), Po = Object.keys(vo);
  function Co(_o) {
    return `@media (min-width:${typeof uo[_o] == "number" ? uo[_o] : _o}${ho})`;
  }
  function So(_o) {
    return `@media (max-width:${(typeof uo[_o] == "number" ? uo[_o] : _o) - go / 100}${ho})`;
  }
  function wo(_o, Io) {
    const Ao = Po.indexOf(Io);
    return `@media (min-width:${typeof uo[_o] == "number" ? uo[_o] : _o}${ho}) and (max-width:${(Ao !== -1 && typeof uo[Po[Ao]] == "number" ? uo[Po[Ao]] : Io) - go / 100}${ho})`;
  }
  function Eo(_o) {
    return Po.indexOf(_o) + 1 < Po.length ? wo(_o, Po[Po.indexOf(_o) + 1]) : Co(_o);
  }
  function Ro(_o) {
    const Io = Po.indexOf(_o);
    return Io === 0 ? Co(Po[1]) : Io === Po.length - 1 ? So(Po[Io]) : wo(_o, Po[Po.indexOf(_o) + 1]).replace("@media", "@media not all and");
  }
  return {
    keys: Po,
    values: vo,
    up: Co,
    down: So,
    between: wo,
    only: Eo,
    not: Ro,
    unit: ho,
    ...bo
  };
}
function sortContainerQueries(Kt, uo) {
  if (!Kt.containerQueries)
    return uo;
  const ho = Object.keys(uo).filter((go) => go.startsWith("@container")).sort((go, bo) => {
    var Po, Co;
    const vo = /min-width:\s*([0-9.]+)/;
    return +(((Po = go.match(vo)) == null ? void 0 : Po[1]) || 0) - +(((Co = bo.match(vo)) == null ? void 0 : Co[1]) || 0);
  });
  return ho.length ? ho.reduce((go, bo) => {
    const vo = uo[bo];
    return delete go[bo], go[bo] = vo, go;
  }, {
    ...uo
  }) : uo;
}
function isCqShorthand(Kt, uo) {
  return uo === "@" || uo.startsWith("@") && (Kt.some((ho) => uo.startsWith(`@${ho}`)) || !!uo.match(/^@\d/));
}
function getContainerQuery(Kt, uo) {
  const ho = uo.match(/^@([^/]+)?\/?(.+)?$/);
  if (!ho) {
    if (process.env.NODE_ENV !== "production")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The provided shorthand ${`(${uo})`} is invalid. The format should be \`@<breakpoint | number>\` or \`@<breakpoint | number>/<container>\`.
For example, \`@sm\` or \`@600\` or \`@40rem/sidebar\`.` : formatMuiErrorMessage(18, `(${uo})`));
    return null;
  }
  const [, go, bo] = ho, vo = Number.isNaN(+go) ? go || 0 : +go;
  return Kt.containerQueries(bo).up(vo);
}
function cssContainerQueries(Kt) {
  const uo = (vo, Po) => vo.replace("@media", Po ? `@container ${Po}` : "@container");
  function ho(vo, Po) {
    vo.up = (...Co) => uo(Kt.breakpoints.up(...Co), Po), vo.down = (...Co) => uo(Kt.breakpoints.down(...Co), Po), vo.between = (...Co) => uo(Kt.breakpoints.between(...Co), Po), vo.only = (...Co) => uo(Kt.breakpoints.only(...Co), Po), vo.not = (...Co) => {
      const So = uo(Kt.breakpoints.not(...Co), Po);
      return So.includes("not all and") ? So.replace("not all and ", "").replace("min-width:", "width<").replace("max-width:", "width>").replace("and", "or") : So;
    };
  }
  const go = {}, bo = (vo) => (ho(go, vo), go);
  return ho(bo), {
    ...Kt,
    containerQueries: bo
  };
}
const shape = {
  borderRadius: 4
}, responsivePropType = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
function merge(Kt, uo) {
  return uo ? deepmerge(Kt, uo, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : Kt;
}
const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (Kt) => `@media (min-width:${values$1[Kt]}px)`
}, defaultContainerQueries = {
  containerQueries: (Kt) => ({
    up: (uo) => {
      let ho = typeof uo == "number" ? uo : values$1[uo] || uo;
      return typeof ho == "number" && (ho = `${ho}px`), Kt ? `@container ${Kt} (min-width:${ho})` : `@container (min-width:${ho})`;
    }
  })
};
function handleBreakpoints(Kt, uo, ho) {
  const go = Kt.theme || {};
  if (Array.isArray(uo)) {
    const vo = go.breakpoints || defaultBreakpoints;
    return uo.reduce((Po, Co, So) => (Po[vo.up(vo.keys[So])] = ho(uo[So]), Po), {});
  }
  if (typeof uo == "object") {
    const vo = go.breakpoints || defaultBreakpoints;
    return Object.keys(uo).reduce((Po, Co) => {
      if (isCqShorthand(vo.keys, Co)) {
        const So = getContainerQuery(go.containerQueries ? go : defaultContainerQueries, Co);
        So && (Po[So] = ho(uo[Co], Co));
      } else if (Object.keys(vo.values || values$1).includes(Co)) {
        const So = vo.up(Co);
        Po[So] = ho(uo[Co], Co);
      } else {
        const So = Co;
        Po[So] = uo[So];
      }
      return Po;
    }, {});
  }
  return ho(uo);
}
function createEmptyBreakpointObject(Kt = {}) {
  var ho;
  return ((ho = Kt.keys) == null ? void 0 : ho.reduce((go, bo) => {
    const vo = Kt.up(bo);
    return go[vo] = {}, go;
  }, {})) || {};
}
function removeUnusedBreakpoints(Kt, uo) {
  return Kt.reduce((ho, go) => {
    const bo = ho[go];
    return (!bo || Object.keys(bo).length === 0) && delete ho[go], ho;
  }, uo);
}
function getPath$2(Kt, uo, ho = !0) {
  if (!uo || typeof uo != "string")
    return null;
  if (Kt && Kt.vars && ho) {
    const go = `vars.${uo}`.split(".").reduce((bo, vo) => bo && bo[vo] ? bo[vo] : null, Kt);
    if (go != null)
      return go;
  }
  return uo.split(".").reduce((go, bo) => go && go[bo] != null ? go[bo] : null, Kt);
}
function getStyleValue$1(Kt, uo, ho, go = ho) {
  let bo;
  return typeof Kt == "function" ? bo = Kt(ho) : Array.isArray(Kt) ? bo = Kt[ho] || go : bo = getPath$2(Kt, ho) || go, uo && (bo = uo(bo, go, Kt)), bo;
}
function style$1(Kt) {
  const {
    prop: uo,
    cssProperty: ho = Kt.prop,
    themeKey: go,
    transform: bo
  } = Kt, vo = (Po) => {
    if (Po[uo] == null)
      return null;
    const Co = Po[uo], So = Po.theme, wo = getPath$2(So, go) || {};
    return handleBreakpoints(Po, Co, (Ro) => {
      let _o = getStyleValue$1(wo, bo, Ro);
      return Ro === _o && typeof Ro == "string" && (_o = getStyleValue$1(wo, bo, `${uo}${Ro === "default" ? "" : capitalize(Ro)}`, Ro)), ho === !1 ? _o : {
        [ho]: _o
      };
    });
  };
  return vo.propTypes = process.env.NODE_ENV !== "production" ? {
    [uo]: responsivePropType
  } : {}, vo.filterProps = [uo], vo;
}
function memoize$4(Kt) {
  const uo = {};
  return (ho) => (uo[ho] === void 0 && (uo[ho] = Kt(ho)), uo[ho]);
}
const properties = {
  m: "margin",
  p: "padding"
}, directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, getCssProperties = memoize$4((Kt) => {
  if (Kt.length > 2)
    if (aliases[Kt])
      Kt = aliases[Kt];
    else
      return [Kt];
  const [uo, ho] = Kt.split(""), go = properties[uo], bo = directions[ho] || "";
  return Array.isArray(bo) ? bo.map((vo) => go + vo) : [go + bo];
}), marginKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], paddingKeys = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(Kt, uo, ho, go) {
  const bo = getPath$2(Kt, uo, !0) ?? ho;
  return typeof bo == "number" || typeof bo == "string" ? (vo) => typeof vo == "string" ? vo : (process.env.NODE_ENV !== "production" && typeof vo != "number" && console.error(`MUI: Expected ${go} argument to be a number or a string, got ${vo}.`), typeof bo == "string" ? `calc(${vo} * ${bo})` : bo * vo) : Array.isArray(bo) ? (vo) => {
    if (typeof vo == "string")
      return vo;
    const Po = Math.abs(vo);
    process.env.NODE_ENV !== "production" && (Number.isInteger(Po) ? Po > bo.length - 1 && console.error([`MUI: The value provided (${Po}) overflows.`, `The supported values are: ${JSON.stringify(bo)}.`, `${Po} > ${bo.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${uo}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${uo}\` as a number.`].join(`
`)));
    const Co = bo[Po];
    return vo >= 0 ? Co : typeof Co == "number" ? -Co : `-${Co}`;
  } : typeof bo == "function" ? bo : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${uo}\` value (${bo}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function createUnarySpacing(Kt) {
  return createUnaryUnit(Kt, "spacing", 8, "spacing");
}
function getValue$2(Kt, uo) {
  return typeof uo == "string" || uo == null ? uo : Kt(uo);
}
function getStyleFromPropValue(Kt, uo) {
  return (ho) => Kt.reduce((go, bo) => (go[bo] = getValue$2(uo, ho), go), {});
}
function resolveCssProperty(Kt, uo, ho, go) {
  if (!uo.includes(ho))
    return null;
  const bo = getCssProperties(ho), vo = getStyleFromPropValue(bo, go), Po = Kt[ho];
  return handleBreakpoints(Kt, Po, vo);
}
function style(Kt, uo) {
  const ho = createUnarySpacing(Kt.theme);
  return Object.keys(Kt).map((go) => resolveCssProperty(Kt, uo, go, ho)).reduce(merge, {});
}
function margin(Kt) {
  return style(Kt, marginKeys);
}
margin.propTypes = process.env.NODE_ENV !== "production" ? marginKeys.reduce((Kt, uo) => (Kt[uo] = responsivePropType, Kt), {}) : {};
margin.filterProps = marginKeys;
function padding(Kt) {
  return style(Kt, paddingKeys);
}
padding.propTypes = process.env.NODE_ENV !== "production" ? paddingKeys.reduce((Kt, uo) => (Kt[uo] = responsivePropType, Kt), {}) : {};
padding.filterProps = paddingKeys;
process.env.NODE_ENV !== "production" && spacingKeys.reduce((Kt, uo) => (Kt[uo] = responsivePropType, Kt), {});
function createSpacing(Kt = 8, uo = createUnarySpacing({
  spacing: Kt
})) {
  if (Kt.mui)
    return Kt;
  const ho = (...go) => (process.env.NODE_ENV !== "production" && (go.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${go.length}`)), (go.length === 0 ? [1] : go).map((vo) => {
    const Po = uo(vo);
    return typeof Po == "number" ? `${Po}px` : Po;
  }).join(" "));
  return ho.mui = !0, ho;
}
function compose$1(...Kt) {
  const uo = Kt.reduce((go, bo) => (bo.filterProps.forEach((vo) => {
    go[vo] = bo;
  }), go), {}), ho = (go) => Object.keys(go).reduce((bo, vo) => uo[vo] ? merge(bo, uo[vo](go)) : bo, {});
  return ho.propTypes = process.env.NODE_ENV !== "production" ? Kt.reduce((go, bo) => Object.assign(go, bo.propTypes), {}) : {}, ho.filterProps = Kt.reduce((go, bo) => go.concat(bo.filterProps), []), ho;
}
function borderTransform(Kt) {
  return typeof Kt != "number" ? Kt : `${Kt}px solid`;
}
function createBorderStyle(Kt, uo) {
  return style$1({
    prop: Kt,
    themeKey: "borders",
    transform: uo
  });
}
const border = createBorderStyle("border", borderTransform), borderTop = createBorderStyle("borderTop", borderTransform), borderRight = createBorderStyle("borderRight", borderTransform), borderBottom = createBorderStyle("borderBottom", borderTransform), borderLeft = createBorderStyle("borderLeft", borderTransform), borderColor = createBorderStyle("borderColor"), borderTopColor = createBorderStyle("borderTopColor"), borderRightColor = createBorderStyle("borderRightColor"), borderBottomColor = createBorderStyle("borderBottomColor"), borderLeftColor = createBorderStyle("borderLeftColor"), outline = createBorderStyle("outline", borderTransform), outlineColor = createBorderStyle("outlineColor"), borderRadius = (Kt) => {
  if (Kt.borderRadius !== void 0 && Kt.borderRadius !== null) {
    const uo = createUnaryUnit(Kt.theme, "shape.borderRadius", 4, "borderRadius"), ho = (go) => ({
      borderRadius: getValue$2(uo, go)
    });
    return handleBreakpoints(Kt, Kt.borderRadius, ho);
  }
  return null;
};
borderRadius.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: responsivePropType
} : {};
borderRadius.filterProps = ["borderRadius"];
compose$1(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius, outline, outlineColor);
const gap = (Kt) => {
  if (Kt.gap !== void 0 && Kt.gap !== null) {
    const uo = createUnaryUnit(Kt.theme, "spacing", 8, "gap"), ho = (go) => ({
      gap: getValue$2(uo, go)
    });
    return handleBreakpoints(Kt, Kt.gap, ho);
  }
  return null;
};
gap.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: responsivePropType
} : {};
gap.filterProps = ["gap"];
const columnGap = (Kt) => {
  if (Kt.columnGap !== void 0 && Kt.columnGap !== null) {
    const uo = createUnaryUnit(Kt.theme, "spacing", 8, "columnGap"), ho = (go) => ({
      columnGap: getValue$2(uo, go)
    });
    return handleBreakpoints(Kt, Kt.columnGap, ho);
  }
  return null;
};
columnGap.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: responsivePropType
} : {};
columnGap.filterProps = ["columnGap"];
const rowGap = (Kt) => {
  if (Kt.rowGap !== void 0 && Kt.rowGap !== null) {
    const uo = createUnaryUnit(Kt.theme, "spacing", 8, "rowGap"), ho = (go) => ({
      rowGap: getValue$2(uo, go)
    });
    return handleBreakpoints(Kt, Kt.rowGap, ho);
  }
  return null;
};
rowGap.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: responsivePropType
} : {};
rowGap.filterProps = ["rowGap"];
const gridColumn = style$1({
  prop: "gridColumn"
}), gridRow = style$1({
  prop: "gridRow"
}), gridAutoFlow = style$1({
  prop: "gridAutoFlow"
}), gridAutoColumns = style$1({
  prop: "gridAutoColumns"
}), gridAutoRows = style$1({
  prop: "gridAutoRows"
}), gridTemplateColumns = style$1({
  prop: "gridTemplateColumns"
}), gridTemplateRows = style$1({
  prop: "gridTemplateRows"
}), gridTemplateAreas = style$1({
  prop: "gridTemplateAreas"
}), gridArea = style$1({
  prop: "gridArea"
});
compose$1(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
function paletteTransform(Kt, uo) {
  return uo === "grey" ? uo : Kt;
}
const color$1 = style$1({
  prop: "color",
  themeKey: "palette",
  transform: paletteTransform
}), bgcolor = style$1({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
}), backgroundColor = style$1({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: paletteTransform
});
compose$1(color$1, bgcolor, backgroundColor);
function sizingTransform(Kt) {
  return Kt <= 1 && Kt !== 0 ? `${Kt * 100}%` : Kt;
}
const width = style$1({
  prop: "width",
  transform: sizingTransform
}), maxWidth = (Kt) => {
  if (Kt.maxWidth !== void 0 && Kt.maxWidth !== null) {
    const uo = (ho) => {
      var bo, vo, Po, Co, So;
      const go = ((Po = (vo = (bo = Kt.theme) == null ? void 0 : bo.breakpoints) == null ? void 0 : vo.values) == null ? void 0 : Po[ho]) || values$1[ho];
      return go ? ((So = (Co = Kt.theme) == null ? void 0 : Co.breakpoints) == null ? void 0 : So.unit) !== "px" ? {
        maxWidth: `${go}${Kt.theme.breakpoints.unit}`
      } : {
        maxWidth: go
      } : {
        maxWidth: sizingTransform(ho)
      };
    };
    return handleBreakpoints(Kt, Kt.maxWidth, uo);
  }
  return null;
};
maxWidth.filterProps = ["maxWidth"];
const minWidth = style$1({
  prop: "minWidth",
  transform: sizingTransform
}), height = style$1({
  prop: "height",
  transform: sizingTransform
}), maxHeight = style$1({
  prop: "maxHeight",
  transform: sizingTransform
}), minHeight = style$1({
  prop: "minHeight",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "width",
  transform: sizingTransform
});
style$1({
  prop: "size",
  cssProperty: "height",
  transform: sizingTransform
});
const boxSizing = style$1({
  prop: "boxSizing"
});
compose$1(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
const defaultSxConfig = {
  // borders
  border: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderTop: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderRight: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderBottom: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderLeft: {
    themeKey: "borders",
    transform: borderTransform
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: borderTransform
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: borderRadius
  },
  // palette
  color: {
    themeKey: "palette",
    transform: paletteTransform
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: paletteTransform
  },
  backgroundColor: {
    themeKey: "palette",
    transform: paletteTransform
  },
  // spacing
  p: {
    style: padding
  },
  pt: {
    style: padding
  },
  pr: {
    style: padding
  },
  pb: {
    style: padding
  },
  pl: {
    style: padding
  },
  px: {
    style: padding
  },
  py: {
    style: padding
  },
  padding: {
    style: padding
  },
  paddingTop: {
    style: padding
  },
  paddingRight: {
    style: padding
  },
  paddingBottom: {
    style: padding
  },
  paddingLeft: {
    style: padding
  },
  paddingX: {
    style: padding
  },
  paddingY: {
    style: padding
  },
  paddingInline: {
    style: padding
  },
  paddingInlineStart: {
    style: padding
  },
  paddingInlineEnd: {
    style: padding
  },
  paddingBlock: {
    style: padding
  },
  paddingBlockStart: {
    style: padding
  },
  paddingBlockEnd: {
    style: padding
  },
  m: {
    style: margin
  },
  mt: {
    style: margin
  },
  mr: {
    style: margin
  },
  mb: {
    style: margin
  },
  ml: {
    style: margin
  },
  mx: {
    style: margin
  },
  my: {
    style: margin
  },
  margin: {
    style: margin
  },
  marginTop: {
    style: margin
  },
  marginRight: {
    style: margin
  },
  marginBottom: {
    style: margin
  },
  marginLeft: {
    style: margin
  },
  marginX: {
    style: margin
  },
  marginY: {
    style: margin
  },
  marginInline: {
    style: margin
  },
  marginInlineStart: {
    style: margin
  },
  marginInlineEnd: {
    style: margin
  },
  marginBlock: {
    style: margin
  },
  marginBlockStart: {
    style: margin
  },
  marginBlockEnd: {
    style: margin
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (Kt) => ({
      "@media print": {
        display: Kt
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: gap
  },
  rowGap: {
    style: rowGap
  },
  columnGap: {
    style: columnGap
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: sizingTransform
  },
  maxWidth: {
    style: maxWidth
  },
  minWidth: {
    transform: sizingTransform
  },
  height: {
    transform: sizingTransform
  },
  maxHeight: {
    transform: sizingTransform
  },
  minHeight: {
    transform: sizingTransform
  },
  boxSizing: {},
  // typography
  font: {
    themeKey: "font"
  },
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function objectsHaveSameKeys(...Kt) {
  const uo = Kt.reduce((go, bo) => go.concat(Object.keys(bo)), []), ho = new Set(uo);
  return Kt.every((go) => ho.size === Object.keys(go).length);
}
function callIfFn(Kt, uo) {
  return typeof Kt == "function" ? Kt(uo) : Kt;
}
function unstable_createStyleFunctionSx() {
  function Kt(ho, go, bo, vo) {
    const Po = {
      [ho]: go,
      theme: bo
    }, Co = vo[ho];
    if (!Co)
      return {
        [ho]: go
      };
    const {
      cssProperty: So = ho,
      themeKey: wo,
      transform: Eo,
      style: Ro
    } = Co;
    if (go == null)
      return null;
    if (wo === "typography" && go === "inherit")
      return {
        [ho]: go
      };
    const _o = getPath$2(bo, wo) || {};
    return Ro ? Ro(Po) : handleBreakpoints(Po, go, (Ao) => {
      let Oo = getStyleValue$1(_o, Eo, Ao);
      return Ao === Oo && typeof Ao == "string" && (Oo = getStyleValue$1(_o, Eo, `${ho}${Ao === "default" ? "" : capitalize(Ao)}`, Ao)), So === !1 ? Oo : {
        [So]: Oo
      };
    });
  }
  function uo(ho) {
    const {
      sx: go,
      theme: bo = {}
    } = ho || {};
    if (!go)
      return null;
    const vo = bo.unstable_sxConfig ?? defaultSxConfig;
    function Po(Co) {
      let So = Co;
      if (typeof Co == "function")
        So = Co(bo);
      else if (typeof Co != "object")
        return Co;
      if (!So)
        return null;
      const wo = createEmptyBreakpointObject(bo.breakpoints), Eo = Object.keys(wo);
      let Ro = wo;
      return Object.keys(So).forEach((_o) => {
        const Io = callIfFn(So[_o], bo);
        if (Io != null)
          if (typeof Io == "object")
            if (vo[_o])
              Ro = merge(Ro, Kt(_o, Io, bo, vo));
            else {
              const Ao = handleBreakpoints({
                theme: bo
              }, Io, (Oo) => ({
                [_o]: Oo
              }));
              objectsHaveSameKeys(Ao, Io) ? Ro[_o] = uo({
                sx: Io,
                theme: bo
              }) : Ro = merge(Ro, Ao);
            }
          else
            Ro = merge(Ro, Kt(_o, Io, bo, vo));
      }), sortContainerQueries(bo, removeUnusedBreakpoints(Eo, Ro));
    }
    return Array.isArray(go) ? go.map(Po) : Po(go);
  }
  return uo;
}
const styleFunctionSx = unstable_createStyleFunctionSx();
styleFunctionSx.filterProps = ["sx"];
function applyStyles(Kt, uo) {
  var go;
  const ho = this;
  if (ho.vars) {
    if (!((go = ho.colorSchemes) != null && go[Kt]) || typeof ho.getColorSchemeSelector != "function")
      return {};
    let bo = ho.getColorSchemeSelector(Kt);
    return bo === "&" ? uo : ((bo.includes("data-") || bo.includes(".")) && (bo = `*:where(${bo.replace(/\s*&$/, "")}) &`), {
      [bo]: uo
    });
  }
  return ho.palette.mode === Kt ? uo : {};
}
function createTheme$1(Kt = {}, ...uo) {
  const {
    breakpoints: ho = {},
    palette: go = {},
    spacing: bo,
    shape: vo = {},
    ...Po
  } = Kt, Co = createBreakpoints(ho), So = createSpacing(bo);
  let wo = deepmerge({
    breakpoints: Co,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: {
      mode: "light",
      ...go
    },
    spacing: So,
    shape: {
      ...shape,
      ...vo
    }
  }, Po);
  return wo = cssContainerQueries(wo), wo.applyStyles = applyStyles, wo = uo.reduce((Eo, Ro) => deepmerge(Eo, Ro), wo), wo.unstable_sxConfig = {
    ...defaultSxConfig,
    ...Po == null ? void 0 : Po.unstable_sxConfig
  }, wo.unstable_sx = function(Ro) {
    return styleFunctionSx({
      sx: Ro,
      theme: this
    });
  }, wo;
}
function isObjectEmpty$1(Kt) {
  return Object.keys(Kt).length === 0;
}
function useTheme$2(Kt = null) {
  const uo = React$1.useContext(ThemeContext);
  return !uo || isObjectEmpty$1(uo) ? Kt : uo;
}
const systemDefaultTheme$1 = createTheme$1();
function useTheme$1(Kt = systemDefaultTheme$1) {
  return useTheme$2(Kt);
}
function GlobalStyles$1({
  styles: Kt,
  themeId: uo,
  defaultTheme: ho = {}
}) {
  const go = useTheme$1(ho), bo = typeof Kt == "function" ? Kt(uo && go[uo] || go) : Kt;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$2, {
    styles: bo
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: PropTypes.object,
  /**
   * @ignore
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool]),
  /**
   * @ignore
   */
  themeId: PropTypes.string
});
const splitProps = (Kt) => {
  var go;
  const uo = {
    systemProps: {},
    otherProps: {}
  }, ho = ((go = Kt == null ? void 0 : Kt.theme) == null ? void 0 : go.unstable_sxConfig) ?? defaultSxConfig;
  return Object.keys(Kt).forEach((bo) => {
    ho[bo] ? uo.systemProps[bo] = Kt[bo] : uo.otherProps[bo] = Kt[bo];
  }), uo;
};
function extendSxProp$1(Kt) {
  const {
    sx: uo,
    ...ho
  } = Kt, {
    systemProps: go,
    otherProps: bo
  } = splitProps(ho);
  let vo;
  return Array.isArray(uo) ? vo = [go, ...uo] : typeof uo == "function" ? vo = (...Po) => {
    const Co = uo(...Po);
    return isPlainObject$2(Co) ? {
      ...go,
      ...Co
    } : go;
  } : vo = {
    ...go,
    ...uo
  }, {
    ...bo,
    sx: vo
  };
}
function preprocessStyles(Kt) {
  const {
    variants: uo,
    ...ho
  } = Kt, go = {
    variants: uo,
    style: internal_serializeStyles(ho),
    isProcessed: !0
  };
  return go.style === ho || uo && uo.forEach((bo) => {
    typeof bo.style != "function" && (bo.style = internal_serializeStyles(bo.style));
  }), go;
}
const systemDefaultTheme = createTheme$1();
function shouldForwardProp(Kt) {
  return Kt !== "ownerState" && Kt !== "theme" && Kt !== "sx" && Kt !== "as";
}
function defaultOverridesResolver(Kt) {
  return Kt ? (uo, ho) => ho[Kt] : null;
}
function attachTheme(Kt, uo, ho) {
  Kt.theme = isObjectEmpty(Kt.theme) ? ho : Kt.theme[uo] || Kt.theme;
}
function processStyle(Kt, uo) {
  const ho = typeof uo == "function" ? uo(Kt) : uo;
  if (Array.isArray(ho))
    return ho.flatMap((go) => processStyle(Kt, go));
  if (Array.isArray(ho == null ? void 0 : ho.variants)) {
    let go;
    if (ho.isProcessed)
      go = ho.style;
    else {
      const {
        variants: bo,
        ...vo
      } = ho;
      go = vo;
    }
    return processStyleVariants(Kt, ho.variants, [go]);
  }
  return ho != null && ho.isProcessed ? ho.style : ho;
}
function processStyleVariants(Kt, uo, ho = []) {
  var bo;
  let go;
  e: for (let vo = 0; vo < uo.length; vo += 1) {
    const Po = uo[vo];
    if (typeof Po.props == "function") {
      if (go ?? (go = {
        ...Kt,
        ...Kt.ownerState,
        ownerState: Kt.ownerState
      }), !Po.props(go))
        continue;
    } else
      for (const Co in Po.props)
        if (Kt[Co] !== Po.props[Co] && ((bo = Kt.ownerState) == null ? void 0 : bo[Co]) !== Po.props[Co])
          continue e;
    typeof Po.style == "function" ? (go ?? (go = {
      ...Kt,
      ...Kt.ownerState,
      ownerState: Kt.ownerState
    }), ho.push(Po.style(go))) : ho.push(Po.style);
  }
  return ho;
}
function createStyled(Kt = {}) {
  const {
    themeId: uo,
    defaultTheme: ho = systemDefaultTheme,
    rootShouldForwardProp: go = shouldForwardProp,
    slotShouldForwardProp: bo = shouldForwardProp
  } = Kt;
  function vo(Co) {
    attachTheme(Co, uo, ho);
  }
  return (Co, So = {}) => {
    internal_mutateStyles(Co, (No) => No.filter((Jo) => Jo !== styleFunctionSx));
    const {
      name: wo,
      slot: Eo,
      skipVariantsResolver: Ro,
      skipSx: _o,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: Io = defaultOverridesResolver(lowercaseFirstLetter(Eo)),
      ...Ao
    } = So, Oo = Ro !== void 0 ? Ro : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      Eo && Eo !== "Root" && Eo !== "root" || !1
    ), jo = _o || !1;
    let Do = shouldForwardProp;
    Eo === "Root" || Eo === "root" ? Do = go : Eo ? Do = bo : isStringTag(Co) && (Do = void 0);
    const Lo = styled$2(Co, {
      shouldForwardProp: Do,
      label: generateStyledLabel(wo, Eo),
      ...Ao
    }), ko = (No) => {
      if (typeof No == "function" && No.__emotion_real !== No)
        return function(ti) {
          return processStyle(ti, No);
        };
      if (isPlainObject$2(No)) {
        const Jo = preprocessStyles(No);
        return Jo.variants ? function(oi) {
          return processStyle(oi, Jo);
        } : Jo.style;
      }
      return No;
    }, Ko = (...No) => {
      const Jo = [], ti = No.map(ko), oi = [];
      if (Jo.push(vo), wo && Io && oi.push(function(ii) {
        var si, li;
        const ri = (li = (si = ii.theme.components) == null ? void 0 : si[wo]) == null ? void 0 : li.styleOverrides;
        if (!ri)
          return null;
        const ni = {};
        for (const ui in ri)
          ni[ui] = processStyle(ii, ri[ui]);
        return Io(ii, ni);
      }), wo && !Oo && oi.push(function(ii) {
        var ni, si;
        const ai = ii.theme, ri = (si = (ni = ai == null ? void 0 : ai.components) == null ? void 0 : ni[wo]) == null ? void 0 : si.variants;
        return ri ? processStyleVariants(ii, ri) : null;
      }), jo || oi.push(styleFunctionSx), Array.isArray(ti[0])) {
        const ei = ti.shift(), ii = new Array(Jo.length).fill(""), ai = new Array(oi.length).fill("");
        let ri;
        ri = [...ii, ...ei, ...ai], ri.raw = [...ii, ...ei.raw, ...ai], Jo.unshift(ri);
      }
      const Qo = [...Jo, ...ti, ...oi], Zo = Lo(...Qo);
      return Co.muiName && (Zo.muiName = Co.muiName), process.env.NODE_ENV !== "production" && (Zo.displayName = generateDisplayName(wo, Eo, Co)), Zo;
    };
    return Lo.withConfig && (Ko.withConfig = Lo.withConfig), Ko;
  };
}
function generateDisplayName(Kt, uo, ho) {
  return Kt ? `${Kt}${capitalize(uo || "")}` : `Styled(${getDisplayName$1(ho)})`;
}
function generateStyledLabel(Kt, uo) {
  let ho;
  return process.env.NODE_ENV !== "production" && Kt && (ho = `${Kt}-${lowercaseFirstLetter(uo || "Root")}`), ho;
}
function isObjectEmpty(Kt) {
  for (const uo in Kt)
    return !1;
  return !0;
}
function isStringTag(Kt) {
  return typeof Kt == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  Kt.charCodeAt(0) > 96;
}
function lowercaseFirstLetter(Kt) {
  return Kt && Kt.charAt(0).toLowerCase() + Kt.slice(1);
}
const styled$1 = createStyled();
function getThemeProps$1(Kt) {
  const {
    theme: uo,
    name: ho,
    props: go
  } = Kt;
  return !uo || !uo.components || !uo.components[ho] || !uo.components[ho].defaultProps ? go : resolveProps(uo.components[ho].defaultProps, go);
}
function useThemeProps$1({
  props: Kt,
  name: uo,
  defaultTheme: ho,
  themeId: go
}) {
  let bo = useTheme$1(ho);
  return go && (bo = bo[go] || bo), getThemeProps$1({
    theme: bo,
    name: uo,
    props: Kt
  });
}
function clampWrapper(Kt, uo = 0, ho = 1) {
  return process.env.NODE_ENV !== "production" && (Kt < uo || Kt > ho) && console.error(`MUI: The value provided ${Kt} is out of range [${uo}, ${ho}].`), clamp$3(Kt, uo, ho);
}
function hexToRgb(Kt) {
  Kt = Kt.slice(1);
  const uo = new RegExp(`.{1,${Kt.length >= 6 ? 2 : 1}}`, "g");
  let ho = Kt.match(uo);
  return ho && ho[0].length === 1 && (ho = ho.map((go) => go + go)), process.env.NODE_ENV !== "production" && Kt.length !== Kt.trim().length && console.error(`MUI: The color: "${Kt}" is invalid. Make sure the color input doesn't contain leading/trailing space.`), ho ? `rgb${ho.length === 4 ? "a" : ""}(${ho.map((go, bo) => bo < 3 ? parseInt(go, 16) : Math.round(parseInt(go, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function decomposeColor(Kt) {
  if (Kt.type)
    return Kt;
  if (Kt.charAt(0) === "#")
    return decomposeColor(hexToRgb(Kt));
  const uo = Kt.indexOf("("), ho = Kt.substring(0, uo);
  if (!["rgb", "rgba", "hsl", "hsla", "color"].includes(ho))
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${Kt}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : formatMuiErrorMessage(9, Kt));
  let go = Kt.substring(uo + 1, Kt.length - 1), bo;
  if (ho === "color") {
    if (go = go.split(" "), bo = go.shift(), go.length === 4 && go[3].charAt(0) === "/" && (go[3] = go[3].slice(1)), !["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].includes(bo))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${bo}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : formatMuiErrorMessage(10, bo));
  } else
    go = go.split(",");
  return go = go.map((vo) => parseFloat(vo)), {
    type: ho,
    values: go,
    colorSpace: bo
  };
}
const colorChannel = (Kt) => {
  const uo = decomposeColor(Kt);
  return uo.values.slice(0, 3).map((ho, go) => uo.type.includes("hsl") && go !== 0 ? `${ho}%` : ho).join(" ");
}, private_safeColorChannel = (Kt, uo) => {
  try {
    return colorChannel(Kt);
  } catch {
    return uo && process.env.NODE_ENV !== "production" && console.warn(uo), Kt;
  }
};
function recomposeColor(Kt) {
  const {
    type: uo,
    colorSpace: ho
  } = Kt;
  let {
    values: go
  } = Kt;
  return uo.includes("rgb") ? go = go.map((bo, vo) => vo < 3 ? parseInt(bo, 10) : bo) : uo.includes("hsl") && (go[1] = `${go[1]}%`, go[2] = `${go[2]}%`), uo.includes("color") ? go = `${ho} ${go.join(" ")}` : go = `${go.join(", ")}`, `${uo}(${go})`;
}
function hslToRgb(Kt) {
  Kt = decomposeColor(Kt);
  const {
    values: uo
  } = Kt, ho = uo[0], go = uo[1] / 100, bo = uo[2] / 100, vo = go * Math.min(bo, 1 - bo), Po = (wo, Eo = (wo + ho / 30) % 12) => bo - vo * Math.max(Math.min(Eo - 3, 9 - Eo, 1), -1);
  let Co = "rgb";
  const So = [Math.round(Po(0) * 255), Math.round(Po(8) * 255), Math.round(Po(4) * 255)];
  return Kt.type === "hsla" && (Co += "a", So.push(uo[3])), recomposeColor({
    type: Co,
    values: So
  });
}
function getLuminance(Kt) {
  Kt = decomposeColor(Kt);
  let uo = Kt.type === "hsl" || Kt.type === "hsla" ? decomposeColor(hslToRgb(Kt)).values : Kt.values;
  return uo = uo.map((ho) => (Kt.type !== "color" && (ho /= 255), ho <= 0.03928 ? ho / 12.92 : ((ho + 0.055) / 1.055) ** 2.4)), Number((0.2126 * uo[0] + 0.7152 * uo[1] + 0.0722 * uo[2]).toFixed(3));
}
function getContrastRatio(Kt, uo) {
  const ho = getLuminance(Kt), go = getLuminance(uo);
  return (Math.max(ho, go) + 0.05) / (Math.min(ho, go) + 0.05);
}
function alpha$1(Kt, uo) {
  return Kt = decomposeColor(Kt), uo = clampWrapper(uo), (Kt.type === "rgb" || Kt.type === "hsl") && (Kt.type += "a"), Kt.type === "color" ? Kt.values[3] = `/${uo}` : Kt.values[3] = uo, recomposeColor(Kt);
}
function private_safeAlpha(Kt, uo, ho) {
  try {
    return alpha$1(Kt, uo);
  } catch {
    return Kt;
  }
}
function darken(Kt, uo) {
  if (Kt = decomposeColor(Kt), uo = clampWrapper(uo), Kt.type.includes("hsl"))
    Kt.values[2] *= 1 - uo;
  else if (Kt.type.includes("rgb") || Kt.type.includes("color"))
    for (let ho = 0; ho < 3; ho += 1)
      Kt.values[ho] *= 1 - uo;
  return recomposeColor(Kt);
}
function private_safeDarken(Kt, uo, ho) {
  try {
    return darken(Kt, uo);
  } catch {
    return Kt;
  }
}
function lighten(Kt, uo) {
  if (Kt = decomposeColor(Kt), uo = clampWrapper(uo), Kt.type.includes("hsl"))
    Kt.values[2] += (100 - Kt.values[2]) * uo;
  else if (Kt.type.includes("rgb"))
    for (let ho = 0; ho < 3; ho += 1)
      Kt.values[ho] += (255 - Kt.values[ho]) * uo;
  else if (Kt.type.includes("color"))
    for (let ho = 0; ho < 3; ho += 1)
      Kt.values[ho] += (1 - Kt.values[ho]) * uo;
  return recomposeColor(Kt);
}
function private_safeLighten(Kt, uo, ho) {
  try {
    return lighten(Kt, uo);
  } catch {
    return Kt;
  }
}
function emphasize(Kt, uo = 0.15) {
  return getLuminance(Kt) > 0.5 ? darken(Kt, uo) : lighten(Kt, uo);
}
function private_safeEmphasize(Kt, uo, ho) {
  try {
    return emphasize(Kt, uo);
  } catch {
    return Kt;
  }
}
const RtlContext = /* @__PURE__ */ React$1.createContext();
process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.bool);
const useRtl = () => React$1.useContext(RtlContext) ?? !1, PropsContext = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.object);
function getThemeProps(Kt) {
  const {
    theme: uo,
    name: ho,
    props: go
  } = Kt;
  if (!uo || !uo.components || !uo.components[ho])
    return go;
  const bo = uo.components[ho];
  return bo.defaultProps ? resolveProps(bo.defaultProps, go) : !bo.styleOverrides && !bo.variants ? resolveProps(bo, go) : go;
}
function useDefaultProps$1({
  props: Kt,
  name: uo
}) {
  const ho = React$1.useContext(PropsContext);
  return getThemeProps({
    props: Kt,
    name: uo,
    theme: {
      components: ho
    }
  });
}
const arg = {
  theme: void 0
};
function unstable_memoTheme(Kt) {
  let uo, ho;
  return function(bo) {
    let vo = uo;
    return (vo === void 0 || bo.theme !== ho) && (arg.theme = bo.theme, vo = preprocessStyles(Kt(arg)), uo = vo, ho = bo.theme), vo;
  };
}
function createGetCssVar$1(Kt = "") {
  function uo(...go) {
    if (!go.length)
      return "";
    const bo = go[0];
    return typeof bo == "string" && !bo.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${Kt ? `${Kt}-` : ""}${bo}${uo(...go.slice(1))})` : `, ${bo}`;
  }
  return (go, ...bo) => `var(--${Kt ? `${Kt}-` : ""}${go}${uo(...bo)})`;
}
const assignNestedKeys = (Kt, uo, ho, go = []) => {
  let bo = Kt;
  uo.forEach((vo, Po) => {
    Po === uo.length - 1 ? Array.isArray(bo) ? bo[Number(vo)] = ho : bo && typeof bo == "object" && (bo[vo] = ho) : bo && typeof bo == "object" && (bo[vo] || (bo[vo] = go.includes(vo) ? [] : {}), bo = bo[vo]);
  });
}, walkObjectDeep = (Kt, uo, ho) => {
  function go(bo, vo = [], Po = []) {
    Object.entries(bo).forEach(([Co, So]) => {
      (!ho || !ho([...vo, Co])) && So != null && (typeof So == "object" && Object.keys(So).length > 0 ? go(So, [...vo, Co], Array.isArray(So) ? [...Po, Co] : Po) : uo([...vo, Co], So, Po));
    });
  }
  go(Kt);
}, getCssValue = (Kt, uo) => typeof uo == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((go) => Kt.includes(go)) || Kt[Kt.length - 1].toLowerCase().includes("opacity") ? uo : `${uo}px` : uo;
function cssVarsParser(Kt, uo) {
  const {
    prefix: ho,
    shouldSkipGeneratingVar: go
  } = uo || {}, bo = {}, vo = {}, Po = {};
  return walkObjectDeep(
    Kt,
    (Co, So, wo) => {
      if ((typeof So == "string" || typeof So == "number") && (!go || !go(Co, So))) {
        const Eo = `--${ho ? `${ho}-` : ""}${Co.join("-")}`, Ro = getCssValue(Co, So);
        Object.assign(bo, {
          [Eo]: Ro
        }), assignNestedKeys(vo, Co, `var(${Eo})`, wo), assignNestedKeys(Po, Co, `var(${Eo}, ${Ro})`, wo);
      }
    },
    (Co) => Co[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: bo,
    vars: vo,
    varsWithDefaults: Po
  };
}
function prepareCssVars(Kt, uo = {}) {
  const {
    getSelector: ho = jo,
    disableCssColorScheme: go,
    colorSchemeSelector: bo
  } = uo, {
    colorSchemes: vo = {},
    components: Po,
    defaultColorScheme: Co = "light",
    ...So
  } = Kt, {
    vars: wo,
    css: Eo,
    varsWithDefaults: Ro
  } = cssVarsParser(So, uo);
  let _o = Ro;
  const Io = {}, {
    [Co]: Ao,
    ...Oo
  } = vo;
  if (Object.entries(Oo || {}).forEach(([ko, Ko]) => {
    const {
      vars: No,
      css: Jo,
      varsWithDefaults: ti
    } = cssVarsParser(Ko, uo);
    _o = deepmerge(_o, ti), Io[ko] = {
      css: Jo,
      vars: No
    };
  }), Ao) {
    const {
      css: ko,
      vars: Ko,
      varsWithDefaults: No
    } = cssVarsParser(Ao, uo);
    _o = deepmerge(_o, No), Io[Co] = {
      css: ko,
      vars: Ko
    };
  }
  function jo(ko, Ko) {
    var Jo, ti;
    let No = bo;
    if (bo === "class" && (No = ".%s"), bo === "data" && (No = "[data-%s]"), bo != null && bo.startsWith("data-") && !bo.includes("%s") && (No = `[${bo}="%s"]`), ko) {
      if (No === "media")
        return Kt.defaultColorScheme === ko ? ":root" : {
          [`@media (prefers-color-scheme: ${((ti = (Jo = vo[ko]) == null ? void 0 : Jo.palette) == null ? void 0 : ti.mode) || ko})`]: {
            ":root": Ko
          }
        };
      if (No)
        return Kt.defaultColorScheme === ko ? `:root, ${No.replace("%s", String(ko))}` : No.replace("%s", String(ko));
    }
    return ":root";
  }
  return {
    vars: _o,
    generateThemeVars: () => {
      let ko = {
        ...wo
      };
      return Object.entries(Io).forEach(([, {
        vars: Ko
      }]) => {
        ko = deepmerge(ko, Ko);
      }), ko;
    },
    generateStyleSheets: () => {
      var oi, Qo;
      const ko = [], Ko = Kt.defaultColorScheme || "light";
      function No(Zo, ei) {
        Object.keys(ei).length && ko.push(typeof Zo == "string" ? {
          [Zo]: {
            ...ei
          }
        } : Zo);
      }
      No(ho(void 0, {
        ...Eo
      }), Eo);
      const {
        [Ko]: Jo,
        ...ti
      } = Io;
      if (Jo) {
        const {
          css: Zo
        } = Jo, ei = (Qo = (oi = vo[Ko]) == null ? void 0 : oi.palette) == null ? void 0 : Qo.mode, ii = !go && ei ? {
          colorScheme: ei,
          ...Zo
        } : {
          ...Zo
        };
        No(ho(Ko, {
          ...ii
        }), ii);
      }
      return Object.entries(ti).forEach(([Zo, {
        css: ei
      }]) => {
        var ri, ni;
        const ii = (ni = (ri = vo[Zo]) == null ? void 0 : ri.palette) == null ? void 0 : ni.mode, ai = !go && ii ? {
          colorScheme: ii,
          ...ei
        } : {
          ...ei
        };
        No(ho(Zo, {
          ...ai
        }), ai);
      }), ko;
    }
  };
}
function createGetColorSchemeSelector(Kt) {
  return function(ho) {
    return Kt === "media" ? (process.env.NODE_ENV !== "production" && ho !== "light" && ho !== "dark" && console.error(`MUI: @media (prefers-color-scheme) supports only 'light' or 'dark', but receive '${ho}'.`), `@media (prefers-color-scheme: ${ho})`) : Kt ? Kt.startsWith("data-") && !Kt.includes("%s") ? `[${Kt}="${ho}"] &` : Kt === "class" ? `.${ho} &` : Kt === "data" ? `[data-${ho}] &` : `${Kt.replace("%s", ho)} &` : "&";
  };
}
const is$2 = Object.is;
function fastObjectShallowCompare(Kt, uo) {
  if (Kt === uo)
    return !0;
  if (!(Kt instanceof Object) || !(uo instanceof Object))
    return !1;
  let ho = 0, go = 0;
  for (const bo in Kt)
    if (ho += 1, !is$2(Kt[bo], uo[bo]) || !(bo in uo))
      return !1;
  for (const bo in uo)
    go += 1;
  return ho === go;
}
function fastMemo(Kt) {
  return /* @__PURE__ */ React$1.memo(Kt, fastObjectShallowCompare);
}
const GRID_DEFAULT_LOCALE_TEXT = {
  // Root
  noRowsLabel: "No rows",
  noResultsOverlayLabel: "No results found.",
  // Density selector toolbar button text
  toolbarDensity: "Density",
  toolbarDensityLabel: "Density",
  toolbarDensityCompact: "Compact",
  toolbarDensityStandard: "Standard",
  toolbarDensityComfortable: "Comfortable",
  // Columns selector toolbar button text
  toolbarColumns: "Columns",
  toolbarColumnsLabel: "Select columns",
  // Filters toolbar button text
  toolbarFilters: "Filters",
  toolbarFiltersLabel: "Show filters",
  toolbarFiltersTooltipHide: "Hide filters",
  toolbarFiltersTooltipShow: "Show filters",
  toolbarFiltersTooltipActive: (Kt) => Kt !== 1 ? `${Kt} active filters` : `${Kt} active filter`,
  // Quick filter toolbar field
  toolbarQuickFilterPlaceholder: "Search…",
  toolbarQuickFilterLabel: "Search",
  toolbarQuickFilterDeleteIconLabel: "Clear",
  // Export selector toolbar button text
  toolbarExport: "Export",
  toolbarExportLabel: "Export",
  toolbarExportCSV: "Download as CSV",
  toolbarExportPrint: "Print",
  toolbarExportExcel: "Download as Excel",
  // Columns management text
  columnsManagementSearchTitle: "Search",
  columnsManagementNoColumns: "No columns",
  columnsManagementShowHideAllText: "Show/Hide All",
  columnsManagementReset: "Reset",
  columnsManagementDeleteIconLabel: "Clear",
  // Filter panel text
  filterPanelAddFilter: "Add filter",
  filterPanelRemoveAll: "Remove all",
  filterPanelDeleteIconLabel: "Delete",
  filterPanelLogicOperator: "Logic operator",
  filterPanelOperator: "Operator",
  filterPanelOperatorAnd: "And",
  filterPanelOperatorOr: "Or",
  filterPanelColumns: "Columns",
  filterPanelInputLabel: "Value",
  filterPanelInputPlaceholder: "Filter value",
  // Filter operators text
  filterOperatorContains: "contains",
  filterOperatorDoesNotContain: "does not contain",
  filterOperatorEquals: "equals",
  filterOperatorDoesNotEqual: "does not equal",
  filterOperatorStartsWith: "starts with",
  filterOperatorEndsWith: "ends with",
  filterOperatorIs: "is",
  filterOperatorNot: "is not",
  filterOperatorAfter: "is after",
  filterOperatorOnOrAfter: "is on or after",
  filterOperatorBefore: "is before",
  filterOperatorOnOrBefore: "is on or before",
  filterOperatorIsEmpty: "is empty",
  filterOperatorIsNotEmpty: "is not empty",
  filterOperatorIsAnyOf: "is any of",
  "filterOperator=": "=",
  "filterOperator!=": "!=",
  "filterOperator>": ">",
  "filterOperator>=": ">=",
  "filterOperator<": "<",
  "filterOperator<=": "<=",
  // Header filter operators text
  headerFilterOperatorContains: "Contains",
  headerFilterOperatorDoesNotContain: "Does not contain",
  headerFilterOperatorEquals: "Equals",
  headerFilterOperatorDoesNotEqual: "Does not equal",
  headerFilterOperatorStartsWith: "Starts with",
  headerFilterOperatorEndsWith: "Ends with",
  headerFilterOperatorIs: "Is",
  headerFilterOperatorNot: "Is not",
  headerFilterOperatorAfter: "Is after",
  headerFilterOperatorOnOrAfter: "Is on or after",
  headerFilterOperatorBefore: "Is before",
  headerFilterOperatorOnOrBefore: "Is on or before",
  headerFilterOperatorIsEmpty: "Is empty",
  headerFilterOperatorIsNotEmpty: "Is not empty",
  headerFilterOperatorIsAnyOf: "Is any of",
  "headerFilterOperator=": "Equals",
  "headerFilterOperator!=": "Not equals",
  "headerFilterOperator>": "Greater than",
  "headerFilterOperator>=": "Greater than or equal to",
  "headerFilterOperator<": "Less than",
  "headerFilterOperator<=": "Less than or equal to",
  // Filter values text
  filterValueAny: "any",
  filterValueTrue: "true",
  filterValueFalse: "false",
  // Column menu text
  columnMenuLabel: "Menu",
  columnMenuShowColumns: "Show columns",
  columnMenuManageColumns: "Manage columns",
  columnMenuFilter: "Filter",
  columnMenuHideColumn: "Hide column",
  columnMenuUnsort: "Unsort",
  columnMenuSortAsc: "Sort by ASC",
  columnMenuSortDesc: "Sort by DESC",
  // Column header text
  columnHeaderFiltersTooltipActive: (Kt) => Kt !== 1 ? `${Kt} active filters` : `${Kt} active filter`,
  columnHeaderFiltersLabel: "Show filters",
  columnHeaderSortIconLabel: "Sort",
  // Rows selected footer text
  footerRowSelected: (Kt) => Kt !== 1 ? `${Kt.toLocaleString()} rows selected` : `${Kt.toLocaleString()} row selected`,
  // Total row amount footer text
  footerTotalRows: "Total Rows:",
  // Total visible row amount footer text
  footerTotalVisibleRows: (Kt, uo) => `${Kt.toLocaleString()} of ${uo.toLocaleString()}`,
  // Checkbox selection text
  checkboxSelectionHeaderName: "Checkbox selection",
  checkboxSelectionSelectAllRows: "Select all rows",
  checkboxSelectionUnselectAllRows: "Unselect all rows",
  checkboxSelectionSelectRow: "Select row",
  checkboxSelectionUnselectRow: "Unselect row",
  // Boolean cell text
  booleanCellTrueLabel: "yes",
  booleanCellFalseLabel: "no",
  // Actions cell more text
  actionsCellMore: "more",
  // Column pinning text
  pinToLeft: "Pin to left",
  pinToRight: "Pin to right",
  unpin: "Unpin",
  // Tree Data
  treeDataGroupingHeaderName: "Group",
  treeDataExpand: "see children",
  treeDataCollapse: "hide children",
  // Grouping columns
  groupingColumnHeaderName: "Group",
  groupColumn: (Kt) => `Group by ${Kt}`,
  unGroupColumn: (Kt) => `Stop grouping by ${Kt}`,
  // Master/detail
  detailPanelToggle: "Detail panel toggle",
  expandDetailPanel: "Expand",
  collapseDetailPanel: "Collapse",
  // Used core components translation keys
  MuiTablePagination: {},
  // Row reordering text
  rowReorderingHeaderName: "Row reordering",
  // Aggregation
  aggregationMenuItemHeader: "Aggregation",
  aggregationFunctionLabelSum: "sum",
  aggregationFunctionLabelAvg: "avg",
  aggregationFunctionLabelMin: "min",
  aggregationFunctionLabelMax: "max",
  aggregationFunctionLabelSize: "size"
};
function getDataGridUtilityClass(Kt) {
  return generateUtilityClass$1("MuiDataGrid", Kt);
}
const gridClasses = generateUtilityClasses$1("MuiDataGrid", ["actionsCell", "aggregationColumnHeader", "aggregationColumnHeader--alignLeft", "aggregationColumnHeader--alignCenter", "aggregationColumnHeader--alignRight", "aggregationColumnHeaderLabel", "autoHeight", "autosizing", "booleanCell", "cell--editable", "cell--editing", "cell--flex", "cell--textCenter", "cell--textLeft", "cell--textRight", "cell--rangeTop", "cell--rangeBottom", "cell--rangeLeft", "cell--rangeRight", "cell--pinnedLeft", "cell--pinnedRight", "cell--selectionMode", "cell", "cellCheckbox", "cellEmpty", "cellSkeleton", "cellOffsetLeft", "checkboxInput", "columnHeader", "columnHeader--alignCenter", "columnHeader--alignLeft", "columnHeader--alignRight", "columnHeader--dragging", "columnHeader--moving", "columnHeader--numeric", "columnHeader--sortable", "columnHeader--sorted", "columnHeader--filtered", "columnHeader--pinnedLeft", "columnHeader--pinnedRight", "columnHeader--last", "columnHeader--lastUnpinned", "columnHeader--siblingFocused", "columnHeaderCheckbox", "columnHeaderDraggableContainer", "columnHeaderTitle", "columnHeaderTitleContainer", "columnHeaderTitleContainerContent", "columnHeader--filledGroup", "columnHeader--emptyGroup", "columnHeaders", "columnSeparator--resizable", "columnSeparator--resizing", "columnSeparator--sideLeft", "columnSeparator--sideRight", "columnSeparator", "columnsManagement", "columnsManagementRow", "columnsManagementHeader", "columnsManagementSearchInput", "columnsManagementFooter", "container--top", "container--bottom", "detailPanel", "detailPanels", "detailPanelToggleCell", "detailPanelToggleCell--expanded", "footerCell", "panel", "panelHeader", "panelWrapper", "panelContent", "panelFooter", "paper", "editBooleanCell", "editInputCell", "filler", "filler--borderBottom", "filler--pinnedLeft", "filler--pinnedRight", "filterForm", "filterFormDeleteIcon", "filterFormLogicOperatorInput", "filterFormColumnInput", "filterFormOperatorInput", "filterFormValueInput", "filterIcon", "footerContainer", "headerFilterRow", "iconButtonContainer", "iconSeparator", "main", "main--hasPinnedRight", "main--hasSkeletonLoadingOverlay", "menu", "menuIcon", "menuIconButton", "menuOpen", "menuList", "overlay", "overlayWrapper", "overlayWrapperInner", "root", "root--densityStandard", "root--densityComfortable", "root--densityCompact", "root--disableUserSelection", "root--noToolbar", "row", "row--editable", "row--editing", "row--firstVisible", "row--lastVisible", "row--dragging", "row--dynamicHeight", "row--detailPanelExpanded", "row--borderBottom", "rowReorderCellPlaceholder", "rowCount", "rowReorderCellContainer", "rowReorderCell", "rowReorderCell--draggable", "rowSkeleton", "scrollArea--left", "scrollArea--right", "scrollArea", "scrollbar", "scrollbar--vertical", "scrollbar--horizontal", "scrollbarFiller", "scrollbarFiller--header", "scrollbarFiller--borderTop", "scrollbarFiller--borderBottom", "scrollbarFiller--pinnedRight", "selectedRowCount", "sortIcon", "toolbarContainer", "toolbarFilterList", "virtualScroller", "virtualScroller--hasScrollX", "virtualScrollerContent", "virtualScrollerContent--overflowed", "virtualScrollerRenderZone", "pinnedColumns", "withVerticalBorder", "withBorderColor", "cell--withRightBorder", "cell--withLeftBorder", "columnHeader--withRightBorder", "columnHeader--withLeftBorder", "treeDataGroupingCell", "treeDataGroupingCellToggle", "treeDataGroupingCellLoadingContainer", "groupingCriteriaCell", "groupingCriteriaCellToggle", "groupingCriteriaCellLoadingContainer", "pinnedRows", "pinnedRows--top", "pinnedRows--bottom", "pinnedRowsRenderZone"]), CLEANUP_TIMER_LOOP_MILLIS = 1e3;
class TimerBasedCleanupTracking {
  constructor(uo = CLEANUP_TIMER_LOOP_MILLIS) {
    this.timeouts = /* @__PURE__ */ new Map(), this.cleanupTimeout = CLEANUP_TIMER_LOOP_MILLIS, this.cleanupTimeout = uo;
  }
  register(uo, ho, go) {
    this.timeouts || (this.timeouts = /* @__PURE__ */ new Map());
    const bo = setTimeout(() => {
      typeof ho == "function" && ho(), this.timeouts.delete(go.cleanupToken);
    }, this.cleanupTimeout);
    this.timeouts.set(go.cleanupToken, bo);
  }
  unregister(uo) {
    const ho = this.timeouts.get(uo.cleanupToken);
    ho && (this.timeouts.delete(uo.cleanupToken), clearTimeout(ho));
  }
  reset() {
    this.timeouts && (this.timeouts.forEach((uo, ho) => {
      this.unregister({
        cleanupToken: ho
      });
    }), this.timeouts = void 0);
  }
}
class FinalizationRegistryBasedCleanupTracking {
  constructor() {
    this.registry = new FinalizationRegistry((uo) => {
      typeof uo == "function" && uo();
    });
  }
  register(uo, ho, go) {
    this.registry.register(uo, ho, go);
  }
  unregister(uo) {
    this.registry.unregister(uo);
  }
  // eslint-disable-next-line class-methods-use-this
  reset() {
  }
}
var GridSignature = /* @__PURE__ */ function(Kt) {
  return Kt.DataGrid = "DataGrid", Kt.DataGridPro = "DataGridPro", Kt.DataGridPremium = "DataGridPremium", Kt;
}(GridSignature || {});
class ObjectToBeRetainedByReact {
}
function createUseGridApiEventHandler(Kt) {
  let uo = 0;
  return function(go, bo, vo, Po) {
    Kt.registry === null && (Kt.registry = typeof FinalizationRegistry < "u" ? new FinalizationRegistryBasedCleanupTracking() : new TimerBasedCleanupTracking());
    const [Co] = React$1.useState(new ObjectToBeRetainedByReact()), So = React$1.useRef(null), wo = React$1.useRef();
    wo.current = vo;
    const Eo = React$1.useRef(null);
    if (!So.current && wo.current) {
      const Ro = (_o, Io, Ao) => {
        var Oo;
        Io.defaultMuiPrevented || (Oo = wo.current) == null || Oo.call(wo, _o, Io, Ao);
      };
      So.current = go.current.subscribeEvent(bo, Ro, Po), uo += 1, Eo.current = {
        cleanupToken: uo
      }, Kt.registry.register(
        Co,
        // The callback below will be called once this reference stops being retained
        () => {
          var _o;
          (_o = So.current) == null || _o.call(So), So.current = null, Eo.current = null;
        },
        Eo.current
      );
    } else !wo.current && So.current && (So.current(), So.current = null, Eo.current && (Kt.registry.unregister(Eo.current), Eo.current = null));
    React$1.useEffect(() => {
      if (!So.current && wo.current) {
        const Ro = (_o, Io, Ao) => {
          var Oo;
          Io.defaultMuiPrevented || (Oo = wo.current) == null || Oo.call(wo, _o, Io, Ao);
        };
        So.current = go.current.subscribeEvent(bo, Ro, Po);
      }
      return Eo.current && Kt.registry && (Kt.registry.unregister(Eo.current), Eo.current = null), () => {
        var Ro;
        (Ro = So.current) == null || Ro.call(So), So.current = null;
      };
    }, [go, bo, Po]);
  };
}
const registryContainer = {
  registry: null
}, useGridApiEventHandler = createUseGridApiEventHandler(registryContainer), optionsSubscriberOptions = {
  isFirst: !0
};
function useGridApiOptionHandler(Kt, uo, ho) {
  useGridApiEventHandler(Kt, uo, ho, optionsSubscriberOptions);
}
const warnedOnceCache = /* @__PURE__ */ new Set();
function warnOnce(Kt, uo = "warning") {
  if (process.env.NODE_ENV === "production")
    return;
  const ho = Array.isArray(Kt) ? Kt.join(`
`) : Kt;
  warnedOnceCache.has(ho) || (warnedOnceCache.add(ho), uo === "error" ? console.error(ho) : console.warn(ho));
}
function isOutputSelector(Kt) {
  return Kt.acceptsApiRef;
}
function applySelector(Kt, uo) {
  return isOutputSelector(uo) ? uo(Kt) : uo(Kt.current.state);
}
const defaultCompare = Object.is, objectShallowCompare = fastObjectShallowCompare, createRefs = () => ({
  state: null,
  equals: null,
  selector: null,
  args: null
}), useGridSelector = (Kt, uo, ho = defaultCompare) => {
  process.env.NODE_ENV !== "production" && (Kt.current.state || warnOnce(["MUI X: `useGridSelector` has been called before the initialization of the state.", "This hook can only be used inside the context of the grid."]));
  const go = useLazyRef(createRefs), bo = go.current.selector !== null, [vo, Po] = React$1.useState(
    // We don't use an initialization function to avoid allocations
    bo ? null : applySelector(Kt, uo)
  );
  return go.current.state = vo, go.current.equals = ho, go.current.selector = uo, useOnMount(() => Kt.current.store.subscribe(() => {
    const Co = applySelector(Kt, go.current.selector);
    go.current.equals(go.current.state, Co) || (go.current.state = Co, Po(Co));
  })), vo;
}, gridDimensionsSelector = (Kt) => Kt.dimensions;
var runIdentityFunctionCheck = (Kt, uo, ho) => {
  if (uo.length === 1 && uo[0] === ho) {
    let go = !1;
    try {
      const bo = {};
      Kt(bo) === bo && (go = !0);
    } catch {
    }
    if (go) {
      let bo;
      try {
        throw new Error();
      } catch (vo) {
        ({ stack: bo } = vo);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: bo }
      );
    }
  }
}, runInputStabilityCheck = (Kt, uo, ho) => {
  const { memoize: go, memoizeOptions: bo } = uo, { inputSelectorResults: vo, inputSelectorResultsCopy: Po } = Kt, Co = go(() => ({}), ...bo);
  if (!(Co.apply(null, vo) === Co.apply(null, Po))) {
    let wo;
    try {
      throw new Error();
    } catch (Eo) {
      ({ stack: wo } = Eo);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: ho,
        firstInputs: vo,
        secondInputs: Po,
        stack: wo
      }
    );
  }
}, globalDevModeChecks = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(Kt, uo = `expected a function, instead received ${typeof Kt}`) {
  if (typeof Kt != "function")
    throw new TypeError(uo);
}
function assertIsObject(Kt, uo = `expected an object, instead received ${typeof Kt}`) {
  if (typeof Kt != "object")
    throw new TypeError(uo);
}
function assertIsArrayOfFunctions(Kt, uo = "expected all items to be functions, instead received the following types: ") {
  if (!Kt.every((ho) => typeof ho == "function")) {
    const ho = Kt.map(
      (go) => typeof go == "function" ? `function ${go.name || "unnamed"}()` : typeof go
    ).join(", ");
    throw new TypeError(`${uo}[${ho}]`);
  }
}
var ensureIsArray = (Kt) => Array.isArray(Kt) ? Kt : [Kt];
function getDependencies(Kt) {
  const uo = Array.isArray(Kt[0]) ? Kt[0] : Kt;
  return assertIsArrayOfFunctions(
    uo,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), uo;
}
function collectInputSelectorResults(Kt, uo) {
  const ho = [], { length: go } = Kt;
  for (let bo = 0; bo < go; bo++)
    ho.push(Kt[bo].apply(null, uo));
  return ho;
}
var getDevModeChecksExecutionInfo = (Kt, uo) => {
  const { identityFunctionCheck: ho, inputStabilityCheck: go } = {
    ...globalDevModeChecks,
    ...uo
  };
  return {
    identityFunctionCheck: {
      shouldRun: ho === "always" || ho === "once" && Kt,
      run: runIdentityFunctionCheck
    },
    inputStabilityCheck: {
      shouldRun: go === "always" || go === "once" && Kt,
      run: runInputStabilityCheck
    }
  };
};
function createSingletonCache(Kt) {
  let uo;
  return {
    get(ho) {
      return uo && Kt(uo.key, ho) ? uo.value : NOT_FOUND;
    },
    put(ho, go) {
      uo = { key: ho, value: go };
    },
    getEntries() {
      return uo ? [uo] : [];
    },
    clear() {
      uo = void 0;
    }
  };
}
function createLruCache(Kt, uo) {
  let ho = [];
  function go(Co) {
    const So = ho.findIndex((wo) => uo(Co, wo.key));
    if (So > -1) {
      const wo = ho[So];
      return So > 0 && (ho.splice(So, 1), ho.unshift(wo)), wo.value;
    }
    return NOT_FOUND;
  }
  function bo(Co, So) {
    go(Co) === NOT_FOUND && (ho.unshift({ key: Co, value: So }), ho.length > Kt && ho.pop());
  }
  function vo() {
    return ho;
  }
  function Po() {
    ho = [];
  }
  return { get: go, put: bo, getEntries: vo, clear: Po };
}
var referenceEqualityCheck = (Kt, uo) => Kt === uo;
function createCacheKeyComparator(Kt) {
  return function(ho, go) {
    if (ho === null || go === null || ho.length !== go.length)
      return !1;
    const { length: bo } = ho;
    for (let vo = 0; vo < bo; vo++)
      if (!Kt(ho[vo], go[vo]))
        return !1;
    return !0;
  };
}
function lruMemoize(Kt, uo) {
  const ho = typeof uo == "object" ? uo : { equalityCheck: uo }, {
    equalityCheck: go = referenceEqualityCheck,
    maxSize: bo = 1,
    resultEqualityCheck: vo
  } = ho, Po = createCacheKeyComparator(go);
  let Co = 0;
  const So = bo <= 1 ? createSingletonCache(Po) : createLruCache(bo, Po);
  function wo() {
    let Eo = So.get(arguments);
    if (Eo === NOT_FOUND) {
      if (Eo = Kt.apply(null, arguments), Co++, vo) {
        const _o = So.getEntries().find(
          (Io) => vo(Io.value, Eo)
        );
        _o && (Eo = _o.value, Co !== 0 && Co--);
      }
      So.put(arguments, Eo);
    }
    return Eo;
  }
  return wo.clearCache = () => {
    So.clear(), wo.resetResultsCount();
  }, wo.resultsCount = () => Co, wo.resetResultsCount = () => {
    Co = 0;
  }, wo;
}
var StrongRef = class {
  constructor(Kt) {
    this.value = Kt;
  }
  deref() {
    return this.value;
  }
}, Ref = typeof WeakRef < "u" ? WeakRef : StrongRef, UNTERMINATED = 0, TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(Kt, uo = {}) {
  let ho = createCacheNode();
  const { resultEqualityCheck: go } = uo;
  let bo, vo = 0;
  function Po() {
    var Ro;
    let Co = ho;
    const { length: So } = arguments;
    for (let _o = 0, Io = So; _o < Io; _o++) {
      const Ao = arguments[_o];
      if (typeof Ao == "function" || typeof Ao == "object" && Ao !== null) {
        let Oo = Co.o;
        Oo === null && (Co.o = Oo = /* @__PURE__ */ new WeakMap());
        const jo = Oo.get(Ao);
        jo === void 0 ? (Co = createCacheNode(), Oo.set(Ao, Co)) : Co = jo;
      } else {
        let Oo = Co.p;
        Oo === null && (Co.p = Oo = /* @__PURE__ */ new Map());
        const jo = Oo.get(Ao);
        jo === void 0 ? (Co = createCacheNode(), Oo.set(Ao, Co)) : Co = jo;
      }
    }
    const wo = Co;
    let Eo;
    if (Co.s === TERMINATED)
      Eo = Co.v;
    else if (Eo = Kt.apply(null, arguments), vo++, go) {
      const _o = ((Ro = bo == null ? void 0 : bo.deref) == null ? void 0 : Ro.call(bo)) ?? bo;
      _o != null && go(_o, Eo) && (Eo = _o, vo !== 0 && vo--), bo = typeof Eo == "object" && Eo !== null || typeof Eo == "function" ? new Ref(Eo) : Eo;
    }
    return wo.s = TERMINATED, wo.v = Eo, Eo;
  }
  return Po.clearCache = () => {
    ho = createCacheNode(), Po.resetResultsCount();
  }, Po.resultsCount = () => vo, Po.resetResultsCount = () => {
    vo = 0;
  }, Po;
}
function createSelectorCreator(Kt, ...uo) {
  const ho = typeof Kt == "function" ? {
    memoize: Kt,
    memoizeOptions: uo
  } : Kt, go = (...bo) => {
    let vo = 0, Po = 0, Co, So = {}, wo = bo.pop();
    typeof wo == "object" && (So = wo, wo = bo.pop()), assertIsFunction(
      wo,
      `createSelector expects an output function after the inputs, but received: [${typeof wo}]`
    );
    const Eo = {
      ...ho,
      ...So
    }, {
      memoize: Ro,
      memoizeOptions: _o = [],
      argsMemoize: Io = weakMapMemoize,
      argsMemoizeOptions: Ao = [],
      devModeChecks: Oo = {}
    } = Eo, jo = ensureIsArray(_o), Do = ensureIsArray(Ao), Lo = getDependencies(bo), ko = Ro(function() {
      return vo++, wo.apply(
        null,
        arguments
      );
    }, ...jo);
    let Ko = !0;
    const No = Io(function() {
      Po++;
      const ti = collectInputSelectorResults(
        Lo,
        arguments
      );
      if (Co = ko.apply(null, ti), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: oi, inputStabilityCheck: Qo } = getDevModeChecksExecutionInfo(Ko, Oo);
        if (oi.shouldRun && oi.run(
          wo,
          ti,
          Co
        ), Qo.shouldRun) {
          const Zo = collectInputSelectorResults(
            Lo,
            arguments
          );
          Qo.run(
            { inputSelectorResults: ti, inputSelectorResultsCopy: Zo },
            { memoize: Ro, memoizeOptions: jo },
            arguments
          );
        }
        Ko && (Ko = !1);
      }
      return Co;
    }, ...Do);
    return Object.assign(No, {
      resultFunc: wo,
      memoizedResultFunc: ko,
      dependencies: Lo,
      dependencyRecomputations: () => Po,
      resetDependencyRecomputations: () => {
        Po = 0;
      },
      lastResult: () => Co,
      recomputations: () => vo,
      resetRecomputations: () => {
        vo = 0;
      },
      memoize: Ro,
      argsMemoize: Io
    });
  };
  return Object.assign(go, {
    withTypes: () => go
  }), go;
}
var createSelector$1 = /* @__PURE__ */ createSelectorCreator(weakMapMemoize), createStructuredSelector = Object.assign(
  (Kt, uo = createSelector$1) => {
    assertIsObject(
      Kt,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof Kt}`
    );
    const ho = Object.keys(Kt), go = ho.map(
      (vo) => Kt[vo]
    );
    return uo(
      go,
      (...vo) => vo.reduce((Po, Co, So) => (Po[ho[So]] = Co, Po), {})
    );
  },
  { withTypes: () => createStructuredSelector }
);
const reselectCreateSelector = createSelectorCreator({
  memoize: lruMemoize,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), cache = /* @__PURE__ */ new WeakMap();
function checkIsAPIRef(Kt) {
  return "current" in Kt && "instanceId" in Kt.current;
}
const DEFAULT_INSTANCE_ID = {
  id: "default"
}, createSelector = (Kt, uo, ho, go, bo, vo, ...Po) => {
  if (Po.length > 0)
    throw new Error("Unsupported number of selectors");
  let Co;
  if (Kt && uo && ho && go && bo && vo)
    Co = (So, wo) => {
      const Eo = checkIsAPIRef(So), Ro = wo ?? (Eo ? So.current.instanceId : DEFAULT_INSTANCE_ID), _o = Eo ? So.current.state : So, Io = Kt(_o, Ro), Ao = uo(_o, Ro), Oo = ho(_o, Ro), jo = go(_o, Ro), Do = bo(_o, Ro);
      return vo(Io, Ao, Oo, jo, Do);
    };
  else if (Kt && uo && ho && go && bo)
    Co = (So, wo) => {
      const Eo = checkIsAPIRef(So), Ro = wo ?? (Eo ? So.current.instanceId : DEFAULT_INSTANCE_ID), _o = Eo ? So.current.state : So, Io = Kt(_o, Ro), Ao = uo(_o, Ro), Oo = ho(_o, Ro), jo = go(_o, Ro);
      return bo(Io, Ao, Oo, jo);
    };
  else if (Kt && uo && ho && go)
    Co = (So, wo) => {
      const Eo = checkIsAPIRef(So), Ro = wo ?? (Eo ? So.current.instanceId : DEFAULT_INSTANCE_ID), _o = Eo ? So.current.state : So, Io = Kt(_o, Ro), Ao = uo(_o, Ro), Oo = ho(_o, Ro);
      return go(Io, Ao, Oo);
    };
  else if (Kt && uo && ho)
    Co = (So, wo) => {
      const Eo = checkIsAPIRef(So), Ro = wo ?? (Eo ? So.current.instanceId : DEFAULT_INSTANCE_ID), _o = Eo ? So.current.state : So, Io = Kt(_o, Ro), Ao = uo(_o, Ro);
      return ho(Io, Ao);
    };
  else if (Kt && uo)
    Co = (So, wo) => {
      const Eo = checkIsAPIRef(So), Ro = wo ?? (Eo ? So.current.instanceId : DEFAULT_INSTANCE_ID), _o = Eo ? So.current.state : So, Io = Kt(_o, Ro);
      return uo(Io);
    };
  else
    throw new Error("Missing arguments");
  return Co.acceptsApiRef = !0, Co;
}, createSelectorMemoized = (...Kt) => {
  const uo = (ho, go) => {
    const bo = checkIsAPIRef(ho), vo = bo ? ho.current.instanceId : go ?? DEFAULT_INSTANCE_ID, Po = bo ? ho.current.state : ho;
    process.env.NODE_ENV !== "production" && vo.id === "default" && warnOnce(["MUI X: A selector was called without passing the instance ID, which may impact the performance of the grid.", "To fix, call it with `apiRef`, for example `mySelector(apiRef)`, or pass the instance ID explicitly, for example `mySelector(state, apiRef.current.instanceId)`."]);
    const Co = cache.get(vo), So = Co ?? /* @__PURE__ */ new Map(), wo = So == null ? void 0 : So.get(Kt);
    if (So && wo)
      return wo(Po, vo);
    const Eo = reselectCreateSelector(...Kt);
    return Co || cache.set(vo, So), So.set(Kt, Eo), Eo(Po, vo);
  };
  return uo.acceptsApiRef = !0, uo;
}, COMPACT_DENSITY_FACTOR = 0.7, COMFORTABLE_DENSITY_FACTOR = 1.3, DENSITY_FACTORS = {
  compact: COMPACT_DENSITY_FACTOR,
  comfortable: COMFORTABLE_DENSITY_FACTOR,
  standard: 1
}, gridDensitySelector = (Kt) => Kt.density, gridDensityFactorSelector = createSelector(gridDensitySelector, (Kt) => DENSITY_FACTORS[Kt]);
let GridPinnedColumnPosition = /* @__PURE__ */ function(Kt) {
  return Kt.LEFT = "left", Kt.RIGHT = "right", Kt;
}({});
const EMPTY_PINNED_COLUMN_FIELDS = {
  left: [],
  right: []
}, gridIsRtlSelector = (Kt) => Kt.isRtl, gridColumnsStateSelector = (Kt) => Kt.columns, gridColumnFieldsSelector = createSelector(gridColumnsStateSelector, (Kt) => Kt.orderedFields), gridColumnLookupSelector = createSelector(gridColumnsStateSelector, (Kt) => Kt.lookup), gridColumnDefinitionsSelector = createSelectorMemoized(gridColumnFieldsSelector, gridColumnLookupSelector, (Kt, uo) => Kt.map((ho) => uo[ho])), gridColumnVisibilityModelSelector = createSelector(gridColumnsStateSelector, (Kt) => Kt.columnVisibilityModel), gridVisibleColumnDefinitionsSelector = createSelectorMemoized(gridColumnDefinitionsSelector, gridColumnVisibilityModelSelector, (Kt, uo) => Kt.filter((ho) => uo[ho.field] !== !1)), gridVisibleColumnFieldsSelector = createSelectorMemoized(gridVisibleColumnDefinitionsSelector, (Kt) => Kt.map((uo) => uo.field)), gridPinnedColumnsSelector = (Kt) => Kt.pinnedColumns, gridVisiblePinnedColumnDefinitionsSelector = createSelectorMemoized(gridColumnsStateSelector, gridPinnedColumnsSelector, gridVisibleColumnFieldsSelector, gridIsRtlSelector, (Kt, uo, ho, go) => {
  const bo = filterVisibleColumns(uo, ho, go);
  return {
    left: bo.left.map((Po) => Kt.lookup[Po]),
    right: bo.right.map((Po) => Kt.lookup[Po])
  };
});
function filterVisibleColumns(Kt, uo, ho) {
  var Co, So;
  if (!Array.isArray(Kt.left) && !Array.isArray(Kt.right) || ((Co = Kt.left) == null ? void 0 : Co.length) === 0 && ((So = Kt.right) == null ? void 0 : So.length) === 0)
    return EMPTY_PINNED_COLUMN_FIELDS;
  const go = (wo, Eo) => Array.isArray(wo) ? wo.filter((Ro) => Eo.includes(Ro)) : [], bo = go(Kt.left, uo), vo = uo.filter(
    // Filter out from the remaining columns those columns already pinned to the left
    (wo) => !bo.includes(wo)
  ), Po = go(Kt.right, vo);
  return ho ? {
    left: Po,
    right: bo
  } : {
    left: bo,
    right: Po
  };
}
const gridColumnPositionsSelector = createSelectorMemoized(gridVisibleColumnDefinitionsSelector, (Kt) => {
  const uo = [];
  let ho = 0;
  for (let go = 0; go < Kt.length; go += 1)
    uo.push(ho), ho += Kt[go].computedWidth;
  return uo;
}), gridColumnsTotalWidthSelector = createSelector(gridVisibleColumnDefinitionsSelector, gridColumnPositionsSelector, (Kt, uo) => {
  const ho = Kt.length;
  return ho === 0 ? 0 : uo[ho - 1] + Kt[ho - 1].computedWidth;
}), gridFilterableColumnDefinitionsSelector = createSelectorMemoized(gridColumnDefinitionsSelector, (Kt) => Kt.filter((uo) => uo.filterable)), gridFilterableColumnLookupSelector = createSelectorMemoized(gridColumnDefinitionsSelector, (Kt) => Kt.reduce((uo, ho) => (ho.filterable && (uo[ho.field] = ho), uo), {})), gridHasColSpanSelector = createSelectorMemoized(gridColumnDefinitionsSelector, (Kt) => Kt.some((uo) => uo.colSpan !== void 0));
function _objectWithoutPropertiesLoose$h(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt) if ({}.hasOwnProperty.call(Kt, go)) {
    if (uo.includes(go)) continue;
    ho[go] = Kt[go];
  }
  return ho;
}
const THEME_ID = "$$material", common = {
  black: "#000",
  white: "#fff"
}, grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
function getLight() {
  return {
    // The colors used to style the text.
    text: {
      // The most important text.
      primary: "rgba(0, 0, 0, 0.87)",
      // Secondary text.
      secondary: "rgba(0, 0, 0, 0.6)",
      // Disabled text have even lower visual prominence.
      disabled: "rgba(0, 0, 0, 0.38)"
    },
    // The color used to divide different elements.
    divider: "rgba(0, 0, 0, 0.12)",
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
      paper: common.white,
      default: common.white
    },
    // The colors used to style the action elements.
    action: {
      // The color of an active action like an icon button.
      active: "rgba(0, 0, 0, 0.54)",
      // The color of an hovered action.
      hover: "rgba(0, 0, 0, 0.04)",
      hoverOpacity: 0.04,
      // The color of a selected action.
      selected: "rgba(0, 0, 0, 0.08)",
      selectedOpacity: 0.08,
      // The color of a disabled action.
      disabled: "rgba(0, 0, 0, 0.26)",
      // The background color of a disabled action.
      disabledBackground: "rgba(0, 0, 0, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(0, 0, 0, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.12
    }
  };
}
const light = getLight();
function getDark() {
  return {
    text: {
      primary: common.white,
      secondary: "rgba(255, 255, 255, 0.7)",
      disabled: "rgba(255, 255, 255, 0.5)",
      icon: "rgba(255, 255, 255, 0.5)"
    },
    divider: "rgba(255, 255, 255, 0.12)",
    background: {
      paper: "#121212",
      default: "#121212"
    },
    action: {
      active: common.white,
      hover: "rgba(255, 255, 255, 0.08)",
      hoverOpacity: 0.08,
      selected: "rgba(255, 255, 255, 0.16)",
      selectedOpacity: 0.16,
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      disabledOpacity: 0.38,
      focus: "rgba(255, 255, 255, 0.12)",
      focusOpacity: 0.12,
      activatedOpacity: 0.24
    }
  };
}
const dark = getDark();
function addLightOrDark(Kt, uo, ho, go) {
  const bo = go.light || go, vo = go.dark || go * 1.5;
  Kt[uo] || (Kt.hasOwnProperty(ho) ? Kt[uo] = Kt[ho] : uo === "light" ? Kt.light = lighten(Kt.main, bo) : uo === "dark" && (Kt.dark = darken(Kt.main, vo)));
}
function getDefaultPrimary(Kt = "light") {
  return Kt === "dark" ? {
    main: blue[200],
    light: blue[50],
    dark: blue[400]
  } : {
    main: blue[700],
    light: blue[400],
    dark: blue[800]
  };
}
function getDefaultSecondary(Kt = "light") {
  return Kt === "dark" ? {
    main: purple[200],
    light: purple[50],
    dark: purple[400]
  } : {
    main: purple[500],
    light: purple[300],
    dark: purple[700]
  };
}
function getDefaultError(Kt = "light") {
  return Kt === "dark" ? {
    main: red[500],
    light: red[300],
    dark: red[700]
  } : {
    main: red[700],
    light: red[400],
    dark: red[800]
  };
}
function getDefaultInfo(Kt = "light") {
  return Kt === "dark" ? {
    main: lightBlue[400],
    light: lightBlue[300],
    dark: lightBlue[700]
  } : {
    main: lightBlue[700],
    light: lightBlue[500],
    dark: lightBlue[900]
  };
}
function getDefaultSuccess(Kt = "light") {
  return Kt === "dark" ? {
    main: green[400],
    light: green[300],
    dark: green[700]
  } : {
    main: green[800],
    light: green[500],
    dark: green[900]
  };
}
function getDefaultWarning(Kt = "light") {
  return Kt === "dark" ? {
    main: orange[400],
    light: orange[300],
    dark: orange[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: orange[500],
    dark: orange[900]
  };
}
function createPalette(Kt) {
  const {
    mode: uo = "light",
    contrastThreshold: ho = 3,
    tonalOffset: go = 0.2,
    ...bo
  } = Kt, vo = Kt.primary || getDefaultPrimary(uo), Po = Kt.secondary || getDefaultSecondary(uo), Co = Kt.error || getDefaultError(uo), So = Kt.info || getDefaultInfo(uo), wo = Kt.success || getDefaultSuccess(uo), Eo = Kt.warning || getDefaultWarning(uo);
  function Ro(Oo) {
    const jo = getContrastRatio(Oo, dark.text.primary) >= ho ? dark.text.primary : light.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const Do = getContrastRatio(Oo, jo);
      Do < 3 && console.error([`MUI: The contrast ratio of ${Do}:1 for ${jo} on ${Oo}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return jo;
  }
  const _o = ({
    color: Oo,
    name: jo,
    mainShade: Do = 500,
    lightShade: Lo = 300,
    darkShade: ko = 700
  }) => {
    if (Oo = {
      ...Oo
    }, !Oo.main && Oo[Do] && (Oo.main = Oo[Do]), !Oo.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${jo ? ` (${jo})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${Do}\` property.` : formatMuiErrorMessage(11, jo ? ` (${jo})` : "", Do));
    if (typeof Oo.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${jo ? ` (${jo})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(Oo.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : formatMuiErrorMessage(12, jo ? ` (${jo})` : "", JSON.stringify(Oo.main)));
    return addLightOrDark(Oo, "light", Lo, go), addLightOrDark(Oo, "dark", ko, go), Oo.contrastText || (Oo.contrastText = Ro(Oo.main)), Oo;
  };
  let Io;
  return uo === "light" ? Io = getLight() : uo === "dark" && (Io = getDark()), process.env.NODE_ENV !== "production" && (Io || console.error(`MUI: The palette mode \`${uo}\` is not supported.`)), deepmerge({
    // A collection of common colors.
    common: {
      ...common
    },
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: uo,
    // The colors used to represent primary interface elements for a user.
    primary: _o({
      color: vo,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: _o({
      color: Po,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: _o({
      color: Co,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: _o({
      color: Eo,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: _o({
      color: So,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: _o({
      color: wo,
      name: "success"
    }),
    // The grey colors.
    grey,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: ho,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: Ro,
    // Generate a rich color object.
    augmentColor: _o,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: go,
    // The light and dark mode object.
    ...Io
  }, bo);
}
function prepareTypographyVars(Kt) {
  const uo = {};
  return Object.entries(Kt).forEach((go) => {
    const [bo, vo] = go;
    typeof vo == "object" && (uo[bo] = `${vo.fontStyle ? `${vo.fontStyle} ` : ""}${vo.fontVariant ? `${vo.fontVariant} ` : ""}${vo.fontWeight ? `${vo.fontWeight} ` : ""}${vo.fontStretch ? `${vo.fontStretch} ` : ""}${vo.fontSize || ""}${vo.lineHeight ? `/${vo.lineHeight} ` : ""}${vo.fontFamily || ""}`);
  }), uo;
}
function createMixins(Kt, uo) {
  return {
    toolbar: {
      minHeight: 56,
      [Kt.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [Kt.up("sm")]: {
        minHeight: 64
      }
    },
    ...uo
  };
}
function round$2(Kt) {
  return Math.round(Kt * 1e5) / 1e5;
}
const caseAllCaps = {
  textTransform: "uppercase"
}, defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(Kt, uo) {
  const {
    fontFamily: ho = defaultFontFamily,
    // The default font size of the Material Specification.
    fontSize: go = 14,
    // px
    fontWeightLight: bo = 300,
    fontWeightRegular: vo = 400,
    fontWeightMedium: Po = 500,
    fontWeightBold: Co = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: So = 16,
    // Apply the CSS properties to all the variants.
    allVariants: wo,
    pxToRem: Eo,
    ...Ro
  } = typeof uo == "function" ? uo(Kt) : uo;
  process.env.NODE_ENV !== "production" && (typeof go != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof So != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const _o = go / 14, Io = Eo || ((jo) => `${jo / So * _o}rem`), Ao = (jo, Do, Lo, ko, Ko) => ({
    fontFamily: ho,
    fontWeight: jo,
    fontSize: Io(Do),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: Lo,
    // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
    // across font-families can cause issues with the kerning.
    ...ho === defaultFontFamily ? {
      letterSpacing: `${round$2(ko / Do)}em`
    } : {},
    ...Ko,
    ...wo
  }), Oo = {
    h1: Ao(bo, 96, 1.167, -1.5),
    h2: Ao(bo, 60, 1.2, -0.5),
    h3: Ao(vo, 48, 1.167, 0),
    h4: Ao(vo, 34, 1.235, 0.25),
    h5: Ao(vo, 24, 1.334, 0),
    h6: Ao(Po, 20, 1.6, 0.15),
    subtitle1: Ao(vo, 16, 1.75, 0.15),
    subtitle2: Ao(Po, 14, 1.57, 0.1),
    body1: Ao(vo, 16, 1.5, 0.15),
    body2: Ao(vo, 14, 1.43, 0.15),
    button: Ao(Po, 14, 1.75, 0.4, caseAllCaps),
    caption: Ao(vo, 12, 1.66, 0.4),
    overline: Ao(vo, 12, 2.66, 1, caseAllCaps),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return deepmerge({
    htmlFontSize: So,
    pxToRem: Io,
    fontFamily: ho,
    fontSize: go,
    fontWeightLight: bo,
    fontWeightRegular: vo,
    fontWeightMedium: Po,
    fontWeightBold: Co,
    ...Oo
  }, Ro, {
    clone: !1
    // No need to clone deep
  });
}
const shadowKeyUmbraOpacity = 0.2, shadowKeyPenumbraOpacity = 0.14, shadowAmbientShadowOpacity = 0.12;
function createShadow(...Kt) {
  return [`${Kt[0]}px ${Kt[1]}px ${Kt[2]}px ${Kt[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${Kt[4]}px ${Kt[5]}px ${Kt[6]}px ${Kt[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${Kt[8]}px ${Kt[9]}px ${Kt[10]}px ${Kt[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(",");
}
const shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(Kt) {
  return `${Math.round(Kt)}ms`;
}
function getAutoHeightDuration(Kt) {
  if (!Kt)
    return 0;
  const uo = Kt / 36;
  return Math.min(Math.round((4 + 15 * uo ** 0.25 + uo / 5) * 10), 3e3);
}
function createTransitions(Kt) {
  const uo = {
    ...easing,
    ...Kt.easing
  }, ho = {
    ...duration,
    ...Kt.duration
  };
  return {
    getAutoHeightDuration,
    create: (bo = ["all"], vo = {}) => {
      const {
        duration: Po = ho.standard,
        easing: Co = uo.easeInOut,
        delay: So = 0,
        ...wo
      } = vo;
      if (process.env.NODE_ENV !== "production") {
        const Eo = (_o) => typeof _o == "string", Ro = (_o) => !Number.isNaN(parseFloat(_o));
        !Eo(bo) && !Array.isArray(bo) && console.error('MUI: Argument "props" must be a string or Array.'), !Ro(Po) && !Eo(Po) && console.error(`MUI: Argument "duration" must be a number or a string but found ${Po}.`), Eo(Co) || console.error('MUI: Argument "easing" must be a string.'), !Ro(So) && !Eo(So) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof vo != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(wo).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(wo).join(",")}].`);
      }
      return (Array.isArray(bo) ? bo : [bo]).map((Eo) => `${Eo} ${typeof Po == "string" ? Po : formatMs(Po)} ${Co} ${typeof So == "string" ? So : formatMs(So)}`).join(",");
    },
    ...Kt,
    easing: uo,
    duration: ho
  };
}
const zIndex = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
function isSerializable(Kt) {
  return isPlainObject$2(Kt) || typeof Kt > "u" || typeof Kt == "string" || typeof Kt == "boolean" || typeof Kt == "number" || Array.isArray(Kt);
}
function stringifyTheme(Kt = {}) {
  const uo = {
    ...Kt
  };
  function ho(go) {
    const bo = Object.entries(go);
    for (let vo = 0; vo < bo.length; vo++) {
      const [Po, Co] = bo[vo];
      !isSerializable(Co) || Po.startsWith("unstable_") ? delete go[Po] : isPlainObject$2(Co) && (go[Po] = {
        ...Co
      }, ho(go[Po]));
    }
  }
  return ho(uo), `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(uo, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}
function createThemeNoVars(Kt = {}, ...uo) {
  const {
    breakpoints: ho,
    mixins: go = {},
    spacing: bo,
    palette: vo = {},
    transitions: Po = {},
    typography: Co = {},
    shape: So,
    ...wo
  } = Kt;
  if (Kt.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : formatMuiErrorMessage(20));
  const Eo = createPalette(vo), Ro = createTheme$1(Kt);
  let _o = deepmerge(Ro, {
    mixins: createMixins(Ro.breakpoints, go),
    palette: Eo,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows.slice(),
    typography: createTypography(Eo, Co),
    transitions: createTransitions(Po),
    zIndex: {
      ...zIndex
    }
  });
  if (_o = deepmerge(_o, wo), _o = uo.reduce((Io, Ao) => deepmerge(Io, Ao), _o), process.env.NODE_ENV !== "production") {
    const Io = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], Ao = (Oo, jo) => {
      let Do;
      for (Do in Oo) {
        const Lo = Oo[Do];
        if (Io.includes(Do) && Object.keys(Lo).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const ko = generateUtilityClass$1("", Do);
            console.error([`MUI: The \`${jo}\` component increases the CSS specificity of the \`${Do}\` internal state.`, "You can not override it like this: ", JSON.stringify(Oo, null, 2), "", `Instead, you need to use the '&.${ko}' syntax:`, JSON.stringify({
              root: {
                [`&.${ko}`]: Lo
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          Oo[Do] = {};
        }
      }
    };
    Object.keys(_o.components).forEach((Oo) => {
      const jo = _o.components[Oo].styleOverrides;
      jo && Oo.startsWith("Mui") && Ao(jo, Oo);
    });
  }
  return _o.unstable_sxConfig = {
    ...defaultSxConfig,
    ...wo == null ? void 0 : wo.unstable_sxConfig
  }, _o.unstable_sx = function(Ao) {
    return styleFunctionSx({
      sx: Ao,
      theme: this
    });
  }, _o.toRuntimeSource = stringifyTheme, _o;
}
function getOverlayAlpha(Kt) {
  let uo;
  return Kt < 1 ? uo = 5.11916 * Kt ** 2 : uo = 4.5 * Math.log(Kt + 1) + 2, Math.round(uo * 10) / 1e3;
}
const defaultDarkOverlays = [...Array(25)].map((Kt, uo) => {
  if (uo === 0)
    return "none";
  const ho = getOverlayAlpha(uo);
  return `linear-gradient(rgba(255 255 255 / ${ho}), rgba(255 255 255 / ${ho}))`;
});
function getOpacity(Kt) {
  return {
    inputPlaceholder: Kt === "dark" ? 0.5 : 0.42,
    inputUnderline: Kt === "dark" ? 0.7 : 0.42,
    switchTrackDisabled: Kt === "dark" ? 0.2 : 0.12,
    switchTrack: Kt === "dark" ? 0.3 : 0.38
  };
}
function getOverlays(Kt) {
  return Kt === "dark" ? defaultDarkOverlays : [];
}
function createColorScheme(Kt) {
  const {
    palette: uo = {
      mode: "light"
    },
    // need to cast to avoid module augmentation test
    opacity: ho,
    overlays: go,
    ...bo
  } = Kt, vo = createPalette(uo);
  return {
    palette: vo,
    opacity: {
      ...getOpacity(vo.mode),
      ...ho
    },
    overlays: go || getOverlays(vo.mode),
    ...bo
  };
}
function shouldSkipGeneratingVar(Kt) {
  var uo;
  return !!Kt[0].match(/(cssVarPrefix|colorSchemeSelector|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!Kt[0].match(/sxConfig$/) || // ends with sxConfig
  Kt[0] === "palette" && !!((uo = Kt[1]) != null && uo.match(/(mode|contrastThreshold|tonalOffset)/));
}
const excludeVariablesFromRoot = (Kt) => [...[...Array(25)].map((uo, ho) => `--${Kt ? `${Kt}-` : ""}overlays-${ho}`), `--${Kt ? `${Kt}-` : ""}palette-AppBar-darkBg`, `--${Kt ? `${Kt}-` : ""}palette-AppBar-darkColor`], defaultGetSelector = (Kt) => (uo, ho) => {
  const go = Kt.rootSelector || ":root", bo = Kt.colorSchemeSelector;
  let vo = bo;
  if (bo === "class" && (vo = ".%s"), bo === "data" && (vo = "[data-%s]"), bo != null && bo.startsWith("data-") && !bo.includes("%s") && (vo = `[${bo}="%s"]`), Kt.defaultColorScheme === uo) {
    if (uo === "dark") {
      const Po = {};
      return excludeVariablesFromRoot(Kt.cssVarPrefix).forEach((Co) => {
        Po[Co] = ho[Co], delete ho[Co];
      }), vo === "media" ? {
        [go]: ho,
        "@media (prefers-color-scheme: dark)": {
          [go]: Po
        }
      } : vo ? {
        [vo.replace("%s", uo)]: Po,
        [`${go}, ${vo.replace("%s", uo)}`]: ho
      } : {
        [go]: {
          ...ho,
          ...Po
        }
      };
    }
    if (vo && vo !== "media")
      return `${go}, ${vo.replace("%s", String(uo))}`;
  } else if (uo) {
    if (vo === "media")
      return {
        [`@media (prefers-color-scheme: ${String(uo)})`]: {
          [go]: ho
        }
      };
    if (vo)
      return vo.replace("%s", String(uo));
  }
  return go;
};
function assignNode(Kt, uo) {
  uo.forEach((ho) => {
    Kt[ho] || (Kt[ho] = {});
  });
}
function setColor(Kt, uo, ho) {
  !Kt[uo] && ho && (Kt[uo] = ho);
}
function toRgb(Kt) {
  return typeof Kt != "string" || !Kt.startsWith("hsl") ? Kt : hslToRgb(Kt);
}
function setColorChannel(Kt, uo) {
  `${uo}Channel` in Kt || (Kt[`${uo}Channel`] = private_safeColorChannel(toRgb(Kt[uo]), `MUI: Can't create \`palette.${uo}Channel\` because \`palette.${uo}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().
To suppress this warning, you need to explicitly provide the \`palette.${uo}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`));
}
function getSpacingVal(Kt) {
  return typeof Kt == "number" ? `${Kt}px` : typeof Kt == "string" || typeof Kt == "function" || Array.isArray(Kt) ? Kt : "8px";
}
const silent = (Kt) => {
  try {
    return Kt();
  } catch {
  }
}, createGetCssVar = (Kt = "mui") => createGetCssVar$1(Kt);
function attachColorScheme$1(Kt, uo, ho, go) {
  if (!uo)
    return;
  uo = uo === !0 ? {} : uo;
  const bo = go === "dark" ? "dark" : "light";
  if (!ho) {
    Kt[go] = createColorScheme({
      ...uo,
      palette: {
        mode: bo,
        ...uo == null ? void 0 : uo.palette
      }
    });
    return;
  }
  const {
    palette: vo,
    ...Po
  } = createThemeNoVars({
    ...ho,
    palette: {
      mode: bo,
      ...uo == null ? void 0 : uo.palette
    }
  });
  return Kt[go] = {
    ...uo,
    palette: vo,
    opacity: {
      ...getOpacity(bo),
      ...uo == null ? void 0 : uo.opacity
    },
    overlays: (uo == null ? void 0 : uo.overlays) || getOverlays(bo)
  }, Po;
}
function createThemeWithVars(Kt = {}, ...uo) {
  const {
    colorSchemes: ho = {
      light: !0
    },
    defaultColorScheme: go,
    disableCssColorScheme: bo = !1,
    cssVarPrefix: vo = "mui",
    shouldSkipGeneratingVar: Po = shouldSkipGeneratingVar,
    colorSchemeSelector: Co = ho.light && ho.dark ? "media" : void 0,
    rootSelector: So = ":root",
    ...wo
  } = Kt, Eo = Object.keys(ho)[0], Ro = go || (ho.light && Eo !== "light" ? "light" : Eo), _o = createGetCssVar(vo), {
    [Ro]: Io,
    light: Ao,
    dark: Oo,
    ...jo
  } = ho, Do = {
    ...jo
  };
  let Lo = Io;
  if ((Ro === "dark" && !("dark" in ho) || Ro === "light" && !("light" in ho)) && (Lo = !0), !Lo)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The \`colorSchemes.${Ro}\` option is either missing or invalid.` : formatMuiErrorMessage(21, Ro));
  const ko = attachColorScheme$1(Do, Lo, wo, Ro);
  Ao && !Do.light && attachColorScheme$1(Do, Ao, void 0, "light"), Oo && !Do.dark && attachColorScheme$1(Do, Oo, void 0, "dark");
  let Ko = {
    defaultColorScheme: Ro,
    ...ko,
    cssVarPrefix: vo,
    colorSchemeSelector: Co,
    rootSelector: So,
    getCssVar: _o,
    colorSchemes: Do,
    font: {
      ...prepareTypographyVars(ko.typography),
      ...ko.font
    },
    spacing: getSpacingVal(wo.spacing)
  };
  Object.keys(Ko.colorSchemes).forEach((Qo) => {
    const Zo = Ko.colorSchemes[Qo].palette, ei = (ii) => {
      const ai = ii.split("-"), ri = ai[1], ni = ai[2];
      return _o(ii, Zo[ri][ni]);
    };
    if (Zo.mode === "light" && (setColor(Zo.common, "background", "#fff"), setColor(Zo.common, "onBackground", "#000")), Zo.mode === "dark" && (setColor(Zo.common, "background", "#000"), setColor(Zo.common, "onBackground", "#fff")), assignNode(Zo, ["Alert", "AppBar", "Avatar", "Button", "Chip", "FilledInput", "LinearProgress", "Skeleton", "Slider", "SnackbarContent", "SpeedDialAction", "StepConnector", "StepContent", "Switch", "TableCell", "Tooltip"]), Zo.mode === "light") {
      setColor(Zo.Alert, "errorColor", private_safeDarken(Zo.error.light, 0.6)), setColor(Zo.Alert, "infoColor", private_safeDarken(Zo.info.light, 0.6)), setColor(Zo.Alert, "successColor", private_safeDarken(Zo.success.light, 0.6)), setColor(Zo.Alert, "warningColor", private_safeDarken(Zo.warning.light, 0.6)), setColor(Zo.Alert, "errorFilledBg", ei("palette-error-main")), setColor(Zo.Alert, "infoFilledBg", ei("palette-info-main")), setColor(Zo.Alert, "successFilledBg", ei("palette-success-main")), setColor(Zo.Alert, "warningFilledBg", ei("palette-warning-main")), setColor(Zo.Alert, "errorFilledColor", silent(() => Zo.getContrastText(Zo.error.main))), setColor(Zo.Alert, "infoFilledColor", silent(() => Zo.getContrastText(Zo.info.main))), setColor(Zo.Alert, "successFilledColor", silent(() => Zo.getContrastText(Zo.success.main))), setColor(Zo.Alert, "warningFilledColor", silent(() => Zo.getContrastText(Zo.warning.main))), setColor(Zo.Alert, "errorStandardBg", private_safeLighten(Zo.error.light, 0.9)), setColor(Zo.Alert, "infoStandardBg", private_safeLighten(Zo.info.light, 0.9)), setColor(Zo.Alert, "successStandardBg", private_safeLighten(Zo.success.light, 0.9)), setColor(Zo.Alert, "warningStandardBg", private_safeLighten(Zo.warning.light, 0.9)), setColor(Zo.Alert, "errorIconColor", ei("palette-error-main")), setColor(Zo.Alert, "infoIconColor", ei("palette-info-main")), setColor(Zo.Alert, "successIconColor", ei("palette-success-main")), setColor(Zo.Alert, "warningIconColor", ei("palette-warning-main")), setColor(Zo.AppBar, "defaultBg", ei("palette-grey-100")), setColor(Zo.Avatar, "defaultBg", ei("palette-grey-400")), setColor(Zo.Button, "inheritContainedBg", ei("palette-grey-300")), setColor(Zo.Button, "inheritContainedHoverBg", ei("palette-grey-A100")), setColor(Zo.Chip, "defaultBorder", ei("palette-grey-400")), setColor(Zo.Chip, "defaultAvatarColor", ei("palette-grey-700")), setColor(Zo.Chip, "defaultIconColor", ei("palette-grey-700")), setColor(Zo.FilledInput, "bg", "rgba(0, 0, 0, 0.06)"), setColor(Zo.FilledInput, "hoverBg", "rgba(0, 0, 0, 0.09)"), setColor(Zo.FilledInput, "disabledBg", "rgba(0, 0, 0, 0.12)"), setColor(Zo.LinearProgress, "primaryBg", private_safeLighten(Zo.primary.main, 0.62)), setColor(Zo.LinearProgress, "secondaryBg", private_safeLighten(Zo.secondary.main, 0.62)), setColor(Zo.LinearProgress, "errorBg", private_safeLighten(Zo.error.main, 0.62)), setColor(Zo.LinearProgress, "infoBg", private_safeLighten(Zo.info.main, 0.62)), setColor(Zo.LinearProgress, "successBg", private_safeLighten(Zo.success.main, 0.62)), setColor(Zo.LinearProgress, "warningBg", private_safeLighten(Zo.warning.main, 0.62)), setColor(Zo.Skeleton, "bg", `rgba(${ei("palette-text-primaryChannel")} / 0.11)`), setColor(Zo.Slider, "primaryTrack", private_safeLighten(Zo.primary.main, 0.62)), setColor(Zo.Slider, "secondaryTrack", private_safeLighten(Zo.secondary.main, 0.62)), setColor(Zo.Slider, "errorTrack", private_safeLighten(Zo.error.main, 0.62)), setColor(Zo.Slider, "infoTrack", private_safeLighten(Zo.info.main, 0.62)), setColor(Zo.Slider, "successTrack", private_safeLighten(Zo.success.main, 0.62)), setColor(Zo.Slider, "warningTrack", private_safeLighten(Zo.warning.main, 0.62));
      const ii = private_safeEmphasize(Zo.background.default, 0.8);
      setColor(Zo.SnackbarContent, "bg", ii), setColor(Zo.SnackbarContent, "color", silent(() => Zo.getContrastText(ii))), setColor(Zo.SpeedDialAction, "fabHoverBg", private_safeEmphasize(Zo.background.paper, 0.15)), setColor(Zo.StepConnector, "border", ei("palette-grey-400")), setColor(Zo.StepContent, "border", ei("palette-grey-400")), setColor(Zo.Switch, "defaultColor", ei("palette-common-white")), setColor(Zo.Switch, "defaultDisabledColor", ei("palette-grey-100")), setColor(Zo.Switch, "primaryDisabledColor", private_safeLighten(Zo.primary.main, 0.62)), setColor(Zo.Switch, "secondaryDisabledColor", private_safeLighten(Zo.secondary.main, 0.62)), setColor(Zo.Switch, "errorDisabledColor", private_safeLighten(Zo.error.main, 0.62)), setColor(Zo.Switch, "infoDisabledColor", private_safeLighten(Zo.info.main, 0.62)), setColor(Zo.Switch, "successDisabledColor", private_safeLighten(Zo.success.main, 0.62)), setColor(Zo.Switch, "warningDisabledColor", private_safeLighten(Zo.warning.main, 0.62)), setColor(Zo.TableCell, "border", private_safeLighten(private_safeAlpha(Zo.divider, 1), 0.88)), setColor(Zo.Tooltip, "bg", private_safeAlpha(Zo.grey[700], 0.92));
    }
    if (Zo.mode === "dark") {
      setColor(Zo.Alert, "errorColor", private_safeLighten(Zo.error.light, 0.6)), setColor(Zo.Alert, "infoColor", private_safeLighten(Zo.info.light, 0.6)), setColor(Zo.Alert, "successColor", private_safeLighten(Zo.success.light, 0.6)), setColor(Zo.Alert, "warningColor", private_safeLighten(Zo.warning.light, 0.6)), setColor(Zo.Alert, "errorFilledBg", ei("palette-error-dark")), setColor(Zo.Alert, "infoFilledBg", ei("palette-info-dark")), setColor(Zo.Alert, "successFilledBg", ei("palette-success-dark")), setColor(Zo.Alert, "warningFilledBg", ei("palette-warning-dark")), setColor(Zo.Alert, "errorFilledColor", silent(() => Zo.getContrastText(Zo.error.dark))), setColor(Zo.Alert, "infoFilledColor", silent(() => Zo.getContrastText(Zo.info.dark))), setColor(Zo.Alert, "successFilledColor", silent(() => Zo.getContrastText(Zo.success.dark))), setColor(Zo.Alert, "warningFilledColor", silent(() => Zo.getContrastText(Zo.warning.dark))), setColor(Zo.Alert, "errorStandardBg", private_safeDarken(Zo.error.light, 0.9)), setColor(Zo.Alert, "infoStandardBg", private_safeDarken(Zo.info.light, 0.9)), setColor(Zo.Alert, "successStandardBg", private_safeDarken(Zo.success.light, 0.9)), setColor(Zo.Alert, "warningStandardBg", private_safeDarken(Zo.warning.light, 0.9)), setColor(Zo.Alert, "errorIconColor", ei("palette-error-main")), setColor(Zo.Alert, "infoIconColor", ei("palette-info-main")), setColor(Zo.Alert, "successIconColor", ei("palette-success-main")), setColor(Zo.Alert, "warningIconColor", ei("palette-warning-main")), setColor(Zo.AppBar, "defaultBg", ei("palette-grey-900")), setColor(Zo.AppBar, "darkBg", ei("palette-background-paper")), setColor(Zo.AppBar, "darkColor", ei("palette-text-primary")), setColor(Zo.Avatar, "defaultBg", ei("palette-grey-600")), setColor(Zo.Button, "inheritContainedBg", ei("palette-grey-800")), setColor(Zo.Button, "inheritContainedHoverBg", ei("palette-grey-700")), setColor(Zo.Chip, "defaultBorder", ei("palette-grey-700")), setColor(Zo.Chip, "defaultAvatarColor", ei("palette-grey-300")), setColor(Zo.Chip, "defaultIconColor", ei("palette-grey-300")), setColor(Zo.FilledInput, "bg", "rgba(255, 255, 255, 0.09)"), setColor(Zo.FilledInput, "hoverBg", "rgba(255, 255, 255, 0.13)"), setColor(Zo.FilledInput, "disabledBg", "rgba(255, 255, 255, 0.12)"), setColor(Zo.LinearProgress, "primaryBg", private_safeDarken(Zo.primary.main, 0.5)), setColor(Zo.LinearProgress, "secondaryBg", private_safeDarken(Zo.secondary.main, 0.5)), setColor(Zo.LinearProgress, "errorBg", private_safeDarken(Zo.error.main, 0.5)), setColor(Zo.LinearProgress, "infoBg", private_safeDarken(Zo.info.main, 0.5)), setColor(Zo.LinearProgress, "successBg", private_safeDarken(Zo.success.main, 0.5)), setColor(Zo.LinearProgress, "warningBg", private_safeDarken(Zo.warning.main, 0.5)), setColor(Zo.Skeleton, "bg", `rgba(${ei("palette-text-primaryChannel")} / 0.13)`), setColor(Zo.Slider, "primaryTrack", private_safeDarken(Zo.primary.main, 0.5)), setColor(Zo.Slider, "secondaryTrack", private_safeDarken(Zo.secondary.main, 0.5)), setColor(Zo.Slider, "errorTrack", private_safeDarken(Zo.error.main, 0.5)), setColor(Zo.Slider, "infoTrack", private_safeDarken(Zo.info.main, 0.5)), setColor(Zo.Slider, "successTrack", private_safeDarken(Zo.success.main, 0.5)), setColor(Zo.Slider, "warningTrack", private_safeDarken(Zo.warning.main, 0.5));
      const ii = private_safeEmphasize(Zo.background.default, 0.98);
      setColor(Zo.SnackbarContent, "bg", ii), setColor(Zo.SnackbarContent, "color", silent(() => Zo.getContrastText(ii))), setColor(Zo.SpeedDialAction, "fabHoverBg", private_safeEmphasize(Zo.background.paper, 0.15)), setColor(Zo.StepConnector, "border", ei("palette-grey-600")), setColor(Zo.StepContent, "border", ei("palette-grey-600")), setColor(Zo.Switch, "defaultColor", ei("palette-grey-300")), setColor(Zo.Switch, "defaultDisabledColor", ei("palette-grey-600")), setColor(Zo.Switch, "primaryDisabledColor", private_safeDarken(Zo.primary.main, 0.55)), setColor(Zo.Switch, "secondaryDisabledColor", private_safeDarken(Zo.secondary.main, 0.55)), setColor(Zo.Switch, "errorDisabledColor", private_safeDarken(Zo.error.main, 0.55)), setColor(Zo.Switch, "infoDisabledColor", private_safeDarken(Zo.info.main, 0.55)), setColor(Zo.Switch, "successDisabledColor", private_safeDarken(Zo.success.main, 0.55)), setColor(Zo.Switch, "warningDisabledColor", private_safeDarken(Zo.warning.main, 0.55)), setColor(Zo.TableCell, "border", private_safeDarken(private_safeAlpha(Zo.divider, 1), 0.68)), setColor(Zo.Tooltip, "bg", private_safeAlpha(Zo.grey[700], 0.92));
    }
    setColorChannel(Zo.background, "default"), setColorChannel(Zo.background, "paper"), setColorChannel(Zo.common, "background"), setColorChannel(Zo.common, "onBackground"), setColorChannel(Zo, "divider"), Object.keys(Zo).forEach((ii) => {
      const ai = Zo[ii];
      ii !== "tonalOffset" && ai && typeof ai == "object" && (ai.main && setColor(Zo[ii], "mainChannel", private_safeColorChannel(toRgb(ai.main))), ai.light && setColor(Zo[ii], "lightChannel", private_safeColorChannel(toRgb(ai.light))), ai.dark && setColor(Zo[ii], "darkChannel", private_safeColorChannel(toRgb(ai.dark))), ai.contrastText && setColor(Zo[ii], "contrastTextChannel", private_safeColorChannel(toRgb(ai.contrastText))), ii === "text" && (setColorChannel(Zo[ii], "primary"), setColorChannel(Zo[ii], "secondary")), ii === "action" && (ai.active && setColorChannel(Zo[ii], "active"), ai.selected && setColorChannel(Zo[ii], "selected")));
    });
  }), Ko = uo.reduce((Qo, Zo) => deepmerge(Qo, Zo), Ko);
  const No = {
    prefix: vo,
    disableCssColorScheme: bo,
    shouldSkipGeneratingVar: Po,
    getSelector: defaultGetSelector(Ko)
  }, {
    vars: Jo,
    generateThemeVars: ti,
    generateStyleSheets: oi
  } = prepareCssVars(Ko, No);
  return Ko.vars = Jo, Object.entries(Ko.colorSchemes[Ko.defaultColorScheme]).forEach(([Qo, Zo]) => {
    Ko[Qo] = Zo;
  }), Ko.generateThemeVars = ti, Ko.generateStyleSheets = oi, Ko.generateSpacing = function() {
    return createSpacing(wo.spacing, createUnarySpacing(this));
  }, Ko.getColorSchemeSelector = createGetColorSchemeSelector(Co), Ko.spacing = Ko.generateSpacing(), Ko.shouldSkipGeneratingVar = Po, Ko.unstable_sxConfig = {
    ...defaultSxConfig,
    ...wo == null ? void 0 : wo.unstable_sxConfig
  }, Ko.unstable_sx = function(Zo) {
    return styleFunctionSx({
      sx: Zo,
      theme: this
    });
  }, Ko.toRuntimeSource = stringifyTheme, Ko;
}
function attachColorScheme(Kt, uo, ho) {
  Kt.colorSchemes && ho && (Kt.colorSchemes[uo] = {
    ...ho !== !0 && ho,
    palette: createPalette({
      ...ho === !0 ? {} : ho.palette,
      mode: uo
    })
    // cast type to skip module augmentation test
  });
}
function createTheme(Kt = {}, ...uo) {
  const {
    palette: ho,
    cssVariables: go = !1,
    colorSchemes: bo = ho ? void 0 : {
      light: !0
    },
    defaultColorScheme: vo = ho == null ? void 0 : ho.mode,
    ...Po
  } = Kt, Co = vo || "light", So = bo == null ? void 0 : bo[Co], wo = {
    ...bo,
    ...ho ? {
      [Co]: {
        ...typeof So != "boolean" && So,
        palette: ho
      }
    } : void 0
  };
  if (go === !1) {
    if (!("colorSchemes" in Kt))
      return createThemeNoVars(Kt, ...uo);
    let Eo = ho;
    "palette" in Kt || wo[Co] && (wo[Co] !== !0 ? Eo = wo[Co].palette : Co === "dark" && (Eo = {
      mode: "dark"
    }));
    const Ro = createThemeNoVars({
      ...Kt,
      palette: Eo
    }, ...uo);
    return Ro.defaultColorScheme = Co, Ro.colorSchemes = wo, Ro.palette.mode === "light" && (Ro.colorSchemes.light = {
      ...wo.light !== !0 && wo.light,
      palette: Ro.palette
    }, attachColorScheme(Ro, "dark", wo.dark)), Ro.palette.mode === "dark" && (Ro.colorSchemes.dark = {
      ...wo.dark !== !0 && wo.dark,
      palette: Ro.palette
    }, attachColorScheme(Ro, "light", wo.light)), Ro;
  }
  return !ho && !("light" in wo) && Co === "light" && (wo.light = !0), createThemeWithVars({
    ...Po,
    colorSchemes: wo,
    defaultColorScheme: Co,
    ...typeof go != "boolean" && go
  }, ...uo);
}
function getUnit(Kt) {
  return String(Kt).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(Kt) {
  return parseFloat(Kt);
}
const defaultTheme = createTheme();
function useTheme() {
  const Kt = useTheme$1(defaultTheme);
  return process.env.NODE_ENV !== "production" && React$1.useDebugValue(Kt), Kt[THEME_ID] || Kt;
}
function useThemeProps({
  props: Kt,
  name: uo
}) {
  return useThemeProps$1({
    props: Kt,
    name: uo,
    defaultTheme,
    themeId: THEME_ID
  });
}
function slotShouldForwardProp(Kt) {
  return Kt !== "ownerState" && Kt !== "theme" && Kt !== "sx" && Kt !== "as";
}
const rootShouldForwardProp = (Kt) => slotShouldForwardProp(Kt) && Kt !== "classes", styled = createStyled({
  themeId: THEME_ID,
  defaultTheme,
  rootShouldForwardProp
});
function getStyleValue(Kt) {
  return parseInt(Kt, 10) || 0;
}
const styles$2 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function isEmpty$1(Kt) {
  return Kt == null || Object.keys(Kt).length === 0 || Kt.outerHeightStyle === 0 && !Kt.overflowing;
}
const TextareaAutosize = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    onChange: go,
    maxRows: bo,
    minRows: vo = 1,
    style: Po,
    value: Co,
    ...So
  } = uo, {
    current: wo
  } = React$1.useRef(Co != null), Eo = React$1.useRef(null), Ro = useForkRef(ho, Eo), _o = React$1.useRef(null), Io = React$1.useRef(null), Ao = React$1.useCallback(() => {
    const Do = Eo.current, ko = ownerWindow(Do).getComputedStyle(Do);
    if (ko.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const Ko = Io.current;
    Ko.style.width = ko.width, Ko.value = Do.value || uo.placeholder || "x", Ko.value.slice(-1) === `
` && (Ko.value += " ");
    const No = ko.boxSizing, Jo = getStyleValue(ko.paddingBottom) + getStyleValue(ko.paddingTop), ti = getStyleValue(ko.borderBottomWidth) + getStyleValue(ko.borderTopWidth), oi = Ko.scrollHeight;
    Ko.value = "x";
    const Qo = Ko.scrollHeight;
    let Zo = oi;
    vo && (Zo = Math.max(Number(vo) * Qo, Zo)), bo && (Zo = Math.min(Number(bo) * Qo, Zo)), Zo = Math.max(Zo, Qo);
    const ei = Zo + (No === "border-box" ? Jo + ti : 0), ii = Math.abs(Zo - oi) <= 1;
    return {
      outerHeightStyle: ei,
      overflowing: ii
    };
  }, [bo, vo, uo.placeholder]), Oo = React$1.useCallback(() => {
    const Do = Ao();
    if (isEmpty$1(Do))
      return;
    const Lo = Do.outerHeightStyle, ko = Eo.current;
    _o.current !== Lo && (_o.current = Lo, ko.style.height = `${Lo}px`), ko.style.overflow = Do.overflowing ? "hidden" : "";
  }, [Ao]);
  useEnhancedEffect(() => {
    const Do = () => {
      Oo();
    };
    let Lo;
    const ko = () => {
      cancelAnimationFrame(Lo), Lo = requestAnimationFrame(() => {
        Do();
      });
    }, Ko = debounce$3(Do), No = Eo.current, Jo = ownerWindow(No);
    Jo.addEventListener("resize", Ko);
    let ti;
    return typeof ResizeObserver < "u" && (ti = new ResizeObserver(process.env.NODE_ENV === "test" ? ko : Do), ti.observe(No)), () => {
      Ko.clear(), cancelAnimationFrame(Lo), Jo.removeEventListener("resize", Ko), ti && ti.disconnect();
    };
  }, [Ao, Oo]), useEnhancedEffect(() => {
    Oo();
  });
  const jo = (Do) => {
    wo || Oo(), go && go(Do);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      value: Co,
      onChange: jo,
      ref: Ro,
      rows: vo,
      style: Po,
      ...So
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("textarea", {
      "aria-hidden": !0,
      className: uo.className,
      readOnly: !0,
      ref: Io,
      tabIndex: -1,
      style: {
        ...styles$2.shadow,
        ...Po,
        paddingTop: 0,
        paddingBottom: 0
      }
    })]
  });
});
process.env.NODE_ENV !== "production" && (TextareaAutosize.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  placeholder: PropTypes.string,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * @ignore
   */
  value: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.number, PropTypes.string])
});
function isHostComponent(Kt) {
  return typeof Kt == "string";
}
function formControlState({
  props: Kt,
  states: uo,
  muiFormControl: ho
}) {
  return uo.reduce((go, bo) => (go[bo] = Kt[bo], ho && typeof Kt[bo] > "u" && (go[bo] = ho[bo]), go), {});
}
const FormControlContext = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (FormControlContext.displayName = "FormControlContext");
function useFormControl() {
  return React$1.useContext(FormControlContext);
}
function GlobalStyles(Kt) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, {
    ...Kt,
    defaultTheme,
    themeId: THEME_ID
  });
}
process.env.NODE_ENV !== "production" && (GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
});
function globalCss(Kt) {
  return function(ho) {
    return (
      // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
      /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles, {
        styles: typeof Kt == "function" ? (go) => Kt({
          theme: go,
          ...ho
        }) : Kt
      })
    );
  };
}
function internal_createExtendSxProp() {
  return extendSxProp$1;
}
const memoTheme = unstable_memoTheme;
process.env.NODE_ENV !== "production" && (PropTypes.node, PropTypes.object.isRequired);
function useDefaultProps(Kt) {
  return useDefaultProps$1(Kt);
}
function hasValue(Kt) {
  return Kt != null && !(Array.isArray(Kt) && Kt.length === 0);
}
function isFilled(Kt, uo = !1) {
  return Kt && (hasValue(Kt.value) && Kt.value !== "" || uo && hasValue(Kt.defaultValue) && Kt.defaultValue !== "");
}
function isAdornedStart(Kt) {
  return Kt.startAdornment;
}
function getInputBaseUtilityClass(Kt) {
  return generateUtilityClass$1("MuiInputBase", Kt);
}
const inputBaseClasses = generateUtilityClasses$1("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]);
var _InputGlobalStyles;
const rootOverridesResolver = (Kt, uo) => {
  const {
    ownerState: ho
  } = Kt;
  return [uo.root, ho.formControl && uo.formControl, ho.startAdornment && uo.adornedStart, ho.endAdornment && uo.adornedEnd, ho.error && uo.error, ho.size === "small" && uo.sizeSmall, ho.multiline && uo.multiline, ho.color && uo[`color${capitalize(ho.color)}`], ho.fullWidth && uo.fullWidth, ho.hiddenLabel && uo.hiddenLabel];
}, inputOverridesResolver = (Kt, uo) => {
  const {
    ownerState: ho
  } = Kt;
  return [uo.input, ho.size === "small" && uo.inputSizeSmall, ho.multiline && uo.inputMultiline, ho.type === "search" && uo.inputTypeSearch, ho.startAdornment && uo.inputAdornedStart, ho.endAdornment && uo.inputAdornedEnd, ho.hiddenLabel && uo.inputHiddenLabel];
}, useUtilityClasses$1o = (Kt) => {
  const {
    classes: uo,
    color: ho,
    disabled: go,
    error: bo,
    endAdornment: vo,
    focused: Po,
    formControl: Co,
    fullWidth: So,
    hiddenLabel: wo,
    multiline: Eo,
    readOnly: Ro,
    size: _o,
    startAdornment: Io,
    type: Ao
  } = Kt, Oo = {
    root: ["root", `color${capitalize(ho)}`, go && "disabled", bo && "error", So && "fullWidth", Po && "focused", Co && "formControl", _o && _o !== "medium" && `size${capitalize(_o)}`, Eo && "multiline", Io && "adornedStart", vo && "adornedEnd", wo && "hiddenLabel", Ro && "readOnly"],
    input: ["input", go && "disabled", Ao === "search" && "inputTypeSearch", Eo && "inputMultiline", _o === "small" && "inputSizeSmall", wo && "inputHiddenLabel", Io && "inputAdornedStart", vo && "inputAdornedEnd", Ro && "readOnly"]
  };
  return composeClasses(Oo, getInputBaseUtilityClass, uo);
}, InputBaseRoot = styled("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body1,
  color: (Kt.vars || Kt).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${inputBaseClasses.disabled}`]: {
    color: (Kt.vars || Kt).palette.text.disabled,
    cursor: "default"
  },
  variants: [{
    props: ({
      ownerState: uo
    }) => uo.multiline,
    style: {
      padding: "4px 0 5px"
    }
  }, {
    props: ({
      ownerState: uo,
      size: ho
    }) => uo.multiline && ho === "small",
    style: {
      paddingTop: 1
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.fullWidth,
    style: {
      width: "100%"
    }
  }]
}))), InputBaseInput = styled("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme: Kt
}) => {
  const uo = Kt.palette.mode === "light", ho = {
    color: "currentColor",
    ...Kt.vars ? {
      opacity: Kt.vars.opacity.inputPlaceholder
    } : {
      opacity: uo ? 0.42 : 0.5
    },
    transition: Kt.transitions.create("opacity", {
      duration: Kt.transitions.duration.shorter
    })
  }, go = {
    opacity: "0 !important"
  }, bo = Kt.vars ? {
    opacity: Kt.vars.opacity.inputPlaceholder
  } : {
    opacity: uo ? 0.42 : 0.5
  };
  return {
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    "&::-webkit-input-placeholder": ho,
    "&::-moz-placeholder": ho,
    // Firefox 19+
    "&::-ms-input-placeholder": ho,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses.formControl} &`]: {
      "&::-webkit-input-placeholder": go,
      "&::-moz-placeholder": go,
      // Firefox 19+
      "&::-ms-input-placeholder": go,
      // Edge
      "&:focus::-webkit-input-placeholder": bo,
      "&:focus::-moz-placeholder": bo,
      // Firefox 19+
      "&:focus::-ms-input-placeholder": bo
      // Edge
    },
    [`&.${inputBaseClasses.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (Kt.vars || Kt).palette.text.disabled
      // Fix opacity Safari bug
    },
    variants: [{
      props: ({
        ownerState: vo
      }) => !vo.disableInjectingGlobalStyles,
      style: {
        animationName: "mui-auto-fill-cancel",
        animationDuration: "10ms",
        "&:-webkit-autofill": {
          animationDuration: "5000s",
          animationName: "mui-auto-fill"
        }
      }
    }, {
      props: {
        size: "small"
      },
      style: {
        paddingTop: 1
      }
    }, {
      props: ({
        ownerState: vo
      }) => vo.multiline,
      style: {
        height: "auto",
        resize: "none",
        padding: 0,
        paddingTop: 0
      }
    }, {
      props: {
        type: "search"
      },
      style: {
        MozAppearance: "textfield"
        // Improve type search style.
      }
    }]
  };
})), InputGlobalStyles = globalCss({
  "@keyframes mui-auto-fill": {
    from: {
      display: "block"
    }
  },
  "@keyframes mui-auto-fill-cancel": {
    from: {
      display: "block"
    }
  }
}), InputBase = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiInputBase"
  }), {
    "aria-describedby": bo,
    autoComplete: vo,
    autoFocus: Po,
    className: Co,
    color: So,
    components: wo = {},
    componentsProps: Eo = {},
    defaultValue: Ro,
    disabled: _o,
    disableInjectingGlobalStyles: Io,
    endAdornment: Ao,
    error: Oo,
    fullWidth: jo = !1,
    id: Do,
    inputComponent: Lo = "input",
    inputProps: ko = {},
    inputRef: Ko,
    margin: No,
    maxRows: Jo,
    minRows: ti,
    multiline: oi = !1,
    name: Qo,
    onBlur: Zo,
    onChange: ei,
    onClick: ii,
    onFocus: ai,
    onKeyDown: ri,
    onKeyUp: ni,
    placeholder: si,
    readOnly: li,
    renderSuffix: ui,
    rows: ci,
    size: fi,
    slotProps: yi = {},
    slots: hi = {},
    startAdornment: mi,
    type: bi = "text",
    value: xi,
    ...$i
  } = go, Ci = ko.value != null ? ko.value : xi, {
    current: Si
  } = React$1.useRef(Ci != null), vi = React$1.useRef(), Pi = React$1.useCallback((Mi) => {
    process.env.NODE_ENV !== "production" && Mi && Mi.nodeName !== "INPUT" && !Mi.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), wi = useForkRef(vi, Ko, ko.ref, Pi), [gi, Ri] = React$1.useState(!1), Ei = useFormControl();
  process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    if (Ei)
      return Ei.registerEffect();
  }, [Ei]);
  const Ni = formControlState({
    props: go,
    muiFormControl: Ei,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  Ni.focused = Ei ? Ei.focused : gi, React$1.useEffect(() => {
    !Ei && _o && gi && (Ri(!1), Zo && Zo());
  }, [Ei, _o, gi, Zo]);
  const Ai = Ei && Ei.onFilled, Yi = Ei && Ei.onEmpty, Ui = React$1.useCallback((Mi) => {
    isFilled(Mi) ? Ai && Ai() : Yi && Yi();
  }, [Ai, Yi]);
  useEnhancedEffect(() => {
    Si && Ui({
      value: Ci
    });
  }, [Ci, Ui, Si]);
  const us = (Mi) => {
    ai && ai(Mi), ko.onFocus && ko.onFocus(Mi), Ei && Ei.onFocus ? Ei.onFocus(Mi) : Ri(!0);
  }, ns = (Mi) => {
    Zo && Zo(Mi), ko.onBlur && ko.onBlur(Mi), Ei && Ei.onBlur ? Ei.onBlur(Mi) : Ri(!1);
  }, Ti = (Mi, ...Wi) => {
    if (!Si) {
      const Hi = Mi.target || vi.current;
      if (Hi == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : formatMuiErrorMessage(1));
      Ui({
        value: Hi.value
      });
    }
    ko.onChange && ko.onChange(Mi, ...Wi), ei && ei(Mi, ...Wi);
  };
  React$1.useEffect(() => {
    Ui(vi.current);
  }, []);
  const _i = (Mi) => {
    vi.current && Mi.currentTarget === Mi.target && vi.current.focus(), ii && ii(Mi);
  };
  let Vi = Lo, Bi = ko;
  oi && Vi === "input" && (ci ? (process.env.NODE_ENV !== "production" && (ti || Jo) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Bi = {
    type: void 0,
    minRows: ci,
    maxRows: ci,
    ...Bi
  }) : Bi = {
    type: void 0,
    maxRows: Jo,
    minRows: ti,
    ...Bi
  }, Vi = TextareaAutosize);
  const Ji = (Mi) => {
    Ui(Mi.animationName === "mui-auto-fill-cancel" ? vi.current : {
      value: "x"
    });
  };
  React$1.useEffect(() => {
    Ei && Ei.setAdornedStart(!!mi);
  }, [Ei, mi]);
  const Ki = {
    ...go,
    color: Ni.color || "primary",
    disabled: Ni.disabled,
    endAdornment: Ao,
    error: Ni.error,
    focused: Ni.focused,
    formControl: Ei,
    fullWidth: jo,
    hiddenLabel: Ni.hiddenLabel,
    multiline: oi,
    size: Ni.size,
    startAdornment: mi,
    type: bi
  }, qi = useUtilityClasses$1o(Ki), rs = hi.root || wo.Root || InputBaseRoot, os = yi.root || Eo.root || {}, ps = hi.input || wo.Input || InputBaseInput;
  return Bi = {
    ...Bi,
    ...yi.input ?? Eo.input
  }, /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [!Io && typeof InputGlobalStyles == "function" && // For Emotion/Styled-components, InputGlobalStyles will be a function
    // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
    (_InputGlobalStyles || (_InputGlobalStyles = /* @__PURE__ */ jsxRuntimeExports.jsx(InputGlobalStyles, {}))), /* @__PURE__ */ jsxRuntimeExports.jsxs(rs, {
      ...os,
      ref: ho,
      onClick: _i,
      ...$i,
      ...!isHostComponent(rs) && {
        ownerState: {
          ...Ki,
          ...os.ownerState
        }
      },
      className: clsx(qi.root, os.className, Co, li && "MuiInputBase-readOnly"),
      children: [mi, /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
        value: null,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ps, {
          "aria-invalid": Ni.error,
          "aria-describedby": bo,
          autoComplete: vo,
          autoFocus: Po,
          defaultValue: Ro,
          disabled: Ni.disabled,
          id: Do,
          onAnimationStart: Ji,
          name: Qo,
          placeholder: si,
          readOnly: li,
          required: Ni.required,
          rows: ci,
          value: Ci,
          onKeyDown: ri,
          onKeyUp: ni,
          type: bi,
          ...Bi,
          ...!isHostComponent(ps) && {
            as: Vi,
            ownerState: {
              ...Ki,
              ...Bi.ownerState
            }
          },
          ref: wi,
          className: clsx(qi.input, Bi.className, li && "MuiInputBase-readOnly"),
          onBlur: ns,
          onChange: Ti,
          onFocus: us
        })
      }), Ao, ui ? ui({
        ...Ni,
        startAdornment: mi
      }) : null]
    })]
  });
});
process.env.NODE_ENV !== "production" && (InputBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: elementTypeAcceptingRef$1,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The size of the component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
const _excluded$$ = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "isValidating", "debounceMs", "isProcessingProps", "onValueChange"], useUtilityClasses$1n = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["editInputCell"]
  }, getDataGridUtilityClass, uo);
}, GridEditInputCellRoot = styled(InputBase, {
  name: "MuiDataGrid",
  slot: "EditInputCell",
  overridesResolver: (Kt, uo) => uo.editInputCell
})(({
  theme: Kt
}) => _extends$q({}, Kt.typography.body2, {
  padding: "1px 0",
  "& input": {
    padding: "0 16px",
    height: "100%"
  }
})), GridEditInputCell = forwardRef((Kt, uo) => {
  const ho = useGridRootProps(), {
    id: go,
    value: bo,
    field: vo,
    colDef: Po,
    hasFocus: Co,
    debounceMs: So = 200,
    isProcessingProps: wo,
    onValueChange: Eo
  } = Kt, Ro = _objectWithoutPropertiesLoose$h(Kt, _excluded$$), _o = useGridApiContext(), Io = React$1.useRef(), [Ao, Oo] = React$1.useState(bo), jo = useUtilityClasses$1n(ho), Do = React$1.useCallback(async (ko) => {
    const Ko = ko.target.value;
    Eo && await Eo(ko, Ko);
    const No = _o.current.getColumn(vo);
    let Jo = Ko;
    No.valueParser && (Jo = No.valueParser(Ko, _o.current.getRow(go), No, _o)), Oo(Jo), _o.current.setEditCellValue({
      id: go,
      field: vo,
      value: Jo,
      debounceMs: So,
      unstable_skipValueParser: !0
    }, ko);
  }, [_o, So, vo, go, Eo]), Lo = _o.current.unstable_getEditCellMeta(go, vo);
  return React$1.useEffect(() => {
    (Lo == null ? void 0 : Lo.changeReason) !== "debouncedSetEditCellValue" && Oo(bo);
  }, [Lo, bo]), useEnhancedEffect(() => {
    Co && Io.current.focus();
  }, [Co]), /* @__PURE__ */ jsxRuntimeExports.jsx(GridEditInputCellRoot, _extends$q({
    inputRef: Io,
    className: jo.root,
    ownerState: ho,
    fullWidth: !0,
    type: Po.type === "number" ? Po.type : "text",
    value: Ao ?? "",
    onChange: Do,
    endAdornment: wo ? /* @__PURE__ */ jsxRuntimeExports.jsx(ho.slots.loadIcon, {
      fontSize: "small",
      color: "action"
    }) : void 0
  }, Ro, {
    ref: uo
  }));
});
process.env.NODE_ENV !== "production" && (GridEditInputCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(["edit", "view"]).isRequired,
  changeReason: PropTypes.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  debounceMs: PropTypes.number,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
});
const renderEditInputCell = (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridEditInputCell, _extends$q({}, Kt)), sanitizeSortModel = (Kt, uo) => uo && Kt.length > 1 ? (process.env.NODE_ENV !== "production" && warnOnce(["MUI X: The `sortModel` can only contain a single item when the `disableMultipleColumnsSorting` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), [Kt[0]]) : Kt, mergeStateWithSortModel = (Kt, uo) => (ho) => _extends$q({}, ho, {
  sorting: _extends$q({}, ho.sorting, {
    sortModel: sanitizeSortModel(Kt, uo)
  })
}), isDesc = (Kt) => Kt === "desc", parseSortItem = (Kt, uo) => {
  const ho = uo.current.getColumn(Kt.field);
  if (!ho || Kt.sort === null)
    return null;
  let go;
  return ho.getSortComparator ? go = ho.getSortComparator(Kt.sort) : go = isDesc(Kt.sort) ? (...vo) => -1 * ho.sortComparator(...vo) : ho.sortComparator, go ? {
    getSortCellParams: (vo) => ({
      id: vo,
      field: ho.field,
      rowNode: uo.current.getRowNode(vo),
      value: uo.current.getCellValue(vo, ho.field),
      api: uo.current
    }),
    comparator: go
  } : null;
}, compareRows = (Kt, uo, ho) => Kt.reduce((go, bo, vo) => {
  if (go !== 0)
    return go;
  const Po = uo.params[vo], Co = ho.params[vo];
  return go = bo.comparator(Po.value, Co.value, Po, Co), go;
}, 0), buildAggregatedSortingApplier = (Kt, uo) => {
  const ho = Kt.map((go) => parseSortItem(go, uo)).filter((go) => !!go);
  return ho.length === 0 ? null : (go) => go.map((bo) => ({
    node: bo,
    params: ho.map((vo) => vo.getSortCellParams(bo.id))
  })).sort((bo, vo) => compareRows(ho, bo, vo)).map((bo) => bo.node.id);
}, getNextGridSortDirection = (Kt, uo) => {
  const ho = Kt.indexOf(uo);
  return !uo || ho === -1 || ho + 1 === Kt.length ? Kt[0] : Kt[ho + 1];
}, gridNillComparator = (Kt, uo) => Kt == null && uo != null ? -1 : uo == null && Kt != null ? 1 : Kt == null && uo == null ? 0 : null, collator$2 = new Intl.Collator(), gridStringOrNumberComparator = (Kt, uo) => {
  const ho = gridNillComparator(Kt, uo);
  return ho !== null ? ho : typeof Kt == "string" ? collator$2.compare(Kt.toString(), uo.toString()) : Kt - uo;
}, gridNumberComparator = (Kt, uo) => {
  const ho = gridNillComparator(Kt, uo);
  return ho !== null ? ho : Number(Kt) - Number(uo);
}, gridDateComparator = (Kt, uo) => {
  const ho = gridNillComparator(Kt, uo);
  return ho !== null ? ho : Kt > uo ? 1 : Kt < uo ? -1 : 0;
}, _excluded$_ = ["item", "applyValue", "type", "apiRef", "focusElementRef", "tabIndex", "disabled", "isFilterActive", "clearButton", "InputProps", "variant"];
function GridFilterInputValue(Kt) {
  var Ko;
  const {
    item: uo,
    applyValue: ho,
    type: go,
    apiRef: bo,
    focusElementRef: vo,
    tabIndex: Po,
    disabled: Co,
    clearButton: So,
    InputProps: wo,
    variant: Eo = "standard"
  } = Kt, Ro = _objectWithoutPropertiesLoose$h(Kt, _excluded$_), _o = useTimeout(), [Io, Ao] = React$1.useState(sanitizeFilterItemValue$1(uo.value, go)), [Oo, jo] = React$1.useState(!1), Do = useId(), Lo = useGridRootProps(), ko = React$1.useCallback((No) => {
    const Jo = sanitizeFilterItemValue$1(No.target.value, go);
    Ao(Jo), jo(!0), _o.start(Lo.filterDebounceMs, () => {
      const ti = _extends$q({}, uo, {
        value: Jo,
        fromInput: Do
      });
      ho(ti), jo(!1);
    });
  }, [_o, Lo.filterDebounceMs, uo, go, Do, ho]);
  return React$1.useEffect(() => {
    (uo.fromInput !== Do || uo.value == null) && Ao(sanitizeFilterItemValue$1(uo.value, go));
  }, [Do, uo, go]), /* @__PURE__ */ jsxRuntimeExports.jsx(Lo.slots.baseTextField, _extends$q({
    id: Do,
    label: bo.current.getLocaleText("filterPanelInputLabel"),
    placeholder: bo.current.getLocaleText("filterPanelInputPlaceholder"),
    value: Io === void 0 ? "" : String(Io),
    onChange: ko,
    variant: Eo,
    type: go || "text",
    InputProps: _extends$q({}, Oo || So ? {
      endAdornment: Oo ? /* @__PURE__ */ jsxRuntimeExports.jsx(Lo.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : So
    } : {}, {
      disabled: Co
    }, wo, {
      inputProps: _extends$q({
        tabIndex: Po
      }, wo == null ? void 0 : wo.inputProps)
    }),
    InputLabelProps: {
      shrink: !0
    },
    inputRef: vo
  }, Ro, (Ko = Lo.slotProps) == null ? void 0 : Ko.baseTextField));
}
function sanitizeFilterItemValue$1(Kt, uo) {
  if (!(Kt == null || Kt === ""))
    return uo === "number" ? Number(Kt) : String(Kt);
}
process.env.NODE_ENV !== "production" && (GridFilterInputValue.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
});
function isNumber$5(Kt) {
  return typeof Kt == "number" && !Number.isNaN(Kt);
}
function isFunction$5(Kt) {
  return typeof Kt == "function";
}
function isObject$a(Kt) {
  return typeof Kt == "object" && Kt !== null;
}
function localStorageAvailable() {
  try {
    const Kt = "__some_random_key_you_are_not_going_to_use__";
    return window.localStorage.setItem(Kt, Kt), window.localStorage.removeItem(Kt), !0;
  } catch {
    return !1;
  }
}
function escapeRegExp(Kt) {
  return Kt.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
const clamp$1 = (Kt, uo, ho) => Math.max(uo, Math.min(ho, Kt));
function range$5(Kt, uo) {
  return Array.from({
    length: uo - Kt
  }).map((ho, go) => Kt + go);
}
function isDeepEqual(Kt, uo) {
  if (Kt === uo)
    return !0;
  if (Kt && uo && typeof Kt == "object" && typeof uo == "object") {
    if (Kt.constructor !== uo.constructor)
      return !1;
    if (Array.isArray(Kt)) {
      const bo = Kt.length;
      if (bo !== uo.length)
        return !1;
      for (let vo = 0; vo < bo; vo += 1)
        if (!isDeepEqual(Kt[vo], uo[vo]))
          return !1;
      return !0;
    }
    if (Kt instanceof Map && uo instanceof Map) {
      if (Kt.size !== uo.size)
        return !1;
      const bo = Array.from(Kt.entries());
      for (let vo = 0; vo < bo.length; vo += 1)
        if (!uo.has(bo[vo][0]))
          return !1;
      for (let vo = 0; vo < bo.length; vo += 1) {
        const Po = bo[vo];
        if (!isDeepEqual(Po[1], uo.get(Po[0])))
          return !1;
      }
      return !0;
    }
    if (Kt instanceof Set && uo instanceof Set) {
      if (Kt.size !== uo.size)
        return !1;
      const bo = Array.from(Kt.entries());
      for (let vo = 0; vo < bo.length; vo += 1)
        if (!uo.has(bo[vo][0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(Kt) && ArrayBuffer.isView(uo)) {
      const bo = Kt.length;
      if (bo !== uo.length)
        return !1;
      for (let vo = 0; vo < bo; vo += 1)
        if (Kt[vo] !== uo[vo])
          return !1;
      return !0;
    }
    if (Kt.constructor === RegExp)
      return Kt.source === uo.source && Kt.flags === uo.flags;
    if (Kt.valueOf !== Object.prototype.valueOf)
      return Kt.valueOf() === uo.valueOf();
    if (Kt.toString !== Object.prototype.toString)
      return Kt.toString() === uo.toString();
    const ho = Object.keys(Kt), go = ho.length;
    if (go !== Object.keys(uo).length)
      return !1;
    for (let bo = 0; bo < go; bo += 1)
      if (!Object.prototype.hasOwnProperty.call(uo, ho[bo]))
        return !1;
    for (let bo = 0; bo < go; bo += 1) {
      const vo = ho[bo];
      if (!isDeepEqual(Kt[vo], uo[vo]))
        return !1;
    }
    return !0;
  }
  return Kt !== Kt && uo !== uo;
}
function mulberry32(Kt) {
  return () => {
    let uo = Kt += 1831565813;
    return uo = Math.imul(uo ^ uo >>> 15, uo | 1), uo ^= uo + Math.imul(uo ^ uo >>> 7, uo | 61), ((uo ^ uo >>> 14) >>> 0) / 4294967296;
  };
}
function createRandomNumberGenerator(Kt) {
  const uo = mulberry32(Kt);
  return (ho, go) => ho + (go - ho) * uo();
}
function deepClone(Kt) {
  return typeof structuredClone == "function" ? structuredClone(Kt) : JSON.parse(JSON.stringify(Kt));
}
function stripDiacritics(Kt) {
  return Kt.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function createFilterOptions(Kt = {}) {
  const {
    ignoreAccents: uo = !0,
    ignoreCase: ho = !0,
    limit: go,
    matchFrom: bo = "any",
    stringify: vo,
    trim: Po = !1
  } = Kt;
  return (Co, {
    inputValue: So,
    getOptionLabel: wo
  }) => {
    let Eo = Po ? So.trim() : So;
    ho && (Eo = Eo.toLowerCase()), uo && (Eo = stripDiacritics(Eo));
    const Ro = Eo ? Co.filter((_o) => {
      let Io = (vo || wo)(_o);
      return ho && (Io = Io.toLowerCase()), uo && (Io = stripDiacritics(Io)), bo === "start" ? Io.startsWith(Eo) : Io.includes(Eo);
    }) : Co;
    return typeof go == "number" ? Ro.slice(0, go) : Ro;
  };
}
const defaultFilterOptions = createFilterOptions(), pageSize = 5, defaultIsActiveElementInListbox = (Kt) => {
  var uo;
  return Kt.current !== null && ((uo = Kt.current.parentElement) == null ? void 0 : uo.contains(document.activeElement));
}, MULTIPLE_DEFAULT_VALUE = [];
function useAutocomplete(Kt) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: uo = defaultIsActiveElementInListbox,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: ho = "Mui",
    autoComplete: go = !1,
    autoHighlight: bo = !1,
    autoSelect: vo = !1,
    blurOnSelect: Po = !1,
    clearOnBlur: Co = !Kt.freeSolo,
    clearOnEscape: So = !1,
    componentName: wo = "useAutocomplete",
    defaultValue: Eo = Kt.multiple ? MULTIPLE_DEFAULT_VALUE : null,
    disableClearable: Ro = !1,
    disableCloseOnSelect: _o = !1,
    disabled: Io,
    disabledItemsFocusable: Ao = !1,
    disableListWrap: Oo = !1,
    filterOptions: jo = defaultFilterOptions,
    filterSelectedOptions: Do = !1,
    freeSolo: Lo = !1,
    getOptionDisabled: ko,
    getOptionKey: Ko,
    getOptionLabel: No = (Gi) => Gi.label ?? Gi,
    groupBy: Jo,
    handleHomeEndKeys: ti = !Kt.freeSolo,
    id: oi,
    includeInputInList: Qo = !1,
    inputValue: Zo,
    isOptionEqualToValue: ei = (Gi, Li) => Gi === Li,
    multiple: ii = !1,
    onChange: ai,
    onClose: ri,
    onHighlightChange: ni,
    onInputChange: si,
    onOpen: li,
    open: ui,
    openOnFocus: ci = !1,
    options: fi,
    readOnly: yi = !1,
    selectOnFocus: hi = !Kt.freeSolo,
    value: mi
  } = Kt, bi = useId(oi);
  let xi = No;
  xi = (Gi) => {
    const Li = No(Gi);
    if (typeof Li != "string") {
      if (process.env.NODE_ENV !== "production") {
        const Qi = Li === void 0 ? "undefined" : `${typeof Li} (${Li})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${wo} returned ${Qi} instead of a string for ${JSON.stringify(Gi)}.`);
      }
      return String(Li);
    }
    return Li;
  };
  const $i = React$1.useRef(!1), Ci = React$1.useRef(!0), Si = React$1.useRef(null), vi = React$1.useRef(null), [Pi, wi] = React$1.useState(null), [gi, Ri] = React$1.useState(-1), Ei = bo ? 0 : -1, Ni = React$1.useRef(Ei), [Ai, Yi] = useControlled({
    controlled: mi,
    default: Eo,
    name: wo
  }), [Ui, us] = useControlled({
    controlled: Zo,
    default: "",
    name: wo,
    state: "inputValue"
  }), [ns, Ti] = React$1.useState(!1), _i = React$1.useCallback((Gi, Li, Qi) => {
    if (!(ii ? Ai.length < Li.length : Li !== null) && !Co)
      return;
    let vs;
    if (ii)
      vs = "";
    else if (Li == null)
      vs = "";
    else {
      const Ss = xi(Li);
      vs = typeof Ss == "string" ? Ss : "";
    }
    Ui !== vs && (us(vs), si && si(Gi, vs, Qi));
  }, [xi, Ui, ii, si, us, Co, Ai]), [Vi, Bi] = useControlled({
    controlled: ui,
    default: !1,
    name: wo,
    state: "open"
  }), [Ji, Ki] = React$1.useState(!0), qi = !ii && Ai != null && Ui === xi(Ai), rs = Vi && !yi, os = rs ? jo(
    fi.filter((Gi) => !(Do && (ii ? Ai : [Ai]).some((Li) => Li !== null && ei(Gi, Li)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: qi && Ji ? "" : Ui,
      getOptionLabel: xi
    }
  ) : [], ps = usePreviousProps({
    filteredOptions: os,
    value: Ai,
    inputValue: Ui
  });
  React$1.useEffect(() => {
    const Gi = Ai !== ps.value;
    ns && !Gi || Lo && !Gi || _i(null, Ai, "reset");
  }, [Ai, _i, ns, ps.value, Lo]);
  const Mi = Vi && os.length > 0 && !yi, Wi = useEventCallback((Gi) => {
    Gi === -1 ? Si.current.focus() : Pi.querySelector(`[data-tag-index="${Gi}"]`).focus();
  });
  React$1.useEffect(() => {
    ii && gi > Ai.length - 1 && (Ri(-1), Wi(-1));
  }, [Ai, ii, gi, Wi]);
  function Hi(Gi, Li) {
    if (!vi.current || Gi < 0 || Gi >= os.length)
      return -1;
    let Qi = Gi;
    for (; ; ) {
      const ms = vi.current.querySelector(`[data-option-index="${Qi}"]`), vs = Ao ? !1 : !ms || ms.disabled || ms.getAttribute("aria-disabled") === "true";
      if (ms && ms.hasAttribute("tabindex") && !vs)
        return Qi;
      if (Li === "next" ? Qi = (Qi + 1) % os.length : Qi = (Qi - 1 + os.length) % os.length, Qi === Gi)
        return -1;
    }
  }
  const Xi = useEventCallback(({
    event: Gi,
    index: Li,
    reason: Qi = "auto"
  }) => {
    if (Ni.current = Li, Li === -1 ? Si.current.removeAttribute("aria-activedescendant") : Si.current.setAttribute("aria-activedescendant", `${bi}-option-${Li}`), ni && ni(Gi, Li === -1 ? null : os[Li], Qi), !vi.current)
      return;
    const ms = vi.current.querySelector(`[role="option"].${ho}-focused`);
    ms && (ms.classList.remove(`${ho}-focused`), ms.classList.remove(`${ho}-focusVisible`));
    let vs = vi.current;
    if (vi.current.getAttribute("role") !== "listbox" && (vs = vi.current.parentElement.querySelector('[role="listbox"]')), !vs)
      return;
    if (Li === -1) {
      vs.scrollTop = 0;
      return;
    }
    const Ss = vi.current.querySelector(`[data-option-index="${Li}"]`);
    if (Ss && (Ss.classList.add(`${ho}-focused`), Qi === "keyboard" && Ss.classList.add(`${ho}-focusVisible`), vs.scrollHeight > vs.clientHeight && Qi !== "mouse" && Qi !== "touch")) {
      const Cs = Ss, Us = vs.clientHeight + vs.scrollTop, fa = Cs.offsetTop + Cs.offsetHeight;
      fa > Us ? vs.scrollTop = fa - vs.clientHeight : Cs.offsetTop - Cs.offsetHeight * (Jo ? 1.3 : 0) < vs.scrollTop && (vs.scrollTop = Cs.offsetTop - Cs.offsetHeight * (Jo ? 1.3 : 0));
    }
  }), Zi = useEventCallback(({
    event: Gi,
    diff: Li,
    direction: Qi = "next",
    reason: ms = "auto"
  }) => {
    if (!rs)
      return;
    const Ss = Hi((() => {
      const Cs = os.length - 1;
      if (Li === "reset")
        return Ei;
      if (Li === "start")
        return 0;
      if (Li === "end")
        return Cs;
      const Us = Ni.current + Li;
      return Us < 0 ? Us === -1 && Qo ? -1 : Oo && Ni.current !== -1 || Math.abs(Li) > 1 ? 0 : Cs : Us > Cs ? Us === Cs + 1 && Qo ? -1 : Oo || Math.abs(Li) > 1 ? Cs : 0 : Us;
    })(), Qi);
    if (Xi({
      index: Ss,
      reason: ms,
      event: Gi
    }), go && Li !== "reset")
      if (Ss === -1)
        Si.current.value = Ui;
      else {
        const Cs = xi(os[Ss]);
        Si.current.value = Cs, Cs.toLowerCase().indexOf(Ui.toLowerCase()) === 0 && Ui.length > 0 && Si.current.setSelectionRange(Ui.length, Cs.length);
      }
  }), zi = () => {
    const Gi = (Li, Qi) => {
      const ms = Li ? xi(Li) : "", vs = Qi ? xi(Qi) : "";
      return ms === vs;
    };
    if (Ni.current !== -1 && ps.filteredOptions && ps.filteredOptions.length !== os.length && ps.inputValue === Ui && (ii ? Ai.length === ps.value.length && ps.value.every((Li, Qi) => xi(Ai[Qi]) === xi(Li)) : Gi(ps.value, Ai))) {
      const Li = ps.filteredOptions[Ni.current];
      if (Li)
        return os.findIndex((Qi) => xi(Qi) === xi(Li));
    }
    return -1;
  }, cs = React$1.useCallback(() => {
    if (!rs)
      return;
    const Gi = zi();
    if (Gi !== -1) {
      Ni.current = Gi;
      return;
    }
    const Li = ii ? Ai[0] : Ai;
    if (os.length === 0 || Li == null) {
      Zi({
        diff: "reset"
      });
      return;
    }
    if (vi.current) {
      if (Li != null) {
        const Qi = os[Ni.current];
        if (ii && Qi && Ai.findIndex((vs) => ei(Qi, vs)) !== -1)
          return;
        const ms = os.findIndex((vs) => ei(vs, Li));
        ms === -1 ? Zi({
          diff: "reset"
        }) : Xi({
          index: ms
        });
        return;
      }
      if (Ni.current >= os.length - 1) {
        Xi({
          index: os.length - 1
        });
        return;
      }
      Xi({
        index: Ni.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    os.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ii ? !1 : Ai,
    Do,
    Zi,
    Xi,
    rs,
    Ui,
    ii
  ]), ys = useEventCallback((Gi) => {
    setRef(vi, Gi), Gi && cs();
  });
  process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    (!Si.current || Si.current.nodeName !== "INPUT") && (Si.current && Si.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${wo} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${Si.current} while an HTMLInputElement was expected.`, `Instead, ${wo} expects an input element.`, "", wo === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [wo]), React$1.useEffect(() => {
    cs();
  }, [cs]);
  const $s = (Gi) => {
    Vi || (Bi(!0), Ki(!0), li && li(Gi));
  }, Ns = (Gi, Li) => {
    Vi && (Bi(!1), ri && ri(Gi, Li));
  }, Bs = (Gi, Li, Qi, ms) => {
    if (ii) {
      if (Ai.length === Li.length && Ai.every((vs, Ss) => vs === Li[Ss]))
        return;
    } else if (Ai === Li)
      return;
    ai && ai(Gi, Li, Qi, ms), Yi(Li);
  }, Ws = React$1.useRef(!1), Hs = (Gi, Li, Qi = "selectOption", ms = "options") => {
    let vs = Qi, Ss = Li;
    if (ii) {
      if (Ss = Array.isArray(Ai) ? Ai.slice() : [], process.env.NODE_ENV !== "production") {
        const Us = Ss.filter((fa) => ei(Li, fa));
        Us.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${wo} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Us.length} matches.`].join(`
`));
      }
      const Cs = Ss.findIndex((Us) => ei(Li, Us));
      Cs === -1 ? Ss.push(Li) : ms !== "freeSolo" && (Ss.splice(Cs, 1), vs = "removeOption");
    }
    _i(Gi, Ss, vs), Bs(Gi, Ss, vs, {
      option: Li
    }), !_o && (!Gi || !Gi.ctrlKey && !Gi.metaKey) && Ns(Gi, vs), (Po === !0 || Po === "touch" && Ws.current || Po === "mouse" && !Ws.current) && Si.current.blur();
  };
  function Ks(Gi, Li) {
    if (Gi === -1)
      return -1;
    let Qi = Gi;
    for (; ; ) {
      if (Li === "next" && Qi === Ai.length || Li === "previous" && Qi === -1)
        return -1;
      const ms = Pi.querySelector(`[data-tag-index="${Qi}"]`);
      if (!ms || !ms.hasAttribute("tabindex") || ms.disabled || ms.getAttribute("aria-disabled") === "true")
        Qi += Li === "next" ? 1 : -1;
      else
        return Qi;
    }
  }
  const zs = (Gi, Li) => {
    if (!ii)
      return;
    Ui === "" && Ns(Gi, "toggleInput");
    let Qi = gi;
    gi === -1 ? Ui === "" && Li === "previous" && (Qi = Ai.length - 1) : (Qi += Li === "next" ? 1 : -1, Qi < 0 && (Qi = 0), Qi === Ai.length && (Qi = -1)), Qi = Ks(Qi, Li), Ri(Qi), Wi(Qi);
  }, Ys = (Gi) => {
    $i.current = !0, us(""), si && si(Gi, "", "clear"), Bs(Gi, ii ? [] : null, "clear");
  }, ds = (Gi) => (Li) => {
    if (Gi.onKeyDown && Gi.onKeyDown(Li), !Li.defaultMuiPrevented && (gi !== -1 && !["ArrowLeft", "ArrowRight"].includes(Li.key) && (Ri(-1), Wi(-1)), Li.which !== 229))
      switch (Li.key) {
        case "Home":
          rs && ti && (Li.preventDefault(), Zi({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: Li
          }));
          break;
        case "End":
          rs && ti && (Li.preventDefault(), Zi({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: Li
          }));
          break;
        case "PageUp":
          Li.preventDefault(), Zi({
            diff: -pageSize,
            direction: "previous",
            reason: "keyboard",
            event: Li
          }), $s(Li);
          break;
        case "PageDown":
          Li.preventDefault(), Zi({
            diff: pageSize,
            direction: "next",
            reason: "keyboard",
            event: Li
          }), $s(Li);
          break;
        case "ArrowDown":
          Li.preventDefault(), Zi({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: Li
          }), $s(Li);
          break;
        case "ArrowUp":
          Li.preventDefault(), Zi({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: Li
          }), $s(Li);
          break;
        case "ArrowLeft":
          zs(Li, "previous");
          break;
        case "ArrowRight":
          zs(Li, "next");
          break;
        case "Enter":
          if (Ni.current !== -1 && rs) {
            const Qi = os[Ni.current], ms = ko ? ko(Qi) : !1;
            if (Li.preventDefault(), ms)
              return;
            Hs(Li, Qi, "selectOption"), go && Si.current.setSelectionRange(Si.current.value.length, Si.current.value.length);
          } else Lo && Ui !== "" && qi === !1 && (ii && Li.preventDefault(), Hs(Li, Ui, "createOption", "freeSolo"));
          break;
        case "Escape":
          rs ? (Li.preventDefault(), Li.stopPropagation(), Ns(Li, "escape")) : So && (Ui !== "" || ii && Ai.length > 0) && (Li.preventDefault(), Li.stopPropagation(), Ys(Li));
          break;
        case "Backspace":
          if (ii && !yi && Ui === "" && Ai.length > 0) {
            const Qi = gi === -1 ? Ai.length - 1 : gi, ms = Ai.slice();
            ms.splice(Qi, 1), Bs(Li, ms, "removeOption", {
              option: Ai[Qi]
            });
          }
          break;
        case "Delete":
          if (ii && !yi && Ui === "" && Ai.length > 0 && gi !== -1) {
            const Qi = gi, ms = Ai.slice();
            ms.splice(Qi, 1), Bs(Li, ms, "removeOption", {
              option: Ai[Qi]
            });
          }
          break;
      }
  }, Ls = (Gi) => {
    Ti(!0), ci && !$i.current && $s(Gi);
  }, Xs = (Gi) => {
    if (uo(vi)) {
      Si.current.focus();
      return;
    }
    Ti(!1), Ci.current = !0, $i.current = !1, vo && Ni.current !== -1 && rs ? Hs(Gi, os[Ni.current], "blur") : vo && Lo && Ui !== "" ? Hs(Gi, Ui, "blur", "freeSolo") : Co && _i(Gi, Ai, "blur"), Ns(Gi, "blur");
  }, sa = (Gi) => {
    const Li = Gi.target.value;
    Ui !== Li && (us(Li), Ki(!1), si && si(Gi, Li, "input")), Li === "" ? !Ro && !ii && Bs(Gi, null, "clear") : $s(Gi);
  }, ya = (Gi) => {
    const Li = Number(Gi.currentTarget.getAttribute("data-option-index"));
    Ni.current !== Li && Xi({
      event: Gi,
      index: Li,
      reason: "mouse"
    });
  }, ma = (Gi) => {
    Xi({
      event: Gi,
      index: Number(Gi.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), Ws.current = !0;
  }, Ca = (Gi) => {
    const Li = Number(Gi.currentTarget.getAttribute("data-option-index"));
    Hs(Gi, os[Li], "selectOption"), Ws.current = !1;
  }, Sa = (Gi) => (Li) => {
    const Qi = Ai.slice();
    Qi.splice(Gi, 1), Bs(Li, Qi, "removeOption", {
      option: Ai[Gi]
    });
  }, va = (Gi) => {
    Vi ? Ns(Gi, "toggleInput") : $s(Gi);
  }, wa = (Gi) => {
    Gi.currentTarget.contains(Gi.target) && Gi.target.getAttribute("id") !== bi && Gi.preventDefault();
  }, ha = (Gi) => {
    Gi.currentTarget.contains(Gi.target) && (Si.current.focus(), hi && Ci.current && Si.current.selectionEnd - Si.current.selectionStart === 0 && Si.current.select(), Ci.current = !1);
  }, Gs = (Gi) => {
    !Io && (Ui === "" || !Vi) && va(Gi);
  };
  let Rs = Lo && Ui.length > 0;
  Rs = Rs || (ii ? Ai.length > 0 : Ai !== null);
  let Qs = os;
  if (Jo) {
    const Gi = /* @__PURE__ */ new Map();
    let Li = !1;
    Qs = os.reduce((Qi, ms, vs) => {
      const Ss = Jo(ms);
      return Qi.length > 0 && Qi[Qi.length - 1].group === Ss ? Qi[Qi.length - 1].options.push(ms) : (process.env.NODE_ENV !== "production" && (Gi.get(Ss) && !Li && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${wo} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), Li = !0), Gi.set(Ss, !0)), Qi.push({
        key: vs,
        index: vs,
        group: Ss,
        options: [ms]
      })), Qi;
    }, []);
  }
  return Io && ns && Xs(), {
    getRootProps: (Gi = {}) => ({
      "aria-owns": Mi ? `${bi}-listbox` : null,
      ...Gi,
      onKeyDown: ds(Gi),
      onMouseDown: wa,
      onClick: ha
    }),
    getInputLabelProps: () => ({
      id: `${bi}-label`,
      htmlFor: bi
    }),
    getInputProps: () => ({
      id: bi,
      value: Ui,
      onBlur: Xs,
      onFocus: Ls,
      onChange: sa,
      onMouseDown: Gs,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": rs ? "" : null,
      "aria-autocomplete": go ? "both" : "list",
      "aria-controls": Mi ? `${bi}-listbox` : void 0,
      "aria-expanded": Mi,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: Si,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: Io
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Ys
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: va
    }),
    getTagProps: ({
      index: Gi
    }) => ({
      key: Gi,
      "data-tag-index": Gi,
      tabIndex: -1,
      ...!yi && {
        onDelete: Sa(Gi)
      }
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${bi}-listbox`,
      "aria-labelledby": `${bi}-label`,
      ref: ys,
      onMouseDown: (Gi) => {
        Gi.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Gi,
      option: Li
    }) => {
      const Qi = (ii ? Ai : [Ai]).some((vs) => vs != null && ei(Li, vs)), ms = ko ? ko(Li) : !1;
      return {
        key: (Ko == null ? void 0 : Ko(Li)) ?? xi(Li),
        tabIndex: -1,
        role: "option",
        id: `${bi}-option-${Gi}`,
        onMouseMove: ya,
        onClick: Ca,
        onTouchStart: ma,
        "data-option-index": Gi,
        "aria-disabled": ms,
        "aria-selected": Qi
      };
    },
    id: bi,
    inputValue: Ui,
    value: Ai,
    dirty: Rs,
    expanded: rs && Pi,
    popupOpen: rs,
    focused: ns || gi !== -1,
    anchorEl: Pi,
    setAnchorEl: wi,
    focusedTag: gi,
    groupedOptions: Qs
  };
}
function getContainer$1(Kt) {
  return typeof Kt == "function" ? Kt() : Kt;
}
const Portal = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    children: go,
    container: bo,
    disablePortal: vo = !1
  } = uo, [Po, Co] = React$1.useState(null), So = useForkRef(/* @__PURE__ */ React$1.isValidElement(go) ? getReactElementRef(go) : null, ho);
  if (useEnhancedEffect(() => {
    vo || Co(getContainer$1(bo) || document.body);
  }, [bo, vo]), useEnhancedEffect(() => {
    if (Po && !vo)
      return setRef(ho, Po), () => {
        setRef(ho, null);
      };
  }, [ho, Po, vo]), vo) {
    if (/* @__PURE__ */ React$1.isValidElement(go)) {
      const wo = {
        ref: So
      };
      return /* @__PURE__ */ React$1.cloneElement(go, wo);
    }
    return go;
  }
  return Po && /* @__PURE__ */ ReactDOM.createPortal(go, Po);
});
process.env.NODE_ENV !== "production" && (Portal.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool
});
process.env.NODE_ENV !== "production" && (Portal.propTypes = exactProp(Portal.propTypes));
function getPopperUtilityClass(Kt) {
  return generateUtilityClass$1("MuiPopper", Kt);
}
generateUtilityClasses$1("MuiPopper", ["root"]);
function flipPlacement(Kt, uo) {
  if (uo === "ltr")
    return Kt;
  switch (Kt) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return Kt;
  }
}
function resolveAnchorEl$1(Kt) {
  return typeof Kt == "function" ? Kt() : Kt;
}
function isHTMLElement(Kt) {
  return Kt.nodeType !== void 0;
}
function isVirtualElement(Kt) {
  return !isHTMLElement(Kt);
}
const useUtilityClasses$1m = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["root"]
  }, getPopperUtilityClass, uo);
}, defaultPopperOptions = {}, PopperTooltip = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    anchorEl: go,
    children: bo,
    direction: vo,
    disablePortal: Po,
    modifiers: Co,
    open: So,
    placement: wo,
    popperOptions: Eo,
    popperRef: Ro,
    slotProps: _o = {},
    slots: Io = {},
    TransitionProps: Ao,
    // @ts-ignore internal logic
    ownerState: Oo,
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...jo
  } = uo, Do = React$1.useRef(null), Lo = useForkRef(Do, ho), ko = React$1.useRef(null), Ko = useForkRef(ko, Ro), No = React$1.useRef(Ko);
  useEnhancedEffect(() => {
    No.current = Ko;
  }, [Ko]), React$1.useImperativeHandle(Ro, () => ko.current, []);
  const Jo = flipPlacement(wo, vo), [ti, oi] = React$1.useState(Jo), [Qo, Zo] = React$1.useState(resolveAnchorEl$1(go));
  React$1.useEffect(() => {
    ko.current && ko.current.forceUpdate();
  }), React$1.useEffect(() => {
    go && Zo(resolveAnchorEl$1(go));
  }, [go]), useEnhancedEffect(() => {
    if (!Qo || !So)
      return;
    const ni = (ui) => {
      oi(ui.placement);
    };
    if (process.env.NODE_ENV !== "production" && Qo && isHTMLElement(Qo) && Qo.nodeType === 1) {
      const ui = Qo.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ui.top === 0 && ui.left === 0 && ui.right === 0 && ui.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let si = [{
      name: "preventOverflow",
      options: {
        altBoundary: Po
      }
    }, {
      name: "flip",
      options: {
        altBoundary: Po
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: ui
      }) => {
        ni(ui);
      }
    }];
    Co != null && (si = si.concat(Co)), Eo && Eo.modifiers != null && (si = si.concat(Eo.modifiers));
    const li = createPopper(Qo, Do.current, {
      placement: Jo,
      ...Eo,
      modifiers: si
    });
    return No.current(li), () => {
      li.destroy(), No.current(null);
    };
  }, [Qo, Po, Co, So, Eo, Jo]);
  const ei = {
    placement: ti
  };
  Ao !== null && (ei.TransitionProps = Ao);
  const ii = useUtilityClasses$1m(uo), ai = Io.root ?? "div", ri = useSlotProps({
    elementType: ai,
    externalSlotProps: _o.root,
    externalForwardedProps: jo,
    additionalProps: {
      role: "tooltip",
      ref: Lo
    },
    ownerState: uo,
    className: ii.root
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ai, {
    ...ri,
    children: typeof bo == "function" ? bo(ei) : bo
  });
}), Popper$1 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    anchorEl: go,
    children: bo,
    container: vo,
    direction: Po = "ltr",
    disablePortal: Co = !1,
    keepMounted: So = !1,
    modifiers: wo,
    open: Eo,
    placement: Ro = "bottom",
    popperOptions: _o = defaultPopperOptions,
    popperRef: Io,
    style: Ao,
    transition: Oo = !1,
    slotProps: jo = {},
    slots: Do = {},
    ...Lo
  } = uo, [ko, Ko] = React$1.useState(!0), No = () => {
    Ko(!1);
  }, Jo = () => {
    Ko(!0);
  };
  if (!So && !Eo && (!Oo || ko))
    return null;
  let ti;
  if (vo)
    ti = vo;
  else if (go) {
    const Zo = resolveAnchorEl$1(go);
    ti = Zo && isHTMLElement(Zo) ? ownerDocument(Zo).body : ownerDocument(null).body;
  }
  const oi = !Eo && So && (!Oo || ko) ? "none" : void 0, Qo = Oo ? {
    in: Eo,
    onEnter: No,
    onExited: Jo
  } : void 0;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    disablePortal: Co,
    container: ti,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopperTooltip, {
      anchorEl: go,
      direction: Po,
      disablePortal: Co,
      modifiers: wo,
      ref: ho,
      open: Oo ? !ko : Eo,
      placement: Ro,
      popperOptions: _o,
      popperRef: Io,
      slotProps: jo,
      slots: Do,
      ...Lo,
      style: {
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: oi,
        ...Ao
      },
      TransitionProps: Qo,
      children: bo
    })
  });
});
process.env.NODE_ENV !== "production" && (Popper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]), (Kt) => {
    if (Kt.open) {
      const uo = resolveAnchorEl$1(Kt.anchorEl);
      if (uo && isHTMLElement(uo) && uo.nodeType === 1) {
        const ho = uo.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && ho.top === 0 && ho.left === 0 && ho.right === 0 && ho.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!uo || typeof uo.getBoundingClientRect != "function" || isVirtualElement(uo) && uo.contextElement != null && uo.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: PropTypes.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
const PopperRoot = styled(Popper$1, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})({}), Popper = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useRtl(), bo = useDefaultProps({
    props: uo,
    name: "MuiPopper"
  }), {
    anchorEl: vo,
    component: Po,
    components: Co,
    componentsProps: So,
    container: wo,
    disablePortal: Eo,
    keepMounted: Ro,
    modifiers: _o,
    open: Io,
    placement: Ao,
    popperOptions: Oo,
    popperRef: jo,
    transition: Do,
    slots: Lo,
    slotProps: ko,
    ...Ko
  } = bo, No = (Lo == null ? void 0 : Lo.root) ?? (Co == null ? void 0 : Co.Root), Jo = {
    anchorEl: vo,
    container: wo,
    disablePortal: Eo,
    keepMounted: Ro,
    modifiers: _o,
    open: Io,
    placement: Ao,
    popperOptions: Oo,
    popperRef: jo,
    transition: Do,
    ...Ko
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PopperRoot, {
    as: Po,
    direction: go ? "rtl" : "ltr",
    slots: {
      root: No
    },
    slotProps: ko ?? So,
    ...Jo,
    ref: ho
  });
});
process.env.NODE_ENV !== "production" && (Popper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.object, PropTypes.func]),
  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object,
    effect: PropTypes.func,
    enabled: PropTypes.bool,
    fn: PropTypes.func,
    name: PropTypes.any,
    options: PropTypes.object,
    phase: PropTypes.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: PropTypes.arrayOf(PropTypes.string),
    requiresIfExists: PropTypes.arrayOf(PropTypes.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: PropTypes.shape({
    modifiers: PropTypes.array,
    onFirstUpdate: PropTypes.func,
    placement: PropTypes.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: PropTypes.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: PropTypes.bool
});
function getListSubheaderUtilityClass(Kt) {
  return generateUtilityClass$1("MuiListSubheader", Kt);
}
generateUtilityClasses$1("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const useUtilityClasses$1l = (Kt) => {
  const {
    classes: uo,
    color: ho,
    disableGutters: go,
    inset: bo,
    disableSticky: vo
  } = Kt, Po = {
    root: ["root", ho !== "default" && `color${capitalize(ho)}`, !go && "gutters", bo && "inset", !vo && "sticky"]
  };
  return composeClasses(Po, getListSubheaderUtilityClass, uo);
}, ListSubheaderRoot = styled("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.color !== "default" && uo[`color${capitalize(ho.color)}`], !ho.disableGutters && uo.gutters, ho.inset && uo.inset, !ho.disableSticky && uo.sticky];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (Kt.vars || Kt).palette.text.secondary,
  fontFamily: Kt.typography.fontFamily,
  fontWeight: Kt.typography.fontWeightMedium,
  fontSize: Kt.typography.pxToRem(14),
  variants: [{
    props: {
      color: "primary"
    },
    style: {
      color: (Kt.vars || Kt).palette.primary.main
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, {
    props: ({
      ownerState: uo
    }) => !uo.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.inset,
    style: {
      paddingLeft: 72
    }
  }, {
    props: ({
      ownerState: uo
    }) => !uo.disableSticky,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: (Kt.vars || Kt).palette.background.paper
    }
  }]
}))), ListSubheader = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiListSubheader"
  }), {
    className: bo,
    color: vo = "default",
    component: Po = "li",
    disableGutters: Co = !1,
    disableSticky: So = !1,
    inset: wo = !1,
    ...Eo
  } = go, Ro = {
    ...go,
    color: vo,
    component: Po,
    disableGutters: Co,
    disableSticky: So,
    inset: wo
  }, _o = useUtilityClasses$1l(Ro);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListSubheaderRoot, {
    as: Po,
    className: clsx(_o.root, bo),
    ref: ho,
    ownerState: Ro,
    ...Eo
  });
});
ListSubheader && (ListSubheader.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (ListSubheader.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: PropTypes.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: PropTypes.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getPaperUtilityClass(Kt) {
  return generateUtilityClass$1("MuiPaper", Kt);
}
generateUtilityClasses$1("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]);
const useUtilityClasses$1k = (Kt) => {
  const {
    square: uo,
    elevation: ho,
    variant: go,
    classes: bo
  } = Kt, vo = {
    root: ["root", go, !uo && "rounded", go === "elevation" && `elevation${ho}`]
  };
  return composeClasses(vo, getPaperUtilityClass, bo);
}, PaperRoot = styled("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.variant], !ho.square && uo.rounded, ho.variant === "elevation" && uo[`elevation${ho.elevation}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  backgroundColor: (Kt.vars || Kt).palette.background.paper,
  color: (Kt.vars || Kt).palette.text.primary,
  transition: Kt.transitions.create("box-shadow"),
  variants: [{
    props: ({
      ownerState: uo
    }) => !uo.square,
    style: {
      borderRadius: Kt.shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: `1px solid ${(Kt.vars || Kt).palette.divider}`
    }
  }, {
    props: {
      variant: "elevation"
    },
    style: {
      boxShadow: "var(--Paper-shadow)",
      backgroundImage: "var(--Paper-overlay)"
    }
  }]
}))), Paper = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  var Io;
  const go = useDefaultProps({
    props: uo,
    name: "MuiPaper"
  }), bo = useTheme(), {
    className: vo,
    component: Po = "div",
    elevation: Co = 1,
    square: So = !1,
    variant: wo = "elevation",
    ...Eo
  } = go, Ro = {
    ...go,
    component: Po,
    elevation: Co,
    square: So,
    variant: wo
  }, _o = useUtilityClasses$1k(Ro);
  return process.env.NODE_ENV !== "production" && bo.shadows[Co] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${Co}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${Co}]\` is defined.`].join(`
`)), /* @__PURE__ */ jsxRuntimeExports.jsx(PaperRoot, {
    as: Po,
    ownerState: Ro,
    className: clsx(_o.root, vo),
    ref: ho,
    ...Eo,
    style: {
      ...wo === "elevation" && {
        "--Paper-shadow": (bo.vars || bo).shadows[Co],
        ...bo.vars && {
          "--Paper-overlay": (Io = bo.vars.overlays) == null ? void 0 : Io[Co]
        },
        ...!bo.vars && bo.palette.mode === "dark" && {
          "--Paper-overlay": `linear-gradient(${alpha$1("#fff", getOverlayAlpha(Co))}, ${alpha$1("#fff", getOverlayAlpha(Co))})`
        }
      },
      ...Eo.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Paper.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: chainPropTypes(integerPropType, (Kt) => {
    const {
      elevation: uo,
      variant: ho
    } = Kt;
    return uo > 0 && ho === "outlined" ? new Error(`MUI: Combining \`elevation={${uo}}\` with \`variant="${ho}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["elevation", "outlined"]), PropTypes.string])
});
function hasCorrectMainProperty(Kt) {
  return typeof Kt.main == "string";
}
function checkSimplePaletteColorValues(Kt, uo = []) {
  if (!hasCorrectMainProperty(Kt))
    return !1;
  for (const ho of uo)
    if (!Kt.hasOwnProperty(ho) || typeof Kt[ho] != "string")
      return !1;
  return !0;
}
function createSimplePaletteValueFilter(Kt = []) {
  return ([, uo]) => uo && checkSimplePaletteColorValues(uo, Kt);
}
class LazyRipple {
  constructor() {
    ba(this, "mountEffect", () => {
      this.shouldMount && !this.didMount && this.ref.current !== null && (this.didMount = !0, this.mounted.resolve());
    });
    this.ref = {
      current: null
    }, this.mounted = null, this.didMount = !1, this.shouldMount = !1, this.setShouldMount = null;
  }
  /** React ref to the ripple instance */
  /** If the ripple component should be mounted */
  /** Promise that resolves when the ripple component is mounted */
  /** If the ripple component has been mounted */
  /** React state hook setter */
  static create() {
    return new LazyRipple();
  }
  static use() {
    const uo = useLazyRef(LazyRipple.create).current, [ho, go] = React$1.useState(!1);
    return uo.shouldMount = ho, uo.setShouldMount = go, React$1.useEffect(uo.mountEffect, [ho]), uo;
  }
  mount() {
    return this.mounted || (this.mounted = createControlledPromise(), this.shouldMount = !0, this.setShouldMount(this.shouldMount)), this.mounted;
  }
  /* Ripple API */
  start(...uo) {
    this.mount().then(() => {
      var ho;
      return (ho = this.ref.current) == null ? void 0 : ho.start(...uo);
    });
  }
  stop(...uo) {
    this.mount().then(() => {
      var ho;
      return (ho = this.ref.current) == null ? void 0 : ho.stop(...uo);
    });
  }
  pulsate(...uo) {
    this.mount().then(() => {
      var ho;
      return (ho = this.ref.current) == null ? void 0 : ho.pulsate(...uo);
    });
  }
}
function useLazyRipple() {
  return LazyRipple.use();
}
function createControlledPromise() {
  let Kt, uo;
  const ho = new Promise((go, bo) => {
    Kt = go, uo = bo;
  });
  return ho.resolve = Kt, ho.reject = uo, ho;
}
function _setPrototypeOf$f(Kt, uo) {
  return _setPrototypeOf$f = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(ho, go) {
    return ho.__proto__ = go, ho;
  }, _setPrototypeOf$f(Kt, uo);
}
function _inheritsLoose(Kt, uo) {
  Kt.prototype = Object.create(uo.prototype), Kt.prototype.constructor = Kt, _setPrototypeOf$f(Kt, uo);
}
const config$2 = {
  disabled: !1
};
var timeoutsShape = process.env.NODE_ENV !== "production" ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]);
const TransitionGroupContext = React__default.createContext(null);
var forceReflow = function(uo) {
  return uo.scrollTop;
}, UNMOUNTED = "unmounted", EXITED = "exited", ENTERING = "entering", ENTERED = "entered", EXITING = "exiting", Transition = /* @__PURE__ */ function(Kt) {
  _inheritsLoose(uo, Kt);
  function uo(go, bo) {
    var vo;
    vo = Kt.call(this, go, bo) || this;
    var Po = bo, Co = Po && !Po.isMounting ? go.enter : go.appear, So;
    return vo.appearStatus = null, go.in ? Co ? (So = EXITED, vo.appearStatus = ENTERING) : So = ENTERED : go.unmountOnExit || go.mountOnEnter ? So = UNMOUNTED : So = EXITED, vo.state = {
      status: So
    }, vo.nextCallback = null, vo;
  }
  uo.getDerivedStateFromProps = function(bo, vo) {
    var Po = bo.in;
    return Po && vo.status === UNMOUNTED ? {
      status: EXITED
    } : null;
  };
  var ho = uo.prototype;
  return ho.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, ho.componentDidUpdate = function(bo) {
    var vo = null;
    if (bo !== this.props) {
      var Po = this.state.status;
      this.props.in ? Po !== ENTERING && Po !== ENTERED && (vo = ENTERING) : (Po === ENTERING || Po === ENTERED) && (vo = EXITING);
    }
    this.updateStatus(!1, vo);
  }, ho.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, ho.getTimeouts = function() {
    var bo = this.props.timeout, vo, Po, Co;
    return vo = Po = Co = bo, bo != null && typeof bo != "number" && (vo = bo.exit, Po = bo.enter, Co = bo.appear !== void 0 ? bo.appear : Po), {
      exit: vo,
      enter: Po,
      appear: Co
    };
  }, ho.updateStatus = function(bo, vo) {
    if (bo === void 0 && (bo = !1), vo !== null)
      if (this.cancelNextCallback(), vo === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var Po = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this);
          Po && forceReflow(Po);
        }
        this.performEnter(bo);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === EXITED && this.setState({
      status: UNMOUNTED
    });
  }, ho.performEnter = function(bo) {
    var vo = this, Po = this.props.enter, Co = this.context ? this.context.isMounting : bo, So = this.props.nodeRef ? [Co] : [ReactDOM__default.findDOMNode(this), Co], wo = So[0], Eo = So[1], Ro = this.getTimeouts(), _o = Co ? Ro.appear : Ro.enter;
    if (!bo && !Po || config$2.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        vo.props.onEntered(wo);
      });
      return;
    }
    this.props.onEnter(wo, Eo), this.safeSetState({
      status: ENTERING
    }, function() {
      vo.props.onEntering(wo, Eo), vo.onTransitionEnd(_o, function() {
        vo.safeSetState({
          status: ENTERED
        }, function() {
          vo.props.onEntered(wo, Eo);
        });
      });
    });
  }, ho.performExit = function() {
    var bo = this, vo = this.props.exit, Po = this.getTimeouts(), Co = this.props.nodeRef ? void 0 : ReactDOM__default.findDOMNode(this);
    if (!vo || config$2.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        bo.props.onExited(Co);
      });
      return;
    }
    this.props.onExit(Co), this.safeSetState({
      status: EXITING
    }, function() {
      bo.props.onExiting(Co), bo.onTransitionEnd(Po.exit, function() {
        bo.safeSetState({
          status: EXITED
        }, function() {
          bo.props.onExited(Co);
        });
      });
    });
  }, ho.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, ho.safeSetState = function(bo, vo) {
    vo = this.setNextCallback(vo), this.setState(bo, vo);
  }, ho.setNextCallback = function(bo) {
    var vo = this, Po = !0;
    return this.nextCallback = function(Co) {
      Po && (Po = !1, vo.nextCallback = null, bo(Co));
    }, this.nextCallback.cancel = function() {
      Po = !1;
    }, this.nextCallback;
  }, ho.onTransitionEnd = function(bo, vo) {
    this.setNextCallback(vo);
    var Po = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default.findDOMNode(this), Co = bo == null && !this.props.addEndListener;
    if (!Po || Co) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var So = this.props.nodeRef ? [this.nextCallback] : [Po, this.nextCallback], wo = So[0], Eo = So[1];
      this.props.addEndListener(wo, Eo);
    }
    bo != null && setTimeout(this.nextCallback, bo);
  }, ho.render = function() {
    var bo = this.state.status;
    if (bo === UNMOUNTED)
      return null;
    var vo = this.props, Po = vo.children;
    vo.in, vo.mountOnEnter, vo.unmountOnExit, vo.appear, vo.enter, vo.exit, vo.timeout, vo.addEndListener, vo.onEnter, vo.onEntering, vo.onEntered, vo.onExit, vo.onExiting, vo.onExited, vo.nodeRef;
    var Co = _objectWithoutPropertiesLoose$h(vo, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof Po == "function" ? Po(bo, Co) : React__default.cloneElement(React__default.Children.only(Po), Co))
    );
  }, uo;
}(React__default.Component);
Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element > "u" ? PropTypes.any : function(Kt, uo, ho, go, bo, vo) {
      var Po = Kt[uo];
      return PropTypes.instanceOf(Po && "ownerDocument" in Po ? Po.ownerDocument.defaultView.Element : Element)(Kt, uo, ho, go, bo, vo);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(uo) {
    var ho = timeoutsShape;
    uo.addEndListener || (ho = ho.isRequired);
    for (var go = arguments.length, bo = new Array(go > 1 ? go - 1 : 0), vo = 1; vo < go; vo++)
      bo[vo - 1] = arguments[vo];
    return ho.apply(void 0, [uo].concat(bo));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};
function noop$6() {
}
Transition.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: noop$6,
  onEntering: noop$6,
  onEntered: noop$6,
  onExit: noop$6,
  onExiting: noop$6,
  onExited: noop$6
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
function _assertThisInitialized$f(Kt) {
  if (Kt === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function getChildMapping(Kt, uo) {
  var ho = function(vo) {
    return uo && isValidElement(vo) ? uo(vo) : vo;
  }, go = /* @__PURE__ */ Object.create(null);
  return Kt && Children.map(Kt, function(bo) {
    return bo;
  }).forEach(function(bo) {
    go[bo.key] = ho(bo);
  }), go;
}
function mergeChildMappings(Kt, uo) {
  Kt = Kt || {}, uo = uo || {};
  function ho(Eo) {
    return Eo in uo ? uo[Eo] : Kt[Eo];
  }
  var go = /* @__PURE__ */ Object.create(null), bo = [];
  for (var vo in Kt)
    vo in uo ? bo.length && (go[vo] = bo, bo = []) : bo.push(vo);
  var Po, Co = {};
  for (var So in uo) {
    if (go[So])
      for (Po = 0; Po < go[So].length; Po++) {
        var wo = go[So][Po];
        Co[go[So][Po]] = ho(wo);
      }
    Co[So] = ho(So);
  }
  for (Po = 0; Po < bo.length; Po++)
    Co[bo[Po]] = ho(bo[Po]);
  return Co;
}
function getProp(Kt, uo, ho) {
  return ho[uo] != null ? ho[uo] : Kt.props[uo];
}
function getInitialChildMapping(Kt, uo) {
  return getChildMapping(Kt.children, function(ho) {
    return cloneElement(ho, {
      onExited: uo.bind(null, ho),
      in: !0,
      appear: getProp(ho, "appear", Kt),
      enter: getProp(ho, "enter", Kt),
      exit: getProp(ho, "exit", Kt)
    });
  });
}
function getNextChildMapping(Kt, uo, ho) {
  var go = getChildMapping(Kt.children), bo = mergeChildMappings(uo, go);
  return Object.keys(bo).forEach(function(vo) {
    var Po = bo[vo];
    if (isValidElement(Po)) {
      var Co = vo in uo, So = vo in go, wo = uo[vo], Eo = isValidElement(wo) && !wo.props.in;
      So && (!Co || Eo) ? bo[vo] = cloneElement(Po, {
        onExited: ho.bind(null, Po),
        in: !0,
        exit: getProp(Po, "exit", Kt),
        enter: getProp(Po, "enter", Kt)
      }) : !So && Co && !Eo ? bo[vo] = cloneElement(Po, {
        in: !1
      }) : So && Co && isValidElement(wo) && (bo[vo] = cloneElement(Po, {
        onExited: ho.bind(null, Po),
        in: wo.props.in,
        exit: getProp(Po, "exit", Kt),
        enter: getProp(Po, "enter", Kt)
      }));
    }
  }), bo;
}
var values = Object.values || function(Kt) {
  return Object.keys(Kt).map(function(uo) {
    return Kt[uo];
  });
}, defaultProps$4 = {
  component: "div",
  childFactory: function(uo) {
    return uo;
  }
}, TransitionGroup = /* @__PURE__ */ function(Kt) {
  _inheritsLoose(uo, Kt);
  function uo(go, bo) {
    var vo;
    vo = Kt.call(this, go, bo) || this;
    var Po = vo.handleExited.bind(_assertThisInitialized$f(vo));
    return vo.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: Po,
      firstRender: !0
    }, vo;
  }
  var ho = uo.prototype;
  return ho.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, ho.componentWillUnmount = function() {
    this.mounted = !1;
  }, uo.getDerivedStateFromProps = function(bo, vo) {
    var Po = vo.children, Co = vo.handleExited, So = vo.firstRender;
    return {
      children: So ? getInitialChildMapping(bo, Co) : getNextChildMapping(bo, Po, Co),
      firstRender: !1
    };
  }, ho.handleExited = function(bo, vo) {
    var Po = getChildMapping(this.props.children);
    bo.key in Po || (bo.props.onExited && bo.props.onExited(vo), this.mounted && this.setState(function(Co) {
      var So = _extends$q({}, Co.children);
      return delete So[bo.key], {
        children: So
      };
    }));
  }, ho.render = function() {
    var bo = this.props, vo = bo.component, Po = bo.childFactory, Co = _objectWithoutPropertiesLoose$h(bo, ["component", "childFactory"]), So = this.state.contextValue, wo = values(this.state.children).map(Po);
    return delete Co.appear, delete Co.enter, delete Co.exit, vo === null ? /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: So
    }, wo) : /* @__PURE__ */ React__default.createElement(TransitionGroupContext.Provider, {
      value: So
    }, /* @__PURE__ */ React__default.createElement(vo, Co, wo));
  }, uo;
}(React__default.Component);
TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$4;
function Ripple(Kt) {
  const {
    className: uo,
    classes: ho,
    pulsate: go = !1,
    rippleX: bo,
    rippleY: vo,
    rippleSize: Po,
    in: Co,
    onExited: So,
    timeout: wo
  } = Kt, [Eo, Ro] = React$1.useState(!1), _o = clsx(uo, ho.ripple, ho.rippleVisible, go && ho.ripplePulsate), Io = {
    width: Po,
    height: Po,
    top: -(Po / 2) + vo,
    left: -(Po / 2) + bo
  }, Ao = clsx(ho.child, Eo && ho.childLeaving, go && ho.childPulsate);
  return !Co && !Eo && Ro(!0), React$1.useEffect(() => {
    if (!Co && So != null) {
      const Oo = setTimeout(So, wo);
      return () => {
        clearTimeout(Oo);
      };
    }
  }, [So, Co, wo]), /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    className: _o,
    style: Io,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: Ao
    })
  });
}
process.env.NODE_ENV !== "production" && (Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,
  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
});
const touchRippleClasses = generateUtilityClasses$1("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), DURATION = 550, DELAY_RIPPLE = 80, enterKeyframe = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`, exitKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`, pulsateKeyframe = keyframes`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`, TouchRippleRoot = styled("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), TouchRippleRipple = styled(Ripple, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})`
  opacity: 0;
  position: absolute;

  &.${touchRippleClasses.rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${enterKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme: Kt
}) => Kt.transitions.easing.easeInOut};
  }

  &.${touchRippleClasses.ripplePulsate} {
    animation-duration: ${({
  theme: Kt
}) => Kt.transitions.duration.shorter}ms;
  }

  & .${touchRippleClasses.child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${touchRippleClasses.childLeaving} {
    opacity: 0;
    animation-name: ${exitKeyframe};
    animation-duration: ${DURATION}ms;
    animation-timing-function: ${({
  theme: Kt
}) => Kt.transitions.easing.easeInOut};
  }

  & .${touchRippleClasses.childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({
  theme: Kt
}) => Kt.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`, TouchRipple = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiTouchRipple"
  }), {
    center: bo = !1,
    classes: vo = {},
    className: Po,
    ...Co
  } = go, [So, wo] = React$1.useState([]), Eo = React$1.useRef(0), Ro = React$1.useRef(null);
  React$1.useEffect(() => {
    Ro.current && (Ro.current(), Ro.current = null);
  }, [So]);
  const _o = React$1.useRef(!1), Io = useTimeout(), Ao = React$1.useRef(null), Oo = React$1.useRef(null), jo = React$1.useCallback((Ko) => {
    const {
      pulsate: No,
      rippleX: Jo,
      rippleY: ti,
      rippleSize: oi,
      cb: Qo
    } = Ko;
    wo((Zo) => [...Zo, /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(vo.ripple, touchRippleClasses.ripple),
        rippleVisible: clsx(vo.rippleVisible, touchRippleClasses.rippleVisible),
        ripplePulsate: clsx(vo.ripplePulsate, touchRippleClasses.ripplePulsate),
        child: clsx(vo.child, touchRippleClasses.child),
        childLeaving: clsx(vo.childLeaving, touchRippleClasses.childLeaving),
        childPulsate: clsx(vo.childPulsate, touchRippleClasses.childPulsate)
      },
      timeout: DURATION,
      pulsate: No,
      rippleX: Jo,
      rippleY: ti,
      rippleSize: oi
    }, Eo.current)]), Eo.current += 1, Ro.current = Qo;
  }, [vo]), Do = React$1.useCallback((Ko = {}, No = {}, Jo = () => {
  }) => {
    const {
      pulsate: ti = !1,
      center: oi = bo || No.pulsate,
      fakeElement: Qo = !1
      // For test purposes
    } = No;
    if ((Ko == null ? void 0 : Ko.type) === "mousedown" && _o.current) {
      _o.current = !1;
      return;
    }
    (Ko == null ? void 0 : Ko.type) === "touchstart" && (_o.current = !0);
    const Zo = Qo ? null : Oo.current, ei = Zo ? Zo.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let ii, ai, ri;
    if (oi || Ko === void 0 || Ko.clientX === 0 && Ko.clientY === 0 || !Ko.clientX && !Ko.touches)
      ii = Math.round(ei.width / 2), ai = Math.round(ei.height / 2);
    else {
      const {
        clientX: ni,
        clientY: si
      } = Ko.touches && Ko.touches.length > 0 ? Ko.touches[0] : Ko;
      ii = Math.round(ni - ei.left), ai = Math.round(si - ei.top);
    }
    if (oi)
      ri = Math.sqrt((2 * ei.width ** 2 + ei.height ** 2) / 3), ri % 2 === 0 && (ri += 1);
    else {
      const ni = Math.max(Math.abs((Zo ? Zo.clientWidth : 0) - ii), ii) * 2 + 2, si = Math.max(Math.abs((Zo ? Zo.clientHeight : 0) - ai), ai) * 2 + 2;
      ri = Math.sqrt(ni ** 2 + si ** 2);
    }
    Ko != null && Ko.touches ? Ao.current === null && (Ao.current = () => {
      jo({
        pulsate: ti,
        rippleX: ii,
        rippleY: ai,
        rippleSize: ri,
        cb: Jo
      });
    }, Io.start(DELAY_RIPPLE, () => {
      Ao.current && (Ao.current(), Ao.current = null);
    })) : jo({
      pulsate: ti,
      rippleX: ii,
      rippleY: ai,
      rippleSize: ri,
      cb: Jo
    });
  }, [bo, jo, Io]), Lo = React$1.useCallback(() => {
    Do({}, {
      pulsate: !0
    });
  }, [Do]), ko = React$1.useCallback((Ko, No) => {
    if (Io.clear(), (Ko == null ? void 0 : Ko.type) === "touchend" && Ao.current) {
      Ao.current(), Ao.current = null, Io.start(0, () => {
        ko(Ko, No);
      });
      return;
    }
    Ao.current = null, wo((Jo) => Jo.length > 0 ? Jo.slice(1) : Jo), Ro.current = No;
  }, [Io]);
  return React$1.useImperativeHandle(ho, () => ({
    pulsate: Lo,
    start: Do,
    stop: ko
  }), [Lo, Do, ko]), /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRippleRoot, {
    className: clsx(touchRippleClasses.root, vo.root, Po),
    ref: Oo,
    ...Co,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionGroup, {
      component: null,
      exit: !0,
      children: So
    })
  });
});
process.env.NODE_ENV !== "production" && (TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string
});
function getButtonBaseUtilityClass(Kt) {
  return generateUtilityClass$1("MuiButtonBase", Kt);
}
const buttonBaseClasses = generateUtilityClasses$1("MuiButtonBase", ["root", "disabled", "focusVisible"]), useUtilityClasses$1j = (Kt) => {
  const {
    disabled: uo,
    focusVisible: ho,
    focusVisibleClassName: go,
    classes: bo
  } = Kt, Po = composeClasses({
    root: ["root", uo && "disabled", ho && "focusVisible"]
  }, getButtonBaseUtilityClass, bo);
  return ho && go && (Po.root += ` ${go}`), Po;
}, ButtonBaseRoot = styled("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${buttonBaseClasses.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), ButtonBase = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiButtonBase"
  }), {
    action: bo,
    centerRipple: vo = !1,
    children: Po,
    className: Co,
    component: So = "button",
    disabled: wo = !1,
    disableRipple: Eo = !1,
    disableTouchRipple: Ro = !1,
    focusRipple: _o = !1,
    focusVisibleClassName: Io,
    LinkComponent: Ao = "a",
    onBlur: Oo,
    onClick: jo,
    onContextMenu: Do,
    onDragLeave: Lo,
    onFocus: ko,
    onFocusVisible: Ko,
    onKeyDown: No,
    onKeyUp: Jo,
    onMouseDown: ti,
    onMouseLeave: oi,
    onMouseUp: Qo,
    onTouchEnd: Zo,
    onTouchMove: ei,
    onTouchStart: ii,
    tabIndex: ai = 0,
    TouchRippleProps: ri,
    touchRippleRef: ni,
    type: si,
    ...li
  } = go, ui = React$1.useRef(null), ci = useLazyRipple(), fi = useForkRef(ci.ref, ni), [yi, hi] = React$1.useState(!1);
  wo && yi && hi(!1), React$1.useImperativeHandle(bo, () => ({
    focusVisible: () => {
      hi(!0), ui.current.focus();
    }
  }), []);
  const mi = ci.shouldMount && !Eo && !wo;
  React$1.useEffect(() => {
    yi && _o && !Eo && ci.pulsate();
  }, [Eo, _o, yi, ci]);
  const bi = useRippleHandler(ci, "start", ti, Ro), xi = useRippleHandler(ci, "stop", Do, Ro), $i = useRippleHandler(ci, "stop", Lo, Ro), Ci = useRippleHandler(ci, "stop", Qo, Ro), Si = useRippleHandler(ci, "stop", (_i) => {
    yi && _i.preventDefault(), oi && oi(_i);
  }, Ro), vi = useRippleHandler(ci, "start", ii, Ro), Pi = useRippleHandler(ci, "stop", Zo, Ro), wi = useRippleHandler(ci, "stop", ei, Ro), gi = useRippleHandler(ci, "stop", (_i) => {
    isFocusVisible(_i.target) || hi(!1), Oo && Oo(_i);
  }, !1), Ri = useEventCallback((_i) => {
    ui.current || (ui.current = _i.currentTarget), isFocusVisible(_i.target) && (hi(!0), Ko && Ko(_i)), ko && ko(_i);
  }), Ei = () => {
    const _i = ui.current;
    return So && So !== "button" && !(_i.tagName === "A" && _i.href);
  }, Ni = useEventCallback((_i) => {
    _o && !_i.repeat && yi && _i.key === " " && ci.stop(_i, () => {
      ci.start(_i);
    }), _i.target === _i.currentTarget && Ei() && _i.key === " " && _i.preventDefault(), No && No(_i), _i.target === _i.currentTarget && Ei() && _i.key === "Enter" && !wo && (_i.preventDefault(), jo && jo(_i));
  }), Ai = useEventCallback((_i) => {
    _o && _i.key === " " && yi && !_i.defaultPrevented && ci.stop(_i, () => {
      ci.pulsate(_i);
    }), Jo && Jo(_i), jo && _i.target === _i.currentTarget && Ei() && _i.key === " " && !_i.defaultPrevented && jo(_i);
  });
  let Yi = So;
  Yi === "button" && (li.href || li.to) && (Yi = Ao);
  const Ui = {};
  Yi === "button" ? (Ui.type = si === void 0 ? "button" : si, Ui.disabled = wo) : (!li.href && !li.to && (Ui.role = "button"), wo && (Ui["aria-disabled"] = wo));
  const us = useForkRef(ho, ui), ns = {
    ...go,
    centerRipple: vo,
    component: So,
    disabled: wo,
    disableRipple: Eo,
    disableTouchRipple: Ro,
    focusRipple: _o,
    tabIndex: ai,
    focusVisible: yi
  }, Ti = useUtilityClasses$1j(ns);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonBaseRoot, {
    as: Yi,
    className: clsx(Ti.root, Co),
    ownerState: ns,
    onBlur: gi,
    onClick: jo,
    onContextMenu: xi,
    onFocus: Ri,
    onKeyDown: Ni,
    onKeyUp: Ai,
    onMouseDown: bi,
    onMouseLeave: Si,
    onMouseUp: Ci,
    onDragLeave: $i,
    onTouchEnd: Pi,
    onTouchMove: wi,
    onTouchStart: vi,
    ref: us,
    tabIndex: wo ? -1 : ai,
    type: si,
    ...Ui,
    ...li,
    children: [Po, mi ? /* @__PURE__ */ jsxRuntimeExports.jsx(TouchRipple, {
      ref: fi,
      center: vo,
      ...ri
    }) : null]
  });
});
function useRippleHandler(Kt, uo, ho, go = !1) {
  return useEventCallback((bo) => (ho && ho(bo), go || Kt[uo](bo), !0));
}
process.env.NODE_ENV !== "production" && (ButtonBase.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: elementTypeAcceptingRef$1,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: PropTypes.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  href: PropTypes.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: PropTypes.elementType,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  onContextMenu: PropTypes.func,
  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,
  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,
  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,
  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,
  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,
  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      pulsate: PropTypes.func.isRequired,
      start: PropTypes.func.isRequired,
      stop: PropTypes.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string])
});
function getIconButtonUtilityClass(Kt) {
  return generateUtilityClass$1("MuiIconButton", Kt);
}
const iconButtonClasses = generateUtilityClasses$1("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), useUtilityClasses$1i = (Kt) => {
  const {
    classes: uo,
    disabled: ho,
    color: go,
    edge: bo,
    size: vo
  } = Kt, Po = {
    root: ["root", ho && "disabled", go !== "default" && `color${capitalize(go)}`, bo && `edge${capitalize(bo)}`, `size${capitalize(vo)}`]
  };
  return composeClasses(Po, getIconButtonUtilityClass, uo);
}, IconButtonRoot = styled(ButtonBase, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.color !== "default" && uo[`color${capitalize(ho.color)}`], ho.edge && uo[`edge${capitalize(ho.edge)}`], uo[`size${capitalize(ho.size)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: Kt.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (Kt.vars || Kt).palette.action.active,
  transition: Kt.transitions.create("background-color", {
    duration: Kt.transitions.duration.shortest
  }),
  variants: [{
    props: (uo) => !uo.disableRipple,
    style: {
      "--IconButton-hoverBg": Kt.vars ? `rgba(${Kt.vars.palette.action.activeChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette.action.active, Kt.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), memoTheme(({
  theme: Kt
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      color: (Kt.vars || Kt).palette[uo].main
    }
  })), ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      "--IconButton-hoverBg": Kt.vars ? `rgba(${(Kt.vars || Kt).palette[uo].mainChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1((Kt.vars || Kt).palette[uo].main, Kt.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: Kt.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: Kt.typography.pxToRem(28)
    }
  }],
  [`&.${iconButtonClasses.disabled}`]: {
    backgroundColor: "transparent",
    color: (Kt.vars || Kt).palette.action.disabled
  }
}))), IconButton = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiIconButton"
  }), {
    edge: bo = !1,
    children: vo,
    className: Po,
    color: Co = "default",
    disabled: So = !1,
    disableFocusRipple: wo = !1,
    size: Eo = "medium",
    ...Ro
  } = go, _o = {
    ...go,
    edge: bo,
    color: Co,
    disabled: So,
    disableFocusRipple: wo,
    size: Eo
  }, Io = useUtilityClasses$1i(_o);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(IconButtonRoot, {
    className: clsx(Io.root, Po),
    centerRipple: !0,
    focusRipple: !wo,
    disabled: So,
    ref: ho,
    ...Ro,
    ownerState: _o,
    children: vo
  });
});
process.env.NODE_ENV !== "production" && (IconButton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: chainPropTypes(PropTypes.node, (Kt) => React$1.Children.toArray(Kt.children).some((ho) => /* @__PURE__ */ React$1.isValidElement(ho) && ho.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getSvgIconUtilityClass(Kt) {
  return generateUtilityClass$1("MuiSvgIcon", Kt);
}
generateUtilityClasses$1("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const useUtilityClasses$1h = (Kt) => {
  const {
    color: uo,
    fontSize: ho,
    classes: go
  } = Kt, bo = {
    root: ["root", uo !== "inherit" && `color${capitalize(uo)}`, `fontSize${capitalize(ho)}`]
  };
  return composeClasses(bo, getSvgIconUtilityClass, go);
}, SvgIconRoot = styled("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.color !== "inherit" && uo[`color${capitalize(ho.color)}`], uo[`fontSize${capitalize(ho.fontSize)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => {
  var uo, ho, go, bo, vo, Po, Co, So, wo, Eo, Ro, _o, Io, Ao;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (bo = (uo = Kt.transitions) == null ? void 0 : uo.create) == null ? void 0 : bo.call(uo, "fill", {
      duration: (go = (ho = (Kt.vars ?? Kt).transitions) == null ? void 0 : ho.duration) == null ? void 0 : go.shorter
    }),
    variants: [
      {
        props: (Oo) => !Oo.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((Po = (vo = Kt.typography) == null ? void 0 : vo.pxToRem) == null ? void 0 : Po.call(vo, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((So = (Co = Kt.typography) == null ? void 0 : Co.pxToRem) == null ? void 0 : So.call(Co, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((Eo = (wo = Kt.typography) == null ? void 0 : wo.pxToRem) == null ? void 0 : Eo.call(wo, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((Kt.vars ?? Kt).palette).filter(([, Oo]) => Oo && Oo.main).map(([Oo]) => {
        var jo, Do;
        return {
          props: {
            color: Oo
          },
          style: {
            color: (Do = (jo = (Kt.vars ?? Kt).palette) == null ? void 0 : jo[Oo]) == null ? void 0 : Do.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (_o = (Ro = (Kt.vars ?? Kt).palette) == null ? void 0 : Ro.action) == null ? void 0 : _o.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (Ao = (Io = (Kt.vars ?? Kt).palette) == null ? void 0 : Io.action) == null ? void 0 : Ao.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), SvgIcon = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiSvgIcon"
  }), {
    children: bo,
    className: vo,
    color: Po = "inherit",
    component: Co = "svg",
    fontSize: So = "medium",
    htmlColor: wo,
    inheritViewBox: Eo = !1,
    titleAccess: Ro,
    viewBox: _o = "0 0 24 24",
    ...Io
  } = go, Ao = /* @__PURE__ */ React$1.isValidElement(bo) && bo.type === "svg", Oo = {
    ...go,
    color: Po,
    component: Co,
    fontSize: So,
    instanceFontSize: uo.fontSize,
    inheritViewBox: Eo,
    viewBox: _o,
    hasSvgAsChild: Ao
  }, jo = {};
  Eo || (jo.viewBox = _o);
  const Do = useUtilityClasses$1h(Oo);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SvgIconRoot, {
    as: Co,
    className: clsx(Do.root, vo),
    focusable: "false",
    color: wo,
    "aria-hidden": Ro ? void 0 : !0,
    role: Ro ? "img" : void 0,
    ref: ho,
    ...jo,
    ...Io,
    ...Ao && bo.props,
    ownerState: Oo,
    children: [Ao ? bo.props.children : bo, Ro ? /* @__PURE__ */ jsxRuntimeExports.jsx("title", {
      children: Ro
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (SvgIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "large", "medium", "small"]), PropTypes.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: PropTypes.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: PropTypes.string
});
SvgIcon.muiName = "SvgIcon";
function createSvgIcon(Kt, uo) {
  function ho(go, bo) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(SvgIcon, {
      "data-testid": `${uo}Icon`,
      ref: bo,
      ...go,
      children: Kt
    });
  }
  return process.env.NODE_ENV !== "production" && (ho.displayName = `${uo}Icon`), ho.muiName = SvgIcon.muiName, /* @__PURE__ */ React$1.memo(/* @__PURE__ */ React$1.forwardRef(ho));
}
const CancelIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function getChipUtilityClass(Kt) {
  return generateUtilityClass$1("MuiChip", Kt);
}
const chipClasses = generateUtilityClasses$1("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorDefault", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), useUtilityClasses$1g = (Kt) => {
  const {
    classes: uo,
    disabled: ho,
    size: go,
    color: bo,
    iconColor: vo,
    onDelete: Po,
    clickable: Co,
    variant: So
  } = Kt, wo = {
    root: ["root", So, ho && "disabled", `size${capitalize(go)}`, `color${capitalize(bo)}`, Co && "clickable", Co && `clickableColor${capitalize(bo)}`, Po && "deletable", Po && `deletableColor${capitalize(bo)}`, `${So}${capitalize(bo)}`],
    label: ["label", `label${capitalize(go)}`],
    avatar: ["avatar", `avatar${capitalize(go)}`, `avatarColor${capitalize(bo)}`],
    icon: ["icon", `icon${capitalize(go)}`, `iconColor${capitalize(vo)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${capitalize(go)}`, `deleteIconColor${capitalize(bo)}`, `deleteIcon${capitalize(So)}Color${capitalize(bo)}`]
  };
  return composeClasses(wo, getChipUtilityClass, uo);
}, ChipRoot = styled("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt, {
      color: go,
      iconColor: bo,
      clickable: vo,
      onDelete: Po,
      size: Co,
      variant: So
    } = ho;
    return [{
      [`& .${chipClasses.avatar}`]: uo.avatar
    }, {
      [`& .${chipClasses.avatar}`]: uo[`avatar${capitalize(Co)}`]
    }, {
      [`& .${chipClasses.avatar}`]: uo[`avatarColor${capitalize(go)}`]
    }, {
      [`& .${chipClasses.icon}`]: uo.icon
    }, {
      [`& .${chipClasses.icon}`]: uo[`icon${capitalize(Co)}`]
    }, {
      [`& .${chipClasses.icon}`]: uo[`iconColor${capitalize(bo)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: uo.deleteIcon
    }, {
      [`& .${chipClasses.deleteIcon}`]: uo[`deleteIcon${capitalize(Co)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: uo[`deleteIconColor${capitalize(go)}`]
    }, {
      [`& .${chipClasses.deleteIcon}`]: uo[`deleteIcon${capitalize(So)}Color${capitalize(go)}`]
    }, uo.root, uo[`size${capitalize(Co)}`], uo[`color${capitalize(go)}`], vo && uo.clickable, vo && go !== "default" && uo[`clickableColor${capitalize(go)})`], Po && uo.deletable, Po && go !== "default" && uo[`deletableColor${capitalize(go)}`], uo[So], uo[`${So}${capitalize(go)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => {
  const uo = Kt.palette.mode === "light" ? Kt.palette.grey[700] : Kt.palette.grey[300];
  return {
    maxWidth: "100%",
    fontFamily: Kt.typography.fontFamily,
    fontSize: Kt.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (Kt.vars || Kt).palette.text.primary,
    backgroundColor: (Kt.vars || Kt).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: Kt.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${chipClasses.disabled}`]: {
      opacity: (Kt.vars || Kt).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${chipClasses.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: Kt.vars ? Kt.vars.palette.Chip.defaultAvatarColor : uo,
      fontSize: Kt.typography.pxToRem(12)
    },
    [`& .${chipClasses.avatarColorPrimary}`]: {
      color: (Kt.vars || Kt).palette.primary.contrastText,
      backgroundColor: (Kt.vars || Kt).palette.primary.dark
    },
    [`& .${chipClasses.avatarColorSecondary}`]: {
      color: (Kt.vars || Kt).palette.secondary.contrastText,
      backgroundColor: (Kt.vars || Kt).palette.secondary.dark
    },
    [`& .${chipClasses.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: Kt.typography.pxToRem(10)
    },
    [`& .${chipClasses.icon}`]: {
      marginLeft: 5,
      marginRight: -6
    },
    [`& .${chipClasses.deleteIcon}`]: {
      WebkitTapHighlightColor: "transparent",
      color: Kt.vars ? `rgba(${Kt.vars.palette.text.primaryChannel} / 0.26)` : alpha$1(Kt.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: Kt.vars ? `rgba(${Kt.vars.palette.text.primaryChannel} / 0.4)` : alpha$1(Kt.palette.text.primary, 0.4)
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        height: 24,
        [`& .${chipClasses.icon}`]: {
          fontSize: 18,
          marginLeft: 4,
          marginRight: -4
        },
        [`& .${chipClasses.deleteIcon}`]: {
          fontSize: 16,
          marginRight: 4,
          marginLeft: -4
        }
      }
    }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter(["contrastText"])).map(([ho]) => ({
      props: {
        color: ho
      },
      style: {
        backgroundColor: (Kt.vars || Kt).palette[ho].main,
        color: (Kt.vars || Kt).palette[ho].contrastText,
        [`& .${chipClasses.deleteIcon}`]: {
          color: Kt.vars ? `rgba(${Kt.vars.palette[ho].contrastTextChannel} / 0.7)` : alpha$1(Kt.palette[ho].contrastText, 0.7),
          "&:hover, &:active": {
            color: (Kt.vars || Kt).palette[ho].contrastText
          }
        }
      }
    })), {
      props: (ho) => ho.iconColor === ho.color,
      style: {
        [`& .${chipClasses.icon}`]: {
          color: Kt.vars ? Kt.vars.palette.Chip.defaultIconColor : uo
        }
      }
    }, {
      props: (ho) => ho.iconColor === ho.color && ho.color !== "default",
      style: {
        [`& .${chipClasses.icon}`]: {
          color: "inherit"
        }
      }
    }, {
      props: {
        onDelete: !0
      },
      style: {
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.action.selectedChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.focusOpacity}))` : alpha$1(Kt.palette.action.selected, Kt.palette.action.selectedOpacity + Kt.palette.action.focusOpacity)
        }
      }
    }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([ho]) => ({
      props: {
        color: ho,
        onDelete: !0
      },
      style: {
        [`&.${chipClasses.focusVisible}`]: {
          background: (Kt.vars || Kt).palette[ho].dark
        }
      }
    })), {
      props: {
        clickable: !0
      },
      style: {
        userSelect: "none",
        WebkitTapHighlightColor: "transparent",
        cursor: "pointer",
        "&:hover": {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.action.selectedChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.hoverOpacity}))` : alpha$1(Kt.palette.action.selected, Kt.palette.action.selectedOpacity + Kt.palette.action.hoverOpacity)
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.action.selectedChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.focusOpacity}))` : alpha$1(Kt.palette.action.selected, Kt.palette.action.selectedOpacity + Kt.palette.action.focusOpacity)
        },
        "&:active": {
          boxShadow: (Kt.vars || Kt).shadows[1]
        }
      }
    }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter(["dark"])).map(([ho]) => ({
      props: {
        color: ho,
        clickable: !0
      },
      style: {
        [`&:hover, &.${chipClasses.focusVisible}`]: {
          backgroundColor: (Kt.vars || Kt).palette[ho].dark
        }
      }
    })), {
      props: {
        variant: "outlined"
      },
      style: {
        backgroundColor: "transparent",
        border: Kt.vars ? `1px solid ${Kt.vars.palette.Chip.defaultBorder}` : `1px solid ${Kt.palette.mode === "light" ? Kt.palette.grey[400] : Kt.palette.grey[700]}`,
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: (Kt.vars || Kt).palette.action.hover
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: (Kt.vars || Kt).palette.action.focus
        },
        [`& .${chipClasses.avatar}`]: {
          marginLeft: 4
        },
        [`& .${chipClasses.avatarSmall}`]: {
          marginLeft: 2
        },
        [`& .${chipClasses.icon}`]: {
          marginLeft: 4
        },
        [`& .${chipClasses.iconSmall}`]: {
          marginLeft: 2
        },
        [`& .${chipClasses.deleteIcon}`]: {
          marginRight: 5
        },
        [`& .${chipClasses.deleteIconSmall}`]: {
          marginRight: 3
        }
      }
    }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([ho]) => ({
      props: {
        variant: "outlined",
        color: ho
      },
      style: {
        color: (Kt.vars || Kt).palette[ho].main,
        border: `1px solid ${Kt.vars ? `rgba(${Kt.vars.palette[ho].mainChannel} / 0.7)` : alpha$1(Kt.palette[ho].main, 0.7)}`,
        [`&.${chipClasses.clickable}:hover`]: {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette[ho].mainChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette[ho].main, Kt.palette.action.hoverOpacity)
        },
        [`&.${chipClasses.focusVisible}`]: {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette[ho].mainChannel} / ${Kt.vars.palette.action.focusOpacity})` : alpha$1(Kt.palette[ho].main, Kt.palette.action.focusOpacity)
        },
        [`& .${chipClasses.deleteIcon}`]: {
          color: Kt.vars ? `rgba(${Kt.vars.palette[ho].mainChannel} / 0.7)` : alpha$1(Kt.palette[ho].main, 0.7),
          "&:hover, &:active": {
            color: (Kt.vars || Kt).palette[ho].main
          }
        }
      }
    }))]
  };
})), ChipLabel = styled("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt, {
      size: go
    } = ho;
    return [uo.label, uo[`label${capitalize(go)}`]];
  }
})({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      variant: "outlined"
    },
    style: {
      paddingLeft: 11,
      paddingRight: 11
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      size: "small",
      variant: "outlined"
    },
    style: {
      paddingLeft: 7,
      paddingRight: 7
    }
  }]
});
function isDeleteKeyboardEvent(Kt) {
  return Kt.key === "Backspace" || Kt.key === "Delete";
}
const Chip = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiChip"
  }), {
    avatar: bo,
    className: vo,
    clickable: Po,
    color: Co = "default",
    component: So,
    deleteIcon: wo,
    disabled: Eo = !1,
    icon: Ro,
    label: _o,
    onClick: Io,
    onDelete: Ao,
    onKeyDown: Oo,
    onKeyUp: jo,
    size: Do = "medium",
    variant: Lo = "filled",
    tabIndex: ko,
    skipFocusWhenDisabled: Ko = !1,
    // TODO v6: Rename to `focusableWhenDisabled`.
    ...No
  } = go, Jo = React$1.useRef(null), ti = useForkRef(Jo, ho), oi = (ci) => {
    ci.stopPropagation(), Ao && Ao(ci);
  }, Qo = (ci) => {
    ci.currentTarget === ci.target && isDeleteKeyboardEvent(ci) && ci.preventDefault(), Oo && Oo(ci);
  }, Zo = (ci) => {
    ci.currentTarget === ci.target && Ao && isDeleteKeyboardEvent(ci) && Ao(ci), jo && jo(ci);
  }, ei = Po !== !1 && Io ? !0 : Po, ii = ei || Ao ? ButtonBase : So || "div", ai = {
    ...go,
    component: ii,
    disabled: Eo,
    size: Do,
    color: Co,
    iconColor: /* @__PURE__ */ React$1.isValidElement(Ro) && Ro.props.color || Co,
    onDelete: !!Ao,
    clickable: ei,
    variant: Lo
  }, ri = useUtilityClasses$1g(ai), ni = ii === ButtonBase ? {
    component: So || "div",
    focusVisibleClassName: ri.focusVisible,
    ...Ao && {
      disableRipple: !0
    }
  } : {};
  let si = null;
  Ao && (si = wo && /* @__PURE__ */ React$1.isValidElement(wo) ? /* @__PURE__ */ React$1.cloneElement(wo, {
    className: clsx(wo.props.className, ri.deleteIcon),
    onClick: oi
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CancelIcon, {
    className: clsx(ri.deleteIcon),
    onClick: oi
  }));
  let li = null;
  bo && /* @__PURE__ */ React$1.isValidElement(bo) && (li = /* @__PURE__ */ React$1.cloneElement(bo, {
    className: clsx(ri.avatar, bo.props.className)
  }));
  let ui = null;
  return Ro && /* @__PURE__ */ React$1.isValidElement(Ro) && (ui = /* @__PURE__ */ React$1.cloneElement(Ro, {
    className: clsx(ri.icon, Ro.props.className)
  })), process.env.NODE_ENV !== "production" && li && ui && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ jsxRuntimeExports.jsxs(ChipRoot, {
    as: ii,
    className: clsx(ri.root, vo),
    disabled: ei && Eo ? !0 : void 0,
    onClick: Io,
    onKeyDown: Qo,
    onKeyUp: Zo,
    ref: ti,
    tabIndex: Ko && Eo ? -1 : ko,
    ownerState: ai,
    ...ni,
    ...No,
    children: [li || ui, /* @__PURE__ */ jsxRuntimeExports.jsx(ChipLabel, {
      className: clsx(ri.label),
      ownerState: ai,
      children: _o
    }), si]
  });
});
process.env.NODE_ENV !== "production" && (Chip.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: PropTypes.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: PropTypes.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Icon element.
   */
  icon: PropTypes.element,
  /**
   * The content of the component.
   */
  label: PropTypes.node,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  tabIndex: PropTypes.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined"]), PropTypes.string])
});
function getInputUtilityClass(Kt) {
  return generateUtilityClass$1("MuiInput", Kt);
}
const inputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses$1("MuiInput", ["root", "underline", "input"])
};
function getOutlinedInputUtilityClass(Kt) {
  return generateUtilityClass$1("MuiOutlinedInput", Kt);
}
const outlinedInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses$1("MuiOutlinedInput", ["root", "notchedOutline", "input"])
};
function getFilledInputUtilityClass(Kt) {
  return generateUtilityClass$1("MuiFilledInput", Kt);
}
const filledInputClasses = {
  ...inputBaseClasses,
  ...generateUtilityClasses$1("MuiFilledInput", ["root", "underline", "input", "adornedStart", "adornedEnd", "sizeSmall", "multiline", "hiddenLabel"])
}, CloseIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), ArrowDropDownIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function getAutocompleteUtilityClass(Kt) {
  return generateUtilityClass$1("MuiAutocomplete", Kt);
}
const autocompleteClasses = generateUtilityClasses$1("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
function useSlot(Kt, uo) {
  const {
    className: ho,
    elementType: go,
    ownerState: bo,
    externalForwardedProps: vo,
    internalForwardedProps: Po,
    ...Co
  } = uo, {
    component: So,
    slots: wo = {
      [Kt]: void 0
    },
    slotProps: Eo = {
      [Kt]: void 0
    },
    ...Ro
  } = vo, _o = wo[Kt] || go, Io = resolveComponentProps(Eo[Kt], bo), {
    props: {
      component: Ao,
      ...Oo
    },
    internalRef: jo
  } = mergeSlotProps({
    className: ho,
    ...Co,
    externalForwardedProps: Kt === "root" ? Ro : void 0,
    externalSlotProps: Io
  }), Do = useForkRef(jo, Io == null ? void 0 : Io.ref, uo.ref), Lo = Kt === "root" ? Ao || So : Ao, ko = appendOwnerState(_o, {
    ...Kt === "root" && !So && !wo[Kt] && Po,
    ...Kt !== "root" && !wo[Kt] && Po,
    ...Oo,
    ...Lo && {
      as: Lo
    },
    ref: Do
  }, bo);
  return [_o, ko];
}
var _ClearIcon, _ArrowDropDownIcon;
const useUtilityClasses$1f = (Kt) => {
  const {
    classes: uo,
    disablePortal: ho,
    expanded: go,
    focused: bo,
    fullWidth: vo,
    hasClearIcon: Po,
    hasPopupIcon: Co,
    inputFocused: So,
    popupOpen: wo,
    size: Eo
  } = Kt, Ro = {
    root: ["root", go && "expanded", bo && "focused", vo && "fullWidth", Po && "hasClearIcon", Co && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", So && "inputFocused"],
    tag: ["tag", `tagSize${capitalize(Eo)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", wo && "popupIndicatorOpen"],
    popper: ["popper", ho && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return composeClasses(Ro, getAutocompleteUtilityClass, uo);
}, AutocompleteRoot = styled("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt, {
      fullWidth: go,
      hasClearIcon: bo,
      hasPopupIcon: vo,
      inputFocused: Po,
      size: Co
    } = ho;
    return [{
      [`& .${autocompleteClasses.tag}`]: uo.tag
    }, {
      [`& .${autocompleteClasses.tag}`]: uo[`tagSize${capitalize(Co)}`]
    }, {
      [`& .${autocompleteClasses.inputRoot}`]: uo.inputRoot
    }, {
      [`& .${autocompleteClasses.input}`]: uo.input
    }, {
      [`& .${autocompleteClasses.input}`]: Po && uo.inputFocused
    }, uo.root, go && uo.fullWidth, vo && uo.hasPopupIcon, bo && uo.hasClearIcon];
  }
})({
  [`&.${autocompleteClasses.focused} .${autocompleteClasses.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${autocompleteClasses.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${autocompleteClasses.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${autocompleteClasses.inputRoot}`]: {
    [`.${autocompleteClasses.hasPopupIcon}&, .${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${autocompleteClasses.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${inputClasses.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${inputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    [`& .${inputClasses.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${outlinedInputClasses.root}`]: {
    padding: 9,
    [`.${autocompleteClasses.hasPopupIcon}&, .${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${autocompleteClasses.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${autocompleteClasses.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${outlinedInputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${autocompleteClasses.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${filledInputClasses.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${autocompleteClasses.hasPopupIcon}&, .${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${autocompleteClasses.hasPopupIcon}.${autocompleteClasses.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${filledInputClasses.input}`]: {
      padding: "7px 4px"
    },
    [`& .${autocompleteClasses.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${filledInputClasses.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${inputBaseClasses.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${autocompleteClasses.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${filledInputClasses.root}.${inputBaseClasses.hiddenLabel}.${inputBaseClasses.sizeSmall}`]: {
    [`& .${autocompleteClasses.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${autocompleteClasses.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${autocompleteClasses.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${autocompleteClasses.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${autocompleteClasses.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), AutocompleteEndAdornment = styled("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (Kt, uo) => uo.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), AutocompleteClearIndicator = styled(IconButton, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (Kt, uo) => uo.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), AutocompletePopupIndicator = styled(IconButton, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.popupIndicator, ho.popupOpen && uo.popupIndicatorOpen];
  }
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), AutocompletePopper = styled(Popper, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [{
      [`& .${autocompleteClasses.option}`]: uo.option
    }, uo.popper, ho.disablePortal && uo.popperDisablePortal];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  zIndex: (Kt.vars || Kt).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
}))), AutocompletePaper = styled(Paper, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (Kt, uo) => uo.paper
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body1,
  overflow: "auto"
}))), AutocompleteLoading = styled("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (Kt, uo) => uo.loading
})(memoTheme(({
  theme: Kt
}) => ({
  color: (Kt.vars || Kt).palette.text.secondary,
  padding: "14px 16px"
}))), AutocompleteNoOptions = styled("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (Kt, uo) => uo.noOptions
})(memoTheme(({
  theme: Kt
}) => ({
  color: (Kt.vars || Kt).palette.text.secondary,
  padding: "14px 16px"
}))), AutocompleteListbox = styled("ul", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (Kt, uo) => uo.listbox
})(memoTheme(({
  theme: Kt
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${autocompleteClasses.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [Kt.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${autocompleteClasses.focused}`]: {
      backgroundColor: (Kt.vars || Kt).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (Kt.vars || Kt).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${autocompleteClasses.focusVisible}`]: {
      backgroundColor: (Kt.vars || Kt).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / ${Kt.vars.palette.action.selectedOpacity})` : alpha$1(Kt.palette.primary.main, Kt.palette.action.selectedOpacity),
      [`&.${autocompleteClasses.focused}`]: {
        backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.hoverOpacity}))` : alpha$1(Kt.palette.primary.main, Kt.palette.action.selectedOpacity + Kt.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (Kt.vars || Kt).palette.action.selected
        }
      },
      [`&.${autocompleteClasses.focusVisible}`]: {
        backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.focusOpacity}))` : alpha$1(Kt.palette.primary.main, Kt.palette.action.selectedOpacity + Kt.palette.action.focusOpacity)
      }
    }
  }
}))), AutocompleteGroupLabel = styled(ListSubheader, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (Kt, uo) => uo.groupLabel
})(memoTheme(({
  theme: Kt
}) => ({
  backgroundColor: (Kt.vars || Kt).palette.background.paper,
  top: -8
}))), AutocompleteGroupUl = styled("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (Kt, uo) => uo.groupUl
})({
  padding: 0,
  [`& .${autocompleteClasses.option}`]: {
    paddingLeft: 24
  }
}), Autocomplete = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiAutocomplete"
  }), {
    autoComplete: bo = !1,
    autoHighlight: vo = !1,
    autoSelect: Po = !1,
    blurOnSelect: Co = !1,
    ChipProps: So,
    className: wo,
    clearIcon: Eo = _ClearIcon || (_ClearIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, {
      fontSize: "small"
    })),
    clearOnBlur: Ro = !go.freeSolo,
    clearOnEscape: _o = !1,
    clearText: Io = "Clear",
    closeText: Ao = "Close",
    componentsProps: Oo,
    defaultValue: jo = go.multiple ? [] : null,
    disableClearable: Do = !1,
    disableCloseOnSelect: Lo = !1,
    disabled: ko = !1,
    disabledItemsFocusable: Ko = !1,
    disableListWrap: No = !1,
    disablePortal: Jo = !1,
    filterOptions: ti,
    filterSelectedOptions: oi = !1,
    forcePopupIcon: Qo = "auto",
    freeSolo: Zo = !1,
    fullWidth: ei = !1,
    getLimitTagsText: ii = (Ts) => `+${Ts}`,
    getOptionDisabled: ai,
    getOptionKey: ri,
    getOptionLabel: ni,
    isOptionEqualToValue: si,
    groupBy: li,
    handleHomeEndKeys: ui = !go.freeSolo,
    id: ci,
    includeInputInList: fi = !1,
    inputValue: yi,
    limitTags: hi = -1,
    ListboxComponent: mi,
    ListboxProps: bi,
    loading: xi = !1,
    loadingText: $i = "Loading…",
    multiple: Ci = !1,
    noOptionsText: Si = "No options",
    onChange: vi,
    onClose: Pi,
    onHighlightChange: wi,
    onInputChange: gi,
    onOpen: Ri,
    open: Ei,
    openOnFocus: Ni = !1,
    openText: Ai = "Open",
    options: Yi,
    PaperComponent: Ui,
    PopperComponent: us,
    popupIcon: ns = _ArrowDropDownIcon || (_ArrowDropDownIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(ArrowDropDownIcon, {})),
    readOnly: Ti = !1,
    renderGroup: _i,
    renderInput: Vi,
    renderOption: Bi,
    renderTags: Ji,
    selectOnFocus: Ki = !go.freeSolo,
    size: qi = "medium",
    slots: rs = {},
    slotProps: os = {},
    value: ps,
    ...Mi
  } = go, {
    getRootProps: Wi,
    getInputProps: Hi,
    getInputLabelProps: Xi,
    getPopupIndicatorProps: Zi,
    getClearProps: zi,
    getTagProps: cs,
    getListboxProps: ys,
    getOptionProps: $s,
    value: Ns,
    dirty: Bs,
    expanded: Ws,
    id: Hs,
    popupOpen: Ks,
    focused: zs,
    focusedTag: Ys,
    anchorEl: ds,
    setAnchorEl: Ls,
    inputValue: Xs,
    groupedOptions: sa
  } = useAutocomplete({
    ...go,
    componentName: "Autocomplete"
  }), ya = !Do && !ko && Bs && !Ti, ma = (!Zo || Qo === !0) && Qo !== !1, {
    onMouseDown: Ca
  } = Hi(), {
    ref: Sa,
    ...va
  } = ys(), ha = ni || ((Ts) => Ts.label ?? Ts), Gs = {
    ...go,
    disablePortal: Jo,
    expanded: Ws,
    focused: zs,
    fullWidth: ei,
    getOptionLabel: ha,
    hasClearIcon: ya,
    hasPopupIcon: ma,
    inputFocused: Ys === -1,
    popupOpen: Ks,
    size: qi
  }, Rs = useUtilityClasses$1f(Gs), Qs = {
    slots: {
      paper: Ui,
      popper: us,
      ...rs
    },
    slotProps: {
      chip: So,
      listbox: bi,
      ...Oo,
      ...os
    }
  }, [Gi, Li] = useSlot("listbox", {
    elementType: AutocompleteListbox,
    externalForwardedProps: Qs,
    ownerState: Gs,
    className: Rs.listbox,
    additionalProps: va,
    ref: Sa
  }), [Qi, ms] = useSlot("paper", {
    elementType: Paper,
    externalForwardedProps: Qs,
    ownerState: Gs,
    className: Rs.paper
  }), [vs, Ss] = useSlot("popper", {
    elementType: Popper,
    externalForwardedProps: Qs,
    ownerState: Gs,
    className: Rs.popper,
    additionalProps: {
      disablePortal: Jo,
      style: {
        width: ds ? ds.clientWidth : null
      },
      role: "presentation",
      anchorEl: ds,
      open: Ks
    }
  });
  let Cs;
  if (Ci && Ns.length > 0) {
    const Ts = (Zs) => ({
      className: Rs.tag,
      disabled: ko,
      ...cs(Zs)
    });
    Ji ? Cs = Ji(Ns, Ts, Gs) : Cs = Ns.map((Zs, ta) => {
      const {
        key: ga,
        ...Ma
      } = Ts({
        index: ta
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Chip, {
        label: ha(Zs),
        size: qi,
        ...Ma,
        ...Qs.slotProps.chip
      }, ga);
    });
  }
  if (hi > -1 && Array.isArray(Cs)) {
    const Ts = Cs.length - hi;
    !zs && Ts > 0 && (Cs = Cs.splice(0, hi), Cs.push(/* @__PURE__ */ jsxRuntimeExports.jsx("span", {
      className: Rs.tag,
      children: ii(Ts)
    }, Cs.length)));
  }
  const fa = _i || ((Ts) => /* @__PURE__ */ jsxRuntimeExports.jsxs("li", {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteGroupLabel, {
      className: Rs.groupLabel,
      ownerState: Gs,
      component: "div",
      children: Ts.group
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteGroupUl, {
      className: Rs.groupUl,
      ownerState: Gs,
      children: Ts.children
    })]
  }, Ts.key)), Aa = Bi || ((Ts, Zs) => {
    const {
      key: ta,
      ...ga
    } = Ts;
    return /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
      ...ga,
      children: ha(Zs)
    }, ta);
  }), Ea = (Ts, Zs) => {
    const ta = $s({
      option: Ts,
      index: Zs
    });
    return Aa({
      ...ta,
      className: Rs.option
    }, Ts, {
      selected: ta["aria-selected"],
      index: Zs,
      inputValue: Xs
    }, Gs);
  }, Pa = Qs.slotProps.clearIndicator, xa = Qs.slotProps.popupIndicator, $a = (Ts) => /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompletePopper, {
    as: vs,
    ...Ss,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompletePaper, {
      as: Qi,
      ...ms,
      children: Ts
    })
  });
  let Ta = null;
  return sa.length > 0 ? Ta = $a(
    // TODO v7: remove `as` prop and move ListboxComponentProp to externalForwardedProps or remove ListboxComponentProp entirely
    // https://github.com/mui/material-ui/pull/43994#issuecomment-2401945800
    /* @__PURE__ */ jsxRuntimeExports.jsx(Gi, {
      as: mi,
      ...Li,
      children: sa.map((Ts, Zs) => li ? fa({
        key: Ts.key,
        group: Ts.group,
        children: Ts.options.map((ta, ga) => Ea(ta, Ts.index + ga))
      }) : Ea(Ts, Zs))
    })
  ) : xi && sa.length === 0 ? Ta = $a(/* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteLoading, {
    className: Rs.loading,
    ownerState: Gs,
    children: $i
  })) : sa.length === 0 && !Zo && !xi && (Ta = $a(/* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteNoOptions, {
    className: Rs.noOptions,
    ownerState: Gs,
    role: "presentation",
    onMouseDown: (Ts) => {
      Ts.preventDefault();
    },
    children: Si
  }))), /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteRoot, {
      ref: ho,
      className: clsx(Rs.root, wo),
      ownerState: Gs,
      ...Wi(Mi),
      children: Vi({
        id: Hs,
        disabled: ko,
        fullWidth: !0,
        size: qi === "small" ? "small" : void 0,
        InputLabelProps: Xi(),
        InputProps: {
          ref: Ls,
          className: Rs.inputRoot,
          startAdornment: Cs,
          onMouseDown: (Ts) => {
            Ts.target === Ts.currentTarget && Ca(Ts);
          },
          ...(ya || ma) && {
            endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsxs(AutocompleteEndAdornment, {
              className: Rs.endAdornment,
              ownerState: Gs,
              children: [ya ? /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompleteClearIndicator, {
                ...zi(),
                "aria-label": Io,
                title: Io,
                ownerState: Gs,
                ...Pa,
                className: clsx(Rs.clearIndicator, Pa == null ? void 0 : Pa.className),
                children: Eo
              }) : null, ma ? /* @__PURE__ */ jsxRuntimeExports.jsx(AutocompletePopupIndicator, {
                ...Zi(),
                disabled: ko,
                "aria-label": Ks ? Ao : Ai,
                title: Ks ? Ao : Ai,
                ownerState: Gs,
                ...xa,
                className: clsx(Rs.popupIndicator, xa == null ? void 0 : xa.className),
                children: ns
              }) : null]
            })
          }
        },
        inputProps: {
          className: Rs.input,
          disabled: ko,
          readOnly: Ti,
          ...Hi()
        }
      })
    }), ds ? Ta : null]
  });
});
process.env.NODE_ENV !== "production" && (Autocomplete.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: PropTypes.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: PropTypes.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: PropTypes.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(["mouse", "touch"]), PropTypes.bool]),
  /**
   * Props applied to the [`Chip`](https://mui.com/material-ui/api/chip/) element.
   * @deprecated Use `slotProps.chip` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ChipProps: PropTypes.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: PropTypes.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: PropTypes.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: PropTypes.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: PropTypes.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: PropTypes.shape({
    clearIndicator: PropTypes.object,
    paper: PropTypes.object,
    popper: PropTypes.object,
    popupIndicator: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: chainPropTypes(PropTypes.any, (Kt) => Kt.multiple && Kt.defaultValue !== void 0 && !Array.isArray(Kt.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${Kt.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: PropTypes.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: PropTypes.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: PropTypes.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: PropTypes.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: PropTypes.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: PropTypes.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: PropTypes.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} option The Autocomplete option.
   * @returns {string}
   */
  groupBy: PropTypes.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: PropTypes.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: PropTypes.bool,
  /**
   * The input value.
   */
  inputValue: PropTypes.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: PropTypes.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: integerPropType,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   * @deprecated Use `slotProps.listbox.component` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxComponent: PropTypes.elementType,
  /**
   * Props applied to the Listbox element.
   * @deprecated Use `slotProps.listbox` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  ListboxProps: PropTypes.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: PropTypes.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: PropTypes.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: PropTypes.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`, `"blur"`, `"selectOption"`, `"removeOption"`
   */
  onInputChange: PropTypes.func,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: PropTypes.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: PropTypes.string,
  /**
   * A list of options that will be shown in the Autocomplete.
   */
  options: PropTypes.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   * @deprecated Use `slots.paper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PaperComponent: PropTypes.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   * @deprecated Use `slots.popper` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: PropTypes.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: PropTypes.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    chip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    clearIndicator: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    listbox: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popupIndicator: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    listbox: PropTypes.elementType,
    paper: PropTypes.elementType,
    popper: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: chainPropTypes(PropTypes.any, (Kt) => Kt.multiple && Kt.value !== void 0 && !Array.isArray(Kt.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${Kt.value} was provided.`].join(`
`)) : null)
});
const _excluded$Z = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"], _excluded2$d = ["key"];
function GridFilterInputMultipleValue(Kt) {
  const {
    item: uo,
    applyValue: ho,
    type: go,
    apiRef: bo,
    focusElementRef: vo,
    color: Po,
    error: Co,
    helperText: So,
    size: wo,
    variant: Eo = "standard"
  } = Kt, Ro = _objectWithoutPropertiesLoose$h(Kt, _excluded$Z), _o = {
    color: Po,
    error: Co,
    helperText: So,
    size: wo,
    variant: Eo
  }, [Io, Ao] = React$1.useState(uo.value || []), Oo = useId(), jo = useGridRootProps();
  React$1.useEffect(() => {
    const Lo = uo.value ?? [];
    Ao(Lo.map(String));
  }, [uo.value]);
  const Do = React$1.useCallback((Lo, ko) => {
    Ao(ko.map(String)), ho(_extends$q({}, uo, {
      value: [...ko.map((Ko) => go === "number" ? Number(Ko) : Ko)]
    }));
  }, [ho, uo, go]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Autocomplete, _extends$q({
    multiple: !0,
    freeSolo: !0,
    options: [],
    filterOptions: (Lo, ko) => {
      const {
        inputValue: Ko
      } = ko;
      return Ko == null || Ko === "" ? [] : [Ko];
    },
    id: Oo,
    value: Io,
    onChange: Do,
    renderTags: (Lo, ko) => Lo.map((Ko, No) => {
      const Jo = ko({
        index: No
      }), {
        key: ti
      } = Jo, oi = _objectWithoutPropertiesLoose$h(Jo, _excluded2$d);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jo.slots.baseChip, _extends$q({
        variant: "outlined",
        size: "small",
        label: Ko
      }, oi), ti);
    }),
    renderInput: (Lo) => {
      var ko;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jo.slots.baseTextField, _extends$q({}, Lo, {
        label: bo.current.getLocaleText("filterPanelInputLabel"),
        placeholder: bo.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: _extends$q({}, Lo.InputLabelProps, {
          shrink: !0
        }),
        inputRef: vo,
        type: go || "text"
      }, _o, (ko = jo.slotProps) == null ? void 0 : ko.baseTextField));
    }
  }, Ro));
}
process.env.NODE_ENV !== "production" && (GridFilterInputMultipleValue.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  type: PropTypes.oneOf(["date", "datetime-local", "number", "text"])
});
var GridEditModes = /* @__PURE__ */ function(Kt) {
  return Kt.Cell = "cell", Kt.Row = "row", Kt;
}(GridEditModes || {}), GridCellModes = /* @__PURE__ */ function(Kt) {
  return Kt.Edit = "edit", Kt.View = "view", Kt;
}(GridCellModes || {}), GridRowModes = /* @__PURE__ */ function(Kt) {
  return Kt.Edit = "edit", Kt.View = "view", Kt;
}(GridRowModes || {}), GridLogicOperator = /* @__PURE__ */ function(Kt) {
  return Kt.And = "and", Kt.Or = "or", Kt;
}(GridLogicOperator || {}), GridCellEditStartReasons = /* @__PURE__ */ function(Kt) {
  return Kt.enterKeyDown = "enterKeyDown", Kt.cellDoubleClick = "cellDoubleClick", Kt.printableKeyDown = "printableKeyDown", Kt.deleteKeyDown = "deleteKeyDown", Kt.pasteKeyDown = "pasteKeyDown", Kt;
}(GridCellEditStartReasons || {}), GridCellEditStopReasons = /* @__PURE__ */ function(Kt) {
  return Kt.cellFocusOut = "cellFocusOut", Kt.escapeKeyDown = "escapeKeyDown", Kt.enterKeyDown = "enterKeyDown", Kt.tabKeyDown = "tabKeyDown", Kt.shiftTabKeyDown = "shiftTabKeyDown", Kt;
}(GridCellEditStopReasons || {}), GridRowEditStartReasons = /* @__PURE__ */ function(Kt) {
  return Kt.enterKeyDown = "enterKeyDown", Kt.cellDoubleClick = "cellDoubleClick", Kt.printableKeyDown = "printableKeyDown", Kt.deleteKeyDown = "deleteKeyDown", Kt;
}(GridRowEditStartReasons || {}), GridRowEditStopReasons = /* @__PURE__ */ function(Kt) {
  return Kt.rowFocusOut = "rowFocusOut", Kt.escapeKeyDown = "escapeKeyDown", Kt.enterKeyDown = "enterKeyDown", Kt.tabKeyDown = "tabKeyDown", Kt.shiftTabKeyDown = "shiftTabKeyDown", Kt;
}(GridRowEditStopReasons || {});
function isLeaf(Kt) {
  return Kt.field !== void 0;
}
const getDefaultGridFilterModel = () => ({
  items: [],
  logicOperator: GridLogicOperator.And,
  quickFilterValues: [],
  quickFilterLogicOperator: GridLogicOperator.And
});
function getPublicApiRef(Kt) {
  return {
    current: Kt.current.getPublicApi()
  };
}
let hasEval;
function getHasEval() {
  if (hasEval !== void 0)
    return hasEval;
  try {
    hasEval = new Function("return true")();
  } catch {
    hasEval = !1;
  }
  return hasEval;
}
const cleanFilterItem = (Kt, uo) => {
  const ho = _extends$q({}, Kt);
  if (ho.id == null && (ho.id = Math.round(Math.random() * 1e5)), ho.operator == null) {
    const go = gridColumnLookupSelector(uo)[ho.field];
    ho.operator = go && go.filterOperators[0].value;
  }
  return ho;
}, sanitizeFilterModel = (Kt, uo, ho) => {
  const go = Kt.items.length > 1;
  let bo;
  go && uo ? (process.env.NODE_ENV !== "production" && warnOnce(["MUI X: The `filterModel` can only contain a single item when the `disableMultipleColumnsFiltering` prop is set to `true`.", "If you are using the community version of the Data Grid, this prop is always `true`."], "error"), bo = [Kt.items[0]]) : bo = Kt.items;
  const vo = go && bo.some((Co) => Co.id == null), Po = bo.some((Co) => Co.operator == null);
  return process.env.NODE_ENV !== "production" && vo && warnOnce("MUI X: The `id` field is required on `filterModel.items` when you use multiple filters.", "error"), process.env.NODE_ENV !== "production" && Po && warnOnce("MUI X: The `operator` field is required on `filterModel.items`, one or more of your filtering item has no `operator` provided.", "error"), Po || vo ? _extends$q({}, Kt, {
    items: bo.map((Co) => cleanFilterItem(Co, ho))
  }) : Kt.items !== bo ? _extends$q({}, Kt, {
    items: bo
  }) : Kt;
}, mergeStateWithFilterModel = (Kt, uo, ho) => (go) => _extends$q({}, go, {
  filterModel: sanitizeFilterModel(Kt, uo, ho)
}), removeDiacritics = (Kt) => typeof Kt == "string" ? Kt.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : Kt, getFilterCallbackFromItem = (Kt, uo) => {
  var Eo;
  if (!Kt.field || !Kt.operator)
    return null;
  const ho = uo.current.getColumn(Kt.field);
  if (!ho)
    return null;
  let go;
  if (ho.valueParser) {
    const Ro = ho.valueParser;
    go = Array.isArray(Kt.value) ? (Eo = Kt.value) == null ? void 0 : Eo.map((_o) => Ro(_o, void 0, ho, uo)) : Ro(Kt.value, void 0, ho, uo);
  } else
    go = Kt.value;
  const {
    ignoreDiacritics: bo
  } = uo.current.rootProps;
  bo && (go = removeDiacritics(go));
  const vo = _extends$q({}, Kt, {
    value: go
  }), Po = ho.filterOperators;
  if (!(Po != null && Po.length))
    throw new Error(`MUI X: No filter operators found for column '${ho.field}'.`);
  const Co = Po.find((Ro) => Ro.value === vo.operator);
  if (!Co)
    throw new Error(`MUI X: No filter operator found for column '${ho.field}' and operator value '${vo.operator}'.`);
  const So = getPublicApiRef(uo), wo = Co.getApplyFilterFn(vo, ho);
  return typeof wo != "function" ? null : {
    item: vo,
    fn: (Ro) => {
      let _o = uo.current.getRowValue(Ro, ho);
      return bo && (_o = removeDiacritics(_o)), wo(_o, Ro, ho, So);
    }
  };
};
let filterItemsApplierId = 1;
const buildAggregatedFilterItemsApplier = (Kt, uo, ho) => {
  const {
    items: go
  } = Kt, bo = go.map((Co) => getFilterCallbackFromItem(Co, uo)).filter((Co) => !!Co);
  if (bo.length === 0)
    return null;
  if (ho || !getHasEval())
    return (Co, So) => {
      const wo = {};
      for (let Eo = 0; Eo < bo.length; Eo += 1) {
        const Ro = bo[Eo];
        (!So || So(Ro.item.field)) && (wo[Ro.item.id] = Ro.fn(Co));
      }
      return wo;
    };
  const vo = new Function("appliers", "row", "shouldApplyFilter", `"use strict";
${bo.map((Co, So) => `const shouldApply${So} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(Co.item.field)});`).join(`
`)}

const result$$ = {
${bo.map((Co, So) => `  ${JSON.stringify(String(Co.item.id))}: !shouldApply${So} ? false : appliers[${So}].fn(row),`).join(`
`)}
};

return result$$;`.replaceAll("$$", String(filterItemsApplierId)));
  return filterItemsApplierId += 1, (Co, So) => vo(bo, Co, So);
}, shouldQuickFilterExcludeHiddenColumns = (Kt) => Kt.quickFilterExcludeHiddenColumns ?? !0, buildAggregatedQuickFilterApplier = (Kt, uo) => {
  var Co;
  const ho = ((Co = Kt.quickFilterValues) == null ? void 0 : Co.filter(Boolean)) ?? [];
  if (ho.length === 0)
    return null;
  const go = shouldQuickFilterExcludeHiddenColumns(Kt) ? gridVisibleColumnFieldsSelector(uo) : gridColumnFieldsSelector(uo), bo = [], {
    ignoreDiacritics: vo
  } = uo.current.rootProps, Po = getPublicApiRef(uo);
  return go.forEach((So) => {
    const wo = uo.current.getColumn(So), Eo = wo == null ? void 0 : wo.getApplyQuickFilterFn;
    Eo && bo.push({
      column: wo,
      appliers: ho.map((Ro) => {
        const _o = vo ? removeDiacritics(Ro) : Ro;
        return {
          fn: Eo(_o, wo, Po)
        };
      })
    });
  }), function(wo, Eo) {
    const Ro = {};
    e: for (let _o = 0; _o < ho.length; _o += 1) {
      const Io = ho[_o];
      for (let Ao = 0; Ao < bo.length; Ao += 1) {
        const {
          column: Oo,
          appliers: jo
        } = bo[Ao], {
          field: Do
        } = Oo;
        if (Eo && !Eo(Do))
          continue;
        const Lo = jo[_o];
        let ko = uo.current.getRowValue(wo, Oo);
        if (Lo.fn === null)
          continue;
        if (vo && (ko = removeDiacritics(ko)), Lo.fn(ko, wo, Oo, Po)) {
          Ro[Io] = !0;
          continue e;
        }
      }
      Ro[Io] = !1;
    }
    return Ro;
  };
}, buildAggregatedFilterApplier = (Kt, uo, ho) => {
  const go = buildAggregatedFilterItemsApplier(Kt, uo, ho), bo = buildAggregatedQuickFilterApplier(Kt, uo);
  return function(Po, Co, So) {
    So.passingFilterItems = (go == null ? void 0 : go(Po, Co)) ?? null, So.passingQuickFilterValues = (bo == null ? void 0 : bo(Po, Co)) ?? null;
  };
}, isNotNull = (Kt) => Kt != null, filterModelItems = (Kt, uo, ho) => (Kt.cleanedFilterItems || (Kt.cleanedFilterItems = ho.filter((go) => getFilterCallbackFromItem(go, uo) !== null)), Kt.cleanedFilterItems), passFilterLogic = (Kt, uo, ho, go, bo) => {
  const vo = filterModelItems(bo, go, ho.items), Po = Kt.filter(isNotNull), Co = uo.filter(isNotNull);
  if (Po.length > 0) {
    const So = (Eo) => Po.some((Ro) => Ro[Eo.id]);
    if ((ho.logicOperator ?? getDefaultGridFilterModel().logicOperator) === GridLogicOperator.And) {
      if (!vo.every(So))
        return !1;
    } else if (!vo.some(So))
      return !1;
  }
  if (Co.length > 0 && ho.quickFilterValues != null) {
    const So = (Eo) => Co.some((Ro) => Ro[Eo]);
    if ((ho.quickFilterLogicOperator ?? getDefaultGridFilterModel().quickFilterLogicOperator) === GridLogicOperator.And) {
      if (!ho.quickFilterValues.every(So))
        return !1;
    } else if (!ho.quickFilterValues.some(So))
      return !1;
  }
  return !0;
}, getGridStringQuickFilterFn = (Kt) => {
  if (!Kt)
    return null;
  const uo = new RegExp(escapeRegExp(Kt), "i");
  return (ho, go, bo, vo) => {
    let Po = vo.current.getRowFormattedValue(go, bo);
    return vo.current.ignoreDiacritics && (Po = removeDiacritics(Po)), Po != null ? uo.test(Po.toString()) : !1;
  };
}, createContainsFilterFn = (Kt, uo) => (ho) => {
  if (!ho.value)
    return null;
  const go = Kt ? ho.value : ho.value.trim(), bo = new RegExp(escapeRegExp(go), "i");
  return (vo) => {
    if (vo == null)
      return uo;
    const Po = bo.test(String(vo));
    return uo ? !Po : Po;
  };
}, createEqualityFilterFn = (Kt, uo) => (ho) => {
  if (!ho.value)
    return null;
  const go = Kt ? ho.value : ho.value.trim(), bo = new Intl.Collator(void 0, {
    sensitivity: "base",
    usage: "search"
  });
  return (vo) => {
    if (vo == null)
      return uo;
    const Po = bo.compare(go, vo.toString()) === 0;
    return uo ? !Po : Po;
  };
}, createEmptyFilterFn = (Kt) => () => (uo) => {
  const ho = uo === "" || uo == null;
  return Kt ? !ho : ho;
}, getGridStringOperators = (Kt = !1) => [{
  value: "contains",
  getApplyFilterFn: createContainsFilterFn(Kt, !1),
  InputComponent: GridFilterInputValue
}, {
  value: "doesNotContain",
  getApplyFilterFn: createContainsFilterFn(Kt, !0),
  InputComponent: GridFilterInputValue
}, {
  value: "equals",
  getApplyFilterFn: createEqualityFilterFn(Kt, !1),
  InputComponent: GridFilterInputValue
}, {
  value: "doesNotEqual",
  getApplyFilterFn: createEqualityFilterFn(Kt, !0),
  InputComponent: GridFilterInputValue
}, {
  value: "startsWith",
  getApplyFilterFn: (uo) => {
    if (!uo.value)
      return null;
    const ho = Kt ? uo.value : uo.value.trim(), go = new RegExp(`^${escapeRegExp(ho)}.*$`, "i");
    return (bo) => bo != null ? go.test(bo.toString()) : !1;
  },
  InputComponent: GridFilterInputValue
}, {
  value: "endsWith",
  getApplyFilterFn: (uo) => {
    if (!uo.value)
      return null;
    const ho = Kt ? uo.value : uo.value.trim(), go = new RegExp(`.*${escapeRegExp(ho)}$`, "i");
    return (bo) => bo != null ? go.test(bo.toString()) : !1;
  },
  InputComponent: GridFilterInputValue
}, {
  value: "isEmpty",
  getApplyFilterFn: createEmptyFilterFn(!1),
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: createEmptyFilterFn(!0),
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFn: (uo) => {
    if (!Array.isArray(uo.value) || uo.value.length === 0)
      return null;
    const ho = Kt ? uo.value : uo.value.map((bo) => bo.trim()), go = new Intl.Collator(void 0, {
      sensitivity: "base",
      usage: "search"
    });
    return (bo) => bo != null ? ho.some((vo) => go.compare(vo, bo.toString() || "") === 0) : !1;
  },
  InputComponent: GridFilterInputMultipleValue
}], GRID_STRING_COL_DEF = {
  width: 100,
  minWidth: 50,
  maxWidth: 1 / 0,
  hideable: !0,
  sortable: !0,
  resizable: !0,
  filterable: !0,
  groupable: !0,
  pinnable: !0,
  // @ts-ignore
  aggregable: !0,
  editable: !1,
  sortComparator: gridStringOrNumberComparator,
  type: "string",
  align: "left",
  filterOperators: getGridStringOperators(),
  renderEditCell: renderEditInputCell,
  getApplyQuickFilterFn: getGridStringQuickFilterFn
};
var reactIs$1 = { exports: {} }, reactIs_production = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production;
function requireReactIs_production() {
  if (hasRequiredReactIs_production) return reactIs_production;
  hasRequiredReactIs_production = 1;
  var Kt = Symbol.for("react.transitional.element"), uo = Symbol.for("react.portal"), ho = Symbol.for("react.fragment"), go = Symbol.for("react.strict_mode"), bo = Symbol.for("react.profiler"), vo = Symbol.for("react.consumer"), Po = Symbol.for("react.context"), Co = Symbol.for("react.forward_ref"), So = Symbol.for("react.suspense"), wo = Symbol.for("react.suspense_list"), Eo = Symbol.for("react.memo"), Ro = Symbol.for("react.lazy"), _o = Symbol.for("react.offscreen"), Io = Symbol.for("react.client.reference");
  function Ao(Oo) {
    if (typeof Oo == "object" && Oo !== null) {
      var jo = Oo.$$typeof;
      switch (jo) {
        case Kt:
          switch (Oo = Oo.type, Oo) {
            case ho:
            case bo:
            case go:
            case So:
            case wo:
              return Oo;
            default:
              switch (Oo = Oo && Oo.$$typeof, Oo) {
                case Po:
                case Co:
                case Ro:
                case Eo:
                  return Oo;
                case vo:
                  return Oo;
                default:
                  return jo;
              }
          }
        case uo:
          return jo;
      }
    }
  }
  return reactIs_production.ContextConsumer = vo, reactIs_production.ContextProvider = Po, reactIs_production.Element = Kt, reactIs_production.ForwardRef = Co, reactIs_production.Fragment = ho, reactIs_production.Lazy = Ro, reactIs_production.Memo = Eo, reactIs_production.Portal = uo, reactIs_production.Profiler = bo, reactIs_production.StrictMode = go, reactIs_production.Suspense = So, reactIs_production.SuspenseList = wo, reactIs_production.isContextConsumer = function(Oo) {
    return Ao(Oo) === vo;
  }, reactIs_production.isContextProvider = function(Oo) {
    return Ao(Oo) === Po;
  }, reactIs_production.isElement = function(Oo) {
    return typeof Oo == "object" && Oo !== null && Oo.$$typeof === Kt;
  }, reactIs_production.isForwardRef = function(Oo) {
    return Ao(Oo) === Co;
  }, reactIs_production.isFragment = function(Oo) {
    return Ao(Oo) === ho;
  }, reactIs_production.isLazy = function(Oo) {
    return Ao(Oo) === Ro;
  }, reactIs_production.isMemo = function(Oo) {
    return Ao(Oo) === Eo;
  }, reactIs_production.isPortal = function(Oo) {
    return Ao(Oo) === uo;
  }, reactIs_production.isProfiler = function(Oo) {
    return Ao(Oo) === bo;
  }, reactIs_production.isStrictMode = function(Oo) {
    return Ao(Oo) === go;
  }, reactIs_production.isSuspense = function(Oo) {
    return Ao(Oo) === So;
  }, reactIs_production.isSuspenseList = function(Oo) {
    return Ao(Oo) === wo;
  }, reactIs_production.isValidElementType = function(Oo) {
    return typeof Oo == "string" || typeof Oo == "function" || Oo === ho || Oo === bo || Oo === go || Oo === So || Oo === wo || Oo === _o || typeof Oo == "object" && Oo !== null && (Oo.$$typeof === Ro || Oo.$$typeof === Eo || Oo.$$typeof === Po || Oo.$$typeof === vo || Oo.$$typeof === Co || Oo.$$typeof === Io || Oo.getModuleId !== void 0);
  }, reactIs_production.typeOf = Ao, reactIs_production;
}
var reactIs_development$1 = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development$1;
function requireReactIs_development$1() {
  return hasRequiredReactIs_development$1 || (hasRequiredReactIs_development$1 = 1, process.env.NODE_ENV !== "production" && function() {
    function Kt(Oo) {
      if (typeof Oo == "object" && Oo !== null) {
        var jo = Oo.$$typeof;
        switch (jo) {
          case uo:
            switch (Oo = Oo.type, Oo) {
              case go:
              case vo:
              case bo:
              case wo:
              case Eo:
                return Oo;
              default:
                switch (Oo = Oo && Oo.$$typeof, Oo) {
                  case Co:
                  case So:
                  case _o:
                  case Ro:
                    return Oo;
                  case Po:
                    return Oo;
                  default:
                    return jo;
                }
            }
          case ho:
            return jo;
        }
      }
    }
    var uo = Symbol.for("react.transitional.element"), ho = Symbol.for("react.portal"), go = Symbol.for("react.fragment"), bo = Symbol.for("react.strict_mode"), vo = Symbol.for("react.profiler"), Po = Symbol.for("react.consumer"), Co = Symbol.for("react.context"), So = Symbol.for("react.forward_ref"), wo = Symbol.for("react.suspense"), Eo = Symbol.for("react.suspense_list"), Ro = Symbol.for("react.memo"), _o = Symbol.for("react.lazy"), Io = Symbol.for("react.offscreen"), Ao = Symbol.for("react.client.reference");
    reactIs_development$1.ContextConsumer = Po, reactIs_development$1.ContextProvider = Co, reactIs_development$1.Element = uo, reactIs_development$1.ForwardRef = So, reactIs_development$1.Fragment = go, reactIs_development$1.Lazy = _o, reactIs_development$1.Memo = Ro, reactIs_development$1.Portal = ho, reactIs_development$1.Profiler = vo, reactIs_development$1.StrictMode = bo, reactIs_development$1.Suspense = wo, reactIs_development$1.SuspenseList = Eo, reactIs_development$1.isContextConsumer = function(Oo) {
      return Kt(Oo) === Po;
    }, reactIs_development$1.isContextProvider = function(Oo) {
      return Kt(Oo) === Co;
    }, reactIs_development$1.isElement = function(Oo) {
      return typeof Oo == "object" && Oo !== null && Oo.$$typeof === uo;
    }, reactIs_development$1.isForwardRef = function(Oo) {
      return Kt(Oo) === So;
    }, reactIs_development$1.isFragment = function(Oo) {
      return Kt(Oo) === go;
    }, reactIs_development$1.isLazy = function(Oo) {
      return Kt(Oo) === _o;
    }, reactIs_development$1.isMemo = function(Oo) {
      return Kt(Oo) === Ro;
    }, reactIs_development$1.isPortal = function(Oo) {
      return Kt(Oo) === ho;
    }, reactIs_development$1.isProfiler = function(Oo) {
      return Kt(Oo) === vo;
    }, reactIs_development$1.isStrictMode = function(Oo) {
      return Kt(Oo) === bo;
    }, reactIs_development$1.isSuspense = function(Oo) {
      return Kt(Oo) === wo;
    }, reactIs_development$1.isSuspenseList = function(Oo) {
      return Kt(Oo) === Eo;
    }, reactIs_development$1.isValidElementType = function(Oo) {
      return typeof Oo == "string" || typeof Oo == "function" || Oo === go || Oo === vo || Oo === bo || Oo === wo || Oo === Eo || Oo === Io || typeof Oo == "object" && Oo !== null && (Oo.$$typeof === _o || Oo.$$typeof === Ro || Oo.$$typeof === Co || Oo.$$typeof === Po || Oo.$$typeof === So || Oo.$$typeof === Ao || Oo.getModuleId !== void 0);
    }, reactIs_development$1.typeOf = Kt;
  }()), reactIs_development$1;
}
process.env.NODE_ENV === "production" ? reactIs$1.exports = requireReactIs_production() : reactIs$1.exports = requireReactIs_development$1();
var reactIsExports$1 = reactIs$1.exports;
const ListContext = /* @__PURE__ */ React$1.createContext({});
process.env.NODE_ENV !== "production" && (ListContext.displayName = "ListContext");
function getListUtilityClass(Kt) {
  return generateUtilityClass$1("MuiList", Kt);
}
generateUtilityClasses$1("MuiList", ["root", "padding", "dense", "subheader"]);
const useUtilityClasses$1e = (Kt) => {
  const {
    classes: uo,
    disablePadding: ho,
    dense: go,
    subheader: bo
  } = Kt;
  return composeClasses({
    root: ["root", !ho && "padding", go && "dense", bo && "subheader"]
  }, getListUtilityClass, uo);
}, ListRoot = styled("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, !ho.disablePadding && uo.padding, ho.dense && uo.dense, ho.subheader && uo.subheader];
  }
})({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative",
  variants: [{
    props: ({
      ownerState: Kt
    }) => !Kt.disablePadding,
    style: {
      paddingTop: 8,
      paddingBottom: 8
    }
  }, {
    props: ({
      ownerState: Kt
    }) => Kt.subheader,
    style: {
      paddingTop: 0
    }
  }]
}), List = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiList"
  }), {
    children: bo,
    className: vo,
    component: Po = "ul",
    dense: Co = !1,
    disablePadding: So = !1,
    subheader: wo,
    ...Eo
  } = go, Ro = React$1.useMemo(() => ({
    dense: Co
  }), [Co]), _o = {
    ...go,
    component: Po,
    dense: Co,
    disablePadding: So
  }, Io = useUtilityClasses$1e(_o);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: Ro,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(ListRoot, {
      as: Po,
      className: clsx(Io.root, vo),
      ref: ho,
      ownerState: _o,
      ...Eo,
      children: [wo, bo]
    })
  });
});
process.env.NODE_ENV !== "production" && (List.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: PropTypes.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function nextItem(Kt, uo, ho) {
  return Kt === uo ? Kt.firstChild : uo && uo.nextElementSibling ? uo.nextElementSibling : ho ? null : Kt.firstChild;
}
function previousItem(Kt, uo, ho) {
  return Kt === uo ? ho ? Kt.firstChild : Kt.lastChild : uo && uo.previousElementSibling ? uo.previousElementSibling : ho ? null : Kt.lastChild;
}
function textCriteriaMatches(Kt, uo) {
  if (uo === void 0)
    return !0;
  let ho = Kt.innerText;
  return ho === void 0 && (ho = Kt.textContent), ho = ho.trim().toLowerCase(), ho.length === 0 ? !1 : uo.repeating ? ho[0] === uo.keys[0] : ho.startsWith(uo.keys.join(""));
}
function moveFocus(Kt, uo, ho, go, bo, vo) {
  let Po = !1, Co = bo(Kt, uo, uo ? ho : !1);
  for (; Co; ) {
    if (Co === Kt.firstChild) {
      if (Po)
        return !1;
      Po = !0;
    }
    const So = go ? !1 : Co.disabled || Co.getAttribute("aria-disabled") === "true";
    if (!Co.hasAttribute("tabindex") || !textCriteriaMatches(Co, vo) || So)
      Co = bo(Kt, Co, ho);
    else
      return Co.focus(), !0;
  }
  return !1;
}
const MenuList = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: go,
    autoFocus: bo = !1,
    autoFocusItem: vo = !1,
    children: Po,
    className: Co,
    disabledItemsFocusable: So = !1,
    disableListWrap: wo = !1,
    onKeyDown: Eo,
    variant: Ro = "selectedMenu",
    ..._o
  } = uo, Io = React$1.useRef(null), Ao = React$1.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  useEnhancedEffect(() => {
    bo && Io.current.focus();
  }, [bo]), React$1.useImperativeHandle(go, () => ({
    adjustStyleForScrollbar: (ko, {
      direction: Ko
    }) => {
      const No = !Io.current.style.width;
      if (ko.clientHeight < Io.current.clientHeight && No) {
        const Jo = `${getScrollbarSize(ownerWindow(ko))}px`;
        Io.current.style[Ko === "rtl" ? "paddingLeft" : "paddingRight"] = Jo, Io.current.style.width = `calc(100% + ${Jo})`;
      }
      return Io.current;
    }
  }), []);
  const Oo = (ko) => {
    const Ko = Io.current, No = ko.key;
    if (ko.ctrlKey || ko.metaKey || ko.altKey) {
      Eo && Eo(ko);
      return;
    }
    const ti = ownerDocument(Ko).activeElement;
    if (No === "ArrowDown")
      ko.preventDefault(), moveFocus(Ko, ti, wo, So, nextItem);
    else if (No === "ArrowUp")
      ko.preventDefault(), moveFocus(Ko, ti, wo, So, previousItem);
    else if (No === "Home")
      ko.preventDefault(), moveFocus(Ko, null, wo, So, nextItem);
    else if (No === "End")
      ko.preventDefault(), moveFocus(Ko, null, wo, So, previousItem);
    else if (No.length === 1) {
      const oi = Ao.current, Qo = No.toLowerCase(), Zo = performance.now();
      oi.keys.length > 0 && (Zo - oi.lastTime > 500 ? (oi.keys = [], oi.repeating = !0, oi.previousKeyMatched = !0) : oi.repeating && Qo !== oi.keys[0] && (oi.repeating = !1)), oi.lastTime = Zo, oi.keys.push(Qo);
      const ei = ti && !oi.repeating && textCriteriaMatches(ti, oi);
      oi.previousKeyMatched && (ei || moveFocus(Ko, ti, !1, So, nextItem, oi)) ? ko.preventDefault() : oi.previousKeyMatched = !1;
    }
    Eo && Eo(ko);
  }, jo = useForkRef(Io, ho);
  let Do = -1;
  React$1.Children.forEach(Po, (ko, Ko) => {
    if (!/* @__PURE__ */ React$1.isValidElement(ko)) {
      Do === Ko && (Do += 1, Do >= Po.length && (Do = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && reactIsExports$1.isFragment(ko) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), ko.props.disabled || (Ro === "selectedMenu" && ko.props.selected || Do === -1) && (Do = Ko), Do === Ko && (ko.props.disabled || ko.props.muiSkipListHighlight || ko.type.muiSkipListHighlight) && (Do += 1, Do >= Po.length && (Do = -1));
  });
  const Lo = React$1.Children.map(Po, (ko, Ko) => {
    if (Ko === Do) {
      const No = {};
      return vo && (No.autoFocus = !0), ko.props.tabIndex === void 0 && Ro === "selectedMenu" && (No.tabIndex = 0), /* @__PURE__ */ React$1.cloneElement(ko, No);
    }
    return ko;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(List, {
    role: "menu",
    ref: jo,
    className: Co,
    onKeyDown: Oo,
    tabIndex: bo ? 0 : -1,
    ..._o,
    children: Lo
  });
});
process.env.NODE_ENV !== "production" && (MenuList.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: PropTypes.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: PropTypes.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: PropTypes.bool,
  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function mapEventPropToEvent(Kt) {
  return Kt.substring(2).toLowerCase();
}
function clickedRootScrollbar(Kt, uo) {
  return uo.documentElement.clientWidth < Kt.clientX || uo.documentElement.clientHeight < Kt.clientY;
}
function ClickAwayListener(Kt) {
  const {
    children: uo,
    disableReactTree: ho = !1,
    mouseEvent: go = "onClick",
    onClickAway: bo,
    touchEvent: vo = "onTouchEnd"
  } = Kt, Po = React$1.useRef(!1), Co = React$1.useRef(null), So = React$1.useRef(!1), wo = React$1.useRef(!1);
  React$1.useEffect(() => (setTimeout(() => {
    So.current = !0;
  }, 0), () => {
    So.current = !1;
  }), []);
  const Eo = useForkRef(getReactElementRef(uo), Co), Ro = useEventCallback((Ao) => {
    const Oo = wo.current;
    wo.current = !1;
    const jo = ownerDocument(Co.current);
    if (!So.current || !Co.current || "clientX" in Ao && clickedRootScrollbar(Ao, jo))
      return;
    if (Po.current) {
      Po.current = !1;
      return;
    }
    let Do;
    Ao.composedPath ? Do = Ao.composedPath().includes(Co.current) : Do = !jo.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      Ao.target
    ) || Co.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      Ao.target
    ), !Do && (ho || !Oo) && bo(Ao);
  }), _o = (Ao) => (Oo) => {
    wo.current = !0;
    const jo = uo.props[Ao];
    jo && jo(Oo);
  }, Io = {
    ref: Eo
  };
  return vo !== !1 && (Io[vo] = _o(vo)), React$1.useEffect(() => {
    if (vo !== !1) {
      const Ao = mapEventPropToEvent(vo), Oo = ownerDocument(Co.current), jo = () => {
        Po.current = !0;
      };
      return Oo.addEventListener(Ao, Ro), Oo.addEventListener("touchmove", jo), () => {
        Oo.removeEventListener(Ao, Ro), Oo.removeEventListener("touchmove", jo);
      };
    }
  }, [Ro, vo]), go !== !1 && (Io[go] = _o(go)), React$1.useEffect(() => {
    if (go !== !1) {
      const Ao = mapEventPropToEvent(go), Oo = ownerDocument(Co.current);
      return Oo.addEventListener(Ao, Ro), () => {
        Oo.removeEventListener(Ao, Ro);
      };
    }
  }, [Ro, go]), /* @__PURE__ */ React$1.cloneElement(uo, Io);
}
process.env.NODE_ENV !== "production" && (ClickAwayListener.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The wrapped element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * If `true`, the React tree is ignored and only the DOM tree is considered.
   * This prop changes how portaled elements are handled.
   * @default false
   */
  disableReactTree: PropTypes.bool,
  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   * @default 'onClick'
   */
  mouseEvent: PropTypes.oneOf(["onClick", "onMouseDown", "onMouseUp", "onPointerDown", "onPointerUp", !1]),
  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,
  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   * @default 'onTouchEnd'
   */
  touchEvent: PropTypes.oneOf(["onTouchEnd", "onTouchStart", !1])
});
process.env.NODE_ENV !== "production" && (ClickAwayListener.propTypes = exactProp(ClickAwayListener.propTypes));
const reflow = (Kt) => Kt.scrollTop;
function getTransitionProps(Kt, uo) {
  const {
    timeout: ho,
    easing: go,
    style: bo = {}
  } = Kt;
  return {
    duration: bo.transitionDuration ?? (typeof ho == "number" ? ho : ho[uo.mode] || 0),
    easing: bo.transitionTimingFunction ?? (typeof go == "object" ? go[uo.mode] : go),
    delay: bo.transitionDelay
  };
}
function getScale(Kt) {
  return `scale(${Kt}, ${Kt ** 2})`;
}
const styles$1 = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, isWebKit154 = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), Grow = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    addEndListener: go,
    appear: bo = !0,
    children: vo,
    easing: Po,
    in: Co,
    onEnter: So,
    onEntered: wo,
    onEntering: Eo,
    onExit: Ro,
    onExited: _o,
    onExiting: Io,
    style: Ao,
    timeout: Oo = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: jo = Transition,
    ...Do
  } = uo, Lo = useTimeout(), ko = React$1.useRef(), Ko = useTheme(), No = React$1.useRef(null), Jo = useForkRef(No, getReactElementRef(vo), ho), ti = (ni) => (si) => {
    if (ni) {
      const li = No.current;
      si === void 0 ? ni(li) : ni(li, si);
    }
  }, oi = ti(Eo), Qo = ti((ni, si) => {
    reflow(ni);
    const {
      duration: li,
      delay: ui,
      easing: ci
    } = getTransitionProps({
      style: Ao,
      timeout: Oo,
      easing: Po
    }, {
      mode: "enter"
    });
    let fi;
    Oo === "auto" ? (fi = Ko.transitions.getAutoHeightDuration(ni.clientHeight), ko.current = fi) : fi = li, ni.style.transition = [Ko.transitions.create("opacity", {
      duration: fi,
      delay: ui
    }), Ko.transitions.create("transform", {
      duration: isWebKit154 ? fi : fi * 0.666,
      delay: ui,
      easing: ci
    })].join(","), So && So(ni, si);
  }), Zo = ti(wo), ei = ti(Io), ii = ti((ni) => {
    const {
      duration: si,
      delay: li,
      easing: ui
    } = getTransitionProps({
      style: Ao,
      timeout: Oo,
      easing: Po
    }, {
      mode: "exit"
    });
    let ci;
    Oo === "auto" ? (ci = Ko.transitions.getAutoHeightDuration(ni.clientHeight), ko.current = ci) : ci = si, ni.style.transition = [Ko.transitions.create("opacity", {
      duration: ci,
      delay: li
    }), Ko.transitions.create("transform", {
      duration: isWebKit154 ? ci : ci * 0.666,
      delay: isWebKit154 ? li : li || ci * 0.333,
      easing: ui
    })].join(","), ni.style.opacity = 0, ni.style.transform = getScale(0.75), Ro && Ro(ni);
  }), ai = ti(_o), ri = (ni) => {
    Oo === "auto" && Lo.start(ko.current || 0, ni), go && go(No.current, ni);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(jo, {
    appear: bo,
    in: Co,
    nodeRef: No,
    onEnter: Qo,
    onEntered: Zo,
    onEntering: oi,
    onExit: ii,
    onExited: ai,
    onExiting: ei,
    addEndListener: ri,
    timeout: Oo === "auto" ? null : Oo,
    ...Do,
    children: (ni, {
      ownerState: si,
      ...li
    }) => /* @__PURE__ */ React$1.cloneElement(vo, {
      style: {
        opacity: 0,
        transform: getScale(0.75),
        visibility: ni === "exited" && !Co ? "hidden" : void 0,
        ...styles$1[ni],
        ...Ao,
        ...vo.props.style
      },
      ref: Jo,
      ...li
    })
  });
});
process.env.NODE_ENV !== "production" && (Grow.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
Grow && (Grow.muiSupportAuto = !0);
const _excluded$Y = ["open", "target", "onClose", "children", "position", "className", "onExited"], useUtilityClasses$1d = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["menu"]
  }, getDataGridUtilityClass, uo);
}, GridMenuRoot = styled(Popper, {
  name: "MuiDataGrid",
  slot: "Menu",
  overridesResolver: (Kt, uo) => uo.menu
})(({
  theme: Kt
}) => ({
  zIndex: Kt.zIndex.modal,
  [`& .${gridClasses.menuList}`]: {
    outline: 0
  }
})), transformOrigin = {
  "bottom-start": "top left",
  "bottom-end": "top right"
};
function GridMenu(Kt) {
  var Oo;
  const {
    open: uo,
    target: ho,
    onClose: go,
    children: bo,
    position: vo,
    className: Po,
    onExited: Co
  } = Kt, So = _objectWithoutPropertiesLoose$h(Kt, _excluded$Y), wo = useGridApiContext(), Eo = useGridRootProps(), Ro = useUtilityClasses$1d(Eo), _o = React$1.useRef(null);
  useEnhancedEffect(() => {
    var jo, Do;
    uo ? _o.current = document.activeElement instanceof HTMLElement ? document.activeElement : null : ((Do = (jo = _o.current) == null ? void 0 : jo.focus) == null || Do.call(jo), _o.current = null);
  }, [uo]), React$1.useEffect(() => {
    const jo = uo ? "menuOpen" : "menuClose";
    wo.current.publishEvent(jo, {
      target: ho
    });
  }, [wo, uo, ho]);
  const Io = (jo) => (Do) => {
    jo && jo(), Co && Co(Do);
  }, Ao = (jo) => {
    jo.target && (ho === jo.target || ho != null && ho.contains(jo.target)) || go(jo);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridMenuRoot, _extends$q({
    as: Eo.slots.basePopper,
    className: clsx(Ro.root, Po),
    ownerState: Eo,
    open: uo,
    anchorEl: ho,
    transition: !0,
    placement: vo
  }, So, (Oo = Eo.slotProps) == null ? void 0 : Oo.basePopper, {
    children: ({
      TransitionProps: jo,
      placement: Do
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(ClickAwayListener, {
      onClickAway: Ao,
      mouseEvent: "onMouseDown",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Grow, _extends$q({}, jo, {
        style: {
          transformOrigin: transformOrigin[Do]
        },
        onExited: Io(jo == null ? void 0 : jo.onExited),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Paper, {
          children: bo
        })
      }))
    })
  }));
}
process.env.NODE_ENV !== "production" && (GridMenu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
  onExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  position: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  target: HTMLElementType
});
const _excluded$X = ["api", "colDef", "id", "hasFocus", "isEditable", "field", "value", "formattedValue", "row", "rowNode", "cellMode", "tabIndex", "position", "focusElementRef"], hasActions = (Kt) => typeof Kt.getActions == "function";
function GridActionsCell(Kt) {
  var si;
  const {
    colDef: uo,
    id: ho,
    hasFocus: go,
    tabIndex: bo,
    position: vo = "bottom-end",
    focusElementRef: Po
  } = Kt, Co = _objectWithoutPropertiesLoose$h(Kt, _excluded$X), [So, wo] = React$1.useState(-1), [Eo, Ro] = React$1.useState(!1), _o = useGridApiContext(), Io = React$1.useRef(null), Ao = React$1.useRef(null), Oo = React$1.useRef(!1), jo = React$1.useRef({}), Do = useRtl(), Lo = useId(), ko = useId(), Ko = useGridRootProps();
  if (!hasActions(uo))
    throw new Error("MUI X: Missing the `getActions` property in the `GridColDef`.");
  const No = uo.getActions(_o.current.getRowParams(ho)), Jo = No.filter((li) => !li.props.showInMenu), ti = No.filter((li) => li.props.showInMenu), oi = Jo.length + (ti.length ? 1 : 0);
  React$1.useLayoutEffect(() => {
    go || Object.entries(jo.current).forEach(([li, ui]) => {
      ui == null || ui.stop({}, () => {
        delete jo.current[li];
      });
    });
  }, [go]), React$1.useEffect(() => {
    if (So < 0 || !Io.current || So >= Io.current.children.length)
      return;
    Io.current.children[So].focus({
      preventScroll: !0
    });
  }, [So]), React$1.useEffect(() => {
    go || (wo(-1), Oo.current = !1);
  }, [go]), React$1.useImperativeHandle(Po, () => ({
    focus() {
      if (!Oo.current) {
        const li = No.findIndex((ui) => !ui.props.disabled);
        wo(li);
      }
    }
  }), [No]), React$1.useEffect(() => {
    So >= oi && wo(oi - 1);
  }, [So, oi]);
  const Qo = () => {
    Ro(!0), wo(oi - 1), Oo.current = !0;
  }, Zo = () => {
    Ro(!1);
  }, ei = () => {
    Eo ? Zo() : Qo();
  }, ii = (li) => (ui) => {
    jo.current[li] = ui;
  }, ai = (li, ui) => (ci) => {
    wo(li), Oo.current = !0, ui && ui(ci);
  }, ri = (li) => {
    if (oi <= 1)
      return;
    const ui = (fi, yi) => {
      var bi;
      if (fi < 0 || fi > No.length)
        return fi;
      const mi = (yi === "left" ? -1 : 1) * (Do ? -1 : 1);
      return (bi = No[fi + mi]) != null && bi.props.disabled ? ui(fi + mi, yi) : fi + mi;
    };
    let ci = So;
    li.key === "ArrowRight" ? ci = ui(So, "right") : li.key === "ArrowLeft" && (ci = ui(So, "left")), !(ci < 0 || ci >= oi) && ci !== So && (li.preventDefault(), li.stopPropagation(), wo(ci));
  }, ni = (li) => {
    li.key === "Tab" && li.preventDefault(), ["Tab", "Escape"].includes(li.key) && Zo();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", _extends$q({
    role: "menu",
    ref: Io,
    tabIndex: -1,
    className: gridClasses.actionsCell,
    onKeyDown: ri
  }, Co, {
    children: [Jo.map((li, ui) => /* @__PURE__ */ React$1.cloneElement(li, {
      key: ui,
      touchRippleRef: ii(ui),
      onClick: ai(ui, li.props.onClick),
      tabIndex: So === ui ? bo : -1
    })), ti.length > 0 && ko && /* @__PURE__ */ jsxRuntimeExports.jsx(Ko.slots.baseIconButton, _extends$q({
      ref: Ao,
      id: ko,
      "aria-label": _o.current.getLocaleText("actionsCellMore"),
      "aria-haspopup": "menu",
      "aria-expanded": Eo,
      "aria-controls": Eo ? Lo : void 0,
      role: "menuitem",
      size: "small",
      onClick: ei,
      touchRippleRef: ii(ko),
      tabIndex: So === Jo.length ? bo : -1
    }, (si = Ko.slotProps) == null ? void 0 : si.baseIconButton, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Ko.slots.moreActionsIcon, {
        fontSize: "small"
      })
    })), ti.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(GridMenu, {
      open: Eo,
      target: Ao.current,
      position: vo,
      onClose: Zo,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList, {
        id: Lo,
        className: gridClasses.menuList,
        onKeyDown: ni,
        "aria-labelledby": ko,
        variant: "menu",
        autoFocusItem: !0,
        children: ti.map((li, ui) => /* @__PURE__ */ React$1.cloneElement(li, {
          key: ui,
          closeMenu: Zo
        }))
      })
    })]
  }));
}
process.env.NODE_ENV !== "production" && (GridActionsCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  api: PropTypes.object,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focus: PropTypes.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  position: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
});
const renderActionsCell = (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridActionsCell, _extends$q({}, Kt)), GRID_ACTIONS_COLUMN_TYPE = "actions", GRID_ACTIONS_COL_DEF = _extends$q({}, GRID_STRING_COL_DEF, {
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  width: 100,
  display: "flex",
  align: "center",
  headerAlign: "center",
  headerName: "",
  disableColumnMenu: !0,
  disableExport: !0,
  renderCell: renderActionsCell,
  getApplyQuickFilterFn: void 0
}), gridRowsStateSelector = (Kt) => Kt.rows, gridRowCountSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.totalRowCount), gridRowsLoadingSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.loading), gridTopLevelRowCountSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.totalTopLevelRowCount), gridRowsLookupSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.dataRowIdToModelLookup), gridRowsDataRowIdToIdLookupSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.dataRowIdToIdLookup), gridRowTreeSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.tree), gridRowGroupsToFetchSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.groupsToFetch), gridRowGroupingNameSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.groupingName), gridRowTreeDepthsSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.treeDepths), gridRowMaximumTreeDepthSelector = createSelectorMemoized(gridRowsStateSelector, (Kt) => {
  const uo = Object.entries(Kt.treeDepths);
  return uo.length === 0 ? 1 : uo.filter(([, ho]) => ho > 0).map(([ho]) => Number(ho)).sort((ho, go) => go - ho)[0] + 1;
}), gridDataRowIdsSelector = createSelector(gridRowsStateSelector, (Kt) => Kt.dataRowIds), gridAdditionalRowGroupsSelector = createSelector(gridRowsStateSelector, (Kt) => Kt == null ? void 0 : Kt.additionalRowGroups), gridPinnedRowsSelector = createSelectorMemoized(gridAdditionalRowGroupsSelector, (Kt) => {
  var ho, go;
  const uo = Kt == null ? void 0 : Kt.pinnedRows;
  return {
    bottom: ((ho = uo == null ? void 0 : uo.bottom) == null ? void 0 : ho.map((bo) => ({
      id: bo.id,
      model: bo.model ?? {}
    }))) ?? [],
    top: ((go = uo == null ? void 0 : uo.top) == null ? void 0 : go.map((bo) => ({
      id: bo.id,
      model: bo.model ?? {}
    }))) ?? []
  };
}), gridPinnedRowsCountSelector = createSelector(gridPinnedRowsSelector, (Kt) => {
  var uo, ho;
  return (((uo = Kt == null ? void 0 : Kt.top) == null ? void 0 : uo.length) || 0) + (((ho = Kt == null ? void 0 : Kt.bottom) == null ? void 0 : ho.length) || 0);
}), GRID_ROOT_GROUP_ID = "auto-generated-group-node-root", GRID_ID_AUTOGENERATED = Symbol("mui.id_autogenerated"), buildRootGroup = () => ({
  type: "group",
  id: GRID_ROOT_GROUP_ID,
  depth: -1,
  groupingField: null,
  groupingKey: null,
  isAutoGenerated: !0,
  children: [],
  childrenFromPath: {},
  childrenExpanded: !0,
  parent: null
});
function checkGridRowIdIsValid(Kt, uo, ho = "A row was provided without id in the rows prop:") {
  if (Kt == null)
    throw new Error(["MUI X: The Data Grid component requires all rows to have a unique `id` property.", "Alternatively, you can use the `getRowId` prop to specify a custom id for each row.", ho, JSON.stringify(uo)].join(`
`));
}
const getRowIdFromRowModel = (Kt, uo, ho) => {
  const go = uo ? uo(Kt) : Kt.id;
  return checkGridRowIdIsValid(go, Kt, ho), go;
}, createRowsInternalCache = ({
  rows: Kt,
  getRowId: uo,
  loading: ho,
  rowCount: go
}) => {
  const bo = {
    type: "full",
    rows: []
  }, vo = {}, Po = {};
  for (let Co = 0; Co < Kt.length; Co += 1) {
    const So = Kt[Co], wo = getRowIdFromRowModel(So, uo);
    vo[wo] = So, Po[wo] = wo, bo.rows.push(wo);
  }
  return {
    rowsBeforePartialUpdates: Kt,
    loadingPropBeforePartialUpdates: ho,
    rowCountPropBeforePartialUpdates: go,
    updates: bo,
    dataRowIdToIdLookup: Po,
    dataRowIdToModelLookup: vo
  };
}, getTopLevelRowCount = ({
  tree: Kt,
  rowCountProp: uo = 0
}) => {
  const ho = Kt[GRID_ROOT_GROUP_ID];
  return Math.max(uo, ho.children.length + (ho.footerId == null ? 0 : 1));
}, getRowsStateFromCache = ({
  apiRef: Kt,
  rowCountProp: uo = 0,
  loadingProp: ho,
  previousTree: go,
  previousTreeDepths: bo,
  previousGroupsToFetch: vo
}) => {
  const Po = Kt.current.caches.rows, {
    tree: Co,
    treeDepths: So,
    dataRowIds: wo,
    groupingName: Eo,
    groupsToFetch: Ro = []
  } = Kt.current.applyStrategyProcessor("rowTreeCreation", {
    previousTree: go,
    previousTreeDepths: bo,
    updates: Po.updates,
    dataRowIdToIdLookup: Po.dataRowIdToIdLookup,
    dataRowIdToModelLookup: Po.dataRowIdToModelLookup,
    previousGroupsToFetch: vo
  }), _o = Kt.current.unstable_applyPipeProcessors("hydrateRows", {
    tree: Co,
    treeDepths: So,
    dataRowIdToIdLookup: Po.dataRowIdToIdLookup,
    dataRowIds: wo,
    dataRowIdToModelLookup: Po.dataRowIdToModelLookup
  });
  return Kt.current.caches.rows.updates = {
    type: "partial",
    actions: {
      insert: [],
      modify: [],
      remove: []
    },
    idToActionLookup: {}
  }, _extends$q({}, _o, {
    totalRowCount: Math.max(uo, _o.dataRowIds.length),
    totalTopLevelRowCount: getTopLevelRowCount({
      tree: _o.tree,
      rowCountProp: uo
    }),
    groupingName: Eo,
    loading: ho,
    groupsToFetch: Ro
  });
}, isAutogeneratedRowNode = (Kt) => Kt.type === "skeletonRow" || Kt.type === "footer" || Kt.type === "group" && Kt.isAutoGenerated || Kt.type === "pinnedRow" && Kt.isAutoGenerated, getTreeNodeDescendants = (Kt, uo, ho) => {
  const go = Kt[uo];
  if (go.type !== "group")
    return [];
  const bo = [];
  for (let vo = 0; vo < go.children.length; vo += 1) {
    const Po = go.children[vo];
    (!ho || !isAutogeneratedRowNode(Kt[Po])) && bo.push(Po);
    const Co = getTreeNodeDescendants(Kt, Po, ho);
    for (let So = 0; So < Co.length; So += 1)
      bo.push(Co[So]);
  }
  return !ho && go.footerId != null && bo.push(go.footerId), bo;
}, updateCacheWithNewRows = ({
  previousCache: Kt,
  getRowId: uo,
  updates: ho,
  groupKeys: go
}) => {
  if (Kt.updates.type === "full")
    throw new Error("MUI X: Unable to prepare a partial update if a full update is not applied yet.");
  const bo = /* @__PURE__ */ new Map();
  ho.forEach((Eo) => {
    const Ro = getRowIdFromRowModel(Eo, uo, "A row was provided without id when calling updateRows():");
    bo.has(Ro) ? bo.set(Ro, _extends$q({}, bo.get(Ro), Eo)) : bo.set(Ro, Eo);
  });
  const vo = {
    type: "partial",
    actions: {
      insert: [...Kt.updates.actions.insert ?? []],
      modify: [...Kt.updates.actions.modify ?? []],
      remove: [...Kt.updates.actions.remove ?? []]
    },
    idToActionLookup: _extends$q({}, Kt.updates.idToActionLookup),
    groupKeys: go
  }, Po = _extends$q({}, Kt.dataRowIdToModelLookup), Co = _extends$q({}, Kt.dataRowIdToIdLookup), So = {
    insert: {},
    modify: {},
    remove: {}
  };
  bo.forEach((Eo, Ro) => {
    const _o = vo.idToActionLookup[Ro];
    if (Eo._action === "delete") {
      if (_o === "remove" || !Po[Ro])
        return;
      _o != null && (So[_o][Ro] = !0), vo.actions.remove.push(Ro), delete Po[Ro], delete Co[Ro];
      return;
    }
    const Io = Po[Ro];
    if (Io) {
      _o === "remove" ? (So.remove[Ro] = !0, vo.actions.modify.push(Ro)) : _o == null && vo.actions.modify.push(Ro), Po[Ro] = _extends$q({}, Io, Eo);
      return;
    }
    _o === "remove" ? (So.remove[Ro] = !0, vo.actions.insert.push(Ro)) : _o == null && vo.actions.insert.push(Ro), Po[Ro] = Eo, Co[Ro] = Ro;
  });
  const wo = Object.keys(So);
  for (let Eo = 0; Eo < wo.length; Eo += 1) {
    const Ro = wo[Eo], _o = So[Ro];
    Object.keys(_o).length > 0 && (vo.actions[Ro] = vo.actions[Ro].filter((Io) => !_o[Io]));
  }
  return {
    dataRowIdToModelLookup: Po,
    dataRowIdToIdLookup: Co,
    updates: vo,
    rowsBeforePartialUpdates: Kt.rowsBeforePartialUpdates,
    loadingPropBeforePartialUpdates: Kt.loadingPropBeforePartialUpdates,
    rowCountPropBeforePartialUpdates: Kt.rowCountPropBeforePartialUpdates
  };
};
function calculatePinnedRowsHeight(Kt) {
  var bo, vo;
  const uo = gridPinnedRowsSelector(Kt), ho = ((bo = uo == null ? void 0 : uo.top) == null ? void 0 : bo.reduce((Po, Co) => (Po += Kt.current.unstable_getRowHeight(Co.id), Po), 0)) || 0, go = ((vo = uo == null ? void 0 : uo.bottom) == null ? void 0 : vo.reduce((Po, Co) => (Po += Kt.current.unstable_getRowHeight(Co.id), Po), 0)) || 0;
  return {
    top: ho,
    bottom: go
  };
}
const minimalContentHeight = "var(--DataGrid-overlayHeight, calc(var(--height) * 2))";
function computeRowsUpdates(Kt, uo, ho) {
  const go = [];
  return uo.forEach((bo) => {
    const vo = getRowIdFromRowModel(bo, ho, "A row was provided without id when calling updateRows():"), Po = Kt.current.getRowNode(vo);
    if ((Po == null ? void 0 : Po.type) === "pinnedRow") {
      const Co = Kt.current.caches.pinnedRows, So = Co.idLookup[vo];
      So && (Co.idLookup[vo] = _extends$q({}, So, bo));
    } else
      go.push(bo);
  }), go;
}
let warnedOnceInvalidRowHeight = !1;
const getValidRowHeight = (Kt, uo, ho) => typeof Kt == "number" && Kt > 0 ? Kt : (process.env.NODE_ENV !== "production" && !warnedOnceInvalidRowHeight && typeof Kt < "u" && Kt !== null && (console.warn(ho), warnedOnceInvalidRowHeight = !0), uo), rowHeightWarning = ["MUI X: The `rowHeight` prop should be a number greater than 0.", "The default value will be used instead."].join(`
`), getRowHeightWarning = ["MUI X: The `getRowHeight` prop should return a number greater than 0 or 'auto'.", "The default value will be used instead."].join(`
`), GRID_TREE_DATA_GROUPING_FIELD = "__tree_data_group__", GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD = "__row_group_by_columns_group__", GRID_DETAIL_PANEL_TOGGLE_FIELD = "__detail_panel_toggle__", _excluded$W = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "hasFocus", "tabIndex", "hideDescendantCount"], useUtilityClasses$1c = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["booleanCell"]
  }, getDataGridUtilityClass, uo);
};
function GridBooleanCellRaw(Kt) {
  const {
    value: uo,
    rowNode: ho
  } = Kt, go = _objectWithoutPropertiesLoose$h(Kt, _excluded$W), bo = useGridApiContext(), vo = useGridRootProps(), Po = {
    classes: vo.classes
  }, Co = useUtilityClasses$1c(Po), wo = (
    // @ts-expect-error - Access tree data prop
    useGridSelector(bo, gridRowMaximumTreeDepthSelector) > 0 && ho.type === "group" && vo.treeData === !1
  ), Eo = React$1.useMemo(() => uo ? vo.slots.booleanCellTrueIcon : vo.slots.booleanCellFalseIcon, [vo.slots.booleanCellFalseIcon, vo.slots.booleanCellTrueIcon, uo]);
  return wo && uo === void 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Eo, _extends$q({
    fontSize: "small",
    className: Co.root,
    titleAccess: bo.current.getLocaleText(uo ? "booleanCellTrueLabel" : "booleanCellFalseLabel"),
    "data-value": !!uo
  }, go));
}
process.env.NODE_ENV !== "production" && (GridBooleanCellRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focus: PropTypes.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  hideDescendantCount: PropTypes.bool,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
});
const GridBooleanCell = /* @__PURE__ */ React$1.memo(GridBooleanCellRaw), renderBooleanCell = (Kt) => Kt.field !== GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD && isAutogeneratedRowNode(Kt.rowNode) ? "" : /* @__PURE__ */ jsxRuntimeExports.jsx(GridBooleanCell, _extends$q({}, Kt)), _excluded$V = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange"], useUtilityClasses$1b = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["editBooleanCell"]
  }, getDataGridUtilityClass, uo);
};
function GridEditBooleanCell(Kt) {
  var Do;
  const {
    id: uo,
    value: ho,
    field: go,
    className: bo,
    hasFocus: vo,
    onValueChange: Po
  } = Kt, Co = _objectWithoutPropertiesLoose$h(Kt, _excluded$V), So = useGridApiContext(), wo = React$1.useRef(null), Eo = useId(), [Ro, _o] = React$1.useState(ho), Io = useGridRootProps(), Ao = {
    classes: Io.classes
  }, Oo = useUtilityClasses$1b(Ao), jo = React$1.useCallback(async (Lo) => {
    const ko = Lo.target.checked;
    Po && await Po(Lo, ko), _o(ko), await So.current.setEditCellValue({
      id: uo,
      field: go,
      value: ko
    }, Lo);
  }, [So, go, uo, Po]);
  return React$1.useEffect(() => {
    _o(ho);
  }, [ho]), useEnhancedEffect(() => {
    vo && wo.current.focus();
  }, [vo]), /* @__PURE__ */ jsxRuntimeExports.jsx("label", _extends$q({
    htmlFor: Eo,
    className: clsx(Oo.root, bo)
  }, Co, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Io.slots.baseCheckbox, _extends$q({
      id: Eo,
      inputRef: wo,
      checked: !!Ro,
      onChange: jo,
      size: "small"
    }, (Do = Io.slotProps) == null ? void 0 : Do.baseCheckbox))
  }));
}
process.env.NODE_ENV !== "production" && (GridEditBooleanCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(["edit", "view"]).isRequired,
  changeReason: PropTypes.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {boolean} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
});
const renderEditBooleanCell = (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridEditBooleanCell, _extends$q({}, Kt)), _excluded$U = ["item", "applyValue", "apiRef", "focusElementRef", "isFilterActive", "clearButton", "tabIndex", "label", "variant", "InputLabelProps"], sanitizeFilterItemValue = (Kt) => {
  if (String(Kt).toLowerCase() === "true")
    return !0;
  if (String(Kt).toLowerCase() === "false")
    return !1;
}, BooleanOperatorContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function GridFilterInputBoolean(Kt) {
  var Ko, No, Jo;
  const {
    item: uo,
    applyValue: ho,
    apiRef: go,
    focusElementRef: bo,
    clearButton: vo,
    tabIndex: Po,
    label: Co,
    variant: So = "standard"
  } = Kt, wo = _objectWithoutPropertiesLoose$h(Kt, _excluded$U), [Eo, Ro] = React$1.useState(sanitizeFilterItemValue(uo.value)), _o = useGridRootProps(), Io = useId(), Ao = useId(), Oo = ((Ko = _o.slotProps) == null ? void 0 : Ko.baseSelect) || {}, jo = Oo.native ?? !1, Do = ((No = _o.slotProps) == null ? void 0 : No.baseSelectOption) || {}, Lo = React$1.useCallback((ti) => {
    const oi = sanitizeFilterItemValue(ti.target.value);
    Ro(oi), ho(_extends$q({}, uo, {
      value: oi
    }));
  }, [ho, uo]);
  React$1.useEffect(() => {
    Ro(sanitizeFilterItemValue(uo.value));
  }, [uo.value]);
  const ko = Co ?? go.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(BooleanOperatorContainer, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(_o.slots.baseFormControl, {
      fullWidth: !0,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(_o.slots.baseInputLabel, _extends$q({}, (Jo = _o.slotProps) == null ? void 0 : Jo.baseInputLabel, {
        id: Io,
        shrink: !0,
        variant: So,
        children: ko
      })), /* @__PURE__ */ jsxRuntimeExports.jsxs(_o.slots.baseSelect, _extends$q({
        labelId: Io,
        id: Ao,
        label: ko,
        value: Eo === void 0 ? "" : String(Eo),
        onChange: Lo,
        variant: So,
        notched: So === "outlined" ? !0 : void 0,
        native: jo,
        displayEmpty: !0,
        inputProps: {
          ref: bo,
          tabIndex: Po
        }
      }, wo, Oo, {
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx(_o.slots.baseSelectOption, _extends$q({}, Do, {
          native: jo,
          value: "",
          children: go.current.getLocaleText("filterValueAny")
        })), /* @__PURE__ */ jsxRuntimeExports.jsx(_o.slots.baseSelectOption, _extends$q({}, Do, {
          native: jo,
          value: "true",
          children: go.current.getLocaleText("filterValueTrue")
        })), /* @__PURE__ */ jsxRuntimeExports.jsx(_o.slots.baseSelectOption, _extends$q({}, Do, {
          native: jo,
          value: "false",
          children: go.current.getLocaleText("filterValueFalse")
        }))]
      }))]
    }), vo]
  });
}
process.env.NODE_ENV !== "production" && (GridFilterInputBoolean.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: refType,
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
});
const getGridBooleanOperators = () => [{
  value: "is",
  getApplyFilterFn: (Kt) => {
    const uo = sanitizeFilterItemValue(Kt.value);
    return uo === void 0 ? null : (ho) => !!ho === uo;
  },
  InputComponent: GridFilterInputBoolean
}], gridBooleanFormatter = (Kt, uo, ho, go) => Kt ? go.current.getLocaleText("booleanCellTrueLabel") : go.current.getLocaleText("booleanCellFalseLabel"), stringToBoolean = (Kt) => {
  switch (Kt.toLowerCase().trim()) {
    case "true":
    case "yes":
    case "1":
      return !0;
    case "false":
    case "no":
    case "0":
    case "null":
    case "undefined":
      return !1;
    default:
      return;
  }
}, GRID_BOOLEAN_COL_DEF = _extends$q({}, GRID_STRING_COL_DEF, {
  type: "boolean",
  display: "flex",
  align: "center",
  headerAlign: "center",
  renderCell: renderBooleanCell,
  renderEditCell: renderEditBooleanCell,
  sortComparator: gridNumberComparator,
  valueFormatter: gridBooleanFormatter,
  filterOperators: getGridBooleanOperators(),
  getApplyQuickFilterFn: void 0,
  // @ts-ignore
  aggregable: !1,
  // @ts-ignore
  pastedValueParser: (Kt) => stringToBoolean(Kt)
}), gridSortingStateSelector = (Kt) => Kt.sorting, gridSortedRowIdsSelector = createSelector(gridSortingStateSelector, (Kt) => Kt.sortedRows), gridSortedRowEntriesSelector = createSelectorMemoized(gridSortedRowIdsSelector, gridRowsLookupSelector, gridRowTreeSelector, (Kt, uo, ho) => Kt.reduce((go, bo) => {
  const vo = uo[bo];
  vo && go.push({
    id: bo,
    model: vo
  });
  const Po = ho[bo];
  return Po && isAutogeneratedRowNode(Po) && go.push({
    id: bo,
    model: {
      [GRID_ID_AUTOGENERATED]: bo
    }
  }), go;
}, [])), gridSortModelSelector = createSelector(gridSortingStateSelector, (Kt) => Kt.sortModel), gridSortColumnLookupSelector = createSelectorMemoized(gridSortModelSelector, (Kt) => Kt.reduce((ho, go, bo) => (ho[go.field] = {
  sortDirection: go.sort,
  sortIndex: Kt.length > 1 ? bo + 1 : void 0
}, ho), {}));
createSelectorMemoized(gridSortedRowIdsSelector, (Kt) => Kt.reduce((uo, ho, go) => (uo[ho] = go, uo), /* @__PURE__ */ Object.create(null)));
const gridFilterStateSelector = (Kt) => Kt.filter, gridFilterModelSelector = createSelector(gridFilterStateSelector, (Kt) => Kt.filterModel);
createSelector(gridFilterModelSelector, (Kt) => Kt.quickFilterValues);
const gridVisibleRowsLookupSelector = (Kt) => Kt.visibleRowsLookup, gridFilteredRowsLookupSelector = createSelector(gridFilterStateSelector, (Kt) => Kt.filteredRowsLookup);
createSelector(gridFilterStateSelector, (Kt) => Kt.filteredChildrenCountLookup);
createSelector(gridFilterStateSelector, (Kt) => Kt.filteredDescendantCountLookup);
const gridExpandedSortedRowEntriesSelector = createSelectorMemoized(gridVisibleRowsLookupSelector, gridSortedRowEntriesSelector, (Kt, uo) => uo.filter((ho) => Kt[ho.id] !== !1)), gridExpandedSortedRowIdsSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, (Kt) => Kt.map((uo) => uo.id)), gridFilteredSortedRowEntriesSelector = createSelectorMemoized(gridFilteredRowsLookupSelector, gridSortedRowEntriesSelector, (Kt, uo) => uo.filter((ho) => Kt[ho.id] !== !1)), gridFilteredSortedRowIdsSelector = createSelectorMemoized(gridFilteredSortedRowEntriesSelector, (Kt) => Kt.map((uo) => uo.id));
createSelectorMemoized(gridExpandedSortedRowIdsSelector, gridRowTreeSelector, (Kt, uo) => {
  const ho = {};
  let go = 0;
  return Kt.reduce((bo, vo) => {
    const Po = uo[vo];
    return ho[Po.depth] || (ho[Po.depth] = 0), Po.depth > go && (ho[Po.depth] = 0), go = Po.depth, ho[Po.depth] += 1, bo[vo] = ho[Po.depth], bo;
  }, {});
});
const gridFilteredSortedTopLevelRowEntriesSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, gridRowTreeSelector, gridRowMaximumTreeDepthSelector, (Kt, uo, ho) => ho < 2 ? Kt : Kt.filter((go) => {
  var bo;
  return ((bo = uo[go.id]) == null ? void 0 : bo.depth) === 0;
})), gridExpandedRowCountSelector = createSelector(gridExpandedSortedRowEntriesSelector, (Kt) => Kt.length), gridFilteredTopLevelRowCountSelector = createSelector(gridFilteredSortedTopLevelRowEntriesSelector, (Kt) => Kt.length), gridFilteredRowCountSelector = createSelector(gridFilteredSortedRowEntriesSelector, (Kt) => Kt.length);
createSelector(gridFilteredRowCountSelector, gridFilteredTopLevelRowCountSelector, (Kt, uo) => Kt - uo);
const gridFilterActiveItemsSelector = createSelectorMemoized(gridFilterModelSelector, gridColumnLookupSelector, (Kt, uo) => {
  var ho;
  return (ho = Kt.items) == null ? void 0 : ho.filter((go) => {
    var Po, Co;
    if (!go.field)
      return !1;
    const bo = uo[go.field];
    if (!(bo != null && bo.filterOperators) || ((Po = bo == null ? void 0 : bo.filterOperators) == null ? void 0 : Po.length) === 0)
      return !1;
    const vo = bo.filterOperators.find((So) => So.value === go.operator);
    return vo ? !vo.InputComponent || go.value != null && ((Co = go.value) == null ? void 0 : Co.toString()) !== "" : !1;
  });
}), gridFilterActiveItemsLookupSelector = createSelectorMemoized(gridFilterActiveItemsSelector, (Kt) => Kt.reduce((ho, go) => (ho[go.field] ? ho[go.field].push(go) : ho[go.field] = [go], ho), {})), gridRowSelectionStateSelector = (Kt) => Kt.rowSelection, selectedGridRowsCountSelector = createSelector(gridRowSelectionStateSelector, (Kt) => Kt.length), selectedGridRowsSelector = createSelectorMemoized(gridRowSelectionStateSelector, gridRowsLookupSelector, (Kt, uo) => new Map(Kt.map((ho) => [ho, uo[ho]]))), selectedIdsLookupSelector = createSelectorMemoized(gridRowSelectionStateSelector, (Kt) => Kt.reduce((uo, ho) => (uo[ho] = ho, uo), {}));
function getGridRowGroupSelectableDescendants(Kt, uo) {
  var So;
  const ho = gridRowTreeSelector(Kt), go = gridSortedRowIdsSelector(Kt), bo = gridFilteredRowsLookupSelector(Kt), vo = ho[uo];
  if (!vo || vo.type !== "group")
    return [];
  const Po = [], Co = go.findIndex((wo) => wo === uo) + 1;
  for (let wo = Co; wo < go.length && ((So = ho[go[wo]]) == null ? void 0 : So.depth) > vo.depth; wo += 1) {
    const Eo = go[wo];
    bo[Eo] !== !1 && Kt.current.isRowSelectable(Eo) && Po.push(Eo);
  }
  return Po;
}
function getCheckboxPropsSelector(Kt, uo) {
  return createSelector(gridRowTreeSelector, gridSortedRowIdsSelector, gridFilteredRowsLookupSelector, selectedIdsLookupSelector, (ho, go, bo, vo) => {
    var Eo;
    const Po = ho[Kt];
    if (!Po || Po.type !== "group")
      return {
        isIndeterminate: !1,
        isChecked: vo[Kt] === Kt
      };
    if (vo[Kt] === Kt)
      return {
        isIndeterminate: !1,
        isChecked: !0
      };
    let Co = 0, So = 0;
    const wo = go.findIndex((Ro) => Ro === Kt) + 1;
    for (let Ro = wo; Ro < go.length && ((Eo = ho[go[Ro]]) == null ? void 0 : Eo.depth) > Po.depth; Ro += 1) {
      const _o = go[Ro];
      bo[_o] !== !1 && (Co += 1, vo[_o] !== void 0 && (So += 1));
    }
    return {
      isIndeterminate: So > 0 && (So < Co || vo[Kt] === void 0),
      isChecked: uo ? So > 0 : vo[Kt] === Kt
    };
  });
}
function isMultipleRowSelectionEnabled(Kt) {
  return Kt.signature === GridSignature.DataGrid ? Kt.checkboxSelection && Kt.disableMultipleRowSelection !== !0 : !Kt.disableMultipleRowSelection;
}
const getRowNodeParents = (Kt, uo) => {
  const ho = [];
  let go = uo;
  for (; go != null && go !== GRID_ROOT_GROUP_ID; ) {
    const bo = Kt[go];
    if (!bo)
      return ho;
    ho.push(go), go = bo.parent;
  }
  return ho;
}, getFilteredRowNodeSiblings = (Kt, uo, ho) => {
  const go = Kt[ho];
  if (!go)
    return [];
  const bo = go.parent;
  return bo == null ? [] : Kt[bo].children.filter((Po) => Po !== ho && uo[Po]);
}, findRowsToSelect = (Kt, uo, ho, go, bo, vo) => {
  const Po = gridFilteredRowsLookupSelector(Kt), Co = selectedIdsLookupSelector(Kt), So = /* @__PURE__ */ new Set([]);
  if (!(!go && !bo)) {
    if (go) {
      const wo = uo[ho];
      (wo == null ? void 0 : wo.type) === "group" && getGridRowGroupSelectableDescendants(Kt, ho).forEach((Ro) => {
        vo(Ro), So.add(Ro);
      });
    }
    if (bo) {
      const wo = (Ro) => {
        if (Co[Ro] !== Ro && !So.has(Ro))
          return !1;
        const _o = uo[Ro];
        return (_o == null ? void 0 : _o.type) !== "group" ? !0 : _o.children.every(wo);
      }, Eo = (Ro) => {
        const _o = getFilteredRowNodeSiblings(uo, Po, Ro);
        if (_o.length === 0 || _o.every(wo)) {
          const Ao = uo[Ro].parent;
          Ao != null && Ao !== GRID_ROOT_GROUP_ID && Kt.current.isRowSelectable(Ao) && (vo(Ao), So.add(Ao), Eo(Ao));
        }
      };
      Eo(ho);
    }
  }
}, findRowsToDeselect = (Kt, uo, ho, go, bo, vo) => {
  const Po = selectedIdsLookupSelector(Kt);
  if (!(!bo && !go) && (bo && getRowNodeParents(uo, ho).forEach((So) => {
    Po[So] === So && vo(So);
  }), go)) {
    const Co = uo[ho];
    (Co == null ? void 0 : Co.type) === "group" && getGridRowGroupSelectableDescendants(Kt, ho).forEach((wo) => {
      vo(wo);
    });
  }
}, _excluded$T = ["field", "id", "formattedValue", "row", "rowNode", "colDef", "isEditable", "cellMode", "hasFocus", "tabIndex", "api"], useUtilityClasses$1a = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["checkboxInput"]
  }, getDataGridUtilityClass, uo);
}, GridCellCheckboxForwardRef = forwardRef(function(uo, ho) {
  var oi, Qo;
  const {
    field: go,
    id: bo,
    rowNode: vo,
    hasFocus: Po,
    tabIndex: Co
  } = uo, So = _objectWithoutPropertiesLoose$h(uo, _excluded$T), wo = useGridApiContext(), Eo = useGridRootProps(), Ro = {
    classes: Eo.classes
  }, _o = useUtilityClasses$1a(Ro), Io = React$1.useRef(null), Ao = React$1.useRef(null), Oo = useForkRef(Io, ho), jo = (Zo) => {
    const ei = {
      value: Zo.target.checked,
      id: bo
    };
    wo.current.publishEvent("rowSelectionCheckboxChange", ei, Zo);
  };
  React$1.useLayoutEffect(() => {
    if (Co === 0) {
      const Zo = wo.current.getCellElement(bo, go);
      Zo && (Zo.tabIndex = -1);
    }
  }, [wo, Co, bo, go]), React$1.useEffect(() => {
    var Zo;
    if (Po) {
      const ei = (Zo = Io.current) == null ? void 0 : Zo.querySelector("input");
      ei == null || ei.focus({
        preventScroll: !0
      });
    } else Ao.current && Ao.current.stop({});
  }, [Po]);
  const Do = React$1.useCallback((Zo) => {
    Zo.key === " " && Zo.stopPropagation();
  }, []), Lo = wo.current.isRowSelectable(bo), ko = getCheckboxPropsSelector(bo, ((oi = Eo.rowSelectionPropagation) == null ? void 0 : oi.parents) ?? !1), {
    isIndeterminate: Ko,
    isChecked: No
  } = useGridSelector(wo, ko);
  if (vo.type === "footer" || vo.type === "pinnedRow")
    return null;
  const Jo = Eo.indeterminateCheckboxAction === "select" ? No && !Ko : No, ti = wo.current.getLocaleText(Jo ? "checkboxSelectionUnselectRow" : "checkboxSelectionSelectRow");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Eo.slots.baseCheckbox, _extends$q({
    tabIndex: Co,
    checked: Jo,
    onChange: jo,
    className: _o.root,
    inputProps: {
      "aria-label": ti
    },
    onKeyDown: Do,
    indeterminate: Ko,
    disabled: !Lo,
    touchRippleRef: Ao
    /* FIXME: typing error */
  }, (Qo = Eo.slotProps) == null ? void 0 : Qo.baseCheckbox, So, {
    ref: Oo
  }));
});
process.env.NODE_ENV !== "production" && (GridCellCheckboxForwardRef.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(["edit", "view"]).isRequired,
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the element that should receive focus.
   * @ignore - do not document.
   */
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.shape({
      focus: PropTypes.func.isRequired
    })
  })]),
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
});
const GridCellCheckboxRenderer = GridCellCheckboxForwardRef, gridFocusStateSelector = (Kt) => Kt.focus, gridFocusCellSelector = createSelector(gridFocusStateSelector, (Kt) => Kt.cell), gridFocusColumnHeaderSelector = createSelector(gridFocusStateSelector, (Kt) => Kt.columnHeader);
createSelector(gridFocusStateSelector, (Kt) => Kt.columnHeaderFilter);
const gridFocusColumnGroupHeaderSelector = createSelector(gridFocusStateSelector, (Kt) => Kt.columnGroupHeader), gridTabIndexStateSelector = (Kt) => Kt.tabIndex, gridTabIndexCellSelector = createSelector(gridTabIndexStateSelector, (Kt) => Kt.cell), gridTabIndexColumnHeaderSelector = createSelector(gridTabIndexStateSelector, (Kt) => Kt.columnHeader);
createSelector(gridTabIndexStateSelector, (Kt) => Kt.columnHeaderFilter);
const gridTabIndexColumnGroupHeaderSelector = createSelector(gridTabIndexStateSelector, (Kt) => Kt.columnGroupHeader);
function useGridApiMethod(Kt, uo, ho) {
  const go = React$1.useRef(!0);
  useEnhancedEffect(() => {
    go.current = !1, Kt.current.register(ho, uo);
  }, [Kt, ho, uo]), go.current && Kt.current.register(ho, uo);
}
function useGridLogger(Kt, uo) {
  const ho = React$1.useRef(null);
  if (ho.current)
    return ho.current;
  const go = Kt.current.getLogger(uo);
  return ho.current = go, go;
}
const useGridNativeEventListener = (Kt, uo, ho, go, bo) => {
  const vo = useGridLogger(Kt, "useNativeEventListener"), [Po, Co] = React$1.useState(!1), So = React$1.useRef(go), wo = isFunction$5(uo) ? uo() : (uo == null ? void 0 : uo.current) ?? null, Eo = React$1.useCallback((Ro) => So.current && So.current(Ro), []);
  React$1.useEffect(() => {
    So.current = go;
  }, [go]), React$1.useEffect(() => {
    if (wo && ho && !Po) {
      vo.debug(`Binding native ${ho} event`), wo.addEventListener(ho, Eo, bo), Co(!0);
      const Ro = () => {
        vo.debug(`Clearing native ${ho} event`), wo.removeEventListener(ho, Eo, bo);
      };
      Kt.current.subscribeEvent("unmount", Ro);
    }
  }, [wo, Eo, ho, Po, vo, bo, Kt]);
}, useFirstRender = (Kt) => {
  const uo = React$1.useRef(!0);
  uo.current && (uo.current = !1, Kt());
}, noop$5 = () => {
}, useRunOnce = (Kt, uo) => {
  const ho = React$1.useRef(!1);
  useEnhancedEffect(() => ho.current || !Kt ? noop$5 : (ho.current = !0, uo()), [ho.current || Kt]);
}, MAX_PAGE_SIZE = 100, defaultPageSize = (Kt) => Kt ? 0 : 100, getPageCount = (Kt, uo, ho) => uo > 0 && Kt > 0 ? Math.ceil(Kt / uo) : Kt === -1 ? ho + 2 : 0, getDefaultGridPaginationModel = (Kt) => ({
  page: 0,
  pageSize: Kt ? 0 : 100
}), getValidPage = (Kt, uo = 0) => uo === 0 ? Kt : Math.max(Math.min(Kt, uo - 1), 0), throwIfPageSizeExceedsTheLimit = (Kt, uo) => {
  if (uo === GridSignature.DataGrid && Kt > MAX_PAGE_SIZE)
    throw new Error(["MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
}, ALL_RESULTS_PAGE_VALUE = -1, gridPaginationSelector = (Kt) => Kt.pagination, gridPaginationModelSelector = createSelector(gridPaginationSelector, (Kt) => Kt.paginationModel), gridPaginationRowCountSelector = createSelector(gridPaginationSelector, (Kt) => Kt.rowCount), gridPaginationMetaSelector = createSelector(gridPaginationSelector, (Kt) => Kt.meta), gridPageSelector = createSelector(gridPaginationModelSelector, (Kt) => Kt.page), gridPageSizeSelector = createSelector(gridPaginationModelSelector, (Kt) => Kt.pageSize), gridPageCountSelector = createSelector(gridPaginationModelSelector, gridPaginationRowCountSelector, (Kt, uo) => getPageCount(uo, Kt.pageSize, Kt.page)), gridPaginationRowRangeSelector = createSelectorMemoized(gridPaginationModelSelector, gridRowTreeSelector, gridRowMaximumTreeDepthSelector, gridExpandedSortedRowEntriesSelector, gridFilteredSortedTopLevelRowEntriesSelector, (Kt, uo, ho, go, bo) => {
  var Io;
  const vo = bo.length, Po = Math.min(Kt.pageSize * Kt.page, vo - 1), Co = Kt.pageSize === ALL_RESULTS_PAGE_VALUE ? vo - 1 : Math.min(Po + Kt.pageSize - 1, vo - 1);
  if (Po === -1 || Co === -1)
    return null;
  if (ho < 2)
    return {
      firstRowIndex: Po,
      lastRowIndex: Co
    };
  const So = bo[Po], wo = Co - Po + 1, Eo = go.findIndex((Ao) => Ao.id === So.id);
  let Ro = Eo, _o = 0;
  for (; Ro < go.length && _o <= wo; ) {
    const Ao = go[Ro], Oo = (Io = uo[Ao.id]) == null ? void 0 : Io.depth;
    Oo === void 0 ? Ro += 1 : ((_o < wo || Oo > 0) && (Ro += 1), Oo === 0 && (_o += 1));
  }
  return {
    firstRowIndex: Eo,
    lastRowIndex: Ro - 1
  };
}), gridPaginatedVisibleSortedGridRowEntriesSelector = createSelectorMemoized(gridExpandedSortedRowEntriesSelector, gridPaginationRowRangeSelector, (Kt, uo) => uo ? Kt.slice(uo.firstRowIndex, uo.lastRowIndex + 1) : []), gridPaginatedVisibleSortedGridRowIdsSelector = createSelectorMemoized(gridExpandedSortedRowIdsSelector, gridPaginationRowRangeSelector, (Kt, uo) => uo ? Kt.slice(uo.firstRowIndex, uo.lastRowIndex + 1) : []), _excluded$S = ["field", "colDef"], useUtilityClasses$19 = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["checkboxInput"]
  }, getDataGridUtilityClass, uo);
}, GridHeaderCheckbox = forwardRef(function(uo, ho) {
  var oi;
  const go = _objectWithoutPropertiesLoose$h(uo, _excluded$S), [, bo] = React$1.useState(!1), vo = useGridApiContext(), Po = useGridRootProps(), Co = {
    classes: Po.classes
  }, So = useUtilityClasses$19(Co), wo = useGridSelector(vo, gridTabIndexColumnHeaderSelector), Eo = useGridSelector(vo, gridRowSelectionStateSelector), Ro = useGridSelector(vo, gridExpandedSortedRowIdsSelector), _o = useGridSelector(vo, gridPaginatedVisibleSortedGridRowIdsSelector), Io = React$1.useMemo(() => typeof Po.isRowSelectable != "function" ? Eo : Eo.filter((Qo) => vo.current.getRow(Qo) ? Po.isRowSelectable(vo.current.getRowParams(Qo)) : !1), [vo, Po.isRowSelectable, Eo]), Ao = React$1.useMemo(() => (!Po.pagination || !Po.checkboxSelectionVisibleOnly ? Ro : _o).reduce((Zo, ei) => (Zo[ei] = !0, Zo), {}), [Po.pagination, Po.checkboxSelectionVisibleOnly, _o, Ro]), Oo = React$1.useMemo(() => Io.filter((Qo) => Ao[Qo]).length, [Io, Ao]), jo = Oo > 0 && Oo < Object.keys(Ao).length, Do = Oo > 0, Lo = (Qo) => {
    const Zo = {
      value: Qo.target.checked
    };
    vo.current.publishEvent("headerSelectionCheckboxChange", Zo);
  }, ko = wo !== null && wo.field === uo.field ? 0 : -1;
  React$1.useLayoutEffect(() => {
    const Qo = vo.current.getColumnHeaderElement(uo.field);
    ko === 0 && Qo && (Qo.tabIndex = -1);
  }, [ko, vo, uo.field]);
  const Ko = React$1.useCallback((Qo) => {
    Qo.key === " " && vo.current.publishEvent("headerSelectionCheckboxChange", {
      value: !Do
    });
  }, [vo, Do]), No = React$1.useCallback(() => {
    bo((Qo) => !Qo);
  }, []);
  React$1.useEffect(() => vo.current.subscribeEvent("rowSelectionChange", No), [vo, No]);
  const Jo = Po.indeterminateCheckboxAction === "select" ? Do && !jo : Do, ti = vo.current.getLocaleText(Jo ? "checkboxSelectionUnselectAllRows" : "checkboxSelectionSelectAllRows");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.baseCheckbox, _extends$q({
    indeterminate: jo,
    checked: Jo,
    onChange: Lo,
    className: So.root,
    inputProps: {
      "aria-label": ti
    },
    tabIndex: ko,
    onKeyDown: Ko,
    disabled: !isMultipleRowSelectionEnabled(Po)
  }, (oi = Po.slotProps) == null ? void 0 : oi.baseCheckbox, go, {
    ref: ho
  }));
});
process.env.NODE_ENV !== "production" && (GridHeaderCheckbox.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The column of the current header component.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the column that triggered the event
   */
  field: PropTypes.string.isRequired
});
const GRID_CHECKBOX_SELECTION_FIELD = "__check__", GRID_CHECKBOX_SELECTION_COL_DEF = _extends$q({}, GRID_BOOLEAN_COL_DEF, {
  type: "custom",
  field: GRID_CHECKBOX_SELECTION_FIELD,
  width: 50,
  resizable: !1,
  sortable: !1,
  filterable: !1,
  // @ts-ignore
  aggregable: !1,
  disableColumnMenu: !0,
  disableReorder: !0,
  disableExport: !0,
  getApplyQuickFilterFn: void 0,
  display: "flex",
  valueGetter: (Kt, uo, ho, go) => {
    const bo = selectedIdsLookupSelector(go), vo = go.current.getRowId(uo);
    return bo[vo] !== void 0;
  },
  renderHeader: (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridHeaderCheckbox, _extends$q({}, Kt)),
  renderCell: (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridCellCheckboxRenderer, _extends$q({}, Kt))
}), _excluded$R = ["item", "applyValue", "type", "apiRef", "focusElementRef", "InputProps", "isFilterActive", "clearButton", "tabIndex", "disabled"];
function convertFilterItemValueToInputValue(Kt, uo) {
  if (Kt == null)
    return "";
  const ho = new Date(Kt);
  return Number.isNaN(ho.getTime()) ? "" : uo === "date" ? ho.toISOString().substring(0, 10) : uo === "datetime-local" ? (ho.setMinutes(ho.getMinutes() - ho.getTimezoneOffset()), ho.toISOString().substring(0, 19)) : ho.toISOString().substring(0, 10);
}
function GridFilterInputDate(Kt) {
  var ko;
  const {
    item: uo,
    applyValue: ho,
    type: go,
    apiRef: bo,
    focusElementRef: vo,
    InputProps: Po,
    clearButton: Co,
    tabIndex: So,
    disabled: wo
  } = Kt, Eo = _objectWithoutPropertiesLoose$h(Kt, _excluded$R), Ro = useTimeout(), [_o, Io] = React$1.useState(() => convertFilterItemValueToInputValue(uo.value, go)), [Ao, Oo] = React$1.useState(!1), jo = useId(), Do = useGridRootProps(), Lo = React$1.useCallback((Ko) => {
    Ro.clear();
    const No = Ko.target.value;
    Io(No), Oo(!0), Ro.start(Do.filterDebounceMs, () => {
      const Jo = new Date(No);
      ho(_extends$q({}, uo, {
        value: Number.isNaN(Jo.getTime()) ? void 0 : Jo
      })), Oo(!1);
    });
  }, [ho, uo, Do.filterDebounceMs, Ro]);
  return React$1.useEffect(() => {
    const Ko = convertFilterItemValueToInputValue(uo.value, go);
    Io(Ko);
  }, [uo.value, go]), /* @__PURE__ */ jsxRuntimeExports.jsx(Do.slots.baseTextField, _extends$q({
    fullWidth: !0,
    id: jo,
    label: bo.current.getLocaleText("filterPanelInputLabel"),
    placeholder: bo.current.getLocaleText("filterPanelInputPlaceholder"),
    value: _o,
    onChange: Lo,
    variant: "standard",
    type: go || "text",
    InputLabelProps: {
      shrink: !0
    },
    inputRef: vo,
    InputProps: _extends$q({}, Ao || Co ? {
      endAdornment: Ao ? /* @__PURE__ */ jsxRuntimeExports.jsx(Do.slots.loadIcon, {
        fontSize: "small",
        color: "action"
      }) : Co
    } : {}, {
      disabled: wo
    }, Po, {
      inputProps: _extends$q({
        max: go === "datetime-local" ? "9999-12-31T23:59" : "9999-12-31",
        tabIndex: So
      }, Po == null ? void 0 : Po.inputProps)
    })
  }, Eo, (ko = Do.slotProps) == null ? void 0 : ko.baseTextField));
}
process.env.NODE_ENV !== "production" && (GridFilterInputDate.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
});
function buildApplyFilterFn(Kt, uo, ho, go) {
  if (!Kt.value)
    return null;
  const bo = new Date(Kt.value);
  ho ? bo.setSeconds(0, 0) : (bo.setMinutes(bo.getMinutes() + bo.getTimezoneOffset()), bo.setHours(0, 0, 0, 0));
  const vo = bo.getTime();
  return (Po) => {
    if (!Po)
      return !1;
    if (go)
      return uo(Po.getTime(), vo);
    const Co = new Date(Po);
    return ho ? Co.setSeconds(0, 0) : Co.setHours(0, 0, 0, 0), uo(Co.getTime(), vo);
  };
}
const getGridDateOperators = (Kt) => [{
  value: "is",
  getApplyFilterFn: (uo) => buildApplyFilterFn(uo, (ho, go) => ho === go, Kt),
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: Kt ? "datetime-local" : "date"
  }
}, {
  value: "not",
  getApplyFilterFn: (uo) => buildApplyFilterFn(uo, (ho, go) => ho !== go, Kt),
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: Kt ? "datetime-local" : "date"
  }
}, {
  value: "after",
  getApplyFilterFn: (uo) => buildApplyFilterFn(uo, (ho, go) => ho > go, Kt),
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: Kt ? "datetime-local" : "date"
  }
}, {
  value: "onOrAfter",
  getApplyFilterFn: (uo) => buildApplyFilterFn(uo, (ho, go) => ho >= go, Kt),
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: Kt ? "datetime-local" : "date"
  }
}, {
  value: "before",
  getApplyFilterFn: (uo) => buildApplyFilterFn(uo, (ho, go) => ho < go, Kt, !Kt),
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: Kt ? "datetime-local" : "date"
  }
}, {
  value: "onOrBefore",
  getApplyFilterFn: (uo) => buildApplyFilterFn(uo, (ho, go) => ho <= go, Kt),
  InputComponent: GridFilterInputDate,
  InputComponentProps: {
    type: Kt ? "datetime-local" : "date"
  }
}, {
  value: "isEmpty",
  getApplyFilterFn: () => (uo) => uo == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: () => (uo) => uo != null,
  requiresFilterValue: !1
}], _excluded$Q = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "hasFocus", "inputProps", "isValidating", "isProcessingProps", "onValueChange"], StyledInputBase = styled(InputBase)({
  fontSize: "inherit"
}), useUtilityClasses$18 = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["editInputCell"]
  }, getDataGridUtilityClass, uo);
};
function GridEditDateCell(Kt) {
  const {
    id: uo,
    value: ho,
    field: go,
    colDef: bo,
    hasFocus: vo,
    inputProps: Po,
    onValueChange: Co
  } = Kt, So = _objectWithoutPropertiesLoose$h(Kt, _excluded$Q), wo = bo.type === "dateTime", Eo = useGridApiContext(), Ro = React$1.useRef(), _o = React$1.useMemo(() => {
    let Ko;
    ho == null ? Ko = null : ho instanceof Date ? Ko = ho : Ko = new Date((ho ?? "").toString());
    let No;
    return Ko == null || Number.isNaN(Ko.getTime()) ? No = "" : No = new Date(Ko.getTime() - Ko.getTimezoneOffset() * 60 * 1e3).toISOString().substr(0, wo ? 16 : 10), {
      parsed: Ko,
      formatted: No
    };
  }, [ho, wo]), [Io, Ao] = React$1.useState(_o), jo = {
    classes: useGridRootProps().classes
  }, Do = useUtilityClasses$18(jo), Lo = React$1.useCallback((Ko) => {
    if (Ko === "")
      return null;
    const [No, Jo] = Ko.split("T"), [ti, oi, Qo] = No.split("-"), Zo = /* @__PURE__ */ new Date();
    if (Zo.setFullYear(Number(ti), Number(oi) - 1, Number(Qo)), Zo.setHours(0, 0, 0, 0), Jo) {
      const [ei, ii] = Jo.split(":");
      Zo.setHours(Number(ei), Number(ii), 0, 0);
    }
    return Zo;
  }, []), ko = React$1.useCallback(async (Ko) => {
    const No = Ko.target.value, Jo = Lo(No);
    Co && await Co(Ko, Jo), Ao({
      parsed: Jo,
      formatted: No
    }), Eo.current.setEditCellValue({
      id: uo,
      field: go,
      value: Jo
    }, Ko);
  }, [Eo, go, uo, Co, Lo]);
  return React$1.useEffect(() => {
    Ao((Ko) => {
      var No, Jo;
      return _o.parsed !== Ko.parsed && ((No = _o.parsed) == null ? void 0 : No.getTime()) !== ((Jo = Ko.parsed) == null ? void 0 : Jo.getTime()) ? _o : Ko;
    });
  }, [_o]), useEnhancedEffect(() => {
    vo && Ro.current.focus();
  }, [vo]), /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInputBase, _extends$q({
    inputRef: Ro,
    fullWidth: !0,
    className: Do.root,
    type: wo ? "datetime-local" : "date",
    inputProps: _extends$q({
      max: wo ? "9999-12-31T23:59" : "9999-12-31"
    }, Po),
    value: Io.formatted,
    onChange: ko
  }, So));
}
process.env.NODE_ENV !== "production" && (GridEditDateCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(["edit", "view"]).isRequired,
  changeReason: PropTypes.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {Date | null} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
});
const renderEditDateCell = (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridEditDateCell, _extends$q({}, Kt));
function throwIfNotDateObject({
  value: Kt,
  columnType: uo,
  rowId: ho,
  field: go
}) {
  if (!(Kt instanceof Date))
    throw new Error([`MUI X: \`${uo}\` column type only accepts \`Date\` objects as values.`, "Use `valueGetter` to transform the value into a `Date` object.", `Row ID: ${ho}, field: "${go}".`].join(`
`));
}
const gridDateFormatter = (Kt, uo, ho, go) => {
  if (!Kt)
    return "";
  const bo = go.current.getRowId(uo);
  return throwIfNotDateObject({
    value: Kt,
    columnType: "date",
    rowId: bo,
    field: ho.field
  }), Kt.toLocaleDateString();
}, gridDateTimeFormatter = (Kt, uo, ho, go) => {
  if (!Kt)
    return "";
  const bo = go.current.getRowId(uo);
  return throwIfNotDateObject({
    value: Kt,
    columnType: "dateTime",
    rowId: bo,
    field: ho.field
  }), Kt.toLocaleString();
}, GRID_DATE_COL_DEF = _extends$q({}, GRID_STRING_COL_DEF, {
  type: "date",
  sortComparator: gridDateComparator,
  valueFormatter: gridDateFormatter,
  filterOperators: getGridDateOperators(),
  renderEditCell: renderEditDateCell,
  // @ts-ignore
  pastedValueParser: (Kt) => new Date(Kt)
}), GRID_DATETIME_COL_DEF = _extends$q({}, GRID_STRING_COL_DEF, {
  type: "dateTime",
  sortComparator: gridDateComparator,
  valueFormatter: gridDateTimeFormatter,
  filterOperators: getGridDateOperators(!0),
  renderEditCell: renderEditDateCell,
  // @ts-ignore
  pastedValueParser: (Kt) => new Date(Kt)
}), parseNumericValue = (Kt) => Kt == null ? null : Number(Kt), getGridNumericQuickFilterFn = (Kt) => Kt == null || Number.isNaN(Kt) || Kt === "" ? null : (uo) => parseNumericValue(uo) === parseNumericValue(Kt), getGridNumericOperators = () => [{
  value: "=",
  getApplyFilterFn: (Kt) => Kt.value == null || Number.isNaN(Kt.value) ? null : (uo) => parseNumericValue(uo) === Kt.value,
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "!=",
  getApplyFilterFn: (Kt) => Kt.value == null || Number.isNaN(Kt.value) ? null : (uo) => parseNumericValue(uo) !== Kt.value,
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">",
  getApplyFilterFn: (Kt) => Kt.value == null || Number.isNaN(Kt.value) ? null : (uo) => uo == null ? !1 : parseNumericValue(uo) > Kt.value,
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: ">=",
  getApplyFilterFn: (Kt) => Kt.value == null || Number.isNaN(Kt.value) ? null : (uo) => uo == null ? !1 : parseNumericValue(uo) >= Kt.value,
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<",
  getApplyFilterFn: (Kt) => Kt.value == null || Number.isNaN(Kt.value) ? null : (uo) => uo == null ? !1 : parseNumericValue(uo) < Kt.value,
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "<=",
  getApplyFilterFn: (Kt) => Kt.value == null || Number.isNaN(Kt.value) ? null : (uo) => uo == null ? !1 : parseNumericValue(uo) <= Kt.value,
  InputComponent: GridFilterInputValue,
  InputComponentProps: {
    type: "number"
  }
}, {
  value: "isEmpty",
  getApplyFilterFn: () => (Kt) => Kt == null,
  requiresFilterValue: !1
}, {
  value: "isNotEmpty",
  getApplyFilterFn: () => (Kt) => Kt != null,
  requiresFilterValue: !1
}, {
  value: "isAnyOf",
  getApplyFilterFn: (Kt) => !Array.isArray(Kt.value) || Kt.value.length === 0 ? null : (uo) => uo != null && Kt.value.includes(Number(uo)),
  InputComponent: GridFilterInputMultipleValue,
  InputComponentProps: {
    type: "number"
  }
}], GRID_NUMERIC_COL_DEF = _extends$q({}, GRID_STRING_COL_DEF, {
  type: "number",
  align: "right",
  headerAlign: "right",
  sortComparator: gridNumberComparator,
  valueParser: (Kt) => Kt === "" ? null : Number(Kt),
  valueFormatter: (Kt) => isNumber$5(Kt) ? Kt.toLocaleString() : Kt || "",
  filterOperators: getGridNumericOperators(),
  getApplyQuickFilterFn: getGridNumericQuickFilterFn
});
function isSingleSelectColDef(Kt) {
  return (Kt == null ? void 0 : Kt.type) === "singleSelect";
}
function getValueOptions(Kt, uo) {
  if (Kt)
    return typeof Kt.valueOptions == "function" ? Kt.valueOptions(_extends$q({
      field: Kt.field
    }, uo)) : Kt.valueOptions;
}
function getValueFromValueOptions(Kt, uo, ho) {
  if (uo === void 0)
    return;
  const go = uo.find((bo) => {
    const vo = ho(bo);
    return String(vo) === String(Kt);
  });
  return ho(go);
}
const _excluded$P = ["id", "value", "formattedValue", "api", "field", "row", "rowNode", "colDef", "cellMode", "isEditable", "tabIndex", "className", "hasFocus", "isValidating", "isProcessingProps", "error", "onValueChange", "initialOpen"], _excluded2$c = ["MenuProps"];
function isKeyboardEvent$1(Kt) {
  return !!Kt.key;
}
function GridEditSingleSelectCell(Kt) {
  var ii, ai;
  const uo = useGridRootProps(), {
    id: ho,
    value: go,
    field: bo,
    row: vo,
    colDef: Po,
    hasFocus: Co,
    error: So,
    onValueChange: wo,
    initialOpen: Eo = uo.editMode === GridEditModes.Cell
  } = Kt, Ro = _objectWithoutPropertiesLoose$h(Kt, _excluded$P), _o = useGridApiContext(), Io = React$1.useRef(), Ao = React$1.useRef(), [Oo, jo] = React$1.useState(Eo), Lo = (((ii = uo.slotProps) == null ? void 0 : ii.baseSelect) || {}).native ?? !1, ko = ((ai = uo.slotProps) == null ? void 0 : ai.baseSelect) || {}, {
    MenuProps: Ko
  } = ko, No = _objectWithoutPropertiesLoose$h(ko, _excluded2$c);
  if (useEnhancedEffect(() => {
    var ri;
    Co && ((ri = Ao.current) == null || ri.focus());
  }, [Co]), !isSingleSelectColDef(Po))
    return null;
  const Jo = getValueOptions(Po, {
    id: ho,
    row: vo
  });
  if (!Jo)
    return null;
  const ti = Po.getOptionValue, oi = Po.getOptionLabel, Qo = async (ri) => {
    if (!isSingleSelectColDef(Po) || !Jo)
      return;
    jo(!1);
    const ni = ri.target, si = getValueFromValueOptions(ni.value, Jo, ti);
    wo && await wo(ri, si), await _o.current.setEditCellValue({
      id: ho,
      field: bo,
      value: si
    }, ri);
  }, Zo = (ri, ni) => {
    if (uo.editMode === GridEditModes.Row) {
      jo(!1);
      return;
    }
    if (ni === "backdropClick" || ri.key === "Escape") {
      const si = _o.current.getCellParams(ho, bo);
      _o.current.publishEvent("cellEditStop", _extends$q({}, si, {
        reason: ri.key === "Escape" ? GridCellEditStopReasons.escapeKeyDown : GridCellEditStopReasons.cellFocusOut
      }));
    }
  }, ei = (ri) => {
    isKeyboardEvent$1(ri) && ri.key === "Enter" || jo(!0);
  };
  return !Jo || !Po ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(uo.slots.baseSelect, _extends$q({
    ref: Io,
    inputRef: Ao,
    value: go,
    onChange: Qo,
    open: Oo,
    onOpen: ei,
    MenuProps: _extends$q({
      onClose: Zo
    }, Ko),
    error: So,
    native: Lo,
    fullWidth: !0
  }, Ro, No, {
    children: Jo.map((ri) => {
      var si;
      const ni = ti(ri);
      return /* @__PURE__ */ createElement(uo.slots.baseSelectOption, _extends$q({}, ((si = uo.slotProps) == null ? void 0 : si.baseSelectOption) || {}, {
        native: Lo,
        key: ni,
        value: ni
      }), oi(ri));
    })
  }));
}
process.env.NODE_ENV !== "production" && (GridEditSingleSelectCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * GridApi that let you manipulate the grid.
   */
  api: PropTypes.object.isRequired,
  /**
   * The mode of the cell.
   */
  cellMode: PropTypes.oneOf(["edit", "view"]).isRequired,
  changeReason: PropTypes.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
  /**
   * The column of the row that the current cell belongs to.
   */
  colDef: PropTypes.object.isRequired,
  /**
   * The column field of the cell that triggered the event.
   */
  field: PropTypes.string.isRequired,
  /**
   * The cell value formatted with the column valueFormatter.
   */
  formattedValue: PropTypes.any,
  /**
   * If true, the cell is the active element.
   */
  hasFocus: PropTypes.bool.isRequired,
  /**
   * The grid row id.
   */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * If true, the select opens by default.
   */
  initialOpen: PropTypes.bool,
  /**
   * If true, the cell is editable.
   */
  isEditable: PropTypes.bool,
  isProcessingProps: PropTypes.bool,
  isValidating: PropTypes.bool,
  /**
   * Callback called when the value is changed by the user.
   * @param {SelectChangeEvent<any>} event The event source of the callback.
   * @param {any} newValue The value that is going to be passed to `apiRef.current.setEditCellValue`.
   * @returns {Promise<void> | void} A promise to be awaited before calling `apiRef.current.setEditCellValue`
   */
  onValueChange: PropTypes.func,
  /**
   * The row model of the row that the current cell belongs to.
   */
  row: PropTypes.any.isRequired,
  /**
   * The node of the row that the current cell belongs to.
   */
  rowNode: PropTypes.object.isRequired,
  /**
   * the tabIndex value.
   */
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired,
  /**
   * The cell value.
   * If the column has `valueGetter`, use `params.row` to directly access the fields.
   */
  value: PropTypes.any
});
const renderEditSingleSelectCell = (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridEditSingleSelectCell, _extends$q({}, Kt)), _excluded$O = ["item", "applyValue", "type", "apiRef", "focusElementRef", "placeholder", "tabIndex", "label", "variant", "isFilterActive", "clearButton", "InputLabelProps"], renderSingleSelectOptions = ({
  column: Kt,
  OptionComponent: uo,
  getOptionLabel: ho,
  getOptionValue: go,
  isSelectNative: bo,
  baseSelectOptionProps: vo
}) => ["", ...getValueOptions(Kt) || []].map((Co) => {
  const So = go(Co);
  let wo = ho(Co);
  return wo === "" && (wo = " "), /* @__PURE__ */ createElement(uo, _extends$q({}, vo, {
    native: bo,
    key: So,
    value: So
  }), wo);
}), SingleSelectOperatorContainer = styled("div")({
  display: "flex",
  alignItems: "flex-end",
  width: "100%",
  "& button": {
    margin: "auto 0px 5px 5px"
  }
});
function GridFilterInputSingleSelect(Kt) {
  var ti, oi, Qo, Zo, ei;
  const {
    item: uo,
    applyValue: ho,
    type: go,
    apiRef: bo,
    focusElementRef: vo,
    placeholder: Po,
    tabIndex: Co,
    label: So,
    variant: wo = "standard",
    clearButton: Eo
  } = Kt, Ro = _objectWithoutPropertiesLoose$h(Kt, _excluded$O), _o = uo.value ?? "", Io = useId(), Ao = useId(), Oo = useGridRootProps(), jo = ((oi = (ti = Oo.slotProps) == null ? void 0 : ti.baseSelect) == null ? void 0 : oi.native) ?? !1;
  let Do = null;
  if (uo.field) {
    const ii = bo.current.getColumn(uo.field);
    isSingleSelectColDef(ii) && (Do = ii);
  }
  const Lo = Do == null ? void 0 : Do.getOptionValue, ko = Do == null ? void 0 : Do.getOptionLabel, Ko = React$1.useMemo(() => getValueOptions(Do), [Do]), No = React$1.useCallback((ii) => {
    let ai = ii.target.value;
    ai = getValueFromValueOptions(ai, Ko, Lo), ho(_extends$q({}, uo, {
      value: ai
    }));
  }, [Ko, Lo, ho, uo]);
  if (!isSingleSelectColDef(Do))
    return null;
  const Jo = So ?? bo.current.getLocaleText("filterPanelInputLabel");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SingleSelectOperatorContainer, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(Oo.slots.baseFormControl, {
      fullWidth: !0,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(Oo.slots.baseInputLabel, _extends$q({}, (Qo = Oo.slotProps) == null ? void 0 : Qo.baseInputLabel, {
        id: Ao,
        htmlFor: Io,
        shrink: !0,
        variant: wo,
        children: Jo
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(Oo.slots.baseSelect, _extends$q({
        id: Io,
        label: Jo,
        labelId: Ao,
        value: _o,
        onChange: No,
        variant: wo,
        type: go || "text",
        inputProps: {
          tabIndex: Co,
          ref: vo,
          placeholder: Po ?? bo.current.getLocaleText("filterPanelInputPlaceholder")
        },
        native: jo,
        notched: wo === "outlined" ? !0 : void 0
      }, Ro, (Zo = Oo.slotProps) == null ? void 0 : Zo.baseSelect, {
        children: renderSingleSelectOptions({
          column: Do,
          OptionComponent: Oo.slots.baseSelectOption,
          getOptionLabel: ko,
          getOptionValue: Lo,
          isSelectNative: jo,
          baseSelectOptionProps: (ei = Oo.slotProps) == null ? void 0 : ei.baseSelectOption
        })
      }))]
    }), Eo]
  });
}
process.env.NODE_ENV !== "production" && (GridFilterInputSingleSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  clearButton: PropTypes.node,
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * It is `true` if the filter either has a value or an operator with no value
   * required is selected (for example `isEmpty`)
   */
  isFilterActive: PropTypes.bool,
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired
});
const _excluded$N = ["item", "applyValue", "type", "apiRef", "focusElementRef", "color", "error", "helperText", "size", "variant"], _excluded2$b = ["key"], filter = createFilterOptions();
function GridFilterInputMultipleSingleSelect(Kt) {
  const {
    item: uo,
    applyValue: ho,
    apiRef: go,
    focusElementRef: bo,
    color: vo,
    error: Po,
    helperText: Co,
    size: So,
    variant: wo = "standard"
  } = Kt, Eo = _objectWithoutPropertiesLoose$h(Kt, _excluded$N), Ro = {
    color: vo,
    error: Po,
    helperText: Co,
    size: So,
    variant: wo
  }, _o = useId(), Io = useGridRootProps();
  let Ao = null;
  if (uo.field) {
    const No = go.current.getColumn(uo.field);
    isSingleSelectColDef(No) && (Ao = No);
  }
  const Oo = Ao == null ? void 0 : Ao.getOptionValue, jo = Ao == null ? void 0 : Ao.getOptionLabel, Do = React$1.useCallback((No, Jo) => Oo(No) === Oo(Jo), [Oo]), Lo = React$1.useMemo(() => getValueOptions(Ao) || [], [Ao]), ko = React$1.useMemo(() => Array.isArray(uo.value) ? uo.value.reduce((No, Jo) => {
    const ti = Lo.find((oi) => Oo(oi) === Jo);
    return ti != null && No.push(ti), No;
  }, []) : [], [Oo, uo.value, Lo]), Ko = React$1.useCallback((No, Jo) => {
    ho(_extends$q({}, uo, {
      value: Jo.map(Oo)
    }));
  }, [ho, uo, Oo]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Autocomplete, _extends$q({
    multiple: !0,
    options: Lo,
    isOptionEqualToValue: Do,
    filterOptions: filter,
    id: _o,
    value: ko,
    onChange: Ko,
    getOptionLabel: jo,
    renderTags: (No, Jo) => No.map((ti, oi) => {
      const Qo = Jo({
        index: oi
      }), {
        key: Zo
      } = Qo, ei = _objectWithoutPropertiesLoose$h(Qo, _excluded2$b);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Io.slots.baseChip, _extends$q({
        variant: "outlined",
        size: "small",
        label: jo(ti)
      }, ei), Zo);
    }),
    renderInput: (No) => {
      var Jo;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Io.slots.baseTextField, _extends$q({}, No, {
        label: go.current.getLocaleText("filterPanelInputLabel"),
        placeholder: go.current.getLocaleText("filterPanelInputPlaceholder"),
        InputLabelProps: _extends$q({}, No.InputLabelProps, {
          shrink: !0
        }),
        inputRef: bo,
        type: "singleSelect"
      }, Ro, (Jo = Io.slotProps) == null ? void 0 : Jo.baseTextField));
    }
  }, Eo));
}
process.env.NODE_ENV !== "production" && (GridFilterInputMultipleSingleSelect.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }).isRequired,
  applyValue: PropTypes.func.isRequired,
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  type: PropTypes.oneOf(["singleSelect"])
});
const parseObjectValue = (Kt) => Kt == null || !isObject$a(Kt) ? Kt : Kt.value, getGridSingleSelectOperators = () => [{
  value: "is",
  getApplyFilterFn: (Kt) => Kt.value == null || Kt.value === "" ? null : (uo) => parseObjectValue(uo) === parseObjectValue(Kt.value),
  InputComponent: GridFilterInputSingleSelect
}, {
  value: "not",
  getApplyFilterFn: (Kt) => Kt.value == null || Kt.value === "" ? null : (uo) => parseObjectValue(uo) !== parseObjectValue(Kt.value),
  InputComponent: GridFilterInputSingleSelect
}, {
  value: "isAnyOf",
  getApplyFilterFn: (Kt) => {
    if (!Array.isArray(Kt.value) || Kt.value.length === 0)
      return null;
    const uo = Kt.value.map(parseObjectValue);
    return (ho) => uo.includes(parseObjectValue(ho));
  },
  InputComponent: GridFilterInputMultipleSingleSelect
}], isArrayOfObjects = (Kt) => typeof Kt[0] == "object", defaultGetOptionValue = (Kt) => isObject$a(Kt) ? Kt.value : Kt, defaultGetOptionLabel = (Kt) => isObject$a(Kt) ? Kt.label : String(Kt), GRID_SINGLE_SELECT_COL_DEF = _extends$q({}, GRID_STRING_COL_DEF, {
  type: "singleSelect",
  getOptionLabel: defaultGetOptionLabel,
  getOptionValue: defaultGetOptionValue,
  valueFormatter(Kt, uo, ho, go) {
    const bo = go.current.getRowId(uo);
    if (!isSingleSelectColDef(ho))
      return "";
    const vo = getValueOptions(ho, {
      id: bo,
      row: uo
    });
    if (Kt == null)
      return "";
    if (!vo)
      return Kt;
    if (!isArrayOfObjects(vo))
      return ho.getOptionLabel(Kt);
    const Po = vo.find((Co) => ho.getOptionValue(Co) === Kt);
    return Po ? ho.getOptionLabel(Po) : "";
  },
  renderEditCell: renderEditSingleSelectCell,
  filterOperators: getGridSingleSelectOperators(),
  // @ts-ignore
  pastedValueParser: (Kt, uo, ho) => {
    const go = ho, bo = getValueOptions(go) || [], vo = go.getOptionValue;
    if (bo.find((Co) => vo(Co) === Kt))
      return Kt;
  }
}), DEFAULT_GRID_COL_TYPE_KEY = "string", getGridDefaultColumnTypes = () => ({
  string: GRID_STRING_COL_DEF,
  number: GRID_NUMERIC_COL_DEF,
  date: GRID_DATE_COL_DEF,
  dateTime: GRID_DATETIME_COL_DEF,
  boolean: GRID_BOOLEAN_COL_DEF,
  singleSelect: GRID_SINGLE_SELECT_COL_DEF,
  [GRID_ACTIONS_COLUMN_TYPE]: GRID_ACTIONS_COL_DEF,
  custom: GRID_STRING_COL_DEF
}), gridHeaderFilteringStateSelector = (Kt) => Kt.headerFiltering, gridHeaderFilteringEnabledSelector = createSelector(
  gridHeaderFilteringStateSelector,
  // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
  (Kt) => (Kt == null ? void 0 : Kt.enabled) ?? !1
), gridHeaderFilteringEditFieldSelector = createSelector(gridHeaderFilteringStateSelector, (Kt) => Kt.editing), gridHeaderFilteringMenuSelector = createSelector(gridHeaderFilteringStateSelector, (Kt) => Kt.menuOpen), gridColumnGroupingSelector = (Kt) => Kt.columnGrouping, gridColumnGroupsUnwrappedModelSelector = createSelectorMemoized(gridColumnGroupingSelector, (Kt) => (Kt == null ? void 0 : Kt.unwrappedGroupingModel) ?? {}), gridColumnGroupsLookupSelector = createSelectorMemoized(gridColumnGroupingSelector, (Kt) => (Kt == null ? void 0 : Kt.lookup) ?? {}), gridColumnGroupsHeaderStructureSelector = createSelectorMemoized(gridColumnGroupingSelector, (Kt) => (Kt == null ? void 0 : Kt.headerStructure) ?? []), gridColumnGroupsHeaderMaxDepthSelector = createSelector(gridColumnGroupingSelector, (Kt) => (Kt == null ? void 0 : Kt.maxDepth) ?? 0), COLUMNS_DIMENSION_PROPERTIES = ["maxWidth", "minWidth", "width", "flex"], COLUMN_TYPES = getGridDefaultColumnTypes();
function computeFlexColumnsWidth({
  initialFreeSpace: Kt,
  totalFlexUnits: uo,
  flexColumns: ho
}) {
  const go = new Set(ho.map((Po) => Po.field)), bo = {
    all: {},
    frozenFields: [],
    freeze: (Po) => {
      const Co = bo.all[Po];
      Co && Co.frozen !== !0 && (bo.all[Po].frozen = !0, bo.frozenFields.push(Po));
    }
  };
  function vo() {
    if (bo.frozenFields.length === go.size)
      return;
    const Po = {
      min: {},
      max: {}
    };
    let Co = Kt, So = uo, wo = 0;
    bo.frozenFields.forEach((Eo) => {
      Co -= bo.all[Eo].computedWidth, So -= bo.all[Eo].flex;
    });
    for (let Eo = 0; Eo < ho.length; Eo += 1) {
      const Ro = ho[Eo];
      if (bo.all[Ro.field] && bo.all[Ro.field].frozen === !0)
        continue;
      let Io = Co / So * Ro.flex;
      Io < Ro.minWidth ? (wo += Ro.minWidth - Io, Io = Ro.minWidth, Po.min[Ro.field] = !0) : Io > Ro.maxWidth && (wo += Ro.maxWidth - Io, Io = Ro.maxWidth, Po.max[Ro.field] = !0), bo.all[Ro.field] = {
        frozen: !1,
        computedWidth: Io,
        flex: Ro.flex
      };
    }
    wo < 0 ? Object.keys(Po.max).forEach((Eo) => {
      bo.freeze(Eo);
    }) : wo > 0 ? Object.keys(Po.min).forEach((Eo) => {
      bo.freeze(Eo);
    }) : ho.forEach(({
      field: Eo
    }) => {
      bo.freeze(Eo);
    }), vo();
  }
  return vo(), bo.all;
}
const hydrateColumnsWidth = (Kt, uo) => {
  const ho = {};
  let go = 0, bo = 0;
  const vo = [];
  Kt.orderedFields.forEach((So) => {
    let wo = Kt.lookup[So], Eo = 0, Ro = !1;
    Kt.columnVisibilityModel[So] !== !1 && (wo.flex && wo.flex > 0 ? (go += wo.flex, Ro = !0) : Eo = clamp$1(wo.width || GRID_STRING_COL_DEF.width, wo.minWidth || GRID_STRING_COL_DEF.minWidth, wo.maxWidth || GRID_STRING_COL_DEF.maxWidth), bo += Eo), wo.computedWidth !== Eo && (wo = _extends$q({}, wo, {
      computedWidth: Eo
    })), Ro && vo.push(wo), ho[So] = wo;
  });
  const Po = uo === void 0 ? 0 : uo.viewportOuterSize.width - (uo.hasScrollY ? uo.scrollbarSize : 0), Co = Math.max(Po - bo, 0);
  if (go > 0 && Po > 0) {
    const So = computeFlexColumnsWidth({
      initialFreeSpace: Co,
      totalFlexUnits: go,
      flexColumns: vo
    });
    Object.keys(So).forEach((wo) => {
      ho[wo].computedWidth = So[wo].computedWidth;
    });
  }
  return _extends$q({}, Kt, {
    lookup: ho
  });
}, applyInitialState = (Kt, uo) => {
  if (!uo)
    return Kt;
  const {
    orderedFields: ho = [],
    dimensions: go = {}
  } = uo, bo = Object.keys(go);
  if (bo.length === 0 && ho.length === 0)
    return Kt;
  const vo = {}, Po = [];
  for (let Eo = 0; Eo < ho.length; Eo += 1) {
    const Ro = ho[Eo];
    Kt.lookup[Ro] && (vo[Ro] = !0, Po.push(Ro));
  }
  const Co = Po.length === 0 ? Kt.orderedFields : [...Po, ...Kt.orderedFields.filter((Eo) => !vo[Eo])], So = _extends$q({}, Kt.lookup);
  for (let Eo = 0; Eo < bo.length; Eo += 1) {
    const Ro = bo[Eo], _o = _extends$q({}, So[Ro], {
      hasBeenResized: !0
    });
    Object.entries(go[Ro]).forEach(([Io, Ao]) => {
      _o[Io] = Ao === -1 ? 1 / 0 : Ao;
    }), So[Ro] = _o;
  }
  return _extends$q({}, Kt, {
    orderedFields: Co,
    lookup: So
  });
};
function getDefaultColTypeDef(Kt) {
  let uo = COLUMN_TYPES[DEFAULT_GRID_COL_TYPE_KEY];
  return Kt && COLUMN_TYPES[Kt] && (uo = COLUMN_TYPES[Kt]), uo;
}
const createColumnsState = ({
  apiRef: Kt,
  columnsToUpsert: uo,
  initialState: ho,
  columnVisibilityModel: go = gridColumnVisibilityModelSelector(Kt),
  keepOnlyColumnsToUpsert: bo = !1
}) => {
  var Eo, Ro;
  const vo = !Kt.current.state.columns;
  let Po;
  if (vo)
    Po = {
      orderedFields: [],
      lookup: {},
      columnVisibilityModel: go
    };
  else {
    const _o = gridColumnsStateSelector(Kt.current.state);
    Po = {
      orderedFields: bo ? [] : [..._o.orderedFields],
      lookup: _extends$q({}, _o.lookup),
      // Will be cleaned later if keepOnlyColumnsToUpsert=true
      columnVisibilityModel: go
    };
  }
  let Co = {};
  bo && !vo && (Co = Object.keys(Po.lookup).reduce((_o, Io) => _extends$q({}, _o, {
    [Io]: !1
  }), {})), uo.forEach((_o) => {
    const {
      field: Io
    } = _o;
    Co[Io] = !0;
    let Ao = Po.lookup[Io];
    Ao == null ? (Ao = _extends$q({}, getDefaultColTypeDef(_o.type), {
      field: Io,
      hasBeenResized: !1
    }), Po.orderedFields.push(Io)) : bo && Po.orderedFields.push(Io), Ao && Ao.type !== _o.type && (Ao = _extends$q({}, getDefaultColTypeDef(_o.type), {
      field: Io
    }));
    let Oo = Ao.hasBeenResized;
    COLUMNS_DIMENSION_PROPERTIES.forEach((jo) => {
      _o[jo] !== void 0 && (Oo = !0, _o[jo] === -1 && (_o[jo] = 1 / 0));
    }), Po.lookup[Io] = resolveProps(Ao, _extends$q({}, _o, {
      hasBeenResized: Oo
    }));
  }), bo && !vo && Object.keys(Po.lookup).forEach((_o) => {
    Co[_o] || delete Po.lookup[_o];
  });
  const So = Kt.current.unstable_applyPipeProcessors("hydrateColumns", Po), wo = applyInitialState(So, ho);
  return hydrateColumnsWidth(wo, ((Ro = (Eo = Kt.current).getRootDimensions) == null ? void 0 : Ro.call(Eo)) ?? void 0);
};
function getFirstNonSpannedColumnToRender({
  firstColumnToRender: Kt,
  apiRef: uo,
  firstRowToRender: ho,
  lastRowToRender: go,
  visibleRows: bo
}) {
  let vo = Kt;
  for (let Po = ho; Po < go; Po += 1)
    if (bo[Po]) {
      const So = bo[Po].id, wo = uo.current.unstable_getCellColSpanInfo(So, Kt);
      wo && wo.spannedByColSpan && (vo = wo.leftVisibleCellIndex);
    }
  return vo;
}
function getTotalHeaderHeight(Kt, uo) {
  if (uo.unstable_listView)
    return 0;
  const ho = gridDensityFactorSelector(Kt), go = gridColumnGroupsHeaderMaxDepthSelector(Kt), bo = gridHeaderFilteringEnabledSelector(Kt), vo = Math.floor(uo.columnHeaderHeight * ho), Po = Math.floor((uo.columnGroupHeaderHeight ?? uo.columnHeaderHeight) * ho), Co = bo ? Math.floor((uo.headerFilterHeight ?? uo.columnHeaderHeight) * ho) : 0;
  return vo + Po * go + Co;
}
const CLIFF = 1, SLOP = 1.5, useUtilityClasses$17 = (Kt) => {
  const {
    scrollDirection: uo,
    classes: ho
  } = Kt, go = {
    root: ["scrollArea", `scrollArea--${uo}`]
  };
  return composeClasses(go, getDataGridUtilityClass, ho);
}, GridScrollAreaRawRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "ScrollArea",
  overridesResolver: (Kt, uo) => [{
    [`&.${gridClasses["scrollArea--left"]}`]: uo["scrollArea--left"]
  }, {
    [`&.${gridClasses["scrollArea--right"]}`]: uo["scrollArea--right"]
  }, uo.scrollArea]
})(() => ({
  position: "absolute",
  top: 0,
  zIndex: 101,
  width: 20,
  bottom: 0,
  [`&.${gridClasses["scrollArea--left"]}`]: {
    left: 0
  },
  [`&.${gridClasses["scrollArea--right"]}`]: {
    right: 0
  }
}));
function GridScrollAreaRaw(Kt) {
  const {
    scrollDirection: uo
  } = Kt, ho = React$1.useRef(null), go = useGridApiContext(), bo = useTimeout(), vo = useGridSelector(go, gridDensityFactorSelector), Po = useGridSelector(go, gridColumnsTotalWidthSelector), Co = useGridSelector(go, gridDimensionsSelector), So = React$1.useRef({
    left: 0,
    top: 0
  }), wo = () => {
    if (uo === "left")
      return So.current.left > 0;
    if (uo === "right") {
      const oi = Po - Co.viewportInnerSize.width;
      return So.current.left < oi;
    }
    return !1;
  }, [Eo, Ro] = React$1.useState(!1), [_o, Io] = React$1.useState(wo), Ao = useGridRootProps(), Oo = _extends$q({}, Ao, {
    scrollDirection: uo
  }), jo = useUtilityClasses$17(Oo), Do = getTotalHeaderHeight(go, Ao), Lo = Math.floor(Ao.columnHeaderHeight * vo), ko = {
    height: Lo,
    top: Do - Lo
  };
  uo === "left" ? ko.left = Co.leftPinnedWidth : uo === "right" && (ko.right = Co.rightPinnedWidth + (Co.hasScrollX ? Co.scrollbarSize : 0));
  const Ko = (oi) => {
    So.current = oi, Io(wo);
  }, No = useEventCallback((oi) => {
    let Qo;
    if (oi.preventDefault(), uo === "left")
      Qo = oi.clientX - ho.current.getBoundingClientRect().right;
    else if (uo === "right")
      Qo = Math.max(1, oi.clientX - ho.current.getBoundingClientRect().left);
    else
      throw new Error("MUI X: Wrong drag direction");
    Qo = (Qo - CLIFF) * SLOP + CLIFF, bo.start(0, () => {
      go.current.scroll({
        left: So.current.left + Qo,
        top: So.current.top
      });
    });
  }), Jo = useEventCallback(() => {
    Ro(!0);
  }), ti = useEventCallback(() => {
    Ro(!1);
  });
  return useGridApiEventHandler(go, "scrollPositionChange", Ko), useGridApiEventHandler(go, "columnHeaderDragStart", Jo), useGridApiEventHandler(go, "columnHeaderDragEnd", ti), !Eo || !_o ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(GridScrollAreaRawRoot, {
    ref: ho,
    className: clsx(jo.root),
    ownerState: Oo,
    onDragOver: No,
    style: ko
  });
}
const GridScrollArea = fastMemo(GridScrollAreaRaw);
var reactMajor = {}, interopRequireWildcard = { exports: {} }, _typeof$J = { exports: {} };
(function(Kt) {
  function uo(ho) {
    "@babel/helpers - typeof";
    return Kt.exports = uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(go) {
      return typeof go;
    } : function(go) {
      return go && typeof Symbol == "function" && go.constructor === Symbol && go !== Symbol.prototype ? "symbol" : typeof go;
    }, Kt.exports.__esModule = !0, Kt.exports.default = Kt.exports, uo(ho);
  }
  Kt.exports = uo, Kt.exports.__esModule = !0, Kt.exports.default = Kt.exports;
})(_typeof$J);
var _typeofExports = _typeof$J.exports;
(function(Kt) {
  var uo = _typeofExports.default;
  function ho(bo) {
    if (typeof WeakMap != "function") return null;
    var vo = /* @__PURE__ */ new WeakMap(), Po = /* @__PURE__ */ new WeakMap();
    return (ho = function(So) {
      return So ? Po : vo;
    })(bo);
  }
  function go(bo, vo) {
    if (!vo && bo && bo.__esModule) return bo;
    if (bo === null || uo(bo) != "object" && typeof bo != "function") return {
      default: bo
    };
    var Po = ho(vo);
    if (Po && Po.has(bo)) return Po.get(bo);
    var Co = {
      __proto__: null
    }, So = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var wo in bo) if (wo !== "default" && {}.hasOwnProperty.call(bo, wo)) {
      var Eo = So ? Object.getOwnPropertyDescriptor(bo, wo) : null;
      Eo && (Eo.get || Eo.set) ? Object.defineProperty(Co, wo, Eo) : Co[wo] = bo[wo];
    }
    return Co.default = bo, Po && Po.set(bo, Co), Co;
  }
  Kt.exports = go, Kt.exports.__esModule = !0, Kt.exports.default = Kt.exports;
})(interopRequireWildcard);
var interopRequireWildcardExports = interopRequireWildcard.exports, _interopRequireWildcard = interopRequireWildcardExports.default;
Object.defineProperty(reactMajor, "__esModule", {
  value: !0
});
var default_1 = reactMajor.default = void 0, React = _interopRequireWildcard(React__default);
default_1 = reactMajor.default = parseInt(React.version, 10);
const GridPrivateApiContext = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (GridPrivateApiContext.displayName = "GridPrivateApiContext");
function useGridPrivateApiContext() {
  const Kt = React$1.useContext(GridPrivateApiContext);
  if (Kt === void 0)
    throw new Error(["MUI X: Could not find the Data Grid private context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return Kt;
}
const getVisibleRows = (Kt, uo) => {
  let ho, go;
  return uo.pagination && uo.paginationMode === "client" ? (go = gridPaginationRowRangeSelector(Kt), ho = gridPaginatedVisibleSortedGridRowEntriesSelector(Kt)) : (ho = gridExpandedSortedRowEntriesSelector(Kt), ho.length === 0 ? go = null : go = {
    firstRowIndex: 0,
    lastRowIndex: ho.length - 1
  }), {
    rows: ho,
    range: go
  };
}, useGridVisibleRows = (Kt, uo) => {
  const ho = getVisibleRows(Kt, uo);
  return React$1.useMemo(() => ({
    rows: ho.rows,
    range: ho.range
  }), [ho.rows, ho.range]);
}, userAgent = typeof navigator < "u" ? navigator.userAgent.toLowerCase() : "empty", isFirefox = userAgent.includes("firefox"), gridRowsMetaSelector = (Kt) => Kt.rowsMeta, gridVirtualizationSelector = (Kt) => Kt.virtualization;
createSelector(gridVirtualizationSelector, (Kt) => Kt.enabled);
const gridVirtualizationColumnEnabledSelector = createSelector(gridVirtualizationSelector, (Kt) => Kt.enabledForColumns), gridVirtualizationRowEnabledSelector = createSelector(gridVirtualizationSelector, (Kt) => Kt.enabledForRows), gridRenderContextSelector = createSelector(gridVirtualizationSelector, (Kt) => Kt.renderContext), gridRenderContextColumnsSelector = createSelectorMemoized((Kt) => Kt.virtualization.renderContext.firstColumnIndex, (Kt) => Kt.virtualization.renderContext.lastColumnIndex, (Kt, uo) => ({
  firstColumnIndex: Kt,
  lastColumnIndex: uo
})), EMPTY_RENDER_CONTEXT = {
  firstRowIndex: 0,
  lastRowIndex: 0,
  firstColumnIndex: 0,
  lastColumnIndex: 0
}, virtualizationStateInitializer = (Kt, uo) => {
  const {
    disableVirtualization: ho,
    autoHeight: go
  } = uo;
  return _extends$q({}, Kt, {
    virtualization: {
      enabled: !ho,
      enabledForColumns: !ho,
      enabledForRows: !ho && !go,
      renderContext: EMPTY_RENDER_CONTEXT
    }
  });
};
function useGridVirtualization(Kt, uo) {
  const ho = (vo) => {
    Kt.current.setState((Po) => _extends$q({}, Po, {
      virtualization: _extends$q({}, Po.virtualization, {
        enabled: vo,
        enabledForColumns: vo,
        enabledForRows: vo && !uo.autoHeight
      })
    }));
  };
  useGridApiMethod(Kt, {
    unstable_setVirtualization: ho,
    unstable_setColumnVirtualization: (vo) => {
      Kt.current.setState((Po) => _extends$q({}, Po, {
        virtualization: _extends$q({}, Po.virtualization, {
          enabledForColumns: vo
        })
      }));
    }
  }, "public"), React$1.useEffect(() => {
    ho(!uo.disableVirtualization);
  }, [uo.disableVirtualization, uo.autoHeight]);
}
const gridRowSpanningStateSelector = (Kt) => Kt.rowSpanning, gridRowSpanningHiddenCellsSelector = createSelector(gridRowSpanningStateSelector, (Kt) => Kt.hiddenCells), gridRowSpanningSpannedCellsSelector = createSelector(gridRowSpanningStateSelector, (Kt) => Kt.spannedCells), gridRowSpanningHiddenCellsOriginMapSelector = createSelector(gridRowSpanningStateSelector, (Kt) => Kt.hiddenCellOriginMap), gridListColumnSelector = (Kt) => Kt.listViewColumn, MINIMUM_COLUMN_WIDTH = 50;
var ScrollDirection = /* @__PURE__ */ function(Kt) {
  return Kt[Kt.NONE = 0] = "NONE", Kt[Kt.UP = 1] = "UP", Kt[Kt.DOWN = 2] = "DOWN", Kt[Kt.LEFT = 3] = "LEFT", Kt[Kt.RIGHT = 4] = "RIGHT", Kt;
}(ScrollDirection || {});
const EMPTY_SCROLL_POSITION = {
  top: 0,
  left: 0
}, EMPTY_DETAIL_PANELS = Object.freeze(/* @__PURE__ */ new Map()), createScrollCache = (Kt, uo, ho, go, bo) => ({
  direction: ScrollDirection.NONE,
  buffer: bufferForDirection(Kt, ScrollDirection.NONE, uo, ho, go, bo)
});
let isJSDOM = !1;
try {
  typeof window < "u" && (isJSDOM = /jsdom|HappyDOM/.test(window.navigator.userAgent));
} catch {
}
const useGridVirtualScroller = () => {
  const Kt = useGridPrivateApiContext(), uo = useGridRootProps(), {
    unstable_listView: ho
  } = uo, go = useGridSelector(Kt, () => ho ? [gridListColumnSelector(Kt.current.state)] : gridVisibleColumnDefinitionsSelector(Kt)), bo = useGridSelector(Kt, gridVirtualizationRowEnabledSelector) && !isJSDOM, vo = useGridSelector(Kt, gridVirtualizationColumnEnabledSelector) && !isJSDOM, Po = useGridSelector(Kt, gridDimensionsSelector), Co = Po.viewportOuterSize, So = useGridSelector(Kt, gridPinnedRowsSelector), wo = useGridSelector(Kt, gridVisiblePinnedColumnDefinitionsSelector), Eo = ho ? {
    left: [],
    right: []
  } : wo, Ro = So.bottom.length > 0, [_o, Io] = React$1.useState(EMPTY_DETAIL_PANELS), Ao = useRtl(), Oo = useGridSelector(Kt, gridFocusCellSelector), jo = useGridSelector(Kt, gridTabIndexCellSelector), Do = useGridSelector(Kt, gridRowsMetaSelector), Lo = useGridSelector(Kt, selectedIdsLookupSelector), ko = useGridVisibleRows(Kt, uo), Ko = Kt.current.rootElementRef, No = Kt.current.mainElementRef, Jo = Kt.current.virtualScrollerRef, ti = Kt.current.virtualScrollbarVerticalRef, oi = Kt.current.virtualScrollbarHorizontalRef, Qo = Po.contentSize.height, Zo = Po.columnsTotalWidth, ei = useGridSelector(Kt, gridHasColSpanSelector), ii = React$1.useCallback((wi) => {
    if (No.current = wi, !wi)
      return;
    const gi = wi.getBoundingClientRect();
    let Ri = roundDimensions(gi);
    if (Kt.current.publishEvent("resize", Ri), typeof ResizeObserver > "u")
      return;
    const Ei = new ResizeObserver((Ni) => {
      const Ai = Ni[0];
      if (!Ai)
        return;
      const Yi = roundDimensions(Ai.contentRect);
      Yi.width === Ri.width && Yi.height === Ri.height || (Kt.current.publishEvent("resize", Yi), Ri = Yi);
    });
    if (Ei.observe(wi), default_1 >= 19)
      return () => {
        No.current = null, Ei.disconnect();
      };
  }, [Kt, No]), ai = React$1.useRef(EMPTY_SCROLL_POSITION), ri = React$1.useRef(EMPTY_SCROLL_POSITION), ni = React$1.useRef(EMPTY_RENDER_CONTEXT), si = useGridSelector(Kt, gridRenderContextSelector), li = useTimeout(), ui = React$1.useRef(void 0), ci = useLazyRef(() => createScrollCache(Ao, uo.rowBufferPx, uo.columnBufferPx, Po.rowHeight * 15, MINIMUM_COLUMN_WIDTH * 6)).current, fi = {
    rowIndex: React$1.useMemo(() => Oo ? ko.rows.findIndex((wi) => wi.id === Oo.id) : -1, [Oo, ko.rows]),
    columnIndex: React$1.useMemo(() => Oo ? go.findIndex((wi) => wi.field === Oo.field) : -1, [Oo, go])
  }, yi = React$1.useCallback((wi) => {
    if (areRenderContextsEqual(wi, Kt.current.state.virtualization.renderContext))
      return;
    const gi = wi.firstRowIndex !== ni.current.firstRowIndex || wi.lastRowIndex !== ni.current.lastRowIndex;
    Kt.current.setState((Ri) => _extends$q({}, Ri, {
      virtualization: _extends$q({}, Ri.virtualization, {
        renderContext: wi
      })
    })), Po.isReady && gi && (ni.current = wi, Kt.current.publishEvent("renderedRowsIntervalChange", wi)), ri.current = ai.current;
  }, [Kt, Po.isReady]), hi = useEventCallback(() => {
    const wi = Jo.current;
    if (!wi)
      return;
    const gi = {
      top: wi.scrollTop,
      left: wi.scrollLeft
    }, Ri = gi.left - ai.current.left, Ei = gi.top - ai.current.top, Ni = Ri !== 0 || Ei !== 0;
    ai.current = gi;
    const Ai = Ni ? directionForDelta(Ri, Ei) : ScrollDirection.NONE, Yi = Math.abs(ai.current.top - ri.current.top), Ui = Math.abs(ai.current.left - ri.current.left), us = Yi >= Po.rowHeight || Ui >= MINIMUM_COLUMN_WIDTH, ns = ci.direction !== Ai;
    if (!(us || ns))
      return si;
    if (ns)
      switch (Ai) {
        case ScrollDirection.NONE:
        case ScrollDirection.LEFT:
        case ScrollDirection.RIGHT:
          ui.current = void 0;
          break;
        default:
          ui.current = si;
          break;
      }
    ci.direction = Ai, ci.buffer = bufferForDirection(Ao, Ai, uo.rowBufferPx, uo.columnBufferPx, Po.rowHeight * 15, MINIMUM_COLUMN_WIDTH * 6);
    const _i = inputsSelector(Kt, uo, bo, vo), Vi = computeRenderContext(_i, ai.current, ci);
    return ReactDOM.flushSync(() => {
      yi(Vi);
    }), li.start(1e3, hi), Vi;
  }), mi = () => {
    const wi = inputsSelector(Kt, uo, bo, vo), gi = computeRenderContext(wi, ai.current, ci);
    ui.current = void 0, yi(gi);
  }, bi = useEventCallback((wi) => {
    const {
      scrollTop: gi,
      scrollLeft: Ri
    } = wi.currentTarget;
    if (gi < 0 || !Ao && Ri < 0 || Ao && Ri > 0)
      return;
    const Ei = hi();
    Kt.current.publishEvent("scrollPositionChange", {
      top: gi,
      left: Ri,
      renderContext: Ei
    });
  }), xi = useEventCallback((wi) => {
    Kt.current.publishEvent("virtualScrollerWheel", {}, wi);
  }), $i = useEventCallback((wi) => {
    Kt.current.publishEvent("virtualScrollerTouchMove", {}, wi);
  }), Ci = (wi = {}) => {
    var Bi;
    if (!wi.rows && !ko.range)
      return [];
    const gi = wi.renderContext ?? si, Ri = !Ro && wi.position === void 0 || Ro && wi.position === "bottom", Ei = wi.position !== void 0;
    let Ni;
    switch (wi.position) {
      case "top":
        Ni = 0;
        break;
      case "bottom":
        Ni = So.top.length + ko.rows.length;
        break;
      case void 0:
        Ni = So.top.length;
        break;
    }
    const Ai = wi.rows ?? ko.rows, Yi = gi.firstRowIndex, Ui = Math.min(gi.lastRowIndex, Ai.length), us = wi.rows ? range$5(0, wi.rows.length) : range$5(Yi, Ui);
    let ns = -1;
    !Ei && fi.rowIndex !== -1 && (fi.rowIndex < Yi && (ns = fi.rowIndex, us.unshift(ns)), fi.rowIndex >= Ui && (ns = fi.rowIndex, us.push(ns)));
    const Ti = [], _i = (Bi = uo.slotProps) == null ? void 0 : Bi.row, Vi = gridColumnPositionsSelector(Kt);
    return us.forEach((Ji) => {
      var Ws, Hs, Ks;
      const {
        id: Ki,
        model: qi
      } = Ai[Ji], rs = (((Ws = ko == null ? void 0 : ko.range) == null ? void 0 : Ws.firstRowIndex) || 0) + Ni + Ji;
      if (ei) {
        const zs = Eo.left.length, Ys = go.length - Eo.right.length;
        Kt.current.calculateColSpan({
          rowId: Ki,
          minFirstColumn: zs,
          maxLastColumn: Ys,
          columns: go
        }), Eo.left.length > 0 && Kt.current.calculateColSpan({
          rowId: Ki,
          minFirstColumn: 0,
          maxLastColumn: Eo.left.length,
          columns: go
        }), Eo.right.length > 0 && Kt.current.calculateColSpan({
          rowId: Ki,
          minFirstColumn: go.length - Eo.right.length,
          maxLastColumn: go.length,
          columns: go
        });
      }
      const os = (Oo == null ? void 0 : Oo.id) === Ki, ps = Kt.current.rowHasAutoHeight(Ki) ? "auto" : Kt.current.unstable_getRowHeight(Ki);
      let Mi;
      Lo[Ki] == null ? Mi = !1 : Mi = Kt.current.isRowSelectable(Ki);
      let Wi = !1;
      wi.position === void 0 && (Wi = Ji === 0);
      let Hi = !1;
      const Xi = Ji === Ai.length - 1;
      if (Ri)
        if (Ei)
          Hi = Xi;
        else {
          const zs = ko.rows.length - 1;
          Ji === zs && (Hi = !0);
        }
      const zi = Ji === ns;
      let cs = null;
      jo !== null && jo.id === Ki && (cs = Kt.current.getCellParams(Ki, jo.field).cellMode === "view" ? jo.field : null);
      let ys = gi;
      !Ei && ui.current && Ji >= ui.current.firstRowIndex && Ji < ui.current.lastRowIndex && (ys = ui.current);
      const $s = computeOffsetLeft(Vi, ys, Eo.left.length), Ns = Xi && wi.position === "top";
      if (Ti.push(/* @__PURE__ */ jsxRuntimeExports.jsx(uo.slots.row, _extends$q({
        row: qi,
        rowId: Ki,
        index: rs,
        selected: Mi,
        offsetTop: wi.rows ? void 0 : Do.positions[Ji],
        offsetLeft: $s,
        dimensions: Po,
        rowHeight: ps,
        tabbableCell: cs,
        pinnedColumns: Eo,
        visibleColumns: go,
        renderContext: ys,
        focusedColumnIndex: os ? fi.columnIndex : void 0,
        isFirstVisible: Wi,
        isLastVisible: Hi,
        isNotVisible: zi,
        showBottomBorder: Ns
      }, _i), Ki)), zi)
        return;
      const Bs = _o.get(Ki);
      Bs && Ti.push(Bs), wi.position === void 0 && Xi && Ti.push((Ks = (Hs = Kt.current).getInfiniteLoadingTriggerElement) == null ? void 0 : Ks.call(Hs, {
        lastRowId: Ki
      }));
    }), Ti;
  }, Si = Co.width && Zo > Co.width, vi = React$1.useMemo(() => ({
    overflowX: !Si || ho ? "hidden" : void 0,
    overflowY: uo.autoHeight ? "hidden" : void 0
  }), [Si, uo.autoHeight, ho]), Pi = React$1.useMemo(() => {
    const wi = {
      width: Si ? Zo : "auto",
      flexBasis: Qo,
      flexShrink: 0
    };
    return wi.flexBasis === 0 && (wi.flexBasis = minimalContentHeight), wi;
  }, [Zo, Qo, Si]);
  return React$1.useEffect(() => {
    Kt.current.publishEvent("virtualScrollerContentSizeChange");
  }, [Kt, Pi]), useEnhancedEffect(() => {
    vo && (Jo.current.scrollLeft = 0), bo && (Jo.current.scrollTop = 0);
  }, [vo, bo, Ko, Jo]), useEnhancedEffect(() => {
    ho && (Jo.current.scrollLeft = 0);
  }, [ho, Jo]), useRunOnce(Co.width !== 0, () => {
    const wi = inputsSelector(Kt, uo, bo, vo), gi = computeRenderContext(wi, ai.current, ci);
    yi(gi), Kt.current.publishEvent("scrollPositionChange", {
      top: ai.current.top,
      left: ai.current.left,
      renderContext: gi
    });
  }), Kt.current.register("private", {
    updateRenderContext: mi
  }), useGridApiEventHandler(Kt, "columnsChange", mi), useGridApiEventHandler(Kt, "filteredRowsSet", mi), useGridApiEventHandler(Kt, "rowExpansionChange", mi), {
    renderContext: si,
    setPanels: Io,
    getRows: Ci,
    getContainerProps: () => ({
      ref: ii
    }),
    getScrollerProps: () => ({
      ref: Jo,
      onScroll: bi,
      onWheel: xi,
      onTouchMove: $i,
      style: vi,
      role: "presentation",
      // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
      // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
      tabIndex: isFirefox ? -1 : void 0
    }),
    getContentProps: () => ({
      style: Pi,
      role: "presentation"
    }),
    getRenderZoneProps: () => ({
      role: "rowgroup"
    }),
    getScrollbarVerticalProps: () => ({
      ref: ti,
      role: "presentation"
    }),
    getScrollbarHorizontalProps: () => ({
      ref: oi,
      role: "presentation"
    })
  };
};
function inputsSelector(Kt, uo, ho, go) {
  const bo = gridDimensionsSelector(Kt.current.state), vo = getVisibleRows(Kt, uo), Po = uo.unstable_listView ? [gridListColumnSelector(Kt.current.state)] : gridVisibleColumnDefinitionsSelector(Kt), Co = gridRowSpanningHiddenCellsOriginMapSelector(Kt), So = Kt.current.state.rows.dataRowIds.at(-1), wo = Po.at(-1);
  return {
    enabledForRows: ho,
    enabledForColumns: go,
    apiRef: Kt,
    autoHeight: uo.autoHeight,
    rowBufferPx: uo.rowBufferPx,
    columnBufferPx: uo.columnBufferPx,
    leftPinnedWidth: bo.leftPinnedWidth,
    columnsTotalWidth: bo.columnsTotalWidth,
    viewportInnerWidth: bo.viewportInnerSize.width,
    viewportInnerHeight: bo.viewportInnerSize.height,
    lastRowHeight: So !== void 0 ? Kt.current.unstable_getRowHeight(So) : 0,
    lastColumnWidth: (wo == null ? void 0 : wo.computedWidth) ?? 0,
    rowsMeta: gridRowsMetaSelector(Kt.current.state),
    columnPositions: gridColumnPositionsSelector(Kt),
    rows: vo.rows,
    range: vo.range,
    pinnedColumns: gridVisiblePinnedColumnDefinitionsSelector(Kt),
    visibleColumns: Po,
    hiddenCellsOriginMap: Co,
    listView: uo.unstable_listView ?? !1,
    virtualizeColumnsWithAutoRowHeight: uo.virtualizeColumnsWithAutoRowHeight
  };
}
function computeRenderContext(Kt, uo, ho) {
  const go = {
    firstRowIndex: 0,
    lastRowIndex: Kt.rows.length,
    firstColumnIndex: 0,
    lastColumnIndex: Kt.visibleColumns.length
  }, {
    top: bo,
    left: vo
  } = uo, Po = Math.abs(vo) + Kt.leftPinnedWidth;
  if (Kt.enabledForRows) {
    let So = Math.min(getNearestIndexToRender(Kt, bo, {
      atStart: !0,
      lastPosition: Kt.rowsMeta.positions[Kt.rowsMeta.positions.length - 1] + Kt.lastRowHeight
    }), Kt.rowsMeta.positions.length - 1);
    const wo = Kt.hiddenCellsOriginMap[So];
    if (wo) {
      const Ro = Math.min(...Object.values(wo));
      So = Math.min(So, Ro);
    }
    const Eo = Kt.autoHeight ? So + Kt.rows.length : getNearestIndexToRender(Kt, bo + Kt.viewportInnerHeight);
    go.firstRowIndex = So, go.lastRowIndex = Eo;
  }
  if (Kt.enabledForColumns) {
    let So = 0, wo = Kt.columnPositions.length, Eo = !1;
    const [Ro, _o] = getIndexesToRender({
      firstIndex: go.firstRowIndex,
      lastIndex: go.lastRowIndex,
      minFirstIndex: 0,
      maxLastIndex: Kt.rows.length,
      bufferBefore: ho.buffer.rowBefore,
      bufferAfter: ho.buffer.rowAfter,
      positions: Kt.rowsMeta.positions,
      lastSize: Kt.lastRowHeight
    });
    if (!Kt.virtualizeColumnsWithAutoRowHeight)
      for (let Io = Ro; Io < _o && !Eo; Io += 1) {
        const Ao = Kt.rows[Io];
        Eo = Kt.apiRef.current.rowHasAutoHeight(Ao.id);
      }
    (!Eo || Kt.virtualizeColumnsWithAutoRowHeight) && (So = binarySearch(Po, Kt.columnPositions, {
      atStart: !0,
      lastPosition: Kt.columnsTotalWidth
    }), wo = binarySearch(Po + Kt.viewportInnerWidth, Kt.columnPositions)), go.firstColumnIndex = So, go.lastColumnIndex = wo;
  }
  return deriveRenderContext(Kt, go, ho);
}
function getNearestIndexToRender(Kt, uo, ho) {
  var Po, Co;
  const go = Kt.apiRef.current.getLastMeasuredRowIndex();
  let bo = go === 1 / 0;
  (Po = Kt.range) != null && Po.lastRowIndex && !bo && (bo = go >= Kt.range.lastRowIndex);
  const vo = clamp$1(go - (((Co = Kt.range) == null ? void 0 : Co.firstRowIndex) || 0), 0, Kt.rowsMeta.positions.length);
  return bo || Kt.rowsMeta.positions[vo] >= uo ? binarySearch(uo, Kt.rowsMeta.positions, ho) : exponentialSearch(uo, Kt.rowsMeta.positions, vo, ho);
}
function deriveRenderContext(Kt, uo, ho) {
  const [go, bo] = getIndexesToRender({
    firstIndex: uo.firstRowIndex,
    lastIndex: uo.lastRowIndex,
    minFirstIndex: 0,
    maxLastIndex: Kt.rows.length,
    bufferBefore: ho.buffer.rowBefore,
    bufferAfter: ho.buffer.rowAfter,
    positions: Kt.rowsMeta.positions,
    lastSize: Kt.lastRowHeight
  }), [vo, Po] = getIndexesToRender({
    firstIndex: uo.firstColumnIndex,
    lastIndex: uo.lastColumnIndex,
    minFirstIndex: Kt.pinnedColumns.left.length,
    maxLastIndex: Kt.visibleColumns.length - Kt.pinnedColumns.right.length,
    bufferBefore: ho.buffer.columnBefore,
    bufferAfter: ho.buffer.columnAfter,
    positions: Kt.columnPositions,
    lastSize: Kt.lastColumnWidth
  }), Co = getFirstNonSpannedColumnToRender({
    firstColumnToRender: vo,
    apiRef: Kt.apiRef,
    firstRowToRender: go,
    lastRowToRender: bo,
    visibleRows: Kt.rows
  });
  return {
    firstRowIndex: go,
    lastRowIndex: bo,
    firstColumnIndex: Co,
    lastColumnIndex: Po
  };
}
function binarySearch(Kt, uo, ho = void 0, go = 0, bo = uo.length) {
  if (uo.length <= 0)
    return -1;
  if (go >= bo)
    return go;
  const vo = go + Math.floor((bo - go) / 2), Po = uo[vo];
  let Co;
  if (ho != null && ho.atStart) {
    const So = (vo === uo.length - 1 ? ho.lastPosition : uo[vo + 1]) - Po;
    Co = Kt - So < Po;
  } else
    Co = Kt <= Po;
  return Co ? binarySearch(Kt, uo, ho, go, vo) : binarySearch(Kt, uo, ho, vo + 1, bo);
}
function exponentialSearch(Kt, uo, ho, go = void 0) {
  let bo = 1;
  for (; ho < uo.length && Math.abs(uo[ho]) < Kt; )
    ho += bo, bo *= 2;
  return binarySearch(Kt, uo, go, Math.floor(ho / 2), Math.min(ho, uo.length));
}
function getIndexesToRender({
  firstIndex: Kt,
  lastIndex: uo,
  bufferBefore: ho,
  bufferAfter: go,
  minFirstIndex: bo,
  maxLastIndex: vo,
  positions: Po,
  lastSize: Co
}) {
  const So = Po[Kt] - ho, wo = Po[uo] + go, Eo = binarySearch(So, Po, {
    atStart: !0,
    lastPosition: Po[Po.length - 1] + Co
  }), Ro = binarySearch(wo, Po);
  return [clamp$1(Eo, bo, vo), clamp$1(Ro, bo, vo)];
}
function areRenderContextsEqual(Kt, uo) {
  return Kt === uo ? !0 : Kt.firstRowIndex === uo.firstRowIndex && Kt.lastRowIndex === uo.lastRowIndex && Kt.firstColumnIndex === uo.firstColumnIndex && Kt.lastColumnIndex === uo.lastColumnIndex;
}
function computeOffsetLeft(Kt, uo, ho) {
  const go = (Kt[uo.firstColumnIndex] ?? 0) - (Kt[ho] ?? 0);
  return Math.abs(go);
}
function directionForDelta(Kt, uo) {
  return Kt === 0 && uo === 0 ? ScrollDirection.NONE : Math.abs(uo) >= Math.abs(Kt) ? uo > 0 ? ScrollDirection.DOWN : ScrollDirection.UP : Kt > 0 ? ScrollDirection.RIGHT : ScrollDirection.LEFT;
}
function bufferForDirection(Kt, uo, ho, go, bo, vo) {
  if (Kt)
    switch (uo) {
      case ScrollDirection.LEFT:
        uo = ScrollDirection.RIGHT;
        break;
      case ScrollDirection.RIGHT:
        uo = ScrollDirection.LEFT;
        break;
    }
  switch (uo) {
    case ScrollDirection.NONE:
      return {
        rowAfter: ho,
        rowBefore: ho,
        columnAfter: go,
        columnBefore: go
      };
    case ScrollDirection.LEFT:
      return {
        rowAfter: 0,
        rowBefore: 0,
        columnAfter: 0,
        columnBefore: vo
      };
    case ScrollDirection.RIGHT:
      return {
        rowAfter: 0,
        rowBefore: 0,
        columnAfter: vo,
        columnBefore: 0
      };
    case ScrollDirection.UP:
      return {
        rowAfter: 0,
        rowBefore: bo,
        columnAfter: 0,
        columnBefore: 0
      };
    case ScrollDirection.DOWN:
      return {
        rowAfter: bo,
        rowBefore: 0,
        columnAfter: 0,
        columnBefore: 0
      };
    default:
      throw new Error("unreachable");
  }
}
function roundDimensions(Kt) {
  return {
    width: Math.round(Kt.width * 10) / 10,
    height: Math.round(Kt.height * 10) / 10
  };
}
const useGridOverlays = () => {
  var Ro, _o;
  const Kt = useGridApiContext(), uo = useGridRootProps(), ho = useGridSelector(Kt, gridRowCountSelector), go = useGridSelector(Kt, gridExpandedRowCountSelector), bo = useGridSelector(Kt, gridPinnedRowsCountSelector), vo = ho === 0 && bo === 0, Po = useGridSelector(Kt, gridRowsLoadingSelector), Co = !Po && vo, So = !Po && ho > 0 && go === 0;
  let wo = null, Eo = null;
  return Co && (wo = "noRowsOverlay"), So && (wo = "noResultsOverlay"), Po && (wo = "loadingOverlay", Eo = ((_o = (Ro = uo.slotProps) == null ? void 0 : Ro.loadingOverlay) == null ? void 0 : _o[vo ? "noRowsVariant" : "variant"]) || null), {
    overlayType: wo,
    loadingOverlayVariant: Eo
  };
}, GridOverlayWrapperRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapper",
  shouldForwardProp: (Kt) => Kt !== "overlayType" && Kt !== "loadingOverlayVariant",
  overridesResolver: (Kt, uo) => uo.overlayWrapper
})(({
  overlayType: Kt,
  loadingOverlayVariant: uo
}) => (
  // Skeleton overlay should flow with the scroll container and not be sticky
  uo !== "skeleton" ? {
    position: "sticky",
    // To stay in place while scrolling
    top: "var(--DataGrid-headersTotalHeight)",
    // TODO: take pinned rows into account
    left: 0,
    width: 0,
    // To stay above the content instead of shifting it down
    height: 0,
    // To stay above the content instead of shifting it down
    zIndex: Kt === "loadingOverlay" ? 5 : 4
    // Should be above pinned columns and detail panel
  } : {}
)), GridOverlayWrapperInner = styled$1("div", {
  name: "MuiDataGrid",
  slot: "OverlayWrapperInner",
  shouldForwardProp: (Kt) => Kt !== "overlayType" && Kt !== "loadingOverlayVariant",
  overridesResolver: (Kt, uo) => uo.overlayWrapperInner
})({}), useUtilityClasses$16 = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["overlayWrapper"],
    inner: ["overlayWrapperInner"]
  }, getDataGridUtilityClass, uo);
};
function GridOverlayWrapper(Kt) {
  const uo = useGridApiContext(), ho = useGridRootProps(), go = useGridSelector(uo, gridDimensionsSelector);
  let bo = Math.max(go.viewportOuterSize.height - go.topContainerHeight - go.bottomContainerHeight - (go.hasScrollX ? go.scrollbarSize : 0), 0);
  bo === 0 && (bo = minimalContentHeight);
  const vo = useUtilityClasses$16(_extends$q({}, Kt, {
    classes: ho.classes
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlayWrapperRoot, _extends$q({
    className: clsx(vo.root)
  }, Kt, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlayWrapperInner, _extends$q({
      className: clsx(vo.inner),
      style: {
        height: bo,
        width: go.viewportOuterSize.width
      }
    }, Kt))
  }));
}
process.env.NODE_ENV !== "production" && (GridOverlayWrapper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  loadingOverlayVariant: PropTypes.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  overlayType: PropTypes.oneOf(["loadingOverlay", "noResultsOverlay", "noRowsOverlay"])
});
process.env.NODE_ENV !== "production" && (GridOverlays.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  loadingOverlayVariant: PropTypes.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  overlayType: PropTypes.oneOf(["loadingOverlay", "noResultsOverlay", "noRowsOverlay"])
});
function GridOverlays(Kt) {
  var vo, Po;
  const {
    overlayType: uo
  } = Kt, ho = useGridRootProps();
  if (!uo)
    return null;
  const go = (vo = ho.slots) == null ? void 0 : vo[uo], bo = (Po = ho.slotProps) == null ? void 0 : Po[uo];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlayWrapper, _extends$q({}, Kt, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(go, _extends$q({}, bo))
  }));
}
const gridColumnMenuSelector = (Kt) => Kt.columnMenu;
function GridHeaders() {
  var jo;
  const Kt = useGridPrivateApiContext(), uo = useGridRootProps(), ho = useGridSelector(Kt, gridVisibleColumnDefinitionsSelector), go = useGridSelector(Kt, gridFilterActiveItemsLookupSelector), bo = useGridSelector(Kt, gridSortColumnLookupSelector), vo = useGridSelector(Kt, gridTabIndexColumnHeaderSelector), Po = useGridSelector(Kt, gridTabIndexCellSelector), Co = useGridSelector(Kt, gridTabIndexColumnGroupHeaderSelector), So = useGridSelector(Kt, gridFocusColumnHeaderSelector), wo = useGridSelector(Kt, gridFocusColumnGroupHeaderSelector), Eo = useGridSelector(Kt, gridColumnGroupsHeaderMaxDepthSelector), Ro = useGridSelector(Kt, gridColumnMenuSelector), _o = useGridSelector(Kt, gridColumnVisibilityModelSelector), Io = useGridSelector(Kt, gridColumnGroupsHeaderStructureSelector), Ao = !(Co === null && vo === null && Po === null), Oo = Kt.current.columnHeadersContainerRef;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(uo.slots.columnHeaders, _extends$q({
    ref: Oo,
    visibleColumns: ho,
    filterColumnLookup: go,
    sortColumnLookup: bo,
    columnHeaderTabIndexState: vo,
    columnGroupHeaderTabIndexState: Co,
    columnHeaderFocus: So,
    columnGroupHeaderFocus: wo,
    headerGroupingMaxDepth: Eo,
    columnMenuState: Ro,
    columnVisibility: _o,
    columnGroupsHeaderStructure: Io,
    hasOtherElementInTabSequence: Ao
  }, (jo = uo.slotProps) == null ? void 0 : jo.columnHeaders));
}
const MemoizedGridHeaders = fastMemo(GridHeaders), GridConfigurationContext = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (GridConfigurationContext.displayName = "GridConfigurationContext");
const useGridConfiguration = () => {
  const Kt = React$1.useContext(GridConfigurationContext);
  if (Kt === void 0)
    throw new Error(["MUI X: Could not find the Data Grid configuration context.", "It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.", "This can also happen if you are bundling multiple versions of the Data Grid."].join(`
`));
  return Kt;
}, GridPanelAnchor = styled$1("div")({
  position: "absolute",
  top: "var(--DataGrid-headersTotalHeight)",
  left: 0,
  width: "calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))"
}), Element$3 = styled$1("div", {
  name: "MuiDataGrid",
  slot: "Main",
  overridesResolver: (Kt, uo) => uo.main
})({
  flexGrow: 1,
  position: "relative",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column"
}), GridMainContainer = forwardRef((Kt, uo) => {
  var vo;
  const ho = useGridRootProps(), bo = useGridConfiguration().hooks.useGridAriaAttributes();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Element$3, _extends$q({
    ownerState: ho,
    className: Kt.className,
    tabIndex: -1
  }, bo, (vo = ho.slotProps) == null ? void 0 : vo.main, {
    ref: uo,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(GridPanelAnchor, {
      role: "presentation",
      "data-id": "gridPanelAnchor"
    }), Kt.children]
  }));
}), useUtilityClasses$15 = () => composeClasses({
  root: ["topContainer"]
}, getDataGridUtilityClass, {}), Element$2 = styled$1("div")({
  position: "sticky",
  zIndex: 4,
  top: 0
});
function GridTopContainer(Kt) {
  const uo = useUtilityClasses$15();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Element$2, _extends$q({}, Kt, {
    className: clsx(uo.root, gridClasses["container--top"]),
    role: "presentation"
  }));
}
const useUtilityClasses$14 = () => composeClasses({
  root: ["bottomContainer"]
}, getDataGridUtilityClass, {}), Element$1 = styled$1("div")({
  position: "sticky",
  zIndex: 4,
  bottom: "calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))"
});
function GridBottomContainer(Kt) {
  const uo = useUtilityClasses$14();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Element$1, _extends$q({}, Kt, {
    className: clsx(uo.root, gridClasses["container--bottom"]),
    role: "presentation"
  }));
}
const useUtilityClasses$13 = (Kt, uo) => {
  const {
    classes: ho
  } = Kt;
  return composeClasses({
    root: ["virtualScrollerContent", uo && "virtualScrollerContent--overflowed"]
  }, getDataGridUtilityClass, ho);
}, VirtualScrollerContentRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerContent",
  overridesResolver: (Kt, uo) => uo.virtualScrollerContent
})({}), GridVirtualScrollerContent = forwardRef(function(uo, ho) {
  var Po;
  const go = useGridRootProps(), bo = !go.autoHeight && ((Po = uo.style) == null ? void 0 : Po.minHeight) === "auto", vo = useUtilityClasses$13(go, bo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VirtualScrollerContentRoot, _extends$q({}, uo, {
    ownerState: go,
    className: clsx(vo.root, uo.className),
    ref: ho
  }));
}), Filler = styled$1("div")({
  display: "flex",
  flexDirection: "row",
  width: "var(--DataGrid-rowWidth)",
  boxSizing: "border-box"
}), Pinned = styled$1("div")({
  position: "sticky",
  height: "100%",
  boxSizing: "border-box",
  borderTop: "1px solid var(--rowBorderColor)",
  backgroundColor: "var(--DataGrid-pinnedBackground)"
}), PinnedLeft = styled$1(Pinned)({
  left: 0,
  borderRight: "1px solid var(--rowBorderColor)"
}), PinnedRight = styled$1(Pinned)({
  right: 0,
  borderLeft: "1px solid var(--rowBorderColor)"
}), Main = styled$1("div")({
  flexGrow: 1,
  borderTop: "1px solid var(--rowBorderColor)"
});
function GridVirtualScrollerFiller({
  rowsLength: Kt
}) {
  const uo = useGridApiContext(), {
    viewportOuterSize: ho,
    minimumSize: go,
    hasScrollX: bo,
    hasScrollY: vo,
    scrollbarSize: Po,
    leftPinnedWidth: Co,
    rightPinnedWidth: So
  } = useGridSelector(uo, gridDimensionsSelector), wo = bo ? Po : 0, Eo = ho.height - go.height > 0;
  return wo === 0 && !Eo ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(Filler, {
    className: gridClasses.filler,
    role: "presentation",
    style: {
      height: wo,
      "--rowBorderColor": Kt === 0 ? "transparent" : "var(--DataGrid-rowBorderColor)"
    },
    children: [Co > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(PinnedLeft, {
      className: gridClasses["filler--pinnedLeft"],
      style: {
        width: Co
      }
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Main, {}), So > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(PinnedRight, {
      className: gridClasses["filler--pinnedRight"],
      style: {
        width: So + (vo ? Po : 0)
      }
    })]
  });
}
const Memoized$2 = fastMemo(GridVirtualScrollerFiller), _excluded$M = ["className"], useUtilityClasses$12 = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["virtualScrollerRenderZone"]
  }, getDataGridUtilityClass, uo);
}, VirtualScrollerRenderZoneRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "VirtualScrollerRenderZone",
  overridesResolver: (Kt, uo) => uo.virtualScrollerRenderZone
})({
  position: "absolute",
  display: "flex",
  // Prevents margin collapsing when using `getRowSpacing`
  flexDirection: "column"
}), GridVirtualScrollerRenderZone = forwardRef(function(uo, ho) {
  const {
    className: go
  } = uo, bo = _objectWithoutPropertiesLoose$h(uo, _excluded$M), vo = useGridApiContext(), Po = useGridRootProps(), Co = useUtilityClasses$12(Po), So = useGridSelector(vo, () => {
    const wo = gridRenderContextSelector(vo);
    return gridRowsMetaSelector(vo.current.state).positions[wo.firstRowIndex] ?? 0;
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(VirtualScrollerRenderZoneRoot, _extends$q({
    className: clsx(Co.root, go),
    ownerState: Po,
    style: {
      transform: `translate3d(0, ${So}px, 0)`
    }
  }, bo, {
    ref: ho
  }));
}), DEFAULT_GRID_AUTOSIZE_OPTIONS = {
  includeHeaders: !0,
  includeOutliers: !1,
  outliersFactor: 1.5,
  expand: !1,
  disableColumnVirtualization: !0
}, gridEditRowsStateSelector = (Kt) => Kt.editRows, gridPreferencePanelStateSelector = (Kt) => Kt.preferencePanel;
var GridPreferencePanelsValue = /* @__PURE__ */ function(Kt) {
  return Kt.filters = "filters", Kt.columns = "columns", Kt;
}(GridPreferencePanelsValue || {});
const useUtilityClasses$11 = (Kt, uo) => {
  const {
    classes: ho
  } = Kt, go = {
    root: ["scrollbar", `scrollbar--${uo}`],
    content: ["scrollbarContent"]
  };
  return composeClasses(go, getDataGridUtilityClass, ho);
}, Scrollbar = styled$1("div")({
  position: "absolute",
  display: "inline-block",
  zIndex: 6,
  // In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
  // their size to be 0px throughout all the calculations, but the floating scrollbar container does need
  // to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
  // don't have a method to find the required size for scrollbars on those platforms.
  "--size": "calc(max(var(--DataGrid-scrollbarSize), 14px))"
}), ScrollbarVertical = styled$1(Scrollbar)({
  width: "var(--size)",
  height: "calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-topContainerHeight) - var(--DataGrid-bottomContainerHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))",
  overflowY: "auto",
  overflowX: "hidden",
  // Disable focus-visible style, it's a scrollbar.
  outline: 0,
  "& > div": {
    width: "var(--size)"
  },
  top: "var(--DataGrid-topContainerHeight)",
  right: "0px"
}), ScrollbarHorizontal = styled$1(Scrollbar)({
  width: "100%",
  height: "var(--size)",
  overflowY: "hidden",
  overflowX: "auto",
  // Disable focus-visible style, it's a scrollbar.
  outline: 0,
  "& > div": {
    height: "var(--size)"
  },
  bottom: "0px"
}), GridVirtualScrollbar = forwardRef(function(uo, ho) {
  const go = useGridPrivateApiContext(), bo = useGridRootProps(), vo = React$1.useRef(!1), Po = React$1.useRef(0), Co = React$1.useRef(null), So = React$1.useRef(null), wo = useUtilityClasses$11(bo, uo.position), Eo = useGridSelector(go, gridDimensionsSelector), Ro = uo.position === "vertical" ? "height" : "width", _o = uo.position === "vertical" ? "scrollTop" : "scrollLeft", Io = uo.position === "vertical" ? Eo.hasScrollX : Eo.hasScrollY, Ao = Eo.minimumSize[Ro] + (Io ? Eo.scrollbarSize : 0), jo = (uo.position === "vertical" ? Eo.viewportInnerSize.height : Eo.viewportOuterSize.width) * (Ao / Eo.viewportOuterSize[Ro]), Do = useEventCallback(() => {
    const Ko = go.current.virtualScrollerRef.current, No = Co.current;
    if (!No || Ko[_o] === Po.current)
      return;
    if (Po.current = Ko[_o], vo.current) {
      vo.current = !1;
      return;
    }
    vo.current = !0;
    const Jo = Ko[_o] / Ao;
    No[_o] = Jo * jo;
  }), Lo = useEventCallback(() => {
    const Ko = go.current.virtualScrollerRef.current, No = Co.current;
    if (!No)
      return;
    if (vo.current) {
      vo.current = !1;
      return;
    }
    vo.current = !0;
    const Jo = No[_o] / jo;
    Ko[_o] = Jo * Ao;
  });
  useOnMount(() => {
    const Ko = go.current.virtualScrollerRef.current, No = Co.current;
    return Ko.addEventListener("scroll", Do, {
      capture: !0
    }), No.addEventListener("scroll", Lo, {
      capture: !0
    }), () => {
      Ko.removeEventListener("scroll", Do, {
        capture: !0
      }), No.removeEventListener("scroll", Lo, {
        capture: !0
      });
    };
  }), React$1.useEffect(() => {
    So.current.style.setProperty(Ro, `${jo}px`);
  }, [jo, Ro]);
  const ko = uo.position === "vertical" ? ScrollbarVertical : ScrollbarHorizontal;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ko, {
    ref: useForkRef(ho, Co),
    className: wo.root,
    style: uo.position === "vertical" && bo.unstable_listView ? {
      height: "100%",
      top: 0
    } : void 0,
    tabIndex: -1,
    "aria-hidden": "true",
    children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      ref: So,
      className: wo.content
    })
  });
}), useUtilityClasses$10 = (Kt, uo, ho) => {
  const {
    classes: go
  } = Kt, bo = {
    root: ["main", uo.rightPinnedWidth > 0 && "main--hasPinnedRight", ho === "skeleton" && "main--hasSkeletonLoadingOverlay"],
    scroller: ["virtualScroller", uo.hasScrollX && "virtualScroller--hasScrollX"]
  };
  return composeClasses(bo, getDataGridUtilityClass, go);
}, Scroller = styled$1("div", {
  name: "MuiDataGrid",
  slot: "VirtualScroller",
  overridesResolver: (Kt, uo) => uo.virtualScroller
})({
  position: "relative",
  height: "100%",
  flexGrow: 1,
  overflow: "scroll",
  scrollbarWidth: "none",
  display: "flex",
  flexDirection: "column",
  "&::-webkit-scrollbar": {
    display: "none"
    /* Safari and Chrome */
  },
  "@media print": {
    overflow: "hidden"
  },
  // See https://github.com/mui/mui-x/issues/10547
  zIndex: 0
});
function GridVirtualScroller(Kt) {
  const uo = useGridApiContext(), ho = useGridRootProps(), go = useGridSelector(uo, gridDimensionsSelector), bo = useGridOverlays(), vo = useUtilityClasses$10(ho, go, bo.loadingOverlayVariant), Po = useGridVirtualScroller(), {
    getContainerProps: Co,
    getScrollerProps: So,
    getContentProps: wo,
    getRenderZoneProps: Eo,
    getScrollbarVerticalProps: Ro,
    getScrollbarHorizontalProps: _o,
    getRows: Io
  } = Po, Ao = Io();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridMainContainer, _extends$q({
    className: vo.root
  }, Co(), {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(GridScrollArea, {
      scrollDirection: "left"
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(GridScrollArea, {
      scrollDirection: "right"
    }), /* @__PURE__ */ jsxRuntimeExports.jsxs(Scroller, _extends$q({
      className: vo.scroller
    }, So(), {
      ownerState: ho,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(GridTopContainer, {
        children: [!ho.unstable_listView && /* @__PURE__ */ jsxRuntimeExports.jsx(MemoizedGridHeaders, {}), /* @__PURE__ */ jsxRuntimeExports.jsx(ho.slots.pinnedRows, {
          position: "top",
          virtualScroller: Po
        })]
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlays, _extends$q({}, bo)), /* @__PURE__ */ jsxRuntimeExports.jsx(GridVirtualScrollerContent, _extends$q({}, wo(), {
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(GridVirtualScrollerRenderZone, _extends$q({}, Eo(), {
          children: [Ao, /* @__PURE__ */ jsxRuntimeExports.jsx(ho.slots.detailPanels, {
            virtualScroller: Po
          })]
        }))
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(Memoized$2, {
        rowsLength: Ao.length
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(GridBottomContainer, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ho.slots.pinnedRows, {
          position: "bottom",
          virtualScroller: Po
        })
      })]
    })), go.hasScrollY && /* @__PURE__ */ jsxRuntimeExports.jsx(GridVirtualScrollbar, _extends$q({
      position: "vertical"
    }, Ro())), go.hasScrollX && !ho.unstable_listView && /* @__PURE__ */ jsxRuntimeExports.jsx(GridVirtualScrollbar, _extends$q({
      position: "horizontal"
    }, _o())), Kt.children]
  }));
}
function GridFooterPlaceholder() {
  var uo;
  const Kt = useGridRootProps();
  return Kt.hideFooter ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Kt.slots.footer, _extends$q(
    {},
    (uo = Kt.slotProps) == null ? void 0 : uo.footer
    /* FIXME: typing error */
  ));
}
let cachedSupportsPreventScroll;
function doesSupportPreventScroll() {
  return cachedSupportsPreventScroll === void 0 && document.createElement("div").focus({
    get preventScroll() {
      return cachedSupportsPreventScroll = !0, !1;
    }
  }), cachedSupportsPreventScroll;
}
const shouldCellShowRightBorder = (Kt, uo, ho, go, bo) => {
  const vo = uo === ho - 1;
  return Kt === GridPinnedColumnPosition.LEFT && vo ? !0 : go ? Kt === GridPinnedColumnPosition.LEFT ? !0 : Kt === GridPinnedColumnPosition.RIGHT ? !vo : !vo || bo : !1;
}, shouldCellShowLeftBorder = (Kt, uo) => Kt === GridPinnedColumnPosition.RIGHT && uo === 0, _excluded$L = ["column", "rowId", "editCellState", "align", "children", "colIndex", "width", "className", "style", "colSpan", "disableDragEvents", "isNotVisible", "pinnedOffset", "pinnedPosition", "sectionIndex", "sectionLength", "gridHasFiller", "onClick", "onDoubleClick", "onMouseDown", "onMouseUp", "onMouseOver", "onKeyDown", "onKeyUp", "onDragEnter", "onDragOver"], _excluded2$a = ["changeReason", "unstable_updateValueOnRender"];
let PinnedPosition = /* @__PURE__ */ function(Kt) {
  return Kt[Kt.NONE = 0] = "NONE", Kt[Kt.LEFT = 1] = "LEFT", Kt[Kt.RIGHT = 2] = "RIGHT", Kt[Kt.VIRTUAL = 3] = "VIRTUAL", Kt;
}({});
const gridPinnedColumnPositionLookup = {
  [PinnedPosition.LEFT]: GridPinnedColumnPosition.LEFT,
  [PinnedPosition.RIGHT]: GridPinnedColumnPosition.RIGHT,
  [PinnedPosition.NONE]: void 0,
  [PinnedPosition.VIRTUAL]: void 0
}, EMPTY_CELL_PARAMS = {
  id: -1,
  field: "__unset__",
  row: {},
  rowNode: {
    id: -1,
    depth: 0,
    type: "leaf",
    parent: -1,
    groupingKey: null
  },
  colDef: {
    type: "string",
    field: "__unset__",
    computedWidth: 0
  },
  cellMode: GridCellModes.View,
  hasFocus: !1,
  tabIndex: -1,
  value: null,
  formattedValue: "__unset__",
  isEditable: !1,
  api: {}
}, useUtilityClasses$$ = (Kt) => {
  const {
    align: uo,
    showLeftBorder: ho,
    showRightBorder: go,
    pinnedPosition: bo,
    isEditable: vo,
    isSelected: Po,
    isSelectionMode: Co,
    classes: So
  } = Kt, wo = {
    root: ["cell", `cell--text${capitalize(uo)}`, Po && "selected", vo && "cell--editable", ho && "cell--withLeftBorder", go && "cell--withRightBorder", bo === PinnedPosition.LEFT && "cell--pinnedLeft", bo === PinnedPosition.RIGHT && "cell--pinnedRight", Co && !vo && "cell--selectionMode"]
  };
  return composeClasses(wo, getDataGridUtilityClass, So);
};
let warnedOnce = !1;
const GridCell = forwardRef(function(uo, ho) {
  var Mi, Wi, Hi, Xi;
  const {
    column: go,
    rowId: bo,
    editCellState: vo,
    align: Po,
    colIndex: Co,
    width: So,
    className: wo,
    style: Eo,
    colSpan: Ro,
    disableDragEvents: _o,
    isNotVisible: Io,
    pinnedOffset: Ao,
    pinnedPosition: Oo,
    sectionIndex: jo,
    sectionLength: Do,
    gridHasFiller: Lo,
    onClick: ko,
    onDoubleClick: Ko,
    onMouseDown: No,
    onMouseUp: Jo,
    onMouseOver: ti,
    onKeyDown: oi,
    onKeyUp: Qo,
    onDragEnter: Zo,
    onDragOver: ei
  } = uo, ii = _objectWithoutPropertiesLoose$h(uo, _excluded$L), ai = useGridApiContext(), ri = useGridRootProps(), ni = useRtl(), si = go.field, li = useGridSelector(ai, () => {
    if (!ai.current.getRow(bo))
      return EMPTY_CELL_PARAMS;
    const zi = ai.current.getCellParams(bo, si);
    return zi.api = ai.current, zi;
  }, objectShallowCompare), ui = useGridSelector(ai, () => ai.current.unstable_applyPipeProcessors("isCellSelected", !1, {
    id: bo,
    field: si
  })), ci = useGridSelector(ai, gridRowSpanningHiddenCellsSelector), fi = useGridSelector(ai, gridRowSpanningSpannedCellsSelector), {
    cellMode: yi,
    hasFocus: hi,
    isEditable: mi = !1,
    value: bi
  } = li, xi = go.type === "actions" && ((Mi = go.getActions) == null ? void 0 : Mi.call(go, ai.current.getRowParams(bo)).some((Zi) => !Zi.props.disabled)), $i = (yi === "view" || !mi) && !xi ? li.tabIndex : -1, {
    classes: Ci,
    getCellClassName: Si
  } = ri, Pi = [useGridSelector(ai, () => ai.current.unstable_applyPipeProcessors("cellClassName", [], {
    id: bo,
    field: si
  }).filter(Boolean).join(" "))];
  go.cellClassName && Pi.push(typeof go.cellClassName == "function" ? go.cellClassName(li) : go.cellClassName), go.display === "flex" && Pi.push(gridClasses["cell--flex"]), Si && Pi.push(Si(li));
  const wi = li.formattedValue ?? bi, gi = React$1.useRef(null), Ri = useForkRef(ho, gi), Ei = React$1.useRef(null), Ni = ri.cellSelection ?? !1, Ai = gridPinnedColumnPositionLookup[Oo], Yi = shouldCellShowLeftBorder(Ai, jo), Ui = shouldCellShowRightBorder(Ai, jo, Do, ri.showCellVerticalBorder, Lo), us = {
    align: Po,
    showLeftBorder: Yi,
    showRightBorder: Ui,
    isEditable: mi,
    classes: ri.classes,
    pinnedPosition: Oo,
    isSelected: ui,
    isSelectionMode: Ni
  }, ns = useUtilityClasses$$(us), Ti = React$1.useCallback((Zi) => (zi) => {
    const cs = ai.current.getCellParams(bo, si || "");
    ai.current.publishEvent(Zi, cs, zi), Jo && Jo(zi);
  }, [ai, si, Jo, bo]), _i = React$1.useCallback((Zi) => (zi) => {
    const cs = ai.current.getCellParams(bo, si || "");
    ai.current.publishEvent(Zi, cs, zi), No && No(zi);
  }, [ai, si, No, bo]), Vi = React$1.useCallback((Zi, zi) => (cs) => {
    if (!ai.current.getRow(bo))
      return;
    const ys = ai.current.getCellParams(bo, si || "");
    ai.current.publishEvent(Zi, ys, cs), zi && zi(cs);
  }, [ai, si, bo]), Bi = ((Wi = ci[bo]) == null ? void 0 : Wi[si]) ?? !1, Ji = ((Hi = fi[bo]) == null ? void 0 : Hi[si]) ?? 1, Ki = React$1.useMemo(() => {
    if (Io)
      return {
        padding: 0,
        opacity: 0,
        width: 0,
        height: 0,
        border: 0
      };
    const Zi = _extends$q({
      "--width": `${So}px`
    }, Eo), zi = Oo === PinnedPosition.LEFT, cs = Oo === PinnedPosition.RIGHT;
    if (zi || cs) {
      let ys = zi ? "left" : "right";
      ni && (ys = zi ? "right" : "left"), Zi[ys] = Ao;
    }
    return Ji > 1 && (Zi.height = `calc(var(--height) * ${Ji})`, Zi.zIndex = 5, (zi || cs) && (Zi.zIndex = 6)), Zi;
  }, [So, Io, Eo, Ao, Oo, ni, Ji]);
  if (React$1.useEffect(() => {
    if (!hi || yi === GridCellModes.Edit)
      return;
    const Zi = ownerDocument(ai.current.rootElementRef.current);
    if (gi.current && !gi.current.contains(Zi.activeElement)) {
      const zi = gi.current.querySelector('[tabindex="0"]'), cs = Ei.current || zi || gi.current;
      if (doesSupportPreventScroll())
        cs.focus({
          preventScroll: !0
        });
      else {
        const ys = ai.current.getScrollPosition();
        cs.focus(), ai.current.scroll(ys);
      }
    }
  }, [hi, yi, ai]), Bi)
    return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      "data-colindex": Co,
      role: "presentation",
      style: _extends$q({
        width: "var(--width)"
      }, Ki)
    });
  if (li === EMPTY_CELL_PARAMS)
    return null;
  let qi = ii.onFocus;
  process.env.NODE_ENV === "test" && ((Xi = ri.experimentalFeatures) != null && Xi.warnIfFocusStateIsNotSynced) && (qi = (Zi) => {
    const zi = gridFocusCellSelector(ai);
    if ((zi == null ? void 0 : zi.id) === bo && zi.field === si) {
      typeof ii.onFocus == "function" && ii.onFocus(Zi);
      return;
    }
    warnedOnce || (console.warn([`MUI X: The cell with id=${bo} and field=${si} received focus.`, `According to the state, the focus should be at id=${zi == null ? void 0 : zi.id}, field=${zi == null ? void 0 : zi.field}.`, "Not syncing the state may cause unwanted behaviors since the `cellFocusIn` event won't be fired.", "Call `fireEvent.mouseUp` before the `fireEvent.click` to sync the focus with the state."].join(`
`)), warnedOnce = !0);
  });
  let rs, os;
  if (vo === null && go.renderCell && (rs = go.renderCell(li)), vo !== null && go.renderEditCell) {
    const Zi = ai.current.getRowWithUpdatedValues(bo, go.field), zi = _objectWithoutPropertiesLoose$h(vo, _excluded2$a), cs = go.valueFormatter ? go.valueFormatter(vo.value, Zi, go, ai) : li.formattedValue, ys = _extends$q({}, li, {
      row: Zi,
      formattedValue: cs
    }, zi);
    rs = go.renderEditCell(ys), Pi.push(gridClasses["cell--editing"]), Pi.push(Ci == null ? void 0 : Ci["cell--editing"]);
  }
  if (rs === void 0) {
    const Zi = wi == null ? void 0 : wi.toString();
    rs = Zi, os = Zi;
  }
  /* @__PURE__ */ React$1.isValidElement(rs) && xi && (rs = /* @__PURE__ */ React$1.cloneElement(rs, {
    focusElementRef: Ei
  }));
  const ps = _o ? null : {
    onDragEnter: Vi("cellDragEnter", Zo),
    onDragOver: Vi("cellDragOver", ei)
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", _extends$q({
    className: clsx(ns.root, Pi, wo),
    role: "gridcell",
    "data-field": si,
    "data-colindex": Co,
    "aria-colindex": Co + 1,
    "aria-colspan": Ro,
    "aria-rowspan": Ji,
    style: Ki,
    title: os,
    tabIndex: $i,
    onClick: Vi("cellClick", ko),
    onDoubleClick: Vi("cellDoubleClick", Ko),
    onMouseOver: Vi("cellMouseOver", ti),
    onMouseDown: _i("cellMouseDown"),
    onMouseUp: Ti("cellMouseUp"),
    onKeyDown: Vi("cellKeyDown", oi),
    onKeyUp: Vi("cellKeyUp", Qo)
  }, ps, ii, {
    onFocus: qi,
    ref: Ri,
    children: rs
  }));
});
process.env.NODE_ENV !== "production" && (GridCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  align: PropTypes.oneOf(["center", "left", "right"]).isRequired,
  colIndex: PropTypes.number.isRequired,
  colSpan: PropTypes.number,
  column: PropTypes.object.isRequired,
  disableDragEvents: PropTypes.bool,
  editCellState: PropTypes.shape({
    changeReason: PropTypes.oneOf(["debouncedSetEditCellValue", "setEditCellValue"]),
    isProcessingProps: PropTypes.bool,
    isValidating: PropTypes.bool,
    value: PropTypes.any
  }),
  gridHasFiller: PropTypes.bool.isRequired,
  isNotVisible: PropTypes.bool.isRequired,
  pinnedOffset: PropTypes.number.isRequired,
  pinnedPosition: PropTypes.oneOf([0, 1, 2, 3]).isRequired,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  sectionIndex: PropTypes.number.isRequired,
  sectionLength: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
});
const MemoizedGridCell = fastMemo(GridCell);
function getDividerUtilityClass(Kt) {
  return generateUtilityClass$1("MuiDivider", Kt);
}
const dividerClasses = generateUtilityClasses$1("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), useUtilityClasses$_ = (Kt) => {
  const {
    absolute: uo,
    children: ho,
    classes: go,
    flexItem: bo,
    light: vo,
    orientation: Po,
    textAlign: Co,
    variant: So
  } = Kt;
  return composeClasses({
    root: ["root", uo && "absolute", So, vo && "light", Po === "vertical" && "vertical", bo && "flexItem", ho && "withChildren", ho && Po === "vertical" && "withChildrenVertical", Co === "right" && Po !== "vertical" && "textAlignRight", Co === "left" && Po !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", Po === "vertical" && "wrapperVertical"]
  }, getDividerUtilityClass, go);
}, DividerRoot = styled("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.absolute && uo.absolute, uo[ho.variant], ho.light && uo.light, ho.orientation === "vertical" && uo.vertical, ho.flexItem && uo.flexItem, ho.children && uo.withChildren, ho.children && ho.orientation === "vertical" && uo.withChildrenVertical, ho.textAlign === "right" && ho.orientation !== "vertical" && uo.textAlignRight, ho.textAlign === "left" && ho.orientation !== "vertical" && uo.textAlignLeft];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (Kt.vars || Kt).palette.divider,
  borderBottomWidth: "thin",
  variants: [{
    props: {
      absolute: !0
    },
    style: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    }
  }, {
    props: {
      light: !0
    },
    style: {
      borderColor: Kt.vars ? `rgba(${Kt.vars.palette.dividerChannel} / 0.08)` : alpha$1(Kt.palette.divider, 0.08)
    }
  }, {
    props: {
      variant: "inset"
    },
    style: {
      marginLeft: 72
    }
  }, {
    props: {
      variant: "middle",
      orientation: "horizontal"
    },
    style: {
      marginLeft: Kt.spacing(2),
      marginRight: Kt.spacing(2)
    }
  }, {
    props: {
      variant: "middle",
      orientation: "vertical"
    },
    style: {
      marginTop: Kt.spacing(1),
      marginBottom: Kt.spacing(1)
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      borderBottomWidth: 0,
      borderRightWidth: "thin"
    }
  }, {
    props: {
      flexItem: !0
    },
    style: {
      alignSelf: "stretch",
      height: "auto"
    }
  }, {
    props: ({
      ownerState: uo
    }) => !!uo.children,
    style: {
      display: "flex",
      textAlign: "center",
      border: 0,
      borderTopStyle: "solid",
      borderLeftStyle: "solid",
      "&::before, &::after": {
        content: '""',
        alignSelf: "center"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.children && uo.orientation !== "vertical",
    style: {
      "&::before, &::after": {
        width: "100%",
        borderTop: `thin solid ${(Kt.vars || Kt).palette.divider}`,
        borderTopStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.orientation === "vertical" && uo.children,
    style: {
      flexDirection: "column",
      "&::before, &::after": {
        height: "100%",
        borderLeft: `thin solid ${(Kt.vars || Kt).palette.divider}`,
        borderLeftStyle: "inherit"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.textAlign === "right" && uo.orientation !== "vertical",
    style: {
      "&::before": {
        width: "90%"
      },
      "&::after": {
        width: "10%"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.textAlign === "left" && uo.orientation !== "vertical",
    style: {
      "&::before": {
        width: "10%"
      },
      "&::after": {
        width: "90%"
      }
    }
  }]
}))), DividerWrapper = styled("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.wrapper, ho.orientation === "vertical" && uo.wrapperVertical];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  display: "inline-block",
  paddingLeft: `calc(${Kt.spacing(1)} * 1.2)`,
  paddingRight: `calc(${Kt.spacing(1)} * 1.2)`,
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      paddingTop: `calc(${Kt.spacing(1)} * 1.2)`,
      paddingBottom: `calc(${Kt.spacing(1)} * 1.2)`
    }
  }]
}))), Divider = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiDivider"
  }), {
    absolute: bo = !1,
    children: vo,
    className: Po,
    orientation: Co = "horizontal",
    component: So = vo || Co === "vertical" ? "div" : "hr",
    flexItem: wo = !1,
    light: Eo = !1,
    role: Ro = So !== "hr" ? "separator" : void 0,
    textAlign: _o = "center",
    variant: Io = "fullWidth",
    ...Ao
  } = go, Oo = {
    ...go,
    absolute: bo,
    component: So,
    flexItem: wo,
    light: Eo,
    orientation: Co,
    role: Ro,
    textAlign: _o,
    variant: Io
  }, jo = useUtilityClasses$_(Oo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(DividerRoot, {
    as: So,
    className: clsx(jo.root, Po),
    role: Ro,
    ref: ho,
    ownerState: Oo,
    "aria-orientation": Ro === "separator" && (So !== "hr" || Co === "vertical") ? Co : void 0,
    ...Ao,
    children: vo ? /* @__PURE__ */ jsxRuntimeExports.jsx(DividerWrapper, {
      className: jo.wrapper,
      ownerState: Oo,
      children: vo
    }) : null
  });
});
Divider && (Divider.muiSkipListHighlight = !0);
process.env.NODE_ENV !== "production" && (Divider.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: PropTypes.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  light: PropTypes.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: PropTypes.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["fullWidth", "inset", "middle"]), PropTypes.string])
});
function getListItemIconUtilityClass(Kt) {
  return generateUtilityClass$1("MuiListItemIcon", Kt);
}
const listItemIconClasses = generateUtilityClasses$1("MuiListItemIcon", ["root", "alignItemsFlexStart"]), useUtilityClasses$Z = (Kt) => {
  const {
    alignItems: uo,
    classes: ho
  } = Kt;
  return composeClasses({
    root: ["root", uo === "flex-start" && "alignItemsFlexStart"]
  }, getListItemIconUtilityClass, ho);
}, ListItemIconRoot = styled("div", {
  name: "MuiListItemIcon",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.alignItems === "flex-start" && uo.alignItemsFlexStart];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  minWidth: 56,
  color: (Kt.vars || Kt).palette.action.active,
  flexShrink: 0,
  display: "inline-flex",
  variants: [{
    props: {
      alignItems: "flex-start"
    },
    style: {
      marginTop: 8
    }
  }]
}))), ListItemIcon = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiListItemIcon"
  }), {
    className: bo,
    ...vo
  } = go, Po = React$1.useContext(ListContext), Co = {
    ...go,
    alignItems: Po.alignItems
  }, So = useUtilityClasses$Z(Co);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIconRoot, {
    className: clsx(So.root, bo),
    ownerState: Co,
    ref: ho,
    ...vo
  });
});
process.env.NODE_ENV !== "production" && (ListItemIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@mui/icons-material` SVG icon element.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getTypographyUtilityClass(Kt) {
  return generateUtilityClass$1("MuiTypography", Kt);
}
const typographyClasses = generateUtilityClasses$1("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]), v6Colors = {
  primary: !0,
  secondary: !0,
  error: !0,
  info: !0,
  success: !0,
  warning: !0,
  textPrimary: !0,
  textSecondary: !0,
  textDisabled: !0
}, extendSxProp = internal_createExtendSxProp(), useUtilityClasses$Y = (Kt) => {
  const {
    align: uo,
    gutterBottom: ho,
    noWrap: go,
    paragraph: bo,
    variant: vo,
    classes: Po
  } = Kt, Co = {
    root: ["root", vo, Kt.align !== "inherit" && `align${capitalize(uo)}`, ho && "gutterBottom", go && "noWrap", bo && "paragraph"]
  };
  return composeClasses(Co, getTypographyUtilityClass, Po);
}, TypographyRoot = styled("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.variant && uo[ho.variant], ho.align !== "inherit" && uo[`align${capitalize(ho.align)}`], ho.noWrap && uo.noWrap, ho.gutterBottom && uo.gutterBottom, ho.paragraph && uo.paragraph];
  }
})(memoTheme(({
  theme: Kt
}) => {
  var uo;
  return {
    margin: 0,
    variants: [{
      props: {
        variant: "inherit"
      },
      style: {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit"
      }
    }, ...Object.entries(Kt.typography).filter(([ho, go]) => ho !== "inherit" && go && typeof go == "object").map(([ho, go]) => ({
      props: {
        variant: ho
      },
      style: go
    })), ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([ho]) => ({
      props: {
        color: ho
      },
      style: {
        color: (Kt.vars || Kt).palette[ho].main
      }
    })), ...Object.entries(((uo = Kt.palette) == null ? void 0 : uo.text) || {}).filter(([, ho]) => typeof ho == "string").map(([ho]) => ({
      props: {
        color: `text${capitalize(ho)}`
      },
      style: {
        color: (Kt.vars || Kt).palette.text[ho]
      }
    })), {
      props: ({
        ownerState: ho
      }) => ho.align !== "inherit",
      style: {
        textAlign: "var(--Typography-textAlign)"
      }
    }, {
      props: ({
        ownerState: ho
      }) => ho.noWrap,
      style: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    }, {
      props: ({
        ownerState: ho
      }) => ho.gutterBottom,
      style: {
        marginBottom: "0.35em"
      }
    }, {
      props: ({
        ownerState: ho
      }) => ho.paragraph,
      style: {
        marginBottom: 16
      }
    }]
  };
})), defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, Typography = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    color: go,
    ...bo
  } = useDefaultProps({
    props: uo,
    name: "MuiTypography"
  }), vo = !v6Colors[go], Po = extendSxProp({
    ...bo,
    ...vo && {
      color: go
    }
  }), {
    align: Co = "inherit",
    className: So,
    component: wo,
    gutterBottom: Eo = !1,
    noWrap: Ro = !1,
    paragraph: _o = !1,
    variant: Io = "body1",
    variantMapping: Ao = defaultVariantMapping,
    ...Oo
  } = Po, jo = {
    ...Po,
    align: Co,
    color: go,
    className: So,
    component: wo,
    gutterBottom: Eo,
    noWrap: Ro,
    paragraph: _o,
    variant: Io,
    variantMapping: Ao
  }, Do = wo || (_o ? "p" : Ao[Io] || defaultVariantMapping[Io]) || "span", Lo = useUtilityClasses$Y(jo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(TypographyRoot, {
    as: Do,
    ref: ho,
    className: clsx(Lo.root, So),
    ...Oo,
    ownerState: jo,
    style: {
      ...Co !== "inherit" && {
        "--Typography-textAlign": Co
      },
      ...Oo.style
    }
  });
});
process.env.NODE_ENV !== "production" && (Typography.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "success", "error", "info", "warning", "textPrimary", "textSecondary", "textDisabled"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: PropTypes.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: PropTypes.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   * @deprecated Use the `component` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  paragraph: PropTypes.bool,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), PropTypes.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: PropTypes.object
});
function getListItemTextUtilityClass(Kt) {
  return generateUtilityClass$1("MuiListItemText", Kt);
}
const listItemTextClasses = generateUtilityClasses$1("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), useUtilityClasses$X = (Kt) => {
  const {
    classes: uo,
    inset: ho,
    primary: go,
    secondary: bo,
    dense: vo
  } = Kt;
  return composeClasses({
    root: ["root", ho && "inset", vo && "dense", go && bo && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, getListItemTextUtilityClass, uo);
}, ListItemTextRoot = styled("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [{
      [`& .${listItemTextClasses.primary}`]: uo.primary
    }, {
      [`& .${listItemTextClasses.secondary}`]: uo.secondary
    }, uo.root, ho.inset && uo.inset, ho.primary && ho.secondary && uo.multiline, ho.dense && uo.dense];
  }
})({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4,
  [`.${typographyClasses.root}:where(& .${listItemTextClasses.primary})`]: {
    display: "block"
  },
  [`.${typographyClasses.root}:where(& .${listItemTextClasses.secondary})`]: {
    display: "block"
  },
  variants: [{
    props: ({
      ownerState: Kt
    }) => Kt.primary && Kt.secondary,
    style: {
      marginTop: 6,
      marginBottom: 6
    }
  }, {
    props: ({
      ownerState: Kt
    }) => Kt.inset,
    style: {
      paddingLeft: 56
    }
  }]
}), ListItemText = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiListItemText"
  }), {
    children: bo,
    className: vo,
    disableTypography: Po = !1,
    inset: Co = !1,
    primary: So,
    primaryTypographyProps: wo,
    secondary: Eo,
    secondaryTypographyProps: Ro,
    slots: _o = {},
    slotProps: Io = {},
    ...Ao
  } = go, {
    dense: Oo
  } = React$1.useContext(ListContext);
  let jo = So ?? bo, Do = Eo;
  const Lo = {
    ...go,
    disableTypography: Po,
    inset: Co,
    primary: !!jo,
    secondary: !!Do,
    dense: Oo
  }, ko = useUtilityClasses$X(Lo), Ko = {
    slots: _o,
    slotProps: {
      primary: wo,
      secondary: Ro,
      ...Io
    }
  }, [No, Jo] = useSlot("primary", {
    className: ko.primary,
    elementType: Typography,
    externalForwardedProps: Ko,
    ownerState: Lo
  }), [ti, oi] = useSlot("secondary", {
    className: ko.secondary,
    elementType: Typography,
    externalForwardedProps: Ko,
    ownerState: Lo
  });
  return jo != null && jo.type !== Typography && !Po && (jo = /* @__PURE__ */ jsxRuntimeExports.jsx(No, {
    variant: Oo ? "body2" : "body1",
    component: Jo != null && Jo.variant ? void 0 : "span",
    ...Jo,
    children: jo
  })), Do != null && Do.type !== Typography && !Po && (Do = /* @__PURE__ */ jsxRuntimeExports.jsx(ti, {
    variant: "body2",
    color: "textSecondary",
    ...oi,
    children: Do
  })), /* @__PURE__ */ jsxRuntimeExports.jsxs(ListItemTextRoot, {
    className: clsx(ko.root, vo),
    ownerState: Lo,
    ref: ho,
    ...Ao,
    children: [jo, Do]
  });
});
process.env.NODE_ENV !== "production" && (ListItemText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: PropTypes.bool,
  /**
   * The main content element.
   */
  primary: PropTypes.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.primary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  primaryTypographyProps: PropTypes.object,
  /**
   * The secondary content element.
   */
  secondary: PropTypes.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   * @deprecated Use `slotProps.secondary` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  secondaryTypographyProps: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    primary: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    secondary: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    primary: PropTypes.elementType,
    secondary: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getMenuItemUtilityClass(Kt) {
  return generateUtilityClass$1("MuiMenuItem", Kt);
}
const menuItemClasses = generateUtilityClasses$1("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), overridesResolver$2 = (Kt, uo) => {
  const {
    ownerState: ho
  } = Kt;
  return [uo.root, ho.dense && uo.dense, ho.divider && uo.divider, !ho.disableGutters && uo.gutters];
}, useUtilityClasses$W = (Kt) => {
  const {
    disabled: uo,
    dense: ho,
    divider: go,
    disableGutters: bo,
    selected: vo,
    classes: Po
  } = Kt, So = composeClasses({
    root: ["root", ho && "dense", uo && "disabled", !bo && "gutters", go && "divider", vo && "selected"]
  }, getMenuItemUtilityClass, Po);
  return {
    ...Po,
    ...So
  };
}, MenuItemRoot = styled(ButtonBase, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: overridesResolver$2
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body1,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap",
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (Kt.vars || Kt).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${menuItemClasses.selected}`]: {
    backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / ${Kt.vars.palette.action.selectedOpacity})` : alpha$1(Kt.palette.primary.main, Kt.palette.action.selectedOpacity),
    [`&.${menuItemClasses.focusVisible}`]: {
      backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.focusOpacity}))` : alpha$1(Kt.palette.primary.main, Kt.palette.action.selectedOpacity + Kt.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses.selected}:hover`]: {
    backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.hoverOpacity}))` : alpha$1(Kt.palette.primary.main, Kt.palette.action.selectedOpacity + Kt.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / ${Kt.vars.palette.action.selectedOpacity})` : alpha$1(Kt.palette.primary.main, Kt.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses.focusVisible}`]: {
    backgroundColor: (Kt.vars || Kt).palette.action.focus
  },
  [`&.${menuItemClasses.disabled}`]: {
    opacity: (Kt.vars || Kt).palette.action.disabledOpacity
  },
  [`& + .${dividerClasses.root}`]: {
    marginTop: Kt.spacing(1),
    marginBottom: Kt.spacing(1)
  },
  [`& + .${dividerClasses.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses.root}`]: {
    minWidth: 36
  },
  variants: [{
    props: ({
      ownerState: uo
    }) => !uo.disableGutters,
    style: {
      paddingLeft: 16,
      paddingRight: 16
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.divider,
    style: {
      borderBottom: `1px solid ${(Kt.vars || Kt).palette.divider}`,
      backgroundClip: "padding-box"
    }
  }, {
    props: ({
      ownerState: uo
    }) => !uo.dense,
    style: {
      [Kt.breakpoints.up("sm")]: {
        minHeight: "auto"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.dense,
    style: {
      minHeight: 32,
      // https://m2.material.io/components/menus#specs > Dense
      paddingTop: 4,
      paddingBottom: 4,
      ...Kt.typography.body2,
      [`& .${listItemIconClasses.root} svg`]: {
        fontSize: "1.25rem"
      }
    }
  }]
}))), MenuItem = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiMenuItem"
  }), {
    autoFocus: bo = !1,
    component: vo = "li",
    dense: Po = !1,
    divider: Co = !1,
    disableGutters: So = !1,
    focusVisibleClassName: wo,
    role: Eo = "menuitem",
    tabIndex: Ro,
    className: _o,
    ...Io
  } = go, Ao = React$1.useContext(ListContext), Oo = React$1.useMemo(() => ({
    dense: Po || Ao.dense || !1,
    disableGutters: So
  }), [Ao.dense, Po, So]), jo = React$1.useRef(null);
  useEnhancedEffect(() => {
    bo && (jo.current ? jo.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [bo]);
  const Do = {
    ...go,
    dense: Oo.dense,
    divider: Co,
    disableGutters: So
  }, Lo = useUtilityClasses$W(go), ko = useForkRef(jo, ho);
  let Ko;
  return go.disabled || (Ko = Ro !== void 0 ? Ro : -1), /* @__PURE__ */ jsxRuntimeExports.jsx(ListContext.Provider, {
    value: Oo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItemRoot, {
      ref: ko,
      role: Eo,
      tabIndex: Ko,
      component: vo,
      focusVisibleClassName: clsx(Lo.focusVisible, wo),
      className: clsx(Lo.root, _o),
      ...Io,
      ownerState: Do,
      classes: Lo
    })
  });
});
process.env.NODE_ENV !== "production" && (MenuItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: PropTypes.bool,
  /**
   * @ignore
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: PropTypes.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * @ignore
   */
  role: PropTypes.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @default 0
   */
  tabIndex: PropTypes.number
});
function getSkeletonUtilityClass(Kt) {
  return generateUtilityClass$1("MuiSkeleton", Kt);
}
generateUtilityClasses$1("MuiSkeleton", ["root", "text", "rectangular", "rounded", "circular", "pulse", "wave", "withChildren", "fitContent", "heightAuto"]);
const useUtilityClasses$V = (Kt) => {
  const {
    classes: uo,
    variant: ho,
    animation: go,
    hasChildren: bo,
    width: vo,
    height: Po
  } = Kt;
  return composeClasses({
    root: ["root", ho, go, bo && "withChildren", bo && !vo && "fitContent", bo && !Po && "heightAuto"]
  }, getSkeletonUtilityClass, uo);
}, pulseKeyframe = keyframes`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`, waveKeyframe = keyframes`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`, pulseAnimation = typeof pulseKeyframe != "string" ? css`
        animation: ${pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null, waveAnimation = typeof waveKeyframe != "string" ? css`
        &::after {
          animation: ${waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null, SkeletonRoot = styled("span", {
  name: "MuiSkeleton",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.variant], ho.animation !== !1 && uo[ho.animation], ho.hasChildren && uo.withChildren, ho.hasChildren && !ho.width && uo.fitContent, ho.hasChildren && !ho.height && uo.heightAuto];
  }
})(memoTheme(({
  theme: Kt
}) => {
  const uo = getUnit(Kt.shape.borderRadius) || "px", ho = toUnitless(Kt.shape.borderRadius);
  return {
    display: "block",
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: Kt.vars ? Kt.vars.palette.Skeleton.bg : alpha$1(Kt.palette.text.primary, Kt.palette.mode === "light" ? 0.11 : 0.13),
    height: "1.2em",
    variants: [{
      props: {
        variant: "text"
      },
      style: {
        marginTop: 0,
        marginBottom: 0,
        height: "auto",
        transformOrigin: "0 55%",
        transform: "scale(1, 0.60)",
        borderRadius: `${ho}${uo}/${Math.round(ho / 0.6 * 10) / 10}${uo}`,
        "&:empty:before": {
          content: '"\\00a0"'
        }
      }
    }, {
      props: {
        variant: "circular"
      },
      style: {
        borderRadius: "50%"
      }
    }, {
      props: {
        variant: "rounded"
      },
      style: {
        borderRadius: (Kt.vars || Kt).shape.borderRadius
      }
    }, {
      props: ({
        ownerState: go
      }) => go.hasChildren,
      style: {
        "& > *": {
          visibility: "hidden"
        }
      }
    }, {
      props: ({
        ownerState: go
      }) => go.hasChildren && !go.width,
      style: {
        maxWidth: "fit-content"
      }
    }, {
      props: ({
        ownerState: go
      }) => go.hasChildren && !go.height,
      style: {
        height: "auto"
      }
    }, {
      props: {
        animation: "pulse"
      },
      style: pulseAnimation || {
        animation: `${pulseKeyframe} 2s ease-in-out 0.5s infinite`
      }
    }, {
      props: {
        animation: "wave"
      },
      style: {
        position: "relative",
        overflow: "hidden",
        /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
        WebkitMaskImage: "-webkit-radial-gradient(white, black)",
        "&::after": {
          background: `linear-gradient(
                90deg,
                transparent,
                ${(Kt.vars || Kt).palette.action.hover},
                transparent
              )`,
          content: '""',
          position: "absolute",
          transform: "translateX(-100%)",
          bottom: 0,
          left: 0,
          right: 0,
          top: 0
        }
      }
    }, {
      props: {
        animation: "wave"
      },
      style: waveAnimation || {
        "&::after": {
          animation: `${waveKeyframe} 2s linear 0.5s infinite`
        }
      }
    }]
  };
})), Skeleton = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiSkeleton"
  }), {
    animation: bo = "pulse",
    className: vo,
    component: Po = "span",
    height: Co,
    style: So,
    variant: wo = "text",
    width: Eo,
    ...Ro
  } = go, _o = {
    ...go,
    animation: bo,
    component: Po,
    variant: wo,
    hasChildren: !!Ro.children
  }, Io = useUtilityClasses$V(_o);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonRoot, {
    as: Po,
    ref: ho,
    className: clsx(Io.root, vo),
    ownerState: _o,
    ...Ro,
    style: {
      width: Eo,
      height: Co,
      ...So
    }
  });
});
process.env.NODE_ENV !== "production" && (Skeleton.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The animation.
   * If `false` the animation effect is disabled.
   * @default 'pulse'
   */
  animation: PropTypes.oneOf(["pulse", "wave", !1]),
  /**
   * Optional children to infer width and height from.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The type of content that will be rendered.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["circular", "rectangular", "rounded", "text"]), PropTypes.string]),
  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
const _excluded$K = ["field", "type", "align", "width", "height", "empty", "style", "className"], CIRCULAR_CONTENT_SIZE = "1.3em", CONTENT_HEIGHT = "1.2em", DEFAULT_CONTENT_WIDTH_RANGE = [40, 80], CONTENT_WIDTH_RANGE_BY_TYPE = {
  number: [40, 60],
  string: [40, 80],
  date: [40, 60],
  dateTime: [60, 80],
  singleSelect: [40, 80]
}, useUtilityClasses$U = (Kt) => {
  const {
    align: uo,
    classes: ho,
    empty: go
  } = Kt, bo = {
    root: ["cell", "cellSkeleton", `cell--text${uo ? capitalize(uo) : "Left"}`, go && "cellEmpty"]
  };
  return composeClasses(bo, getDataGridUtilityClass, ho);
}, randomNumberGenerator = createRandomNumberGenerator(12345);
function GridSkeletonCell(Kt) {
  const {
    field: uo,
    type: ho,
    align: go,
    width: bo,
    height: vo,
    empty: Po = !1,
    style: Co,
    className: So
  } = Kt, wo = _objectWithoutPropertiesLoose$h(Kt, _excluded$K), Ro = {
    classes: useGridRootProps().classes,
    align: go,
    empty: Po
  }, _o = useUtilityClasses$U(Ro), Io = React$1.useMemo(() => {
    if (ho === "boolean" || ho === "actions")
      return {
        variant: "circular",
        width: CIRCULAR_CONTENT_SIZE,
        height: CIRCULAR_CONTENT_SIZE
      };
    const [Oo, jo] = ho ? CONTENT_WIDTH_RANGE_BY_TYPE[ho] ?? DEFAULT_CONTENT_WIDTH_RANGE : DEFAULT_CONTENT_WIDTH_RANGE;
    return {
      variant: "text",
      width: `${Math.round(randomNumberGenerator(Oo, jo))}%`,
      height: CONTENT_HEIGHT
    };
  }, [ho]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", _extends$q({
    "data-field": uo,
    className: clsx(_o.root, So),
    style: _extends$q({
      height: vo,
      maxWidth: bo,
      minWidth: bo
    }, Co)
  }, wo, {
    children: !Po && /* @__PURE__ */ jsxRuntimeExports.jsx(Skeleton, _extends$q({}, Io))
  }));
}
process.env.NODE_ENV !== "production" && (GridSkeletonCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  align: PropTypes.string,
  /**
   * If `true`, the cell will not display the skeleton but still reserve the cell space.
   * @default false
   */
  empty: PropTypes.bool,
  field: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number]),
  type: PropTypes.oneOf(["actions", "boolean", "custom", "date", "dateTime", "number", "singleSelect", "string"]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});
const Memoized$1 = fastMemo(GridSkeletonCell);
function getBorderColor(Kt) {
  return Kt.vars ? Kt.vars.palette.TableCell.border : Kt.palette.mode === "light" ? lighten(alpha$1(Kt.palette.divider, 1), 0.88) : darken(alpha$1(Kt.palette.divider, 1), 0.68);
}
const columnHeaderStyles = {
  [`& .${gridClasses.iconButtonContainer}`]: {
    visibility: "visible",
    width: "auto"
  },
  [`& .${gridClasses.menuIcon}`]: {
    width: "auto",
    visibility: "visible"
  }
}, columnSeparatorTargetSize = 10, columnSeparatorOffset = -5, focusOutlineWidth = 1, separatorIconDragStyles = {
  width: 3,
  rx: 1.5,
  x: 10.5
}, ignoreSsrWarning = "/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */", GridRootStyles = styled("div", {
  name: "MuiDataGrid",
  slot: "Root",
  overridesResolver: (Kt, uo) => [{
    [`&.${gridClasses.autoHeight}`]: uo.autoHeight
  }, {
    [`&.${gridClasses.aggregationColumnHeader}`]: uo.aggregationColumnHeader
  }, {
    [`&.${gridClasses["aggregationColumnHeader--alignLeft"]}`]: uo["aggregationColumnHeader--alignLeft"]
  }, {
    [`&.${gridClasses["aggregationColumnHeader--alignCenter"]}`]: uo["aggregationColumnHeader--alignCenter"]
  }, {
    [`&.${gridClasses["aggregationColumnHeader--alignRight"]}`]: uo["aggregationColumnHeader--alignRight"]
  }, {
    [`&.${gridClasses.aggregationColumnHeaderLabel}`]: uo.aggregationColumnHeaderLabel
  }, {
    [`&.${gridClasses["root--disableUserSelection"]} .${gridClasses.cell}`]: uo["root--disableUserSelection"]
  }, {
    [`&.${gridClasses.autosizing}`]: uo.autosizing
  }, {
    [`& .${gridClasses.editBooleanCell}`]: uo.editBooleanCell
  }, {
    [`& .${gridClasses.cell}`]: uo.cell
  }, {
    [`& .${gridClasses["cell--editing"]}`]: uo["cell--editing"]
  }, {
    [`& .${gridClasses["cell--textCenter"]}`]: uo["cell--textCenter"]
  }, {
    [`& .${gridClasses["cell--textLeft"]}`]: uo["cell--textLeft"]
  }, {
    [`& .${gridClasses["cell--textRight"]}`]: uo["cell--textRight"]
  }, {
    [`& .${gridClasses["cell--rangeTop"]}`]: uo["cell--rangeTop"]
  }, {
    [`& .${gridClasses["cell--rangeBottom"]}`]: uo["cell--rangeBottom"]
  }, {
    [`& .${gridClasses["cell--rangeLeft"]}`]: uo["cell--rangeLeft"]
  }, {
    [`& .${gridClasses["cell--rangeRight"]}`]: uo["cell--rangeRight"]
  }, {
    [`& .${gridClasses["cell--withRightBorder"]}`]: uo["cell--withRightBorder"]
  }, {
    [`& .${gridClasses.cellCheckbox}`]: uo.cellCheckbox
  }, {
    [`& .${gridClasses.cellSkeleton}`]: uo.cellSkeleton
  }, {
    [`& .${gridClasses.checkboxInput}`]: uo.checkboxInput
  }, {
    [`& .${gridClasses["columnHeader--alignCenter"]}`]: uo["columnHeader--alignCenter"]
  }, {
    [`& .${gridClasses["columnHeader--alignLeft"]}`]: uo["columnHeader--alignLeft"]
  }, {
    [`& .${gridClasses["columnHeader--alignRight"]}`]: uo["columnHeader--alignRight"]
  }, {
    [`& .${gridClasses["columnHeader--dragging"]}`]: uo["columnHeader--dragging"]
  }, {
    [`& .${gridClasses["columnHeader--moving"]}`]: uo["columnHeader--moving"]
  }, {
    [`& .${gridClasses["columnHeader--numeric"]}`]: uo["columnHeader--numeric"]
  }, {
    [`& .${gridClasses["columnHeader--sortable"]}`]: uo["columnHeader--sortable"]
  }, {
    [`& .${gridClasses["columnHeader--sorted"]}`]: uo["columnHeader--sorted"]
  }, {
    [`& .${gridClasses["columnHeader--withRightBorder"]}`]: uo["columnHeader--withRightBorder"]
  }, {
    [`& .${gridClasses.columnHeader}`]: uo.columnHeader
  }, {
    [`& .${gridClasses.headerFilterRow}`]: uo.headerFilterRow
  }, {
    [`& .${gridClasses.columnHeaderCheckbox}`]: uo.columnHeaderCheckbox
  }, {
    [`& .${gridClasses.columnHeaderDraggableContainer}`]: uo.columnHeaderDraggableContainer
  }, {
    [`& .${gridClasses.columnHeaderTitleContainer}`]: uo.columnHeaderTitleContainer
  }, {
    [`& .${gridClasses["columnSeparator--resizable"]}`]: uo["columnSeparator--resizable"]
  }, {
    [`& .${gridClasses["columnSeparator--resizing"]}`]: uo["columnSeparator--resizing"]
  }, {
    [`& .${gridClasses.columnSeparator}`]: uo.columnSeparator
  }, {
    [`& .${gridClasses.filterIcon}`]: uo.filterIcon
  }, {
    [`& .${gridClasses.iconSeparator}`]: uo.iconSeparator
  }, {
    [`& .${gridClasses.menuIcon}`]: uo.menuIcon
  }, {
    [`& .${gridClasses.menuIconButton}`]: uo.menuIconButton
  }, {
    [`& .${gridClasses.menuOpen}`]: uo.menuOpen
  }, {
    [`& .${gridClasses.menuList}`]: uo.menuList
  }, {
    [`& .${gridClasses["row--editable"]}`]: uo["row--editable"]
  }, {
    [`& .${gridClasses["row--editing"]}`]: uo["row--editing"]
  }, {
    [`& .${gridClasses["row--dragging"]}`]: uo["row--dragging"]
  }, {
    [`& .${gridClasses.row}`]: uo.row
  }, {
    [`& .${gridClasses.rowReorderCellPlaceholder}`]: uo.rowReorderCellPlaceholder
  }, {
    [`& .${gridClasses.rowReorderCell}`]: uo.rowReorderCell
  }, {
    [`& .${gridClasses["rowReorderCell--draggable"]}`]: uo["rowReorderCell--draggable"]
  }, {
    [`& .${gridClasses.sortIcon}`]: uo.sortIcon
  }, {
    [`& .${gridClasses.withBorderColor}`]: uo.withBorderColor
  }, {
    [`& .${gridClasses.treeDataGroupingCell}`]: uo.treeDataGroupingCell
  }, {
    [`& .${gridClasses.treeDataGroupingCellToggle}`]: uo.treeDataGroupingCellToggle
  }, {
    [`& .${gridClasses.treeDataGroupingCellLoadingContainer}`]: uo.treeDataGroupingCellLoadingContainer
  }, {
    [`& .${gridClasses.groupingCriteriaCellLoadingContainer}`]: uo.groupingCriteriaCellLoadingContainer
  }, {
    [`& .${gridClasses.detailPanelToggleCell}`]: uo.detailPanelToggleCell
  }, {
    [`& .${gridClasses["detailPanelToggleCell--expanded"]}`]: uo["detailPanelToggleCell--expanded"]
  }, uo.root]
})(({
  theme: Kt
}) => {
  var oi, Qo;
  const uo = useGridPrivateApiContext(), ho = useGridSelector(uo, gridDimensionsSelector), go = getBorderColor(Kt), bo = Kt.shape.borderRadius, vo = Kt.vars ? Kt.vars.palette.background.default : ((oi = Kt.mixins.MuiDataGrid) == null ? void 0 : oi.containerBackground) ?? Kt.palette.background.default, Po = ((Qo = Kt.mixins.MuiDataGrid) == null ? void 0 : Qo.pinnedBackground) ?? vo, Co = Kt.vars ? `rgba(${Kt.vars.palette.background.defaultChannel} / ${Kt.vars.palette.action.disabledOpacity})` : alpha$1(Kt.palette.background.default, Kt.palette.action.disabledOpacity), So = (Kt.vars || Kt).palette.action.hoverOpacity, wo = (Kt.vars || Kt).palette.action.hover, Eo = (Kt.vars || Kt).palette.action.selectedOpacity, Ro = Kt.vars ? `calc(${So} + ${Eo})` : So + Eo, _o = Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / ${Eo})` : alpha$1(Kt.palette.primary.main, Eo), Io = Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / ${Ro})` : alpha$1(Kt.palette.primary.main, Ro), Ao = Kt.vars ? blendCssVars : blend, Oo = (Zo) => ({
    [`& .${gridClasses["cell--pinnedLeft"]}, & .${gridClasses["cell--pinnedRight"]}`]: {
      backgroundColor: Zo,
      "&.Mui-selected": {
        backgroundColor: Ao(Zo, _o, Eo),
        "&:hover": {
          backgroundColor: Ao(Zo, _o, Ro)
        }
      }
    }
  }), jo = Ao(Po, wo, So), Do = Oo(jo), Lo = Ao(Po, _o, Eo), ko = Oo(Lo), Ko = Ao(Po, Io, Ro), No = Oo(Ko), Jo = {
    backgroundColor: _o,
    "&:hover": {
      backgroundColor: Io,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: _o
      }
    }
  };
  return _extends$q({
    "--unstable_DataGrid-radius": typeof bo == "number" ? `${bo}px` : bo,
    "--unstable_DataGrid-headWeight": Kt.typography.fontWeightMedium,
    "--unstable_DataGrid-overlayBackground": Co,
    "--DataGrid-containerBackground": vo,
    "--DataGrid-pinnedBackground": Po,
    "--DataGrid-rowBorderColor": go,
    "--DataGrid-cellOffsetMultiplier": 2,
    "--DataGrid-width": "0px",
    "--DataGrid-hasScrollX": "0",
    "--DataGrid-hasScrollY": "0",
    "--DataGrid-scrollbarSize": "10px",
    "--DataGrid-rowWidth": "0px",
    "--DataGrid-columnsTotalWidth": "0px",
    "--DataGrid-leftPinnedWidth": "0px",
    "--DataGrid-rightPinnedWidth": "0px",
    "--DataGrid-headerHeight": "0px",
    "--DataGrid-headersTotalHeight": "0px",
    "--DataGrid-topContainerHeight": "0px",
    "--DataGrid-bottomContainerHeight": "0px",
    flex: 1,
    boxSizing: "border-box",
    position: "relative",
    borderWidth: "1px",
    borderStyle: "solid",
    borderColor: go,
    borderRadius: "var(--unstable_DataGrid-radius)",
    color: (Kt.vars || Kt).palette.text.primary
  }, Kt.typography.body2, {
    outline: "none",
    height: "100%",
    display: "flex",
    minWidth: 0,
    // See https://github.com/mui/mui-x/issues/8547
    minHeight: 0,
    flexDirection: "column",
    overflow: "hidden",
    overflowAnchor: "none",
    // Keep the same scrolling position
    [`.${gridClasses.main} > *:first-child${ignoreSsrWarning}`]: {
      borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
      borderTopRightRadius: "var(--unstable_DataGrid-radius)"
    },
    [`&.${gridClasses.autoHeight}`]: {
      height: "auto"
    },
    [`&.${gridClasses.autosizing}`]: {
      [`& .${gridClasses.columnHeaderTitleContainerContent} > *`]: {
        overflow: "visible !important"
      },
      "@media (hover: hover)": {
        [`& .${gridClasses.iconButtonContainer}`]: {
          width: "0 !important",
          visibility: "hidden !important"
        },
        [`& .${gridClasses.menuIcon}`]: {
          width: "0 !important",
          visibility: "hidden !important"
        }
      },
      [`& .${gridClasses.cell}`]: {
        overflow: "visible !important",
        whiteSpace: "nowrap",
        minWidth: "max-content !important",
        maxWidth: "max-content !important"
      },
      [`& .${gridClasses.groupingCriteriaCell}`]: {
        width: "unset"
      },
      [`& .${gridClasses.treeDataGroupingCell}`]: {
        width: "unset"
      }
    },
    [`& .${gridClasses.columnHeader}, & .${gridClasses.cell}`]: {
      WebkitTapHighlightColor: "transparent",
      padding: "0 10px",
      boxSizing: "border-box"
    },
    [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]: {
      outline: `solid ${Kt.vars ? `rgba(${Kt.vars.palette.primary.mainChannel} / 0.5)` : alpha$1(Kt.palette.primary.main, 0.5)} ${focusOutlineWidth}px`,
      outlineOffset: focusOutlineWidth * -1
    },
    [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.cell}:focus`]: {
      outline: `solid ${Kt.palette.primary.main} ${focusOutlineWidth}px`,
      outlineOffset: focusOutlineWidth * -1
    },
    // Hide the column separator when:
    // - the column is focused and has an outline
    // - the next column is focused and has an outline
    // - the column has a left or right border
    // - the next column is pinned right and has a left border
    [`& .${gridClasses.columnHeader}:focus,
      & .${gridClasses["columnHeader--withLeftBorder"]},
      & .${gridClasses["columnHeader--withRightBorder"]},
      & .${gridClasses["columnHeader--siblingFocused"]},
      & .${gridClasses["virtualScroller--hasScrollX"]} .${gridClasses["columnHeader--lastUnpinned"]},
      & .${gridClasses["virtualScroller--hasScrollX"]} .${gridClasses["columnHeader--last"]}
      `]: {
      [`& .${gridClasses.columnSeparator}`]: {
        opacity: 0
      },
      // Show resizable separators at all times on touch devices
      "@media (hover: none)": {
        [`& .${gridClasses["columnSeparator--resizable"]}`]: {
          opacity: 1
        }
      },
      [`& .${gridClasses["columnSeparator--resizable"]}:hover`]: {
        opacity: 1
      }
    },
    [`&.${gridClasses["root--noToolbar"]} [aria-rowindex="1"] [aria-colindex="1"]`]: {
      borderTopLeftRadius: "calc(var(--unstable_DataGrid-radius) - 1px)"
    },
    [`&.${gridClasses["root--noToolbar"]} [aria-rowindex="1"] .${gridClasses["columnHeader--last"]}`]: {
      borderTopRightRadius: ho.hasScrollX && (!ho.hasScrollY || ho.scrollbarSize === 0) ? "calc(var(--unstable_DataGrid-radius) - 1px)" : void 0
    },
    [`& .${gridClasses.columnHeaderCheckbox}, & .${gridClasses.cellCheckbox}`]: {
      padding: 0,
      justifyContent: "center",
      alignItems: "center"
    },
    [`& .${gridClasses.columnHeader}`]: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    [`& .${gridClasses["virtualScroller--hasScrollX"]} .${gridClasses["columnHeader--last"]}`]: {
      overflow: "hidden"
    },
    [`& .${gridClasses["columnHeader--sorted"]} .${gridClasses.iconButtonContainer}, & .${gridClasses["columnHeader--filtered"]} .${gridClasses.iconButtonContainer}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${gridClasses.columnHeader}:not(.${gridClasses["columnHeader--sorted"]}) .${gridClasses.sortIcon}`]: {
      opacity: 0,
      transition: Kt.transitions.create(["opacity"], {
        duration: Kt.transitions.duration.shorter
      })
    },
    [`& .${gridClasses.columnHeaderTitleContainer}`]: {
      display: "flex",
      alignItems: "center",
      gap: Kt.spacing(0.25),
      minWidth: 0,
      flex: 1,
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    [`& .${gridClasses.columnHeaderTitleContainerContent}`]: {
      overflow: "hidden",
      display: "flex",
      alignItems: "center"
    },
    [`& .${gridClasses["columnHeader--filledGroup"]} .${gridClasses.columnHeaderTitleContainer}`]: {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      boxSizing: "border-box"
    },
    [`& .${gridClasses.sortIcon}, & .${gridClasses.filterIcon}`]: {
      fontSize: "inherit"
    },
    [`& .${gridClasses["columnHeader--sortable"]}`]: {
      cursor: "pointer"
    },
    [`& .${gridClasses["columnHeader--alignCenter"]} .${gridClasses.columnHeaderTitleContainer}`]: {
      justifyContent: "center"
    },
    [`& .${gridClasses["columnHeader--alignRight"]} .${gridClasses.columnHeaderDraggableContainer}, & .${gridClasses["columnHeader--alignRight"]} .${gridClasses.columnHeaderTitleContainer}`]: {
      flexDirection: "row-reverse"
    },
    [`& .${gridClasses["columnHeader--alignCenter"]} .${gridClasses.menuIcon}`]: {
      marginLeft: "auto"
    },
    [`& .${gridClasses["columnHeader--alignRight"]} .${gridClasses.menuIcon}`]: {
      marginRight: "auto",
      marginLeft: -5
    },
    [`& .${gridClasses["columnHeader--moving"]}`]: {
      backgroundColor: (Kt.vars || Kt).palette.action.hover
    },
    [`& .${gridClasses["columnHeader--pinnedLeft"]}, & .${gridClasses["columnHeader--pinnedRight"]}`]: {
      position: "sticky",
      zIndex: 4,
      // Should be above the column separator
      background: "var(--DataGrid-pinnedBackground)"
    },
    [`& .${gridClasses.columnSeparator}`]: {
      position: "absolute",
      overflow: "hidden",
      zIndex: 3,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      maxWidth: columnSeparatorTargetSize,
      color: go
    },
    [`& .${gridClasses.columnHeaders}`]: {
      width: "var(--DataGrid-rowWidth)"
    },
    "@media (hover: hover)": {
      [`& .${gridClasses.columnHeader}:hover`]: columnHeaderStyles,
      [`& .${gridClasses.columnHeader}:not(.${gridClasses["columnHeader--sorted"]}):hover .${gridClasses.sortIcon}`]: {
        opacity: 0.5
      }
    },
    "@media (hover: none)": {
      [`& .${gridClasses.columnHeader}`]: columnHeaderStyles,
      [`& .${gridClasses.columnHeader}:focus,
        & .${gridClasses["columnHeader--siblingFocused"]}`]: {
        [`.${gridClasses["columnSeparator--resizable"]}`]: {
          color: (Kt.vars || Kt).palette.primary.main
        }
      }
    },
    [`& .${gridClasses["columnSeparator--sideLeft"]}`]: {
      left: columnSeparatorOffset
    },
    [`& .${gridClasses["columnSeparator--sideRight"]}`]: {
      right: columnSeparatorOffset
    },
    [`& .${gridClasses["columnHeader--withRightBorder"]} .${gridClasses["columnSeparator--sideLeft"]}`]: {
      left: columnSeparatorOffset - 0.5
    },
    [`& .${gridClasses["columnHeader--withRightBorder"]} .${gridClasses["columnSeparator--sideRight"]}`]: {
      right: columnSeparatorOffset - 0.5
    },
    [`& .${gridClasses["columnSeparator--resizable"]}`]: {
      cursor: "col-resize",
      touchAction: "none",
      [`&.${gridClasses["columnSeparator--resizing"]}`]: {
        color: (Kt.vars || Kt).palette.primary.main
      },
      // Always appear as draggable on touch devices
      "@media (hover: none)": {
        [`& .${gridClasses.iconSeparator} rect`]: separatorIconDragStyles
      },
      "@media (hover: hover)": {
        "&:hover": {
          color: (Kt.vars || Kt).palette.primary.main,
          [`& .${gridClasses.iconSeparator} rect`]: separatorIconDragStyles
        }
      },
      "& svg": {
        pointerEvents: "none"
      }
    },
    [`& .${gridClasses.iconSeparator}`]: {
      color: "inherit",
      transition: Kt.transitions.create(["color", "width"], {
        duration: Kt.transitions.duration.shortest
      })
    },
    [`& .${gridClasses.menuIcon}`]: {
      width: 0,
      visibility: "hidden",
      fontSize: 20,
      marginRight: -5,
      display: "flex",
      alignItems: "center"
    },
    [`.${gridClasses.menuOpen}`]: {
      visibility: "visible",
      width: "auto"
    },
    [`& .${gridClasses.headerFilterRow}`]: {
      [`& .${gridClasses.columnHeader}`]: {
        boxSizing: "border-box",
        borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
      }
    },
    /* Bottom border of the top-container */
    [`& .${gridClasses["row--borderBottom"]} .${gridClasses.columnHeader},
      & .${gridClasses["row--borderBottom"]} .${gridClasses.filler},
      & .${gridClasses["row--borderBottom"]} .${gridClasses.scrollbarFiller}`]: {
      borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
    },
    [`& .${gridClasses["row--borderBottom"]} .${gridClasses.cell}`]: {
      borderBottom: "1px solid var(--rowBorderColor)"
    },
    /* Row styles */
    [`.${gridClasses.row}`]: {
      display: "flex",
      width: "var(--DataGrid-rowWidth)",
      breakInside: "avoid",
      // Avoid the row to be broken in two different print pages.
      "--rowBorderColor": "var(--DataGrid-rowBorderColor)",
      [`&.${gridClasses["row--firstVisible"]}`]: {
        "--rowBorderColor": "transparent"
      },
      "&:hover": {
        backgroundColor: (Kt.vars || Kt).palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      [`&.${gridClasses.rowSkeleton}:hover`]: {
        backgroundColor: "transparent"
      },
      "&.Mui-selected": Jo
    },
    [`& .${gridClasses["container--top"]}, & .${gridClasses["container--bottom"]}`]: {
      "[role=row]": {
        background: "var(--DataGrid-containerBackground)"
      }
    },
    /* Cell styles */
    [`& .${gridClasses.cell}`]: {
      flex: "0 0 auto",
      height: "var(--height)",
      width: "var(--width)",
      lineHeight: "calc(var(--height) - 1px)",
      // -1px for the border
      boxSizing: "border-box",
      borderTop: "1px solid var(--rowBorderColor)",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      "&.Mui-selected": Jo
    },
    [`& .${gridClasses["virtualScrollerContent--overflowed"]} .${gridClasses["row--lastVisible"]} .${gridClasses.cell}`]: {
      borderTopColor: "transparent"
    },
    [`& .${gridClasses["pinnedRows--top"]} :first-of-type`]: {
      [`& .${gridClasses.cell}, .${gridClasses.scrollbarFiller}`]: {
        borderTop: "none"
      }
    },
    [`&.${gridClasses["root--disableUserSelection"]} .${gridClasses.cell}`]: {
      userSelect: "none"
    },
    [`& .${gridClasses["row--dynamicHeight"]} > .${gridClasses.cell}`]: {
      whiteSpace: "initial",
      lineHeight: "inherit"
    },
    [`& .${gridClasses.cellEmpty}`]: {
      padding: 0,
      height: "unset"
    },
    [`& .${gridClasses.cell}.${gridClasses["cell--selectionMode"]}`]: {
      cursor: "default"
    },
    [`& .${gridClasses.cell}.${gridClasses["cell--editing"]}`]: {
      padding: 1,
      display: "flex",
      boxShadow: Kt.shadows[2],
      backgroundColor: (Kt.vars || Kt).palette.background.paper,
      "&:focus-within": {
        outline: `${focusOutlineWidth}px solid ${(Kt.vars || Kt).palette.primary.main}`,
        outlineOffset: focusOutlineWidth * -1
      }
    },
    [`& .${gridClasses["row--editing"]}`]: {
      boxShadow: Kt.shadows[2]
    },
    [`& .${gridClasses["row--editing"]} .${gridClasses.cell}`]: {
      boxShadow: Kt.shadows[0],
      backgroundColor: (Kt.vars || Kt).palette.background.paper
    },
    [`& .${gridClasses.editBooleanCell}`]: {
      display: "flex",
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center"
    },
    [`& .${gridClasses.booleanCell}[data-value="true"]`]: {
      color: (Kt.vars || Kt).palette.text.secondary
    },
    [`& .${gridClasses.booleanCell}[data-value="false"]`]: {
      color: (Kt.vars || Kt).palette.text.disabled
    },
    [`& .${gridClasses.actionsCell}`]: {
      display: "inline-flex",
      alignItems: "center",
      gridGap: Kt.spacing(1)
    },
    [`& .${gridClasses.rowReorderCell}`]: {
      display: "inline-flex",
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      opacity: (Kt.vars || Kt).palette.action.disabledOpacity
    },
    [`& .${gridClasses["rowReorderCell--draggable"]}`]: {
      cursor: "move",
      opacity: 1
    },
    [`& .${gridClasses.rowReorderCellContainer}`]: {
      padding: 0,
      display: "flex",
      alignItems: "stretch"
    },
    [`.${gridClasses.withBorderColor}`]: {
      borderColor: go
    },
    [`& .${gridClasses["cell--withLeftBorder"]}, & .${gridClasses["columnHeader--withLeftBorder"]}`]: {
      borderLeftColor: "var(--DataGrid-rowBorderColor)",
      borderLeftWidth: "1px",
      borderLeftStyle: "solid"
    },
    [`& .${gridClasses["cell--withRightBorder"]}, & .${gridClasses["columnHeader--withRightBorder"]}`]: {
      borderRightColor: "var(--DataGrid-rowBorderColor)",
      borderRightWidth: "1px",
      borderRightStyle: "solid"
    },
    [`& .${gridClasses["cell--flex"]}`]: {
      display: "flex",
      alignItems: "center",
      lineHeight: "inherit"
    },
    [`& .${gridClasses["cell--textLeft"]}`]: {
      textAlign: "left",
      justifyContent: "flex-start"
    },
    [`& .${gridClasses["cell--textRight"]}`]: {
      textAlign: "right",
      justifyContent: "flex-end"
    },
    [`& .${gridClasses["cell--textCenter"]}`]: {
      textAlign: "center",
      justifyContent: "center"
    },
    [`& .${gridClasses["cell--pinnedLeft"]}, & .${gridClasses["cell--pinnedRight"]}`]: {
      position: "sticky",
      zIndex: 3,
      background: "var(--DataGrid-pinnedBackground)",
      "&.Mui-selected": {
        backgroundColor: Lo
      }
    },
    [`& .${gridClasses.virtualScrollerContent} .${gridClasses.row}`]: {
      "&:hover": Do,
      "&.Mui-selected": ko,
      "&.Mui-selected:hover": No
    },
    [`& .${gridClasses.cellOffsetLeft}`]: {
      flex: "0 0 auto",
      display: "inline-block"
    },
    [`& .${gridClasses.cellSkeleton}`]: {
      flex: "0 0 auto",
      height: "100%",
      display: "inline-flex",
      alignItems: "center"
    },
    [`& .${gridClasses.columnHeaderDraggableContainer}`]: {
      display: "flex",
      width: "100%",
      height: "100%"
    },
    [`& .${gridClasses.rowReorderCellPlaceholder}`]: {
      display: "none"
    },
    [`& .${gridClasses["columnHeader--dragging"]}, & .${gridClasses["row--dragging"]}`]: {
      background: (Kt.vars || Kt).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (Kt.vars || Kt).palette.action.disabledOpacity
    },
    [`& .${gridClasses["row--dragging"]}`]: {
      background: (Kt.vars || Kt).palette.background.paper,
      padding: "0 12px",
      borderRadius: "var(--unstable_DataGrid-radius)",
      opacity: (Kt.vars || Kt).palette.action.disabledOpacity,
      [`& .${gridClasses.rowReorderCellPlaceholder}`]: {
        display: "flex"
      }
    },
    [`& .${gridClasses.treeDataGroupingCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${gridClasses.treeDataGroupingCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: Kt.spacing(2)
    },
    [`& .${gridClasses.treeDataGroupingCellLoadingContainer}, .${gridClasses.groupingCriteriaCellLoadingContainer}`]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%"
    },
    [`& .${gridClasses.groupingCriteriaCell}`]: {
      display: "flex",
      alignItems: "center",
      width: "100%"
    },
    [`& .${gridClasses.groupingCriteriaCellToggle}`]: {
      flex: "0 0 28px",
      alignSelf: "stretch",
      marginRight: Kt.spacing(2)
    },
    /* ScrollbarFiller styles */
    [`.${gridClasses.scrollbarFiller}`]: {
      minWidth: "calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))",
      alignSelf: "stretch",
      [`&.${gridClasses["scrollbarFiller--borderTop"]}`]: {
        borderTop: "1px solid var(--DataGrid-rowBorderColor)"
      },
      [`&.${gridClasses["scrollbarFiller--borderBottom"]}`]: {
        borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
      },
      [`&.${gridClasses["scrollbarFiller--pinnedRight"]}`]: {
        backgroundColor: "var(--DataGrid-pinnedBackground)",
        position: "sticky",
        right: 0
      }
    },
    [`& .${gridClasses.filler}`]: {
      flex: "1 0 auto"
    },
    [`& .${gridClasses["filler--borderBottom"]}`]: {
      borderBottom: "1px solid var(--DataGrid-rowBorderColor)"
    },
    /* Hide grid rows, row filler, and vertical scrollbar when skeleton overlay is visible */
    [`& .${gridClasses["main--hasSkeletonLoadingOverlay"]}`]: {
      [`& .${gridClasses.virtualScrollerContent}`]: {
        // We use visibility hidden so that the virtual scroller content retains its height.
        // Position fixed is used to remove the virtual scroller content from the flow.
        // https://github.com/mui/mui-x/issues/14061
        position: "fixed",
        visibility: "hidden"
      },
      [`& .${gridClasses["scrollbar--vertical"]}, & .${gridClasses.pinnedRows}, & .${gridClasses.virtualScroller} > .${gridClasses.filler}`]: {
        display: "none"
      }
    }
  });
});
function blend(Kt, uo, ho, go = 1) {
  const bo = (So, wo) => Math.round((So ** (1 / go) * (1 - ho) + wo ** (1 / go) * ho) ** go), vo = decomposeColor(Kt), Po = decomposeColor(uo), Co = [bo(vo.values[0], Po.values[0]), bo(vo.values[1], Po.values[1]), bo(vo.values[2], Po.values[2])];
  return recomposeColor({
    type: "rgb",
    values: Co
  });
}
const removeOpacity = (Kt) => `rgb(from ${Kt} r g b / 1)`;
function blendCssVars(Kt, uo, ho) {
  return `color-mix(in srgb,${Kt}, ${removeOpacity(uo)} calc(${ho} * 100%))`;
}
const _excluded$J = ["className"], useUtilityClasses$T = (Kt, uo) => {
  const {
    autoHeight: ho,
    classes: go,
    showCellVerticalBorder: bo
  } = Kt, vo = {
    root: ["root", ho && "autoHeight", `root--density${capitalize(uo)}`, Kt.slots.toolbar === null && "root--noToolbar", "withBorderColor", bo && "withVerticalBorder"]
  };
  return composeClasses(vo, getDataGridUtilityClass, go);
}, GridRoot = forwardRef(function(uo, ho) {
  const go = useGridRootProps(), {
    className: bo
  } = uo, vo = _objectWithoutPropertiesLoose$h(uo, _excluded$J), Po = useGridPrivateApiContext(), Co = useGridSelector(Po, gridDensitySelector), So = Po.current.rootElementRef, wo = useForkRef(So, ho), Eo = go, Ro = useUtilityClasses$T(Eo, Co), [_o, Io] = React$1.useState(!1);
  return useEnhancedEffect(() => {
    Io(!0);
  }, []), _o ? /* @__PURE__ */ jsxRuntimeExports.jsx(GridRootStyles, _extends$q({
    className: clsx(Ro.root, bo),
    ownerState: Eo
  }, vo, {
    ref: wo
  })) : null;
});
process.env.NODE_ENV !== "production" && (GridRoot.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const _excluded$I = ["className"], useUtilityClasses$S = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["footerContainer", "withBorderColor"]
  }, getDataGridUtilityClass, uo);
}, GridFooterContainerRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "FooterContainer",
  overridesResolver: (Kt, uo) => uo.footerContainer
})({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: 52,
  borderTop: "1px solid"
}), GridFooterContainer = forwardRef(function(uo, ho) {
  const {
    className: go
  } = uo, bo = _objectWithoutPropertiesLoose$h(uo, _excluded$I), vo = useGridRootProps(), Po = useUtilityClasses$S(vo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridFooterContainerRoot, _extends$q({
    className: clsx(Po.root, go),
    ownerState: vo
  }, bo, {
    ref: ho
  }));
});
process.env.NODE_ENV !== "production" && (GridFooterContainer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const _excluded$H = ["className"], useUtilityClasses$R = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["overlay"]
  }, getDataGridUtilityClass, uo);
}, GridOverlayRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "Overlay",
  overridesResolver: (Kt, uo) => uo.overlay
})({
  width: "100%",
  height: "100%",
  display: "flex",
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "var(--unstable_DataGrid-overlayBackground)"
}), GridOverlay = forwardRef(function(uo, ho) {
  const {
    className: go
  } = uo, bo = _objectWithoutPropertiesLoose$h(uo, _excluded$H), vo = useGridRootProps(), Po = useUtilityClasses$R(vo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlayRoot, _extends$q({
    className: clsx(Po.root, go),
    ownerState: vo
  }, bo, {
    ref: ho
  }));
});
process.env.NODE_ENV !== "production" && (GridOverlay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const useUtilityClasses$Q = (Kt) => {
  const {
    classes: uo,
    open: ho
  } = Kt;
  return composeClasses({
    root: ["menuIcon", ho && "menuOpen"],
    button: ["menuIconButton"]
  }, getDataGridUtilityClass, uo);
}, ColumnHeaderMenuIcon = /* @__PURE__ */ React$1.memo((Kt) => {
  var Ro, _o;
  const {
    colDef: uo,
    open: ho,
    columnMenuId: go,
    columnMenuButtonId: bo,
    iconButtonRef: vo
  } = Kt, Po = useGridApiContext(), Co = useGridRootProps(), So = _extends$q({}, Kt, {
    classes: Co.classes
  }), wo = useUtilityClasses$Q(So), Eo = React$1.useCallback((Io) => {
    Io.preventDefault(), Io.stopPropagation(), Po.current.toggleColumnMenu(uo.field);
  }, [Po, uo.field]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: wo.root,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(Co.slots.baseTooltip, _extends$q({
      title: Po.current.getLocaleText("columnMenuLabel"),
      enterDelay: 1e3
    }, (Ro = Co.slotProps) == null ? void 0 : Ro.baseTooltip, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(Co.slots.baseIconButton, _extends$q({
        ref: vo,
        tabIndex: -1,
        className: wo.button,
        "aria-label": Po.current.getLocaleText("columnMenuLabel"),
        size: "small",
        onClick: Eo,
        "aria-haspopup": "menu",
        "aria-expanded": ho,
        "aria-controls": ho ? go : void 0,
        id: bo
      }, (_o = Co.slotProps) == null ? void 0 : _o.baseIconButton, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(Co.slots.columnMenuIcon, {
          fontSize: "inherit"
        })
      }))
    }))
  });
});
function GridColumnHeaderMenu({
  columnMenuId: Kt,
  columnMenuButtonId: uo,
  ContentComponent: ho,
  contentComponentProps: go,
  field: bo,
  open: vo,
  target: Po,
  onExited: Co
}) {
  const So = useGridApiContext(), wo = So.current.getColumn(bo), Eo = useEventCallback((Ro) => {
    Ro && (Ro.stopPropagation(), Po != null && Po.contains(Ro.target)) || So.current.hideColumnMenu();
  });
  return !Po || !wo ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(GridMenu, {
    placement: `bottom-${wo.align === "right" ? "start" : "end"}`,
    open: vo,
    target: Po,
    onClose: Eo,
    onExited: Co,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ho, _extends$q({
      colDef: wo,
      hideMenu: Eo,
      open: vo,
      id: Kt,
      labelledby: uo
    }, go))
  });
}
process.env.NODE_ENV !== "production" && (GridColumnHeaderMenu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnMenuButtonId: PropTypes.string,
  columnMenuId: PropTypes.string,
  ContentComponent: PropTypes.elementType.isRequired,
  contentComponentProps: PropTypes.any,
  field: PropTypes.string.isRequired,
  onExited: PropTypes.func,
  open: PropTypes.bool.isRequired,
  target: HTMLElementType
});
function isOverflown(Kt) {
  return Kt.scrollHeight > Kt.clientHeight || Kt.scrollWidth > Kt.clientWidth;
}
function findParentElementFromClassName(Kt, uo) {
  return Kt.closest(`.${uo}`);
}
function escapeOperandAttributeSelector(Kt) {
  return Kt.replace(/["\\]/g, "\\$&");
}
function getGridColumnHeaderElement(Kt, uo) {
  return Kt.querySelector(`[role="columnheader"][data-field="${escapeOperandAttributeSelector(uo)}"]`);
}
function getGridRowElementSelector(Kt) {
  return `.${gridClasses.row}[data-id="${escapeOperandAttributeSelector(String(Kt))}"]`;
}
function getGridRowElement(Kt, uo) {
  return Kt.querySelector(getGridRowElementSelector(uo));
}
function getGridCellElement(Kt, {
  id: uo,
  field: ho
}) {
  const go = getGridRowElementSelector(uo), bo = `.${gridClasses.cell}[data-field="${escapeOperandAttributeSelector(ho)}"]`, vo = `${go} ${bo}`;
  return Kt.querySelector(vo);
}
function isEventTargetInPortal(Kt) {
  return (
    // The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    Kt.target.nodeType === 1 && !Kt.currentTarget.contains(Kt.target)
  );
}
function getFieldFromHeaderElem(Kt) {
  return Kt.getAttribute("data-field");
}
function findHeaderElementFromField(Kt, uo) {
  return Kt.querySelector(`[data-field="${escapeOperandAttributeSelector(uo)}"]`);
}
function getFieldsFromGroupHeaderElem(Kt) {
  return Kt.getAttribute("data-fields").slice(2, -2).split("-|-");
}
function findGroupHeaderElementsFromField(Kt, uo) {
  return Array.from(Kt.querySelectorAll(`[data-fields*="|-${escapeOperandAttributeSelector(uo)}-|"]`) ?? []);
}
function findGridCellElementsFromCol(Kt, uo) {
  var Po;
  if (!findParentElementFromClassName(Kt, gridClasses.root))
    throw new Error("MUI X: The root element is not found.");
  const go = Kt.getAttribute("aria-colindex");
  if (!go)
    return [];
  const bo = Number(go) - 1, vo = [];
  return (Po = uo.virtualScrollerRef) != null && Po.current ? (queryRows(uo).forEach((Co) => {
    const So = Co.getAttribute("data-id");
    if (!So)
      return;
    let wo = bo;
    const Eo = uo.unstable_getCellColSpanInfo(So, bo);
    Eo && Eo.spannedByColSpan && (wo = Eo.leftVisibleCellIndex);
    const Ro = Co.querySelector(`[data-colindex="${wo}"]`);
    Ro && vo.push(Ro);
  }), vo) : [];
}
function findGridElement(Kt, uo) {
  return Kt.rootElementRef.current.querySelector(`.${gridClasses[uo]}`);
}
const findPinnedCells = ({
  api: Kt,
  colIndex: uo,
  position: ho,
  filterFn: go
}) => {
  if (uo === null)
    return [];
  const bo = [];
  return queryRows(Kt).forEach((vo) => {
    vo.getAttribute("data-id") && vo.querySelectorAll(`.${gridClasses[ho === "left" ? "cell--pinnedLeft" : "cell--pinnedRight"]}`).forEach((Co) => {
      const So = parseCellColIndex(Co);
      So !== null && go(So) && bo.push(Co);
    });
  }), bo;
};
function findLeftPinnedCellsAfterCol(Kt, uo, ho) {
  const go = parseCellColIndex(uo);
  return findPinnedCells({
    api: Kt,
    colIndex: go,
    position: ho ? "right" : "left",
    filterFn: (bo) => ho ? bo < go : bo > go
  });
}
function findRightPinnedCellsBeforeCol(Kt, uo, ho) {
  const go = parseCellColIndex(uo);
  return findPinnedCells({
    api: Kt,
    colIndex: go,
    position: ho ? "left" : "right",
    filterFn: (bo) => ho ? bo > go : bo < go
  });
}
const findPinnedHeaders = ({
  api: Kt,
  colIndex: uo,
  position: ho,
  filterFn: go
}) => {
  var vo;
  if (!((vo = Kt.columnHeadersContainerRef) != null && vo.current))
    return [];
  if (uo === null)
    return [];
  const bo = [];
  return Kt.columnHeadersContainerRef.current.querySelectorAll(`.${gridClasses[ho === "left" ? "columnHeader--pinnedLeft" : "columnHeader--pinnedRight"]}`).forEach((Po) => {
    const Co = parseCellColIndex(Po);
    Co !== null && go(Co) && bo.push(Po);
  }), bo;
};
function findLeftPinnedHeadersAfterCol(Kt, uo, ho) {
  const go = parseCellColIndex(uo);
  return findPinnedHeaders({
    api: Kt,
    position: ho ? "right" : "left",
    colIndex: go,
    filterFn: (bo) => ho ? bo < go : bo > go
  });
}
function findRightPinnedHeadersBeforeCol(Kt, uo, ho) {
  const go = parseCellColIndex(uo);
  return findPinnedHeaders({
    api: Kt,
    position: ho ? "left" : "right",
    colIndex: go,
    filterFn: (bo) => ho ? bo > go : bo < go
  });
}
function findGridHeader(Kt, uo) {
  return Kt.columnHeadersContainerRef.current.querySelector(`:scope > div > [data-field="${escapeOperandAttributeSelector(uo)}"][role="columnheader"]`);
}
function findGridCells(Kt, uo) {
  const ho = Kt.virtualScrollerRef.current;
  return Array.from(ho.querySelectorAll(`:scope > div > div > div > [data-field="${escapeOperandAttributeSelector(uo)}"][role="gridcell"]`));
}
function queryRows(Kt) {
  return Kt.virtualScrollerRef.current.querySelectorAll(
    // Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${gridClasses.row}`
  );
}
function parseCellColIndex(Kt) {
  const uo = Kt.getAttribute("aria-colindex");
  return uo ? Number(uo) - 1 : null;
}
const _excluded$G = ["className", "aria-label"], useUtilityClasses$P = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["columnHeaderTitle"]
  }, getDataGridUtilityClass, uo);
}, GridColumnHeaderTitleRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderTitle",
  overridesResolver: (Kt, uo) => uo.columnHeaderTitle
})({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  fontWeight: "var(--unstable_DataGrid-headWeight)",
  lineHeight: "normal"
}), ColumnHeaderInnerTitle = forwardRef(function(uo, ho) {
  const {
    className: go
  } = uo, bo = _objectWithoutPropertiesLoose$h(uo, _excluded$G), vo = useGridRootProps(), Po = useUtilityClasses$P(vo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnHeaderTitleRoot, _extends$q({
    className: clsx(Po.root, go),
    ownerState: vo
  }, bo, {
    ref: ho
  }));
});
function GridColumnHeaderTitle(Kt) {
  var So;
  const {
    label: uo,
    description: ho
  } = Kt, go = useGridRootProps(), bo = React$1.useRef(null), [vo, Po] = React$1.useState(""), Co = React$1.useCallback(() => {
    if (!ho && (bo != null && bo.current)) {
      const wo = isOverflown(bo.current);
      Po(wo ? uo : "");
    }
  }, [ho, uo]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(go.slots.baseTooltip, _extends$q({
    title: ho || vo
  }, (So = go.slotProps) == null ? void 0 : So.baseTooltip, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnHeaderInnerTitle, {
      onMouseOver: Co,
      ref: bo,
      children: uo
    })
  }));
}
process.env.NODE_ENV !== "production" && (GridColumnHeaderTitle.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnWidth: PropTypes.number.isRequired,
  description: PropTypes.node,
  label: PropTypes.string.isRequired
});
const _excluded$F = ["resizable", "resizing", "height", "side"];
var GridColumnHeaderSeparatorSides = /* @__PURE__ */ function(Kt) {
  return Kt.Left = "left", Kt.Right = "right", Kt;
}(GridColumnHeaderSeparatorSides || {});
const useUtilityClasses$O = (Kt) => {
  const {
    resizable: uo,
    resizing: ho,
    classes: go,
    side: bo
  } = Kt, vo = {
    root: ["columnSeparator", uo && "columnSeparator--resizable", ho && "columnSeparator--resizing", bo && `columnSeparator--side${capitalize(bo)}`],
    icon: ["iconSeparator"]
  };
  return composeClasses(vo, getDataGridUtilityClass, go);
};
function GridColumnHeaderSeparatorRaw(Kt) {
  const {
    height: uo,
    side: ho = GridColumnHeaderSeparatorSides.Right
  } = Kt, go = _objectWithoutPropertiesLoose$h(Kt, _excluded$F), bo = useGridRootProps(), vo = _extends$q({}, Kt, {
    side: ho,
    classes: bo.classes
  }), Po = useUtilityClasses$O(vo), Co = React$1.useCallback((So) => {
    So.preventDefault(), So.stopPropagation();
  }, []);
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", _extends$q({
      className: Po.root,
      style: {
        minHeight: uo
      }
    }, go, {
      onClick: Co,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.columnResizeIcon, {
        className: Po.icon
      })
    }))
  );
}
const GridColumnHeaderSeparator = /* @__PURE__ */ React$1.memo(GridColumnHeaderSeparatorRaw);
process.env.NODE_ENV !== "production" && (GridColumnHeaderSeparatorRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  height: PropTypes.number.isRequired,
  resizable: PropTypes.bool.isRequired,
  resizing: PropTypes.bool.isRequired,
  side: PropTypes.oneOf(["left", "right"])
});
const _excluded$E = ["classes", "columnMenuOpen", "colIndex", "height", "isResizing", "sortDirection", "hasFocus", "tabIndex", "separatorSide", "isDraggable", "headerComponent", "description", "elementId", "width", "columnMenuIconButton", "columnMenu", "columnTitleIconButtons", "headerClassName", "label", "resizable", "draggableContainerProps", "columnHeaderSeparatorProps", "style"], GridGenericColumnHeaderItem = forwardRef(function(uo, ho) {
  const {
    classes: go,
    colIndex: bo,
    height: vo,
    isResizing: Po,
    sortDirection: Co,
    hasFocus: So,
    tabIndex: wo,
    separatorSide: Eo,
    isDraggable: Ro,
    headerComponent: _o,
    description: Io,
    width: Ao,
    columnMenuIconButton: Oo = null,
    columnMenu: jo = null,
    columnTitleIconButtons: Do = null,
    headerClassName: Lo,
    label: ko,
    resizable: Ko,
    draggableContainerProps: No,
    columnHeaderSeparatorProps: Jo,
    style: ti
  } = uo, oi = _objectWithoutPropertiesLoose$h(uo, _excluded$E), Qo = useGridPrivateApiContext(), Zo = useGridRootProps(), ei = React$1.useRef(null), ii = useForkRef(ei, ho);
  let ai = "none";
  return Co != null && (ai = Co === "asc" ? "ascending" : "descending"), React$1.useLayoutEffect(() => {
    var ni;
    const ri = Qo.current.state.columnMenu;
    if (So && !ri.open) {
      const li = ei.current.querySelector('[tabindex="0"]') || ei.current;
      li == null || li.focus(), (ni = Qo.current.columnHeadersContainerRef) != null && ni.current && (Qo.current.columnHeadersContainerRef.current.scrollLeft = 0);
    }
  }, [Qo, So]), /* @__PURE__ */ jsxRuntimeExports.jsxs("div", _extends$q({
    className: clsx(go.root, Lo),
    style: _extends$q({}, ti, {
      height: vo,
      width: Ao
    }),
    role: "columnheader",
    tabIndex: wo,
    "aria-colindex": bo + 1,
    "aria-sort": ai
  }, oi, {
    ref: ii,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("div", _extends$q({
      className: go.draggableContainer,
      draggable: Ro,
      role: "presentation"
    }, No, {
      children: [/* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
        className: go.titleContainer,
        role: "presentation",
        children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
          className: go.titleContainerContent,
          children: _o !== void 0 ? _o : /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnHeaderTitle, {
            label: ko,
            description: Io,
            columnWidth: Ao
          })
        }), Do]
      }), Oo]
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnHeaderSeparator, _extends$q({
      resizable: !Zo.disableColumnResize && !!Ko,
      resizing: Po,
      height: vo,
      side: Eo
    }, Jo)), jo]
  }));
}), useUtilityClasses$N = (Kt) => {
  const {
    colDef: uo,
    classes: ho,
    isDragging: go,
    sortDirection: bo,
    showRightBorder: vo,
    showLeftBorder: Po,
    filterItemsCounter: Co,
    pinnedPosition: So,
    isLastUnpinned: wo,
    isSiblingFocused: Eo
  } = Kt, Ro = bo != null, _o = Co != null && Co > 0, Io = uo.type === "number", Ao = {
    root: [
      "columnHeader",
      uo.headerAlign === "left" && "columnHeader--alignLeft",
      uo.headerAlign === "center" && "columnHeader--alignCenter",
      uo.headerAlign === "right" && "columnHeader--alignRight",
      uo.sortable && "columnHeader--sortable",
      go && "columnHeader--moving",
      Ro && "columnHeader--sorted",
      _o && "columnHeader--filtered",
      Io && "columnHeader--numeric",
      "withBorderColor",
      vo && "columnHeader--withRightBorder",
      Po && "columnHeader--withLeftBorder",
      So === "left" && "columnHeader--pinnedLeft",
      So === "right" && "columnHeader--pinnedRight",
      // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
      // See https://github.com/mui/mui-x/pull/14559
      wo && "columnHeader--lastUnpinned",
      Eo && "columnHeader--siblingFocused"
    ],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  };
  return composeClasses(Ao, getDataGridUtilityClass, ho);
};
function GridColumnHeaderItem(Kt) {
  var vi, Pi, wi;
  const {
    colDef: uo,
    columnMenuOpen: ho,
    colIndex: go,
    headerHeight: bo,
    isResizing: vo,
    isLast: Po,
    sortDirection: Co,
    sortIndex: So,
    filterItemsCounter: wo,
    hasFocus: Eo,
    tabIndex: Ro,
    disableReorder: _o,
    separatorSide: Io,
    style: Ao,
    pinnedPosition: Oo,
    indexInSection: jo,
    sectionLength: Do,
    gridHasFiller: Lo
  } = Kt, ko = useGridPrivateApiContext(), Ko = useGridRootProps(), No = React$1.useRef(null), Jo = useId(), ti = useId(), oi = React$1.useRef(null), [Qo, Zo] = React$1.useState(ho), ei = React$1.useMemo(() => !Ko.disableColumnReorder && !_o && !uo.disableReorder, [Ko.disableColumnReorder, _o, uo.disableReorder]);
  let ii;
  uo.renderHeader && (ii = uo.renderHeader(ko.current.getColumnHeaderParams(uo.field)));
  const ai = shouldCellShowLeftBorder(Oo, jo), ri = shouldCellShowRightBorder(Oo, jo, Do, Ko.showColumnVerticalBorder, Lo), ni = _extends$q({}, Kt, {
    classes: Ko.classes,
    showRightBorder: ri,
    showLeftBorder: ai
  }), si = useUtilityClasses$N(ni), li = React$1.useCallback((gi) => (Ri) => {
    isEventTargetInPortal(Ri) || ko.current.publishEvent(gi, ko.current.getColumnHeaderParams(uo.field), Ri);
  }, [ko, uo.field]), ui = React$1.useMemo(() => ({
    onClick: li("columnHeaderClick"),
    onContextMenu: li("columnHeaderContextMenu"),
    onDoubleClick: li("columnHeaderDoubleClick"),
    onMouseOver: li("columnHeaderOver"),
    // TODO remove as it's not used
    onMouseOut: li("columnHeaderOut"),
    // TODO remove as it's not used
    onMouseEnter: li("columnHeaderEnter"),
    // TODO remove as it's not used
    onMouseLeave: li("columnHeaderLeave"),
    // TODO remove as it's not used
    onKeyDown: li("columnHeaderKeyDown"),
    onFocus: li("columnHeaderFocus"),
    onBlur: li("columnHeaderBlur")
  }), [li]), ci = React$1.useMemo(() => ei ? {
    onDragStart: li("columnHeaderDragStart"),
    onDragEnter: li("columnHeaderDragEnter"),
    onDragOver: li("columnHeaderDragOver"),
    onDragEnd: li("columnHeaderDragEnd")
  } : {}, [ei, li]), fi = React$1.useMemo(() => ({
    onMouseDown: li("columnSeparatorMouseDown"),
    onDoubleClick: li("columnSeparatorDoubleClick")
  }), [li]);
  React$1.useEffect(() => {
    Qo || Zo(ho);
  }, [Qo, ho]);
  const yi = React$1.useCallback(() => {
    Zo(!1);
  }, []), hi = !Ko.disableColumnMenu && !uo.disableColumnMenu && /* @__PURE__ */ jsxRuntimeExports.jsx(ColumnHeaderMenuIcon, {
    colDef: uo,
    columnMenuId: Jo,
    columnMenuButtonId: ti,
    open: Qo,
    iconButtonRef: oi
  }), mi = /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnHeaderMenu, {
    columnMenuId: Jo,
    columnMenuButtonId: ti,
    field: uo.field,
    open: ho,
    target: oi.current,
    ContentComponent: Ko.slots.columnMenu,
    contentComponentProps: (vi = Ko.slotProps) == null ? void 0 : vi.columnMenu,
    onExited: yi
  }), bi = uo.sortingOrder ?? Ko.sortingOrder, xi = (uo.sortable || Co != null) && !uo.hideSortIcons && !Ko.disableColumnSorting, $i = /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [!Ko.disableColumnFilter && /* @__PURE__ */ jsxRuntimeExports.jsx(Ko.slots.columnHeaderFilterIconButton, _extends$q({
      field: uo.field,
      counter: wo
    }, (Pi = Ko.slotProps) == null ? void 0 : Pi.columnHeaderFilterIconButton)), xi && /* @__PURE__ */ jsxRuntimeExports.jsx(Ko.slots.columnHeaderSortIcon, _extends$q({
      field: uo.field,
      direction: Co,
      index: So,
      sortingOrder: bi,
      disabled: !uo.sortable
    }, (wi = Ko.slotProps) == null ? void 0 : wi.columnHeaderSortIcon))]
  });
  React$1.useLayoutEffect(() => {
    var Ri;
    const gi = ko.current.state.columnMenu;
    if (Eo && !gi.open) {
      const Ni = No.current.querySelector('[tabindex="0"]') || No.current;
      Ni == null || Ni.focus(), (Ri = ko.current.columnHeadersContainerRef) != null && Ri.current && (ko.current.columnHeadersContainerRef.current.scrollLeft = 0);
    }
  }, [ko, Eo]);
  const Ci = typeof uo.headerClassName == "function" ? uo.headerClassName({
    field: uo.field,
    colDef: uo
  }) : uo.headerClassName, Si = uo.headerName ?? uo.field;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridGenericColumnHeaderItem, _extends$q({
    ref: No,
    classes: si,
    columnMenuOpen: ho,
    colIndex: go,
    height: bo,
    isResizing: vo,
    sortDirection: Co,
    hasFocus: Eo,
    tabIndex: Ro,
    separatorSide: Io,
    isDraggable: ei,
    headerComponent: ii,
    description: uo.description,
    elementId: uo.field,
    width: uo.computedWidth,
    columnMenuIconButton: hi,
    columnTitleIconButtons: $i,
    headerClassName: clsx(Ci, Po && gridClasses["columnHeader--last"]),
    label: Si,
    resizable: !Ko.disableColumnResize && !!uo.resizable,
    "data-field": uo.field,
    columnMenu: mi,
    draggableContainerProps: ci,
    columnHeaderSeparatorProps: fi,
    style: Ao
  }, ui));
}
process.env.NODE_ENV !== "production" && (GridColumnHeaderItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  colIndex: PropTypes.number.isRequired,
  columnMenuOpen: PropTypes.bool.isRequired,
  disableReorder: PropTypes.bool,
  filterItemsCounter: PropTypes.number,
  gridHasFiller: PropTypes.bool.isRequired,
  hasFocus: PropTypes.bool,
  headerHeight: PropTypes.number.isRequired,
  indexInSection: PropTypes.number.isRequired,
  isDragging: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
  isLastUnpinned: PropTypes.bool.isRequired,
  isResizing: PropTypes.bool.isRequired,
  isSiblingFocused: PropTypes.bool.isRequired,
  pinnedPosition: PropTypes.oneOf(["left", "right"]),
  sectionLength: PropTypes.number.isRequired,
  separatorSide: PropTypes.oneOf(["left", "right"]),
  sortDirection: PropTypes.oneOf(["asc", "desc"]),
  sortIndex: PropTypes.number,
  style: PropTypes.object,
  tabIndex: PropTypes.oneOf([-1, 0]).isRequired
});
const Memoized = fastMemo(GridColumnHeaderItem), _excluded$D = ["className"], useUtilityClasses$M = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["iconButtonContainer"]
  }, getDataGridUtilityClass, uo);
}, GridIconButtonContainerRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "IconButtonContainer",
  overridesResolver: (Kt, uo) => uo.iconButtonContainer
})(() => ({
  display: "flex",
  visibility: "hidden",
  width: 0
})), GridIconButtonContainer = forwardRef(function(uo, ho) {
  const {
    className: go
  } = uo, bo = _objectWithoutPropertiesLoose$h(uo, _excluded$D), vo = useGridRootProps(), Po = useUtilityClasses$M(vo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridIconButtonContainerRoot, _extends$q({
    className: clsx(Po.root, go),
    ownerState: vo
  }, bo, {
    ref: ho
  }));
}), _excluded$C = ["direction", "index", "sortingOrder", "disabled"], useUtilityClasses$L = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    icon: ["sortIcon"]
  }, getDataGridUtilityClass, uo);
};
function getIcon(Kt, uo, ho, go) {
  let bo;
  const vo = {};
  return uo === "asc" ? bo = Kt.columnSortedAscendingIcon : uo === "desc" ? bo = Kt.columnSortedDescendingIcon : (bo = Kt.columnUnsortedIcon, vo.sortingOrder = go), bo ? /* @__PURE__ */ jsxRuntimeExports.jsx(bo, _extends$q({
    fontSize: "small",
    className: ho
  }, vo)) : null;
}
function GridColumnHeaderSortIconRaw(Kt) {
  var _o;
  const {
    direction: uo,
    index: ho,
    sortingOrder: go,
    disabled: bo
  } = Kt, vo = _objectWithoutPropertiesLoose$h(Kt, _excluded$C), Po = useGridApiContext(), Co = useGridRootProps(), So = _extends$q({}, Kt, {
    classes: Co.classes
  }), wo = useUtilityClasses$L(So), Eo = getIcon(Co.slots, uo, wo.icon, go);
  if (!Eo)
    return null;
  const Ro = /* @__PURE__ */ jsxRuntimeExports.jsx(Co.slots.baseIconButton, _extends$q({
    tabIndex: -1,
    "aria-label": Po.current.getLocaleText("columnHeaderSortIconLabel"),
    title: Po.current.getLocaleText("columnHeaderSortIconLabel"),
    size: "small",
    disabled: bo
  }, (_o = Co.slotProps) == null ? void 0 : _o.baseIconButton, vo, {
    children: Eo
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridIconButtonContainer, {
    children: [ho != null && /* @__PURE__ */ jsxRuntimeExports.jsx(Co.slots.baseBadge, {
      badgeContent: ho,
      color: "default",
      overlap: "circular",
      children: Ro
    }), ho == null && Ro]
  });
}
const GridColumnHeaderSortIcon = /* @__PURE__ */ React$1.memo(GridColumnHeaderSortIconRaw);
process.env.NODE_ENV !== "production" && (GridColumnHeaderSortIconRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  direction: PropTypes.oneOf(["asc", "desc"]),
  disabled: PropTypes.bool,
  field: PropTypes.string.isRequired,
  index: PropTypes.number,
  sortingOrder: PropTypes.arrayOf(PropTypes.oneOf(["asc", "desc"])).isRequired
});
const useUtilityClasses$K = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    icon: ["filterIcon"]
  }, getDataGridUtilityClass, uo);
};
function GridColumnHeaderFilterIconButton(Kt) {
  var Ao, Oo;
  const {
    counter: uo,
    field: ho,
    onClick: go
  } = Kt, bo = useGridApiContext(), vo = useGridRootProps(), Po = _extends$q({}, Kt, {
    classes: vo.classes
  }), Co = useUtilityClasses$K(Po), So = useGridSelector(bo, gridPreferencePanelStateSelector), wo = useId(), Eo = useId(), Ro = React$1.useCallback((jo) => {
    jo.preventDefault(), jo.stopPropagation();
    const {
      open: Do,
      openedPanelValue: Lo
    } = gridPreferencePanelStateSelector(bo.current.state);
    Do && Lo === GridPreferencePanelsValue.filters ? bo.current.hideFilterPanel() : bo.current.showFilterPanel(void 0, Eo, wo), go && go(bo.current.getColumnHeaderParams(ho), jo);
  }, [bo, ho, go, Eo, wo]);
  if (!uo)
    return null;
  const _o = So.open && So.labelId === wo, Io = /* @__PURE__ */ jsxRuntimeExports.jsx(vo.slots.baseIconButton, _extends$q({
    id: wo,
    onClick: Ro,
    color: "default",
    "aria-label": bo.current.getLocaleText("columnHeaderFiltersLabel"),
    size: "small",
    tabIndex: -1,
    "aria-haspopup": "menu",
    "aria-expanded": _o,
    "aria-controls": _o ? Eo : void 0
  }, (Ao = vo.slotProps) == null ? void 0 : Ao.baseIconButton, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(vo.slots.columnFilteredIcon, {
      className: Co.icon,
      fontSize: "small"
    })
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(vo.slots.baseTooltip, _extends$q({
    title: bo.current.getLocaleText("columnHeaderFiltersTooltipActive")(uo),
    enterDelay: 1e3
  }, (Oo = vo.slotProps) == null ? void 0 : Oo.baseTooltip, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(GridIconButtonContainer, {
      children: [uo > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(vo.slots.baseBadge, {
        badgeContent: uo,
        color: "default",
        children: Io
      }), uo === 1 && Io]
    })
  }));
}
process.env.NODE_ENV !== "production" && (GridColumnHeaderFilterIconButton.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  counter: PropTypes.number,
  field: PropTypes.string.isRequired,
  onClick: PropTypes.func
});
const GridArrowUpwardIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), "ArrowUpward"), GridArrowDownwardIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward"), GridKeyboardArrowRight = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "KeyboardArrowRight"), GridExpandMoreIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore"), GridFilterListIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), "FilterList"), GridFilterAltIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), "FilterAlt"), GridSearchIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), "Search");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), "Menu");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckCircle");
const GridColumnIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
}), "ColumnIcon"), GridSeparatorIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("rect", {
  width: "1",
  height: "24",
  x: "11.5",
  rx: "0.5"
}), "Separator"), GridViewHeadlineIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), "ViewHeadline"), GridTableRowsIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), "TableRows"), GridViewStreamIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), "ViewStream"), GridTripleDotsVerticalIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "TripleDotsVertical"), GridCloseIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), GridAddIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), "Add"), GridRemoveIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 13H5v-2h14v2z"
}), "Remove"), GridLoadIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), "Load"), GridDragIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "Drag"), GridSaveAltIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
}), "SaveAlt"), GridCheckIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), "Check"), GridMoreVertIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreVert"), GridVisibilityOffIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), "VisibilityOff"), GridViewColumnIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("g", {
  children: /* @__PURE__ */ jsxRuntimeExports.jsx("path", {
    d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
  })
}), "ViewColumn"), GridClearIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
const GridDeleteForeverIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), "Delete");
function isPrintableKey(Kt) {
  return Kt.key.length === 1 && !Kt.ctrlKey && !Kt.metaKey;
}
const isNavigationKey = (Kt) => Kt.indexOf("Arrow") === 0 || Kt.indexOf("Page") === 0 || Kt === " " || Kt === "Home" || Kt === "End", isKeyboardEvent = (Kt) => !!Kt.key, isHideMenuKey = (Kt) => Kt === "Tab" || Kt === "Escape";
function isPasteShortcut(Kt) {
  return (Kt.ctrlKey || Kt.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
  // for example, it would be another letter on a Dvorak physical keyboard.
  // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
  // for example, it would be ה on a Hebrew keyboard layout.
  // https://github.com/w3c/uievents/issues/377 could be a long-term solution
  String.fromCharCode(Kt.keyCode) === "V" && !Kt.shiftKey && !Kt.altKey;
}
function isCopyShortcut(Kt) {
  return (Kt.ctrlKey || Kt.metaKey) && String.fromCharCode(Kt.keyCode) === "C" && !Kt.shiftKey && !Kt.altKey;
}
const _excluded$B = ["hideMenu", "colDef", "id", "labelledby", "className", "children", "open"], StyledMenuList = styled(MenuList)(() => ({
  minWidth: 248
})), GridColumnMenuContainer = forwardRef(function(uo, ho) {
  const {
    hideMenu: go,
    id: bo,
    labelledby: vo,
    className: Po,
    children: Co,
    open: So
  } = uo, wo = _objectWithoutPropertiesLoose$h(uo, _excluded$B), Eo = React$1.useCallback((Ro) => {
    Ro.key === "Tab" && Ro.preventDefault(), isHideMenuKey(Ro.key) && go(Ro);
  }, [go]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StyledMenuList, _extends$q({
    id: bo,
    className: clsx(gridClasses.menuList, Po),
    "aria-labelledby": vo,
    onKeyDown: Eo,
    autoFocus: So
  }, wo, {
    ref: ho,
    children: Co
  }));
});
process.env.NODE_ENV !== "production" && (GridColumnMenuContainer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  hideMenu: PropTypes.func.isRequired,
  id: PropTypes.string,
  labelledby: PropTypes.string,
  open: PropTypes.bool.isRequired
});
const _excluded$A = ["displayOrder"], useGridColumnMenuSlots = (Kt) => {
  const uo = useGridPrivateApiContext(), ho = useGridRootProps(), {
    defaultSlots: go,
    defaultSlotProps: bo,
    slots: vo = {},
    slotProps: Po = {},
    hideMenu: Co,
    colDef: So,
    addDividers: wo = !0
  } = Kt, Eo = React$1.useMemo(() => _extends$q({}, go, vo), [go, vo]), Ro = React$1.useMemo(() => {
    if (!Po || Object.keys(Po).length === 0)
      return bo;
    const Ao = _extends$q({}, Po);
    return Object.entries(bo).forEach(([Oo, jo]) => {
      Ao[Oo] = _extends$q({}, jo, Po[Oo] || {});
    }), Ao;
  }, [bo, Po]), _o = uo.current.unstable_applyPipeProcessors("columnMenu", [], Kt.colDef), Io = React$1.useMemo(() => {
    const Ao = Object.keys(go);
    return Object.keys(vo).filter((Oo) => !Ao.includes(Oo));
  }, [vo, go]);
  return React$1.useMemo(() => {
    const jo = Array.from(/* @__PURE__ */ new Set([..._o, ...Io])).filter((Do) => Eo[Do] != null).sort((Do, Lo) => {
      const ko = Ro[Do], Ko = Ro[Lo], No = Number.isFinite(ko == null ? void 0 : ko.displayOrder) ? ko.displayOrder : 100, Jo = Number.isFinite(Ko == null ? void 0 : Ko.displayOrder) ? Ko.displayOrder : 100;
      return No - Jo;
    });
    return jo.reduce((Do, Lo, ko) => {
      let Ko = {
        colDef: So,
        onClick: Co
      };
      const No = Ro[Lo];
      if (No) {
        const Jo = _objectWithoutPropertiesLoose$h(No, _excluded$A);
        Ko = _extends$q({}, Ko, Jo);
      }
      return wo && ko !== jo.length - 1 ? [...Do, [Eo[Lo], Ko], [ho.slots.baseDivider, {}]] : [...Do, [Eo[Lo], Ko]];
    }, []);
  }, [wo, So, _o, Co, Eo, Ro, Io, ho.slots.baseDivider]);
};
function GridColumnMenuHideItem(Kt) {
  const {
    colDef: uo,
    onClick: ho
  } = Kt, go = useGridApiContext(), bo = useGridRootProps(), Co = gridVisibleColumnDefinitionsSelector(go).filter((wo) => wo.disableColumnMenu !== !0).length === 1, So = React$1.useCallback((wo) => {
    Co || (go.current.setColumnVisibility(uo.field, !1), ho(wo));
  }, [go, uo.field, ho, Co]);
  return bo.disableColumnSelector || uo.hideable === !1 ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, {
    onClick: So,
    disabled: Co,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.columnMenuHideIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, {
      children: go.current.getLocaleText("columnMenuHideColumn")
    })]
  });
}
process.env.NODE_ENV !== "production" && (GridColumnMenuHideItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
});
function GridColumnMenuManageItem(Kt) {
  const {
    onClick: uo
  } = Kt, ho = useGridApiContext(), go = useGridRootProps(), bo = React$1.useCallback((vo) => {
    uo(vo), ho.current.showPreferences(GridPreferencePanelsValue.columns);
  }, [ho, uo]);
  return go.disableColumnSelector ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, {
    onClick: bo,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(go.slots.columnMenuManageColumnsIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, {
      children: ho.current.getLocaleText("columnMenuManageColumns")
    })]
  });
}
process.env.NODE_ENV !== "production" && (GridColumnMenuManageItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
});
function GridColumnMenuColumnsItem(Kt) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnMenuHideItem, _extends$q({}, Kt)), /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnMenuManageItem, _extends$q({}, Kt))]
  });
}
process.env.NODE_ENV !== "production" && (GridColumnMenuColumnsItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
});
function GridColumnMenuFilterItem(Kt) {
  const {
    colDef: uo,
    onClick: ho
  } = Kt, go = useGridApiContext(), bo = useGridRootProps(), vo = React$1.useCallback((Po) => {
    ho(Po), go.current.showFilterPanel(uo.field);
  }, [go, uo.field, ho]);
  return bo.disableColumnFilter || !uo.filterable ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, {
    onClick: vo,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.columnMenuFilterIcon, {
        fontSize: "small"
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, {
      children: go.current.getLocaleText("columnMenuFilter")
    })]
  });
}
process.env.NODE_ENV !== "production" && (GridColumnMenuFilterItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
});
function GridColumnMenuSortItem(Kt) {
  const {
    colDef: uo,
    onClick: ho
  } = Kt, go = useGridApiContext(), bo = useGridSelector(go, gridSortModelSelector), vo = useGridRootProps(), Po = React$1.useMemo(() => {
    if (!uo)
      return null;
    const Eo = bo.find((Ro) => Ro.field === uo.field);
    return Eo == null ? void 0 : Eo.sort;
  }, [uo, bo]), Co = uo.sortingOrder ?? vo.sortingOrder, So = React$1.useCallback((Eo) => {
    ho(Eo);
    const Ro = Eo.currentTarget.getAttribute("data-value") || null;
    go.current.sortColumn(uo.field, Ro === Po ? null : Ro);
  }, [go, uo, ho, Po]);
  if (vo.disableColumnSorting || !uo || !uo.sortable || !Co.some((Eo) => !!Eo))
    return null;
  const wo = (Eo) => {
    const Ro = go.current.getLocaleText(Eo);
    return typeof Ro == "function" ? Ro(uo) : Ro;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [Co.includes("asc") && Po !== "asc" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, {
      onClick: So,
      "data-value": "asc",
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(vo.slots.columnMenuSortAscendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, {
        children: wo("columnMenuSortAsc")
      })]
    }) : null, Co.includes("desc") && Po !== "desc" ? /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, {
      onClick: So,
      "data-value": "desc",
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(vo.slots.columnMenuSortDescendingIcon, {
          fontSize: "small"
        })
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, {
        children: wo("columnMenuSortDesc")
      })]
    }) : null, Co.includes(null) && Po != null ? /* @__PURE__ */ jsxRuntimeExports.jsxs(MenuItem, {
      onClick: So,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ListItemIcon, {}), /* @__PURE__ */ jsxRuntimeExports.jsx(ListItemText, {
        children: go.current.getLocaleText("columnMenuUnsort")
      })]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" && (GridColumnMenuSortItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
});
const _excluded$z = ["defaultSlots", "defaultSlotProps", "slots", "slotProps"], GRID_COLUMN_MENU_SLOTS = {
  columnMenuSortItem: GridColumnMenuSortItem,
  columnMenuFilterItem: GridColumnMenuFilterItem,
  columnMenuColumnsItem: GridColumnMenuColumnsItem
}, GRID_COLUMN_MENU_SLOT_PROPS = {
  columnMenuSortItem: {
    displayOrder: 10
  },
  columnMenuFilterItem: {
    displayOrder: 20
  },
  columnMenuColumnsItem: {
    displayOrder: 30
  }
}, GridGenericColumnMenu = forwardRef(function(uo, ho) {
  const {
    defaultSlots: go,
    defaultSlotProps: bo,
    slots: vo,
    slotProps: Po
  } = uo, Co = _objectWithoutPropertiesLoose$h(uo, _excluded$z), So = useGridColumnMenuSlots(_extends$q({}, Co, {
    defaultSlots: go,
    defaultSlotProps: bo,
    slots: vo,
    slotProps: Po
  }));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnMenuContainer, _extends$q({}, Co, {
    ref: ho,
    children: So.map(([wo, Eo], Ro) => /* @__PURE__ */ jsxRuntimeExports.jsx(wo, _extends$q({}, Eo), Ro))
  }));
});
process.env.NODE_ENV !== "production" && (GridGenericColumnMenu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  /**
   * Initial `slotProps` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */
  defaultSlotProps: PropTypes.object.isRequired,
  /**
   * Initial `slots` - it is internal, to be overrriden by Pro or Premium packages
   * @ignore - do not document.
   */
  defaultSlots: PropTypes.object.isRequired,
  hideMenu: PropTypes.func.isRequired,
  id: PropTypes.string,
  labelledby: PropTypes.string,
  open: PropTypes.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: PropTypes.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: PropTypes.object
});
const GridColumnMenu = forwardRef(function(uo, ho) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridGenericColumnMenu, _extends$q({}, uo, {
    ref: ho,
    defaultSlots: GRID_COLUMN_MENU_SLOTS,
    defaultSlotProps: GRID_COLUMN_MENU_SLOT_PROPS
  }));
});
process.env.NODE_ENV !== "production" && (GridColumnMenu.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  colDef: PropTypes.object.isRequired,
  hideMenu: PropTypes.func.isRequired,
  id: PropTypes.string,
  labelledby: PropTypes.string,
  open: PropTypes.bool.isRequired,
  /**
   * Could be used to pass new props or override props specific to a column menu component
   * e.g. `displayOrder`
   */
  slotProps: PropTypes.object,
  /**
   * `slots` could be used to add new and (or) override default column menu items
   * If you register a nee component you must pass it's `displayOrder` in `slotProps`
   * or it will be placed in the end of the list
   */
  slots: PropTypes.object
});
const candidatesSelector = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function getTabIndex(Kt) {
  const uo = parseInt(Kt.getAttribute("tabindex") || "", 10);
  return Number.isNaN(uo) ? Kt.contentEditable === "true" || (Kt.nodeName === "AUDIO" || Kt.nodeName === "VIDEO" || Kt.nodeName === "DETAILS") && Kt.getAttribute("tabindex") === null ? 0 : Kt.tabIndex : uo;
}
function isNonTabbableRadio(Kt) {
  if (Kt.tagName !== "INPUT" || Kt.type !== "radio" || !Kt.name)
    return !1;
  const uo = (go) => Kt.ownerDocument.querySelector(`input[type="radio"]${go}`);
  let ho = uo(`[name="${Kt.name}"]:checked`);
  return ho || (ho = uo(`[name="${Kt.name}"]`)), ho !== Kt;
}
function isNodeMatchingSelectorFocusable(Kt) {
  return !(Kt.disabled || Kt.tagName === "INPUT" && Kt.type === "hidden" || isNonTabbableRadio(Kt));
}
function defaultGetTabbable(Kt) {
  const uo = [], ho = [];
  return Array.from(Kt.querySelectorAll(candidatesSelector)).forEach((go, bo) => {
    const vo = getTabIndex(go);
    vo === -1 || !isNodeMatchingSelectorFocusable(go) || (vo === 0 ? uo.push(go) : ho.push({
      documentOrder: bo,
      tabIndex: vo,
      node: go
    }));
  }), ho.sort((go, bo) => go.tabIndex === bo.tabIndex ? go.documentOrder - bo.documentOrder : go.tabIndex - bo.tabIndex).map((go) => go.node).concat(uo);
}
function defaultIsEnabled() {
  return !0;
}
function FocusTrap(Kt) {
  const {
    children: uo,
    disableAutoFocus: ho = !1,
    disableEnforceFocus: go = !1,
    disableRestoreFocus: bo = !1,
    getTabbable: vo = defaultGetTabbable,
    isEnabled: Po = defaultIsEnabled,
    open: Co
  } = Kt, So = React$1.useRef(!1), wo = React$1.useRef(null), Eo = React$1.useRef(null), Ro = React$1.useRef(null), _o = React$1.useRef(null), Io = React$1.useRef(!1), Ao = React$1.useRef(null), Oo = useForkRef(getReactElementRef(uo), Ao), jo = React$1.useRef(null);
  React$1.useEffect(() => {
    !Co || !Ao.current || (Io.current = !ho);
  }, [ho, Co]), React$1.useEffect(() => {
    if (!Co || !Ao.current)
      return;
    const ko = ownerDocument(Ao.current);
    return Ao.current.contains(ko.activeElement) || (Ao.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), Ao.current.setAttribute("tabIndex", "-1")), Io.current && Ao.current.focus()), () => {
      bo || (Ro.current && Ro.current.focus && (So.current = !0, Ro.current.focus()), Ro.current = null);
    };
  }, [Co]), React$1.useEffect(() => {
    if (!Co || !Ao.current)
      return;
    const ko = ownerDocument(Ao.current), Ko = (ti) => {
      jo.current = ti, !(go || !Po() || ti.key !== "Tab") && ko.activeElement === Ao.current && ti.shiftKey && (So.current = !0, Eo.current && Eo.current.focus());
    }, No = () => {
      var Qo, Zo;
      const ti = Ao.current;
      if (ti === null)
        return;
      if (!ko.hasFocus() || !Po() || So.current) {
        So.current = !1;
        return;
      }
      if (ti.contains(ko.activeElement) || go && ko.activeElement !== wo.current && ko.activeElement !== Eo.current)
        return;
      if (ko.activeElement !== _o.current)
        _o.current = null;
      else if (_o.current !== null)
        return;
      if (!Io.current)
        return;
      let oi = [];
      if ((ko.activeElement === wo.current || ko.activeElement === Eo.current) && (oi = vo(Ao.current)), oi.length > 0) {
        const ei = !!((Qo = jo.current) != null && Qo.shiftKey && ((Zo = jo.current) == null ? void 0 : Zo.key) === "Tab"), ii = oi[0], ai = oi[oi.length - 1];
        typeof ii != "string" && typeof ai != "string" && (ei ? ai.focus() : ii.focus());
      } else
        ti.focus();
    };
    ko.addEventListener("focusin", No), ko.addEventListener("keydown", Ko, !0);
    const Jo = setInterval(() => {
      ko.activeElement && ko.activeElement.tagName === "BODY" && No();
    }, 50);
    return () => {
      clearInterval(Jo), ko.removeEventListener("focusin", No), ko.removeEventListener("keydown", Ko, !0);
    };
  }, [ho, go, bo, Po, Co, vo]);
  const Do = (ko) => {
    Ro.current === null && (Ro.current = ko.relatedTarget), Io.current = !0, _o.current = ko.target;
    const Ko = uo.props.onFocus;
    Ko && Ko(ko);
  }, Lo = (ko) => {
    Ro.current === null && (Ro.current = ko.relatedTarget), Io.current = !0;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: Co ? 0 : -1,
      onFocus: Lo,
      ref: wo,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ React$1.cloneElement(uo, {
      ref: Oo,
      onFocus: Do
    }), /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      tabIndex: Co ? 0 : -1,
      onFocus: Lo,
      ref: Eo,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: PropTypes.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: PropTypes.func,
  /**
   * If `true`, focus is locked.
   */
  open: PropTypes.bool.isRequired
});
process.env.NODE_ENV !== "production" && (FocusTrap.propTypes = exactProp(FocusTrap.propTypes));
const _excluded$y = ["className", "slotProps"], useUtilityClasses$J = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["panelWrapper"]
  }, getDataGridUtilityClass, uo);
}, GridPanelWrapperRoot = styled("div", {
  name: "MuiDataGrid",
  slot: "PanelWrapper",
  overridesResolver: (Kt, uo) => uo.panelWrapper
})({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  "&:focus": {
    outline: 0
  }
}), isEnabled = () => !0, GridPanelWrapper = forwardRef(function(uo, ho) {
  const {
    className: go,
    slotProps: bo = {}
  } = uo, vo = _objectWithoutPropertiesLoose$h(uo, _excluded$y), Po = useGridRootProps(), Co = useUtilityClasses$J(Po);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, _extends$q({
    open: !0,
    disableEnforceFocus: !0,
    isEnabled
  }, bo.TrapFocus, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(GridPanelWrapperRoot, _extends$q({
      tabIndex: -1,
      className: clsx(Co.root, go),
      ownerState: Po
    }, vo, {
      ref: ho
    }))
  }));
});
process.env.NODE_ENV !== "production" && (GridPanelWrapper.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: PropTypes.object
});
function GridColumnsPanel(Kt) {
  var ho;
  const uo = useGridRootProps();
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridPanelWrapper, _extends$q({}, Kt, {
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(uo.slots.columnsManagement, _extends$q({}, (ho = uo.slotProps) == null ? void 0 : ho.columnsManagement))
  }));
}
process.env.NODE_ENV !== "production" && (GridColumnsPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  slotProps: PropTypes.object
});
const _excluded$x = ["children", "className", "classes"], gridPanelClasses = generateUtilityClasses$1("MuiDataGrid", ["panel", "paper"]), GridPanelRoot = styled(Popper, {
  name: "MuiDataGrid",
  slot: "Panel",
  overridesResolver: (Kt, uo) => uo.panel
})(({
  theme: Kt
}) => ({
  zIndex: Kt.zIndex.modal
})), GridPaperRoot = styled(Paper, {
  name: "MuiDataGrid",
  slot: "Paper",
  overridesResolver: (Kt, uo) => uo.paper
})(({
  theme: Kt
}) => ({
  backgroundColor: (Kt.vars || Kt).palette.background.paper,
  minWidth: 300,
  maxHeight: 450,
  display: "flex",
  maxWidth: `calc(100vw - ${Kt.spacing(0.5)})`,
  overflow: "auto"
})), GridPanel = forwardRef((Kt, uo) => {
  const {
    children: ho,
    className: go
  } = Kt, bo = _objectWithoutPropertiesLoose$h(Kt, _excluded$x), vo = useGridApiContext(), Po = useGridRootProps(), Co = gridPanelClasses, [So, wo] = React$1.useState(!1), Eo = React$1.useCallback(() => {
    vo.current.hidePreferences();
  }, [vo]), Ro = React$1.useCallback((Oo) => {
    Oo.key === "Escape" && vo.current.hidePreferences();
  }, [vo]), _o = React$1.useMemo(() => [{
    name: "flip",
    enabled: !0,
    options: {
      rootBoundary: "document"
    }
  }, {
    name: "isPlaced",
    enabled: !0,
    phase: "main",
    fn: () => {
      wo(!0);
    },
    effect: () => () => {
      wo(!1);
    }
  }], []), [Io, Ao] = React$1.useState(null);
  return React$1.useEffect(() => {
    var jo, Do;
    const Oo = (Do = (jo = vo.current.rootElementRef) == null ? void 0 : jo.current) == null ? void 0 : Do.querySelector('[data-id="gridPanelAnchor"]');
    Oo && Ao(Oo);
  }, [vo]), Io ? /* @__PURE__ */ jsxRuntimeExports.jsx(GridPanelRoot, _extends$q({
    placement: "bottom-start",
    className: clsx(Co.panel, go),
    ownerState: Po,
    anchorEl: Io,
    modifiers: _o
  }, bo, {
    ref: uo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ClickAwayListener, {
      mouseEvent: "onMouseUp",
      onClickAway: Eo,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(GridPaperRoot, {
        className: Co.paper,
        ownerState: Po,
        elevation: 8,
        onKeyDown: Ro,
        children: So && ho
      })
    })
  })) : null;
});
process.env.NODE_ENV !== "production" && (GridPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Popper render function or node.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  ownerState: PropTypes.object
});
const _excluded$w = ["className"], useUtilityClasses$I = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["panelContent"]
  }, getDataGridUtilityClass, uo);
}, GridPanelContentRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "PanelContent",
  overridesResolver: (Kt, uo) => uo.panelContent
})({
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: "1 1",
  maxHeight: 400
});
function GridPanelContent(Kt) {
  const {
    className: uo
  } = Kt, ho = _objectWithoutPropertiesLoose$h(Kt, _excluded$w), go = useGridRootProps(), bo = useUtilityClasses$I(go);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridPanelContentRoot, _extends$q({
    className: clsx(bo.root, uo),
    ownerState: go
  }, ho));
}
process.env.NODE_ENV !== "production" && (GridPanelContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const _excluded$v = ["className"], useUtilityClasses$H = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["panelFooter"]
  }, getDataGridUtilityClass, uo);
}, GridPanelFooterRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "PanelFooter",
  overridesResolver: (Kt, uo) => uo.panelFooter
})(({
  theme: Kt
}) => ({
  padding: Kt.spacing(0.5),
  display: "flex",
  justifyContent: "space-between"
}));
function GridPanelFooter(Kt) {
  const {
    className: uo
  } = Kt, ho = _objectWithoutPropertiesLoose$h(Kt, _excluded$v), go = useGridRootProps(), bo = useUtilityClasses$H(go);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridPanelFooterRoot, _extends$q({
    className: clsx(bo.root, uo),
    ownerState: go
  }, ho));
}
process.env.NODE_ENV !== "production" && (GridPanelFooter.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const _excluded$u = ["item", "hasMultipleFilters", "deleteFilter", "applyFilterChanges", "showMultiFilterOperators", "disableMultiFilterOperator", "applyMultiFilterOperatorChanges", "focusElementRef", "logicOperators", "columnsSort", "filterColumns", "deleteIconProps", "logicOperatorInputProps", "operatorInputProps", "columnInputProps", "valueInputProps", "readOnly", "children"], _excluded2$9 = ["InputComponentProps"], useUtilityClasses$G = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["filterForm"],
    deleteIcon: ["filterFormDeleteIcon"],
    logicOperatorInput: ["filterFormLogicOperatorInput"],
    columnInput: ["filterFormColumnInput"],
    operatorInput: ["filterFormOperatorInput"],
    valueInput: ["filterFormValueInput"]
  }, getDataGridUtilityClass, uo);
}, GridFilterFormRoot = styled("div", {
  name: "MuiDataGrid",
  slot: "FilterForm",
  overridesResolver: (Kt, uo) => uo.filterForm
})(({
  theme: Kt
}) => ({
  display: "flex",
  padding: Kt.spacing(1)
})), FilterFormDeleteIcon = styled("div", {
  name: "MuiDataGrid",
  slot: "FilterFormDeleteIcon",
  overridesResolver: (Kt, uo) => uo.filterFormDeleteIcon
})(({
  theme: Kt
}) => ({
  flexShrink: 0,
  justifyContent: "flex-end",
  marginRight: Kt.spacing(0.5),
  marginBottom: Kt.spacing(0.2)
})), FilterFormLogicOperatorInput = styled("div", {
  name: "MuiDataGrid",
  slot: "FilterFormLogicOperatorInput",
  overridesResolver: (Kt, uo) => uo.filterFormLogicOperatorInput
})({
  minWidth: 55,
  marginRight: 5,
  justifyContent: "end"
}), FilterFormColumnInput = styled("div", {
  name: "MuiDataGrid",
  slot: "FilterFormColumnInput",
  overridesResolver: (Kt, uo) => uo.filterFormColumnInput
})({
  width: 150
}), FilterFormOperatorInput = styled("div", {
  name: "MuiDataGrid",
  slot: "FilterFormOperatorInput",
  overridesResolver: (Kt, uo) => uo.filterFormOperatorInput
})({
  width: 150
}), FilterFormValueInput = styled("div", {
  name: "MuiDataGrid",
  slot: "FilterFormValueInput",
  overridesResolver: (Kt, uo) => uo.filterFormValueInput
})({
  width: 190
}), getLogicOperatorLocaleKey = (Kt) => {
  switch (Kt) {
    case GridLogicOperator.And:
      return "filterPanelOperatorAnd";
    case GridLogicOperator.Or:
      return "filterPanelOperatorOr";
    default:
      throw new Error("MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.");
  }
}, getColumnLabel = (Kt) => Kt.headerName || Kt.field, collator$1 = new Intl.Collator(), GridFilterForm = forwardRef(function(uo, ho) {
  var Ni, Ai, Yi, Ui, us, ns, Ti, _i, Vi;
  const {
    item: go,
    hasMultipleFilters: bo,
    deleteFilter: vo,
    applyFilterChanges: Po,
    showMultiFilterOperators: Co,
    disableMultiFilterOperator: So,
    applyMultiFilterOperatorChanges: wo,
    focusElementRef: Eo,
    logicOperators: Ro = [GridLogicOperator.And, GridLogicOperator.Or],
    columnsSort: _o,
    filterColumns: Io,
    deleteIconProps: Ao = {},
    logicOperatorInputProps: Oo = {},
    operatorInputProps: jo = {},
    columnInputProps: Do = {},
    valueInputProps: Lo = {},
    readOnly: ko
  } = uo, Ko = _objectWithoutPropertiesLoose$h(uo, _excluded$u), No = useGridApiContext(), Jo = useGridSelector(No, gridColumnLookupSelector), ti = useGridSelector(No, gridFilterableColumnDefinitionsSelector), oi = useGridSelector(No, gridFilterModelSelector), Qo = useId(), Zo = useId(), ei = useId(), ii = useId(), ai = useGridRootProps(), ri = useUtilityClasses$G(ai), ni = React$1.useRef(null), si = React$1.useRef(null), li = oi.logicOperator ?? GridLogicOperator.And, ui = bo && Ro.length > 0, ci = ((Ni = ai.slotProps) == null ? void 0 : Ni.baseFormControl) || {}, yi = (((Ai = ai.slotProps) == null ? void 0 : Ai.baseSelect) || {}).native ?? !1, hi = ((Yi = ai.slotProps) == null ? void 0 : Yi.baseInputLabel) || {}, mi = ((Ui = ai.slotProps) == null ? void 0 : Ui.baseSelectOption) || {}, {
    InputComponentProps: bi
  } = Lo, xi = _objectWithoutPropertiesLoose$h(Lo, _excluded2$9), {
    filteredColumns: $i,
    selectedField: Ci
  } = React$1.useMemo(() => {
    let Bi = go.field;
    const Ji = Jo[go.field].filterable === !1 ? Jo[go.field] : null;
    if (Ji)
      return {
        filteredColumns: [Ji],
        selectedField: Bi
      };
    if (Io === void 0 || typeof Io != "function")
      return {
        filteredColumns: ti,
        selectedField: Bi
      };
    const Ki = Io({
      field: go.field,
      columns: ti,
      currentFilters: (oi == null ? void 0 : oi.items) || []
    });
    return {
      filteredColumns: ti.filter((qi) => {
        const rs = Ki.includes(qi.field);
        return qi.field === go.field && !rs && (Bi = void 0), rs;
      }),
      selectedField: Bi
    };
  }, [Io, oi == null ? void 0 : oi.items, ti, go.field, Jo]), Si = React$1.useMemo(() => {
    switch (_o) {
      case "asc":
        return $i.sort((Bi, Ji) => collator$1.compare(getColumnLabel(Bi), getColumnLabel(Ji)));
      case "desc":
        return $i.sort((Bi, Ji) => -collator$1.compare(getColumnLabel(Bi), getColumnLabel(Ji)));
      default:
        return $i;
    }
  }, [$i, _o]), vi = go.field ? No.current.getColumn(go.field) : null, Pi = React$1.useMemo(() => {
    var Bi;
    return !go.operator || !vi ? null : (Bi = vi.filterOperators) == null ? void 0 : Bi.find((Ji) => Ji.value === go.operator);
  }, [go, vi]), wi = React$1.useCallback((Bi) => {
    const Ji = Bi.target.value, Ki = No.current.getColumn(Ji);
    if (Ki.field === vi.field)
      return;
    const qi = Ki.filterOperators.find((ps) => ps.value === go.operator) || Ki.filterOperators[0];
    let os = !qi.InputComponent || qi.InputComponent !== (Pi == null ? void 0 : Pi.InputComponent) || Ki.type !== vi.type ? void 0 : go.value;
    if (Ki.type === "singleSelect" && os !== void 0) {
      const ps = Ki, Mi = getValueOptions(ps);
      Array.isArray(os) ? os = os.filter((Wi) => (
        // Only keep values that are in the new value options
        getValueFromValueOptions(Wi, Mi, ps == null ? void 0 : ps.getOptionValue) !== void 0
      )) : getValueFromValueOptions(go.value, Mi, ps == null ? void 0 : ps.getOptionValue) === void 0 && (os = void 0);
    }
    Po(_extends$q({}, go, {
      field: Ji,
      operator: qi.value,
      value: os
    }));
  }, [No, Po, go, vi, Pi]), gi = React$1.useCallback((Bi) => {
    const Ji = Bi.target.value, Ki = vi == null ? void 0 : vi.filterOperators.find((rs) => rs.value === Ji), qi = !(Ki != null && Ki.InputComponent) || (Ki == null ? void 0 : Ki.InputComponent) !== (Pi == null ? void 0 : Pi.InputComponent);
    Po(_extends$q({}, go, {
      operator: Ji,
      value: qi ? void 0 : go.value
    }));
  }, [Po, go, vi, Pi]), Ri = React$1.useCallback((Bi) => {
    const Ji = Bi.target.value === GridLogicOperator.And.toString() ? GridLogicOperator.And : GridLogicOperator.Or;
    wo(Ji);
  }, [wo]), Ei = () => {
    vo(go);
  };
  return React$1.useImperativeHandle(Eo, () => ({
    focus: () => {
      var Bi;
      Pi != null && Pi.InputComponent ? (Bi = ni == null ? void 0 : ni.current) == null || Bi.focus() : si.current.focus();
    }
  }), [Pi]), /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFilterFormRoot, _extends$q({
    className: ri.root,
    "data-id": go.id,
    ownerState: ai
  }, Ko, {
    ref: ho,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(FilterFormDeleteIcon, _extends$q({
      variant: "standard",
      as: ai.slots.baseFormControl
    }, ci, Ao, {
      className: clsx(ri.deleteIcon, ci.className, Ao.className),
      ownerState: ai,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ai.slots.baseIconButton, _extends$q({
        "aria-label": No.current.getLocaleText("filterPanelDeleteIconLabel"),
        title: No.current.getLocaleText("filterPanelDeleteIconLabel"),
        onClick: Ei,
        size: "small",
        disabled: ko
      }, (us = ai.slotProps) == null ? void 0 : us.baseIconButton, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(ai.slots.filterPanelDeleteIcon, {
          fontSize: "small"
        })
      }))
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(FilterFormLogicOperatorInput, _extends$q({
      variant: "standard",
      as: ai.slots.baseFormControl
    }, ci, Oo, {
      sx: [ui ? {
        display: "flex"
      } : {
        display: "none"
      }, Co ? {
        visibility: "visible"
      } : {
        visibility: "hidden"
      }, ci.sx, Oo.sx],
      className: clsx(ri.logicOperatorInput, ci.className, Oo.className),
      ownerState: ai,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ai.slots.baseSelect, _extends$q({
        inputProps: {
          "aria-label": No.current.getLocaleText("filterPanelLogicOperator")
        },
        value: li ?? "",
        onChange: Ri,
        disabled: !!So || Ro.length === 1,
        native: yi
      }, (ns = ai.slotProps) == null ? void 0 : ns.baseSelect, {
        children: Ro.map((Bi) => /* @__PURE__ */ createElement(ai.slots.baseSelectOption, _extends$q({}, mi, {
          native: yi,
          key: Bi.toString(),
          value: Bi.toString()
        }), No.current.getLocaleText(getLogicOperatorLocaleKey(Bi))))
      }))
    })), /* @__PURE__ */ jsxRuntimeExports.jsxs(FilterFormColumnInput, _extends$q({
      variant: "standard",
      as: ai.slots.baseFormControl
    }, ci, Do, {
      className: clsx(ri.columnInput, ci.className, Do.className),
      ownerState: ai,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ai.slots.baseInputLabel, _extends$q({}, hi, {
        htmlFor: Qo,
        id: Zo,
        children: No.current.getLocaleText("filterPanelColumns")
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(ai.slots.baseSelect, _extends$q({
        labelId: Zo,
        id: Qo,
        label: No.current.getLocaleText("filterPanelColumns"),
        value: Ci ?? "",
        onChange: wi,
        native: yi,
        disabled: ko
      }, (Ti = ai.slotProps) == null ? void 0 : Ti.baseSelect, {
        children: Si.map((Bi) => /* @__PURE__ */ createElement(ai.slots.baseSelectOption, _extends$q({}, mi, {
          native: yi,
          key: Bi.field,
          value: Bi.field
        }), getColumnLabel(Bi)))
      }))]
    })), /* @__PURE__ */ jsxRuntimeExports.jsxs(FilterFormOperatorInput, _extends$q({
      variant: "standard",
      as: ai.slots.baseFormControl
    }, ci, jo, {
      className: clsx(ri.operatorInput, ci.className, jo.className),
      ownerState: ai,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(ai.slots.baseInputLabel, _extends$q({}, hi, {
        htmlFor: ei,
        id: ii,
        children: No.current.getLocaleText("filterPanelOperator")
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(ai.slots.baseSelect, _extends$q({
        labelId: ii,
        label: No.current.getLocaleText("filterPanelOperator"),
        id: ei,
        value: go.operator,
        onChange: gi,
        native: yi,
        inputRef: si,
        disabled: ko
      }, (_i = ai.slotProps) == null ? void 0 : _i.baseSelect, {
        children: (Vi = vi == null ? void 0 : vi.filterOperators) == null ? void 0 : Vi.map((Bi) => /* @__PURE__ */ createElement(ai.slots.baseSelectOption, _extends$q({}, mi, {
          native: yi,
          key: Bi.value,
          value: Bi.value
        }), Bi.label || No.current.getLocaleText(`filterOperator${capitalize(Bi.value)}`)))
      }))]
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(FilterFormValueInput, _extends$q({
      variant: "standard",
      as: ai.slots.baseFormControl
    }, ci, xi, {
      className: clsx(ri.valueInput, ci.className, xi.className),
      ownerState: ai,
      children: Pi != null && Pi.InputComponent ? /* @__PURE__ */ jsxRuntimeExports.jsx(Pi.InputComponent, _extends$q({
        apiRef: No,
        item: go,
        applyValue: Po,
        focusElementRef: ni,
        disabled: ko
      }, Pi.InputComponentProps, bi), go.field) : null
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (GridFilterForm.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Callback called when the operator, column field or value is changed.
   * @param {GridFilterItem} item The updated [[GridFilterItem]].
   */
  applyFilterChanges: PropTypes.func.isRequired,
  /**
   * Callback called when the logic operator is changed.
   * @param {GridLogicOperator} operator The new logic operator.
   */
  applyMultiFilterOperatorChanges: PropTypes.func.isRequired,
  /**
   * @ignore - do not document.
   */
  children: PropTypes.node,
  /**
   * Props passed to the column input component.
   * @default {}
   */
  columnInputProps: PropTypes.any,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Callback called when the delete button is clicked.
   * @param {GridFilterItem} item The deleted [[GridFilterItem]].
   */
  deleteFilter: PropTypes.func.isRequired,
  /**
   * Props passed to the delete icon.
   * @default {}
   */
  deleteIconProps: PropTypes.any,
  /**
   * If `true`, disables the logic operator field but still renders it.
   */
  disableMultiFilterOperator: PropTypes.bool,
  /**
   * Allows to filter the columns displayed in the filter form.
   * @param {FilterColumnsArgs} args The columns of the grid and name of field.
   * @returns {GridColDef['field'][]} The filtered fields array.
   */
  filterColumns: PropTypes.func,
  /**
   * A ref allowing to set imperative focus.
   * It can be passed to the el
   */
  focusElementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the logic operator field is rendered.
   * The field will be invisible if `showMultiFilterOperators` is also `true`.
   */
  hasMultipleFilters: PropTypes.bool.isRequired,
  /**
   * The [[GridFilterItem]] representing this form.
   */
  item: PropTypes.shape({
    field: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    operator: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  /**
   * Props passed to the logic operator input component.
   * @default {}
   */
  logicOperatorInputProps: PropTypes.any,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: PropTypes.arrayOf(PropTypes.oneOf(["and", "or"]).isRequired),
  /**
   * Props passed to the operator input component.
   * @default {}
   */
  operatorInputProps: PropTypes.any,
  /**
   * `true` if the filter is disabled/read only.
   * i.e. `colDef.fiterable = false` but passed in `filterModel`
   * @default false
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the logic operator field is visible.
   */
  showMultiFilterOperators: PropTypes.bool,
  /**
   * Props passed to the value input component.
   * @default {}
   */
  valueInputProps: PropTypes.any
});
const _excluded$t = ["logicOperators", "columnsSort", "filterFormProps", "getColumnForNewFilter", "children", "disableAddFilterButton", "disableRemoveAllButton"], getGridFilter = (Kt) => ({
  field: Kt.field,
  operator: Kt.filterOperators[0].value,
  id: Math.round(Math.random() * 1e5)
}), GridFilterPanel = forwardRef(function(uo, ho) {
  var ii, ai;
  const go = useGridApiContext(), bo = useGridRootProps(), vo = useGridSelector(go, gridFilterModelSelector), Po = useGridSelector(go, gridFilterableColumnDefinitionsSelector), Co = useGridSelector(go, gridFilterableColumnLookupSelector), So = React$1.useRef(null), wo = React$1.useRef(null), {
    logicOperators: Eo = [GridLogicOperator.And, GridLogicOperator.Or],
    columnsSort: Ro,
    filterFormProps: _o,
    getColumnForNewFilter: Io,
    disableAddFilterButton: Ao = !1,
    disableRemoveAllButton: Oo = !1
  } = uo, jo = _objectWithoutPropertiesLoose$h(uo, _excluded$t), Do = go.current.upsertFilterItem, Lo = React$1.useCallback((ri) => {
    go.current.setFilterLogicOperator(ri);
  }, [go]), ko = React$1.useCallback(() => {
    let ri;
    if (Io && typeof Io == "function") {
      const ni = Io({
        currentFilters: (vo == null ? void 0 : vo.items) || [],
        columns: Po
      });
      if (ni === null)
        return null;
      ri = Po.find(({
        field: si
      }) => si === ni);
    } else
      ri = Po.find((ni) => {
        var si;
        return (si = ni.filterOperators) == null ? void 0 : si.length;
      });
    return ri ? getGridFilter(ri) : null;
  }, [vo == null ? void 0 : vo.items, Po, Io]), Ko = React$1.useCallback(() => {
    if (Io === void 0 || typeof Io != "function")
      return ko();
    const ri = vo.items.length ? vo.items : [ko()].filter(Boolean), ni = Io({
      currentFilters: ri,
      columns: Po
    });
    if (ni === null)
      return null;
    const si = Po.find(({
      field: li
    }) => li === ni);
    return si ? getGridFilter(si) : null;
  }, [vo.items, Po, Io, ko]), No = React$1.useMemo(() => vo.items.length ? vo.items : (wo.current || (wo.current = ko()), wo.current ? [wo.current] : []), [vo.items, ko]), Jo = No.length > 1, {
    readOnlyFilters: ti,
    validFilters: oi
  } = React$1.useMemo(() => No.reduce((ri, ni) => (Co[ni.field] ? ri.validFilters.push(ni) : ri.readOnlyFilters.push(ni), ri), {
    readOnlyFilters: [],
    validFilters: []
  }), [No, Co]), Qo = React$1.useCallback(() => {
    const ri = Ko();
    ri && go.current.upsertFilterItems([...No, ri]);
  }, [go, Ko, No]), Zo = React$1.useCallback((ri) => {
    const ni = oi.length === 1;
    go.current.deleteFilterItem(ri), ni && go.current.hideFilterPanel();
  }, [go, oi.length]), ei = React$1.useCallback(() => oi.length === 1 && oi[0].value === void 0 ? (go.current.deleteFilterItem(oi[0]), go.current.hideFilterPanel()) : go.current.setFilterModel(_extends$q({}, vo, {
    items: ti
  }), "removeAllFilterItems"), [go, ti, vo, oi]);
  return React$1.useEffect(() => {
    Eo.length > 0 && vo.logicOperator && !Eo.includes(vo.logicOperator) && Lo(Eo[0]);
  }, [Eo, Lo, vo.logicOperator]), React$1.useEffect(() => {
    oi.length > 0 && So.current.focus();
  }, [oi.length]), /* @__PURE__ */ jsxRuntimeExports.jsxs(GridPanelWrapper, _extends$q({}, jo, {
    ref: ho,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsxs(GridPanelContent, {
      children: [ti.map((ri, ni) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterForm, _extends$q({
        item: ri,
        applyFilterChanges: Do,
        deleteFilter: Zo,
        hasMultipleFilters: Jo,
        showMultiFilterOperators: ni > 0,
        disableMultiFilterOperator: ni !== 1,
        applyMultiFilterOperatorChanges: Lo,
        focusElementRef: null,
        readOnly: !0,
        logicOperators: Eo,
        columnsSort: Ro
      }, _o), ri.id == null ? ni : ri.id)), oi.map((ri, ni) => /* @__PURE__ */ jsxRuntimeExports.jsx(GridFilterForm, _extends$q({
        item: ri,
        applyFilterChanges: Do,
        deleteFilter: Zo,
        hasMultipleFilters: Jo,
        showMultiFilterOperators: ti.length + ni > 0,
        disableMultiFilterOperator: ti.length + ni !== 1,
        applyMultiFilterOperatorChanges: Lo,
        focusElementRef: ni === oi.length - 1 ? So : null,
        logicOperators: Eo,
        columnsSort: Ro
      }, _o), ri.id == null ? ni + ti.length : ri.id))]
    }), !bo.disableMultipleColumnsFiltering && !(Ao && Oo) ? /* @__PURE__ */ jsxRuntimeExports.jsxs(GridPanelFooter, {
      children: [Ao ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.baseButton, _extends$q({
        onClick: Qo,
        startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.filterPanelAddIcon, {})
      }, (ii = bo.slotProps) == null ? void 0 : ii.baseButton, {
        children: go.current.getLocaleText("filterPanelAddFilter")
      })), !Oo && oi.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.baseButton, _extends$q({
        onClick: ei,
        startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.filterPanelRemoveAllIcon, {})
      }, (ai = bo.slotProps) == null ? void 0 : ai.baseButton, {
        children: go.current.getLocaleText("filterPanelRemoveAll")
      })) : null]
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (GridFilterPanel.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * @ignore - do not document.
   */
  children: PropTypes.node,
  /**
   * Changes how the options in the columns selector should be ordered.
   * If not specified, the order is derived from the `columns` prop.
   */
  columnsSort: PropTypes.oneOf(["asc", "desc"]),
  /**
   * If `true`, the `Add filter` button will not be displayed.
   * @default false
   */
  disableAddFilterButton: PropTypes.bool,
  /**
   * If `true`, the `Remove all` button will be disabled
   * @default false
   */
  disableRemoveAllButton: PropTypes.bool,
  /**
   * Props passed to each filter form.
   */
  filterFormProps: PropTypes.shape({
    columnInputProps: PropTypes.any,
    columnsSort: PropTypes.oneOf(["asc", "desc"]),
    deleteIconProps: PropTypes.any,
    filterColumns: PropTypes.func,
    logicOperatorInputProps: PropTypes.any,
    operatorInputProps: PropTypes.any,
    valueInputProps: PropTypes.any
  }),
  /**
   * Function that returns the next filter item to be picked as default filter.
   * @param {GetColumnForNewFilterArgs} args Currently configured filters and columns.
   * @returns {GridColDef['field']} The field to be used for the next filter or `null` to prevent adding a filter.
   */
  getColumnForNewFilter: PropTypes.func,
  /**
   * Sets the available logic operators.
   * @default [GridLogicOperator.And, GridLogicOperator.Or]
   */
  logicOperators: PropTypes.arrayOf(PropTypes.oneOf(["and", "or"]).isRequired),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getFormControlUtilityClasses(Kt) {
  return generateUtilityClass$1("MuiFormControl", Kt);
}
generateUtilityClasses$1("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const useUtilityClasses$F = (Kt) => {
  const {
    classes: uo,
    margin: ho,
    fullWidth: go
  } = Kt, bo = {
    root: ["root", ho !== "none" && `margin${capitalize(ho)}`, go && "fullWidth"]
  };
  return composeClasses(bo, getFormControlUtilityClasses, uo);
}, FormControlRoot = styled("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[`margin${capitalize(ho.margin)}`], ho.fullWidth && uo.fullWidth];
  }
})({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top",
  // Fix alignment issue on Safari.
  variants: [{
    props: {
      margin: "normal"
    },
    style: {
      marginTop: 16,
      marginBottom: 8
    }
  }, {
    props: {
      margin: "dense"
    },
    style: {
      marginTop: 8,
      marginBottom: 4
    }
  }, {
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }]
}), FormControl = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiFormControl"
  }), {
    children: bo,
    className: vo,
    color: Po = "primary",
    component: Co = "div",
    disabled: So = !1,
    error: wo = !1,
    focused: Eo,
    fullWidth: Ro = !1,
    hiddenLabel: _o = !1,
    margin: Io = "none",
    required: Ao = !1,
    size: Oo = "medium",
    variant: jo = "outlined",
    ...Do
  } = go, Lo = {
    ...go,
    color: Po,
    component: Co,
    disabled: So,
    error: wo,
    fullWidth: Ro,
    hiddenLabel: _o,
    margin: Io,
    required: Ao,
    size: Oo,
    variant: jo
  }, ko = useUtilityClasses$F(Lo), [Ko, No] = React$1.useState(() => {
    let ri = !1;
    return bo && React$1.Children.forEach(bo, (ni) => {
      if (!isMuiElement(ni, ["Input", "Select"]))
        return;
      const si = isMuiElement(ni, ["Select"]) ? ni.props.input : ni;
      si && isAdornedStart(si.props) && (ri = !0);
    }), ri;
  }), [Jo, ti] = React$1.useState(() => {
    let ri = !1;
    return bo && React$1.Children.forEach(bo, (ni) => {
      isMuiElement(ni, ["Input", "Select"]) && (isFilled(ni.props, !0) || isFilled(ni.props.inputProps, !0)) && (ri = !0);
    }), ri;
  }), [oi, Qo] = React$1.useState(!1);
  So && oi && Qo(!1);
  const Zo = Eo !== void 0 && !So ? Eo : oi;
  let ei;
  const ii = React$1.useRef(!1);
  process.env.NODE_ENV !== "production" && (ei = () => (ii.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), ii.current = !0, () => {
    ii.current = !1;
  }));
  const ai = React$1.useMemo(() => ({
    adornedStart: Ko,
    setAdornedStart: No,
    color: Po,
    disabled: So,
    error: wo,
    filled: Jo,
    focused: Zo,
    fullWidth: Ro,
    hiddenLabel: _o,
    size: Oo,
    onBlur: () => {
      Qo(!1);
    },
    onEmpty: () => {
      ti(!1);
    },
    onFilled: () => {
      ti(!0);
    },
    onFocus: () => {
      Qo(!0);
    },
    registerEffect: ei,
    required: Ao,
    variant: jo
  }), [Ko, Po, So, wo, Jo, Zo, Ro, _o, ei, Ao, Oo, jo]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: ai,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlRoot, {
      as: Co,
      ownerState: Lo,
      className: clsx(ko.root, vo),
      ref: ho,
      ...Do,
      children: bo
    })
  });
});
process.env.NODE_ENV !== "production" && (FormControl.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getFormControlLabelUtilityClasses(Kt) {
  return generateUtilityClass$1("MuiFormControlLabel", Kt);
}
const formControlLabelClasses = generateUtilityClasses$1("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), useUtilityClasses$E = (Kt) => {
  const {
    classes: uo,
    disabled: ho,
    labelPlacement: go,
    error: bo,
    required: vo
  } = Kt, Po = {
    root: ["root", ho && "disabled", `labelPlacement${capitalize(go)}`, bo && "error", vo && "required"],
    label: ["label", ho && "disabled"],
    asterisk: ["asterisk", bo && "error"]
  };
  return composeClasses(Po, getFormControlLabelUtilityClasses, uo);
}, FormControlLabelRoot = styled("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [{
      [`& .${formControlLabelClasses.label}`]: uo.label
    }, uo.root, uo[`labelPlacement${capitalize(ho.labelPlacement)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${formControlLabelClasses.disabled}`]: {
    cursor: "default"
  },
  [`& .${formControlLabelClasses.label}`]: {
    [`&.${formControlLabelClasses.disabled}`]: {
      color: (Kt.vars || Kt).palette.text.disabled
    }
  },
  variants: [{
    props: {
      labelPlacement: "start"
    },
    style: {
      flexDirection: "row-reverse",
      marginRight: -11
    }
  }, {
    props: {
      labelPlacement: "top"
    },
    style: {
      flexDirection: "column-reverse"
    }
  }, {
    props: {
      labelPlacement: "bottom"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: ({
      labelPlacement: uo
    }) => uo === "start" || uo === "top" || uo === "bottom",
    style: {
      marginLeft: 16
      // used for row presentation of radio/checkbox
    }
  }]
}))), AsteriskComponent$1 = styled("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (Kt, uo) => uo.asterisk
})(memoTheme(({
  theme: Kt
}) => ({
  [`&.${formControlLabelClasses.error}`]: {
    color: (Kt.vars || Kt).palette.error.main
  }
}))), FormControlLabel = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiFormControlLabel"
  }), {
    checked: bo,
    className: vo,
    componentsProps: Po = {},
    control: Co,
    disabled: So,
    disableTypography: wo,
    inputRef: Eo,
    label: Ro,
    labelPlacement: _o = "end",
    name: Io,
    onChange: Ao,
    required: Oo,
    slots: jo = {},
    slotProps: Do = {},
    value: Lo,
    ...ko
  } = go, Ko = useFormControl(), No = So ?? Co.props.disabled ?? (Ko == null ? void 0 : Ko.disabled), Jo = Oo ?? Co.props.required, ti = {
    disabled: No,
    required: Jo
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((ni) => {
    typeof Co.props[ni] > "u" && typeof go[ni] < "u" && (ti[ni] = go[ni]);
  });
  const oi = formControlState({
    props: go,
    muiFormControl: Ko,
    states: ["error"]
  }), Qo = {
    ...go,
    disabled: No,
    labelPlacement: _o,
    required: Jo,
    error: oi.error
  }, Zo = useUtilityClasses$E(Qo), ei = {
    slots: jo,
    slotProps: {
      ...Po,
      ...Do
    }
  }, [ii, ai] = useSlot("typography", {
    elementType: Typography,
    externalForwardedProps: ei,
    ownerState: Qo
  });
  let ri = Ro;
  return ri != null && ri.type !== Typography && !wo && (ri = /* @__PURE__ */ jsxRuntimeExports.jsx(ii, {
    component: "span",
    ...ai,
    className: clsx(Zo.label, ai == null ? void 0 : ai.className),
    children: ri
  })), /* @__PURE__ */ jsxRuntimeExports.jsxs(FormControlLabelRoot, {
    className: clsx(Zo.root, vo),
    ownerState: Qo,
    ref: ho,
    ...ko,
    children: [/* @__PURE__ */ React$1.cloneElement(Co, ti), Jo ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
      children: [ri, /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent$1, {
        ownerState: Qo,
        "aria-hidden": !0,
        className: Zo.asterisk,
        children: [" ", "*"]
      })]
    }) : ri]
  });
});
process.env.NODE_ENV !== "production" && (FormControlLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: PropTypes.shape({
    typography: PropTypes.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: PropTypes.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: PropTypes.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: PropTypes.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: PropTypes.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    typography: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    typography: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
const useUtilityClasses$D = (Kt) => {
  const {
    classes: uo,
    disableUnderline: ho
  } = Kt, bo = composeClasses({
    root: ["root", !ho && "underline"],
    input: ["input"]
  }, getInputUtilityClass, uo);
  return {
    ...uo,
    // forward classes to the InputBase
    ...bo
  };
}, InputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [...rootOverridesResolver(Kt, uo), !ho.disableUnderline && uo.underline];
  }
})(memoTheme(({
  theme: Kt
}) => {
  let ho = Kt.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return Kt.vars && (ho = `rgba(${Kt.vars.palette.common.onBackgroundChannel} / ${Kt.vars.opacity.inputUnderline})`), {
    position: "relative",
    variants: [{
      props: ({
        ownerState: go
      }) => go.formControl,
      style: {
        "label + &": {
          marginTop: 16
        }
      }
    }, {
      props: ({
        ownerState: go
      }) => !go.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: Kt.transitions.create("transform", {
            duration: Kt.transitions.duration.shorter,
            easing: Kt.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${inputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${inputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (Kt.vars || Kt).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${ho}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: Kt.transitions.create("border-bottom-color", {
            duration: Kt.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${inputClasses.disabled}, .${inputClasses.error}):before`]: {
          borderBottom: `2px solid ${(Kt.vars || Kt).palette.text.primary}`,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            borderBottom: `1px solid ${ho}`
          }
        },
        [`&.${inputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([go]) => ({
      props: {
        color: go,
        disableUnderline: !1
      },
      style: {
        "&::after": {
          borderBottom: `2px solid ${(Kt.vars || Kt).palette[go].main}`
        }
      }
    }))]
  };
})), InputInput = styled(InputBaseInput, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})({}), Input = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiInput"
  }), {
    disableUnderline: bo = !1,
    components: vo = {},
    componentsProps: Po,
    fullWidth: Co = !1,
    inputComponent: So = "input",
    multiline: wo = !1,
    slotProps: Eo,
    slots: Ro = {},
    type: _o = "text",
    ...Io
  } = go, Ao = useUtilityClasses$D(go), jo = {
    root: {
      ownerState: {
        disableUnderline: bo
      }
    }
  }, Do = Eo ?? Po ? deepmerge(Eo ?? Po, jo) : jo, Lo = Ro.root ?? vo.Root ?? InputRoot, ko = Ro.input ?? vo.Input ?? InputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: Lo,
      input: ko
    },
    slotProps: Do,
    fullWidth: Co,
    inputComponent: So,
    multiline: wo,
    ref: ho,
    type: _o,
    ...Io,
    classes: Ao
  });
});
process.env.NODE_ENV !== "production" && (Input.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `input` will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
Input.muiName = "Input";
const useUtilityClasses$C = (Kt) => {
  const {
    classes: uo,
    disableUnderline: ho,
    startAdornment: go,
    endAdornment: bo,
    size: vo,
    hiddenLabel: Po,
    multiline: Co
  } = Kt, So = {
    root: ["root", !ho && "underline", go && "adornedStart", bo && "adornedEnd", vo === "small" && `size${capitalize(vo)}`, Po && "hiddenLabel", Co && "multiline"],
    input: ["input"]
  }, wo = composeClasses(So, getFilledInputUtilityClass, uo);
  return {
    ...uo,
    // forward classes to the InputBase
    ...wo
  };
}, FilledInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [...rootOverridesResolver(Kt, uo), !ho.disableUnderline && uo.underline];
  }
})(memoTheme(({
  theme: Kt
}) => {
  const uo = Kt.palette.mode === "light", ho = uo ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", go = uo ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", bo = uo ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", vo = uo ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return {
    position: "relative",
    backgroundColor: Kt.vars ? Kt.vars.palette.FilledInput.bg : go,
    borderTopLeftRadius: (Kt.vars || Kt).shape.borderRadius,
    borderTopRightRadius: (Kt.vars || Kt).shape.borderRadius,
    transition: Kt.transitions.create("background-color", {
      duration: Kt.transitions.duration.shorter,
      easing: Kt.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: Kt.vars ? Kt.vars.palette.FilledInput.hoverBg : bo,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: Kt.vars ? Kt.vars.palette.FilledInput.bg : go
      }
    },
    [`&.${filledInputClasses.focused}`]: {
      backgroundColor: Kt.vars ? Kt.vars.palette.FilledInput.bg : go
    },
    [`&.${filledInputClasses.disabled}`]: {
      backgroundColor: Kt.vars ? Kt.vars.palette.FilledInput.disabledBg : vo
    },
    variants: [{
      props: ({
        ownerState: Po
      }) => !Po.disableUnderline,
      style: {
        "&::after": {
          left: 0,
          bottom: 0,
          content: '""',
          position: "absolute",
          right: 0,
          transform: "scaleX(0)",
          transition: Kt.transitions.create("transform", {
            duration: Kt.transitions.duration.shorter,
            easing: Kt.transitions.easing.easeOut
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&.${filledInputClasses.focused}:after`]: {
          // translateX(0) is a workaround for Safari transform scale bug
          // See https://github.com/mui/material-ui/issues/31766
          transform: "scaleX(1) translateX(0)"
        },
        [`&.${filledInputClasses.error}`]: {
          "&::before, &::after": {
            borderBottomColor: (Kt.vars || Kt).palette.error.main
          }
        },
        "&::before": {
          borderBottom: `1px solid ${Kt.vars ? `rgba(${Kt.vars.palette.common.onBackgroundChannel} / ${Kt.vars.opacity.inputUnderline})` : ho}`,
          left: 0,
          bottom: 0,
          content: '"\\00a0"',
          position: "absolute",
          right: 0,
          transition: Kt.transitions.create("border-bottom-color", {
            duration: Kt.transitions.duration.shorter
          }),
          pointerEvents: "none"
          // Transparent to the hover style.
        },
        [`&:hover:not(.${filledInputClasses.disabled}, .${filledInputClasses.error}):before`]: {
          borderBottom: `1px solid ${(Kt.vars || Kt).palette.text.primary}`
        },
        [`&.${filledInputClasses.disabled}:before`]: {
          borderBottomStyle: "dotted"
        }
      }
    }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([Po]) => {
      var Co;
      return {
        props: {
          disableUnderline: !1,
          color: Po
        },
        style: {
          "&::after": {
            borderBottom: `2px solid ${(Co = (Kt.vars || Kt).palette[Po]) == null ? void 0 : Co.main}`
          }
        }
      };
    }), {
      props: ({
        ownerState: Po
      }) => Po.startAdornment,
      style: {
        paddingLeft: 12
      }
    }, {
      props: ({
        ownerState: Po
      }) => Po.endAdornment,
      style: {
        paddingRight: 12
      }
    }, {
      props: ({
        ownerState: Po
      }) => Po.multiline,
      style: {
        padding: "25px 12px 8px"
      }
    }, {
      props: ({
        ownerState: Po,
        size: Co
      }) => Po.multiline && Co === "small",
      style: {
        paddingTop: 21,
        paddingBottom: 4
      }
    }, {
      props: ({
        ownerState: Po
      }) => Po.multiline && Po.hiddenLabel,
      style: {
        paddingTop: 16,
        paddingBottom: 17
      }
    }, {
      props: ({
        ownerState: Po
      }) => Po.multiline && Po.hiddenLabel && Po.size === "small",
      style: {
        paddingTop: 8,
        paddingBottom: 9
      }
    }]
  };
})), FilledInputInput = styled(InputBaseInput, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme: Kt
}) => ({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  ...!Kt.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: Kt.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: Kt.palette.mode === "light" ? null : "#fff",
      caretColor: Kt.palette.mode === "light" ? null : "#fff",
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    }
  },
  ...Kt.vars && {
    "&:-webkit-autofill": {
      borderTopLeftRadius: "inherit",
      borderTopRightRadius: "inherit"
    },
    [Kt.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      paddingTop: 21,
      paddingBottom: 4
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.hiddenLabel,
    style: {
      paddingTop: 16,
      paddingBottom: 17
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.endAdornment,
    style: {
      paddingRight: 0
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.hiddenLabel && uo.size === "small",
    style: {
      paddingTop: 8,
      paddingBottom: 9
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.multiline,
    style: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      paddingRight: 0
    }
  }]
}))), FilledInput = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiFilledInput"
  }), {
    disableUnderline: bo = !1,
    components: vo = {},
    componentsProps: Po,
    fullWidth: Co = !1,
    hiddenLabel: So,
    // declare here to prevent spreading to DOM
    inputComponent: wo = "input",
    multiline: Eo = !1,
    slotProps: Ro,
    slots: _o = {},
    type: Io = "text",
    ...Ao
  } = go, Oo = {
    ...go,
    disableUnderline: bo,
    fullWidth: Co,
    inputComponent: wo,
    multiline: Eo,
    type: Io
  }, jo = useUtilityClasses$C(go), Do = {
    root: {
      ownerState: Oo
    },
    input: {
      ownerState: Oo
    }
  }, Lo = Ro ?? Po ? deepmerge(Do, Ro ?? Po) : Do, ko = _o.root ?? vo.Root ?? FilledInputRoot, Ko = _o.input ?? vo.Input ?? FilledInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: ko,
      input: Ko
    },
    slotProps: Lo,
    fullWidth: Co,
    inputComponent: wo,
    multiline: Eo,
    ref: ho,
    type: Io,
    ...Ao,
    classes: jo
  });
});
process.env.NODE_ENV !== "production" && (FilledInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the input will not have an underline.
   * @default false
   */
  disableUnderline: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: PropTypes.shape({
    input: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
FilledInput.muiName = "Input";
var _span$3;
const NotchedOutlineRoot$1 = styled("fieldset", {
  shouldForwardProp: rootShouldForwardProp
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), NotchedOutlineLegend = styled("legend", {
  shouldForwardProp: rootShouldForwardProp
})(memoTheme(({
  theme: Kt
}) => ({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden",
  // Fix Horizontal scroll when label too long
  variants: [{
    props: ({
      ownerState: uo
    }) => !uo.withLabel,
    style: {
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: Kt.transitions.create("width", {
        duration: 150,
        easing: Kt.transitions.easing.easeOut
      })
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.withLabel,
    style: {
      display: "block",
      // Fix conflict with normalize.css and sanitize.css
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: Kt.transitions.create("max-width", {
        duration: 50,
        easing: Kt.transitions.easing.easeOut
      }),
      whiteSpace: "nowrap",
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block",
        opacity: 0,
        visibility: "visible"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.withLabel && uo.notched,
    style: {
      maxWidth: "100%",
      transition: Kt.transitions.create("max-width", {
        duration: 100,
        easing: Kt.transitions.easing.easeOut,
        delay: 50
      })
    }
  }]
})));
function NotchedOutline(Kt) {
  const {
    children: uo,
    classes: ho,
    className: go,
    label: bo,
    notched: vo,
    ...Po
  } = Kt, Co = bo != null && bo !== "", So = {
    ...Kt,
    notched: vo,
    withLabel: Co
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot$1, {
    "aria-hidden": !0,
    className: go,
    ownerState: So,
    ...Po,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineLegend, {
      ownerState: So,
      children: Co ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        children: bo
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$3 || (_span$3 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      )
    })
  });
}
process.env.NODE_ENV !== "production" && (NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The label.
   */
  label: PropTypes.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  style: PropTypes.object
});
const useUtilityClasses$B = (Kt) => {
  const {
    classes: uo
  } = Kt, go = composeClasses({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, getOutlinedInputUtilityClass, uo);
  return {
    ...uo,
    // forward classes to the InputBase
    ...go
  };
}, OutlinedInputRoot = styled(InputBaseRoot, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: rootOverridesResolver
})(memoTheme(({
  theme: Kt
}) => {
  const uo = Kt.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    position: "relative",
    borderRadius: (Kt.vars || Kt).shape.borderRadius,
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: (Kt.vars || Kt).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
        borderColor: Kt.vars ? `rgba(${Kt.vars.palette.common.onBackgroundChannel} / 0.23)` : uo
      }
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
      borderWidth: 2
    },
    variants: [...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([ho]) => ({
      props: {
        color: ho
      },
      style: {
        [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (Kt.vars || Kt).palette[ho].main
        }
      }
    })), {
      props: {},
      // to overide the above style
      style: {
        [`&.${outlinedInputClasses.error} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (Kt.vars || Kt).palette.error.main
        },
        [`&.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
          borderColor: (Kt.vars || Kt).palette.action.disabled
        }
      }
    }, {
      props: ({
        ownerState: ho
      }) => ho.startAdornment,
      style: {
        paddingLeft: 14
      }
    }, {
      props: ({
        ownerState: ho
      }) => ho.endAdornment,
      style: {
        paddingRight: 14
      }
    }, {
      props: ({
        ownerState: ho
      }) => ho.multiline,
      style: {
        padding: "16.5px 14px"
      }
    }, {
      props: ({
        ownerState: ho,
        size: go
      }) => ho.multiline && go === "small",
      style: {
        padding: "8.5px 14px"
      }
    }]
  };
})), NotchedOutlineRoot = styled(NotchedOutline, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (Kt, uo) => uo.notchedOutline
})(memoTheme(({
  theme: Kt
}) => {
  const uo = Kt.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: Kt.vars ? `rgba(${Kt.vars.palette.common.onBackgroundChannel} / 0.23)` : uo
  };
})), OutlinedInputInput = styled(InputBaseInput, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: inputOverridesResolver
})(memoTheme(({
  theme: Kt
}) => ({
  padding: "16.5px 14px",
  ...!Kt.vars && {
    "&:-webkit-autofill": {
      WebkitBoxShadow: Kt.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
      WebkitTextFillColor: Kt.palette.mode === "light" ? null : "#fff",
      caretColor: Kt.palette.mode === "light" ? null : "#fff",
      borderRadius: "inherit"
    }
  },
  ...Kt.vars && {
    "&:-webkit-autofill": {
      borderRadius: "inherit"
    },
    [Kt.getColorSchemeSelector("dark")]: {
      "&:-webkit-autofill": {
        WebkitBoxShadow: "0 0 0 100px #266798 inset",
        WebkitTextFillColor: "#fff",
        caretColor: "#fff"
      }
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      padding: "8.5px 14px"
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.multiline,
    style: {
      padding: 0
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.startAdornment,
    style: {
      paddingLeft: 0
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.endAdornment,
    style: {
      paddingRight: 0
    }
  }]
}))), OutlinedInput = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  var go;
  const bo = useDefaultProps({
    props: uo,
    name: "MuiOutlinedInput"
  }), {
    components: vo = {},
    fullWidth: Po = !1,
    inputComponent: Co = "input",
    label: So,
    multiline: wo = !1,
    notched: Eo,
    slots: Ro = {},
    type: _o = "text",
    ...Io
  } = bo, Ao = useUtilityClasses$B(bo), Oo = useFormControl(), jo = formControlState({
    props: bo,
    muiFormControl: Oo,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), Do = {
    ...bo,
    color: jo.color || "primary",
    disabled: jo.disabled,
    error: jo.error,
    focused: jo.focused,
    formControl: Oo,
    fullWidth: Po,
    hiddenLabel: jo.hiddenLabel,
    multiline: wo,
    size: jo.size,
    type: _o
  }, Lo = Ro.root ?? vo.Root ?? OutlinedInputRoot, ko = Ro.input ?? vo.Input ?? OutlinedInputInput;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {
    slots: {
      root: Lo,
      input: ko
    },
    renderSuffix: (Ko) => /* @__PURE__ */ jsxRuntimeExports.jsx(NotchedOutlineRoot, {
      ownerState: Do,
      className: Ao.notchedOutline,
      label: So != null && So !== "" && jo.required ? go || (go = /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [So, " ", "*"]
      })) : So,
      notched: typeof Eo < "u" ? Eo : !!(Ko.startAdornment || Ko.filled || Ko.focused)
    }),
    fullWidth: Po,
    inputComponent: Co,
    multiline: wo,
    ref: ho,
    type: _o,
    ...Io,
    classes: {
      ...Ao,
      notchedOutline: null
    }
  });
});
process.env.NODE_ENV !== "production" && (OutlinedInput.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary"]), PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Input: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: PropTypes.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: PropTypes.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: PropTypes.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: PropTypes.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a [TextareaAutosize](https://mui.com/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: PropTypes.shape({
    input: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
});
OutlinedInput.muiName = "Input";
function getFormLabelUtilityClasses(Kt) {
  return generateUtilityClass$1("MuiFormLabel", Kt);
}
const formLabelClasses = generateUtilityClasses$1("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), useUtilityClasses$A = (Kt) => {
  const {
    classes: uo,
    color: ho,
    focused: go,
    disabled: bo,
    error: vo,
    filled: Po,
    required: Co
  } = Kt, So = {
    root: ["root", `color${capitalize(ho)}`, bo && "disabled", vo && "error", Po && "filled", go && "focused", Co && "required"],
    asterisk: ["asterisk", vo && "error"]
  };
  return composeClasses(So, getFormLabelUtilityClasses, uo);
}, FormLabelRoot = styled("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.color === "secondary" && uo.colorSecondary, ho.filled && uo.filled];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  color: (Kt.vars || Kt).palette.text.secondary,
  ...Kt.typography.body1,
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  variants: [...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      [`&.${formLabelClasses.focused}`]: {
        color: (Kt.vars || Kt).palette[uo].main
      }
    }
  })), {
    props: {},
    style: {
      [`&.${formLabelClasses.disabled}`]: {
        color: (Kt.vars || Kt).palette.text.disabled
      },
      [`&.${formLabelClasses.error}`]: {
        color: (Kt.vars || Kt).palette.error.main
      }
    }
  }]
}))), AsteriskComponent = styled("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (Kt, uo) => uo.asterisk
})(memoTheme(({
  theme: Kt
}) => ({
  [`&.${formLabelClasses.error}`]: {
    color: (Kt.vars || Kt).palette.error.main
  }
}))), FormLabel = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiFormLabel"
  }), {
    children: bo,
    className: vo,
    color: Po,
    component: Co = "label",
    disabled: So,
    error: wo,
    filled: Eo,
    focused: Ro,
    required: _o,
    ...Io
  } = go, Ao = useFormControl(), Oo = formControlState({
    props: go,
    muiFormControl: Ao,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), jo = {
    ...go,
    color: Oo.color || "primary",
    component: Co,
    disabled: Oo.disabled,
    error: Oo.error,
    filled: Oo.filled,
    focused: Oo.focused,
    required: Oo.required
  }, Do = useUtilityClasses$A(jo);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FormLabelRoot, {
    as: Co,
    ownerState: jo,
    className: clsx(Do.root, vo),
    ref: ho,
    ...Io,
    children: [bo, Oo.required && /* @__PURE__ */ jsxRuntimeExports.jsxs(AsteriskComponent, {
      ownerState: jo,
      "aria-hidden": !0,
      className: Do.asterisk,
      children: [" ", "*"]
    })]
  });
});
process.env.NODE_ENV !== "production" && (FormLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getInputLabelUtilityClasses(Kt) {
  return generateUtilityClass$1("MuiInputLabel", Kt);
}
generateUtilityClasses$1("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]);
const useUtilityClasses$z = (Kt) => {
  const {
    classes: uo,
    formControl: ho,
    size: go,
    shrink: bo,
    disableAnimation: vo,
    variant: Po,
    required: Co
  } = Kt, So = {
    root: ["root", ho && "formControl", !vo && "animated", bo && "shrink", go && go !== "normal" && `size${capitalize(go)}`, Po],
    asterisk: [Co && "asterisk"]
  }, wo = composeClasses(So, getInputLabelUtilityClasses, uo);
  return {
    ...uo,
    // forward the focused, disabled, etc. classes to the FormLabel
    ...wo
  };
}, InputLabelRoot = styled(FormLabel, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [{
      [`& .${formLabelClasses.asterisk}`]: uo.asterisk
    }, uo.root, ho.formControl && uo.formControl, ho.size === "small" && uo.sizeSmall, ho.shrink && uo.shrink, !ho.disableAnimation && uo.animated, ho.focused && uo.focused, uo[ho.variant]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  variants: [{
    props: ({
      ownerState: uo
    }) => uo.formControl,
    style: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 20px) scale(1)"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      // Compensation for the `Input.inputSizeSmall` style.
      transform: "translate(0, 17px) scale(1)"
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.shrink,
    style: {
      transform: "translate(0, -1.5px) scale(0.75)",
      transformOrigin: "top left",
      maxWidth: "133%"
    }
  }, {
    props: ({
      ownerState: uo
    }) => !uo.disableAnimation,
    style: {
      transition: Kt.transitions.create(["color", "transform", "max-width"], {
        duration: Kt.transitions.duration.shorter,
        easing: Kt.transitions.easing.easeOut
      })
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "filled",
      size: "small"
    },
    style: {
      transform: "translate(12px, 13px) scale(1)"
    }
  }, {
    props: ({
      variant: uo,
      ownerState: ho
    }) => uo === "filled" && ho.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      transform: "translate(12px, 7px) scale(0.75)",
      maxWidth: "calc(133% - 24px)"
    }
  }, {
    props: ({
      variant: uo,
      ownerState: ho,
      size: go
    }) => uo === "filled" && ho.shrink && go === "small",
    style: {
      transform: "translate(12px, 4px) scale(0.75)"
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 16px) scale(1)",
      maxWidth: "calc(100% - 24px)"
    }
  }, {
    props: {
      variant: "outlined",
      size: "small"
    },
    style: {
      transform: "translate(14px, 9px) scale(1)"
    }
  }, {
    props: ({
      variant: uo,
      ownerState: ho
    }) => uo === "outlined" && ho.shrink,
    style: {
      userSelect: "none",
      pointerEvents: "auto",
      // Theoretically, we should have (8+5)*2/0.75 = 34px
      // but it feels a better when it bleeds a bit on the left, so 32px.
      maxWidth: "calc(133% - 32px)",
      transform: "translate(14px, -9px) scale(0.75)"
    }
  }]
}))), InputLabel = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    name: "MuiInputLabel",
    props: uo
  }), {
    disableAnimation: bo = !1,
    margin: vo,
    shrink: Po,
    variant: Co,
    className: So,
    ...wo
  } = go, Eo = useFormControl();
  let Ro = Po;
  typeof Ro > "u" && Eo && (Ro = Eo.filled || Eo.focused || Eo.adornedStart);
  const _o = formControlState({
    props: go,
    muiFormControl: Eo,
    states: ["size", "variant", "required", "focused"]
  }), Io = {
    ...go,
    disableAnimation: bo,
    formControl: Eo,
    shrink: Ro,
    size: _o.size,
    variant: _o.variant,
    required: _o.required,
    focused: _o.focused
  }, Ao = useUtilityClasses$z(Io);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(InputLabelRoot, {
    "data-shrink": Ro,
    ref: ho,
    className: clsx(Ao.root, So),
    ...wo,
    ownerState: Io,
    classes: Ao
  });
});
process.env.NODE_ENV !== "production" && (InputLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: PropTypes.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["normal", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getFormHelperTextUtilityClasses(Kt) {
  return generateUtilityClass$1("MuiFormHelperText", Kt);
}
const formHelperTextClasses = generateUtilityClasses$1("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var _span$2;
const useUtilityClasses$y = (Kt) => {
  const {
    classes: uo,
    contained: ho,
    size: go,
    disabled: bo,
    error: vo,
    filled: Po,
    focused: Co,
    required: So
  } = Kt, wo = {
    root: ["root", bo && "disabled", vo && "error", go && `size${capitalize(go)}`, ho && "contained", Co && "focused", Po && "filled", So && "required"]
  };
  return composeClasses(wo, getFormHelperTextUtilityClasses, uo);
}, FormHelperTextRoot = styled("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.size && uo[`size${capitalize(ho.size)}`], ho.contained && uo.contained, ho.filled && uo.filled];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  color: (Kt.vars || Kt).palette.text.secondary,
  ...Kt.typography.caption,
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses.disabled}`]: {
    color: (Kt.vars || Kt).palette.text.disabled
  },
  [`&.${formHelperTextClasses.error}`]: {
    color: (Kt.vars || Kt).palette.error.main
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginTop: 4
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.contained,
    style: {
      marginLeft: 14,
      marginRight: 14
    }
  }]
}))), FormHelperText = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiFormHelperText"
  }), {
    children: bo,
    className: vo,
    component: Po = "p",
    disabled: Co,
    error: So,
    filled: wo,
    focused: Eo,
    margin: Ro,
    required: _o,
    variant: Io,
    ...Ao
  } = go, Oo = useFormControl(), jo = formControlState({
    props: go,
    muiFormControl: Oo,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), Do = {
    ...go,
    component: Po,
    contained: jo.variant === "filled" || jo.variant === "outlined",
    variant: jo.variant,
    size: jo.size,
    disabled: jo.disabled,
    error: jo.error,
    filled: jo.filled,
    focused: jo.focused,
    required: jo.required
  };
  delete Do.ownerState;
  const Lo = useUtilityClasses$y(Do);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormHelperTextRoot, {
    as: Po,
    className: clsx(Lo.root, vo),
    ref: ho,
    ...Ao,
    ownerState: Do,
    children: bo === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      _span$2 || (_span$2 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
        className: "notranslate",
        "aria-hidden": !0,
        children: "​"
      }))
    ) : bo
  });
});
process.env.NODE_ENV !== "production" && (FormHelperText.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["filled", "outlined", "standard"]), PropTypes.string])
});
function isOverflowing(Kt) {
  const uo = ownerDocument(Kt);
  return uo.body === Kt ? ownerWindow(Kt).innerWidth > uo.documentElement.clientWidth : Kt.scrollHeight > Kt.clientHeight;
}
function ariaHidden(Kt, uo) {
  uo ? Kt.setAttribute("aria-hidden", "true") : Kt.removeAttribute("aria-hidden");
}
function getPaddingRight(Kt) {
  return parseInt(ownerWindow(Kt).getComputedStyle(Kt).paddingRight, 10) || 0;
}
function isAriaHiddenForbiddenOnElement(Kt) {
  const ho = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].includes(Kt.tagName), go = Kt.tagName === "INPUT" && Kt.getAttribute("type") === "hidden";
  return ho || go;
}
function ariaHiddenSiblings(Kt, uo, ho, go, bo) {
  const vo = [uo, ho, ...go];
  [].forEach.call(Kt.children, (Po) => {
    const Co = !vo.includes(Po), So = !isAriaHiddenForbiddenOnElement(Po);
    Co && So && ariaHidden(Po, bo);
  });
}
function findIndexOf(Kt, uo) {
  let ho = -1;
  return Kt.some((go, bo) => uo(go) ? (ho = bo, !0) : !1), ho;
}
function handleContainer(Kt, uo) {
  const ho = [], go = Kt.container;
  if (!uo.disableScrollLock) {
    if (isOverflowing(go)) {
      const Po = getScrollbarSize(ownerWindow(go));
      ho.push({
        value: go.style.paddingRight,
        property: "padding-right",
        el: go
      }), go.style.paddingRight = `${getPaddingRight(go) + Po}px`;
      const Co = ownerDocument(go).querySelectorAll(".mui-fixed");
      [].forEach.call(Co, (So) => {
        ho.push({
          value: So.style.paddingRight,
          property: "padding-right",
          el: So
        }), So.style.paddingRight = `${getPaddingRight(So) + Po}px`;
      });
    }
    let vo;
    if (go.parentNode instanceof DocumentFragment)
      vo = ownerDocument(go).body;
    else {
      const Po = go.parentElement, Co = ownerWindow(go);
      vo = (Po == null ? void 0 : Po.nodeName) === "HTML" && Co.getComputedStyle(Po).overflowY === "scroll" ? Po : go;
    }
    ho.push({
      value: vo.style.overflow,
      property: "overflow",
      el: vo
    }, {
      value: vo.style.overflowX,
      property: "overflow-x",
      el: vo
    }, {
      value: vo.style.overflowY,
      property: "overflow-y",
      el: vo
    }), vo.style.overflow = "hidden";
  }
  return () => {
    ho.forEach(({
      value: vo,
      el: Po,
      property: Co
    }) => {
      vo ? Po.style.setProperty(Co, vo) : Po.style.removeProperty(Co);
    });
  };
}
function getHiddenSiblings(Kt) {
  const uo = [];
  return [].forEach.call(Kt.children, (ho) => {
    ho.getAttribute("aria-hidden") === "true" && uo.push(ho);
  }), uo;
}
class ModalManager {
  constructor() {
    this.modals = [], this.containers = [];
  }
  add(uo, ho) {
    let go = this.modals.indexOf(uo);
    if (go !== -1)
      return go;
    go = this.modals.length, this.modals.push(uo), uo.modalRef && ariaHidden(uo.modalRef, !1);
    const bo = getHiddenSiblings(ho);
    ariaHiddenSiblings(ho, uo.mount, uo.modalRef, bo, !0);
    const vo = findIndexOf(this.containers, (Po) => Po.container === ho);
    return vo !== -1 ? (this.containers[vo].modals.push(uo), go) : (this.containers.push({
      modals: [uo],
      container: ho,
      restore: null,
      hiddenSiblings: bo
    }), go);
  }
  mount(uo, ho) {
    const go = findIndexOf(this.containers, (vo) => vo.modals.includes(uo)), bo = this.containers[go];
    bo.restore || (bo.restore = handleContainer(bo, ho));
  }
  remove(uo, ho = !0) {
    const go = this.modals.indexOf(uo);
    if (go === -1)
      return go;
    const bo = findIndexOf(this.containers, (Po) => Po.modals.includes(uo)), vo = this.containers[bo];
    if (vo.modals.splice(vo.modals.indexOf(uo), 1), this.modals.splice(go, 1), vo.modals.length === 0)
      vo.restore && vo.restore(), uo.modalRef && ariaHidden(uo.modalRef, ho), ariaHiddenSiblings(vo.container, uo.mount, uo.modalRef, vo.hiddenSiblings, !1), this.containers.splice(bo, 1);
    else {
      const Po = vo.modals[vo.modals.length - 1];
      Po.modalRef && ariaHidden(Po.modalRef, !1);
    }
    return go;
  }
  isTopModal(uo) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === uo;
  }
}
const styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, Fade = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useTheme(), bo = {
    enter: go.transitions.duration.enteringScreen,
    exit: go.transitions.duration.leavingScreen
  }, {
    addEndListener: vo,
    appear: Po = !0,
    children: Co,
    easing: So,
    in: wo,
    onEnter: Eo,
    onEntered: Ro,
    onEntering: _o,
    onExit: Io,
    onExited: Ao,
    onExiting: Oo,
    style: jo,
    timeout: Do = bo,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: Lo = Transition,
    ...ko
  } = uo, Ko = React$1.useRef(null), No = useForkRef(Ko, getReactElementRef(Co), ho), Jo = (ri) => (ni) => {
    if (ri) {
      const si = Ko.current;
      ni === void 0 ? ri(si) : ri(si, ni);
    }
  }, ti = Jo(_o), oi = Jo((ri, ni) => {
    reflow(ri);
    const si = getTransitionProps({
      style: jo,
      timeout: Do,
      easing: So
    }, {
      mode: "enter"
    });
    ri.style.webkitTransition = go.transitions.create("opacity", si), ri.style.transition = go.transitions.create("opacity", si), Eo && Eo(ri, ni);
  }), Qo = Jo(Ro), Zo = Jo(Oo), ei = Jo((ri) => {
    const ni = getTransitionProps({
      style: jo,
      timeout: Do,
      easing: So
    }, {
      mode: "exit"
    });
    ri.style.webkitTransition = go.transitions.create("opacity", ni), ri.style.transition = go.transitions.create("opacity", ni), Io && Io(ri);
  }), ii = Jo(Ao), ai = (ri) => {
    vo && vo(Ko.current, ri);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Lo, {
    appear: Po,
    in: wo,
    nodeRef: Ko,
    onEnter: oi,
    onEntered: Qo,
    onEntering: ti,
    onExit: ei,
    onExited: ii,
    onExiting: Zo,
    addEndListener: ai,
    timeout: Do,
    ...ko,
    children: (ri, {
      ownerState: ni,
      ...si
    }) => /* @__PURE__ */ React$1.cloneElement(Co, {
      style: {
        opacity: 0,
        visibility: ri === "exited" && !wo ? "hidden" : void 0,
        ...styles[ri],
        ...jo,
        ...Co.props.style
      },
      ref: No,
      ...si
    })
  });
});
process.env.NODE_ENV !== "production" && (Fade.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: PropTypes.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: PropTypes.bool,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: PropTypes.oneOfType([PropTypes.shape({
    enter: PropTypes.string,
    exit: PropTypes.string
  }), PropTypes.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,
  /**
   * @ignore
   */
  onEnter: PropTypes.func,
  /**
   * @ignore
   */
  onEntered: PropTypes.func,
  /**
   * @ignore
   */
  onEntering: PropTypes.func,
  /**
   * @ignore
   */
  onExit: PropTypes.func,
  /**
   * @ignore
   */
  onExited: PropTypes.func,
  /**
   * @ignore
   */
  onExiting: PropTypes.func,
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getBackdropUtilityClass(Kt) {
  return generateUtilityClass$1("MuiBackdrop", Kt);
}
generateUtilityClasses$1("MuiBackdrop", ["root", "invisible"]);
const useUtilityClasses$x = (Kt) => {
  const {
    classes: uo,
    invisible: ho
  } = Kt;
  return composeClasses({
    root: ["root", ho && "invisible"]
  }, getBackdropUtilityClass, uo);
}, BackdropRoot = styled("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.invisible && uo.invisible];
  }
})({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent",
  variants: [{
    props: {
      invisible: !0
    },
    style: {
      backgroundColor: "transparent"
    }
  }]
}), Backdrop = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiBackdrop"
  }), {
    children: bo,
    className: vo,
    component: Po = "div",
    invisible: Co = !1,
    open: So,
    components: wo = {},
    componentsProps: Eo = {},
    slotProps: Ro = {},
    slots: _o = {},
    TransitionComponent: Io,
    transitionDuration: Ao,
    ...Oo
  } = go, jo = {
    ...go,
    component: Po,
    invisible: Co
  }, Do = useUtilityClasses$x(jo), Lo = {
    transition: Io,
    root: wo.Root,
    ..._o
  }, ko = {
    ...Eo,
    ...Ro
  }, Ko = {
    slots: Lo,
    slotProps: ko
  }, [No, Jo] = useSlot("root", {
    elementType: BackdropRoot,
    externalForwardedProps: Ko,
    className: clsx(Do.root, vo),
    ownerState: jo
  }), [ti, oi] = useSlot("transition", {
    elementType: Fade,
    externalForwardedProps: Ko,
    ownerState: jo
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ti, {
    in: So,
    timeout: Ao,
    ...Oo,
    ...oi,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(No, {
      "aria-hidden": !0,
      ...Jo,
      classes: Do,
      ref: ho,
      children: bo
    })
  });
});
process.env.NODE_ENV !== "production" && (Backdrop.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    root: PropTypes.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    root: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
});
function getContainer(Kt) {
  return typeof Kt == "function" ? Kt() : Kt;
}
function getHasTransition(Kt) {
  return Kt ? Kt.props.hasOwnProperty("in") : !1;
}
const noop$4 = () => {
}, manager = new ModalManager();
function useModal(Kt) {
  const {
    container: uo,
    disableEscapeKeyDown: ho = !1,
    disableScrollLock: go = !1,
    closeAfterTransition: bo = !1,
    onTransitionEnter: vo,
    onTransitionExited: Po,
    children: Co,
    onClose: So,
    open: wo,
    rootRef: Eo
  } = Kt, Ro = React$1.useRef({}), _o = React$1.useRef(null), Io = React$1.useRef(null), Ao = useForkRef(Io, Eo), [Oo, jo] = React$1.useState(!wo), Do = getHasTransition(Co);
  let Lo = !0;
  (Kt["aria-hidden"] === "false" || Kt["aria-hidden"] === !1) && (Lo = !1);
  const ko = () => ownerDocument(_o.current), Ko = () => (Ro.current.modalRef = Io.current, Ro.current.mount = _o.current, Ro.current), No = () => {
    manager.mount(Ko(), {
      disableScrollLock: go
    }), Io.current && (Io.current.scrollTop = 0);
  }, Jo = useEventCallback(() => {
    const ni = getContainer(uo) || ko().body;
    manager.add(Ko(), ni), Io.current && No();
  }), ti = () => manager.isTopModal(Ko()), oi = useEventCallback((ni) => {
    _o.current = ni, ni && (wo && ti() ? No() : Io.current && ariaHidden(Io.current, Lo));
  }), Qo = React$1.useCallback(() => {
    manager.remove(Ko(), Lo);
  }, [Lo]);
  React$1.useEffect(() => () => {
    Qo();
  }, [Qo]), React$1.useEffect(() => {
    wo ? Jo() : (!Do || !bo) && Qo();
  }, [wo, Qo, Do, bo, Jo]);
  const Zo = (ni) => (si) => {
    var li;
    (li = ni.onKeyDown) == null || li.call(ni, si), !(si.key !== "Escape" || si.which === 229 || // Wait until IME is settled.
    !ti()) && (ho || (si.stopPropagation(), So && So(si, "escapeKeyDown")));
  }, ei = (ni) => (si) => {
    var li;
    (li = ni.onClick) == null || li.call(ni, si), si.target === si.currentTarget && So && So(si, "backdropClick");
  };
  return {
    getRootProps: (ni = {}) => {
      const si = extractEventHandlers(Kt);
      delete si.onTransitionEnter, delete si.onTransitionExited;
      const li = {
        ...si,
        ...ni
      };
      return {
        /*
         * Marking an element with the role presentation indicates to assistive technology
         * that this element should be ignored; it exists to support the web application and
         * is not meant for humans to interact with directly.
         * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
         */
        role: "presentation",
        ...li,
        onKeyDown: Zo(li),
        ref: Ao
      };
    },
    getBackdropProps: (ni = {}) => {
      const si = ni;
      return {
        "aria-hidden": !0,
        ...si,
        onClick: ei(si),
        open: wo
      };
    },
    getTransitionProps: () => {
      const ni = () => {
        jo(!1), vo && vo();
      }, si = () => {
        jo(!0), Po && Po(), bo && Qo();
      };
      return {
        onEnter: createChainedFunction(ni, (Co == null ? void 0 : Co.props.onEnter) ?? noop$4),
        onExited: createChainedFunction(si, (Co == null ? void 0 : Co.props.onExited) ?? noop$4)
      };
    },
    rootRef: Ao,
    portalRef: oi,
    isTopModal: ti,
    exited: Oo,
    hasTransition: Do
  };
}
function getModalUtilityClass(Kt) {
  return generateUtilityClass$1("MuiModal", Kt);
}
generateUtilityClasses$1("MuiModal", ["root", "hidden", "backdrop"]);
const useUtilityClasses$w = (Kt) => {
  const {
    open: uo,
    exited: ho,
    classes: go
  } = Kt;
  return composeClasses({
    root: ["root", !uo && ho && "hidden"],
    backdrop: ["backdrop"]
  }, getModalUtilityClass, go);
}, ModalRoot = styled("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, !ho.open && ho.exited && uo.hidden];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  position: "fixed",
  zIndex: (Kt.vars || Kt).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  variants: [{
    props: ({
      ownerState: uo
    }) => !uo.open && uo.exited,
    style: {
      visibility: "hidden"
    }
  }]
}))), ModalBackdrop = styled(Backdrop, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (Kt, uo) => uo.backdrop
})({
  zIndex: -1
}), Modal$1 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    name: "MuiModal",
    props: uo
  }), {
    BackdropComponent: bo = ModalBackdrop,
    BackdropProps: vo,
    classes: Po,
    className: Co,
    closeAfterTransition: So = !1,
    children: wo,
    container: Eo,
    component: Ro,
    components: _o = {},
    componentsProps: Io = {},
    disableAutoFocus: Ao = !1,
    disableEnforceFocus: Oo = !1,
    disableEscapeKeyDown: jo = !1,
    disablePortal: Do = !1,
    disableRestoreFocus: Lo = !1,
    disableScrollLock: ko = !1,
    hideBackdrop: Ko = !1,
    keepMounted: No = !1,
    onBackdropClick: Jo,
    onClose: ti,
    onTransitionEnter: oi,
    onTransitionExited: Qo,
    open: Zo,
    slotProps: ei = {},
    slots: ii = {},
    // eslint-disable-next-line react/prop-types
    theme: ai,
    ...ri
  } = go, ni = {
    ...go,
    closeAfterTransition: So,
    disableAutoFocus: Ao,
    disableEnforceFocus: Oo,
    disableEscapeKeyDown: jo,
    disablePortal: Do,
    disableRestoreFocus: Lo,
    disableScrollLock: ko,
    hideBackdrop: Ko,
    keepMounted: No
  }, {
    getRootProps: si,
    getBackdropProps: li,
    getTransitionProps: ui,
    portalRef: ci,
    isTopModal: fi,
    exited: yi,
    hasTransition: hi
  } = useModal({
    ...ni,
    rootRef: ho
  }), mi = {
    ...ni,
    exited: yi
  }, bi = useUtilityClasses$w(mi), xi = {};
  if (wo.props.tabIndex === void 0 && (xi.tabIndex = "-1"), hi) {
    const {
      onEnter: gi,
      onExited: Ri
    } = ui();
    xi.onEnter = gi, xi.onExited = Ri;
  }
  const $i = {
    ...ri,
    slots: {
      root: _o.Root,
      backdrop: _o.Backdrop,
      ...ii
    },
    slotProps: {
      ...Io,
      ...ei
    }
  }, [Ci, Si] = useSlot("root", {
    elementType: ModalRoot,
    externalForwardedProps: $i,
    getSlotProps: si,
    additionalProps: {
      ref: ho,
      as: Ro
    },
    ownerState: mi,
    className: clsx(Co, bi == null ? void 0 : bi.root, !mi.open && mi.exited && (bi == null ? void 0 : bi.hidden))
  }), [vi, Pi] = useSlot("backdrop", {
    elementType: bo,
    externalForwardedProps: $i,
    additionalProps: vo,
    getSlotProps: (gi) => li({
      ...gi,
      onClick: (Ri) => {
        Jo && Jo(Ri), gi != null && gi.onClick && gi.onClick(Ri);
      }
    }),
    className: clsx(vo == null ? void 0 : vo.className, bi == null ? void 0 : bi.backdrop),
    ownerState: mi
  }), wi = useForkRef(vo == null ? void 0 : vo.ref, Pi.ref);
  return !No && !Zo && (!hi || yi) ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, {
    ref: ci,
    container: Eo,
    disablePortal: Do,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Ci, {
      ...Si,
      children: [!Ko && bo ? /* @__PURE__ */ jsxRuntimeExports.jsx(vi, {
        ...Pi,
        ref: wi
      }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, {
        disableEnforceFocus: Oo,
        disableAutoFocus: Ao,
        disableRestoreFocus: Lo,
        isEnabled: fi,
        open: Zo,
        children: /* @__PURE__ */ React$1.cloneElement(wo, xi)
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (Modal$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](https://mui.com/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated Use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Backdrop: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated Use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: PropTypes.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: PropTypes.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: PropTypes.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: PropTypes.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: PropTypes.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: PropTypes.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: PropTypes.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: PropTypes.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: PropTypes.shape({
    backdrop: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    backdrop: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getPopoverUtilityClass(Kt) {
  return generateUtilityClass$1("MuiPopover", Kt);
}
generateUtilityClasses$1("MuiPopover", ["root", "paper"]);
function getOffsetTop(Kt, uo) {
  let ho = 0;
  return typeof uo == "number" ? ho = uo : uo === "center" ? ho = Kt.height / 2 : uo === "bottom" && (ho = Kt.height), ho;
}
function getOffsetLeft(Kt, uo) {
  let ho = 0;
  return typeof uo == "number" ? ho = uo : uo === "center" ? ho = Kt.width / 2 : uo === "right" && (ho = Kt.width), ho;
}
function getTransformOriginValue(Kt) {
  return [Kt.horizontal, Kt.vertical].map((uo) => typeof uo == "number" ? `${uo}px` : uo).join(" ");
}
function resolveAnchorEl(Kt) {
  return typeof Kt == "function" ? Kt() : Kt;
}
const useUtilityClasses$v = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["root"],
    paper: ["paper"]
  }, getPopoverUtilityClass, uo);
}, PopoverRoot = styled(Modal$1, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})({}), PopoverPaper = styled(Paper, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (Kt, uo) => uo.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Popover = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiPopover"
  }), {
    action: bo,
    anchorEl: vo,
    anchorOrigin: Po = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: Co,
    anchorReference: So = "anchorEl",
    children: wo,
    className: Eo,
    container: Ro,
    elevation: _o = 8,
    marginThreshold: Io = 16,
    open: Ao,
    PaperProps: Oo = {},
    slots: jo = {},
    slotProps: Do = {},
    transformOrigin: Lo = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: ko = Grow,
    transitionDuration: Ko = "auto",
    TransitionProps: {
      onEntering: No,
      ...Jo
    } = {},
    disableScrollLock: ti = !1,
    ...oi
  } = go, Qo = (Do == null ? void 0 : Do.paper) ?? Oo, Zo = React$1.useRef(), ei = {
    ...go,
    anchorOrigin: Po,
    anchorReference: So,
    elevation: _o,
    marginThreshold: Io,
    externalPaperSlotProps: Qo,
    transformOrigin: Lo,
    TransitionComponent: ko,
    transitionDuration: Ko,
    TransitionProps: Jo
  }, ii = useUtilityClasses$v(ei), ai = React$1.useCallback(() => {
    if (So === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (Co || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), Co;
    const Pi = resolveAnchorEl(vo), wi = Pi && Pi.nodeType === 1 ? Pi : ownerDocument(Zo.current).body, gi = wi.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const Ri = wi.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && Ri.top === 0 && Ri.left === 0 && Ri.right === 0 && Ri.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: gi.top + getOffsetTop(gi, Po.vertical),
      left: gi.left + getOffsetLeft(gi, Po.horizontal)
    };
  }, [vo, Po.horizontal, Po.vertical, Co, So]), ri = React$1.useCallback((Pi) => ({
    vertical: getOffsetTop(Pi, Lo.vertical),
    horizontal: getOffsetLeft(Pi, Lo.horizontal)
  }), [Lo.horizontal, Lo.vertical]), ni = React$1.useCallback((Pi) => {
    const wi = {
      width: Pi.offsetWidth,
      height: Pi.offsetHeight
    }, gi = ri(wi);
    if (So === "none")
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(gi)
      };
    const Ri = ai();
    let Ei = Ri.top - gi.vertical, Ni = Ri.left - gi.horizontal;
    const Ai = Ei + wi.height, Yi = Ni + wi.width, Ui = ownerWindow(resolveAnchorEl(vo)), us = Ui.innerHeight - Io, ns = Ui.innerWidth - Io;
    if (Io !== null && Ei < Io) {
      const Ti = Ei - Io;
      Ei -= Ti, gi.vertical += Ti;
    } else if (Io !== null && Ai > us) {
      const Ti = Ai - us;
      Ei -= Ti, gi.vertical += Ti;
    }
    if (process.env.NODE_ENV !== "production" && wi.height > us && wi.height && us && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${wi.height - us}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), Io !== null && Ni < Io) {
      const Ti = Ni - Io;
      Ni -= Ti, gi.horizontal += Ti;
    } else if (Yi > ns) {
      const Ti = Yi - ns;
      Ni -= Ti, gi.horizontal += Ti;
    }
    return {
      top: `${Math.round(Ei)}px`,
      left: `${Math.round(Ni)}px`,
      transformOrigin: getTransformOriginValue(gi)
    };
  }, [vo, So, ai, ri, Io]), [si, li] = React$1.useState(Ao), ui = React$1.useCallback(() => {
    const Pi = Zo.current;
    if (!Pi)
      return;
    const wi = ni(Pi);
    wi.top !== null && Pi.style.setProperty("top", wi.top), wi.left !== null && (Pi.style.left = wi.left), Pi.style.transformOrigin = wi.transformOrigin, li(!0);
  }, [ni]);
  React$1.useEffect(() => (ti && window.addEventListener("scroll", ui), () => window.removeEventListener("scroll", ui)), [vo, ti, ui]);
  const ci = (Pi, wi) => {
    No && No(Pi, wi), ui();
  }, fi = () => {
    li(!1);
  };
  React$1.useEffect(() => {
    Ao && ui();
  }), React$1.useImperativeHandle(bo, () => Ao ? {
    updatePosition: () => {
      ui();
    }
  } : null, [Ao, ui]), React$1.useEffect(() => {
    if (!Ao)
      return;
    const Pi = debounce$3(() => {
      ui();
    }), wi = ownerWindow(vo);
    return wi.addEventListener("resize", Pi), () => {
      Pi.clear(), wi.removeEventListener("resize", Pi);
    };
  }, [vo, Ao, ui]);
  let yi = Ko;
  Ko === "auto" && !ko.muiSupportAuto && (yi = void 0);
  const hi = Ro || (vo ? ownerDocument(resolveAnchorEl(vo)).body : void 0), mi = {
    slots: jo,
    slotProps: {
      ...Do,
      paper: Qo
    }
  }, [bi, xi] = useSlot("paper", {
    elementType: PopoverPaper,
    externalForwardedProps: mi,
    additionalProps: {
      elevation: _o,
      className: clsx(ii.paper, Qo == null ? void 0 : Qo.className),
      style: si ? Qo.style : {
        ...Qo.style,
        opacity: 0
      }
    },
    ownerState: ei
  }), [$i, {
    slotProps: Ci,
    ...Si
  }] = useSlot("root", {
    elementType: PopoverRoot,
    externalForwardedProps: mi,
    additionalProps: {
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: hi,
      open: Ao
    },
    ownerState: ei,
    className: clsx(ii.root, Eo)
  }), vi = useForkRef(Zo, xi.ref);
  return /* @__PURE__ */ jsxRuntimeExports.jsx($i, {
    ...Si,
    ...!isHostComponent($i) && {
      slotProps: Ci,
      disableScrollLock: ti
    },
    ...oi,
    ref: ho,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(ko, {
      appear: !0,
      in: Ao,
      onEntering: ci,
      onExited: fi,
      timeout: yi,
      ...Jo,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(bi, {
        ...xi,
        ref: vi,
        children: wo
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (Popover.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,
  /**
   * An HTML element, [PopoverVirtualElement](https://mui.com/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([HTMLElementType, PropTypes.func]), (Kt) => {
    if (Kt.open && (!Kt.anchorReference || Kt.anchorReference === "anchorEl")) {
      const uo = resolveAnchorEl(Kt.anchorEl);
      if (uo && uo.nodeType === 1) {
        const ho = uo.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && ho.top === 0 && ho.left === 0 && ho.right === 0 && ho.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${uo}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: PropTypes.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slotProps.root.slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slotProps.root.slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.root.slotProps.backdrop` instead.
   */
  BackdropProps: PropTypes.object,
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: PropTypes.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: integerPropType,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * Props applied to the [`Paper`](https://mui.com/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef$1
  }),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.oneOf(["center", "left", "right"]), PropTypes.number]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.oneOf(["bottom", "center", "top"]), PropTypes.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
function getMenuUtilityClass(Kt) {
  return generateUtilityClass$1("MuiMenu", Kt);
}
generateUtilityClasses$1("MuiMenu", ["root", "paper", "list"]);
const RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
}, LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
}, useUtilityClasses$u = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, getMenuUtilityClass, uo);
}, MenuRoot = styled(Popover, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})({}), MenuPaper = styled(PopoverPaper, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (Kt, uo) => uo.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), MenuMenuList = styled(MenuList, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (Kt, uo) => uo.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), Menu = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiMenu"
  }), {
    autoFocus: bo = !0,
    children: vo,
    className: Po,
    disableAutoFocusItem: Co = !1,
    MenuListProps: So = {},
    onClose: wo,
    open: Eo,
    PaperProps: Ro = {},
    PopoverClasses: _o,
    transitionDuration: Io = "auto",
    TransitionProps: {
      onEntering: Ao,
      ...Oo
    } = {},
    variant: jo = "selectedMenu",
    slots: Do = {},
    slotProps: Lo = {},
    ...ko
  } = go, Ko = useRtl(), No = {
    ...go,
    autoFocus: bo,
    disableAutoFocusItem: Co,
    MenuListProps: So,
    onEntering: Ao,
    PaperProps: Ro,
    transitionDuration: Io,
    TransitionProps: Oo,
    variant: jo
  }, Jo = useUtilityClasses$u(No), ti = bo && !Co && Eo, oi = React$1.useRef(null), Qo = (si, li) => {
    oi.current && oi.current.adjustStyleForScrollbar(si, {
      direction: Ko ? "rtl" : "ltr"
    }), Ao && Ao(si, li);
  }, Zo = (si) => {
    si.key === "Tab" && (si.preventDefault(), wo && wo(si, "tabKeyDown"));
  };
  let ei = -1;
  React$1.Children.map(vo, (si, li) => {
    /* @__PURE__ */ React$1.isValidElement(si) && (process.env.NODE_ENV !== "production" && reactIsExports$1.isFragment(si) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), si.props.disabled || (jo === "selectedMenu" && si.props.selected || ei === -1) && (ei = li));
  });
  const ii = Do.paper ?? MenuPaper, ai = Lo.paper ?? Ro, ri = useSlotProps({
    elementType: Do.root,
    externalSlotProps: Lo.root,
    ownerState: No,
    className: [Jo.root, Po]
  }), ni = useSlotProps({
    elementType: ii,
    externalSlotProps: ai,
    ownerState: No,
    className: Jo.paper
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuRoot, {
    onClose: wo,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: Ko ? "right" : "left"
    },
    transformOrigin: Ko ? RTL_ORIGIN : LTR_ORIGIN,
    slots: {
      paper: ii,
      root: Do.root
    },
    slotProps: {
      root: ri,
      paper: ni
    },
    open: Eo,
    ref: ho,
    transitionDuration: Io,
    TransitionProps: {
      onEntering: Qo,
      ...Oo
    },
    ownerState: No,
    ...ko,
    classes: _o,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuMenuList, {
      onKeyDown: Zo,
      actions: oi,
      autoFocus: bo && (ei === -1 || Co),
      autoFocusItem: ti,
      variant: jo,
      ...So,
      className: clsx(Jo.list, So.className),
      children: vo
    })
  });
});
process.env.NODE_ENV !== "production" && (Menu.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([HTMLElementType, PropTypes.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: PropTypes.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: PropTypes.bool,
  /**
   * Props applied to the [`MenuList`](https://mui.com/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: PropTypes.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: PropTypes.object,
  /**
   * `classes` prop applied to the [`Popover`](https://mui.com/material-ui/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    paper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    paper: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: PropTypes.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: PropTypes.oneOf(["menu", "selectedMenu"])
});
function getNativeSelectUtilityClasses(Kt) {
  return generateUtilityClass$1("MuiNativeSelect", Kt);
}
const nativeSelectClasses = generateUtilityClasses$1("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), useUtilityClasses$t = (Kt) => {
  const {
    classes: uo,
    variant: ho,
    disabled: go,
    multiple: bo,
    open: vo,
    error: Po
  } = Kt, Co = {
    select: ["select", ho, go && "disabled", bo && "multiple", Po && "error"],
    icon: ["icon", `icon${capitalize(ho)}`, vo && "iconOpen", go && "disabled"]
  };
  return composeClasses(Co, getNativeSelectUtilityClasses, uo);
}, StyledSelectSelect = styled("select")(({
  theme: Kt
}) => ({
  // Reset
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  // Reset
  borderRadius: 0,
  cursor: "pointer",
  "&:focus": {
    // Reset Chrome style
    borderRadius: 0
  },
  [`&.${nativeSelectClasses.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (Kt.vars || Kt).palette.background.paper
  },
  variants: [{
    props: ({
      ownerState: uo
    }) => uo.variant !== "filled" && uo.variant !== "outlined",
    style: {
      // Bump specificity to allow extending custom inputs
      "&&&": {
        paddingRight: 24,
        minWidth: 16
        // So it doesn't collapse.
      }
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      "&&&": {
        paddingRight: 32
      }
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      borderRadius: (Kt.vars || Kt).shape.borderRadius,
      "&:focus": {
        borderRadius: (Kt.vars || Kt).shape.borderRadius
        // Reset the reset for Chrome style
      },
      "&&&": {
        paddingRight: 32
      }
    }
  }]
})), NativeSelectSelect = styled(StyledSelectSelect, {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: rootShouldForwardProp,
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.select, uo[ho.variant], ho.error && uo.error, {
      [`&.${nativeSelectClasses.multiple}`]: uo.multiple
    }];
  }
})({}), StyledSelectIcon = styled("svg")(({
  theme: Kt
}) => ({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  // Center vertically, height is 1em
  top: "calc(50% - .5em)",
  // Don't block pointer events on the select under the icon.
  pointerEvents: "none",
  color: (Kt.vars || Kt).palette.action.active,
  [`&.${nativeSelectClasses.disabled}`]: {
    color: (Kt.vars || Kt).palette.action.disabled
  },
  variants: [{
    props: ({
      ownerState: uo
    }) => uo.open,
    style: {
      transform: "rotate(180deg)"
    }
  }, {
    props: {
      variant: "filled"
    },
    style: {
      right: 7
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      right: 7
    }
  }]
})), NativeSelectIcon = styled(StyledSelectIcon, {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.icon, ho.variant && uo[`icon${capitalize(ho.variant)}`], ho.open && uo.iconOpen];
  }
})({}), NativeSelectInput = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    className: go,
    disabled: bo,
    error: vo,
    IconComponent: Po,
    inputRef: Co,
    variant: So = "standard",
    ...wo
  } = uo, Eo = {
    ...uo,
    disabled: bo,
    variant: So,
    error: vo
  }, Ro = useUtilityClasses$t(Eo);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectSelect, {
      ownerState: Eo,
      className: clsx(Ro.select, go),
      disabled: bo,
      ref: Co || ho,
      ...wo
    }), uo.multiple ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(NativeSelectIcon, {
      as: Po,
      ownerState: Eo,
      className: Ro.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,
  /**
   * @ignore
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
function getSelectUtilityClasses(Kt) {
  return generateUtilityClass$1("MuiSelect", Kt);
}
const selectClasses = generateUtilityClasses$1("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var _span$1;
const SelectSelect = styled(StyledSelectSelect, {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [
      // Win specificity over the input base
      {
        [`&.${selectClasses.select}`]: uo.select
      },
      {
        [`&.${selectClasses.select}`]: uo[ho.variant]
      },
      {
        [`&.${selectClasses.error}`]: uo.error
      },
      {
        [`&.${selectClasses.multiple}`]: uo.multiple
      }
    ];
  }
})({
  // Win specificity over the input base
  [`&.${selectClasses.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), SelectIcon = styled(StyledSelectIcon, {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.icon, ho.variant && uo[`icon${capitalize(ho.variant)}`], ho.open && uo.iconOpen];
  }
})({}), SelectNativeInput = styled("input", {
  shouldForwardProp: (Kt) => slotShouldForwardProp(Kt) && Kt !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (Kt, uo) => uo.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function areEqualValues(Kt, uo) {
  return typeof uo == "object" && uo !== null ? Kt === uo : String(Kt) === String(uo);
}
function isEmpty(Kt) {
  return Kt == null || typeof Kt == "string" && !Kt.trim();
}
const useUtilityClasses$s = (Kt) => {
  const {
    classes: uo,
    variant: ho,
    disabled: go,
    multiple: bo,
    open: vo,
    error: Po
  } = Kt, Co = {
    select: ["select", ho, go && "disabled", bo && "multiple", Po && "error"],
    icon: ["icon", `icon${capitalize(ho)}`, vo && "iconOpen", go && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return composeClasses(Co, getSelectUtilityClasses, uo);
}, SelectInput = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  var Zi;
  const {
    "aria-describedby": go,
    "aria-label": bo,
    autoFocus: vo,
    autoWidth: Po,
    children: Co,
    className: So,
    defaultOpen: wo,
    defaultValue: Eo,
    disabled: Ro,
    displayEmpty: _o,
    error: Io = !1,
    IconComponent: Ao,
    inputRef: Oo,
    labelId: jo,
    MenuProps: Do = {},
    multiple: Lo,
    name: ko,
    onBlur: Ko,
    onChange: No,
    onClose: Jo,
    onFocus: ti,
    onOpen: oi,
    open: Qo,
    readOnly: Zo,
    renderValue: ei,
    required: ii,
    SelectDisplayProps: ai = {},
    tabIndex: ri,
    // catching `type` from Input which makes no sense for SelectInput
    type: ni,
    value: si,
    variant: li = "standard",
    ...ui
  } = uo, [ci, fi] = useControlled({
    controlled: si,
    default: Eo,
    name: "Select"
  }), [yi, hi] = useControlled({
    controlled: Qo,
    default: wo,
    name: "Select"
  }), mi = React$1.useRef(null), bi = React$1.useRef(null), [xi, $i] = React$1.useState(null), {
    current: Ci
  } = React$1.useRef(Qo != null), [Si, vi] = React$1.useState(), Pi = useForkRef(ho, Oo), wi = React$1.useCallback((zi) => {
    bi.current = zi, zi && $i(zi);
  }, []), gi = xi == null ? void 0 : xi.parentNode;
  React$1.useImperativeHandle(Pi, () => ({
    focus: () => {
      bi.current.focus();
    },
    node: mi.current,
    value: ci
  }), [ci]), React$1.useEffect(() => {
    wo && yi && xi && !Ci && (vi(Po ? null : gi.clientWidth), bi.current.focus());
  }, [xi, Po]), React$1.useEffect(() => {
    vo && bi.current.focus();
  }, [vo]), React$1.useEffect(() => {
    if (!jo)
      return;
    const zi = ownerDocument(bi.current).getElementById(jo);
    if (zi) {
      const cs = () => {
        getSelection().isCollapsed && bi.current.focus();
      };
      return zi.addEventListener("click", cs), () => {
        zi.removeEventListener("click", cs);
      };
    }
  }, [jo]);
  const Ri = (zi, cs) => {
    zi ? oi && oi(cs) : Jo && Jo(cs), Ci || (vi(Po ? null : gi.clientWidth), hi(zi));
  }, Ei = (zi) => {
    zi.button === 0 && (zi.preventDefault(), bi.current.focus(), Ri(!0, zi));
  }, Ni = (zi) => {
    Ri(!1, zi);
  }, Ai = React$1.Children.toArray(Co), Yi = (zi) => {
    const cs = Ai.find((ys) => ys.props.value === zi.target.value);
    cs !== void 0 && (fi(cs.props.value), No && No(zi, cs));
  }, Ui = (zi) => (cs) => {
    let ys;
    if (cs.currentTarget.hasAttribute("tabindex")) {
      if (Lo) {
        ys = Array.isArray(ci) ? ci.slice() : [];
        const $s = ci.indexOf(zi.props.value);
        $s === -1 ? ys.push(zi.props.value) : ys.splice($s, 1);
      } else
        ys = zi.props.value;
      if (zi.props.onClick && zi.props.onClick(cs), ci !== ys && (fi(ys), No)) {
        const $s = cs.nativeEvent || cs, Ns = new $s.constructor($s.type, $s);
        Object.defineProperty(Ns, "target", {
          writable: !0,
          value: {
            value: ys,
            name: ko
          }
        }), No(Ns, zi);
      }
      Lo || Ri(!1, cs);
    }
  }, us = (zi) => {
    Zo || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].includes(zi.key) && (zi.preventDefault(), Ri(!0, zi));
  }, ns = xi !== null && yi, Ti = (zi) => {
    !ns && Ko && (Object.defineProperty(zi, "target", {
      writable: !0,
      value: {
        value: ci,
        name: ko
      }
    }), Ko(zi));
  };
  delete ui["aria-invalid"];
  let _i, Vi;
  const Bi = [];
  let Ji = !1, Ki = !1;
  (isFilled({
    value: ci
  }) || _o) && (ei ? _i = ei(ci) : Ji = !0);
  const qi = Ai.map((zi) => {
    if (!/* @__PURE__ */ React$1.isValidElement(zi))
      return null;
    process.env.NODE_ENV !== "production" && reactIsExports$1.isFragment(zi) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let cs;
    if (Lo) {
      if (!Array.isArray(ci))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : formatMuiErrorMessage(2));
      cs = ci.some((ys) => areEqualValues(ys, zi.props.value)), cs && Ji && Bi.push(zi.props.children);
    } else
      cs = areEqualValues(ci, zi.props.value), cs && Ji && (Vi = zi.props.children);
    return cs && (Ki = !0), /* @__PURE__ */ React$1.cloneElement(zi, {
      "aria-selected": cs ? "true" : "false",
      onClick: Ui(zi),
      onKeyUp: (ys) => {
        ys.key === " " && ys.preventDefault(), zi.props.onKeyUp && zi.props.onKeyUp(ys);
      },
      role: "option",
      selected: cs,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": zi.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && React$1.useEffect(() => {
    if (!Ki && !Lo && ci !== "") {
      const zi = Ai.map((cs) => cs.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${ci}\` for the select ${ko ? `(name="${ko}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${zi.filter((cs) => cs != null).map((cs) => `\`${cs}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Ki, Ai, Lo, ko, ci]), Ji && (Lo ? Bi.length === 0 ? _i = null : _i = Bi.reduce((zi, cs, ys) => (zi.push(cs), ys < Bi.length - 1 && zi.push(", "), zi), []) : _i = Vi);
  let rs = Si;
  !Po && Ci && xi && (rs = gi.clientWidth);
  let os;
  typeof ri < "u" ? os = ri : os = Ro ? null : 0;
  const ps = ai.id || (ko ? `mui-component-select-${ko}` : void 0), Mi = {
    ...uo,
    variant: li,
    value: ci,
    open: ns,
    error: Io
  }, Wi = useUtilityClasses$s(Mi), Hi = {
    ...Do.PaperProps,
    ...(Zi = Do.slotProps) == null ? void 0 : Zi.paper
  }, Xi = useId();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SelectSelect, {
      as: "div",
      ref: wi,
      tabIndex: os,
      role: "combobox",
      "aria-controls": Xi,
      "aria-disabled": Ro ? "true" : void 0,
      "aria-expanded": ns ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": bo,
      "aria-labelledby": [jo, ps].filter(Boolean).join(" ") || void 0,
      "aria-describedby": go,
      "aria-required": ii ? "true" : void 0,
      "aria-invalid": Io ? "true" : void 0,
      onKeyDown: us,
      onMouseDown: Ro || Zo ? null : Ei,
      onBlur: Ti,
      onFocus: ti,
      ...ai,
      ownerState: Mi,
      className: clsx(ai.className, Wi.select, So),
      id: ps,
      children: isEmpty(_i) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        _span$1 || (_span$1 = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
          className: "notranslate",
          "aria-hidden": !0,
          children: "​"
        }))
      ) : _i
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectNativeInput, {
      "aria-invalid": Io,
      value: Array.isArray(ci) ? ci.join(",") : ci,
      name: ko,
      ref: mi,
      "aria-hidden": !0,
      onChange: Yi,
      tabIndex: -1,
      disabled: Ro,
      className: Wi.nativeInput,
      autoFocus: vo,
      required: ii,
      ...ui,
      ownerState: Mi
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SelectIcon, {
      as: Ao,
      className: Wi.icon,
      ownerState: Mi
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(Menu, {
      id: `menu-${ko || ""}`,
      anchorEl: gi,
      open: ns,
      onClose: Ni,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      },
      ...Do,
      MenuListProps: {
        "aria-labelledby": jo,
        role: "listbox",
        "aria-multiselectable": Lo ? "true" : void 0,
        disableListWrap: !0,
        id: Xi,
        ...Do.MenuListProps
      },
      slotProps: {
        ...Do.slotProps,
        paper: {
          ...Hi,
          style: {
            minWidth: rs,
            ...Hi != null ? Hi.style : null
          }
        }
      },
      children: qi
    })]
  });
});
process.env.NODE_ENV !== "production" && (SelectInput.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": PropTypes.string,
  /**
   * @ignore
   */
  "aria-label": PropTypes.string,
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * @ignore
   */
  readOnly: PropTypes.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * If `true`, the component is required.
   */
  required: PropTypes.bool,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  type: PropTypes.any,
  /**
   * The input value.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(["standard", "outlined", "filled"])
});
const useUtilityClasses$r = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return uo;
}, styledRootConfig = {
  name: "MuiSelect",
  overridesResolver: (Kt, uo) => uo.root,
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) && Kt !== "variant",
  slot: "Root"
}, StyledInput = styled(Input, styledRootConfig)(""), StyledOutlinedInput = styled(OutlinedInput, styledRootConfig)(""), StyledFilledInput = styled(FilledInput, styledRootConfig)(""), Select$1 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    name: "MuiSelect",
    props: uo
  }), {
    autoWidth: bo = !1,
    children: vo,
    classes: Po = {},
    className: Co,
    defaultOpen: So = !1,
    displayEmpty: wo = !1,
    IconComponent: Eo = ArrowDropDownIcon,
    id: Ro,
    input: _o,
    inputProps: Io,
    label: Ao,
    labelId: Oo,
    MenuProps: jo,
    multiple: Do = !1,
    native: Lo = !1,
    onClose: ko,
    onOpen: Ko,
    open: No,
    renderValue: Jo,
    SelectDisplayProps: ti,
    variant: oi = "outlined",
    ...Qo
  } = go, Zo = Lo ? NativeSelectInput : SelectInput, ei = useFormControl(), ii = formControlState({
    props: go,
    muiFormControl: ei,
    states: ["variant", "error"]
  }), ai = ii.variant || oi, ri = {
    ...go,
    variant: ai,
    classes: Po
  }, ni = useUtilityClasses$r(ri), {
    root: si,
    ...li
  } = ni, ui = _o || {
    standard: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledInput, {
      ownerState: ri
    }),
    outlined: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledOutlinedInput, {
      label: Ao,
      ownerState: ri
    }),
    filled: /* @__PURE__ */ jsxRuntimeExports.jsx(StyledFilledInput, {
      ownerState: ri
    })
  }[ai], ci = useForkRef(ho, getReactElementRef(ui));
  return /* @__PURE__ */ jsxRuntimeExports.jsx(React$1.Fragment, {
    children: /* @__PURE__ */ React$1.cloneElement(ui, {
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: Zo,
      inputProps: {
        children: vo,
        error: ii.error,
        IconComponent: Eo,
        variant: ai,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: Do,
        ...Lo ? {
          id: Ro
        } : {
          autoWidth: bo,
          defaultOpen: So,
          displayEmpty: wo,
          labelId: Oo,
          MenuProps: jo,
          onClose: ko,
          onOpen: Ko,
          open: No,
          renderValue: Jo,
          SelectDisplayProps: {
            id: Ro,
            ...ti
          }
        },
        ...Io,
        classes: Io ? deepmerge(li, Io.classes) : li,
        ..._o ? _o.props.inputProps : {}
      },
      ...(Do && Lo || wo) && ai === "outlined" ? {
        notched: !0
      } : {},
      ref: ci,
      className: clsx(ui.props.className, Co, ni.root),
      // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
      ...!_o && {
        variant: ai
      },
      ...Qo
    })
  });
});
process.env.NODE_ENV !== "production" && (Select$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: PropTypes.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: PropTypes.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: PropTypes.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: PropTypes.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: PropTypes.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,
  /**
   * See [OutlinedInput#label](https://mui.com/material-ui/api/outlined-input/#props)
   */
  label: PropTypes.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,
  /**
   * Props applied to the [`Menu`](https://mui.com/material-ui/api/menu/) element.
   */
  MenuProps: PropTypes.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: PropTypes.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: PropTypes.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.oneOfType([PropTypes.oneOf([""]), PropTypes.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
Select$1.muiName = "Select";
function getTextFieldUtilityClass(Kt) {
  return generateUtilityClass$1("MuiTextField", Kt);
}
generateUtilityClasses$1("MuiTextField", ["root"]);
const variantComponent = {
  standard: Input,
  filled: FilledInput,
  outlined: OutlinedInput
}, useUtilityClasses$q = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["root"]
  }, getTextFieldUtilityClass, uo);
}, TextFieldRoot = styled(FormControl, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})({}), TextField = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiTextField"
  }), {
    autoComplete: bo,
    autoFocus: vo = !1,
    children: Po,
    className: Co,
    color: So = "primary",
    defaultValue: wo,
    disabled: Eo = !1,
    error: Ro = !1,
    FormHelperTextProps: _o,
    fullWidth: Io = !1,
    helperText: Ao,
    id: Oo,
    InputLabelProps: jo,
    inputProps: Do,
    InputProps: Lo,
    inputRef: ko,
    label: Ko,
    maxRows: No,
    minRows: Jo,
    multiline: ti = !1,
    name: oi,
    onBlur: Qo,
    onChange: Zo,
    onFocus: ei,
    placeholder: ii,
    required: ai = !1,
    rows: ri,
    select: ni = !1,
    SelectProps: si,
    slots: li = {},
    slotProps: ui = {},
    type: ci,
    value: fi,
    variant: yi = "outlined",
    ...hi
  } = go, mi = {
    ...go,
    autoFocus: vo,
    color: So,
    disabled: Eo,
    error: Ro,
    fullWidth: Io,
    multiline: ti,
    required: ai,
    select: ni,
    variant: yi
  }, bi = useUtilityClasses$q(mi);
  process.env.NODE_ENV !== "production" && ni && !Po && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const xi = useId(Oo), $i = Ao && xi ? `${xi}-helper-text` : void 0, Ci = Ko && xi ? `${xi}-label` : void 0, Si = variantComponent[yi], vi = {
    slots: li,
    slotProps: {
      input: Lo,
      inputLabel: jo,
      htmlInput: Do,
      formHelperText: _o,
      select: si,
      ...ui
    }
  }, Pi = {}, wi = vi.slotProps.inputLabel;
  yi === "outlined" && (wi && typeof wi.shrink < "u" && (Pi.notched = wi.shrink), Pi.label = Ko), ni && ((!si || !si.native) && (Pi.id = void 0), Pi["aria-describedby"] = void 0);
  const [gi, Ri] = useSlot("input", {
    elementType: Si,
    externalForwardedProps: vi,
    additionalProps: Pi,
    ownerState: mi
  }), [Ei, Ni] = useSlot("inputLabel", {
    elementType: InputLabel,
    externalForwardedProps: vi,
    ownerState: mi
  }), [Ai, Yi] = useSlot("htmlInput", {
    elementType: "input",
    externalForwardedProps: vi,
    ownerState: mi
  }), [Ui, us] = useSlot("formHelperText", {
    elementType: FormHelperText,
    externalForwardedProps: vi,
    ownerState: mi
  }), [ns, Ti] = useSlot("select", {
    elementType: Select$1,
    externalForwardedProps: vi,
    ownerState: mi
  }), _i = /* @__PURE__ */ jsxRuntimeExports.jsx(gi, {
    "aria-describedby": $i,
    autoComplete: bo,
    autoFocus: vo,
    defaultValue: wo,
    fullWidth: Io,
    multiline: ti,
    name: oi,
    rows: ri,
    maxRows: No,
    minRows: Jo,
    type: ci,
    value: fi,
    id: xi,
    inputRef: ko,
    onBlur: Qo,
    onChange: Zo,
    onFocus: ei,
    placeholder: ii,
    inputProps: Yi,
    slots: {
      input: li.htmlInput ? Ai : void 0
    },
    ...Ri
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(TextFieldRoot, {
    className: clsx(bi.root, Co),
    disabled: Eo,
    error: Ro,
    fullWidth: Io,
    ref: ho,
    required: ai,
    color: So,
    variant: yi,
    ownerState: mi,
    ...hi,
    children: [Ko != null && Ko !== "" && /* @__PURE__ */ jsxRuntimeExports.jsx(Ei, {
      htmlFor: xi,
      id: Ci,
      ...Ni,
      children: Ko
    }), ni ? /* @__PURE__ */ jsxRuntimeExports.jsx(ns, {
      "aria-describedby": $i,
      id: xi,
      labelId: Ci,
      value: fi,
      input: _i,
      ...Ti,
      children: Po
    }) : _i, Ao && /* @__PURE__ */ jsxRuntimeExports.jsx(Ui, {
      id: $i,
      ...us,
      children: Ao
    })]
  });
});
process.env.NODE_ENV !== "production" && (TextField.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: PropTypes.bool,
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Props applied to the [`FormHelperText`](https://mui.com/material-ui/api/form-helper-text/) element.
   * @deprecated Use `slotProps.formHelperText` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  FormHelperTextProps: PropTypes.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,
  /**
   * Props applied to the [`InputLabel`](https://mui.com/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   * @deprecated Use `slotProps.inputLabel` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputLabelProps: PropTypes.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.htmlInput` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  inputProps: PropTypes.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](https://mui.com/material-ui/api/filled-input/),
   * [`OutlinedInput`](https://mui.com/material-ui/api/outlined-input/) or [`Input`](https://mui.com/material-ui/api/input/)
   * component depending on the `variant` prop value.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  InputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: PropTypes.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: PropTypes.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: PropTypes.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Render a [`Select`](https://mui.com/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: PropTypes.bool,
  /**
   * Props applied to the [`Select`](https://mui.com/material-ui/api/select/) element.
   * @deprecated Use `slotProps.select` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  SelectProps: PropTypes.object,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    formHelperText: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    htmlInput: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    input: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    inputLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    select: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    formHelperText: PropTypes.elementType,
    htmlInput: PropTypes.elementType,
    input: PropTypes.elementType,
    inputLabel: PropTypes.elementType,
    select: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
const checkColumnVisibilityModelsSame = (Kt, uo) => {
  const ho = new Set(Object.keys(Kt).filter((vo) => Kt[vo] === !1)), go = new Set(Object.keys(uo).filter((vo) => uo[vo] === !1));
  if (ho.size !== go.size)
    return !1;
  let bo = !0;
  return ho.forEach((vo) => {
    go.has(vo) || (bo = !1);
  }), bo;
}, defaultSearchPredicate = (Kt, uo) => (Kt.headerName || Kt.field).toLowerCase().indexOf(uo) > -1, useUtilityClasses$p = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["columnsManagement"],
    header: ["columnsManagementHeader"],
    searchInput: ["columnsManagementSearchInput"],
    footer: ["columnsManagementFooter"],
    row: ["columnsManagementRow"]
  }, getDataGridUtilityClass, uo);
}, collator = new Intl.Collator();
function GridColumnsManagement(Kt) {
  var ni, si, li, ui;
  const uo = useGridApiContext(), ho = React$1.useRef(null), go = useGridSelector(uo, gridColumnDefinitionsSelector), bo = useLazyRef(() => gridColumnVisibilityModelSelector(uo)).current, vo = useGridSelector(uo, gridColumnVisibilityModelSelector), Po = useGridRootProps(), [Co, So] = React$1.useState(""), wo = useUtilityClasses$p(Po), {
    sort: Eo,
    searchPredicate: Ro = defaultSearchPredicate,
    autoFocusSearchField: _o = !0,
    disableShowHideToggle: Io = !1,
    disableResetButton: Ao = !1,
    toggleAllMode: Oo = "all",
    getTogglableColumns: jo,
    searchInputProps: Do
  } = Kt, Lo = React$1.useMemo(() => checkColumnVisibilityModelsSame(vo, bo), [vo, bo]), ko = React$1.useMemo(() => {
    switch (Eo) {
      case "asc":
        return [...go].sort((ci, fi) => collator.compare(ci.headerName || ci.field, fi.headerName || fi.field));
      case "desc":
        return [...go].sort((ci, fi) => -collator.compare(ci.headerName || ci.field, fi.headerName || fi.field));
      default:
        return go;
    }
  }, [go, Eo]), Ko = (ci) => {
    const {
      name: fi
    } = ci.target;
    uo.current.setColumnVisibility(fi, vo[fi] === !1);
  }, No = React$1.useMemo(() => {
    const ci = jo ? jo(ko) : null, fi = ci ? ko.filter(({
      field: yi
    }) => ci.includes(yi)) : ko;
    return Co ? fi.filter((yi) => Ro(yi, Co.toLowerCase())) : fi;
  }, [ko, Co, Ro, jo]), Jo = React$1.useCallback((ci) => {
    const fi = gridColumnVisibilityModelSelector(uo), yi = _extends$q({}, fi), hi = jo ? jo(go) : null;
    return (Oo === "filteredOnly" ? No : go).forEach((mi) => {
      mi.hideable && (hi == null || hi.includes(mi.field)) && (ci ? delete yi[mi.field] : yi[mi.field] = !1);
    }), uo.current.setColumnVisibilityModel(yi);
  }, [uo, go, jo, Oo, No]), ti = React$1.useCallback((ci) => {
    So(ci.target.value);
  }, []), oi = React$1.useMemo(() => No.filter((ci) => ci.hideable), [No]), Qo = React$1.useMemo(() => oi.every((ci) => vo[ci.field] == null || vo[ci.field] !== !1), [vo, oi]), Zo = React$1.useMemo(() => oi.every((ci) => vo[ci.field] === !1), [vo, oi]), ei = React$1.useRef(null);
  React$1.useEffect(() => {
    _o ? ho.current.focus() : ei.current && typeof ei.current.focus == "function" && ei.current.focus();
  }, [_o]);
  let ii = !1;
  const ai = (ci) => ii === !1 && ci.hideable !== !1 ? (ii = !0, !0) : !1, ri = React$1.useCallback(() => {
    So(""), ho.current.focus();
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnsManagementHeader, {
      className: wo.header,
      ownerState: Po,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(SearchInput, _extends$q({
        as: Po.slots.baseTextField,
        ownerState: Po,
        placeholder: uo.current.getLocaleText("columnsManagementSearchTitle"),
        inputRef: ho,
        className: wo.searchInput,
        value: Co,
        onChange: ti,
        variant: "outlined",
        size: "small",
        type: "search",
        InputProps: {
          startAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.baseInputAdornment, {
            position: "start",
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.quickFilterIcon, {})
          }),
          endAdornment: /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.baseIconButton, _extends$q({
            "aria-label": uo.current.getLocaleText("columnsManagementDeleteIconLabel"),
            size: "small",
            sx: [Co ? {
              visibility: "visible"
            } : {
              visibility: "hidden"
            }],
            tabIndex: -1,
            onClick: ri
          }, (ni = Po.slotProps) == null ? void 0 : ni.baseIconButton, {
            children: /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.quickFilterClearIcon, {
              fontSize: "small"
            })
          }))
        },
        inputProps: {
          "aria-label": uo.current.getLocaleText("columnsManagementSearchTitle")
        },
        autoComplete: "off",
        fullWidth: !0
      }, (si = Po.slotProps) == null ? void 0 : si.baseTextField, Do))
    }), /* @__PURE__ */ jsxRuntimeExports.jsxs(GridColumnsManagementBody, {
      className: wo.root,
      ownerState: Po,
      children: [No.map((ci) => {
        var fi;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlLabel, {
          className: wo.row,
          control: /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.baseCheckbox, _extends$q({
            disabled: ci.hideable === !1,
            checked: vo[ci.field] !== !1,
            onClick: Ko,
            name: ci.field,
            sx: {
              p: 0.5
            },
            inputRef: ai(ci) ? ei : void 0
          }, (fi = Po.slotProps) == null ? void 0 : fi.baseCheckbox)),
          label: ci.headerName || ci.field
        }, ci.field);
      }), No.length === 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnsManagementEmptyText, {
        ownerState: Po,
        children: uo.current.getLocaleText("columnsManagementNoColumns")
      })]
    }), (!Io || !Ao) && No.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(GridColumnsManagementFooter, {
      ownerState: Po,
      className: wo.footer,
      children: [Io ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", {}) : /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlLabel, {
        control: /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.baseCheckbox, _extends$q({
          disabled: oi.length === 0,
          checked: Qo,
          indeterminate: !Qo && !Zo,
          onClick: () => Jo(!Qo),
          name: uo.current.getLocaleText("columnsManagementShowHideAllText"),
          sx: {
            p: 0.5
          }
        }, (li = Po.slotProps) == null ? void 0 : li.baseCheckbox)),
        label: uo.current.getLocaleText("columnsManagementShowHideAllText")
      }), Ao ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(Po.slots.baseButton, _extends$q({
        onClick: () => uo.current.setColumnVisibilityModel(bo),
        disabled: Lo
      }, (ui = Po.slotProps) == null ? void 0 : ui.baseButton, {
        children: uo.current.getLocaleText("columnsManagementReset")
      }))]
    }) : null]
  });
}
process.env.NODE_ENV !== "production" && (GridColumnsManagement.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the column search field will be focused automatically.
   * If `false`, the first column switch input will be focused automatically.
   * This helps to avoid input keyboard panel to popup automatically on touch devices.
   * @default true
   */
  autoFocusSearchField: PropTypes.bool,
  /**
   * If `true`, the `Reset` button will not be disabled
   * @default false
   */
  disableResetButton: PropTypes.bool,
  /**
   * If `true`, the `Show/Hide all` toggle checkbox will not be displayed.
   * @default false
   */
  disableShowHideToggle: PropTypes.bool,
  /**
   * Returns the list of togglable columns.
   * If used, only those columns will be displayed in the panel
   * which are passed as the return value of the function.
   * @param {GridColDef[]} columns The `ColDef` list of all columns.
   * @returns {GridColDef['field'][]} The list of togglable columns' field names.
   */
  getTogglableColumns: PropTypes.func,
  searchInputProps: PropTypes.object,
  searchPredicate: PropTypes.func,
  sort: PropTypes.oneOf(["asc", "desc"]),
  /**
   * Changes the behavior of the `Show/Hide All` toggle when the search field is used:
   * - `all`: Will toggle all columns.
   * - `filteredOnly`: Will only toggle columns that match the search criteria.
   * @default 'all'
   */
  toggleAllMode: PropTypes.oneOf(["all", "filteredOnly"])
});
const GridColumnsManagementBody = styled("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagement",
  overridesResolver: (Kt, uo) => uo.columnsManagement
})(({
  theme: Kt
}) => ({
  padding: Kt.spacing(0, 3, 1.5),
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  flex: "1 1",
  maxHeight: 400,
  alignItems: "flex-start"
})), GridColumnsManagementHeader = styled("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagementHeader",
  overridesResolver: (Kt, uo) => uo.columnsManagementHeader
})(({
  theme: Kt
}) => ({
  padding: Kt.spacing(1.5, 3)
})), SearchInput = styled(TextField, {
  name: "MuiDataGrid",
  slot: "ColumnsManagementSearchInput",
  overridesResolver: (Kt, uo) => uo.columnsManagementSearchInput
})(({
  theme: Kt
}) => ({
  [`& .${inputBaseClasses.root}`]: {
    padding: Kt.spacing(0, 1.5, 0, 1.5)
  },
  [`& .${inputBaseClasses.input}::-webkit-search-decoration,
  & .${inputBaseClasses.input}::-webkit-search-cancel-button,
  & .${inputBaseClasses.input}::-webkit-search-results-button,
  & .${inputBaseClasses.input}::-webkit-search-results-decoration`]: {
    /* clears the 'X' icon from Chrome */
    display: "none"
  }
})), GridColumnsManagementFooter = styled("div", {
  name: "MuiDataGrid",
  slot: "ColumnsManagementFooter",
  overridesResolver: (Kt, uo) => uo.columnsManagementFooter
})(({
  theme: Kt
}) => ({
  padding: Kt.spacing(0.5, 1, 0.5, 3),
  display: "flex",
  justifyContent: "space-between",
  borderTop: `1px solid ${Kt.palette.divider}`
})), GridColumnsManagementEmptyText = styled("div")(({
  theme: Kt
}) => ({
  padding: Kt.spacing(0.5, 0),
  color: Kt.palette.grey[500]
})), GridToolbarExportContainer = forwardRef(function(uo, ho) {
  var Lo, ko;
  const {
    children: go,
    slotProps: bo = {}
  } = uo, vo = bo.button || {}, Po = bo.tooltip || {}, Co = useGridApiContext(), So = useGridRootProps(), wo = useId(), Eo = useId(), [Ro, _o] = React$1.useState(!1), Io = React$1.useRef(null), Ao = useForkRef(ho, Io), Oo = (Ko) => {
    var No;
    _o((Jo) => !Jo), (No = vo.onClick) == null || No.call(vo, Ko);
  }, jo = () => _o(!1), Do = (Ko) => {
    Ko.key === "Tab" && Ko.preventDefault(), isHideMenuKey(Ko.key) && jo();
  };
  return go == null ? null : /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(So.slots.baseTooltip, _extends$q({
      title: Co.current.getLocaleText("toolbarExportLabel"),
      enterDelay: 1e3
    }, (Lo = So.slotProps) == null ? void 0 : Lo.baseTooltip, Po, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(So.slots.baseButton, _extends$q({
        size: "small",
        startIcon: /* @__PURE__ */ jsxRuntimeExports.jsx(So.slots.exportIcon, {}),
        "aria-expanded": Ro,
        "aria-label": Co.current.getLocaleText("toolbarExportLabel"),
        "aria-haspopup": "menu",
        "aria-controls": Ro ? Eo : void 0,
        id: wo,
        onClick: Oo
      }, (ko = So.slotProps) == null ? void 0 : ko.baseButton, vo, {
        ref: Ao,
        children: Co.current.getLocaleText("toolbarExport")
      }))
    })), /* @__PURE__ */ jsxRuntimeExports.jsx(GridMenu, {
      open: Ro,
      target: Io.current,
      onClose: jo,
      position: "bottom-start",
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuList, {
        id: Eo,
        className: gridClasses.menuList,
        "aria-labelledby": wo,
        onKeyDown: Do,
        autoFocusItem: Ro,
        children: React$1.Children.map(go, (Ko) => /* @__PURE__ */ React$1.isValidElement(Ko) ? /* @__PURE__ */ React$1.cloneElement(Ko, {
          hideMenu: jo
        }) : Ko)
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (GridToolbarExportContainer.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.object
});
const _excluded$s = ["hideMenu", "options"], _excluded2$8 = ["hideMenu", "options"], _excluded3$1 = ["csvOptions", "printOptions", "excelOptions"];
function GridCsvExportMenuItem(Kt) {
  const uo = useGridApiContext(), {
    hideMenu: ho,
    options: go
  } = Kt, bo = _objectWithoutPropertiesLoose$h(Kt, _excluded$s);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, _extends$q({
    onClick: () => {
      uo.current.exportDataAsCsv(go), ho == null || ho();
    }
  }, bo, {
    children: uo.current.getLocaleText("toolbarExportCSV")
  }));
}
process.env.NODE_ENV !== "production" && (GridCsvExportMenuItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  hideMenu: PropTypes.func,
  options: PropTypes.shape({
    allColumns: PropTypes.bool,
    delimiter: PropTypes.string,
    disableToolbarButton: PropTypes.bool,
    escapeFormulas: PropTypes.bool,
    fields: PropTypes.arrayOf(PropTypes.string),
    fileName: PropTypes.string,
    getRowsToExport: PropTypes.func,
    includeColumnGroupsHeaders: PropTypes.bool,
    includeHeaders: PropTypes.bool,
    shouldAppendQuotes: PropTypes.bool,
    utf8WithBom: PropTypes.bool
  })
});
function GridPrintExportMenuItem(Kt) {
  const uo = useGridApiContext(), {
    hideMenu: ho,
    options: go
  } = Kt, bo = _objectWithoutPropertiesLoose$h(Kt, _excluded2$8);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, _extends$q({
    onClick: () => {
      uo.current.exportDataAsPrint(go), ho == null || ho();
    }
  }, bo, {
    children: uo.current.getLocaleText("toolbarExportPrint")
  }));
}
process.env.NODE_ENV !== "production" && (GridPrintExportMenuItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  hideMenu: PropTypes.func,
  options: PropTypes.shape({
    allColumns: PropTypes.bool,
    bodyClassName: PropTypes.string,
    copyStyles: PropTypes.bool,
    disableToolbarButton: PropTypes.bool,
    fields: PropTypes.arrayOf(PropTypes.string),
    fileName: PropTypes.string,
    getRowsToExport: PropTypes.func,
    hideFooter: PropTypes.bool,
    hideToolbar: PropTypes.bool,
    includeCheckboxes: PropTypes.bool,
    pageStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.string])
  })
});
const GridToolbarExport = forwardRef(function(uo, ho) {
  const go = uo, {
    csvOptions: bo = {},
    printOptions: vo = {},
    excelOptions: Po
  } = go, Co = _objectWithoutPropertiesLoose$h(go, _excluded3$1), wo = useGridApiContext().current.unstable_applyPipeProcessors("exportMenu", [], {
    excelOptions: Po,
    csvOptions: bo,
    printOptions: vo
  }).sort((Eo, Ro) => Eo.componentName > Ro.componentName ? 1 : -1);
  return wo.length === 0 ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(GridToolbarExportContainer, _extends$q({}, Co, {
    ref: ho,
    children: wo.map((Eo, Ro) => /* @__PURE__ */ React$1.cloneElement(Eo.component, {
      key: Ro
    }))
  }));
});
process.env.NODE_ENV !== "production" && (GridToolbarExport.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  csvOptions: PropTypes.object,
  printOptions: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.object
});
const _excluded$r = ["className", "selectedRowCount"], useUtilityClasses$o = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["selectedRowCount"]
  }, getDataGridUtilityClass, uo);
}, GridSelectedRowCountRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "SelectedRowCount",
  overridesResolver: (Kt, uo) => uo.selectedRowCount
})(({
  theme: Kt
}) => ({
  alignItems: "center",
  display: "flex",
  margin: Kt.spacing(0, 2),
  visibility: "hidden",
  width: 0,
  height: 0,
  [Kt.breakpoints.up("sm")]: {
    visibility: "visible",
    width: "auto",
    height: "auto"
  }
})), GridSelectedRowCount = forwardRef(function(uo, ho) {
  const {
    className: go,
    selectedRowCount: bo
  } = uo, vo = _objectWithoutPropertiesLoose$h(uo, _excluded$r), Po = useGridApiContext(), Co = useGridRootProps(), So = useUtilityClasses$o(Co), wo = Po.current.getLocaleText("footerRowSelected")(bo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridSelectedRowCountRoot, _extends$q({
    className: clsx(So.root, go),
    ownerState: Co
  }, vo, {
    ref: ho,
    children: wo
  }));
});
process.env.NODE_ENV !== "production" && (GridSelectedRowCount.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  selectedRowCount: PropTypes.number.isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const GridFooter = forwardRef(function(uo, ho) {
  var Ro, _o;
  const go = useGridApiContext(), bo = useGridRootProps(), vo = useGridSelector(go, gridTopLevelRowCountSelector), Po = useGridSelector(go, selectedGridRowsCountSelector), Co = useGridSelector(go, gridFilteredTopLevelRowCountSelector), So = !bo.hideFooterSelectedRowCount && Po > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(GridSelectedRowCount, {
    selectedRowCount: Po
  }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}), wo = !bo.hideFooterRowCount && !bo.pagination ? /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.footerRowCount, _extends$q({}, (Ro = bo.slotProps) == null ? void 0 : Ro.footerRowCount, {
    rowCount: vo,
    visibleRowCount: Co
  })) : null, Eo = bo.pagination && !bo.hideFooterPagination && bo.slots.pagination && /* @__PURE__ */ jsxRuntimeExports.jsx(bo.slots.pagination, _extends$q({}, (_o = bo.slotProps) == null ? void 0 : _o.pagination));
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridFooterContainer, _extends$q({}, uo, {
    ref: ho,
    children: [So, wo, Eo]
  }));
});
process.env.NODE_ENV !== "production" && (GridFooter.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function GridPreferencesPanel() {
  var vo, Po;
  const Kt = useGridApiContext(), uo = useGridSelector(Kt, gridColumnDefinitionsSelector), ho = useGridRootProps(), go = useGridSelector(Kt, gridPreferencePanelStateSelector), bo = Kt.current.unstable_applyPipeProcessors("preferencePanel", null, go.openedPanelValue ?? GridPreferencePanelsValue.filters);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ho.slots.panel, _extends$q({
    as: ho.slots.basePopper,
    open: uo.length > 0 && go.open,
    id: go.panelId,
    "aria-labelledby": go.labelId
  }, (vo = ho.slotProps) == null ? void 0 : vo.panel, (Po = ho.slotProps) == null ? void 0 : Po.basePopper, {
    children: bo
  }));
}
function GridHeader() {
  var uo;
  const Kt = useGridRootProps();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(GridPreferencesPanel, {}), Kt.slots.toolbar && /* @__PURE__ */ jsxRuntimeExports.jsx(Kt.slots.toolbar, _extends$q({}, (uo = Kt.slotProps) == null ? void 0 : uo.toolbar))]
  });
}
function getLinearProgressUtilityClass(Kt) {
  return generateUtilityClass$1("MuiLinearProgress", Kt);
}
generateUtilityClasses$1("MuiLinearProgress", ["root", "colorPrimary", "colorSecondary", "determinate", "indeterminate", "buffer", "query", "dashed", "dashedColorPrimary", "dashedColorSecondary", "bar", "barColorPrimary", "barColorSecondary", "bar1Indeterminate", "bar1Determinate", "bar1Buffer", "bar2Indeterminate", "bar2Buffer"]);
const TRANSITION_DURATION = 4, indeterminate1Keyframe = keyframes`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`, indeterminate1Animation = typeof indeterminate1Keyframe != "string" ? css`
        animation: ${indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null, indeterminate2Keyframe = keyframes`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`, indeterminate2Animation = typeof indeterminate2Keyframe != "string" ? css`
        animation: ${indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null, bufferKeyframe = keyframes`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`, bufferAnimation = typeof bufferKeyframe != "string" ? css`
        animation: ${bufferKeyframe} 3s infinite linear;
      ` : null, useUtilityClasses$n = (Kt) => {
  const {
    classes: uo,
    variant: ho,
    color: go
  } = Kt, bo = {
    root: ["root", `color${capitalize(go)}`, ho],
    dashed: ["dashed", `dashedColor${capitalize(go)}`],
    bar1: ["bar", `barColor${capitalize(go)}`, (ho === "indeterminate" || ho === "query") && "bar1Indeterminate", ho === "determinate" && "bar1Determinate", ho === "buffer" && "bar1Buffer"],
    bar2: ["bar", ho !== "buffer" && `barColor${capitalize(go)}`, ho === "buffer" && `color${capitalize(go)}`, (ho === "indeterminate" || ho === "query") && "bar2Indeterminate", ho === "buffer" && "bar2Buffer"]
  };
  return composeClasses(bo, getLinearProgressUtilityClass, uo);
}, getColorShade = (Kt, uo) => Kt.vars ? Kt.vars.palette.LinearProgress[`${uo}Bg`] : Kt.palette.mode === "light" ? lighten(Kt.palette[uo].main, 0.62) : darken(Kt.palette[uo].main, 0.5), LinearProgressRoot = styled("span", {
  name: "MuiLinearProgress",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[`color${capitalize(ho.color)}`], uo[ho.variant]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  position: "relative",
  overflow: "hidden",
  display: "block",
  height: 4,
  // Fix Safari's bug during composition of different paint.
  zIndex: 0,
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      backgroundColor: getColorShade(Kt, uo)
    }
  })), {
    props: ({
      ownerState: uo
    }) => uo.color === "inherit" && uo.variant !== "buffer",
    style: {
      "&::before": {
        content: '""',
        position: "absolute",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "currentColor",
        opacity: 0.3
      }
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      backgroundColor: "transparent"
    }
  }, {
    props: {
      variant: "query"
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}))), LinearProgressDashed = styled("span", {
  name: "MuiLinearProgress",
  slot: "Dashed",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.dashed, uo[`dashedColor${capitalize(ho.color)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  position: "absolute",
  marginTop: 0,
  height: "100%",
  width: "100%",
  backgroundSize: "10px 10px",
  backgroundPosition: "0 -23px",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3,
      backgroundImage: "radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)"
    }
  }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => {
    const ho = getColorShade(Kt, uo);
    return {
      props: {
        color: uo
      },
      style: {
        backgroundImage: `radial-gradient(${ho} 0%, ${ho} 16%, transparent 42%)`
      }
    };
  })]
})), bufferAnimation || {
  // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
  animation: `${bufferKeyframe} 3s infinite linear`
}), LinearProgressBar1 = styled("span", {
  name: "MuiLinearProgress",
  slot: "Bar1",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.bar, uo[`barColor${capitalize(ho.color)}`], (ho.variant === "indeterminate" || ho.variant === "query") && uo.bar1Indeterminate, ho.variant === "determinate" && uo.bar1Determinate, ho.variant === "buffer" && uo.bar1Buffer];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      backgroundColor: "currentColor"
    }
  }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      backgroundColor: (Kt.vars || Kt).palette[uo].main
    }
  })), {
    props: {
      variant: "determinate"
    },
    style: {
      transition: `transform .${TRANSITION_DURATION}s linear`
    }
  }, {
    props: {
      variant: "buffer"
    },
    style: {
      zIndex: 1,
      transition: `transform .${TRANSITION_DURATION}s linear`
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.variant === "indeterminate" || uo.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.variant === "indeterminate" || uo.variant === "query",
    style: indeterminate1Animation || {
      animation: `${indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
    }
  }]
}))), LinearProgressBar2 = styled("span", {
  name: "MuiLinearProgress",
  slot: "Bar2",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.bar, uo[`barColor${capitalize(ho.color)}`], (ho.variant === "indeterminate" || ho.variant === "query") && uo.bar2Indeterminate, ho.variant === "buffer" && uo.bar2Buffer];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  width: "100%",
  position: "absolute",
  left: 0,
  bottom: 0,
  top: 0,
  transition: "transform 0.2s linear",
  transformOrigin: "left",
  variants: [...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      "--LinearProgressBar2-barColor": (Kt.vars || Kt).palette[uo].main
    }
  })), {
    props: ({
      ownerState: uo
    }) => uo.variant !== "buffer" && uo.color !== "inherit",
    style: {
      backgroundColor: "var(--LinearProgressBar2-barColor, currentColor)"
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.variant !== "buffer" && uo.color === "inherit",
    style: {
      backgroundColor: "currentColor"
    }
  }, {
    props: {
      color: "inherit"
    },
    style: {
      opacity: 0.3
    }
  }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo,
      variant: "buffer"
    },
    style: {
      backgroundColor: getColorShade(Kt, uo),
      transition: `transform .${TRANSITION_DURATION}s linear`
    }
  })), {
    props: ({
      ownerState: uo
    }) => uo.variant === "indeterminate" || uo.variant === "query",
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.variant === "indeterminate" || uo.variant === "query",
    style: indeterminate2Animation || {
      animation: `${indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
    }
  }]
}))), LinearProgress = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiLinearProgress"
  }), {
    className: bo,
    color: vo = "primary",
    value: Po,
    valueBuffer: Co,
    variant: So = "indeterminate",
    ...wo
  } = go, Eo = {
    ...go,
    color: vo,
    variant: So
  }, Ro = useUtilityClasses$n(Eo), _o = useRtl(), Io = {}, Ao = {
    bar1: {},
    bar2: {}
  };
  if (So === "determinate" || So === "buffer")
    if (Po !== void 0) {
      Io["aria-valuenow"] = Math.round(Po), Io["aria-valuemin"] = 0, Io["aria-valuemax"] = 100;
      let Oo = Po - 100;
      _o && (Oo = -Oo), Ao.bar1.transform = `translateX(${Oo}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a value prop when using the determinate or buffer variant of LinearProgress .");
  if (So === "buffer")
    if (Co !== void 0) {
      let Oo = (Co || 0) - 100;
      _o && (Oo = -Oo), Ao.bar2.transform = `translateX(${Oo}%)`;
    } else process.env.NODE_ENV !== "production" && console.error("MUI: You need to provide a valueBuffer prop when using the buffer variant of LinearProgress.");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(LinearProgressRoot, {
    className: clsx(Ro.root, bo),
    ownerState: Eo,
    role: "progressbar",
    ...Io,
    ref: ho,
    ...wo,
    children: [So === "buffer" ? /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressDashed, {
      className: Ro.dashed,
      ownerState: Eo
    }) : null, /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressBar1, {
      className: Ro.bar1,
      ownerState: Eo,
      style: Ao.bar1
    }), So === "determinate" ? null : /* @__PURE__ */ jsxRuntimeExports.jsx(LinearProgressBar2, {
      className: Ro.bar2,
      ownerState: Eo,
      style: Ao.bar2
    })]
  });
});
process.env.NODE_ENV !== "production" && (LinearProgress.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["buffer", "determinate", "indeterminate", "query"])
});
function getCircularProgressUtilityClass(Kt) {
  return generateUtilityClass$1("MuiCircularProgress", Kt);
}
generateUtilityClasses$1("MuiCircularProgress", ["root", "determinate", "indeterminate", "colorPrimary", "colorSecondary", "svg", "circle", "circleDeterminate", "circleIndeterminate", "circleDisableShrink"]);
const SIZE$1 = 44, circularRotateKeyframe = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`, circularDashKeyframe = keyframes`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`, rotateAnimation = typeof circularRotateKeyframe != "string" ? css`
        animation: ${circularRotateKeyframe} 1.4s linear infinite;
      ` : null, dashAnimation = typeof circularDashKeyframe != "string" ? css`
        animation: ${circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null, useUtilityClasses$m = (Kt) => {
  const {
    classes: uo,
    variant: ho,
    color: go,
    disableShrink: bo
  } = Kt, vo = {
    root: ["root", ho, `color${capitalize(go)}`],
    svg: ["svg"],
    circle: ["circle", `circle${capitalize(ho)}`, bo && "circleDisableShrink"]
  };
  return composeClasses(vo, getCircularProgressUtilityClass, uo);
}, CircularProgressRoot = styled("span", {
  name: "MuiCircularProgress",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.variant], uo[`color${capitalize(ho.color)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  display: "inline-block",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: Kt.transitions.create("transform")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: rotateAnimation || {
      animation: `${circularRotateKeyframe} 1.4s linear infinite`
    }
  }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      color: (Kt.vars || Kt).palette[uo].main
    }
  }))]
}))), CircularProgressSVG = styled("svg", {
  name: "MuiCircularProgress",
  slot: "Svg",
  overridesResolver: (Kt, uo) => uo.svg
})({
  display: "block"
  // Keeps the progress centered
}), CircularProgressCircle = styled("circle", {
  name: "MuiCircularProgress",
  slot: "Circle",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.circle, uo[`circle${capitalize(ho.variant)}`], ho.disableShrink && uo.circleDisableShrink];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  stroke: "currentColor",
  variants: [{
    props: {
      variant: "determinate"
    },
    style: {
      transition: Kt.transitions.create("stroke-dashoffset")
    }
  }, {
    props: {
      variant: "indeterminate"
    },
    style: {
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: 0
      // Add the unit to fix a Edge 16 and below bug.
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.variant === "indeterminate" && !uo.disableShrink,
    style: dashAnimation || {
      // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
      animation: `${circularDashKeyframe} 1.4s ease-in-out infinite`
    }
  }]
}))), CircularProgress = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiCircularProgress"
  }), {
    className: bo,
    color: vo = "primary",
    disableShrink: Po = !1,
    size: Co = 40,
    style: So,
    thickness: wo = 3.6,
    value: Eo = 0,
    variant: Ro = "indeterminate",
    ..._o
  } = go, Io = {
    ...go,
    color: vo,
    disableShrink: Po,
    size: Co,
    thickness: wo,
    value: Eo,
    variant: Ro
  }, Ao = useUtilityClasses$m(Io), Oo = {}, jo = {}, Do = {};
  if (Ro === "determinate") {
    const Lo = 2 * Math.PI * ((SIZE$1 - wo) / 2);
    Oo.strokeDasharray = Lo.toFixed(3), Do["aria-valuenow"] = Math.round(Eo), Oo.strokeDashoffset = `${((100 - Eo) / 100 * Lo).toFixed(3)}px`, jo.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressRoot, {
    className: clsx(Ao.root, bo),
    style: {
      width: Co,
      height: Co,
      ...jo,
      ...So
    },
    ownerState: Io,
    ref: ho,
    role: "progressbar",
    ...Do,
    ..._o,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressSVG, {
      className: Ao.svg,
      ownerState: Io,
      viewBox: `${SIZE$1 / 2} ${SIZE$1 / 2} ${SIZE$1} ${SIZE$1}`,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(CircularProgressCircle, {
        className: Ao.circle,
        style: Oo,
        ownerState: Io,
        cx: SIZE$1,
        cy: SIZE$1,
        r: (SIZE$1 - wo) / 2,
        fill: "none",
        strokeWidth: wo
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (CircularProgress.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   * @default false
   */
  disableShrink: chainPropTypes(PropTypes.bool, (Kt) => Kt.disableShrink && Kt.variant && Kt.variant !== "indeterminate" ? new Error("MUI: You have provided the `disableShrink` prop with a variant other than `indeterminate`. This will have no effect.") : null),
  /**
   * The size of the component.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, for example '3rem'.
   * @default 40
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * @ignore
   */
  style: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The thickness of the circle.
   * @default 3.6
   */
  thickness: PropTypes.number,
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number,
  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   * @default 'indeterminate'
   */
  variant: PropTypes.oneOf(["determinate", "indeterminate"])
});
const getPinnedCellOffset = (Kt, uo, ho, go, bo) => {
  const vo = bo.hasScrollY ? bo.scrollbarSize : 0;
  let Po;
  switch (Kt) {
    case GridPinnedColumnPosition.LEFT:
      Po = go[ho];
      break;
    case GridPinnedColumnPosition.RIGHT:
      Po = bo.columnsTotalWidth - go[ho] - uo + vo;
      break;
    default:
      Po = 0;
      break;
  }
  return Po;
}, classes = {
  root: gridClasses.scrollbarFiller,
  header: gridClasses["scrollbarFiller--header"],
  borderTop: gridClasses["scrollbarFiller--borderTop"],
  borderBottom: gridClasses["scrollbarFiller--borderBottom"],
  pinnedRight: gridClasses["scrollbarFiller--pinnedRight"]
};
function GridScrollbarFillerCell({
  header: Kt,
  borderTop: uo = !0,
  borderBottom: ho,
  pinnedRight: go
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "presentation",
    className: clsx(classes.root, Kt && classes.header, uo && classes.borderTop, ho && classes.borderBottom, go && classes.pinnedRight)
  });
}
const SkeletonOverlay = styled$1("div", {
  name: "MuiDataGrid",
  slot: "SkeletonLoadingOverlay",
  overridesResolver: (Kt, uo) => uo.skeletonLoadingOverlay
})({
  minWidth: "100%",
  width: "max-content",
  // prevents overflow: clip; cutting off the x axis
  height: "100%",
  overflow: "clip"
  // y axis is hidden while the x axis is allowed to overflow
}), useUtilityClasses$l = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["skeletonLoadingOverlay"]
  }, getDataGridUtilityClass, uo);
}, getColIndex = (Kt) => parseInt(Kt.getAttribute("data-colindex"), 10), GridSkeletonLoadingOverlay = forwardRef(function(uo, ho) {
  const go = useGridRootProps(), {
    slots: bo
  } = go, vo = useUtilityClasses$l({
    classes: go.classes
  }), Po = React$1.useRef(null), Co = useForkRef(Po, ho), So = useGridApiContext(), wo = useGridSelector(So, gridDimensionsSelector), Eo = (wo == null ? void 0 : wo.viewportInnerSize.height) ?? 0, Ro = Math.ceil(Eo / wo.rowHeight), _o = useGridSelector(So, gridColumnsTotalWidthSelector), Io = useGridSelector(So, gridColumnPositionsSelector), Ao = React$1.useMemo(() => Io.filter((Jo) => Jo <= _o).length, [_o, Io]), Oo = useGridSelector(So, gridVisibleColumnDefinitionsSelector), jo = React$1.useMemo(() => Oo.slice(0, Ao), [Oo, Ao]), Do = useGridSelector(So, gridVisiblePinnedColumnDefinitionsSelector), Lo = React$1.useCallback((Jo, ti, oi) => {
    const Qo = getPinnedCellOffset(oi, Jo, ti, Io, wo);
    return {
      [oi]: Qo
    };
  }, [wo, Io]), ko = React$1.useCallback((Jo) => {
    if (Do.left.findIndex((ti) => ti.field === Jo) !== -1)
      return GridPinnedColumnPosition.LEFT;
    if (Do.right.findIndex((ti) => ti.field === Jo) !== -1)
      return GridPinnedColumnPosition.RIGHT;
  }, [Do.left, Do.right]), Ko = React$1.useMemo(() => {
    const Jo = [];
    for (let ti = 0; ti < Ro; ti += 1) {
      const oi = [];
      for (let Qo = 0; Qo < jo.length; Qo += 1) {
        const Zo = jo[Qo], ei = ko(Zo.field), ii = ei === GridPinnedColumnPosition.LEFT, ai = ei === GridPinnedColumnPosition.RIGHT, ri = ei ? Do[ei].length : jo.length - Do.left.length - Do.right.length, ni = ei ? Do[ei].findIndex((vi) => vi.field === Zo.field) : Qo - Do.left.length, si = ei && Lo(Zo.computedWidth, Qo, ei), li = wo.columnsTotalWidth < wo.viewportOuterSize.width, ui = shouldCellShowRightBorder(ei, ni, ri, go.showCellVerticalBorder, li), ci = shouldCellShowLeftBorder(ei, ni), fi = Qo === jo.length - 1, yi = ai && ni === 0, hi = yi && li, mi = fi && !yi && li, bi = wo.viewportOuterSize.width - wo.columnsTotalWidth, xi = Math.max(0, bi), $i = /* @__PURE__ */ jsxRuntimeExports.jsx(bo.skeletonCell, {
          width: xi,
          empty: !0
        }, `skeleton-filler-column-${ti}`), Ci = wo.hasScrollY ? wo.scrollbarSize : 0, Si = fi && Ci !== 0;
        hi && oi.push($i), oi.push(/* @__PURE__ */ jsxRuntimeExports.jsx(bo.skeletonCell, {
          field: Zo.field,
          type: Zo.type,
          align: Zo.align,
          width: "var(--width)",
          height: wo.rowHeight,
          "data-colindex": Qo,
          className: clsx(ii && gridClasses["cell--pinnedLeft"], ai && gridClasses["cell--pinnedRight"], ui && gridClasses["cell--withRightBorder"], ci && gridClasses["cell--withLeftBorder"]),
          style: _extends$q({
            "--width": `${Zo.computedWidth}px`
          }, si)
        }, `skeleton-column-${ti}-${Zo.field}`)), mi && oi.push($i), Si && oi.push(/* @__PURE__ */ jsxRuntimeExports.jsx(GridScrollbarFillerCell, {
          pinnedRight: Do.right.length > 0
        }, `skeleton-scrollbar-filler-${ti}`));
      }
      Jo.push(/* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        className: clsx(gridClasses.row, gridClasses.rowSkeleton, ti === 0 && gridClasses["row--firstVisible"]),
        children: oi
      }, `skeleton-row-${ti}`));
    }
    return Jo;
  }, [bo, jo, Do, Ro, go.showCellVerticalBorder, wo.columnsTotalWidth, wo.viewportOuterSize.width, wo.rowHeight, wo.hasScrollY, wo.scrollbarSize, ko, Lo]);
  return useGridApiEventHandler(So, "columnResize", (Jo) => {
    var si, li, ui;
    const {
      colDef: ti,
      width: oi
    } = Jo, Qo = (si = Po.current) == null ? void 0 : si.querySelectorAll(`[data-field="${escapeOperandAttributeSelector(ti.field)}"]`);
    if (!Qo)
      throw new Error("MUI X: Expected skeleton cells to be defined with `data-field` attribute.");
    const Zo = jo.findIndex((ci) => ci.field === ti.field), ei = ko(ti.field), ii = ei === GridPinnedColumnPosition.LEFT, ai = ei === GridPinnedColumnPosition.RIGHT, ri = getComputedStyle(Qo[0]).getPropertyValue("--width"), ni = parseInt(ri, 10) - oi;
    if (Qo && Qo.forEach((ci) => {
      ci.style.setProperty("--width", `${oi}px`);
    }), ii) {
      const ci = (li = Po.current) == null ? void 0 : li.querySelectorAll(`.${gridClasses["cell--pinnedLeft"]}`);
      ci == null || ci.forEach((fi) => {
        getColIndex(fi) > Zo && (fi.style.left = `${parseInt(getComputedStyle(fi).left, 10) - ni}px`);
      });
    }
    if (ai) {
      const ci = (ui = Po.current) == null ? void 0 : ui.querySelectorAll(`.${gridClasses["cell--pinnedRight"]}`);
      ci == null || ci.forEach((fi) => {
        getColIndex(fi) < Zo && (fi.style.right = `${parseInt(getComputedStyle(fi).right, 10) + ni}px`);
      });
    }
  }), /* @__PURE__ */ jsxRuntimeExports.jsx(SkeletonOverlay, _extends$q({
    className: vo.root
  }, uo, {
    ref: Co,
    children: Ko
  }));
}), _excluded$q = ["variant", "noRowsVariant", "style"], LOADING_VARIANTS = {
  "circular-progress": {
    component: CircularProgress,
    style: {}
  },
  "linear-progress": {
    component: LinearProgress,
    style: {
      display: "block"
    }
  },
  skeleton: {
    component: GridSkeletonLoadingOverlay,
    style: {
      display: "block"
    }
  }
}, GridLoadingOverlay = forwardRef(function(uo, ho) {
  const {
    variant: go = "circular-progress",
    noRowsVariant: bo = "circular-progress",
    style: vo
  } = uo, Po = _objectWithoutPropertiesLoose$h(uo, _excluded$q), Co = useGridApiContext(), So = useGridSelector(Co, gridRowCountSelector), wo = LOADING_VARIANTS[So === 0 ? bo : go];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlay, _extends$q({
    style: _extends$q({}, wo.style, vo)
  }, Po, {
    ref: ho,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(wo.component, {})
  }));
});
process.env.NODE_ENV !== "production" && (GridLoadingOverlay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The variant of the overlay when no rows are displayed.
   * @default 'circular-progress'
   */
  noRowsVariant: PropTypes.oneOf(["circular-progress", "linear-progress", "skeleton"]),
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant of the overlay.
   * @default 'circular-progress'
   */
  variant: PropTypes.oneOf(["circular-progress", "linear-progress", "skeleton"])
});
const GridNoRowsOverlay = forwardRef(function(uo, ho) {
  const bo = useGridApiContext().current.getLocaleText("noRowsLabel");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlay, _extends$q({}, uo, {
    ref: ho,
    children: bo
  }));
});
process.env.NODE_ENV !== "production" && (GridNoRowsOverlay.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const TableContext = /* @__PURE__ */ React$1.createContext();
process.env.NODE_ENV !== "production" && (TableContext.displayName = "TableContext");
const Tablelvl2Context = /* @__PURE__ */ React$1.createContext();
process.env.NODE_ENV !== "production" && (Tablelvl2Context.displayName = "Tablelvl2Context");
function getTableCellUtilityClass(Kt) {
  return generateUtilityClass$1("MuiTableCell", Kt);
}
const tableCellClasses = generateUtilityClasses$1("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), useUtilityClasses$k = (Kt) => {
  const {
    classes: uo,
    variant: ho,
    align: go,
    padding: bo,
    size: vo,
    stickyHeader: Po
  } = Kt, Co = {
    root: ["root", ho, Po && "stickyHeader", go !== "inherit" && `align${capitalize(go)}`, bo !== "normal" && `padding${capitalize(bo)}`, `size${capitalize(vo)}`]
  };
  return composeClasses(Co, getTableCellUtilityClass, uo);
}, TableCellRoot = styled("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.variant], uo[`size${capitalize(ho.size)}`], ho.padding !== "normal" && uo[`padding${capitalize(ho.padding)}`], ho.align !== "inherit" && uo[`align${capitalize(ho.align)}`], ho.stickyHeader && uo.stickyHeader];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body2,
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: Kt.vars ? `1px solid ${Kt.vars.palette.TableCell.border}` : `1px solid
    ${Kt.palette.mode === "light" ? lighten(alpha$1(Kt.palette.divider, 1), 0.88) : darken(alpha$1(Kt.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16,
  variants: [{
    props: {
      variant: "head"
    },
    style: {
      color: (Kt.vars || Kt).palette.text.primary,
      lineHeight: Kt.typography.pxToRem(24),
      fontWeight: Kt.typography.fontWeightMedium
    }
  }, {
    props: {
      variant: "body"
    },
    style: {
      color: (Kt.vars || Kt).palette.text.primary
    }
  }, {
    props: {
      variant: "footer"
    },
    style: {
      color: (Kt.vars || Kt).palette.text.secondary,
      lineHeight: Kt.typography.pxToRem(21),
      fontSize: Kt.typography.pxToRem(12)
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      padding: "6px 16px",
      [`&.${tableCellClasses.paddingCheckbox}`]: {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "& > *": {
          padding: 0
        }
      }
    }
  }, {
    props: {
      padding: "checkbox"
    },
    style: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px"
    }
  }, {
    props: {
      padding: "none"
    },
    style: {
      padding: 0
    }
  }, {
    props: {
      align: "left"
    },
    style: {
      textAlign: "left"
    }
  }, {
    props: {
      align: "center"
    },
    style: {
      textAlign: "center"
    }
  }, {
    props: {
      align: "right"
    },
    style: {
      textAlign: "right",
      flexDirection: "row-reverse"
    }
  }, {
    props: {
      align: "justify"
    },
    style: {
      textAlign: "justify"
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.stickyHeader,
    style: {
      position: "sticky",
      top: 0,
      zIndex: 2,
      backgroundColor: (Kt.vars || Kt).palette.background.default
    }
  }]
}))), TableCell = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiTableCell"
  }), {
    align: bo = "inherit",
    className: vo,
    component: Po,
    padding: Co,
    scope: So,
    size: wo,
    sortDirection: Eo,
    variant: Ro,
    ..._o
  } = go, Io = React$1.useContext(TableContext), Ao = React$1.useContext(Tablelvl2Context), Oo = Ao && Ao.variant === "head";
  let jo;
  Po ? jo = Po : jo = Oo ? "th" : "td";
  let Do = So;
  jo === "td" ? Do = void 0 : !Do && Oo && (Do = "col");
  const Lo = Ro || Ao && Ao.variant, ko = {
    ...go,
    align: bo,
    component: jo,
    padding: Co || (Io && Io.padding ? Io.padding : "normal"),
    size: wo || (Io && Io.size ? Io.size : "medium"),
    sortDirection: Eo,
    stickyHeader: Lo === "head" && Io && Io.stickyHeader,
    variant: Lo
  }, Ko = useUtilityClasses$k(ko);
  let No = null;
  return Eo && (No = Eo === "asc" ? "ascending" : "descending"), /* @__PURE__ */ jsxRuntimeExports.jsx(TableCellRoot, {
    as: jo,
    ref: ho,
    className: clsx(Ko.root, vo),
    "aria-sort": No,
    scope: Do,
    ownerState: ko,
    ..._o
  });
});
process.env.NODE_ENV !== "production" && (TableCell.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: PropTypes.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: PropTypes.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["body", "footer", "head"]), PropTypes.string])
});
function getToolbarUtilityClass(Kt) {
  return generateUtilityClass$1("MuiToolbar", Kt);
}
generateUtilityClasses$1("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const useUtilityClasses$j = (Kt) => {
  const {
    classes: uo,
    disableGutters: ho,
    variant: go
  } = Kt;
  return composeClasses({
    root: ["root", !ho && "gutters", go]
  }, getToolbarUtilityClass, uo);
}, ToolbarRoot = styled("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, !ho.disableGutters && uo.gutters, uo[ho.variant]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  variants: [{
    props: ({
      ownerState: uo
    }) => !uo.disableGutters,
    style: {
      paddingLeft: Kt.spacing(2),
      paddingRight: Kt.spacing(2),
      [Kt.breakpoints.up("sm")]: {
        paddingLeft: Kt.spacing(3),
        paddingRight: Kt.spacing(3)
      }
    }
  }, {
    props: {
      variant: "dense"
    },
    style: {
      minHeight: 48
    }
  }, {
    props: {
      variant: "regular"
    },
    style: Kt.mixins.toolbar
  }]
}))), Toolbar = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiToolbar"
  }), {
    className: bo,
    component: vo = "div",
    disableGutters: Po = !1,
    variant: Co = "regular",
    ...So
  } = go, wo = {
    ...go,
    component: vo,
    disableGutters: Po,
    variant: Co
  }, Eo = useUtilityClasses$j(wo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ToolbarRoot, {
    as: vo,
    className: clsx(Eo.root, bo),
    ref: ho,
    ownerState: wo,
    ...So
  });
});
process.env.NODE_ENV !== "production" && (Toolbar.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["dense", "regular"]), PropTypes.string])
});
const KeyboardArrowLeft = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), KeyboardArrowRight = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight"), LastPageIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), "LastPage"), FirstPageIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), "FirstPage"), TablePaginationActions = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    backIconButtonProps: go,
    count: bo,
    disabled: vo = !1,
    getItemAriaLabel: Po,
    nextIconButtonProps: Co,
    onPageChange: So,
    page: wo,
    rowsPerPage: Eo,
    showFirstButton: Ro,
    showLastButton: _o,
    slots: Io = {},
    slotProps: Ao = {},
    ...Oo
  } = uo, jo = useRtl(), Do = (yi) => {
    So(yi, 0);
  }, Lo = (yi) => {
    So(yi, wo - 1);
  }, ko = (yi) => {
    So(yi, wo + 1);
  }, Ko = (yi) => {
    So(yi, Math.max(0, Math.ceil(bo / Eo) - 1));
  }, No = Io.firstButton ?? IconButton, Jo = Io.lastButton ?? IconButton, ti = Io.nextButton ?? IconButton, oi = Io.previousButton ?? IconButton, Qo = Io.firstButtonIcon ?? FirstPageIcon, Zo = Io.lastButtonIcon ?? LastPageIcon, ei = Io.nextButtonIcon ?? KeyboardArrowRight, ii = Io.previousButtonIcon ?? KeyboardArrowLeft, ai = jo ? Jo : No, ri = jo ? ti : oi, ni = jo ? oi : ti, si = jo ? No : Jo, li = jo ? Ao.lastButton : Ao.firstButton, ui = jo ? Ao.nextButton : Ao.previousButton, ci = jo ? Ao.previousButton : Ao.nextButton, fi = jo ? Ao.firstButton : Ao.lastButton;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", {
    ref: ho,
    ...Oo,
    children: [Ro && /* @__PURE__ */ jsxRuntimeExports.jsx(ai, {
      onClick: Do,
      disabled: vo || wo === 0,
      "aria-label": Po("first", wo),
      title: Po("first", wo),
      ...li,
      children: jo ? /* @__PURE__ */ jsxRuntimeExports.jsx(Zo, {
        ...Ao.lastButtonIcon
      }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Qo, {
        ...Ao.firstButtonIcon
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(ri, {
      onClick: Lo,
      disabled: vo || wo === 0,
      color: "inherit",
      "aria-label": Po("previous", wo),
      title: Po("previous", wo),
      ...ui ?? go,
      children: jo ? /* @__PURE__ */ jsxRuntimeExports.jsx(ei, {
        ...Ao.nextButtonIcon
      }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ii, {
        ...Ao.previousButtonIcon
      })
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(ni, {
      onClick: ko,
      disabled: vo || (bo !== -1 ? wo >= Math.ceil(bo / Eo) - 1 : !1),
      color: "inherit",
      "aria-label": Po("next", wo),
      title: Po("next", wo),
      ...ci ?? Co,
      children: jo ? /* @__PURE__ */ jsxRuntimeExports.jsx(ii, {
        ...Ao.previousButtonIcon
      }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ei, {
        ...Ao.nextButtonIcon
      })
    }), _o && /* @__PURE__ */ jsxRuntimeExports.jsx(si, {
      onClick: Ko,
      disabled: vo || wo >= Math.ceil(bo / Eo) - 1,
      "aria-label": Po("last", wo),
      title: Po("last", wo),
      ...fi,
      children: jo ? /* @__PURE__ */ jsxRuntimeExports.jsx(Qo, {
        ...Ao.firstButtonIcon
      }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Zo, {
        ...Ao.lastButtonIcon
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  backIconButtonProps: PropTypes.object,
  /**
   * The total number of rows.
   */
  count: PropTypes.number.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @returns {string}
   */
  getItemAriaLabel: PropTypes.func.isRequired,
  /**
   * Props applied to the next arrow [`IconButton`](/material-ui/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * The zero-based index of the current page.
   */
  page: PropTypes.number.isRequired,
  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired,
  /**
   * If `true`, show the first-page button.
   */
  showFirstButton: PropTypes.bool.isRequired,
  /**
   * If `true`, show the last-page button.
   */
  showLastButton: PropTypes.bool.isRequired,
  /**
   * The props used for each slot inside the TablePaginationActions.
   * @default {}
   */
  slotProps: PropTypes.shape({
    firstButton: PropTypes.object,
    firstButtonIcon: PropTypes.object,
    lastButton: PropTypes.object,
    lastButtonIcon: PropTypes.object,
    nextButton: PropTypes.object,
    nextButtonIcon: PropTypes.object,
    previousButton: PropTypes.object,
    previousButtonIcon: PropTypes.object
  }),
  /**
   * The components used for each slot inside the TablePaginationActions.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    firstButton: PropTypes.elementType,
    firstButtonIcon: PropTypes.elementType,
    lastButton: PropTypes.elementType,
    lastButtonIcon: PropTypes.elementType,
    nextButton: PropTypes.elementType,
    nextButtonIcon: PropTypes.elementType,
    previousButton: PropTypes.elementType,
    previousButtonIcon: PropTypes.elementType
  })
});
function getTablePaginationUtilityClass(Kt) {
  return generateUtilityClass$1("MuiTablePagination", Kt);
}
const tablePaginationClasses = generateUtilityClasses$1("MuiTablePagination", ["root", "toolbar", "spacer", "selectLabel", "selectRoot", "select", "selectIcon", "input", "menuItem", "displayedRows", "actions"]);
var _InputBase;
const TablePaginationRoot = styled(TableCell, {
  name: "MuiTablePagination",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})(memoTheme(({
  theme: Kt
}) => ({
  overflow: "auto",
  color: (Kt.vars || Kt).palette.text.primary,
  fontSize: Kt.typography.pxToRem(14),
  // Increase the specificity to override TableCell.
  "&:last-child": {
    padding: 0
  }
}))), TablePaginationToolbar = styled(Toolbar, {
  name: "MuiTablePagination",
  slot: "Toolbar",
  overridesResolver: (Kt, uo) => ({
    [`& .${tablePaginationClasses.actions}`]: uo.actions,
    ...uo.toolbar
  })
})(memoTheme(({
  theme: Kt
}) => ({
  minHeight: 52,
  paddingRight: 2,
  [`${Kt.breakpoints.up("xs")} and (orientation: landscape)`]: {
    minHeight: 52
  },
  [Kt.breakpoints.up("sm")]: {
    minHeight: 52,
    paddingRight: 2
  },
  [`& .${tablePaginationClasses.actions}`]: {
    flexShrink: 0,
    marginLeft: 20
  }
}))), TablePaginationSpacer = styled("div", {
  name: "MuiTablePagination",
  slot: "Spacer",
  overridesResolver: (Kt, uo) => uo.spacer
})({
  flex: "1 1 100%"
}), TablePaginationSelectLabel = styled("p", {
  name: "MuiTablePagination",
  slot: "SelectLabel",
  overridesResolver: (Kt, uo) => uo.selectLabel
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body2,
  flexShrink: 0
}))), TablePaginationSelect = styled(Select$1, {
  name: "MuiTablePagination",
  slot: "Select",
  overridesResolver: (Kt, uo) => ({
    [`& .${tablePaginationClasses.selectIcon}`]: uo.selectIcon,
    [`& .${tablePaginationClasses.select}`]: uo.select,
    ...uo.input,
    ...uo.selectRoot
  })
})({
  color: "inherit",
  fontSize: "inherit",
  flexShrink: 0,
  marginRight: 32,
  marginLeft: 8,
  [`& .${tablePaginationClasses.select}`]: {
    paddingLeft: 8,
    paddingRight: 24,
    textAlign: "right",
    textAlignLast: "right"
    // Align <select> on Chrome.
  }
}), TablePaginationMenuItem = styled(MenuItem, {
  name: "MuiTablePagination",
  slot: "MenuItem",
  overridesResolver: (Kt, uo) => uo.menuItem
})({}), TablePaginationDisplayedRows = styled("p", {
  name: "MuiTablePagination",
  slot: "DisplayedRows",
  overridesResolver: (Kt, uo) => uo.displayedRows
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body2,
  flexShrink: 0
})));
function defaultLabelDisplayedRows$1({
  from: Kt,
  to: uo,
  count: ho
}) {
  return `${Kt}–${uo} of ${ho !== -1 ? ho : `more than ${uo}`}`;
}
function defaultGetAriaLabel$1(Kt) {
  return `Go to ${Kt} page`;
}
const useUtilityClasses$i = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["root"],
    toolbar: ["toolbar"],
    spacer: ["spacer"],
    selectLabel: ["selectLabel"],
    select: ["select"],
    input: ["input"],
    selectIcon: ["selectIcon"],
    menuItem: ["menuItem"],
    displayedRows: ["displayedRows"],
    actions: ["actions"]
  }, getTablePaginationUtilityClass, uo);
}, TablePagination = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiTablePagination"
  }), {
    ActionsComponent: bo = TablePaginationActions,
    backIconButtonProps: vo,
    colSpan: Po,
    component: Co = TableCell,
    count: So,
    disabled: wo = !1,
    getItemAriaLabel: Eo = defaultGetAriaLabel$1,
    labelDisplayedRows: Ro = defaultLabelDisplayedRows$1,
    labelRowsPerPage: _o = "Rows per page:",
    nextIconButtonProps: Io,
    onPageChange: Ao,
    onRowsPerPageChange: Oo,
    page: jo,
    rowsPerPage: Do,
    rowsPerPageOptions: Lo = [10, 25, 50, 100],
    SelectProps: ko = {},
    showFirstButton: Ko = !1,
    showLastButton: No = !1,
    slotProps: Jo = {},
    slots: ti = {},
    ...oi
  } = go, Qo = go, Zo = useUtilityClasses$i(Qo), ei = (Jo == null ? void 0 : Jo.select) ?? ko, ii = ei.native ? "option" : TablePaginationMenuItem;
  let ai;
  (Co === TableCell || Co === "td") && (ai = Po || 1e3);
  const ri = useId(ei.id), ni = useId(ei.labelId), si = () => So === -1 ? (jo + 1) * Do : Do === -1 ? So : Math.min(So, (jo + 1) * Do), li = {
    slots: ti,
    slotProps: Jo
  }, [ui, ci] = useSlot("root", {
    ref: ho,
    className: Zo.root,
    elementType: TablePaginationRoot,
    externalForwardedProps: {
      ...li,
      component: Co,
      ...oi
    },
    ownerState: Qo,
    additionalProps: {
      colSpan: ai
    }
  }), [fi, yi] = useSlot("toolbar", {
    className: Zo.toolbar,
    elementType: TablePaginationToolbar,
    externalForwardedProps: li,
    ownerState: Qo
  }), [hi, mi] = useSlot("spacer", {
    className: Zo.spacer,
    elementType: TablePaginationSpacer,
    externalForwardedProps: li,
    ownerState: Qo
  }), [bi, xi] = useSlot("selectLabel", {
    className: Zo.selectLabel,
    elementType: TablePaginationSelectLabel,
    externalForwardedProps: li,
    ownerState: Qo,
    additionalProps: {
      id: ni
    }
  }), [$i, Ci] = useSlot("select", {
    className: Zo.select,
    elementType: TablePaginationSelect,
    externalForwardedProps: li,
    ownerState: Qo
  }), [Si, vi] = useSlot("menuItem", {
    className: Zo.menuItem,
    elementType: ii,
    externalForwardedProps: li,
    ownerState: Qo
  }), [Pi, wi] = useSlot("displayedRows", {
    className: Zo.displayedRows,
    elementType: TablePaginationDisplayedRows,
    externalForwardedProps: li,
    ownerState: Qo
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ui, {
    ...ci,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(fi, {
      ...yi,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(hi, {
        ...mi
      }), Lo.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(bi, {
        ...xi,
        children: _o
      }), Lo.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx($i, {
        variant: "standard",
        ...!ei.variant && {
          input: _InputBase || (_InputBase = /* @__PURE__ */ jsxRuntimeExports.jsx(InputBase, {}))
        },
        value: Do,
        onChange: Oo,
        id: ri,
        labelId: ni,
        ...ei,
        classes: {
          ...ei.classes,
          // TODO v5 remove `classes.input`
          root: clsx(Zo.input, Zo.selectRoot, (ei.classes || {}).root),
          select: clsx(Zo.select, (ei.classes || {}).select),
          // TODO v5 remove `selectIcon`
          icon: clsx(Zo.selectIcon, (ei.classes || {}).icon)
        },
        disabled: wo,
        ...Ci,
        children: Lo.map((gi) => /* @__PURE__ */ createElement(Si, {
          ...vi,
          key: gi.label ? gi.label : gi,
          value: gi.value ? gi.value : gi
        }, gi.label ? gi.label : gi))
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(Pi, {
        ...wi,
        children: Ro({
          from: So === 0 ? 0 : jo * Do + 1,
          to: si(),
          count: So === -1 ? -1 : So,
          page: jo
        })
      }), /* @__PURE__ */ jsxRuntimeExports.jsx(bo, {
        className: Zo.actions,
        backIconButtonProps: vo,
        count: So,
        nextIconButtonProps: Io,
        onPageChange: Ao,
        page: jo,
        rowsPerPage: Do,
        showFirstButton: Ko,
        showLastButton: No,
        slotProps: Jo.actions,
        slots: ti.actions,
        getItemAriaLabel: Eo,
        disabled: wo
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (TablePagination.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The component used for displaying the actions.
   * Either a string to use a HTML element or a component.
   * @default TablePaginationActions
   */
  ActionsComponent: PropTypes.elementType,
  /**
   * Props applied to the back arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) component.
   *
   * This prop is an alias for `slotProps.actions.previousButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.previousButton` instead.
   */
  backIconButtonProps: PropTypes.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  colSpan: PropTypes.number,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The total number of rows.
   *
   * To enable server side pagination for an unknown number of items, provide -1.
   */
  count: integerPropType.isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('first' | 'last' | 'next' | 'previous').
   * @returns {string}
   * @default function defaultGetAriaLabel(type) {
   *   return `Go to ${type} page`;
   * }
   */
  getItemAriaLabel: PropTypes.func,
  /**
   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
   * object.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default function defaultLabelDisplayedRows({ from, to, count }) {
   *   return `${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`;
   * }
   */
  labelDisplayedRows: PropTypes.func,
  /**
   * Customize the rows per page label.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @default 'Rows per page:'
   */
  labelRowsPerPage: PropTypes.node,
  /**
   * Props applied to the next arrow [`IconButton`](https://mui.com/material-ui/api/icon-button/) element.
   *
   * This prop is an alias for `slotProps.actions.nextButton` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.actions.nextButton` instead.
   */
  nextIconButtonProps: PropTypes.object,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.MouseEvent<HTMLButtonElement> | null} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   */
  onRowsPerPageChange: PropTypes.func,
  /**
   * The zero-based index of the current page.
   */
  page: chainPropTypes(integerPropType.isRequired, (Kt) => {
    const {
      count: uo,
      page: ho,
      rowsPerPage: go
    } = Kt;
    if (uo === -1)
      return null;
    const bo = Math.max(0, Math.ceil(uo / go) - 1);
    return ho < 0 || ho > bo ? new Error(`MUI: The page prop of a TablePagination is out of range (0 to ${bo}, but page is ${ho}).`) : null;
  }),
  /**
   * The number of rows per page.
   *
   * Set -1 to display all the rows.
   */
  rowsPerPage: integerPropType.isRequired,
  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   * Use -1 for the value with a custom label to show all the rows.
   * @default [10, 25, 50, 100]
   */
  rowsPerPageOptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })]).isRequired),
  /**
   * Props applied to the rows per page [`Select`](https://mui.com/material-ui/api/select/) element.
   *
   * This prop is an alias for `slotProps.select` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.select` instead.
   *
   * @default {}
   */
  SelectProps: PropTypes.object,
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: PropTypes.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: PropTypes.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    actions: PropTypes.shape({
      firstButton: PropTypes.object,
      firstButtonIcon: PropTypes.object,
      lastButton: PropTypes.object,
      lastButtonIcon: PropTypes.object,
      nextButton: PropTypes.object,
      nextButtonIcon: PropTypes.object,
      previousButton: PropTypes.object,
      previousButtonIcon: PropTypes.object
    }),
    displayedRows: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    menuItem: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    select: PropTypes.object,
    selectLabel: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    spacer: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    toolbar: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    actions: PropTypes.shape({
      firstButton: PropTypes.elementType,
      firstButtonIcon: PropTypes.elementType,
      lastButton: PropTypes.elementType,
      lastButtonIcon: PropTypes.elementType,
      nextButton: PropTypes.elementType,
      nextButtonIcon: PropTypes.elementType,
      previousButton: PropTypes.elementType,
      previousButtonIcon: PropTypes.elementType
    }),
    displayedRows: PropTypes.elementType,
    menuItem: PropTypes.elementType,
    root: PropTypes.elementType,
    select: PropTypes.elementType,
    selectLabel: PropTypes.elementType,
    spacer: PropTypes.elementType,
    toolbar: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const GridPaginationRoot = styled(TablePagination)(({
  theme: Kt
}) => ({
  maxHeight: "calc(100% + 1px)",
  // border width
  flexGrow: 1,
  [`& .${tablePaginationClasses.selectLabel}`]: {
    display: "none",
    [Kt.breakpoints.up("sm")]: {
      display: "block"
    }
  },
  [`& .${tablePaginationClasses.input}`]: {
    display: "none",
    [Kt.breakpoints.up("sm")]: {
      display: "inline-flex"
    }
  }
})), wrapLabelDisplayedRows = (Kt, uo) => ({
  from: ho,
  to: go,
  count: bo,
  page: vo
}) => Kt({
  from: ho,
  to: go,
  count: bo,
  page: vo,
  estimated: uo
}), defaultLabelDisplayedRows = ({
  from: Kt,
  to: uo,
  count: ho,
  estimated: go
}) => go ? `${Kt}–${uo} of ${ho !== -1 ? ho : `more than ${go > uo ? go : uo}`}` : `${Kt}–${uo} of ${ho !== -1 ? ho : `more than ${uo}`}`, GridPagination = forwardRef(function(uo, ho) {
  var Ko;
  const go = useGridApiContext(), bo = useGridRootProps(), vo = useGridSelector(go, gridPaginationModelSelector), Po = useGridSelector(go, gridPaginationRowCountSelector), Co = useGridSelector(go, gridPageCountSelector), {
    paginationMode: So,
    loading: wo,
    estimatedRowCount: Eo
  } = bo, Ro = React$1.useMemo(() => Po === -1 && So === "server" && wo ? {
    backIconButtonProps: {
      disabled: !0
    },
    nextIconButtonProps: {
      disabled: !0
    }
  } : {}, [wo, So, Po]), _o = React$1.useMemo(() => Math.max(0, Co - 1), [Co]), Io = React$1.useMemo(() => Po === -1 || vo.page <= _o ? vo.page : _o, [_o, vo.page, Po]), Ao = React$1.useCallback((No) => {
    const Jo = Number(No.target.value);
    go.current.setPageSize(Jo);
  }, [go]), Oo = React$1.useCallback((No, Jo) => {
    go.current.setPage(Jo);
  }, [go]), jo = (No) => {
    for (let Jo = 0; Jo < bo.pageSizeOptions.length; Jo += 1) {
      const ti = bo.pageSizeOptions[Jo];
      if (typeof ti == "number") {
        if (ti === No)
          return !0;
      } else if (ti.value === No)
        return !0;
    }
    return !1;
  };
  if (process.env.NODE_ENV !== "production") {
    const No = React$1.useRef(!1), Jo = ((Ko = bo.paginationModel) == null ? void 0 : Ko.pageSize) ?? vo.pageSize;
    !No.current && !bo.autoPageSize && !jo(Jo) && (console.warn([`MUI X: The page size \`${vo.pageSize}\` is not present in the \`pageSizeOptions\`.`, "Add it to show the pagination select."].join(`
`)), No.current = !0);
  }
  const Do = jo(vo.pageSize) ? bo.pageSizeOptions : [], Lo = go.current.getLocaleText("MuiTablePagination"), ko = wrapLabelDisplayedRows(Lo.labelDisplayedRows || defaultLabelDisplayedRows, Eo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridPaginationRoot, _extends$q({
    component: "div",
    count: Po,
    page: Io,
    rowsPerPageOptions: Do,
    rowsPerPage: vo.pageSize,
    onPageChange: Oo,
    onRowsPerPageChange: Ao
  }, Ro, Lo, {
    labelDisplayedRows: ko
  }, uo, {
    ref: ho
  }));
});
process.env.NODE_ENV !== "production" && (GridPagination.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  component: PropTypes.elementType
});
const _excluded$p = ["className", "rowCount", "visibleRowCount"], useUtilityClasses$h = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["rowCount"]
  }, getDataGridUtilityClass, uo);
}, GridRowCountRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "RowCount",
  overridesResolver: (Kt, uo) => uo.rowCount
})(({
  theme: Kt
}) => ({
  alignItems: "center",
  display: "flex",
  margin: Kt.spacing(0, 2)
})), GridRowCount = forwardRef(function(uo, ho) {
  const {
    className: go,
    rowCount: bo,
    visibleRowCount: vo
  } = uo, Po = _objectWithoutPropertiesLoose$h(uo, _excluded$p), Co = useGridApiContext(), So = useGridRootProps(), wo = useUtilityClasses$h(So);
  if (bo === 0)
    return null;
  const Eo = vo < bo ? Co.current.getLocaleText("footerTotalVisibleRows")(vo, bo) : bo.toLocaleString();
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridRowCountRoot, _extends$q({
    className: clsx(wo.root, go),
    ownerState: So
  }, Po, {
    ref: ho,
    children: [Co.current.getLocaleText("footerTotalRows"), " ", Eo]
  }));
});
process.env.NODE_ENV !== "production" && (GridRowCount.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  rowCount: PropTypes.number.isRequired,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  visibleRowCount: PropTypes.number.isRequired
});
function composeGridClasses(Kt, uo) {
  return composeClasses(uo, getDataGridUtilityClass, Kt);
}
const _excluded$o = ["selected", "rowId", "row", "index", "style", "rowHeight", "className", "visibleColumns", "pinnedColumns", "offsetTop", "offsetLeft", "dimensions", "renderContext", "focusedColumnIndex", "isFirstVisible", "isLastVisible", "isNotVisible", "showBottomBorder", "tabbableCell", "onClick", "onDoubleClick", "onMouseEnter", "onMouseLeave", "onMouseOut", "onMouseOver"];
function EmptyCell({
  width: Kt
}) {
  return Kt ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    role: "presentation",
    className: clsx(gridClasses.cell, gridClasses.cellEmpty),
    style: {
      "--width": `${Kt}px`
    }
  }) : null;
}
process.env.NODE_ENV !== "production" && (EmptyCell.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  width: PropTypes.number.isRequired
});
const GridRow = forwardRef(function(uo, ho) {
  var Wi;
  const {
    selected: go,
    rowId: bo,
    row: vo,
    index: Po,
    style: Co,
    rowHeight: So,
    className: wo,
    visibleColumns: Eo,
    pinnedColumns: Ro,
    offsetLeft: _o,
    dimensions: Io,
    renderContext: Ao,
    focusedColumnIndex: Oo,
    isFirstVisible: jo,
    isLastVisible: Do,
    isNotVisible: Lo,
    showBottomBorder: ko,
    onClick: Ko,
    onDoubleClick: No,
    onMouseEnter: Jo,
    onMouseLeave: ti,
    onMouseOut: oi,
    onMouseOver: Qo
  } = uo, Zo = _objectWithoutPropertiesLoose$h(uo, _excluded$o), ei = useGridPrivateApiContext(), ii = useGridConfiguration(), ai = React$1.useRef(null), ri = useGridRootProps(), ni = useGridVisibleRows(ei, ri), si = useGridSelector(ei, gridSortModelSelector), li = useGridSelector(ei, gridRowMaximumTreeDepthSelector), ui = useGridSelector(ei, gridColumnPositionsSelector), ci = useGridSelector(ei, gridEditRowsStateSelector), fi = useForkRef(ai, ho), yi = ei.current.getRowNode(bo), hi = Io.hasScrollY ? Io.scrollbarSize : 0, mi = Io.columnsTotalWidth < Io.viewportOuterSize.width, bi = ei.current.getRowMode(bo) === GridRowModes.Edit, xi = ri.editMode === GridEditModes.Row, $i = useGridSelector(ei, gridVirtualizationColumnEnabledSelector), Ci = Oo !== void 0, Si = Ci && Oo >= Ro.left.length && Oo < Ao.firstColumnIndex, vi = Ci && Oo < Eo.length - Ro.right.length && Oo >= Ao.lastColumnIndex, Pi = composeGridClasses(ri.classes, {
    root: ["row", go && "selected", xi && "row--editable", bi && "row--editing", jo && "row--firstVisible", Do && "row--lastVisible", ko && "row--borderBottom", So === "auto" && "row--dynamicHeight"]
  }), wi = ii.hooks.useGridRowAriaAttributes();
  React$1.useLayoutEffect(() => {
    if (ni.range) {
      const Hi = ei.current.getRowIndexRelativeToVisibleRows(bo);
      Hi !== void 0 && ei.current.unstable_setLastMeasuredRowIndex(Hi);
    }
    if (ai.current && So === "auto")
      return ei.current.observeRowHeight(ai.current, bo);
  }, [ei, ni.range, So, bo]);
  const gi = React$1.useCallback((Hi, Xi) => (Zi) => {
    isEventTargetInPortal(Zi) || ei.current.getRow(bo) && (ei.current.publishEvent(Hi, ei.current.getRowParams(bo), Zi), Xi && Xi(Zi));
  }, [ei, bo]), Ri = React$1.useCallback((Hi) => {
    const Xi = findParentElementFromClassName(Hi.target, gridClasses.cell), Zi = Xi == null ? void 0 : Xi.getAttribute("data-field");
    if (Zi) {
      if (Zi === GRID_CHECKBOX_SELECTION_COL_DEF.field || Zi === GRID_DETAIL_PANEL_TOGGLE_FIELD || Zi === "__reorder__" || ei.current.getCellMode(bo, Zi) === GridCellModes.Edit)
        return;
      const zi = ei.current.getColumn(Zi);
      if ((zi == null ? void 0 : zi.type) === GRID_ACTIONS_COLUMN_TYPE)
        return;
    }
    gi("rowClick", Ko)(Hi);
  }, [ei, Ko, gi, bo]), {
    slots: Ei,
    slotProps: Ni,
    disableColumnReorder: Ai
  } = ri, Yi = ri.rowReordering, Ui = useGridSelector(ei, () => _extends$q({}, ei.current.getRowHeightEntry(bo)), objectShallowCompare), us = React$1.useMemo(() => {
    if (Lo)
      return {
        opacity: 0,
        width: 0,
        height: 0
      };
    const Hi = _extends$q({}, Co, {
      maxHeight: So === "auto" ? "none" : So,
      // max-height doesn't support "auto"
      minHeight: So,
      "--height": typeof So == "number" ? `${So}px` : So
    });
    if (Ui.spacingTop) {
      const Xi = ri.rowSpacingType === "border" ? "borderTopWidth" : "marginTop";
      Hi[Xi] = Ui.spacingTop;
    }
    if (Ui.spacingBottom) {
      const Xi = ri.rowSpacingType === "border" ? "borderBottomWidth" : "marginBottom";
      let Zi = Hi[Xi];
      typeof Zi != "number" && (Zi = parseInt(Zi || "0", 10)), Zi += Ui.spacingBottom, Hi[Xi] = Zi;
    }
    return Hi;
  }, [Lo, So, Co, Ui, ri.rowSpacingType]), ns = ei.current.unstable_applyPipeProcessors("rowClassName", [], bo), Ti = yi ? wi(yi, Po) : void 0;
  if (typeof ri.getRowClassName == "function") {
    const Hi = Po - (((Wi = ni.range) == null ? void 0 : Wi.firstRowIndex) || 0), Xi = _extends$q({}, ei.current.getRowParams(bo), {
      isFirstVisible: Hi === 0,
      isLastVisible: Hi === ni.rows.length - 1,
      indexRelativeToCurrentPage: Hi
    });
    ns.push(ri.getRowClassName(Xi));
  }
  const _i = (Hi, Xi, Zi, zi, cs = PinnedPosition.NONE) => {
    var Xs;
    const ys = ei.current.unstable_getCellColSpanInfo(bo, Zi);
    if (ys != null && ys.spannedByColSpan)
      return null;
    const $s = (ys == null ? void 0 : ys.cellProps.width) ?? Hi.computedWidth, Ns = (ys == null ? void 0 : ys.cellProps.colSpan) ?? 1, Bs = getPinnedCellOffset(gridPinnedColumnPositionLookup[cs], Hi.computedWidth, Zi, ui, Io);
    if ((yi == null ? void 0 : yi.type) === "skeletonRow")
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Ei.skeletonCell, {
        type: Hi.type,
        width: $s,
        height: So,
        field: Hi.field,
        align: Hi.align
      }, Hi.field);
    const Ws = ((Xs = ci[bo]) == null ? void 0 : Xs[Hi.field]) ?? null, Hs = Hi.field === "__reorder__", Ks = Object.keys(ci).length > 0, zs = !(Ai || Hi.disableReorder), Ys = Yi && !si.length && li <= 1 && !Ks, ds = !(zs || Hs && Ys), Ls = cs === PinnedPosition.VIRTUAL;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Ei.cell, _extends$q({
      column: Hi,
      width: $s,
      rowId: bo,
      align: Hi.align || "left",
      colIndex: Zi,
      colSpan: Ns,
      disableDragEvents: ds,
      editCellState: Ws,
      isNotVisible: Ls,
      pinnedOffset: Bs,
      pinnedPosition: cs,
      sectionIndex: Xi,
      sectionLength: zi,
      gridHasFiller: mi
    }, Ni == null ? void 0 : Ni.cell), Hi.field);
  };
  if (!yi)
    return null;
  const Vi = Ro.left.map((Hi, Xi) => _i(Hi, Xi, Xi, Ro.left.length, PinnedPosition.LEFT)), Bi = Ro.right.map((Hi, Xi) => {
    const Zi = Eo.length - Ro.right.length + Xi;
    return _i(Hi, Xi, Zi, Ro.right.length, PinnedPosition.RIGHT);
  }), Ji = Eo.length - Ro.left.length - Ro.right.length, Ki = [];
  Si && Ki.push(_i(Eo[Oo], Oo - Ro.left.length, Oo, Ji, PinnedPosition.VIRTUAL));
  let qi, rs;
  !ri.disableVirtualization && !$i ? (qi = 0, rs = Eo.length) : (qi = Ao.firstColumnIndex, rs = Ao.lastColumnIndex);
  for (let Hi = qi; Hi < rs; Hi += 1) {
    const Xi = Eo[Hi], Zi = Hi - Ro.left.length;
    Xi && Ki.push(_i(Xi, Zi, Hi, Ji));
  }
  vi && Ki.push(_i(Eo[Oo], Oo - Ro.left.length, Oo, Ji, PinnedPosition.VIRTUAL));
  const os = vo ? {
    onClick: Ri,
    onDoubleClick: gi("rowDoubleClick", No),
    onMouseEnter: gi("rowMouseEnter", Jo),
    onMouseLeave: gi("rowMouseLeave", ti),
    onMouseOut: gi("rowMouseOut", oi),
    onMouseOver: gi("rowMouseOver", Qo)
  } : null, ps = Io.viewportOuterSize.width - Io.columnsTotalWidth - hi, Mi = Math.max(0, ps);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", _extends$q({
    "data-id": bo,
    "data-rowindex": Po,
    role: "row",
    className: clsx(...ns, Pi.root, wo),
    style: us
  }, Ti, os, Zo, {
    ref: fi,
    children: [Vi, /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      role: "presentation",
      className: gridClasses.cellOffsetLeft,
      style: {
        width: _o
      }
    }), Ki, Mi > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyCell, {
      width: Mi
    }), Bi.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
      role: "presentation",
      className: gridClasses.filler
    }), Bi, hi !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(GridScrollbarFillerCell, {
      pinnedRight: Ro.right.length > 0
    })]
  }));
});
process.env.NODE_ENV !== "production" && (GridRow.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  dimensions: PropTypes.shape({
    bottomContainerHeight: PropTypes.number.isRequired,
    columnsTotalWidth: PropTypes.number.isRequired,
    contentSize: PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    }).isRequired,
    groupHeaderHeight: PropTypes.number.isRequired,
    hasScrollX: PropTypes.bool.isRequired,
    hasScrollY: PropTypes.bool.isRequired,
    headerFilterHeight: PropTypes.number.isRequired,
    headerHeight: PropTypes.number.isRequired,
    headersTotalHeight: PropTypes.number.isRequired,
    isReady: PropTypes.bool.isRequired,
    leftPinnedWidth: PropTypes.number.isRequired,
    minimumSize: PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    }).isRequired,
    rightPinnedWidth: PropTypes.number.isRequired,
    root: PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    }).isRequired,
    rowHeight: PropTypes.number.isRequired,
    rowWidth: PropTypes.number.isRequired,
    scrollbarSize: PropTypes.number.isRequired,
    topContainerHeight: PropTypes.number.isRequired,
    viewportInnerSize: PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    }).isRequired,
    viewportOuterSize: PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    }).isRequired
  }).isRequired,
  /**
   * Determines which cell has focus.
   * If `null`, no cell in this row has focus.
   */
  focusedColumnIndex: PropTypes.number,
  /**
   * Index of the row in the whole sorted and filtered dataset.
   * If some rows above have expanded children, this index also take those children into account.
   */
  index: PropTypes.number.isRequired,
  isFirstVisible: PropTypes.bool.isRequired,
  isLastVisible: PropTypes.bool.isRequired,
  isNotVisible: PropTypes.bool.isRequired,
  offsetLeft: PropTypes.number.isRequired,
  offsetTop: PropTypes.number,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  pinnedColumns: PropTypes.object.isRequired,
  renderContext: PropTypes.shape({
    firstColumnIndex: PropTypes.number.isRequired,
    firstRowIndex: PropTypes.number.isRequired,
    lastColumnIndex: PropTypes.number.isRequired,
    lastRowIndex: PropTypes.number.isRequired
  }).isRequired,
  row: PropTypes.object.isRequired,
  rowHeight: PropTypes.oneOfType([PropTypes.oneOf(["auto"]), PropTypes.number]).isRequired,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  selected: PropTypes.bool.isRequired,
  showBottomBorder: PropTypes.bool.isRequired,
  /**
   * Determines which cell should be tabbable by having tabIndex=0.
   * If `null`, no cell in this row is in the tab sequence.
   */
  tabbableCell: PropTypes.string,
  visibleColumns: PropTypes.arrayOf(PropTypes.object).isRequired
});
const MemoizedGridRow = fastMemo(GridRow), useGridAriaAttributes = () => {
  const Kt = useGridPrivateApiContext(), uo = useGridRootProps(), ho = useGridSelector(Kt, gridVisibleColumnDefinitionsSelector), go = useGridSelector(Kt, gridExpandedRowCountSelector), bo = useGridSelector(Kt, gridColumnGroupsHeaderMaxDepthSelector), vo = useGridSelector(Kt, gridPinnedRowsCountSelector);
  return {
    role: "grid",
    "aria-colcount": ho.length,
    "aria-rowcount": bo + 1 + vo + go,
    "aria-multiselectable": isMultipleRowSelectionEnabled(uo)
  };
}, useGridRowAriaAttributes = () => {
  const Kt = useGridPrivateApiContext(), uo = useGridSelector(Kt, selectedIdsLookupSelector), ho = useGridSelector(Kt, gridColumnGroupsHeaderMaxDepthSelector);
  return React$1.useCallback((go, bo) => {
    const vo = {}, Po = bo + ho + 2;
    return vo["aria-rowindex"] = Po, Kt.current.isRowSelectable(go.id) && (vo["aria-selected"] = uo[go.id] !== void 0), vo;
  }, [Kt, uo, ho]);
};
function GridContextProvider({
  privateApiRef: Kt,
  configuration: uo,
  props: ho,
  children: go
}) {
  const bo = React$1.useRef(Kt.current.getPublicApi());
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridConfigurationContext.Provider, {
    value: uo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(GridRootPropsContext.Provider, {
      value: ho,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(GridPrivateApiContext.Provider, {
        value: Kt,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(GridApiContext.Provider, {
          value: bo,
          children: go
        })
      })
    })
  });
}
const useGridRefs = (Kt) => {
  const uo = React$1.useRef(null), ho = React$1.useRef(null), go = React$1.useRef(null), bo = React$1.useRef(null), vo = React$1.useRef(null), Po = React$1.useRef(null);
  Kt.current.register("public", {
    rootElementRef: uo
  }), Kt.current.register("private", {
    mainElementRef: ho,
    virtualScrollerRef: go,
    virtualScrollbarVerticalRef: bo,
    virtualScrollbarHorizontalRef: vo,
    columnHeadersContainerRef: Po
  });
}, useGridIsRtl = (Kt) => {
  const uo = useRtl();
  Kt.current.state.isRtl === void 0 && (Kt.current.state.isRtl = uo);
  const ho = React$1.useRef(!0);
  React$1.useEffect(() => {
    ho.current ? ho.current = !1 : Kt.current.setState((go) => _extends$q({}, go, {
      isRtl: uo
    }));
  }, [Kt, uo]);
}, forceDebug = localStorageAvailable() && window.localStorage.getItem("DEBUG") != null, noop$3 = () => {
}, noopLogger = {
  debug: noop$3,
  info: noop$3,
  warn: noop$3,
  error: noop$3
}, LOG_LEVELS = ["debug", "info", "warn", "error"];
function getAppender(Kt, uo, ho = console) {
  const go = LOG_LEVELS.indexOf(uo);
  if (go === -1)
    throw new Error(`MUI X: Log level ${uo} not recognized.`);
  return LOG_LEVELS.reduce((vo, Po, Co) => (Co >= go ? vo[Po] = (...So) => {
    const [wo, ...Eo] = So;
    ho[Po](`MUI X: ${Kt} - ${wo}`, ...Eo);
  } : vo[Po] = noop$3, vo), {});
}
const useGridLoggerFactory = (Kt, uo) => {
  const ho = React$1.useCallback((go) => forceDebug ? getAppender(go, "debug", uo.logger) : uo.logLevel ? getAppender(go, uo.logLevel.toString(), uo.logger) : noopLogger, [uo.logLevel, uo.logger]);
  useGridApiMethod(Kt, {
    getLogger: ho
  }, "private");
};
class EventManager {
  constructor() {
    this.maxListeners = 20, this.warnOnce = !1, this.events = {};
  }
  on(uo, ho, go = {}) {
    let bo = this.events[uo];
    if (bo || (bo = {
      highPriority: /* @__PURE__ */ new Map(),
      regular: /* @__PURE__ */ new Map()
    }, this.events[uo] = bo), go.isFirst ? bo.highPriority.set(ho, !0) : bo.regular.set(ho, !0), process.env.NODE_ENV !== "production") {
      const vo = bo.highPriority.size + bo.regular.size;
      vo > this.maxListeners && !this.warnOnce && (this.warnOnce = !0, console.warn([`Possible EventEmitter memory leak detected. ${vo} ${uo} listeners added.`].join(`
`)));
    }
  }
  removeListener(uo, ho) {
    this.events[uo] && (this.events[uo].regular.delete(ho), this.events[uo].highPriority.delete(ho));
  }
  removeAllListeners() {
    this.events = {};
  }
  emit(uo, ...ho) {
    const go = this.events[uo];
    if (!go)
      return;
    const bo = Array.from(go.highPriority.keys()), vo = Array.from(go.regular.keys());
    for (let Po = bo.length - 1; Po >= 0; Po -= 1) {
      const Co = bo[Po];
      go.highPriority.has(Co) && Co.apply(this, ho);
    }
    for (let Po = 0; Po < vo.length; Po += 1) {
      const Co = vo[Po];
      go.regular.has(Co) && Co.apply(this, ho);
    }
  }
  once(uo, ho) {
    const go = this;
    this.on(uo, function bo(...vo) {
      go.removeListener(uo, bo), ho.apply(go, vo);
    });
  }
}
class Store {
  static create(uo) {
    return new Store(uo);
  }
  constructor(uo) {
    this.value = void 0, this.listeners = void 0, this.subscribe = (ho) => (this.listeners.add(ho), () => {
      this.listeners.delete(ho);
    }), this.getSnapshot = () => this.value, this.update = (ho) => {
      this.value = ho, this.listeners.forEach((go) => go(ho));
    }, this.value = uo, this.listeners = /* @__PURE__ */ new Set();
  }
}
const SYMBOL_API_PRIVATE = Symbol("mui.api_private"), isSyntheticEvent = (Kt) => Kt.isPropagationStopped !== void 0;
let globalId = 0;
function createPrivateAPI(Kt) {
  var bo;
  const uo = (bo = Kt.current) == null ? void 0 : bo[SYMBOL_API_PRIVATE];
  if (uo)
    return uo;
  const ho = {}, go = {
    state: ho,
    store: Store.create(ho),
    instanceId: {
      id: globalId
    }
  };
  return globalId += 1, go.getPublicApi = () => Kt.current, go.register = (vo, Po) => {
    Object.keys(Po).forEach((Co) => {
      const So = Po[Co], wo = go[Co];
      if ((wo == null ? void 0 : wo.spying) === !0 ? wo.target = So : go[Co] = So, vo === "public") {
        const Eo = Kt.current, Ro = Eo[Co];
        (Ro == null ? void 0 : Ro.spying) === !0 ? Ro.target = So : Eo[Co] = So;
      }
    });
  }, go.register("private", {
    caches: {},
    eventManager: new EventManager()
  }), go;
}
function createPublicAPI(Kt) {
  return {
    get state() {
      return Kt.current.state;
    },
    get store() {
      return Kt.current.store;
    },
    get instanceId() {
      return Kt.current.instanceId;
    },
    [SYMBOL_API_PRIVATE]: Kt.current
  };
}
function useGridApiInitialization(Kt, uo) {
  var Po;
  const ho = React$1.useRef(), go = React$1.useRef();
  go.current || (go.current = createPrivateAPI(ho)), ho.current || (ho.current = createPublicAPI(go));
  const bo = React$1.useCallback((...Co) => {
    const [So, wo, Eo = {}] = Co;
    if (Eo.defaultMuiPrevented = !1, isSyntheticEvent(Eo) && Eo.isPropagationStopped())
      return;
    const Ro = uo.signature === GridSignature.DataGridPro || uo.signature === GridSignature.DataGridPremium ? {
      api: go.current.getPublicApi()
    } : {};
    go.current.eventManager.emit(So, wo, Eo, Ro);
  }, [go, uo.signature]), vo = React$1.useCallback((Co, So, wo) => {
    go.current.eventManager.on(Co, So, wo);
    const Eo = go.current;
    return () => {
      Eo.eventManager.removeListener(Co, So);
    };
  }, [go]);
  return useGridApiMethod(go, {
    subscribeEvent: vo,
    publishEvent: bo
  }, "public"), Kt && !((Po = Kt.current) != null && Po.state) && (Kt.current = ho.current), React$1.useImperativeHandle(Kt, () => ho.current, [ho]), React$1.useEffect(() => {
    const Co = go.current;
    return () => {
      Co.publishEvent("unmount");
    };
  }, [go]), go;
}
const useGridLocaleText = (Kt, uo) => {
  const ho = React$1.useCallback((go) => {
    if (uo.localeText[go] == null)
      throw new Error(`Missing translation for key ${go}.`);
    return uo.localeText[go];
  }, [uo.localeText]);
  Kt.current.register("public", {
    getLocaleText: ho
  });
};
function _typeof$I(Kt) {
  "@babel/helpers - typeof";
  return _typeof$I = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$I(Kt);
}
function toPrimitive(Kt, uo) {
  if (_typeof$I(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo);
    if (_typeof$I(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Kt);
}
function toPropertyKey(Kt) {
  var uo = toPrimitive(Kt, "string");
  return _typeof$I(uo) == "symbol" ? uo : uo + "";
}
const useGridPipeProcessing = (Kt) => {
  const uo = React$1.useRef({}), ho = React$1.useRef(!1), go = React$1.useCallback((Eo) => {
    ho.current || !Eo || (ho.current = !0, Object.values(Eo.appliers).forEach((Ro) => {
      Ro();
    }), ho.current = !1);
  }, []), bo = React$1.useCallback((Eo, Ro, _o) => {
    uo.current[Eo] || (uo.current[Eo] = {
      processors: /* @__PURE__ */ new Map(),
      processorsAsArray: [],
      appliers: {}
    });
    const Io = uo.current[Eo];
    return Io.processors.get(Ro) !== _o && (Io.processors.set(Ro, _o), Io.processorsAsArray = Array.from(uo.current[Eo].processors.values()), go(Io)), () => {
      uo.current[Eo].processors.delete(Ro), uo.current[Eo].processorsAsArray = Array.from(uo.current[Eo].processors.values());
    };
  }, [go]), vo = React$1.useCallback((Eo, Ro, _o) => (uo.current[Eo] || (uo.current[Eo] = {
    processors: /* @__PURE__ */ new Map(),
    processorsAsArray: [],
    appliers: {}
  }), uo.current[Eo].appliers[Ro] = _o, () => {
    const Io = uo.current[Eo].appliers, Ao = _objectWithoutPropertiesLoose$h(Io, [Ro].map(toPropertyKey));
    uo.current[Eo].appliers = Ao;
  }), []), Po = React$1.useCallback((Eo) => {
    go(uo.current[Eo]);
  }, [go]), Co = React$1.useCallback((...Eo) => {
    const [Ro, _o, Io] = Eo;
    if (!uo.current[Ro])
      return _o;
    const Ao = uo.current[Ro].processorsAsArray;
    let Oo = _o;
    for (let jo = 0; jo < Ao.length; jo += 1)
      Oo = Ao[jo](Oo, Io);
    return Oo;
  }, []), So = {
    registerPipeProcessor: bo,
    registerPipeApplier: vo,
    requestPipeProcessorsApplication: Po
  }, wo = {
    unstable_applyPipeProcessors: Co
  };
  useGridApiMethod(Kt, So, "private"), useGridApiMethod(Kt, wo, "public");
}, useGridRegisterPipeProcessor = (Kt, uo, ho) => {
  const go = React$1.useRef(), bo = React$1.useRef(`mui-${Math.round(Math.random() * 1e9)}`), vo = React$1.useCallback(() => {
    go.current = Kt.current.registerPipeProcessor(uo, bo.current, ho);
  }, [Kt, ho, uo]);
  useFirstRender(() => {
    vo();
  });
  const Po = React$1.useRef(!0);
  React$1.useEffect(() => (Po.current ? Po.current = !1 : vo(), () => {
    go.current && (go.current(), go.current = null);
  }), [vo]);
}, useGridRegisterPipeApplier = (Kt, uo, ho) => {
  const go = React$1.useRef(), bo = React$1.useRef(`mui-${Math.round(Math.random() * 1e9)}`), vo = React$1.useCallback(() => {
    go.current = Kt.current.registerPipeApplier(uo, bo.current, ho);
  }, [Kt, ho, uo]);
  useFirstRender(() => {
    vo();
  });
  const Po = React$1.useRef(!0);
  React$1.useEffect(() => (Po.current ? Po.current = !1 : vo(), () => {
    go.current && (go.current(), go.current = null);
  }), [vo]);
}, useGridRegisterStrategyProcessor = (Kt, uo, ho, go) => {
  const bo = React$1.useCallback(() => {
    Kt.current.registerStrategyProcessor(uo, ho, go);
  }, [Kt, go, ho, uo]);
  useFirstRender(() => {
    bo();
  });
  const vo = React$1.useRef(!0);
  React$1.useEffect(() => {
    vo.current ? vo.current = !1 : bo();
  }, [bo]);
}, GRID_DEFAULT_STRATEGY = "none", GRID_STRATEGIES_PROCESSORS = {
  rowTreeCreation: "rowTree",
  filtering: "rowTree",
  sorting: "rowTree",
  visibleRowsLookupCreation: "rowTree"
}, useGridStrategyProcessing = (Kt) => {
  const uo = React$1.useRef(/* @__PURE__ */ new Map()), ho = React$1.useRef({}), go = React$1.useCallback((So, wo, Eo) => {
    const Ro = () => {
      const Ao = ho.current[wo], Oo = _objectWithoutPropertiesLoose$h(Ao, [So].map(toPropertyKey));
      ho.current[wo] = Oo;
    };
    ho.current[wo] || (ho.current[wo] = {});
    const _o = ho.current[wo], Io = _o[So];
    return _o[So] = Eo, !Io || Io === Eo || So === Kt.current.getActiveStrategy(GRID_STRATEGIES_PROCESSORS[wo]) && Kt.current.publishEvent("activeStrategyProcessorChange", wo), Ro;
  }, [Kt]), bo = React$1.useCallback((So, wo) => {
    const Eo = Kt.current.getActiveStrategy(GRID_STRATEGIES_PROCESSORS[So]);
    if (Eo == null)
      throw new Error("Can't apply a strategy processor before defining an active strategy");
    const Ro = ho.current[So];
    if (!Ro || !Ro[Eo])
      throw new Error(`No processor found for processor "${So}" on strategy "${Eo}"`);
    const _o = Ro[Eo];
    return _o(wo);
  }, [Kt]), vo = React$1.useCallback((So) => {
    const Eo = Array.from(uo.current.entries()).find(([, Ro]) => Ro.group !== So ? !1 : Ro.isAvailable());
    return (Eo == null ? void 0 : Eo[0]) ?? GRID_DEFAULT_STRATEGY;
  }, []), Po = React$1.useCallback((So, wo, Eo) => {
    uo.current.set(wo, {
      group: So,
      isAvailable: Eo
    }), Kt.current.publishEvent("strategyAvailabilityChange");
  }, [Kt]);
  useGridApiMethod(Kt, {
    registerStrategyProcessor: go,
    applyStrategyProcessor: bo,
    getActiveStrategy: vo,
    setStrategyAvailability: Po
  }, "private");
}, useGridStateInitialization = (Kt) => {
  const uo = React$1.useRef({}), [, ho] = React$1.useState(), go = React$1.useCallback((wo) => {
    uo.current[wo.stateId] = wo;
  }, []), bo = React$1.useCallback((wo, Eo) => {
    let Ro;
    if (isFunction$5(wo) ? Ro = wo(Kt.current.state) : Ro = wo, Kt.current.state === Ro)
      return !1;
    let _o = !1;
    const Io = [];
    if (Object.keys(uo.current).forEach((Ao) => {
      const Oo = uo.current[Ao], jo = Oo.stateSelector(Kt.current.state, Kt.current.instanceId), Do = Oo.stateSelector(Ro, Kt.current.instanceId);
      Do !== jo && (Io.push({
        stateId: Oo.stateId,
        hasPropChanged: Do !== Oo.propModel
      }), Oo.propModel !== void 0 && Do !== Oo.propModel && (_o = !0));
    }), Io.length > 1)
      throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${Io[0].stateId}, therefore, you're not allowed to update ${Io.map((Ao) => Ao.stateId).join(", ")} in the same transaction.`);
    if (_o || (Kt.current.state = Ro, Kt.current.publishEvent("stateChange", Ro), Kt.current.store.update(Ro)), Io.length === 1) {
      const {
        stateId: Ao,
        hasPropChanged: Oo
      } = Io[0], jo = uo.current[Ao], Do = jo.stateSelector(Ro, Kt.current.instanceId);
      jo.propOnChange && Oo && jo.propOnChange(Do, {
        reason: Eo,
        api: Kt.current
      }), _o || Kt.current.publishEvent(jo.changeEvent, Do, {
        reason: Eo
      });
    }
    return !_o;
  }, [Kt]), vo = React$1.useCallback((wo, Eo, Ro) => Kt.current.setState((_o) => _extends$q({}, _o, {
    [wo]: Eo(_o[wo])
  }), Ro), [Kt]), Po = React$1.useCallback(() => ho(() => Kt.current.state), [Kt]), Co = {
    setState: bo,
    forceUpdate: Po
  }, So = {
    updateControlState: vo,
    registerControlState: go
  };
  useGridApiMethod(Kt, Co, "public"), useGridApiMethod(Kt, So, "private");
}, useGridInitialization = (Kt, uo) => {
  const ho = useGridApiInitialization(Kt, uo);
  return useGridRefs(ho), useGridIsRtl(ho), useGridLoggerFactory(ho, uo), useGridStateInitialization(ho), useGridPipeProcessing(ho), useGridStrategyProcessing(ho), useGridLocaleText(ho, uo), ho.current.register("private", {
    rootProps: uo
  }), ho;
}, useGridInitializeState = (Kt, uo, ho) => {
  const go = React$1.useRef(!1);
  go.current || (uo.current.state = Kt(uo.current.state, ho, uo), go.current = !0);
};
function sanitizeCellValue(Kt, uo) {
  if (Kt == null)
    return "";
  const ho = typeof Kt == "string" ? Kt : `${Kt}`;
  if (uo.shouldAppendQuotes || uo.escapeFormulas) {
    const go = ho.replace(/"/g, '""');
    return uo.escapeFormulas && ["=", "+", "-", "@", "	", "\r"].includes(go[0]) ? `"'${go}"` : [uo.delimiter, `
`, "\r", '"'].some((bo) => ho.includes(bo)) ? `"${go}"` : go;
  }
  return ho;
}
const serializeCellValue = (Kt, uo) => {
  var vo, Po;
  const {
    csvOptions: ho,
    ignoreValueFormatter: go
  } = uo;
  let bo;
  if (go) {
    const Co = Kt.colDef.type;
    Co === "number" ? bo = String(Kt.value) : Co === "date" || Co === "dateTime" ? bo = (vo = Kt.value) == null ? void 0 : vo.toISOString() : typeof ((Po = Kt.value) == null ? void 0 : Po.toString) == "function" ? bo = Kt.value.toString() : bo = Kt.value;
  } else
    bo = Kt.formattedValue;
  return sanitizeCellValue(bo, ho);
};
class CSVRow {
  constructor(uo) {
    this.options = void 0, this.rowString = "", this.isEmpty = !0, this.options = uo;
  }
  addValue(uo) {
    this.isEmpty || (this.rowString += this.options.csvOptions.delimiter), typeof this.options.sanitizeCellValue == "function" ? this.rowString += this.options.sanitizeCellValue(uo, this.options.csvOptions) : this.rowString += uo, this.isEmpty = !1;
  }
  getRowString() {
    return this.rowString;
  }
}
const serializeRow = ({
  id: Kt,
  columns: uo,
  getCellParams: ho,
  csvOptions: go,
  ignoreValueFormatter: bo
}) => {
  const vo = new CSVRow({
    csvOptions: go
  });
  return uo.forEach((Po) => {
    const Co = ho(Kt, Po.field);
    process.env.NODE_ENV !== "production" && String(Co.formattedValue) === "[object Object]" && warnOnce(["MUI X: When the value of a field is an object or a `renderCell` is provided, the CSV export might not display the value correctly.", "You can provide a `valueFormatter` with a string representation to be used."]), vo.addValue(serializeCellValue(Co, {
      ignoreValueFormatter: bo,
      csvOptions: go
    }));
  }), vo.getRowString();
};
function buildCSV(Kt) {
  const {
    columns: uo,
    rowIds: ho,
    csvOptions: go,
    ignoreValueFormatter: bo,
    apiRef: vo
  } = Kt, Po = ho.reduce((Ro, _o) => `${Ro}${serializeRow({
    id: _o,
    columns: uo,
    getCellParams: vo.current.getCellParams,
    ignoreValueFormatter: bo,
    csvOptions: go
  })}\r
`, "").trim();
  if (!go.includeHeaders)
    return Po;
  const Co = uo.filter((Ro) => Ro.field !== GRID_CHECKBOX_SELECTION_COL_DEF.field), So = [];
  if (go.includeColumnGroupsHeaders) {
    const Ro = vo.current.getAllGroupDetails();
    let _o = 0;
    const Io = Co.reduce((Ao, Oo) => {
      const jo = vo.current.getColumnGroupPath(Oo.field);
      return Ao[Oo.field] = jo, _o = Math.max(_o, jo.length), Ao;
    }, {});
    for (let Ao = 0; Ao < _o; Ao += 1) {
      const Oo = new CSVRow({
        csvOptions: go,
        sanitizeCellValue
      });
      So.push(Oo), Co.forEach((jo) => {
        const Do = (Io[jo.field] || [])[Ao], Lo = Ro[Do];
        Oo.addValue(Lo ? Lo.headerName || Lo.groupId : "");
      });
    }
  }
  const wo = new CSVRow({
    csvOptions: go,
    sanitizeCellValue
  });
  return Co.forEach((Ro) => {
    wo.addValue(Ro.headerName || Ro.field);
  }), So.push(wo), `${`${So.map((Ro) => Ro.getRowString()).join(`\r
`)}\r
`}${Po}`.trim();
}
function writeToClipboardPolyfill(Kt) {
  const uo = document.createElement("span");
  uo.style.whiteSpace = "pre", uo.style.userSelect = "all", uo.style.opacity = "0px", uo.textContent = Kt, document.body.appendChild(uo);
  const ho = document.createRange();
  ho.selectNode(uo);
  const go = window.getSelection();
  go.removeAllRanges(), go.addRange(ho);
  try {
    document.execCommand("copy");
  } finally {
    document.body.removeChild(uo);
  }
}
function copyToClipboard(Kt) {
  navigator.clipboard ? navigator.clipboard.writeText(Kt).catch(() => {
    writeToClipboardPolyfill(Kt);
  }) : writeToClipboardPolyfill(Kt);
}
function hasNativeSelection(Kt) {
  var uo;
  return !!((uo = window.getSelection()) != null && uo.toString() || Kt && (Kt.selectionEnd || 0) - (Kt.selectionStart || 0) > 0);
}
const useGridClipboard = (Kt, uo) => {
  const ho = uo.ignoreValueFormatterDuringExport, go = (typeof ho == "object" ? ho == null ? void 0 : ho.clipboardExport : ho) || !1, bo = uo.clipboardCopyCellDelimiter, vo = React$1.useCallback((Po) => {
    if (!isCopyShortcut(Po) || hasNativeSelection(Po.target))
      return;
    let Co = "";
    if (Kt.current.getSelectedRows().size > 0)
      Co = Kt.current.getDataAsCsv({
        includeHeaders: !1,
        delimiter: bo,
        shouldAppendQuotes: !1,
        escapeFormulas: !1
      });
    else {
      const wo = gridFocusCellSelector(Kt);
      if (wo) {
        const Eo = Kt.current.getCellParams(wo.id, wo.field);
        Co = serializeCellValue(Eo, {
          csvOptions: {
            delimiter: bo,
            shouldAppendQuotes: !1,
            escapeFormulas: !1
          },
          ignoreValueFormatter: go
        });
      }
    }
    Co = Kt.current.unstable_applyPipeProcessors("clipboardCopy", Co), Co && (copyToClipboard(Co), Kt.current.publishEvent("clipboardCopy", Co));
  }, [Kt, go, bo]);
  useGridNativeEventListener(Kt, Kt.current.rootElementRef, "keydown", vo), useGridApiOptionHandler(Kt, "clipboardCopy", uo.onClipboardCopy);
}, columnMenuStateInitializer = (Kt) => _extends$q({}, Kt, {
  columnMenu: {
    open: !1
  }
}), useGridColumnMenu = (Kt) => {
  const uo = useGridLogger(Kt, "useGridColumnMenu"), ho = React$1.useCallback((Po) => {
    const Co = gridColumnMenuSelector(Kt.current.state), So = {
      open: !0,
      field: Po
    };
    (So.open !== Co.open || So.field !== Co.field) && (Kt.current.setState((Eo) => Eo.columnMenu.open && Eo.columnMenu.field === Po ? Eo : (uo.debug("Opening Column Menu"), _extends$q({}, Eo, {
      columnMenu: {
        open: !0,
        field: Po
      }
    }))), Kt.current.hidePreferences(), Kt.current.forceUpdate());
  }, [Kt, uo]), go = React$1.useCallback(() => {
    const Po = gridColumnMenuSelector(Kt.current.state);
    if (Po.field) {
      const wo = gridColumnLookupSelector(Kt), Eo = gridColumnVisibilityModelSelector(Kt), Ro = gridColumnFieldsSelector(Kt);
      let _o = Po.field;
      if (wo[_o] || (_o = Ro[0]), Eo[_o] === !1) {
        const Io = Ro.filter((Oo) => Oo === _o ? !0 : Eo[Oo] !== !1), Ao = Io.indexOf(_o);
        _o = Io[Ao + 1] || Io[Ao - 1];
      }
      Kt.current.setColumnHeaderFocus(_o);
    }
    const Co = {
      open: !1,
      field: void 0
    };
    (Co.open !== Po.open || Co.field !== Po.field) && (Kt.current.setState((wo) => (uo.debug("Hiding Column Menu"), _extends$q({}, wo, {
      columnMenu: Co
    }))), Kt.current.forceUpdate());
  }, [Kt, uo]), bo = React$1.useCallback((Po) => {
    uo.debug("Toggle Column Menu");
    const Co = gridColumnMenuSelector(Kt.current.state);
    !Co.open || Co.field !== Po ? ho(Po) : go();
  }, [Kt, uo, ho, go]);
  useGridApiMethod(Kt, {
    showColumnMenu: ho,
    hideColumnMenu: go,
    toggleColumnMenu: bo
  }, "public"), useGridApiEventHandler(Kt, "columnResizeStart", go), useGridApiEventHandler(Kt, "virtualScrollerWheel", Kt.current.hideColumnMenu), useGridApiEventHandler(Kt, "virtualScrollerTouchMove", Kt.current.hideColumnMenu);
}, columnsStateInitializer = (Kt, uo, ho) => {
  var bo, vo, Po;
  const go = createColumnsState({
    apiRef: ho,
    columnsToUpsert: uo.columns,
    initialState: (bo = uo.initialState) == null ? void 0 : bo.columns,
    columnVisibilityModel: uo.columnVisibilityModel ?? ((Po = (vo = uo.initialState) == null ? void 0 : vo.columns) == null ? void 0 : Po.columnVisibilityModel) ?? {},
    keepOnlyColumnsToUpsert: !0
  });
  return _extends$q({}, Kt, {
    columns: go,
    // In pro/premium, this part of the state is defined. We give it an empty but defined value
    // for the community version.
    pinnedColumns: Kt.pinnedColumns ?? EMPTY_PINNED_COLUMN_FIELDS
  });
};
function useGridColumns(Kt, uo) {
  var Zo, ei;
  const ho = useGridLogger(Kt, "useGridColumns"), go = React$1.useRef(uo.columns);
  Kt.current.registerControlState({
    stateId: "visibleColumns",
    propModel: uo.columnVisibilityModel,
    propOnChange: uo.onColumnVisibilityModelChange,
    stateSelector: gridColumnVisibilityModelSelector,
    changeEvent: "columnVisibilityModelChange"
  });
  const bo = React$1.useCallback((ii) => {
    var ai, ri;
    ho.debug("Updating columns state."), Kt.current.setState(mergeColumnsState(ii)), Kt.current.publishEvent("columnsChange", ii.orderedFields), (ri = (ai = Kt.current).updateRenderContext) == null || ri.call(ai), Kt.current.forceUpdate();
  }, [ho, Kt]), vo = React$1.useCallback((ii) => gridColumnLookupSelector(Kt)[ii], [Kt]), Po = React$1.useCallback(() => gridColumnDefinitionsSelector(Kt), [Kt]), Co = React$1.useCallback(() => gridVisibleColumnDefinitionsSelector(Kt), [Kt]), So = React$1.useCallback((ii, ai = !0) => (ai ? gridVisibleColumnDefinitionsSelector(Kt) : gridColumnDefinitionsSelector(Kt)).findIndex((ni) => ni.field === ii), [Kt]), wo = React$1.useCallback((ii) => {
    const ai = So(ii);
    return gridColumnPositionsSelector(Kt)[ai];
  }, [Kt, So]), Eo = React$1.useCallback((ii) => {
    var ri, ni;
    gridColumnVisibilityModelSelector(Kt) !== ii && (Kt.current.setState((si) => _extends$q({}, si, {
      columns: createColumnsState({
        apiRef: Kt,
        columnsToUpsert: [],
        initialState: void 0,
        columnVisibilityModel: ii,
        keepOnlyColumnsToUpsert: !1
      })
    })), (ni = (ri = Kt.current).updateRenderContext) == null || ni.call(ri), Kt.current.forceUpdate());
  }, [Kt]), Ro = React$1.useCallback((ii) => {
    const ai = createColumnsState({
      apiRef: Kt,
      columnsToUpsert: ii,
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    bo(ai);
  }, [Kt, bo]), _o = React$1.useCallback((ii, ai) => {
    const ri = gridColumnVisibilityModelSelector(Kt), ni = ri[ii] ?? !0;
    if (ai !== ni) {
      const si = _extends$q({}, ri, {
        [ii]: ai
      });
      Kt.current.setColumnVisibilityModel(si);
    }
  }, [Kt]), Io = React$1.useCallback((ii) => gridColumnFieldsSelector(Kt).findIndex((ri) => ri === ii), [Kt]), Ao = React$1.useCallback((ii, ai) => {
    const ri = gridColumnFieldsSelector(Kt), ni = Io(ii);
    if (ni === ai)
      return;
    ho.debug(`Moving column ${ii} to index ${ai}`);
    const si = [...ri], li = si.splice(ni, 1)[0];
    si.splice(ai, 0, li), bo(_extends$q({}, gridColumnsStateSelector(Kt.current.state), {
      orderedFields: si
    }));
    const ui = {
      column: Kt.current.getColumn(ii),
      targetIndex: Kt.current.getColumnIndexRelativeToVisibleColumns(ii),
      oldIndex: ni
    };
    Kt.current.publishEvent("columnIndexChange", ui);
  }, [Kt, ho, bo, Io]), Oo = React$1.useCallback((ii, ai) => {
    ho.debug(`Updating column ${ii} width to ${ai}`);
    const ri = gridColumnsStateSelector(Kt.current.state), ni = ri.lookup[ii], si = _extends$q({}, ni, {
      width: ai,
      hasBeenResized: !0
    });
    bo(hydrateColumnsWidth(_extends$q({}, ri, {
      lookup: _extends$q({}, ri.lookup, {
        [ii]: si
      })
    }), Kt.current.getRootDimensions())), Kt.current.publishEvent("columnWidthChange", {
      element: Kt.current.getColumnHeaderElement(ii),
      colDef: si,
      width: ai
    });
  }, [Kt, ho, bo]), jo = {
    getColumn: vo,
    getAllColumns: Po,
    getColumnIndex: So,
    getColumnPosition: wo,
    getVisibleColumns: Co,
    getColumnIndexRelativeToVisibleColumns: Io,
    updateColumns: Ro,
    setColumnVisibilityModel: Eo,
    setColumnVisibility: _o,
    setColumnWidth: Oo
  }, Do = {
    setColumnIndex: Ao
  };
  useGridApiMethod(Kt, jo, "public"), useGridApiMethod(Kt, Do, uo.signature === GridSignature.DataGrid ? "private" : "public");
  const Lo = React$1.useCallback((ii, ai) => {
    var ci, fi;
    const ri = {}, ni = gridColumnVisibilityModelSelector(Kt);
    // Always export if the `exportOnlyDirtyModels` property is not activated
    (!ai.exportOnlyDirtyModels || // Always export if the model is controlled
    uo.columnVisibilityModel != null || // Always export if the model has been initialized
    // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
    Object.keys(((fi = (ci = uo.initialState) == null ? void 0 : ci.columns) == null ? void 0 : fi.columnVisibilityModel) ?? {}).length > 0 || // Always export if the model is not empty
    Object.keys(ni).length > 0) && (ri.columnVisibilityModel = ni), ri.orderedFields = gridColumnFieldsSelector(Kt);
    const li = gridColumnDefinitionsSelector(Kt), ui = {};
    return li.forEach((yi) => {
      if (yi.hasBeenResized) {
        const hi = {};
        COLUMNS_DIMENSION_PROPERTIES.forEach((mi) => {
          let bi = yi[mi];
          bi === 1 / 0 && (bi = -1), hi[mi] = bi;
        }), ui[yi.field] = hi;
      }
    }), Object.keys(ui).length > 0 && (ri.dimensions = ui), _extends$q({}, ii, {
      columns: ri
    });
  }, [Kt, uo.columnVisibilityModel, (Zo = uo.initialState) == null ? void 0 : Zo.columns]), ko = React$1.useCallback((ii, ai) => {
    var li;
    const ri = (li = ai.stateToRestore.columns) == null ? void 0 : li.columnVisibilityModel, ni = ai.stateToRestore.columns;
    if (ri == null && ni == null)
      return ii;
    const si = createColumnsState({
      apiRef: Kt,
      columnsToUpsert: [],
      initialState: ni,
      columnVisibilityModel: ri,
      keepOnlyColumnsToUpsert: !1
    });
    return Kt.current.setState(mergeColumnsState(si)), ni != null && Kt.current.publishEvent("columnsChange", si.orderedFields), ii;
  }, [Kt]), Ko = React$1.useCallback((ii, ai) => {
    var ri;
    if (ai === GridPreferencePanelsValue.columns) {
      const ni = uo.slots.columnsPanel;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ni, _extends$q({}, (ri = uo.slotProps) == null ? void 0 : ri.columnsPanel));
    }
    return ii;
  }, [uo.slots.columnsPanel, (ei = uo.slotProps) == null ? void 0 : ei.columnsPanel]), No = React$1.useCallback((ii) => uo.disableColumnSelector ? ii : [...ii, "columnMenuColumnsItem"], [uo.disableColumnSelector]);
  useGridRegisterPipeProcessor(Kt, "columnMenu", No), useGridRegisterPipeProcessor(Kt, "exportState", Lo), useGridRegisterPipeProcessor(Kt, "restoreState", ko), useGridRegisterPipeProcessor(Kt, "preferencePanel", Ko);
  const Jo = React$1.useRef(null);
  useGridApiEventHandler(Kt, "viewportInnerSizeChange", (ii) => {
    Jo.current !== ii.width && (Jo.current = ii.width, bo(hydrateColumnsWidth(gridColumnsStateSelector(Kt.current.state), Kt.current.getRootDimensions())));
  });
  const oi = React$1.useCallback(() => {
    ho.info("Columns pipe processing have changed, regenerating the columns");
    const ii = createColumnsState({
      apiRef: Kt,
      columnsToUpsert: [],
      initialState: void 0,
      keepOnlyColumnsToUpsert: !1
    });
    bo(ii);
  }, [Kt, ho, bo]);
  useGridRegisterPipeApplier(Kt, "hydrateColumns", oi);
  const Qo = React$1.useRef(!0);
  React$1.useEffect(() => {
    if (Qo.current) {
      Qo.current = !1;
      return;
    }
    if (ho.info(`GridColumns have changed, new length ${uo.columns.length}`), go.current === uo.columns)
      return;
    const ii = createColumnsState({
      apiRef: Kt,
      initialState: void 0,
      // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
      columnsToUpsert: uo.columns,
      keepOnlyColumnsToUpsert: !0
    });
    go.current = uo.columns, bo(ii);
  }, [ho, Kt, bo, uo.columns]), React$1.useEffect(() => {
    uo.columnVisibilityModel !== void 0 && Kt.current.setColumnVisibilityModel(uo.columnVisibilityModel);
  }, [Kt, ho, uo.columnVisibilityModel]);
}
function mergeColumnsState(Kt) {
  return (uo) => _extends$q({}, uo, {
    columns: Kt
  });
}
const densityStateInitializer = (Kt, uo) => {
  var ho;
  return _extends$q({}, Kt, {
    density: ((ho = uo.initialState) == null ? void 0 : ho.density) ?? uo.density ?? "standard"
  });
}, useGridDensity = (Kt, uo) => {
  var Co;
  const ho = useGridLogger(Kt, "useDensity");
  Kt.current.registerControlState({
    stateId: "density",
    propModel: uo.density,
    propOnChange: uo.onDensityChange,
    stateSelector: gridDensitySelector,
    changeEvent: "densityChange"
  });
  const bo = {
    setDensity: useEventCallback((So) => {
      gridDensitySelector(Kt.current.state) !== So && (ho.debug(`Set grid density to ${So}`), Kt.current.setState((Eo) => _extends$q({}, Eo, {
        density: So
      })));
    })
  };
  useGridApiMethod(Kt, bo, "public");
  const vo = React$1.useCallback((So, wo) => {
    var _o;
    const Eo = gridDensitySelector(Kt.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !wo.exportOnlyDirtyModels || // Always export if the `density` is controlled
      uo.density != null || // Always export if the `density` has been initialized
      ((_o = uo.initialState) == null ? void 0 : _o.density) != null ? _extends$q({}, So, {
        density: Eo
      }) : So
    );
  }, [Kt, uo.density, (Co = uo.initialState) == null ? void 0 : Co.density]), Po = React$1.useCallback((So, wo) => {
    var Ro;
    const Eo = (Ro = wo.stateToRestore) != null && Ro.density ? wo.stateToRestore.density : gridDensitySelector(Kt.current.state);
    return Kt.current.setState((_o) => _extends$q({}, _o, {
      density: Eo
    })), So;
  }, [Kt]);
  useGridRegisterPipeProcessor(Kt, "exportState", vo), useGridRegisterPipeProcessor(Kt, "restoreState", Po), React$1.useEffect(() => {
    uo.density && Kt.current.setDensity(uo.density);
  }, [Kt, uo.density]);
};
function exportAs(Kt, uo = "csv", ho = document.title || "untitled") {
  const go = `${ho}.${uo}`;
  if ("download" in HTMLAnchorElement.prototype) {
    const bo = URL.createObjectURL(Kt), vo = document.createElement("a");
    vo.href = bo, vo.download = go, vo.click(), setTimeout(() => {
      URL.revokeObjectURL(bo);
    });
    return;
  }
  throw new Error("MUI X: exportAs not supported.");
}
const getColumnsToExport = ({
  apiRef: Kt,
  options: uo
}) => {
  const ho = gridColumnDefinitionsSelector(Kt);
  return uo.fields ? uo.fields.reduce((bo, vo) => {
    const Po = ho.find((Co) => Co.field === vo);
    return Po && bo.push(Po), bo;
  }, []) : (uo.allColumns ? ho : gridVisibleColumnDefinitionsSelector(Kt)).filter((bo) => !bo.disableExport);
}, defaultGetRowsToExport = ({
  apiRef: Kt
}) => {
  var So, wo;
  const uo = gridFilteredSortedRowIdsSelector(Kt), ho = gridRowTreeSelector(Kt), go = Kt.current.getSelectedRows(), bo = uo.filter((Eo) => ho[Eo].type !== "footer"), vo = gridPinnedRowsSelector(Kt), Po = ((So = vo == null ? void 0 : vo.top) == null ? void 0 : So.map((Eo) => Eo.id)) || [], Co = ((wo = vo == null ? void 0 : vo.bottom) == null ? void 0 : wo.map((Eo) => Eo.id)) || [];
  return bo.unshift(...Po), bo.push(...Co), go.size > 0 ? bo.filter((Eo) => go.has(Eo)) : bo;
}, useGridCsvExport = (Kt, uo) => {
  const ho = useGridLogger(Kt, "useGridCsvExport"), go = uo.ignoreValueFormatterDuringExport, bo = (typeof go == "object" ? go == null ? void 0 : go.csvExport : go) || !1, vo = React$1.useCallback((wo = {}) => {
    ho.debug("Get data as CSV");
    const Eo = getColumnsToExport({
      apiRef: Kt,
      options: wo
    }), _o = (wo.getRowsToExport ?? defaultGetRowsToExport)({
      apiRef: Kt
    });
    return buildCSV({
      columns: Eo,
      rowIds: _o,
      csvOptions: {
        delimiter: wo.delimiter || ",",
        shouldAppendQuotes: wo.shouldAppendQuotes ?? !0,
        includeHeaders: wo.includeHeaders ?? !0,
        includeColumnGroupsHeaders: wo.includeColumnGroupsHeaders ?? !0,
        escapeFormulas: wo.escapeFormulas ?? !0
      },
      ignoreValueFormatter: bo,
      apiRef: Kt
    });
  }, [ho, Kt, bo]), Po = React$1.useCallback((wo) => {
    ho.debug("Export data as CSV");
    const Eo = vo(wo), Ro = new Blob([wo != null && wo.utf8WithBom ? new Uint8Array([239, 187, 191]) : "", Eo], {
      type: "text/csv"
    });
    exportAs(Ro, "csv", wo == null ? void 0 : wo.fileName);
  }, [ho, vo]);
  useGridApiMethod(Kt, {
    getDataAsCsv: vo,
    exportDataAsCsv: Po
  }, "public");
  const So = React$1.useCallback((wo, Eo) => {
    var Ro;
    return (Ro = Eo.csvOptions) != null && Ro.disableToolbarButton ? wo : [...wo, {
      component: /* @__PURE__ */ jsxRuntimeExports.jsx(GridCsvExportMenuItem, {
        options: Eo.csvOptions
      }),
      componentName: "csvExport"
    }];
  }, []);
  useGridRegisterPipeProcessor(Kt, "exportMenu", So);
}, getDerivedPaginationModel = (Kt, uo, ho) => {
  let go = Kt.paginationModel;
  const bo = Kt.rowCount, vo = (ho == null ? void 0 : ho.pageSize) ?? go.pageSize, Po = (ho == null ? void 0 : ho.page) ?? go.page, Co = getPageCount(bo, vo, Po);
  ho && ((ho == null ? void 0 : ho.page) !== go.page || (ho == null ? void 0 : ho.pageSize) !== go.pageSize) && (go = ho);
  const So = getValidPage(go.page, Co);
  return So !== go.page && (go = _extends$q({}, go, {
    page: So
  })), throwIfPageSizeExceedsTheLimit(go.pageSize, uo), go;
}, useGridPaginationModel = (Kt, uo) => {
  var Ao, Oo;
  const ho = useGridLogger(Kt, "useGridPaginationModel"), go = useGridSelector(Kt, gridDensityFactorSelector), bo = Math.floor(uo.rowHeight * go);
  Kt.current.registerControlState({
    stateId: "paginationModel",
    propModel: uo.paginationModel,
    propOnChange: uo.onPaginationModelChange,
    stateSelector: gridPaginationModelSelector,
    changeEvent: "paginationModelChange"
  });
  const vo = React$1.useCallback((jo) => {
    const Do = gridPaginationModelSelector(Kt);
    jo !== Do.page && (ho.debug(`Setting page to ${jo}`), Kt.current.setPaginationModel({
      page: jo,
      pageSize: Do.pageSize
    }));
  }, [Kt, ho]), Po = React$1.useCallback((jo) => {
    const Do = gridPaginationModelSelector(Kt);
    jo !== Do.pageSize && (ho.debug(`Setting page size to ${jo}`), Kt.current.setPaginationModel({
      pageSize: jo,
      page: Do.page
    }));
  }, [Kt, ho]), Co = React$1.useCallback((jo) => {
    const Do = gridPaginationModelSelector(Kt);
    jo !== Do && (ho.debug("Setting 'paginationModel' to", jo), Kt.current.setState((Lo) => _extends$q({}, Lo, {
      pagination: _extends$q({}, Lo.pagination, {
        paginationModel: getDerivedPaginationModel(Lo.pagination, uo.signature, jo)
      })
    }), "setPaginationModel"));
  }, [Kt, ho, uo.signature]);
  useGridApiMethod(Kt, {
    setPage: vo,
    setPageSize: Po,
    setPaginationModel: Co
  }, "public");
  const wo = React$1.useCallback((jo, Do) => {
    var Ko, No;
    const Lo = gridPaginationModelSelector(Kt);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !Do.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
      uo.paginationModel != null || // Always export if the `paginationModel` has been initialized
      ((No = (Ko = uo.initialState) == null ? void 0 : Ko.pagination) == null ? void 0 : No.paginationModel) != null || // Export if `page` or `pageSize` is not equal to the default value
      Lo.page !== 0 && Lo.pageSize !== defaultPageSize(uo.autoPageSize) ? _extends$q({}, jo, {
        pagination: _extends$q({}, jo.pagination, {
          paginationModel: Lo
        })
      }) : jo
    );
  }, [Kt, uo.paginationModel, (Oo = (Ao = uo.initialState) == null ? void 0 : Ao.pagination) == null ? void 0 : Oo.paginationModel, uo.autoPageSize]), Eo = React$1.useCallback((jo, Do) => {
    var ko, Ko;
    const Lo = (ko = Do.stateToRestore.pagination) != null && ko.paginationModel ? _extends$q({}, getDefaultGridPaginationModel(uo.autoPageSize), (Ko = Do.stateToRestore.pagination) == null ? void 0 : Ko.paginationModel) : gridPaginationModelSelector(Kt);
    return Kt.current.setState((No) => _extends$q({}, No, {
      pagination: _extends$q({}, No.pagination, {
        paginationModel: getDerivedPaginationModel(No.pagination, uo.signature, Lo)
      })
    }), "stateRestorePreProcessing"), jo;
  }, [Kt, uo.autoPageSize, uo.signature]);
  useGridRegisterPipeProcessor(Kt, "exportState", wo), useGridRegisterPipeProcessor(Kt, "restoreState", Eo);
  const Ro = () => {
    var Do;
    const jo = gridPaginationModelSelector(Kt);
    (Do = Kt.current.virtualScrollerRef) != null && Do.current && Kt.current.scrollToIndexes({
      rowIndex: jo.page * jo.pageSize
    });
  }, _o = React$1.useCallback(() => {
    if (!uo.autoPageSize)
      return;
    const jo = Kt.current.getRootDimensions(), Do = Math.floor(jo.viewportInnerSize.height / bo);
    Kt.current.setPageSize(Do);
  }, [Kt, uo.autoPageSize, bo]), Io = React$1.useCallback((jo) => {
    if (jo == null)
      return;
    const Do = gridPaginationModelSelector(Kt), Lo = gridPageCountSelector(Kt);
    Do.page > Lo - 1 && Kt.current.setPage(Math.max(0, Lo - 1));
  }, [Kt]);
  useGridApiEventHandler(Kt, "viewportInnerSizeChange", _o), useGridApiEventHandler(Kt, "paginationModelChange", Ro), useGridApiEventHandler(Kt, "rowCountChange", Io), React$1.useEffect(() => {
    Kt.current.setState((jo) => _extends$q({}, jo, {
      pagination: _extends$q({}, jo.pagination, {
        paginationModel: getDerivedPaginationModel(jo.pagination, uo.signature, uo.paginationModel)
      })
    }));
  }, [Kt, uo.paginationModel, uo.paginationMode, uo.signature]), React$1.useEffect(_o, [_o]);
};
function raf() {
  return new Promise((Kt) => {
    requestAnimationFrame(() => {
      Kt();
    });
  });
}
function buildPrintWindow(Kt) {
  const uo = document.createElement("iframe");
  return uo.style.position = "absolute", uo.style.width = "0px", uo.style.height = "0px", uo.title = Kt || document.title, uo;
}
const useGridPrintExport = (Kt, uo) => {
  const ho = Kt.current.rootElementRef.current !== null, go = useGridLogger(Kt, "useGridPrintExport"), bo = React$1.useRef(null), vo = React$1.useRef(null), Po = React$1.useRef({}), Co = React$1.useRef([]), So = React$1.useRef();
  React$1.useEffect(() => {
    bo.current = ownerDocument(Kt.current.rootElementRef.current);
  }, [Kt, ho]);
  const wo = React$1.useCallback((jo, Do, Lo) => new Promise((ko) => {
    const Ko = getColumnsToExport({
      apiRef: Kt,
      options: {
        fields: jo,
        allColumns: Do
      }
    }).map((ti) => ti.field), No = gridColumnDefinitionsSelector(Kt), Jo = {};
    No.forEach((ti) => {
      Jo[ti.field] = Ko.includes(ti.field);
    }), Lo && (Jo[GRID_CHECKBOX_SELECTION_COL_DEF.field] = !0), Kt.current.setColumnVisibilityModel(Jo), ko();
  }), [Kt]), Eo = React$1.useCallback((jo) => {
    const Lo = jo({
      apiRef: Kt
    }).reduce((ko, Ko) => {
      const No = Kt.current.getRow(Ko);
      return No[GRID_ID_AUTOGENERATED] || ko.push(No), ko;
    }, []);
    Kt.current.setRows(Lo);
  }, [Kt]), Ro = React$1.useCallback((jo, Do) => {
    var ri, ni, si, li;
    const Lo = _extends$q({
      copyStyles: !0,
      hideToolbar: !1,
      hideFooter: !1,
      includeCheckboxes: !1
    }, Do), ko = jo.contentDocument;
    if (!ko)
      return;
    const Ko = gridRowsMetaSelector(Kt.current.state), No = Kt.current.rootElementRef.current, Jo = No.cloneNode(!0), ti = Jo.querySelector(`.${gridClasses.main}`);
    ti.style.overflow = "visible", Jo.style.contain = "size";
    let oi = ((ri = No.querySelector(`.${gridClasses.toolbarContainer}`)) == null ? void 0 : ri.offsetHeight) || 0, Qo = ((ni = No.querySelector(`.${gridClasses.footerContainer}`)) == null ? void 0 : ni.offsetHeight) || 0;
    Lo.hideToolbar && ((si = Jo.querySelector(`.${gridClasses.toolbarContainer}`)) == null || si.remove(), oi = 0), Lo.hideFooter && ((li = Jo.querySelector(`.${gridClasses.footerContainer}`)) == null || li.remove(), Qo = 0);
    const Zo = Ko.currentPageTotalHeight + getTotalHeaderHeight(Kt, uo) + oi + Qo;
    if (Jo.style.height = `${Zo}px`, Jo.style.boxSizing = "content-box", !Lo.hideFooter) {
      const ui = Jo.querySelector(`.${gridClasses.footerContainer}`);
      ui.style.position = "absolute", ui.style.width = "100%", ui.style.top = `${Zo - Qo}px`;
    }
    const ei = document.createElement("div");
    ei.appendChild(Jo), ko.body.style.marginTop = "0px", ko.body.innerHTML = ei.innerHTML;
    const ii = typeof Lo.pageStyle == "function" ? Lo.pageStyle() : Lo.pageStyle;
    if (typeof ii == "string") {
      const ui = ko.createElement("style");
      ui.appendChild(ko.createTextNode(ii)), ko.head.appendChild(ui);
    }
    Lo.bodyClassName && ko.body.classList.add(...Lo.bodyClassName.split(" "));
    const ai = [];
    if (Lo.copyStyles) {
      const ui = No.getRootNode(), fi = (ui.constructor.name === "ShadowRoot" ? ui : bo.current).querySelectorAll("style, link[rel='stylesheet']");
      for (let yi = 0; yi < fi.length; yi += 1) {
        const hi = fi[yi];
        if (hi.tagName === "STYLE") {
          const mi = ko.createElement(hi.tagName), bi = hi.sheet;
          if (bi) {
            let xi = "";
            for (let $i = 0; $i < bi.cssRules.length; $i += 1)
              typeof bi.cssRules[$i].cssText == "string" && (xi += `${bi.cssRules[$i].cssText}\r
`);
            mi.appendChild(ko.createTextNode(xi)), ko.head.appendChild(mi);
          }
        } else if (hi.getAttribute("href")) {
          const mi = ko.createElement(hi.tagName);
          for (let bi = 0; bi < hi.attributes.length; bi += 1) {
            const xi = hi.attributes[bi];
            xi && mi.setAttribute(xi.nodeName, xi.nodeValue || "");
          }
          ai.push(new Promise((bi) => {
            mi.addEventListener("load", () => bi());
          })), ko.head.appendChild(mi);
        }
      }
    }
    process.env.NODE_ENV !== "test" && Promise.all(ai).then(() => {
      jo.contentWindow.print();
    });
  }, [Kt, bo, uo]), _o = React$1.useCallback((jo) => {
    var Do, Lo;
    bo.current.body.removeChild(jo), Kt.current.restoreState(vo.current || {}), (Lo = (Do = vo.current) == null ? void 0 : Do.columns) != null && Lo.columnVisibilityModel || Kt.current.setColumnVisibilityModel(Po.current), Kt.current.setState((ko) => _extends$q({}, ko, {
      virtualization: So.current
    })), Kt.current.setRows(Co.current), vo.current = null, Po.current = {}, Co.current = [];
  }, [Kt]), Ao = {
    exportDataAsPrint: React$1.useCallback(async (jo) => {
      if (go.debug("Export data as Print"), !Kt.current.rootElementRef.current)
        throw new Error("MUI X: No grid root element available.");
      if (vo.current = Kt.current.exportState(), Po.current = gridColumnVisibilityModelSelector(Kt), Co.current = Kt.current.getSortedRows().filter((Lo) => !Lo[GRID_ID_AUTOGENERATED]), uo.pagination) {
        const ko = {
          page: 0,
          pageSize: gridExpandedRowCountSelector(Kt)
        };
        Kt.current.setState((Ko) => _extends$q({}, Ko, {
          pagination: _extends$q({}, Ko.pagination, {
            paginationModel: getDerivedPaginationModel(
              Ko.pagination,
              // Using signature `DataGridPro` to allow more than 100 rows in the print export
              "DataGridPro",
              ko
            )
          })
        }));
      }
      So.current = Kt.current.state.virtualization, Kt.current.setState((Lo) => _extends$q({}, Lo, {
        virtualization: _extends$q({}, Lo.virtualization, {
          enabled: !1,
          enabledForColumns: !1
        })
      })), await wo(jo == null ? void 0 : jo.fields, jo == null ? void 0 : jo.allColumns, jo == null ? void 0 : jo.includeCheckboxes), Eo((jo == null ? void 0 : jo.getRowsToExport) ?? defaultGetRowsToExport), await raf();
      const Do = buildPrintWindow(jo == null ? void 0 : jo.fileName);
      process.env.NODE_ENV === "test" ? (bo.current.body.appendChild(Do), Ro(Do, jo), _o(Do)) : (Do.onload = () => {
        Ro(Do, jo), Do.contentWindow.matchMedia("print").addEventListener("change", (ko) => {
          ko.matches === !1 && _o(Do);
        });
      }, bo.current.body.appendChild(Do));
    }, [uo, go, Kt, Ro, _o, wo, Eo])
  };
  useGridApiMethod(Kt, Ao, "public");
  const Oo = React$1.useCallback((jo, Do) => {
    var Lo;
    return (Lo = Do.printOptions) != null && Lo.disableToolbarButton ? jo : [...jo, {
      component: /* @__PURE__ */ jsxRuntimeExports.jsx(GridPrintExportMenuItem, {
        options: Do.printOptions
      }),
      componentName: "printExport"
    }];
  }, []);
  useGridRegisterPipeProcessor(Kt, "exportMenu", Oo);
}, filterStateInitializer = (Kt, uo, ho) => {
  var bo, vo;
  const go = uo.filterModel ?? ((vo = (bo = uo.initialState) == null ? void 0 : bo.filter) == null ? void 0 : vo.filterModel) ?? getDefaultGridFilterModel();
  return _extends$q({}, Kt, {
    filter: {
      filterModel: sanitizeFilterModel(go, uo.disableMultipleColumnsFiltering, ho),
      filteredRowsLookup: {},
      filteredChildrenCountLookup: {},
      filteredDescendantCountLookup: {}
    },
    visibleRowsLookup: {}
  });
}, getVisibleRowsLookup = (Kt) => Kt.filteredRowsLookup;
function getVisibleRowsLookupState(Kt, uo) {
  return Kt.current.applyStrategyProcessor("visibleRowsLookupCreation", {
    tree: uo.rows.tree,
    filteredRowsLookup: uo.filter.filteredRowsLookup
  });
}
function createMemoizedValues() {
  return lruMemoize(Object.values);
}
const useGridFilter = (Kt, uo) => {
  var Qo, Zo, ei;
  const ho = useGridLogger(Kt, "useGridFilter");
  Kt.current.registerControlState({
    stateId: "filter",
    propModel: uo.filterModel,
    propOnChange: uo.onFilterModelChange,
    stateSelector: gridFilterModelSelector,
    changeEvent: "filterModelChange"
  });
  const go = React$1.useCallback(() => {
    Kt.current.setState((ii) => {
      const ai = gridFilterModelSelector(ii, Kt.current.instanceId), ri = Kt.current.getFilterState(ai), ni = _extends$q({}, ii, {
        filter: _extends$q({}, ii.filter, ri)
      }), si = getVisibleRowsLookupState(Kt, ni);
      return _extends$q({}, ni, {
        visibleRowsLookup: si
      });
    }), Kt.current.publishEvent("filteredRowsSet");
  }, [Kt]), bo = React$1.useCallback((ii, ai) => ai == null || ai.filterable === !1 || uo.disableColumnFilter ? ii : [...ii, "columnMenuFilterItem"], [uo.disableColumnFilter]), vo = React$1.useCallback(() => {
    go(), Kt.current.forceUpdate();
  }, [Kt, go]), Po = React$1.useCallback((ii) => {
    const ai = gridFilterModelSelector(Kt), ri = [...ai.items], ni = ri.findIndex((si) => si.id === ii.id);
    ni === -1 ? ri.push(ii) : ri[ni] = ii, Kt.current.setFilterModel(_extends$q({}, ai, {
      items: ri
    }), "upsertFilterItem");
  }, [Kt]), Co = React$1.useCallback((ii) => {
    const ai = gridFilterModelSelector(Kt), ri = [...ai.items];
    ii.forEach((ni) => {
      const si = ri.findIndex((li) => li.id === ni.id);
      si === -1 ? ri.push(ni) : ri[si] = ni;
    }), Kt.current.setFilterModel(_extends$q({}, ai, {
      items: ri
    }), "upsertFilterItems");
  }, [Kt]), So = React$1.useCallback((ii) => {
    const ai = gridFilterModelSelector(Kt), ri = ai.items.filter((ni) => ni.id !== ii.id);
    ri.length !== ai.items.length && Kt.current.setFilterModel(_extends$q({}, ai, {
      items: ri
    }), "deleteFilterItem");
  }, [Kt]), wo = React$1.useCallback((ii, ai, ri) => {
    if (ho.debug("Displaying filter panel"), ii) {
      const ni = gridFilterModelSelector(Kt), si = ni.items.filter((fi) => {
        var bi;
        if (fi.value !== void 0)
          return !(Array.isArray(fi.value) && fi.value.length === 0);
        const hi = (bi = Kt.current.getColumn(fi.field).filterOperators) == null ? void 0 : bi.find((xi) => xi.value === fi.operator);
        return !(typeof (hi == null ? void 0 : hi.requiresFilterValue) > "u" ? !0 : hi == null ? void 0 : hi.requiresFilterValue);
      });
      let li;
      const ui = si.find((fi) => fi.field === ii), ci = Kt.current.getColumn(ii);
      ui ? li = si : uo.disableMultipleColumnsFiltering ? li = [cleanFilterItem({
        field: ii,
        operator: ci.filterOperators[0].value
      }, Kt)] : li = [...si, cleanFilterItem({
        field: ii,
        operator: ci.filterOperators[0].value
      }, Kt)], Kt.current.setFilterModel(_extends$q({}, ni, {
        items: li
      }));
    }
    Kt.current.showPreferences(GridPreferencePanelsValue.filters, ai, ri);
  }, [Kt, ho, uo.disableMultipleColumnsFiltering]), Eo = React$1.useCallback(() => {
    ho.debug("Hiding filter panel"), Kt.current.hidePreferences();
  }, [Kt, ho]), Ro = React$1.useCallback((ii) => {
    const ai = gridFilterModelSelector(Kt);
    ai.logicOperator !== ii && Kt.current.setFilterModel(_extends$q({}, ai, {
      logicOperator: ii
    }), "changeLogicOperator");
  }, [Kt]), _o = React$1.useCallback((ii) => {
    const ai = gridFilterModelSelector(Kt);
    isDeepEqual(ai.quickFilterValues, ii) || Kt.current.setFilterModel(_extends$q({}, ai, {
      quickFilterValues: [...ii]
    }));
  }, [Kt]), Io = React$1.useCallback((ii, ai) => {
    gridFilterModelSelector(Kt) !== ii && (ho.debug("Setting filter model"), Kt.current.updateControlState("filter", mergeStateWithFilterModel(ii, uo.disableMultipleColumnsFiltering, Kt), ai), Kt.current.unstable_applyFilters());
  }, [Kt, ho, uo.disableMultipleColumnsFiltering]), Ao = React$1.useCallback((ii) => {
    const ai = sanitizeFilterModel(ii, uo.disableMultipleColumnsFiltering, Kt), ri = uo.filterMode === "client" ? buildAggregatedFilterApplier(ai, Kt, uo.disableEval) : null, ni = Kt.current.applyStrategyProcessor("filtering", {
      isRowMatchingFilters: ri,
      filterModel: ai ?? getDefaultGridFilterModel()
    });
    return _extends$q({}, ni, {
      filterModel: ai
    });
  }, [uo.disableMultipleColumnsFiltering, uo.filterMode, uo.disableEval, Kt]), Oo = {
    setFilterLogicOperator: Ro,
    unstable_applyFilters: vo,
    deleteFilterItem: So,
    upsertFilterItem: Po,
    upsertFilterItems: Co,
    setFilterModel: Io,
    showFilterPanel: wo,
    hideFilterPanel: Eo,
    setQuickFilterValues: _o,
    ignoreDiacritics: uo.ignoreDiacritics,
    getFilterState: Ao
  };
  useGridApiMethod(Kt, Oo, "public");
  const jo = React$1.useCallback((ii, ai) => {
    var si, li;
    const ri = gridFilterModelSelector(Kt);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !ai.exportOnlyDirtyModels || // Always export if the model is controlled
      uo.filterModel != null || // Always export if the model has been initialized
      ((li = (si = uo.initialState) == null ? void 0 : si.filter) == null ? void 0 : li.filterModel) != null || // Export if the model is not equal to the default value
      !isDeepEqual(ri, getDefaultGridFilterModel()) ? _extends$q({}, ii, {
        filter: {
          filterModel: ri
        }
      }) : ii
    );
  }, [Kt, uo.filterModel, (Zo = (Qo = uo.initialState) == null ? void 0 : Qo.filter) == null ? void 0 : Zo.filterModel]), Do = React$1.useCallback((ii, ai) => {
    var ni;
    const ri = (ni = ai.stateToRestore.filter) == null ? void 0 : ni.filterModel;
    return ri == null ? ii : (Kt.current.updateControlState("filter", mergeStateWithFilterModel(ri, uo.disableMultipleColumnsFiltering, Kt), "restoreState"), _extends$q({}, ii, {
      callbacks: [...ii.callbacks, Kt.current.unstable_applyFilters]
    }));
  }, [Kt, uo.disableMultipleColumnsFiltering]), Lo = React$1.useCallback((ii, ai) => {
    var ri;
    if (ai === GridPreferencePanelsValue.filters) {
      const ni = uo.slots.filterPanel;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ni, _extends$q({}, (ri = uo.slotProps) == null ? void 0 : ri.filterPanel));
    }
    return ii;
  }, [uo.slots.filterPanel, (ei = uo.slotProps) == null ? void 0 : ei.filterPanel]), {
    getRowId: ko
  } = uo, Ko = useLazyRef(createMemoizedValues), No = React$1.useCallback((ii) => {
    if (uo.filterMode !== "client" || !ii.isRowMatchingFilters)
      return {
        filteredRowsLookup: {},
        filteredChildrenCountLookup: {},
        filteredDescendantCountLookup: {}
      };
    const ai = gridRowsLookupSelector(Kt), ri = {}, {
      isRowMatchingFilters: ni
    } = ii, si = {}, li = {
      passingFilterItems: null,
      passingQuickFilterValues: null
    }, ui = Ko.current(Kt.current.state.rows.dataRowIdToModelLookup);
    for (let yi = 0; yi < ui.length; yi += 1) {
      const hi = ui[yi], mi = ko ? ko(hi) : hi.id;
      ni(hi, void 0, li);
      const bi = passFilterLogic([li.passingFilterItems], [li.passingQuickFilterValues], ii.filterModel, Kt, si);
      ri[mi] = bi;
    }
    const ci = "auto-generated-group-footer-root";
    return ai[ci] && (ri[ci] = !0), {
      filteredRowsLookup: ri,
      filteredChildrenCountLookup: {},
      filteredDescendantCountLookup: {}
    };
  }, [Kt, uo.filterMode, ko, Ko]);
  useGridRegisterPipeProcessor(Kt, "columnMenu", bo), useGridRegisterPipeProcessor(Kt, "exportState", jo), useGridRegisterPipeProcessor(Kt, "restoreState", Do), useGridRegisterPipeProcessor(Kt, "preferencePanel", Lo), useGridRegisterStrategyProcessor(Kt, GRID_DEFAULT_STRATEGY, "filtering", No), useGridRegisterStrategyProcessor(Kt, GRID_DEFAULT_STRATEGY, "visibleRowsLookupCreation", getVisibleRowsLookup);
  const Jo = React$1.useCallback(() => {
    ho.debug("onColUpdated - GridColumns changed, applying filters");
    const ii = gridFilterModelSelector(Kt), ai = gridColumnLookupSelector(Kt), ri = ii.items.filter((ni) => ni.field && ai[ni.field]);
    ri.length < ii.items.length && Kt.current.setFilterModel(_extends$q({}, ii, {
      items: ri
    }));
  }, [Kt, ho]), ti = React$1.useCallback((ii) => {
    ii === "filtering" && Kt.current.unstable_applyFilters();
  }, [Kt]), oi = React$1.useCallback(() => {
    Kt.current.setState((ii) => _extends$q({}, ii, {
      visibleRowsLookup: getVisibleRowsLookupState(Kt, ii)
    })), Kt.current.forceUpdate();
  }, [Kt]);
  useGridApiEventHandler(Kt, "rowsSet", go), useGridApiEventHandler(Kt, "columnsChange", Jo), useGridApiEventHandler(Kt, "activeStrategyProcessorChange", ti), useGridApiEventHandler(Kt, "rowExpansionChange", oi), useGridApiEventHandler(Kt, "columnVisibilityModelChange", () => {
    const ii = gridFilterModelSelector(Kt);
    ii.quickFilterValues && shouldQuickFilterExcludeHiddenColumns(ii) && Kt.current.unstable_applyFilters();
  }), useFirstRender(() => {
    Kt.current.unstable_applyFilters();
  }), useEnhancedEffect(() => {
    uo.filterModel !== void 0 && Kt.current.setFilterModel(uo.filterModel);
  }, [Kt, ho, uo.filterModel]);
}, focusStateInitializer = (Kt) => _extends$q({}, Kt, {
  focus: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  },
  tabIndex: {
    cell: null,
    columnHeader: null,
    columnHeaderFilter: null,
    columnGroupHeader: null
  }
}), useGridFocus = (Kt, uo) => {
  const ho = useGridLogger(Kt, "useGridFocus"), go = React$1.useRef(null), bo = Kt.current.rootElementRef.current !== null, vo = React$1.useCallback((oi, Qo) => {
    oi && Kt.current.getRow(oi.id) && Kt.current.publishEvent("cellFocusOut", Kt.current.getCellParams(oi.id, oi.field), Qo);
  }, [Kt]), Po = React$1.useCallback((oi, Qo) => {
    const Zo = gridFocusCellSelector(Kt);
    (Zo == null ? void 0 : Zo.id) === oi && (Zo == null ? void 0 : Zo.field) === Qo || (Kt.current.setState((ei) => (ho.debug(`Focusing on cell with id=${oi} and field=${Qo}`), _extends$q({}, ei, {
      tabIndex: {
        cell: {
          id: oi,
          field: Qo
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      },
      focus: {
        cell: {
          id: oi,
          field: Qo
        },
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    }))), Kt.current.forceUpdate(), Kt.current.getRow(oi) && (Zo && vo(Zo, {}), Kt.current.publishEvent("cellFocusIn", Kt.current.getCellParams(oi, Qo))));
  }, [Kt, ho, vo]), Co = React$1.useCallback((oi, Qo = {}) => {
    const Zo = gridFocusCellSelector(Kt);
    vo(Zo, Qo), Kt.current.setState((ei) => (ho.debug(`Focusing on column header with colIndex=${oi}`), _extends$q({}, ei, {
      tabIndex: {
        columnHeader: {
          field: oi
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: {
          field: oi
        },
        columnHeaderFilter: null,
        cell: null,
        columnGroupHeader: null
      }
    }))), Kt.current.forceUpdate();
  }, [Kt, ho, vo]), So = React$1.useCallback((oi, Qo = {}) => {
    const Zo = gridFocusCellSelector(Kt);
    vo(Zo, Qo), Kt.current.setState((ei) => (ho.debug(`Focusing on column header filter with colIndex=${oi}`), _extends$q({}, ei, {
      tabIndex: {
        columnHeader: null,
        columnHeaderFilter: {
          field: oi
        },
        cell: null,
        columnGroupHeader: null
      },
      focus: {
        columnHeader: null,
        columnHeaderFilter: {
          field: oi
        },
        cell: null,
        columnGroupHeader: null
      }
    }))), Kt.current.forceUpdate();
  }, [Kt, ho, vo]), wo = React$1.useCallback((oi, Qo, Zo = {}) => {
    const ei = gridFocusCellSelector(Kt);
    ei && Kt.current.publishEvent("cellFocusOut", Kt.current.getCellParams(ei.id, ei.field), Zo), Kt.current.setState((ii) => _extends$q({}, ii, {
      tabIndex: {
        columnGroupHeader: {
          field: oi,
          depth: Qo
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      },
      focus: {
        columnGroupHeader: {
          field: oi,
          depth: Qo
        },
        columnHeader: null,
        columnHeaderFilter: null,
        cell: null
      }
    })), Kt.current.forceUpdate();
  }, [Kt]), Eo = React$1.useCallback(() => gridFocusColumnGroupHeaderSelector(Kt), [Kt]), Ro = React$1.useCallback((oi, Qo, Zo) => {
    let ei = Kt.current.getColumnIndex(Qo);
    const ii = gridVisibleColumnDefinitionsSelector(Kt), ai = getVisibleRows(Kt, {
      pagination: uo.pagination,
      paginationMode: uo.paginationMode
    }), ri = gridPinnedRowsSelector(Kt), ni = [].concat(ri.top || [], ai.rows, ri.bottom || []);
    let si = ni.findIndex((fi) => fi.id === oi);
    Zo === "right" ? ei += 1 : Zo === "left" ? ei -= 1 : si += 1, ei >= ii.length ? (si += 1, si < ni.length && (ei = 0)) : ei < 0 && (si -= 1, si >= 0 && (ei = ii.length - 1)), si = clamp$1(si, 0, ni.length - 1);
    const li = ni[si];
    if (!li)
      return;
    const ui = Kt.current.unstable_getCellColSpanInfo(li.id, ei);
    ui && ui.spannedByColSpan && (Zo === "left" || Zo === "below" ? ei = ui.leftVisibleCellIndex : Zo === "right" && (ei = ui.rightVisibleCellIndex)), ei = clamp$1(ei, 0, ii.length - 1);
    const ci = ii[ei];
    Kt.current.setCellFocus(li.id, ci.field);
  }, [Kt, uo.pagination, uo.paginationMode]), _o = React$1.useCallback(({
    id: oi,
    field: Qo
  }) => {
    Kt.current.setCellFocus(oi, Qo);
  }, [Kt]), Io = React$1.useCallback((oi, Qo) => {
    Qo.key === "Enter" || Qo.key === "Tab" || Qo.key === "Shift" || isNavigationKey(Qo.key) || Kt.current.setCellFocus(oi.id, oi.field);
  }, [Kt]), Ao = React$1.useCallback(({
    field: oi
  }, Qo) => {
    Qo.target === Qo.currentTarget && Kt.current.setColumnHeaderFocus(oi, Qo);
  }, [Kt]), Oo = React$1.useCallback(({
    fields: oi,
    depth: Qo
  }, Zo) => {
    if (Zo.target !== Zo.currentTarget)
      return;
    const ei = gridFocusColumnGroupHeaderSelector(Kt);
    ei !== null && ei.depth === Qo && oi.includes(ei.field) || Kt.current.setColumnGroupHeaderFocus(oi[0], Qo, Zo);
  }, [Kt]), jo = React$1.useCallback((oi, Qo) => {
    var Zo, ei;
    (ei = (Zo = Qo.relatedTarget) == null ? void 0 : Zo.getAttribute("class")) != null && ei.includes(gridClasses.columnHeader) || (ho.debug("Clearing focus"), Kt.current.setState((ii) => _extends$q({}, ii, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })));
  }, [ho, Kt]), Do = React$1.useCallback((oi) => {
    go.current = oi;
  }, []), Lo = React$1.useCallback((oi) => {
    const Qo = go.current;
    go.current = null;
    const Zo = gridFocusCellSelector(Kt);
    if (!Kt.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: oi,
      cell: Qo
    }))
      return;
    if (!Zo) {
      Qo && Kt.current.setCellFocus(Qo.id, Qo.field);
      return;
    }
    if ((Qo == null ? void 0 : Qo.id) === Zo.id && (Qo == null ? void 0 : Qo.field) === Zo.field)
      return;
    const ii = Kt.current.getCellElement(Zo.id, Zo.field);
    ii != null && ii.contains(oi.target) || (Qo ? Kt.current.setCellFocus(Qo.id, Qo.field) : (Kt.current.setState((ai) => _extends$q({}, ai, {
      focus: {
        cell: null,
        columnHeader: null,
        columnHeaderFilter: null,
        columnGroupHeader: null
      }
    })), Kt.current.forceUpdate(), vo(Zo, oi)));
  }, [Kt, vo]), ko = React$1.useCallback((oi) => {
    if (oi.cellMode === "view")
      return;
    const Qo = gridFocusCellSelector(Kt);
    ((Qo == null ? void 0 : Qo.id) !== oi.id || (Qo == null ? void 0 : Qo.field) !== oi.field) && Kt.current.setCellFocus(oi.id, oi.field);
  }, [Kt]), Ko = React$1.useCallback(() => {
    var Qo;
    const oi = gridFocusCellSelector(Kt);
    if (oi && !Kt.current.getRow(oi.id)) {
      const Zo = (Qo = gridFocusCellSelector(Kt)) == null ? void 0 : Qo.id;
      let ei = null;
      if (typeof Zo < "u") {
        const ii = Kt.current.getRowIndexRelativeToVisibleRows(Zo), ai = getVisibleRows(Kt, {
          pagination: uo.pagination,
          paginationMode: uo.paginationMode
        }), ri = ai.rows[clamp$1(ii, 0, ai.rows.length - 1)];
        ei = (ri == null ? void 0 : ri.id) ?? null;
      }
      Kt.current.setState((ii) => _extends$q({}, ii, {
        focus: {
          cell: ei === null ? null : {
            id: ei,
            field: oi.field
          },
          columnHeader: null,
          columnHeaderFilter: null,
          columnGroupHeader: null
        }
      }));
    }
  }, [Kt, uo.pagination, uo.paginationMode]), No = useEventCallback(() => {
    const oi = gridFocusCellSelector(Kt);
    if (!oi)
      return;
    const Qo = getVisibleRows(Kt, {
      pagination: uo.pagination,
      paginationMode: uo.paginationMode
    });
    if (Qo.rows.find((ii) => ii.id === oi.id))
      return;
    const ei = gridVisibleColumnDefinitionsSelector(Kt);
    Kt.current.setState((ii) => _extends$q({}, ii, {
      tabIndex: {
        cell: {
          id: Qo.rows[0].id,
          field: ei[0].field
        },
        columnGroupHeader: null,
        columnHeader: null,
        columnHeaderFilter: null
      }
    }));
  }), Jo = {
    setCellFocus: Po,
    setColumnHeaderFocus: Co,
    setColumnHeaderFilterFocus: So
  }, ti = {
    moveFocusToRelativeCell: Ro,
    setColumnGroupHeaderFocus: wo,
    getColumnGroupHeaderFocus: Eo
  };
  useGridApiMethod(Kt, Jo, "public"), useGridApiMethod(Kt, ti, "private"), React$1.useEffect(() => {
    const oi = ownerDocument(Kt.current.rootElementRef.current);
    return oi.addEventListener("mouseup", Lo), () => {
      oi.removeEventListener("mouseup", Lo);
    };
  }, [Kt, bo, Lo]), useGridApiEventHandler(Kt, "columnHeaderBlur", jo), useGridApiEventHandler(Kt, "cellDoubleClick", _o), useGridApiEventHandler(Kt, "cellMouseDown", Do), useGridApiEventHandler(Kt, "cellKeyDown", Io), useGridApiEventHandler(Kt, "cellModeChange", ko), useGridApiEventHandler(Kt, "columnHeaderFocus", Ao), useGridApiEventHandler(Kt, "columnGroupHeaderFocus", Oo), useGridApiEventHandler(Kt, "rowsSet", Ko), useGridApiEventHandler(Kt, "paginationModelChange", No);
}, getRowGroupingCriteriaFromGroupingField = (Kt) => {
  const uo = Kt.match(/^__row_group_by_columns_group_(.*)__$/);
  return uo ? uo[1] : null;
}, isGroupingColumn = (Kt) => Kt === GRID_ROW_GROUPING_SINGLE_GROUPING_FIELD || getRowGroupingCriteriaFromGroupingField(Kt) !== null;
function enrichPageRowsWithPinnedRows(Kt, uo) {
  const ho = gridPinnedRowsSelector(Kt) || {};
  return [...ho.top || [], ...uo, ...ho.bottom || []];
}
const getLeftColumnIndex = ({
  currentColIndex: Kt,
  firstColIndex: uo,
  lastColIndex: ho,
  isRtl: go
}) => {
  if (go) {
    if (Kt < ho)
      return Kt + 1;
  } else if (!go && Kt > uo)
    return Kt - 1;
  return null;
}, getRightColumnIndex = ({
  currentColIndex: Kt,
  firstColIndex: uo,
  lastColIndex: ho,
  isRtl: go
}) => {
  if (go) {
    if (Kt > uo)
      return Kt - 1;
  } else if (!go && Kt < ho)
    return Kt + 1;
  return null;
};
function findNonRowSpannedCell(Kt, uo, ho, go) {
  var Co, So;
  const bo = gridRowSpanningHiddenCellsSelector(Kt);
  if (!((Co = bo[uo]) != null && Co[ho]))
    return uo;
  const vo = gridFilteredSortedRowIdsSelector(Kt);
  let Po = vo.indexOf(uo) + (go === "down" ? 1 : -1);
  for (; Po >= 0 && Po < vo.length; ) {
    const wo = vo[Po];
    if (!((So = bo[wo]) != null && So[ho]))
      return wo;
    Po += go === "down" ? 1 : -1;
  }
  return uo;
}
const useGridKeyboardNavigation = (Kt, uo) => {
  const ho = useGridLogger(Kt, "useGridKeyboardNavigation"), go = useGridVisibleRows(Kt, uo).rows, bo = useRtl(), vo = uo.unstable_listView, Po = React$1.useMemo(() => enrichPageRowsWithPinnedRows(Kt, go), [Kt, go]), Co = uo.signature !== "DataGrid" && uo.headerFilters, So = React$1.useCallback((Lo, ko, Ko = "left", No = "up") => {
    const Jo = gridExpandedSortedRowEntriesSelector(Kt), ti = Kt.current.unstable_getCellColSpanInfo(ko, Lo);
    ti && ti.spannedByColSpan && (Ko === "left" ? Lo = ti.leftVisibleCellIndex : Ko === "right" && (Lo = ti.rightVisibleCellIndex));
    const oi = vo ? gridListColumnSelector(Kt.current.state).field : gridVisibleColumnFieldsSelector(Kt)[Lo], Qo = findNonRowSpannedCell(Kt, ko, oi, No), Zo = Jo.findIndex((ei) => ei.id === Qo);
    ho.debug(`Navigating to cell row ${Zo}, col ${Lo}`), Kt.current.scrollToIndexes({
      colIndex: Lo,
      rowIndex: Zo
    }), Kt.current.setCellFocus(Qo, oi);
  }, [Kt, ho, vo]), wo = React$1.useCallback((Lo, ko) => {
    ho.debug(`Navigating to header col ${Lo}`), Kt.current.scrollToIndexes({
      colIndex: Lo
    });
    const Ko = Kt.current.getVisibleColumns()[Lo].field;
    Kt.current.setColumnHeaderFocus(Ko, ko);
  }, [Kt, ho]), Eo = React$1.useCallback((Lo, ko) => {
    ho.debug(`Navigating to header filter col ${Lo}`), Kt.current.scrollToIndexes({
      colIndex: Lo
    });
    const Ko = Kt.current.getVisibleColumns()[Lo].field;
    Kt.current.setColumnHeaderFilterFocus(Ko, ko);
  }, [Kt, ho]), Ro = React$1.useCallback((Lo, ko, Ko) => {
    ho.debug(`Navigating to header col ${Lo}`), Kt.current.scrollToIndexes({
      colIndex: Lo
    });
    const {
      field: No
    } = Kt.current.getVisibleColumns()[Lo];
    Kt.current.setColumnGroupHeaderFocus(No, ko, Ko);
  }, [Kt, ho]), _o = React$1.useCallback((Lo) => {
    var ko;
    return (ko = Po[Lo]) == null ? void 0 : ko.id;
  }, [Po]), Io = React$1.useCallback((Lo, ko) => {
    const Ko = ko.currentTarget.querySelector(`.${gridClasses.columnHeaderTitleContainerContent}`);
    if (!!Ko && Ko.contains(ko.target) && Lo.field !== GRID_CHECKBOX_SELECTION_COL_DEF.field)
      return;
    const Jo = Kt.current.getViewportPageSize(), ti = Lo.field ? Kt.current.getColumnIndex(Lo.field) : 0, oi = Po.length > 0 ? 0 : null, Qo = Po.length - 1, Zo = 0, ei = gridVisibleColumnDefinitionsSelector(Kt).length - 1, ii = gridColumnGroupsHeaderMaxDepthSelector(Kt);
    let ai = !0;
    switch (ko.key) {
      case "ArrowDown": {
        oi !== null && (Co ? Eo(ti, ko) : So(ti, _o(oi)));
        break;
      }
      case "ArrowRight": {
        const ri = getRightColumnIndex({
          currentColIndex: ti,
          firstColIndex: Zo,
          lastColIndex: ei,
          isRtl: bo
        });
        ri !== null && wo(ri, ko);
        break;
      }
      case "ArrowLeft": {
        const ri = getLeftColumnIndex({
          currentColIndex: ti,
          firstColIndex: Zo,
          lastColIndex: ei,
          isRtl: bo
        });
        ri !== null && wo(ri, ko);
        break;
      }
      case "ArrowUp": {
        ii > 0 && Ro(ti, ii - 1, ko);
        break;
      }
      case "PageDown": {
        oi !== null && Qo !== null && So(ti, _o(Math.min(oi + Jo, Qo)));
        break;
      }
      case "Home": {
        wo(Zo, ko);
        break;
      }
      case "End": {
        wo(ei, ko);
        break;
      }
      case "Enter": {
        (ko.ctrlKey || ko.metaKey) && Kt.current.toggleColumnMenu(Lo.field);
        break;
      }
      case " ":
        break;
      default:
        ai = !1;
    }
    ai && ko.preventDefault();
  }, [Kt, Po.length, Co, Eo, So, _o, bo, wo, Ro]), Ao = React$1.useCallback((Lo, ko) => {
    const Ko = gridHeaderFilteringEditFieldSelector(Kt) === Lo.field, No = gridHeaderFilteringMenuSelector(Kt) === Lo.field;
    if (Ko || No || !isNavigationKey(ko.key))
      return;
    const Jo = Kt.current.getViewportPageSize(), ti = Lo.field ? Kt.current.getColumnIndex(Lo.field) : 0, oi = 0, Qo = Po.length - 1, Zo = 0, ei = gridVisibleColumnDefinitionsSelector(Kt).length - 1;
    let ii = !0;
    switch (ko.key) {
      case "ArrowDown": {
        const ai = _o(oi);
        ai != null && So(ti, ai);
        break;
      }
      case "ArrowRight": {
        const ai = getRightColumnIndex({
          currentColIndex: ti,
          firstColIndex: Zo,
          lastColIndex: ei,
          isRtl: bo
        });
        ai !== null && Eo(ai, ko);
        break;
      }
      case "ArrowLeft": {
        const ai = getLeftColumnIndex({
          currentColIndex: ti,
          firstColIndex: Zo,
          lastColIndex: ei,
          isRtl: bo
        });
        ai !== null ? Eo(ai, ko) : Kt.current.setColumnHeaderFilterFocus(Lo.field, ko);
        break;
      }
      case "ArrowUp": {
        wo(ti, ko);
        break;
      }
      case "PageDown": {
        Qo !== null && So(ti, _o(Math.min(oi + Jo, Qo)));
        break;
      }
      case "Home": {
        Eo(Zo, ko);
        break;
      }
      case "End": {
        Eo(ei, ko);
        break;
      }
      case " ":
        break;
      default:
        ii = !1;
    }
    ii && ko.preventDefault();
  }, [Kt, Po.length, Eo, bo, wo, So, _o]), Oo = React$1.useCallback((Lo, ko) => {
    const Ko = gridFocusColumnGroupHeaderSelector(Kt);
    if (Ko === null)
      return;
    const {
      field: No,
      depth: Jo
    } = Ko, {
      fields: ti,
      depth: oi,
      maxDepth: Qo
    } = Lo, Zo = Kt.current.getViewportPageSize(), ei = Kt.current.getColumnIndex(No), ii = No ? Kt.current.getColumnIndex(No) : 0, ai = 0, ri = Po.length - 1, ni = 0, si = gridVisibleColumnDefinitionsSelector(Kt).length - 1;
    let li = !0;
    switch (ko.key) {
      case "ArrowDown": {
        oi === Qo - 1 ? wo(ei, ko) : Ro(ei, Jo + 1, ko);
        break;
      }
      case "ArrowUp": {
        oi > 0 && Ro(ei, Jo - 1, ko);
        break;
      }
      case "ArrowRight": {
        const ui = ti.length - ti.indexOf(No) - 1;
        ei + ui + 1 <= si && Ro(ei + ui + 1, Jo, ko);
        break;
      }
      case "ArrowLeft": {
        const ui = ti.indexOf(No);
        ei - ui - 1 >= ni && Ro(ei - ui - 1, Jo, ko);
        break;
      }
      case "PageDown": {
        ri !== null && So(ii, _o(Math.min(ai + Zo, ri)));
        break;
      }
      case "Home": {
        Ro(ni, Jo, ko);
        break;
      }
      case "End": {
        Ro(si, Jo, ko);
        break;
      }
      case " ":
        break;
      default:
        li = !1;
    }
    li && ko.preventDefault();
  }, [Kt, Po.length, wo, Ro, So, _o]), jo = React$1.useCallback((Lo, ko) => {
    if (isEventTargetInPortal(ko))
      return;
    const Ko = Kt.current.getCellParams(Lo.id, Lo.field);
    if (Ko.cellMode === GridCellModes.Edit || !isNavigationKey(ko.key) || !Kt.current.unstable_applyPipeProcessors("canUpdateFocus", !0, {
      event: ko,
      cell: Ko
    }) || Po.length === 0)
      return;
    const Jo = Kt.current.getViewportPageSize(), ti = vo ? () => 0 : Kt.current.getColumnIndex, oi = Lo.field ? ti(Lo.field) : 0, Qo = Po.findIndex((si) => si.id === Lo.id), Zo = 0, ei = Po.length - 1, ii = 0, ri = (vo ? [gridListColumnSelector(Kt.current.state)] : gridVisibleColumnDefinitionsSelector(Kt)).length - 1;
    let ni = !0;
    switch (ko.key) {
      case "ArrowDown": {
        Qo < ei && So(oi, _o(Qo + 1), bo ? "right" : "left", "down");
        break;
      }
      case "ArrowUp": {
        Qo > Zo ? So(oi, _o(Qo - 1)) : Co ? Eo(oi, ko) : wo(oi, ko);
        break;
      }
      case "ArrowRight": {
        const si = getRightColumnIndex({
          currentColIndex: oi,
          firstColIndex: ii,
          lastColIndex: ri,
          isRtl: bo
        });
        si !== null && So(si, _o(Qo), bo ? "left" : "right");
        break;
      }
      case "ArrowLeft": {
        const si = getLeftColumnIndex({
          currentColIndex: oi,
          firstColIndex: ii,
          lastColIndex: ri,
          isRtl: bo
        });
        si !== null && So(si, _o(Qo), bo ? "right" : "left");
        break;
      }
      case "Tab": {
        ko.shiftKey && oi > ii ? So(oi - 1, _o(Qo), "left") : !ko.shiftKey && oi < ri && So(oi + 1, _o(Qo), "right");
        break;
      }
      case " ": {
        if (Lo.field === GRID_DETAIL_PANEL_TOGGLE_FIELD)
          break;
        const li = Lo.colDef;
        if (li && (li.field === GRID_TREE_DATA_GROUPING_FIELD || isGroupingColumn(li.field)))
          break;
        !ko.shiftKey && Qo < ei && So(oi, _o(Math.min(Qo + Jo, ei)));
        break;
      }
      case "PageDown": {
        Qo < ei && So(oi, _o(Math.min(Qo + Jo, ei)));
        break;
      }
      case "PageUp": {
        const si = Math.max(Qo - Jo, Zo);
        si !== Qo && si >= Zo ? So(oi, _o(si)) : wo(oi, ko);
        break;
      }
      case "Home": {
        ko.ctrlKey || ko.metaKey || ko.shiftKey ? So(ii, _o(Zo)) : So(ii, _o(Qo));
        break;
      }
      case "End": {
        ko.ctrlKey || ko.metaKey || ko.shiftKey ? So(ri, _o(ei)) : So(ri, _o(Qo));
        break;
      }
      default:
        ni = !1;
    }
    ni && ko.preventDefault();
  }, [Kt, Po, bo, So, _o, Co, Eo, wo, vo]), Do = React$1.useCallback((Lo, {
    event: ko
  }) => ko.key === " " ? !1 : Lo, []);
  useGridRegisterPipeProcessor(Kt, "canStartEditing", Do), useGridApiEventHandler(Kt, "columnHeaderKeyDown", Io), useGridApiEventHandler(Kt, "headerFilterKeyDown", Ao), useGridApiEventHandler(Kt, "columnGroupHeaderKeyDown", Oo), useGridApiEventHandler(Kt, "cellKeyDown", jo);
}, useGridRowCount = (Kt, uo) => {
  var Ao, Oo;
  const ho = useGridLogger(Kt, "useGridRowCount"), go = useGridSelector(Kt, gridFilteredTopLevelRowCountSelector), bo = useGridSelector(Kt, gridPaginationRowCountSelector), vo = useGridSelector(Kt, gridPaginationMetaSelector), Po = useGridSelector(Kt, gridPaginationModelSelector), Co = useLazyRef(() => gridPaginationModelSelector(Kt).pageSize);
  Kt.current.registerControlState({
    stateId: "paginationRowCount",
    propModel: uo.rowCount,
    propOnChange: uo.onRowCountChange,
    stateSelector: gridPaginationRowCountSelector,
    changeEvent: "rowCountChange"
  });
  const wo = {
    setRowCount: React$1.useCallback((jo) => {
      bo !== jo && (ho.debug("Setting 'rowCount' to", jo), Kt.current.setState((Do) => _extends$q({}, Do, {
        pagination: _extends$q({}, Do.pagination, {
          rowCount: jo
        })
      })));
    }, [Kt, ho, bo])
  };
  useGridApiMethod(Kt, wo, "public");
  const Eo = React$1.useCallback((jo, Do) => {
    var Ko, No;
    const Lo = gridPaginationRowCountSelector(Kt);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !Do.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
      uo.rowCount != null || // Always export if the `rowCount` has been initialized
      ((No = (Ko = uo.initialState) == null ? void 0 : Ko.pagination) == null ? void 0 : No.rowCount) != null ? _extends$q({}, jo, {
        pagination: _extends$q({}, jo.pagination, {
          rowCount: Lo
        })
      }) : jo
    );
  }, [Kt, uo.rowCount, (Oo = (Ao = uo.initialState) == null ? void 0 : Ao.pagination) == null ? void 0 : Oo.rowCount]), Ro = React$1.useCallback((jo, Do) => {
    var ko;
    const Lo = (ko = Do.stateToRestore.pagination) != null && ko.rowCount ? Do.stateToRestore.pagination.rowCount : gridPaginationRowCountSelector(Kt);
    return Kt.current.setState((Ko) => _extends$q({}, Ko, {
      pagination: _extends$q({}, Ko.pagination, {
        rowCount: Lo
      })
    })), jo;
  }, [Kt]);
  useGridRegisterPipeProcessor(Kt, "exportState", Eo), useGridRegisterPipeProcessor(Kt, "restoreState", Ro);
  const _o = React$1.useCallback((jo) => {
    uo.paginationMode === "client" || !Co.current || jo.pageSize !== Co.current && (Co.current = jo.pageSize, bo === -1 && Kt.current.setPage(0));
  }, [uo.paginationMode, Co, bo, Kt]);
  useGridApiEventHandler(Kt, "paginationModelChange", _o), React$1.useEffect(() => {
    uo.paginationMode === "client" ? Kt.current.setRowCount(go) : uo.rowCount != null && Kt.current.setRowCount(uo.rowCount);
  }, [Kt, uo.paginationMode, go, uo.rowCount]);
  const Io = vo.hasNextPage === !1;
  React$1.useEffect(() => {
    Io && bo === -1 && Kt.current.setRowCount(Po.pageSize * Po.page + go);
  }, [Kt, go, Io, bo, Po]);
}, useGridPaginationMeta = (Kt, uo) => {
  var So, wo;
  const ho = useGridLogger(Kt, "useGridPaginationMeta"), go = useGridSelector(Kt, gridPaginationMetaSelector);
  Kt.current.registerControlState({
    stateId: "paginationMeta",
    propModel: uo.paginationMeta,
    propOnChange: uo.onPaginationMetaChange,
    stateSelector: gridPaginationMetaSelector,
    changeEvent: "paginationMetaChange"
  });
  const vo = {
    setPaginationMeta: React$1.useCallback((Eo) => {
      go !== Eo && (ho.debug("Setting 'paginationMeta' to", Eo), Kt.current.setState((Ro) => _extends$q({}, Ro, {
        pagination: _extends$q({}, Ro.pagination, {
          meta: Eo
        })
      })));
    }, [Kt, ho, go])
  };
  useGridApiMethod(Kt, vo, "public");
  const Po = React$1.useCallback((Eo, Ro) => {
    var Ao, Oo;
    const _o = gridPaginationMetaSelector(Kt);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !Ro.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
      uo.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
      ((Oo = (Ao = uo.initialState) == null ? void 0 : Ao.pagination) == null ? void 0 : Oo.meta) != null ? _extends$q({}, Eo, {
        pagination: _extends$q({}, Eo.pagination, {
          meta: _o
        })
      }) : Eo
    );
  }, [Kt, uo.paginationMeta, (wo = (So = uo.initialState) == null ? void 0 : So.pagination) == null ? void 0 : wo.meta]), Co = React$1.useCallback((Eo, Ro) => {
    var Io;
    const _o = (Io = Ro.stateToRestore.pagination) != null && Io.meta ? Ro.stateToRestore.pagination.meta : gridPaginationMetaSelector(Kt);
    return Kt.current.setState((Ao) => _extends$q({}, Ao, {
      pagination: _extends$q({}, Ao.pagination, {
        meta: _o
      })
    })), Eo;
  }, [Kt]);
  useGridRegisterPipeProcessor(Kt, "exportState", Po), useGridRegisterPipeProcessor(Kt, "restoreState", Co), React$1.useEffect(() => {
    uo.paginationMeta && Kt.current.setPaginationMeta(uo.paginationMeta);
  }, [Kt, uo.paginationMeta]);
}, paginationStateInitializer = (Kt, uo) => {
  var vo, Po, Co, So, wo, Eo;
  const ho = _extends$q({}, getDefaultGridPaginationModel(uo.autoPageSize), uo.paginationModel ?? ((Po = (vo = uo.initialState) == null ? void 0 : vo.pagination) == null ? void 0 : Po.paginationModel));
  throwIfPageSizeExceedsTheLimit(ho.pageSize, uo.signature);
  const go = uo.rowCount ?? ((So = (Co = uo.initialState) == null ? void 0 : Co.pagination) == null ? void 0 : So.rowCount), bo = uo.paginationMeta ?? ((Eo = (wo = uo.initialState) == null ? void 0 : wo.pagination) == null ? void 0 : Eo.meta) ?? {};
  return _extends$q({}, Kt, {
    pagination: {
      paginationModel: ho,
      rowCount: go,
      meta: bo
    }
  });
}, useGridPagination = (Kt, uo) => {
  useGridPaginationMeta(Kt, uo), useGridPaginationModel(Kt, uo), useGridRowCount(Kt, uo);
}, preferencePanelStateInitializer = (Kt, uo) => {
  var ho;
  return _extends$q({}, Kt, {
    preferencePanel: ((ho = uo.initialState) == null ? void 0 : ho.preferencePanel) ?? {
      open: !1
    }
  });
}, useGridPreferencesPanel = (Kt, uo) => {
  var Ro;
  const ho = useGridLogger(Kt, "useGridPreferencesPanel"), go = React$1.useRef(), bo = React$1.useRef(), vo = React$1.useCallback(() => {
    ho.debug("Hiding Preferences Panel");
    const _o = gridPreferencePanelStateSelector(Kt.current.state);
    _o.openedPanelValue && Kt.current.publishEvent("preferencePanelClose", {
      openedPanelValue: _o.openedPanelValue
    }), Kt.current.setState((Io) => _extends$q({}, Io, {
      preferencePanel: {
        open: !1
      }
    })), Kt.current.forceUpdate();
  }, [Kt, ho]), Po = React$1.useCallback(() => {
    bo.current = setTimeout(() => clearTimeout(go.current), 0);
  }, []), Co = React$1.useCallback(() => {
    go.current = setTimeout(vo, 100);
  }, [vo]), So = React$1.useCallback((_o, Io, Ao) => {
    ho.debug("Opening Preferences Panel"), Po(), Kt.current.setState((Oo) => _extends$q({}, Oo, {
      preferencePanel: _extends$q({}, Oo.preferencePanel, {
        open: !0,
        openedPanelValue: _o,
        panelId: Io,
        labelId: Ao
      })
    })), Kt.current.publishEvent("preferencePanelOpen", {
      openedPanelValue: _o
    }), Kt.current.forceUpdate();
  }, [ho, Po, Kt]);
  useGridApiMethod(Kt, {
    showPreferences: So,
    hidePreferences: Co
  }, "public");
  const wo = React$1.useCallback((_o, Io) => {
    var jo;
    const Ao = gridPreferencePanelStateSelector(Kt.current.state);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !Io.exportOnlyDirtyModels || // Always export if the panel was initialized
      ((jo = uo.initialState) == null ? void 0 : jo.preferencePanel) != null || // Always export if the panel is opened
      Ao.open ? _extends$q({}, _o, {
        preferencePanel: Ao
      }) : _o
    );
  }, [Kt, (Ro = uo.initialState) == null ? void 0 : Ro.preferencePanel]), Eo = React$1.useCallback((_o, Io) => {
    const Ao = Io.stateToRestore.preferencePanel;
    return Ao != null && Kt.current.setState((Oo) => _extends$q({}, Oo, {
      preferencePanel: Ao
    })), _o;
  }, [Kt]);
  useGridRegisterPipeProcessor(Kt, "exportState", wo), useGridRegisterPipeProcessor(Kt, "restoreState", Eo), React$1.useEffect(() => () => {
    clearTimeout(go.current), clearTimeout(bo.current);
  }, []);
}, getDefaultCellValue = (Kt) => {
  switch (Kt.type) {
    case "boolean":
      return !1;
    case "date":
    case "dateTime":
    case "number":
      return;
    case "singleSelect":
      return null;
    case "string":
    default:
      return "";
  }
}, _excluded$n = ["id", "field"], _excluded2$7 = ["id", "field"], useGridCellEditing = (Kt, uo) => {
  const [ho, go] = React$1.useState({}), bo = React$1.useRef(ho), vo = React$1.useRef({}), {
    processRowUpdate: Po,
    onProcessRowUpdateError: Co,
    cellModesModel: So,
    onCellModesModelChange: wo
  } = uo, Eo = (ni) => (...si) => {
    uo.editMode === GridEditModes.Cell && ni(...si);
  }, Ro = React$1.useCallback((ni, si) => {
    const li = Kt.current.getCellParams(ni, si);
    if (!Kt.current.isCellEditable(li))
      throw new Error(`MUI X: The cell with id=${ni} and field=${si} is not editable.`);
  }, [Kt]), _o = React$1.useCallback((ni, si, li) => {
    if (Kt.current.getCellMode(ni, si) !== li)
      throw new Error(`MUI X: The cell with id=${ni} and field=${si} is not in ${li} mode.`);
  }, [Kt]), Io = React$1.useCallback((ni, si) => {
    if (!ni.isEditable || ni.cellMode === GridCellModes.Edit)
      return;
    const li = _extends$q({}, ni, {
      reason: GridCellEditStartReasons.cellDoubleClick
    });
    Kt.current.publishEvent("cellEditStart", li, si);
  }, [Kt]), Ao = React$1.useCallback((ni, si) => {
    if (ni.cellMode === GridCellModes.View || Kt.current.getCellMode(ni.id, ni.field) === GridCellModes.View)
      return;
    const li = _extends$q({}, ni, {
      reason: GridCellEditStopReasons.cellFocusOut
    });
    Kt.current.publishEvent("cellEditStop", li, si);
  }, [Kt]), Oo = React$1.useCallback((ni, si) => {
    if (ni.cellMode === GridCellModes.Edit) {
      if (si.which === 229)
        return;
      let li;
      if (si.key === "Escape" ? li = GridCellEditStopReasons.escapeKeyDown : si.key === "Enter" ? li = GridCellEditStopReasons.enterKeyDown : si.key === "Tab" && (li = si.shiftKey ? GridCellEditStopReasons.shiftTabKeyDown : GridCellEditStopReasons.tabKeyDown, si.preventDefault()), li) {
        const ui = _extends$q({}, ni, {
          reason: li
        });
        Kt.current.publishEvent("cellEditStop", ui, si);
      }
    } else if (ni.isEditable) {
      let li;
      if (!Kt.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: si,
        cellParams: ni,
        editMode: "cell"
      }))
        return;
      if (isPrintableKey(si) ? li = GridCellEditStartReasons.printableKeyDown : isPasteShortcut(si) ? li = GridCellEditStartReasons.pasteKeyDown : si.key === "Enter" ? li = GridCellEditStartReasons.enterKeyDown : (si.key === "Backspace" || si.key === "Delete") && (li = GridCellEditStartReasons.deleteKeyDown), li) {
        const ci = _extends$q({}, ni, {
          reason: li,
          key: si.key
        });
        Kt.current.publishEvent("cellEditStart", ci, si);
      }
    }
  }, [Kt]), jo = React$1.useCallback((ni) => {
    const {
      id: si,
      field: li,
      reason: ui
    } = ni, ci = {
      id: si,
      field: li
    };
    (ui === GridCellEditStartReasons.printableKeyDown || ui === GridCellEditStartReasons.deleteKeyDown || ui === GridCellEditStartReasons.pasteKeyDown) && (ci.deleteValue = !0), Kt.current.startCellEditMode(ci);
  }, [Kt]), Do = React$1.useCallback((ni) => {
    const {
      id: si,
      field: li,
      reason: ui
    } = ni;
    Kt.current.runPendingEditCellValueMutation(si, li);
    let ci;
    ui === GridCellEditStopReasons.enterKeyDown ? ci = "below" : ui === GridCellEditStopReasons.tabKeyDown ? ci = "right" : ui === GridCellEditStopReasons.shiftTabKeyDown && (ci = "left");
    const fi = ui === "escapeKeyDown";
    Kt.current.stopCellEditMode({
      id: si,
      field: li,
      ignoreModifications: fi,
      cellToFocusAfter: ci
    });
  }, [Kt]), Lo = (ni) => async (...si) => {
    var li;
    if (ni) {
      const {
        id: ui,
        field: ci
      } = si[0];
      ((li = Kt.current.state.editRows[ui][ci]) == null ? void 0 : li.error) || ni(...si);
    }
  };
  useGridApiEventHandler(Kt, "cellDoubleClick", Eo(Io)), useGridApiEventHandler(Kt, "cellFocusOut", Eo(Ao)), useGridApiEventHandler(Kt, "cellKeyDown", Eo(Oo)), useGridApiEventHandler(Kt, "cellEditStart", Eo(jo)), useGridApiEventHandler(Kt, "cellEditStop", Eo(Do)), useGridApiOptionHandler(Kt, "cellEditStart", uo.onCellEditStart), useGridApiOptionHandler(Kt, "cellEditStop", Lo(uo.onCellEditStop));
  const ko = React$1.useCallback((ni, si) => {
    const li = gridEditRowsStateSelector(Kt.current.state);
    return li[ni] && li[ni][si] ? GridCellModes.Edit : GridCellModes.View;
  }, [Kt]), Ko = useEventCallback((ni) => {
    const si = ni !== uo.cellModesModel;
    wo && si && wo(ni, {
      api: Kt.current
    }), !(uo.cellModesModel && si) && (go(ni), bo.current = ni, Kt.current.publishEvent("cellModesModelChange", ni));
  }), No = React$1.useCallback((ni, si, li) => {
    const ui = _extends$q({}, bo.current);
    if (li !== null)
      ui[ni] = _extends$q({}, ui[ni], {
        [si]: _extends$q({}, li)
      });
    else {
      const ci = ui[ni], fi = _objectWithoutPropertiesLoose$h(ci, [si].map(toPropertyKey));
      ui[ni] = fi, Object.keys(ui[ni]).length === 0 && delete ui[ni];
    }
    Ko(ui);
  }, [Ko]), Jo = React$1.useCallback((ni, si, li) => {
    Kt.current.setState((ui) => {
      const ci = _extends$q({}, ui.editRows);
      return li !== null ? ci[ni] = _extends$q({}, ci[ni], {
        [si]: _extends$q({}, li)
      }) : (delete ci[ni][si], Object.keys(ci[ni]).length === 0 && delete ci[ni]), _extends$q({}, ui, {
        editRows: ci
      });
    }), Kt.current.forceUpdate();
  }, [Kt]), ti = React$1.useCallback((ni) => {
    const {
      id: si,
      field: li
    } = ni, ui = _objectWithoutPropertiesLoose$h(ni, _excluded$n);
    Ro(si, li), _o(si, li, GridCellModes.View), No(si, li, _extends$q({
      mode: GridCellModes.Edit
    }, ui));
  }, [Ro, _o, No]), oi = useEventCallback(async (ni) => {
    const {
      id: si,
      field: li,
      deleteValue: ui,
      initialValue: ci
    } = ni, fi = Kt.current.getCellValue(si, li);
    let yi = fi;
    ui ? yi = getDefaultCellValue(Kt.current.getColumn(li)) : ci && (yi = ci);
    const hi = Kt.current.getColumn(li), mi = !!hi.preProcessEditCellProps && ui;
    let bi = {
      value: yi,
      error: !1,
      isProcessingProps: mi
    };
    if (Jo(si, li, bi), Kt.current.setCellFocus(si, li), mi && (bi = await Promise.resolve(hi.preProcessEditCellProps({
      id: si,
      row: Kt.current.getRow(si),
      props: bi,
      hasChanged: yi !== fi
    })), Kt.current.getCellMode(si, li) === GridCellModes.Edit)) {
      const xi = gridEditRowsStateSelector(Kt.current.state);
      Jo(si, li, _extends$q({}, bi, {
        value: xi[si][li].value,
        isProcessingProps: !1
      }));
    }
  }), Qo = React$1.useCallback((ni) => {
    const {
      id: si,
      field: li
    } = ni, ui = _objectWithoutPropertiesLoose$h(ni, _excluded2$7);
    _o(si, li, GridCellModes.Edit), No(si, li, _extends$q({
      mode: GridCellModes.View
    }, ui));
  }, [_o, No]), Zo = useEventCallback(async (ni) => {
    const {
      id: si,
      field: li,
      ignoreModifications: ui,
      cellToFocusAfter: ci = "none"
    } = ni;
    _o(si, li, GridCellModes.Edit), Kt.current.runPendingEditCellValueMutation(si, li);
    const fi = () => {
      Jo(si, li, null), No(si, li, null), ci !== "none" && Kt.current.moveFocusToRelativeCell(si, li, ci);
    };
    if (ui) {
      fi();
      return;
    }
    const yi = gridEditRowsStateSelector(Kt.current.state), {
      error: hi,
      isProcessingProps: mi
    } = yi[si][li];
    if (hi || mi) {
      vo.current[si][li].mode = GridCellModes.Edit, No(si, li, {
        mode: GridCellModes.Edit
      });
      return;
    }
    const bi = Kt.current.getRowWithUpdatedValuesFromCellEditing(si, li);
    if (Po) {
      const xi = ($i) => {
        vo.current[si][li].mode = GridCellModes.Edit, No(si, li, {
          mode: GridCellModes.Edit
        }), Co ? Co($i) : process.env.NODE_ENV !== "production" && warnOnce(["MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."], "error");
      };
      try {
        const $i = Kt.current.getRow(si);
        Promise.resolve(Po(bi, $i, {
          rowId: si
        })).then((Ci) => {
          Kt.current.updateRows([Ci]), fi();
        }).catch(xi);
      } catch ($i) {
        xi($i);
      }
    } else
      Kt.current.updateRows([bi]), fi();
  }), ei = React$1.useCallback(async (ni) => {
    var $i, Ci;
    const {
      id: si,
      field: li,
      value: ui,
      debounceMs: ci,
      unstable_skipValueParser: fi
    } = ni;
    Ro(si, li), _o(si, li, GridCellModes.Edit);
    const yi = Kt.current.getColumn(li), hi = Kt.current.getRow(si);
    let mi = ui;
    yi.valueParser && !fi && (mi = yi.valueParser(ui, hi, yi, Kt));
    let bi = gridEditRowsStateSelector(Kt.current.state), xi = _extends$q({}, bi[si][li], {
      value: mi,
      changeReason: ci ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    if (yi.preProcessEditCellProps) {
      const Si = ui !== bi[si][li].value;
      xi = _extends$q({}, xi, {
        isProcessingProps: !0
      }), Jo(si, li, xi), xi = await Promise.resolve(yi.preProcessEditCellProps({
        id: si,
        row: hi,
        props: xi,
        hasChanged: Si
      }));
    }
    return Kt.current.getCellMode(si, li) === GridCellModes.View ? !1 : (bi = gridEditRowsStateSelector(Kt.current.state), xi = _extends$q({}, xi, {
      isProcessingProps: !1
    }), xi.value = yi.preProcessEditCellProps ? bi[si][li].value : mi, Jo(si, li, xi), bi = gridEditRowsStateSelector(Kt.current.state), !((Ci = ($i = bi[si]) == null ? void 0 : $i[li]) != null && Ci.error));
  }, [Kt, Ro, _o, Jo]), ii = React$1.useCallback((ni, si) => {
    const li = Kt.current.getColumn(si), ui = gridEditRowsStateSelector(Kt.current.state), ci = Kt.current.getRow(ni);
    if (!ui[ni] || !ui[ni][si])
      return Kt.current.getRow(ni);
    const {
      value: fi
    } = ui[ni][si];
    return li.valueSetter ? li.valueSetter(fi, ci, li, Kt) : _extends$q({}, ci, {
      [si]: fi
    });
  }, [Kt]), ai = {
    getCellMode: ko,
    startCellEditMode: ti,
    stopCellEditMode: Qo
  }, ri = {
    setCellEditingEditCellValue: ei,
    getRowWithUpdatedValuesFromCellEditing: ii
  };
  useGridApiMethod(Kt, ai, "public"), useGridApiMethod(Kt, ri, "private"), React$1.useEffect(() => {
    So && Ko(So);
  }, [So, Ko]), useEnhancedEffect(() => {
    const ni = gridRowsDataRowIdToIdLookupSelector(Kt), si = vo.current;
    vo.current = deepClone(ho), Object.entries(ho).forEach(([li, ui]) => {
      Object.entries(ui).forEach(([ci, fi]) => {
        var mi, bi;
        const yi = ((bi = (mi = si[li]) == null ? void 0 : mi[ci]) == null ? void 0 : bi.mode) || GridCellModes.View, hi = ni[li] ?? li;
        fi.mode === GridCellModes.Edit && yi === GridCellModes.View ? oi(_extends$q({
          id: hi,
          field: ci
        }, fi)) : fi.mode === GridCellModes.View && yi === GridCellModes.Edit && Zo(_extends$q({
          id: hi,
          field: ci
        }, fi));
      });
    });
  }, [Kt, ho, oi, Zo]);
}, _excluded$m = ["id"], _excluded2$6 = ["id"], useGridRowEditing = (Kt, uo) => {
  const [ho, go] = React$1.useState({}), bo = React$1.useRef(ho), vo = React$1.useRef({}), Po = React$1.useRef(), Co = React$1.useRef(null), {
    processRowUpdate: So,
    onProcessRowUpdateError: wo,
    rowModesModel: Eo,
    onRowModesModelChange: Ro
  } = uo, _o = (ci) => (...fi) => {
    uo.editMode === GridEditModes.Row && ci(...fi);
  }, Io = React$1.useCallback((ci, fi) => {
    const yi = Kt.current.getCellParams(ci, fi);
    if (!Kt.current.isCellEditable(yi))
      throw new Error(`MUI X: The cell with id=${ci} and field=${fi} is not editable.`);
  }, [Kt]), Ao = React$1.useCallback((ci, fi) => {
    if (Kt.current.getRowMode(ci) !== fi)
      throw new Error(`MUI X: The row with id=${ci} is not in ${fi} mode.`);
  }, [Kt]), Oo = React$1.useCallback((ci) => {
    const fi = gridEditRowsStateSelector(Kt.current.state);
    return Object.values(fi[ci]).some((yi) => yi.error);
  }, [Kt]), jo = React$1.useCallback((ci, fi) => {
    if (!ci.isEditable || Kt.current.getRowMode(ci.id) === GridRowModes.Edit)
      return;
    const yi = Kt.current.getRowParams(ci.id), hi = _extends$q({}, yi, {
      field: ci.field,
      reason: GridRowEditStartReasons.cellDoubleClick
    });
    Kt.current.publishEvent("rowEditStart", hi, fi);
  }, [Kt]), Do = React$1.useCallback((ci) => {
    Co.current = ci;
  }, []), Lo = React$1.useCallback((ci, fi) => {
    ci.isEditable && Kt.current.getRowMode(ci.id) !== GridRowModes.View && (Co.current = null, Po.current = setTimeout(() => {
      var yi;
      if (((yi = Co.current) == null ? void 0 : yi.id) !== ci.id) {
        if (!Kt.current.getRow(ci.id) || Kt.current.getRowMode(ci.id) === GridRowModes.View || Oo(ci.id))
          return;
        const hi = Kt.current.getRowParams(ci.id), mi = _extends$q({}, hi, {
          field: ci.field,
          reason: GridRowEditStopReasons.rowFocusOut
        });
        Kt.current.publishEvent("rowEditStop", mi, fi);
      }
    }));
  }, [Kt, Oo]);
  React$1.useEffect(() => () => {
    clearTimeout(Po.current);
  }, []);
  const ko = React$1.useCallback((ci, fi) => {
    if (ci.cellMode === GridRowModes.Edit) {
      if (fi.which === 229)
        return;
      let yi;
      if (fi.key === "Escape")
        yi = GridRowEditStopReasons.escapeKeyDown;
      else if (fi.key === "Enter")
        yi = GridRowEditStopReasons.enterKeyDown;
      else if (fi.key === "Tab") {
        const hi = gridVisibleColumnFieldsSelector(Kt).filter((mi) => Kt.current.getColumn(mi).type === GRID_ACTIONS_COLUMN_TYPE ? !0 : Kt.current.isCellEditable(Kt.current.getCellParams(ci.id, mi)));
        if (fi.shiftKey ? ci.field === hi[0] && (yi = GridRowEditStopReasons.shiftTabKeyDown) : ci.field === hi[hi.length - 1] && (yi = GridRowEditStopReasons.tabKeyDown), fi.preventDefault(), !yi) {
          const mi = hi.findIndex((xi) => xi === ci.field), bi = hi[fi.shiftKey ? mi - 1 : mi + 1];
          Kt.current.setCellFocus(ci.id, bi);
        }
      }
      if (yi) {
        if (yi !== GridRowEditStopReasons.escapeKeyDown && Oo(ci.id))
          return;
        const hi = _extends$q({}, Kt.current.getRowParams(ci.id), {
          reason: yi,
          field: ci.field
        });
        Kt.current.publishEvent("rowEditStop", hi, fi);
      }
    } else if (ci.isEditable) {
      let yi;
      if (!Kt.current.unstable_applyPipeProcessors("canStartEditing", !0, {
        event: fi,
        cellParams: ci,
        editMode: "row"
      }))
        return;
      if (isPrintableKey(fi) || isPasteShortcut(fi) ? yi = GridRowEditStartReasons.printableKeyDown : fi.key === "Enter" ? yi = GridRowEditStartReasons.enterKeyDown : (fi.key === "Backspace" || fi.key === "Delete") && (yi = GridRowEditStartReasons.deleteKeyDown), yi) {
        const mi = Kt.current.getRowParams(ci.id), bi = _extends$q({}, mi, {
          field: ci.field,
          reason: yi
        });
        Kt.current.publishEvent("rowEditStart", bi, fi);
      }
    }
  }, [Kt, Oo]), Ko = React$1.useCallback((ci) => {
    const {
      id: fi,
      field: yi,
      reason: hi
    } = ci, mi = {
      id: fi,
      fieldToFocus: yi
    };
    (hi === GridRowEditStartReasons.printableKeyDown || hi === GridRowEditStartReasons.deleteKeyDown) && (mi.deleteValue = !!yi), Kt.current.startRowEditMode(mi);
  }, [Kt]), No = React$1.useCallback((ci) => {
    const {
      id: fi,
      reason: yi,
      field: hi
    } = ci;
    Kt.current.runPendingEditCellValueMutation(fi);
    let mi;
    yi === GridRowEditStopReasons.enterKeyDown ? mi = "below" : yi === GridRowEditStopReasons.tabKeyDown ? mi = "right" : yi === GridRowEditStopReasons.shiftTabKeyDown && (mi = "left");
    const bi = yi === "escapeKeyDown";
    Kt.current.stopRowEditMode({
      id: fi,
      ignoreModifications: bi,
      field: hi,
      cellToFocusAfter: mi
    });
  }, [Kt]);
  useGridApiEventHandler(Kt, "cellDoubleClick", _o(jo)), useGridApiEventHandler(Kt, "cellFocusIn", _o(Do)), useGridApiEventHandler(Kt, "cellFocusOut", _o(Lo)), useGridApiEventHandler(Kt, "cellKeyDown", _o(ko)), useGridApiEventHandler(Kt, "rowEditStart", _o(Ko)), useGridApiEventHandler(Kt, "rowEditStop", _o(No)), useGridApiOptionHandler(Kt, "rowEditStart", uo.onRowEditStart), useGridApiOptionHandler(Kt, "rowEditStop", uo.onRowEditStop);
  const Jo = React$1.useCallback((ci) => {
    if (uo.editMode === GridEditModes.Cell)
      return GridRowModes.View;
    const fi = gridEditRowsStateSelector(Kt.current.state);
    return fi[ci] && Object.keys(fi[ci]).length > 0 ? GridRowModes.Edit : GridRowModes.View;
  }, [Kt, uo.editMode]), ti = useEventCallback((ci) => {
    const fi = ci !== uo.rowModesModel;
    Ro && fi && Ro(ci, {
      api: Kt.current
    }), !(uo.rowModesModel && fi) && (go(ci), bo.current = ci, Kt.current.publishEvent("rowModesModelChange", ci));
  }), oi = React$1.useCallback((ci, fi) => {
    const yi = _extends$q({}, bo.current);
    fi !== null ? yi[ci] = _extends$q({}, fi) : delete yi[ci], ti(yi);
  }, [ti]), Qo = React$1.useCallback((ci, fi) => {
    Kt.current.setState((yi) => {
      const hi = _extends$q({}, yi.editRows);
      return fi !== null ? hi[ci] = fi : delete hi[ci], _extends$q({}, yi, {
        editRows: hi
      });
    }), Kt.current.forceUpdate();
  }, [Kt]), Zo = React$1.useCallback((ci, fi, yi) => {
    Kt.current.setState((hi) => {
      const mi = _extends$q({}, hi.editRows);
      return yi !== null ? mi[ci] = _extends$q({}, mi[ci], {
        [fi]: _extends$q({}, yi)
      }) : (delete mi[ci][fi], Object.keys(mi[ci]).length === 0 && delete mi[ci]), _extends$q({}, hi, {
        editRows: mi
      });
    }), Kt.current.forceUpdate();
  }, [Kt]), ei = React$1.useCallback((ci) => {
    const {
      id: fi
    } = ci, yi = _objectWithoutPropertiesLoose$h(ci, _excluded$m);
    Ao(fi, GridRowModes.View), oi(fi, _extends$q({
      mode: GridRowModes.Edit
    }, yi));
  }, [Ao, oi]), ii = useEventCallback((ci) => {
    const {
      id: fi,
      fieldToFocus: yi,
      deleteValue: hi,
      initialValue: mi
    } = ci, bi = gridColumnFieldsSelector(Kt), xi = bi.reduce(($i, Ci) => {
      if (!Kt.current.getCellParams(fi, Ci).isEditable)
        return $i;
      const vi = Kt.current.getColumn(Ci);
      let Pi = Kt.current.getCellValue(fi, Ci);
      return yi === Ci && (hi || mi) && (hi ? Pi = getDefaultCellValue(vi) : mi && (Pi = mi)), $i[Ci] = {
        value: Pi,
        error: !1,
        isProcessingProps: !!vi.preProcessEditCellProps && hi
      }, $i;
    }, {});
    Qo(fi, xi), yi && Kt.current.setCellFocus(fi, yi), bi.filter(($i) => !!Kt.current.getColumn($i).preProcessEditCellProps && hi).forEach(($i) => {
      const Ci = Kt.current.getColumn($i), Si = Kt.current.getCellValue(fi, $i), vi = hi ? getDefaultCellValue(Ci) : mi ?? Si;
      Promise.resolve(Ci.preProcessEditCellProps({
        id: fi,
        row: Kt.current.getRow(fi),
        props: xi[$i],
        hasChanged: vi !== Si
      })).then((Pi) => {
        if (Kt.current.getRowMode(fi) === GridRowModes.Edit) {
          const wi = gridEditRowsStateSelector(Kt.current.state);
          Zo(fi, $i, _extends$q({}, Pi, {
            value: wi[fi][$i].value,
            isProcessingProps: !1
          }));
        }
      });
    });
  }), ai = React$1.useCallback((ci) => {
    const {
      id: fi
    } = ci, yi = _objectWithoutPropertiesLoose$h(ci, _excluded2$6);
    Ao(fi, GridRowModes.Edit), oi(fi, _extends$q({
      mode: GridRowModes.View
    }, yi));
  }, [Ao, oi]), ri = useEventCallback((ci) => {
    const {
      id: fi,
      ignoreModifications: yi,
      field: hi,
      cellToFocusAfter: mi = "none"
    } = ci;
    Kt.current.runPendingEditCellValueMutation(fi);
    const bi = () => {
      mi !== "none" && hi && Kt.current.moveFocusToRelativeCell(fi, hi, mi), Qo(fi, null), oi(fi, null);
    };
    if (yi) {
      bi();
      return;
    }
    const xi = gridEditRowsStateSelector(Kt.current.state), $i = Kt.current.getRow(fi);
    if (Object.values(xi[fi]).some((vi) => vi.isProcessingProps)) {
      vo.current[fi].mode = GridRowModes.Edit;
      return;
    }
    if (Oo(fi)) {
      vo.current[fi].mode = GridRowModes.Edit, oi(fi, {
        mode: GridRowModes.Edit
      });
      return;
    }
    const Si = Kt.current.getRowWithUpdatedValuesFromRowEditing(fi);
    if (So) {
      const vi = (Pi) => {
        vo.current[fi].mode = GridRowModes.Edit, oi(fi, {
          mode: GridRowModes.Edit
        }), wo ? wo(Pi) : process.env.NODE_ENV !== "production" && warnOnce(["MUI X: A call to `processRowUpdate` threw an error which was not handled because `onProcessRowUpdateError` is missing.", "To handle the error pass a callback to the `onProcessRowUpdateError` prop, for example `<DataGrid onProcessRowUpdateError={(error) => ...} />`.", "For more detail, see https://mui.com/x/react-data-grid/editing/#server-side-persistence."], "error");
      };
      try {
        Promise.resolve(So(Si, $i, {
          rowId: fi
        })).then((Pi) => {
          Kt.current.updateRows([Pi]), bi();
        }).catch(vi);
      } catch (Pi) {
        vi(Pi);
      }
    } else
      Kt.current.updateRows([Si]), bi();
  }), ni = React$1.useCallback((ci) => {
    const {
      id: fi,
      field: yi,
      value: hi,
      debounceMs: mi,
      unstable_skipValueParser: bi
    } = ci;
    Io(fi, yi);
    const xi = Kt.current.getColumn(yi), $i = Kt.current.getRow(fi);
    let Ci = hi;
    xi.valueParser && !bi && (Ci = xi.valueParser(hi, $i, xi, Kt));
    let Si = gridEditRowsStateSelector(Kt.current.state), vi = _extends$q({}, Si[fi][yi], {
      value: Ci,
      changeReason: mi ? "debouncedSetEditCellValue" : "setEditCellValue"
    });
    return xi.preProcessEditCellProps || Zo(fi, yi, vi), new Promise((Pi) => {
      const wi = [];
      if (xi.preProcessEditCellProps) {
        const gi = vi.value !== Si[fi][yi].value;
        vi = _extends$q({}, vi, {
          isProcessingProps: !0
        }), Zo(fi, yi, vi);
        const Ri = Si[fi], Ei = _objectWithoutPropertiesLoose$h(Ri, [yi].map(toPropertyKey)), Ni = Promise.resolve(xi.preProcessEditCellProps({
          id: fi,
          row: $i,
          props: vi,
          hasChanged: gi,
          otherFieldsProps: Ei
        })).then((Ai) => {
          if (Kt.current.getRowMode(fi) === GridRowModes.View) {
            Pi(!1);
            return;
          }
          Si = gridEditRowsStateSelector(Kt.current.state), Ai = _extends$q({}, Ai, {
            isProcessingProps: !1
          }), Ai.value = xi.preProcessEditCellProps ? Si[fi][yi].value : Ci, Zo(fi, yi, Ai);
        });
        wi.push(Ni);
      }
      Object.entries(Si[fi]).forEach(([gi, Ri]) => {
        if (gi === yi)
          return;
        const Ei = Kt.current.getColumn(gi);
        if (!Ei.preProcessEditCellProps)
          return;
        Ri = _extends$q({}, Ri, {
          isProcessingProps: !0
        }), Zo(fi, gi, Ri), Si = gridEditRowsStateSelector(Kt.current.state);
        const Ni = Si[fi], Ai = _objectWithoutPropertiesLoose$h(Ni, [gi].map(toPropertyKey)), Yi = Promise.resolve(Ei.preProcessEditCellProps({
          id: fi,
          row: $i,
          props: Ri,
          hasChanged: !1,
          otherFieldsProps: Ai
        })).then((Ui) => {
          if (Kt.current.getRowMode(fi) === GridRowModes.View) {
            Pi(!1);
            return;
          }
          Ui = _extends$q({}, Ui, {
            isProcessingProps: !1
          }), Zo(fi, gi, Ui);
        });
        wi.push(Yi);
      }), Promise.all(wi).then(() => {
        Kt.current.getRowMode(fi) === GridRowModes.Edit ? (Si = gridEditRowsStateSelector(Kt.current.state), Pi(!Si[fi][yi].error)) : Pi(!1);
      });
    });
  }, [Kt, Io, Zo]), si = React$1.useCallback((ci) => {
    const fi = gridEditRowsStateSelector(Kt.current.state), yi = Kt.current.getRow(ci);
    if (!fi[ci])
      return Kt.current.getRow(ci);
    let hi = _extends$q({}, yi);
    return Object.entries(fi[ci]).forEach(([mi, bi]) => {
      const xi = Kt.current.getColumn(mi);
      xi.valueSetter ? hi = xi.valueSetter(bi.value, hi, xi, Kt) : hi[mi] = bi.value;
    }), hi;
  }, [Kt]), li = {
    getRowMode: Jo,
    startRowEditMode: ei,
    stopRowEditMode: ai
  }, ui = {
    setRowEditingEditCellValue: ni,
    getRowWithUpdatedValuesFromRowEditing: si
  };
  useGridApiMethod(Kt, li, "public"), useGridApiMethod(Kt, ui, "private"), React$1.useEffect(() => {
    Eo && ti(Eo);
  }, [Eo, ti]), useEnhancedEffect(() => {
    const ci = gridRowsDataRowIdToIdLookupSelector(Kt), fi = vo.current;
    vo.current = deepClone(ho);
    const yi = /* @__PURE__ */ new Set([...Object.keys(ho), ...Object.keys(fi)]);
    Array.from(yi).forEach((hi) => {
      var $i;
      const mi = ho[hi] ?? {
        mode: GridRowModes.View
      }, bi = (($i = fi[hi]) == null ? void 0 : $i.mode) || GridRowModes.View, xi = ci[hi] ?? hi;
      mi.mode === GridRowModes.Edit && bi === GridRowModes.View ? ii(_extends$q({
        id: xi
      }, mi)) : mi.mode === GridRowModes.View && bi === GridRowModes.Edit && ri(_extends$q({
        id: xi
      }, mi));
    });
  }, [Kt, ho, ii, ri]);
}, editingStateInitializer = (Kt) => _extends$q({}, Kt, {
  editRows: {}
}), useGridEditing = (Kt, uo) => {
  useGridCellEditing(Kt, uo), useGridRowEditing(Kt, uo);
  const ho = React$1.useRef({}), {
    isCellEditable: go
  } = uo, bo = React$1.useCallback((_o) => isAutogeneratedRowNode(_o.rowNode) || !_o.colDef.editable || !_o.colDef.renderEditCell ? !1 : go ? go(_o) : !0, [go]), vo = (_o, Io, Ao, Oo) => {
    if (!Ao) {
      Oo();
      return;
    }
    if (ho.current[_o] || (ho.current[_o] = {}), ho.current[_o][Io]) {
      const [Lo] = ho.current[_o][Io];
      clearTimeout(Lo);
    }
    const jo = () => {
      const [Lo] = ho.current[_o][Io];
      clearTimeout(Lo), Oo(), delete ho.current[_o][Io];
    }, Do = setTimeout(() => {
      Oo(), delete ho.current[_o][Io];
    }, Ao);
    ho.current[_o][Io] = [Do, jo];
  };
  React$1.useEffect(() => {
    const _o = ho.current;
    return () => {
      Object.entries(_o).forEach(([Io, Ao]) => {
        Object.keys(Ao).forEach((Oo) => {
          const [jo] = _o[Io][Oo];
          clearTimeout(jo), delete _o[Io][Oo];
        });
      });
    };
  }, []);
  const Po = React$1.useCallback((_o, Io) => {
    if (ho.current[_o]) {
      if (!Io)
        Object.keys(ho.current[_o]).forEach((Ao) => {
          const [, Oo] = ho.current[_o][Ao];
          Oo();
        });
      else if (ho.current[_o][Io]) {
        const [, Ao] = ho.current[_o][Io];
        Ao();
      }
    }
  }, []), Co = React$1.useCallback((_o) => {
    const {
      id: Io,
      field: Ao,
      debounceMs: Oo
    } = _o;
    return new Promise((jo) => {
      vo(Io, Ao, Oo, async () => {
        const Do = uo.editMode === GridEditModes.Row ? Kt.current.setRowEditingEditCellValue : Kt.current.setCellEditingEditCellValue;
        if (Kt.current.getCellMode(Io, Ao) === GridCellModes.Edit) {
          const Lo = await Do(_o);
          jo(Lo);
        }
      });
    });
  }, [Kt, uo.editMode]), So = React$1.useCallback((_o, Io) => uo.editMode === GridEditModes.Cell ? Kt.current.getRowWithUpdatedValuesFromCellEditing(_o, Io) : Kt.current.getRowWithUpdatedValuesFromRowEditing(_o), [Kt, uo.editMode]), wo = React$1.useCallback((_o, Io) => {
    var Oo;
    return ((Oo = gridEditRowsStateSelector(Kt.current.state)[_o]) == null ? void 0 : Oo[Io]) ?? null;
  }, [Kt]), Eo = {
    isCellEditable: bo,
    setEditCellValue: Co,
    getRowWithUpdatedValues: So,
    unstable_getEditCellMeta: wo
  }, Ro = {
    runPendingEditCellValueMutation: Po
  };
  useGridApiMethod(Kt, Eo, "public"), useGridApiMethod(Kt, Ro, "private");
}, rowsStateInitializer = (Kt, uo, ho) => {
  const go = !!uo.unstable_dataSource;
  return ho.current.caches.rows = createRowsInternalCache({
    rows: go ? [] : uo.rows,
    getRowId: uo.getRowId,
    loading: uo.loading,
    rowCount: uo.rowCount
  }), _extends$q({}, Kt, {
    rows: getRowsStateFromCache({
      apiRef: ho,
      rowCountProp: uo.rowCount,
      loadingProp: go ? !0 : uo.loading,
      previousTree: null,
      previousTreeDepths: null
    })
  });
}, useGridRows = (Kt, uo) => {
  if (process.env.NODE_ENV !== "production")
    try {
      Object.freeze(uo.rows);
    } catch {
    }
  const ho = useGridLogger(Kt, "useGridRows"), go = useGridVisibleRows(Kt, uo), bo = React$1.useRef(Date.now()), vo = React$1.useRef(uo.rowCount), Po = useTimeout(), Co = React$1.useCallback((ui) => {
    const ci = gridRowsLookupSelector(Kt)[ui];
    if (ci)
      return ci;
    const fi = Kt.current.getRowNode(ui);
    return fi && isAutogeneratedRowNode(fi) ? {
      [GRID_ID_AUTOGENERATED]: ui
    } : null;
  }, [Kt]), So = uo.getRowId, wo = React$1.useCallback((ui) => GRID_ID_AUTOGENERATED in ui ? ui[GRID_ID_AUTOGENERATED] : So ? So(ui) : ui.id, [So]), Eo = React$1.useMemo(() => go.rows.reduce((ui, {
    id: ci
  }, fi) => (ui[ci] = fi, ui), {}), [go.rows]), Ro = React$1.useCallback(({
    cache: ui,
    throttle: ci
  }) => {
    const fi = () => {
      bo.current = Date.now(), Kt.current.setState((hi) => _extends$q({}, hi, {
        rows: getRowsStateFromCache({
          apiRef: Kt,
          rowCountProp: uo.rowCount,
          loadingProp: uo.loading,
          previousTree: gridRowTreeSelector(Kt),
          previousTreeDepths: gridRowTreeDepthsSelector(Kt),
          previousGroupsToFetch: gridRowGroupsToFetchSelector(Kt)
        })
      })), Kt.current.publishEvent("rowsSet"), Kt.current.forceUpdate();
    };
    if (Po.clear(), Kt.current.caches.rows = ui, !ci) {
      fi();
      return;
    }
    const yi = uo.throttleRowsMs - (Date.now() - bo.current);
    if (yi > 0) {
      Po.start(yi, fi);
      return;
    }
    fi();
  }, [uo.throttleRowsMs, uo.rowCount, uo.loading, Kt, Po]), _o = React$1.useCallback((ui) => {
    ho.debug(`Updating all rows, new length ${ui.length}`);
    const ci = createRowsInternalCache({
      rows: ui,
      getRowId: uo.getRowId,
      loading: uo.loading,
      rowCount: uo.rowCount
    }), fi = Kt.current.caches.rows;
    ci.rowsBeforePartialUpdates = fi.rowsBeforePartialUpdates, Ro({
      cache: ci,
      throttle: !0
    });
  }, [ho, uo.getRowId, uo.loading, uo.rowCount, Ro, Kt]), Io = React$1.useCallback((ui) => {
    if (uo.signature === GridSignature.DataGrid && ui.length > 1)
      throw new Error(["MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    const ci = computeRowsUpdates(Kt, ui, uo.getRowId), fi = updateCacheWithNewRows({
      updates: ci,
      getRowId: uo.getRowId,
      previousCache: Kt.current.caches.rows
    });
    Ro({
      cache: fi,
      throttle: !0
    });
  }, [uo.signature, uo.getRowId, Ro, Kt]), Ao = React$1.useCallback((ui, ci) => {
    const fi = computeRowsUpdates(Kt, ui, uo.getRowId), yi = updateCacheWithNewRows({
      updates: fi,
      getRowId: uo.getRowId,
      previousCache: Kt.current.caches.rows,
      groupKeys: ci ?? []
    });
    Ro({
      cache: yi,
      throttle: !1
    });
  }, [uo.getRowId, Ro, Kt]), Oo = React$1.useCallback((ui) => {
    ui !== uo.loading && (ho.debug(`Setting loading to ${ui}`), Kt.current.setState((ci) => _extends$q({}, ci, {
      rows: _extends$q({}, ci.rows, {
        loading: ui
      })
    })), Kt.current.caches.rows.loadingPropBeforePartialUpdates = ui);
  }, [uo.loading, Kt, ho]), jo = React$1.useCallback(() => {
    const ui = gridDataRowIdsSelector(Kt), ci = gridRowsLookupSelector(Kt);
    return new Map(ui.map((fi) => [fi, ci[fi] ?? {}]));
  }, [Kt]), Do = React$1.useCallback(() => gridRowCountSelector(Kt), [Kt]), Lo = React$1.useCallback(() => gridDataRowIdsSelector(Kt), [Kt]), ko = React$1.useCallback((ui) => Eo[ui], [Eo]), Ko = React$1.useCallback((ui, ci) => {
    const fi = Kt.current.getRowNode(ui);
    if (!fi)
      throw new Error(`MUI X: No row with id #${ui} found.`);
    if (fi.type !== "group")
      throw new Error("MUI X: Only group nodes can be expanded or collapsed.");
    const yi = _extends$q({}, fi, {
      childrenExpanded: ci
    });
    Kt.current.setState((hi) => _extends$q({}, hi, {
      rows: _extends$q({}, hi.rows, {
        tree: _extends$q({}, hi.rows.tree, {
          [ui]: yi
        })
      })
    })), Kt.current.forceUpdate(), Kt.current.publishEvent("rowExpansionChange", yi);
  }, [Kt]), No = React$1.useCallback((ui) => gridRowTreeSelector(Kt)[ui] ?? null, [Kt]), Jo = React$1.useCallback(({
    skipAutoGeneratedRows: ui = !0,
    groupId: ci,
    applySorting: fi,
    applyFiltering: yi
  }) => {
    const hi = gridRowTreeSelector(Kt);
    let mi;
    if (fi) {
      const bi = hi[ci];
      if (!bi)
        return [];
      const xi = gridSortedRowIdsSelector(Kt);
      mi = [];
      const $i = xi.findIndex((Ci) => Ci === ci) + 1;
      for (let Ci = $i; Ci < xi.length && hi[xi[Ci]].depth > bi.depth; Ci += 1) {
        const Si = xi[Ci];
        (!ui || !isAutogeneratedRowNode(hi[Si])) && mi.push(Si);
      }
    } else
      mi = getTreeNodeDescendants(hi, ci, ui);
    if (yi) {
      const bi = gridFilteredRowsLookupSelector(Kt);
      mi = mi.filter((xi) => bi[xi] !== !1);
    }
    return mi;
  }, [Kt]), ti = React$1.useCallback((ui, ci) => {
    const fi = Kt.current.getRowNode(ui);
    if (!fi)
      throw new Error(`MUI X: No row with id #${ui} found.`);
    if (fi.parent !== GRID_ROOT_GROUP_ID)
      throw new Error("MUI X: The row reordering do not support reordering of grouped rows yet.");
    if (fi.type !== "leaf")
      throw new Error("MUI X: The row reordering do not support reordering of footer or grouping rows.");
    Kt.current.setState((yi) => {
      const hi = gridRowTreeSelector(yi, Kt.current.instanceId)[GRID_ROOT_GROUP_ID], mi = hi.children, bi = mi.findIndex(($i) => $i === ui);
      if (bi === -1 || bi === ci)
        return yi;
      ho.debug(`Moving row ${ui} to index ${ci}`);
      const xi = [...mi];
      return xi.splice(ci, 0, xi.splice(bi, 1)[0]), _extends$q({}, yi, {
        rows: _extends$q({}, yi.rows, {
          tree: _extends$q({}, yi.rows.tree, {
            [GRID_ROOT_GROUP_ID]: _extends$q({}, hi, {
              children: xi
            })
          })
        })
      });
    }), Kt.current.publishEvent("rowsSet");
  }, [Kt, ho]), oi = React$1.useCallback((ui, ci) => {
    if (uo.signature === GridSignature.DataGrid && ci.length > 1)
      throw new Error(["MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`));
    if (ci.length === 0)
      return;
    if (gridRowMaximumTreeDepthSelector(Kt) > 1)
      throw new Error("`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping");
    const yi = _extends$q({}, gridRowTreeSelector(Kt)), hi = _extends$q({}, gridRowsLookupSelector(Kt)), mi = _extends$q({}, gridRowsDataRowIdToIdLookupSelector(Kt)), bi = yi[GRID_ROOT_GROUP_ID], xi = [...bi.children], $i = /* @__PURE__ */ new Set();
    for (let Si = 0; Si < ci.length; Si += 1) {
      const vi = ci[Si], Pi = getRowIdFromRowModel(vi, uo.getRowId, "A row was provided without id when calling replaceRows()."), [wi] = xi.splice(ui + Si, 1, Pi);
      $i.has(wi) || (delete hi[wi], delete mi[wi], delete yi[wi]);
      const gi = {
        id: Pi,
        depth: 0,
        parent: GRID_ROOT_GROUP_ID,
        type: "leaf",
        groupingKey: null
      };
      hi[Pi] = vi, mi[Pi] = Pi, yi[Pi] = gi, $i.add(Pi);
    }
    yi[GRID_ROOT_GROUP_ID] = _extends$q({}, bi, {
      children: xi
    });
    const Ci = xi.filter((Si) => {
      var vi;
      return ((vi = yi[Si]) == null ? void 0 : vi.type) === "leaf";
    });
    Kt.current.caches.rows.dataRowIdToModelLookup = hi, Kt.current.caches.rows.dataRowIdToIdLookup = mi, Kt.current.setState((Si) => _extends$q({}, Si, {
      rows: _extends$q({}, Si.rows, {
        dataRowIdToModelLookup: hi,
        dataRowIdToIdLookup: mi,
        dataRowIds: Ci,
        tree: yi
      })
    })), Kt.current.publishEvent("rowsSet");
  }, [Kt, uo.signature, uo.getRowId]), Qo = {
    getRow: Co,
    setLoading: Oo,
    getRowId: wo,
    getRowModels: jo,
    getRowsCount: Do,
    getAllRowIds: Lo,
    setRows: _o,
    updateRows: Io,
    getRowNode: No,
    getRowIndexRelativeToVisibleRows: ko,
    unstable_replaceRows: oi
  }, Zo = {
    setRowIndex: ti,
    setRowChildrenExpansion: Ko,
    getRowGroupChildren: Jo
  }, ei = {
    updateServerRows: Ao
  }, ii = React$1.useCallback(() => {
    ho.info("Row grouping pre-processing have changed, regenerating the row tree");
    let ui;
    Kt.current.caches.rows.rowsBeforePartialUpdates === uo.rows ? ui = _extends$q({}, Kt.current.caches.rows, {
      updates: {
        type: "full",
        rows: gridDataRowIdsSelector(Kt)
      }
    }) : ui = createRowsInternalCache({
      rows: uo.rows,
      getRowId: uo.getRowId,
      loading: uo.loading,
      rowCount: uo.rowCount
    }), Ro({
      cache: ui,
      throttle: !1
    });
  }, [ho, Kt, uo.rows, uo.getRowId, uo.loading, uo.rowCount, Ro]), ai = useLazyRef(() => uo.unstable_dataSource), ri = React$1.useCallback((ui) => {
    if (uo.unstable_dataSource && uo.unstable_dataSource !== ai.current) {
      ai.current = uo.unstable_dataSource;
      return;
    }
    ui === "rowTreeCreation" && ii();
  }, [ii, ai, uo.unstable_dataSource]), ni = React$1.useCallback(() => {
    Kt.current.getActiveStrategy("rowTree") !== gridRowGroupingNameSelector(Kt) && ii();
  }, [Kt, ii]);
  useGridApiEventHandler(Kt, "activeStrategyProcessorChange", ri), useGridApiEventHandler(Kt, "strategyAvailabilityChange", ni);
  const si = React$1.useCallback(() => {
    Kt.current.setState((ui) => {
      const ci = Kt.current.unstable_applyPipeProcessors("hydrateRows", {
        tree: gridRowTreeSelector(ui, Kt.current.instanceId),
        treeDepths: gridRowTreeDepthsSelector(ui, Kt.current.instanceId),
        dataRowIds: gridDataRowIdsSelector(ui, Kt.current.instanceId),
        dataRowIdToModelLookup: gridRowsLookupSelector(ui, Kt.current.instanceId),
        dataRowIdToIdLookup: gridRowsDataRowIdToIdLookupSelector(ui, Kt.current.instanceId)
      });
      return _extends$q({}, ui, {
        rows: _extends$q({}, ui.rows, ci, {
          totalTopLevelRowCount: getTopLevelRowCount({
            tree: ci.tree,
            rowCountProp: uo.rowCount
          })
        })
      });
    }), Kt.current.publishEvent("rowsSet"), Kt.current.forceUpdate();
  }, [Kt, uo.rowCount]);
  useGridRegisterPipeApplier(Kt, "hydrateRows", si), useGridApiMethod(Kt, Qo, "public"), useGridApiMethod(Kt, Zo, uo.signature === GridSignature.DataGrid ? "private" : "public"), useGridApiMethod(Kt, ei, "private");
  const li = React$1.useRef(!0);
  React$1.useEffect(() => {
    var hi;
    if (li.current) {
      li.current = !1;
      return;
    }
    let ui = !1;
    uo.rowCount !== vo.current && (ui = !0, vo.current = uo.rowCount);
    const ci = Kt.current.caches.rows.rowsBeforePartialUpdates === uo.rows, fi = Kt.current.caches.rows.loadingPropBeforePartialUpdates === uo.loading, yi = Kt.current.caches.rows.rowCountPropBeforePartialUpdates === uo.rowCount;
    ci && (fi || (Kt.current.setState((mi) => _extends$q({}, mi, {
      rows: _extends$q({}, mi.rows, {
        loading: uo.loading
      })
    })), Kt.current.caches.rows.loadingPropBeforePartialUpdates = uo.loading, Kt.current.forceUpdate()), yi || (Kt.current.setState((mi) => _extends$q({}, mi, {
      rows: _extends$q({}, mi.rows, {
        totalRowCount: Math.max(uo.rowCount || 0, mi.rows.totalRowCount),
        totalTopLevelRowCount: Math.max(uo.rowCount || 0, mi.rows.totalTopLevelRowCount)
      })
    })), Kt.current.caches.rows.rowCountPropBeforePartialUpdates = uo.rowCount, Kt.current.forceUpdate()), !ui) || (ho.debug(`Updating all rows, new length ${(hi = uo.rows) == null ? void 0 : hi.length}`), Ro({
      cache: createRowsInternalCache({
        rows: uo.rows,
        getRowId: uo.getRowId,
        loading: uo.loading,
        rowCount: uo.rowCount
      }),
      throttle: !1
    }));
  }, [uo.rows, uo.rowCount, uo.getRowId, uo.loading, ho, Ro, Kt]);
}, createFlatRowTree = (Kt) => {
  const uo = {
    [GRID_ROOT_GROUP_ID]: _extends$q({}, buildRootGroup(), {
      children: Kt
    })
  };
  for (let ho = 0; ho < Kt.length; ho += 1) {
    const go = Kt[ho];
    uo[go] = {
      id: go,
      depth: 0,
      parent: GRID_ROOT_GROUP_ID,
      type: "leaf",
      groupingKey: null
    };
  }
  return {
    groupingName: GRID_DEFAULT_STRATEGY,
    tree: uo,
    treeDepths: {
      0: Kt.length
    },
    dataRowIds: Kt
  };
}, updateFlatRowTree = ({
  previousTree: Kt,
  actions: uo
}) => {
  const ho = _extends$q({}, Kt), go = {};
  for (let Po = 0; Po < uo.remove.length; Po += 1) {
    const Co = uo.remove[Po];
    go[Co] = !0, delete ho[Co];
  }
  for (let Po = 0; Po < uo.insert.length; Po += 1) {
    const Co = uo.insert[Po];
    ho[Co] = {
      id: Co,
      depth: 0,
      parent: GRID_ROOT_GROUP_ID,
      type: "leaf",
      groupingKey: null
    };
  }
  const bo = ho[GRID_ROOT_GROUP_ID];
  let vo = [...bo.children, ...uo.insert];
  return Object.values(go).length && (vo = vo.filter((Po) => !go[Po])), ho[GRID_ROOT_GROUP_ID] = _extends$q({}, bo, {
    children: vo
  }), {
    groupingName: GRID_DEFAULT_STRATEGY,
    tree: ho,
    treeDepths: {
      0: vo.length
    },
    dataRowIds: vo
  };
}, flatRowTreeCreationMethod = (Kt) => Kt.updates.type === "full" ? createFlatRowTree(Kt.updates.rows) : updateFlatRowTree({
  previousTree: Kt.previousTree,
  actions: Kt.updates.actions
}), useGridRowsPreProcessors = (Kt) => {
  useGridRegisterStrategyProcessor(Kt, GRID_DEFAULT_STRATEGY, "rowTreeCreation", flatRowTreeCreationMethod);
};
class MissingRowIdError extends Error {
}
function useGridParamsApi(Kt, uo) {
  const ho = React$1.useCallback((_o) => ({
    field: _o,
    colDef: Kt.current.getColumn(_o)
  }), [Kt]), go = React$1.useCallback((_o) => {
    const Io = Kt.current.getRow(_o);
    if (!Io)
      throw new MissingRowIdError(`No row with id #${_o} found`);
    return {
      id: _o,
      columns: Kt.current.getAllColumns(),
      row: Io
    };
  }, [Kt]), bo = React$1.useCallback((_o, Io) => {
    const Ao = uo.unstable_listView ? gridListColumnSelector(Kt.current.state) : Kt.current.getColumn(Io), Oo = Kt.current.getRow(_o), jo = Kt.current.getRowNode(_o);
    if (!Oo || !jo)
      throw new MissingRowIdError(`No row with id #${_o} found`);
    const Do = Oo[Io], Lo = Ao != null && Ao.valueGetter ? Ao.valueGetter(Do, Oo, Ao, Kt) : Do, ko = gridFocusCellSelector(Kt), Ko = gridTabIndexCellSelector(Kt), No = {
      id: _o,
      field: Io,
      row: Oo,
      rowNode: jo,
      colDef: Ao,
      cellMode: Kt.current.getCellMode(_o, Io),
      hasFocus: ko !== null && ko.field === Io && ko.id === _o,
      tabIndex: Ko && Ko.field === Io && Ko.id === _o ? 0 : -1,
      value: Lo,
      formattedValue: Lo,
      isEditable: !1,
      api: {}
    };
    return Ao && Ao.valueFormatter && (No.formattedValue = Ao.valueFormatter(Lo, Oo, Ao, Kt)), No.isEditable = Ao && Kt.current.isCellEditable(No), No;
  }, [Kt, uo.unstable_listView]), vo = React$1.useCallback((_o, Io) => {
    const Ao = Kt.current.getColumn(Io), Oo = Kt.current.getRow(_o);
    if (!Oo)
      throw new MissingRowIdError(`No row with id #${_o} found`);
    return !Ao || !Ao.valueGetter ? Oo[Io] : Ao.valueGetter(Oo[Ao.field], Oo, Ao, Kt);
  }, [Kt]), Po = React$1.useCallback((_o, Io) => {
    const Ao = Io.field;
    if (!Io || !Io.valueGetter)
      return _o[Ao];
    const Oo = _o[Io.field];
    return Io.valueGetter(Oo, _o, Io, Kt);
  }, [Kt]), Co = React$1.useCallback((_o, Io) => {
    const Ao = Po(_o, Io);
    return !Io || !Io.valueFormatter ? Ao : Io.valueFormatter(Ao, _o, Io, Kt);
  }, [Kt, Po]), So = React$1.useCallback((_o) => Kt.current.rootElementRef.current ? getGridColumnHeaderElement(Kt.current.rootElementRef.current, _o) : null, [Kt]), wo = React$1.useCallback((_o) => Kt.current.rootElementRef.current ? getGridRowElement(Kt.current.rootElementRef.current, _o) : null, [Kt]), Eo = React$1.useCallback((_o, Io) => Kt.current.rootElementRef.current ? getGridCellElement(Kt.current.rootElementRef.current, {
    id: _o,
    field: Io
  }) : null, [Kt]);
  useGridApiMethod(Kt, {
    getCellValue: vo,
    getCellParams: bo,
    getCellElement: Eo,
    getRowValue: Po,
    getRowFormattedValue: Co,
    getRowParams: go,
    getRowElement: wo,
    getColumnHeaderParams: ho,
    getColumnHeaderElement: So
  }, "public");
}
const getSelectionModelPropValue = (Kt, uo) => Kt == null || Array.isArray(Kt) ? Kt : uo && uo[0] === Kt ? uo : [Kt], rowSelectionStateInitializer = (Kt, uo) => _extends$q({}, Kt, {
  rowSelection: uo.rowSelection ? getSelectionModelPropValue(uo.rowSelectionModel) ?? [] : []
}), useGridRowSelection = (Kt, uo) => {
  var si, li, ui, ci, fi, yi, hi;
  const ho = useGridLogger(Kt, "useGridSelection"), go = React$1.useCallback((mi) => (...bi) => {
    uo.rowSelection && mi(...bi);
  }, [uo.rowSelection]), bo = uo.signature !== GridSignature.DataGrid && (((si = uo.rowSelectionPropagation) == null ? void 0 : si.parents) || ((li = uo.rowSelectionPropagation) == null ? void 0 : li.descendants)), vo = React$1.useMemo(() => getSelectionModelPropValue(uo.rowSelectionModel, gridRowSelectionStateSelector(Kt.current.state)), [Kt, uo.rowSelectionModel]), Po = React$1.useRef(null);
  Kt.current.registerControlState({
    stateId: "rowSelection",
    propModel: vo,
    propOnChange: uo.onRowSelectionModelChange,
    stateSelector: gridRowSelectionStateSelector,
    changeEvent: "rowSelectionChange"
  });
  const {
    checkboxSelection: Co,
    disableRowSelectionOnClick: So,
    isRowSelectable: wo
  } = uo, Eo = isMultipleRowSelectionEnabled(uo), Ro = useGridVisibleRows(Kt, uo), _o = useGridSelector(Kt, gridRowTreeSelector), Io = useGridSelector(Kt, gridRowMaximumTreeDepthSelector) > 1, Ao = React$1.useCallback((mi) => {
    let bi = mi;
    const xi = Po.current ?? mi, $i = Kt.current.isRowSelected(mi);
    if ($i) {
      const Ci = gridExpandedSortedRowIdsSelector(Kt), Si = Ci.findIndex((Pi) => Pi === xi), vi = Ci.findIndex((Pi) => Pi === bi);
      if (Si === vi)
        return;
      Si > vi ? bi = Ci[vi + 1] : bi = Ci[vi - 1];
    }
    Po.current = mi, Kt.current.selectRowRange({
      startId: xi,
      endId: bi
    }, !$i);
  }, [Kt]), Oo = React$1.useCallback((mi) => {
    if (uo.signature === GridSignature.DataGrid && !Eo && Array.isArray(mi) && mi.length > 1)
      throw new Error(["MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.", "You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection."].join(`
`));
    gridRowSelectionStateSelector(Kt.current.state) !== mi && (ho.debug("Setting selection model"), Kt.current.setState((xi) => _extends$q({}, xi, {
      rowSelection: uo.rowSelection ? mi : []
    })), Kt.current.forceUpdate());
  }, [Kt, ho, uo.rowSelection, uo.signature, Eo]), jo = React$1.useCallback((mi) => gridRowSelectionStateSelector(Kt.current.state).includes(mi), [Kt]), Do = React$1.useCallback((mi) => {
    if (uo.rowSelection === !1 || wo && !wo(Kt.current.getRowParams(mi)))
      return !1;
    const bi = Kt.current.getRowNode(mi);
    return !((bi == null ? void 0 : bi.type) === "footer" || (bi == null ? void 0 : bi.type) === "pinnedRow");
  }, [Kt, uo.rowSelection, wo]), Lo = React$1.useCallback(() => selectedGridRowsSelector(Kt), [Kt]), ko = React$1.useCallback((mi, bi = !0, xi = !1) => {
    var $i, Ci, Si, vi, Pi, wi;
    if (Kt.current.isRowSelectable(mi))
      if (Po.current = mi, xi) {
        ho.debug(`Setting selection for row ${mi}`);
        const gi = [], Ri = (Ei) => {
          gi.push(Ei);
        };
        bi && (Ri(mi), bo && findRowsToSelect(Kt, _o, mi, (($i = uo.rowSelectionPropagation) == null ? void 0 : $i.descendants) ?? !1, ((Ci = uo.rowSelectionPropagation) == null ? void 0 : Ci.parents) ?? !1, Ri)), Kt.current.setRowSelectionModel(gi);
      } else {
        ho.debug(`Toggling selection for row ${mi}`);
        const gi = gridRowSelectionStateSelector(Kt.current.state), Ri = new Set(gi);
        Ri.delete(mi);
        const Ei = (Yi) => {
          Ri.add(Yi);
        }, Ni = (Yi) => {
          Ri.delete(Yi);
        };
        bi ? (Ei(mi), bo && findRowsToSelect(Kt, _o, mi, ((Si = uo.rowSelectionPropagation) == null ? void 0 : Si.descendants) ?? !1, ((vi = uo.rowSelectionPropagation) == null ? void 0 : vi.parents) ?? !1, Ei)) : bo && findRowsToDeselect(Kt, _o, mi, ((Pi = uo.rowSelectionPropagation) == null ? void 0 : Pi.descendants) ?? !1, ((wi = uo.rowSelectionPropagation) == null ? void 0 : wi.parents) ?? !1, Ni), (Ri.size < 2 || Eo) && Kt.current.setRowSelectionModel(Array.from(Ri));
      }
  }, [Kt, ho, bo, _o, (ui = uo.rowSelectionPropagation) == null ? void 0 : ui.descendants, (ci = uo.rowSelectionPropagation) == null ? void 0 : ci.parents, Eo]), Ko = React$1.useCallback((mi, bi = !0, xi = !1) => {
    ho.debug("Setting selection for several rows");
    const $i = mi.filter((vi) => Kt.current.isRowSelectable(vi));
    let Ci;
    if (xi) {
      if (bi) {
        if (Ci = new Set($i), bo) {
          const Pi = (wi) => {
            Ci.add(wi);
          };
          $i.forEach((wi) => {
            var gi, Ri;
            findRowsToSelect(Kt, _o, wi, ((gi = uo.rowSelectionPropagation) == null ? void 0 : gi.descendants) ?? !1, ((Ri = uo.rowSelectionPropagation) == null ? void 0 : Ri.parents) ?? !1, Pi);
          });
        }
      } else
        Ci = /* @__PURE__ */ new Set();
      const vi = selectedIdsLookupSelector(Kt);
      if (Ci.size === Object.keys(vi).length && Array.from(Ci).every((Pi) => vi[Pi] === Pi))
        return;
    } else {
      Ci = new Set(Object.values(selectedIdsLookupSelector(Kt)));
      const vi = (wi) => {
        Ci.add(wi);
      }, Pi = (wi) => {
        Ci.delete(wi);
      };
      $i.forEach((wi) => {
        var gi, Ri, Ei, Ni;
        bi ? (Ci.add(wi), bo && findRowsToSelect(Kt, _o, wi, ((gi = uo.rowSelectionPropagation) == null ? void 0 : gi.descendants) ?? !1, ((Ri = uo.rowSelectionPropagation) == null ? void 0 : Ri.parents) ?? !1, vi)) : (Pi(wi), bo && findRowsToDeselect(Kt, _o, wi, ((Ei = uo.rowSelectionPropagation) == null ? void 0 : Ei.descendants) ?? !1, ((Ni = uo.rowSelectionPropagation) == null ? void 0 : Ni.parents) ?? !1, Pi));
      });
    }
    (Ci.size < 2 || Eo) && Kt.current.setRowSelectionModel(Array.from(Ci));
  }, [ho, bo, Eo, Kt, _o, (fi = uo.rowSelectionPropagation) == null ? void 0 : fi.descendants, (yi = uo.rowSelectionPropagation) == null ? void 0 : yi.parents]), No = React$1.useCallback(({
    startId: mi,
    endId: bi
  }, xi = !0, $i = !1) => {
    if (!Kt.current.getRow(mi) || !Kt.current.getRow(bi))
      return;
    ho.debug(`Expanding selection from row ${mi} to row ${bi}`);
    const Ci = gridExpandedSortedRowIdsSelector(Kt), Si = Ci.indexOf(mi), vi = Ci.indexOf(bi), [Pi, wi] = Si > vi ? [vi, Si] : [Si, vi], gi = Ci.slice(Pi, wi + 1);
    Kt.current.selectRows(gi, xi, $i);
  }, [Kt, ho]), Jo = {
    selectRow: ko,
    setRowSelectionModel: Oo,
    getSelectedRows: Lo,
    isRowSelected: jo,
    isRowSelectable: Do
  }, ti = {
    selectRows: Ko,
    selectRowRange: No
  };
  useGridApiMethod(Kt, Jo, "public"), useGridApiMethod(Kt, ti, uo.signature === GridSignature.DataGrid ? "private" : "public");
  const oi = React$1.useCallback((mi = !1) => {
    var wi;
    const bi = gridRowSelectionStateSelector(Kt.current.state), xi = gridRowsLookupSelector(Kt), $i = gridFilteredRowsLookupSelector(Kt), Ci = _extends$q({}, selectedIdsLookupSelector(Kt)), Si = (gi) => uo.filterMode === "server" ? !xi[gi] : $i[gi] !== !0;
    let vi = !1;
    bi.forEach((gi) => {
      var Ei;
      if (Si(gi)) {
        if (uo.keepNonExistentRowsSelected)
          return;
        delete Ci[gi], vi = !0;
        return;
      }
      if (!((Ei = uo.rowSelectionPropagation) != null && Ei.parents))
        return;
      const Ri = _o[gi];
      if (Ri.type === "group") {
        if (Ri.isAutoGenerated) {
          delete Ci[gi], vi = !0;
          return;
        }
        Ri.children.every((Ai) => $i[Ai] === !1) || (delete Ci[gi], vi = !0);
      }
    });
    const Pi = Io && ((wi = uo.rowSelectionPropagation) == null ? void 0 : wi.parents) && Object.keys(Ci).length > 0;
    if (vi || Pi && !mi) {
      const gi = Object.values(Ci);
      Pi ? Kt.current.selectRows(gi, !0, !0) : Kt.current.setRowSelectionModel(gi);
    }
  }, [Kt, Io, (hi = uo.rowSelectionPropagation) == null ? void 0 : hi.parents, uo.keepNonExistentRowsSelected, uo.filterMode, _o]), Qo = React$1.useCallback((mi, bi) => {
    const xi = bi.metaKey || bi.ctrlKey, $i = !Co && !xi && !isKeyboardEvent(bi), Ci = !Eo || $i, Si = Kt.current.isRowSelected(mi);
    Ci ? Kt.current.selectRow(mi, $i ? !0 : !Si, !0) : Kt.current.selectRow(mi, !Si, !1);
  }, [Kt, Eo, Co]), Zo = React$1.useCallback((mi, bi) => {
    var Ci;
    if (So)
      return;
    const xi = (Ci = bi.target.closest(`.${gridClasses.cell}`)) == null ? void 0 : Ci.getAttribute("data-field");
    if (xi === GRID_CHECKBOX_SELECTION_COL_DEF.field || xi === GRID_DETAIL_PANEL_TOGGLE_FIELD)
      return;
    if (xi) {
      const Si = Kt.current.getColumn(xi);
      if ((Si == null ? void 0 : Si.type) === GRID_ACTIONS_COLUMN_TYPE)
        return;
    }
    Kt.current.getRowNode(mi.id).type !== "pinnedRow" && (bi.shiftKey && Eo ? Ao(mi.id) : Qo(mi.id, bi));
  }, [So, Eo, Kt, Ao, Qo]), ei = React$1.useCallback((mi, bi) => {
    var xi;
    Eo && bi.shiftKey && ((xi = window.getSelection()) == null || xi.removeAllRanges());
  }, [Eo]), ii = React$1.useCallback((mi, bi) => {
    Eo && bi.nativeEvent.shiftKey ? Ao(mi.id) : Kt.current.selectRow(mi.id, mi.value, !Eo);
  }, [Kt, Ao, Eo]), ai = React$1.useCallback((mi) => {
    const bi = uo.pagination && uo.checkboxSelectionVisibleOnly && uo.paginationMode === "client" ? gridPaginatedVisibleSortedGridRowIdsSelector(Kt) : gridExpandedSortedRowIdsSelector(Kt);
    Kt.current.selectRows(bi, mi.value);
  }, [Kt, uo.checkboxSelectionVisibleOnly, uo.pagination, uo.paginationMode]), ri = React$1.useCallback((mi, bi) => {
    if (Kt.current.getCellMode(mi.id, mi.field) !== GridCellModes.Edit && !isEventTargetInPortal(bi)) {
      if (isNavigationKey(bi.key) && bi.shiftKey) {
        const xi = gridFocusCellSelector(Kt);
        if (xi && xi.id !== mi.id) {
          bi.preventDefault();
          const $i = Kt.current.isRowSelected(xi.id);
          if (!Eo) {
            Kt.current.selectRow(xi.id, !$i, !0);
            return;
          }
          const Ci = Kt.current.getRowIndexRelativeToVisibleRows(xi.id), Si = Kt.current.getRowIndexRelativeToVisibleRows(mi.id);
          let vi, Pi;
          Ci > Si ? $i ? (vi = Si, Pi = Ci - 1) : (vi = Si, Pi = Ci) : $i ? (vi = Ci + 1, Pi = Si) : (vi = Ci, Pi = Si);
          const wi = Ro.rows.slice(vi, Pi + 1).map((gi) => gi.id);
          Kt.current.selectRows(wi, !$i);
          return;
        }
      }
      if (bi.key === " " && bi.shiftKey) {
        bi.preventDefault(), Qo(mi.id, bi);
        return;
      }
      String.fromCharCode(bi.keyCode) === "A" && (bi.ctrlKey || bi.metaKey) && (bi.preventDefault(), Ko(Kt.current.getAllRowIds(), !0));
    }
  }, [Kt, Qo, Ko, Ro.rows, Eo]);
  useGridApiEventHandler(Kt, "sortedRowsSet", go(() => oi(!0))), useGridApiEventHandler(Kt, "filteredRowsSet", go(oi)), useGridApiEventHandler(Kt, "rowClick", go(Zo)), useGridApiEventHandler(Kt, "rowSelectionCheckboxChange", go(ii)), useGridApiEventHandler(Kt, "headerSelectionCheckboxChange", ai), useGridApiEventHandler(Kt, "cellMouseDown", go(ei)), useGridApiEventHandler(Kt, "cellKeyDown", go(ri)), React$1.useEffect(() => {
    vo !== void 0 && Kt.current.setRowSelectionModel(vo);
  }, [Kt, vo, uo.rowSelection]), React$1.useEffect(() => {
    uo.rowSelection || Kt.current.setRowSelectionModel([]);
  }, [Kt, uo.rowSelection]);
  const ni = vo != null;
  React$1.useEffect(() => {
    if (ni || !uo.rowSelection)
      return;
    const mi = gridRowSelectionStateSelector(Kt.current.state);
    if (Do) {
      const bi = mi.filter((xi) => Do(xi));
      bi.length < mi.length && Kt.current.setRowSelectionModel(bi);
    }
  }, [Kt, Do, ni, uo.rowSelection]), React$1.useEffect(() => {
    if (!uo.rowSelection || ni)
      return;
    const mi = gridRowSelectionStateSelector(Kt.current.state);
    !Eo && mi.length > 1 && Kt.current.setRowSelectionModel([]);
  }, [Kt, Eo, Co, ni, uo.rowSelection]), React$1.useEffect(() => {
    go(oi);
  }, [oi, go]);
}, useUtilityClasses$g = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return React$1.useMemo(() => composeClasses({
    cellCheckbox: ["cellCheckbox"],
    columnHeaderCheckbox: ["columnHeaderCheckbox"]
  }, getDataGridUtilityClass, uo), [uo]);
}, useGridRowSelectionPreProcessors = (Kt, uo) => {
  const ho = {
    classes: uo.classes
  }, go = useUtilityClasses$g(ho), bo = React$1.useCallback((vo) => {
    const Po = _extends$q({}, GRID_CHECKBOX_SELECTION_COL_DEF, {
      cellClassName: go.cellCheckbox,
      headerClassName: go.columnHeaderCheckbox,
      headerName: Kt.current.getLocaleText("checkboxSelectionHeaderName")
    }), Co = uo.checkboxSelection, So = vo.lookup[GRID_CHECKBOX_SELECTION_FIELD] != null;
    return Co && !So ? (vo.lookup[GRID_CHECKBOX_SELECTION_FIELD] = Po, vo.orderedFields = [GRID_CHECKBOX_SELECTION_FIELD, ...vo.orderedFields]) : !Co && So ? (delete vo.lookup[GRID_CHECKBOX_SELECTION_FIELD], vo.orderedFields = vo.orderedFields.filter((wo) => wo !== GRID_CHECKBOX_SELECTION_FIELD)) : Co && So && (vo.lookup[GRID_CHECKBOX_SELECTION_FIELD] = _extends$q({}, Po, vo.lookup[GRID_CHECKBOX_SELECTION_FIELD])), vo;
  }, [Kt, go, uo.checkboxSelection]);
  useGridRegisterPipeProcessor(Kt, "hydrateColumns", bo);
}, sortingStateInitializer = (Kt, uo) => {
  var go, bo;
  const ho = uo.sortModel ?? ((bo = (go = uo.initialState) == null ? void 0 : go.sorting) == null ? void 0 : bo.sortModel) ?? [];
  return _extends$q({}, Kt, {
    sorting: {
      sortModel: sanitizeSortModel(ho, uo.disableMultipleColumnsSorting),
      sortedRows: []
    }
  });
}, useGridSorting = (Kt, uo) => {
  var No, Jo;
  const ho = useGridLogger(Kt, "useGridSorting");
  Kt.current.registerControlState({
    stateId: "sortModel",
    propModel: uo.sortModel,
    propOnChange: uo.onSortModelChange,
    stateSelector: gridSortModelSelector,
    changeEvent: "sortModelChange"
  });
  const go = React$1.useCallback((ti, oi) => {
    const Qo = gridSortModelSelector(Kt), Zo = Qo.findIndex((ii) => ii.field === ti);
    let ei = [...Qo];
    return Zo > -1 ? (oi == null ? void 0 : oi.sort) == null ? ei.splice(Zo, 1) : ei.splice(Zo, 1, oi) : ei = [...Qo, oi], ei;
  }, [Kt]), bo = React$1.useCallback((ti, oi) => {
    const Zo = gridSortModelSelector(Kt).find((ei) => ei.field === ti.field);
    if (Zo) {
      const ei = oi === void 0 ? getNextGridSortDirection(ti.sortingOrder ?? uo.sortingOrder, Zo.sort) : oi;
      return ei === void 0 ? void 0 : _extends$q({}, Zo, {
        sort: ei
      });
    }
    return {
      field: ti.field,
      sort: oi === void 0 ? getNextGridSortDirection(ti.sortingOrder ?? uo.sortingOrder) : oi
    };
  }, [Kt, uo.sortingOrder]), vo = React$1.useCallback((ti, oi) => oi == null || oi.sortable === !1 || uo.disableColumnSorting ? ti : (oi.sortingOrder || uo.sortingOrder).some((Zo) => !!Zo) ? [...ti, "columnMenuSortItem"] : ti, [uo.sortingOrder, uo.disableColumnSorting]), Po = React$1.useCallback(() => {
    Kt.current.setState((ti) => {
      if (uo.sortingMode === "server")
        return ho.debug("Skipping sorting rows as sortingMode = server"), _extends$q({}, ti, {
          sorting: _extends$q({}, ti.sorting, {
            sortedRows: getTreeNodeDescendants(gridRowTreeSelector(Kt), GRID_ROOT_GROUP_ID, !1)
          })
        });
      const oi = gridSortModelSelector(ti, Kt.current.instanceId), Qo = buildAggregatedSortingApplier(oi, Kt), Zo = Kt.current.applyStrategyProcessor("sorting", {
        sortRowList: Qo
      });
      return _extends$q({}, ti, {
        sorting: _extends$q({}, ti.sorting, {
          sortedRows: Zo
        })
      });
    }), Kt.current.publishEvent("sortedRowsSet"), Kt.current.forceUpdate();
  }, [Kt, ho, uo.sortingMode]), Co = React$1.useCallback((ti) => {
    gridSortModelSelector(Kt) !== ti && (ho.debug("Setting sort model"), Kt.current.setState(mergeStateWithSortModel(ti, uo.disableMultipleColumnsSorting)), Kt.current.forceUpdate(), Kt.current.applySorting());
  }, [Kt, ho, uo.disableMultipleColumnsSorting]), So = React$1.useCallback((ti, oi, Qo) => {
    const Zo = Kt.current.getColumn(ti), ei = bo(Zo, oi);
    let ii;
    !Qo || uo.disableMultipleColumnsSorting ? ii = (ei == null ? void 0 : ei.sort) == null ? [] : [ei] : ii = go(Zo.field, ei), Kt.current.setSortModel(ii);
  }, [Kt, go, bo, uo.disableMultipleColumnsSorting]), wo = React$1.useCallback(() => gridSortModelSelector(Kt), [Kt]), Eo = React$1.useCallback(() => gridSortedRowEntriesSelector(Kt).map((oi) => oi.model), [Kt]), Ro = React$1.useCallback(() => gridSortedRowIdsSelector(Kt), [Kt]), _o = React$1.useCallback((ti) => Kt.current.getSortedRowIds()[ti], [Kt]);
  useGridApiMethod(Kt, {
    getSortModel: wo,
    getSortedRows: Eo,
    getSortedRowIds: Ro,
    getRowIdFromRowIndex: _o,
    setSortModel: Co,
    sortColumn: So,
    applySorting: Po
  }, "public");
  const Ao = React$1.useCallback((ti, oi) => {
    var ei, ii;
    const Qo = gridSortModelSelector(Kt);
    return (
      // Always export if the `exportOnlyDirtyModels` property is not activated
      !oi.exportOnlyDirtyModels || // Always export if the model is controlled
      uo.sortModel != null || // Always export if the model has been initialized
      ((ii = (ei = uo.initialState) == null ? void 0 : ei.sorting) == null ? void 0 : ii.sortModel) != null || // Export if the model is not empty
      Qo.length > 0 ? _extends$q({}, ti, {
        sorting: {
          sortModel: Qo
        }
      }) : ti
    );
  }, [Kt, uo.sortModel, (Jo = (No = uo.initialState) == null ? void 0 : No.sorting) == null ? void 0 : Jo.sortModel]), Oo = React$1.useCallback((ti, oi) => {
    var Zo;
    const Qo = (Zo = oi.stateToRestore.sorting) == null ? void 0 : Zo.sortModel;
    return Qo == null ? ti : (Kt.current.setState(mergeStateWithSortModel(Qo, uo.disableMultipleColumnsSorting)), _extends$q({}, ti, {
      callbacks: [...ti.callbacks, Kt.current.applySorting]
    }));
  }, [Kt, uo.disableMultipleColumnsSorting]), jo = React$1.useCallback((ti) => {
    const oi = gridRowTreeSelector(Kt), Qo = oi[GRID_ROOT_GROUP_ID], Zo = ti.sortRowList ? ti.sortRowList(Qo.children.map((ei) => oi[ei])) : [...Qo.children];
    return Qo.footerId != null && Zo.push(Qo.footerId), Zo;
  }, [Kt]);
  useGridRegisterPipeProcessor(Kt, "exportState", Ao), useGridRegisterPipeProcessor(Kt, "restoreState", Oo), useGridRegisterStrategyProcessor(Kt, GRID_DEFAULT_STRATEGY, "sorting", jo);
  const Do = React$1.useCallback(({
    field: ti,
    colDef: oi
  }, Qo) => {
    if (!oi.sortable || uo.disableColumnSorting)
      return;
    const Zo = Qo.shiftKey || Qo.metaKey || Qo.ctrlKey;
    So(ti, void 0, Zo);
  }, [So, uo.disableColumnSorting]), Lo = React$1.useCallback(({
    field: ti,
    colDef: oi
  }, Qo) => {
    !oi.sortable || uo.disableColumnSorting || Qo.key === "Enter" && !Qo.ctrlKey && !Qo.metaKey && So(ti, void 0, Qo.shiftKey);
  }, [So, uo.disableColumnSorting]), ko = React$1.useCallback(() => {
    const ti = gridSortModelSelector(Kt), oi = gridColumnLookupSelector(Kt);
    if (ti.length > 0) {
      const Qo = ti.filter((Zo) => oi[Zo.field]);
      Qo.length < ti.length && Kt.current.setSortModel(Qo);
    }
  }, [Kt]), Ko = React$1.useCallback((ti) => {
    ti === "sorting" && Kt.current.applySorting();
  }, [Kt]);
  useGridRegisterPipeProcessor(Kt, "columnMenu", vo), useGridApiEventHandler(Kt, "columnHeaderClick", Do), useGridApiEventHandler(Kt, "columnHeaderKeyDown", Lo), useGridApiEventHandler(Kt, "rowsSet", Kt.current.applySorting), useGridApiEventHandler(Kt, "columnsChange", ko), useGridApiEventHandler(Kt, "activeStrategyProcessorChange", Ko), useFirstRender(() => {
    Kt.current.applySorting();
  }), useEnhancedEffect(() => {
    uo.sortModel !== void 0 && Kt.current.setSortModel(uo.sortModel);
  }, [Kt, uo.sortModel]);
};
function scrollIntoView(Kt) {
  const {
    containerSize: uo,
    scrollPosition: ho,
    elementSize: go,
    elementOffset: bo
  } = Kt, vo = bo + go;
  if (go > uo)
    return bo;
  if (vo - uo > ho)
    return vo - uo;
  if (bo < ho)
    return bo;
}
const useGridScroll = (Kt, uo) => {
  const ho = useRtl(), go = useGridLogger(Kt, "useGridScroll"), bo = Kt.current.columnHeadersContainerRef, vo = Kt.current.virtualScrollerRef, Po = useGridSelector(Kt, gridExpandedSortedRowEntriesSelector), Co = React$1.useCallback((Ro) => {
    var Do;
    const _o = gridDimensionsSelector(Kt.current.state), Io = gridRowCountSelector(Kt), Ao = uo.unstable_listView ? [gridListColumnSelector(Kt.current.state)] : gridVisibleColumnDefinitionsSelector(Kt);
    if (!(Ro.rowIndex == null) && Io === 0 || Ao.length === 0)
      return !1;
    go.debug(`Scrolling to cell at row ${Ro.rowIndex}, col: ${Ro.colIndex} `);
    let jo = {};
    if (Ro.colIndex !== void 0) {
      const Lo = gridColumnPositionsSelector(Kt);
      let ko;
      if (typeof Ro.rowIndex < "u") {
        const Ko = (Do = Po[Ro.rowIndex]) == null ? void 0 : Do.id, No = Kt.current.unstable_getCellColSpanInfo(Ko, Ro.colIndex);
        No && !No.spannedByColSpan && (ko = No.cellProps.width);
      }
      typeof ko > "u" && (ko = Ao[Ro.colIndex].computedWidth), jo.left = scrollIntoView({
        containerSize: _o.viewportOuterSize.width,
        scrollPosition: Math.abs(vo.current.scrollLeft),
        elementSize: ko,
        elementOffset: Lo[Ro.colIndex]
      });
    }
    if (Ro.rowIndex !== void 0) {
      const Lo = gridRowsMetaSelector(Kt.current.state), ko = gridPageSelector(Kt), Ko = gridPageSizeSelector(Kt), No = uo.pagination ? Ro.rowIndex - ko * Ko : Ro.rowIndex, Jo = Lo.positions[No + 1] ? Lo.positions[No + 1] - Lo.positions[No] : Lo.currentPageTotalHeight - Lo.positions[No];
      jo.top = scrollIntoView({
        containerSize: _o.viewportInnerSize.height,
        scrollPosition: vo.current.scrollTop,
        elementSize: Jo,
        elementOffset: Lo.positions[No]
      });
    }
    return jo = Kt.current.unstable_applyPipeProcessors("scrollToIndexes", jo, Ro), typeof jo.left !== void 0 || typeof jo.top !== void 0 ? (Kt.current.scroll(jo), !0) : !1;
  }, [go, Kt, vo, uo.pagination, Po, uo.unstable_listView]), So = React$1.useCallback((Ro) => {
    if (vo.current && Ro.left !== void 0 && bo.current) {
      const _o = ho ? -1 : 1;
      bo.current.scrollLeft = Ro.left, vo.current.scrollLeft = _o * Ro.left, go.debug(`Scrolling left: ${Ro.left}`);
    }
    vo.current && Ro.top !== void 0 && (vo.current.scrollTop = Ro.top, go.debug(`Scrolling top: ${Ro.top}`)), go.debug("Scrolling, updating container, and viewport");
  }, [vo, ho, bo, go]), wo = React$1.useCallback(() => vo != null && vo.current ? {
    top: vo.current.scrollTop,
    left: vo.current.scrollLeft
  } : {
    top: 0,
    left: 0
  }, [vo]);
  useGridApiMethod(Kt, {
    scroll: So,
    scrollToIndexes: Co,
    getScrollPosition: wo
  }, "public");
};
function useGridEvents(Kt, uo) {
  useGridApiOptionHandler(Kt, "columnHeaderClick", uo.onColumnHeaderClick), useGridApiOptionHandler(Kt, "columnHeaderContextMenu", uo.onColumnHeaderContextMenu), useGridApiOptionHandler(Kt, "columnHeaderDoubleClick", uo.onColumnHeaderDoubleClick), useGridApiOptionHandler(Kt, "columnHeaderOver", uo.onColumnHeaderOver), useGridApiOptionHandler(Kt, "columnHeaderOut", uo.onColumnHeaderOut), useGridApiOptionHandler(Kt, "columnHeaderEnter", uo.onColumnHeaderEnter), useGridApiOptionHandler(Kt, "columnHeaderLeave", uo.onColumnHeaderLeave), useGridApiOptionHandler(Kt, "cellClick", uo.onCellClick), useGridApiOptionHandler(Kt, "cellDoubleClick", uo.onCellDoubleClick), useGridApiOptionHandler(Kt, "cellKeyDown", uo.onCellKeyDown), useGridApiOptionHandler(Kt, "preferencePanelClose", uo.onPreferencePanelClose), useGridApiOptionHandler(Kt, "preferencePanelOpen", uo.onPreferencePanelOpen), useGridApiOptionHandler(Kt, "menuOpen", uo.onMenuOpen), useGridApiOptionHandler(Kt, "menuClose", uo.onMenuClose), useGridApiOptionHandler(Kt, "rowDoubleClick", uo.onRowDoubleClick), useGridApiOptionHandler(Kt, "rowClick", uo.onRowClick), useGridApiOptionHandler(Kt, "stateChange", uo.onStateChange);
}
function throttle$2(Kt, uo = 166) {
  let ho, go;
  const bo = () => {
    ho = void 0, Kt(...go);
  };
  function vo(...Po) {
    go = Po, ho === void 0 && (ho = setTimeout(bo, uo));
  }
  return vo.clear = () => {
    clearTimeout(ho), ho = void 0;
  }, vo;
}
const DATA_GRID_PROPS_DEFAULT_VALUES = {
  autoHeight: !1,
  autoPageSize: !1,
  autosizeOnMount: !1,
  checkboxSelection: !1,
  checkboxSelectionVisibleOnly: !1,
  clipboardCopyCellDelimiter: "	",
  columnBufferPx: 150,
  columnHeaderHeight: 56,
  disableAutosize: !1,
  disableColumnFilter: !1,
  disableColumnMenu: !1,
  disableColumnReorder: !1,
  disableColumnResize: !1,
  disableColumnSelector: !1,
  disableColumnSorting: !1,
  disableDensitySelector: !1,
  disableEval: !1,
  disableMultipleColumnsFiltering: !1,
  disableMultipleColumnsSorting: !1,
  disableMultipleRowSelection: !1,
  disableRowSelectionOnClick: !1,
  disableVirtualization: !1,
  editMode: GridEditModes.Cell,
  filterDebounceMs: 150,
  filterMode: "client",
  hideFooter: !1,
  hideFooterPagination: !1,
  hideFooterRowCount: !1,
  hideFooterSelectedRowCount: !1,
  ignoreDiacritics: !1,
  ignoreValueFormatterDuringExport: !1,
  // TODO v8: Update to 'select'
  indeterminateCheckboxAction: "deselect",
  keepColumnPositionIfDraggedOutside: !1,
  keepNonExistentRowsSelected: !1,
  loading: !1,
  logger: console,
  logLevel: process.env.NODE_ENV === "production" ? "error" : "warn",
  pageSizeOptions: [25, 50, 100],
  pagination: !1,
  paginationMode: "client",
  resizeThrottleMs: 60,
  rowBufferPx: 150,
  rowHeight: 52,
  rowPositionsDebounceMs: 166,
  rows: [],
  rowSelection: !0,
  rowSpacingType: "margin",
  showCellVerticalBorder: !1,
  showColumnVerticalBorder: !1,
  sortingMode: "client",
  sortingOrder: ["asc", "desc", null],
  throttleRowsMs: 0,
  unstable_rowSpanning: !1,
  virtualizeColumnsWithAutoRowHeight: !1
}, EMPTY_SIZE = {
  width: 0,
  height: 0
}, EMPTY_DIMENSIONS = {
  isReady: !1,
  root: EMPTY_SIZE,
  viewportOuterSize: EMPTY_SIZE,
  viewportInnerSize: EMPTY_SIZE,
  contentSize: EMPTY_SIZE,
  minimumSize: EMPTY_SIZE,
  hasScrollX: !1,
  hasScrollY: !1,
  scrollbarSize: 0,
  headerHeight: 0,
  groupHeaderHeight: 0,
  headerFilterHeight: 0,
  rowWidth: 0,
  rowHeight: 0,
  columnsTotalWidth: 0,
  leftPinnedWidth: 0,
  rightPinnedWidth: 0,
  headersTotalHeight: 0,
  topContainerHeight: 0,
  bottomContainerHeight: 0
}, dimensionsStateInitializer = (Kt) => _extends$q({}, Kt, {
  dimensions: EMPTY_DIMENSIONS
});
function useGridDimensions(Kt, uo) {
  const ho = useGridLogger(Kt, "useResizeContainer"), go = React$1.useRef(!1), bo = React$1.useRef(EMPTY_SIZE), vo = useGridSelector(Kt, gridDimensionsSelector), Po = useGridSelector(Kt, gridRowsMetaSelector), Co = useGridSelector(Kt, gridVisiblePinnedColumnDefinitionsSelector), So = useGridSelector(Kt, gridDensityFactorSelector), wo = React$1.useMemo(() => getValidRowHeight(uo.rowHeight, DATA_GRID_PROPS_DEFAULT_VALUES.rowHeight, rowHeightWarning), [uo.rowHeight]), Eo = Math.floor(wo * So), Ro = Math.floor(uo.columnHeaderHeight * So), _o = Math.floor((uo.columnGroupHeaderHeight ?? uo.columnHeaderHeight) * So), Io = Math.floor((uo.headerFilterHeight ?? uo.columnHeaderHeight) * So), Ao = roundToDecimalPlaces(gridColumnsTotalWidthSelector(Kt), 6), Oo = getTotalHeaderHeight(Kt, uo), jo = Co.left.reduce((si, li) => si + li.computedWidth, 0), Do = Co.right.reduce((si, li) => si + li.computedWidth, 0), [Lo, ko] = React$1.useState(), Ko = React$1.useMemo(() => throttle$2(ko, uo.resizeThrottleMs), [uo.resizeThrottleMs]);
  React$1.useEffect(() => Ko.clear, [Ko]);
  const No = React$1.useRef(), Jo = () => Kt.current.state.dimensions, ti = useEventCallback((si) => {
    Kt.current.setState((li) => _extends$q({}, li, {
      dimensions: si
    }));
  }), oi = React$1.useCallback(() => {
    const si = Kt.current.mainElementRef.current;
    if (!si)
      return;
    const li = ownerWindow(si).getComputedStyle(si), ui = {
      width: parseFloat(li.width) || 0,
      height: parseFloat(li.height) || 0
    };
    (!No.current || !areElementSizesEqual(No.current, ui)) && (Kt.current.publishEvent("resize", ui), No.current = ui);
  }, [Kt]), Qo = React$1.useCallback(() => {
    const si = gridDimensionsSelector(Kt.current.state);
    if (!si.isReady)
      return 0;
    const li = getVisibleRows(Kt, {
      pagination: uo.pagination,
      paginationMode: uo.paginationMode
    });
    if (uo.getRowHeight) {
      const ci = gridRenderContextSelector(Kt), fi = ci.lastRowIndex - ci.firstRowIndex;
      return Math.min(fi - 1, li.rows.length);
    }
    const ui = Math.floor(si.viewportInnerSize.height / Eo);
    return Math.min(ui, li.rows.length);
  }, [Kt, uo.pagination, uo.paginationMode, uo.getRowHeight, Eo]), Zo = React$1.useCallback(() => {
    var wi, gi;
    const si = Kt.current.rootElementRef.current, li = calculatePinnedRowsHeight(Kt), ui = measureScrollbarSize(si, Ao, uo.scrollbarSize), ci = Oo + li.top, fi = li.bottom, hi = {
      width: Ao - jo - Do,
      height: Po.currentPageTotalHeight
    };
    let mi, bi, xi = !1, $i = !1;
    if (uo.autoHeight)
      $i = !1, xi = Math.round(Ao) > Math.round(bo.current.width), mi = {
        width: bo.current.width,
        height: ci + fi + hi.height
      }, bi = {
        width: Math.max(0, mi.width - ($i ? ui : 0)),
        height: Math.max(0, mi.height - (xi ? ui : 0))
      };
    else {
      mi = {
        width: bo.current.width,
        height: bo.current.height
      }, bi = {
        width: Math.max(0, mi.width - jo - Do),
        height: Math.max(0, mi.height - ci - fi)
      };
      const Ri = hi, Ei = bi, Ni = Ri.width > Ei.width, Ai = Ri.height > Ei.height;
      (Ni || Ai) && ($i = Ai, xi = Ri.width + ($i ? ui : 0) > Ei.width, xi && ($i = Ri.height + ui > Ei.height)), $i && (bi.width -= ui), xi && (bi.height -= ui);
    }
    const Ci = Math.max(mi.width, Ao + ($i ? ui : 0)), Si = {
      width: Ao,
      height: ci + hi.height + fi
    }, vi = {
      isReady: !0,
      root: bo.current,
      viewportOuterSize: mi,
      viewportInnerSize: bi,
      contentSize: hi,
      minimumSize: Si,
      hasScrollX: xi,
      hasScrollY: $i,
      scrollbarSize: ui,
      headerHeight: Ro,
      groupHeaderHeight: _o,
      headerFilterHeight: Io,
      rowWidth: Ci,
      rowHeight: Eo,
      columnsTotalWidth: Ao,
      leftPinnedWidth: jo,
      rightPinnedWidth: Do,
      headersTotalHeight: Oo,
      topContainerHeight: ci,
      bottomContainerHeight: fi
    }, Pi = Kt.current.state.dimensions;
    ti(vi), areElementSizesEqual(vi.viewportInnerSize, Pi.viewportInnerSize) || Kt.current.publishEvent("viewportInnerSizeChange", vi.viewportInnerSize), (gi = (wi = Kt.current).updateRenderContext) == null || gi.call(wi);
  }, [Kt, ti, uo.scrollbarSize, uo.autoHeight, Po.currentPageTotalHeight, Eo, Ro, _o, Io, Ao, Oo, jo, Do]), ei = {
    resize: oi,
    getRootDimensions: Jo
  }, ii = {
    updateDimensions: Zo,
    getViewportPageSize: Qo
  };
  useGridApiMethod(Kt, ei, "public"), useGridApiMethod(Kt, ii, "private"), useEnhancedEffect(() => {
    Lo && (Zo(), Kt.current.publishEvent("debouncedResize", bo.current));
  }, [Kt, Lo, Zo]);
  const ai = Kt.current.rootElementRef.current;
  useEnhancedEffect(() => {
    if (!ai)
      return;
    const si = (li, ui) => ai.style.setProperty(li, ui);
    si("--DataGrid-width", `${vo.viewportOuterSize.width}px`), si("--DataGrid-hasScrollX", `${Number(vo.hasScrollX)}`), si("--DataGrid-hasScrollY", `${Number(vo.hasScrollY)}`), si("--DataGrid-scrollbarSize", `${vo.scrollbarSize}px`), si("--DataGrid-rowWidth", `${vo.rowWidth}px`), si("--DataGrid-columnsTotalWidth", `${vo.columnsTotalWidth}px`), si("--DataGrid-leftPinnedWidth", `${vo.leftPinnedWidth}px`), si("--DataGrid-rightPinnedWidth", `${vo.rightPinnedWidth}px`), si("--DataGrid-headerHeight", `${vo.headerHeight}px`), si("--DataGrid-headersTotalHeight", `${vo.headersTotalHeight}px`), si("--DataGrid-topContainerHeight", `${vo.topContainerHeight}px`), si("--DataGrid-bottomContainerHeight", `${vo.bottomContainerHeight}px`), si("--height", `${vo.rowHeight}px`);
  }, [ai, vo]);
  const ri = React$1.useRef(!0), ni = React$1.useCallback((si) => {
    bo.current = si;
    const li = /jsdom|HappyDOM/.test(window.navigator.userAgent);
    if (si.height === 0 && !go.current && !uo.autoHeight && !li && (ho.error(["The parent DOM element of the Data Grid has an empty height.", "Please make sure that this element has an intrinsic height.", "The grid displays with a height of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), go.current = !0), si.width === 0 && !go.current && !li && (ho.error(["The parent DOM element of the Data Grid has an empty width.", "Please make sure that this element has an intrinsic width.", "The grid displays with a width of 0px.", "", "More details: https://mui.com/r/x-data-grid-no-dimensions."].join(`
`)), go.current = !0), ri.current) {
      ko(si), ri.current = !1;
      return;
    }
    Ko(si);
  }, [uo.autoHeight, Ko, ho]);
  useEnhancedEffect(Zo, [Zo]), useGridApiOptionHandler(Kt, "sortedRowsSet", Zo), useGridApiOptionHandler(Kt, "paginationModelChange", Zo), useGridApiOptionHandler(Kt, "columnsChange", Zo), useGridApiEventHandler(Kt, "resize", ni), useGridApiOptionHandler(Kt, "debouncedResize", uo.onResize);
}
function measureScrollbarSize(Kt, uo, ho) {
  if (ho !== void 0)
    return ho;
  if (Kt === null || uo === 0)
    return 0;
  const bo = ownerDocument(Kt).createElement("div");
  bo.style.width = "99px", bo.style.height = "99px", bo.style.position = "absolute", bo.style.overflow = "scroll", bo.className = "scrollDiv", Kt.appendChild(bo);
  const vo = bo.offsetWidth - bo.clientWidth;
  return Kt.removeChild(bo), vo;
}
function roundToDecimalPlaces(Kt, uo) {
  return Math.round(Kt * 10 ** uo) / 10 ** uo;
}
function areElementSizesEqual(Kt, uo) {
  return Kt.width === uo.width && Kt.height === uo.height;
}
const ResizeObserver$1 = typeof globalThis.ResizeObserver < "u" ? globalThis.ResizeObserver : class {
  observe() {
  }
  unobserve() {
  }
  disconnect() {
  }
}, rowsMetaStateInitializer = (Kt, uo, ho) => (ho.current.caches.rowsMeta = {
  heights: /* @__PURE__ */ new Map()
}, _extends$q({}, Kt, {
  rowsMeta: {
    currentPageTotalHeight: 0,
    positions: []
  }
})), useGridRowsMeta = (Kt, uo) => {
  const {
    getRowHeight: ho,
    getRowSpacing: go,
    getEstimatedRowHeight: bo
  } = uo, vo = Kt.current.caches.rowsMeta.heights, Po = React$1.useRef(-1), Co = React$1.useRef(!1), So = React$1.useRef(!1), wo = useGridSelector(Kt, gridDensityFactorSelector), Eo = useGridSelector(Kt, gridFilterModelSelector), Ro = useGridSelector(Kt, gridPaginationSelector), _o = useGridSelector(Kt, gridSortModelSelector), Io = useGridVisibleRows(Kt, uo), Ao = useGridSelector(Kt, gridPinnedRowsSelector), Oo = useGridSelector(Kt, () => gridDimensionsSelector(Kt.current.state).rowHeight), jo = (ai) => {
    let ri = vo.get(ai);
    return ri === void 0 && (ri = {
      content: Oo,
      spacingTop: 0,
      spacingBottom: 0,
      detail: 0,
      autoHeight: !1,
      needsFirstMeasurement: !0
    }, vo.set(ai, ri)), ri;
  }, Do = React$1.useCallback((ai) => {
    const ri = gridDimensionsSelector(Kt.current.state).rowHeight, ni = Kt.current.getRowHeightEntry(ai.id);
    if (!ho)
      ni.content = ri, ni.needsFirstMeasurement = !1;
    else {
      const si = ho(_extends$q({}, ai, {
        densityFactor: wo
      }));
      if (si === "auto") {
        if (ni.needsFirstMeasurement) {
          const li = bo ? bo(_extends$q({}, ai, {
            densityFactor: wo
          })) : ri;
          ni.content = li ?? ri;
        }
        Co.current = !0, ni.autoHeight = !0;
      } else
        ni.content = getValidRowHeight(si, ri, getRowHeightWarning), ni.needsFirstMeasurement = !1, ni.autoHeight = !1;
    }
    if (go) {
      const si = Kt.current.getRowIndexRelativeToVisibleRows(ai.id), li = go(_extends$q({}, ai, {
        isFirstVisible: si === 0,
        isLastVisible: si === Io.rows.length - 1,
        indexRelativeToCurrentPage: si
      }));
      ni.spacingTop = li.top ?? 0, ni.spacingBottom = li.bottom ?? 0;
    } else
      ni.spacingTop = 0, ni.spacingBottom = 0;
    return Kt.current.unstable_applyPipeProcessors("rowHeight", ni, ai), ni;
  }, [Kt, Io.rows.length, ho, bo, Oo, go, wo]), Lo = React$1.useCallback(() => {
    Co.current = !1, Ao.top.forEach(Do), Ao.bottom.forEach(Do);
    const ai = [], ri = Io.rows.reduce((ni, si) => {
      ai.push(ni);
      const li = Do(si), ui = li.content + li.spacingTop + li.spacingBottom + li.detail;
      return ni + ui;
    }, 0);
    Co.current || (Po.current = 1 / 0), Kt.current.setState((ni) => _extends$q({}, ni, {
      rowsMeta: {
        currentPageTotalHeight: ri,
        positions: ai
      }
    })), So.current = !0;
  }, [Kt, Ao, Io.rows, Do]), ko = (ai) => {
    var ri;
    return ((ri = vo.get(ai)) == null ? void 0 : ri.content) ?? Oo;
  }, Ko = (ai, ri) => {
    const ni = Kt.current.getRowHeightEntry(ai), si = ni.content !== ri;
    ni.needsFirstMeasurement = !1, ni.content = ri, So.current && (So.current = !si);
  }, No = (ai) => {
    var ri;
    return ((ri = vo.get(ai)) == null ? void 0 : ri.autoHeight) ?? !1;
  }, Jo = () => Po.current, ti = (ai) => {
    Co.current && ai > Po.current && (Po.current = ai);
  }, oi = () => {
    vo.clear(), Lo();
  }, Qo = useLazyRef(() => new ResizeObserver$1((ai) => {
    for (let ri = 0; ri < ai.length; ri += 1) {
      const ni = ai[ri], si = ni.borderBoxSize && ni.borderBoxSize.length > 0 ? ni.borderBoxSize[0].blockSize : ni.contentRect.height, li = ni.target.__mui_id;
      Kt.current.unstable_storeRowHeightMeasurement(li, si);
    }
    So.current || Kt.current.requestPipeProcessorsApplication("rowHeight");
  })).current, Zo = (ai, ri) => (ai.__mui_id = ri, Qo.observe(ai), () => Qo.unobserve(ai));
  useGridRegisterPipeApplier(Kt, "rowHeight", Lo), React$1.useEffect(() => {
    Lo();
  }, [Eo, Ro, _o, Lo]);
  const ei = {
    unstable_getRowHeight: ko,
    unstable_setLastMeasuredRowIndex: ti,
    unstable_storeRowHeightMeasurement: Ko,
    resetRowHeights: oi
  }, ii = {
    hydrateRowsMeta: Lo,
    observeRowHeight: Zo,
    rowHasAutoHeight: No,
    getRowHeightEntry: jo,
    getLastMeasuredRowIndex: Jo
  };
  useGridApiMethod(Kt, ei, "public"), useGridApiMethod(Kt, ii, "private");
}, useGridStatePersistence = (Kt) => {
  const uo = React$1.useCallback((bo = {}) => Kt.current.unstable_applyPipeProcessors("exportState", {}, bo), [Kt]), ho = React$1.useCallback((bo) => {
    Kt.current.unstable_applyPipeProcessors("restoreState", {
      callbacks: []
    }, {
      stateToRestore: bo
    }).callbacks.forEach((Po) => {
      Po();
    }), Kt.current.forceUpdate();
  }, [Kt]);
  useGridApiMethod(Kt, {
    exportState: uo,
    restoreState: ho
  }, "public");
}, useGridColumnSpanning = (Kt) => {
  const uo = React$1.useRef({}), ho = (Co, So) => {
    var wo;
    return (wo = uo.current[Co]) == null ? void 0 : wo[So];
  }, go = () => {
    uo.current = {};
  }, bo = React$1.useCallback(({
    rowId: Co,
    minFirstColumn: So,
    maxLastColumn: wo,
    columns: Eo
  }) => {
    for (let Ro = So; Ro < wo; Ro += 1) {
      const _o = calculateCellColSpan({
        apiRef: Kt,
        lookup: uo.current,
        columnIndex: Ro,
        rowId: Co,
        minFirstColumnIndex: So,
        maxLastColumnIndex: wo,
        columns: Eo
      });
      _o.colSpan > 1 && (Ro += _o.colSpan - 1);
    }
  }, [Kt]), vo = {
    unstable_getCellColSpanInfo: ho
  }, Po = {
    resetColSpan: go,
    calculateColSpan: bo
  };
  useGridApiMethod(Kt, vo, "public"), useGridApiMethod(Kt, Po, "private"), useGridApiEventHandler(Kt, "columnOrderChange", go);
};
function calculateCellColSpan(Kt) {
  const {
    apiRef: uo,
    lookup: ho,
    columnIndex: go,
    rowId: bo,
    minFirstColumnIndex: vo,
    maxLastColumnIndex: Po,
    columns: Co
  } = Kt, So = Co.length, wo = Co[go], Eo = uo.current.getRow(bo), Ro = uo.current.getRowValue(Eo, wo), _o = typeof wo.colSpan == "function" ? wo.colSpan(Ro, Eo, wo, uo) : wo.colSpan;
  if (!_o || _o === 1)
    return setCellColSpanInfo(ho, bo, go, {
      spannedByColSpan: !1,
      cellProps: {
        colSpan: 1,
        width: wo.computedWidth
      }
    }), {
      colSpan: 1
    };
  let Io = wo.computedWidth;
  for (let Ao = 1; Ao < _o; Ao += 1) {
    const Oo = go + Ao;
    if (Oo >= vo && Oo < Po) {
      const jo = Co[Oo];
      Io += jo.computedWidth, setCellColSpanInfo(ho, bo, go + Ao, {
        spannedByColSpan: !0,
        rightVisibleCellIndex: Math.min(go + _o, So - 1),
        leftVisibleCellIndex: go
      });
    }
    setCellColSpanInfo(ho, bo, go, {
      spannedByColSpan: !1,
      cellProps: {
        colSpan: _o,
        width: Io
      }
    });
  }
  return {
    colSpan: _o
  };
}
function setCellColSpanInfo(Kt, uo, ho, go) {
  Kt[uo] || (Kt[uo] = {}), Kt[uo][ho] = go;
}
const recurrentUnwrapGroupingColumnModel = (Kt, uo, ho) => {
  if (isLeaf(Kt)) {
    if (ho[Kt.field] !== void 0)
      throw new Error(["MUI X: columnGroupingModel contains duplicated field", `column field ${Kt.field} occurs two times in the grouping model:`, `- ${ho[Kt.field].join(" > ")}`, `- ${uo.join(" > ")}`].join(`
`));
    ho[Kt.field] = uo;
    return;
  }
  const {
    groupId: go,
    children: bo
  } = Kt;
  bo.forEach((vo) => {
    recurrentUnwrapGroupingColumnModel(vo, [...uo, go], ho);
  });
}, unwrapGroupingColumnModel = (Kt) => {
  if (!Kt)
    return {};
  const uo = {};
  return Kt.forEach((ho) => {
    recurrentUnwrapGroupingColumnModel(ho, [], uo);
  }), uo;
}, getColumnGroupsHeaderStructure = (Kt, uo, ho) => {
  const go = (So) => uo[So] ?? [], bo = [], vo = Math.max(...Kt.map((So) => go(So).length)), Po = (So, wo, Eo) => isDeepEqual(go(So).slice(0, Eo + 1), go(wo).slice(0, Eo + 1)), Co = (So, wo) => !!(ho != null && ho.left && ho.left.includes(So) && !ho.left.includes(wo) || ho != null && ho.right && !ho.right.includes(So) && ho.right.includes(wo));
  for (let So = 0; So < vo; So += 1) {
    const wo = Kt.reduce((Eo, Ro) => {
      const _o = go(Ro)[So] ?? null;
      if (Eo.length === 0)
        return [{
          columnFields: [Ro],
          groupId: _o
        }];
      const Io = Eo[Eo.length - 1], Ao = Io.columnFields[Io.columnFields.length - 1];
      return Io.groupId !== _o || !Po(Ao, Ro, So) || // Fix for https://github.com/mui/mui-x/issues/7041
      Co(Ao, Ro) ? [...Eo, {
        columnFields: [Ro],
        groupId: _o
      }] : [...Eo.slice(0, Eo.length - 1), {
        columnFields: [...Io.columnFields, Ro],
        groupId: _o
      }];
    }, []);
    bo.push(wo);
  }
  return bo;
}, _excluded$l = ["groupId", "children"], createGroupLookup = (Kt) => {
  let uo = {};
  return Kt.forEach((ho) => {
    if (isLeaf(ho))
      return;
    const {
      groupId: go,
      children: bo
    } = ho, vo = _objectWithoutPropertiesLoose$h(ho, _excluded$l);
    if (!go)
      throw new Error("MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.");
    process.env.NODE_ENV !== "production" && (bo || console.warn(`MUI X: group groupId=${go} has no children.`));
    const Po = _extends$q({}, vo, {
      groupId: go
    }), Co = createGroupLookup(bo);
    if (Co[go] !== void 0 || uo[go] !== void 0)
      throw new Error(`MUI X: The groupId ${go} is used multiple times in the columnGroupingModel.`);
    uo = _extends$q({}, uo, Co, {
      [go]: Po
    });
  }), _extends$q({}, uo);
}, columnGroupsStateInitializer = (Kt, uo, ho) => {
  if (!uo.columnGroupingModel)
    return Kt;
  const go = gridColumnFieldsSelector(ho), bo = gridVisibleColumnFieldsSelector(ho), vo = createGroupLookup(uo.columnGroupingModel ?? []), Po = unwrapGroupingColumnModel(uo.columnGroupingModel ?? []), Co = getColumnGroupsHeaderStructure(go, Po, ho.current.state.pinnedColumns ?? {}), So = bo.length === 0 ? 0 : Math.max(...bo.map((wo) => {
    var Eo;
    return ((Eo = Po[wo]) == null ? void 0 : Eo.length) ?? 0;
  }));
  return _extends$q({}, Kt, {
    columnGrouping: {
      lookup: vo,
      unwrappedGroupingModel: Po,
      headerStructure: Co,
      maxDepth: So
    }
  });
}, useGridColumnGrouping = (Kt, uo) => {
  const ho = React$1.useCallback((Co) => gridColumnGroupsUnwrappedModelSelector(Kt)[Co] ?? [], [Kt]), go = React$1.useCallback(() => gridColumnGroupsLookupSelector(Kt), [Kt]);
  useGridApiMethod(Kt, {
    getColumnGroupPath: ho,
    getAllGroupDetails: go
  }, "public");
  const vo = React$1.useCallback(() => {
    const Co = unwrapGroupingColumnModel(uo.columnGroupingModel ?? []);
    Kt.current.setState((So) => {
      var _o;
      const wo = ((_o = So.columns) == null ? void 0 : _o.orderedFields) ?? [], Eo = So.pinnedColumns ?? {}, Ro = getColumnGroupsHeaderStructure(wo, Co, Eo);
      return _extends$q({}, So, {
        columnGrouping: _extends$q({}, So.columnGrouping, {
          headerStructure: Ro
        })
      });
    });
  }, [Kt, uo.columnGroupingModel]), Po = React$1.useCallback((Co) => {
    var Oo, jo;
    const So = ((jo = (Oo = Kt.current).getPinnedColumns) == null ? void 0 : jo.call(Oo)) ?? {}, wo = gridColumnFieldsSelector(Kt), Eo = gridVisibleColumnFieldsSelector(Kt), Ro = createGroupLookup(Co ?? []), _o = unwrapGroupingColumnModel(Co ?? []), Io = getColumnGroupsHeaderStructure(wo, _o, So), Ao = Eo.length === 0 ? 0 : Math.max(...Eo.map((Do) => {
      var Lo;
      return ((Lo = _o[Do]) == null ? void 0 : Lo.length) ?? 0;
    }));
    Kt.current.setState((Do) => _extends$q({}, Do, {
      columnGrouping: {
        lookup: Ro,
        unwrappedGroupingModel: _o,
        headerStructure: Io,
        maxDepth: Ao
      }
    }));
  }, [Kt]);
  useGridApiEventHandler(Kt, "columnIndexChange", vo), useGridApiEventHandler(Kt, "columnsChange", () => {
    Po(uo.columnGroupingModel);
  }), useGridApiEventHandler(Kt, "columnVisibilityModelChange", () => {
    Po(uo.columnGroupingModel);
  }), React$1.useEffect(() => {
    Po(uo.columnGroupingModel);
  }, [Po, uo.columnGroupingModel]);
};
function createControllablePromise() {
  let Kt, uo;
  const ho = new Promise((go, bo) => {
    Kt = go, uo = bo;
  });
  return ho.resolve = Kt, ho.reject = uo, ho;
}
function trackFinger(Kt, uo) {
  if (uo !== void 0 && Kt.changedTouches) {
    for (let ho = 0; ho < Kt.changedTouches.length; ho += 1) {
      const go = Kt.changedTouches[ho];
      if (go.identifier === uo)
        return {
          x: go.clientX,
          y: go.clientY
        };
    }
    return !1;
  }
  return {
    x: Kt.clientX,
    y: Kt.clientY
  };
}
function computeNewWidth(Kt, uo, ho, go) {
  let bo = Kt;
  return go === "Right" ? bo += uo - ho.left : bo += ho.right - uo, bo;
}
function computeOffsetToSeparator(Kt, uo, ho) {
  return ho === "Left" ? Kt - uo.left : uo.right - Kt;
}
function flipResizeDirection(Kt) {
  return Kt === "Right" ? "Left" : "Right";
}
function getResizeDirection(Kt, uo) {
  const ho = Kt.classList.contains(gridClasses["columnSeparator--sideRight"]) ? "Right" : "Left";
  return uo ? flipResizeDirection(ho) : ho;
}
function preventClick(Kt) {
  Kt.preventDefault(), Kt.stopImmediatePropagation();
}
function useColumnVirtualizationDisabled(Kt) {
  const uo = React$1.useRef(), ho = () => gridVirtualizationColumnEnabledSelector(Kt), go = useGridSelector(Kt, ho);
  return React$1.useEffect(() => {
    uo.current && go === !1 && (uo.current.resolve(), uo.current = void 0);
  }), () => {
    if (!uo.current) {
      if (ho() === !1)
        return Promise.resolve();
      uo.current = createControllablePromise();
    }
    return uo.current;
  };
}
function excludeOutliers(Kt, uo) {
  if (Kt.length < 4)
    return Kt;
  const ho = Kt.slice();
  ho.sort((Co, So) => Co - So);
  const go = ho[Math.floor(ho.length * 0.25)], bo = ho[Math.floor(ho.length * 0.75) - 1], vo = bo - go, Po = vo < 5 ? 5 : vo * uo;
  return ho.filter((Co) => Co > go - Po && Co < bo + Po);
}
function extractColumnWidths(Kt, uo, ho) {
  const go = {}, bo = Kt.current.rootElementRef.current;
  return bo.classList.add(gridClasses.autosizing), ho.forEach((vo) => {
    const Co = findGridCells(Kt.current, vo.field).map((Ao) => Ao.getBoundingClientRect().width ?? 0), So = uo.includeOutliers ? Co : excludeOutliers(Co, uo.outliersFactor);
    if (uo.includeHeaders) {
      const Ao = findGridHeader(Kt.current, vo.field);
      if (Ao) {
        const Oo = Ao.querySelector(`.${gridClasses.columnHeaderTitle}`), jo = Ao.querySelector(`.${gridClasses.columnHeaderTitleContainerContent}`), Do = Ao.querySelector(`.${gridClasses.iconButtonContainer}`), Lo = Ao.querySelector(`.${gridClasses.menuIcon}`), ko = Oo ?? jo, Ko = window.getComputedStyle(Ao, null), No = parseInt(Ko.paddingLeft, 10) + parseInt(Ko.paddingRight, 10), ti = ko.scrollWidth + 1 + No + ((Do == null ? void 0 : Do.clientWidth) ?? 0) + ((Lo == null ? void 0 : Lo.clientWidth) ?? 0);
        So.push(ti);
      }
    }
    const wo = vo.minWidth !== -1 / 0 && vo.minWidth !== void 0, Eo = vo.maxWidth !== 1 / 0 && vo.maxWidth !== void 0, Ro = wo ? vo.minWidth : 0, _o = Eo ? vo.maxWidth : 1 / 0, Io = So.length === 0 ? 0 : Math.max(...So);
    go[vo.field] = clamp$1(Io, Ro, _o);
  }), bo.classList.remove(gridClasses.autosizing), go;
}
const columnResizeStateInitializer = (Kt) => _extends$q({}, Kt, {
  columnResize: {
    resizingColumnField: ""
  }
});
function createResizeRefs() {
  return {
    colDef: void 0,
    initialColWidth: 0,
    initialTotalWidth: 0,
    previousMouseClickEvent: void 0,
    columnHeaderElement: void 0,
    headerFilterElement: void 0,
    groupHeaderElements: [],
    cellElements: [],
    leftPinnedCellsAfter: [],
    rightPinnedCellsBefore: [],
    fillerLeft: void 0,
    fillerRight: void 0,
    leftPinnedHeadersAfter: [],
    rightPinnedHeadersBefore: []
  };
}
const useGridColumnResize = (Kt, uo) => {
  const ho = useRtl(), go = useGridLogger(Kt, "useGridColumnResize"), bo = useLazyRef(createResizeRefs).current, vo = React$1.useRef(), Po = React$1.useRef(), Co = useTimeout(), So = React$1.useRef(), wo = (Qo) => {
    var si, li;
    go.debug(`Updating width to ${Qo} for col ${bo.colDef.field}`);
    const Zo = bo.columnHeaderElement.offsetWidth, ei = Qo - Zo, ii = Qo - bo.initialColWidth, ai = bo.initialTotalWidth + ii;
    (li = (si = Kt.current.rootElementRef) == null ? void 0 : si.current) == null || li.style.setProperty("--DataGrid-rowWidth", `${ai}px`), bo.colDef.computedWidth = Qo, bo.colDef.width = Qo, bo.colDef.flex = 0, bo.columnHeaderElement.style.width = `${Qo}px`;
    const ri = bo.headerFilterElement;
    ri && (ri.style.width = `${Qo}px`), bo.groupHeaderElements.forEach((ui) => {
      const ci = ui;
      let fi;
      ci.getAttribute("aria-colspan") === "1" ? fi = `${Qo}px` : fi = `${ci.offsetWidth + ei}px`, ci.style.width = fi;
    }), bo.cellElements.forEach((ui) => {
      const ci = ui;
      let fi;
      ci.getAttribute("aria-colspan") === "1" ? fi = `${Qo}px` : fi = `${ci.offsetWidth + ei}px`, ci.style.setProperty("--width", fi);
    });
    const ni = Kt.current.unstable_applyPipeProcessors("isColumnPinned", !1, bo.colDef.field);
    ni === GridPinnedColumnPosition.LEFT && (updateProperty(bo.fillerLeft, "width", ei), bo.leftPinnedCellsAfter.forEach((ui) => {
      updateProperty(ui, "left", ei);
    }), bo.leftPinnedHeadersAfter.forEach((ui) => {
      updateProperty(ui, "left", ei);
    })), ni === GridPinnedColumnPosition.RIGHT && (updateProperty(bo.fillerRight, "width", ei), bo.rightPinnedCellsBefore.forEach((ui) => {
      updateProperty(ui, "right", ei);
    }), bo.rightPinnedHeadersBefore.forEach((ui) => {
      updateProperty(ui, "right", ei);
    }));
  }, Eo = (Qo) => {
    if (Do(), bo.previousMouseClickEvent) {
      const Zo = bo.previousMouseClickEvent, ei = Zo.timeStamp, ii = Zo.clientX, ai = Zo.clientY;
      if (Qo.timeStamp - ei < 300 && Qo.clientX === ii && Qo.clientY === ai) {
        bo.previousMouseClickEvent = void 0, Kt.current.publishEvent("columnResizeStop", null, Qo);
        return;
      }
    }
    if (bo.colDef) {
      Kt.current.setColumnWidth(bo.colDef.field, bo.colDef.width), go.debug(`Updating col ${bo.colDef.field} with new width: ${bo.colDef.width}`);
      const Zo = gridColumnsStateSelector(Kt.current.state);
      bo.groupHeaderElements.forEach((ei) => {
        const ii = getFieldsFromGroupHeaderElem(ei), ai = ei, ni = `${ii.reduce((si, li) => Zo.columnVisibilityModel[li] !== !1 ? si + Zo.lookup[li].computedWidth : si, 0)}px`;
        ai.style.width = ni;
      });
    }
    Co.start(0, () => {
      Kt.current.publishEvent("columnResizeStop", null, Qo);
    });
  }, Ro = (Qo, Zo, ei) => {
    var ni;
    const ii = Kt.current.rootElementRef.current;
    bo.initialColWidth = Qo.computedWidth, bo.initialTotalWidth = Kt.current.getRootDimensions().rowWidth, bo.colDef = Qo, bo.columnHeaderElement = findHeaderElementFromField(Kt.current.columnHeadersContainerRef.current, Qo.field);
    const ai = ii.querySelector(`.${gridClasses.headerFilterRow} [data-field="${escapeOperandAttributeSelector(Qo.field)}"]`);
    ai && (bo.headerFilterElement = ai), bo.groupHeaderElements = findGroupHeaderElementsFromField((ni = Kt.current.columnHeadersContainerRef) == null ? void 0 : ni.current, Qo.field), bo.cellElements = findGridCellElementsFromCol(bo.columnHeaderElement, Kt.current), bo.fillerLeft = findGridElement(Kt.current, ho ? "filler--pinnedRight" : "filler--pinnedLeft"), bo.fillerRight = findGridElement(Kt.current, ho ? "filler--pinnedLeft" : "filler--pinnedRight");
    const ri = Kt.current.unstable_applyPipeProcessors("isColumnPinned", !1, bo.colDef.field);
    bo.leftPinnedCellsAfter = ri !== GridPinnedColumnPosition.LEFT ? [] : findLeftPinnedCellsAfterCol(Kt.current, bo.columnHeaderElement, ho), bo.rightPinnedCellsBefore = ri !== GridPinnedColumnPosition.RIGHT ? [] : findRightPinnedCellsBeforeCol(Kt.current, bo.columnHeaderElement, ho), bo.leftPinnedHeadersAfter = ri !== GridPinnedColumnPosition.LEFT ? [] : findLeftPinnedHeadersAfterCol(Kt.current, bo.columnHeaderElement, ho), bo.rightPinnedHeadersBefore = ri !== GridPinnedColumnPosition.RIGHT ? [] : findRightPinnedHeadersBeforeCol(Kt.current, bo.columnHeaderElement, ho), Po.current = getResizeDirection(Zo, ho), vo.current = computeOffsetToSeparator(ei, bo.columnHeaderElement.getBoundingClientRect(), Po.current);
  }, _o = useEventCallback(Eo), Io = useEventCallback((Qo) => {
    if (Qo.buttons === 0) {
      _o(Qo);
      return;
    }
    let Zo = computeNewWidth(vo.current, Qo.clientX, bo.columnHeaderElement.getBoundingClientRect(), Po.current);
    Zo = clamp$1(Zo, bo.colDef.minWidth, bo.colDef.maxWidth), wo(Zo);
    const ei = {
      element: bo.columnHeaderElement,
      colDef: bo.colDef,
      width: Zo
    };
    Kt.current.publishEvent("columnResize", ei, Qo);
  }), Ao = useEventCallback((Qo) => {
    trackFinger(Qo, So.current) && Eo(Qo);
  }), Oo = useEventCallback((Qo) => {
    const Zo = trackFinger(Qo, So.current);
    if (!Zo)
      return;
    if (Qo.type === "mousemove" && Qo.buttons === 0) {
      Ao(Qo);
      return;
    }
    let ei = computeNewWidth(vo.current, Zo.x, bo.columnHeaderElement.getBoundingClientRect(), Po.current);
    ei = clamp$1(ei, bo.colDef.minWidth, bo.colDef.maxWidth), wo(ei);
    const ii = {
      element: bo.columnHeaderElement,
      colDef: bo.colDef,
      width: ei
    };
    Kt.current.publishEvent("columnResize", ii, Qo);
  }), jo = useEventCallback((Qo) => {
    const Zo = findParentElementFromClassName(Qo.target, gridClasses["columnSeparator--resizable"]);
    if (!Zo)
      return;
    const ei = Qo.changedTouches[0];
    ei != null && (So.current = ei.identifier);
    const ii = findParentElementFromClassName(Qo.target, gridClasses.columnHeader), ai = getFieldFromHeaderElem(ii), ri = Kt.current.getColumn(ai);
    go.debug(`Start Resize on col ${ri.field}`), Kt.current.publishEvent("columnResizeStart", {
      field: ai
    }, Qo), Ro(ri, Zo, ei.clientX);
    const ni = ownerDocument(Qo.currentTarget);
    ni.addEventListener("touchmove", Oo), ni.addEventListener("touchend", Ao);
  }), Do = React$1.useCallback(() => {
    const Qo = ownerDocument(Kt.current.rootElementRef.current);
    Qo.body.style.removeProperty("cursor"), Qo.removeEventListener("mousemove", Io), Qo.removeEventListener("mouseup", _o), Qo.removeEventListener("touchmove", Oo), Qo.removeEventListener("touchend", Ao), setTimeout(() => {
      Qo.removeEventListener("click", preventClick, !0);
    }, 100), bo.columnHeaderElement && (bo.columnHeaderElement.style.pointerEvents = "unset");
  }, [Kt, bo, Io, _o, Oo, Ao]), Lo = React$1.useCallback(({
    field: Qo
  }) => {
    Kt.current.setState((Zo) => _extends$q({}, Zo, {
      columnResize: _extends$q({}, Zo.columnResize, {
        resizingColumnField: Qo
      })
    })), Kt.current.forceUpdate();
  }, [Kt]), ko = React$1.useCallback(() => {
    Kt.current.setState((Qo) => _extends$q({}, Qo, {
      columnResize: _extends$q({}, Qo.columnResize, {
        resizingColumnField: ""
      })
    })), Kt.current.forceUpdate();
  }, [Kt]), Ko = useEventCallback(({
    colDef: Qo
  }, Zo) => {
    if (Zo.button !== 0 || !Zo.currentTarget.classList.contains(gridClasses["columnSeparator--resizable"]))
      return;
    Zo.preventDefault(), go.debug(`Start Resize on col ${Qo.field}`), Kt.current.publishEvent("columnResizeStart", {
      field: Qo.field
    }, Zo), Ro(Qo, Zo.currentTarget, Zo.clientX);
    const ei = ownerDocument(Kt.current.rootElementRef.current);
    ei.body.style.cursor = "col-resize", bo.previousMouseClickEvent = Zo.nativeEvent, ei.addEventListener("mousemove", Io), ei.addEventListener("mouseup", _o), ei.addEventListener("click", preventClick, !0);
  }), No = useEventCallback((Qo, Zo) => {
    if (uo.disableAutosize || Zo.button !== 0)
      return;
    const ei = Kt.current.state.columns.lookup[Qo.field];
    ei.resizable !== !1 && Kt.current.autosizeColumns(_extends$q({}, uo.autosizeOptions, {
      disableColumnVirtualization: !1,
      columns: [ei.field]
    }));
  }), Jo = useColumnVirtualizationDisabled(Kt), ti = React$1.useRef(!1), oi = React$1.useCallback(async (Qo) => {
    var ri;
    if (!((ri = Kt.current.rootElementRef) == null ? void 0 : ri.current) || ti.current)
      return;
    ti.current = !0;
    const ei = gridColumnsStateSelector(Kt.current.state), ii = _extends$q({}, DEFAULT_GRID_AUTOSIZE_OPTIONS, Qo, {
      columns: (Qo == null ? void 0 : Qo.columns) ?? ei.orderedFields
    });
    ii.columns = ii.columns.filter((ni) => ei.columnVisibilityModel[ni] !== !1);
    const ai = ii.columns.map((ni) => Kt.current.state.columns.lookup[ni]);
    try {
      !uo.disableVirtualization && ii.disableColumnVirtualization && (Kt.current.unstable_setColumnVirtualization(!1), await Jo());
      const ni = extractColumnWidths(Kt, ii, ai), si = ai.map((li) => _extends$q({}, li, {
        width: ni[li.field],
        computedWidth: ni[li.field],
        flex: 0
      }));
      if (ii.expand) {
        const ui = ei.orderedFields.map((yi) => ei.lookup[yi]).filter((yi) => ei.columnVisibilityModel[yi.field] !== !1).reduce((yi, hi) => yi + (ni[hi.field] ?? hi.computedWidth ?? hi.width), 0), fi = Kt.current.getRootDimensions().viewportInnerSize.width - ui;
        if (fi > 0) {
          const yi = fi / (si.length || 1);
          si.forEach((hi) => {
            hi.width += yi, hi.computedWidth += yi;
          });
        }
      }
      Kt.current.updateColumns(si), si.forEach((li, ui) => {
        if (li.width !== ai[ui].width) {
          const ci = li.width;
          Kt.current.publishEvent("columnWidthChange", {
            element: Kt.current.getColumnHeaderElement(li.field),
            colDef: li,
            width: ci
          });
        }
      });
    } finally {
      uo.disableVirtualization || Kt.current.unstable_setColumnVirtualization(!0), ti.current = !1;
    }
  }, [Kt, Jo, uo.disableVirtualization]);
  React$1.useEffect(() => Do, [Do]), useOnMount(() => {
    uo.autosizeOnMount && Promise.resolve().then(() => {
      Kt.current.autosizeColumns(uo.autosizeOptions);
    });
  }), useGridNativeEventListener(Kt, () => {
    var Qo;
    return (Qo = Kt.current.columnHeadersContainerRef) == null ? void 0 : Qo.current;
  }, "touchstart", jo, {
    passive: !0
  }), useGridApiMethod(Kt, {
    autosizeColumns: oi
  }, "public"), useGridApiEventHandler(Kt, "columnResizeStop", ko), useGridApiEventHandler(Kt, "columnResizeStart", Lo), useGridApiEventHandler(Kt, "columnSeparatorMouseDown", Ko), useGridApiEventHandler(Kt, "columnSeparatorDoubleClick", No), useGridApiOptionHandler(Kt, "columnResize", uo.onColumnResize), useGridApiOptionHandler(Kt, "columnWidthChange", uo.onColumnWidthChange);
};
function updateProperty(Kt, uo, ho) {
  Kt && (Kt.style[uo] = `${parseInt(Kt.style[uo], 10) + ho}px`);
}
function getUnprocessedRange(Kt, uo) {
  return Kt.firstRowIndex >= uo.firstRowIndex && Kt.lastRowIndex <= uo.lastRowIndex ? null : Kt.firstRowIndex >= uo.firstRowIndex && Kt.lastRowIndex > uo.lastRowIndex ? {
    firstRowIndex: uo.lastRowIndex,
    lastRowIndex: Kt.lastRowIndex
  } : Kt.firstRowIndex < uo.firstRowIndex && Kt.lastRowIndex <= uo.lastRowIndex ? {
    firstRowIndex: Kt.firstRowIndex,
    lastRowIndex: uo.firstRowIndex - 1
  } : Kt;
}
function isRowContextInitialized(Kt) {
  return Kt.firstRowIndex !== 0 || Kt.lastRowIndex !== 0;
}
function isRowRangeUpdated(Kt, uo) {
  return Kt.firstRowIndex !== uo.firstRowIndex || Kt.lastRowIndex !== uo.lastRowIndex;
}
const getCellValue = (Kt, uo, ho) => {
  if (!Kt)
    return null;
  let go = Kt[uo.field];
  const bo = uo.rowSpanValueGetter ?? uo.valueGetter;
  return bo && (go = bo(go, Kt, uo, ho)), go;
}, EMPTY_STATE = {
  spannedCells: {},
  hiddenCells: {},
  hiddenCellOriginMap: {}
}, EMPTY_RANGE = {
  firstRowIndex: 0,
  lastRowIndex: 0
}, skippedFields = /* @__PURE__ */ new Set([GRID_CHECKBOX_SELECTION_FIELD, "__reorder__", GRID_DETAIL_PANEL_TOGGLE_FIELD]), DEFAULT_ROWS_TO_PROCESS = 20, computeRowSpanningState = (Kt, uo, ho, go, bo, vo, Po) => {
  const Co = vo ? {} : _extends$q({}, Kt.current.state.rowSpanning.spannedCells), So = vo ? {} : _extends$q({}, Kt.current.state.rowSpanning.hiddenCells), wo = vo ? {} : _extends$q({}, Kt.current.state.rowSpanning.hiddenCellOriginMap);
  return vo && (Po = EMPTY_RANGE), uo.forEach((Eo) => {
    var Ro;
    if (!skippedFields.has(Eo.field)) {
      for (let _o = bo.firstRowIndex; _o < bo.lastRowIndex; _o += 1) {
        const Io = ho[_o];
        if ((Ro = So[Io.id]) != null && Ro[Eo.field])
          continue;
        const Ao = getCellValue(Io.model, Eo, Kt);
        if (Ao == null)
          continue;
        let Oo = Io.id, jo = _o, Do = 0;
        const Lo = [];
        if (_o === bo.firstRowIndex) {
          let Ko = _o - 1;
          const No = ho[Ko];
          for (; Ko >= go.firstRowIndex && getCellValue(No.model, Eo, Kt) === Ao; ) {
            const Jo = ho[Ko + 1];
            So[Jo.id] ? So[Jo.id][Eo.field] = !0 : So[Jo.id] = {
              [Eo.field]: !0
            }, Lo.push(_o), Do += 1, Oo = No.id, jo = Ko, Ko -= 1;
          }
        }
        Lo.forEach((Ko) => {
          wo[Ko] ? wo[Ko][Eo.field] = jo : wo[Ko] = {
            [Eo.field]: jo
          };
        });
        let ko = _o + 1;
        for (; ko <= go.lastRowIndex && ho[ko] && getCellValue(ho[ko].model, Eo, Kt) === Ao; ) {
          const Ko = ho[ko];
          So[Ko.id] ? So[Ko.id][Eo.field] = !0 : So[Ko.id] = {
            [Eo.field]: !0
          }, wo[ko] ? wo[ko][Eo.field] = jo : wo[ko] = {
            [Eo.field]: jo
          }, ko += 1, Do += 1;
        }
        Do > 0 && (Co[Oo] ? Co[Oo][Eo.field] = Do + 1 : Co[Oo] = {
          [Eo.field]: Do + 1
        });
      }
      Po = {
        firstRowIndex: Math.min(Po.firstRowIndex, bo.firstRowIndex),
        lastRowIndex: Math.max(Po.lastRowIndex, bo.lastRowIndex)
      };
    }
  }), {
    spannedCells: Co,
    hiddenCells: So,
    hiddenCellOriginMap: wo,
    processedRange: Po
  };
}, rowSpanningStateInitializer = (Kt, uo, ho) => {
  var go;
  if (uo.unstable_rowSpanning) {
    const bo = Kt.rows.dataRowIds || [], vo = Kt.columns.orderedFields || [], Po = Kt.rows.dataRowIdToModelLookup, Co = Kt.columns.lookup, So = !!Kt.filter.filterModel.items.length || !!((go = Kt.filter.filterModel.quickFilterValues) != null && go.length);
    if (!bo.length || !vo.length || !Po || !Co || So)
      return _extends$q({}, Kt, {
        rowSpanning: EMPTY_STATE
      });
    const wo = {
      firstRowIndex: 0,
      lastRowIndex: Math.min(DEFAULT_ROWS_TO_PROCESS, Math.max(bo.length, 0))
    }, Eo = bo.map((Oo) => ({
      id: Oo,
      model: Po[Oo]
    })), Ro = vo.map((Oo) => Co[Oo]), {
      spannedCells: _o,
      hiddenCells: Io,
      hiddenCellOriginMap: Ao
    } = computeRowSpanningState(ho, Ro, Eo, wo, wo, !0, EMPTY_RANGE);
    return _extends$q({}, Kt, {
      rowSpanning: {
        spannedCells: _o,
        hiddenCells: Io,
        hiddenCellOriginMap: Ao
      }
    });
  }
  return _extends$q({}, Kt, {
    rowSpanning: EMPTY_STATE
  });
}, useGridRowSpanning = (Kt, uo) => {
  const {
    range: ho,
    rows: go
  } = useGridVisibleRows(Kt, uo), bo = useGridSelector(Kt, gridRenderContextSelector), vo = useGridSelector(Kt, gridVisibleColumnDefinitionsSelector), Po = useGridSelector(Kt, gridRowTreeSelector), Co = useLazyRef(() => Object.keys(Kt.current.state.rowSpanning.spannedCells).length > 0 ? {
    firstRowIndex: 0,
    lastRowIndex: Math.min(DEFAULT_ROWS_TO_PROCESS, Math.max(Kt.current.state.rows.dataRowIds.length, 0))
  } : EMPTY_RANGE), So = React$1.useRef(EMPTY_RANGE), wo = React$1.useCallback(
    // A reset needs to occur when:
    // - The `unstable_rowSpanning` prop is updated (feature flag)
    // - The filtering is applied
    // - The sorting is applied
    // - The `paginationModel` is updated
    // - The rows are updated
    (Ao = !0) => {
      if (!uo.unstable_rowSpanning) {
        Kt.current.state.rowSpanning !== EMPTY_STATE && Kt.current.setState((Qo) => _extends$q({}, Qo, {
          rowSpanning: EMPTY_STATE
        }));
        return;
      }
      if (ho === null || !isRowContextInitialized(bo))
        return;
      Ao && (Co.current = EMPTY_RANGE);
      const Oo = getUnprocessedRange({
        firstRowIndex: bo.firstRowIndex,
        lastRowIndex: Math.min(bo.lastRowIndex, ho.lastRowIndex + 1)
      }, Co.current);
      if (Oo === null)
        return;
      const {
        spannedCells: jo,
        hiddenCells: Do,
        hiddenCellOriginMap: Lo,
        processedRange: ko
      } = computeRowSpanningState(Kt, vo, go, ho, Oo, Ao, Co.current);
      Co.current = ko;
      const Ko = Object.keys(jo).length, No = Object.keys(Do).length, Jo = Object.keys(Kt.current.state.rowSpanning.spannedCells).length, ti = Object.keys(Kt.current.state.rowSpanning.hiddenCells).length;
      (Ao || Ko !== Jo || No !== ti) && Kt.current.setState((Qo) => _extends$q({}, Qo, {
        rowSpanning: {
          spannedCells: jo,
          hiddenCells: Do,
          hiddenCellOriginMap: Lo
        }
      }));
    },
    [Kt, uo.unstable_rowSpanning, ho, bo, go, vo, Co]
  ), Eo = React$1.useRef(bo), Ro = React$1.useRef(!0), _o = React$1.useRef(!1), Io = React$1.useRef(Po);
  React$1.useEffect(() => {
    const Ao = Ro.current;
    if (Ro.current && (Ro.current = !1), Po !== Io.current) {
      Io.current = Po, wo(!0);
      return;
    }
    if (ho && So.current && isRowRangeUpdated(ho, So.current) && (So.current = ho, _o.current = !0), !Ao && Eo.current !== bo) {
      isRowRangeUpdated(Eo.current, bo) && (wo(_o.current), _o.current = !1), Eo.current = bo;
      return;
    }
    wo();
  }, [wo, bo, ho, So, Po]);
}, listViewStateInitializer = (Kt, uo, ho) => _extends$q({}, Kt, {
  listViewColumn: uo.unstable_listColumn ? _extends$q({}, uo.unstable_listColumn, {
    computedWidth: getListColumnWidth(ho)
  }) : void 0
});
function useGridListView(Kt, uo) {
  const ho = () => {
    Kt.current.setState((vo) => vo.listViewColumn ? _extends$q({}, vo, {
      listViewColumn: _extends$q({}, vo.listViewColumn, {
        computedWidth: getListColumnWidth(Kt)
      })
    }) : vo);
  }, go = React$1.useRef(null);
  useGridApiEventHandler(Kt, "viewportInnerSizeChange", (vo) => {
    go.current !== vo.width && (go.current = vo.width, ho());
  }), useGridApiEventHandler(Kt, "columnVisibilityModelChange", ho), React$1.useEffect(() => {
    const vo = uo.unstable_listColumn;
    vo && Kt.current.setState((Po) => _extends$q({}, Po, {
      listViewColumn: _extends$q({}, vo, {
        computedWidth: getListColumnWidth(Kt)
      })
    }));
  }, [Kt, uo.unstable_listColumn]), React$1.useEffect(() => {
    uo.unstable_listView && !uo.unstable_listColumn && warnOnce(["MUI X: The `unstable_listColumn` prop must be set if `unstable_listView` is enabled.", 'To fix, pass a column definition to the `unstable_listColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.', "For more details, see https://mui.com/x/react-data-grid/list-view/"]);
  }, [uo.unstable_listView, uo.unstable_listColumn]);
}
function getListColumnWidth(Kt) {
  return gridDimensionsSelector(Kt.current.state).viewportInnerSize.width;
}
const useDataGridComponent = (Kt, uo) => {
  const ho = useGridInitialization(Kt, uo);
  return useGridRowSelectionPreProcessors(ho, uo), useGridRowsPreProcessors(ho), useGridInitializeState(dimensionsStateInitializer, ho, uo), useGridInitializeState(rowSelectionStateInitializer, ho, uo), useGridInitializeState(columnsStateInitializer, ho, uo), useGridInitializeState(rowsStateInitializer, ho, uo), useGridInitializeState(editingStateInitializer, ho, uo), useGridInitializeState(focusStateInitializer, ho, uo), useGridInitializeState(sortingStateInitializer, ho, uo), useGridInitializeState(preferencePanelStateInitializer, ho, uo), useGridInitializeState(filterStateInitializer, ho, uo), useGridInitializeState(rowSpanningStateInitializer, ho, uo), useGridInitializeState(densityStateInitializer, ho, uo), useGridInitializeState(columnResizeStateInitializer, ho, uo), useGridInitializeState(paginationStateInitializer, ho, uo), useGridInitializeState(rowsMetaStateInitializer, ho, uo), useGridInitializeState(columnMenuStateInitializer, ho, uo), useGridInitializeState(columnGroupsStateInitializer, ho, uo), useGridInitializeState(virtualizationStateInitializer, ho, uo), useGridInitializeState(listViewStateInitializer, ho, uo), useGridKeyboardNavigation(ho, uo), useGridRowSelection(ho, uo), useGridColumns(ho, uo), useGridRows(ho, uo), useGridRowSpanning(ho, uo), useGridParamsApi(ho, uo), useGridColumnSpanning(ho), useGridColumnGrouping(ho, uo), useGridEditing(ho, uo), useGridFocus(ho, uo), useGridPreferencesPanel(ho, uo), useGridFilter(ho, uo), useGridSorting(ho, uo), useGridDensity(ho, uo), useGridColumnResize(ho, uo), useGridPagination(ho, uo), useGridRowsMeta(ho, uo), useGridScroll(ho, uo), useGridColumnMenu(ho), useGridCsvExport(ho, uo), useGridPrintExport(ho, uo), useGridClipboard(ho, uo), useGridDimensions(ho, uo), useGridEvents(ho, uo), useGridStatePersistence(ho), useGridVirtualization(ho, uo), useGridListView(ho, uo), ho;
}, useUtilityClasses$f = (Kt) => {
  const {
    classes: uo,
    headerAlign: ho,
    isDragging: go,
    isLastColumn: bo,
    showLeftBorder: vo,
    showRightBorder: Po,
    groupId: Co,
    pinnedPosition: So
  } = Kt;
  return composeClasses({
    root: ["columnHeader", ho === "left" && "columnHeader--alignLeft", ho === "center" && "columnHeader--alignCenter", ho === "right" && "columnHeader--alignRight", go && "columnHeader--moving", Po && "columnHeader--withRightBorder", vo && "columnHeader--withLeftBorder", "withBorderColor", Co === null ? "columnHeader--emptyGroup" : "columnHeader--filledGroup", So === "left" && "columnHeader--pinnedLeft", So === "right" && "columnHeader--pinnedRight", bo && "columnHeader--last"],
    draggableContainer: ["columnHeaderDraggableContainer"],
    titleContainer: ["columnHeaderTitleContainer", "withBorderColor"],
    titleContainerContent: ["columnHeaderTitleContainerContent"]
  }, getDataGridUtilityClass, uo);
};
function GridColumnGroupHeader(Kt) {
  var yi;
  const {
    groupId: uo,
    width: ho,
    depth: go,
    maxDepth: bo,
    fields: vo,
    height: Po,
    colIndex: Co,
    hasFocus: So,
    tabIndex: wo,
    isLastColumn: Eo,
    pinnedPosition: Ro,
    style: _o,
    indexInSection: Io,
    sectionLength: Ao,
    gridHasFiller: Oo
  } = Kt, jo = useGridRootProps(), Do = React$1.useRef(null), Lo = useGridApiContext(), ko = useGridSelector(Lo, gridColumnGroupsLookupSelector), Ko = uo ? ko[uo] : {}, {
    headerName: No = uo ?? "",
    description: Jo = "",
    headerAlign: ti = void 0
  } = Ko;
  let oi;
  const Qo = uo && ((yi = ko[uo]) == null ? void 0 : yi.renderHeaderGroup), Zo = React$1.useMemo(() => ({
    groupId: uo,
    headerName: No,
    description: Jo,
    depth: go,
    maxDepth: bo,
    fields: vo,
    colIndex: Co,
    isLastColumn: Eo
  }), [uo, No, Jo, go, bo, vo, Co, Eo]);
  uo && Qo && (oi = Qo(Zo));
  const ei = shouldCellShowLeftBorder(Ro, Io), ii = shouldCellShowRightBorder(Ro, Io, Ao, jo.showColumnVerticalBorder, Oo), ai = _extends$q({}, Kt, {
    classes: jo.classes,
    showLeftBorder: ei,
    showRightBorder: ii,
    headerAlign: ti,
    depth: go,
    isDragging: !1
  }), ri = No ?? uo, ni = useId(), si = uo === null ? `empty-group-cell-${ni}` : uo, li = useUtilityClasses$f(ai);
  React$1.useLayoutEffect(() => {
    if (So) {
      const mi = Do.current.querySelector('[tabindex="0"]') || Do.current;
      mi == null || mi.focus();
    }
  }, [Lo, So]);
  const ui = React$1.useCallback(
    (hi) => (mi) => {
      isEventTargetInPortal(mi) || Lo.current.publishEvent(hi, Zo, mi);
    },
    // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [Lo, Zo]
  ), ci = React$1.useMemo(() => ({
    onKeyDown: ui("columnGroupHeaderKeyDown"),
    onFocus: ui("columnGroupHeaderFocus"),
    onBlur: ui("columnGroupHeaderBlur")
  }), [ui]), fi = typeof Ko.headerClassName == "function" ? Ko.headerClassName(Zo) : Ko.headerClassName;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridGenericColumnHeaderItem, _extends$q({
    ref: Do,
    classes: li,
    columnMenuOpen: !1,
    colIndex: Co,
    height: Po,
    isResizing: !1,
    sortDirection: null,
    hasFocus: !1,
    tabIndex: wo,
    isDraggable: !1,
    headerComponent: oi,
    headerClassName: fi,
    description: Jo,
    elementId: si,
    width: ho,
    columnMenuIconButton: null,
    columnTitleIconButtons: null,
    resizable: !1,
    label: ri,
    "aria-colspan": vo.length,
    "data-fields": `|-${vo.join("-|-")}-|`,
    style: _o
  }, ci));
}
const GridColumnHeaderRow = styled("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaderRow",
  overridesResolver: (Kt, uo) => uo.columnHeaderRow
})({
  display: "flex"
}), useGridColumnHeaders = (Kt) => {
  const {
    visibleColumns: uo,
    sortColumnLookup: ho,
    filterColumnLookup: go,
    columnHeaderTabIndexState: bo,
    columnGroupHeaderTabIndexState: vo,
    columnHeaderFocus: Po,
    columnGroupHeaderFocus: Co,
    headerGroupingMaxDepth: So,
    columnMenuState: wo,
    columnVisibility: Eo,
    columnGroupsHeaderStructure: Ro,
    hasOtherElementInTabSequence: _o
  } = Kt, [Io, Ao] = React$1.useState(""), [Oo, jo] = React$1.useState(""), Do = useGridPrivateApiContext(), Lo = useRtl(), ko = useGridRootProps(), Ko = useGridSelector(Do, gridDimensionsSelector), No = useGridSelector(Do, gridVirtualizationColumnEnabledSelector), Jo = useGridSelector(Do, gridColumnGroupsUnwrappedModelSelector), ti = useGridSelector(Do, gridColumnPositionsSelector), oi = useGridSelector(Do, gridRenderContextColumnsSelector), Qo = useGridSelector(Do, gridVisiblePinnedColumnDefinitionsSelector), Zo = useGridSelector(Do, gridColumnLookupSelector), ei = computeOffsetLeft(ti, oi, Qo.left.length), ii = Ko.columnsTotalWidth < Ko.viewportOuterSize.width;
  React$1.useEffect(() => {
    Do.current.columnHeadersContainerRef.current && (Do.current.columnHeadersContainerRef.current.scrollLeft = 0);
  }, [Do]);
  const ai = React$1.useCallback(($i) => jo($i.field), []), ri = React$1.useCallback(() => jo(""), []), ni = React$1.useCallback(($i) => Ao($i.field), []), si = React$1.useCallback(() => Ao(""), []), li = React$1.useMemo(() => Qo.left.length ? {
    firstColumnIndex: 0,
    lastColumnIndex: Qo.left.length
  } : null, [Qo.left.length]), ui = React$1.useMemo(() => Qo.right.length ? {
    firstColumnIndex: uo.length - Qo.right.length,
    lastColumnIndex: uo.length
  } : null, [Qo.right.length, uo.length]);
  useGridApiEventHandler(Do, "columnResizeStart", ai), useGridApiEventHandler(Do, "columnResizeStop", ri), useGridApiEventHandler(Do, "columnHeaderDragStart", ni), useGridApiEventHandler(Do, "columnHeaderDragEnd", si);
  const ci = ($i) => {
    const {
      renderContext: Ci = oi,
      maxLastColumn: Si = uo.length
    } = $i || {};
    let vi, Pi;
    return !ko.disableVirtualization && !No ? (vi = 0, Pi = Si) : (vi = Ci.firstColumnIndex, Pi = Ci.lastColumnIndex), {
      renderedColumns: uo.slice(vi, Pi),
      firstColumnToRender: vi,
      lastColumnToRender: Pi
    };
  }, fi = ($i, Ci, Si, vi = !1) => {
    const Pi = ($i == null ? void 0 : $i.position) === GridPinnedColumnPosition.RIGHT, wi = ($i == null ? void 0 : $i.position) === void 0, gi = Qo.right.length > 0 && Pi || Qo.right.length === 0 && wi, Ri = ei - Si;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
      children: [wi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        role: "presentation",
        style: {
          width: Ri
        }
      }), Ci, wi && /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
        role: "presentation",
        className: clsx(gridClasses.filler, vi && gridClasses["filler--borderBottom"])
      }), gi && /* @__PURE__ */ jsxRuntimeExports.jsx(GridScrollbarFillerCell, {
        header: !0,
        pinnedRight: Pi,
        borderBottom: vi,
        borderTop: !1
      })]
    });
  }, yi = ({
    pinnedPosition: $i,
    columnIndex: Ci,
    computedWidth: Si
  }) => {
    let vi;
    const Pi = $i === GridPinnedColumnPosition.LEFT, wi = $i === GridPinnedColumnPosition.RIGHT;
    if (Pi || wi) {
      const gi = getPinnedCellOffset($i, Si, Ci, ti, Ko);
      let Ri = Pi ? "left" : "right";
      Lo && (Ri = Pi ? "right" : "left"), $i === "left" && (vi = {
        [Ri]: gi
      }), $i === "right" && (vi = {
        [Ri]: gi
      });
    }
    return vi;
  }, hi = ($i, Ci = {}) => {
    const {
      renderedColumns: Si,
      firstColumnToRender: vi
    } = ci($i), Pi = [];
    for (let wi = 0; wi < Si.length; wi += 1) {
      const gi = Si[wi], Ri = vi + wi, Ei = Ri === 0, Ni = bo !== null && bo.field === gi.field || Ei && !_o ? 0 : -1, Ai = Po !== null && Po.field === gi.field, Yi = wo.open && wo.field === gi.field, Ui = $i == null ? void 0 : $i.position, us = yi({
        pinnedPosition: Ui,
        columnIndex: Ri,
        computedWidth: gi.computedWidth
      }), ns = Ui === GridPinnedColumnPosition.RIGHT ? Si[wi - 1] : Si[wi + 1], Ti = ns ? Po !== null && Po.field === ns.field : !1, _i = Ri + 1 === ti.length - Qo.right.length;
      Pi.push(/* @__PURE__ */ jsxRuntimeExports.jsx(Memoized, _extends$q({}, ho[gi.field], {
        columnMenuOpen: Yi,
        filterItemsCounter: go[gi.field] && go[gi.field].length,
        headerHeight: Ko.headerHeight,
        isDragging: gi.field === Io,
        colDef: gi,
        colIndex: Ri,
        isResizing: Oo === gi.field,
        isLast: Ri === ti.length - 1,
        hasFocus: Ai,
        tabIndex: Ni,
        pinnedPosition: Ui,
        style: us,
        indexInSection: wi,
        sectionLength: Si.length,
        gridHasFiller: ii,
        isLastUnpinned: _i,
        isSiblingFocused: Ti
      }, Ci), gi.field));
    }
    return fi($i, Pi, 0);
  }, mi = () => /* @__PURE__ */ jsxRuntimeExports.jsxs(GridColumnHeaderRow, {
    role: "row",
    "aria-rowindex": So + 1,
    ownerState: ko,
    className: gridClasses["row--borderBottom"],
    children: [li && hi({
      position: GridPinnedColumnPosition.LEFT,
      renderContext: li,
      maxLastColumn: li.lastColumnIndex
    }, {
      disableReorder: !0
    }), hi({
      renderContext: oi,
      maxLastColumn: uo.length - Qo.right.length
    }), ui && hi({
      position: GridPinnedColumnPosition.RIGHT,
      renderContext: ui,
      maxLastColumn: ui.lastColumnIndex
    }, {
      disableReorder: !0,
      separatorSide: GridColumnHeaderSeparatorSides.Left
    })]
  }), bi = ({
    depth: $i,
    params: Ci
  }) => {
    var Bi, Ji;
    const Si = ci(Ci);
    if (Si.renderedColumns.length === 0)
      return null;
    const {
      firstColumnToRender: vi,
      lastColumnToRender: Pi
    } = Si, wi = Ro[$i], gi = uo[vi].field, Ri = ((Bi = Jo[gi]) == null ? void 0 : Bi[$i]) ?? null, Ei = wi.findIndex(({
      groupId: Ki,
      columnFields: qi
    }) => Ki === Ri && qi.includes(gi)), Ni = uo[Pi - 1].field, Ai = ((Ji = Jo[Ni]) == null ? void 0 : Ji[$i]) ?? null, Yi = wi.findIndex(({
      groupId: Ki,
      columnFields: qi
    }) => Ki === Ai && qi.includes(Ni)), Ui = wi.slice(Ei, Yi + 1).map((Ki) => _extends$q({}, Ki, {
      columnFields: Ki.columnFields.filter((qi) => Eo[qi] !== !1)
    })).filter((Ki) => Ki.columnFields.length > 0), us = Ui[0].columnFields.indexOf(gi), Ti = Ui[0].columnFields.slice(0, us).reduce((Ki, qi) => {
      const rs = Zo[qi];
      return Ki + (rs.computedWidth ?? 0);
    }, 0);
    let _i = vi;
    const Vi = Ui.map(({
      groupId: Ki,
      columnFields: qi
    }, rs) => {
      const os = Co !== null && Co.depth === $i && qi.includes(Co.field), ps = vo !== null && vo.depth === $i && qi.includes(vo.field) ? 0 : -1, Mi = {
        groupId: Ki,
        width: qi.reduce((Zi, zi) => Zi + Zo[zi].computedWidth, 0),
        fields: qi,
        colIndex: _i,
        hasFocus: os,
        tabIndex: ps
      }, Wi = Ci.position, Hi = yi({
        pinnedPosition: Wi,
        columnIndex: _i,
        computedWidth: Mi.width
      });
      _i += qi.length;
      let Xi = rs;
      return Wi === "left" && (Xi = _i - 1), /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnGroupHeader, {
        groupId: Ki,
        width: Mi.width,
        fields: Mi.fields,
        colIndex: Mi.colIndex,
        depth: $i,
        isLastColumn: rs === Ui.length - 1,
        maxDepth: So,
        height: Ko.groupHeaderHeight,
        hasFocus: os,
        tabIndex: ps,
        pinnedPosition: Wi,
        style: Hi,
        indexInSection: Xi,
        sectionLength: Ui.length,
        gridHasFiller: ii
      }, rs);
    });
    return fi(Ci, Vi, Ti);
  };
  return {
    renderContext: oi,
    leftRenderContext: li,
    rightRenderContext: ui,
    pinnedColumns: Qo,
    visibleColumns: uo,
    getCellOffsetStyle: yi,
    getFillers: fi,
    getColumnHeadersRow: mi,
    getColumnsToRender: ci,
    getColumnGroupHeadersRows: () => {
      if (So === 0)
        return null;
      const $i = [];
      for (let Ci = 0; Ci < So; Ci += 1)
        $i.push(/* @__PURE__ */ jsxRuntimeExports.jsxs(GridColumnHeaderRow, {
          role: "row",
          "aria-rowindex": Ci + 1,
          ownerState: ko,
          children: [li && bi({
            depth: Ci,
            params: {
              position: GridPinnedColumnPosition.LEFT,
              renderContext: li,
              maxLastColumn: li.lastColumnIndex
            }
          }), bi({
            depth: Ci,
            params: {
              renderContext: oi
            }
          }), ui && bi({
            depth: Ci,
            params: {
              position: GridPinnedColumnPosition.RIGHT,
              renderContext: ui,
              maxLastColumn: ui.lastColumnIndex
            }
          })]
        }, Ci));
      return $i;
    },
    isDragging: !!Io,
    getInnerProps: () => ({
      role: "rowgroup"
    })
  };
}, _excluded$k = ["className"], useUtilityClasses$e = (Kt) => {
  const {
    classes: uo
  } = Kt;
  return composeClasses({
    root: ["columnHeaders"]
  }, getDataGridUtilityClass, uo);
}, GridColumnHeadersRoot = styled$1("div", {
  name: "MuiDataGrid",
  slot: "ColumnHeaders",
  overridesResolver: (Kt, uo) => uo.columnHeaders
})({
  display: "flex",
  flexDirection: "column",
  borderTopLeftRadius: "var(--unstable_DataGrid-radius)",
  borderTopRightRadius: "var(--unstable_DataGrid-radius)"
}), GridBaseColumnHeaders = forwardRef(function(uo, ho) {
  const {
    className: go
  } = uo, bo = _objectWithoutPropertiesLoose$h(uo, _excluded$k), vo = useGridRootProps(), Po = useUtilityClasses$e(vo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridColumnHeadersRoot, _extends$q({
    className: clsx(Po.root, go),
    ownerState: vo
  }, bo, {
    role: "presentation",
    ref: ho
  }));
}), _excluded$j = ["className", "visibleColumns", "sortColumnLookup", "filterColumnLookup", "columnHeaderTabIndexState", "columnGroupHeaderTabIndexState", "columnHeaderFocus", "columnGroupHeaderFocus", "headerGroupingMaxDepth", "columnMenuState", "columnVisibility", "columnGroupsHeaderStructure", "hasOtherElementInTabSequence"], GridColumnHeaders = forwardRef(function(uo, ho) {
  const {
    visibleColumns: go,
    sortColumnLookup: bo,
    filterColumnLookup: vo,
    columnHeaderTabIndexState: Po,
    columnGroupHeaderTabIndexState: Co,
    columnHeaderFocus: So,
    columnGroupHeaderFocus: wo,
    headerGroupingMaxDepth: Eo,
    columnMenuState: Ro,
    columnVisibility: _o,
    columnGroupsHeaderStructure: Io,
    hasOtherElementInTabSequence: Ao
  } = uo, Oo = _objectWithoutPropertiesLoose$h(uo, _excluded$j), {
    getInnerProps: jo,
    getColumnHeadersRow: Do,
    getColumnGroupHeadersRows: Lo
  } = useGridColumnHeaders({
    visibleColumns: go,
    sortColumnLookup: bo,
    filterColumnLookup: vo,
    columnHeaderTabIndexState: Po,
    columnGroupHeaderTabIndexState: Co,
    columnHeaderFocus: So,
    columnGroupHeaderFocus: wo,
    headerGroupingMaxDepth: Eo,
    columnMenuState: Ro,
    columnVisibility: _o,
    columnGroupsHeaderStructure: Io,
    hasOtherElementInTabSequence: Ao
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(GridBaseColumnHeaders, _extends$q({}, Oo, jo(), {
    ref: ho,
    children: [Lo(), Do()]
  }));
});
process.env.NODE_ENV !== "production" && (GridColumnHeaders.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  columnGroupHeaderFocus: PropTypes.shape({
    depth: PropTypes.number.isRequired,
    field: PropTypes.string.isRequired
  }),
  columnGroupHeaderTabIndexState: PropTypes.shape({
    depth: PropTypes.number.isRequired,
    field: PropTypes.string.isRequired
  }),
  columnGroupsHeaderStructure: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    columnFields: PropTypes.arrayOf(PropTypes.string).isRequired,
    groupId: PropTypes.string
  }))).isRequired,
  columnHeaderFocus: PropTypes.shape({
    field: PropTypes.string.isRequired
  }),
  columnHeaderTabIndexState: PropTypes.shape({
    field: PropTypes.string.isRequired
  }),
  columnMenuState: PropTypes.shape({
    field: PropTypes.string,
    open: PropTypes.bool.isRequired
  }).isRequired,
  columnVisibility: PropTypes.object.isRequired,
  filterColumnLookup: PropTypes.object.isRequired,
  hasOtherElementInTabSequence: PropTypes.bool.isRequired,
  headerGroupingMaxDepth: PropTypes.number.isRequired,
  sortColumnLookup: PropTypes.object.isRequired,
  visibleColumns: PropTypes.arrayOf(PropTypes.object).isRequired
});
const MemoizedGridColumnHeaders = fastMemo(GridColumnHeaders);
function GridDetailPanels(Kt) {
  return null;
}
function GridPinnedRows(Kt) {
  return null;
}
const GridNoResultsOverlay = forwardRef(function(uo, ho) {
  const bo = useGridApiContext().current.getLocaleText("noResultsOverlayLabel");
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridOverlay, _extends$q({}, uo, {
    ref: ho,
    children: bo
  }));
});
function useBadge(Kt) {
  const {
    badgeContent: uo,
    invisible: ho = !1,
    max: go = 99,
    showZero: bo = !1
  } = Kt, vo = usePreviousProps({
    badgeContent: uo,
    max: go
  });
  let Po = ho;
  ho === !1 && uo === 0 && !bo && (Po = !0);
  const {
    badgeContent: Co,
    max: So = go
  } = Po ? vo : Kt, wo = Co && Number(Co) > So ? `${So}+` : Co;
  return {
    badgeContent: Co,
    invisible: Po,
    max: So,
    displayValue: wo
  };
}
function getBadgeUtilityClass(Kt) {
  return generateUtilityClass$1("MuiBadge", Kt);
}
const badgeClasses = generateUtilityClasses$1("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), RADIUS_STANDARD = 10, RADIUS_DOT = 4, useUtilityClasses$d = (Kt) => {
  const {
    color: uo,
    anchorOrigin: ho,
    invisible: go,
    overlap: bo,
    variant: vo,
    classes: Po = {}
  } = Kt, Co = {
    root: ["root"],
    badge: ["badge", vo, go && "invisible", `anchorOrigin${capitalize(ho.vertical)}${capitalize(ho.horizontal)}`, `anchorOrigin${capitalize(ho.vertical)}${capitalize(ho.horizontal)}${capitalize(bo)}`, `overlap${capitalize(bo)}`, uo !== "default" && `color${capitalize(uo)}`]
  };
  return composeClasses(Co, getBadgeUtilityClass, Po);
}, BadgeRoot = styled("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), BadgeBadge = styled("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.badge, uo[ho.variant], uo[`anchorOrigin${capitalize(ho.anchorOrigin.vertical)}${capitalize(ho.anchorOrigin.horizontal)}${capitalize(ho.overlap)}`], ho.color !== "default" && uo[`color${capitalize(ho.color)}`], ho.invisible && uo.invisible];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  position: "absolute",
  boxSizing: "border-box",
  fontFamily: Kt.typography.fontFamily,
  fontWeight: Kt.typography.fontWeightMedium,
  fontSize: Kt.typography.pxToRem(12),
  minWidth: RADIUS_STANDARD * 2,
  lineHeight: 1,
  padding: "0 6px",
  height: RADIUS_STANDARD * 2,
  borderRadius: RADIUS_STANDARD,
  zIndex: 1,
  // Render the badge on top of potential ripples.
  transition: Kt.transitions.create("transform", {
    easing: Kt.transitions.easing.easeInOut,
    duration: Kt.transitions.duration.enteringScreen
  }),
  variants: [...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter(["contrastText"])).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      backgroundColor: (Kt.vars || Kt).palette[uo].main,
      color: (Kt.vars || Kt).palette[uo].contrastText
    }
  })), {
    props: {
      variant: "dot"
    },
    style: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "top" && uo.anchorOrigin.horizontal === "right" && uo.overlap === "rectangular",
    style: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "bottom" && uo.anchorOrigin.horizontal === "right" && uo.overlap === "rectangular",
    style: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "top" && uo.anchorOrigin.horizontal === "left" && uo.overlap === "rectangular",
    style: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "bottom" && uo.anchorOrigin.horizontal === "left" && uo.overlap === "rectangular",
    style: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "top" && uo.anchorOrigin.horizontal === "right" && uo.overlap === "circular",
    style: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "bottom" && uo.anchorOrigin.horizontal === "right" && uo.overlap === "circular",
    style: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(50%, 50%)"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "top" && uo.anchorOrigin.horizontal === "left" && uo.overlap === "circular",
    style: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(-50%, -50%)"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.anchorOrigin.vertical === "bottom" && uo.anchorOrigin.horizontal === "left" && uo.overlap === "circular",
    style: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      [`&.${badgeClasses.invisible}`]: {
        transform: "scale(0) translate(-50%, 50%)"
      }
    }
  }, {
    props: {
      invisible: !0
    },
    style: {
      transition: Kt.transitions.create("transform", {
        easing: Kt.transitions.easing.easeInOut,
        duration: Kt.transitions.duration.leavingScreen
      })
    }
  }]
})));
function getAnchorOrigin(Kt) {
  return {
    vertical: (Kt == null ? void 0 : Kt.vertical) ?? "top",
    horizontal: (Kt == null ? void 0 : Kt.horizontal) ?? "right"
  };
}
const Badge$1 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiBadge"
  }), {
    anchorOrigin: bo,
    className: vo,
    classes: Po,
    component: Co,
    components: So = {},
    componentsProps: wo = {},
    children: Eo,
    overlap: Ro = "rectangular",
    color: _o = "default",
    invisible: Io = !1,
    max: Ao = 99,
    badgeContent: Oo,
    slots: jo,
    slotProps: Do,
    showZero: Lo = !1,
    variant: ko = "standard",
    ...Ko
  } = go, {
    badgeContent: No,
    invisible: Jo,
    max: ti,
    displayValue: oi
  } = useBadge({
    max: Ao,
    invisible: Io,
    badgeContent: Oo,
    showZero: Lo
  }), Qo = usePreviousProps({
    anchorOrigin: getAnchorOrigin(bo),
    color: _o,
    overlap: Ro,
    variant: ko,
    badgeContent: Oo
  }), Zo = Jo || No == null && ko !== "dot", {
    color: ei = _o,
    overlap: ii = Ro,
    anchorOrigin: ai,
    variant: ri = ko
  } = Zo ? Qo : go, ni = getAnchorOrigin(ai), si = ri !== "dot" ? oi : void 0, li = {
    ...go,
    badgeContent: No,
    invisible: Zo,
    max: ti,
    displayValue: si,
    showZero: Lo,
    anchorOrigin: ni,
    color: ei,
    overlap: ii,
    variant: ri
  }, ui = useUtilityClasses$d(li), ci = (jo == null ? void 0 : jo.root) ?? So.Root ?? BadgeRoot, fi = (jo == null ? void 0 : jo.badge) ?? So.Badge ?? BadgeBadge, yi = (Do == null ? void 0 : Do.root) ?? wo.root, hi = (Do == null ? void 0 : Do.badge) ?? wo.badge, mi = useSlotProps({
    elementType: ci,
    externalSlotProps: yi,
    externalForwardedProps: Ko,
    additionalProps: {
      ref: ho,
      as: Co
    },
    ownerState: li,
    className: clsx(yi == null ? void 0 : yi.className, ui.root, vo)
  }), bi = useSlotProps({
    elementType: fi,
    externalSlotProps: hi,
    ownerState: li,
    className: clsx(ui.badge, hi == null ? void 0 : hi.className)
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ci, {
    ...mi,
    children: [Eo, /* @__PURE__ */ jsxRuntimeExports.jsx(fi, {
      ...bi,
      children: si
    })]
  });
});
process.env.NODE_ENV !== "production" && (Badge$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(["left", "right"]),
    vertical: PropTypes.oneOf(["bottom", "top"])
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,
  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Badge: PropTypes.elementType,
    Root: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    badge: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: PropTypes.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: PropTypes.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: PropTypes.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: PropTypes.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: PropTypes.shape({
    badge: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    root: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: PropTypes.shape({
    badge: PropTypes.elementType,
    root: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["dot", "standard"]), PropTypes.string])
});
function getSwitchBaseUtilityClass(Kt) {
  return generateUtilityClass$1("PrivateSwitchBase", Kt);
}
generateUtilityClasses$1("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const useUtilityClasses$c = (Kt) => {
  const {
    classes: uo,
    checked: ho,
    disabled: go,
    edge: bo
  } = Kt, vo = {
    root: ["root", ho && "checked", go && "disabled", bo && `edge${capitalize(bo)}`],
    input: ["input"]
  };
  return composeClasses(vo, getSwitchBaseUtilityClass, uo);
}, SwitchBaseRoot = styled(ButtonBase)({
  padding: 9,
  borderRadius: "50%",
  variants: [{
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: ({
      edge: Kt,
      ownerState: uo
    }) => Kt === "start" && uo.size !== "small",
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }, {
    props: ({
      edge: Kt,
      ownerState: uo
    }) => Kt === "end" && uo.size !== "small",
    style: {
      marginRight: -12
    }
  }]
}), SwitchBaseInput = styled("input", {
  shouldForwardProp: rootShouldForwardProp
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), SwitchBase = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const {
    autoFocus: go,
    checked: bo,
    checkedIcon: vo,
    className: Po,
    defaultChecked: Co,
    disabled: So,
    disableFocusRipple: wo = !1,
    edge: Eo = !1,
    icon: Ro,
    id: _o,
    inputProps: Io,
    inputRef: Ao,
    name: Oo,
    onBlur: jo,
    onChange: Do,
    onFocus: Lo,
    readOnly: ko,
    required: Ko = !1,
    tabIndex: No,
    type: Jo,
    value: ti,
    ...oi
  } = uo, [Qo, Zo] = useControlled({
    controlled: bo,
    default: !!Co,
    name: "SwitchBase",
    state: "checked"
  }), ei = useFormControl(), ii = (ci) => {
    Lo && Lo(ci), ei && ei.onFocus && ei.onFocus(ci);
  }, ai = (ci) => {
    jo && jo(ci), ei && ei.onBlur && ei.onBlur(ci);
  }, ri = (ci) => {
    if (ci.nativeEvent.defaultPrevented)
      return;
    const fi = ci.target.checked;
    Zo(fi), Do && Do(ci, fi);
  };
  let ni = So;
  ei && typeof ni > "u" && (ni = ei.disabled);
  const si = Jo === "checkbox" || Jo === "radio", li = {
    ...uo,
    checked: Qo,
    disabled: ni,
    disableFocusRipple: wo,
    edge: Eo
  }, ui = useUtilityClasses$c(li);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchBaseRoot, {
    component: "span",
    className: clsx(ui.root, Po),
    centerRipple: !0,
    focusRipple: !wo,
    disabled: ni,
    tabIndex: null,
    role: void 0,
    onFocus: ii,
    onBlur: ai,
    ownerState: li,
    ref: ho,
    ...oi,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchBaseInput, {
      autoFocus: go,
      checked: bo,
      defaultChecked: Co,
      className: ui.input,
      disabled: ni,
      id: si ? _o : void 0,
      name: Oo,
      onChange: ri,
      readOnly: ko,
      ref: Ao,
      required: Ko,
      ownerState: li,
      tabIndex: No,
      type: Jo,
      ...Jo === "checkbox" && ti === void 0 ? {} : {
        value: ti
      },
      ...Io
    }), Qo ? vo : Ro]
  });
});
process.env.NODE_ENV !== "production" && (SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: PropTypes.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /*
   * @ignore
   */
  name: PropTypes.string,
  /**
   * @ignore
   */
  onBlur: PropTypes.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * @ignore
   */
  onFocus: PropTypes.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.object,
  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,
  /**
   * The value of the component.
   */
  value: PropTypes.any
});
const CheckBoxOutlineBlankIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), CheckBoxIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), IndeterminateCheckBoxIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function getCheckboxUtilityClass(Kt) {
  return generateUtilityClass$1("MuiCheckbox", Kt);
}
const checkboxClasses = generateUtilityClasses$1("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), useUtilityClasses$b = (Kt) => {
  const {
    classes: uo,
    indeterminate: ho,
    color: go,
    size: bo
  } = Kt, vo = {
    root: ["root", ho && "indeterminate", `color${capitalize(go)}`, `size${capitalize(bo)}`]
  }, Po = composeClasses(vo, getCheckboxUtilityClass, uo);
  return {
    ...uo,
    // forward the disabled and checked classes to the SwitchBase
    ...Po
  };
}, CheckboxRoot = styled(SwitchBase, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.indeterminate && uo.indeterminate, uo[`size${capitalize(ho.size)}`], ho.color !== "default" && uo[`color${capitalize(ho.color)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  color: (Kt.vars || Kt).palette.text.secondary,
  variants: [{
    props: {
      color: "default",
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.action.activeChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette.action.active, Kt.palette.action.hoverOpacity)
      }
    }
  }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo,
      disableRipple: !1
    },
    style: {
      "&:hover": {
        backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette[uo].mainChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette[uo].main, Kt.palette.action.hoverOpacity)
      }
    }
  })), ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
        color: (Kt.vars || Kt).palette[uo].main
      },
      [`&.${checkboxClasses.disabled}`]: {
        color: (Kt.vars || Kt).palette.action.disabled
      }
    }
  })), {
    // Should be last to override other colors
    props: {
      disableRipple: !1
    },
    style: {
      // Reset on touch devices, it doesn't add specificity
      "&:hover": {
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }]
}))), defaultCheckedIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxIcon, {}), defaultIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(CheckBoxOutlineBlankIcon, {}), defaultIndeterminateIcon = /* @__PURE__ */ jsxRuntimeExports.jsx(IndeterminateCheckBoxIcon, {}), Checkbox = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiCheckbox"
  }), {
    checkedIcon: bo = defaultCheckedIcon,
    color: vo = "primary",
    icon: Po = defaultIcon,
    indeterminate: Co = !1,
    indeterminateIcon: So = defaultIndeterminateIcon,
    inputProps: wo,
    size: Eo = "medium",
    disableRipple: Ro = !1,
    className: _o,
    ...Io
  } = go, Ao = Co ? So : Po, Oo = Co ? So : bo, jo = {
    ...go,
    disableRipple: Ro,
    color: vo,
    indeterminate: Co,
    size: Eo
  }, Do = useUtilityClasses$b(jo);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxRoot, {
    type: "checkbox",
    inputProps: {
      "data-indeterminate": Co,
      ...wo
    },
    icon: /* @__PURE__ */ React$1.cloneElement(Ao, {
      fontSize: Ao.props.fontSize ?? Eo
    }),
    checkedIcon: /* @__PURE__ */ React$1.cloneElement(Oo, {
      fontSize: Oo.props.fontSize ?? Eo
    }),
    ownerState: jo,
    ref: ho,
    className: clsx(Do.root, _o),
    disableRipple: Ro,
    ...Io,
    classes: Do
  });
});
process.env.NODE_ENV !== "production" && (Checkbox.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: PropTypes.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: PropTypes.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
});
function getButtonUtilityClass(Kt) {
  return generateUtilityClass$1("MuiButton", Kt);
}
const buttonClasses = generateUtilityClasses$1("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), ButtonGroupContext = /* @__PURE__ */ React$1.createContext({});
process.env.NODE_ENV !== "production" && (ButtonGroupContext.displayName = "ButtonGroupContext");
const ButtonGroupButtonContext = /* @__PURE__ */ React$1.createContext(void 0);
process.env.NODE_ENV !== "production" && (ButtonGroupButtonContext.displayName = "ButtonGroupButtonContext");
const useUtilityClasses$a = (Kt) => {
  const {
    color: uo,
    disableElevation: ho,
    fullWidth: go,
    size: bo,
    variant: vo,
    classes: Po
  } = Kt, Co = {
    root: ["root", vo, `${vo}${capitalize(uo)}`, `size${capitalize(bo)}`, `${vo}Size${capitalize(bo)}`, `color${capitalize(uo)}`, ho && "disableElevation", go && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${capitalize(bo)}`],
    endIcon: ["icon", "endIcon", `iconSize${capitalize(bo)}`]
  }, So = composeClasses(Co, getButtonUtilityClass, Po);
  return {
    ...Po,
    // forward the focused, disabled, etc. classes to the ButtonBase
    ...So
  };
}, commonIconStyles = [{
  props: {
    size: "small"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 18
    }
  }
}, {
  props: {
    size: "medium"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 20
    }
  }
}, {
  props: {
    size: "large"
  },
  style: {
    "& > *:nth-of-type(1)": {
      fontSize: 22
    }
  }
}], ButtonRoot = styled(ButtonBase, {
  shouldForwardProp: (Kt) => rootShouldForwardProp(Kt) || Kt === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.variant], uo[`${ho.variant}${capitalize(ho.color)}`], uo[`size${capitalize(ho.size)}`], uo[`${ho.variant}Size${capitalize(ho.size)}`], ho.color === "inherit" && uo.colorInherit, ho.disableElevation && uo.disableElevation, ho.fullWidth && uo.fullWidth];
  }
})(memoTheme(({
  theme: Kt
}) => {
  const uo = Kt.palette.mode === "light" ? Kt.palette.grey[300] : Kt.palette.grey[800], ho = Kt.palette.mode === "light" ? Kt.palette.grey.A100 : Kt.palette.grey[700];
  return {
    ...Kt.typography.button,
    minWidth: 64,
    padding: "6px 16px",
    border: 0,
    borderRadius: (Kt.vars || Kt).shape.borderRadius,
    transition: Kt.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: Kt.transitions.duration.short
    }),
    "&:hover": {
      textDecoration: "none"
    },
    [`&.${buttonClasses.disabled}`]: {
      color: (Kt.vars || Kt).palette.action.disabled
    },
    variants: [{
      props: {
        variant: "contained"
      },
      style: {
        color: "var(--variant-containedColor)",
        backgroundColor: "var(--variant-containedBg)",
        boxShadow: (Kt.vars || Kt).shadows[2],
        "&:hover": {
          boxShadow: (Kt.vars || Kt).shadows[4],
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            boxShadow: (Kt.vars || Kt).shadows[2]
          }
        },
        "&:active": {
          boxShadow: (Kt.vars || Kt).shadows[8]
        },
        [`&.${buttonClasses.focusVisible}`]: {
          boxShadow: (Kt.vars || Kt).shadows[6]
        },
        [`&.${buttonClasses.disabled}`]: {
          color: (Kt.vars || Kt).palette.action.disabled,
          boxShadow: (Kt.vars || Kt).shadows[0],
          backgroundColor: (Kt.vars || Kt).palette.action.disabledBackground
        }
      }
    }, {
      props: {
        variant: "outlined"
      },
      style: {
        padding: "5px 15px",
        border: "1px solid currentColor",
        borderColor: "var(--variant-outlinedBorder, currentColor)",
        backgroundColor: "var(--variant-outlinedBg)",
        color: "var(--variant-outlinedColor)",
        [`&.${buttonClasses.disabled}`]: {
          border: `1px solid ${(Kt.vars || Kt).palette.action.disabledBackground}`
        }
      }
    }, {
      props: {
        variant: "text"
      },
      style: {
        padding: "6px 8px",
        color: "var(--variant-textColor)",
        backgroundColor: "var(--variant-textBg)"
      }
    }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter()).map(([go]) => ({
      props: {
        color: go
      },
      style: {
        "--variant-textColor": (Kt.vars || Kt).palette[go].main,
        "--variant-outlinedColor": (Kt.vars || Kt).palette[go].main,
        "--variant-outlinedBorder": Kt.vars ? `rgba(${Kt.vars.palette[go].mainChannel} / 0.5)` : alpha$1(Kt.palette[go].main, 0.5),
        "--variant-containedColor": (Kt.vars || Kt).palette[go].contrastText,
        "--variant-containedBg": (Kt.vars || Kt).palette[go].main,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": (Kt.vars || Kt).palette[go].dark,
            "--variant-textBg": Kt.vars ? `rgba(${Kt.vars.palette[go].mainChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette[go].main, Kt.palette.action.hoverOpacity),
            "--variant-outlinedBorder": (Kt.vars || Kt).palette[go].main,
            "--variant-outlinedBg": Kt.vars ? `rgba(${Kt.vars.palette[go].mainChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette[go].main, Kt.palette.action.hoverOpacity)
          }
        }
      }
    })), {
      props: {
        color: "inherit"
      },
      style: {
        color: "inherit",
        borderColor: "currentColor",
        "--variant-containedBg": Kt.vars ? Kt.vars.palette.Button.inheritContainedBg : uo,
        "@media (hover: hover)": {
          "&:hover": {
            "--variant-containedBg": Kt.vars ? Kt.vars.palette.Button.inheritContainedHoverBg : ho,
            "--variant-textBg": Kt.vars ? `rgba(${Kt.vars.palette.text.primaryChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette.text.primary, Kt.palette.action.hoverOpacity),
            "--variant-outlinedBg": Kt.vars ? `rgba(${Kt.vars.palette.text.primaryChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette.text.primary, Kt.palette.action.hoverOpacity)
          }
        }
      }
    }, {
      props: {
        size: "small",
        variant: "text"
      },
      style: {
        padding: "4px 5px",
        fontSize: Kt.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "text"
      },
      style: {
        padding: "8px 11px",
        fontSize: Kt.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "outlined"
      },
      style: {
        padding: "3px 9px",
        fontSize: Kt.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "outlined"
      },
      style: {
        padding: "7px 21px",
        fontSize: Kt.typography.pxToRem(15)
      }
    }, {
      props: {
        size: "small",
        variant: "contained"
      },
      style: {
        padding: "4px 10px",
        fontSize: Kt.typography.pxToRem(13)
      }
    }, {
      props: {
        size: "large",
        variant: "contained"
      },
      style: {
        padding: "8px 22px",
        fontSize: Kt.typography.pxToRem(15)
      }
    }, {
      props: {
        disableElevation: !0
      },
      style: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none"
        },
        [`&.${buttonClasses.focusVisible}`]: {
          boxShadow: "none"
        },
        "&:active": {
          boxShadow: "none"
        },
        [`&.${buttonClasses.disabled}`]: {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        fullWidth: !0
      },
      style: {
        width: "100%"
      }
    }]
  };
})), ButtonStartIcon = styled("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.startIcon, uo[`iconSize${capitalize(ho.size)}`]];
  }
})({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginLeft: -2
    }
  }, ...commonIconStyles]
}), ButtonEndIcon = styled("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.endIcon, uo[`iconSize${capitalize(ho.size)}`]];
  }
})({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8,
  variants: [{
    props: {
      size: "small"
    },
    style: {
      marginRight: -2
    }
  }, ...commonIconStyles]
}), Button = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = React$1.useContext(ButtonGroupContext), bo = React$1.useContext(ButtonGroupButtonContext), vo = resolveProps(go, uo), Po = useDefaultProps({
    props: vo,
    name: "MuiButton"
  }), {
    children: Co,
    color: So = "primary",
    component: wo = "button",
    className: Eo,
    disabled: Ro = !1,
    disableElevation: _o = !1,
    disableFocusRipple: Io = !1,
    endIcon: Ao,
    focusVisibleClassName: Oo,
    fullWidth: jo = !1,
    size: Do = "medium",
    startIcon: Lo,
    type: ko,
    variant: Ko = "text",
    ...No
  } = Po, Jo = {
    ...Po,
    color: So,
    component: wo,
    disabled: Ro,
    disableElevation: _o,
    disableFocusRipple: Io,
    fullWidth: jo,
    size: Do,
    type: ko,
    variant: Ko
  }, ti = useUtilityClasses$a(Jo), oi = Lo && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonStartIcon, {
    className: ti.startIcon,
    ownerState: Jo,
    children: Lo
  }), Qo = Ao && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonEndIcon, {
    className: ti.endIcon,
    ownerState: Jo,
    children: Ao
  }), Zo = bo || "";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(ButtonRoot, {
    ownerState: Jo,
    className: clsx(go.className, ti.root, Eo, Zo),
    component: wo,
    disabled: Ro,
    focusRipple: !Io,
    focusVisibleClassName: clsx(ti.focusVisible, Oo),
    ref: ho,
    type: ko,
    ...No,
    classes: ti,
    children: [oi, Co, Qo]
  });
});
process.env.NODE_ENV !== "production" && (Button.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: PropTypes.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,
  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: PropTypes.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   */
  type: PropTypes.oneOfType([PropTypes.oneOf(["button", "reset", "submit"]), PropTypes.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["contained", "outlined", "text"]), PropTypes.string])
});
function getInputAdornmentUtilityClass(Kt) {
  return generateUtilityClass$1("MuiInputAdornment", Kt);
}
const inputAdornmentClasses = generateUtilityClasses$1("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var _span;
const overridesResolver$1 = (Kt, uo) => {
  const {
    ownerState: ho
  } = Kt;
  return [uo.root, uo[`position${capitalize(ho.position)}`], ho.disablePointerEvents === !0 && uo.disablePointerEvents, uo[ho.variant]];
}, useUtilityClasses$9 = (Kt) => {
  const {
    classes: uo,
    disablePointerEvents: ho,
    hiddenLabel: go,
    position: bo,
    size: vo,
    variant: Po
  } = Kt, Co = {
    root: ["root", ho && "disablePointerEvents", bo && `position${capitalize(bo)}`, Po, go && "hiddenLabel", vo && `size${capitalize(vo)}`]
  };
  return composeClasses(Co, getInputAdornmentUtilityClass, uo);
}, InputAdornmentRoot = styled("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: overridesResolver$1
})(memoTheme(({
  theme: Kt
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (Kt.vars || Kt).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${inputAdornmentClasses.positionStart}&:not(.${inputAdornmentClasses.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), InputAdornment = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiInputAdornment"
  }), {
    children: bo,
    className: vo,
    component: Po = "div",
    disablePointerEvents: Co = !1,
    disableTypography: So = !1,
    position: wo,
    variant: Eo,
    ...Ro
  } = go, _o = useFormControl() || {};
  let Io = Eo;
  Eo && _o.variant && process.env.NODE_ENV !== "production" && Eo === _o.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), Io || (Io = _o.variant);
  const Ao = {
    ...go,
    hiddenLabel: _o.hiddenLabel,
    size: _o.size,
    disablePointerEvents: Co,
    position: wo,
    variant: Io
  }, Oo = useUtilityClasses$9(Ao);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlContext.Provider, {
    value: null,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(InputAdornmentRoot, {
      as: Po,
      ownerState: Ao,
      className: clsx(Oo.root, vo),
      ref: ho,
      ...Ro,
      children: typeof bo == "string" && !So ? /* @__PURE__ */ jsxRuntimeExports.jsx(Typography, {
        color: "textSecondary",
        children: bo
      }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
        children: [wo === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          _span || (_span = /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
            className: "notranslate",
            "aria-hidden": !0,
            children: "​"
          }))
        ) : null, bo]
      })
    })
  });
});
process.env.NODE_ENV !== "production" && (InputAdornment.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: PropTypes.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: PropTypes.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(["filled", "outlined", "standard"])
});
function getTooltipUtilityClass(Kt) {
  return generateUtilityClass$1("MuiTooltip", Kt);
}
const tooltipClasses = generateUtilityClasses$1("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]);
function round$1(Kt) {
  return Math.round(Kt * 1e5) / 1e5;
}
const useUtilityClasses$8 = (Kt) => {
  const {
    classes: uo,
    disableInteractive: ho,
    arrow: go,
    touch: bo,
    placement: vo
  } = Kt, Po = {
    popper: ["popper", !ho && "popperInteractive", go && "popperArrow"],
    tooltip: ["tooltip", go && "tooltipArrow", bo && "touch", `tooltipPlacement${capitalize(vo.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return composeClasses(Po, getTooltipUtilityClass, uo);
}, TooltipPopper = styled(Popper, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.popper, !ho.disableInteractive && uo.popperInteractive, ho.arrow && uo.popperArrow, !ho.open && uo.popperClose];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  zIndex: (Kt.vars || Kt).zIndex.tooltip,
  pointerEvents: "none",
  variants: [{
    props: ({
      ownerState: uo
    }) => !uo.disableInteractive,
    style: {
      pointerEvents: "auto"
    }
  }, {
    props: ({
      open: uo
    }) => !uo,
    style: {
      pointerEvents: "none"
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.arrow,
    style: {
      [`&[data-popper-placement*="bottom"] .${tooltipClasses.arrow}`]: {
        top: 0,
        marginTop: "-0.71em",
        "&::before": {
          transformOrigin: "0 100%"
        }
      },
      [`&[data-popper-placement*="top"] .${tooltipClasses.arrow}`]: {
        bottom: 0,
        marginBottom: "-0.71em",
        "&::before": {
          transformOrigin: "100% 0"
        }
      },
      [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "100% 100%"
        }
      },
      [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
        height: "1em",
        width: "0.71em",
        "&::before": {
          transformOrigin: "0 0"
        }
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.arrow && !uo.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.arrow && !!uo.isRtl,
    style: {
      [`&[data-popper-placement*="right"] .${tooltipClasses.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.arrow && !uo.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
        right: 0,
        marginRight: "-0.71em"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.arrow && !!uo.isRtl,
    style: {
      [`&[data-popper-placement*="left"] .${tooltipClasses.arrow}`]: {
        left: 0,
        marginLeft: "-0.71em"
      }
    }
  }]
}))), TooltipTooltip = styled("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.tooltip, ho.touch && uo.touch, ho.arrow && uo.tooltipArrow, uo[`tooltipPlacement${capitalize(ho.placement.split("-")[0])}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  backgroundColor: Kt.vars ? Kt.vars.palette.Tooltip.bg : alpha$1(Kt.palette.grey[700], 0.92),
  borderRadius: (Kt.vars || Kt).shape.borderRadius,
  color: (Kt.vars || Kt).palette.common.white,
  fontFamily: Kt.typography.fontFamily,
  padding: "4px 8px",
  fontSize: Kt.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: Kt.typography.fontWeightMedium,
  [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
    transformOrigin: "right center"
  },
  [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
    transformOrigin: "left center"
  },
  [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
    transformOrigin: "center bottom",
    marginBottom: "14px"
  },
  [`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: {
    transformOrigin: "center top",
    marginTop: "14px"
  },
  variants: [{
    props: ({
      ownerState: uo
    }) => uo.arrow,
    style: {
      position: "relative",
      margin: 0
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.touch,
    style: {
      padding: "8px 16px",
      fontSize: Kt.typography.pxToRem(14),
      lineHeight: `${round$1(16 / 14)}em`,
      fontWeight: Kt.typography.fontWeightRegular
    }
  }, {
    props: ({
      ownerState: uo
    }) => !uo.isRtl,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "14px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "14px"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => !uo.isRtl && uo.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginRight: "24px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: "24px"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => !!uo.isRtl,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "14px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "14px"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => !!uo.isRtl && uo.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginLeft: "24px"
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginRight: "24px"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: "24px"
      }
    }
  }, {
    props: ({
      ownerState: uo
    }) => uo.touch,
    style: {
      [`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: "24px"
      }
    }
  }]
}))), TooltipArrow = styled("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (Kt, uo) => uo.arrow
})(memoTheme(({
  theme: Kt
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: Kt.vars ? Kt.vars.palette.Tooltip.bg : alpha$1(Kt.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
})));
let hystersisOpen = !1;
const hystersisTimer = new Timeout();
let cursorPosition = {
  x: 0,
  y: 0
};
function composeEventHandler(Kt, uo) {
  return (ho, ...go) => {
    uo && uo(ho, ...go), Kt(ho, ...go);
  };
}
const Tooltip$2 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiTooltip"
  }), {
    arrow: bo = !1,
    children: vo,
    classes: Po,
    components: Co = {},
    componentsProps: So = {},
    describeChild: wo = !1,
    disableFocusListener: Eo = !1,
    disableHoverListener: Ro = !1,
    disableInteractive: _o = !1,
    disableTouchListener: Io = !1,
    enterDelay: Ao = 100,
    enterNextDelay: Oo = 0,
    enterTouchDelay: jo = 700,
    followCursor: Do = !1,
    id: Lo,
    leaveDelay: ko = 0,
    leaveTouchDelay: Ko = 1500,
    onClose: No,
    onOpen: Jo,
    open: ti,
    placement: oi = "bottom",
    PopperComponent: Qo,
    PopperProps: Zo = {},
    slotProps: ei = {},
    slots: ii = {},
    title: ai,
    TransitionComponent: ri,
    TransitionProps: ni,
    ...si
  } = go, li = /* @__PURE__ */ React$1.isValidElement(vo) ? vo : /* @__PURE__ */ jsxRuntimeExports.jsx("span", {
    children: vo
  }), ui = useTheme(), ci = useRtl(), [fi, yi] = React$1.useState(), [hi, mi] = React$1.useState(null), bi = React$1.useRef(!1), xi = _o || Do, $i = useTimeout(), Ci = useTimeout(), Si = useTimeout(), vi = useTimeout(), [Pi, wi] = useControlled({
    controlled: ti,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let gi = Pi;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: ds
    } = React$1.useRef(ti !== void 0);
    React$1.useEffect(() => {
      fi && fi.disabled && !ds && ai !== "" && fi.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [ai, fi, ds]);
  }
  const Ri = useId(Lo), Ei = React$1.useRef(), Ni = useEventCallback(() => {
    Ei.current !== void 0 && (document.body.style.WebkitUserSelect = Ei.current, Ei.current = void 0), vi.clear();
  });
  React$1.useEffect(() => Ni, [Ni]);
  const Ai = (ds) => {
    hystersisTimer.clear(), hystersisOpen = !0, wi(!0), Jo && !gi && Jo(ds);
  }, Yi = useEventCallback(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (ds) => {
      hystersisTimer.start(800 + ko, () => {
        hystersisOpen = !1;
      }), wi(!1), No && gi && No(ds), $i.start(ui.transitions.duration.shortest, () => {
        bi.current = !1;
      });
    }
  ), Ui = (ds) => {
    bi.current && ds.type !== "touchstart" || (fi && fi.removeAttribute("title"), Ci.clear(), Si.clear(), Ao || hystersisOpen && Oo ? Ci.start(hystersisOpen ? Oo : Ao, () => {
      Ai(ds);
    }) : Ai(ds));
  }, us = (ds) => {
    Ci.clear(), Si.start(ko, () => {
      Yi(ds);
    });
  }, [, ns] = React$1.useState(!1), Ti = (ds) => {
    isFocusVisible(ds.target) || (ns(!1), us(ds));
  }, _i = (ds) => {
    fi || yi(ds.currentTarget), isFocusVisible(ds.target) && (ns(!0), Ui(ds));
  }, Vi = (ds) => {
    bi.current = !0;
    const Ls = li.props;
    Ls.onTouchStart && Ls.onTouchStart(ds);
  }, Bi = (ds) => {
    Vi(ds), Si.clear(), $i.clear(), Ni(), Ei.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", vi.start(jo, () => {
      document.body.style.WebkitUserSelect = Ei.current, Ui(ds);
    });
  }, Ji = (ds) => {
    li.props.onTouchEnd && li.props.onTouchEnd(ds), Ni(), Si.start(Ko, () => {
      Yi(ds);
    });
  };
  React$1.useEffect(() => {
    if (!gi)
      return;
    function ds(Ls) {
      Ls.key === "Escape" && Yi(Ls);
    }
    return document.addEventListener("keydown", ds), () => {
      document.removeEventListener("keydown", ds);
    };
  }, [Yi, gi]);
  const Ki = useForkRef(getReactElementRef(li), yi, ho);
  !ai && ai !== 0 && (gi = !1);
  const qi = React$1.useRef(), rs = (ds) => {
    const Ls = li.props;
    Ls.onMouseMove && Ls.onMouseMove(ds), cursorPosition = {
      x: ds.clientX,
      y: ds.clientY
    }, qi.current && qi.current.update();
  }, os = {}, ps = typeof ai == "string";
  wo ? (os.title = !gi && ps && !Ro ? ai : null, os["aria-describedby"] = gi ? Ri : null) : (os["aria-label"] = ps ? ai : null, os["aria-labelledby"] = gi && !ps ? Ri : null);
  const Mi = {
    ...os,
    ...si,
    ...li.props,
    className: clsx(si.className, li.props.className),
    onTouchStart: Vi,
    ref: Ki,
    ...Do ? {
      onMouseMove: rs
    } : {}
  };
  process.env.NODE_ENV !== "production" && (Mi["data-mui-internal-clone-element"] = !0, React$1.useEffect(() => {
    fi && !fi.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [fi]));
  const Wi = {};
  Io || (Mi.onTouchStart = Bi, Mi.onTouchEnd = Ji), Ro || (Mi.onMouseOver = composeEventHandler(Ui, Mi.onMouseOver), Mi.onMouseLeave = composeEventHandler(us, Mi.onMouseLeave), xi || (Wi.onMouseOver = Ui, Wi.onMouseLeave = us)), Eo || (Mi.onFocus = composeEventHandler(_i, Mi.onFocus), Mi.onBlur = composeEventHandler(Ti, Mi.onBlur), xi || (Wi.onFocus = _i, Wi.onBlur = Ti)), process.env.NODE_ENV !== "production" && li.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${li.props.title}\` or the Tooltip component.`].join(`
`));
  const Hi = {
    ...go,
    isRtl: ci,
    arrow: bo,
    disableInteractive: xi,
    placement: oi,
    PopperComponentProp: Qo,
    touch: bi.current
  }, Xi = typeof ei.popper == "function" ? ei.popper(Hi) : ei.popper, Zi = React$1.useMemo(() => {
    var Ls, Xs;
    let ds = [{
      name: "arrow",
      enabled: !!hi,
      options: {
        element: hi,
        padding: 4
      }
    }];
    return (Ls = Zo.popperOptions) != null && Ls.modifiers && (ds = ds.concat(Zo.popperOptions.modifiers)), (Xs = Xi == null ? void 0 : Xi.popperOptions) != null && Xs.modifiers && (ds = ds.concat(Xi.popperOptions.modifiers)), {
      ...Zo.popperOptions,
      ...Xi == null ? void 0 : Xi.popperOptions,
      modifiers: ds
    };
  }, [hi, Zo.popperOptions, Xi == null ? void 0 : Xi.popperOptions]), zi = useUtilityClasses$8(Hi), cs = typeof ei.transition == "function" ? ei.transition(Hi) : ei.transition, ys = {
    slots: {
      popper: Co.Popper,
      transition: Co.Transition ?? ri,
      tooltip: Co.Tooltip,
      arrow: Co.Arrow,
      ...ii
    },
    slotProps: {
      arrow: ei.arrow ?? So.arrow,
      popper: {
        ...Zo,
        ...Xi ?? So.popper
      },
      // resolvedPopperProps can be spread because it's already an object
      tooltip: ei.tooltip ?? So.tooltip,
      transition: {
        ...ni,
        ...cs ?? So.transition
      }
    }
  }, [$s, Ns] = useSlot("popper", {
    elementType: TooltipPopper,
    externalForwardedProps: ys,
    ownerState: Hi,
    className: clsx(zi.popper, Zo == null ? void 0 : Zo.className)
  }), [Bs, Ws] = useSlot("transition", {
    elementType: Grow,
    externalForwardedProps: ys,
    ownerState: Hi
  }), [Hs, Ks] = useSlot("tooltip", {
    elementType: TooltipTooltip,
    className: zi.tooltip,
    externalForwardedProps: ys,
    ownerState: Hi
  }), [zs, Ys] = useSlot("arrow", {
    elementType: TooltipArrow,
    className: zi.arrow,
    externalForwardedProps: ys,
    ownerState: Hi,
    ref: mi
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
    children: [/* @__PURE__ */ React$1.cloneElement(li, Mi), /* @__PURE__ */ jsxRuntimeExports.jsx($s, {
      as: Qo ?? Popper,
      placement: oi,
      anchorEl: Do ? {
        getBoundingClientRect: () => ({
          top: cursorPosition.y,
          left: cursorPosition.x,
          right: cursorPosition.x,
          bottom: cursorPosition.y,
          width: 0,
          height: 0
        })
      } : fi,
      popperRef: qi,
      open: fi ? gi : !1,
      id: Ri,
      transition: !0,
      ...Wi,
      ...Ns,
      popperOptions: Zi,
      children: ({
        TransitionProps: ds
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Bs, {
        timeout: ui.transitions.duration.shorter,
        ...ds,
        ...Ws,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Hs, {
          ...Ks,
          children: [ai, bo ? /* @__PURE__ */ jsxRuntimeExports.jsx(zs, {
            ...Ys
          }) : null]
        })
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Tooltip$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: PropTypes.bool,
  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  components: PropTypes.shape({
    Arrow: PropTypes.elementType,
    Popper: PropTypes.elementType,
    Tooltip: PropTypes.elementType,
    Transition: PropTypes.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   *
   * @default {}
   */
  componentsProps: PropTypes.shape({
    arrow: PropTypes.object,
    popper: PropTypes.object,
    tooltip: PropTypes.object,
    transition: PropTypes.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: PropTypes.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: PropTypes.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: PropTypes.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: PropTypes.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: PropTypes.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: PropTypes.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: PropTypes.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: PropTypes.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: PropTypes.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: PropTypes.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: PropTypes.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: PropTypes.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: PropTypes.func,
  /**
   * If `true`, the component is shown.
   */
  open: PropTypes.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: PropTypes.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @deprecated use the `slots.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  PopperComponent: PropTypes.elementType,
  /**
   * Props applied to the [`Popper`](https://mui.com/material-ui/api/popper/) element.
   * @deprecated use the `slotProps.popper` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  PopperProps: PropTypes.object,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    arrow: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    popper: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    tooltip: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    transition: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    arrow: PropTypes.elementType,
    popper: PropTypes.elementType,
    tooltip: PropTypes.elementType,
    transition: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: PropTypes.node,
  /**
   * The component used for the transition.
   * [Follow this guide](https://mui.com/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated use the `slots.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  TransitionComponent: PropTypes.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated use the `slotProps.transition` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   * @default {}
   */
  TransitionProps: PropTypes.object
});
const _excluded$i = ["sortingOrder"], GridColumnUnsortedIcon = /* @__PURE__ */ React$1.memo(function(uo) {
  const {
    sortingOrder: ho
  } = uo, go = _objectWithoutPropertiesLoose$h(uo, _excluded$i), bo = useGridRootProps(), [vo] = ho, Po = vo === "asc" ? bo.slots.columnSortedAscendingIcon : bo.slots.columnSortedDescendingIcon;
  return Po ? /* @__PURE__ */ jsxRuntimeExports.jsx(Po, _extends$q({}, go)) : null;
}), _excluded$h = ["native"];
function MUISelectOption(Kt) {
  let {
    native: uo
  } = Kt, ho = _objectWithoutPropertiesLoose$h(Kt, _excluded$h);
  return uo ? /* @__PURE__ */ jsxRuntimeExports.jsx("option", _extends$q({}, ho)) : /* @__PURE__ */ jsxRuntimeExports.jsx(MenuItem, _extends$q({}, ho));
}
const iconSlots = {
  booleanCellTrueIcon: GridCheckIcon,
  booleanCellFalseIcon: GridCloseIcon,
  columnMenuIcon: GridTripleDotsVerticalIcon,
  openFilterButtonIcon: GridFilterListIcon,
  filterPanelDeleteIcon: GridCloseIcon,
  columnFilteredIcon: GridFilterAltIcon,
  columnSelectorIcon: GridColumnIcon,
  columnUnsortedIcon: GridColumnUnsortedIcon,
  columnSortedAscendingIcon: GridArrowUpwardIcon,
  columnSortedDescendingIcon: GridArrowDownwardIcon,
  columnResizeIcon: GridSeparatorIcon,
  densityCompactIcon: GridViewHeadlineIcon,
  densityStandardIcon: GridTableRowsIcon,
  densityComfortableIcon: GridViewStreamIcon,
  exportIcon: GridSaveAltIcon,
  moreActionsIcon: GridMoreVertIcon,
  treeDataCollapseIcon: GridExpandMoreIcon,
  treeDataExpandIcon: GridKeyboardArrowRight,
  groupingCriteriaCollapseIcon: GridExpandMoreIcon,
  groupingCriteriaExpandIcon: GridKeyboardArrowRight,
  detailPanelExpandIcon: GridAddIcon,
  detailPanelCollapseIcon: GridRemoveIcon,
  rowReorderIcon: GridDragIcon,
  quickFilterIcon: GridSearchIcon,
  quickFilterClearIcon: GridCloseIcon,
  columnMenuHideIcon: GridVisibilityOffIcon,
  columnMenuSortAscendingIcon: GridArrowUpwardIcon,
  columnMenuSortDescendingIcon: GridArrowDownwardIcon,
  columnMenuFilterIcon: GridFilterAltIcon,
  columnMenuManageColumnsIcon: GridViewColumnIcon,
  columnMenuClearIcon: GridClearIcon,
  loadIcon: GridLoadIcon,
  filterPanelAddIcon: GridAddIcon,
  filterPanelRemoveAllIcon: GridDeleteForeverIcon,
  columnReorderIcon: GridDragIcon
}, materialSlots = _extends$q({}, iconSlots, {
  baseBadge: Badge$1,
  baseCheckbox: Checkbox,
  baseDivider: Divider,
  baseTextField: TextField,
  baseFormControl: FormControl,
  baseSelect: Select$1,
  baseButton: Button,
  baseIconButton: IconButton,
  baseInputAdornment: InputAdornment,
  baseTooltip: Tooltip$2,
  basePopper: Popper,
  baseInputLabel: InputLabel,
  baseSelectOption: MUISelectOption,
  baseChip: Chip
}), DATA_GRID_DEFAULT_SLOTS_COMPONENTS = _extends$q({}, materialSlots, {
  cell: MemoizedGridCell,
  skeletonCell: Memoized$1,
  columnHeaderFilterIconButton: GridColumnHeaderFilterIconButton,
  columnHeaderSortIcon: GridColumnHeaderSortIcon,
  columnMenu: GridColumnMenu,
  columnHeaders: MemoizedGridColumnHeaders,
  detailPanels: GridDetailPanels,
  footer: GridFooter,
  footerRowCount: GridRowCount,
  toolbar: null,
  pinnedRows: GridPinnedRows,
  loadingOverlay: GridLoadingOverlay,
  noResultsOverlay: GridNoResultsOverlay,
  noRowsOverlay: GridNoRowsOverlay,
  pagination: GridPagination,
  filterPanel: GridFilterPanel,
  columnsPanel: GridColumnsPanel,
  columnsManagement: GridColumnsManagement,
  panel: GridPanel,
  row: MemoizedGridRow
});
function computeSlots({
  defaultSlots: Kt,
  slots: uo
}) {
  const ho = uo;
  if (!ho || Object.keys(ho).length === 0)
    return Kt;
  const go = _extends$q({}, Kt);
  return Object.keys(ho).forEach((bo) => {
    const vo = bo;
    ho[vo] !== void 0 && (go[vo] = ho[vo]);
  }), go;
}
function groupForwardedProps(Kt) {
  var bo;
  if ((bo = Kt.slotProps) != null && bo.root)
    return Kt;
  const uo = Object.keys(Kt);
  if (!uo.some((vo) => vo.startsWith("aria-") || vo.startsWith("data-")))
    return Kt;
  const ho = {}, go = Kt.forwardedProps ?? {};
  for (let vo = 0; vo < uo.length; vo += 1) {
    const Po = uo[vo];
    Po.startsWith("aria-") || Po.startsWith("data-") ? go[Po] = Kt[Po] : ho[Po] = Kt[Po];
  }
  return ho.forwardedProps = go, ho;
}
function useProps(Kt) {
  return React$1.useMemo(() => groupForwardedProps(Kt), [Kt]);
}
const propValidatorsDataGrid = [(Kt) => Kt.autoPageSize && Kt.autoHeight && ["MUI X: `<DataGrid autoPageSize={true} autoHeight={true} />` are not valid props.", "You cannot use both the `autoPageSize` and `autoHeight` props at the same time because `autoHeight` scales the height of the Data Grid according to the `pageSize`.", "", "Please remove one of these two props."].join(`
`) || void 0, (Kt) => Kt.paginationMode === "client" && Kt.paginationMeta != null && ['MUI X: Usage of the `paginationMeta` prop with client-side pagination (`paginationMode="client"`) has no effect.', '`paginationMeta` is only meant to be used with `paginationMode="server"`.'].join(`
`) || void 0, (Kt) => Kt.signature === GridSignature.DataGrid && Kt.paginationMode === "client" && isNumber$5(Kt.rowCount) && ['MUI X: Usage of the `rowCount` prop with client side pagination (`paginationMode="client"`) has no effect.', '`rowCount` is only meant to be used with `paginationMode="server"`.'].join(`
`) || void 0, (Kt) => Kt.paginationMode === "server" && Kt.rowCount == null && !Kt.unstable_dataSource && ["MUI X: The `rowCount` prop must be passed using `paginationMode='server'`", "For more detail, see http://mui.com/components/data-grid/pagination/#index-based-pagination"].join(`
`) || void 0];
function validateProps(Kt, uo) {
  uo.forEach((ho) => {
    const go = ho(Kt);
    go && warnOnce(go, "error");
  });
}
const DATA_GRID_FORCED_PROPS = {
  disableMultipleColumnsFiltering: !0,
  disableMultipleColumnsSorting: !0,
  throttleRowsMs: void 0,
  hideFooterRowCount: !1,
  pagination: !0,
  checkboxSelectionVisibleOnly: !1,
  disableColumnReorder: !0,
  keepColumnPositionIfDraggedOutside: !1,
  signature: "DataGrid",
  unstable_listView: !1
}, defaultSlots = DATA_GRID_DEFAULT_SLOTS_COMPONENTS, useDataGridProps = (Kt) => {
  const uo = useProps(
    // eslint-disable-next-line material-ui/mui-name-matches-component-name
    useThemeProps({
      props: Kt,
      name: "MuiDataGrid"
    })
  ), ho = React$1.useMemo(() => _extends$q({}, GRID_DEFAULT_LOCALE_TEXT, uo.localeText), [uo.localeText]), go = React$1.useMemo(() => computeSlots({
    defaultSlots,
    slots: uo.slots
  }), [uo.slots]), bo = React$1.useMemo(() => Object.keys(DATA_GRID_PROPS_DEFAULT_VALUES).reduce((vo, Po) => (vo[Po] = uo[Po] ?? DATA_GRID_PROPS_DEFAULT_VALUES[Po], vo), {}), [uo]);
  return React$1.useMemo(() => _extends$q({}, uo, bo, {
    localeText: ho,
    slots: go
  }, DATA_GRID_FORCED_PROPS), [uo, ho, go, bo]);
}, configuration = {
  hooks: {
    useGridAriaAttributes,
    useGridRowAriaAttributes
  }
};
let propValidators;
process.env.NODE_ENV !== "production" && (propValidators = [
  ...propValidatorsDataGrid,
  // Only validate in MIT version
  (Kt) => Kt.columns && Kt.columns.some((uo) => uo.resizable) && ["MUI X: `column.resizable = true` is not a valid prop.", "Column resizing is not available in the MIT version.", "", "You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature."].join(`
`) || void 0
]);
const DataGridRaw = forwardRef(function(uo, ho) {
  var vo;
  const go = useDataGridProps(uo), bo = useDataGridComponent(go.apiRef, go);
  return process.env.NODE_ENV !== "production" && validateProps(go, propValidators), /* @__PURE__ */ jsxRuntimeExports.jsx(GridContextProvider, {
    privateApiRef: bo,
    configuration,
    props: go,
    children: /* @__PURE__ */ jsxRuntimeExports.jsxs(GridRoot, _extends$q({
      className: go.className,
      style: go.style,
      sx: go.sx
    }, go.forwardedProps, (vo = go.slotProps) == null ? void 0 : vo.root, {
      ref: ho,
      children: [/* @__PURE__ */ jsxRuntimeExports.jsx(GridHeader, {}), /* @__PURE__ */ jsxRuntimeExports.jsx(GridVirtualScroller, {}), /* @__PURE__ */ jsxRuntimeExports.jsx(GridFooterPlaceholder, {})]
    }))
  });
}), DataGrid = /* @__PURE__ */ React$1.memo(DataGridRaw);
DataGridRaw.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * The ref object that allows Data Grid manipulation. Can be instantiated with `useGridApiRef()`.
   */
  apiRef: PropTypes.shape({
    current: PropTypes.object.isRequired
  }),
  /**
   * The label of the Data Grid.
   */
  "aria-label": PropTypes.string,
  /**
   * The id of the element containing a label for the Data Grid.
   */
  "aria-labelledby": PropTypes.string,
  /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */
  autoHeight: PropTypes.bool,
  /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */
  autoPageSize: PropTypes.bool,
  /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */
  autosizeOnMount: PropTypes.bool,
  /**
   * The options for autosize when user-initiated.
   */
  autosizeOptions: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.string),
    disableColumnVirtualization: PropTypes.bool,
    expand: PropTypes.bool,
    includeHeaders: PropTypes.bool,
    includeOutliers: PropTypes.bool,
    outliersFactor: PropTypes.number
  }),
  /**
   * Controls the modes of the cells.
   */
  cellModesModel: PropTypes.object,
  /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */
  checkboxSelection: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */
  clipboardCopyCellDelimiter: PropTypes.string,
  /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */
  columnBufferPx: PropTypes.number,
  /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */
  columnGroupHeaderHeight: PropTypes.number,
  columnGroupingModel: PropTypes.arrayOf(PropTypes.object),
  /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */
  columnHeaderHeight: PropTypes.number,
  /**
   * Set of columns of type [[GridColDef]][].
   */
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */
  columnVisibilityModel: PropTypes.object,
  /**
   * Set the density of the Data Grid.
   * @default "standard"
   */
  density: PropTypes.oneOf(["comfortable", "compact", "standard"]),
  /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */
  disableAutosize: PropTypes.bool,
  /**
   * If `true`, column filters are disabled.
   * @default false
   */
  disableColumnFilter: PropTypes.bool,
  /**
   * If `true`, the column menu is disabled.
   * @default false
   */
  disableColumnMenu: PropTypes.bool,
  /**
   * If `true`, resizing columns is disabled.
   * @default false
   */
  disableColumnResize: PropTypes.bool,
  /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */
  disableColumnSelector: PropTypes.bool,
  /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */
  disableColumnSorting: PropTypes.bool,
  /**
   * If `true`, the density selector is disabled.
   * @default false
   */
  disableDensitySelector: PropTypes.bool,
  /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */
  disableEval: PropTypes.bool,
  /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */
  disableMultipleRowSelection: PropTypes.bool,
  /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */
  disableRowSelectionOnClick: PropTypes.bool,
  /**
   * If `true`, the virtualization is disabled.
   * @default false
   */
  disableVirtualization: PropTypes.bool,
  /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */
  editMode: PropTypes.oneOf(["cell", "row"]),
  /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */
  estimatedRowCount: PropTypes.number,
  /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */
  experimentalFeatures: PropTypes.shape({
    warnIfFocusStateIsNotSynced: PropTypes.bool
  }),
  /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */
  filterDebounceMs: PropTypes.number,
  /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */
  filterMode: PropTypes.oneOf(["client", "server"]),
  /**
   * Set the filter model of the Data Grid.
   */
  filterModel: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({
      field: PropTypes.string.isRequired,
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      operator: PropTypes.string.isRequired,
      value: PropTypes.any
    })).isRequired,
    logicOperator: PropTypes.oneOf(["and", "or"]),
    quickFilterExcludeHiddenColumns: PropTypes.bool,
    quickFilterLogicOperator: PropTypes.oneOf(["and", "or"]),
    quickFilterValues: PropTypes.array
  }),
  /**
   * Forwarded props for the Data Grid root element.
   * @ignore - do not document.
   */
  forwardedProps: PropTypes.object,
  /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */
  getCellClassName: PropTypes.func,
  /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */
  getDetailPanelContent: PropTypes.func,
  /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */
  getEstimatedRowHeight: PropTypes.func,
  /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */
  getRowClassName: PropTypes.func,
  /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */
  getRowHeight: PropTypes.func,
  /**
   * Return the id of a given [[GridRowModel]].
   */
  getRowId: PropTypes.func,
  /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */
  getRowSpacing: PropTypes.func,
  /**
   * If `true`, the footer component is hidden.
   * @default false
   */
  hideFooter: PropTypes.bool,
  /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */
  hideFooterPagination: PropTypes.bool,
  /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */
  hideFooterSelectedRowCount: PropTypes.bool,
  /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */
  ignoreDiacritics: PropTypes.bool,
  /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */
  ignoreValueFormatterDuringExport: PropTypes.oneOfType([PropTypes.shape({
    clipboardExport: PropTypes.bool,
    csvExport: PropTypes.bool
  }), PropTypes.bool]),
  /**
   * If `select`, a group header checkbox in indeterminate state (like "Select All" checkbox)
   * will select all the rows under it.
   * If `deselect`, it will deselect all the rows under it.
   * Works only if `checkboxSelection` is enabled.
   * @default "deselect"
   * @deprecated `select` will be the default behavior from v8 onwards
   */
  indeterminateCheckboxAction: PropTypes.oneOf(["deselect", "select"]),
  /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */
  initialState: PropTypes.object,
  /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */
  isCellEditable: PropTypes.func,
  /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */
  isRowSelectable: PropTypes.func,
  /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */
  keepNonExistentRowsSelected: PropTypes.bool,
  /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */
  loading: PropTypes.bool,
  /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */
  localeText: PropTypes.object,
  /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */
  logger: PropTypes.shape({
    debug: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
    info: PropTypes.func.isRequired,
    warn: PropTypes.func.isRequired
  }),
  /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */
  logLevel: PropTypes.oneOf(["debug", "error", "info", "warn", !1]),
  /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */
  nonce: PropTypes.string,
  /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellClick: PropTypes.func,
  /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellDoubleClick: PropTypes.func,
  /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStart: PropTypes.func,
  /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onCellEditStop: PropTypes.func,
  /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellKeyDown: PropTypes.func,
  /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onCellModesModelChange: PropTypes.func,
  /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */
  onClipboardCopy: PropTypes.func,
  /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderClick: PropTypes.func,
  /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */
  onColumnHeaderContextMenu: PropTypes.func,
  /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderDoubleClick: PropTypes.func,
  /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderEnter: PropTypes.func,
  /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderLeave: PropTypes.func,
  /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOut: PropTypes.func,
  /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnHeaderOver: PropTypes.func,
  /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnOrderChange: PropTypes.func,
  /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnResize: PropTypes.func,
  /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnVisibilityModelChange: PropTypes.func,
  /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onColumnWidthChange: PropTypes.func,
  /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */
  onDensityChange: PropTypes.func,
  /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onFilterModelChange: PropTypes.func,
  /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuClose: PropTypes.func,
  /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onMenuOpen: PropTypes.func,
  /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */
  onPaginationMetaChange: PropTypes.func,
  /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPaginationModelChange: PropTypes.func,
  /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelClose: PropTypes.func,
  /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onPreferencePanelOpen: PropTypes.func,
  /**
   * Callback called when `processRowUpdate` throws an error or rejects.
   * @param {any} error The error thrown.
   */
  onProcessRowUpdateError: PropTypes.func,
  /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onResize: PropTypes.func,
  /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowClick: PropTypes.func,
  /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */
  onRowCountChange: PropTypes.func,
  /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowDoubleClick: PropTypes.func,
  /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStart: PropTypes.func,
  /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */
  onRowEditStop: PropTypes.func,
  /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowModesModelChange: PropTypes.func,
  /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onRowSelectionModelChange: PropTypes.func,
  /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */
  onSortModelChange: PropTypes.func,
  /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */
  onStateChange: PropTypes.func,
  /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */
  pageSizeOptions: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired
  })]).isRequired),
  pagination: PropTypes.oneOf([!0]),
  /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */
  paginationMeta: PropTypes.shape({
    hasNextPage: PropTypes.bool
  }),
  /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */
  paginationMode: PropTypes.oneOf(["client", "server"]),
  /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */
  paginationModel: PropTypes.shape({
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired
  }),
  /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */
  processRowUpdate: PropTypes.func,
  /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */
  resizeThrottleMs: PropTypes.number,
  /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */
  rowBufferPx: PropTypes.number,
  /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */
  rowCount: PropTypes.number,
  /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */
  rowHeight: PropTypes.number,
  /**
   * Controls the modes of the rows.
   */
  rowModesModel: PropTypes.object,
  /**
   * The milliseconds delay to wait after measuring the row height before recalculating row positions.
   * Setting it to a lower value could be useful when using dynamic row height,
   * but might reduce performance when displaying a large number of rows.
   * @default 166
   * @deprecated
   */
  rowPositionsDebounceMs: PropTypes.number,
  /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */
  rows: PropTypes.arrayOf(PropTypes.object),
  /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */
  rowSelection: PropTypes.bool,
  /**
   * Sets the row selection model of the Data Grid.
   */
  rowSelectionModel: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired), PropTypes.number, PropTypes.string]),
  /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */
  rowSpacingType: PropTypes.oneOf(["border", "margin"]),
  /**
   * Override the height/width of the Data Grid inner scrollbar.
   */
  scrollbarSize: PropTypes.number,
  /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */
  showCellVerticalBorder: PropTypes.bool,
  /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */
  showColumnVerticalBorder: PropTypes.bool,
  /**
   * Overridable components props dynamically passed to the component at rendering.
   */
  slotProps: PropTypes.object,
  /**
   * Overridable components.
   */
  slots: PropTypes.object,
  /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */
  sortingMode: PropTypes.oneOf(["client", "server"]),
  /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */
  sortingOrder: PropTypes.arrayOf(PropTypes.oneOf(["asc", "desc"])),
  /**
   * Set the sort model of the Data Grid.
   */
  sortModel: PropTypes.arrayOf(PropTypes.shape({
    field: PropTypes.string.isRequired,
    sort: PropTypes.oneOf(["asc", "desc"])
  })),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */
  unstable_rowSpanning: PropTypes.bool,
  /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */
  virtualizeColumnsWithAutoRowHeight: PropTypes.bool
};
function getPaginationUtilityClass(Kt) {
  return generateUtilityClass$1("MuiPagination", Kt);
}
generateUtilityClasses$1("MuiPagination", ["root", "ul", "outlined", "text"]);
function usePagination$1(Kt = {}) {
  const {
    boundaryCount: uo = 1,
    componentName: ho = "usePagination",
    count: go = 1,
    defaultPage: bo = 1,
    disabled: vo = !1,
    hideNextButton: Po = !1,
    hidePrevButton: Co = !1,
    onChange: So,
    page: wo,
    showFirstButton: Eo = !1,
    showLastButton: Ro = !1,
    siblingCount: _o = 1,
    ...Io
  } = Kt, [Ao, Oo] = useControlled({
    controlled: wo,
    default: bo,
    name: ho,
    state: "page"
  }), jo = (Qo, Zo) => {
    wo || Oo(Zo), So && So(Qo, Zo);
  }, Do = (Qo, Zo) => {
    const ei = Zo - Qo + 1;
    return Array.from({
      length: ei
    }, (ii, ai) => Qo + ai);
  }, Lo = Do(1, Math.min(uo, go)), ko = Do(Math.max(go - uo + 1, uo + 1), go), Ko = Math.max(
    Math.min(
      // Natural start
      Ao - _o,
      // Lower boundary when page is high
      go - uo - _o * 2 - 1
    ),
    // Greater than startPages
    uo + 2
  ), No = Math.min(
    Math.max(
      // Natural end
      Ao + _o,
      // Upper boundary when page is low
      uo + _o * 2 + 2
    ),
    // Less than endPages
    go - uo - 1
  ), Jo = [
    ...Eo ? ["first"] : [],
    ...Co ? [] : ["previous"],
    ...Lo,
    // Start ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...Ko > uo + 2 ? ["start-ellipsis"] : uo + 1 < go - uo ? [uo + 1] : [],
    // Sibling pages
    ...Do(Ko, No),
    // End ellipsis
    // eslint-disable-next-line no-nested-ternary
    ...No < go - uo - 1 ? ["end-ellipsis"] : go - uo > uo ? [go - uo] : [],
    ...ko,
    ...Po ? [] : ["next"],
    ...Ro ? ["last"] : []
  ], ti = (Qo) => {
    switch (Qo) {
      case "first":
        return 1;
      case "previous":
        return Ao - 1;
      case "next":
        return Ao + 1;
      case "last":
        return go;
      default:
        return null;
    }
  };
  return {
    items: Jo.map((Qo) => typeof Qo == "number" ? {
      onClick: (Zo) => {
        jo(Zo, Qo);
      },
      type: "page",
      page: Qo,
      selected: Qo === Ao,
      disabled: vo,
      "aria-current": Qo === Ao ? "page" : void 0
    } : {
      onClick: (Zo) => {
        jo(Zo, ti(Qo));
      },
      type: Qo,
      page: ti(Qo),
      selected: !1,
      disabled: vo || !Qo.includes("ellipsis") && (Qo === "next" || Qo === "last" ? Ao >= go : Ao <= 1)
    }),
    ...Io
  };
}
function getPaginationItemUtilityClass(Kt) {
  return generateUtilityClass$1("MuiPaginationItem", Kt);
}
const paginationItemClasses = generateUtilityClasses$1("MuiPaginationItem", ["root", "page", "sizeSmall", "sizeLarge", "text", "textPrimary", "textSecondary", "outlined", "outlinedPrimary", "outlinedSecondary", "rounded", "ellipsis", "firstLast", "previousNext", "focusVisible", "disabled", "selected", "icon", "colorPrimary", "colorSecondary"]), NavigateBeforeIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "NavigateBefore"), NavigateNextIcon = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "NavigateNext"), overridesResolver = (Kt, uo) => {
  const {
    ownerState: ho
  } = Kt;
  return [uo.root, uo[ho.variant], uo[`size${capitalize(ho.size)}`], ho.variant === "text" && uo[`text${capitalize(ho.color)}`], ho.variant === "outlined" && uo[`outlined${capitalize(ho.color)}`], ho.shape === "rounded" && uo.rounded, ho.type === "page" && uo.page, (ho.type === "start-ellipsis" || ho.type === "end-ellipsis") && uo.ellipsis, (ho.type === "previous" || ho.type === "next") && uo.previousNext, (ho.type === "first" || ho.type === "last") && uo.firstLast];
}, useUtilityClasses$7 = (Kt) => {
  const {
    classes: uo,
    color: ho,
    disabled: go,
    selected: bo,
    size: vo,
    shape: Po,
    type: Co,
    variant: So
  } = Kt, wo = {
    root: ["root", `size${capitalize(vo)}`, So, Po, ho !== "standard" && `color${capitalize(ho)}`, ho !== "standard" && `${So}${capitalize(ho)}`, go && "disabled", bo && "selected", {
      page: "page",
      first: "firstLast",
      last: "firstLast",
      "start-ellipsis": "ellipsis",
      "end-ellipsis": "ellipsis",
      previous: "previousNext",
      next: "previousNext"
    }[Co]],
    icon: ["icon"]
  };
  return composeClasses(wo, getPaginationItemUtilityClass, uo);
}, PaginationItemEllipsis = styled("div", {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (Kt.vars || Kt).palette.text.primary,
  height: "auto",
  [`&.${paginationItemClasses.disabled}`]: {
    opacity: (Kt.vars || Kt).palette.action.disabledOpacity
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: Kt.typography.pxToRem(15)
    }
  }]
}))), PaginationItemPage = styled(ButtonBase, {
  name: "MuiPaginationItem",
  slot: "Root",
  overridesResolver
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body2,
  borderRadius: 32 / 2,
  textAlign: "center",
  boxSizing: "border-box",
  minWidth: 32,
  height: 32,
  padding: "0 6px",
  margin: "0 3px",
  color: (Kt.vars || Kt).palette.text.primary,
  [`&.${paginationItemClasses.focusVisible}`]: {
    backgroundColor: (Kt.vars || Kt).palette.action.focus
  },
  [`&.${paginationItemClasses.disabled}`]: {
    opacity: (Kt.vars || Kt).palette.action.disabledOpacity
  },
  transition: Kt.transitions.create(["color", "background-color"], {
    duration: Kt.transitions.duration.short
  }),
  "&:hover": {
    backgroundColor: (Kt.vars || Kt).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${paginationItemClasses.selected}`]: {
    backgroundColor: (Kt.vars || Kt).palette.action.selected,
    "&:hover": {
      backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.action.selectedChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.hoverOpacity}))` : alpha$1(Kt.palette.action.selected, Kt.palette.action.selectedOpacity + Kt.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (Kt.vars || Kt).palette.action.selected
      }
    },
    [`&.${paginationItemClasses.focusVisible}`]: {
      backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.action.selectedChannel} / calc(${Kt.vars.palette.action.selectedOpacity} + ${Kt.vars.palette.action.focusOpacity}))` : alpha$1(Kt.palette.action.selected, Kt.palette.action.selectedOpacity + Kt.palette.action.focusOpacity)
    },
    [`&.${paginationItemClasses.disabled}`]: {
      opacity: 1,
      color: (Kt.vars || Kt).palette.action.disabled,
      backgroundColor: (Kt.vars || Kt).palette.action.selected
    }
  },
  variants: [{
    props: {
      size: "small"
    },
    style: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: "0 1px",
      padding: "0 4px"
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: "0 10px",
      fontSize: Kt.typography.pxToRem(15)
    }
  }, {
    props: {
      shape: "rounded"
    },
    style: {
      borderRadius: (Kt.vars || Kt).shape.borderRadius
    }
  }, {
    props: {
      variant: "outlined"
    },
    style: {
      border: Kt.vars ? `1px solid rgba(${Kt.vars.palette.common.onBackgroundChannel} / 0.23)` : `1px solid ${Kt.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"}`,
      [`&.${paginationItemClasses.selected}`]: {
        [`&.${paginationItemClasses.disabled}`]: {
          borderColor: (Kt.vars || Kt).palette.action.disabledBackground,
          color: (Kt.vars || Kt).palette.action.disabled
        }
      }
    }
  }, {
    props: {
      variant: "text"
    },
    style: {
      [`&.${paginationItemClasses.selected}`]: {
        [`&.${paginationItemClasses.disabled}`]: {
          color: (Kt.vars || Kt).palette.action.disabled
        }
      }
    }
  }, ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter(["dark", "contrastText"])).map(([uo]) => ({
    props: {
      variant: "text",
      color: uo
    },
    style: {
      [`&.${paginationItemClasses.selected}`]: {
        color: (Kt.vars || Kt).palette[uo].contrastText,
        backgroundColor: (Kt.vars || Kt).palette[uo].main,
        "&:hover": {
          backgroundColor: (Kt.vars || Kt).palette[uo].dark,
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: (Kt.vars || Kt).palette[uo].main
          }
        },
        [`&.${paginationItemClasses.focusVisible}`]: {
          backgroundColor: (Kt.vars || Kt).palette[uo].dark
        },
        [`&.${paginationItemClasses.disabled}`]: {
          color: (Kt.vars || Kt).palette.action.disabled
        }
      }
    }
  })), ...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter(["light"])).map(([uo]) => ({
    props: {
      variant: "outlined",
      color: uo
    },
    style: {
      [`&.${paginationItemClasses.selected}`]: {
        color: (Kt.vars || Kt).palette[uo].main,
        border: `1px solid ${Kt.vars ? `rgba(${Kt.vars.palette[uo].mainChannel} / 0.5)` : alpha$1(Kt.palette[uo].main, 0.5)}`,
        backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette[uo].mainChannel} / ${Kt.vars.palette.action.activatedOpacity})` : alpha$1(Kt.palette[uo].main, Kt.palette.action.activatedOpacity),
        "&:hover": {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette[uo].mainChannel} / calc(${Kt.vars.palette.action.activatedOpacity} + ${Kt.vars.palette.action.focusOpacity}))` : alpha$1(Kt.palette[uo].main, Kt.palette.action.activatedOpacity + Kt.palette.action.focusOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${paginationItemClasses.focusVisible}`]: {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette[uo].mainChannel} / calc(${Kt.vars.palette.action.activatedOpacity} + ${Kt.vars.palette.action.focusOpacity}))` : alpha$1(Kt.palette[uo].main, Kt.palette.action.activatedOpacity + Kt.palette.action.focusOpacity)
        }
      }
    }
  }))]
}))), PaginationItemPageIcon = styled("div", {
  name: "MuiPaginationItem",
  slot: "Icon",
  overridesResolver: (Kt, uo) => uo.icon
})(memoTheme(({
  theme: Kt
}) => ({
  fontSize: Kt.typography.pxToRem(20),
  margin: "0 -8px",
  variants: [{
    props: {
      size: "small"
    },
    style: {
      fontSize: Kt.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      fontSize: Kt.typography.pxToRem(22)
    }
  }]
}))), PaginationItem = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiPaginationItem"
  }), {
    className: bo,
    color: vo = "standard",
    component: Po,
    components: Co = {},
    disabled: So = !1,
    page: wo,
    selected: Eo = !1,
    shape: Ro = "circular",
    size: _o = "medium",
    slots: Io = {},
    slotProps: Ao = {},
    type: Oo = "page",
    variant: jo = "text",
    ...Do
  } = go, Lo = {
    ...go,
    color: vo,
    disabled: So,
    selected: Eo,
    shape: Ro,
    size: _o,
    type: Oo,
    variant: jo
  }, ko = useRtl(), Ko = useUtilityClasses$7(Lo), No = {
    slots: {
      previous: Io.previous ?? Co.previous,
      next: Io.next ?? Co.next,
      first: Io.first ?? Co.first,
      last: Io.last ?? Co.last
    },
    slotProps: Ao
  }, [Jo, ti] = useSlot("previous", {
    elementType: NavigateBeforeIcon,
    externalForwardedProps: No,
    ownerState: Lo
  }), [oi, Qo] = useSlot("next", {
    elementType: NavigateNextIcon,
    externalForwardedProps: No,
    ownerState: Lo
  }), [Zo, ei] = useSlot("first", {
    elementType: FirstPageIcon,
    externalForwardedProps: No,
    ownerState: Lo
  }), [ii, ai] = useSlot("last", {
    elementType: LastPageIcon,
    externalForwardedProps: No,
    ownerState: Lo
  }), ri = ko ? {
    previous: "next",
    next: "previous",
    first: "last",
    last: "first"
  }[Oo] : Oo, ni = {
    previous: Jo,
    next: oi,
    first: Zo,
    last: ii
  }[ri], si = {
    previous: ti,
    next: Qo,
    first: ei,
    last: ai
  }[ri];
  return Oo === "start-ellipsis" || Oo === "end-ellipsis" ? /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationItemEllipsis, {
    ref: ho,
    ownerState: Lo,
    className: clsx(Ko.root, bo),
    children: "…"
  }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(PaginationItemPage, {
    ref: ho,
    ownerState: Lo,
    component: Po,
    disabled: So,
    className: clsx(Ko.root, bo),
    ...Do,
    children: [Oo === "page" && wo, ni ? /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationItemPageIcon, {
      ...si,
      className: Ko.icon,
      as: ni
    }) : null]
  });
});
process.env.NODE_ENV !== "production" && (PaginationItem.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "standard"]), PropTypes.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  components: PropTypes.shape({
    first: PropTypes.elementType,
    last: PropTypes.elementType,
    next: PropTypes.elementType,
    previous: PropTypes.elementType
  }),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * The current page number.
   */
  page: PropTypes.node,
  /**
   * If `true` the pagination item is selected.
   * @default false
   */
  selected: PropTypes.bool,
  /**
   * The shape of the pagination item.
   * @default 'circular'
   */
  shape: PropTypes.oneOf(["circular", "rounded"]),
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    first: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    last: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    next: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    previous: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    first: PropTypes.elementType,
    last: PropTypes.elementType,
    next: PropTypes.elementType,
    previous: PropTypes.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The type of pagination item.
   * @default 'page'
   */
  type: PropTypes.oneOf(["end-ellipsis", "first", "last", "next", "page", "previous", "start-ellipsis"]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["outlined", "text"]), PropTypes.string])
});
const useUtilityClasses$6 = (Kt) => {
  const {
    classes: uo,
    variant: ho
  } = Kt;
  return composeClasses({
    root: ["root", ho],
    ul: ["ul"]
  }, getPaginationUtilityClass, uo);
}, PaginationRoot = styled("nav", {
  name: "MuiPagination",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.variant]];
  }
})({}), PaginationUl = styled("ul", {
  name: "MuiPagination",
  slot: "Ul",
  overridesResolver: (Kt, uo) => uo.ul
})({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  padding: 0,
  margin: 0,
  listStyle: "none"
});
function defaultGetAriaLabel(Kt, uo, ho) {
  return Kt === "page" ? `${ho ? "" : "Go to "}page ${uo}` : `Go to ${Kt} page`;
}
const Pagination$2 = /* @__PURE__ */ React$1.forwardRef(function(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiPagination"
  }), {
    boundaryCount: bo = 1,
    className: vo,
    color: Po = "standard",
    count: Co = 1,
    defaultPage: So = 1,
    disabled: wo = !1,
    getItemAriaLabel: Eo = defaultGetAriaLabel,
    hideNextButton: Ro = !1,
    hidePrevButton: _o = !1,
    onChange: Io,
    page: Ao,
    renderItem: Oo = (Zo) => /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationItem, {
      ...Zo
    }),
    shape: jo = "circular",
    showFirstButton: Do = !1,
    showLastButton: Lo = !1,
    siblingCount: ko = 1,
    size: Ko = "medium",
    variant: No = "text",
    ...Jo
  } = go, {
    items: ti
  } = usePagination$1({
    ...go,
    componentName: "Pagination"
  }), oi = {
    ...go,
    boundaryCount: bo,
    color: Po,
    count: Co,
    defaultPage: So,
    disabled: wo,
    getItemAriaLabel: Eo,
    hideNextButton: Ro,
    hidePrevButton: _o,
    renderItem: Oo,
    shape: jo,
    showFirstButton: Do,
    showLastButton: Lo,
    siblingCount: ko,
    size: Ko,
    variant: No
  }, Qo = useUtilityClasses$6(oi);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationRoot, {
    "aria-label": "pagination navigation",
    className: clsx(Qo.root, vo),
    ownerState: oi,
    ref: ho,
    ...Jo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(PaginationUl, {
      className: Qo.ul,
      ownerState: oi,
      children: ti.map((Zo, ei) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", {
        children: Oo({
          ...Zo,
          color: Po,
          "aria-label": Eo(Zo.type, Zo.page, Zo.selected),
          shape: jo,
          size: Ko,
          variant: No
        })
      }, ei))
    })
  });
});
process.env.NODE_ENV !== "production" && (Pagination$2.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: integerPropType,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The active color.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'standard'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["primary", "secondary", "standard"]), PropTypes.string]),
  /**
   * The total number of pages.
   * @default 1
   */
  count: integerPropType,
  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: integerPropType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   * This is important for screen reader users.
   *
   * For localization purposes, you can use the provided [translations](https://mui.com/material-ui/guides/localization/).
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous' | 'start-ellipsis' | 'end-ellipsis'). Defaults to 'page'.
   * @param {number | null} page The page number to format.
   * @param {boolean} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: PropTypes.func,
  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: PropTypes.bool,
  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: PropTypes.bool,
  /**
   * Callback fired when the page is changed.
   *
   * @param {React.ChangeEvent<unknown>} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: PropTypes.func,
  /**
   * The current page. Unlike `TablePagination`, which starts numbering from `0`, this pagination starts from `1`.
   */
  page: integerPropType,
  /**
   * Render the item.
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   * @default (item) => <PaginationItem {...item} />
   */
  renderItem: PropTypes.func,
  /**
   * The shape of the pagination items.
   * @default 'circular'
   */
  shape: PropTypes.oneOf(["circular", "rounded"]),
  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: PropTypes.bool,
  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: PropTypes.bool,
  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: integerPropType,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["small", "medium", "large"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(["outlined", "text"]), PropTypes.string])
});
function Pagination$1({
  page: Kt,
  onPageChange: uo,
  className: ho,
  ...go
}) {
  const bo = useGridApiContext(), vo = useGridSelector(bo, gridPageCountSelector), {
    // eslint-disable-next-line no-unused-vars, react/prop-types
    nextIconButtonProps: Po,
    backIconButtonProps: Co,
    slotProps: So,
    slots: wo,
    rowsPerPage: Eo,
    count: Ro,
    ..._o
  } = go;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Pagination$2,
    {
      color: "primary",
      className: ho,
      count: vo,
      page: Kt + 1,
      onChange: (Io, Ao) => {
        uo(Io, Ao - 1);
      },
      ..._o
    }
  );
}
function CustomPagination() {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GridPagination, { ActionsComponent: Pagination$1 });
}
const Table = (Kt) => {
  const {
    checkboxSelection: uo = !1,
    columns: ho,
    rows: go,
    fieldToSort: bo = null,
    hideInColumnMenu: vo = [],
    initialPageSize: Po = 10,
    pageSizeOptions: Co = [
      10,
      15,
      20
    ],
    getRowId: So,
    slots: wo,
    ...Eo
  } = Kt, Ro = ho.map((Ko) => ({
    ...Ko,
    // Defaults left alignment unless user provides different values in column
    align: Ko.align || "left",
    headerAlign: Ko.headerAlign || "left",
    // Allows use of any component to be rendered
    renderCell: (No) => Ko.renderCell ? Ko.renderCell(No) : void 0
  })), _o = {
    color: "var(--vp-action-blue)"
  }, Io = () => /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-label": "Sort Ascending", style: _o, className: "fa-solid fa-caret-up" }), Ao = () => /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-label": "Sort Descending", style: _o, className: "fa-solid fa-caret-down" }), Oo = () => /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-label": "Column Options", style: _o, title: "Show Column Options", className: "fa-solid fa-ellipsis" }), jo = () => /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", style: _o, className: "fa-solid fa-eye-slash" }), Do = () => /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", style: _o, className: "fa-solid fa-gear" }), Lo = (Ko) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    GridColumnMenu,
    {
      ...Ko,
      slots: {
        // Hide `filter`
        columnMenuFilterItem: null
      },
      style: {
        color: "var(--vp-action-blue)"
      },
      className: "column-menu"
    }
  ), ko = (Ko) => Ko.filter((No) => !vo.includes(No.field)).map((No) => No.field);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-table", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    DataGrid,
    {
      autoHeight: !0,
      columns: Ro,
      rows: go,
      getRowId: So,
      checkboxSelection: uo,
      disableRowSelectionOnClick: !0,
      disableColumnResize: !0,
      pageSizeOptions: Co,
      pagination: !0,
      rowHeight: 38,
      columnHeaderHeight: 38,
      localeText: {
        columnMenuSortAsc: "Sort Ascending",
        columnMenuSortDesc: "Sort Descending",
        noResultsOverlayLabel: "No matching records found",
        noRowsLabel: "No matching records found"
      },
      sortingOrder: ["asc", "desc"],
      slots: {
        pagination: CustomPagination,
        columnSortedAscendingIcon: Io,
        columnSortedDescendingIcon: Ao,
        columnMenuIcon: Oo,
        columnMenu: Lo,
        columnMenuSortAscendingIcon: Io,
        columnMenuSortDescendingIcon: Ao,
        columnMenuHideIcon: jo,
        columnMenuManageColumnsIcon: Do,
        ...wo
      },
      slotProps: {
        columnsManagement: {
          getTogglableColumns: ko
        }
      },
      initialState: {
        pagination: {
          paginationModel: {
            pageSize: Po
          }
        },
        sorting: {
          sortModel: [{ field: bo, sort: "asc" }]
        }
      },
      ...Eo
    }
  ) });
};
Table.propTypes = {
  /**
   * Whether table has checkboxes to select the rows
   */
  checkboxSelection: PropTypes.bool,
  /**
   * Columns configuration for the table
   */
  columns: PropTypes.arrayOf(PropTypes.shape({
    /**
     * Alignment of the columns
     */
    align: PropTypes.oneOf([
      "left",
      "center",
      "right"
    ]),
    /**
     * Description of each column
     */
    description: PropTypes.string,
    /**
     * Sets if user can edit column from the rendered state
     */
    editable: PropTypes.oneOfType([
      /**
       * Boolean or function that returns a boolean to set if column is editable
      */
      PropTypes.bool,
      PropTypes.func
    ]),
    /**
     * Field name (required)
     */
    field: PropTypes.string.isRequired,
    /**
     * Sets if user can filter columns
     */
    filterable: PropTypes.bool,
    /**
     * Sets if column is visible
     */
    hide: PropTypes.bool,
    /**
     * Name displayed at the top of the column
     */
    headerName: PropTypes.string,
    /**
     * Alignment of the headers
     */
    headerAlign: PropTypes.oneOf([
      "left",
      "center",
      "right"
    ]),
    /**
     * Set maximum width
     */
    maxWidth: PropTypes.number,
    /**
     * Set minimum width
     */
    minWidth: PropTypes.number,
    /**
     * Function that renders custom cell content
     */
    renderCell: PropTypes.func,
    /**
     * Function that renders custom header
     */
    renderHeader: PropTypes.func,
    /**
     * Sets if user is able to sort by column
     */
    sortable: PropTypes.bool,
    /**
     * Function for custom sorting
     */
    sortComparator: PropTypes.func,
    /**
     * Type of data for records - Defaulted as string
     */
    type: PropTypes.oneOf([
      "string",
      "number",
      "date",
      "boolean",
      "actions",
      "singleSelect",
      "multiSelect",
      "node"
    ]),
    /**
     * Function to transform data for custom display
     */
    valueFormatter: PropTypes.func,
    /**
     * Function to retrieve and display value in a column
     */
    valueGetter: PropTypes.func,
    /**
     * Set custom width
     */
    width: PropTypes.number
  })),
  /**
   * The field that the table should sort on by default
   */
  fieldToSort: PropTypes.string,
  /**
   * Function to set row id if ID field is not present
   */
  getRowId: PropTypes.func,
  /**
   * Array of column names that that should always be visible
   * (user does not have ability to toggle visibility)
   */
  hideInColumnMenu: PropTypes.arrayOf(PropTypes.string),
  /**
   * How many rows render per page on initial render
   */
  initialPageSize: PropTypes.number,
  /**
   * Array of options for how many rows render per page. Only accepts integers
   * and no 'All' option. One of the options must match the intialPageSize
   * for the selection list to appear.
   */
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  /**
   * Records to populate the table
   */
  rows: PropTypes.arrayOf(PropTypes.object),
  /**
   * The slot options from MUI that we are implementing.
   * There are more available for use in the MUI documentation https://mui.com/x/react-data-grid/components/
   */
  slots: PropTypes.shape({
    pagination: PropTypes.elementType,
    columnSortedAscendingIcon: PropTypes.elementType,
    columnSortedDescendingIcon: PropTypes.elementType,
    columnMenuIcon: PropTypes.elementType,
    columnMenu: PropTypes.elementType,
    columnMenuSortAscendingIcon: PropTypes.elementType,
    columnMenuSortDescendingIcon: PropTypes.elementType,
    columnMenuHideIcon: PropTypes.elementType,
    columnMenuManageColumnsIcon: PropTypes.elementType,
    noResultsOverlay: PropTypes.elementType,
    noRowsOverlay: PropTypes.elementType
  })
};
Pagination$1.propTypes = {
  /**
   * The current page number (0-indexed)
   */
  page: PropTypes.number.isRequired,
  /**
   * Function to handle page changes
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * Additional class names for styling
   */
  className: PropTypes.string
  /**
   * There are more props available here: https://mui.com/material-ui/api/table-pagination/
   */
};
const TabList = (Kt) => {
  const {
    tabs: uo,
    pages: ho,
    canClose: go = !1,
    handleClose: bo,
    // props to pass to each underlying component if necessary
    tabsprops: vo,
    tabprops: Po,
    listprops: Co,
    panelprops: So
  } = Kt, wo = () => uo.map((Ro, _o) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "tab-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Tab,
      {
        value: _o,
        className: "tab",
        title: Ro,
        id: `tab-${_o}`,
        ...Po,
        onKeyDown: (Io) => {
          (Io.key === "Backspace" || Io.key === "Delete") && bo(_o);
        },
        children: Ro
      },
      `tab-head-${_o}`
    ),
    go && bo && // Note: according to wcag, tablists cannot contain interactive elements other than role=tab
    // but there is currently no workaround that does not violate some other wcag requirement.
    // https://github.com/w3c/aria/issues/1440
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        "data-value": _o,
        className: "tab-close",
        tabIndex: -1,
        onClick: () => bo(_o),
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "i",
          {
            title: "Close Tab",
            "aria-hidden": !0,
            className: "fa-solid fa-circle-xmark"
          }
        )
      }
    )
  ] }, `${Ro}-${_o}`)), Eo = () => ho.map((Ro, _o) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    TabPanel,
    {
      className: "tab-panel",
      value: _o,
      "aria-labelledby": `panel-${_o}`,
      ...So,
      children: Ro
    },
    `panel-${_o}`
  ));
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-tablist", { children: uo.length ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Tabs, { defaultValue: 0, "aria-label": "Tab List", ...vo, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(TabsList, { className: "tab-list", ...Co, children: wo() }),
    Eo()
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", {}) });
};
TabList.propTypes = {
  /**
   * Determines whether tabs can be closed with a button click
   * @default false
   */
  canClose: PropTypes.bool,
  /**
   *Callback for clicking on the close button
   */
  handleClose: PropTypes.func,
  /**
   *Array of html or jsx of each page\'s content
   */
  pages: PropTypes.array,
  /**
   * Array of tab names
   */
  tabs: PropTypes.array.isRequired,
  /**
   * Optional array for props
   */
  tabsprops: PropTypes.array,
  /**
   * Optional array for props
   */
  tabprops: PropTypes.array,
  /**
   * Optional array for props
   */
  listprops: PropTypes.array,
  /**
   * Optional array for props
   */
  panelprops: PropTypes.array
};
const Modal = (Kt) => {
  const {
    closeIcon: uo = !0,
    header: ho,
    headerIcon: go,
    trigger: bo,
    disableBackdropClick: vo = !1,
    slots: Po = {},
    headerPlacement: Co = "headerCenter",
    ...So
  } = Kt, [wo, Eo] = useState(!1), [Ro, _o] = useState(null), Io = useRef(null), Ao = () => Eo(!0), Oo = () => Eo(!1);
  useEffect(() => {
    const Do = document.querySelectorAll(".modalContent");
    _o(Do.length + 1);
  }, []);
  const jo = forwardRef$1(
    ({
      /**
       * The defined props are not valid for the version of MUI we are using but are still
       * coming through for some reason. They must be spread here to get rid of console errors.
       * We do not want to pass them along so users implementing the component use them which
       * is why they are pulled out here.
       */
      // eslint-disable-next-line no-unused-vars, react/prop-types
      open: Do,
      ownerState: Lo,
      ...ko
    }, Ko) => vo ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "disabled-backdrop" }) : /* @__PURE__ */ jsxRuntimeExports.jsx("div", { ref: Ko, ...ko })
  );
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-modal", { children: [
    typeof bo == "function" ? bo({ handleOpen: Ao }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Modal$2,
      {
        open: wo,
        onClose: Oo,
        closeAfterTransition: !0,
        slots: {
          backdrop: jo
        },
        ...So,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
          "div",
          {
            className: `modalContent ${Ro ? `instance-${Ro}` : ""}`,
            ref: Io,
            children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { className: Co, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { children: [
                  go && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: `$'modalIcon' ${go}` }),
                  ho
                ] }),
                uo && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  "button",
                  {
                    onClick: Oo,
                    "aria-label": "Close Modal",
                    "data-testid": "modal-closer",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "fa-solid fa-circle-xmark", "aria-hidden": "true" })
                  }
                )
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("main", { children: typeof (Po == null ? void 0 : Po.content) == "function" ? Po.content(Oo) : null })
            ]
          }
        )
      }
    )
  ] });
};
Modal.propTypes = {
  /**
   * Whether the X icon renders at the top right corner
   */
  closeIcon: PropTypes.bool,
  /**
   * Disable modal close when backdrop is clicked
   */
  disableBackdropClick: PropTypes.bool,
  /**
   * Title rendered at the top of the modal
   */
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
  * Position of the header.
  */
  headerPlacement: PropTypes.oneOf([
    "headerCenter",
    "headerLeft",
    "headerRight"
  ]),
  /**
  * Icon to be shown to the left of the title text
  */
  headerIcon: PropTypes.string,
  /**
   * Custom attributes used to modify specific elements/components
   * - content: function for external component use (ex. closing modal)
   */
  slots: PropTypes.shape({ content: PropTypes.func }),
  /**
   * Component used to activate the modal
   */
  trigger: PropTypes.func.isRequired
};
/**!
 * is
 * the definitive JavaScript type testing library
 *
 * @copyright 2013-2014 Enrico Marino / Jordan Harband
 * @license MIT
 */
var objProto = Object.prototype, owns = objProto.hasOwnProperty, toStr = objProto.toString, symbolValueOf$1;
typeof Symbol == "function" && (symbolValueOf$1 = Symbol.prototype.valueOf);
var bigIntValueOf;
typeof BigInt == "function" && (bigIntValueOf = BigInt.prototype.valueOf);
var isActualNaN = function(Kt) {
  return Kt !== Kt;
}, NON_HOST_TYPES = {
  boolean: 1,
  number: 1,
  string: 1,
  undefined: 1
}, base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$/, hexRegex = /^[A-Fa-f0-9]+$/, is$1 = {};
is$1.a = is$1.type = function(Kt, uo) {
  return typeof Kt === uo;
};
is$1.defined = function(Kt) {
  return typeof Kt < "u";
};
is$1.empty = function(Kt) {
  var uo = toStr.call(Kt), ho;
  if (uo === "[object Array]" || uo === "[object Arguments]" || uo === "[object String]")
    return Kt.length === 0;
  if (uo === "[object Object]") {
    for (ho in Kt)
      if (owns.call(Kt, ho))
        return !1;
    return !0;
  }
  return !Kt;
};
is$1.equal = function(uo, ho) {
  if (uo === ho)
    return !0;
  var go = toStr.call(uo), bo;
  if (go !== toStr.call(ho))
    return !1;
  if (go === "[object Object]") {
    for (bo in uo)
      if (!is$1.equal(uo[bo], ho[bo]) || !(bo in ho))
        return !1;
    for (bo in ho)
      if (!is$1.equal(uo[bo], ho[bo]) || !(bo in uo))
        return !1;
    return !0;
  }
  if (go === "[object Array]") {
    if (bo = uo.length, bo !== ho.length)
      return !1;
    for (; bo--; )
      if (!is$1.equal(uo[bo], ho[bo]))
        return !1;
    return !0;
  }
  return go === "[object Function]" ? uo.prototype === ho.prototype : go === "[object Date]" ? uo.getTime() === ho.getTime() : !1;
};
is$1.hosted = function(Kt, uo) {
  var ho = typeof uo[Kt];
  return ho === "object" ? !!uo[Kt] : !NON_HOST_TYPES[ho];
};
is$1.instance = is$1.instanceof = function(Kt, uo) {
  return Kt instanceof uo;
};
is$1.nil = is$1.null = function(Kt) {
  return Kt === null;
};
is$1.undef = is$1.undefined = function(Kt) {
  return typeof Kt > "u";
};
is$1.args = is$1.arguments = function(Kt) {
  var uo = toStr.call(Kt) === "[object Arguments]", ho = !is$1.array(Kt) && is$1.arraylike(Kt) && is$1.object(Kt) && is$1.fn(Kt.callee);
  return uo || ho;
};
is$1.array = Array.isArray || function(Kt) {
  return toStr.call(Kt) === "[object Array]";
};
is$1.args.empty = function(Kt) {
  return is$1.args(Kt) && Kt.length === 0;
};
is$1.array.empty = function(Kt) {
  return is$1.array(Kt) && Kt.length === 0;
};
is$1.arraylike = function(Kt) {
  return !!Kt && !is$1.bool(Kt) && owns.call(Kt, "length") && isFinite(Kt.length) && is$1.number(Kt.length) && Kt.length >= 0;
};
is$1.bool = is$1.boolean = function(Kt) {
  return toStr.call(Kt) === "[object Boolean]";
};
is$1.false = function(Kt) {
  return is$1.bool(Kt) && !Number(Kt);
};
is$1.true = function(Kt) {
  return is$1.bool(Kt) && !!Number(Kt);
};
is$1.date = function(Kt) {
  return toStr.call(Kt) === "[object Date]";
};
is$1.date.valid = function(Kt) {
  return is$1.date(Kt) && !isNaN(Number(Kt));
};
is$1.element = function(Kt) {
  return Kt !== void 0 && typeof HTMLElement < "u" && Kt instanceof HTMLElement && Kt.nodeType === 1;
};
is$1.error = function(Kt) {
  return toStr.call(Kt) === "[object Error]";
};
is$1.fn = is$1.function = function(Kt) {
  var uo = typeof window < "u" && Kt === window.alert;
  if (uo)
    return !0;
  var ho = toStr.call(Kt);
  return ho === "[object Function]" || ho === "[object GeneratorFunction]" || ho === "[object AsyncFunction]";
};
is$1.number = function(Kt) {
  return toStr.call(Kt) === "[object Number]";
};
is$1.infinite = function(Kt) {
  return Kt === 1 / 0 || Kt === -1 / 0;
};
is$1.decimal = function(Kt) {
  return is$1.number(Kt) && !isActualNaN(Kt) && !is$1.infinite(Kt) && Kt % 1 !== 0;
};
is$1.divisibleBy = function(Kt, uo) {
  var ho = is$1.infinite(Kt), go = is$1.infinite(uo), bo = is$1.number(Kt) && !isActualNaN(Kt) && is$1.number(uo) && !isActualNaN(uo) && uo !== 0;
  return ho || go || bo && Kt % uo === 0;
};
is$1.integer = is$1.int = function(Kt) {
  return is$1.number(Kt) && !isActualNaN(Kt) && Kt % 1 === 0;
};
is$1.maximum = function(Kt, uo) {
  if (isActualNaN(Kt))
    throw new TypeError("NaN is not a valid value");
  if (!is$1.arraylike(uo))
    throw new TypeError("second argument must be array-like");
  for (var ho = uo.length; --ho >= 0; )
    if (Kt < uo[ho])
      return !1;
  return !0;
};
is$1.minimum = function(Kt, uo) {
  if (isActualNaN(Kt))
    throw new TypeError("NaN is not a valid value");
  if (!is$1.arraylike(uo))
    throw new TypeError("second argument must be array-like");
  for (var ho = uo.length; --ho >= 0; )
    if (Kt > uo[ho])
      return !1;
  return !0;
};
is$1.nan = function(Kt) {
  return !is$1.number(Kt) || Kt !== Kt;
};
is$1.even = function(Kt) {
  return is$1.infinite(Kt) || is$1.number(Kt) && Kt === Kt && Kt % 2 === 0;
};
is$1.odd = function(Kt) {
  return is$1.infinite(Kt) || is$1.number(Kt) && Kt === Kt && Kt % 2 !== 0;
};
is$1.ge = function(Kt, uo) {
  if (isActualNaN(Kt) || isActualNaN(uo))
    throw new TypeError("NaN is not a valid value");
  return !is$1.infinite(Kt) && !is$1.infinite(uo) && Kt >= uo;
};
is$1.gt = function(Kt, uo) {
  if (isActualNaN(Kt) || isActualNaN(uo))
    throw new TypeError("NaN is not a valid value");
  return !is$1.infinite(Kt) && !is$1.infinite(uo) && Kt > uo;
};
is$1.le = function(Kt, uo) {
  if (isActualNaN(Kt) || isActualNaN(uo))
    throw new TypeError("NaN is not a valid value");
  return !is$1.infinite(Kt) && !is$1.infinite(uo) && Kt <= uo;
};
is$1.lt = function(Kt, uo) {
  if (isActualNaN(Kt) || isActualNaN(uo))
    throw new TypeError("NaN is not a valid value");
  return !is$1.infinite(Kt) && !is$1.infinite(uo) && Kt < uo;
};
is$1.within = function(Kt, uo, ho) {
  if (isActualNaN(Kt) || isActualNaN(uo) || isActualNaN(ho))
    throw new TypeError("NaN is not a valid value");
  if (!is$1.number(Kt) || !is$1.number(uo) || !is$1.number(ho))
    throw new TypeError("all arguments must be numbers");
  var go = is$1.infinite(Kt) || is$1.infinite(uo) || is$1.infinite(ho);
  return go || Kt >= uo && Kt <= ho;
};
is$1.object = function(Kt) {
  return toStr.call(Kt) === "[object Object]";
};
is$1.primitive = function(uo) {
  return uo ? !(typeof uo == "object" || is$1.object(uo) || is$1.fn(uo) || is$1.array(uo)) : !0;
};
is$1.hash = function(Kt) {
  return is$1.object(Kt) && Kt.constructor === Object && !Kt.nodeType && !Kt.setInterval;
};
is$1.regexp = function(Kt) {
  return toStr.call(Kt) === "[object RegExp]";
};
is$1.string = function(Kt) {
  return toStr.call(Kt) === "[object String]";
};
is$1.base64 = function(Kt) {
  return is$1.string(Kt) && (!Kt.length || base64Regex.test(Kt));
};
is$1.hex = function(Kt) {
  return is$1.string(Kt) && (!Kt.length || hexRegex.test(Kt));
};
is$1.symbol = function(Kt) {
  return typeof Symbol == "function" && toStr.call(Kt) === "[object Symbol]" && typeof symbolValueOf$1.call(Kt) == "symbol";
};
is$1.bigint = function(Kt) {
  return typeof BigInt == "function" && toStr.call(Kt) === "[object BigInt]" && typeof bigIntValueOf.call(Kt) == "bigint";
};
var is_1 = is$1;
const Select = (Kt) => {
  const {
    errorMessage: uo,
    id: ho = "selectId1",
    label: go,
    lineSeparator: bo,
    options: vo,
    onSelectChange: Po,
    required: Co,
    ...So
  } = Kt, [wo, Eo] = useState(null), [Ro, _o] = useState(!1), [Io, Ao] = useState(So.value ?? null), Oo = "This field is required.", jo = useRef(null);
  return useEffect(() => {
    if (jo.current) {
      const Do = document.querySelector(`#listbox-${ho}`);
      Do && (Do.style.width = `${jo.current.offsetWidth}px`);
    }
  }, [jo, wo]), useEffect(() => {
    Co && !is_1.null(wo) && !wo && is_1.null(Io) ? _o(!0) : _o(!1);
  }, [wo, Io]), /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-select", { children: [
    go && /* @__PURE__ */ jsxRuntimeExports.jsx(
      "label",
      {
        className: [Ro || uo ? "error-container" : ""].join(" ").replace(/\s+/g, " ").trim(),
        title: go,
        htmlFor: ho,
        "aria-labelledby": ho,
        children: go
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(
      "div",
      {
        className: [Ro || uo ? "error-container" : "", "select-container"].join(" ").replace(/\s+/g, " ").trim(),
        "data-testid": "container",
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Select$2,
            {
              "aria-label": "selectDropdown",
              id: ho,
              listboxOpen: wo,
              onChange: (Do, Lo) => {
                Ao(Lo), Po(Lo);
              },
              value: So.value || Io,
              onListboxOpenChange: Eo,
              placeholder: So.placeholder,
              ref: jo,
              required: Co,
              slotProps: {
                listbox: {
                  className: "listbox"
                },
                ...So.slotProps
              },
              listboxId: `listbox-${ho}`,
              ...So,
              children: vo && vo.map((Do, Lo) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
                bo && Lo > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("hr", {}),
                /* @__PURE__ */ jsxRuntimeExports.jsx(Option, { value: Do, children: Do }, Lo)
              ] }, Lo))
            }
          ),
          uo && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "error-message", children: uo }),
          Ro && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "error-message", children: Oo })
        ]
      }
    )
  ] });
};
Select.propTypes = {
  /**
   * The unique identifier for the select button
   */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The label in front of the select dropdown
   */
  label: PropTypes.string,
  /**
   * If a line should show between the options in the dropdown
   */
  lineSeparator: PropTypes.bool,
  /**
   * Function to call when the selected option is changed
   * @param {Object} event - The event object triggered by the change
  */
  onSelectChange: PropTypes.func,
  /**
   * The text shown in the select if you do not want to show a default selected value
   */
  placeholder: PropTypes.node,
  /**
   * Whether the select input is required or not
   */
  required: PropTypes.bool
};
function c$3(Kt, uo, ho) {
  var go = this, bo = useRef(null), vo = useRef(0), Po = useRef(null), Co = useRef([]), So = useRef(), wo = useRef(), Eo = useRef(Kt), Ro = useRef(!0);
  Eo.current = Kt;
  var _o = typeof window < "u", Io = !uo && uo !== 0 && _o;
  if (typeof Kt != "function") throw new TypeError("Expected a function");
  uo = +uo || 0;
  var Ao = !!(ho = ho || {}).leading, Oo = !("trailing" in ho) || !!ho.trailing, jo = "maxWait" in ho, Do = "debounceOnServer" in ho && !!ho.debounceOnServer, Lo = jo ? Math.max(+ho.maxWait || 0, uo) : null;
  useEffect(function() {
    return Ro.current = !0, function() {
      Ro.current = !1;
    };
  }, []);
  var ko = useMemo(function() {
    var Ko = function(Zo) {
      var ei = Co.current, ii = So.current;
      return Co.current = So.current = null, vo.current = Zo, wo.current = Eo.current.apply(ii, ei);
    }, No = function(Zo, ei) {
      Io && cancelAnimationFrame(Po.current), Po.current = Io ? requestAnimationFrame(Zo) : setTimeout(Zo, ei);
    }, Jo = function(Zo) {
      if (!Ro.current) return !1;
      var ei = Zo - bo.current;
      return !bo.current || ei >= uo || ei < 0 || jo && Zo - vo.current >= Lo;
    }, ti = function(Zo) {
      return Po.current = null, Oo && Co.current ? Ko(Zo) : (Co.current = So.current = null, wo.current);
    }, oi = function Zo() {
      var ei = Date.now();
      if (Jo(ei)) return ti(ei);
      if (Ro.current) {
        var ii = uo - (ei - bo.current), ai = jo ? Math.min(ii, Lo - (ei - vo.current)) : ii;
        No(Zo, ai);
      }
    }, Qo = function() {
      if (_o || Do) {
        var Zo = Date.now(), ei = Jo(Zo);
        if (Co.current = [].slice.call(arguments), So.current = go, bo.current = Zo, ei) {
          if (!Po.current && Ro.current) return vo.current = bo.current, No(oi, uo), Ao ? Ko(bo.current) : wo.current;
          if (jo) return No(oi, uo), Ko(bo.current);
        }
        return Po.current || No(oi, uo), wo.current;
      }
    };
    return Qo.cancel = function() {
      Po.current && (Io ? cancelAnimationFrame(Po.current) : clearTimeout(Po.current)), vo.current = 0, Co.current = bo.current = So.current = Po.current = null;
    }, Qo.isPending = function() {
      return !!Po.current;
    }, Qo.flush = function() {
      return Po.current ? ti(Date.now()) : wo.current;
    }, Qo;
  }, [Ao, jo, uo, Lo, Oo, Io, _o, Do]);
  return ko;
}
const prettyLogStyles = {
  reset: [0, 0],
  bold: [1, 22],
  dim: [2, 22],
  italic: [3, 23],
  underline: [4, 24],
  overline: [53, 55],
  inverse: [7, 27],
  hidden: [8, 28],
  strikethrough: [9, 29],
  black: [30, 39],
  red: [31, 39],
  green: [32, 39],
  yellow: [33, 39],
  blue: [34, 39],
  magenta: [35, 39],
  cyan: [36, 39],
  white: [37, 39],
  blackBright: [90, 39],
  redBright: [91, 39],
  greenBright: [92, 39],
  yellowBright: [93, 39],
  blueBright: [94, 39],
  magentaBright: [95, 39],
  cyanBright: [96, 39],
  whiteBright: [97, 39],
  bgBlack: [40, 49],
  bgRed: [41, 49],
  bgGreen: [42, 49],
  bgYellow: [43, 49],
  bgBlue: [44, 49],
  bgMagenta: [45, 49],
  bgCyan: [46, 49],
  bgWhite: [47, 49],
  bgBlackBright: [100, 49],
  bgRedBright: [101, 49],
  bgGreenBright: [102, 49],
  bgYellowBright: [103, 49],
  bgBlueBright: [104, 49],
  bgMagentaBright: [105, 49],
  bgCyanBright: [106, 49],
  bgWhiteBright: [107, 49]
};
function formatTemplate(Kt, uo, ho, go = !1) {
  const bo = String(uo), vo = (So, wo) => `\x1B[${wo[0]}m${So}\x1B[${wo[1]}m`, Po = (So, wo) => wo != null && typeof wo == "string" ? vo(So, prettyLogStyles[wo]) : wo != null && Array.isArray(wo) ? wo.reduce((Eo, Ro) => Po(Eo, Ro), So) : wo != null && wo[So.trim()] != null ? Po(So, wo[So.trim()]) : wo != null && wo["*"] != null ? Po(So, wo["*"]) : So, Co = null;
  return bo.replace(/{{(.+?)}}/g, (So, wo) => {
    var Ro;
    const Eo = ho[wo] != null ? String(ho[wo]) : go ? "" : So;
    return Kt.stylePrettyLogs ? Po(Eo, ((Ro = Kt == null ? void 0 : Kt.prettyLogStyles) == null ? void 0 : Ro[wo]) ?? Co) + vo("", prettyLogStyles.reset) : Eo;
  });
}
function formatNumberAddZeros(Kt, uo = 2, ho = 0) {
  return Kt != null && isNaN(Kt) ? "" : (Kt = Kt != null ? Kt + ho : Kt, uo === 2 ? Kt == null ? "--" : Kt < 10 ? "0" + Kt : Kt.toString() : Kt == null ? "---" : Kt < 10 ? "00" + Kt : Kt < 100 ? "0" + Kt : Kt.toString());
}
function urlToObject(Kt) {
  return {
    href: Kt.href,
    protocol: Kt.protocol,
    username: Kt.username,
    password: Kt.password,
    host: Kt.host,
    hostname: Kt.hostname,
    port: Kt.port,
    pathname: Kt.pathname,
    search: Kt.search,
    searchParams: [...Kt.searchParams].map(([uo, ho]) => ({ key: uo, value: ho })),
    hash: Kt.hash,
    origin: Kt.origin
  };
}
function jsonStringifyRecursive(Kt) {
  const uo = /* @__PURE__ */ new Set();
  return JSON.stringify(Kt, (ho, go) => {
    if (typeof go == "object" && go !== null) {
      if (uo.has(go))
        return "[Circular]";
      uo.add(go);
    }
    return typeof go == "bigint" ? `${go}` : go;
  });
}
function inspect(Kt, uo) {
  const ho = {
    seen: [],
    stylize: stylizeNoColor
  };
  return uo != null && _extend(ho, uo), isUndefined(ho.showHidden) && (ho.showHidden = !1), isUndefined(ho.depth) && (ho.depth = 2), isUndefined(ho.colors) && (ho.colors = !0), isUndefined(ho.customInspect) && (ho.customInspect = !0), ho.colors && (ho.stylize = stylizeWithColor), formatValue(ho, Kt, ho.depth);
}
inspect.colors = prettyLogStyles;
inspect.styles = {
  special: "cyan",
  number: "yellow",
  boolean: "yellow",
  undefined: "grey",
  null: "bold",
  string: "green",
  date: "magenta",
  regexp: "red"
};
function isBoolean$2(Kt) {
  return typeof Kt == "boolean";
}
function isUndefined(Kt) {
  return Kt === void 0;
}
function stylizeNoColor(Kt) {
  return Kt;
}
function stylizeWithColor(Kt, uo) {
  var go, bo, vo, Po;
  const ho = inspect.styles[uo];
  return ho != null && ((bo = (go = inspect == null ? void 0 : inspect.colors) == null ? void 0 : go[ho]) == null ? void 0 : bo[0]) != null && ((Po = (vo = inspect == null ? void 0 : inspect.colors) == null ? void 0 : vo[ho]) == null ? void 0 : Po[1]) != null ? "\x1B[" + inspect.colors[ho][0] + "m" + Kt + "\x1B[" + inspect.colors[ho][1] + "m" : Kt;
}
function isFunction$4(Kt) {
  return typeof Kt == "function";
}
function isString$2(Kt) {
  return typeof Kt == "string";
}
function isNumber$4(Kt) {
  return typeof Kt == "number";
}
function isNull(Kt) {
  return Kt === null;
}
function hasOwn$1(Kt, uo) {
  return Object.prototype.hasOwnProperty.call(Kt, uo);
}
function isRegExp(Kt) {
  return isObject$9(Kt) && objectToString$2(Kt) === "[object RegExp]";
}
function isObject$9(Kt) {
  return typeof Kt == "object" && Kt !== null;
}
function isError$1(Kt) {
  return isObject$9(Kt) && (objectToString$2(Kt) === "[object Error]" || Kt instanceof Error);
}
function isDate(Kt) {
  return isObject$9(Kt) && objectToString$2(Kt) === "[object Date]";
}
function objectToString$2(Kt) {
  return Object.prototype.toString.call(Kt);
}
function arrayToHash(Kt) {
  const uo = {};
  return Kt.forEach((ho) => {
    uo[ho] = !0;
  }), uo;
}
function formatArray(Kt, uo, ho, go, bo) {
  const vo = [];
  for (let Po = 0, Co = uo.length; Po < Co; ++Po)
    hasOwn$1(uo, String(Po)) ? vo.push(formatProperty(Kt, uo, ho, go, String(Po), !0)) : vo.push("");
  return bo.forEach((Po) => {
    Po.match(/^\d+$/) || vo.push(formatProperty(Kt, uo, ho, go, Po, !0));
  }), vo;
}
function formatError(Kt) {
  return "[" + Error.prototype.toString.call(Kt) + "]";
}
function formatValue(Kt, uo, ho = 0) {
  if (Kt.customInspect && uo != null && isFunction$4(uo) && (uo == null ? void 0 : uo.inspect) !== inspect && !(uo != null && uo.constructor && (uo == null ? void 0 : uo.constructor.prototype) === uo)) {
    if (typeof uo.inspect != "function" && uo.toString != null)
      return uo.toString();
    let Eo = uo == null ? void 0 : uo.inspect(ho, Kt);
    return isString$2(Eo) || (Eo = formatValue(Kt, Eo, ho)), Eo;
  }
  const go = formatPrimitive(Kt, uo);
  if (go)
    return go;
  let bo = Object.keys(uo);
  const vo = arrayToHash(bo);
  try {
    Kt.showHidden && Object.getOwnPropertyNames && (bo = Object.getOwnPropertyNames(uo));
  } catch {
  }
  if (isError$1(uo) && (bo.indexOf("message") >= 0 || bo.indexOf("description") >= 0))
    return formatError(uo);
  if (bo.length === 0)
    if (isFunction$4(Kt.stylize)) {
      if (isFunction$4(uo)) {
        const Eo = uo.name ? ": " + uo.name : "";
        return Kt.stylize("[Function" + Eo + "]", "special");
      }
      if (isRegExp(uo))
        return Kt.stylize(RegExp.prototype.toString.call(uo), "regexp");
      if (isDate(uo))
        return Kt.stylize(Date.prototype.toISOString.call(uo), "date");
      if (isError$1(uo))
        return formatError(uo);
    } else
      return uo;
  let Po = "", Co = !1, So = [`{
`, `
}`];
  if (Array.isArray(uo) && (Co = !0, So = [`[
`, `
]`]), isFunction$4(uo) && (Po = " [Function" + (uo.name ? ": " + uo.name : "") + "]"), isRegExp(uo) && (Po = " " + RegExp.prototype.toString.call(uo)), isDate(uo) && (Po = " " + Date.prototype.toUTCString.call(uo)), isError$1(uo) && (Po = " " + formatError(uo)), bo.length === 0 && (!Co || uo.length == 0))
    return So[0] + Po + So[1];
  if (ho < 0)
    return isRegExp(uo) ? Kt.stylize(RegExp.prototype.toString.call(uo), "regexp") : Kt.stylize("[Object]", "special");
  Kt.seen.push(uo);
  let wo;
  return Co ? wo = formatArray(Kt, uo, ho, vo, bo) : wo = bo.map((Eo) => formatProperty(Kt, uo, ho, vo, Eo, Co)), Kt.seen.pop(), reduceToSingleString(wo, Po, So);
}
function formatProperty(Kt, uo, ho, go, bo, vo) {
  let Po, Co, So = { value: void 0 };
  try {
    So.value = uo[bo];
  } catch {
  }
  try {
    Object.getOwnPropertyDescriptor && (So = Object.getOwnPropertyDescriptor(uo, bo) || So);
  } catch {
  }
  if (So.get ? So.set ? Co = Kt.stylize("[Getter/Setter]", "special") : Co = Kt.stylize("[Getter]", "special") : So.set && (Co = Kt.stylize("[Setter]", "special")), hasOwn$1(go, bo) || (Po = "[" + bo + "]"), Co || (Kt.seen.indexOf(So.value) < 0 ? (isNull(ho) ? Co = formatValue(Kt, So.value, void 0) : Co = formatValue(Kt, So.value, ho - 1), Co.indexOf(`
`) > -1 && (vo ? Co = Co.split(`
`).map((wo) => "  " + wo).join(`
`).substr(2) : Co = `
` + Co.split(`
`).map((wo) => "   " + wo).join(`
`))) : Co = Kt.stylize("[Circular]", "special")), isUndefined(Po)) {
    if (vo && bo.match(/^\d+$/))
      return Co;
    Po = JSON.stringify("" + bo), Po.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (Po = Po.substr(1, Po.length - 2), Po = Kt.stylize(Po, "name")) : (Po = Po.replace(/'/g, "\\'").replace(/\\"/g, "\\'").replace(/(^"|"$)/g, "'"), Po = Kt.stylize(Po, "string"));
  }
  return Po + ": " + Co;
}
function formatPrimitive(Kt, uo) {
  if (isUndefined(uo))
    return Kt.stylize("undefined", "undefined");
  if (isString$2(uo)) {
    const ho = "'" + JSON.stringify(uo).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, "\\'") + "'";
    return Kt.stylize(ho, "string");
  }
  if (isNumber$4(uo))
    return Kt.stylize("" + uo, "number");
  if (isBoolean$2(uo))
    return Kt.stylize("" + uo, "boolean");
  if (isNull(uo))
    return Kt.stylize("null", "null");
}
function reduceToSingleString(Kt, uo, ho) {
  return ho[0] + (uo === "" ? "" : uo + `
`) + "  " + Kt.join(`,
  `) + " " + ho[1];
}
function _extend(Kt, uo) {
  const ho = { ...Kt };
  if (!uo || !isObject$9(uo))
    return Kt;
  const go = { ...uo }, bo = Object.keys(uo);
  let vo = bo.length;
  for (; vo--; )
    ho[bo[vo]] = go[bo[vo]];
  return ho;
}
function formatWithOptions(Kt, ...uo) {
  const ho = {
    seen: [],
    stylize: stylizeNoColor
  };
  Kt != null && _extend(ho, Kt);
  const go = uo[0];
  let bo = 0, vo = "", Po = "";
  if (typeof go == "string") {
    if (uo.length === 1)
      return go;
    let Co, So = 0;
    for (let wo = 0; wo < go.length - 1; wo++)
      if (go.charCodeAt(wo) === 37) {
        const Eo = go.charCodeAt(++wo);
        if (bo + 1 !== uo.length) {
          switch (Eo) {
            case 115: {
              const Ro = uo[++bo];
              typeof Ro == "number" || typeof Ro == "bigint" ? Co = formatPrimitive(ho, Ro) : typeof Ro != "object" || Ro === null ? Co = String(Ro) : Co = inspect(Ro, {
                ...Kt,
                compact: 3,
                colors: !1,
                depth: 0
              });
              break;
            }
            case 106:
              Co = jsonStringifyRecursive(uo[++bo]);
              break;
            case 100: {
              const Ro = uo[++bo];
              typeof Ro == "bigint" ? Co = formatPrimitive(ho, Ro) : typeof Ro == "symbol" ? Co = "NaN" : Co = formatPrimitive(ho, Ro);
              break;
            }
            case 79:
              Co = inspect(uo[++bo], Kt);
              break;
            case 111:
              Co = inspect(uo[++bo], {
                ...Kt,
                showHidden: !0,
                showProxy: !0,
                depth: 4
              });
              break;
            case 105: {
              const Ro = uo[++bo];
              typeof Ro == "bigint" ? Co = formatPrimitive(ho, Ro) : typeof Ro == "symbol" ? Co = "NaN" : Co = formatPrimitive(ho, parseInt(Co));
              break;
            }
            case 102: {
              const Ro = uo[++bo];
              typeof Ro == "symbol" ? Co = "NaN" : Co = formatPrimitive(ho, parseInt(Ro));
              break;
            }
            case 99:
              bo += 1, Co = "";
              break;
            case 37:
              vo += go.slice(So, wo), So = wo + 1;
              continue;
            default:
              continue;
          }
          So !== wo - 1 && (vo += go.slice(So, wo - 1)), vo += Co, So = wo + 1;
        } else Eo === 37 && (vo += go.slice(So, wo), So = wo + 1);
      }
    So !== 0 && (bo++, Po = " ", So < go.length && (vo += go.slice(So)));
  }
  for (; bo < uo.length; ) {
    const Co = uo[bo];
    vo += Po, vo += typeof Co != "string" ? inspect(Co, Kt) : Co, Po = " ", bo++;
  }
  return vo;
}
const Runtime = {
  getCallerStackFrame,
  getErrorTrace,
  getMeta,
  transportJSON,
  transportFormatted,
  isBuffer: isBuffer$3,
  isError,
  prettyFormatLogObj,
  prettyFormatErrorObj
};
var Oa;
const meta = {
  runtime: [typeof window, typeof document].includes("undefined") ? "Generic" : "Browser",
  browser: (Oa = globalThis == null ? void 0 : globalThis.navigator) == null ? void 0 : Oa.userAgent
}, pathRegex = /(?:(?:file|https?|global code|[^@]+)@)?(?:file:)?((?:\/[^:/]+){2,})(?::(\d+))?(?::(\d+))?/;
function getMeta(Kt, uo, ho, go, bo, vo) {
  return Object.assign({}, meta, {
    name: bo,
    parentNames: vo,
    date: /* @__PURE__ */ new Date(),
    logLevelId: Kt,
    logLevelName: uo,
    path: go ? void 0 : getCallerStackFrame(ho)
  });
}
function getCallerStackFrame(Kt, uo = Error()) {
  var ho, go, bo;
  return stackLineToStackFrame((bo = (go = (ho = uo == null ? void 0 : uo.stack) == null ? void 0 : ho.split(`
`)) == null ? void 0 : go.filter((vo) => !vo.includes("Error: "))) == null ? void 0 : bo[Kt]);
}
function getErrorTrace(Kt) {
  var uo, ho, go;
  return (go = (ho = ((uo = Kt == null ? void 0 : Kt.stack) == null ? void 0 : uo.split(`
`)) ?? []) == null ? void 0 : ho.filter((bo) => !bo.includes("Error: "))) == null ? void 0 : go.reduce((bo, vo) => (bo.push(stackLineToStackFrame(vo)), bo), []);
}
function stackLineToStackFrame(Kt) {
  var go;
  const uo = (go = globalThis == null ? void 0 : globalThis.location) == null ? void 0 : go.origin, ho = {
    fullFilePath: void 0,
    fileName: void 0,
    fileNameWithLine: void 0,
    fileColumn: void 0,
    fileLine: void 0,
    filePath: void 0,
    filePathWithLine: void 0,
    method: void 0
  };
  if (Kt != null) {
    const bo = Kt.match(pathRegex);
    if (bo) {
      ho.filePath = bo[1].replace(/\?.*$/, ""), ho.fullFilePath = `${uo}${ho.filePath}`;
      const vo = ho.filePath.split("/");
      ho.fileName = vo[vo.length - 1], ho.fileLine = bo[2], ho.fileColumn = bo[3], ho.filePathWithLine = `${ho.filePath}:${ho.fileLine}`, ho.fileNameWithLine = `${ho.fileName}:${ho.fileLine}`;
    }
  }
  return ho;
}
function isError(Kt) {
  return Kt instanceof Error;
}
function prettyFormatLogObj(Kt, uo) {
  return Kt.reduce((ho, go) => (isError(go) ? ho.errors.push(prettyFormatErrorObj(go, uo)) : ho.args.push(go), ho), { args: [], errors: [] });
}
function prettyFormatErrorObj(Kt, uo) {
  const ho = getErrorTrace(Kt).map((bo) => formatTemplate(uo, uo.prettyErrorStackTemplate, { ...bo }, !0)), go = {
    errorName: ` ${Kt.name} `,
    errorMessage: Object.getOwnPropertyNames(Kt).reduce((bo, vo) => (vo !== "stack" && bo.push(Kt[vo]), bo), []).join(", "),
    errorStack: ho.join(`
`)
  };
  return formatTemplate(uo, uo.prettyErrorTemplate, go);
}
function transportFormatted(Kt, uo, ho, go) {
  const bo = (ho.length > 0 && uo.length > 0 ? `
` : "") + ho.join(`
`);
  go.prettyInspectOptions.colors = go.stylePrettyLogs, console.log(Kt + formatWithOptions(go.prettyInspectOptions, ...uo) + bo);
}
function transportJSON(Kt) {
  console.log(jsonStringifyRecursive(Kt));
}
function isBuffer$3(Kt) {
  return !1;
}
class BaseLogger {
  constructor(uo, ho, go = 4) {
    var bo, vo, Po, Co, So, wo, Eo, Ro;
    this.logObj = ho, this.stackDepthLevel = go, this.runtime = Runtime, this.settings = {
      type: (uo == null ? void 0 : uo.type) ?? "pretty",
      name: uo == null ? void 0 : uo.name,
      parentNames: uo == null ? void 0 : uo.parentNames,
      minLevel: (uo == null ? void 0 : uo.minLevel) ?? 0,
      argumentsArrayName: uo == null ? void 0 : uo.argumentsArrayName,
      hideLogPositionForProduction: (uo == null ? void 0 : uo.hideLogPositionForProduction) ?? !1,
      prettyLogTemplate: (uo == null ? void 0 : uo.prettyLogTemplate) ?? "{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}	{{logLevelName}}	{{filePathWithLine}}{{nameWithDelimiterPrefix}}	",
      prettyErrorTemplate: (uo == null ? void 0 : uo.prettyErrorTemplate) ?? `
{{errorName}} {{errorMessage}}
error stack:
{{errorStack}}`,
      prettyErrorStackTemplate: (uo == null ? void 0 : uo.prettyErrorStackTemplate) ?? `  • {{fileName}}	{{method}}
	{{filePathWithLine}}`,
      prettyErrorParentNamesSeparator: (uo == null ? void 0 : uo.prettyErrorParentNamesSeparator) ?? ":",
      prettyErrorLoggerNameDelimiter: (uo == null ? void 0 : uo.prettyErrorLoggerNameDelimiter) ?? "	",
      stylePrettyLogs: (uo == null ? void 0 : uo.stylePrettyLogs) ?? !0,
      prettyLogTimeZone: (uo == null ? void 0 : uo.prettyLogTimeZone) ?? "UTC",
      prettyLogStyles: (uo == null ? void 0 : uo.prettyLogStyles) ?? {
        logLevelName: {
          "*": ["bold", "black", "bgWhiteBright", "dim"],
          SILLY: ["bold", "white"],
          TRACE: ["bold", "whiteBright"],
          DEBUG: ["bold", "green"],
          INFO: ["bold", "blue"],
          WARN: ["bold", "yellow"],
          ERROR: ["bold", "red"],
          FATAL: ["bold", "redBright"]
        },
        dateIsoStr: "white",
        filePathWithLine: "white",
        name: ["white", "bold"],
        nameWithDelimiterPrefix: ["white", "bold"],
        nameWithDelimiterSuffix: ["white", "bold"],
        errorName: ["bold", "bgRedBright", "whiteBright"],
        fileName: ["yellow"],
        fileNameWithLine: "white"
      },
      prettyInspectOptions: (uo == null ? void 0 : uo.prettyInspectOptions) ?? {
        colors: !0,
        compact: !1,
        depth: 1 / 0
      },
      metaProperty: (uo == null ? void 0 : uo.metaProperty) ?? "_meta",
      maskPlaceholder: (uo == null ? void 0 : uo.maskPlaceholder) ?? "[***]",
      maskValuesOfKeys: (uo == null ? void 0 : uo.maskValuesOfKeys) ?? ["password"],
      maskValuesOfKeysCaseInsensitive: (uo == null ? void 0 : uo.maskValuesOfKeysCaseInsensitive) ?? !1,
      maskValuesRegEx: uo == null ? void 0 : uo.maskValuesRegEx,
      prefix: [...(uo == null ? void 0 : uo.prefix) ?? []],
      attachedTransports: [...(uo == null ? void 0 : uo.attachedTransports) ?? []],
      overwrite: {
        mask: (bo = uo == null ? void 0 : uo.overwrite) == null ? void 0 : bo.mask,
        toLogObj: (vo = uo == null ? void 0 : uo.overwrite) == null ? void 0 : vo.toLogObj,
        addMeta: (Po = uo == null ? void 0 : uo.overwrite) == null ? void 0 : Po.addMeta,
        addPlaceholders: (Co = uo == null ? void 0 : uo.overwrite) == null ? void 0 : Co.addPlaceholders,
        formatMeta: (So = uo == null ? void 0 : uo.overwrite) == null ? void 0 : So.formatMeta,
        formatLogObj: (wo = uo == null ? void 0 : uo.overwrite) == null ? void 0 : wo.formatLogObj,
        transportFormatted: (Eo = uo == null ? void 0 : uo.overwrite) == null ? void 0 : Eo.transportFormatted,
        transportJSON: (Ro = uo == null ? void 0 : uo.overwrite) == null ? void 0 : Ro.transportJSON
      }
    };
  }
  log(uo, ho, ...go) {
    var Ro, _o, Io, Ao, Oo, jo, Do, Lo, ko, Ko, No, Jo, ti, oi;
    if (uo < this.settings.minLevel)
      return;
    const bo = [...this.settings.prefix, ...go], vo = ((Ro = this.settings.overwrite) == null ? void 0 : Ro.mask) != null ? (_o = this.settings.overwrite) == null ? void 0 : _o.mask(bo) : this.settings.maskValuesOfKeys != null && this.settings.maskValuesOfKeys.length > 0 ? this._mask(bo) : bo, Po = this.logObj != null ? this._recursiveCloneAndExecuteFunctions(this.logObj) : void 0, Co = ((Io = this.settings.overwrite) == null ? void 0 : Io.toLogObj) != null ? (Ao = this.settings.overwrite) == null ? void 0 : Ao.toLogObj(vo, Po) : this._toLogObj(vo, Po), So = ((Oo = this.settings.overwrite) == null ? void 0 : Oo.addMeta) != null ? (jo = this.settings.overwrite) == null ? void 0 : jo.addMeta(Co, uo, ho) : this._addMetaToLogObj(Co, uo, ho);
    let wo, Eo;
    return ((Do = this.settings.overwrite) == null ? void 0 : Do.formatMeta) != null && (wo = (Lo = this.settings.overwrite) == null ? void 0 : Lo.formatMeta(So == null ? void 0 : So[this.settings.metaProperty])), ((ko = this.settings.overwrite) == null ? void 0 : ko.formatLogObj) != null && (Eo = (Ko = this.settings.overwrite) == null ? void 0 : Ko.formatLogObj(vo, this.settings)), this.settings.type === "pretty" && (wo = wo ?? this._prettyFormatLogObjMeta(So == null ? void 0 : So[this.settings.metaProperty]), Eo = Eo ?? this.runtime.prettyFormatLogObj(vo, this.settings)), wo != null && Eo != null ? ((No = this.settings.overwrite) == null ? void 0 : No.transportFormatted) != null ? (Jo = this.settings.overwrite) == null || Jo.transportFormatted(wo, Eo.args, Eo.errors, this.settings) : this.runtime.transportFormatted(wo, Eo.args, Eo.errors, this.settings) : ((ti = this.settings.overwrite) == null ? void 0 : ti.transportJSON) != null ? (oi = this.settings.overwrite) == null || oi.transportJSON(So) : this.settings.type !== "hidden" && this.runtime.transportJSON(So), this.settings.attachedTransports != null && this.settings.attachedTransports.length > 0 && this.settings.attachedTransports.forEach((Qo) => {
      Qo(So);
    }), So;
  }
  attachTransport(uo) {
    this.settings.attachedTransports.push(uo);
  }
  getSubLogger(uo, ho) {
    var vo, Po, Co;
    const go = {
      ...this.settings,
      ...uo,
      parentNames: ((vo = this.settings) == null ? void 0 : vo.parentNames) != null && ((Po = this.settings) == null ? void 0 : Po.name) != null ? [...this.settings.parentNames, this.settings.name] : ((Co = this.settings) == null ? void 0 : Co.name) != null ? [this.settings.name] : void 0,
      prefix: [...this.settings.prefix, ...(uo == null ? void 0 : uo.prefix) ?? []]
    };
    return new this.constructor(go, ho ?? this.logObj, this.stackDepthLevel);
  }
  _mask(uo) {
    const ho = this.settings.maskValuesOfKeysCaseInsensitive !== !0 ? this.settings.maskValuesOfKeys : this.settings.maskValuesOfKeys.map((go) => go.toLowerCase());
    return uo == null ? void 0 : uo.map((go) => this._recursiveCloneAndMaskValuesOfKeys(go, ho));
  }
  _recursiveCloneAndMaskValuesOfKeys(uo, ho, go = []) {
    var bo, vo;
    if (go.includes(uo))
      return { ...uo };
    if (typeof uo == "object" && uo !== null && go.push(uo), this.runtime.isError(uo) || this.runtime.isBuffer(uo))
      return uo;
    if (uo instanceof Map)
      return new Map(uo);
    if (uo instanceof Set)
      return new Set(uo);
    if (Array.isArray(uo))
      return uo.map((Po) => this._recursiveCloneAndMaskValuesOfKeys(Po, ho, go));
    if (uo instanceof Date)
      return new Date(uo.getTime());
    if (uo instanceof URL)
      return urlToObject(uo);
    if (uo !== null && typeof uo == "object") {
      const Po = this.runtime.isError(uo) ? this._cloneError(uo) : Object.create(Object.getPrototypeOf(uo));
      return Object.getOwnPropertyNames(uo).reduce((Co, So) => {
        var wo;
        return Co[So] = ho.includes(((wo = this.settings) == null ? void 0 : wo.maskValuesOfKeysCaseInsensitive) !== !0 ? So : So.toLowerCase()) ? this.settings.maskPlaceholder : (() => {
          try {
            return this._recursiveCloneAndMaskValuesOfKeys(uo[So], ho, go);
          } catch {
            return null;
          }
        })(), Co;
      }, Po);
    } else {
      if (typeof uo == "string") {
        let Po = uo;
        for (const Co of ((bo = this.settings) == null ? void 0 : bo.maskValuesRegEx) || [])
          Po = Po.replace(Co, ((vo = this.settings) == null ? void 0 : vo.maskPlaceholder) || "");
        return Po;
      }
      return uo;
    }
  }
  _recursiveCloneAndExecuteFunctions(uo, ho = []) {
    return this.isObjectOrArray(uo) && ho.includes(uo) ? this.shallowCopy(uo) : (this.isObjectOrArray(uo) && ho.push(uo), Array.isArray(uo) ? uo.map((go) => this._recursiveCloneAndExecuteFunctions(go, ho)) : uo instanceof Date ? new Date(uo.getTime()) : this.isObject(uo) ? Object.getOwnPropertyNames(uo).reduce((go, bo) => {
      const vo = Object.getOwnPropertyDescriptor(uo, bo);
      if (vo) {
        Object.defineProperty(go, bo, vo);
        const Po = uo[bo];
        go[bo] = typeof Po == "function" ? Po() : this._recursiveCloneAndExecuteFunctions(Po, ho);
      }
      return go;
    }, Object.create(Object.getPrototypeOf(uo))) : uo);
  }
  isObjectOrArray(uo) {
    return typeof uo == "object" && uo !== null;
  }
  isObject(uo) {
    return typeof uo == "object" && !Array.isArray(uo) && uo !== null;
  }
  shallowCopy(uo) {
    return Array.isArray(uo) ? [...uo] : { ...uo };
  }
  _toLogObj(uo, ho = {}) {
    return uo = uo == null ? void 0 : uo.map((go) => this.runtime.isError(go) ? this._toErrorObject(go) : go), this.settings.argumentsArrayName == null ? uo.length === 1 && !Array.isArray(uo[0]) && this.runtime.isBuffer(uo[0]) !== !0 && !(uo[0] instanceof Date) ? ho = typeof uo[0] == "object" && uo[0] != null ? { ...uo[0], ...ho } : { 0: uo[0], ...ho } : ho = { ...ho, ...uo } : ho = {
      ...ho,
      [this.settings.argumentsArrayName]: uo
    }, ho;
  }
  _cloneError(uo) {
    const ho = new uo.constructor();
    return Object.getOwnPropertyNames(uo).forEach((go) => {
      ho[go] = uo[go];
    }), ho;
  }
  _toErrorObject(uo) {
    return {
      nativeError: uo,
      name: uo.name ?? "Error",
      message: uo.message,
      stack: this.runtime.getErrorTrace(uo)
    };
  }
  _addMetaToLogObj(uo, ho, go) {
    return {
      ...uo,
      [this.settings.metaProperty]: this.runtime.getMeta(ho, go, this.stackDepthLevel, this.settings.hideLogPositionForProduction, this.settings.name, this.settings.parentNames)
    };
  }
  _prettyFormatLogObjMeta(uo) {
    var Po, Co, So, wo, Eo, Ro, _o, Io, Ao, Oo, jo, Do, Lo, ko, Ko, No, Jo, ti, oi, Qo, Zo, ei;
    if (uo == null)
      return "";
    let ho = this.settings.prettyLogTemplate;
    const go = {};
    ho.includes("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}") ? ho = ho.replace("{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}", "{{dateIsoStr}}") : this.settings.prettyLogTimeZone === "UTC" ? (go.yyyy = ((Po = uo == null ? void 0 : uo.date) == null ? void 0 : Po.getUTCFullYear()) ?? "----", go.mm = formatNumberAddZeros((Co = uo == null ? void 0 : uo.date) == null ? void 0 : Co.getUTCMonth(), 2, 1), go.dd = formatNumberAddZeros((So = uo == null ? void 0 : uo.date) == null ? void 0 : So.getUTCDate(), 2), go.hh = formatNumberAddZeros((wo = uo == null ? void 0 : uo.date) == null ? void 0 : wo.getUTCHours(), 2), go.MM = formatNumberAddZeros((Eo = uo == null ? void 0 : uo.date) == null ? void 0 : Eo.getUTCMinutes(), 2), go.ss = formatNumberAddZeros((Ro = uo == null ? void 0 : uo.date) == null ? void 0 : Ro.getUTCSeconds(), 2), go.ms = formatNumberAddZeros((_o = uo == null ? void 0 : uo.date) == null ? void 0 : _o.getUTCMilliseconds(), 3)) : (go.yyyy = ((Io = uo == null ? void 0 : uo.date) == null ? void 0 : Io.getFullYear()) ?? "----", go.mm = formatNumberAddZeros((Ao = uo == null ? void 0 : uo.date) == null ? void 0 : Ao.getMonth(), 2, 1), go.dd = formatNumberAddZeros((Oo = uo == null ? void 0 : uo.date) == null ? void 0 : Oo.getDate(), 2), go.hh = formatNumberAddZeros((jo = uo == null ? void 0 : uo.date) == null ? void 0 : jo.getHours(), 2), go.MM = formatNumberAddZeros((Do = uo == null ? void 0 : uo.date) == null ? void 0 : Do.getMinutes(), 2), go.ss = formatNumberAddZeros((Lo = uo == null ? void 0 : uo.date) == null ? void 0 : Lo.getSeconds(), 2), go.ms = formatNumberAddZeros((ko = uo == null ? void 0 : uo.date) == null ? void 0 : ko.getMilliseconds(), 3));
    const bo = this.settings.prettyLogTimeZone === "UTC" ? uo == null ? void 0 : uo.date : new Date(((Ko = uo == null ? void 0 : uo.date) == null ? void 0 : Ko.getTime()) - ((No = uo == null ? void 0 : uo.date) == null ? void 0 : No.getTimezoneOffset()) * 6e4);
    go.rawIsoStr = bo == null ? void 0 : bo.toISOString(), go.dateIsoStr = bo == null ? void 0 : bo.toISOString().replace("T", " ").replace("Z", ""), go.logLevelName = uo == null ? void 0 : uo.logLevelName, go.fileNameWithLine = ((Jo = uo == null ? void 0 : uo.path) == null ? void 0 : Jo.fileNameWithLine) ?? "", go.filePathWithLine = ((ti = uo == null ? void 0 : uo.path) == null ? void 0 : ti.filePathWithLine) ?? "", go.fullFilePath = ((oi = uo == null ? void 0 : uo.path) == null ? void 0 : oi.fullFilePath) ?? "";
    let vo = (Qo = this.settings.parentNames) == null ? void 0 : Qo.join(this.settings.prettyErrorParentNamesSeparator);
    return vo = vo != null && (uo == null ? void 0 : uo.name) != null ? vo + this.settings.prettyErrorParentNamesSeparator : void 0, go.name = (uo == null ? void 0 : uo.name) != null || vo != null ? (vo ?? "") + (uo == null ? void 0 : uo.name) : "", go.nameWithDelimiterPrefix = go.name.length > 0 ? this.settings.prettyErrorLoggerNameDelimiter + go.name : "", go.nameWithDelimiterSuffix = go.name.length > 0 ? go.name + this.settings.prettyErrorLoggerNameDelimiter : "", ((Zo = this.settings.overwrite) == null ? void 0 : Zo.addPlaceholders) != null && ((ei = this.settings.overwrite) == null || ei.addPlaceholders(uo, go)), formatTemplate(this.settings, ho, go);
  }
}
class Logger extends BaseLogger {
  constructor(uo, ho) {
    const go = typeof window < "u" && typeof document < "u", bo = go ? window.chrome !== void 0 && window.CSS !== void 0 && window.CSS.supports("color", "green") : !1, vo = go ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
    uo = uo || {}, uo.stylePrettyLogs = uo.stylePrettyLogs && go && !bo ? !1 : uo.stylePrettyLogs, super(uo, ho, vo ? 4 : 5);
  }
  log(uo, ho, ...go) {
    return super.log(uo, ho, ...go);
  }
  silly(...uo) {
    return super.log(0, "SILLY", ...uo);
  }
  trace(...uo) {
    return super.log(1, "TRACE", ...uo);
  }
  debug(...uo) {
    return super.log(2, "DEBUG", ...uo);
  }
  info(...uo) {
    return super.log(3, "INFO", ...uo);
  }
  warn(...uo) {
    return super.log(4, "WARN", ...uo);
  }
  error(...uo) {
    return super.log(5, "ERROR", ...uo);
  }
  fatal(...uo) {
    return super.log(6, "FATAL", ...uo);
  }
  getSubLogger(uo, ho) {
    return super.getSubLogger(uo, ho);
  }
}
function Slot(Kt) {
  let {
    type: uo = "div",
    children: ho = [],
    className: go = "",
    ...bo
  } = Kt || {}, vo, Po;
  uo === void 0 && (uo = "div"), Array.isArray(ho) || (ho = [ho]);
  const Co = {};
  for (const [So, wo] of Object.entries(bo)) {
    const Eo = So.startsWith("on") ? So.toLocaleLowerCase() : So.replace(new RegExp("(?<=[a-z])[A-Z]+(?!$)", "g"), (Ro) => `-${Ro.toLowerCase()}`);
    Co[Eo] = wo;
  }
  return is_1.string(go) && !is_1.empty(go) && (Co.class = go), Kt && is_1.function(Kt.onClick) && !is_1.empty(Kt.onClick) && (vo = Kt.onClick), Kt && is_1.function(Kt.onKeyDown) && !is_1.empty(Kt.onKeyDown) && (Po = Kt.onKeyDown), createElement(
    uo,
    {
      ...Co,
      onClick: vo,
      onKeyDown: Po
    },
    ...ho
  );
}
function Results(Kt) {
  let {
    type: uo = "alc-search-bar-results",
    className: ho = "",
    children: go,
    ...bo
  } = Kt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: uo,
      className: [ho].join(" ").trim(),
      ...bo,
      children: go
    }
  );
}
function ResultsTitle(Kt) {
  let {
    type: uo = "alc-search-bar-results-title",
    className: ho = "",
    children: go,
    ...bo
  } = Kt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: uo,
      className: [ho].join(" ").trim(),
      ...bo,
      children: go
    }
  );
}
function ResultsCount(Kt) {
  let {
    type: uo = "alc-search-bar-results-title-count",
    className: ho = "",
    children: go,
    ...bo
  } = Kt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: uo,
      className: [ho].join(" ").trim(),
      ...bo,
      children: go
    }
  );
}
function ResultsMessage(Kt) {
  let {
    type: uo = "alc-search-bar-results-message",
    className: ho = "",
    children: go,
    ...bo
  } = Kt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: uo,
      className: [ho].join(" ").trim(),
      ...bo,
      children: go
    }
  );
}
function ResultsItems(Kt) {
  let {
    type: uo = "alc-search-bar-results-list",
    className: ho = "",
    children: go,
    ...bo
  } = Kt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: uo,
      className: [ho].join(" ").trim(),
      ...bo,
      children: go
    }
  );
}
function ResultsItem(Kt) {
  let {
    type: uo = "alc-search-bar-results-listitem",
    className: ho = "",
    children: go,
    ...bo
  } = Kt ?? {};
  return /* @__PURE__ */ jsxRuntimeExports.jsx(
    Slot,
    {
      type: uo,
      className: [ho].join(" ").trim(),
      ...bo,
      children: go
    }
  );
}
const Pagination = (Kt) => {
  var Ro, _o, Io, Ao, Oo, jo, Do, Lo, ko, Ko, No, Jo, ti, oi, Qo, Zo;
  const {
    currentPage: uo,
    pages: ho,
    lastPage: go,
    onPageChange: bo,
    addFirstPageButton: vo = !1,
    addLastPageButton: Po = !1,
    alignment: Co = "centered",
    render: So = !0,
    slots: wo = {}
  } = Kt ?? {}, Eo = [Co, ((Ro = wo == null ? void 0 : wo.root) == null ? void 0 : Ro.className) ?? ""].join(" ").trim();
  return So ? !is_1.array(ho) || is_1.empty(ho) ? /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {}) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Slot, { type: ((_o = wo == null ? void 0 : wo.root) == null ? void 0 : _o.element) ?? "alc-pagination", className: Eo, ...(Io = wo == null ? void 0 : wo.root) == null ? void 0 : Io.attributes, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Slot, { type: ((Oo = (Ao = wo == null ? void 0 : wo.buttons) == null ? void 0 : Ao.leftColumn) == null ? void 0 : Oo.element) ?? "alc-pagination-left-column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (ei) => bo(1, ei),
          className: vo && uo !== 1 ? "" : "hidden",
          "aria-hidden": !vo && uo !== 1,
          "aria-label": "Go to first page",
          "data-test-id": "first-page-button",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: ((Do = (jo = wo == null ? void 0 : wo.buttons) == null ? void 0 : jo.firstPage) == null ? void 0 : Do.icon) ?? "fa-solid fa-chevron-double-left" })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (ei) => bo(uo - 1, ei),
          className: uo == 1 || !is_1.array(ho) ? "hidden" : "",
          "aria-hidden": uo == 1,
          "aria-label": "Go to previous page",
          "data-test-id": "previous-page-button",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: ((ko = (Lo = wo == null ? void 0 : wo.buttons) == null ? void 0 : Lo.prevPage) == null ? void 0 : ko.icon) ?? "fa-solid fa-chevron-left" })
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Slot, { type: ((Ko = wo == null ? void 0 : wo.buttons) == null ? void 0 : Ko.element) ?? "alc-pagination-pages", children: is_1.array(ho) && ho.filter((ei) => is_1.number(ei)).map((ei, ii) => /* @__PURE__ */ jsxRuntimeExports.jsx(
      "button",
      {
        onClick: (ai) => bo(ei, ai),
        className: ["page-button", ei === uo ? "active" : ""].join(" ").trim(),
        "aria-label": `Go to page ${ei}`,
        "data-test-id": `page-button-${ei}`,
        tabIndex: 0,
        children: ei
      },
      ii
    )) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Slot, { type: ((Jo = (No = wo == null ? void 0 : wo.buttons) == null ? void 0 : No.rightColumn) == null ? void 0 : Jo.element) ?? "alc-pagination-right-column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (ei) => bo(uo + 1, ei),
          type: "text",
          className: uo === go || !is_1.array(ho) ? "hidden" : "",
          "aria-hidden": uo === go,
          "aria-label": "Go to next page",
          "data-test-id": "next-page-button",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: ((oi = (ti = wo == null ? void 0 : wo.buttons) == null ? void 0 : ti.nextPage) == null ? void 0 : oi.icon) ?? "fa-solid fa-chevron-right", "aria-hidden": "true" })
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: (ei) => bo(go, ei),
          type: "text",
          className: !Po || uo === go ? "hidden" : "",
          "aria-hidden": !Po || uo === go,
          "aria-label": "Go to last page",
          tabIndex: 0,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: ((Zo = (Qo = wo == null ? void 0 : wo.buttons) == null ? void 0 : Qo.lastPage) == null ? void 0 : Zo.icon) ?? "fa-solid fa-chevron-double-right", "aria-hidden": "true" })
        }
      )
    ] })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, {});
};
Pagination.propTypes = {
  /**
   * The current page being displayed.
   *
   * Is used to indicate the page being shown in the pagination row. Minimum should be 1.
   */
  currentPage: PropTypes.number,
  /**
   * A list of page numbers to display in the pagination row.
   *
   * Any non-numbers will be ignored and the pages will be displayed in the order they appear in the list.
   */
  pages: PropTypes.arrayOf(PropTypes.number),
  /**
   * The last available page for the pagination.
   *
   * Used to know when to stop showing the next and last page buttons.
   */
  lastPage: PropTypes.number,
  /**
   * Function to execute when the one of the pagination buttons is clicked, or a page button is clicked.
   *
   * The function will always provide the currently selected page as the first argument and a object of options as
   * the second argument. The contents of the argument changes with the type selected:
   * - event (Event): The Event object provided. (This is always provided)
   * - items (object[]): The objects to be displayed for the selected page. (Only provided for 'local' type)
   */
  onPageChange: PropTypes.func.isRequired,
  /**
   * Indicates that a button to go directly to the first page should be displayed.
   *
   * Defaults to 'false'.
   */
  addFirstPageButton: PropTypes.bool,
  /**
   * Indicates that a button to go directly to the last page should be displayed.
   *
   * Defaults to 'false'.
   */
  addLastPageButton: PropTypes.bool,
  /**
   * Positions the pagination buttons within the pagination row.
   *
   * Accepted values:
   * - 'center': The pagination buttons are centered in the row. This is the default.
   * - 'left-aligned': The pagination buttons are aligned to the left of the row.
   * - 'right-aligned': The pagination buttons are aligned to the right of the row.
   * - 'space-around': The pagination buttons are evenly distributed in the line with equal space around them.
   */
  alignment: PropTypes.oneOf([
    "centered",
    "left-aligned",
    "right-aligned",
    "space-around"
  ]),
  /**
   * The maximum number of pages to show at one time. This should be an odd number and will be increased to the
   * next odd number if it isn't.
   */
  viewportSize: PropTypes.number,
  /**
   * The number of pages that need to be iterated over.
   */
  totalPages: PropTypes.number,
  /**
   * Custom attributes used to modify specific elements/components and/or attributes of components.
   *
   * The shape of slots for this component is thus:
   * {
   *   root: { // affects the root element of the pagination row.
   *     element: the name of the element to render. Defaults to 'alc-pagination',
   *     className: additional classes to add to the element. Defaults to '',
   *     attributes: additional attributes to add to the element.,
   *   },
   *   buttons: { // affects the pagination row buttons.
   *     leftColumn: { // affects the container for the first and prev buttons
   *       element: the name of the element to render. Defaults to 'alc-pagination-left-column'
   *     },
   *     rightColumn: { // affects the container for the last and nxt buttons
   *       element: the name of the element to render. Defaults to 'alc-pagination-right-column'
   *     },
   *     firstPage: { // affects the first page button, if displayed
   *       icon: the font-awesome icon to show as the first button. Defaults to 'fa-solid fa-chevrons-left'.
   *     },
   *     prevPage: { // affects the previous page button
   *       icon: the font-awesome icon to show as the previous button. Defaults to 'fa-solid fa-chevron-left'.
   *     },
   *     current: { // affects the currently selected page button
   *       backgroundColor: the background color of the current / active page button. Defaults to
   *       'var(--vp-bright-blue)'.
   *       color: the color of the page number text of the current / active page button. Defaults to 'var(--vp-white)'.
   *     },
   *     nextPage: { // affects the next page button, if displayed
   *       icon: the font-awesome icon to show as the next button. Defaults to 'fa-solid fa-chevron-right'.
   *     },
   *     lastPage: { // affects the first page button, if displayed
   *       icon: the font-awesome icon to show as the first button. Defaults to 'fa-solid fa-chevrons-right'.
   *     },
   *     backgroundColor: the background color of the other page buttons. Defaults to 'transparent'.
   *     color: the color of the page number text of the page buttons. Defaults to 'var(--vp-dark-blue)'.
   *   }
   * }
   */
  slots: PropTypes.shape({
    root: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    buttons: PropTypes.shape({
      leftColumn: PropTypes.shape({
        element: PropTypes.string
      }),
      rightColumn: PropTypes.shape({
        element: PropTypes.string
      }),
      firstPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      prevPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      nextPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      lastPage: PropTypes.shape({
        icon: PropTypes.string
      }),
      current: PropTypes.shape({
        backgroundColor: PropTypes.string,
        color: PropTypes.string
      }),
      backgroundColor: PropTypes.string,
      color: PropTypes.string
    })
  })
};
const log$3 = new Logger({ name: "numbers" }), clamp = (Kt, uo) => {
  const {
    minimum: ho = Number.MIN_SAFE_INTEGER,
    maximum: go = Number.MAX_SAFE_INTEGER
  } = uo || {};
  return Math.min(Math.max(Kt, ho), go);
};
function range$4(Kt = {}) {
  const {
    startAt: uo = 1,
    endAt: ho,
    increment: go = 1
  } = Kt ?? {};
  if (!is_1.number(uo))
    throw new TypeError("starting range number must be a number.");
  if (!is_1.number(ho))
    throw new TypeError("ending range number must be a number.");
  if (!is_1.number(go))
    throw new TypeError("increment number must be a number");
  if (go === 0)
    throw new TypeError("increment number cannot be zero (0).");
  if (uo > ho && go > 0)
    throw new TypeError("starting range number cannot be greater-than ending range number if increment is positive.");
  if (uo < ho && go < 1)
    throw new TypeError("starting range number cannot be less-than ending range number is increment is negative.");
  if (ho === uo)
    return [uo];
  const bo = [];
  if (ho > uo) {
    for (let vo = uo; vo <= ho; vo += go)
      bo.push(vo);
    return bo;
  }
  for (let vo = uo; vo >= ho; vo += go)
    bo.push(vo);
  return bo;
}
const ensureIsNumber = (Kt, uo) => is_1.number(Kt) ? Kt : is_1.number(uo) ? (log$3.warn(`ensureIsNumber: ${Kt} is not a number - returning default value.`), uo) : (log$3.warn("ensureIsNumber: default value is not a number - returning Number.NaN"), Number.NaN), ensureIsOddNumber = (Kt) => is_1.number(Kt) ? Kt % 2 === 0 ? Kt + 1 : Kt : Number.NaN, getMedianValues = (...Kt) => {
  if (Kt = Kt.filter((uo) => is_1.number(uo)), is_1.empty(Kt))
    return [];
  if (Kt.sort(), Kt.length % 2 === 0) {
    if (Kt.length == 2)
      return Kt;
    const uo = Kt.length / 2;
    return [Kt[uo - 1], Kt[uo]];
  }
  return [Kt[Math.floor(Kt.length / 2)]];
};
new Logger({ name: "utils:func" });
const toCamelCase = (Kt) => Kt.toLowerCase().split(" ").map((uo, ho) => ho === 0 ? uo : uo.charAt(0).toUpperCase() + uo.slice(1)).join("");
class ExtendedArray extends Array {
  /**
   * Returns the first index value for the array.
   * 
   * If the array is empty, returns Number.NaN.
   * 
   * @property
   * @returns {number | Number.NaN}
   */
  get firstIndexValue() {
    return this.isEmpty() ? Number.NaN : 0;
  }
  /**
   * Returns the last index number for the array.
   * 
   * If the array is empty, returns NaN.
   * 
   * @property
   * @returns {number | Number.NaN}
   */
  get lastIndexValue() {
    return this.isEmpty() ? Number.NaN : this.length - 1;
  }
  /**
   * Returns a list of the center index values for the array.
   * 
   * If the array has an odd number of items, the list will contain the exact median index value.
   * If the array contains an even number of items, the list will contain two values.
   * 
   * If the array is empty, the method will return Number.NaN.
   * 
   * @property
   * @returns {number[] | number}
   */
  get centerIndexValue() {
    return this.isEmpty() ? Number.NaN : new ExtendedArray(...getMedianValues(
      range$4({ startAt: 0, endAt: this.lastIndexValue })
    ));
  }
  /**
   * Returns the first element in the list.
   * 
   * If the list is empty, returns undefined.
   * 
   * @returns {* | undefined}
   */
  first() {
    if (!this.isEmpty())
      return this[this.firstIndexValue];
  }
  /**
   * Returns the last element in the list.
   * 
   * If the list is empty, return undefined.
   * 
   * @returns {* | undefined}
   */
  last() {
    if (!this.isEmpty())
      return this[this.lastIndexValue];
  }
  /**
   * Removes all of the entries in the array by making the length zero (0).
   * 
   * @returns {void}
   */
  clear() {
    this.length = 0;
  }
  /**
   * Indicates if the array is empty.
   * 
   * @returns {boolean}
   */
  isEmpty() {
    return this.length === 0;
  }
}
var Vs, ea, na, ws, Js, oa, ia;
class ArrayWalker {
  /**
   * Creates an instance of ArrayWalker.
   * 
   * @param {array} items The list of items to walk across.
   * @param {object} options An object for configuring  the walker.
   * @param {number} [paddingLeft = 0] A buffer number for determining the lower index bound.
   * @param {number} [paddingRight = 0] A buffer number for determining the upper index bound.
   */
  constructor(uo, ho = {}) {
    /**
     * The internal array for the instance.
     * 
     * @property
     * @private
     */
    ra(this, Vs, new ExtendedArray());
    /**
     * The lowest value that the internal pointer can have when moving up the array.
     * 
     * @property
     * @private
     */
    ra(this, ea);
    /**
     * The highest value that the internal pointer can have when moving down the array.
     * 
     * @property
     * @private
     */
    ra(this, na);
    /**
     * The value that stores the internal index that the 
     * 
     * @property
     * @private
     */
    ra(this, ws);
    /**
     * The previous index pointer value.
     * 
     * @property
     * @private
     */
    ra(this, Js, Number.NaN);
    /**
     * The padding to use for adjusting the upper index bound value.
     * 
     * @property
     * @private
     */
    ra(this, oa);
    /**
     * The padding to use for adjusting the lower index bound value.
     * 
     * @property
     * @private
     */
    ra(this, ia);
    this.setPadding(ho), this.setArray(uo, !0);
  }
  /**
   * Returns the value of the internal index pointer.
   * 
   * @property
   * @returns {number}
   */
  get pointer() {
    return xs(this, ws);
  }
  /**
   * Provides access to the value at the internal pointer's position.
   * 
   * @property
   * @returns {any}
   */
  get value() {
    return xs(this, Vs)[xs(this, ws)];
  }
  /**
   * Returns the length of the underlying array.
   * 
   * @property
   * @returns {number}
   */
  get size() {
    return is_1.array(xs(this, Vs)) ? xs(this, Vs).length : 0;
  }
  /**
   * Wrapper around the size property.
   * 
   * @property
   * @returns {number}
   */
  get length() {
    return this.size;
  }
  /**
   * Creates a slice of the underlying array from the current index to the length passed.
   * 
   * @param {number} [length = 1] The length of the viewport to return.
   * @param {number} [adjustPOinter] Adjust the pointer temporarily to shift the viewport starting number.
   * @returns {any[]}
   */
  viewport(uo, ho = {}) {
    if (!is_1.array(xs(this, Vs)))
      return [];
    const {
      adjustPointer: go = 0
    } = ho ?? {}, bo = ensureIsNumber(go, 0), vo = xs(this, ws) + bo;
    return uo = vo + ensureIsNumber(uo, 1), xs(this, Vs).slice(vo, uo);
  }
  /**
   * Increases the internal pointer value by 1.
   * 
   * The internal pointer cannot exceed the upper index bound value.
   * 
   * @returns {void}
   */
  down() {
    this.downBy(1);
  }
  /**
   * Increases the internal pointer value by the value provided.
   * 
   * If the value is not a number, the value is automatically set to 1.
   * If the value is negative, it will be set to 1.
   * The internal pointer cannot exceed the upper index bound value.
   * 
   * @param {number} [value = 1] The number to use to adjust the internal index pointer.
   * @returns {void}
   */
  downBy(uo) {
    uo = Math.max(ensureIsNumber(uo, 1), 1), As(this, Js, xs(this, ws)), As(this, ws, Math.min(xs(this, ws) + uo, xs(this, na)));
  }
  /**
   * Decreases the internal pointe value by 1.
   * 
   * The internal pointer cannot be less-than the lower bound value.
   * @returns {void}
   */
  up() {
    this.upBy(1);
  }
  /**
   * Decreases the internal pointer value by the value provided.
   * 
   * If the value is not a number, the value is automatically set to 1.
   * If the value is negative, it will be set to 1.
   * The internal pointer cannot be less-than the lower bound value.
   * 
   * @param {number} [value = 1] The number to use to adjust the internal index pointer.
   * @returns {void}
   */
  upBy(uo) {
    uo = Math.max(ensureIsNumber(uo, 1), 1), As(this, Js, xs(this, ws)), As(this, ws, Math.max(xs(this, ws) - uo, xs(this, ea)));
  }
  /**
   * Set the internal pointer to the value corresponding to the center of the underlying array.
   * 
   * @returns {void}
   */
  goToCenter() {
    const uo = xs(this, Vs).centerIndexValue;
    is_1.array(uo) && (As(this, Js, xs(this, ws)), As(this, ws, ensureIsNumber(uo[0], xs(this, ws))));
  }
  /**
   * Sets the internal pointer to the index value provided.
   * 
   * If the underlying array is empty, the method does nothing.
   * If the value of index is not a number, the method does nothing.
   * 
   * The internal pointer will be set no higher than the upper bounds and no lower than the lower bounds.
   * 
   * @param {number} index The index location to move the internal pointer to.
   * @returns {void}
   */
  goToIndex(uo) {
    xs(this, Vs).isEmpty() || is_1.number(uo) && (As(this, Js, xs(this, ws)), As(this, ws, Math.max(Math.min(uo, xs(this, na)), xs(this, ea))));
  }
  /**
   * Sets the internal array with the values passed in.
   * 
   * 
   * @param {any[]} items The array of items to add to the internal array.
   * @param {boolean} [reset = false] If true, resets the internal index pointer.
   * @returns {void}
   */
  setArray(uo, ho = !1) {
    is_1.array(uo) && (xs(this, Vs).clear(), xs(this, Vs).push(...uo), As(this, ea, ensureIsNumber(xs(this, ia), 0)), As(this, na, xs(this, Vs).lastIndexValue - xs(this, oa)), ho && (As(this, Js, Number.NaN), As(this, ws, Math.max(0, xs(this, ea)))));
  }
  /**
   * Sets the paddings and upper and lower bounds.
   * 
   * Also adjusts the index pointer so it will fall between the upper and lower bounds.
   * 
   * @param {array} items The list of items to walk across.
   * @param {object} options An object for configuring  the walker.
   * @param {number} [paddingLeft = 0] A buffer number for determining the lower index bound.
   * @param {number} [paddingRight = 0] A buffer number for determining the upper index bound.
   * @returns {void}
   */
  setPadding(uo = {}) {
    const {
      paddingLeft: ho = ensureIsNumber(xs(this, ia), 0),
      paddingRight: go = ensureIsNumber(xs(this, oa), 0)
    } = uo ?? {};
    As(this, oa, Math.max(ensureIsNumber(go, 0), 0)), As(this, ia, Math.max(ensureIsNumber(ho, 0), 0)), As(this, ea, ensureIsNumber(xs(this, ia), 0)), As(this, na, xs(this, Vs).lastIndexValue - xs(this, oa)), As(this, ws, Math.max(
      Math.min(xs(this, ws), xs(this, na)),
      xs(this, ea)
    )), As(this, Js, Number.NaN);
  }
  /**
   * Indicates that the index pointer has moved.
   * 
   * @returns {boolean}
   */
  hasPointerMoved() {
    return xs(this, Js) !== xs(this, ws);
  }
  /**
   * Indicates that the index pointer is one of the values for the center indexes.
   * 
   * @returns {boolean}
   */
  indexIsInCenter() {
    return xs(this, Vs).centerIndexes.includes(xs(this, ws));
  }
}
Vs = new WeakMap(), ea = new WeakMap(), na = new WeakMap(), ws = new WeakMap(), Js = new WeakMap(), oa = new WeakMap(), ia = new WeakMap();
const eventEnterKeyReleased = (Kt) => Kt.key === "Enter" || Kt.which === 13 || Kt.keyCode === 13, log$2 = new Logger({ name: "SearchBar logger" }), SearchBar = (Kt) => {
  const {
    accessibleLabel: uo,
    // eslint-disable-next-line
    children: ho,
    disabled: go,
    enableFilterOnInput: bo = !0,
    endAdornment: vo = {},
    errorMessage: Po,
    filterStartLength: Co = 0,
    gridElement: So,
    handleSearch: wo,
    identifier: Eo = `search-bar-${Math.random().toString(36).substring(2, 9)}`,
    inputBackgroundColor: Ro = "var(--vp-bg-grey-blue)",
    inputBorderStyle: _o = "1px solid var(--vp-border-grey)",
    inputColor: Io = "var(--vp-skyline-blue)",
    noResultsText: Ao = "No matching data.",
    onBlur: Oo,
    onClickResultsItem: jo,
    paginationConfig: Do = {},
    placeholder: Lo,
    results: ko = null,
    resultsItem: Ko = null,
    resultsMessage: No = null,
    searchDelay: Jo = 2e3,
    selectedResult: ti,
    slots: oi = {},
    totalResults: Qo = 0,
    ...Zo
  } = Kt, ei = "This field is required.", [ii, ai] = useState(ti || ""), ri = Do.pagination, [ni, si] = useState(!1), li = (hi) => {
    si(hi.target.value.length === 0 && Zo.required), Oo && Oo(hi);
  }, ui = (hi) => {
    const mi = hi.target.value;
    if (!is_1.string(mi)) {
      log$2.warn("Target element value property is not a string.");
      return;
    }
    si(mi.length === 0 && Zo.required), ai(mi), bo && ci(hi);
  }, ci = c$3((hi) => {
    hi.target.value.length >= Co && fi(hi);
  }, Jo);
  useEffect(() => {
    ii === "" && fi("");
  }, [ii]), useEffect(() => {
    go && ti && si(!1);
  });
  function fi(hi) {
    var bi;
    if (!is_1.function(wo) || !bo) {
      log$2.warn("handleSearch is not a function.");
      return;
    }
    const mi = is_1.undefined((bi = hi == null ? void 0 : hi.target) == null ? void 0 : bi.value) ? ii : hi.target.value;
    wo(mi, hi);
  }
  const yi = (hi) => {
    hi.preventDefault(), ai(""), !is_1.undefined(vo) && !is_1.null(vo) && !is_1.empty(vo) && vo.handleAdornmentClick(hi);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "alc-search-bar",
    {
      class: [(ni || Po) && "errorContainer"].join(" ").replace(/\s+/, " ").trim(),
      "data-testid": "alc-search-bar",
      children: [
        ho && /* @__PURE__ */ jsxRuntimeExports.jsx(
          "label",
          {
            htmlFor: `${Eo}`,
            "aria-labelledby": `${Eo}`,
            className: "search-label",
            title: "Search",
            children: ho
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "inputContainer", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "inputColumn", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            Input$2,
            {
              id: `${Eo}`,
              "aria-label": go ? `Selected ${ti}` : uo ? `Search for ${uo}` : "Search",
              className: "search-input",
              style: {
                border: ni ? "var(--vp-border-error-red)" : _o,
                backgroundColor: ni ? "var(--vp-bg-grey-blue)" : Ro,
                color: ni ? "var(--vp-warning-red)" : Io,
                fontFamily: ni ? "var(--vp-font-open-sans-semibold)" : "var(--vp-font-open-sans)"
              },
              error: ni,
              type: "text",
              title: go ? `Selected ${ti}` : bo && Co > 0 ? `You must type ${Co} characters to start the search` : "",
              endAdornment: !is_1.undefined(vo) && !is_1.empty(vo) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  "aria-label": vo.label,
                  title: vo.title,
                  onClick: yi,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: vo.iconName })
                }
              ) : is_1.empty(ii) ? /* @__PURE__ */ jsxRuntimeExports.jsx(
                "i",
                {
                  id: `search-input-${Eo}`,
                  "aria-hidden": "true",
                  title: "Search Input",
                  className: "fa-regular fa-magnifying-glass"
                }
              ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
                "button",
                {
                  "aria-label": "Delete Input",
                  title: "Remove text",
                  onClick: yi,
                  children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                    "i",
                    {
                      "aria-hidden": "true",
                      className: "fa-solid fa-circle-xmark",
                      style: { color: "var(--vp-action-blue)" }
                    }
                  )
                }
              ),
              onChange: (hi) => ui(hi),
              onBlur: li,
              placeholder: Lo,
              disabled: go,
              value: go ? ti : ii,
              ...Zo
            }
          ),
          Po && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "errorMessage", children: Po }),
          ni && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "errorMessage", children: ei }),
          !(is_1.nil(ko) || is_1.undefined(ko)) && /* @__PURE__ */ jsxRuntimeExports.jsxs(Results, { ...oi.results, children: [
            is_1.array(ko) && !is_1.empty(ko) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs(ResultsTitle, { ...oi.resultsTitle, children: [
                /* @__PURE__ */ jsxRuntimeExports.jsxs(
                  ResultsCount,
                  {
                    ...oi.resultCount,
                    "aria-label": `${Qo} result${Qo > 1 ? "s" : ""}`,
                    children: [
                      Qo,
                      " result",
                      Qo > 1 ? "s." : ".",
                      " "
                    ]
                  }
                ),
                No && /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsMessage, { ...oi.resultsMessage, children: No })
              ] }),
              /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsItems, { ...oi.resultsItems, children: ko.map((hi, mi) => /* @__PURE__ */ createElement(
                ResultsItem,
                {
                  ...oi.resultsItem,
                  className: is_1.undefined(jo) ? "" : "clickable",
                  onClick: () => !is_1.undefined(jo) && jo(hi),
                  onKeyDown: (bi) => {
                    bi.key === "Enter" && (bi.preventDefault(), is_1.undefined(jo) || jo(hi));
                  },
                  key: mi,
                  tabindex: 0
                },
                Ko(hi, mi, ko.length)
              )) })
            ] }),
            is_1.array(ko) && is_1.empty(ko) && /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsMessage, { ...oi.emptyResultsMessage, children: Ao }),
            !is_1.array(ko) && /* @__PURE__ */ jsxRuntimeExports.jsx(ResultsMessage, { ...oi.otherResultsMessage, children: ko }),
            (Do == null ? void 0 : Do.enabled) && is_1.array(ko) && !is_1.empty(ko) && /* @__PURE__ */ jsxRuntimeExports.jsx(
              Pagination,
              {
                firstPage: 1,
                lastPage: ri.lastPage(),
                currentPage: ri.getPage(),
                alignment: (Do == null ? void 0 : Do.alignment) ?? "center",
                onPageChange: (hi, mi) => {
                  mi.preventDefault();
                  const bi = Math.max(
                    ensureIsNumber(Do == null ? void 0 : Do.itemsPerPage, 5),
                    1
                  ), xi = (hi - 1) * bi;
                  ri.goToPage(hi), Do == null || Do.onPageChange(
                    xi,
                    xi + bi,
                    hi
                  );
                },
                pages: ri.getViewport()
              }
            )
          ] }),
          So && So
        ] }) })
      ]
    }
  );
};
SearchBar.propTypes = {
  /**
   * Adds "for xxx" to 'Search' for the aria-label and title on button hover
   */
  accessibleLabel: PropTypes.string,
  /**
   * Whether input is disabled or not (after result is selected)
   */
  disabled: PropTypes.bool,
  /**
   * Whether to initiate the filter/search before clicking the button.
   * Set `filterStartLength` to set the number of characters to start the filter from
   */
  enableFilterOnInput: PropTypes.bool,
  /**
   * Custom end adornment properties if the default should be overriden
   */
  endAdornment: PropTypes.shape({
    handleAdornmentClick: PropTypes.func,
    iconName: PropTypes.string,
    label: PropTypes.string,
    title: PropTypes.string
  }),
  /**
   * The message that should be displayed when there's an error
   */
  errorMessage: PropTypes.string,
  /**
   * The number of characters required to be entered before a filter/search starts
   */
  filterStartLength: PropTypes.number,
  /**
   * Elements to stay inline with the pagination dropdown
   */
  gridElement: PropTypes.node,
  /**
   * Callback to handle click of custom adornment
   */
  handleAdornmentClick: PropTypes.func,
  /**
   * Callback when search button is clicked or when more than the characters
   * defined with 'filterStartLength' are entered in the search bar.
   * The arguments passed to this function are the event's target value and the event itself
   */
  handleSearch: PropTypes.func.isRequired,
  /**
   * Identifier used as the input 'id' and label 'for' attributes.
   * Keeping this optional for the time being but is highly recommended for best UX.
   */
  identifier: PropTypes.string,
  /**
  * Background color of the search input bar
  */
  inputBackgroundColor: PropTypes.string,
  /**
   * Style around the border of the search input bar
   */
  inputBorderStyle: PropTypes.string,
  /**
   * Text color of the search input bar
   */
  inputColor: PropTypes.string,
  /**
   * The text to display if results is an empty array.
   *
   * Only valid if results are provided.
   *
   * Defaults to 'No matching data.'.
   */
  noResultsText: PropTypes.string,
  /**
   * Callback function when state of element changes focus
   */
  onBlur: PropTypes.func,
  /**
   * Callback when a results item is clicked.
   * The argument passed to this function is the item itself
   */
  onClickResultsItem: PropTypes.func,
  /**
   * Adds placeholder in the search bar
   */
  placeholder: PropTypes.string,
  /**
   * Whether the search input field is required or not
   */
  required: PropTypes.bool,
  /**
   * A set of results to display under the search bar.
   */
  results: PropTypes.array,
  /**
   * A function to provide data to render from the results.
   *
   * Required if results are provided.
   */
  resultsItem: PropTypes.func,
  /**
   * A message to display above the results.
   */
  resultsMessage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node
  ]),
  /**
   * Sets the delay in milliseconds for when keyboard input is being
   *
   * Defaults to 2000.
   */
  searchDelay: PropTypes.number,
  /**
   * Passes through selected value after a search
   */
  selectedResult: PropTypes.string,
  /**
   * The total number of results found during the search.
   *
   * Only rendered if results are provided.
   */
  totalResults: PropTypes.number,
  /**
   * Provides to ability to configure the results section of the SearchBar.
   *
   * Each slots entry has the same shape:
   * - element (string): The name of tag to be rendered for the component.
   * - className (string): A space delimited string whose value will be used for the class attribute for the rendered
   * tag. If the className is empty, the class attribute will not be added to the tag.
   * - attributes: An object of extra attributes to be added to the tag. All attribute names will be converted from
   * camel case (ariaLabel) to kebab case (aria-label) before being added to the tag.
   *
   * These are the elements that may be modified:
   * - results: The root container element for the results.
   *   - element defaults to 'alc-search-bar-results'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsTitle: The container for the count and message for results.
   *   - element defaults to 'alc-search-bar-results-title'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsCount: The container for the display of the number of results retrieved.
   *   - element defaults to 'alc-search-bar-results-title-count'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsMessage: The container for the explanatory message shown with the count.
   *   - element defaults to 'alc-search-bar-results-message'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsItems: The container for the displayed results.
   *   - element defaults to 'alc-search-bar-results-list'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsItem: The container for the individual results.
   *   - element defaults to 'alc-search-bar-results-listitem'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsEmptyResultsMessage: The container for the message displayed if there are no results.
   *   - element defaults to 'alc-search-bar-results-message'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   * - resultsOtherResultsMessage: The container for when results is not a list of items, but is also provided something
   * (i.e. A react component to display for loading purposed).
   *   - element defaults to 'alc-search-bar-results-message'.
   *   - classname defaults to empty string.
   *   - attributes defaults to empty object.
   */
  slots: PropTypes.shape({
    results: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsTitle: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsCount: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsMessage: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsItems: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsItem: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsEmptyResultsMessage: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    }),
    resultsOtherResultsMessage: PropTypes.shape({
      element: PropTypes.string,
      className: PropTypes.string,
      attributes: PropTypes.object
    })
  }),
  /**
   * Configuration object for pagination with the following properties:
   * - enabled (boolean): indicates that pagination will be shown when there are results.
   * - viewportSize (number): the number of pages to show in the page bar.
   * - itemsPerPage (number): the number of items to show on each page; helps with determining the number of pages
   * - onPageChange (function): the function to execute when a new page is selected. This function will be provided
   * with the beginning index of the items to display, the end index of the items to display (non-inclusive), and
   * the current page.
   * - alignment (one of: centered, right-aligned, left-aligned): where the pagination
   * - pagination (object | class): expected to be a pagination Interface implementation. This means that the provided
   * property should have the following properties and methods:
   *   - lastPage (function): provides the last page of the pagination
   *   - getPage (function): returns the current page of the pagination
   *   - goToPage (function): sets the viewport to center on the page passed as the first argument
   *   - getViewport (function: returns the list of page numbers to display.
   *   This is normally added using the useClientSideSearch() hook.
   */
  paginationConfig: PropTypes.shape({
    enabled: PropTypes.bool,
    itemsPerPage: PropTypes.number,
    viewportSize: PropTypes.number,
    onPageChange: PropTypes.func,
    alignment: PropTypes.oneOf([
      "centered",
      "right-aligned",
      "left-aligned"
    ]),
    pagination: PropTypes.shape({
      lastPage: PropTypes.func,
      goToPage: PropTypes.func,
      getPage: PropTypes.func,
      getViewport: PropTypes.func
    })
  })
};
const ActionsMenu = (Kt) => {
  const {
    content: uo,
    id: ho = "actionsMenu1",
    isOpen: go,
    menuPlacement: bo,
    menuStyle: vo,
    onToggle: Po,
    summaryText: Co
  } = Kt, So = useRef(null), wo = useRef(null);
  return useEffect(() => {
    const Eo = (Ro) => {
      wo.current && !wo.current.contains(Ro.target) && So.current && !So.current.contains(Ro.target) && Po();
    };
    return go ? document.addEventListener("mousedown", Eo) : document.removeEventListener("mousedown", Eo), () => {
      document.removeEventListener("mousedown", Eo);
    };
  }, [go, Po]), useEffect(() => {
    if (So.current && vo === "menu-size-equal-to-parent") {
      const Eo = document.querySelector(`#listbox-${ho}`);
      Eo && (Eo.style.width = `${So.current.offsetWidth}px`);
    }
  }, [
    So,
    ho,
    go,
    vo
  ]), /* @__PURE__ */ jsxRuntimeExports.jsx("alc-actions-menu", { class: vo, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Dropdown, { open: go, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      MenuButton,
      {
        ref: So,
        onClick: Po,
        children: Co
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Menu$1,
      {
        id: `listbox-${ho}`,
        ref: wo,
        slotProps: {
          root: {
            placement: bo
          }
        },
        anchorel: So.current,
        className: [vo, "menu-container"].join(" ").replace(/\s+/, " ").trim(),
        children: uo
      },
      `listbox-${ho}`
    )
  ] }) });
};
ActionsMenu.propTypes = {
  /**
   * The content that is toggled when summary is clicked
   */
  content: PropTypes.node,
  /**
   * The unique identifier for the dropdown
  */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * Controls whether the Menu content should be visible
   */
  isOpen: PropTypes.bool.isRequired,
  /**
   * Placement of where the dropdown contents should show in relation to the button
   */
  menuPlacement: PropTypes.oneOf([
    "bottom-end",
    "bottom-start",
    "bottom",
    "left-end",
    "left-start",
    "left",
    "right-end",
    "right-start",
    "right",
    "top-end",
    "top-start",
    "top"
  ]),
  /**
   * Changes the styling of the component based on the implementation method selected
   */
  menuStyle: PropTypes.oneOf([
    "menu-bottom-left",
    "icon-button",
    "menu-size-equal-to-parent",
    "nested-menu"
  ]),
  /**
   * Callback fired when the button is clicked
   */
  onToggle: PropTypes.func.isRequired,
  /**
   * The text shown that is clickable that toggles the content
   */
  summaryText: PropTypes.node
};
const Form = (Kt) => {
  const {
    children: uo,
    footer: ho = [],
    footerPlacement: go = "right",
    formTitle: bo,
    title: vo = [],
    titlePlacement: Po = "center"
  } = Kt;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-form", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { "aria-label": bo, children: [
    vo && vo.length !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { style: { justifyContent: Po }, children: vo.map((Co, So) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Co }, So)) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "input-container", children: uo }),
    ho && ho.length !== 0 && /* @__PURE__ */ jsxRuntimeExports.jsx("footer", { style: { justifyContent: go }, "data-testid": "footer", children: ho.map((Co, So) => /* @__PURE__ */ jsxRuntimeExports.jsx(Fragment, { children: Co }, So)) })
  ] }) });
}, styleTypes = [
  "center",
  "start",
  "end",
  "flex-start",
  "flex-end",
  "left",
  "right",
  "normal",
  "space-between",
  "space-around",
  "space-evenly",
  "inherit",
  "initial",
  "revert",
  "revert-layer",
  "unset"
];
Form.propTypes = {
  /**
  * The content passed as children (slots)
  */
  children: PropTypes.node,
  /**
  * Array of elements to place at the bottom of the form
  */
  footer: PropTypes.array,
  /**
  * Position of the footer. Set from an option for the CSS 'justify-content' property
  */
  footerPlacement: PropTypes.oneOf(styleTypes),
  /**
  * Accessible name for the form. Required to expose the element as a landmark region
  */
  formTitle: PropTypes.string.isRequired,
  /**
  * Array of elements to place at the top of the form
  */
  title: PropTypes.array,
  /**
  * Position of the title. Set from an option for the CSS 'justify-content' property
  */
  titlePlacement: PropTypes.oneOf(styleTypes)
};
var isArray$f = Array.isArray, isArray_1 = isArray$f, freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal, _freeGlobal = freeGlobal$1, freeGlobal = _freeGlobal, freeSelf = typeof self == "object" && self && self.Object === Object && self, root$9 = freeGlobal || freeSelf || Function("return this")(), _root = root$9, root$8 = _root, Symbol$7 = root$8.Symbol, _Symbol = Symbol$7, Symbol$6 = _Symbol, objectProto$c = Object.prototype, hasOwnProperty$a = objectProto$c.hasOwnProperty, nativeObjectToString$1 = objectProto$c.toString, symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : void 0;
function getRawTag$1(Kt) {
  var uo = hasOwnProperty$a.call(Kt, symToStringTag$1), ho = Kt[symToStringTag$1];
  try {
    Kt[symToStringTag$1] = void 0;
    var go = !0;
  } catch {
  }
  var bo = nativeObjectToString$1.call(Kt);
  return go && (uo ? Kt[symToStringTag$1] = ho : delete Kt[symToStringTag$1]), bo;
}
var _getRawTag = getRawTag$1, objectProto$b = Object.prototype, nativeObjectToString = objectProto$b.toString;
function objectToString$1(Kt) {
  return nativeObjectToString.call(Kt);
}
var _objectToString = objectToString$1, Symbol$5 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString, nullTag = "[object Null]", undefinedTag = "[object Undefined]", symToStringTag = Symbol$5 ? Symbol$5.toStringTag : void 0;
function baseGetTag$9(Kt) {
  return Kt == null ? Kt === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(Kt) ? getRawTag(Kt) : objectToString(Kt);
}
var _baseGetTag = baseGetTag$9;
function isObjectLike$9(Kt) {
  return Kt != null && typeof Kt == "object";
}
var isObjectLike_1 = isObjectLike$9, baseGetTag$8 = _baseGetTag, isObjectLike$8 = isObjectLike_1, symbolTag$1 = "[object Symbol]";
function isSymbol$6(Kt) {
  return typeof Kt == "symbol" || isObjectLike$8(Kt) && baseGetTag$8(Kt) == symbolTag$1;
}
var isSymbol_1 = isSymbol$6, isArray$e = isArray_1, isSymbol$5 = isSymbol_1, reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$3(Kt, uo) {
  if (isArray$e(Kt))
    return !1;
  var ho = typeof Kt;
  return ho == "number" || ho == "symbol" || ho == "boolean" || Kt == null || isSymbol$5(Kt) ? !0 : reIsPlainProp.test(Kt) || !reIsDeepProp.test(Kt) || uo != null && Kt in Object(uo);
}
var _isKey = isKey$3;
function isObject$7(Kt) {
  var uo = typeof Kt;
  return Kt != null && (uo == "object" || uo == "function");
}
var isObject_1 = isObject$7;
const isObject$8 = /* @__PURE__ */ getDefaultExportFromCjs(isObject_1);
var baseGetTag$7 = _baseGetTag, isObject$6 = isObject_1, asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(Kt) {
  if (!isObject$6(Kt))
    return !1;
  var uo = baseGetTag$7(Kt);
  return uo == funcTag$1 || uo == genTag || uo == asyncTag || uo == proxyTag;
}
var isFunction_1 = isFunction$2;
const isFunction$3 = /* @__PURE__ */ getDefaultExportFromCjs(isFunction_1);
var root$7 = _root, coreJsData$1 = root$7["__core-js_shared__"], _coreJsData = coreJsData$1, coreJsData = _coreJsData, maskSrcKey = function() {
  var Kt = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return Kt ? "Symbol(src)_1." + Kt : "";
}();
function isMasked$1(Kt) {
  return !!maskSrcKey && maskSrcKey in Kt;
}
var _isMasked = isMasked$1, funcProto$2 = Function.prototype, funcToString$2 = funcProto$2.toString;
function toSource$2(Kt) {
  if (Kt != null) {
    try {
      return funcToString$2.call(Kt);
    } catch {
    }
    try {
      return Kt + "";
    } catch {
    }
  }
  return "";
}
var _toSource = toSource$2, isFunction$1 = isFunction_1, isMasked = _isMasked, isObject$5 = isObject_1, toSource$1 = _toSource, reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reIsHostCtor = /^\[object .+?Constructor\]$/, funcProto$1 = Function.prototype, objectProto$a = Object.prototype, funcToString$1 = funcProto$1.toString, hasOwnProperty$9 = objectProto$a.hasOwnProperty, reIsNative = RegExp(
  "^" + funcToString$1.call(hasOwnProperty$9).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(Kt) {
  if (!isObject$5(Kt) || isMasked(Kt))
    return !1;
  var uo = isFunction$1(Kt) ? reIsNative : reIsHostCtor;
  return uo.test(toSource$1(Kt));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(Kt, uo) {
  return Kt == null ? void 0 : Kt[uo];
}
var _getValue = getValue$1, baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$7(Kt, uo) {
  var ho = getValue(Kt, uo);
  return baseIsNative(ho) ? ho : void 0;
}
var _getNative = getNative$7, getNative$6 = _getNative, nativeCreate$4 = getNative$6(Object, "create"), _nativeCreate = nativeCreate$4, nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {}, this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(Kt) {
  var uo = this.has(Kt) && delete this.__data__[Kt];
  return this.size -= uo ? 1 : 0, uo;
}
var _hashDelete = hashDelete$1, nativeCreate$2 = _nativeCreate, HASH_UNDEFINED$2 = "__lodash_hash_undefined__", objectProto$9 = Object.prototype, hasOwnProperty$8 = objectProto$9.hasOwnProperty;
function hashGet$1(Kt) {
  var uo = this.__data__;
  if (nativeCreate$2) {
    var ho = uo[Kt];
    return ho === HASH_UNDEFINED$2 ? void 0 : ho;
  }
  return hasOwnProperty$8.call(uo, Kt) ? uo[Kt] : void 0;
}
var _hashGet = hashGet$1, nativeCreate$1 = _nativeCreate, objectProto$8 = Object.prototype, hasOwnProperty$7 = objectProto$8.hasOwnProperty;
function hashHas$1(Kt) {
  var uo = this.__data__;
  return nativeCreate$1 ? uo[Kt] !== void 0 : hasOwnProperty$7.call(uo, Kt);
}
var _hashHas = hashHas$1, nativeCreate = _nativeCreate, HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(Kt, uo) {
  var ho = this.__data__;
  return this.size += this.has(Kt) ? 0 : 1, ho[Kt] = nativeCreate && uo === void 0 ? HASH_UNDEFINED$1 : uo, this;
}
var _hashSet = hashSet$1, hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(Kt) {
  var uo = -1, ho = Kt == null ? 0 : Kt.length;
  for (this.clear(); ++uo < ho; ) {
    var go = Kt[uo];
    this.set(go[0], go[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype.delete = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
function listCacheClear$1() {
  this.__data__ = [], this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$3(Kt, uo) {
  return Kt === uo || Kt !== Kt && uo !== uo;
}
var eq_1 = eq$3, eq$2 = eq_1;
function assocIndexOf$4(Kt, uo) {
  for (var ho = Kt.length; ho--; )
    if (eq$2(Kt[ho][0], uo))
      return ho;
  return -1;
}
var _assocIndexOf = assocIndexOf$4, assocIndexOf$3 = _assocIndexOf, arrayProto = Array.prototype, splice = arrayProto.splice;
function listCacheDelete$1(Kt) {
  var uo = this.__data__, ho = assocIndexOf$3(uo, Kt);
  if (ho < 0)
    return !1;
  var go = uo.length - 1;
  return ho == go ? uo.pop() : splice.call(uo, ho, 1), --this.size, !0;
}
var _listCacheDelete = listCacheDelete$1, assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(Kt) {
  var uo = this.__data__, ho = assocIndexOf$2(uo, Kt);
  return ho < 0 ? void 0 : uo[ho][1];
}
var _listCacheGet = listCacheGet$1, assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(Kt) {
  return assocIndexOf$1(this.__data__, Kt) > -1;
}
var _listCacheHas = listCacheHas$1, assocIndexOf = _assocIndexOf;
function listCacheSet$1(Kt, uo) {
  var ho = this.__data__, go = assocIndexOf(ho, Kt);
  return go < 0 ? (++this.size, ho.push([Kt, uo])) : ho[go][1] = uo, this;
}
var _listCacheSet = listCacheSet$1, listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(Kt) {
  var uo = -1, ho = Kt == null ? 0 : Kt.length;
  for (this.clear(); ++uo < ho; ) {
    var go = Kt[uo];
    this.set(go[0], go[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype.delete = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4, getNative$5 = _getNative, root$6 = _root, Map$4 = getNative$5(root$6, "Map"), _Map = Map$4, Hash = _Hash, ListCache$3 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0, this.__data__ = {
    hash: new Hash(),
    map: new (Map$3 || ListCache$3)(),
    string: new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(Kt) {
  var uo = typeof Kt;
  return uo == "string" || uo == "number" || uo == "symbol" || uo == "boolean" ? Kt !== "__proto__" : Kt === null;
}
var _isKeyable = isKeyable$1, isKeyable = _isKeyable;
function getMapData$4(Kt, uo) {
  var ho = Kt.__data__;
  return isKeyable(uo) ? ho[typeof uo == "string" ? "string" : "hash"] : ho.map;
}
var _getMapData = getMapData$4, getMapData$3 = _getMapData;
function mapCacheDelete$1(Kt) {
  var uo = getMapData$3(this, Kt).delete(Kt);
  return this.size -= uo ? 1 : 0, uo;
}
var _mapCacheDelete = mapCacheDelete$1, getMapData$2 = _getMapData;
function mapCacheGet$1(Kt) {
  return getMapData$2(this, Kt).get(Kt);
}
var _mapCacheGet = mapCacheGet$1, getMapData$1 = _getMapData;
function mapCacheHas$1(Kt) {
  return getMapData$1(this, Kt).has(Kt);
}
var _mapCacheHas = mapCacheHas$1, getMapData = _getMapData;
function mapCacheSet$1(Kt, uo) {
  var ho = getMapData(this, Kt), go = ho.size;
  return ho.set(Kt, uo), this.size += ho.size == go ? 0 : 1, this;
}
var _mapCacheSet = mapCacheSet$1, mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$3(Kt) {
  var uo = -1, ho = Kt == null ? 0 : Kt.length;
  for (this.clear(); ++uo < ho; ) {
    var go = Kt[uo];
    this.set(go[0], go[1]);
  }
}
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype.delete = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;
var _MapCache = MapCache$3, MapCache$2 = _MapCache, FUNC_ERROR_TEXT$2 = "Expected a function";
function memoize$2(Kt, uo) {
  if (typeof Kt != "function" || uo != null && typeof uo != "function")
    throw new TypeError(FUNC_ERROR_TEXT$2);
  var ho = function() {
    var go = arguments, bo = uo ? uo.apply(this, go) : go[0], vo = ho.cache;
    if (vo.has(bo))
      return vo.get(bo);
    var Po = Kt.apply(this, go);
    return ho.cache = vo.set(bo, Po) || vo, Po;
  };
  return ho.cache = new (memoize$2.Cache || MapCache$2)(), ho;
}
memoize$2.Cache = MapCache$2;
var memoize_1 = memoize$2;
const memoize$3 = /* @__PURE__ */ getDefaultExportFromCjs(memoize_1);
var memoize$1 = memoize_1, MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(Kt) {
  var uo = memoize$1(Kt, function(go) {
    return ho.size === MAX_MEMOIZE_SIZE && ho.clear(), go;
  }), ho = uo.cache;
  return uo;
}
var _memoizeCapped = memoizeCapped$1, memoizeCapped = _memoizeCapped, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, reEscapeChar = /\\(\\)?/g, stringToPath$1 = memoizeCapped(function(Kt) {
  var uo = [];
  return Kt.charCodeAt(0) === 46 && uo.push(""), Kt.replace(rePropName, function(ho, go, bo, vo) {
    uo.push(bo ? vo.replace(reEscapeChar, "$1") : go || ho);
  }), uo;
}), _stringToPath = stringToPath$1;
function arrayMap$3(Kt, uo) {
  for (var ho = -1, go = Kt == null ? 0 : Kt.length, bo = Array(go); ++ho < go; )
    bo[ho] = uo(Kt[ho], ho, Kt);
  return bo;
}
var _arrayMap = arrayMap$3, Symbol$4 = _Symbol, arrayMap$2 = _arrayMap, isArray$d = isArray_1, isSymbol$4 = isSymbol_1, INFINITY$3 = 1 / 0, symbolProto$1 = Symbol$4 ? Symbol$4.prototype : void 0, symbolToString = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$1(Kt) {
  if (typeof Kt == "string")
    return Kt;
  if (isArray$d(Kt))
    return arrayMap$2(Kt, baseToString$1) + "";
  if (isSymbol$4(Kt))
    return symbolToString ? symbolToString.call(Kt) : "";
  var uo = Kt + "";
  return uo == "0" && 1 / Kt == -INFINITY$3 ? "-0" : uo;
}
var _baseToString = baseToString$1, baseToString = _baseToString;
function toString$3(Kt) {
  return Kt == null ? "" : baseToString(Kt);
}
var toString_1 = toString$3, isArray$c = isArray_1, isKey$2 = _isKey, stringToPath = _stringToPath, toString$2 = toString_1;
function castPath$2(Kt, uo) {
  return isArray$c(Kt) ? Kt : isKey$2(Kt, uo) ? [Kt] : stringToPath(toString$2(Kt));
}
var _castPath = castPath$2, isSymbol$3 = isSymbol_1, INFINITY$2 = 1 / 0;
function toKey$4(Kt) {
  if (typeof Kt == "string" || isSymbol$3(Kt))
    return Kt;
  var uo = Kt + "";
  return uo == "0" && 1 / Kt == -INFINITY$2 ? "-0" : uo;
}
var _toKey = toKey$4, castPath$1 = _castPath, toKey$3 = _toKey;
function baseGet$3(Kt, uo) {
  uo = castPath$1(uo, Kt);
  for (var ho = 0, go = uo.length; Kt != null && ho < go; )
    Kt = Kt[toKey$3(uo[ho++])];
  return ho && ho == go ? Kt : void 0;
}
var _baseGet = baseGet$3, baseGet$2 = _baseGet;
function get$1(Kt, uo, ho) {
  var go = Kt == null ? void 0 : baseGet$2(Kt, uo);
  return go === void 0 ? ho : go;
}
var get_1 = get$1;
const get$2 = /* @__PURE__ */ getDefaultExportFromCjs(get_1);
function isNil(Kt) {
  return Kt == null;
}
var isNil_1 = isNil;
const isNil$1 = /* @__PURE__ */ getDefaultExportFromCjs(isNil_1);
var baseGetTag$6 = _baseGetTag, isArray$b = isArray_1, isObjectLike$7 = isObjectLike_1, stringTag$2 = "[object String]";
function isString(Kt) {
  return typeof Kt == "string" || !isArray$b(Kt) && isObjectLike$7(Kt) && baseGetTag$6(Kt) == stringTag$2;
}
var isString_1 = isString;
const isString$1 = /* @__PURE__ */ getDefaultExportFromCjs(isString_1);
var reactIs = { exports: {} }, reactIs_production_min = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_production_min;
function requireReactIs_production_min() {
  if (hasRequiredReactIs_production_min) return reactIs_production_min;
  hasRequiredReactIs_production_min = 1;
  var Kt = Symbol.for("react.element"), uo = Symbol.for("react.portal"), ho = Symbol.for("react.fragment"), go = Symbol.for("react.strict_mode"), bo = Symbol.for("react.profiler"), vo = Symbol.for("react.provider"), Po = Symbol.for("react.context"), Co = Symbol.for("react.server_context"), So = Symbol.for("react.forward_ref"), wo = Symbol.for("react.suspense"), Eo = Symbol.for("react.suspense_list"), Ro = Symbol.for("react.memo"), _o = Symbol.for("react.lazy"), Io = Symbol.for("react.offscreen"), Ao;
  Ao = Symbol.for("react.module.reference");
  function Oo(jo) {
    if (typeof jo == "object" && jo !== null) {
      var Do = jo.$$typeof;
      switch (Do) {
        case Kt:
          switch (jo = jo.type, jo) {
            case ho:
            case bo:
            case go:
            case wo:
            case Eo:
              return jo;
            default:
              switch (jo = jo && jo.$$typeof, jo) {
                case Co:
                case Po:
                case So:
                case _o:
                case Ro:
                case vo:
                  return jo;
                default:
                  return Do;
              }
          }
        case uo:
          return Do;
      }
    }
  }
  return reactIs_production_min.ContextConsumer = Po, reactIs_production_min.ContextProvider = vo, reactIs_production_min.Element = Kt, reactIs_production_min.ForwardRef = So, reactIs_production_min.Fragment = ho, reactIs_production_min.Lazy = _o, reactIs_production_min.Memo = Ro, reactIs_production_min.Portal = uo, reactIs_production_min.Profiler = bo, reactIs_production_min.StrictMode = go, reactIs_production_min.Suspense = wo, reactIs_production_min.SuspenseList = Eo, reactIs_production_min.isAsyncMode = function() {
    return !1;
  }, reactIs_production_min.isConcurrentMode = function() {
    return !1;
  }, reactIs_production_min.isContextConsumer = function(jo) {
    return Oo(jo) === Po;
  }, reactIs_production_min.isContextProvider = function(jo) {
    return Oo(jo) === vo;
  }, reactIs_production_min.isElement = function(jo) {
    return typeof jo == "object" && jo !== null && jo.$$typeof === Kt;
  }, reactIs_production_min.isForwardRef = function(jo) {
    return Oo(jo) === So;
  }, reactIs_production_min.isFragment = function(jo) {
    return Oo(jo) === ho;
  }, reactIs_production_min.isLazy = function(jo) {
    return Oo(jo) === _o;
  }, reactIs_production_min.isMemo = function(jo) {
    return Oo(jo) === Ro;
  }, reactIs_production_min.isPortal = function(jo) {
    return Oo(jo) === uo;
  }, reactIs_production_min.isProfiler = function(jo) {
    return Oo(jo) === bo;
  }, reactIs_production_min.isStrictMode = function(jo) {
    return Oo(jo) === go;
  }, reactIs_production_min.isSuspense = function(jo) {
    return Oo(jo) === wo;
  }, reactIs_production_min.isSuspenseList = function(jo) {
    return Oo(jo) === Eo;
  }, reactIs_production_min.isValidElementType = function(jo) {
    return typeof jo == "string" || typeof jo == "function" || jo === ho || jo === bo || jo === go || jo === wo || jo === Eo || jo === Io || typeof jo == "object" && jo !== null && (jo.$$typeof === _o || jo.$$typeof === Ro || jo.$$typeof === vo || jo.$$typeof === Po || jo.$$typeof === So || jo.$$typeof === Ao || jo.getModuleId !== void 0);
  }, reactIs_production_min.typeOf = Oo, reactIs_production_min;
}
var reactIs_development = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hasRequiredReactIs_development;
function requireReactIs_development() {
  return hasRequiredReactIs_development || (hasRequiredReactIs_development = 1, process.env.NODE_ENV !== "production" && function() {
    var Kt = Symbol.for("react.element"), uo = Symbol.for("react.portal"), ho = Symbol.for("react.fragment"), go = Symbol.for("react.strict_mode"), bo = Symbol.for("react.profiler"), vo = Symbol.for("react.provider"), Po = Symbol.for("react.context"), Co = Symbol.for("react.server_context"), So = Symbol.for("react.forward_ref"), wo = Symbol.for("react.suspense"), Eo = Symbol.for("react.suspense_list"), Ro = Symbol.for("react.memo"), _o = Symbol.for("react.lazy"), Io = Symbol.for("react.offscreen"), Ao = !1, Oo = !1, jo = !1, Do = !1, Lo = !1, ko;
    ko = Symbol.for("react.module.reference");
    function Ko(Ei) {
      return !!(typeof Ei == "string" || typeof Ei == "function" || Ei === ho || Ei === bo || Lo || Ei === go || Ei === wo || Ei === Eo || Do || Ei === Io || Ao || Oo || jo || typeof Ei == "object" && Ei !== null && (Ei.$$typeof === _o || Ei.$$typeof === Ro || Ei.$$typeof === vo || Ei.$$typeof === Po || Ei.$$typeof === So || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      Ei.$$typeof === ko || Ei.getModuleId !== void 0));
    }
    function No(Ei) {
      if (typeof Ei == "object" && Ei !== null) {
        var Ni = Ei.$$typeof;
        switch (Ni) {
          case Kt:
            var Ai = Ei.type;
            switch (Ai) {
              case ho:
              case bo:
              case go:
              case wo:
              case Eo:
                return Ai;
              default:
                var Yi = Ai && Ai.$$typeof;
                switch (Yi) {
                  case Co:
                  case Po:
                  case So:
                  case _o:
                  case Ro:
                  case vo:
                    return Yi;
                  default:
                    return Ni;
                }
            }
          case uo:
            return Ni;
        }
      }
    }
    var Jo = Po, ti = vo, oi = Kt, Qo = So, Zo = ho, ei = _o, ii = Ro, ai = uo, ri = bo, ni = go, si = wo, li = Eo, ui = !1, ci = !1;
    function fi(Ei) {
      return ui || (ui = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function yi(Ei) {
      return ci || (ci = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function hi(Ei) {
      return No(Ei) === Po;
    }
    function mi(Ei) {
      return No(Ei) === vo;
    }
    function bi(Ei) {
      return typeof Ei == "object" && Ei !== null && Ei.$$typeof === Kt;
    }
    function xi(Ei) {
      return No(Ei) === So;
    }
    function $i(Ei) {
      return No(Ei) === ho;
    }
    function Ci(Ei) {
      return No(Ei) === _o;
    }
    function Si(Ei) {
      return No(Ei) === Ro;
    }
    function vi(Ei) {
      return No(Ei) === uo;
    }
    function Pi(Ei) {
      return No(Ei) === bo;
    }
    function wi(Ei) {
      return No(Ei) === go;
    }
    function gi(Ei) {
      return No(Ei) === wo;
    }
    function Ri(Ei) {
      return No(Ei) === Eo;
    }
    reactIs_development.ContextConsumer = Jo, reactIs_development.ContextProvider = ti, reactIs_development.Element = oi, reactIs_development.ForwardRef = Qo, reactIs_development.Fragment = Zo, reactIs_development.Lazy = ei, reactIs_development.Memo = ii, reactIs_development.Portal = ai, reactIs_development.Profiler = ri, reactIs_development.StrictMode = ni, reactIs_development.Suspense = si, reactIs_development.SuspenseList = li, reactIs_development.isAsyncMode = fi, reactIs_development.isConcurrentMode = yi, reactIs_development.isContextConsumer = hi, reactIs_development.isContextProvider = mi, reactIs_development.isElement = bi, reactIs_development.isForwardRef = xi, reactIs_development.isFragment = $i, reactIs_development.isLazy = Ci, reactIs_development.isMemo = Si, reactIs_development.isPortal = vi, reactIs_development.isProfiler = Pi, reactIs_development.isStrictMode = wi, reactIs_development.isSuspense = gi, reactIs_development.isSuspenseList = Ri, reactIs_development.isValidElementType = Ko, reactIs_development.typeOf = No;
  }()), reactIs_development;
}
process.env.NODE_ENV === "production" ? reactIs.exports = requireReactIs_production_min() : reactIs.exports = requireReactIs_development();
var reactIsExports = reactIs.exports, baseGetTag$5 = _baseGetTag, isObjectLike$6 = isObjectLike_1, numberTag$2 = "[object Number]";
function isNumber$2(Kt) {
  return typeof Kt == "number" || isObjectLike$6(Kt) && baseGetTag$5(Kt) == numberTag$2;
}
var isNumber_1 = isNumber$2;
const isNumber$3 = /* @__PURE__ */ getDefaultExportFromCjs(isNumber_1);
var isNumber$1 = isNumber_1;
function isNaN$1(Kt) {
  return isNumber$1(Kt) && Kt != +Kt;
}
var _isNaN = isNaN$1;
const isNan = /* @__PURE__ */ getDefaultExportFromCjs(_isNaN);
var mathSign = function(uo) {
  return uo === 0 ? 0 : uo > 0 ? 1 : -1;
}, isPercent = function(uo) {
  return isString$1(uo) && uo.indexOf("%") === uo.length - 1;
}, isNumber = function(uo) {
  return isNumber$3(uo) && !isNan(uo);
}, isNumOrStr = function(uo) {
  return isNumber(uo) || isString$1(uo);
}, idCounter = 0, uniqueId = function(uo) {
  var ho = ++idCounter;
  return "".concat(uo || "").concat(ho);
}, getPercentValue = function(uo, ho) {
  var go = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, bo = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!isNumber(uo) && !isString$1(uo))
    return go;
  var vo;
  if (isPercent(uo)) {
    var Po = uo.indexOf("%");
    vo = ho * parseFloat(uo.slice(0, Po)) / 100;
  } else
    vo = +uo;
  return isNan(vo) && (vo = go), bo && vo > ho && (vo = ho), vo;
}, getAnyElementOfObject = function(uo) {
  if (!uo)
    return null;
  var ho = Object.keys(uo);
  return ho && ho.length ? uo[ho[0]] : null;
}, hasDuplicate = function(uo) {
  if (!Array.isArray(uo))
    return !1;
  for (var ho = uo.length, go = {}, bo = 0; bo < ho; bo++)
    if (!go[uo[bo]])
      go[uo[bo]] = !0;
    else
      return !0;
  return !1;
}, interpolateNumber$2 = function(uo, ho) {
  return isNumber(uo) && isNumber(ho) ? function(go) {
    return uo + go * (ho - uo);
  } : function() {
    return ho;
  };
};
function findEntryInArray(Kt, uo, ho) {
  return !Kt || !Kt.length ? null : Kt.find(function(go) {
    return go && (typeof uo == "function" ? uo(go) : get$2(go, uo)) === ho;
  });
}
function shallowEqual(Kt, uo) {
  for (var ho in Kt)
    if ({}.hasOwnProperty.call(Kt, ho) && (!{}.hasOwnProperty.call(uo, ho) || Kt[ho] !== uo[ho]))
      return !1;
  for (var go in uo)
    if ({}.hasOwnProperty.call(uo, go) && !{}.hasOwnProperty.call(Kt, go))
      return !1;
  return !0;
}
function _typeof$H(Kt) {
  "@babel/helpers - typeof";
  return _typeof$H = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$H(Kt);
}
var SVGContainerPropKeys = ["viewBox", "children"], SVGElementPropKeys = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], PolyElementKeys = ["points", "pathLength"], FilteredElementKeyMap = {
  svg: SVGContainerPropKeys,
  polygon: PolyElementKeys,
  polyline: PolyElementKeys
}, EventKeys = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], adaptEventHandlers = function(uo, ho) {
  if (!uo || typeof uo == "function" || typeof uo == "boolean")
    return null;
  var go = uo;
  if (/* @__PURE__ */ isValidElement(uo) && (go = uo.props), !isObject$8(go))
    return null;
  var bo = {};
  return Object.keys(go).forEach(function(vo) {
    EventKeys.includes(vo) && (bo[vo] = ho || function(Po) {
      return go[vo](go, Po);
    });
  }), bo;
}, getEventHandlerOfChild = function(uo, ho, go) {
  return function(bo) {
    return uo(ho, go, bo), null;
  };
}, adaptEventsOfChild = function(uo, ho, go) {
  if (!isObject$8(uo) || _typeof$H(uo) !== "object")
    return null;
  var bo = null;
  return Object.keys(uo).forEach(function(vo) {
    var Po = uo[vo];
    EventKeys.includes(vo) && typeof Po == "function" && (bo || (bo = {}), bo[vo] = getEventHandlerOfChild(Po, ho, go));
  }), bo;
}, _excluded$g = ["children"], _excluded2$5 = ["children"];
function _objectWithoutProperties$g(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$g(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$g(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
var REACT_BROWSER_EVENT_MAP = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, getDisplayName = function(uo) {
  return typeof uo == "string" ? uo : uo ? uo.displayName || uo.name || "Component" : "";
}, lastChildren = null, lastResult = null, toArray = function Kt(uo) {
  if (uo === lastChildren && Array.isArray(lastResult))
    return lastResult;
  var ho = [];
  return Children.forEach(uo, function(go) {
    isNil$1(go) || (reactIsExports.isFragment(go) ? ho = ho.concat(Kt(go.props.children)) : ho.push(go));
  }), lastResult = ho, lastChildren = uo, ho;
};
function findAllByType(Kt, uo) {
  var ho = [], go = [];
  return Array.isArray(uo) ? go = uo.map(function(bo) {
    return getDisplayName(bo);
  }) : go = [getDisplayName(uo)], toArray(Kt).forEach(function(bo) {
    var vo = get$2(bo, "type.displayName") || get$2(bo, "type.name");
    go.indexOf(vo) !== -1 && ho.push(bo);
  }), ho;
}
function findChildByType(Kt, uo) {
  var ho = findAllByType(Kt, uo);
  return ho[0];
}
var validateWidthHeight = function(uo) {
  if (!uo || !uo.props)
    return !1;
  var ho = uo.props, go = ho.width, bo = ho.height;
  return !(!isNumber(go) || go <= 0 || !isNumber(bo) || bo <= 0);
}, SVG_TAGS = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], isSvgElement = function(uo) {
  return uo && uo.type && isString$1(uo.type) && SVG_TAGS.indexOf(uo.type) >= 0;
}, isValidSpreadableProp = function(uo, ho, go, bo) {
  var vo, Po = (vo = FilteredElementKeyMap == null ? void 0 : FilteredElementKeyMap[bo]) !== null && vo !== void 0 ? vo : [];
  return !isFunction$3(uo) && (bo && Po.includes(ho) || SVGElementPropKeys.includes(ho)) || go && EventKeys.includes(ho);
}, filterProps = function(uo, ho, go) {
  if (!uo || typeof uo == "function" || typeof uo == "boolean")
    return null;
  var bo = uo;
  if (/* @__PURE__ */ isValidElement(uo) && (bo = uo.props), !isObject$8(bo))
    return null;
  var vo = {};
  return Object.keys(bo).forEach(function(Po) {
    var Co;
    isValidSpreadableProp((Co = bo) === null || Co === void 0 ? void 0 : Co[Po], Po, ho, go) && (vo[Po] = bo[Po]);
  }), vo;
}, isChildrenEqual = function Kt(uo, ho) {
  if (uo === ho)
    return !0;
  var go = Children.count(uo);
  if (go !== Children.count(ho))
    return !1;
  if (go === 0)
    return !0;
  if (go === 1)
    return isSingleChildEqual(Array.isArray(uo) ? uo[0] : uo, Array.isArray(ho) ? ho[0] : ho);
  for (var bo = 0; bo < go; bo++) {
    var vo = uo[bo], Po = ho[bo];
    if (Array.isArray(vo) || Array.isArray(Po)) {
      if (!Kt(vo, Po))
        return !1;
    } else if (!isSingleChildEqual(vo, Po))
      return !1;
  }
  return !0;
}, isSingleChildEqual = function(uo, ho) {
  if (isNil$1(uo) && isNil$1(ho))
    return !0;
  if (!isNil$1(uo) && !isNil$1(ho)) {
    var go = uo.props || {}, bo = go.children, vo = _objectWithoutProperties$g(go, _excluded$g), Po = ho.props || {}, Co = Po.children, So = _objectWithoutProperties$g(Po, _excluded2$5);
    return bo && Co ? shallowEqual(vo, So) && isChildrenEqual(bo, Co) : !bo && !Co ? shallowEqual(vo, So) : !1;
  }
  return !1;
}, renderByOrder = function(uo, ho) {
  var go = [], bo = {};
  return toArray(uo).forEach(function(vo, Po) {
    if (isSvgElement(vo))
      go.push(vo);
    else if (vo) {
      var Co = getDisplayName(vo.type), So = ho[Co] || {}, wo = So.handler, Eo = So.once;
      if (wo && (!Eo || !bo[Co])) {
        var Ro = wo(vo, Co, Po);
        go.push(Ro), bo[Co] = !0;
      }
    }
  }), go;
}, getReactEventByType = function(uo) {
  var ho = uo && uo.type;
  return ho && REACT_BROWSER_EVENT_MAP[ho] ? REACT_BROWSER_EVENT_MAP[ho] : null;
}, parseChildIndex = function(uo, ho) {
  return toArray(ho).indexOf(uo);
}, _excluded$f = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function _extends$p() {
  return _extends$p = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$p.apply(this, arguments);
}
function _objectWithoutProperties$f(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$f(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$f(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function Surface(Kt) {
  var uo = Kt.children, ho = Kt.width, go = Kt.height, bo = Kt.viewBox, vo = Kt.className, Po = Kt.style, Co = Kt.title, So = Kt.desc, wo = _objectWithoutProperties$f(Kt, _excluded$f), Eo = bo || {
    width: ho,
    height: go,
    x: 0,
    y: 0
  }, Ro = clsx("recharts-surface", vo);
  return /* @__PURE__ */ React__default.createElement("svg", _extends$p({}, filterProps(wo, !0, "svg"), {
    className: Ro,
    width: ho,
    height: go,
    style: Po,
    viewBox: "".concat(Eo.x, " ").concat(Eo.y, " ").concat(Eo.width, " ").concat(Eo.height)
  }), /* @__PURE__ */ React__default.createElement("title", null, Co), /* @__PURE__ */ React__default.createElement("desc", null, So), uo);
}
var _excluded$e = ["children", "className"];
function _extends$o() {
  return _extends$o = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$o.apply(this, arguments);
}
function _objectWithoutProperties$e(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$e(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$e(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
var Layer = /* @__PURE__ */ React__default.forwardRef(function(Kt, uo) {
  var ho = Kt.children, go = Kt.className, bo = _objectWithoutProperties$e(Kt, _excluded$e), vo = clsx("recharts-layer", go);
  return /* @__PURE__ */ React__default.createElement("g", _extends$o({
    className: vo
  }, filterProps(bo, !0), {
    ref: uo
  }), ho);
}), isDev$1 = process.env.NODE_ENV !== "production", warn$1 = function(uo, ho) {
  for (var go = arguments.length, bo = new Array(go > 2 ? go - 2 : 0), vo = 2; vo < go; vo++)
    bo[vo - 2] = arguments[vo];
  if (isDev$1 && typeof console < "u" && console.warn && (ho === void 0 && console.warn("LogUtils requires an error message argument"), !uo))
    if (ho === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var Po = 0;
      console.warn(ho.replace(/%s/g, function() {
        return bo[Po++];
      }));
    }
};
function baseSlice$1(Kt, uo, ho) {
  var go = -1, bo = Kt.length;
  uo < 0 && (uo = -uo > bo ? 0 : bo + uo), ho = ho > bo ? bo : ho, ho < 0 && (ho += bo), bo = uo > ho ? 0 : ho - uo >>> 0, uo >>>= 0;
  for (var vo = Array(bo); ++go < bo; )
    vo[go] = Kt[go + uo];
  return vo;
}
var _baseSlice = baseSlice$1, baseSlice = _baseSlice;
function castSlice$1(Kt, uo, ho) {
  var go = Kt.length;
  return ho = ho === void 0 ? go : ho, !uo && ho >= go ? Kt : baseSlice(Kt, uo, ho);
}
var _castSlice = castSlice$1, rsAstralRange$1 = "\\ud800-\\udfff", rsComboMarksRange$1 = "\\u0300-\\u036f", reComboHalfMarksRange$1 = "\\ufe20-\\ufe2f", rsComboSymbolsRange$1 = "\\u20d0-\\u20ff", rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1, rsVarRange$1 = "\\ufe0e\\ufe0f", rsZWJ$1 = "\\u200d", reHasUnicode = RegExp("[" + rsZWJ$1 + rsAstralRange$1 + rsComboRange$1 + rsVarRange$1 + "]");
function hasUnicode$2(Kt) {
  return reHasUnicode.test(Kt);
}
var _hasUnicode = hasUnicode$2;
function asciiToArray$1(Kt) {
  return Kt.split("");
}
var _asciiToArray = asciiToArray$1, rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsVarRange = "\\ufe0e\\ufe0f", rsAstral = "[" + rsAstralRange + "]", rsCombo = "[" + rsComboRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsZWJ = "\\u200d", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")", reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
function unicodeToArray$1(Kt) {
  return Kt.match(reUnicode) || [];
}
var _unicodeToArray = unicodeToArray$1, asciiToArray = _asciiToArray, hasUnicode$1 = _hasUnicode, unicodeToArray = _unicodeToArray;
function stringToArray$1(Kt) {
  return hasUnicode$1(Kt) ? unicodeToArray(Kt) : asciiToArray(Kt);
}
var _stringToArray = stringToArray$1, castSlice = _castSlice, hasUnicode = _hasUnicode, stringToArray = _stringToArray, toString$1 = toString_1;
function createCaseFirst$1(Kt) {
  return function(uo) {
    uo = toString$1(uo);
    var ho = hasUnicode(uo) ? stringToArray(uo) : void 0, go = ho ? ho[0] : uo.charAt(0), bo = ho ? castSlice(ho, 1).join("") : uo.slice(1);
    return go[Kt]() + bo;
  };
}
var _createCaseFirst = createCaseFirst$1, createCaseFirst = _createCaseFirst, upperFirst = createCaseFirst("toUpperCase"), upperFirst_1 = upperFirst;
const upperFirst$1 = /* @__PURE__ */ getDefaultExportFromCjs(upperFirst_1);
function constant$3(Kt) {
  return function() {
    return Kt;
  };
}
const cos = Math.cos, sin = Math.sin, sqrt$1 = Math.sqrt, pi$2 = Math.PI, tau$1 = 2 * pi$2, pi$1 = Math.PI, tau = 2 * pi$1, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function append(Kt) {
  this._ += Kt[0];
  for (let uo = 1, ho = Kt.length; uo < ho; ++uo)
    this._ += arguments[uo] + Kt[uo];
}
function appendRound(Kt) {
  let uo = Math.floor(Kt);
  if (!(uo >= 0)) throw new Error(`invalid digits: ${Kt}`);
  if (uo > 15) return append;
  const ho = 10 ** uo;
  return function(go) {
    this._ += go[0];
    for (let bo = 1, vo = go.length; bo < vo; ++bo)
      this._ += Math.round(arguments[bo] * ho) / ho + go[bo];
  };
}
class Path {
  constructor(uo) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = uo == null ? append : appendRound(uo);
  }
  moveTo(uo, ho) {
    this._append`M${this._x0 = this._x1 = +uo},${this._y0 = this._y1 = +ho}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(uo, ho) {
    this._append`L${this._x1 = +uo},${this._y1 = +ho}`;
  }
  quadraticCurveTo(uo, ho, go, bo) {
    this._append`Q${+uo},${+ho},${this._x1 = +go},${this._y1 = +bo}`;
  }
  bezierCurveTo(uo, ho, go, bo, vo, Po) {
    this._append`C${+uo},${+ho},${+go},${+bo},${this._x1 = +vo},${this._y1 = +Po}`;
  }
  arcTo(uo, ho, go, bo, vo) {
    if (uo = +uo, ho = +ho, go = +go, bo = +bo, vo = +vo, vo < 0) throw new Error(`negative radius: ${vo}`);
    let Po = this._x1, Co = this._y1, So = go - uo, wo = bo - ho, Eo = Po - uo, Ro = Co - ho, _o = Eo * Eo + Ro * Ro;
    if (this._x1 === null)
      this._append`M${this._x1 = uo},${this._y1 = ho}`;
    else if (_o > epsilon) if (!(Math.abs(Ro * So - wo * Eo) > epsilon) || !vo)
      this._append`L${this._x1 = uo},${this._y1 = ho}`;
    else {
      let Io = go - Po, Ao = bo - Co, Oo = So * So + wo * wo, jo = Io * Io + Ao * Ao, Do = Math.sqrt(Oo), Lo = Math.sqrt(_o), ko = vo * Math.tan((pi$1 - Math.acos((Oo + _o - jo) / (2 * Do * Lo))) / 2), Ko = ko / Lo, No = ko / Do;
      Math.abs(Ko - 1) > epsilon && this._append`L${uo + Ko * Eo},${ho + Ko * Ro}`, this._append`A${vo},${vo},0,0,${+(Ro * Io > Eo * Ao)},${this._x1 = uo + No * So},${this._y1 = ho + No * wo}`;
    }
  }
  arc(uo, ho, go, bo, vo, Po) {
    if (uo = +uo, ho = +ho, go = +go, Po = !!Po, go < 0) throw new Error(`negative radius: ${go}`);
    let Co = go * Math.cos(bo), So = go * Math.sin(bo), wo = uo + Co, Eo = ho + So, Ro = 1 ^ Po, _o = Po ? bo - vo : vo - bo;
    this._x1 === null ? this._append`M${wo},${Eo}` : (Math.abs(this._x1 - wo) > epsilon || Math.abs(this._y1 - Eo) > epsilon) && this._append`L${wo},${Eo}`, go && (_o < 0 && (_o = _o % tau + tau), _o > tauEpsilon ? this._append`A${go},${go},0,1,${Ro},${uo - Co},${ho - So}A${go},${go},0,1,${Ro},${this._x1 = wo},${this._y1 = Eo}` : _o > epsilon && this._append`A${go},${go},0,${+(_o >= pi$1)},${Ro},${this._x1 = uo + go * Math.cos(vo)},${this._y1 = ho + go * Math.sin(vo)}`);
  }
  rect(uo, ho, go, bo) {
    this._append`M${this._x0 = this._x1 = +uo},${this._y0 = this._y1 = +ho}h${go = +go}v${+bo}h${-go}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(Kt) {
  let uo = 3;
  return Kt.digits = function(ho) {
    if (!arguments.length) return uo;
    if (ho == null)
      uo = null;
    else {
      const go = Math.floor(ho);
      if (!(go >= 0)) throw new RangeError(`invalid digits: ${ho}`);
      uo = go;
    }
    return Kt;
  }, () => new Path(uo);
}
function array(Kt) {
  return typeof Kt == "object" && "length" in Kt ? Kt : Array.from(Kt);
}
function Linear(Kt) {
  this._context = Kt;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(Kt, uo) {
    switch (Kt = +Kt, uo = +uo, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(Kt, uo) : this._context.moveTo(Kt, uo);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(Kt, uo);
        break;
    }
  }
};
function curveLinear(Kt) {
  return new Linear(Kt);
}
function x$4(Kt) {
  return Kt[0];
}
function y$2(Kt) {
  return Kt[1];
}
function shapeLine(Kt, uo) {
  var ho = constant$3(!0), go = null, bo = curveLinear, vo = null, Po = withPath(Co);
  Kt = typeof Kt == "function" ? Kt : Kt === void 0 ? x$4 : constant$3(Kt), uo = typeof uo == "function" ? uo : uo === void 0 ? y$2 : constant$3(uo);
  function Co(So) {
    var wo, Eo = (So = array(So)).length, Ro, _o = !1, Io;
    for (go == null && (vo = bo(Io = Po())), wo = 0; wo <= Eo; ++wo)
      !(wo < Eo && ho(Ro = So[wo], wo, So)) === _o && ((_o = !_o) ? vo.lineStart() : vo.lineEnd()), _o && vo.point(+Kt(Ro, wo, So), +uo(Ro, wo, So));
    if (Io) return vo = null, Io + "" || null;
  }
  return Co.x = function(So) {
    return arguments.length ? (Kt = typeof So == "function" ? So : constant$3(+So), Co) : Kt;
  }, Co.y = function(So) {
    return arguments.length ? (uo = typeof So == "function" ? So : constant$3(+So), Co) : uo;
  }, Co.defined = function(So) {
    return arguments.length ? (ho = typeof So == "function" ? So : constant$3(!!So), Co) : ho;
  }, Co.curve = function(So) {
    return arguments.length ? (bo = So, go != null && (vo = bo(go)), Co) : bo;
  }, Co.context = function(So) {
    return arguments.length ? (So == null ? go = vo = null : vo = bo(go = So), Co) : go;
  }, Co;
}
function shapeArea(Kt, uo, ho) {
  var go = null, bo = constant$3(!0), vo = null, Po = curveLinear, Co = null, So = withPath(wo);
  Kt = typeof Kt == "function" ? Kt : Kt === void 0 ? x$4 : constant$3(+Kt), uo = typeof uo == "function" ? uo : constant$3(uo === void 0 ? 0 : +uo), ho = typeof ho == "function" ? ho : ho === void 0 ? y$2 : constant$3(+ho);
  function wo(Ro) {
    var _o, Io, Ao, Oo = (Ro = array(Ro)).length, jo, Do = !1, Lo, ko = new Array(Oo), Ko = new Array(Oo);
    for (vo == null && (Co = Po(Lo = So())), _o = 0; _o <= Oo; ++_o) {
      if (!(_o < Oo && bo(jo = Ro[_o], _o, Ro)) === Do)
        if (Do = !Do)
          Io = _o, Co.areaStart(), Co.lineStart();
        else {
          for (Co.lineEnd(), Co.lineStart(), Ao = _o - 1; Ao >= Io; --Ao)
            Co.point(ko[Ao], Ko[Ao]);
          Co.lineEnd(), Co.areaEnd();
        }
      Do && (ko[_o] = +Kt(jo, _o, Ro), Ko[_o] = +uo(jo, _o, Ro), Co.point(go ? +go(jo, _o, Ro) : ko[_o], ho ? +ho(jo, _o, Ro) : Ko[_o]));
    }
    if (Lo) return Co = null, Lo + "" || null;
  }
  function Eo() {
    return shapeLine().defined(bo).curve(Po).context(vo);
  }
  return wo.x = function(Ro) {
    return arguments.length ? (Kt = typeof Ro == "function" ? Ro : constant$3(+Ro), go = null, wo) : Kt;
  }, wo.x0 = function(Ro) {
    return arguments.length ? (Kt = typeof Ro == "function" ? Ro : constant$3(+Ro), wo) : Kt;
  }, wo.x1 = function(Ro) {
    return arguments.length ? (go = Ro == null ? null : typeof Ro == "function" ? Ro : constant$3(+Ro), wo) : go;
  }, wo.y = function(Ro) {
    return arguments.length ? (uo = typeof Ro == "function" ? Ro : constant$3(+Ro), ho = null, wo) : uo;
  }, wo.y0 = function(Ro) {
    return arguments.length ? (uo = typeof Ro == "function" ? Ro : constant$3(+Ro), wo) : uo;
  }, wo.y1 = function(Ro) {
    return arguments.length ? (ho = Ro == null ? null : typeof Ro == "function" ? Ro : constant$3(+Ro), wo) : ho;
  }, wo.lineX0 = wo.lineY0 = function() {
    return Eo().x(Kt).y(uo);
  }, wo.lineY1 = function() {
    return Eo().x(Kt).y(ho);
  }, wo.lineX1 = function() {
    return Eo().x(go).y(uo);
  }, wo.defined = function(Ro) {
    return arguments.length ? (bo = typeof Ro == "function" ? Ro : constant$3(!!Ro), wo) : bo;
  }, wo.curve = function(Ro) {
    return arguments.length ? (Po = Ro, vo != null && (Co = Po(vo)), wo) : Po;
  }, wo.context = function(Ro) {
    return arguments.length ? (Ro == null ? vo = Co = null : Co = Po(vo = Ro), wo) : vo;
  }, wo;
}
class Bump {
  constructor(uo, ho) {
    this._context = uo, this._x = ho;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(uo, ho) {
    switch (uo = +uo, ho = +ho, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(uo, ho) : this._context.moveTo(uo, ho);
        break;
      }
      case 1:
        this._point = 2;
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + uo) / 2, this._y0, this._x0, ho, uo, ho) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + ho) / 2, uo, this._y0, uo, ho);
        break;
      }
    }
    this._x0 = uo, this._y0 = ho;
  }
}
function bumpX(Kt) {
  return new Bump(Kt, !0);
}
function bumpY(Kt) {
  return new Bump(Kt, !1);
}
const symbolCircle = {
  draw(Kt, uo) {
    const ho = sqrt$1(uo / pi$2);
    Kt.moveTo(ho, 0), Kt.arc(0, 0, ho, 0, tau$1);
  }
}, symbolCross = {
  draw(Kt, uo) {
    const ho = sqrt$1(uo / 5) / 2;
    Kt.moveTo(-3 * ho, -ho), Kt.lineTo(-ho, -ho), Kt.lineTo(-ho, -3 * ho), Kt.lineTo(ho, -3 * ho), Kt.lineTo(ho, -ho), Kt.lineTo(3 * ho, -ho), Kt.lineTo(3 * ho, ho), Kt.lineTo(ho, ho), Kt.lineTo(ho, 3 * ho), Kt.lineTo(-ho, 3 * ho), Kt.lineTo(-ho, ho), Kt.lineTo(-3 * ho, ho), Kt.closePath();
  }
}, tan30 = sqrt$1(1 / 3), tan30_2 = tan30 * 2, symbolDiamond = {
  draw(Kt, uo) {
    const ho = sqrt$1(uo / tan30_2), go = ho * tan30;
    Kt.moveTo(0, -ho), Kt.lineTo(go, 0), Kt.lineTo(0, ho), Kt.lineTo(-go, 0), Kt.closePath();
  }
}, symbolSquare = {
  draw(Kt, uo) {
    const ho = sqrt$1(uo), go = -ho / 2;
    Kt.rect(go, go, ho, ho);
  }
}, ka = 0.8908130915292852, kr$2 = sin(pi$2 / 10) / sin(7 * pi$2 / 10), kx = sin(tau$1 / 10) * kr$2, ky = -cos(tau$1 / 10) * kr$2, symbolStar = {
  draw(Kt, uo) {
    const ho = sqrt$1(uo * ka), go = kx * ho, bo = ky * ho;
    Kt.moveTo(0, -ho), Kt.lineTo(go, bo);
    for (let vo = 1; vo < 5; ++vo) {
      const Po = tau$1 * vo / 5, Co = cos(Po), So = sin(Po);
      Kt.lineTo(So * ho, -Co * ho), Kt.lineTo(Co * go - So * bo, So * go + Co * bo);
    }
    Kt.closePath();
  }
}, sqrt3 = sqrt$1(3), symbolTriangle = {
  draw(Kt, uo) {
    const ho = -sqrt$1(uo / (sqrt3 * 3));
    Kt.moveTo(0, ho * 2), Kt.lineTo(-sqrt3 * ho, -ho), Kt.lineTo(sqrt3 * ho, -ho), Kt.closePath();
  }
}, c$2 = -0.5, s$3 = sqrt$1(3) / 2, k$5 = 1 / sqrt$1(12), a$2 = (k$5 / 2 + 1) * 3, symbolWye = {
  draw(Kt, uo) {
    const ho = sqrt$1(uo / a$2), go = ho / 2, bo = ho * k$5, vo = go, Po = ho * k$5 + ho, Co = -vo, So = Po;
    Kt.moveTo(go, bo), Kt.lineTo(vo, Po), Kt.lineTo(Co, So), Kt.lineTo(c$2 * go - s$3 * bo, s$3 * go + c$2 * bo), Kt.lineTo(c$2 * vo - s$3 * Po, s$3 * vo + c$2 * Po), Kt.lineTo(c$2 * Co - s$3 * So, s$3 * Co + c$2 * So), Kt.lineTo(c$2 * go + s$3 * bo, c$2 * bo - s$3 * go), Kt.lineTo(c$2 * vo + s$3 * Po, c$2 * Po - s$3 * vo), Kt.lineTo(c$2 * Co + s$3 * So, c$2 * So - s$3 * Co), Kt.closePath();
  }
};
function Symbol$3(Kt, uo) {
  let ho = null, go = withPath(bo);
  Kt = typeof Kt == "function" ? Kt : constant$3(Kt || symbolCircle), uo = typeof uo == "function" ? uo : constant$3(uo === void 0 ? 64 : +uo);
  function bo() {
    let vo;
    if (ho || (ho = vo = go()), Kt.apply(this, arguments).draw(ho, +uo.apply(this, arguments)), vo) return ho = null, vo + "" || null;
  }
  return bo.type = function(vo) {
    return arguments.length ? (Kt = typeof vo == "function" ? vo : constant$3(vo), bo) : Kt;
  }, bo.size = function(vo) {
    return arguments.length ? (uo = typeof vo == "function" ? vo : constant$3(+vo), bo) : uo;
  }, bo.context = function(vo) {
    return arguments.length ? (ho = vo ?? null, bo) : ho;
  }, bo;
}
function noop$2() {
}
function point$2(Kt, uo, ho) {
  Kt._context.bezierCurveTo(
    (2 * Kt._x0 + Kt._x1) / 3,
    (2 * Kt._y0 + Kt._y1) / 3,
    (Kt._x0 + 2 * Kt._x1) / 3,
    (Kt._y0 + 2 * Kt._y1) / 3,
    (Kt._x0 + 4 * Kt._x1 + uo) / 6,
    (Kt._y0 + 4 * Kt._y1 + ho) / 6
  );
}
function Basis(Kt) {
  this._context = Kt;
}
Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        point$2(this, this._x1, this._y1);
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(Kt, uo) {
    switch (Kt = +Kt, uo = +uo, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(Kt, uo) : this._context.moveTo(Kt, uo);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      default:
        point$2(this, Kt, uo);
        break;
    }
    this._x0 = this._x1, this._x1 = Kt, this._y0 = this._y1, this._y1 = uo;
  }
};
function curveBasis(Kt) {
  return new Basis(Kt);
}
function BasisClosed(Kt) {
  this._context = Kt;
}
BasisClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(Kt, uo) {
    switch (Kt = +Kt, uo = +uo, this._point) {
      case 0:
        this._point = 1, this._x2 = Kt, this._y2 = uo;
        break;
      case 1:
        this._point = 2, this._x3 = Kt, this._y3 = uo;
        break;
      case 2:
        this._point = 3, this._x4 = Kt, this._y4 = uo, this._context.moveTo((this._x0 + 4 * this._x1 + Kt) / 6, (this._y0 + 4 * this._y1 + uo) / 6);
        break;
      default:
        point$2(this, Kt, uo);
        break;
    }
    this._x0 = this._x1, this._x1 = Kt, this._y0 = this._y1, this._y1 = uo;
  }
};
function curveBasisClosed(Kt) {
  return new BasisClosed(Kt);
}
function BasisOpen(Kt) {
  this._context = Kt;
}
BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(Kt, uo) {
    switch (Kt = +Kt, uo = +uo, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var ho = (this._x0 + 4 * this._x1 + Kt) / 6, go = (this._y0 + 4 * this._y1 + uo) / 6;
        this._line ? this._context.lineTo(ho, go) : this._context.moveTo(ho, go);
        break;
      case 3:
        this._point = 4;
      default:
        point$2(this, Kt, uo);
        break;
    }
    this._x0 = this._x1, this._x1 = Kt, this._y0 = this._y1, this._y1 = uo;
  }
};
function curveBasisOpen(Kt) {
  return new BasisOpen(Kt);
}
function LinearClosed(Kt) {
  this._context = Kt;
}
LinearClosed.prototype = {
  areaStart: noop$2,
  areaEnd: noop$2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(Kt, uo) {
    Kt = +Kt, uo = +uo, this._point ? this._context.lineTo(Kt, uo) : (this._point = 1, this._context.moveTo(Kt, uo));
  }
};
function curveLinearClosed(Kt) {
  return new LinearClosed(Kt);
}
function sign(Kt) {
  return Kt < 0 ? -1 : 1;
}
function slope3(Kt, uo, ho) {
  var go = Kt._x1 - Kt._x0, bo = uo - Kt._x1, vo = (Kt._y1 - Kt._y0) / (go || bo < 0 && -0), Po = (ho - Kt._y1) / (bo || go < 0 && -0), Co = (vo * bo + Po * go) / (go + bo);
  return (sign(vo) + sign(Po)) * Math.min(Math.abs(vo), Math.abs(Po), 0.5 * Math.abs(Co)) || 0;
}
function slope2(Kt, uo) {
  var ho = Kt._x1 - Kt._x0;
  return ho ? (3 * (Kt._y1 - Kt._y0) / ho - uo) / 2 : uo;
}
function point$1(Kt, uo, ho) {
  var go = Kt._x0, bo = Kt._y0, vo = Kt._x1, Po = Kt._y1, Co = (vo - go) / 3;
  Kt._context.bezierCurveTo(go + Co, bo + Co * uo, vo - Co, Po - Co * ho, vo, Po);
}
function MonotoneX(Kt) {
  this._context = Kt;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point$1(this, this._t0, slope2(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(Kt, uo) {
    var ho = NaN;
    if (Kt = +Kt, uo = +uo, !(Kt === this._x1 && uo === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(Kt, uo) : this._context.moveTo(Kt, uo);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, point$1(this, slope2(this, ho = slope3(this, Kt, uo)), ho);
          break;
        default:
          point$1(this, this._t0, ho = slope3(this, Kt, uo));
          break;
      }
      this._x0 = this._x1, this._x1 = Kt, this._y0 = this._y1, this._y1 = uo, this._t0 = ho;
    }
  }
};
function MonotoneY(Kt) {
  this._context = new ReflectContext(Kt);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(Kt, uo) {
  MonotoneX.prototype.point.call(this, uo, Kt);
};
function ReflectContext(Kt) {
  this._context = Kt;
}
ReflectContext.prototype = {
  moveTo: function(Kt, uo) {
    this._context.moveTo(uo, Kt);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(Kt, uo) {
    this._context.lineTo(uo, Kt);
  },
  bezierCurveTo: function(Kt, uo, ho, go, bo, vo) {
    this._context.bezierCurveTo(uo, Kt, go, ho, vo, bo);
  }
};
function monotoneX(Kt) {
  return new MonotoneX(Kt);
}
function monotoneY(Kt) {
  return new MonotoneY(Kt);
}
function Natural(Kt) {
  this._context = Kt;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var Kt = this._x, uo = this._y, ho = Kt.length;
    if (ho)
      if (this._line ? this._context.lineTo(Kt[0], uo[0]) : this._context.moveTo(Kt[0], uo[0]), ho === 2)
        this._context.lineTo(Kt[1], uo[1]);
      else
        for (var go = controlPoints(Kt), bo = controlPoints(uo), vo = 0, Po = 1; Po < ho; ++vo, ++Po)
          this._context.bezierCurveTo(go[0][vo], bo[0][vo], go[1][vo], bo[1][vo], Kt[Po], uo[Po]);
    (this._line || this._line !== 0 && ho === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(Kt, uo) {
    this._x.push(+Kt), this._y.push(+uo);
  }
};
function controlPoints(Kt) {
  var uo, ho = Kt.length - 1, go, bo = new Array(ho), vo = new Array(ho), Po = new Array(ho);
  for (bo[0] = 0, vo[0] = 2, Po[0] = Kt[0] + 2 * Kt[1], uo = 1; uo < ho - 1; ++uo) bo[uo] = 1, vo[uo] = 4, Po[uo] = 4 * Kt[uo] + 2 * Kt[uo + 1];
  for (bo[ho - 1] = 2, vo[ho - 1] = 7, Po[ho - 1] = 8 * Kt[ho - 1] + Kt[ho], uo = 1; uo < ho; ++uo) go = bo[uo] / vo[uo - 1], vo[uo] -= go, Po[uo] -= go * Po[uo - 1];
  for (bo[ho - 1] = Po[ho - 1] / vo[ho - 1], uo = ho - 2; uo >= 0; --uo) bo[uo] = (Po[uo] - bo[uo + 1]) / vo[uo];
  for (vo[ho - 1] = (Kt[ho] + bo[ho - 1]) / 2, uo = 0; uo < ho - 1; ++uo) vo[uo] = 2 * Kt[uo + 1] - bo[uo + 1];
  return [bo, vo];
}
function curveNatural(Kt) {
  return new Natural(Kt);
}
function Step$1(Kt, uo) {
  this._context = Kt, this._t = uo;
}
Step$1.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(Kt, uo) {
    switch (Kt = +Kt, uo = +uo, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(Kt, uo) : this._context.moveTo(Kt, uo);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, uo), this._context.lineTo(Kt, uo);
        else {
          var ho = this._x * (1 - this._t) + Kt * this._t;
          this._context.lineTo(ho, this._y), this._context.lineTo(ho, uo);
        }
        break;
      }
    }
    this._x = Kt, this._y = uo;
  }
};
function curveStep(Kt) {
  return new Step$1(Kt, 0.5);
}
function stepBefore(Kt) {
  return new Step$1(Kt, 0);
}
function stepAfter(Kt) {
  return new Step$1(Kt, 1);
}
function stackOffsetNone(Kt, uo) {
  if ((Po = Kt.length) > 1)
    for (var ho = 1, go, bo, vo = Kt[uo[0]], Po, Co = vo.length; ho < Po; ++ho)
      for (bo = vo, vo = Kt[uo[ho]], go = 0; go < Co; ++go)
        vo[go][1] += vo[go][0] = isNaN(bo[go][1]) ? bo[go][0] : bo[go][1];
}
function stackOrderNone(Kt) {
  for (var uo = Kt.length, ho = new Array(uo); --uo >= 0; ) ho[uo] = uo;
  return ho;
}
function stackValue(Kt, uo) {
  return Kt[uo];
}
function stackSeries(Kt) {
  const uo = [];
  return uo.key = Kt, uo;
}
function shapeStack() {
  var Kt = constant$3([]), uo = stackOrderNone, ho = stackOffsetNone, go = stackValue;
  function bo(vo) {
    var Po = Array.from(Kt.apply(this, arguments), stackSeries), Co, So = Po.length, wo = -1, Eo;
    for (const Ro of vo)
      for (Co = 0, ++wo; Co < So; ++Co)
        (Po[Co][wo] = [0, +go(Ro, Po[Co].key, wo, vo)]).data = Ro;
    for (Co = 0, Eo = array(uo(Po)); Co < So; ++Co)
      Po[Eo[Co]].index = Co;
    return ho(Po, Eo), Po;
  }
  return bo.keys = function(vo) {
    return arguments.length ? (Kt = typeof vo == "function" ? vo : constant$3(Array.from(vo)), bo) : Kt;
  }, bo.value = function(vo) {
    return arguments.length ? (go = typeof vo == "function" ? vo : constant$3(+vo), bo) : go;
  }, bo.order = function(vo) {
    return arguments.length ? (uo = vo == null ? stackOrderNone : typeof vo == "function" ? vo : constant$3(Array.from(vo)), bo) : uo;
  }, bo.offset = function(vo) {
    return arguments.length ? (ho = vo ?? stackOffsetNone, bo) : ho;
  }, bo;
}
function stackOffsetExpand(Kt, uo) {
  if ((go = Kt.length) > 0) {
    for (var ho, go, bo = 0, vo = Kt[0].length, Po; bo < vo; ++bo) {
      for (Po = ho = 0; ho < go; ++ho) Po += Kt[ho][bo][1] || 0;
      if (Po) for (ho = 0; ho < go; ++ho) Kt[ho][bo][1] /= Po;
    }
    stackOffsetNone(Kt, uo);
  }
}
function stackOffsetSilhouette(Kt, uo) {
  if ((bo = Kt.length) > 0) {
    for (var ho = 0, go = Kt[uo[0]], bo, vo = go.length; ho < vo; ++ho) {
      for (var Po = 0, Co = 0; Po < bo; ++Po) Co += Kt[Po][ho][1] || 0;
      go[ho][1] += go[ho][0] = -Co / 2;
    }
    stackOffsetNone(Kt, uo);
  }
}
function stackOffsetWiggle(Kt, uo) {
  if (!(!((Po = Kt.length) > 0) || !((vo = (bo = Kt[uo[0]]).length) > 0))) {
    for (var ho = 0, go = 1, bo, vo, Po; go < vo; ++go) {
      for (var Co = 0, So = 0, wo = 0; Co < Po; ++Co) {
        for (var Eo = Kt[uo[Co]], Ro = Eo[go][1] || 0, _o = Eo[go - 1][1] || 0, Io = (Ro - _o) / 2, Ao = 0; Ao < Co; ++Ao) {
          var Oo = Kt[uo[Ao]], jo = Oo[go][1] || 0, Do = Oo[go - 1][1] || 0;
          Io += jo - Do;
        }
        So += Ro, wo += Io * Ro;
      }
      bo[go - 1][1] += bo[go - 1][0] = ho, So && (ho -= wo / So);
    }
    bo[go - 1][1] += bo[go - 1][0] = ho, stackOffsetNone(Kt, uo);
  }
}
function _typeof$G(Kt) {
  "@babel/helpers - typeof";
  return _typeof$G = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$G(Kt);
}
var _excluded$d = ["type", "size", "sizeType"];
function _extends$n() {
  return _extends$n = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$n.apply(this, arguments);
}
function ownKeys$y(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$y(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$y(Object(ho), !0).forEach(function(go) {
      _defineProperty$E(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$y(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$E(Kt, uo, ho) {
  return uo = _toPropertyKey$E(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$E(Kt) {
  var uo = _toPrimitive$E(Kt, "string");
  return _typeof$G(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$E(Kt, uo) {
  if (_typeof$G(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$G(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _objectWithoutProperties$d(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$d(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$d(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
var symbolFactories = {
  symbolCircle,
  symbolCross,
  symbolDiamond,
  symbolSquare,
  symbolStar,
  symbolTriangle,
  symbolWye
}, RADIAN$1 = Math.PI / 180, getSymbolFactory = function(uo) {
  var ho = "symbol".concat(upperFirst$1(uo));
  return symbolFactories[ho] || symbolCircle;
}, calculateAreaSize = function(uo, ho, go) {
  if (ho === "area")
    return uo;
  switch (go) {
    case "cross":
      return 5 * uo * uo / 9;
    case "diamond":
      return 0.5 * uo * uo / Math.sqrt(3);
    case "square":
      return uo * uo;
    case "star": {
      var bo = 18 * RADIAN$1;
      return 1.25 * uo * uo * (Math.tan(bo) - Math.tan(bo * 2) * Math.pow(Math.tan(bo), 2));
    }
    case "triangle":
      return Math.sqrt(3) * uo * uo / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * uo * uo / 8;
    default:
      return Math.PI * uo * uo / 4;
  }
}, registerSymbol = function(uo, ho) {
  symbolFactories["symbol".concat(upperFirst$1(uo))] = ho;
}, Symbols = function(uo) {
  var ho = uo.type, go = ho === void 0 ? "circle" : ho, bo = uo.size, vo = bo === void 0 ? 64 : bo, Po = uo.sizeType, Co = Po === void 0 ? "area" : Po, So = _objectWithoutProperties$d(uo, _excluded$d), wo = _objectSpread$y(_objectSpread$y({}, So), {}, {
    type: go,
    size: vo,
    sizeType: Co
  }), Eo = function() {
    var jo = getSymbolFactory(go), Do = Symbol$3().type(jo).size(calculateAreaSize(vo, Co, go));
    return Do();
  }, Ro = wo.className, _o = wo.cx, Io = wo.cy, Ao = filterProps(wo, !0);
  return _o === +_o && Io === +Io && vo === +vo ? /* @__PURE__ */ React__default.createElement("path", _extends$n({}, Ao, {
    className: clsx("recharts-symbols", Ro),
    transform: "translate(".concat(_o, ", ").concat(Io, ")"),
    d: Eo()
  })) : null;
};
Symbols.registerSymbol = registerSymbol;
function _typeof$F(Kt) {
  "@babel/helpers - typeof";
  return _typeof$F = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$F(Kt);
}
function _extends$m() {
  return _extends$m = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$m.apply(this, arguments);
}
function ownKeys$x(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$x(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$x(Object(ho), !0).forEach(function(go) {
      _defineProperty$D(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$x(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$h(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$h(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$D(go.key), go);
  }
}
function _createClass$h(Kt, uo, ho) {
  return _defineProperties$h(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$d(Kt, uo, ho) {
  return uo = _getPrototypeOf$e(uo), _possibleConstructorReturn$e(Kt, _isNativeReflectConstruct$e() ? Reflect.construct(uo, ho || [], _getPrototypeOf$e(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$e(Kt, uo) {
  if (uo && (_typeof$F(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$e(Kt);
}
function _assertThisInitialized$e(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$e() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$e = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$e(Kt) {
  return _getPrototypeOf$e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$e(Kt);
}
function _inherits$e(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$e(Kt, uo);
}
function _setPrototypeOf$e(Kt, uo) {
  return _setPrototypeOf$e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$e(Kt, uo);
}
function _defineProperty$D(Kt, uo, ho) {
  return uo = _toPropertyKey$D(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$D(Kt) {
  var uo = _toPrimitive$D(Kt, "string");
  return _typeof$F(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$D(Kt, uo) {
  if (_typeof$F(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$F(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var SIZE = 32, DefaultLegendContent = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$h(this, uo), _callSuper$d(this, uo, arguments);
  }
  return _inherits$e(uo, Kt), _createClass$h(uo, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(go) {
        var bo = this.props.inactiveColor, vo = SIZE / 2, Po = SIZE / 6, Co = SIZE / 3, So = go.inactive ? bo : go.color;
        if (go.type === "plainline")
          return /* @__PURE__ */ React__default.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: So,
            strokeDasharray: go.payload.strokeDasharray,
            x1: 0,
            y1: vo,
            x2: SIZE,
            y2: vo,
            className: "recharts-legend-icon"
          });
        if (go.type === "line")
          return /* @__PURE__ */ React__default.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: So,
            d: "M0,".concat(vo, "h").concat(Co, `
            A`).concat(Po, ",").concat(Po, ",0,1,1,").concat(2 * Co, ",").concat(vo, `
            H`).concat(SIZE, "M").concat(2 * Co, ",").concat(vo, `
            A`).concat(Po, ",").concat(Po, ",0,1,1,").concat(Co, ",").concat(vo),
            className: "recharts-legend-icon"
          });
        if (go.type === "rect")
          return /* @__PURE__ */ React__default.createElement("path", {
            stroke: "none",
            fill: So,
            d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ React__default.isValidElement(go.legendIcon)) {
          var wo = _objectSpread$x({}, go);
          return delete wo.legendIcon, /* @__PURE__ */ React__default.cloneElement(go.legendIcon, wo);
        }
        return /* @__PURE__ */ React__default.createElement(Symbols, {
          fill: So,
          cx: vo,
          cy: vo,
          size: SIZE,
          sizeType: "diameter",
          type: go.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var go = this, bo = this.props, vo = bo.payload, Po = bo.iconSize, Co = bo.layout, So = bo.formatter, wo = bo.inactiveColor, Eo = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      }, Ro = {
        display: Co === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, _o = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return vo.map(function(Io, Ao) {
        var Oo = Io.formatter || So, jo = clsx(_defineProperty$D(_defineProperty$D({
          "recharts-legend-item": !0
        }, "legend-item-".concat(Ao), !0), "inactive", Io.inactive));
        if (Io.type === "none")
          return null;
        var Do = isFunction$3(Io.value) ? null : Io.value;
        warn$1(
          !isFunction$3(Io.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var Lo = Io.inactive ? wo : Io.color;
        return /* @__PURE__ */ React__default.createElement("li", _extends$m({
          className: jo,
          style: Ro,
          key: "legend-item-".concat(Ao)
        }, adaptEventsOfChild(go.props, Io, Ao)), /* @__PURE__ */ React__default.createElement(Surface, {
          width: Po,
          height: Po,
          viewBox: Eo,
          style: _o
        }, go.renderIcon(Io)), /* @__PURE__ */ React__default.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: Lo
          }
        }, Oo ? Oo(Do, Io, Ao) : Do));
      });
    }
  }, {
    key: "render",
    value: function() {
      var go = this.props, bo = go.payload, vo = go.layout, Po = go.align;
      if (!bo || !bo.length)
        return null;
      var Co = {
        padding: 0,
        margin: 0,
        textAlign: vo === "horizontal" ? Po : "left"
      };
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: "recharts-default-legend",
        style: Co
      }, this.renderItems());
    }
  }]);
}(PureComponent);
_defineProperty$D(DefaultLegendContent, "displayName", "Legend");
_defineProperty$D(DefaultLegendContent, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var ListCache$2 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$2(), this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(Kt) {
  var uo = this.__data__, ho = uo.delete(Kt);
  return this.size = uo.size, ho;
}
var _stackDelete = stackDelete$1;
function stackGet$1(Kt) {
  return this.__data__.get(Kt);
}
var _stackGet = stackGet$1;
function stackHas$1(Kt) {
  return this.__data__.has(Kt);
}
var _stackHas = stackHas$1, ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache, LARGE_ARRAY_SIZE$1 = 200;
function stackSet$1(Kt, uo) {
  var ho = this.__data__;
  if (ho instanceof ListCache$1) {
    var go = ho.__data__;
    if (!Map$2 || go.length < LARGE_ARRAY_SIZE$1 - 1)
      return go.push([Kt, uo]), this.size = ++ho.size, this;
    ho = this.__data__ = new MapCache$1(go);
  }
  return ho.set(Kt, uo), this.size = ho.size, this;
}
var _stackSet = stackSet$1, ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$2(Kt) {
  var uo = this.__data__ = new ListCache(Kt);
  this.size = uo.size;
}
Stack$2.prototype.clear = stackClear;
Stack$2.prototype.delete = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;
var _Stack = Stack$2, HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(Kt) {
  return this.__data__.set(Kt, HASH_UNDEFINED), this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(Kt) {
  return this.__data__.has(Kt);
}
var _setCacheHas = setCacheHas$1, MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$2(Kt) {
  var uo = -1, ho = Kt == null ? 0 : Kt.length;
  for (this.__data__ = new MapCache(); ++uo < ho; )
    this.add(Kt[uo]);
}
SetCache$2.prototype.add = SetCache$2.prototype.push = setCacheAdd;
SetCache$2.prototype.has = setCacheHas;
var _SetCache = SetCache$2;
function arraySome$2(Kt, uo) {
  for (var ho = -1, go = Kt == null ? 0 : Kt.length; ++ho < go; )
    if (uo(Kt[ho], ho, Kt))
      return !0;
  return !1;
}
var _arraySome = arraySome$2;
function cacheHas$2(Kt, uo) {
  return Kt.has(uo);
}
var _cacheHas = cacheHas$2, SetCache$1 = _SetCache, arraySome$1 = _arraySome, cacheHas$1 = _cacheHas, COMPARE_PARTIAL_FLAG$5 = 1, COMPARE_UNORDERED_FLAG$3 = 2;
function equalArrays$2(Kt, uo, ho, go, bo, vo) {
  var Po = ho & COMPARE_PARTIAL_FLAG$5, Co = Kt.length, So = uo.length;
  if (Co != So && !(Po && So > Co))
    return !1;
  var wo = vo.get(Kt), Eo = vo.get(uo);
  if (wo && Eo)
    return wo == uo && Eo == Kt;
  var Ro = -1, _o = !0, Io = ho & COMPARE_UNORDERED_FLAG$3 ? new SetCache$1() : void 0;
  for (vo.set(Kt, uo), vo.set(uo, Kt); ++Ro < Co; ) {
    var Ao = Kt[Ro], Oo = uo[Ro];
    if (go)
      var jo = Po ? go(Oo, Ao, Ro, uo, Kt, vo) : go(Ao, Oo, Ro, Kt, uo, vo);
    if (jo !== void 0) {
      if (jo)
        continue;
      _o = !1;
      break;
    }
    if (Io) {
      if (!arraySome$1(uo, function(Do, Lo) {
        if (!cacheHas$1(Io, Lo) && (Ao === Do || bo(Ao, Do, ho, go, vo)))
          return Io.push(Lo);
      })) {
        _o = !1;
        break;
      }
    } else if (!(Ao === Oo || bo(Ao, Oo, ho, go, vo))) {
      _o = !1;
      break;
    }
  }
  return vo.delete(Kt), vo.delete(uo), _o;
}
var _equalArrays = equalArrays$2, root$5 = _root, Uint8Array$2 = root$5.Uint8Array, _Uint8Array = Uint8Array$2;
function mapToArray$1(Kt) {
  var uo = -1, ho = Array(Kt.size);
  return Kt.forEach(function(go, bo) {
    ho[++uo] = [bo, go];
  }), ho;
}
var _mapToArray = mapToArray$1;
function setToArray$3(Kt) {
  var uo = -1, ho = Array(Kt.size);
  return Kt.forEach(function(go) {
    ho[++uo] = go;
  }), ho;
}
var _setToArray = setToArray$3, Symbol$2 = _Symbol, Uint8Array$1 = _Uint8Array, eq$1 = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray$2 = _setToArray, COMPARE_PARTIAL_FLAG$4 = 1, COMPARE_UNORDERED_FLAG$2 = 2, boolTag$2 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]", arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]", symbolProto = Symbol$2 ? Symbol$2.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(Kt, uo, ho, go, bo, vo, Po) {
  switch (ho) {
    case dataViewTag$2:
      if (Kt.byteLength != uo.byteLength || Kt.byteOffset != uo.byteOffset)
        return !1;
      Kt = Kt.buffer, uo = uo.buffer;
    case arrayBufferTag$1:
      return !(Kt.byteLength != uo.byteLength || !vo(new Uint8Array$1(Kt), new Uint8Array$1(uo)));
    case boolTag$2:
    case dateTag$1:
    case numberTag$1:
      return eq$1(+Kt, +uo);
    case errorTag$1:
      return Kt.name == uo.name && Kt.message == uo.message;
    case regexpTag$1:
    case stringTag$1:
      return Kt == uo + "";
    case mapTag$2:
      var Co = mapToArray;
    case setTag$2:
      var So = go & COMPARE_PARTIAL_FLAG$4;
      if (Co || (Co = setToArray$2), Kt.size != uo.size && !So)
        return !1;
      var wo = Po.get(Kt);
      if (wo)
        return wo == uo;
      go |= COMPARE_UNORDERED_FLAG$2, Po.set(Kt, uo);
      var Eo = equalArrays$1(Co(Kt), Co(uo), go, bo, vo, Po);
      return Po.delete(Kt), Eo;
    case symbolTag:
      if (symbolValueOf)
        return symbolValueOf.call(Kt) == symbolValueOf.call(uo);
  }
  return !1;
}
var _equalByTag = equalByTag$1;
function arrayPush$2(Kt, uo) {
  for (var ho = -1, go = uo.length, bo = Kt.length; ++ho < go; )
    Kt[bo + ho] = uo[ho];
  return Kt;
}
var _arrayPush = arrayPush$2, arrayPush$1 = _arrayPush, isArray$a = isArray_1;
function baseGetAllKeys$1(Kt, uo, ho) {
  var go = uo(Kt);
  return isArray$a(Kt) ? go : arrayPush$1(go, ho(Kt));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(Kt, uo) {
  for (var ho = -1, go = Kt == null ? 0 : Kt.length, bo = 0, vo = []; ++ho < go; ) {
    var Po = Kt[ho];
    uo(Po, ho, Kt) && (vo[bo++] = Po);
  }
  return vo;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1, arrayFilter = _arrayFilter, stubArray = stubArray_1, objectProto$7 = Object.prototype, propertyIsEnumerable$1 = objectProto$7.propertyIsEnumerable, nativeGetSymbols = Object.getOwnPropertySymbols, getSymbols$1 = nativeGetSymbols ? function(Kt) {
  return Kt == null ? [] : (Kt = Object(Kt), arrayFilter(nativeGetSymbols(Kt), function(uo) {
    return propertyIsEnumerable$1.call(Kt, uo);
  }));
} : stubArray, _getSymbols = getSymbols$1;
function baseTimes$1(Kt, uo) {
  for (var ho = -1, go = Array(Kt); ++ho < Kt; )
    go[ho] = uo(ho);
  return go;
}
var _baseTimes = baseTimes$1, baseGetTag$4 = _baseGetTag, isObjectLike$5 = isObjectLike_1, argsTag$2 = "[object Arguments]";
function baseIsArguments$1(Kt) {
  return isObjectLike$5(Kt) && baseGetTag$4(Kt) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1, baseIsArguments = _baseIsArguments, isObjectLike$4 = isObjectLike_1, objectProto$6 = Object.prototype, hasOwnProperty$6 = objectProto$6.hasOwnProperty, propertyIsEnumerable = objectProto$6.propertyIsEnumerable, isArguments$3 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(Kt) {
  return isObjectLike$4(Kt) && hasOwnProperty$6.call(Kt, "callee") && !propertyIsEnumerable.call(Kt, "callee");
}, isArguments_1 = isArguments$3, isBuffer$2 = { exports: {} };
function stubFalse() {
  return !1;
}
var stubFalse_1 = stubFalse;
isBuffer$2.exports;
(function(Kt, uo) {
  var ho = _root, go = stubFalse_1, bo = uo && !uo.nodeType && uo, vo = bo && !0 && Kt && !Kt.nodeType && Kt, Po = vo && vo.exports === bo, Co = Po ? ho.Buffer : void 0, So = Co ? Co.isBuffer : void 0, wo = So || go;
  Kt.exports = wo;
})(isBuffer$2, isBuffer$2.exports);
var isBufferExports = isBuffer$2.exports, MAX_SAFE_INTEGER$2 = 9007199254740991, reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$3(Kt, uo) {
  var ho = typeof Kt;
  return uo = uo ?? MAX_SAFE_INTEGER$2, !!uo && (ho == "number" || ho != "symbol" && reIsUint.test(Kt)) && Kt > -1 && Kt % 1 == 0 && Kt < uo;
}
var _isIndex = isIndex$3, MAX_SAFE_INTEGER$1 = 9007199254740991;
function isLength$3(Kt) {
  return typeof Kt == "number" && Kt > -1 && Kt % 1 == 0 && Kt <= MAX_SAFE_INTEGER$1;
}
var isLength_1 = isLength$3, baseGetTag$3 = _baseGetTag, isLength$2 = isLength_1, isObjectLike$3 = isObjectLike_1, argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag$1 = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$3 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]", arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]", typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = !0;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$3] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = !1;
function baseIsTypedArray$1(Kt) {
  return isObjectLike$3(Kt) && isLength$2(Kt.length) && !!typedArrayTags[baseGetTag$3(Kt)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$2(Kt) {
  return function(uo) {
    return Kt(uo);
  };
}
var _baseUnary = baseUnary$2, _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(Kt, uo) {
  var ho = _freeGlobal, go = uo && !uo.nodeType && uo, bo = go && !0 && Kt && !Kt.nodeType && Kt, vo = bo && bo.exports === go, Po = vo && ho.process, Co = function() {
    try {
      var So = bo && bo.require && bo.require("util").types;
      return So || Po && Po.binding && Po.binding("util");
    } catch {
    }
  }();
  Kt.exports = Co;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports, baseIsTypedArray = _baseIsTypedArray, baseUnary$1 = _baseUnary, nodeUtil = _nodeUtilExports, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray, isTypedArray$3 = nodeIsTypedArray ? baseUnary$1(nodeIsTypedArray) : baseIsTypedArray, isTypedArray_1 = isTypedArray$3, baseTimes = _baseTimes, isArguments$2 = isArguments_1, isArray$9 = isArray_1, isBuffer$1 = isBufferExports, isIndex$2 = _isIndex, isTypedArray$2 = isTypedArray_1, objectProto$5 = Object.prototype, hasOwnProperty$5 = objectProto$5.hasOwnProperty;
function arrayLikeKeys$1(Kt, uo) {
  var ho = isArray$9(Kt), go = !ho && isArguments$2(Kt), bo = !ho && !go && isBuffer$1(Kt), vo = !ho && !go && !bo && isTypedArray$2(Kt), Po = ho || go || bo || vo, Co = Po ? baseTimes(Kt.length, String) : [], So = Co.length;
  for (var wo in Kt)
    (uo || hasOwnProperty$5.call(Kt, wo)) && !(Po && // Safari 9 has enumerable `arguments.length` in strict mode.
    (wo == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    bo && (wo == "offset" || wo == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    vo && (wo == "buffer" || wo == "byteLength" || wo == "byteOffset") || // Skip index properties.
    isIndex$2(wo, So))) && Co.push(wo);
  return Co;
}
var _arrayLikeKeys = arrayLikeKeys$1, objectProto$4 = Object.prototype;
function isPrototype$1(Kt) {
  var uo = Kt && Kt.constructor, ho = typeof uo == "function" && uo.prototype || objectProto$4;
  return Kt === ho;
}
var _isPrototype = isPrototype$1;
function overArg$2(Kt, uo) {
  return function(ho) {
    return Kt(uo(ho));
  };
}
var _overArg = overArg$2, overArg$1 = _overArg, nativeKeys$1 = overArg$1(Object.keys, Object), _nativeKeys = nativeKeys$1, isPrototype = _isPrototype, nativeKeys = _nativeKeys, objectProto$3 = Object.prototype, hasOwnProperty$4 = objectProto$3.hasOwnProperty;
function baseKeys$1(Kt) {
  if (!isPrototype(Kt))
    return nativeKeys(Kt);
  var uo = [];
  for (var ho in Object(Kt))
    hasOwnProperty$4.call(Kt, ho) && ho != "constructor" && uo.push(ho);
  return uo;
}
var _baseKeys = baseKeys$1, isFunction = isFunction_1, isLength$1 = isLength_1;
function isArrayLike$5(Kt) {
  return Kt != null && isLength$1(Kt.length) && !isFunction(Kt);
}
var isArrayLike_1 = isArrayLike$5, arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike$4 = isArrayLike_1;
function keys$5(Kt) {
  return isArrayLike$4(Kt) ? arrayLikeKeys(Kt) : baseKeys(Kt);
}
var keys_1 = keys$5, baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys$4 = keys_1;
function getAllKeys$1(Kt) {
  return baseGetAllKeys(Kt, keys$4, getSymbols);
}
var _getAllKeys = getAllKeys$1, getAllKeys = _getAllKeys, COMPARE_PARTIAL_FLAG$3 = 1, objectProto$2 = Object.prototype, hasOwnProperty$3 = objectProto$2.hasOwnProperty;
function equalObjects$1(Kt, uo, ho, go, bo, vo) {
  var Po = ho & COMPARE_PARTIAL_FLAG$3, Co = getAllKeys(Kt), So = Co.length, wo = getAllKeys(uo), Eo = wo.length;
  if (So != Eo && !Po)
    return !1;
  for (var Ro = So; Ro--; ) {
    var _o = Co[Ro];
    if (!(Po ? _o in uo : hasOwnProperty$3.call(uo, _o)))
      return !1;
  }
  var Io = vo.get(Kt), Ao = vo.get(uo);
  if (Io && Ao)
    return Io == uo && Ao == Kt;
  var Oo = !0;
  vo.set(Kt, uo), vo.set(uo, Kt);
  for (var jo = Po; ++Ro < So; ) {
    _o = Co[Ro];
    var Do = Kt[_o], Lo = uo[_o];
    if (go)
      var ko = Po ? go(Lo, Do, _o, uo, Kt, vo) : go(Do, Lo, _o, Kt, uo, vo);
    if (!(ko === void 0 ? Do === Lo || bo(Do, Lo, ho, go, vo) : ko)) {
      Oo = !1;
      break;
    }
    jo || (jo = _o == "constructor");
  }
  if (Oo && !jo) {
    var Ko = Kt.constructor, No = uo.constructor;
    Ko != No && "constructor" in Kt && "constructor" in uo && !(typeof Ko == "function" && Ko instanceof Ko && typeof No == "function" && No instanceof No) && (Oo = !1);
  }
  return vo.delete(Kt), vo.delete(uo), Oo;
}
var _equalObjects = equalObjects$1, getNative$4 = _getNative, root$4 = _root, DataView$2 = getNative$4(root$4, "DataView"), _DataView = DataView$2, getNative$3 = _getNative, root$3 = _root, Promise$2 = getNative$3(root$3, "Promise"), _Promise = Promise$2, getNative$2 = _getNative, root$2 = _root, Set$3 = getNative$2(root$2, "Set"), _Set = Set$3, getNative$1 = _getNative, root$1 = _root, WeakMap$2 = getNative$1(root$1, "WeakMap"), _WeakMap = WeakMap$2, DataView$1 = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$2 = _Set, WeakMap$1 = _WeakMap, baseGetTag$2 = _baseGetTag, toSource = _toSource, mapTag = "[object Map]", objectTag$2 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]", dataViewTag = "[object DataView]", dataViewCtorString = toSource(DataView$1), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$2), weakMapCtorString = toSource(WeakMap$1), getTag$2 = baseGetTag$2;
(DataView$1 && getTag$2(new DataView$1(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$2(new Map$1()) != mapTag || Promise$1 && getTag$2(Promise$1.resolve()) != promiseTag || Set$2 && getTag$2(new Set$2()) != setTag || WeakMap$1 && getTag$2(new WeakMap$1()) != weakMapTag) && (getTag$2 = function(Kt) {
  var uo = baseGetTag$2(Kt), ho = uo == objectTag$2 ? Kt.constructor : void 0, go = ho ? toSource(ho) : "";
  if (go)
    switch (go) {
      case dataViewCtorString:
        return dataViewTag;
      case mapCtorString:
        return mapTag;
      case promiseCtorString:
        return promiseTag;
      case setCtorString:
        return setTag;
      case weakMapCtorString:
        return weakMapTag;
    }
  return uo;
});
var _getTag = getTag$2, Stack$1 = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag$1 = _getTag, isArray$8 = isArray_1, isBuffer = isBufferExports, isTypedArray$1 = isTypedArray_1, COMPARE_PARTIAL_FLAG$2 = 1, argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag$1 = "[object Object]", objectProto$1 = Object.prototype, hasOwnProperty$2 = objectProto$1.hasOwnProperty;
function baseIsEqualDeep$1(Kt, uo, ho, go, bo, vo) {
  var Po = isArray$8(Kt), Co = isArray$8(uo), So = Po ? arrayTag : getTag$1(Kt), wo = Co ? arrayTag : getTag$1(uo);
  So = So == argsTag ? objectTag$1 : So, wo = wo == argsTag ? objectTag$1 : wo;
  var Eo = So == objectTag$1, Ro = wo == objectTag$1, _o = So == wo;
  if (_o && isBuffer(Kt)) {
    if (!isBuffer(uo))
      return !1;
    Po = !0, Eo = !1;
  }
  if (_o && !Eo)
    return vo || (vo = new Stack$1()), Po || isTypedArray$1(Kt) ? equalArrays(Kt, uo, ho, go, bo, vo) : equalByTag(Kt, uo, So, ho, go, bo, vo);
  if (!(ho & COMPARE_PARTIAL_FLAG$2)) {
    var Io = Eo && hasOwnProperty$2.call(Kt, "__wrapped__"), Ao = Ro && hasOwnProperty$2.call(uo, "__wrapped__");
    if (Io || Ao) {
      var Oo = Io ? Kt.value() : Kt, jo = Ao ? uo.value() : uo;
      return vo || (vo = new Stack$1()), bo(Oo, jo, ho, go, vo);
    }
  }
  return _o ? (vo || (vo = new Stack$1()), equalObjects(Kt, uo, ho, go, bo, vo)) : !1;
}
var _baseIsEqualDeep = baseIsEqualDeep$1, baseIsEqualDeep = _baseIsEqualDeep, isObjectLike$2 = isObjectLike_1;
function baseIsEqual$3(Kt, uo, ho, go, bo) {
  return Kt === uo ? !0 : Kt == null || uo == null || !isObjectLike$2(Kt) && !isObjectLike$2(uo) ? Kt !== Kt && uo !== uo : baseIsEqualDeep(Kt, uo, ho, go, baseIsEqual$3, bo);
}
var _baseIsEqual = baseIsEqual$3, Stack = _Stack, baseIsEqual$2 = _baseIsEqual, COMPARE_PARTIAL_FLAG$1 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function baseIsMatch$1(Kt, uo, ho, go) {
  var bo = ho.length, vo = bo, Po = !go;
  if (Kt == null)
    return !vo;
  for (Kt = Object(Kt); bo--; ) {
    var Co = ho[bo];
    if (Po && Co[2] ? Co[1] !== Kt[Co[0]] : !(Co[0] in Kt))
      return !1;
  }
  for (; ++bo < vo; ) {
    Co = ho[bo];
    var So = Co[0], wo = Kt[So], Eo = Co[1];
    if (Po && Co[2]) {
      if (wo === void 0 && !(So in Kt))
        return !1;
    } else {
      var Ro = new Stack();
      if (go)
        var _o = go(wo, Eo, So, Kt, uo, Ro);
      if (!(_o === void 0 ? baseIsEqual$2(Eo, wo, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, go, Ro) : _o))
        return !1;
    }
  }
  return !0;
}
var _baseIsMatch = baseIsMatch$1, isObject$4 = isObject_1;
function isStrictComparable$2(Kt) {
  return Kt === Kt && !isObject$4(Kt);
}
var _isStrictComparable = isStrictComparable$2, isStrictComparable$1 = _isStrictComparable, keys$3 = keys_1;
function getMatchData$1(Kt) {
  for (var uo = keys$3(Kt), ho = uo.length; ho--; ) {
    var go = uo[ho], bo = Kt[go];
    uo[ho] = [go, bo, isStrictComparable$1(bo)];
  }
  return uo;
}
var _getMatchData = getMatchData$1;
function matchesStrictComparable$2(Kt, uo) {
  return function(ho) {
    return ho == null ? !1 : ho[Kt] === uo && (uo !== void 0 || Kt in Object(ho));
  };
}
var _matchesStrictComparable = matchesStrictComparable$2, baseIsMatch = _baseIsMatch, getMatchData = _getMatchData, matchesStrictComparable$1 = _matchesStrictComparable;
function baseMatches$1(Kt) {
  var uo = getMatchData(Kt);
  return uo.length == 1 && uo[0][2] ? matchesStrictComparable$1(uo[0][0], uo[0][1]) : function(ho) {
    return ho === Kt || baseIsMatch(ho, Kt, uo);
  };
}
var _baseMatches = baseMatches$1;
function baseHasIn$1(Kt, uo) {
  return Kt != null && uo in Object(Kt);
}
var _baseHasIn = baseHasIn$1, castPath = _castPath, isArguments$1 = isArguments_1, isArray$7 = isArray_1, isIndex$1 = _isIndex, isLength = isLength_1, toKey$2 = _toKey;
function hasPath$1(Kt, uo, ho) {
  uo = castPath(uo, Kt);
  for (var go = -1, bo = uo.length, vo = !1; ++go < bo; ) {
    var Po = toKey$2(uo[go]);
    if (!(vo = Kt != null && ho(Kt, Po)))
      break;
    Kt = Kt[Po];
  }
  return vo || ++go != bo ? vo : (bo = Kt == null ? 0 : Kt.length, !!bo && isLength(bo) && isIndex$1(Po, bo) && (isArray$7(Kt) || isArguments$1(Kt)));
}
var _hasPath = hasPath$1, baseHasIn = _baseHasIn, hasPath = _hasPath;
function hasIn$1(Kt, uo) {
  return Kt != null && hasPath(Kt, uo, baseHasIn);
}
var hasIn_1 = hasIn$1, baseIsEqual$1 = _baseIsEqual, get = get_1, hasIn = hasIn_1, isKey$1 = _isKey, isStrictComparable = _isStrictComparable, matchesStrictComparable = _matchesStrictComparable, toKey$1 = _toKey, COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function baseMatchesProperty$1(Kt, uo) {
  return isKey$1(Kt) && isStrictComparable(uo) ? matchesStrictComparable(toKey$1(Kt), uo) : function(ho) {
    var go = get(ho, Kt);
    return go === void 0 && go === uo ? hasIn(ho, Kt) : baseIsEqual$1(uo, go, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}
var _baseMatchesProperty = baseMatchesProperty$1;
function identity$b(Kt) {
  return Kt;
}
var identity_1 = identity$b;
function baseProperty$1(Kt) {
  return function(uo) {
    return uo == null ? void 0 : uo[Kt];
  };
}
var _baseProperty = baseProperty$1, baseGet$1 = _baseGet;
function basePropertyDeep$1(Kt) {
  return function(uo) {
    return baseGet$1(uo, Kt);
  };
}
var _basePropertyDeep = basePropertyDeep$1, baseProperty = _baseProperty, basePropertyDeep = _basePropertyDeep, isKey = _isKey, toKey = _toKey;
function property$1(Kt) {
  return isKey(Kt) ? baseProperty(toKey(Kt)) : basePropertyDeep(Kt);
}
var property_1 = property$1, baseMatches = _baseMatches, baseMatchesProperty = _baseMatchesProperty, identity$a = identity_1, isArray$6 = isArray_1, property = property_1;
function baseIteratee$8(Kt) {
  return typeof Kt == "function" ? Kt : Kt == null ? identity$a : typeof Kt == "object" ? isArray$6(Kt) ? baseMatchesProperty(Kt[0], Kt[1]) : baseMatches(Kt) : property(Kt);
}
var _baseIteratee = baseIteratee$8;
function baseFindIndex$2(Kt, uo, ho, go) {
  for (var bo = Kt.length, vo = ho + (go ? 1 : -1); go ? vo-- : ++vo < bo; )
    if (uo(Kt[vo], vo, Kt))
      return vo;
  return -1;
}
var _baseFindIndex = baseFindIndex$2;
function baseIsNaN$1(Kt) {
  return Kt !== Kt;
}
var _baseIsNaN = baseIsNaN$1;
function strictIndexOf$1(Kt, uo, ho) {
  for (var go = ho - 1, bo = Kt.length; ++go < bo; )
    if (Kt[go] === uo)
      return go;
  return -1;
}
var _strictIndexOf = strictIndexOf$1, baseFindIndex$1 = _baseFindIndex, baseIsNaN = _baseIsNaN, strictIndexOf = _strictIndexOf;
function baseIndexOf$1(Kt, uo, ho) {
  return uo === uo ? strictIndexOf(Kt, uo, ho) : baseFindIndex$1(Kt, baseIsNaN, ho);
}
var _baseIndexOf = baseIndexOf$1, baseIndexOf = _baseIndexOf;
function arrayIncludes$1(Kt, uo) {
  var ho = Kt == null ? 0 : Kt.length;
  return !!ho && baseIndexOf(Kt, uo, 0) > -1;
}
var _arrayIncludes = arrayIncludes$1;
function arrayIncludesWith$1(Kt, uo, ho) {
  for (var go = -1, bo = Kt == null ? 0 : Kt.length; ++go < bo; )
    if (ho(uo, Kt[go]))
      return !0;
  return !1;
}
var _arrayIncludesWith = arrayIncludesWith$1;
function noop$1() {
}
var noop_1 = noop$1, Set$1 = _Set, noop = noop_1, setToArray$1 = _setToArray, INFINITY$1 = 1 / 0, createSet$1 = Set$1 && 1 / setToArray$1(new Set$1([, -0]))[1] == INFINITY$1 ? function(Kt) {
  return new Set$1(Kt);
} : noop, _createSet = createSet$1, SetCache = _SetCache, arrayIncludes = _arrayIncludes, arrayIncludesWith = _arrayIncludesWith, cacheHas = _cacheHas, createSet = _createSet, setToArray = _setToArray, LARGE_ARRAY_SIZE = 200;
function baseUniq$1(Kt, uo, ho) {
  var go = -1, bo = arrayIncludes, vo = Kt.length, Po = !0, Co = [], So = Co;
  if (ho)
    Po = !1, bo = arrayIncludesWith;
  else if (vo >= LARGE_ARRAY_SIZE) {
    var wo = uo ? null : createSet(Kt);
    if (wo)
      return setToArray(wo);
    Po = !1, bo = cacheHas, So = new SetCache();
  } else
    So = uo ? [] : Co;
  e:
    for (; ++go < vo; ) {
      var Eo = Kt[go], Ro = uo ? uo(Eo) : Eo;
      if (Eo = ho || Eo !== 0 ? Eo : 0, Po && Ro === Ro) {
        for (var _o = So.length; _o--; )
          if (So[_o] === Ro)
            continue e;
        uo && So.push(Ro), Co.push(Eo);
      } else bo(So, Ro, ho) || (So !== Co && So.push(Ro), Co.push(Eo));
    }
  return Co;
}
var _baseUniq = baseUniq$1, baseIteratee$7 = _baseIteratee, baseUniq = _baseUniq;
function uniqBy(Kt, uo) {
  return Kt && Kt.length ? baseUniq(Kt, baseIteratee$7(uo)) : [];
}
var uniqBy_1 = uniqBy;
const uniqBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(uniqBy_1);
function getUniqPayload(Kt, uo, ho) {
  return uo === !0 ? uniqBy$1(Kt, ho) : isFunction$3(uo) ? uniqBy$1(Kt, uo) : Kt;
}
function _typeof$E(Kt) {
  "@babel/helpers - typeof";
  return _typeof$E = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$E(Kt);
}
var _excluded$c = ["ref"];
function ownKeys$w(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$w(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$w(Object(ho), !0).forEach(function(go) {
      _defineProperty$C(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$w(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$g(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$g(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$C(go.key), go);
  }
}
function _createClass$g(Kt, uo, ho) {
  return _defineProperties$g(Kt.prototype, uo), _defineProperties$g(Kt, ho), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$c(Kt, uo, ho) {
  return uo = _getPrototypeOf$d(uo), _possibleConstructorReturn$d(Kt, _isNativeReflectConstruct$d() ? Reflect.construct(uo, ho, _getPrototypeOf$d(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$d(Kt, uo) {
  if (uo && (_typeof$E(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$d(Kt);
}
function _assertThisInitialized$d(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$d() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$d = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$d(Kt) {
  return _getPrototypeOf$d = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$d(Kt);
}
function _inherits$d(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$d(Kt, uo);
}
function _setPrototypeOf$d(Kt, uo) {
  return _setPrototypeOf$d = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$d(Kt, uo);
}
function _defineProperty$C(Kt, uo, ho) {
  return uo = _toPropertyKey$C(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$C(Kt) {
  var uo = _toPrimitive$C(Kt, "string");
  return _typeof$E(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$C(Kt, uo) {
  if (_typeof$E(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$E(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _objectWithoutProperties$c(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$c(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$c(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function defaultUniqBy$1(Kt) {
  return Kt.value;
}
function renderContent$1(Kt, uo) {
  if (/* @__PURE__ */ React__default.isValidElement(Kt))
    return /* @__PURE__ */ React__default.cloneElement(Kt, uo);
  if (typeof Kt == "function")
    return /* @__PURE__ */ React__default.createElement(Kt, uo);
  uo.ref;
  var ho = _objectWithoutProperties$c(uo, _excluded$c);
  return /* @__PURE__ */ React__default.createElement(DefaultLegendContent, ho);
}
var EPS$1 = 1, Legend = /* @__PURE__ */ function(Kt) {
  function uo() {
    var ho;
    _classCallCheck$g(this, uo);
    for (var go = arguments.length, bo = new Array(go), vo = 0; vo < go; vo++)
      bo[vo] = arguments[vo];
    return ho = _callSuper$c(this, uo, [].concat(bo)), _defineProperty$C(ho, "lastBoundingBox", {
      width: -1,
      height: -1
    }), ho;
  }
  return _inherits$d(uo, Kt), _createClass$g(uo, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var go = this.wrapperNode.getBoundingClientRect();
        return go.height = this.wrapperNode.offsetHeight, go.width = this.wrapperNode.offsetWidth, go;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var go = this.props.onBBoxUpdate, bo = this.getBBox();
      bo ? (Math.abs(bo.width - this.lastBoundingBox.width) > EPS$1 || Math.abs(bo.height - this.lastBoundingBox.height) > EPS$1) && (this.lastBoundingBox.width = bo.width, this.lastBoundingBox.height = bo.height, go && go(bo)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, go && go(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? _objectSpread$w({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(go) {
      var bo = this.props, vo = bo.layout, Po = bo.align, Co = bo.verticalAlign, So = bo.margin, wo = bo.chartWidth, Eo = bo.chartHeight, Ro, _o;
      if (!go || (go.left === void 0 || go.left === null) && (go.right === void 0 || go.right === null))
        if (Po === "center" && vo === "vertical") {
          var Io = this.getBBoxSnapshot();
          Ro = {
            left: ((wo || 0) - Io.width) / 2
          };
        } else
          Ro = Po === "right" ? {
            right: So && So.right || 0
          } : {
            left: So && So.left || 0
          };
      if (!go || (go.top === void 0 || go.top === null) && (go.bottom === void 0 || go.bottom === null))
        if (Co === "middle") {
          var Ao = this.getBBoxSnapshot();
          _o = {
            top: ((Eo || 0) - Ao.height) / 2
          };
        } else
          _o = Co === "bottom" ? {
            bottom: So && So.bottom || 0
          } : {
            top: So && So.top || 0
          };
      return _objectSpread$w(_objectSpread$w({}, Ro), _o);
    }
  }, {
    key: "render",
    value: function() {
      var go = this, bo = this.props, vo = bo.content, Po = bo.width, Co = bo.height, So = bo.wrapperStyle, wo = bo.payloadUniqBy, Eo = bo.payload, Ro = _objectSpread$w(_objectSpread$w({
        position: "absolute",
        width: Po || "auto",
        height: Co || "auto"
      }, this.getDefaultPosition(So)), So);
      return /* @__PURE__ */ React__default.createElement("div", {
        className: "recharts-legend-wrapper",
        style: Ro,
        ref: function(Io) {
          go.wrapperNode = Io;
        }
      }, renderContent$1(vo, _objectSpread$w(_objectSpread$w({}, this.props), {}, {
        payload: getUniqPayload(Eo, wo, defaultUniqBy$1)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(go, bo) {
      var vo = _objectSpread$w(_objectSpread$w({}, this.defaultProps), go.props), Po = vo.layout;
      return Po === "vertical" && isNumber(go.props.height) ? {
        height: go.props.height
      } : Po === "horizontal" ? {
        width: go.props.width || bo
      } : null;
    }
  }]);
}(PureComponent);
_defineProperty$C(Legend, "displayName", "Legend");
_defineProperty$C(Legend, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var Symbol$1 = _Symbol, isArguments = isArguments_1, isArray$5 = isArray_1, spreadableSymbol = Symbol$1 ? Symbol$1.isConcatSpreadable : void 0;
function isFlattenable$1(Kt) {
  return isArray$5(Kt) || isArguments(Kt) || !!(spreadableSymbol && Kt && Kt[spreadableSymbol]);
}
var _isFlattenable = isFlattenable$1, arrayPush = _arrayPush, isFlattenable = _isFlattenable;
function baseFlatten$2(Kt, uo, ho, go, bo) {
  var vo = -1, Po = Kt.length;
  for (ho || (ho = isFlattenable), bo || (bo = []); ++vo < Po; ) {
    var Co = Kt[vo];
    uo > 0 && ho(Co) ? uo > 1 ? baseFlatten$2(Co, uo - 1, ho, go, bo) : arrayPush(bo, Co) : go || (bo[bo.length] = Co);
  }
  return bo;
}
var _baseFlatten = baseFlatten$2;
function createBaseFor$1(Kt) {
  return function(uo, ho, go) {
    for (var bo = -1, vo = Object(uo), Po = go(uo), Co = Po.length; Co--; ) {
      var So = Po[Kt ? Co : ++bo];
      if (ho(vo[So], So, vo) === !1)
        break;
    }
    return uo;
  };
}
var _createBaseFor = createBaseFor$1, createBaseFor = _createBaseFor, baseFor$1 = createBaseFor(), _baseFor = baseFor$1, baseFor = _baseFor, keys$2 = keys_1;
function baseForOwn$2(Kt, uo) {
  return Kt && baseFor(Kt, uo, keys$2);
}
var _baseForOwn = baseForOwn$2, isArrayLike$3 = isArrayLike_1;
function createBaseEach$1(Kt, uo) {
  return function(ho, go) {
    if (ho == null)
      return ho;
    if (!isArrayLike$3(ho))
      return Kt(ho, go);
    for (var bo = ho.length, vo = uo ? bo : -1, Po = Object(ho); (uo ? vo-- : ++vo < bo) && go(Po[vo], vo, Po) !== !1; )
      ;
    return ho;
  };
}
var _createBaseEach = createBaseEach$1, baseForOwn$1 = _baseForOwn, createBaseEach = _createBaseEach, baseEach$3 = createBaseEach(baseForOwn$1), _baseEach = baseEach$3, baseEach$2 = _baseEach, isArrayLike$2 = isArrayLike_1;
function baseMap$2(Kt, uo) {
  var ho = -1, go = isArrayLike$2(Kt) ? Array(Kt.length) : [];
  return baseEach$2(Kt, function(bo, vo, Po) {
    go[++ho] = uo(bo, vo, Po);
  }), go;
}
var _baseMap = baseMap$2;
function baseSortBy$1(Kt, uo) {
  var ho = Kt.length;
  for (Kt.sort(uo); ho--; )
    Kt[ho] = Kt[ho].value;
  return Kt;
}
var _baseSortBy = baseSortBy$1, isSymbol$2 = isSymbol_1;
function compareAscending$1(Kt, uo) {
  if (Kt !== uo) {
    var ho = Kt !== void 0, go = Kt === null, bo = Kt === Kt, vo = isSymbol$2(Kt), Po = uo !== void 0, Co = uo === null, So = uo === uo, wo = isSymbol$2(uo);
    if (!Co && !wo && !vo && Kt > uo || vo && Po && So && !Co && !wo || go && Po && So || !ho && So || !bo)
      return 1;
    if (!go && !vo && !wo && Kt < uo || wo && ho && bo && !go && !vo || Co && ho && bo || !Po && bo || !So)
      return -1;
  }
  return 0;
}
var _compareAscending = compareAscending$1, compareAscending = _compareAscending;
function compareMultiple$1(Kt, uo, ho) {
  for (var go = -1, bo = Kt.criteria, vo = uo.criteria, Po = bo.length, Co = ho.length; ++go < Po; ) {
    var So = compareAscending(bo[go], vo[go]);
    if (So) {
      if (go >= Co)
        return So;
      var wo = ho[go];
      return So * (wo == "desc" ? -1 : 1);
    }
  }
  return Kt.index - uo.index;
}
var _compareMultiple = compareMultiple$1, arrayMap$1 = _arrayMap, baseGet = _baseGet, baseIteratee$6 = _baseIteratee, baseMap$1 = _baseMap, baseSortBy = _baseSortBy, baseUnary = _baseUnary, compareMultiple = _compareMultiple, identity$9 = identity_1, isArray$4 = isArray_1;
function baseOrderBy$1(Kt, uo, ho) {
  uo.length ? uo = arrayMap$1(uo, function(vo) {
    return isArray$4(vo) ? function(Po) {
      return baseGet(Po, vo.length === 1 ? vo[0] : vo);
    } : vo;
  }) : uo = [identity$9];
  var go = -1;
  uo = arrayMap$1(uo, baseUnary(baseIteratee$6));
  var bo = baseMap$1(Kt, function(vo, Po, Co) {
    var So = arrayMap$1(uo, function(wo) {
      return wo(vo);
    });
    return { criteria: So, index: ++go, value: vo };
  });
  return baseSortBy(bo, function(vo, Po) {
    return compareMultiple(vo, Po, ho);
  });
}
var _baseOrderBy = baseOrderBy$1;
function apply$1(Kt, uo, ho) {
  switch (ho.length) {
    case 0:
      return Kt.call(uo);
    case 1:
      return Kt.call(uo, ho[0]);
    case 2:
      return Kt.call(uo, ho[0], ho[1]);
    case 3:
      return Kt.call(uo, ho[0], ho[1], ho[2]);
  }
  return Kt.apply(uo, ho);
}
var _apply = apply$1, apply = _apply, nativeMax$3 = Math.max;
function overRest$1(Kt, uo, ho) {
  return uo = nativeMax$3(uo === void 0 ? Kt.length - 1 : uo, 0), function() {
    for (var go = arguments, bo = -1, vo = nativeMax$3(go.length - uo, 0), Po = Array(vo); ++bo < vo; )
      Po[bo] = go[uo + bo];
    bo = -1;
    for (var Co = Array(uo + 1); ++bo < uo; )
      Co[bo] = go[bo];
    return Co[uo] = ho(Po), apply(Kt, this, Co);
  };
}
var _overRest = overRest$1;
function constant$2(Kt) {
  return function() {
    return Kt;
  };
}
var constant_1 = constant$2, getNative = _getNative, defineProperty$2 = function() {
  try {
    var Kt = getNative(Object, "defineProperty");
    return Kt({}, "", {}), Kt;
  } catch {
  }
}(), _defineProperty$B = defineProperty$2, constant$1 = constant_1, defineProperty$1 = _defineProperty$B, identity$8 = identity_1, baseSetToString$1 = defineProperty$1 ? function(Kt, uo) {
  return defineProperty$1(Kt, "toString", {
    configurable: !0,
    enumerable: !1,
    value: constant$1(uo),
    writable: !0
  });
} : identity$8, _baseSetToString = baseSetToString$1, HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut$1(Kt) {
  var uo = 0, ho = 0;
  return function() {
    var go = nativeNow(), bo = HOT_SPAN - (go - ho);
    if (ho = go, bo > 0) {
      if (++uo >= HOT_COUNT)
        return arguments[0];
    } else
      uo = 0;
    return Kt.apply(void 0, arguments);
  };
}
var _shortOut = shortOut$1, baseSetToString = _baseSetToString, shortOut = _shortOut, setToString$1 = shortOut(baseSetToString), _setToString = setToString$1, identity$7 = identity_1, overRest = _overRest, setToString = _setToString;
function baseRest$1(Kt, uo) {
  return setToString(overRest(Kt, uo, identity$7), Kt + "");
}
var _baseRest = baseRest$1, eq = eq_1, isArrayLike$1 = isArrayLike_1, isIndex = _isIndex, isObject$3 = isObject_1;
function isIterateeCall$4(Kt, uo, ho) {
  if (!isObject$3(ho))
    return !1;
  var go = typeof uo;
  return (go == "number" ? isArrayLike$1(ho) && isIndex(uo, ho.length) : go == "string" && uo in ho) ? eq(ho[uo], Kt) : !1;
}
var _isIterateeCall = isIterateeCall$4, baseFlatten$1 = _baseFlatten, baseOrderBy = _baseOrderBy, baseRest = _baseRest, isIterateeCall$3 = _isIterateeCall, sortBy = baseRest(function(Kt, uo) {
  if (Kt == null)
    return [];
  var ho = uo.length;
  return ho > 1 && isIterateeCall$3(Kt, uo[0], uo[1]) ? uo = [] : ho > 2 && isIterateeCall$3(uo[0], uo[1], uo[2]) && (uo = [uo[0]]), baseOrderBy(Kt, baseFlatten$1(uo, 1), []);
}), sortBy_1 = sortBy;
const sortBy$1 = /* @__PURE__ */ getDefaultExportFromCjs(sortBy_1);
function _typeof$D(Kt) {
  "@babel/helpers - typeof";
  return _typeof$D = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$D(Kt);
}
function _extends$l() {
  return _extends$l = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$l.apply(this, arguments);
}
function _slicedToArray$b(Kt, uo) {
  return _arrayWithHoles$c(Kt) || _iterableToArrayLimit$b(Kt, uo) || _unsupportedIterableToArray$i(Kt, uo) || _nonIterableRest$c();
}
function _nonIterableRest$c() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$i(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$i(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$i(Kt, uo);
  }
}
function _arrayLikeToArray$i(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$b(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$c(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function ownKeys$v(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$v(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$v(Object(ho), !0).forEach(function(go) {
      _defineProperty$A(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$v(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$A(Kt, uo, ho) {
  return uo = _toPropertyKey$B(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$B(Kt) {
  var uo = _toPrimitive$B(Kt, "string");
  return _typeof$D(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$B(Kt, uo) {
  if (_typeof$D(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$D(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function defaultFormatter(Kt) {
  return Array.isArray(Kt) && isNumOrStr(Kt[0]) && isNumOrStr(Kt[1]) ? Kt.join(" ~ ") : Kt;
}
var DefaultTooltipContent = function(uo) {
  var ho = uo.separator, go = ho === void 0 ? " : " : ho, bo = uo.contentStyle, vo = bo === void 0 ? {} : bo, Po = uo.itemStyle, Co = Po === void 0 ? {} : Po, So = uo.labelStyle, wo = So === void 0 ? {} : So, Eo = uo.payload, Ro = uo.formatter, _o = uo.itemSorter, Io = uo.wrapperClassName, Ao = uo.labelClassName, Oo = uo.label, jo = uo.labelFormatter, Do = uo.accessibilityLayer, Lo = Do === void 0 ? !1 : Do, ko = function() {
    if (Eo && Eo.length) {
      var ii = {
        padding: 0,
        margin: 0
      }, ai = (_o ? sortBy$1(Eo, _o) : Eo).map(function(ri, ni) {
        if (ri.type === "none")
          return null;
        var si = _objectSpread$v({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: ri.color || "#000"
        }, Co), li = ri.formatter || Ro || defaultFormatter, ui = ri.value, ci = ri.name, fi = ui, yi = ci;
        if (fi != null && yi != null) {
          var hi = li(ui, ci, ri, ni, Eo);
          if (Array.isArray(hi)) {
            var mi = _slicedToArray$b(hi, 2);
            fi = mi[0], yi = mi[1];
          } else
            fi = hi;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ React__default.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(ni),
            style: si
          }, isNumOrStr(yi) ? /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, yi) : null, isNumOrStr(yi) ? /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, go) : null, /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, fi), /* @__PURE__ */ React__default.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, ri.unit || ""))
        );
      });
      return /* @__PURE__ */ React__default.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: ii
      }, ai);
    }
    return null;
  }, Ko = _objectSpread$v({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, vo), No = _objectSpread$v({
    margin: 0
  }, wo), Jo = !isNil$1(Oo), ti = Jo ? Oo : "", oi = clsx("recharts-default-tooltip", Io), Qo = clsx("recharts-tooltip-label", Ao);
  Jo && jo && Eo !== void 0 && Eo !== null && (ti = jo(Oo, Eo));
  var Zo = Lo ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ React__default.createElement("div", _extends$l({
    className: oi,
    style: Ko
  }, Zo), /* @__PURE__ */ React__default.createElement("p", {
    className: Qo,
    style: No
  }, /* @__PURE__ */ React__default.isValidElement(ti) ? ti : "".concat(ti)), ko());
};
function _typeof$C(Kt) {
  "@babel/helpers - typeof";
  return _typeof$C = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$C(Kt);
}
function _defineProperty$z(Kt, uo, ho) {
  return uo = _toPropertyKey$A(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$A(Kt) {
  var uo = _toPrimitive$A(Kt, "string");
  return _typeof$C(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$A(Kt, uo) {
  if (_typeof$C(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$C(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var CSS_CLASS_PREFIX = "recharts-tooltip-wrapper", TOOLTIP_HIDDEN = {
  visibility: "hidden"
};
function getTooltipCSSClassName(Kt) {
  var uo = Kt.coordinate, ho = Kt.translateX, go = Kt.translateY;
  return clsx(CSS_CLASS_PREFIX, _defineProperty$z(_defineProperty$z(_defineProperty$z(_defineProperty$z({}, "".concat(CSS_CLASS_PREFIX, "-right"), isNumber(ho) && uo && isNumber(uo.x) && ho >= uo.x), "".concat(CSS_CLASS_PREFIX, "-left"), isNumber(ho) && uo && isNumber(uo.x) && ho < uo.x), "".concat(CSS_CLASS_PREFIX, "-bottom"), isNumber(go) && uo && isNumber(uo.y) && go >= uo.y), "".concat(CSS_CLASS_PREFIX, "-top"), isNumber(go) && uo && isNumber(uo.y) && go < uo.y));
}
function getTooltipTranslateXY(Kt) {
  var uo = Kt.allowEscapeViewBox, ho = Kt.coordinate, go = Kt.key, bo = Kt.offsetTopLeft, vo = Kt.position, Po = Kt.reverseDirection, Co = Kt.tooltipDimension, So = Kt.viewBox, wo = Kt.viewBoxDimension;
  if (vo && isNumber(vo[go]))
    return vo[go];
  var Eo = ho[go] - Co - bo, Ro = ho[go] + bo;
  if (uo[go])
    return Po[go] ? Eo : Ro;
  if (Po[go]) {
    var _o = Eo, Io = So[go];
    return _o < Io ? Math.max(Ro, So[go]) : Math.max(Eo, So[go]);
  }
  var Ao = Ro + Co, Oo = So[go] + wo;
  return Ao > Oo ? Math.max(Eo, So[go]) : Math.max(Ro, So[go]);
}
function getTransformStyle(Kt) {
  var uo = Kt.translateX, ho = Kt.translateY, go = Kt.useTranslate3d;
  return {
    transform: go ? "translate3d(".concat(uo, "px, ").concat(ho, "px, 0)") : "translate(".concat(uo, "px, ").concat(ho, "px)")
  };
}
function getTooltipTranslate(Kt) {
  var uo = Kt.allowEscapeViewBox, ho = Kt.coordinate, go = Kt.offsetTopLeft, bo = Kt.position, vo = Kt.reverseDirection, Po = Kt.tooltipBox, Co = Kt.useTranslate3d, So = Kt.viewBox, wo, Eo, Ro;
  return Po.height > 0 && Po.width > 0 && ho ? (Eo = getTooltipTranslateXY({
    allowEscapeViewBox: uo,
    coordinate: ho,
    key: "x",
    offsetTopLeft: go,
    position: bo,
    reverseDirection: vo,
    tooltipDimension: Po.width,
    viewBox: So,
    viewBoxDimension: So.width
  }), Ro = getTooltipTranslateXY({
    allowEscapeViewBox: uo,
    coordinate: ho,
    key: "y",
    offsetTopLeft: go,
    position: bo,
    reverseDirection: vo,
    tooltipDimension: Po.height,
    viewBox: So,
    viewBoxDimension: So.height
  }), wo = getTransformStyle({
    translateX: Eo,
    translateY: Ro,
    useTranslate3d: Co
  })) : wo = TOOLTIP_HIDDEN, {
    cssProperties: wo,
    cssClasses: getTooltipCSSClassName({
      translateX: Eo,
      translateY: Ro,
      coordinate: ho
    })
  };
}
function _typeof$B(Kt) {
  "@babel/helpers - typeof";
  return _typeof$B = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$B(Kt);
}
function ownKeys$u(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$u(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$u(Object(ho), !0).forEach(function(go) {
      _defineProperty$y(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$u(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$f(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$f(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$z(go.key), go);
  }
}
function _createClass$f(Kt, uo, ho) {
  return _defineProperties$f(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$b(Kt, uo, ho) {
  return uo = _getPrototypeOf$c(uo), _possibleConstructorReturn$c(Kt, _isNativeReflectConstruct$c() ? Reflect.construct(uo, ho, _getPrototypeOf$c(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$c(Kt, uo) {
  if (uo && (_typeof$B(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$c(Kt);
}
function _assertThisInitialized$c(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$c() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$c = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$c(Kt) {
  return _getPrototypeOf$c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$c(Kt);
}
function _inherits$c(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$c(Kt, uo);
}
function _setPrototypeOf$c(Kt, uo) {
  return _setPrototypeOf$c = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$c(Kt, uo);
}
function _defineProperty$y(Kt, uo, ho) {
  return uo = _toPropertyKey$z(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$z(Kt) {
  var uo = _toPrimitive$z(Kt, "string");
  return _typeof$B(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$z(Kt, uo) {
  if (_typeof$B(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo);
    if (_typeof$B(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Kt);
}
var EPSILON = 1, TooltipBoundingBox = /* @__PURE__ */ function(Kt) {
  function uo() {
    var ho;
    _classCallCheck$f(this, uo);
    for (var go = arguments.length, bo = new Array(go), vo = 0; vo < go; vo++)
      bo[vo] = arguments[vo];
    return ho = _callSuper$b(this, uo, [].concat(bo)), _defineProperty$y(ho, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), _defineProperty$y(ho, "handleKeyDown", function(Po) {
      if (Po.key === "Escape") {
        var Co, So, wo, Eo;
        ho.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (Co = (So = ho.props.coordinate) === null || So === void 0 ? void 0 : So.x) !== null && Co !== void 0 ? Co : 0,
            y: (wo = (Eo = ho.props.coordinate) === null || Eo === void 0 ? void 0 : Eo.y) !== null && wo !== void 0 ? wo : 0
          }
        });
      }
    }), ho;
  }
  return _inherits$c(uo, Kt), _createClass$f(uo, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var go = this.wrapperNode.getBoundingClientRect();
        (Math.abs(go.width - this.state.lastBoundingBox.width) > EPSILON || Math.abs(go.height - this.state.lastBoundingBox.height) > EPSILON) && this.setState({
          lastBoundingBox: {
            width: go.width,
            height: go.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var go, bo;
      this.props.active && this.updateBBox(), this.state.dismissed && (((go = this.props.coordinate) === null || go === void 0 ? void 0 : go.x) !== this.state.dismissedAtCoordinate.x || ((bo = this.props.coordinate) === null || bo === void 0 ? void 0 : bo.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var go = this, bo = this.props, vo = bo.active, Po = bo.allowEscapeViewBox, Co = bo.animationDuration, So = bo.animationEasing, wo = bo.children, Eo = bo.coordinate, Ro = bo.hasPayload, _o = bo.isAnimationActive, Io = bo.offset, Ao = bo.position, Oo = bo.reverseDirection, jo = bo.useTranslate3d, Do = bo.viewBox, Lo = bo.wrapperStyle, ko = getTooltipTranslate({
        allowEscapeViewBox: Po,
        coordinate: Eo,
        offsetTopLeft: Io,
        position: Ao,
        reverseDirection: Oo,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: jo,
        viewBox: Do
      }), Ko = ko.cssClasses, No = ko.cssProperties, Jo = _objectSpread$u(_objectSpread$u({
        transition: _o && vo ? "transform ".concat(Co, "ms ").concat(So) : void 0
      }, No), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && vo && Ro ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, Lo);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ React__default.createElement("div", {
          tabIndex: -1,
          className: Ko,
          style: Jo,
          ref: function(oi) {
            go.wrapperNode = oi;
          }
        }, wo)
      );
    }
  }]);
}(PureComponent), parseIsSsrByDefault = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Global = {
  isSsr: parseIsSsrByDefault(),
  get: function(uo) {
    return Global[uo];
  },
  set: function(uo, ho) {
    if (typeof uo == "string")
      Global[uo] = ho;
    else {
      var go = Object.keys(uo);
      go && go.length && go.forEach(function(bo) {
        Global[bo] = uo[bo];
      });
    }
  }
};
function _typeof$A(Kt) {
  "@babel/helpers - typeof";
  return _typeof$A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$A(Kt);
}
function ownKeys$t(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$t(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$t(Object(ho), !0).forEach(function(go) {
      _defineProperty$x(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$t(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$e(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$e(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$y(go.key), go);
  }
}
function _createClass$e(Kt, uo, ho) {
  return _defineProperties$e(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$a(Kt, uo, ho) {
  return uo = _getPrototypeOf$b(uo), _possibleConstructorReturn$b(Kt, _isNativeReflectConstruct$b() ? Reflect.construct(uo, ho || [], _getPrototypeOf$b(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$b(Kt, uo) {
  if (uo && (_typeof$A(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$b(Kt);
}
function _assertThisInitialized$b(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$b() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$b = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$b(Kt) {
  return _getPrototypeOf$b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$b(Kt);
}
function _inherits$b(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$b(Kt, uo);
}
function _setPrototypeOf$b(Kt, uo) {
  return _setPrototypeOf$b = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$b(Kt, uo);
}
function _defineProperty$x(Kt, uo, ho) {
  return uo = _toPropertyKey$y(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$y(Kt) {
  var uo = _toPrimitive$y(Kt, "string");
  return _typeof$A(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$y(Kt, uo) {
  if (_typeof$A(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$A(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function defaultUniqBy(Kt) {
  return Kt.dataKey;
}
function renderContent(Kt, uo) {
  return /* @__PURE__ */ React__default.isValidElement(Kt) ? /* @__PURE__ */ React__default.cloneElement(Kt, uo) : typeof Kt == "function" ? /* @__PURE__ */ React__default.createElement(Kt, uo) : /* @__PURE__ */ React__default.createElement(DefaultTooltipContent, uo);
}
var Tooltip$1 = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$e(this, uo), _callSuper$a(this, uo, arguments);
  }
  return _inherits$b(uo, Kt), _createClass$e(uo, [{
    key: "render",
    value: function() {
      var go = this, bo = this.props, vo = bo.active, Po = bo.allowEscapeViewBox, Co = bo.animationDuration, So = bo.animationEasing, wo = bo.content, Eo = bo.coordinate, Ro = bo.filterNull, _o = bo.isAnimationActive, Io = bo.offset, Ao = bo.payload, Oo = bo.payloadUniqBy, jo = bo.position, Do = bo.reverseDirection, Lo = bo.useTranslate3d, ko = bo.viewBox, Ko = bo.wrapperStyle, No = Ao ?? [];
      Ro && No.length && (No = getUniqPayload(Ao.filter(function(ti) {
        return ti.value != null && (ti.hide !== !0 || go.props.includeHidden);
      }), Oo, defaultUniqBy));
      var Jo = No.length > 0;
      return /* @__PURE__ */ React__default.createElement(TooltipBoundingBox, {
        allowEscapeViewBox: Po,
        animationDuration: Co,
        animationEasing: So,
        isAnimationActive: _o,
        active: vo,
        coordinate: Eo,
        hasPayload: Jo,
        offset: Io,
        position: jo,
        reverseDirection: Do,
        useTranslate3d: Lo,
        viewBox: ko,
        wrapperStyle: Ko
      }, renderContent(wo, _objectSpread$t(_objectSpread$t({}, this.props), {}, {
        payload: No
      })));
    }
  }]);
}(PureComponent);
_defineProperty$x(Tooltip$1, "displayName", "Tooltip");
_defineProperty$x(Tooltip$1, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Global.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var root = _root, now$1 = function() {
  return root.Date.now();
}, now_1 = now$1, reWhitespace = /\s/;
function trimmedEndIndex$1(Kt) {
  for (var uo = Kt.length; uo-- && reWhitespace.test(Kt.charAt(uo)); )
    ;
  return uo;
}
var _trimmedEndIndex = trimmedEndIndex$1, trimmedEndIndex = _trimmedEndIndex, reTrimStart = /^\s+/;
function baseTrim$1(Kt) {
  return Kt && Kt.slice(0, trimmedEndIndex(Kt) + 1).replace(reTrimStart, "");
}
var _baseTrim = baseTrim$1, baseTrim = _baseTrim, isObject$2 = isObject_1, isSymbol$1 = isSymbol_1, NAN = NaN, reIsBadHex = /^[-+]0x[0-9a-f]+$/i, reIsBinary = /^0b[01]+$/i, reIsOctal = /^0o[0-7]+$/i, freeParseInt = parseInt;
function toNumber$2(Kt) {
  if (typeof Kt == "number")
    return Kt;
  if (isSymbol$1(Kt))
    return NAN;
  if (isObject$2(Kt)) {
    var uo = typeof Kt.valueOf == "function" ? Kt.valueOf() : Kt;
    Kt = isObject$2(uo) ? uo + "" : uo;
  }
  if (typeof Kt != "string")
    return Kt === 0 ? Kt : +Kt;
  Kt = baseTrim(Kt);
  var ho = reIsBinary.test(Kt);
  return ho || reIsOctal.test(Kt) ? freeParseInt(Kt.slice(2), ho ? 2 : 8) : reIsBadHex.test(Kt) ? NAN : +Kt;
}
var toNumber_1 = toNumber$2, isObject$1 = isObject_1, now = now_1, toNumber$1 = toNumber_1, FUNC_ERROR_TEXT$1 = "Expected a function", nativeMax$2 = Math.max, nativeMin = Math.min;
function debounce$1(Kt, uo, ho) {
  var go, bo, vo, Po, Co, So, wo = 0, Eo = !1, Ro = !1, _o = !0;
  if (typeof Kt != "function")
    throw new TypeError(FUNC_ERROR_TEXT$1);
  uo = toNumber$1(uo) || 0, isObject$1(ho) && (Eo = !!ho.leading, Ro = "maxWait" in ho, vo = Ro ? nativeMax$2(toNumber$1(ho.maxWait) || 0, uo) : vo, _o = "trailing" in ho ? !!ho.trailing : _o);
  function Io(Jo) {
    var ti = go, oi = bo;
    return go = bo = void 0, wo = Jo, Po = Kt.apply(oi, ti), Po;
  }
  function Ao(Jo) {
    return wo = Jo, Co = setTimeout(Do, uo), Eo ? Io(Jo) : Po;
  }
  function Oo(Jo) {
    var ti = Jo - So, oi = Jo - wo, Qo = uo - ti;
    return Ro ? nativeMin(Qo, vo - oi) : Qo;
  }
  function jo(Jo) {
    var ti = Jo - So, oi = Jo - wo;
    return So === void 0 || ti >= uo || ti < 0 || Ro && oi >= vo;
  }
  function Do() {
    var Jo = now();
    if (jo(Jo))
      return Lo(Jo);
    Co = setTimeout(Do, Oo(Jo));
  }
  function Lo(Jo) {
    return Co = void 0, _o && go ? Io(Jo) : (go = bo = void 0, Po);
  }
  function ko() {
    Co !== void 0 && clearTimeout(Co), wo = 0, go = So = bo = Co = void 0;
  }
  function Ko() {
    return Co === void 0 ? Po : Lo(now());
  }
  function No() {
    var Jo = now(), ti = jo(Jo);
    if (go = arguments, bo = this, So = Jo, ti) {
      if (Co === void 0)
        return Ao(So);
      if (Ro)
        return clearTimeout(Co), Co = setTimeout(Do, uo), Io(So);
    }
    return Co === void 0 && (Co = setTimeout(Do, uo)), Po;
  }
  return No.cancel = ko, No.flush = Ko, No;
}
var debounce_1 = debounce$1, debounce = debounce_1, isObject = isObject_1, FUNC_ERROR_TEXT = "Expected a function";
function throttle(Kt, uo, ho) {
  var go = !0, bo = !0;
  if (typeof Kt != "function")
    throw new TypeError(FUNC_ERROR_TEXT);
  return isObject(ho) && (go = "leading" in ho ? !!ho.leading : go, bo = "trailing" in ho ? !!ho.trailing : bo), debounce(Kt, uo, {
    leading: go,
    maxWait: uo,
    trailing: bo
  });
}
var throttle_1 = throttle;
const throttle$1 = /* @__PURE__ */ getDefaultExportFromCjs(throttle_1);
function _typeof$z(Kt) {
  "@babel/helpers - typeof";
  return _typeof$z = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$z(Kt);
}
function ownKeys$s(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$s(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$s(Object(ho), !0).forEach(function(go) {
      _defineProperty$w(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$s(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$w(Kt, uo, ho) {
  return uo = _toPropertyKey$x(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$x(Kt) {
  var uo = _toPrimitive$x(Kt, "string");
  return _typeof$z(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$x(Kt, uo) {
  if (_typeof$z(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$z(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _slicedToArray$a(Kt, uo) {
  return _arrayWithHoles$b(Kt) || _iterableToArrayLimit$a(Kt, uo) || _unsupportedIterableToArray$h(Kt, uo) || _nonIterableRest$b();
}
function _nonIterableRest$b() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$h(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$h(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$h(Kt, uo);
  }
}
function _arrayLikeToArray$h(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$a(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$b(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
var ResponsiveContainer = /* @__PURE__ */ forwardRef$1(function(Kt, uo) {
  var ho = Kt.aspect, go = Kt.initialDimension, bo = go === void 0 ? {
    width: -1,
    height: -1
  } : go, vo = Kt.width, Po = vo === void 0 ? "100%" : vo, Co = Kt.height, So = Co === void 0 ? "100%" : Co, wo = Kt.minWidth, Eo = wo === void 0 ? 0 : wo, Ro = Kt.minHeight, _o = Kt.maxHeight, Io = Kt.children, Ao = Kt.debounce, Oo = Ao === void 0 ? 0 : Ao, jo = Kt.id, Do = Kt.className, Lo = Kt.onResize, ko = Kt.style, Ko = ko === void 0 ? {} : ko, No = useRef(null), Jo = useRef();
  Jo.current = Lo, useImperativeHandle(uo, function() {
    return Object.defineProperty(No.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), No.current;
      },
      configurable: !0
    });
  });
  var ti = useState({
    containerWidth: bo.width,
    containerHeight: bo.height
  }), oi = _slicedToArray$a(ti, 2), Qo = oi[0], Zo = oi[1], ei = useCallback(function(ai, ri) {
    Zo(function(ni) {
      var si = Math.round(ai), li = Math.round(ri);
      return ni.containerWidth === si && ni.containerHeight === li ? ni : {
        containerWidth: si,
        containerHeight: li
      };
    });
  }, []);
  useEffect(function() {
    var ai = function(ci) {
      var fi, yi = ci[0].contentRect, hi = yi.width, mi = yi.height;
      ei(hi, mi), (fi = Jo.current) === null || fi === void 0 || fi.call(Jo, hi, mi);
    };
    Oo > 0 && (ai = throttle$1(ai, Oo, {
      trailing: !0,
      leading: !1
    }));
    var ri = new ResizeObserver(ai), ni = No.current.getBoundingClientRect(), si = ni.width, li = ni.height;
    return ei(si, li), ri.observe(No.current), function() {
      ri.disconnect();
    };
  }, [ei, Oo]);
  var ii = useMemo(function() {
    var ai = Qo.containerWidth, ri = Qo.containerHeight;
    if (ai < 0 || ri < 0)
      return null;
    warn$1(isPercent(Po) || isPercent(So), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, Po, So), warn$1(!ho || ho > 0, "The aspect(%s) must be greater than zero.", ho);
    var ni = isPercent(Po) ? ai : Po, si = isPercent(So) ? ri : So;
    ho && ho > 0 && (ni ? si = ni / ho : si && (ni = si * ho), _o && si > _o && (si = _o)), warn$1(ni > 0 || si > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, ni, si, Po, So, Eo, Ro, ho);
    var li = !Array.isArray(Io) && getDisplayName(Io.type).endsWith("Chart");
    return React__default.Children.map(Io, function(ui) {
      return /* @__PURE__ */ React__default.isValidElement(ui) ? /* @__PURE__ */ cloneElement(ui, _objectSpread$s({
        width: ni,
        height: si
      }, li ? {
        style: _objectSpread$s({
          height: "100%",
          width: "100%",
          maxHeight: si,
          maxWidth: ni
        }, ui.props.style)
      } : {})) : ui;
    });
  }, [ho, Io, So, _o, Ro, Eo, Qo, Po]);
  return /* @__PURE__ */ React__default.createElement("div", {
    id: jo ? "".concat(jo) : void 0,
    className: clsx("recharts-responsive-container", Do),
    style: _objectSpread$s(_objectSpread$s({}, Ko), {}, {
      width: Po,
      height: So,
      minWidth: Eo,
      minHeight: Ro,
      maxHeight: _o
    }),
    ref: No
  }, ii);
}), Cell = function(uo) {
  return null;
};
Cell.displayName = "Cell";
function _typeof$y(Kt) {
  "@babel/helpers - typeof";
  return _typeof$y = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$y(Kt);
}
function ownKeys$r(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$r(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$r(Object(ho), !0).forEach(function(go) {
      _defineProperty$v(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$r(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$v(Kt, uo, ho) {
  return uo = _toPropertyKey$w(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$w(Kt) {
  var uo = _toPrimitive$w(Kt, "string");
  return _typeof$y(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$w(Kt, uo) {
  if (_typeof$y(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$y(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var stringCache = {
  widthCache: {},
  cacheCount: 0
}, MAX_CACHE_NUM = 2e3, SPAN_STYLE = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function removeInvalidKeys(Kt) {
  var uo = _objectSpread$r({}, Kt);
  return Object.keys(uo).forEach(function(ho) {
    uo[ho] || delete uo[ho];
  }), uo;
}
var getStringSize = function(uo) {
  var ho = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (uo == null || Global.isSsr)
    return {
      width: 0,
      height: 0
    };
  var go = removeInvalidKeys(ho), bo = JSON.stringify({
    text: uo,
    copyStyle: go
  });
  if (stringCache.widthCache[bo])
    return stringCache.widthCache[bo];
  try {
    var vo = document.getElementById(MEASUREMENT_SPAN_ID);
    vo || (vo = document.createElement("span"), vo.setAttribute("id", MEASUREMENT_SPAN_ID), vo.setAttribute("aria-hidden", "true"), document.body.appendChild(vo));
    var Po = _objectSpread$r(_objectSpread$r({}, SPAN_STYLE), go);
    Object.assign(vo.style, Po), vo.textContent = "".concat(uo);
    var Co = vo.getBoundingClientRect(), So = {
      width: Co.width,
      height: Co.height
    };
    return stringCache.widthCache[bo] = So, ++stringCache.cacheCount > MAX_CACHE_NUM && (stringCache.cacheCount = 0, stringCache.widthCache = {}), So;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, getOffset = function(uo) {
  return {
    top: uo.top + window.scrollY - document.documentElement.clientTop,
    left: uo.left + window.scrollX - document.documentElement.clientLeft
  };
};
function _typeof$x(Kt) {
  "@babel/helpers - typeof";
  return _typeof$x = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$x(Kt);
}
function _slicedToArray$9(Kt, uo) {
  return _arrayWithHoles$a(Kt) || _iterableToArrayLimit$9(Kt, uo) || _unsupportedIterableToArray$g(Kt, uo) || _nonIterableRest$a();
}
function _nonIterableRest$a() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$g(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$g(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$g(Kt, uo);
  }
}
function _arrayLikeToArray$g(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$9(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo === 0) {
        if (Object(ho) !== ho) return;
        So = !1;
      } else for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$a(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function _classCallCheck$d(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$d(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$v(go.key), go);
  }
}
function _createClass$d(Kt, uo, ho) {
  return _defineProperties$d(Kt.prototype, uo), _defineProperties$d(Kt, ho), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _toPropertyKey$v(Kt) {
  var uo = _toPrimitive$v(Kt, "string");
  return _typeof$x(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$v(Kt, uo) {
  if (_typeof$x(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo);
    if (_typeof$x(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Kt);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, CONVERSION_RATES = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, FIXED_CSS_LENGTH_UNITS = Object.keys(CONVERSION_RATES), STR_NAN = "NaN";
function convertToPx(Kt, uo) {
  return Kt * CONVERSION_RATES[uo];
}
var DecimalCSS = /* @__PURE__ */ function() {
  function Kt(uo, ho) {
    _classCallCheck$d(this, Kt), this.num = uo, this.unit = ho, this.num = uo, this.unit = ho, Number.isNaN(uo) && (this.unit = ""), ho !== "" && !CSS_LENGTH_UNIT_REGEX.test(ho) && (this.num = NaN, this.unit = ""), FIXED_CSS_LENGTH_UNITS.includes(ho) && (this.num = convertToPx(uo, ho), this.unit = "px");
  }
  return _createClass$d(Kt, [{
    key: "add",
    value: function(ho) {
      return this.unit !== ho.unit ? new Kt(NaN, "") : new Kt(this.num + ho.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(ho) {
      return this.unit !== ho.unit ? new Kt(NaN, "") : new Kt(this.num - ho.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(ho) {
      return this.unit !== "" && ho.unit !== "" && this.unit !== ho.unit ? new Kt(NaN, "") : new Kt(this.num * ho.num, this.unit || ho.unit);
    }
  }, {
    key: "divide",
    value: function(ho) {
      return this.unit !== "" && ho.unit !== "" && this.unit !== ho.unit ? new Kt(NaN, "") : new Kt(this.num / ho.num, this.unit || ho.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(ho) {
      var go, bo = (go = NUM_SPLIT_REGEX.exec(ho)) !== null && go !== void 0 ? go : [], vo = _slicedToArray$9(bo, 3), Po = vo[1], Co = vo[2];
      return new Kt(parseFloat(Po), Co ?? "");
    }
  }]);
}();
function calculateArithmetic(Kt) {
  if (Kt.includes(STR_NAN))
    return STR_NAN;
  for (var uo = Kt; uo.includes("*") || uo.includes("/"); ) {
    var ho, go = (ho = MULTIPLY_OR_DIVIDE_REGEX.exec(uo)) !== null && ho !== void 0 ? ho : [], bo = _slicedToArray$9(go, 4), vo = bo[1], Po = bo[2], Co = bo[3], So = DecimalCSS.parse(vo ?? ""), wo = DecimalCSS.parse(Co ?? ""), Eo = Po === "*" ? So.multiply(wo) : So.divide(wo);
    if (Eo.isNaN())
      return STR_NAN;
    uo = uo.replace(MULTIPLY_OR_DIVIDE_REGEX, Eo.toString());
  }
  for (; uo.includes("+") || /.-\d+(?:\.\d+)?/.test(uo); ) {
    var Ro, _o = (Ro = ADD_OR_SUBTRACT_REGEX.exec(uo)) !== null && Ro !== void 0 ? Ro : [], Io = _slicedToArray$9(_o, 4), Ao = Io[1], Oo = Io[2], jo = Io[3], Do = DecimalCSS.parse(Ao ?? ""), Lo = DecimalCSS.parse(jo ?? ""), ko = Oo === "+" ? Do.add(Lo) : Do.subtract(Lo);
    if (ko.isNaN())
      return STR_NAN;
    uo = uo.replace(ADD_OR_SUBTRACT_REGEX, ko.toString());
  }
  return uo;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(Kt) {
  for (var uo = Kt; uo.includes("("); ) {
    var ho = PARENTHESES_REGEX.exec(uo), go = _slicedToArray$9(ho, 2), bo = go[1];
    uo = uo.replace(PARENTHESES_REGEX, calculateArithmetic(bo));
  }
  return uo;
}
function evaluateExpression(Kt) {
  var uo = Kt.replace(/\s+/g, "");
  return uo = calculateParentheses(uo), uo = calculateArithmetic(uo), uo;
}
function safeEvaluateExpression(Kt) {
  try {
    return evaluateExpression(Kt);
  } catch {
    return STR_NAN;
  }
}
function reduceCSSCalc(Kt) {
  var uo = safeEvaluateExpression(Kt.slice(5, -1));
  return uo === STR_NAN ? "" : uo;
}
var _excluded$b = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], _excluded2$4 = ["dx", "dy", "angle", "className", "breakAll"];
function _extends$k() {
  return _extends$k = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$k.apply(this, arguments);
}
function _objectWithoutProperties$b(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$b(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$b(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function _slicedToArray$8(Kt, uo) {
  return _arrayWithHoles$9(Kt) || _iterableToArrayLimit$8(Kt, uo) || _unsupportedIterableToArray$f(Kt, uo) || _nonIterableRest$9();
}
function _nonIterableRest$9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$f(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$f(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$f(Kt, uo);
  }
}
function _arrayLikeToArray$f(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$8(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo === 0) {
        if (Object(ho) !== ho) return;
        So = !1;
      } else for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$9(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/, calculateWordWidths = function(uo) {
  var ho = uo.children, go = uo.breakAll, bo = uo.style;
  try {
    var vo = [];
    isNil$1(ho) || (go ? vo = ho.toString().split("") : vo = ho.toString().split(BREAKING_SPACES));
    var Po = vo.map(function(So) {
      return {
        word: So,
        width: getStringSize(So, bo).width
      };
    }), Co = go ? 0 : getStringSize(" ", bo).width;
    return {
      wordsWithComputedWidth: Po,
      spaceWidth: Co
    };
  } catch {
    return null;
  }
}, calculateWordsByLines = function(uo, ho, go, bo, vo) {
  var Po = uo.maxLines, Co = uo.children, So = uo.style, wo = uo.breakAll, Eo = isNumber(Po), Ro = Co, _o = function() {
    var ni = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return ni.reduce(function(si, li) {
      var ui = li.word, ci = li.width, fi = si[si.length - 1];
      if (fi && (bo == null || vo || fi.width + ci + go < Number(bo)))
        fi.words.push(ui), fi.width += ci + go;
      else {
        var yi = {
          words: [ui],
          width: ci
        };
        si.push(yi);
      }
      return si;
    }, []);
  }, Io = _o(ho), Ao = function(ni) {
    return ni.reduce(function(si, li) {
      return si.width > li.width ? si : li;
    });
  };
  if (!Eo)
    return Io;
  for (var Oo = "…", jo = function(ni) {
    var si = Ro.slice(0, ni), li = calculateWordWidths({
      breakAll: wo,
      style: So,
      children: si + Oo
    }).wordsWithComputedWidth, ui = _o(li), ci = ui.length > Po || Ao(ui).width > Number(bo);
    return [ci, ui];
  }, Do = 0, Lo = Ro.length - 1, ko = 0, Ko; Do <= Lo && ko <= Ro.length - 1; ) {
    var No = Math.floor((Do + Lo) / 2), Jo = No - 1, ti = jo(Jo), oi = _slicedToArray$8(ti, 2), Qo = oi[0], Zo = oi[1], ei = jo(No), ii = _slicedToArray$8(ei, 1), ai = ii[0];
    if (!Qo && !ai && (Do = No + 1), Qo && ai && (Lo = No - 1), !Qo && ai) {
      Ko = Zo;
      break;
    }
    ko++;
  }
  return Ko || Io;
}, getWordsWithoutCalculate = function(uo) {
  var ho = isNil$1(uo) ? [] : uo.toString().split(BREAKING_SPACES);
  return [{
    words: ho
  }];
}, getWordsByLines = function(uo) {
  var ho = uo.width, go = uo.scaleToFit, bo = uo.children, vo = uo.style, Po = uo.breakAll, Co = uo.maxLines;
  if ((ho || go) && !Global.isSsr) {
    var So, wo, Eo = calculateWordWidths({
      breakAll: Po,
      children: bo,
      style: vo
    });
    if (Eo) {
      var Ro = Eo.wordsWithComputedWidth, _o = Eo.spaceWidth;
      So = Ro, wo = _o;
    } else
      return getWordsWithoutCalculate(bo);
    return calculateWordsByLines({
      breakAll: Po,
      children: bo,
      maxLines: Co,
      style: vo
    }, So, wo, ho, go);
  }
  return getWordsWithoutCalculate(bo);
}, DEFAULT_FILL = "#808080", Text = function(uo) {
  var ho = uo.x, go = ho === void 0 ? 0 : ho, bo = uo.y, vo = bo === void 0 ? 0 : bo, Po = uo.lineHeight, Co = Po === void 0 ? "1em" : Po, So = uo.capHeight, wo = So === void 0 ? "0.71em" : So, Eo = uo.scaleToFit, Ro = Eo === void 0 ? !1 : Eo, _o = uo.textAnchor, Io = _o === void 0 ? "start" : _o, Ao = uo.verticalAnchor, Oo = Ao === void 0 ? "end" : Ao, jo = uo.fill, Do = jo === void 0 ? DEFAULT_FILL : jo, Lo = _objectWithoutProperties$b(uo, _excluded$b), ko = useMemo(function() {
    return getWordsByLines({
      breakAll: Lo.breakAll,
      children: Lo.children,
      maxLines: Lo.maxLines,
      scaleToFit: Ro,
      style: Lo.style,
      width: Lo.width
    });
  }, [Lo.breakAll, Lo.children, Lo.maxLines, Ro, Lo.style, Lo.width]), Ko = Lo.dx, No = Lo.dy, Jo = Lo.angle, ti = Lo.className, oi = Lo.breakAll, Qo = _objectWithoutProperties$b(Lo, _excluded2$4);
  if (!isNumOrStr(go) || !isNumOrStr(vo))
    return null;
  var Zo = go + (isNumber(Ko) ? Ko : 0), ei = vo + (isNumber(No) ? No : 0), ii;
  switch (Oo) {
    case "start":
      ii = reduceCSSCalc("calc(".concat(wo, ")"));
      break;
    case "middle":
      ii = reduceCSSCalc("calc(".concat((ko.length - 1) / 2, " * -").concat(Co, " + (").concat(wo, " / 2))"));
      break;
    default:
      ii = reduceCSSCalc("calc(".concat(ko.length - 1, " * -").concat(Co, ")"));
      break;
  }
  var ai = [];
  if (Ro) {
    var ri = ko[0].width, ni = Lo.width;
    ai.push("scale(".concat((isNumber(ni) ? ni / ri : 1) / ri, ")"));
  }
  return Jo && ai.push("rotate(".concat(Jo, ", ").concat(Zo, ", ").concat(ei, ")")), ai.length && (Qo.transform = ai.join(" ")), /* @__PURE__ */ React__default.createElement("text", _extends$k({}, filterProps(Qo, !0), {
    x: Zo,
    y: ei,
    className: clsx("recharts-text", ti),
    textAnchor: Io,
    fill: Do.includes("url") ? DEFAULT_FILL : Do
  }), ko.map(function(si, li) {
    var ui = si.words.join(oi ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ React__default.createElement("tspan", {
        x: Zo,
        dy: li === 0 ? ii : Co,
        key: "".concat(ui, "-").concat(li)
      }, ui)
    );
  }));
};
function ascending(Kt, uo) {
  return Kt == null || uo == null ? NaN : Kt < uo ? -1 : Kt > uo ? 1 : Kt >= uo ? 0 : NaN;
}
function descending(Kt, uo) {
  return Kt == null || uo == null ? NaN : uo < Kt ? -1 : uo > Kt ? 1 : uo >= Kt ? 0 : NaN;
}
function bisector(Kt) {
  let uo, ho, go;
  Kt.length !== 2 ? (uo = ascending, ho = (Co, So) => ascending(Kt(Co), So), go = (Co, So) => Kt(Co) - So) : (uo = Kt === ascending || Kt === descending ? Kt : zero$1, ho = Kt, go = Kt);
  function bo(Co, So, wo = 0, Eo = Co.length) {
    if (wo < Eo) {
      if (uo(So, So) !== 0) return Eo;
      do {
        const Ro = wo + Eo >>> 1;
        ho(Co[Ro], So) < 0 ? wo = Ro + 1 : Eo = Ro;
      } while (wo < Eo);
    }
    return wo;
  }
  function vo(Co, So, wo = 0, Eo = Co.length) {
    if (wo < Eo) {
      if (uo(So, So) !== 0) return Eo;
      do {
        const Ro = wo + Eo >>> 1;
        ho(Co[Ro], So) <= 0 ? wo = Ro + 1 : Eo = Ro;
      } while (wo < Eo);
    }
    return wo;
  }
  function Po(Co, So, wo = 0, Eo = Co.length) {
    const Ro = bo(Co, So, wo, Eo - 1);
    return Ro > wo && go(Co[Ro - 1], So) > -go(Co[Ro], So) ? Ro - 1 : Ro;
  }
  return { left: bo, center: Po, right: vo };
}
function zero$1() {
  return 0;
}
function number$2(Kt) {
  return Kt === null ? NaN : +Kt;
}
function* numbers(Kt, uo) {
  for (let ho of Kt)
    ho != null && (ho = +ho) >= ho && (yield ho);
}
const ascendingBisect = bisector(ascending), bisectRight = ascendingBisect.right;
bisector(number$2).center;
class InternMap extends Map {
  constructor(uo, ho = keyof) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: ho } }), uo != null) for (const [go, bo] of uo) this.set(go, bo);
  }
  get(uo) {
    return super.get(intern_get(this, uo));
  }
  has(uo) {
    return super.has(intern_get(this, uo));
  }
  set(uo, ho) {
    return super.set(intern_set(this, uo), ho);
  }
  delete(uo) {
    return super.delete(intern_delete(this, uo));
  }
}
function intern_get({ _intern: Kt, _key: uo }, ho) {
  const go = uo(ho);
  return Kt.has(go) ? Kt.get(go) : ho;
}
function intern_set({ _intern: Kt, _key: uo }, ho) {
  const go = uo(ho);
  return Kt.has(go) ? Kt.get(go) : (Kt.set(go, ho), ho);
}
function intern_delete({ _intern: Kt, _key: uo }, ho) {
  const go = uo(ho);
  return Kt.has(go) && (ho = Kt.get(go), Kt.delete(go)), ho;
}
function keyof(Kt) {
  return Kt !== null && typeof Kt == "object" ? Kt.valueOf() : Kt;
}
function compareDefined(Kt = ascending) {
  if (Kt === ascending) return ascendingDefined;
  if (typeof Kt != "function") throw new TypeError("compare is not a function");
  return (uo, ho) => {
    const go = Kt(uo, ho);
    return go || go === 0 ? go : (Kt(ho, ho) === 0) - (Kt(uo, uo) === 0);
  };
}
function ascendingDefined(Kt, uo) {
  return (Kt == null || !(Kt >= Kt)) - (uo == null || !(uo >= uo)) || (Kt < uo ? -1 : Kt > uo ? 1 : 0);
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(Kt, uo, ho) {
  const go = (uo - Kt) / Math.max(0, ho), bo = Math.floor(Math.log10(go)), vo = go / Math.pow(10, bo), Po = vo >= e10 ? 10 : vo >= e5 ? 5 : vo >= e2 ? 2 : 1;
  let Co, So, wo;
  return bo < 0 ? (wo = Math.pow(10, -bo) / Po, Co = Math.round(Kt * wo), So = Math.round(uo * wo), Co / wo < Kt && ++Co, So / wo > uo && --So, wo = -wo) : (wo = Math.pow(10, bo) * Po, Co = Math.round(Kt / wo), So = Math.round(uo / wo), Co * wo < Kt && ++Co, So * wo > uo && --So), So < Co && 0.5 <= ho && ho < 2 ? tickSpec(Kt, uo, ho * 2) : [Co, So, wo];
}
function ticks(Kt, uo, ho) {
  if (uo = +uo, Kt = +Kt, ho = +ho, !(ho > 0)) return [];
  if (Kt === uo) return [Kt];
  const go = uo < Kt, [bo, vo, Po] = go ? tickSpec(uo, Kt, ho) : tickSpec(Kt, uo, ho);
  if (!(vo >= bo)) return [];
  const Co = vo - bo + 1, So = new Array(Co);
  if (go)
    if (Po < 0) for (let wo = 0; wo < Co; ++wo) So[wo] = (vo - wo) / -Po;
    else for (let wo = 0; wo < Co; ++wo) So[wo] = (vo - wo) * Po;
  else if (Po < 0) for (let wo = 0; wo < Co; ++wo) So[wo] = (bo + wo) / -Po;
  else for (let wo = 0; wo < Co; ++wo) So[wo] = (bo + wo) * Po;
  return So;
}
function tickIncrement(Kt, uo, ho) {
  return uo = +uo, Kt = +Kt, ho = +ho, tickSpec(Kt, uo, ho)[2];
}
function tickStep(Kt, uo, ho) {
  uo = +uo, Kt = +Kt, ho = +ho;
  const go = uo < Kt, bo = go ? tickIncrement(uo, Kt, ho) : tickIncrement(Kt, uo, ho);
  return (go ? -1 : 1) * (bo < 0 ? 1 / -bo : bo);
}
function max$2(Kt, uo) {
  let ho;
  for (const go of Kt)
    go != null && (ho < go || ho === void 0 && go >= go) && (ho = go);
  return ho;
}
function min$2(Kt, uo) {
  let ho;
  for (const go of Kt)
    go != null && (ho > go || ho === void 0 && go >= go) && (ho = go);
  return ho;
}
function quickselect(Kt, uo, ho = 0, go = 1 / 0, bo) {
  if (uo = Math.floor(uo), ho = Math.floor(Math.max(0, ho)), go = Math.floor(Math.min(Kt.length - 1, go)), !(ho <= uo && uo <= go)) return Kt;
  for (bo = bo === void 0 ? ascendingDefined : compareDefined(bo); go > ho; ) {
    if (go - ho > 600) {
      const So = go - ho + 1, wo = uo - ho + 1, Eo = Math.log(So), Ro = 0.5 * Math.exp(2 * Eo / 3), _o = 0.5 * Math.sqrt(Eo * Ro * (So - Ro) / So) * (wo - So / 2 < 0 ? -1 : 1), Io = Math.max(ho, Math.floor(uo - wo * Ro / So + _o)), Ao = Math.min(go, Math.floor(uo + (So - wo) * Ro / So + _o));
      quickselect(Kt, uo, Io, Ao, bo);
    }
    const vo = Kt[uo];
    let Po = ho, Co = go;
    for (swap(Kt, ho, uo), bo(Kt[go], vo) > 0 && swap(Kt, ho, go); Po < Co; ) {
      for (swap(Kt, Po, Co), ++Po, --Co; bo(Kt[Po], vo) < 0; ) ++Po;
      for (; bo(Kt[Co], vo) > 0; ) --Co;
    }
    bo(Kt[ho], vo) === 0 ? swap(Kt, ho, Co) : (++Co, swap(Kt, Co, go)), Co <= uo && (ho = Co + 1), uo <= Co && (go = Co - 1);
  }
  return Kt;
}
function swap(Kt, uo, ho) {
  const go = Kt[uo];
  Kt[uo] = Kt[ho], Kt[ho] = go;
}
function quantile$1(Kt, uo, ho) {
  if (Kt = Float64Array.from(numbers(Kt)), !(!(go = Kt.length) || isNaN(uo = +uo))) {
    if (uo <= 0 || go < 2) return min$2(Kt);
    if (uo >= 1) return max$2(Kt);
    var go, bo = (go - 1) * uo, vo = Math.floor(bo), Po = max$2(quickselect(Kt, vo).subarray(0, vo + 1)), Co = min$2(Kt.subarray(vo + 1));
    return Po + (Co - Po) * (bo - vo);
  }
}
function quantileSorted(Kt, uo, ho = number$2) {
  if (!(!(go = Kt.length) || isNaN(uo = +uo))) {
    if (uo <= 0 || go < 2) return +ho(Kt[0], 0, Kt);
    if (uo >= 1) return +ho(Kt[go - 1], go - 1, Kt);
    var go, bo = (go - 1) * uo, vo = Math.floor(bo), Po = +ho(Kt[vo], vo, Kt), Co = +ho(Kt[vo + 1], vo + 1, Kt);
    return Po + (Co - Po) * (bo - vo);
  }
}
function range$3(Kt, uo, ho) {
  Kt = +Kt, uo = +uo, ho = (bo = arguments.length) < 2 ? (uo = Kt, Kt = 0, 1) : bo < 3 ? 1 : +ho;
  for (var go = -1, bo = Math.max(0, Math.ceil((uo - Kt) / ho)) | 0, vo = new Array(bo); ++go < bo; )
    vo[go] = Kt + go * ho;
  return vo;
}
function initRange(Kt, uo) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(Kt);
      break;
    default:
      this.range(uo).domain(Kt);
      break;
  }
  return this;
}
function initInterpolator(Kt, uo) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof Kt == "function" ? this.interpolator(Kt) : this.range(Kt);
      break;
    }
    default: {
      this.domain(Kt), typeof uo == "function" ? this.interpolator(uo) : this.range(uo);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var Kt = new InternMap(), uo = [], ho = [], go = implicit;
  function bo(vo) {
    let Po = Kt.get(vo);
    if (Po === void 0) {
      if (go !== implicit) return go;
      Kt.set(vo, Po = uo.push(vo) - 1);
    }
    return ho[Po % ho.length];
  }
  return bo.domain = function(vo) {
    if (!arguments.length) return uo.slice();
    uo = [], Kt = new InternMap();
    for (const Po of vo)
      Kt.has(Po) || Kt.set(Po, uo.push(Po) - 1);
    return bo;
  }, bo.range = function(vo) {
    return arguments.length ? (ho = Array.from(vo), bo) : ho.slice();
  }, bo.unknown = function(vo) {
    return arguments.length ? (go = vo, bo) : go;
  }, bo.copy = function() {
    return ordinal(uo, ho).unknown(go);
  }, initRange.apply(bo, arguments), bo;
}
function band() {
  var Kt = ordinal().unknown(void 0), uo = Kt.domain, ho = Kt.range, go = 0, bo = 1, vo, Po, Co = !1, So = 0, wo = 0, Eo = 0.5;
  delete Kt.unknown;
  function Ro() {
    var _o = uo().length, Io = bo < go, Ao = Io ? bo : go, Oo = Io ? go : bo;
    vo = (Oo - Ao) / Math.max(1, _o - So + wo * 2), Co && (vo = Math.floor(vo)), Ao += (Oo - Ao - vo * (_o - So)) * Eo, Po = vo * (1 - So), Co && (Ao = Math.round(Ao), Po = Math.round(Po));
    var jo = range$3(_o).map(function(Do) {
      return Ao + vo * Do;
    });
    return ho(Io ? jo.reverse() : jo);
  }
  return Kt.domain = function(_o) {
    return arguments.length ? (uo(_o), Ro()) : uo();
  }, Kt.range = function(_o) {
    return arguments.length ? ([go, bo] = _o, go = +go, bo = +bo, Ro()) : [go, bo];
  }, Kt.rangeRound = function(_o) {
    return [go, bo] = _o, go = +go, bo = +bo, Co = !0, Ro();
  }, Kt.bandwidth = function() {
    return Po;
  }, Kt.step = function() {
    return vo;
  }, Kt.round = function(_o) {
    return arguments.length ? (Co = !!_o, Ro()) : Co;
  }, Kt.padding = function(_o) {
    return arguments.length ? (So = Math.min(1, wo = +_o), Ro()) : So;
  }, Kt.paddingInner = function(_o) {
    return arguments.length ? (So = Math.min(1, _o), Ro()) : So;
  }, Kt.paddingOuter = function(_o) {
    return arguments.length ? (wo = +_o, Ro()) : wo;
  }, Kt.align = function(_o) {
    return arguments.length ? (Eo = Math.max(0, Math.min(1, _o)), Ro()) : Eo;
  }, Kt.copy = function() {
    return band(uo(), [go, bo]).round(Co).paddingInner(So).paddingOuter(wo).align(Eo);
  }, initRange.apply(Ro(), arguments);
}
function pointish(Kt) {
  var uo = Kt.copy;
  return Kt.padding = Kt.paddingOuter, delete Kt.paddingInner, delete Kt.paddingOuter, Kt.copy = function() {
    return pointish(uo());
  }, Kt;
}
function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}
function define$1(Kt, uo, ho) {
  Kt.prototype = uo.prototype = ho, ho.constructor = Kt;
}
function extend(Kt, uo) {
  var ho = Object.create(Kt.prototype);
  for (var go in uo) ho[go] = uo[go];
  return ho;
}
function Color() {
}
var darker = 0.7, brighter = 1 / darker, reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`), named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define$1(Color, color, {
  copy(Kt) {
    return Object.assign(new this.constructor(), this, Kt);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(Kt) {
  var uo, ho;
  return Kt = (Kt + "").trim().toLowerCase(), (uo = reHex.exec(Kt)) ? (ho = uo[1].length, uo = parseInt(uo[1], 16), ho === 6 ? rgbn(uo) : ho === 3 ? new Rgb(uo >> 8 & 15 | uo >> 4 & 240, uo >> 4 & 15 | uo & 240, (uo & 15) << 4 | uo & 15, 1) : ho === 8 ? rgba(uo >> 24 & 255, uo >> 16 & 255, uo >> 8 & 255, (uo & 255) / 255) : ho === 4 ? rgba(uo >> 12 & 15 | uo >> 8 & 240, uo >> 8 & 15 | uo >> 4 & 240, uo >> 4 & 15 | uo & 240, ((uo & 15) << 4 | uo & 15) / 255) : null) : (uo = reRgbInteger.exec(Kt)) ? new Rgb(uo[1], uo[2], uo[3], 1) : (uo = reRgbPercent.exec(Kt)) ? new Rgb(uo[1] * 255 / 100, uo[2] * 255 / 100, uo[3] * 255 / 100, 1) : (uo = reRgbaInteger.exec(Kt)) ? rgba(uo[1], uo[2], uo[3], uo[4]) : (uo = reRgbaPercent.exec(Kt)) ? rgba(uo[1] * 255 / 100, uo[2] * 255 / 100, uo[3] * 255 / 100, uo[4]) : (uo = reHslPercent.exec(Kt)) ? hsla(uo[1], uo[2] / 100, uo[3] / 100, 1) : (uo = reHslaPercent.exec(Kt)) ? hsla(uo[1], uo[2] / 100, uo[3] / 100, uo[4]) : named.hasOwnProperty(Kt) ? rgbn(named[Kt]) : Kt === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(Kt) {
  return new Rgb(Kt >> 16 & 255, Kt >> 8 & 255, Kt & 255, 1);
}
function rgba(Kt, uo, ho, go) {
  return go <= 0 && (Kt = uo = ho = NaN), new Rgb(Kt, uo, ho, go);
}
function rgbConvert(Kt) {
  return Kt instanceof Color || (Kt = color(Kt)), Kt ? (Kt = Kt.rgb(), new Rgb(Kt.r, Kt.g, Kt.b, Kt.opacity)) : new Rgb();
}
function rgb$1(Kt, uo, ho, go) {
  return arguments.length === 1 ? rgbConvert(Kt) : new Rgb(Kt, uo, ho, go ?? 1);
}
function Rgb(Kt, uo, ho, go) {
  this.r = +Kt, this.g = +uo, this.b = +ho, this.opacity = +go;
}
define$1(Rgb, rgb$1, extend(Color, {
  brighter(Kt) {
    return Kt = Kt == null ? brighter : Math.pow(brighter, Kt), new Rgb(this.r * Kt, this.g * Kt, this.b * Kt, this.opacity);
  },
  darker(Kt) {
    return Kt = Kt == null ? darker : Math.pow(darker, Kt), new Rgb(this.r * Kt, this.g * Kt, this.b * Kt, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const Kt = clampa(this.opacity);
  return `${Kt === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${Kt === 1 ? ")" : `, ${Kt})`}`;
}
function clampa(Kt) {
  return isNaN(Kt) ? 1 : Math.max(0, Math.min(1, Kt));
}
function clampi(Kt) {
  return Math.max(0, Math.min(255, Math.round(Kt) || 0));
}
function hex(Kt) {
  return Kt = clampi(Kt), (Kt < 16 ? "0" : "") + Kt.toString(16);
}
function hsla(Kt, uo, ho, go) {
  return go <= 0 ? Kt = uo = ho = NaN : ho <= 0 || ho >= 1 ? Kt = uo = NaN : uo <= 0 && (Kt = NaN), new Hsl(Kt, uo, ho, go);
}
function hslConvert(Kt) {
  if (Kt instanceof Hsl) return new Hsl(Kt.h, Kt.s, Kt.l, Kt.opacity);
  if (Kt instanceof Color || (Kt = color(Kt)), !Kt) return new Hsl();
  if (Kt instanceof Hsl) return Kt;
  Kt = Kt.rgb();
  var uo = Kt.r / 255, ho = Kt.g / 255, go = Kt.b / 255, bo = Math.min(uo, ho, go), vo = Math.max(uo, ho, go), Po = NaN, Co = vo - bo, So = (vo + bo) / 2;
  return Co ? (uo === vo ? Po = (ho - go) / Co + (ho < go) * 6 : ho === vo ? Po = (go - uo) / Co + 2 : Po = (uo - ho) / Co + 4, Co /= So < 0.5 ? vo + bo : 2 - vo - bo, Po *= 60) : Co = So > 0 && So < 1 ? 0 : Po, new Hsl(Po, Co, So, Kt.opacity);
}
function hsl(Kt, uo, ho, go) {
  return arguments.length === 1 ? hslConvert(Kt) : new Hsl(Kt, uo, ho, go ?? 1);
}
function Hsl(Kt, uo, ho, go) {
  this.h = +Kt, this.s = +uo, this.l = +ho, this.opacity = +go;
}
define$1(Hsl, hsl, extend(Color, {
  brighter(Kt) {
    return Kt = Kt == null ? brighter : Math.pow(brighter, Kt), new Hsl(this.h, this.s, this.l * Kt, this.opacity);
  },
  darker(Kt) {
    return Kt = Kt == null ? darker : Math.pow(darker, Kt), new Hsl(this.h, this.s, this.l * Kt, this.opacity);
  },
  rgb() {
    var Kt = this.h % 360 + (this.h < 0) * 360, uo = isNaN(Kt) || isNaN(this.s) ? 0 : this.s, ho = this.l, go = ho + (ho < 0.5 ? ho : 1 - ho) * uo, bo = 2 * ho - go;
    return new Rgb(
      hsl2rgb(Kt >= 240 ? Kt - 240 : Kt + 120, bo, go),
      hsl2rgb(Kt, bo, go),
      hsl2rgb(Kt < 120 ? Kt + 240 : Kt - 120, bo, go),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const Kt = clampa(this.opacity);
    return `${Kt === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${Kt === 1 ? ")" : `, ${Kt})`}`;
  }
}));
function clamph(Kt) {
  return Kt = (Kt || 0) % 360, Kt < 0 ? Kt + 360 : Kt;
}
function clampt(Kt) {
  return Math.max(0, Math.min(1, Kt || 0));
}
function hsl2rgb(Kt, uo, ho) {
  return (Kt < 60 ? uo + (ho - uo) * Kt / 60 : Kt < 180 ? ho : Kt < 240 ? uo + (ho - uo) * (240 - Kt) / 60 : uo) * 255;
}
const constant = (Kt) => () => Kt;
function linear$1(Kt, uo) {
  return function(ho) {
    return Kt + ho * uo;
  };
}
function exponential(Kt, uo, ho) {
  return Kt = Math.pow(Kt, ho), uo = Math.pow(uo, ho) - Kt, ho = 1 / ho, function(go) {
    return Math.pow(Kt + go * uo, ho);
  };
}
function gamma(Kt) {
  return (Kt = +Kt) == 1 ? nogamma : function(uo, ho) {
    return ho - uo ? exponential(uo, ho, Kt) : constant(isNaN(uo) ? ho : uo);
  };
}
function nogamma(Kt, uo) {
  var ho = uo - Kt;
  return ho ? linear$1(Kt, ho) : constant(isNaN(Kt) ? uo : Kt);
}
const rgb = function Kt(uo) {
  var ho = gamma(uo);
  function go(bo, vo) {
    var Po = ho((bo = rgb$1(bo)).r, (vo = rgb$1(vo)).r), Co = ho(bo.g, vo.g), So = ho(bo.b, vo.b), wo = nogamma(bo.opacity, vo.opacity);
    return function(Eo) {
      return bo.r = Po(Eo), bo.g = Co(Eo), bo.b = So(Eo), bo.opacity = wo(Eo), bo + "";
    };
  }
  return go.gamma = Kt, go;
}(1);
function numberArray(Kt, uo) {
  uo || (uo = []);
  var ho = Kt ? Math.min(uo.length, Kt.length) : 0, go = uo.slice(), bo;
  return function(vo) {
    for (bo = 0; bo < ho; ++bo) go[bo] = Kt[bo] * (1 - vo) + uo[bo] * vo;
    return go;
  };
}
function isNumberArray(Kt) {
  return ArrayBuffer.isView(Kt) && !(Kt instanceof DataView);
}
function genericArray(Kt, uo) {
  var ho = uo ? uo.length : 0, go = Kt ? Math.min(ho, Kt.length) : 0, bo = new Array(go), vo = new Array(ho), Po;
  for (Po = 0; Po < go; ++Po) bo[Po] = interpolate(Kt[Po], uo[Po]);
  for (; Po < ho; ++Po) vo[Po] = uo[Po];
  return function(Co) {
    for (Po = 0; Po < go; ++Po) vo[Po] = bo[Po](Co);
    return vo;
  };
}
function date$1(Kt, uo) {
  var ho = /* @__PURE__ */ new Date();
  return Kt = +Kt, uo = +uo, function(go) {
    return ho.setTime(Kt * (1 - go) + uo * go), ho;
  };
}
function interpolateNumber$1(Kt, uo) {
  return Kt = +Kt, uo = +uo, function(ho) {
    return Kt * (1 - ho) + uo * ho;
  };
}
function object(Kt, uo) {
  var ho = {}, go = {}, bo;
  (Kt === null || typeof Kt != "object") && (Kt = {}), (uo === null || typeof uo != "object") && (uo = {});
  for (bo in uo)
    bo in Kt ? ho[bo] = interpolate(Kt[bo], uo[bo]) : go[bo] = uo[bo];
  return function(vo) {
    for (bo in ho) go[bo] = ho[bo](vo);
    return go;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(Kt) {
  return function() {
    return Kt;
  };
}
function one(Kt) {
  return function(uo) {
    return Kt(uo) + "";
  };
}
function string(Kt, uo) {
  var ho = reA.lastIndex = reB.lastIndex = 0, go, bo, vo, Po = -1, Co = [], So = [];
  for (Kt = Kt + "", uo = uo + ""; (go = reA.exec(Kt)) && (bo = reB.exec(uo)); )
    (vo = bo.index) > ho && (vo = uo.slice(ho, vo), Co[Po] ? Co[Po] += vo : Co[++Po] = vo), (go = go[0]) === (bo = bo[0]) ? Co[Po] ? Co[Po] += bo : Co[++Po] = bo : (Co[++Po] = null, So.push({ i: Po, x: interpolateNumber$1(go, bo) })), ho = reB.lastIndex;
  return ho < uo.length && (vo = uo.slice(ho), Co[Po] ? Co[Po] += vo : Co[++Po] = vo), Co.length < 2 ? So[0] ? one(So[0].x) : zero(uo) : (uo = So.length, function(wo) {
    for (var Eo = 0, Ro; Eo < uo; ++Eo) Co[(Ro = So[Eo]).i] = Ro.x(wo);
    return Co.join("");
  });
}
function interpolate(Kt, uo) {
  var ho = typeof uo, go;
  return uo == null || ho === "boolean" ? constant(uo) : (ho === "number" ? interpolateNumber$1 : ho === "string" ? (go = color(uo)) ? (uo = go, rgb) : string : uo instanceof color ? rgb : uo instanceof Date ? date$1 : isNumberArray(uo) ? numberArray : Array.isArray(uo) ? genericArray : typeof uo.valueOf != "function" && typeof uo.toString != "function" || isNaN(uo) ? object : interpolateNumber$1)(Kt, uo);
}
function interpolateRound(Kt, uo) {
  return Kt = +Kt, uo = +uo, function(ho) {
    return Math.round(Kt * (1 - ho) + uo * ho);
  };
}
function piecewise(Kt, uo) {
  uo === void 0 && (uo = Kt, Kt = interpolate);
  for (var ho = 0, go = uo.length - 1, bo = uo[0], vo = new Array(go < 0 ? 0 : go); ho < go; ) vo[ho] = Kt(bo, bo = uo[++ho]);
  return function(Po) {
    var Co = Math.max(0, Math.min(go - 1, Math.floor(Po *= go)));
    return vo[Co](Po - Co);
  };
}
function constants(Kt) {
  return function() {
    return Kt;
  };
}
function number$1(Kt) {
  return +Kt;
}
var unit = [0, 1];
function identity$6(Kt) {
  return Kt;
}
function normalize(Kt, uo) {
  return (uo -= Kt = +Kt) ? function(ho) {
    return (ho - Kt) / uo;
  } : constants(isNaN(uo) ? NaN : 0.5);
}
function clamper(Kt, uo) {
  var ho;
  return Kt > uo && (ho = Kt, Kt = uo, uo = ho), function(go) {
    return Math.max(Kt, Math.min(uo, go));
  };
}
function bimap(Kt, uo, ho) {
  var go = Kt[0], bo = Kt[1], vo = uo[0], Po = uo[1];
  return bo < go ? (go = normalize(bo, go), vo = ho(Po, vo)) : (go = normalize(go, bo), vo = ho(vo, Po)), function(Co) {
    return vo(go(Co));
  };
}
function polymap(Kt, uo, ho) {
  var go = Math.min(Kt.length, uo.length) - 1, bo = new Array(go), vo = new Array(go), Po = -1;
  for (Kt[go] < Kt[0] && (Kt = Kt.slice().reverse(), uo = uo.slice().reverse()); ++Po < go; )
    bo[Po] = normalize(Kt[Po], Kt[Po + 1]), vo[Po] = ho(uo[Po], uo[Po + 1]);
  return function(Co) {
    var So = bisectRight(Kt, Co, 1, go) - 1;
    return vo[So](bo[So](Co));
  };
}
function copy$1(Kt, uo) {
  return uo.domain(Kt.domain()).range(Kt.range()).interpolate(Kt.interpolate()).clamp(Kt.clamp()).unknown(Kt.unknown());
}
function transformer$2() {
  var Kt = unit, uo = unit, ho = interpolate, go, bo, vo, Po = identity$6, Co, So, wo;
  function Eo() {
    var _o = Math.min(Kt.length, uo.length);
    return Po !== identity$6 && (Po = clamper(Kt[0], Kt[_o - 1])), Co = _o > 2 ? polymap : bimap, So = wo = null, Ro;
  }
  function Ro(_o) {
    return _o == null || isNaN(_o = +_o) ? vo : (So || (So = Co(Kt.map(go), uo, ho)))(go(Po(_o)));
  }
  return Ro.invert = function(_o) {
    return Po(bo((wo || (wo = Co(uo, Kt.map(go), interpolateNumber$1)))(_o)));
  }, Ro.domain = function(_o) {
    return arguments.length ? (Kt = Array.from(_o, number$1), Eo()) : Kt.slice();
  }, Ro.range = function(_o) {
    return arguments.length ? (uo = Array.from(_o), Eo()) : uo.slice();
  }, Ro.rangeRound = function(_o) {
    return uo = Array.from(_o), ho = interpolateRound, Eo();
  }, Ro.clamp = function(_o) {
    return arguments.length ? (Po = _o ? !0 : identity$6, Eo()) : Po !== identity$6;
  }, Ro.interpolate = function(_o) {
    return arguments.length ? (ho = _o, Eo()) : ho;
  }, Ro.unknown = function(_o) {
    return arguments.length ? (vo = _o, Ro) : vo;
  }, function(_o, Io) {
    return go = _o, bo = Io, Eo();
  };
}
function continuous() {
  return transformer$2()(identity$6, identity$6);
}
function formatDecimal(Kt) {
  return Math.abs(Kt = Math.round(Kt)) >= 1e21 ? Kt.toLocaleString("en").replace(/,/g, "") : Kt.toString(10);
}
function formatDecimalParts(Kt, uo) {
  if ((ho = (Kt = uo ? Kt.toExponential(uo - 1) : Kt.toExponential()).indexOf("e")) < 0) return null;
  var ho, go = Kt.slice(0, ho);
  return [
    go.length > 1 ? go[0] + go.slice(2) : go,
    +Kt.slice(ho + 1)
  ];
}
function exponent(Kt) {
  return Kt = formatDecimalParts(Math.abs(Kt)), Kt ? Kt[1] : NaN;
}
function formatGroup(Kt, uo) {
  return function(ho, go) {
    for (var bo = ho.length, vo = [], Po = 0, Co = Kt[0], So = 0; bo > 0 && Co > 0 && (So + Co + 1 > go && (Co = Math.max(1, go - So)), vo.push(ho.substring(bo -= Co, bo + Co)), !((So += Co + 1) > go)); )
      Co = Kt[Po = (Po + 1) % Kt.length];
    return vo.reverse().join(uo);
  };
}
function formatNumerals(Kt) {
  return function(uo) {
    return uo.replace(/[0-9]/g, function(ho) {
      return Kt[+ho];
    });
  };
}
var re$2 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(Kt) {
  if (!(uo = re$2.exec(Kt))) throw new Error("invalid format: " + Kt);
  var uo;
  return new FormatSpecifier({
    fill: uo[1],
    align: uo[2],
    sign: uo[3],
    symbol: uo[4],
    zero: uo[5],
    width: uo[6],
    comma: uo[7],
    precision: uo[8] && uo[8].slice(1),
    trim: uo[9],
    type: uo[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(Kt) {
  this.fill = Kt.fill === void 0 ? " " : Kt.fill + "", this.align = Kt.align === void 0 ? ">" : Kt.align + "", this.sign = Kt.sign === void 0 ? "-" : Kt.sign + "", this.symbol = Kt.symbol === void 0 ? "" : Kt.symbol + "", this.zero = !!Kt.zero, this.width = Kt.width === void 0 ? void 0 : +Kt.width, this.comma = !!Kt.comma, this.precision = Kt.precision === void 0 ? void 0 : +Kt.precision, this.trim = !!Kt.trim, this.type = Kt.type === void 0 ? "" : Kt.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(Kt) {
  e: for (var uo = Kt.length, ho = 1, go = -1, bo; ho < uo; ++ho)
    switch (Kt[ho]) {
      case ".":
        go = bo = ho;
        break;
      case "0":
        go === 0 && (go = ho), bo = ho;
        break;
      default:
        if (!+Kt[ho]) break e;
        go > 0 && (go = 0);
        break;
    }
  return go > 0 ? Kt.slice(0, go) + Kt.slice(bo + 1) : Kt;
}
var prefixExponent;
function formatPrefixAuto(Kt, uo) {
  var ho = formatDecimalParts(Kt, uo);
  if (!ho) return Kt + "";
  var go = ho[0], bo = ho[1], vo = bo - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(bo / 3))) * 3) + 1, Po = go.length;
  return vo === Po ? go : vo > Po ? go + new Array(vo - Po + 1).join("0") : vo > 0 ? go.slice(0, vo) + "." + go.slice(vo) : "0." + new Array(1 - vo).join("0") + formatDecimalParts(Kt, Math.max(0, uo + vo - 1))[0];
}
function formatRounded(Kt, uo) {
  var ho = formatDecimalParts(Kt, uo);
  if (!ho) return Kt + "";
  var go = ho[0], bo = ho[1];
  return bo < 0 ? "0." + new Array(-bo).join("0") + go : go.length > bo + 1 ? go.slice(0, bo + 1) + "." + go.slice(bo + 1) : go + new Array(bo - go.length + 2).join("0");
}
const formatTypes = {
  "%": (Kt, uo) => (Kt * 100).toFixed(uo),
  b: (Kt) => Math.round(Kt).toString(2),
  c: (Kt) => Kt + "",
  d: formatDecimal,
  e: (Kt, uo) => Kt.toExponential(uo),
  f: (Kt, uo) => Kt.toFixed(uo),
  g: (Kt, uo) => Kt.toPrecision(uo),
  o: (Kt) => Math.round(Kt).toString(8),
  p: (Kt, uo) => formatRounded(Kt * 100, uo),
  r: formatRounded,
  s: formatPrefixAuto,
  X: (Kt) => Math.round(Kt).toString(16).toUpperCase(),
  x: (Kt) => Math.round(Kt).toString(16)
};
function identity$5(Kt) {
  return Kt;
}
var map$3 = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale$1(Kt) {
  var uo = Kt.grouping === void 0 || Kt.thousands === void 0 ? identity$5 : formatGroup(map$3.call(Kt.grouping, Number), Kt.thousands + ""), ho = Kt.currency === void 0 ? "" : Kt.currency[0] + "", go = Kt.currency === void 0 ? "" : Kt.currency[1] + "", bo = Kt.decimal === void 0 ? "." : Kt.decimal + "", vo = Kt.numerals === void 0 ? identity$5 : formatNumerals(map$3.call(Kt.numerals, String)), Po = Kt.percent === void 0 ? "%" : Kt.percent + "", Co = Kt.minus === void 0 ? "−" : Kt.minus + "", So = Kt.nan === void 0 ? "NaN" : Kt.nan + "";
  function wo(Ro) {
    Ro = formatSpecifier(Ro);
    var _o = Ro.fill, Io = Ro.align, Ao = Ro.sign, Oo = Ro.symbol, jo = Ro.zero, Do = Ro.width, Lo = Ro.comma, ko = Ro.precision, Ko = Ro.trim, No = Ro.type;
    No === "n" ? (Lo = !0, No = "g") : formatTypes[No] || (ko === void 0 && (ko = 12), Ko = !0, No = "g"), (jo || _o === "0" && Io === "=") && (jo = !0, _o = "0", Io = "=");
    var Jo = Oo === "$" ? ho : Oo === "#" && /[boxX]/.test(No) ? "0" + No.toLowerCase() : "", ti = Oo === "$" ? go : /[%p]/.test(No) ? Po : "", oi = formatTypes[No], Qo = /[defgprs%]/.test(No);
    ko = ko === void 0 ? 6 : /[gprs]/.test(No) ? Math.max(1, Math.min(21, ko)) : Math.max(0, Math.min(20, ko));
    function Zo(ei) {
      var ii = Jo, ai = ti, ri, ni, si;
      if (No === "c")
        ai = oi(ei) + ai, ei = "";
      else {
        ei = +ei;
        var li = ei < 0 || 1 / ei < 0;
        if (ei = isNaN(ei) ? So : oi(Math.abs(ei), ko), Ko && (ei = formatTrim(ei)), li && +ei == 0 && Ao !== "+" && (li = !1), ii = (li ? Ao === "(" ? Ao : Co : Ao === "-" || Ao === "(" ? "" : Ao) + ii, ai = (No === "s" ? prefixes[8 + prefixExponent / 3] : "") + ai + (li && Ao === "(" ? ")" : ""), Qo) {
          for (ri = -1, ni = ei.length; ++ri < ni; )
            if (si = ei.charCodeAt(ri), 48 > si || si > 57) {
              ai = (si === 46 ? bo + ei.slice(ri + 1) : ei.slice(ri)) + ai, ei = ei.slice(0, ri);
              break;
            }
        }
      }
      Lo && !jo && (ei = uo(ei, 1 / 0));
      var ui = ii.length + ei.length + ai.length, ci = ui < Do ? new Array(Do - ui + 1).join(_o) : "";
      switch (Lo && jo && (ei = uo(ci + ei, ci.length ? Do - ai.length : 1 / 0), ci = ""), Io) {
        case "<":
          ei = ii + ei + ai + ci;
          break;
        case "=":
          ei = ii + ci + ei + ai;
          break;
        case "^":
          ei = ci.slice(0, ui = ci.length >> 1) + ii + ei + ai + ci.slice(ui);
          break;
        default:
          ei = ci + ii + ei + ai;
          break;
      }
      return vo(ei);
    }
    return Zo.toString = function() {
      return Ro + "";
    }, Zo;
  }
  function Eo(Ro, _o) {
    var Io = wo((Ro = formatSpecifier(Ro), Ro.type = "f", Ro)), Ao = Math.max(-8, Math.min(8, Math.floor(exponent(_o) / 3))) * 3, Oo = Math.pow(10, -Ao), jo = prefixes[8 + Ao / 3];
    return function(Do) {
      return Io(Oo * Do) + jo;
    };
  }
  return {
    format: wo,
    formatPrefix: Eo
  };
}
var locale$1, format, formatPrefix;
defaultLocale$1({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale$1(Kt) {
  return locale$1 = formatLocale$1(Kt), format = locale$1.format, formatPrefix = locale$1.formatPrefix, locale$1;
}
function precisionFixed(Kt) {
  return Math.max(0, -exponent(Math.abs(Kt)));
}
function precisionPrefix(Kt, uo) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(uo) / 3))) * 3 - exponent(Math.abs(Kt)));
}
function precisionRound(Kt, uo) {
  return Kt = Math.abs(Kt), uo = Math.abs(uo) - Kt, Math.max(0, exponent(uo) - exponent(Kt)) + 1;
}
function tickFormat(Kt, uo, ho, go) {
  var bo = tickStep(Kt, uo, ho), vo;
  switch (go = formatSpecifier(go ?? ",f"), go.type) {
    case "s": {
      var Po = Math.max(Math.abs(Kt), Math.abs(uo));
      return go.precision == null && !isNaN(vo = precisionPrefix(bo, Po)) && (go.precision = vo), formatPrefix(go, Po);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      go.precision == null && !isNaN(vo = precisionRound(bo, Math.max(Math.abs(Kt), Math.abs(uo)))) && (go.precision = vo - (go.type === "e"));
      break;
    }
    case "f":
    case "%": {
      go.precision == null && !isNaN(vo = precisionFixed(bo)) && (go.precision = vo - (go.type === "%") * 2);
      break;
    }
  }
  return format(go);
}
function linearish(Kt) {
  var uo = Kt.domain;
  return Kt.ticks = function(ho) {
    var go = uo();
    return ticks(go[0], go[go.length - 1], ho ?? 10);
  }, Kt.tickFormat = function(ho, go) {
    var bo = uo();
    return tickFormat(bo[0], bo[bo.length - 1], ho ?? 10, go);
  }, Kt.nice = function(ho) {
    ho == null && (ho = 10);
    var go = uo(), bo = 0, vo = go.length - 1, Po = go[bo], Co = go[vo], So, wo, Eo = 10;
    for (Co < Po && (wo = Po, Po = Co, Co = wo, wo = bo, bo = vo, vo = wo); Eo-- > 0; ) {
      if (wo = tickIncrement(Po, Co, ho), wo === So)
        return go[bo] = Po, go[vo] = Co, uo(go);
      if (wo > 0)
        Po = Math.floor(Po / wo) * wo, Co = Math.ceil(Co / wo) * wo;
      else if (wo < 0)
        Po = Math.ceil(Po * wo) / wo, Co = Math.floor(Co * wo) / wo;
      else
        break;
      So = wo;
    }
    return Kt;
  }, Kt;
}
function linear() {
  var Kt = continuous();
  return Kt.copy = function() {
    return copy$1(Kt, linear());
  }, initRange.apply(Kt, arguments), linearish(Kt);
}
function identity$4(Kt) {
  var uo;
  function ho(go) {
    return go == null || isNaN(go = +go) ? uo : go;
  }
  return ho.invert = ho, ho.domain = ho.range = function(go) {
    return arguments.length ? (Kt = Array.from(go, number$1), ho) : Kt.slice();
  }, ho.unknown = function(go) {
    return arguments.length ? (uo = go, ho) : uo;
  }, ho.copy = function() {
    return identity$4(Kt).unknown(uo);
  }, Kt = arguments.length ? Array.from(Kt, number$1) : [0, 1], linearish(ho);
}
function nice(Kt, uo) {
  Kt = Kt.slice();
  var ho = 0, go = Kt.length - 1, bo = Kt[ho], vo = Kt[go], Po;
  return vo < bo && (Po = ho, ho = go, go = Po, Po = bo, bo = vo, vo = Po), Kt[ho] = uo.floor(bo), Kt[go] = uo.ceil(vo), Kt;
}
function transformLog(Kt) {
  return Math.log(Kt);
}
function transformExp(Kt) {
  return Math.exp(Kt);
}
function transformLogn(Kt) {
  return -Math.log(-Kt);
}
function transformExpn(Kt) {
  return -Math.exp(-Kt);
}
function pow10(Kt) {
  return isFinite(Kt) ? +("1e" + Kt) : Kt < 0 ? 0 : Kt;
}
function powp(Kt) {
  return Kt === 10 ? pow10 : Kt === Math.E ? Math.exp : (uo) => Math.pow(Kt, uo);
}
function logp(Kt) {
  return Kt === Math.E ? Math.log : Kt === 10 && Math.log10 || Kt === 2 && Math.log2 || (Kt = Math.log(Kt), (uo) => Math.log(uo) / Kt);
}
function reflect(Kt) {
  return (uo, ho) => -Kt(-uo, ho);
}
function loggish(Kt) {
  const uo = Kt(transformLog, transformExp), ho = uo.domain;
  let go = 10, bo, vo;
  function Po() {
    return bo = logp(go), vo = powp(go), ho()[0] < 0 ? (bo = reflect(bo), vo = reflect(vo), Kt(transformLogn, transformExpn)) : Kt(transformLog, transformExp), uo;
  }
  return uo.base = function(Co) {
    return arguments.length ? (go = +Co, Po()) : go;
  }, uo.domain = function(Co) {
    return arguments.length ? (ho(Co), Po()) : ho();
  }, uo.ticks = (Co) => {
    const So = ho();
    let wo = So[0], Eo = So[So.length - 1];
    const Ro = Eo < wo;
    Ro && ([wo, Eo] = [Eo, wo]);
    let _o = bo(wo), Io = bo(Eo), Ao, Oo;
    const jo = Co == null ? 10 : +Co;
    let Do = [];
    if (!(go % 1) && Io - _o < jo) {
      if (_o = Math.floor(_o), Io = Math.ceil(Io), wo > 0) {
        for (; _o <= Io; ++_o)
          for (Ao = 1; Ao < go; ++Ao)
            if (Oo = _o < 0 ? Ao / vo(-_o) : Ao * vo(_o), !(Oo < wo)) {
              if (Oo > Eo) break;
              Do.push(Oo);
            }
      } else for (; _o <= Io; ++_o)
        for (Ao = go - 1; Ao >= 1; --Ao)
          if (Oo = _o > 0 ? Ao / vo(-_o) : Ao * vo(_o), !(Oo < wo)) {
            if (Oo > Eo) break;
            Do.push(Oo);
          }
      Do.length * 2 < jo && (Do = ticks(wo, Eo, jo));
    } else
      Do = ticks(_o, Io, Math.min(Io - _o, jo)).map(vo);
    return Ro ? Do.reverse() : Do;
  }, uo.tickFormat = (Co, So) => {
    if (Co == null && (Co = 10), So == null && (So = go === 10 ? "s" : ","), typeof So != "function" && (!(go % 1) && (So = formatSpecifier(So)).precision == null && (So.trim = !0), So = format(So)), Co === 1 / 0) return So;
    const wo = Math.max(1, go * Co / uo.ticks().length);
    return (Eo) => {
      let Ro = Eo / vo(Math.round(bo(Eo)));
      return Ro * go < go - 0.5 && (Ro *= go), Ro <= wo ? So(Eo) : "";
    };
  }, uo.nice = () => ho(nice(ho(), {
    floor: (Co) => vo(Math.floor(bo(Co))),
    ceil: (Co) => vo(Math.ceil(bo(Co)))
  })), uo;
}
function log$1() {
  const Kt = loggish(transformer$2()).domain([1, 10]);
  return Kt.copy = () => copy$1(Kt, log$1()).base(Kt.base()), initRange.apply(Kt, arguments), Kt;
}
function transformSymlog(Kt) {
  return function(uo) {
    return Math.sign(uo) * Math.log1p(Math.abs(uo / Kt));
  };
}
function transformSymexp(Kt) {
  return function(uo) {
    return Math.sign(uo) * Math.expm1(Math.abs(uo)) * Kt;
  };
}
function symlogish(Kt) {
  var uo = 1, ho = Kt(transformSymlog(uo), transformSymexp(uo));
  return ho.constant = function(go) {
    return arguments.length ? Kt(transformSymlog(uo = +go), transformSymexp(uo)) : uo;
  }, linearish(ho);
}
function symlog() {
  var Kt = symlogish(transformer$2());
  return Kt.copy = function() {
    return copy$1(Kt, symlog()).constant(Kt.constant());
  }, initRange.apply(Kt, arguments);
}
function transformPow(Kt) {
  return function(uo) {
    return uo < 0 ? -Math.pow(-uo, Kt) : Math.pow(uo, Kt);
  };
}
function transformSqrt(Kt) {
  return Kt < 0 ? -Math.sqrt(-Kt) : Math.sqrt(Kt);
}
function transformSquare(Kt) {
  return Kt < 0 ? -Kt * Kt : Kt * Kt;
}
function powish(Kt) {
  var uo = Kt(identity$6, identity$6), ho = 1;
  function go() {
    return ho === 1 ? Kt(identity$6, identity$6) : ho === 0.5 ? Kt(transformSqrt, transformSquare) : Kt(transformPow(ho), transformPow(1 / ho));
  }
  return uo.exponent = function(bo) {
    return arguments.length ? (ho = +bo, go()) : ho;
  }, linearish(uo);
}
function pow() {
  var Kt = powish(transformer$2());
  return Kt.copy = function() {
    return copy$1(Kt, pow()).exponent(Kt.exponent());
  }, initRange.apply(Kt, arguments), Kt;
}
function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}
function square(Kt) {
  return Math.sign(Kt) * Kt * Kt;
}
function unsquare(Kt) {
  return Math.sign(Kt) * Math.sqrt(Math.abs(Kt));
}
function radial() {
  var Kt = continuous(), uo = [0, 1], ho = !1, go;
  function bo(vo) {
    var Po = unsquare(Kt(vo));
    return isNaN(Po) ? go : ho ? Math.round(Po) : Po;
  }
  return bo.invert = function(vo) {
    return Kt.invert(square(vo));
  }, bo.domain = function(vo) {
    return arguments.length ? (Kt.domain(vo), bo) : Kt.domain();
  }, bo.range = function(vo) {
    return arguments.length ? (Kt.range((uo = Array.from(vo, number$1)).map(square)), bo) : uo.slice();
  }, bo.rangeRound = function(vo) {
    return bo.range(vo).round(!0);
  }, bo.round = function(vo) {
    return arguments.length ? (ho = !!vo, bo) : ho;
  }, bo.clamp = function(vo) {
    return arguments.length ? (Kt.clamp(vo), bo) : Kt.clamp();
  }, bo.unknown = function(vo) {
    return arguments.length ? (go = vo, bo) : go;
  }, bo.copy = function() {
    return radial(Kt.domain(), uo).round(ho).clamp(Kt.clamp()).unknown(go);
  }, initRange.apply(bo, arguments), linearish(bo);
}
function quantile() {
  var Kt = [], uo = [], ho = [], go;
  function bo() {
    var Po = 0, Co = Math.max(1, uo.length);
    for (ho = new Array(Co - 1); ++Po < Co; ) ho[Po - 1] = quantileSorted(Kt, Po / Co);
    return vo;
  }
  function vo(Po) {
    return Po == null || isNaN(Po = +Po) ? go : uo[bisectRight(ho, Po)];
  }
  return vo.invertExtent = function(Po) {
    var Co = uo.indexOf(Po);
    return Co < 0 ? [NaN, NaN] : [
      Co > 0 ? ho[Co - 1] : Kt[0],
      Co < ho.length ? ho[Co] : Kt[Kt.length - 1]
    ];
  }, vo.domain = function(Po) {
    if (!arguments.length) return Kt.slice();
    Kt = [];
    for (let Co of Po) Co != null && !isNaN(Co = +Co) && Kt.push(Co);
    return Kt.sort(ascending), bo();
  }, vo.range = function(Po) {
    return arguments.length ? (uo = Array.from(Po), bo()) : uo.slice();
  }, vo.unknown = function(Po) {
    return arguments.length ? (go = Po, vo) : go;
  }, vo.quantiles = function() {
    return ho.slice();
  }, vo.copy = function() {
    return quantile().domain(Kt).range(uo).unknown(go);
  }, initRange.apply(vo, arguments);
}
function quantize() {
  var Kt = 0, uo = 1, ho = 1, go = [0.5], bo = [0, 1], vo;
  function Po(So) {
    return So != null && So <= So ? bo[bisectRight(go, So, 0, ho)] : vo;
  }
  function Co() {
    var So = -1;
    for (go = new Array(ho); ++So < ho; ) go[So] = ((So + 1) * uo - (So - ho) * Kt) / (ho + 1);
    return Po;
  }
  return Po.domain = function(So) {
    return arguments.length ? ([Kt, uo] = So, Kt = +Kt, uo = +uo, Co()) : [Kt, uo];
  }, Po.range = function(So) {
    return arguments.length ? (ho = (bo = Array.from(So)).length - 1, Co()) : bo.slice();
  }, Po.invertExtent = function(So) {
    var wo = bo.indexOf(So);
    return wo < 0 ? [NaN, NaN] : wo < 1 ? [Kt, go[0]] : wo >= ho ? [go[ho - 1], uo] : [go[wo - 1], go[wo]];
  }, Po.unknown = function(So) {
    return arguments.length && (vo = So), Po;
  }, Po.thresholds = function() {
    return go.slice();
  }, Po.copy = function() {
    return quantize().domain([Kt, uo]).range(bo).unknown(vo);
  }, initRange.apply(linearish(Po), arguments);
}
function threshold() {
  var Kt = [0.5], uo = [0, 1], ho, go = 1;
  function bo(vo) {
    return vo != null && vo <= vo ? uo[bisectRight(Kt, vo, 0, go)] : ho;
  }
  return bo.domain = function(vo) {
    return arguments.length ? (Kt = Array.from(vo), go = Math.min(Kt.length, uo.length - 1), bo) : Kt.slice();
  }, bo.range = function(vo) {
    return arguments.length ? (uo = Array.from(vo), go = Math.min(Kt.length, uo.length - 1), bo) : uo.slice();
  }, bo.invertExtent = function(vo) {
    var Po = uo.indexOf(vo);
    return [Kt[Po - 1], Kt[Po]];
  }, bo.unknown = function(vo) {
    return arguments.length ? (ho = vo, bo) : ho;
  }, bo.copy = function() {
    return threshold().domain(Kt).range(uo).unknown(ho);
  }, initRange.apply(bo, arguments);
}
const t0 = /* @__PURE__ */ new Date(), t1 = /* @__PURE__ */ new Date();
function timeInterval(Kt, uo, ho, go) {
  function bo(vo) {
    return Kt(vo = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+vo)), vo;
  }
  return bo.floor = (vo) => (Kt(vo = /* @__PURE__ */ new Date(+vo)), vo), bo.ceil = (vo) => (Kt(vo = new Date(vo - 1)), uo(vo, 1), Kt(vo), vo), bo.round = (vo) => {
    const Po = bo(vo), Co = bo.ceil(vo);
    return vo - Po < Co - vo ? Po : Co;
  }, bo.offset = (vo, Po) => (uo(vo = /* @__PURE__ */ new Date(+vo), Po == null ? 1 : Math.floor(Po)), vo), bo.range = (vo, Po, Co) => {
    const So = [];
    if (vo = bo.ceil(vo), Co = Co == null ? 1 : Math.floor(Co), !(vo < Po) || !(Co > 0)) return So;
    let wo;
    do
      So.push(wo = /* @__PURE__ */ new Date(+vo)), uo(vo, Co), Kt(vo);
    while (wo < vo && vo < Po);
    return So;
  }, bo.filter = (vo) => timeInterval((Po) => {
    if (Po >= Po) for (; Kt(Po), !vo(Po); ) Po.setTime(Po - 1);
  }, (Po, Co) => {
    if (Po >= Po)
      if (Co < 0) for (; ++Co <= 0; )
        for (; uo(Po, -1), !vo(Po); )
          ;
      else for (; --Co >= 0; )
        for (; uo(Po, 1), !vo(Po); )
          ;
  }), ho && (bo.count = (vo, Po) => (t0.setTime(+vo), t1.setTime(+Po), Kt(t0), Kt(t1), Math.floor(ho(t0, t1))), bo.every = (vo) => (vo = Math.floor(vo), !isFinite(vo) || !(vo > 0) ? null : vo > 1 ? bo.filter(go ? (Po) => go(Po) % vo === 0 : (Po) => bo.count(0, Po) % vo === 0) : bo)), bo;
}
const millisecond = timeInterval(() => {
}, (Kt, uo) => {
  Kt.setTime(+Kt + uo);
}, (Kt, uo) => uo - Kt);
millisecond.every = (Kt) => (Kt = Math.floor(Kt), !isFinite(Kt) || !(Kt > 0) ? null : Kt > 1 ? timeInterval((uo) => {
  uo.setTime(Math.floor(uo / Kt) * Kt);
}, (uo, ho) => {
  uo.setTime(+uo + ho * Kt);
}, (uo, ho) => (ho - uo) / Kt) : millisecond);
millisecond.range;
const durationSecond = 1e3, durationMinute = durationSecond * 60, durationHour = durationMinute * 60, durationDay = durationHour * 24, durationWeek = durationDay * 7, durationMonth = durationDay * 30, durationYear = durationDay * 365, second = timeInterval((Kt) => {
  Kt.setTime(Kt - Kt.getMilliseconds());
}, (Kt, uo) => {
  Kt.setTime(+Kt + uo * durationSecond);
}, (Kt, uo) => (uo - Kt) / durationSecond, (Kt) => Kt.getUTCSeconds());
second.range;
const timeMinute = timeInterval((Kt) => {
  Kt.setTime(Kt - Kt.getMilliseconds() - Kt.getSeconds() * durationSecond);
}, (Kt, uo) => {
  Kt.setTime(+Kt + uo * durationMinute);
}, (Kt, uo) => (uo - Kt) / durationMinute, (Kt) => Kt.getMinutes());
timeMinute.range;
const utcMinute = timeInterval((Kt) => {
  Kt.setUTCSeconds(0, 0);
}, (Kt, uo) => {
  Kt.setTime(+Kt + uo * durationMinute);
}, (Kt, uo) => (uo - Kt) / durationMinute, (Kt) => Kt.getUTCMinutes());
utcMinute.range;
const timeHour = timeInterval((Kt) => {
  Kt.setTime(Kt - Kt.getMilliseconds() - Kt.getSeconds() * durationSecond - Kt.getMinutes() * durationMinute);
}, (Kt, uo) => {
  Kt.setTime(+Kt + uo * durationHour);
}, (Kt, uo) => (uo - Kt) / durationHour, (Kt) => Kt.getHours());
timeHour.range;
const utcHour = timeInterval((Kt) => {
  Kt.setUTCMinutes(0, 0, 0);
}, (Kt, uo) => {
  Kt.setTime(+Kt + uo * durationHour);
}, (Kt, uo) => (uo - Kt) / durationHour, (Kt) => Kt.getUTCHours());
utcHour.range;
const timeDay = timeInterval(
  (Kt) => Kt.setHours(0, 0, 0, 0),
  (Kt, uo) => Kt.setDate(Kt.getDate() + uo),
  (Kt, uo) => (uo - Kt - (uo.getTimezoneOffset() - Kt.getTimezoneOffset()) * durationMinute) / durationDay,
  (Kt) => Kt.getDate() - 1
);
timeDay.range;
const utcDay = timeInterval((Kt) => {
  Kt.setUTCHours(0, 0, 0, 0);
}, (Kt, uo) => {
  Kt.setUTCDate(Kt.getUTCDate() + uo);
}, (Kt, uo) => (uo - Kt) / durationDay, (Kt) => Kt.getUTCDate() - 1);
utcDay.range;
const unixDay = timeInterval((Kt) => {
  Kt.setUTCHours(0, 0, 0, 0);
}, (Kt, uo) => {
  Kt.setUTCDate(Kt.getUTCDate() + uo);
}, (Kt, uo) => (uo - Kt) / durationDay, (Kt) => Math.floor(Kt / durationDay));
unixDay.range;
function timeWeekday(Kt) {
  return timeInterval((uo) => {
    uo.setDate(uo.getDate() - (uo.getDay() + 7 - Kt) % 7), uo.setHours(0, 0, 0, 0);
  }, (uo, ho) => {
    uo.setDate(uo.getDate() + ho * 7);
  }, (uo, ho) => (ho - uo - (ho.getTimezoneOffset() - uo.getTimezoneOffset()) * durationMinute) / durationWeek);
}
const timeSunday = timeWeekday(0), timeMonday = timeWeekday(1), timeTuesday = timeWeekday(2), timeWednesday = timeWeekday(3), timeThursday = timeWeekday(4), timeFriday = timeWeekday(5), timeSaturday = timeWeekday(6);
timeSunday.range;
timeMonday.range;
timeTuesday.range;
timeWednesday.range;
timeThursday.range;
timeFriday.range;
timeSaturday.range;
function utcWeekday(Kt) {
  return timeInterval((uo) => {
    uo.setUTCDate(uo.getUTCDate() - (uo.getUTCDay() + 7 - Kt) % 7), uo.setUTCHours(0, 0, 0, 0);
  }, (uo, ho) => {
    uo.setUTCDate(uo.getUTCDate() + ho * 7);
  }, (uo, ho) => (ho - uo) / durationWeek);
}
const utcSunday = utcWeekday(0), utcMonday = utcWeekday(1), utcTuesday = utcWeekday(2), utcWednesday = utcWeekday(3), utcThursday = utcWeekday(4), utcFriday = utcWeekday(5), utcSaturday = utcWeekday(6);
utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;
const timeMonth = timeInterval((Kt) => {
  Kt.setDate(1), Kt.setHours(0, 0, 0, 0);
}, (Kt, uo) => {
  Kt.setMonth(Kt.getMonth() + uo);
}, (Kt, uo) => uo.getMonth() - Kt.getMonth() + (uo.getFullYear() - Kt.getFullYear()) * 12, (Kt) => Kt.getMonth());
timeMonth.range;
const utcMonth = timeInterval((Kt) => {
  Kt.setUTCDate(1), Kt.setUTCHours(0, 0, 0, 0);
}, (Kt, uo) => {
  Kt.setUTCMonth(Kt.getUTCMonth() + uo);
}, (Kt, uo) => uo.getUTCMonth() - Kt.getUTCMonth() + (uo.getUTCFullYear() - Kt.getUTCFullYear()) * 12, (Kt) => Kt.getUTCMonth());
utcMonth.range;
const timeYear = timeInterval((Kt) => {
  Kt.setMonth(0, 1), Kt.setHours(0, 0, 0, 0);
}, (Kt, uo) => {
  Kt.setFullYear(Kt.getFullYear() + uo);
}, (Kt, uo) => uo.getFullYear() - Kt.getFullYear(), (Kt) => Kt.getFullYear());
timeYear.every = (Kt) => !isFinite(Kt = Math.floor(Kt)) || !(Kt > 0) ? null : timeInterval((uo) => {
  uo.setFullYear(Math.floor(uo.getFullYear() / Kt) * Kt), uo.setMonth(0, 1), uo.setHours(0, 0, 0, 0);
}, (uo, ho) => {
  uo.setFullYear(uo.getFullYear() + ho * Kt);
});
timeYear.range;
const utcYear = timeInterval((Kt) => {
  Kt.setUTCMonth(0, 1), Kt.setUTCHours(0, 0, 0, 0);
}, (Kt, uo) => {
  Kt.setUTCFullYear(Kt.getUTCFullYear() + uo);
}, (Kt, uo) => uo.getUTCFullYear() - Kt.getUTCFullYear(), (Kt) => Kt.getUTCFullYear());
utcYear.every = (Kt) => !isFinite(Kt = Math.floor(Kt)) || !(Kt > 0) ? null : timeInterval((uo) => {
  uo.setUTCFullYear(Math.floor(uo.getUTCFullYear() / Kt) * Kt), uo.setUTCMonth(0, 1), uo.setUTCHours(0, 0, 0, 0);
}, (uo, ho) => {
  uo.setUTCFullYear(uo.getUTCFullYear() + ho * Kt);
});
utcYear.range;
function ticker(Kt, uo, ho, go, bo, vo) {
  const Po = [
    [second, 1, durationSecond],
    [second, 5, 5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [vo, 1, durationMinute],
    [vo, 5, 5 * durationMinute],
    [vo, 15, 15 * durationMinute],
    [vo, 30, 30 * durationMinute],
    [bo, 1, durationHour],
    [bo, 3, 3 * durationHour],
    [bo, 6, 6 * durationHour],
    [bo, 12, 12 * durationHour],
    [go, 1, durationDay],
    [go, 2, 2 * durationDay],
    [ho, 1, durationWeek],
    [uo, 1, durationMonth],
    [uo, 3, 3 * durationMonth],
    [Kt, 1, durationYear]
  ];
  function Co(wo, Eo, Ro) {
    const _o = Eo < wo;
    _o && ([wo, Eo] = [Eo, wo]);
    const Io = Ro && typeof Ro.range == "function" ? Ro : So(wo, Eo, Ro), Ao = Io ? Io.range(wo, +Eo + 1) : [];
    return _o ? Ao.reverse() : Ao;
  }
  function So(wo, Eo, Ro) {
    const _o = Math.abs(Eo - wo) / Ro, Io = bisector(([, , jo]) => jo).right(Po, _o);
    if (Io === Po.length) return Kt.every(tickStep(wo / durationYear, Eo / durationYear, Ro));
    if (Io === 0) return millisecond.every(Math.max(tickStep(wo, Eo, Ro), 1));
    const [Ao, Oo] = Po[_o / Po[Io - 1][2] < Po[Io][2] / _o ? Io - 1 : Io];
    return Ao.every(Oo);
  }
  return [Co, So];
}
const [utcTicks, utcTickInterval] = ticker(utcYear, utcMonth, utcSunday, unixDay, utcHour, utcMinute), [timeTicks, timeTickInterval] = ticker(timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute);
function localDate(Kt) {
  if (0 <= Kt.y && Kt.y < 100) {
    var uo = new Date(-1, Kt.m, Kt.d, Kt.H, Kt.M, Kt.S, Kt.L);
    return uo.setFullYear(Kt.y), uo;
  }
  return new Date(Kt.y, Kt.m, Kt.d, Kt.H, Kt.M, Kt.S, Kt.L);
}
function utcDate(Kt) {
  if (0 <= Kt.y && Kt.y < 100) {
    var uo = new Date(Date.UTC(-1, Kt.m, Kt.d, Kt.H, Kt.M, Kt.S, Kt.L));
    return uo.setUTCFullYear(Kt.y), uo;
  }
  return new Date(Date.UTC(Kt.y, Kt.m, Kt.d, Kt.H, Kt.M, Kt.S, Kt.L));
}
function newDate(Kt, uo, ho) {
  return { y: Kt, m: uo, d: ho, H: 0, M: 0, S: 0, L: 0 };
}
function formatLocale(Kt) {
  var uo = Kt.dateTime, ho = Kt.date, go = Kt.time, bo = Kt.periods, vo = Kt.days, Po = Kt.shortDays, Co = Kt.months, So = Kt.shortMonths, wo = formatRe(bo), Eo = formatLookup(bo), Ro = formatRe(vo), _o = formatLookup(vo), Io = formatRe(Po), Ao = formatLookup(Po), Oo = formatRe(Co), jo = formatLookup(Co), Do = formatRe(So), Lo = formatLookup(So), ko = {
    a: li,
    A: ui,
    b: ci,
    B: fi,
    c: null,
    d: formatDayOfMonth,
    e: formatDayOfMonth,
    f: formatMicroseconds,
    g: formatYearISO,
    G: formatFullYearISO,
    H: formatHour24,
    I: formatHour12,
    j: formatDayOfYear,
    L: formatMilliseconds,
    m: formatMonthNumber,
    M: formatMinutes,
    p: yi,
    q: hi,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatSeconds,
    u: formatWeekdayNumberMonday,
    U: formatWeekNumberSunday,
    V: formatWeekNumberISO,
    w: formatWeekdayNumberSunday,
    W: formatWeekNumberMonday,
    x: null,
    X: null,
    y: formatYear,
    Y: formatFullYear,
    Z: formatZone,
    "%": formatLiteralPercent
  }, Ko = {
    a: mi,
    A: bi,
    b: xi,
    B: $i,
    c: null,
    d: formatUTCDayOfMonth,
    e: formatUTCDayOfMonth,
    f: formatUTCMicroseconds,
    g: formatUTCYearISO,
    G: formatUTCFullYearISO,
    H: formatUTCHour24,
    I: formatUTCHour12,
    j: formatUTCDayOfYear,
    L: formatUTCMilliseconds,
    m: formatUTCMonthNumber,
    M: formatUTCMinutes,
    p: Ci,
    q: Si,
    Q: formatUnixTimestamp,
    s: formatUnixTimestampSeconds,
    S: formatUTCSeconds,
    u: formatUTCWeekdayNumberMonday,
    U: formatUTCWeekNumberSunday,
    V: formatUTCWeekNumberISO,
    w: formatUTCWeekdayNumberSunday,
    W: formatUTCWeekNumberMonday,
    x: null,
    X: null,
    y: formatUTCYear,
    Y: formatUTCFullYear,
    Z: formatUTCZone,
    "%": formatLiteralPercent
  }, No = {
    a: Zo,
    A: ei,
    b: ii,
    B: ai,
    c: ri,
    d: parseDayOfMonth,
    e: parseDayOfMonth,
    f: parseMicroseconds,
    g: parseYear,
    G: parseFullYear,
    H: parseHour24,
    I: parseHour24,
    j: parseDayOfYear,
    L: parseMilliseconds,
    m: parseMonthNumber,
    M: parseMinutes,
    p: Qo,
    q: parseQuarter,
    Q: parseUnixTimestamp,
    s: parseUnixTimestampSeconds,
    S: parseSeconds,
    u: parseWeekdayNumberMonday,
    U: parseWeekNumberSunday,
    V: parseWeekNumberISO,
    w: parseWeekdayNumberSunday,
    W: parseWeekNumberMonday,
    x: ni,
    X: si,
    y: parseYear,
    Y: parseFullYear,
    Z: parseZone,
    "%": parseLiteralPercent
  };
  ko.x = Jo(ho, ko), ko.X = Jo(go, ko), ko.c = Jo(uo, ko), Ko.x = Jo(ho, Ko), Ko.X = Jo(go, Ko), Ko.c = Jo(uo, Ko);
  function Jo(vi, Pi) {
    return function(wi) {
      var gi = [], Ri = -1, Ei = 0, Ni = vi.length, Ai, Yi, Ui;
      for (wi instanceof Date || (wi = /* @__PURE__ */ new Date(+wi)); ++Ri < Ni; )
        vi.charCodeAt(Ri) === 37 && (gi.push(vi.slice(Ei, Ri)), (Yi = pads[Ai = vi.charAt(++Ri)]) != null ? Ai = vi.charAt(++Ri) : Yi = Ai === "e" ? " " : "0", (Ui = Pi[Ai]) && (Ai = Ui(wi, Yi)), gi.push(Ai), Ei = Ri + 1);
      return gi.push(vi.slice(Ei, Ri)), gi.join("");
    };
  }
  function ti(vi, Pi) {
    return function(wi) {
      var gi = newDate(1900, void 0, 1), Ri = oi(gi, vi, wi += "", 0), Ei, Ni;
      if (Ri != wi.length) return null;
      if ("Q" in gi) return new Date(gi.Q);
      if ("s" in gi) return new Date(gi.s * 1e3 + ("L" in gi ? gi.L : 0));
      if (Pi && !("Z" in gi) && (gi.Z = 0), "p" in gi && (gi.H = gi.H % 12 + gi.p * 12), gi.m === void 0 && (gi.m = "q" in gi ? gi.q : 0), "V" in gi) {
        if (gi.V < 1 || gi.V > 53) return null;
        "w" in gi || (gi.w = 1), "Z" in gi ? (Ei = utcDate(newDate(gi.y, 0, 1)), Ni = Ei.getUTCDay(), Ei = Ni > 4 || Ni === 0 ? utcMonday.ceil(Ei) : utcMonday(Ei), Ei = utcDay.offset(Ei, (gi.V - 1) * 7), gi.y = Ei.getUTCFullYear(), gi.m = Ei.getUTCMonth(), gi.d = Ei.getUTCDate() + (gi.w + 6) % 7) : (Ei = localDate(newDate(gi.y, 0, 1)), Ni = Ei.getDay(), Ei = Ni > 4 || Ni === 0 ? timeMonday.ceil(Ei) : timeMonday(Ei), Ei = timeDay.offset(Ei, (gi.V - 1) * 7), gi.y = Ei.getFullYear(), gi.m = Ei.getMonth(), gi.d = Ei.getDate() + (gi.w + 6) % 7);
      } else ("W" in gi || "U" in gi) && ("w" in gi || (gi.w = "u" in gi ? gi.u % 7 : "W" in gi ? 1 : 0), Ni = "Z" in gi ? utcDate(newDate(gi.y, 0, 1)).getUTCDay() : localDate(newDate(gi.y, 0, 1)).getDay(), gi.m = 0, gi.d = "W" in gi ? (gi.w + 6) % 7 + gi.W * 7 - (Ni + 5) % 7 : gi.w + gi.U * 7 - (Ni + 6) % 7);
      return "Z" in gi ? (gi.H += gi.Z / 100 | 0, gi.M += gi.Z % 100, utcDate(gi)) : localDate(gi);
    };
  }
  function oi(vi, Pi, wi, gi) {
    for (var Ri = 0, Ei = Pi.length, Ni = wi.length, Ai, Yi; Ri < Ei; ) {
      if (gi >= Ni) return -1;
      if (Ai = Pi.charCodeAt(Ri++), Ai === 37) {
        if (Ai = Pi.charAt(Ri++), Yi = No[Ai in pads ? Pi.charAt(Ri++) : Ai], !Yi || (gi = Yi(vi, wi, gi)) < 0) return -1;
      } else if (Ai != wi.charCodeAt(gi++))
        return -1;
    }
    return gi;
  }
  function Qo(vi, Pi, wi) {
    var gi = wo.exec(Pi.slice(wi));
    return gi ? (vi.p = Eo.get(gi[0].toLowerCase()), wi + gi[0].length) : -1;
  }
  function Zo(vi, Pi, wi) {
    var gi = Io.exec(Pi.slice(wi));
    return gi ? (vi.w = Ao.get(gi[0].toLowerCase()), wi + gi[0].length) : -1;
  }
  function ei(vi, Pi, wi) {
    var gi = Ro.exec(Pi.slice(wi));
    return gi ? (vi.w = _o.get(gi[0].toLowerCase()), wi + gi[0].length) : -1;
  }
  function ii(vi, Pi, wi) {
    var gi = Do.exec(Pi.slice(wi));
    return gi ? (vi.m = Lo.get(gi[0].toLowerCase()), wi + gi[0].length) : -1;
  }
  function ai(vi, Pi, wi) {
    var gi = Oo.exec(Pi.slice(wi));
    return gi ? (vi.m = jo.get(gi[0].toLowerCase()), wi + gi[0].length) : -1;
  }
  function ri(vi, Pi, wi) {
    return oi(vi, uo, Pi, wi);
  }
  function ni(vi, Pi, wi) {
    return oi(vi, ho, Pi, wi);
  }
  function si(vi, Pi, wi) {
    return oi(vi, go, Pi, wi);
  }
  function li(vi) {
    return Po[vi.getDay()];
  }
  function ui(vi) {
    return vo[vi.getDay()];
  }
  function ci(vi) {
    return So[vi.getMonth()];
  }
  function fi(vi) {
    return Co[vi.getMonth()];
  }
  function yi(vi) {
    return bo[+(vi.getHours() >= 12)];
  }
  function hi(vi) {
    return 1 + ~~(vi.getMonth() / 3);
  }
  function mi(vi) {
    return Po[vi.getUTCDay()];
  }
  function bi(vi) {
    return vo[vi.getUTCDay()];
  }
  function xi(vi) {
    return So[vi.getUTCMonth()];
  }
  function $i(vi) {
    return Co[vi.getUTCMonth()];
  }
  function Ci(vi) {
    return bo[+(vi.getUTCHours() >= 12)];
  }
  function Si(vi) {
    return 1 + ~~(vi.getUTCMonth() / 3);
  }
  return {
    format: function(vi) {
      var Pi = Jo(vi += "", ko);
      return Pi.toString = function() {
        return vi;
      }, Pi;
    },
    parse: function(vi) {
      var Pi = ti(vi += "", !1);
      return Pi.toString = function() {
        return vi;
      }, Pi;
    },
    utcFormat: function(vi) {
      var Pi = Jo(vi += "", Ko);
      return Pi.toString = function() {
        return vi;
      }, Pi;
    },
    utcParse: function(vi) {
      var Pi = ti(vi += "", !0);
      return Pi.toString = function() {
        return vi;
      }, Pi;
    }
  };
}
var pads = { "-": "", _: " ", 0: "0" }, numberRe = /^\s*\d+/, percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(Kt, uo, ho) {
  var go = Kt < 0 ? "-" : "", bo = (go ? -Kt : Kt) + "", vo = bo.length;
  return go + (vo < ho ? new Array(ho - vo + 1).join(uo) + bo : bo);
}
function requote(Kt) {
  return Kt.replace(requoteRe, "\\$&");
}
function formatRe(Kt) {
  return new RegExp("^(?:" + Kt.map(requote).join("|") + ")", "i");
}
function formatLookup(Kt) {
  return new Map(Kt.map((uo, ho) => [uo.toLowerCase(), ho]));
}
function parseWeekdayNumberSunday(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 1));
  return go ? (Kt.w = +go[0], ho + go[0].length) : -1;
}
function parseWeekdayNumberMonday(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 1));
  return go ? (Kt.u = +go[0], ho + go[0].length) : -1;
}
function parseWeekNumberSunday(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.U = +go[0], ho + go[0].length) : -1;
}
function parseWeekNumberISO(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.V = +go[0], ho + go[0].length) : -1;
}
function parseWeekNumberMonday(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.W = +go[0], ho + go[0].length) : -1;
}
function parseFullYear(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 4));
  return go ? (Kt.y = +go[0], ho + go[0].length) : -1;
}
function parseYear(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.y = +go[0] + (+go[0] > 68 ? 1900 : 2e3), ho + go[0].length) : -1;
}
function parseZone(Kt, uo, ho) {
  var go = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(uo.slice(ho, ho + 6));
  return go ? (Kt.Z = go[1] ? 0 : -(go[2] + (go[3] || "00")), ho + go[0].length) : -1;
}
function parseQuarter(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 1));
  return go ? (Kt.q = go[0] * 3 - 3, ho + go[0].length) : -1;
}
function parseMonthNumber(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.m = go[0] - 1, ho + go[0].length) : -1;
}
function parseDayOfMonth(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.d = +go[0], ho + go[0].length) : -1;
}
function parseDayOfYear(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 3));
  return go ? (Kt.m = 0, Kt.d = +go[0], ho + go[0].length) : -1;
}
function parseHour24(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.H = +go[0], ho + go[0].length) : -1;
}
function parseMinutes(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.M = +go[0], ho + go[0].length) : -1;
}
function parseSeconds(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 2));
  return go ? (Kt.S = +go[0], ho + go[0].length) : -1;
}
function parseMilliseconds(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 3));
  return go ? (Kt.L = +go[0], ho + go[0].length) : -1;
}
function parseMicroseconds(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho, ho + 6));
  return go ? (Kt.L = Math.floor(go[0] / 1e3), ho + go[0].length) : -1;
}
function parseLiteralPercent(Kt, uo, ho) {
  var go = percentRe.exec(uo.slice(ho, ho + 1));
  return go ? ho + go[0].length : -1;
}
function parseUnixTimestamp(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho));
  return go ? (Kt.Q = +go[0], ho + go[0].length) : -1;
}
function parseUnixTimestampSeconds(Kt, uo, ho) {
  var go = numberRe.exec(uo.slice(ho));
  return go ? (Kt.s = +go[0], ho + go[0].length) : -1;
}
function formatDayOfMonth(Kt, uo) {
  return pad(Kt.getDate(), uo, 2);
}
function formatHour24(Kt, uo) {
  return pad(Kt.getHours(), uo, 2);
}
function formatHour12(Kt, uo) {
  return pad(Kt.getHours() % 12 || 12, uo, 2);
}
function formatDayOfYear(Kt, uo) {
  return pad(1 + timeDay.count(timeYear(Kt), Kt), uo, 3);
}
function formatMilliseconds(Kt, uo) {
  return pad(Kt.getMilliseconds(), uo, 3);
}
function formatMicroseconds(Kt, uo) {
  return formatMilliseconds(Kt, uo) + "000";
}
function formatMonthNumber(Kt, uo) {
  return pad(Kt.getMonth() + 1, uo, 2);
}
function formatMinutes(Kt, uo) {
  return pad(Kt.getMinutes(), uo, 2);
}
function formatSeconds(Kt, uo) {
  return pad(Kt.getSeconds(), uo, 2);
}
function formatWeekdayNumberMonday(Kt) {
  var uo = Kt.getDay();
  return uo === 0 ? 7 : uo;
}
function formatWeekNumberSunday(Kt, uo) {
  return pad(timeSunday.count(timeYear(Kt) - 1, Kt), uo, 2);
}
function dISO(Kt) {
  var uo = Kt.getDay();
  return uo >= 4 || uo === 0 ? timeThursday(Kt) : timeThursday.ceil(Kt);
}
function formatWeekNumberISO(Kt, uo) {
  return Kt = dISO(Kt), pad(timeThursday.count(timeYear(Kt), Kt) + (timeYear(Kt).getDay() === 4), uo, 2);
}
function formatWeekdayNumberSunday(Kt) {
  return Kt.getDay();
}
function formatWeekNumberMonday(Kt, uo) {
  return pad(timeMonday.count(timeYear(Kt) - 1, Kt), uo, 2);
}
function formatYear(Kt, uo) {
  return pad(Kt.getFullYear() % 100, uo, 2);
}
function formatYearISO(Kt, uo) {
  return Kt = dISO(Kt), pad(Kt.getFullYear() % 100, uo, 2);
}
function formatFullYear(Kt, uo) {
  return pad(Kt.getFullYear() % 1e4, uo, 4);
}
function formatFullYearISO(Kt, uo) {
  var ho = Kt.getDay();
  return Kt = ho >= 4 || ho === 0 ? timeThursday(Kt) : timeThursday.ceil(Kt), pad(Kt.getFullYear() % 1e4, uo, 4);
}
function formatZone(Kt) {
  var uo = Kt.getTimezoneOffset();
  return (uo > 0 ? "-" : (uo *= -1, "+")) + pad(uo / 60 | 0, "0", 2) + pad(uo % 60, "0", 2);
}
function formatUTCDayOfMonth(Kt, uo) {
  return pad(Kt.getUTCDate(), uo, 2);
}
function formatUTCHour24(Kt, uo) {
  return pad(Kt.getUTCHours(), uo, 2);
}
function formatUTCHour12(Kt, uo) {
  return pad(Kt.getUTCHours() % 12 || 12, uo, 2);
}
function formatUTCDayOfYear(Kt, uo) {
  return pad(1 + utcDay.count(utcYear(Kt), Kt), uo, 3);
}
function formatUTCMilliseconds(Kt, uo) {
  return pad(Kt.getUTCMilliseconds(), uo, 3);
}
function formatUTCMicroseconds(Kt, uo) {
  return formatUTCMilliseconds(Kt, uo) + "000";
}
function formatUTCMonthNumber(Kt, uo) {
  return pad(Kt.getUTCMonth() + 1, uo, 2);
}
function formatUTCMinutes(Kt, uo) {
  return pad(Kt.getUTCMinutes(), uo, 2);
}
function formatUTCSeconds(Kt, uo) {
  return pad(Kt.getUTCSeconds(), uo, 2);
}
function formatUTCWeekdayNumberMonday(Kt) {
  var uo = Kt.getUTCDay();
  return uo === 0 ? 7 : uo;
}
function formatUTCWeekNumberSunday(Kt, uo) {
  return pad(utcSunday.count(utcYear(Kt) - 1, Kt), uo, 2);
}
function UTCdISO(Kt) {
  var uo = Kt.getUTCDay();
  return uo >= 4 || uo === 0 ? utcThursday(Kt) : utcThursday.ceil(Kt);
}
function formatUTCWeekNumberISO(Kt, uo) {
  return Kt = UTCdISO(Kt), pad(utcThursday.count(utcYear(Kt), Kt) + (utcYear(Kt).getUTCDay() === 4), uo, 2);
}
function formatUTCWeekdayNumberSunday(Kt) {
  return Kt.getUTCDay();
}
function formatUTCWeekNumberMonday(Kt, uo) {
  return pad(utcMonday.count(utcYear(Kt) - 1, Kt), uo, 2);
}
function formatUTCYear(Kt, uo) {
  return pad(Kt.getUTCFullYear() % 100, uo, 2);
}
function formatUTCYearISO(Kt, uo) {
  return Kt = UTCdISO(Kt), pad(Kt.getUTCFullYear() % 100, uo, 2);
}
function formatUTCFullYear(Kt, uo) {
  return pad(Kt.getUTCFullYear() % 1e4, uo, 4);
}
function formatUTCFullYearISO(Kt, uo) {
  var ho = Kt.getUTCDay();
  return Kt = ho >= 4 || ho === 0 ? utcThursday(Kt) : utcThursday.ceil(Kt), pad(Kt.getUTCFullYear() % 1e4, uo, 4);
}
function formatUTCZone() {
  return "+0000";
}
function formatLiteralPercent() {
  return "%";
}
function formatUnixTimestamp(Kt) {
  return +Kt;
}
function formatUnixTimestampSeconds(Kt) {
  return Math.floor(+Kt / 1e3);
}
var locale, timeFormat, utcFormat;
defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function defaultLocale(Kt) {
  return locale = formatLocale(Kt), timeFormat = locale.format, locale.parse, utcFormat = locale.utcFormat, locale.utcParse, locale;
}
function date(Kt) {
  return new Date(Kt);
}
function number(Kt) {
  return Kt instanceof Date ? +Kt : +/* @__PURE__ */ new Date(+Kt);
}
function calendar(Kt, uo, ho, go, bo, vo, Po, Co, So, wo) {
  var Eo = continuous(), Ro = Eo.invert, _o = Eo.domain, Io = wo(".%L"), Ao = wo(":%S"), Oo = wo("%I:%M"), jo = wo("%I %p"), Do = wo("%a %d"), Lo = wo("%b %d"), ko = wo("%B"), Ko = wo("%Y");
  function No(Jo) {
    return (So(Jo) < Jo ? Io : Co(Jo) < Jo ? Ao : Po(Jo) < Jo ? Oo : vo(Jo) < Jo ? jo : go(Jo) < Jo ? bo(Jo) < Jo ? Do : Lo : ho(Jo) < Jo ? ko : Ko)(Jo);
  }
  return Eo.invert = function(Jo) {
    return new Date(Ro(Jo));
  }, Eo.domain = function(Jo) {
    return arguments.length ? _o(Array.from(Jo, number)) : _o().map(date);
  }, Eo.ticks = function(Jo) {
    var ti = _o();
    return Kt(ti[0], ti[ti.length - 1], Jo ?? 10);
  }, Eo.tickFormat = function(Jo, ti) {
    return ti == null ? No : wo(ti);
  }, Eo.nice = function(Jo) {
    var ti = _o();
    return (!Jo || typeof Jo.range != "function") && (Jo = uo(ti[0], ti[ti.length - 1], Jo ?? 10)), Jo ? _o(nice(ti, Jo)) : Eo;
  }, Eo.copy = function() {
    return copy$1(Eo, calendar(Kt, uo, ho, go, bo, vo, Po, Co, So, wo));
  }, Eo;
}
function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear, timeMonth, timeSunday, timeDay, timeHour, timeMinute, second, timeFormat).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear, utcMonth, utcSunday, utcDay, utcHour, utcMinute, second, utcFormat).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function transformer$1() {
  var Kt = 0, uo = 1, ho, go, bo, vo, Po = identity$6, Co = !1, So;
  function wo(Ro) {
    return Ro == null || isNaN(Ro = +Ro) ? So : Po(bo === 0 ? 0.5 : (Ro = (vo(Ro) - ho) * bo, Co ? Math.max(0, Math.min(1, Ro)) : Ro));
  }
  wo.domain = function(Ro) {
    return arguments.length ? ([Kt, uo] = Ro, ho = vo(Kt = +Kt), go = vo(uo = +uo), bo = ho === go ? 0 : 1 / (go - ho), wo) : [Kt, uo];
  }, wo.clamp = function(Ro) {
    return arguments.length ? (Co = !!Ro, wo) : Co;
  }, wo.interpolator = function(Ro) {
    return arguments.length ? (Po = Ro, wo) : Po;
  };
  function Eo(Ro) {
    return function(_o) {
      var Io, Ao;
      return arguments.length ? ([Io, Ao] = _o, Po = Ro(Io, Ao), wo) : [Po(0), Po(1)];
    };
  }
  return wo.range = Eo(interpolate), wo.rangeRound = Eo(interpolateRound), wo.unknown = function(Ro) {
    return arguments.length ? (So = Ro, wo) : So;
  }, function(Ro) {
    return vo = Ro, ho = Ro(Kt), go = Ro(uo), bo = ho === go ? 0 : 1 / (go - ho), wo;
  };
}
function copy(Kt, uo) {
  return uo.domain(Kt.domain()).interpolator(Kt.interpolator()).clamp(Kt.clamp()).unknown(Kt.unknown());
}
function sequential() {
  var Kt = linearish(transformer$1()(identity$6));
  return Kt.copy = function() {
    return copy(Kt, sequential());
  }, initInterpolator.apply(Kt, arguments);
}
function sequentialLog() {
  var Kt = loggish(transformer$1()).domain([1, 10]);
  return Kt.copy = function() {
    return copy(Kt, sequentialLog()).base(Kt.base());
  }, initInterpolator.apply(Kt, arguments);
}
function sequentialSymlog() {
  var Kt = symlogish(transformer$1());
  return Kt.copy = function() {
    return copy(Kt, sequentialSymlog()).constant(Kt.constant());
  }, initInterpolator.apply(Kt, arguments);
}
function sequentialPow() {
  var Kt = powish(transformer$1());
  return Kt.copy = function() {
    return copy(Kt, sequentialPow()).exponent(Kt.exponent());
  }, initInterpolator.apply(Kt, arguments);
}
function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}
function sequentialQuantile() {
  var Kt = [], uo = identity$6;
  function ho(go) {
    if (go != null && !isNaN(go = +go)) return uo((bisectRight(Kt, go, 1) - 1) / (Kt.length - 1));
  }
  return ho.domain = function(go) {
    if (!arguments.length) return Kt.slice();
    Kt = [];
    for (let bo of go) bo != null && !isNaN(bo = +bo) && Kt.push(bo);
    return Kt.sort(ascending), ho;
  }, ho.interpolator = function(go) {
    return arguments.length ? (uo = go, ho) : uo;
  }, ho.range = function() {
    return Kt.map((go, bo) => uo(bo / (Kt.length - 1)));
  }, ho.quantiles = function(go) {
    return Array.from({ length: go + 1 }, (bo, vo) => quantile$1(Kt, vo / go));
  }, ho.copy = function() {
    return sequentialQuantile(uo).domain(Kt);
  }, initInterpolator.apply(ho, arguments);
}
function transformer() {
  var Kt = 0, uo = 0.5, ho = 1, go = 1, bo, vo, Po, Co, So, wo = identity$6, Eo, Ro = !1, _o;
  function Io(Oo) {
    return isNaN(Oo = +Oo) ? _o : (Oo = 0.5 + ((Oo = +Eo(Oo)) - vo) * (go * Oo < go * vo ? Co : So), wo(Ro ? Math.max(0, Math.min(1, Oo)) : Oo));
  }
  Io.domain = function(Oo) {
    return arguments.length ? ([Kt, uo, ho] = Oo, bo = Eo(Kt = +Kt), vo = Eo(uo = +uo), Po = Eo(ho = +ho), Co = bo === vo ? 0 : 0.5 / (vo - bo), So = vo === Po ? 0 : 0.5 / (Po - vo), go = vo < bo ? -1 : 1, Io) : [Kt, uo, ho];
  }, Io.clamp = function(Oo) {
    return arguments.length ? (Ro = !!Oo, Io) : Ro;
  }, Io.interpolator = function(Oo) {
    return arguments.length ? (wo = Oo, Io) : wo;
  };
  function Ao(Oo) {
    return function(jo) {
      var Do, Lo, ko;
      return arguments.length ? ([Do, Lo, ko] = jo, wo = piecewise(Oo, [Do, Lo, ko]), Io) : [wo(0), wo(0.5), wo(1)];
    };
  }
  return Io.range = Ao(interpolate), Io.rangeRound = Ao(interpolateRound), Io.unknown = function(Oo) {
    return arguments.length ? (_o = Oo, Io) : _o;
  }, function(Oo) {
    return Eo = Oo, bo = Oo(Kt), vo = Oo(uo), Po = Oo(ho), Co = bo === vo ? 0 : 0.5 / (vo - bo), So = vo === Po ? 0 : 0.5 / (Po - vo), go = vo < bo ? -1 : 1, Io;
  };
}
function diverging() {
  var Kt = linearish(transformer()(identity$6));
  return Kt.copy = function() {
    return copy(Kt, diverging());
  }, initInterpolator.apply(Kt, arguments);
}
function divergingLog() {
  var Kt = loggish(transformer()).domain([0.1, 1, 10]);
  return Kt.copy = function() {
    return copy(Kt, divergingLog()).base(Kt.base());
  }, initInterpolator.apply(Kt, arguments);
}
function divergingSymlog() {
  var Kt = symlogish(transformer());
  return Kt.copy = function() {
    return copy(Kt, divergingSymlog()).constant(Kt.constant());
  }, initInterpolator.apply(Kt, arguments);
}
function divergingPow() {
  var Kt = powish(transformer());
  return Kt.copy = function() {
    return copy(Kt, divergingPow()).exponent(Kt.exponent());
  }, initInterpolator.apply(Kt, arguments);
}
function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}
const d3Scales = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: band,
  scaleDiverging: diverging,
  scaleDivergingLog: divergingLog,
  scaleDivergingPow: divergingPow,
  scaleDivergingSqrt: divergingSqrt,
  scaleDivergingSymlog: divergingSymlog,
  scaleIdentity: identity$4,
  scaleImplicit: implicit,
  scaleLinear: linear,
  scaleLog: log$1,
  scaleOrdinal: ordinal,
  scalePoint: point,
  scalePow: pow,
  scaleQuantile: quantile,
  scaleQuantize: quantize,
  scaleRadial: radial,
  scaleSequential: sequential,
  scaleSequentialLog: sequentialLog,
  scaleSequentialPow: sequentialPow,
  scaleSequentialQuantile: sequentialQuantile,
  scaleSequentialSqrt: sequentialSqrt,
  scaleSequentialSymlog: sequentialSymlog,
  scaleSqrt: sqrt,
  scaleSymlog: symlog,
  scaleThreshold: threshold,
  scaleTime: time,
  scaleUtc: utcTime,
  tickFormat
}, Symbol.toStringTag, { value: "Module" }));
var isSymbol = isSymbol_1;
function baseExtremum$2(Kt, uo, ho) {
  for (var go = -1, bo = Kt.length; ++go < bo; ) {
    var vo = Kt[go], Po = uo(vo);
    if (Po != null && (Co === void 0 ? Po === Po && !isSymbol(Po) : ho(Po, Co)))
      var Co = Po, So = vo;
  }
  return So;
}
var _baseExtremum = baseExtremum$2;
function baseGt$1(Kt, uo) {
  return Kt > uo;
}
var _baseGt = baseGt$1, baseExtremum$1 = _baseExtremum, baseGt = _baseGt, identity$3 = identity_1;
function max(Kt) {
  return Kt && Kt.length ? baseExtremum$1(Kt, identity$3, baseGt) : void 0;
}
var max_1 = max;
const max$1 = /* @__PURE__ */ getDefaultExportFromCjs(max_1);
function baseLt$1(Kt, uo) {
  return Kt < uo;
}
var _baseLt = baseLt$1, baseExtremum = _baseExtremum, baseLt = _baseLt, identity$2 = identity_1;
function min(Kt) {
  return Kt && Kt.length ? baseExtremum(Kt, identity$2, baseLt) : void 0;
}
var min_1 = min;
const min$1 = /* @__PURE__ */ getDefaultExportFromCjs(min_1);
var arrayMap = _arrayMap, baseIteratee$5 = _baseIteratee, baseMap = _baseMap, isArray$3 = isArray_1;
function map$2(Kt, uo) {
  var ho = isArray$3(Kt) ? arrayMap : baseMap;
  return ho(Kt, baseIteratee$5(uo));
}
var map_1 = map$2, baseFlatten = _baseFlatten, map$1 = map_1;
function flatMap(Kt, uo) {
  return baseFlatten(map$1(Kt, uo), 1);
}
var flatMap_1 = flatMap;
const flatMap$1 = /* @__PURE__ */ getDefaultExportFromCjs(flatMap_1);
var baseIsEqual = _baseIsEqual;
function isEqual(Kt, uo) {
  return baseIsEqual(Kt, uo);
}
var isEqual_1 = isEqual;
const isEqual$1 = /* @__PURE__ */ getDefaultExportFromCjs(isEqual_1);
var MAX_DIGITS = 1e9, defaults = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, Decimal, external = !0, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), P$4 = {};
P$4.absoluteValue = P$4.abs = function() {
  var Kt = new this.constructor(this);
  return Kt.s && (Kt.s = 1), Kt;
};
P$4.comparedTo = P$4.cmp = function(Kt) {
  var uo, ho, go, bo, vo = this;
  if (Kt = new vo.constructor(Kt), vo.s !== Kt.s) return vo.s || -Kt.s;
  if (vo.e !== Kt.e) return vo.e > Kt.e ^ vo.s < 0 ? 1 : -1;
  for (go = vo.d.length, bo = Kt.d.length, uo = 0, ho = go < bo ? go : bo; uo < ho; ++uo)
    if (vo.d[uo] !== Kt.d[uo]) return vo.d[uo] > Kt.d[uo] ^ vo.s < 0 ? 1 : -1;
  return go === bo ? 0 : go > bo ^ vo.s < 0 ? 1 : -1;
};
P$4.decimalPlaces = P$4.dp = function() {
  var Kt = this, uo = Kt.d.length - 1, ho = (uo - Kt.e) * LOG_BASE;
  if (uo = Kt.d[uo], uo) for (; uo % 10 == 0; uo /= 10) ho--;
  return ho < 0 ? 0 : ho;
};
P$4.dividedBy = P$4.div = function(Kt) {
  return divide(this, new this.constructor(Kt));
};
P$4.dividedToIntegerBy = P$4.idiv = function(Kt) {
  var uo = this, ho = uo.constructor;
  return round(divide(uo, new ho(Kt), 0, 1), ho.precision);
};
P$4.equals = P$4.eq = function(Kt) {
  return !this.cmp(Kt);
};
P$4.exponent = function() {
  return getBase10Exponent(this);
};
P$4.greaterThan = P$4.gt = function(Kt) {
  return this.cmp(Kt) > 0;
};
P$4.greaterThanOrEqualTo = P$4.gte = function(Kt) {
  return this.cmp(Kt) >= 0;
};
P$4.isInteger = P$4.isint = function() {
  return this.e > this.d.length - 2;
};
P$4.isNegative = P$4.isneg = function() {
  return this.s < 0;
};
P$4.isPositive = P$4.ispos = function() {
  return this.s > 0;
};
P$4.isZero = function() {
  return this.s === 0;
};
P$4.lessThan = P$4.lt = function(Kt) {
  return this.cmp(Kt) < 0;
};
P$4.lessThanOrEqualTo = P$4.lte = function(Kt) {
  return this.cmp(Kt) < 1;
};
P$4.logarithm = P$4.log = function(Kt) {
  var uo, ho = this, go = ho.constructor, bo = go.precision, vo = bo + 5;
  if (Kt === void 0)
    Kt = new go(10);
  else if (Kt = new go(Kt), Kt.s < 1 || Kt.eq(ONE)) throw Error(decimalError + "NaN");
  if (ho.s < 1) throw Error(decimalError + (ho.s ? "NaN" : "-Infinity"));
  return ho.eq(ONE) ? new go(0) : (external = !1, uo = divide(ln$1(ho, vo), ln$1(Kt, vo), vo), external = !0, round(uo, bo));
};
P$4.minus = P$4.sub = function(Kt) {
  var uo = this;
  return Kt = new uo.constructor(Kt), uo.s == Kt.s ? subtract(uo, Kt) : add(uo, (Kt.s = -Kt.s, Kt));
};
P$4.modulo = P$4.mod = function(Kt) {
  var uo, ho = this, go = ho.constructor, bo = go.precision;
  if (Kt = new go(Kt), !Kt.s) throw Error(decimalError + "NaN");
  return ho.s ? (external = !1, uo = divide(ho, Kt, 0, 1).times(Kt), external = !0, ho.minus(uo)) : round(new go(ho), bo);
};
P$4.naturalExponential = P$4.exp = function() {
  return exp(this);
};
P$4.naturalLogarithm = P$4.ln = function() {
  return ln$1(this);
};
P$4.negated = P$4.neg = function() {
  var Kt = new this.constructor(this);
  return Kt.s = -Kt.s || 0, Kt;
};
P$4.plus = P$4.add = function(Kt) {
  var uo = this;
  return Kt = new uo.constructor(Kt), uo.s == Kt.s ? add(uo, Kt) : subtract(uo, (Kt.s = -Kt.s, Kt));
};
P$4.precision = P$4.sd = function(Kt) {
  var uo, ho, go, bo = this;
  if (Kt !== void 0 && Kt !== !!Kt && Kt !== 1 && Kt !== 0) throw Error(invalidArgument + Kt);
  if (uo = getBase10Exponent(bo) + 1, go = bo.d.length - 1, ho = go * LOG_BASE + 1, go = bo.d[go], go) {
    for (; go % 10 == 0; go /= 10) ho--;
    for (go = bo.d[0]; go >= 10; go /= 10) ho++;
  }
  return Kt && uo > ho ? uo : ho;
};
P$4.squareRoot = P$4.sqrt = function() {
  var Kt, uo, ho, go, bo, vo, Po, Co = this, So = Co.constructor;
  if (Co.s < 1) {
    if (!Co.s) return new So(0);
    throw Error(decimalError + "NaN");
  }
  for (Kt = getBase10Exponent(Co), external = !1, bo = Math.sqrt(+Co), bo == 0 || bo == 1 / 0 ? (uo = digitsToString(Co.d), (uo.length + Kt) % 2 == 0 && (uo += "0"), bo = Math.sqrt(uo), Kt = mathfloor((Kt + 1) / 2) - (Kt < 0 || Kt % 2), bo == 1 / 0 ? uo = "5e" + Kt : (uo = bo.toExponential(), uo = uo.slice(0, uo.indexOf("e") + 1) + Kt), go = new So(uo)) : go = new So(bo.toString()), ho = So.precision, bo = Po = ho + 3; ; )
    if (vo = go, go = vo.plus(divide(Co, vo, Po + 2)).times(0.5), digitsToString(vo.d).slice(0, Po) === (uo = digitsToString(go.d)).slice(0, Po)) {
      if (uo = uo.slice(Po - 3, Po + 1), bo == Po && uo == "4999") {
        if (round(vo, ho + 1, 0), vo.times(vo).eq(Co)) {
          go = vo;
          break;
        }
      } else if (uo != "9999")
        break;
      Po += 4;
    }
  return external = !0, round(go, ho);
};
P$4.times = P$4.mul = function(Kt) {
  var uo, ho, go, bo, vo, Po, Co, So, wo, Eo = this, Ro = Eo.constructor, _o = Eo.d, Io = (Kt = new Ro(Kt)).d;
  if (!Eo.s || !Kt.s) return new Ro(0);
  for (Kt.s *= Eo.s, ho = Eo.e + Kt.e, So = _o.length, wo = Io.length, So < wo && (vo = _o, _o = Io, Io = vo, Po = So, So = wo, wo = Po), vo = [], Po = So + wo, go = Po; go--; ) vo.push(0);
  for (go = wo; --go >= 0; ) {
    for (uo = 0, bo = So + go; bo > go; )
      Co = vo[bo] + Io[go] * _o[bo - go - 1] + uo, vo[bo--] = Co % BASE | 0, uo = Co / BASE | 0;
    vo[bo] = (vo[bo] + uo) % BASE | 0;
  }
  for (; !vo[--Po]; ) vo.pop();
  return uo ? ++ho : vo.shift(), Kt.d = vo, Kt.e = ho, external ? round(Kt, Ro.precision) : Kt;
};
P$4.toDecimalPlaces = P$4.todp = function(Kt, uo) {
  var ho = this, go = ho.constructor;
  return ho = new go(ho), Kt === void 0 ? ho : (checkInt32(Kt, 0, MAX_DIGITS), uo === void 0 ? uo = go.rounding : checkInt32(uo, 0, 8), round(ho, Kt + getBase10Exponent(ho) + 1, uo));
};
P$4.toExponential = function(Kt, uo) {
  var ho, go = this, bo = go.constructor;
  return Kt === void 0 ? ho = toString(go, !0) : (checkInt32(Kt, 0, MAX_DIGITS), uo === void 0 ? uo = bo.rounding : checkInt32(uo, 0, 8), go = round(new bo(go), Kt + 1, uo), ho = toString(go, !0, Kt + 1)), ho;
};
P$4.toFixed = function(Kt, uo) {
  var ho, go, bo = this, vo = bo.constructor;
  return Kt === void 0 ? toString(bo) : (checkInt32(Kt, 0, MAX_DIGITS), uo === void 0 ? uo = vo.rounding : checkInt32(uo, 0, 8), go = round(new vo(bo), Kt + getBase10Exponent(bo) + 1, uo), ho = toString(go.abs(), !1, Kt + getBase10Exponent(go) + 1), bo.isneg() && !bo.isZero() ? "-" + ho : ho);
};
P$4.toInteger = P$4.toint = function() {
  var Kt = this, uo = Kt.constructor;
  return round(new uo(Kt), getBase10Exponent(Kt) + 1, uo.rounding);
};
P$4.toNumber = function() {
  return +this;
};
P$4.toPower = P$4.pow = function(Kt) {
  var uo, ho, go, bo, vo, Po, Co = this, So = Co.constructor, wo = 12, Eo = +(Kt = new So(Kt));
  if (!Kt.s) return new So(ONE);
  if (Co = new So(Co), !Co.s) {
    if (Kt.s < 1) throw Error(decimalError + "Infinity");
    return Co;
  }
  if (Co.eq(ONE)) return Co;
  if (go = So.precision, Kt.eq(ONE)) return round(Co, go);
  if (uo = Kt.e, ho = Kt.d.length - 1, Po = uo >= ho, vo = Co.s, Po) {
    if ((ho = Eo < 0 ? -Eo : Eo) <= MAX_SAFE_INTEGER) {
      for (bo = new So(ONE), uo = Math.ceil(go / LOG_BASE + 4), external = !1; ho % 2 && (bo = bo.times(Co), truncate(bo.d, uo)), ho = mathfloor(ho / 2), ho !== 0; )
        Co = Co.times(Co), truncate(Co.d, uo);
      return external = !0, Kt.s < 0 ? new So(ONE).div(bo) : round(bo, go);
    }
  } else if (vo < 0) throw Error(decimalError + "NaN");
  return vo = vo < 0 && Kt.d[Math.max(uo, ho)] & 1 ? -1 : 1, Co.s = 1, external = !1, bo = Kt.times(ln$1(Co, go + wo)), external = !0, bo = exp(bo), bo.s = vo, bo;
};
P$4.toPrecision = function(Kt, uo) {
  var ho, go, bo = this, vo = bo.constructor;
  return Kt === void 0 ? (ho = getBase10Exponent(bo), go = toString(bo, ho <= vo.toExpNeg || ho >= vo.toExpPos)) : (checkInt32(Kt, 1, MAX_DIGITS), uo === void 0 ? uo = vo.rounding : checkInt32(uo, 0, 8), bo = round(new vo(bo), Kt, uo), ho = getBase10Exponent(bo), go = toString(bo, Kt <= ho || ho <= vo.toExpNeg, Kt)), go;
};
P$4.toSignificantDigits = P$4.tosd = function(Kt, uo) {
  var ho = this, go = ho.constructor;
  return Kt === void 0 ? (Kt = go.precision, uo = go.rounding) : (checkInt32(Kt, 1, MAX_DIGITS), uo === void 0 ? uo = go.rounding : checkInt32(uo, 0, 8)), round(new go(ho), Kt, uo);
};
P$4.toString = P$4.valueOf = P$4.val = P$4.toJSON = P$4[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var Kt = this, uo = getBase10Exponent(Kt), ho = Kt.constructor;
  return toString(Kt, uo <= ho.toExpNeg || uo >= ho.toExpPos);
};
function add(Kt, uo) {
  var ho, go, bo, vo, Po, Co, So, wo, Eo = Kt.constructor, Ro = Eo.precision;
  if (!Kt.s || !uo.s)
    return uo.s || (uo = new Eo(Kt)), external ? round(uo, Ro) : uo;
  if (So = Kt.d, wo = uo.d, Po = Kt.e, bo = uo.e, So = So.slice(), vo = Po - bo, vo) {
    for (vo < 0 ? (go = So, vo = -vo, Co = wo.length) : (go = wo, bo = Po, Co = So.length), Po = Math.ceil(Ro / LOG_BASE), Co = Po > Co ? Po + 1 : Co + 1, vo > Co && (vo = Co, go.length = 1), go.reverse(); vo--; ) go.push(0);
    go.reverse();
  }
  for (Co = So.length, vo = wo.length, Co - vo < 0 && (vo = Co, go = wo, wo = So, So = go), ho = 0; vo; )
    ho = (So[--vo] = So[vo] + wo[vo] + ho) / BASE | 0, So[vo] %= BASE;
  for (ho && (So.unshift(ho), ++bo), Co = So.length; So[--Co] == 0; ) So.pop();
  return uo.d = So, uo.e = bo, external ? round(uo, Ro) : uo;
}
function checkInt32(Kt, uo, ho) {
  if (Kt !== ~~Kt || Kt < uo || Kt > ho)
    throw Error(invalidArgument + Kt);
}
function digitsToString(Kt) {
  var uo, ho, go, bo = Kt.length - 1, vo = "", Po = Kt[0];
  if (bo > 0) {
    for (vo += Po, uo = 1; uo < bo; uo++)
      go = Kt[uo] + "", ho = LOG_BASE - go.length, ho && (vo += getZeroString(ho)), vo += go;
    Po = Kt[uo], go = Po + "", ho = LOG_BASE - go.length, ho && (vo += getZeroString(ho));
  } else if (Po === 0)
    return "0";
  for (; Po % 10 === 0; ) Po /= 10;
  return vo + Po;
}
var divide = /* @__PURE__ */ function() {
  function Kt(go, bo) {
    var vo, Po = 0, Co = go.length;
    for (go = go.slice(); Co--; )
      vo = go[Co] * bo + Po, go[Co] = vo % BASE | 0, Po = vo / BASE | 0;
    return Po && go.unshift(Po), go;
  }
  function uo(go, bo, vo, Po) {
    var Co, So;
    if (vo != Po)
      So = vo > Po ? 1 : -1;
    else
      for (Co = So = 0; Co < vo; Co++)
        if (go[Co] != bo[Co]) {
          So = go[Co] > bo[Co] ? 1 : -1;
          break;
        }
    return So;
  }
  function ho(go, bo, vo) {
    for (var Po = 0; vo--; )
      go[vo] -= Po, Po = go[vo] < bo[vo] ? 1 : 0, go[vo] = Po * BASE + go[vo] - bo[vo];
    for (; !go[0] && go.length > 1; ) go.shift();
  }
  return function(go, bo, vo, Po) {
    var Co, So, wo, Eo, Ro, _o, Io, Ao, Oo, jo, Do, Lo, ko, Ko, No, Jo, ti, oi, Qo = go.constructor, Zo = go.s == bo.s ? 1 : -1, ei = go.d, ii = bo.d;
    if (!go.s) return new Qo(go);
    if (!bo.s) throw Error(decimalError + "Division by zero");
    for (So = go.e - bo.e, ti = ii.length, No = ei.length, Io = new Qo(Zo), Ao = Io.d = [], wo = 0; ii[wo] == (ei[wo] || 0); ) ++wo;
    if (ii[wo] > (ei[wo] || 0) && --So, vo == null ? Lo = vo = Qo.precision : Po ? Lo = vo + (getBase10Exponent(go) - getBase10Exponent(bo)) + 1 : Lo = vo, Lo < 0) return new Qo(0);
    if (Lo = Lo / LOG_BASE + 2 | 0, wo = 0, ti == 1)
      for (Eo = 0, ii = ii[0], Lo++; (wo < No || Eo) && Lo--; wo++)
        ko = Eo * BASE + (ei[wo] || 0), Ao[wo] = ko / ii | 0, Eo = ko % ii | 0;
    else {
      for (Eo = BASE / (ii[0] + 1) | 0, Eo > 1 && (ii = Kt(ii, Eo), ei = Kt(ei, Eo), ti = ii.length, No = ei.length), Ko = ti, Oo = ei.slice(0, ti), jo = Oo.length; jo < ti; ) Oo[jo++] = 0;
      oi = ii.slice(), oi.unshift(0), Jo = ii[0], ii[1] >= BASE / 2 && ++Jo;
      do
        Eo = 0, Co = uo(ii, Oo, ti, jo), Co < 0 ? (Do = Oo[0], ti != jo && (Do = Do * BASE + (Oo[1] || 0)), Eo = Do / Jo | 0, Eo > 1 ? (Eo >= BASE && (Eo = BASE - 1), Ro = Kt(ii, Eo), _o = Ro.length, jo = Oo.length, Co = uo(Ro, Oo, _o, jo), Co == 1 && (Eo--, ho(Ro, ti < _o ? oi : ii, _o))) : (Eo == 0 && (Co = Eo = 1), Ro = ii.slice()), _o = Ro.length, _o < jo && Ro.unshift(0), ho(Oo, Ro, jo), Co == -1 && (jo = Oo.length, Co = uo(ii, Oo, ti, jo), Co < 1 && (Eo++, ho(Oo, ti < jo ? oi : ii, jo))), jo = Oo.length) : Co === 0 && (Eo++, Oo = [0]), Ao[wo++] = Eo, Co && Oo[0] ? Oo[jo++] = ei[Ko] || 0 : (Oo = [ei[Ko]], jo = 1);
      while ((Ko++ < No || Oo[0] !== void 0) && Lo--);
    }
    return Ao[0] || Ao.shift(), Io.e = So, round(Io, Po ? vo + getBase10Exponent(Io) + 1 : vo);
  };
}();
function exp(Kt, uo) {
  var ho, go, bo, vo, Po, Co, So = 0, wo = 0, Eo = Kt.constructor, Ro = Eo.precision;
  if (getBase10Exponent(Kt) > 16) throw Error(exponentOutOfRange + getBase10Exponent(Kt));
  if (!Kt.s) return new Eo(ONE);
  for (uo == null ? (external = !1, Co = Ro) : Co = uo, Po = new Eo(0.03125); Kt.abs().gte(0.1); )
    Kt = Kt.times(Po), wo += 5;
  for (go = Math.log(mathpow(2, wo)) / Math.LN10 * 2 + 5 | 0, Co += go, ho = bo = vo = new Eo(ONE), Eo.precision = Co; ; ) {
    if (bo = round(bo.times(Kt), Co), ho = ho.times(++So), Po = vo.plus(divide(bo, ho, Co)), digitsToString(Po.d).slice(0, Co) === digitsToString(vo.d).slice(0, Co)) {
      for (; wo--; ) vo = round(vo.times(vo), Co);
      return Eo.precision = Ro, uo == null ? (external = !0, round(vo, Ro)) : vo;
    }
    vo = Po;
  }
}
function getBase10Exponent(Kt) {
  for (var uo = Kt.e * LOG_BASE, ho = Kt.d[0]; ho >= 10; ho /= 10) uo++;
  return uo;
}
function getLn10(Kt, uo, ho) {
  if (uo > Kt.LN10.sd())
    throw external = !0, ho && (Kt.precision = ho), Error(decimalError + "LN10 precision limit exceeded");
  return round(new Kt(Kt.LN10), uo);
}
function getZeroString(Kt) {
  for (var uo = ""; Kt--; ) uo += "0";
  return uo;
}
function ln$1(Kt, uo) {
  var ho, go, bo, vo, Po, Co, So, wo, Eo, Ro = 1, _o = 10, Io = Kt, Ao = Io.d, Oo = Io.constructor, jo = Oo.precision;
  if (Io.s < 1) throw Error(decimalError + (Io.s ? "NaN" : "-Infinity"));
  if (Io.eq(ONE)) return new Oo(0);
  if (uo == null ? (external = !1, wo = jo) : wo = uo, Io.eq(10))
    return uo == null && (external = !0), getLn10(Oo, wo);
  if (wo += _o, Oo.precision = wo, ho = digitsToString(Ao), go = ho.charAt(0), vo = getBase10Exponent(Io), Math.abs(vo) < 15e14) {
    for (; go < 7 && go != 1 || go == 1 && ho.charAt(1) > 3; )
      Io = Io.times(Kt), ho = digitsToString(Io.d), go = ho.charAt(0), Ro++;
    vo = getBase10Exponent(Io), go > 1 ? (Io = new Oo("0." + ho), vo++) : Io = new Oo(go + "." + ho.slice(1));
  } else
    return So = getLn10(Oo, wo + 2, jo).times(vo + ""), Io = ln$1(new Oo(go + "." + ho.slice(1)), wo - _o).plus(So), Oo.precision = jo, uo == null ? (external = !0, round(Io, jo)) : Io;
  for (Co = Po = Io = divide(Io.minus(ONE), Io.plus(ONE), wo), Eo = round(Io.times(Io), wo), bo = 3; ; ) {
    if (Po = round(Po.times(Eo), wo), So = Co.plus(divide(Po, new Oo(bo), wo)), digitsToString(So.d).slice(0, wo) === digitsToString(Co.d).slice(0, wo))
      return Co = Co.times(2), vo !== 0 && (Co = Co.plus(getLn10(Oo, wo + 2, jo).times(vo + ""))), Co = divide(Co, new Oo(Ro), wo), Oo.precision = jo, uo == null ? (external = !0, round(Co, jo)) : Co;
    Co = So, bo += 2;
  }
}
function parseDecimal(Kt, uo) {
  var ho, go, bo;
  for ((ho = uo.indexOf(".")) > -1 && (uo = uo.replace(".", "")), (go = uo.search(/e/i)) > 0 ? (ho < 0 && (ho = go), ho += +uo.slice(go + 1), uo = uo.substring(0, go)) : ho < 0 && (ho = uo.length), go = 0; uo.charCodeAt(go) === 48; ) ++go;
  for (bo = uo.length; uo.charCodeAt(bo - 1) === 48; ) --bo;
  if (uo = uo.slice(go, bo), uo) {
    if (bo -= go, ho = ho - go - 1, Kt.e = mathfloor(ho / LOG_BASE), Kt.d = [], go = (ho + 1) % LOG_BASE, ho < 0 && (go += LOG_BASE), go < bo) {
      for (go && Kt.d.push(+uo.slice(0, go)), bo -= LOG_BASE; go < bo; ) Kt.d.push(+uo.slice(go, go += LOG_BASE));
      uo = uo.slice(go), go = LOG_BASE - uo.length;
    } else
      go -= bo;
    for (; go--; ) uo += "0";
    if (Kt.d.push(+uo), external && (Kt.e > MAX_E || Kt.e < -MAX_E)) throw Error(exponentOutOfRange + ho);
  } else
    Kt.s = 0, Kt.e = 0, Kt.d = [0];
  return Kt;
}
function round(Kt, uo, ho) {
  var go, bo, vo, Po, Co, So, wo, Eo, Ro = Kt.d;
  for (Po = 1, vo = Ro[0]; vo >= 10; vo /= 10) Po++;
  if (go = uo - Po, go < 0)
    go += LOG_BASE, bo = uo, wo = Ro[Eo = 0];
  else {
    if (Eo = Math.ceil((go + 1) / LOG_BASE), vo = Ro.length, Eo >= vo) return Kt;
    for (wo = vo = Ro[Eo], Po = 1; vo >= 10; vo /= 10) Po++;
    go %= LOG_BASE, bo = go - LOG_BASE + Po;
  }
  if (ho !== void 0 && (vo = mathpow(10, Po - bo - 1), Co = wo / vo % 10 | 0, So = uo < 0 || Ro[Eo + 1] !== void 0 || wo % vo, So = ho < 4 ? (Co || So) && (ho == 0 || ho == (Kt.s < 0 ? 3 : 2)) : Co > 5 || Co == 5 && (ho == 4 || So || ho == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (go > 0 ? bo > 0 ? wo / mathpow(10, Po - bo) : 0 : Ro[Eo - 1]) % 10 & 1 || ho == (Kt.s < 0 ? 8 : 7))), uo < 1 || !Ro[0])
    return So ? (vo = getBase10Exponent(Kt), Ro.length = 1, uo = uo - vo - 1, Ro[0] = mathpow(10, (LOG_BASE - uo % LOG_BASE) % LOG_BASE), Kt.e = mathfloor(-uo / LOG_BASE) || 0) : (Ro.length = 1, Ro[0] = Kt.e = Kt.s = 0), Kt;
  if (go == 0 ? (Ro.length = Eo, vo = 1, Eo--) : (Ro.length = Eo + 1, vo = mathpow(10, LOG_BASE - go), Ro[Eo] = bo > 0 ? (wo / mathpow(10, Po - bo) % mathpow(10, bo) | 0) * vo : 0), So)
    for (; ; )
      if (Eo == 0) {
        (Ro[0] += vo) == BASE && (Ro[0] = 1, ++Kt.e);
        break;
      } else {
        if (Ro[Eo] += vo, Ro[Eo] != BASE) break;
        Ro[Eo--] = 0, vo = 1;
      }
  for (go = Ro.length; Ro[--go] === 0; ) Ro.pop();
  if (external && (Kt.e > MAX_E || Kt.e < -MAX_E))
    throw Error(exponentOutOfRange + getBase10Exponent(Kt));
  return Kt;
}
function subtract(Kt, uo) {
  var ho, go, bo, vo, Po, Co, So, wo, Eo, Ro, _o = Kt.constructor, Io = _o.precision;
  if (!Kt.s || !uo.s)
    return uo.s ? uo.s = -uo.s : uo = new _o(Kt), external ? round(uo, Io) : uo;
  if (So = Kt.d, Ro = uo.d, go = uo.e, wo = Kt.e, So = So.slice(), Po = wo - go, Po) {
    for (Eo = Po < 0, Eo ? (ho = So, Po = -Po, Co = Ro.length) : (ho = Ro, go = wo, Co = So.length), bo = Math.max(Math.ceil(Io / LOG_BASE), Co) + 2, Po > bo && (Po = bo, ho.length = 1), ho.reverse(), bo = Po; bo--; ) ho.push(0);
    ho.reverse();
  } else {
    for (bo = So.length, Co = Ro.length, Eo = bo < Co, Eo && (Co = bo), bo = 0; bo < Co; bo++)
      if (So[bo] != Ro[bo]) {
        Eo = So[bo] < Ro[bo];
        break;
      }
    Po = 0;
  }
  for (Eo && (ho = So, So = Ro, Ro = ho, uo.s = -uo.s), Co = So.length, bo = Ro.length - Co; bo > 0; --bo) So[Co++] = 0;
  for (bo = Ro.length; bo > Po; ) {
    if (So[--bo] < Ro[bo]) {
      for (vo = bo; vo && So[--vo] === 0; ) So[vo] = BASE - 1;
      --So[vo], So[bo] += BASE;
    }
    So[bo] -= Ro[bo];
  }
  for (; So[--Co] === 0; ) So.pop();
  for (; So[0] === 0; So.shift()) --go;
  return So[0] ? (uo.d = So, uo.e = go, external ? round(uo, Io) : uo) : new _o(0);
}
function toString(Kt, uo, ho) {
  var go, bo = getBase10Exponent(Kt), vo = digitsToString(Kt.d), Po = vo.length;
  return uo ? (ho && (go = ho - Po) > 0 ? vo = vo.charAt(0) + "." + vo.slice(1) + getZeroString(go) : Po > 1 && (vo = vo.charAt(0) + "." + vo.slice(1)), vo = vo + (bo < 0 ? "e" : "e+") + bo) : bo < 0 ? (vo = "0." + getZeroString(-bo - 1) + vo, ho && (go = ho - Po) > 0 && (vo += getZeroString(go))) : bo >= Po ? (vo += getZeroString(bo + 1 - Po), ho && (go = ho - bo - 1) > 0 && (vo = vo + "." + getZeroString(go))) : ((go = bo + 1) < Po && (vo = vo.slice(0, go) + "." + vo.slice(go)), ho && (go = ho - Po) > 0 && (bo + 1 === Po && (vo += "."), vo += getZeroString(go))), Kt.s < 0 ? "-" + vo : vo;
}
function truncate(Kt, uo) {
  if (Kt.length > uo)
    return Kt.length = uo, !0;
}
function clone(Kt) {
  var uo, ho, go;
  function bo(vo) {
    var Po = this;
    if (!(Po instanceof bo)) return new bo(vo);
    if (Po.constructor = bo, vo instanceof bo) {
      Po.s = vo.s, Po.e = vo.e, Po.d = (vo = vo.d) ? vo.slice() : vo;
      return;
    }
    if (typeof vo == "number") {
      if (vo * 0 !== 0)
        throw Error(invalidArgument + vo);
      if (vo > 0)
        Po.s = 1;
      else if (vo < 0)
        vo = -vo, Po.s = -1;
      else {
        Po.s = 0, Po.e = 0, Po.d = [0];
        return;
      }
      if (vo === ~~vo && vo < 1e7) {
        Po.e = 0, Po.d = [vo];
        return;
      }
      return parseDecimal(Po, vo.toString());
    } else if (typeof vo != "string")
      throw Error(invalidArgument + vo);
    if (vo.charCodeAt(0) === 45 ? (vo = vo.slice(1), Po.s = -1) : Po.s = 1, isDecimal.test(vo)) parseDecimal(Po, vo);
    else throw Error(invalidArgument + vo);
  }
  if (bo.prototype = P$4, bo.ROUND_UP = 0, bo.ROUND_DOWN = 1, bo.ROUND_CEIL = 2, bo.ROUND_FLOOR = 3, bo.ROUND_HALF_UP = 4, bo.ROUND_HALF_DOWN = 5, bo.ROUND_HALF_EVEN = 6, bo.ROUND_HALF_CEIL = 7, bo.ROUND_HALF_FLOOR = 8, bo.clone = clone, bo.config = bo.set = config$1, Kt === void 0 && (Kt = {}), Kt)
    for (go = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], uo = 0; uo < go.length; ) Kt.hasOwnProperty(ho = go[uo++]) || (Kt[ho] = this[ho]);
  return bo.config(Kt), bo;
}
function config$1(Kt) {
  if (!Kt || typeof Kt != "object")
    throw Error(decimalError + "Object expected");
  var uo, ho, go, bo = [
    "precision",
    1,
    MAX_DIGITS,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (uo = 0; uo < bo.length; uo += 3)
    if ((go = Kt[ho = bo[uo]]) !== void 0)
      if (mathfloor(go) === go && go >= bo[uo + 1] && go <= bo[uo + 2]) this[ho] = go;
      else throw Error(invalidArgument + ho + ": " + go);
  if ((go = Kt[ho = "LN10"]) !== void 0)
    if (go == Math.LN10) this[ho] = new this(go);
    else throw Error(invalidArgument + ho + ": " + go);
  return this;
}
var Decimal = clone(defaults);
ONE = new Decimal(1);
const Decimal$1 = Decimal;
function _toConsumableArray$9(Kt) {
  return _arrayWithoutHoles$9(Kt) || _iterableToArray$a(Kt) || _unsupportedIterableToArray$e(Kt) || _nonIterableSpread$9();
}
function _nonIterableSpread$9() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$e(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$e(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$e(Kt, uo);
  }
}
function _iterableToArray$a(Kt) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(Kt)) return Array.from(Kt);
}
function _arrayWithoutHoles$9(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$e(Kt);
}
function _arrayLikeToArray$e(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++)
    go[ho] = Kt[ho];
  return go;
}
var identity$1 = function(uo) {
  return uo;
}, PLACE_HOLDER = {
  "@@functional/placeholder": !0
}, isPlaceHolder = function(uo) {
  return uo === PLACE_HOLDER;
}, curry0 = function(uo) {
  return function ho() {
    return arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? void 0 : arguments[0]) ? ho : uo.apply(void 0, arguments);
  };
}, curryN = function Kt(uo, ho) {
  return uo === 1 ? ho : curry0(function() {
    for (var go = arguments.length, bo = new Array(go), vo = 0; vo < go; vo++)
      bo[vo] = arguments[vo];
    var Po = bo.filter(function(Co) {
      return Co !== PLACE_HOLDER;
    }).length;
    return Po >= uo ? ho.apply(void 0, bo) : Kt(uo - Po, curry0(function() {
      for (var Co = arguments.length, So = new Array(Co), wo = 0; wo < Co; wo++)
        So[wo] = arguments[wo];
      var Eo = bo.map(function(Ro) {
        return isPlaceHolder(Ro) ? So.shift() : Ro;
      });
      return ho.apply(void 0, _toConsumableArray$9(Eo).concat(So));
    }));
  });
}, curry = function(uo) {
  return curryN(uo.length, uo);
}, range$2 = function(uo, ho) {
  for (var go = [], bo = uo; bo < ho; ++bo)
    go[bo - uo] = bo;
  return go;
}, map = curry(function(Kt, uo) {
  return Array.isArray(uo) ? uo.map(Kt) : Object.keys(uo).map(function(ho) {
    return uo[ho];
  }).map(Kt);
}), compose = function() {
  for (var uo = arguments.length, ho = new Array(uo), go = 0; go < uo; go++)
    ho[go] = arguments[go];
  if (!ho.length)
    return identity$1;
  var bo = ho.reverse(), vo = bo[0], Po = bo.slice(1);
  return function() {
    return Po.reduce(function(Co, So) {
      return So(Co);
    }, vo.apply(void 0, arguments));
  };
}, reverse = function(uo) {
  return Array.isArray(uo) ? uo.reverse() : uo.split("").reverse.join("");
}, memoize = function(uo) {
  var ho = null, go = null;
  return function() {
    for (var bo = arguments.length, vo = new Array(bo), Po = 0; Po < bo; Po++)
      vo[Po] = arguments[Po];
    return ho && vo.every(function(Co, So) {
      return Co === ho[So];
    }) || (ho = vo, go = uo.apply(void 0, vo)), go;
  };
};
function getDigitCount(Kt) {
  var uo;
  return Kt === 0 ? uo = 1 : uo = Math.floor(new Decimal$1(Kt).abs().log(10).toNumber()) + 1, uo;
}
function rangeStep(Kt, uo, ho) {
  for (var go = new Decimal$1(Kt), bo = 0, vo = []; go.lt(uo) && bo < 1e5; )
    vo.push(go.toNumber()), go = go.add(ho), bo++;
  return vo;
}
var interpolateNumber = curry(function(Kt, uo, ho) {
  var go = +Kt, bo = +uo;
  return go + ho * (bo - go);
}), uninterpolateNumber = curry(function(Kt, uo, ho) {
  var go = uo - +Kt;
  return go = go || 1 / 0, (ho - Kt) / go;
}), uninterpolateTruncation = curry(function(Kt, uo, ho) {
  var go = uo - +Kt;
  return go = go || 1 / 0, Math.max(0, Math.min(1, (ho - Kt) / go));
});
const Arithmetic = {
  rangeStep,
  getDigitCount,
  interpolateNumber,
  uninterpolateNumber,
  uninterpolateTruncation
};
function _toConsumableArray$8(Kt) {
  return _arrayWithoutHoles$8(Kt) || _iterableToArray$9(Kt) || _unsupportedIterableToArray$d(Kt) || _nonIterableSpread$8();
}
function _nonIterableSpread$8() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$9(Kt) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(Kt)) return Array.from(Kt);
}
function _arrayWithoutHoles$8(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$d(Kt);
}
function _slicedToArray$7(Kt, uo) {
  return _arrayWithHoles$8(Kt) || _iterableToArrayLimit$7(Kt, uo) || _unsupportedIterableToArray$d(Kt, uo) || _nonIterableRest$8();
}
function _nonIterableRest$8() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$d(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$d(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$d(Kt, uo);
  }
}
function _arrayLikeToArray$d(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++)
    go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$7(Kt, uo) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(Kt)))) {
    var ho = [], go = !0, bo = !1, vo = void 0;
    try {
      for (var Po = Kt[Symbol.iterator](), Co; !(go = (Co = Po.next()).done) && (ho.push(Co.value), !(uo && ho.length === uo)); go = !0)
        ;
    } catch (So) {
      bo = !0, vo = So;
    } finally {
      try {
        !go && Po.return != null && Po.return();
      } finally {
        if (bo) throw vo;
      }
    }
    return ho;
  }
}
function _arrayWithHoles$8(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function getValidInterval(Kt) {
  var uo = _slicedToArray$7(Kt, 2), ho = uo[0], go = uo[1], bo = ho, vo = go;
  return ho > go && (bo = go, vo = ho), [bo, vo];
}
function getFormatStep(Kt, uo, ho) {
  if (Kt.lte(0))
    return new Decimal$1(0);
  var go = Arithmetic.getDigitCount(Kt.toNumber()), bo = new Decimal$1(10).pow(go), vo = Kt.div(bo), Po = go !== 1 ? 0.05 : 0.1, Co = new Decimal$1(Math.ceil(vo.div(Po).toNumber())).add(ho).mul(Po), So = Co.mul(bo);
  return uo ? So : new Decimal$1(Math.ceil(So));
}
function getTickOfSingleValue(Kt, uo, ho) {
  var go = 1, bo = new Decimal$1(Kt);
  if (!bo.isint() && ho) {
    var vo = Math.abs(Kt);
    vo < 1 ? (go = new Decimal$1(10).pow(Arithmetic.getDigitCount(Kt) - 1), bo = new Decimal$1(Math.floor(bo.div(go).toNumber())).mul(go)) : vo > 1 && (bo = new Decimal$1(Math.floor(Kt)));
  } else Kt === 0 ? bo = new Decimal$1(Math.floor((uo - 1) / 2)) : ho || (bo = new Decimal$1(Math.floor(Kt)));
  var Po = Math.floor((uo - 1) / 2), Co = compose(map(function(So) {
    return bo.add(new Decimal$1(So - Po).mul(go)).toNumber();
  }), range$2);
  return Co(0, uo);
}
function calculateStep(Kt, uo, ho, go) {
  var bo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((uo - Kt) / (ho - 1)))
    return {
      step: new Decimal$1(0),
      tickMin: new Decimal$1(0),
      tickMax: new Decimal$1(0)
    };
  var vo = getFormatStep(new Decimal$1(uo).sub(Kt).div(ho - 1), go, bo), Po;
  Kt <= 0 && uo >= 0 ? Po = new Decimal$1(0) : (Po = new Decimal$1(Kt).add(uo).div(2), Po = Po.sub(new Decimal$1(Po).mod(vo)));
  var Co = Math.ceil(Po.sub(Kt).div(vo).toNumber()), So = Math.ceil(new Decimal$1(uo).sub(Po).div(vo).toNumber()), wo = Co + So + 1;
  return wo > ho ? calculateStep(Kt, uo, ho, go, bo + 1) : (wo < ho && (So = uo > 0 ? So + (ho - wo) : So, Co = uo > 0 ? Co : Co + (ho - wo)), {
    step: vo,
    tickMin: Po.sub(new Decimal$1(Co).mul(vo)),
    tickMax: Po.add(new Decimal$1(So).mul(vo))
  });
}
function getNiceTickValuesFn(Kt) {
  var uo = _slicedToArray$7(Kt, 2), ho = uo[0], go = uo[1], bo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, vo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, Po = Math.max(bo, 2), Co = getValidInterval([ho, go]), So = _slicedToArray$7(Co, 2), wo = So[0], Eo = So[1];
  if (wo === -1 / 0 || Eo === 1 / 0) {
    var Ro = Eo === 1 / 0 ? [wo].concat(_toConsumableArray$8(range$2(0, bo - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(_toConsumableArray$8(range$2(0, bo - 1).map(function() {
      return -1 / 0;
    })), [Eo]);
    return ho > go ? reverse(Ro) : Ro;
  }
  if (wo === Eo)
    return getTickOfSingleValue(wo, bo, vo);
  var _o = calculateStep(wo, Eo, Po, vo), Io = _o.step, Ao = _o.tickMin, Oo = _o.tickMax, jo = Arithmetic.rangeStep(Ao, Oo.add(new Decimal$1(0.1).mul(Io)), Io);
  return ho > go ? reverse(jo) : jo;
}
function getTickValuesFixedDomainFn(Kt, uo) {
  var ho = _slicedToArray$7(Kt, 2), go = ho[0], bo = ho[1], vo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, Po = getValidInterval([go, bo]), Co = _slicedToArray$7(Po, 2), So = Co[0], wo = Co[1];
  if (So === -1 / 0 || wo === 1 / 0)
    return [go, bo];
  if (So === wo)
    return [So];
  var Eo = Math.max(uo, 2), Ro = getFormatStep(new Decimal$1(wo).sub(So).div(Eo - 1), vo, 0), _o = [].concat(_toConsumableArray$8(Arithmetic.rangeStep(new Decimal$1(So), new Decimal$1(wo).sub(new Decimal$1(0.99).mul(Ro)), Ro)), [wo]);
  return go > bo ? reverse(_o) : _o;
}
var getNiceTickValues = memoize(getNiceTickValuesFn), getTickValuesFixedDomain = memoize(getTickValuesFixedDomainFn), isProduction = process.env.NODE_ENV === "production", prefix = "Invariant failed";
function invariant(Kt, uo) {
  if (isProduction)
    throw new Error(prefix);
  var ho = typeof uo == "function" ? uo() : uo, go = ho ? "".concat(prefix, ": ").concat(ho) : prefix;
  throw new Error(go);
}
var _excluded$a = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function _typeof$w(Kt) {
  "@babel/helpers - typeof";
  return _typeof$w = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$w(Kt);
}
function _extends$j() {
  return _extends$j = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$j.apply(this, arguments);
}
function _slicedToArray$6(Kt, uo) {
  return _arrayWithHoles$7(Kt) || _iterableToArrayLimit$6(Kt, uo) || _unsupportedIterableToArray$c(Kt, uo) || _nonIterableRest$7();
}
function _nonIterableRest$7() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$c(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$c(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$c(Kt, uo);
  }
}
function _arrayLikeToArray$c(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$6(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$7(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function _objectWithoutProperties$a(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$a(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$a(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function _classCallCheck$c(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$c(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$u(go.key), go);
  }
}
function _createClass$c(Kt, uo, ho) {
  return _defineProperties$c(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$9(Kt, uo, ho) {
  return uo = _getPrototypeOf$a(uo), _possibleConstructorReturn$a(Kt, _isNativeReflectConstruct$a() ? Reflect.construct(uo, ho || [], _getPrototypeOf$a(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$a(Kt, uo) {
  if (uo && (_typeof$w(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$a(Kt);
}
function _assertThisInitialized$a(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$a() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$a = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$a(Kt) {
  return _getPrototypeOf$a = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$a(Kt);
}
function _inherits$a(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$a(Kt, uo);
}
function _setPrototypeOf$a(Kt, uo) {
  return _setPrototypeOf$a = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$a(Kt, uo);
}
function _defineProperty$u(Kt, uo, ho) {
  return uo = _toPropertyKey$u(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$u(Kt) {
  var uo = _toPrimitive$u(Kt, "string");
  return _typeof$w(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$u(Kt, uo) {
  if (_typeof$w(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$w(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var ErrorBar = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$c(this, uo), _callSuper$9(this, uo, arguments);
  }
  return _inherits$a(uo, Kt), _createClass$c(uo, [{
    key: "render",
    value: function() {
      var go = this.props, bo = go.offset, vo = go.layout, Po = go.width, Co = go.dataKey, So = go.data, wo = go.dataPointFormatter, Eo = go.xAxis, Ro = go.yAxis, _o = _objectWithoutProperties$a(go, _excluded$a), Io = filterProps(_o, !1);
      this.props.direction === "x" && Eo.type !== "number" && (process.env.NODE_ENV !== "production" ? invariant(!1, 'ErrorBar requires Axis type property to be "number".') : invariant());
      var Ao = So.map(function(Oo) {
        var jo = wo(Oo, Co), Do = jo.x, Lo = jo.y, ko = jo.value, Ko = jo.errorVal;
        if (!Ko)
          return null;
        var No = [], Jo, ti;
        if (Array.isArray(Ko)) {
          var oi = _slicedToArray$6(Ko, 2);
          Jo = oi[0], ti = oi[1];
        } else
          Jo = ti = Ko;
        if (vo === "vertical") {
          var Qo = Eo.scale, Zo = Lo + bo, ei = Zo + Po, ii = Zo - Po, ai = Qo(ko - Jo), ri = Qo(ko + ti);
          No.push({
            x1: ri,
            y1: ei,
            x2: ri,
            y2: ii
          }), No.push({
            x1: ai,
            y1: Zo,
            x2: ri,
            y2: Zo
          }), No.push({
            x1: ai,
            y1: ei,
            x2: ai,
            y2: ii
          });
        } else if (vo === "horizontal") {
          var ni = Ro.scale, si = Do + bo, li = si - Po, ui = si + Po, ci = ni(ko - Jo), fi = ni(ko + ti);
          No.push({
            x1: li,
            y1: fi,
            x2: ui,
            y2: fi
          }), No.push({
            x1: si,
            y1: ci,
            x2: si,
            y2: fi
          }), No.push({
            x1: li,
            y1: ci,
            x2: ui,
            y2: ci
          });
        }
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$j({
          className: "recharts-errorBar",
          key: "bar-".concat(No.map(function(yi) {
            return "".concat(yi.x1, "-").concat(yi.x2, "-").concat(yi.y1, "-").concat(yi.y2);
          }))
        }, Io), No.map(function(yi) {
          return /* @__PURE__ */ React__default.createElement("line", _extends$j({}, yi, {
            key: "line-".concat(yi.x1, "-").concat(yi.x2, "-").concat(yi.y1, "-").concat(yi.y2)
          }));
        }));
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-errorBars"
      }, Ao);
    }
  }]);
}(React__default.Component);
_defineProperty$u(ErrorBar, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
_defineProperty$u(ErrorBar, "displayName", "ErrorBar");
function _typeof$v(Kt) {
  "@babel/helpers - typeof";
  return _typeof$v = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$v(Kt);
}
function ownKeys$q(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$q(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$q(Object(ho), !0).forEach(function(go) {
      _defineProperty$t(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$q(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$t(Kt, uo, ho) {
  return uo = _toPropertyKey$t(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$t(Kt) {
  var uo = _toPrimitive$t(Kt, "string");
  return _typeof$v(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$t(Kt, uo) {
  if (_typeof$v(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$v(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var getLegendProps = function(uo) {
  var ho = uo.children, go = uo.formattedGraphicalItems, bo = uo.legendWidth, vo = uo.legendContent, Po = findChildByType(ho, Legend);
  if (!Po)
    return null;
  var Co = Legend.defaultProps, So = Co !== void 0 ? _objectSpread$q(_objectSpread$q({}, Co), Po.props) : {}, wo;
  return Po.props && Po.props.payload ? wo = Po.props && Po.props.payload : vo === "children" ? wo = (go || []).reduce(function(Eo, Ro) {
    var _o = Ro.item, Io = Ro.props, Ao = Io.sectors || Io.data || [];
    return Eo.concat(Ao.map(function(Oo) {
      return {
        type: Po.props.iconType || _o.props.legendType,
        value: Oo.name,
        color: Oo.fill,
        payload: Oo
      };
    }));
  }, []) : wo = (go || []).map(function(Eo) {
    var Ro = Eo.item, _o = Ro.type.defaultProps, Io = _o !== void 0 ? _objectSpread$q(_objectSpread$q({}, _o), Ro.props) : {}, Ao = Io.dataKey, Oo = Io.name, jo = Io.legendType, Do = Io.hide;
    return {
      inactive: Do,
      dataKey: Ao,
      type: So.iconType || jo || "square",
      color: getMainColorOfGraphicItem(Ro),
      value: Oo || Ao,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: Io
    };
  }), _objectSpread$q(_objectSpread$q(_objectSpread$q({}, So), Legend.getWithHeight(Po, bo)), {}, {
    payload: wo,
    item: Po
  });
};
function _typeof$u(Kt) {
  "@babel/helpers - typeof";
  return _typeof$u = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$u(Kt);
}
function _toConsumableArray$7(Kt) {
  return _arrayWithoutHoles$7(Kt) || _iterableToArray$8(Kt) || _unsupportedIterableToArray$b(Kt) || _nonIterableSpread$7();
}
function _nonIterableSpread$7() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$b(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$b(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$b(Kt, uo);
  }
}
function _iterableToArray$8(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles$7(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$b(Kt);
}
function _arrayLikeToArray$b(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function ownKeys$p(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$p(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$p(Object(ho), !0).forEach(function(go) {
      _defineProperty$s(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$p(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$s(Kt, uo, ho) {
  return uo = _toPropertyKey$s(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$s(Kt) {
  var uo = _toPrimitive$s(Kt, "string");
  return _typeof$u(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$s(Kt, uo) {
  if (_typeof$u(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$u(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function getValueByDataKey(Kt, uo, ho) {
  return isNil$1(Kt) || isNil$1(uo) ? ho : isNumOrStr(uo) ? get$2(Kt, uo, ho) : isFunction$3(uo) ? uo(Kt) : ho;
}
function getDomainOfDataByKey(Kt, uo, ho, go) {
  var bo = flatMap$1(Kt, function(Co) {
    return getValueByDataKey(Co, uo);
  });
  if (ho === "number") {
    var vo = bo.filter(function(Co) {
      return isNumber(Co) || parseFloat(Co);
    });
    return vo.length ? [min$1(vo), max$1(vo)] : [1 / 0, -1 / 0];
  }
  var Po = go ? bo.filter(function(Co) {
    return !isNil$1(Co);
  }) : bo;
  return Po.map(function(Co) {
    return isNumOrStr(Co) || Co instanceof Date ? Co : "";
  });
}
var calculateActiveTickIndex = function(uo) {
  var ho, go = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], bo = arguments.length > 2 ? arguments[2] : void 0, vo = arguments.length > 3 ? arguments[3] : void 0, Po = -1, Co = (ho = go == null ? void 0 : go.length) !== null && ho !== void 0 ? ho : 0;
  if (Co <= 1)
    return 0;
  if (vo && vo.axisType === "angleAxis" && Math.abs(Math.abs(vo.range[1] - vo.range[0]) - 360) <= 1e-6)
    for (var So = vo.range, wo = 0; wo < Co; wo++) {
      var Eo = wo > 0 ? bo[wo - 1].coordinate : bo[Co - 1].coordinate, Ro = bo[wo].coordinate, _o = wo >= Co - 1 ? bo[0].coordinate : bo[wo + 1].coordinate, Io = void 0;
      if (mathSign(Ro - Eo) !== mathSign(_o - Ro)) {
        var Ao = [];
        if (mathSign(_o - Ro) === mathSign(So[1] - So[0])) {
          Io = _o;
          var Oo = Ro + So[1] - So[0];
          Ao[0] = Math.min(Oo, (Oo + Eo) / 2), Ao[1] = Math.max(Oo, (Oo + Eo) / 2);
        } else {
          Io = Eo;
          var jo = _o + So[1] - So[0];
          Ao[0] = Math.min(Ro, (jo + Ro) / 2), Ao[1] = Math.max(Ro, (jo + Ro) / 2);
        }
        var Do = [Math.min(Ro, (Io + Ro) / 2), Math.max(Ro, (Io + Ro) / 2)];
        if (uo > Do[0] && uo <= Do[1] || uo >= Ao[0] && uo <= Ao[1]) {
          Po = bo[wo].index;
          break;
        }
      } else {
        var Lo = Math.min(Eo, _o), ko = Math.max(Eo, _o);
        if (uo > (Lo + Ro) / 2 && uo <= (ko + Ro) / 2) {
          Po = bo[wo].index;
          break;
        }
      }
    }
  else
    for (var Ko = 0; Ko < Co; Ko++)
      if (Ko === 0 && uo <= (go[Ko].coordinate + go[Ko + 1].coordinate) / 2 || Ko > 0 && Ko < Co - 1 && uo > (go[Ko].coordinate + go[Ko - 1].coordinate) / 2 && uo <= (go[Ko].coordinate + go[Ko + 1].coordinate) / 2 || Ko === Co - 1 && uo > (go[Ko].coordinate + go[Ko - 1].coordinate) / 2) {
        Po = go[Ko].index;
        break;
      }
  return Po;
}, getMainColorOfGraphicItem = function(uo) {
  var ho, go = uo, bo = go.type.displayName, vo = (ho = uo.type) !== null && ho !== void 0 && ho.defaultProps ? _objectSpread$p(_objectSpread$p({}, uo.type.defaultProps), uo.props) : uo.props, Po = vo.stroke, Co = vo.fill, So;
  switch (bo) {
    case "Line":
      So = Po;
      break;
    case "Area":
    case "Radar":
      So = Po && Po !== "none" ? Po : Co;
      break;
    default:
      So = Co;
      break;
  }
  return So;
}, getBarSizeList = function(uo) {
  var ho = uo.barSize, go = uo.totalSize, bo = uo.stackGroups, vo = bo === void 0 ? {} : bo;
  if (!vo)
    return {};
  for (var Po = {}, Co = Object.keys(vo), So = 0, wo = Co.length; So < wo; So++)
    for (var Eo = vo[Co[So]].stackGroups, Ro = Object.keys(Eo), _o = 0, Io = Ro.length; _o < Io; _o++) {
      var Ao = Eo[Ro[_o]], Oo = Ao.items, jo = Ao.cateAxisId, Do = Oo.filter(function(ti) {
        return getDisplayName(ti.type).indexOf("Bar") >= 0;
      });
      if (Do && Do.length) {
        var Lo = Do[0].type.defaultProps, ko = Lo !== void 0 ? _objectSpread$p(_objectSpread$p({}, Lo), Do[0].props) : Do[0].props, Ko = ko.barSize, No = ko[jo];
        Po[No] || (Po[No] = []);
        var Jo = isNil$1(Ko) ? ho : Ko;
        Po[No].push({
          item: Do[0],
          stackList: Do.slice(1),
          barSize: isNil$1(Jo) ? void 0 : getPercentValue(Jo, go, 0)
        });
      }
    }
  return Po;
}, getBarPosition = function(uo) {
  var ho = uo.barGap, go = uo.barCategoryGap, bo = uo.bandSize, vo = uo.sizeList, Po = vo === void 0 ? [] : vo, Co = uo.maxBarSize, So = Po.length;
  if (So < 1) return null;
  var wo = getPercentValue(ho, bo, 0, !0), Eo, Ro = [];
  if (Po[0].barSize === +Po[0].barSize) {
    var _o = !1, Io = bo / So, Ao = Po.reduce(function(Ko, No) {
      return Ko + No.barSize || 0;
    }, 0);
    Ao += (So - 1) * wo, Ao >= bo && (Ao -= (So - 1) * wo, wo = 0), Ao >= bo && Io > 0 && (_o = !0, Io *= 0.9, Ao = So * Io);
    var Oo = (bo - Ao) / 2 >> 0, jo = {
      offset: Oo - wo,
      size: 0
    };
    Eo = Po.reduce(function(Ko, No) {
      var Jo = {
        item: No.item,
        position: {
          offset: jo.offset + jo.size + wo,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: _o ? Io : No.barSize
        }
      }, ti = [].concat(_toConsumableArray$7(Ko), [Jo]);
      return jo = ti[ti.length - 1].position, No.stackList && No.stackList.length && No.stackList.forEach(function(oi) {
        ti.push({
          item: oi,
          position: jo
        });
      }), ti;
    }, Ro);
  } else {
    var Do = getPercentValue(go, bo, 0, !0);
    bo - 2 * Do - (So - 1) * wo <= 0 && (wo = 0);
    var Lo = (bo - 2 * Do - (So - 1) * wo) / So;
    Lo > 1 && (Lo >>= 0);
    var ko = Co === +Co ? Math.min(Lo, Co) : Lo;
    Eo = Po.reduce(function(Ko, No, Jo) {
      var ti = [].concat(_toConsumableArray$7(Ko), [{
        item: No.item,
        position: {
          offset: Do + (Lo + wo) * Jo + (Lo - ko) / 2,
          size: ko
        }
      }]);
      return No.stackList && No.stackList.length && No.stackList.forEach(function(oi) {
        ti.push({
          item: oi,
          position: ti[ti.length - 1].position
        });
      }), ti;
    }, Ro);
  }
  return Eo;
}, appendOffsetOfLegend = function(uo, ho, go, bo) {
  var vo = go.children, Po = go.width, Co = go.margin, So = Po - (Co.left || 0) - (Co.right || 0), wo = getLegendProps({
    children: vo,
    legendWidth: So
  });
  if (wo) {
    var Eo = bo || {}, Ro = Eo.width, _o = Eo.height, Io = wo.align, Ao = wo.verticalAlign, Oo = wo.layout;
    if ((Oo === "vertical" || Oo === "horizontal" && Ao === "middle") && Io !== "center" && isNumber(uo[Io]))
      return _objectSpread$p(_objectSpread$p({}, uo), {}, _defineProperty$s({}, Io, uo[Io] + (Ro || 0)));
    if ((Oo === "horizontal" || Oo === "vertical" && Io === "center") && Ao !== "middle" && isNumber(uo[Ao]))
      return _objectSpread$p(_objectSpread$p({}, uo), {}, _defineProperty$s({}, Ao, uo[Ao] + (_o || 0)));
  }
  return uo;
}, isErrorBarRelevantForAxis = function(uo, ho, go) {
  return isNil$1(ho) ? !0 : uo === "horizontal" ? ho === "yAxis" : uo === "vertical" || go === "x" ? ho === "xAxis" : go === "y" ? ho === "yAxis" : !0;
}, getDomainOfErrorBars = function(uo, ho, go, bo, vo) {
  var Po = ho.props.children, Co = findAllByType(Po, ErrorBar).filter(function(wo) {
    return isErrorBarRelevantForAxis(bo, vo, wo.props.direction);
  });
  if (Co && Co.length) {
    var So = Co.map(function(wo) {
      return wo.props.dataKey;
    });
    return uo.reduce(function(wo, Eo) {
      var Ro = getValueByDataKey(Eo, go);
      if (isNil$1(Ro)) return wo;
      var _o = Array.isArray(Ro) ? [min$1(Ro), max$1(Ro)] : [Ro, Ro], Io = So.reduce(function(Ao, Oo) {
        var jo = getValueByDataKey(Eo, Oo, 0), Do = _o[0] - Math.abs(Array.isArray(jo) ? jo[0] : jo), Lo = _o[1] + Math.abs(Array.isArray(jo) ? jo[1] : jo);
        return [Math.min(Do, Ao[0]), Math.max(Lo, Ao[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(Io[0], wo[0]), Math.max(Io[1], wo[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, parseErrorBarsOfAxis = function(uo, ho, go, bo, vo) {
  var Po = ho.map(function(Co) {
    return getDomainOfErrorBars(uo, Co, go, vo, bo);
  }).filter(function(Co) {
    return !isNil$1(Co);
  });
  return Po && Po.length ? Po.reduce(function(Co, So) {
    return [Math.min(Co[0], So[0]), Math.max(Co[1], So[1])];
  }, [1 / 0, -1 / 0]) : null;
}, getDomainOfItemsWithSameAxis = function(uo, ho, go, bo, vo) {
  var Po = ho.map(function(So) {
    var wo = So.props.dataKey;
    return go === "number" && wo && getDomainOfErrorBars(uo, So, wo, bo) || getDomainOfDataByKey(uo, wo, go, vo);
  });
  if (go === "number")
    return Po.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(So, wo) {
        return [Math.min(So[0], wo[0]), Math.max(So[1], wo[1])];
      },
      [1 / 0, -1 / 0]
    );
  var Co = {};
  return Po.reduce(function(So, wo) {
    for (var Eo = 0, Ro = wo.length; Eo < Ro; Eo++)
      Co[wo[Eo]] || (Co[wo[Eo]] = !0, So.push(wo[Eo]));
    return So;
  }, []);
}, isCategoricalAxis = function(uo, ho) {
  return uo === "horizontal" && ho === "xAxis" || uo === "vertical" && ho === "yAxis" || uo === "centric" && ho === "angleAxis" || uo === "radial" && ho === "radiusAxis";
}, getCoordinatesOfGrid = function(uo, ho, go, bo) {
  if (bo)
    return uo.map(function(So) {
      return So.coordinate;
    });
  var vo, Po, Co = uo.map(function(So) {
    return So.coordinate === ho && (vo = !0), So.coordinate === go && (Po = !0), So.coordinate;
  });
  return vo || Co.push(ho), Po || Co.push(go), Co;
}, getTicksOfAxis = function(uo, ho, go) {
  if (!uo) return null;
  var bo = uo.scale, vo = uo.duplicateDomain, Po = uo.type, Co = uo.range, So = uo.realScaleType === "scaleBand" ? bo.bandwidth() / 2 : 2, wo = (ho || go) && Po === "category" && bo.bandwidth ? bo.bandwidth() / So : 0;
  if (wo = uo.axisType === "angleAxis" && (Co == null ? void 0 : Co.length) >= 2 ? mathSign(Co[0] - Co[1]) * 2 * wo : wo, ho && (uo.ticks || uo.niceTicks)) {
    var Eo = (uo.ticks || uo.niceTicks).map(function(Ro) {
      var _o = vo ? vo.indexOf(Ro) : Ro;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: bo(_o) + wo,
        value: Ro,
        offset: wo
      };
    });
    return Eo.filter(function(Ro) {
      return !isNan(Ro.coordinate);
    });
  }
  return uo.isCategorical && uo.categoricalDomain ? uo.categoricalDomain.map(function(Ro, _o) {
    return {
      coordinate: bo(Ro) + wo,
      value: Ro,
      index: _o,
      offset: wo
    };
  }) : bo.ticks && !go ? bo.ticks(uo.tickCount).map(function(Ro) {
    return {
      coordinate: bo(Ro) + wo,
      value: Ro,
      offset: wo
    };
  }) : bo.domain().map(function(Ro, _o) {
    return {
      coordinate: bo(Ro) + wo,
      value: vo ? vo[Ro] : Ro,
      index: _o,
      offset: wo
    };
  });
}, handlerWeakMap = /* @__PURE__ */ new WeakMap(), combineEventHandlers = function(uo, ho) {
  if (typeof ho != "function")
    return uo;
  handlerWeakMap.has(uo) || handlerWeakMap.set(uo, /* @__PURE__ */ new WeakMap());
  var go = handlerWeakMap.get(uo);
  if (go.has(ho))
    return go.get(ho);
  var bo = function() {
    uo.apply(void 0, arguments), ho.apply(void 0, arguments);
  };
  return go.set(ho, bo), bo;
}, parseScale = function(uo, ho, go) {
  var bo = uo.scale, vo = uo.type, Po = uo.layout, Co = uo.axisType;
  if (bo === "auto")
    return Po === "radial" && Co === "radiusAxis" ? {
      scale: band(),
      realScaleType: "band"
    } : Po === "radial" && Co === "angleAxis" ? {
      scale: linear(),
      realScaleType: "linear"
    } : vo === "category" && ho && (ho.indexOf("LineChart") >= 0 || ho.indexOf("AreaChart") >= 0 || ho.indexOf("ComposedChart") >= 0 && !go) ? {
      scale: point(),
      realScaleType: "point"
    } : vo === "category" ? {
      scale: band(),
      realScaleType: "band"
    } : {
      scale: linear(),
      realScaleType: "linear"
    };
  if (isString$1(bo)) {
    var So = "scale".concat(upperFirst$1(bo));
    return {
      scale: (d3Scales[So] || point)(),
      realScaleType: d3Scales[So] ? So : "point"
    };
  }
  return isFunction$3(bo) ? {
    scale: bo
  } : {
    scale: point(),
    realScaleType: "point"
  };
}, EPS = 1e-4, checkDomainOfScale = function(uo) {
  var ho = uo.domain();
  if (!(!ho || ho.length <= 2)) {
    var go = ho.length, bo = uo.range(), vo = Math.min(bo[0], bo[1]) - EPS, Po = Math.max(bo[0], bo[1]) + EPS, Co = uo(ho[0]), So = uo(ho[go - 1]);
    (Co < vo || Co > Po || So < vo || So > Po) && uo.domain([ho[0], ho[go - 1]]);
  }
}, findPositionOfBar = function(uo, ho) {
  if (!uo)
    return null;
  for (var go = 0, bo = uo.length; go < bo; go++)
    if (uo[go].item === ho)
      return uo[go].position;
  return null;
}, truncateByDomain = function(uo, ho) {
  if (!ho || ho.length !== 2 || !isNumber(ho[0]) || !isNumber(ho[1]))
    return uo;
  var go = Math.min(ho[0], ho[1]), bo = Math.max(ho[0], ho[1]), vo = [uo[0], uo[1]];
  return (!isNumber(uo[0]) || uo[0] < go) && (vo[0] = go), (!isNumber(uo[1]) || uo[1] > bo) && (vo[1] = bo), vo[0] > bo && (vo[0] = bo), vo[1] < go && (vo[1] = go), vo;
}, offsetSign = function(uo) {
  var ho = uo.length;
  if (!(ho <= 0))
    for (var go = 0, bo = uo[0].length; go < bo; ++go)
      for (var vo = 0, Po = 0, Co = 0; Co < ho; ++Co) {
        var So = isNan(uo[Co][go][1]) ? uo[Co][go][0] : uo[Co][go][1];
        So >= 0 ? (uo[Co][go][0] = vo, uo[Co][go][1] = vo + So, vo = uo[Co][go][1]) : (uo[Co][go][0] = Po, uo[Co][go][1] = Po + So, Po = uo[Co][go][1]);
      }
}, offsetPositive = function(uo) {
  var ho = uo.length;
  if (!(ho <= 0))
    for (var go = 0, bo = uo[0].length; go < bo; ++go)
      for (var vo = 0, Po = 0; Po < ho; ++Po) {
        var Co = isNan(uo[Po][go][1]) ? uo[Po][go][0] : uo[Po][go][1];
        Co >= 0 ? (uo[Po][go][0] = vo, uo[Po][go][1] = vo + Co, vo = uo[Po][go][1]) : (uo[Po][go][0] = 0, uo[Po][go][1] = 0);
      }
}, STACK_OFFSET_MAP = {
  sign: offsetSign,
  // @ts-expect-error definitelytyped types are incorrect
  expand: stackOffsetExpand,
  // @ts-expect-error definitelytyped types are incorrect
  none: stackOffsetNone,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: stackOffsetSilhouette,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: stackOffsetWiggle,
  positive: offsetPositive
}, getStackedData = function(uo, ho, go) {
  var bo = ho.map(function(Co) {
    return Co.props.dataKey;
  }), vo = STACK_OFFSET_MAP[go], Po = shapeStack().keys(bo).value(function(Co, So) {
    return +getValueByDataKey(Co, So, 0);
  }).order(stackOrderNone).offset(vo);
  return Po(uo);
}, getStackGroupsByAxisId = function(uo, ho, go, bo, vo, Po) {
  if (!uo)
    return null;
  var Co = Po ? ho.reverse() : ho, So = {}, wo = Co.reduce(function(Ro, _o) {
    var Io, Ao = (Io = _o.type) !== null && Io !== void 0 && Io.defaultProps ? _objectSpread$p(_objectSpread$p({}, _o.type.defaultProps), _o.props) : _o.props, Oo = Ao.stackId, jo = Ao.hide;
    if (jo)
      return Ro;
    var Do = Ao[go], Lo = Ro[Do] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (isNumOrStr(Oo)) {
      var ko = Lo.stackGroups[Oo] || {
        numericAxisId: go,
        cateAxisId: bo,
        items: []
      };
      ko.items.push(_o), Lo.hasStack = !0, Lo.stackGroups[Oo] = ko;
    } else
      Lo.stackGroups[uniqueId("_stackId_")] = {
        numericAxisId: go,
        cateAxisId: bo,
        items: [_o]
      };
    return _objectSpread$p(_objectSpread$p({}, Ro), {}, _defineProperty$s({}, Do, Lo));
  }, So), Eo = {};
  return Object.keys(wo).reduce(function(Ro, _o) {
    var Io = wo[_o];
    if (Io.hasStack) {
      var Ao = {};
      Io.stackGroups = Object.keys(Io.stackGroups).reduce(function(Oo, jo) {
        var Do = Io.stackGroups[jo];
        return _objectSpread$p(_objectSpread$p({}, Oo), {}, _defineProperty$s({}, jo, {
          numericAxisId: go,
          cateAxisId: bo,
          items: Do.items,
          stackedData: getStackedData(uo, Do.items, vo)
        }));
      }, Ao);
    }
    return _objectSpread$p(_objectSpread$p({}, Ro), {}, _defineProperty$s({}, _o, Io));
  }, Eo);
}, getTicksOfScale = function(uo, ho) {
  var go = ho.realScaleType, bo = ho.type, vo = ho.tickCount, Po = ho.originalDomain, Co = ho.allowDecimals, So = go || ho.scale;
  if (So !== "auto" && So !== "linear")
    return null;
  if (vo && bo === "number" && Po && (Po[0] === "auto" || Po[1] === "auto")) {
    var wo = uo.domain();
    if (!wo.length)
      return null;
    var Eo = getNiceTickValues(wo, vo, Co);
    return uo.domain([min$1(Eo), max$1(Eo)]), {
      niceTicks: Eo
    };
  }
  if (vo && bo === "number") {
    var Ro = uo.domain(), _o = getTickValuesFixedDomain(Ro, vo, Co);
    return {
      niceTicks: _o
    };
  }
  return null;
}, getCateCoordinateOfBar = function(uo) {
  var ho = uo.axis, go = uo.ticks, bo = uo.offset, vo = uo.bandSize, Po = uo.entry, Co = uo.index;
  if (ho.type === "category")
    return go[Co] ? go[Co].coordinate + bo : null;
  var So = getValueByDataKey(Po, ho.dataKey, ho.domain[Co]);
  return isNil$1(So) ? null : ho.scale(So) - vo / 2 + bo;
}, getBaseValueOfBar = function(uo) {
  var ho = uo.numericAxis, go = ho.scale.domain();
  if (ho.type === "number") {
    var bo = Math.min(go[0], go[1]), vo = Math.max(go[0], go[1]);
    return bo <= 0 && vo >= 0 ? 0 : vo < 0 ? vo : bo;
  }
  return go[0];
}, getStackedDataOfItem = function(uo, ho) {
  var go, bo = (go = uo.type) !== null && go !== void 0 && go.defaultProps ? _objectSpread$p(_objectSpread$p({}, uo.type.defaultProps), uo.props) : uo.props, vo = bo.stackId;
  if (isNumOrStr(vo)) {
    var Po = ho[vo];
    if (Po) {
      var Co = Po.items.indexOf(uo);
      return Co >= 0 ? Po.stackedData[Co] : null;
    }
  }
  return null;
}, getDomainOfSingle = function(uo) {
  return uo.reduce(function(ho, go) {
    return [min$1(go.concat([ho[0]]).filter(isNumber)), max$1(go.concat([ho[1]]).filter(isNumber))];
  }, [1 / 0, -1 / 0]);
}, getDomainOfStackGroups = function(uo, ho, go) {
  return Object.keys(uo).reduce(function(bo, vo) {
    var Po = uo[vo], Co = Po.stackedData, So = Co.reduce(function(wo, Eo) {
      var Ro = getDomainOfSingle(Eo.slice(ho, go + 1));
      return [Math.min(wo[0], Ro[0]), Math.max(wo[1], Ro[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(So[0], bo[0]), Math.max(So[1], bo[1])];
  }, [1 / 0, -1 / 0]).map(function(bo) {
    return bo === 1 / 0 || bo === -1 / 0 ? 0 : bo;
  });
}, MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, parseSpecifiedDomain = function(uo, ho, go) {
  if (isFunction$3(uo))
    return uo(ho, go);
  if (!Array.isArray(uo))
    return ho;
  var bo = [];
  if (isNumber(uo[0]))
    bo[0] = go ? uo[0] : Math.min(uo[0], ho[0]);
  else if (MIN_VALUE_REG.test(uo[0])) {
    var vo = +MIN_VALUE_REG.exec(uo[0])[1];
    bo[0] = ho[0] - vo;
  } else isFunction$3(uo[0]) ? bo[0] = uo[0](ho[0]) : bo[0] = ho[0];
  if (isNumber(uo[1]))
    bo[1] = go ? uo[1] : Math.max(uo[1], ho[1]);
  else if (MAX_VALUE_REG.test(uo[1])) {
    var Po = +MAX_VALUE_REG.exec(uo[1])[1];
    bo[1] = ho[1] + Po;
  } else isFunction$3(uo[1]) ? bo[1] = uo[1](ho[1]) : bo[1] = ho[1];
  return bo;
}, getBandSizeOfAxis = function(uo, ho, go) {
  if (uo && uo.scale && uo.scale.bandwidth) {
    var bo = uo.scale.bandwidth();
    if (!go || bo > 0)
      return bo;
  }
  if (uo && ho && ho.length >= 2) {
    for (var vo = sortBy$1(ho, function(Ro) {
      return Ro.coordinate;
    }), Po = 1 / 0, Co = 1, So = vo.length; Co < So; Co++) {
      var wo = vo[Co], Eo = vo[Co - 1];
      Po = Math.min((wo.coordinate || 0) - (Eo.coordinate || 0), Po);
    }
    return Po === 1 / 0 ? 0 : Po;
  }
  return go ? void 0 : 0;
}, parseDomainOfCategoryAxis = function(uo, ho, go) {
  return !uo || !uo.length || isEqual$1(uo, get$2(go, "type.defaultProps.domain")) ? ho : uo;
}, getTooltipItem = function(uo, ho) {
  var go = uo.type.defaultProps ? _objectSpread$p(_objectSpread$p({}, uo.type.defaultProps), uo.props) : uo.props, bo = go.dataKey, vo = go.name, Po = go.unit, Co = go.formatter, So = go.tooltipType, wo = go.chartType, Eo = go.hide;
  return _objectSpread$p(_objectSpread$p({}, filterProps(uo, !1)), {}, {
    dataKey: bo,
    unit: Po,
    formatter: Co,
    name: vo || bo,
    color: getMainColorOfGraphicItem(uo),
    value: getValueByDataKey(ho, bo),
    type: So,
    payload: ho,
    chartType: wo,
    hide: Eo
  });
};
function _typeof$t(Kt) {
  "@babel/helpers - typeof";
  return _typeof$t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$t(Kt);
}
function ownKeys$o(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$o(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$o(Object(ho), !0).forEach(function(go) {
      _defineProperty$r(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$o(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$r(Kt, uo, ho) {
  return uo = _toPropertyKey$r(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$r(Kt) {
  var uo = _toPrimitive$r(Kt, "string");
  return _typeof$t(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$r(Kt, uo) {
  if (_typeof$t(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$t(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var RADIAN = Math.PI / 180, radianToDegree = function(uo) {
  return uo * 180 / Math.PI;
}, polarToCartesian = function(uo, ho, go, bo) {
  return {
    x: uo + Math.cos(-RADIAN * bo) * go,
    y: ho + Math.sin(-RADIAN * bo) * go
  };
}, distanceBetweenPoints = function(uo, ho) {
  var go = uo.x, bo = uo.y, vo = ho.x, Po = ho.y;
  return Math.sqrt(Math.pow(go - vo, 2) + Math.pow(bo - Po, 2));
}, getAngleOfPoint = function(uo, ho) {
  var go = uo.x, bo = uo.y, vo = ho.cx, Po = ho.cy, Co = distanceBetweenPoints({
    x: go,
    y: bo
  }, {
    x: vo,
    y: Po
  });
  if (Co <= 0)
    return {
      radius: Co
    };
  var So = (go - vo) / Co, wo = Math.acos(So);
  return bo > Po && (wo = 2 * Math.PI - wo), {
    radius: Co,
    angle: radianToDegree(wo),
    angleInRadian: wo
  };
}, formatAngleOfSector = function(uo) {
  var ho = uo.startAngle, go = uo.endAngle, bo = Math.floor(ho / 360), vo = Math.floor(go / 360), Po = Math.min(bo, vo);
  return {
    startAngle: ho - Po * 360,
    endAngle: go - Po * 360
  };
}, reverseFormatAngleOfSetor = function(uo, ho) {
  var go = ho.startAngle, bo = ho.endAngle, vo = Math.floor(go / 360), Po = Math.floor(bo / 360), Co = Math.min(vo, Po);
  return uo + Co * 360;
}, inRangeOfSector = function(uo, ho) {
  var go = uo.x, bo = uo.y, vo = getAngleOfPoint({
    x: go,
    y: bo
  }, ho), Po = vo.radius, Co = vo.angle, So = ho.innerRadius, wo = ho.outerRadius;
  if (Po < So || Po > wo)
    return !1;
  if (Po === 0)
    return !0;
  var Eo = formatAngleOfSector(ho), Ro = Eo.startAngle, _o = Eo.endAngle, Io = Co, Ao;
  if (Ro <= _o) {
    for (; Io > _o; )
      Io -= 360;
    for (; Io < Ro; )
      Io += 360;
    Ao = Io >= Ro && Io <= _o;
  } else {
    for (; Io > Ro; )
      Io -= 360;
    for (; Io < _o; )
      Io += 360;
    Ao = Io >= _o && Io <= Ro;
  }
  return Ao ? _objectSpread$o(_objectSpread$o({}, ho), {}, {
    radius: Po,
    angle: reverseFormatAngleOfSetor(Io, ho)
  }) : null;
};
function _typeof$s(Kt) {
  "@babel/helpers - typeof";
  return _typeof$s = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$s(Kt);
}
var _excluded$9 = ["offset"];
function _toConsumableArray$6(Kt) {
  return _arrayWithoutHoles$6(Kt) || _iterableToArray$7(Kt) || _unsupportedIterableToArray$a(Kt) || _nonIterableSpread$6();
}
function _nonIterableSpread$6() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$a(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$a(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$a(Kt, uo);
  }
}
function _iterableToArray$7(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles$6(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$a(Kt);
}
function _arrayLikeToArray$a(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _objectWithoutProperties$9(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$9(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$9(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function ownKeys$n(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$n(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$n(Object(ho), !0).forEach(function(go) {
      _defineProperty$q(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$n(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$q(Kt, uo, ho) {
  return uo = _toPropertyKey$q(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$q(Kt) {
  var uo = _toPrimitive$q(Kt, "string");
  return _typeof$s(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$q(Kt, uo) {
  if (_typeof$s(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$s(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _extends$i() {
  return _extends$i = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$i.apply(this, arguments);
}
var getLabel = function(uo) {
  var ho = uo.value, go = uo.formatter, bo = isNil$1(uo.children) ? ho : uo.children;
  return isFunction$3(go) ? go(bo) : bo;
}, getDeltaAngle$1 = function(uo, ho) {
  var go = mathSign(ho - uo), bo = Math.min(Math.abs(ho - uo), 360);
  return go * bo;
}, renderRadialLabel = function(uo, ho, go) {
  var bo = uo.position, vo = uo.viewBox, Po = uo.offset, Co = uo.className, So = vo, wo = So.cx, Eo = So.cy, Ro = So.innerRadius, _o = So.outerRadius, Io = So.startAngle, Ao = So.endAngle, Oo = So.clockWise, jo = (Ro + _o) / 2, Do = getDeltaAngle$1(Io, Ao), Lo = Do >= 0 ? 1 : -1, ko, Ko;
  bo === "insideStart" ? (ko = Io + Lo * Po, Ko = Oo) : bo === "insideEnd" ? (ko = Ao - Lo * Po, Ko = !Oo) : bo === "end" && (ko = Ao + Lo * Po, Ko = Oo), Ko = Do <= 0 ? Ko : !Ko;
  var No = polarToCartesian(wo, Eo, jo, ko), Jo = polarToCartesian(wo, Eo, jo, ko + (Ko ? 1 : -1) * 359), ti = "M".concat(No.x, ",").concat(No.y, `
    A`).concat(jo, ",").concat(jo, ",0,1,").concat(Ko ? 0 : 1, `,
    `).concat(Jo.x, ",").concat(Jo.y), oi = isNil$1(uo.id) ? uniqueId("recharts-radial-line-") : uo.id;
  return /* @__PURE__ */ React__default.createElement("text", _extends$i({}, go, {
    dominantBaseline: "central",
    className: clsx("recharts-radial-bar-label", Co)
  }), /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("path", {
    id: oi,
    d: ti
  })), /* @__PURE__ */ React__default.createElement("textPath", {
    xlinkHref: "#".concat(oi)
  }, ho));
}, getAttrsOfPolarLabel = function(uo) {
  var ho = uo.viewBox, go = uo.offset, bo = uo.position, vo = ho, Po = vo.cx, Co = vo.cy, So = vo.innerRadius, wo = vo.outerRadius, Eo = vo.startAngle, Ro = vo.endAngle, _o = (Eo + Ro) / 2;
  if (bo === "outside") {
    var Io = polarToCartesian(Po, Co, wo + go, _o), Ao = Io.x, Oo = Io.y;
    return {
      x: Ao,
      y: Oo,
      textAnchor: Ao >= Po ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (bo === "center")
    return {
      x: Po,
      y: Co,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (bo === "centerTop")
    return {
      x: Po,
      y: Co,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (bo === "centerBottom")
    return {
      x: Po,
      y: Co,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var jo = (So + wo) / 2, Do = polarToCartesian(Po, Co, jo, _o), Lo = Do.x, ko = Do.y;
  return {
    x: Lo,
    y: ko,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, getAttrsOfCartesianLabel = function(uo) {
  var ho = uo.viewBox, go = uo.parentViewBox, bo = uo.offset, vo = uo.position, Po = ho, Co = Po.x, So = Po.y, wo = Po.width, Eo = Po.height, Ro = Eo >= 0 ? 1 : -1, _o = Ro * bo, Io = Ro > 0 ? "end" : "start", Ao = Ro > 0 ? "start" : "end", Oo = wo >= 0 ? 1 : -1, jo = Oo * bo, Do = Oo > 0 ? "end" : "start", Lo = Oo > 0 ? "start" : "end";
  if (vo === "top") {
    var ko = {
      x: Co + wo / 2,
      y: So - Ro * bo,
      textAnchor: "middle",
      verticalAnchor: Io
    };
    return _objectSpread$n(_objectSpread$n({}, ko), go ? {
      height: Math.max(So - go.y, 0),
      width: wo
    } : {});
  }
  if (vo === "bottom") {
    var Ko = {
      x: Co + wo / 2,
      y: So + Eo + _o,
      textAnchor: "middle",
      verticalAnchor: Ao
    };
    return _objectSpread$n(_objectSpread$n({}, Ko), go ? {
      height: Math.max(go.y + go.height - (So + Eo), 0),
      width: wo
    } : {});
  }
  if (vo === "left") {
    var No = {
      x: Co - jo,
      y: So + Eo / 2,
      textAnchor: Do,
      verticalAnchor: "middle"
    };
    return _objectSpread$n(_objectSpread$n({}, No), go ? {
      width: Math.max(No.x - go.x, 0),
      height: Eo
    } : {});
  }
  if (vo === "right") {
    var Jo = {
      x: Co + wo + jo,
      y: So + Eo / 2,
      textAnchor: Lo,
      verticalAnchor: "middle"
    };
    return _objectSpread$n(_objectSpread$n({}, Jo), go ? {
      width: Math.max(go.x + go.width - Jo.x, 0),
      height: Eo
    } : {});
  }
  var ti = go ? {
    width: wo,
    height: Eo
  } : {};
  return vo === "insideLeft" ? _objectSpread$n({
    x: Co + jo,
    y: So + Eo / 2,
    textAnchor: Lo,
    verticalAnchor: "middle"
  }, ti) : vo === "insideRight" ? _objectSpread$n({
    x: Co + wo - jo,
    y: So + Eo / 2,
    textAnchor: Do,
    verticalAnchor: "middle"
  }, ti) : vo === "insideTop" ? _objectSpread$n({
    x: Co + wo / 2,
    y: So + _o,
    textAnchor: "middle",
    verticalAnchor: Ao
  }, ti) : vo === "insideBottom" ? _objectSpread$n({
    x: Co + wo / 2,
    y: So + Eo - _o,
    textAnchor: "middle",
    verticalAnchor: Io
  }, ti) : vo === "insideTopLeft" ? _objectSpread$n({
    x: Co + jo,
    y: So + _o,
    textAnchor: Lo,
    verticalAnchor: Ao
  }, ti) : vo === "insideTopRight" ? _objectSpread$n({
    x: Co + wo - jo,
    y: So + _o,
    textAnchor: Do,
    verticalAnchor: Ao
  }, ti) : vo === "insideBottomLeft" ? _objectSpread$n({
    x: Co + jo,
    y: So + Eo - _o,
    textAnchor: Lo,
    verticalAnchor: Io
  }, ti) : vo === "insideBottomRight" ? _objectSpread$n({
    x: Co + wo - jo,
    y: So + Eo - _o,
    textAnchor: Do,
    verticalAnchor: Io
  }, ti) : isObject$8(vo) && (isNumber(vo.x) || isPercent(vo.x)) && (isNumber(vo.y) || isPercent(vo.y)) ? _objectSpread$n({
    x: Co + getPercentValue(vo.x, wo),
    y: So + getPercentValue(vo.y, Eo),
    textAnchor: "end",
    verticalAnchor: "end"
  }, ti) : _objectSpread$n({
    x: Co + wo / 2,
    y: So + Eo / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, ti);
}, isPolar = function(uo) {
  return "cx" in uo && isNumber(uo.cx);
};
function Label(Kt) {
  var uo = Kt.offset, ho = uo === void 0 ? 5 : uo, go = _objectWithoutProperties$9(Kt, _excluded$9), bo = _objectSpread$n({
    offset: ho
  }, go), vo = bo.viewBox, Po = bo.position, Co = bo.value, So = bo.children, wo = bo.content, Eo = bo.className, Ro = Eo === void 0 ? "" : Eo, _o = bo.textBreakAll;
  if (!vo || isNil$1(Co) && isNil$1(So) && !/* @__PURE__ */ isValidElement(wo) && !isFunction$3(wo))
    return null;
  if (/* @__PURE__ */ isValidElement(wo))
    return /* @__PURE__ */ cloneElement(wo, bo);
  var Io;
  if (isFunction$3(wo)) {
    if (Io = /* @__PURE__ */ createElement(wo, bo), /* @__PURE__ */ isValidElement(Io))
      return Io;
  } else
    Io = getLabel(bo);
  var Ao = isPolar(vo), Oo = filterProps(bo, !0);
  if (Ao && (Po === "insideStart" || Po === "insideEnd" || Po === "end"))
    return renderRadialLabel(bo, Io, Oo);
  var jo = Ao ? getAttrsOfPolarLabel(bo) : getAttrsOfCartesianLabel(bo);
  return /* @__PURE__ */ React__default.createElement(Text, _extends$i({
    className: clsx("recharts-label", Ro)
  }, Oo, jo, {
    breakAll: _o
  }), Io);
}
Label.displayName = "Label";
var parseViewBox = function(uo) {
  var ho = uo.cx, go = uo.cy, bo = uo.angle, vo = uo.startAngle, Po = uo.endAngle, Co = uo.r, So = uo.radius, wo = uo.innerRadius, Eo = uo.outerRadius, Ro = uo.x, _o = uo.y, Io = uo.top, Ao = uo.left, Oo = uo.width, jo = uo.height, Do = uo.clockWise, Lo = uo.labelViewBox;
  if (Lo)
    return Lo;
  if (isNumber(Oo) && isNumber(jo)) {
    if (isNumber(Ro) && isNumber(_o))
      return {
        x: Ro,
        y: _o,
        width: Oo,
        height: jo
      };
    if (isNumber(Io) && isNumber(Ao))
      return {
        x: Io,
        y: Ao,
        width: Oo,
        height: jo
      };
  }
  return isNumber(Ro) && isNumber(_o) ? {
    x: Ro,
    y: _o,
    width: 0,
    height: 0
  } : isNumber(ho) && isNumber(go) ? {
    cx: ho,
    cy: go,
    startAngle: vo || bo || 0,
    endAngle: Po || bo || 0,
    innerRadius: wo || 0,
    outerRadius: Eo || So || Co || 0,
    clockWise: Do
  } : uo.viewBox ? uo.viewBox : {};
}, parseLabel = function(uo, ho) {
  return uo ? uo === !0 ? /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    viewBox: ho
  }) : isNumOrStr(uo) ? /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    viewBox: ho,
    value: uo
  }) : /* @__PURE__ */ isValidElement(uo) ? uo.type === Label ? /* @__PURE__ */ cloneElement(uo, {
    key: "label-implicit",
    viewBox: ho
  }) : /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    content: uo,
    viewBox: ho
  }) : isFunction$3(uo) ? /* @__PURE__ */ React__default.createElement(Label, {
    key: "label-implicit",
    content: uo,
    viewBox: ho
  }) : isObject$8(uo) ? /* @__PURE__ */ React__default.createElement(Label, _extends$i({
    viewBox: ho
  }, uo, {
    key: "label-implicit"
  })) : null : null;
}, renderCallByParent$1 = function(uo, ho) {
  var go = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!uo || !uo.children && go && !uo.label)
    return null;
  var bo = uo.children, vo = parseViewBox(uo), Po = findAllByType(bo, Label).map(function(So, wo) {
    return /* @__PURE__ */ cloneElement(So, {
      viewBox: ho || vo,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(wo)
    });
  });
  if (!go)
    return Po;
  var Co = parseLabel(uo.label, ho || vo);
  return [Co].concat(_toConsumableArray$6(Po));
};
Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent$1;
function last(Kt) {
  var uo = Kt == null ? 0 : Kt.length;
  return uo ? Kt[uo - 1] : void 0;
}
var last_1 = last;
const last$1 = /* @__PURE__ */ getDefaultExportFromCjs(last_1);
function _typeof$r(Kt) {
  "@babel/helpers - typeof";
  return _typeof$r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$r(Kt);
}
var _excluded$8 = ["valueAccessor"], _excluded2$3 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function _toConsumableArray$5(Kt) {
  return _arrayWithoutHoles$5(Kt) || _iterableToArray$6(Kt) || _unsupportedIterableToArray$9(Kt) || _nonIterableSpread$5();
}
function _nonIterableSpread$5() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$9(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$9(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$9(Kt, uo);
  }
}
function _iterableToArray$6(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles$5(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$9(Kt);
}
function _arrayLikeToArray$9(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _extends$h() {
  return _extends$h = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$h.apply(this, arguments);
}
function ownKeys$m(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$m(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$m(Object(ho), !0).forEach(function(go) {
      _defineProperty$p(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$m(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$p(Kt, uo, ho) {
  return uo = _toPropertyKey$p(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$p(Kt) {
  var uo = _toPrimitive$p(Kt, "string");
  return _typeof$r(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$p(Kt, uo) {
  if (_typeof$r(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$r(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _objectWithoutProperties$8(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$8(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$8(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
var defaultAccessor = function(uo) {
  return Array.isArray(uo.value) ? last$1(uo.value) : uo.value;
};
function LabelList(Kt) {
  var uo = Kt.valueAccessor, ho = uo === void 0 ? defaultAccessor : uo, go = _objectWithoutProperties$8(Kt, _excluded$8), bo = go.data, vo = go.dataKey, Po = go.clockWise, Co = go.id, So = go.textBreakAll, wo = _objectWithoutProperties$8(go, _excluded2$3);
  return !bo || !bo.length ? null : /* @__PURE__ */ React__default.createElement(Layer, {
    className: "recharts-label-list"
  }, bo.map(function(Eo, Ro) {
    var _o = isNil$1(vo) ? ho(Eo, Ro) : getValueByDataKey(Eo && Eo.payload, vo), Io = isNil$1(Co) ? {} : {
      id: "".concat(Co, "-").concat(Ro)
    };
    return /* @__PURE__ */ React__default.createElement(Label, _extends$h({}, filterProps(Eo, !0), wo, Io, {
      parentViewBox: Eo.parentViewBox,
      value: _o,
      textBreakAll: So,
      viewBox: Label.parseViewBox(isNil$1(Po) ? Eo : _objectSpread$m(_objectSpread$m({}, Eo), {}, {
        clockWise: Po
      })),
      key: "label-".concat(Ro),
      index: Ro
    }));
  }));
}
LabelList.displayName = "LabelList";
function parseLabelList(Kt, uo) {
  return Kt ? Kt === !0 ? /* @__PURE__ */ React__default.createElement(LabelList, {
    key: "labelList-implicit",
    data: uo
  }) : /* @__PURE__ */ React__default.isValidElement(Kt) || isFunction$3(Kt) ? /* @__PURE__ */ React__default.createElement(LabelList, {
    key: "labelList-implicit",
    data: uo,
    content: Kt
  }) : isObject$8(Kt) ? /* @__PURE__ */ React__default.createElement(LabelList, _extends$h({
    data: uo
  }, Kt, {
    key: "labelList-implicit"
  })) : null : null;
}
function renderCallByParent(Kt, uo) {
  var ho = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!Kt || !Kt.children && ho && !Kt.label)
    return null;
  var go = Kt.children, bo = findAllByType(go, LabelList).map(function(Po, Co) {
    return /* @__PURE__ */ cloneElement(Po, {
      data: uo,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(Co)
    });
  });
  if (!ho)
    return bo;
  var vo = parseLabelList(Kt.label, uo);
  return [vo].concat(_toConsumableArray$5(bo));
}
LabelList.renderCallByParent = renderCallByParent;
function _typeof$q(Kt) {
  "@babel/helpers - typeof";
  return _typeof$q = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$q(Kt);
}
function _extends$g() {
  return _extends$g = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$g.apply(this, arguments);
}
function ownKeys$l(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$l(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$l(Object(ho), !0).forEach(function(go) {
      _defineProperty$o(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$l(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$o(Kt, uo, ho) {
  return uo = _toPropertyKey$o(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$o(Kt) {
  var uo = _toPrimitive$o(Kt, "string");
  return _typeof$q(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$o(Kt, uo) {
  if (_typeof$q(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$q(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var getDeltaAngle = function(uo, ho) {
  var go = mathSign(ho - uo), bo = Math.min(Math.abs(ho - uo), 359.999);
  return go * bo;
}, getTangentCircle = function(uo) {
  var ho = uo.cx, go = uo.cy, bo = uo.radius, vo = uo.angle, Po = uo.sign, Co = uo.isExternal, So = uo.cornerRadius, wo = uo.cornerIsExternal, Eo = So * (Co ? 1 : -1) + bo, Ro = Math.asin(So / Eo) / RADIAN, _o = wo ? vo : vo + Po * Ro, Io = polarToCartesian(ho, go, Eo, _o), Ao = polarToCartesian(ho, go, bo, _o), Oo = wo ? vo - Po * Ro : vo, jo = polarToCartesian(ho, go, Eo * Math.cos(Ro * RADIAN), Oo);
  return {
    center: Io,
    circleTangency: Ao,
    lineTangency: jo,
    theta: Ro
  };
}, getSectorPath = function(uo) {
  var ho = uo.cx, go = uo.cy, bo = uo.innerRadius, vo = uo.outerRadius, Po = uo.startAngle, Co = uo.endAngle, So = getDeltaAngle(Po, Co), wo = Po + So, Eo = polarToCartesian(ho, go, vo, Po), Ro = polarToCartesian(ho, go, vo, wo), _o = "M ".concat(Eo.x, ",").concat(Eo.y, `
    A `).concat(vo, ",").concat(vo, `,0,
    `).concat(+(Math.abs(So) > 180), ",").concat(+(Po > wo), `,
    `).concat(Ro.x, ",").concat(Ro.y, `
  `);
  if (bo > 0) {
    var Io = polarToCartesian(ho, go, bo, Po), Ao = polarToCartesian(ho, go, bo, wo);
    _o += "L ".concat(Ao.x, ",").concat(Ao.y, `
            A `).concat(bo, ",").concat(bo, `,0,
            `).concat(+(Math.abs(So) > 180), ",").concat(+(Po <= wo), `,
            `).concat(Io.x, ",").concat(Io.y, " Z");
  } else
    _o += "L ".concat(ho, ",").concat(go, " Z");
  return _o;
}, getSectorWithCorner = function(uo) {
  var ho = uo.cx, go = uo.cy, bo = uo.innerRadius, vo = uo.outerRadius, Po = uo.cornerRadius, Co = uo.forceCornerRadius, So = uo.cornerIsExternal, wo = uo.startAngle, Eo = uo.endAngle, Ro = mathSign(Eo - wo), _o = getTangentCircle({
    cx: ho,
    cy: go,
    radius: vo,
    angle: wo,
    sign: Ro,
    cornerRadius: Po,
    cornerIsExternal: So
  }), Io = _o.circleTangency, Ao = _o.lineTangency, Oo = _o.theta, jo = getTangentCircle({
    cx: ho,
    cy: go,
    radius: vo,
    angle: Eo,
    sign: -Ro,
    cornerRadius: Po,
    cornerIsExternal: So
  }), Do = jo.circleTangency, Lo = jo.lineTangency, ko = jo.theta, Ko = So ? Math.abs(wo - Eo) : Math.abs(wo - Eo) - Oo - ko;
  if (Ko < 0)
    return Co ? "M ".concat(Ao.x, ",").concat(Ao.y, `
        a`).concat(Po, ",").concat(Po, ",0,0,1,").concat(Po * 2, `,0
        a`).concat(Po, ",").concat(Po, ",0,0,1,").concat(-Po * 2, `,0
      `) : getSectorPath({
      cx: ho,
      cy: go,
      innerRadius: bo,
      outerRadius: vo,
      startAngle: wo,
      endAngle: Eo
    });
  var No = "M ".concat(Ao.x, ",").concat(Ao.y, `
    A`).concat(Po, ",").concat(Po, ",0,0,").concat(+(Ro < 0), ",").concat(Io.x, ",").concat(Io.y, `
    A`).concat(vo, ",").concat(vo, ",0,").concat(+(Ko > 180), ",").concat(+(Ro < 0), ",").concat(Do.x, ",").concat(Do.y, `
    A`).concat(Po, ",").concat(Po, ",0,0,").concat(+(Ro < 0), ",").concat(Lo.x, ",").concat(Lo.y, `
  `);
  if (bo > 0) {
    var Jo = getTangentCircle({
      cx: ho,
      cy: go,
      radius: bo,
      angle: wo,
      sign: Ro,
      isExternal: !0,
      cornerRadius: Po,
      cornerIsExternal: So
    }), ti = Jo.circleTangency, oi = Jo.lineTangency, Qo = Jo.theta, Zo = getTangentCircle({
      cx: ho,
      cy: go,
      radius: bo,
      angle: Eo,
      sign: -Ro,
      isExternal: !0,
      cornerRadius: Po,
      cornerIsExternal: So
    }), ei = Zo.circleTangency, ii = Zo.lineTangency, ai = Zo.theta, ri = So ? Math.abs(wo - Eo) : Math.abs(wo - Eo) - Qo - ai;
    if (ri < 0 && Po === 0)
      return "".concat(No, "L").concat(ho, ",").concat(go, "Z");
    No += "L".concat(ii.x, ",").concat(ii.y, `
      A`).concat(Po, ",").concat(Po, ",0,0,").concat(+(Ro < 0), ",").concat(ei.x, ",").concat(ei.y, `
      A`).concat(bo, ",").concat(bo, ",0,").concat(+(ri > 180), ",").concat(+(Ro > 0), ",").concat(ti.x, ",").concat(ti.y, `
      A`).concat(Po, ",").concat(Po, ",0,0,").concat(+(Ro < 0), ",").concat(oi.x, ",").concat(oi.y, "Z");
  } else
    No += "L".concat(ho, ",").concat(go, "Z");
  return No;
}, defaultProps$3 = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, Sector = function(uo) {
  var ho = _objectSpread$l(_objectSpread$l({}, defaultProps$3), uo), go = ho.cx, bo = ho.cy, vo = ho.innerRadius, Po = ho.outerRadius, Co = ho.cornerRadius, So = ho.forceCornerRadius, wo = ho.cornerIsExternal, Eo = ho.startAngle, Ro = ho.endAngle, _o = ho.className;
  if (Po < vo || Eo === Ro)
    return null;
  var Io = clsx("recharts-sector", _o), Ao = Po - vo, Oo = getPercentValue(Co, Ao, 0, !0), jo;
  return Oo > 0 && Math.abs(Eo - Ro) < 360 ? jo = getSectorWithCorner({
    cx: go,
    cy: bo,
    innerRadius: vo,
    outerRadius: Po,
    cornerRadius: Math.min(Oo, Ao / 2),
    forceCornerRadius: So,
    cornerIsExternal: wo,
    startAngle: Eo,
    endAngle: Ro
  }) : jo = getSectorPath({
    cx: go,
    cy: bo,
    innerRadius: vo,
    outerRadius: Po,
    startAngle: Eo,
    endAngle: Ro
  }), /* @__PURE__ */ React__default.createElement("path", _extends$g({}, filterProps(ho, !0), {
    className: Io,
    d: jo,
    role: "img"
  }));
};
function _typeof$p(Kt) {
  "@babel/helpers - typeof";
  return _typeof$p = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$p(Kt);
}
function _extends$f() {
  return _extends$f = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$f.apply(this, arguments);
}
function ownKeys$k(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$k(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$k(Object(ho), !0).forEach(function(go) {
      _defineProperty$n(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$k(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$n(Kt, uo, ho) {
  return uo = _toPropertyKey$n(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$n(Kt) {
  var uo = _toPrimitive$n(Kt, "string");
  return _typeof$p(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$n(Kt, uo) {
  if (_typeof$p(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$p(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var CURVE_FACTORIES = {
  curveBasisClosed,
  curveBasisOpen,
  curveBasis,
  curveBumpX: bumpX,
  curveBumpY: bumpY,
  curveLinearClosed,
  curveLinear,
  curveMonotoneX: monotoneX,
  curveMonotoneY: monotoneY,
  curveNatural,
  curveStep,
  curveStepAfter: stepAfter,
  curveStepBefore: stepBefore
}, defined = function(uo) {
  return uo.x === +uo.x && uo.y === +uo.y;
}, getX = function(uo) {
  return uo.x;
}, getY = function(uo) {
  return uo.y;
}, getCurveFactory = function(uo, ho) {
  if (isFunction$3(uo))
    return uo;
  var go = "curve".concat(upperFirst$1(uo));
  return (go === "curveMonotone" || go === "curveBump") && ho ? CURVE_FACTORIES["".concat(go).concat(ho === "vertical" ? "Y" : "X")] : CURVE_FACTORIES[go] || curveLinear;
}, getPath$1 = function(uo) {
  var ho = uo.type, go = ho === void 0 ? "linear" : ho, bo = uo.points, vo = bo === void 0 ? [] : bo, Po = uo.baseLine, Co = uo.layout, So = uo.connectNulls, wo = So === void 0 ? !1 : So, Eo = getCurveFactory(go, Co), Ro = wo ? vo.filter(function(Oo) {
    return defined(Oo);
  }) : vo, _o;
  if (Array.isArray(Po)) {
    var Io = wo ? Po.filter(function(Oo) {
      return defined(Oo);
    }) : Po, Ao = Ro.map(function(Oo, jo) {
      return _objectSpread$k(_objectSpread$k({}, Oo), {}, {
        base: Io[jo]
      });
    });
    return Co === "vertical" ? _o = shapeArea().y(getY).x1(getX).x0(function(Oo) {
      return Oo.base.x;
    }) : _o = shapeArea().x(getX).y1(getY).y0(function(Oo) {
      return Oo.base.y;
    }), _o.defined(defined).curve(Eo), _o(Ao);
  }
  return Co === "vertical" && isNumber(Po) ? _o = shapeArea().y(getY).x1(getX).x0(Po) : isNumber(Po) ? _o = shapeArea().x(getX).y1(getY).y0(Po) : _o = shapeLine().x(getX).y(getY), _o.defined(defined).curve(Eo), _o(Ro);
}, Curve = function(uo) {
  var ho = uo.className, go = uo.points, bo = uo.path, vo = uo.pathRef;
  if ((!go || !go.length) && !bo)
    return null;
  var Po = go && go.length ? getPath$1(uo) : bo;
  return /* @__PURE__ */ React__default.createElement("path", _extends$f({}, filterProps(uo, !1), adaptEventHandlers(uo), {
    className: clsx("recharts-curve", ho),
    d: Po,
    ref: vo
  }));
}, getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty$1 = Object.prototype.hasOwnProperty;
function combineComparators(Kt, uo) {
  return function(go, bo, vo) {
    return Kt(go, bo, vo) && uo(go, bo, vo);
  };
}
function createIsCircular(Kt) {
  return function(ho, go, bo) {
    if (!ho || !go || typeof ho != "object" || typeof go != "object")
      return Kt(ho, go, bo);
    var vo = bo.cache, Po = vo.get(ho), Co = vo.get(go);
    if (Po && Co)
      return Po === go && Co === ho;
    vo.set(ho, go), vo.set(go, ho);
    var So = Kt(ho, go, bo);
    return vo.delete(ho), vo.delete(go), So;
  };
}
function getStrictProperties(Kt) {
  return getOwnPropertyNames(Kt).concat(getOwnPropertySymbols(Kt));
}
var hasOwn = Object.hasOwn || function(Kt, uo) {
  return hasOwnProperty$1.call(Kt, uo);
};
function sameValueZeroEqual(Kt, uo) {
  return Kt || uo ? Kt === uo : Kt === uo || Kt !== Kt && uo !== uo;
}
var OWNER = "_owner", getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys$1 = Object.keys;
function areArraysEqual(Kt, uo, ho) {
  var go = Kt.length;
  if (uo.length !== go)
    return !1;
  for (; go-- > 0; )
    if (!ho.equals(Kt[go], uo[go], go, go, Kt, uo, ho))
      return !1;
  return !0;
}
function areDatesEqual(Kt, uo) {
  return sameValueZeroEqual(Kt.getTime(), uo.getTime());
}
function areMapsEqual(Kt, uo, ho) {
  if (Kt.size !== uo.size)
    return !1;
  for (var go = {}, bo = Kt.entries(), vo = 0, Po, Co; (Po = bo.next()) && !Po.done; ) {
    for (var So = uo.entries(), wo = !1, Eo = 0; (Co = So.next()) && !Co.done; ) {
      var Ro = Po.value, _o = Ro[0], Io = Ro[1], Ao = Co.value, Oo = Ao[0], jo = Ao[1];
      !wo && !go[Eo] && (wo = ho.equals(_o, Oo, vo, Eo, Kt, uo, ho) && ho.equals(Io, jo, _o, Oo, Kt, uo, ho)) && (go[Eo] = !0), Eo++;
    }
    if (!wo)
      return !1;
    vo++;
  }
  return !0;
}
function areObjectsEqual(Kt, uo, ho) {
  var go = keys$1(Kt), bo = go.length;
  if (keys$1(uo).length !== bo)
    return !1;
  for (var vo; bo-- > 0; )
    if (vo = go[bo], vo === OWNER && (Kt.$$typeof || uo.$$typeof) && Kt.$$typeof !== uo.$$typeof || !hasOwn(uo, vo) || !ho.equals(Kt[vo], uo[vo], vo, vo, Kt, uo, ho))
      return !1;
  return !0;
}
function areObjectsEqualStrict(Kt, uo, ho) {
  var go = getStrictProperties(Kt), bo = go.length;
  if (getStrictProperties(uo).length !== bo)
    return !1;
  for (var vo, Po, Co; bo-- > 0; )
    if (vo = go[bo], vo === OWNER && (Kt.$$typeof || uo.$$typeof) && Kt.$$typeof !== uo.$$typeof || !hasOwn(uo, vo) || !ho.equals(Kt[vo], uo[vo], vo, vo, Kt, uo, ho) || (Po = getOwnPropertyDescriptor(Kt, vo), Co = getOwnPropertyDescriptor(uo, vo), (Po || Co) && (!Po || !Co || Po.configurable !== Co.configurable || Po.enumerable !== Co.enumerable || Po.writable !== Co.writable)))
      return !1;
  return !0;
}
function arePrimitiveWrappersEqual(Kt, uo) {
  return sameValueZeroEqual(Kt.valueOf(), uo.valueOf());
}
function areRegExpsEqual(Kt, uo) {
  return Kt.source === uo.source && Kt.flags === uo.flags;
}
function areSetsEqual(Kt, uo, ho) {
  if (Kt.size !== uo.size)
    return !1;
  for (var go = {}, bo = Kt.values(), vo, Po; (vo = bo.next()) && !vo.done; ) {
    for (var Co = uo.values(), So = !1, wo = 0; (Po = Co.next()) && !Po.done; )
      !So && !go[wo] && (So = ho.equals(vo.value, Po.value, vo.value, Po.value, Kt, uo, ho)) && (go[wo] = !0), wo++;
    if (!So)
      return !1;
  }
  return !0;
}
function areTypedArraysEqual(Kt, uo) {
  var ho = Kt.length;
  if (uo.length !== ho)
    return !1;
  for (; ho-- > 0; )
    if (Kt[ho] !== uo[ho])
      return !1;
  return !0;
}
var ARGUMENTS_TAG = "[object Arguments]", BOOLEAN_TAG = "[object Boolean]", DATE_TAG = "[object Date]", MAP_TAG = "[object Map]", NUMBER_TAG = "[object Number]", OBJECT_TAG = "[object Object]", REG_EXP_TAG = "[object RegExp]", SET_TAG = "[object Set]", STRING_TAG = "[object String]", isArray$2 = Array.isArray, isTypedArray = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, assign = Object.assign, getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
function createEqualityComparator(Kt) {
  var uo = Kt.areArraysEqual, ho = Kt.areDatesEqual, go = Kt.areMapsEqual, bo = Kt.areObjectsEqual, vo = Kt.arePrimitiveWrappersEqual, Po = Kt.areRegExpsEqual, Co = Kt.areSetsEqual, So = Kt.areTypedArraysEqual;
  return function(Eo, Ro, _o) {
    if (Eo === Ro)
      return !0;
    if (Eo == null || Ro == null || typeof Eo != "object" || typeof Ro != "object")
      return Eo !== Eo && Ro !== Ro;
    var Io = Eo.constructor;
    if (Io !== Ro.constructor)
      return !1;
    if (Io === Object)
      return bo(Eo, Ro, _o);
    if (isArray$2(Eo))
      return uo(Eo, Ro, _o);
    if (isTypedArray != null && isTypedArray(Eo))
      return So(Eo, Ro, _o);
    if (Io === Date)
      return ho(Eo, Ro, _o);
    if (Io === RegExp)
      return Po(Eo, Ro, _o);
    if (Io === Map)
      return go(Eo, Ro, _o);
    if (Io === Set)
      return Co(Eo, Ro, _o);
    var Ao = getTag(Eo);
    return Ao === DATE_TAG ? ho(Eo, Ro, _o) : Ao === REG_EXP_TAG ? Po(Eo, Ro, _o) : Ao === MAP_TAG ? go(Eo, Ro, _o) : Ao === SET_TAG ? Co(Eo, Ro, _o) : Ao === OBJECT_TAG ? typeof Eo.then != "function" && typeof Ro.then != "function" && bo(Eo, Ro, _o) : Ao === ARGUMENTS_TAG ? bo(Eo, Ro, _o) : Ao === BOOLEAN_TAG || Ao === NUMBER_TAG || Ao === STRING_TAG ? vo(Eo, Ro, _o) : !1;
  };
}
function createEqualityComparatorConfig(Kt) {
  var uo = Kt.circular, ho = Kt.createCustomConfig, go = Kt.strict, bo = {
    areArraysEqual: go ? areObjectsEqualStrict : areArraysEqual,
    areDatesEqual,
    areMapsEqual: go ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
    areObjectsEqual: go ? areObjectsEqualStrict : areObjectsEqual,
    arePrimitiveWrappersEqual,
    areRegExpsEqual,
    areSetsEqual: go ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
    areTypedArraysEqual: go ? areObjectsEqualStrict : areTypedArraysEqual
  };
  if (ho && (bo = assign({}, bo, ho(bo))), uo) {
    var vo = createIsCircular(bo.areArraysEqual), Po = createIsCircular(bo.areMapsEqual), Co = createIsCircular(bo.areObjectsEqual), So = createIsCircular(bo.areSetsEqual);
    bo = assign({}, bo, {
      areArraysEqual: vo,
      areMapsEqual: Po,
      areObjectsEqual: Co,
      areSetsEqual: So
    });
  }
  return bo;
}
function createInternalEqualityComparator(Kt) {
  return function(uo, ho, go, bo, vo, Po, Co) {
    return Kt(uo, ho, Co);
  };
}
function createIsEqual(Kt) {
  var uo = Kt.circular, ho = Kt.comparator, go = Kt.createState, bo = Kt.equals, vo = Kt.strict;
  if (go)
    return function(So, wo) {
      var Eo = go(), Ro = Eo.cache, _o = Ro === void 0 ? uo ? /* @__PURE__ */ new WeakMap() : void 0 : Ro, Io = Eo.meta;
      return ho(So, wo, {
        cache: _o,
        equals: bo,
        meta: Io,
        strict: vo
      });
    };
  if (uo)
    return function(So, wo) {
      return ho(So, wo, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: bo,
        meta: void 0,
        strict: vo
      });
    };
  var Po = {
    cache: void 0,
    equals: bo,
    meta: void 0,
    strict: vo
  };
  return function(So, wo) {
    return ho(So, wo, Po);
  };
}
var deepEqual = createCustomEqual();
createCustomEqual({ strict: !0 });
createCustomEqual({ circular: !0 });
createCustomEqual({
  circular: !0,
  strict: !0
});
createCustomEqual({
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  strict: !0,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: !0,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  }
});
createCustomEqual({
  circular: !0,
  createInternalComparator: function() {
    return sameValueZeroEqual;
  },
  strict: !0
});
function createCustomEqual(Kt) {
  Kt === void 0 && (Kt = {});
  var uo = Kt.circular, ho = uo === void 0 ? !1 : uo, go = Kt.createInternalComparator, bo = Kt.createState, vo = Kt.strict, Po = vo === void 0 ? !1 : vo, Co = createEqualityComparatorConfig(Kt), So = createEqualityComparator(Co), wo = go ? go(So) : createInternalEqualityComparator(So);
  return createIsEqual({ circular: ho, comparator: So, createState: bo, equals: wo, strict: Po });
}
function safeRequestAnimationFrame(Kt) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(Kt);
}
function setRafTimeout(Kt) {
  var uo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, ho = -1, go = function bo(vo) {
    ho < 0 && (ho = vo), vo - ho > uo ? (Kt(vo), ho = -1) : safeRequestAnimationFrame(bo);
  };
  requestAnimationFrame(go);
}
function _typeof$o(Kt) {
  "@babel/helpers - typeof";
  return _typeof$o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$o(Kt);
}
function _toArray(Kt) {
  return _arrayWithHoles$6(Kt) || _iterableToArray$5(Kt) || _unsupportedIterableToArray$8(Kt) || _nonIterableRest$6();
}
function _nonIterableRest$6() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$8(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$8(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$8(Kt, uo);
  }
}
function _arrayLikeToArray$8(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArray$5(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithHoles$6(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function createAnimateManager() {
  var Kt = {}, uo = function() {
    return null;
  }, ho = !1, go = function bo(vo) {
    if (!ho) {
      if (Array.isArray(vo)) {
        if (!vo.length)
          return;
        var Po = vo, Co = _toArray(Po), So = Co[0], wo = Co.slice(1);
        if (typeof So == "number") {
          setRafTimeout(bo.bind(null, wo), So);
          return;
        }
        bo(So), setRafTimeout(bo.bind(null, wo));
        return;
      }
      _typeof$o(vo) === "object" && (Kt = vo, uo(Kt)), typeof vo == "function" && vo();
    }
  };
  return {
    stop: function() {
      ho = !0;
    },
    start: function(vo) {
      ho = !1, go(vo);
    },
    subscribe: function(vo) {
      return uo = vo, function() {
        uo = function() {
          return null;
        };
      };
    }
  };
}
function _typeof$n(Kt) {
  "@babel/helpers - typeof";
  return _typeof$n = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$n(Kt);
}
function ownKeys$j(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$j(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$j(Object(ho), !0).forEach(function(go) {
      _defineProperty$m(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$j(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$m(Kt, uo, ho) {
  return uo = _toPropertyKey$m(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$m(Kt) {
  var uo = _toPrimitive$m(Kt, "string");
  return _typeof$n(uo) === "symbol" ? uo : String(uo);
}
function _toPrimitive$m(Kt, uo) {
  if (_typeof$n(Kt) !== "object" || Kt === null) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$n(go) !== "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var getIntersectionKeys = function(uo, ho) {
  return [Object.keys(uo), Object.keys(ho)].reduce(function(go, bo) {
    return go.filter(function(vo) {
      return bo.includes(vo);
    });
  });
}, identity = function(uo) {
  return uo;
}, getDashCase = function(uo) {
  return uo.replace(/([A-Z])/g, function(ho) {
    return "-".concat(ho.toLowerCase());
  });
}, mapObject = function(uo, ho) {
  return Object.keys(ho).reduce(function(go, bo) {
    return _objectSpread$j(_objectSpread$j({}, go), {}, _defineProperty$m({}, bo, uo(bo, ho[bo])));
  }, {});
}, getTransitionVal = function(uo, ho, go) {
  return uo.map(function(bo) {
    return "".concat(getDashCase(bo), " ").concat(ho, "ms ").concat(go);
  }).join(",");
}, isDev = process.env.NODE_ENV !== "production", warn = function(uo, ho, go, bo, vo, Po, Co, So) {
  if (isDev && typeof console < "u" && console.warn && (ho === void 0 && console.warn("LogUtils requires an error message argument"), !uo))
    if (ho === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var wo = [go, bo, vo, Po, Co, So], Eo = 0;
      console.warn(ho.replace(/%s/g, function() {
        return wo[Eo++];
      }));
    }
};
function _slicedToArray$5(Kt, uo) {
  return _arrayWithHoles$5(Kt) || _iterableToArrayLimit$5(Kt, uo) || _unsupportedIterableToArray$7(Kt, uo) || _nonIterableRest$5();
}
function _nonIterableRest$5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit$5(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$5(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function _toConsumableArray$4(Kt) {
  return _arrayWithoutHoles$4(Kt) || _iterableToArray$4(Kt) || _unsupportedIterableToArray$7(Kt) || _nonIterableSpread$4();
}
function _nonIterableSpread$4() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$7(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$7(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$7(Kt, uo);
  }
}
function _iterableToArray$4(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles$4(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$7(Kt);
}
function _arrayLikeToArray$7(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
var ACCURACY = 1e-4, cubicBezierFactor = function(uo, ho) {
  return [0, 3 * uo, 3 * ho - 6 * uo, 3 * uo - 3 * ho + 1];
}, multyTime = function(uo, ho) {
  return uo.map(function(go, bo) {
    return go * Math.pow(ho, bo);
  }).reduce(function(go, bo) {
    return go + bo;
  });
}, cubicBezier = function(uo, ho) {
  return function(go) {
    var bo = cubicBezierFactor(uo, ho);
    return multyTime(bo, go);
  };
}, derivativeCubicBezier = function(uo, ho) {
  return function(go) {
    var bo = cubicBezierFactor(uo, ho), vo = [].concat(_toConsumableArray$4(bo.map(function(Po, Co) {
      return Po * Co;
    }).slice(1)), [0]);
    return multyTime(vo, go);
  };
}, configBezier = function() {
  for (var uo = arguments.length, ho = new Array(uo), go = 0; go < uo; go++)
    ho[go] = arguments[go];
  var bo = ho[0], vo = ho[1], Po = ho[2], Co = ho[3];
  if (ho.length === 1)
    switch (ho[0]) {
      case "linear":
        bo = 0, vo = 0, Po = 1, Co = 1;
        break;
      case "ease":
        bo = 0.25, vo = 0.1, Po = 0.25, Co = 1;
        break;
      case "ease-in":
        bo = 0.42, vo = 0, Po = 1, Co = 1;
        break;
      case "ease-out":
        bo = 0.42, vo = 0, Po = 0.58, Co = 1;
        break;
      case "ease-in-out":
        bo = 0, vo = 0, Po = 0.58, Co = 1;
        break;
      default: {
        var So = ho[0].split("(");
        if (So[0] === "cubic-bezier" && So[1].split(")")[0].split(",").length === 4) {
          var wo = So[1].split(")")[0].split(",").map(function(jo) {
            return parseFloat(jo);
          }), Eo = _slicedToArray$5(wo, 4);
          bo = Eo[0], vo = Eo[1], Po = Eo[2], Co = Eo[3];
        } else
          warn(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", ho);
      }
    }
  warn([bo, Po, vo, Co].every(function(jo) {
    return typeof jo == "number" && jo >= 0 && jo <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", ho);
  var Ro = cubicBezier(bo, Po), _o = cubicBezier(vo, Co), Io = derivativeCubicBezier(bo, Po), Ao = function(Do) {
    return Do > 1 ? 1 : Do < 0 ? 0 : Do;
  }, Oo = function(Do) {
    for (var Lo = Do > 1 ? 1 : Do, ko = Lo, Ko = 0; Ko < 8; ++Ko) {
      var No = Ro(ko) - Lo, Jo = Io(ko);
      if (Math.abs(No - Lo) < ACCURACY || Jo < ACCURACY)
        return _o(ko);
      ko = Ao(ko - No / Jo);
    }
    return _o(ko);
  };
  return Oo.isStepper = !1, Oo;
}, configSpring = function() {
  var uo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ho = uo.stiff, go = ho === void 0 ? 100 : ho, bo = uo.damping, vo = bo === void 0 ? 8 : bo, Po = uo.dt, Co = Po === void 0 ? 17 : Po, So = function(Eo, Ro, _o) {
    var Io = -(Eo - Ro) * go, Ao = _o * vo, Oo = _o + (Io - Ao) * Co / 1e3, jo = _o * Co / 1e3 + Eo;
    return Math.abs(jo - Ro) < ACCURACY && Math.abs(Oo) < ACCURACY ? [Ro, 0] : [jo, Oo];
  };
  return So.isStepper = !0, So.dt = Co, So;
}, configEasing = function() {
  for (var uo = arguments.length, ho = new Array(uo), go = 0; go < uo; go++)
    ho[go] = arguments[go];
  var bo = ho[0];
  if (typeof bo == "string")
    switch (bo) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return configBezier(bo);
      case "spring":
        return configSpring();
      default:
        if (bo.split("(")[0] === "cubic-bezier")
          return configBezier(bo);
        warn(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", ho);
    }
  return typeof bo == "function" ? bo : (warn(!1, "[configEasing]: first argument type should be function or string, instead received %s", ho), null);
};
function _typeof$m(Kt) {
  "@babel/helpers - typeof";
  return _typeof$m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$m(Kt);
}
function _toConsumableArray$3(Kt) {
  return _arrayWithoutHoles$3(Kt) || _iterableToArray$3(Kt) || _unsupportedIterableToArray$6(Kt) || _nonIterableSpread$3();
}
function _nonIterableSpread$3() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArray$3(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles$3(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$6(Kt);
}
function ownKeys$i(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$i(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$i(Object(ho), !0).forEach(function(go) {
      _defineProperty$l(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$i(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$l(Kt, uo, ho) {
  return uo = _toPropertyKey$l(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$l(Kt) {
  var uo = _toPrimitive$l(Kt, "string");
  return _typeof$m(uo) === "symbol" ? uo : String(uo);
}
function _toPrimitive$l(Kt, uo) {
  if (_typeof$m(Kt) !== "object" || Kt === null) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$m(go) !== "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _slicedToArray$4(Kt, uo) {
  return _arrayWithHoles$4(Kt) || _iterableToArrayLimit$4(Kt, uo) || _unsupportedIterableToArray$6(Kt, uo) || _nonIterableRest$4();
}
function _nonIterableRest$4() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$6(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$6(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$6(Kt, uo);
  }
}
function _arrayLikeToArray$6(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$4(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$4(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
var alpha = function(uo, ho, go) {
  return uo + (ho - uo) * go;
}, needContinue = function(uo) {
  var ho = uo.from, go = uo.to;
  return ho !== go;
}, calStepperVals = function Kt(uo, ho, go) {
  var bo = mapObject(function(vo, Po) {
    if (needContinue(Po)) {
      var Co = uo(Po.from, Po.to, Po.velocity), So = _slicedToArray$4(Co, 2), wo = So[0], Eo = So[1];
      return _objectSpread$i(_objectSpread$i({}, Po), {}, {
        from: wo,
        velocity: Eo
      });
    }
    return Po;
  }, ho);
  return go < 1 ? mapObject(function(vo, Po) {
    return needContinue(Po) ? _objectSpread$i(_objectSpread$i({}, Po), {}, {
      velocity: alpha(Po.velocity, bo[vo].velocity, go),
      from: alpha(Po.from, bo[vo].from, go)
    }) : Po;
  }, ho) : Kt(uo, bo, go - 1);
};
const configUpdate = function(Kt, uo, ho, go, bo) {
  var vo = getIntersectionKeys(Kt, uo), Po = vo.reduce(function(jo, Do) {
    return _objectSpread$i(_objectSpread$i({}, jo), {}, _defineProperty$l({}, Do, [Kt[Do], uo[Do]]));
  }, {}), Co = vo.reduce(function(jo, Do) {
    return _objectSpread$i(_objectSpread$i({}, jo), {}, _defineProperty$l({}, Do, {
      from: Kt[Do],
      velocity: 0,
      to: uo[Do]
    }));
  }, {}), So = -1, wo, Eo, Ro = function() {
    return null;
  }, _o = function() {
    return mapObject(function(Do, Lo) {
      return Lo.from;
    }, Co);
  }, Io = function() {
    return !Object.values(Co).filter(needContinue).length;
  }, Ao = function(Do) {
    wo || (wo = Do);
    var Lo = Do - wo, ko = Lo / ho.dt;
    Co = calStepperVals(ho, Co, ko), bo(_objectSpread$i(_objectSpread$i(_objectSpread$i({}, Kt), uo), _o())), wo = Do, Io() || (So = requestAnimationFrame(Ro));
  }, Oo = function(Do) {
    Eo || (Eo = Do);
    var Lo = (Do - Eo) / go, ko = mapObject(function(No, Jo) {
      return alpha.apply(void 0, _toConsumableArray$3(Jo).concat([ho(Lo)]));
    }, Po);
    if (bo(_objectSpread$i(_objectSpread$i(_objectSpread$i({}, Kt), uo), ko)), Lo < 1)
      So = requestAnimationFrame(Ro);
    else {
      var Ko = mapObject(function(No, Jo) {
        return alpha.apply(void 0, _toConsumableArray$3(Jo).concat([ho(1)]));
      }, Po);
      bo(_objectSpread$i(_objectSpread$i(_objectSpread$i({}, Kt), uo), Ko));
    }
  };
  return Ro = ho.isStepper ? Ao : Oo, function() {
    return requestAnimationFrame(Ro), function() {
      cancelAnimationFrame(So);
    };
  };
};
function _typeof$l(Kt) {
  "@babel/helpers - typeof";
  return _typeof$l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$l(Kt);
}
var _excluded$7 = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function _objectWithoutProperties$7(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$7(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$7(Kt, uo) {
  if (Kt == null) return {};
  var ho = {}, go = Object.keys(Kt), bo, vo;
  for (vo = 0; vo < go.length; vo++)
    bo = go[vo], !(uo.indexOf(bo) >= 0) && (ho[bo] = Kt[bo]);
  return ho;
}
function _toConsumableArray$2(Kt) {
  return _arrayWithoutHoles$2(Kt) || _iterableToArray$2(Kt) || _unsupportedIterableToArray$5(Kt) || _nonIterableSpread$2();
}
function _nonIterableSpread$2() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$5(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$5(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$5(Kt, uo);
  }
}
function _iterableToArray$2(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles$2(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$5(Kt);
}
function _arrayLikeToArray$5(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function ownKeys$h(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$h(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$h(Object(ho), !0).forEach(function(go) {
      _defineProperty$k(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$h(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$k(Kt, uo, ho) {
  return uo = _toPropertyKey$k(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _classCallCheck$b(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$b(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$k(go.key), go);
  }
}
function _createClass$b(Kt, uo, ho) {
  return _defineProperties$b(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _toPropertyKey$k(Kt) {
  var uo = _toPrimitive$k(Kt, "string");
  return _typeof$l(uo) === "symbol" ? uo : String(uo);
}
function _toPrimitive$k(Kt, uo) {
  if (_typeof$l(Kt) !== "object" || Kt === null) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$l(go) !== "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _inherits$9(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$9(Kt, uo);
}
function _setPrototypeOf$9(Kt, uo) {
  return _setPrototypeOf$9 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$9(Kt, uo);
}
function _createSuper(Kt) {
  var uo = _isNativeReflectConstruct$9();
  return function() {
    var go = _getPrototypeOf$9(Kt), bo;
    if (uo) {
      var vo = _getPrototypeOf$9(this).constructor;
      bo = Reflect.construct(go, arguments, vo);
    } else
      bo = go.apply(this, arguments);
    return _possibleConstructorReturn$9(this, bo);
  };
}
function _possibleConstructorReturn$9(Kt, uo) {
  if (uo && (_typeof$l(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$9(Kt);
}
function _assertThisInitialized$9(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$9() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function _getPrototypeOf$9(Kt) {
  return _getPrototypeOf$9 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$9(Kt);
}
var Animate = /* @__PURE__ */ function(Kt) {
  _inherits$9(ho, Kt);
  var uo = _createSuper(ho);
  function ho(go, bo) {
    var vo;
    _classCallCheck$b(this, ho), vo = uo.call(this, go, bo);
    var Po = vo.props, Co = Po.isActive, So = Po.attributeName, wo = Po.from, Eo = Po.to, Ro = Po.steps, _o = Po.children, Io = Po.duration;
    if (vo.handleStyleChange = vo.handleStyleChange.bind(_assertThisInitialized$9(vo)), vo.changeStyle = vo.changeStyle.bind(_assertThisInitialized$9(vo)), !Co || Io <= 0)
      return vo.state = {
        style: {}
      }, typeof _o == "function" && (vo.state = {
        style: Eo
      }), _possibleConstructorReturn$9(vo);
    if (Ro && Ro.length)
      vo.state = {
        style: Ro[0].style
      };
    else if (wo) {
      if (typeof _o == "function")
        return vo.state = {
          style: wo
        }, _possibleConstructorReturn$9(vo);
      vo.state = {
        style: So ? _defineProperty$k({}, So, wo) : wo
      };
    } else
      vo.state = {
        style: {}
      };
    return vo;
  }
  return _createClass$b(ho, [{
    key: "componentDidMount",
    value: function() {
      var bo = this.props, vo = bo.isActive, Po = bo.canBegin;
      this.mounted = !0, !(!vo || !Po) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(bo) {
      var vo = this.props, Po = vo.isActive, Co = vo.canBegin, So = vo.attributeName, wo = vo.shouldReAnimate, Eo = vo.to, Ro = vo.from, _o = this.state.style;
      if (Co) {
        if (!Po) {
          var Io = {
            style: So ? _defineProperty$k({}, So, Eo) : Eo
          };
          this.state && _o && (So && _o[So] !== Eo || !So && _o !== Eo) && this.setState(Io);
          return;
        }
        if (!(deepEqual(bo.to, Eo) && bo.canBegin && bo.isActive)) {
          var Ao = !bo.canBegin || !bo.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var Oo = Ao || wo ? Ro : bo.to;
          if (this.state && _o) {
            var jo = {
              style: So ? _defineProperty$k({}, So, Oo) : Oo
            };
            (So && _o[So] !== Oo || !So && _o !== Oo) && this.setState(jo);
          }
          this.runAnimation(_objectSpread$h(_objectSpread$h({}, this.props), {}, {
            from: Oo,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var bo = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), bo && bo();
    }
  }, {
    key: "handleStyleChange",
    value: function(bo) {
      this.changeStyle(bo);
    }
  }, {
    key: "changeStyle",
    value: function(bo) {
      this.mounted && this.setState({
        style: bo
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(bo) {
      var vo = this, Po = bo.from, Co = bo.to, So = bo.duration, wo = bo.easing, Eo = bo.begin, Ro = bo.onAnimationEnd, _o = bo.onAnimationStart, Io = configUpdate(Po, Co, configEasing(wo), So, this.changeStyle), Ao = function() {
        vo.stopJSAnimation = Io();
      };
      this.manager.start([_o, Eo, Ao, So, Ro]);
    }
  }, {
    key: "runStepAnimation",
    value: function(bo) {
      var vo = this, Po = bo.steps, Co = bo.begin, So = bo.onAnimationStart, wo = Po[0], Eo = wo.style, Ro = wo.duration, _o = Ro === void 0 ? 0 : Ro, Io = function(Oo, jo, Do) {
        if (Do === 0)
          return Oo;
        var Lo = jo.duration, ko = jo.easing, Ko = ko === void 0 ? "ease" : ko, No = jo.style, Jo = jo.properties, ti = jo.onAnimationEnd, oi = Do > 0 ? Po[Do - 1] : jo, Qo = Jo || Object.keys(No);
        if (typeof Ko == "function" || Ko === "spring")
          return [].concat(_toConsumableArray$2(Oo), [vo.runJSAnimation.bind(vo, {
            from: oi.style,
            to: No,
            duration: Lo,
            easing: Ko
          }), Lo]);
        var Zo = getTransitionVal(Qo, Lo, Ko), ei = _objectSpread$h(_objectSpread$h(_objectSpread$h({}, oi.style), No), {}, {
          transition: Zo
        });
        return [].concat(_toConsumableArray$2(Oo), [ei, Lo, ti]).filter(identity);
      };
      return this.manager.start([So].concat(_toConsumableArray$2(Po.reduce(Io, [Eo, Math.max(_o, Co)])), [bo.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(bo) {
      this.manager || (this.manager = createAnimateManager());
      var vo = bo.begin, Po = bo.duration, Co = bo.attributeName, So = bo.to, wo = bo.easing, Eo = bo.onAnimationStart, Ro = bo.onAnimationEnd, _o = bo.steps, Io = bo.children, Ao = this.manager;
      if (this.unSubscribe = Ao.subscribe(this.handleStyleChange), typeof wo == "function" || typeof Io == "function" || wo === "spring") {
        this.runJSAnimation(bo);
        return;
      }
      if (_o.length > 1) {
        this.runStepAnimation(bo);
        return;
      }
      var Oo = Co ? _defineProperty$k({}, Co, So) : So, jo = getTransitionVal(Object.keys(Oo), Po, wo);
      Ao.start([Eo, vo, _objectSpread$h(_objectSpread$h({}, Oo), {}, {
        transition: jo
      }), Po, Ro]);
    }
  }, {
    key: "render",
    value: function() {
      var bo = this.props, vo = bo.children;
      bo.begin;
      var Po = bo.duration;
      bo.attributeName, bo.easing;
      var Co = bo.isActive;
      bo.steps, bo.from, bo.to, bo.canBegin, bo.onAnimationEnd, bo.shouldReAnimate, bo.onAnimationReStart;
      var So = _objectWithoutProperties$7(bo, _excluded$7), wo = Children.count(vo), Eo = this.state.style;
      if (typeof vo == "function")
        return vo(Eo);
      if (!Co || wo === 0 || Po <= 0)
        return vo;
      var Ro = function(Io) {
        var Ao = Io.props, Oo = Ao.style, jo = Oo === void 0 ? {} : Oo, Do = Ao.className, Lo = /* @__PURE__ */ cloneElement(Io, _objectSpread$h(_objectSpread$h({}, So), {}, {
          style: _objectSpread$h(_objectSpread$h({}, jo), Eo),
          className: Do
        }));
        return Lo;
      };
      return wo === 1 ? Ro(Children.only(vo)) : /* @__PURE__ */ React__default.createElement("div", null, Children.map(vo, function(_o) {
        return Ro(_o);
      }));
    }
  }]), ho;
}(PureComponent);
Animate.displayName = "Animate";
Animate.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
Animate.propTypes = {
  from: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  to: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  attributeName: PropTypes.string,
  // animation duration
  duration: PropTypes.number,
  begin: PropTypes.number,
  easing: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  steps: PropTypes.arrayOf(PropTypes.shape({
    duration: PropTypes.number.isRequired,
    style: PropTypes.object.isRequired,
    easing: PropTypes.oneOfType([PropTypes.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), PropTypes.func]),
    // transition css properties(dash case), optional
    properties: PropTypes.arrayOf("string"),
    onAnimationEnd: PropTypes.func
  })),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isActive: PropTypes.bool,
  canBegin: PropTypes.bool,
  onAnimationEnd: PropTypes.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: PropTypes.bool,
  onAnimationStart: PropTypes.func,
  onAnimationReStart: PropTypes.func
};
PropTypes.object, PropTypes.object, PropTypes.object, PropTypes.element;
PropTypes.object, PropTypes.object, PropTypes.object, PropTypes.oneOfType([PropTypes.array, PropTypes.element]), PropTypes.any;
function _typeof$k(Kt) {
  "@babel/helpers - typeof";
  return _typeof$k = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$k(Kt);
}
function _extends$e() {
  return _extends$e = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$e.apply(this, arguments);
}
function _slicedToArray$3(Kt, uo) {
  return _arrayWithHoles$3(Kt) || _iterableToArrayLimit$3(Kt, uo) || _unsupportedIterableToArray$4(Kt, uo) || _nonIterableRest$3();
}
function _nonIterableRest$3() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$4(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$4(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$4(Kt, uo);
  }
}
function _arrayLikeToArray$4(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$3(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$3(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function ownKeys$g(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$g(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$g(Object(ho), !0).forEach(function(go) {
      _defineProperty$j(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$g(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$j(Kt, uo, ho) {
  return uo = _toPropertyKey$j(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$j(Kt) {
  var uo = _toPrimitive$j(Kt, "string");
  return _typeof$k(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$j(Kt, uo) {
  if (_typeof$k(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$k(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var getRectanglePath = function(uo, ho, go, bo, vo) {
  var Po = Math.min(Math.abs(go) / 2, Math.abs(bo) / 2), Co = bo >= 0 ? 1 : -1, So = go >= 0 ? 1 : -1, wo = bo >= 0 && go >= 0 || bo < 0 && go < 0 ? 1 : 0, Eo;
  if (Po > 0 && vo instanceof Array) {
    for (var Ro = [0, 0, 0, 0], _o = 0, Io = 4; _o < Io; _o++)
      Ro[_o] = vo[_o] > Po ? Po : vo[_o];
    Eo = "M".concat(uo, ",").concat(ho + Co * Ro[0]), Ro[0] > 0 && (Eo += "A ".concat(Ro[0], ",").concat(Ro[0], ",0,0,").concat(wo, ",").concat(uo + So * Ro[0], ",").concat(ho)), Eo += "L ".concat(uo + go - So * Ro[1], ",").concat(ho), Ro[1] > 0 && (Eo += "A ".concat(Ro[1], ",").concat(Ro[1], ",0,0,").concat(wo, `,
        `).concat(uo + go, ",").concat(ho + Co * Ro[1])), Eo += "L ".concat(uo + go, ",").concat(ho + bo - Co * Ro[2]), Ro[2] > 0 && (Eo += "A ".concat(Ro[2], ",").concat(Ro[2], ",0,0,").concat(wo, `,
        `).concat(uo + go - So * Ro[2], ",").concat(ho + bo)), Eo += "L ".concat(uo + So * Ro[3], ",").concat(ho + bo), Ro[3] > 0 && (Eo += "A ".concat(Ro[3], ",").concat(Ro[3], ",0,0,").concat(wo, `,
        `).concat(uo, ",").concat(ho + bo - Co * Ro[3])), Eo += "Z";
  } else if (Po > 0 && vo === +vo && vo > 0) {
    var Ao = Math.min(Po, vo);
    Eo = "M ".concat(uo, ",").concat(ho + Co * Ao, `
            A `).concat(Ao, ",").concat(Ao, ",0,0,").concat(wo, ",").concat(uo + So * Ao, ",").concat(ho, `
            L `).concat(uo + go - So * Ao, ",").concat(ho, `
            A `).concat(Ao, ",").concat(Ao, ",0,0,").concat(wo, ",").concat(uo + go, ",").concat(ho + Co * Ao, `
            L `).concat(uo + go, ",").concat(ho + bo - Co * Ao, `
            A `).concat(Ao, ",").concat(Ao, ",0,0,").concat(wo, ",").concat(uo + go - So * Ao, ",").concat(ho + bo, `
            L `).concat(uo + So * Ao, ",").concat(ho + bo, `
            A `).concat(Ao, ",").concat(Ao, ",0,0,").concat(wo, ",").concat(uo, ",").concat(ho + bo - Co * Ao, " Z");
  } else
    Eo = "M ".concat(uo, ",").concat(ho, " h ").concat(go, " v ").concat(bo, " h ").concat(-go, " Z");
  return Eo;
}, isInRectangle = function(uo, ho) {
  if (!uo || !ho)
    return !1;
  var go = uo.x, bo = uo.y, vo = ho.x, Po = ho.y, Co = ho.width, So = ho.height;
  if (Math.abs(Co) > 0 && Math.abs(So) > 0) {
    var wo = Math.min(vo, vo + Co), Eo = Math.max(vo, vo + Co), Ro = Math.min(Po, Po + So), _o = Math.max(Po, Po + So);
    return go >= wo && go <= Eo && bo >= Ro && bo <= _o;
  }
  return !1;
}, defaultProps$2 = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Rectangle = function(uo) {
  var ho = _objectSpread$g(_objectSpread$g({}, defaultProps$2), uo), go = useRef(), bo = useState(-1), vo = _slicedToArray$3(bo, 2), Po = vo[0], Co = vo[1];
  useEffect(function() {
    if (go.current && go.current.getTotalLength)
      try {
        var Ko = go.current.getTotalLength();
        Ko && Co(Ko);
      } catch {
      }
  }, []);
  var So = ho.x, wo = ho.y, Eo = ho.width, Ro = ho.height, _o = ho.radius, Io = ho.className, Ao = ho.animationEasing, Oo = ho.animationDuration, jo = ho.animationBegin, Do = ho.isAnimationActive, Lo = ho.isUpdateAnimationActive;
  if (So !== +So || wo !== +wo || Eo !== +Eo || Ro !== +Ro || Eo === 0 || Ro === 0)
    return null;
  var ko = clsx("recharts-rectangle", Io);
  return Lo ? /* @__PURE__ */ React__default.createElement(Animate, {
    canBegin: Po > 0,
    from: {
      width: Eo,
      height: Ro,
      x: So,
      y: wo
    },
    to: {
      width: Eo,
      height: Ro,
      x: So,
      y: wo
    },
    duration: Oo,
    animationEasing: Ao,
    isActive: Lo
  }, function(Ko) {
    var No = Ko.width, Jo = Ko.height, ti = Ko.x, oi = Ko.y;
    return /* @__PURE__ */ React__default.createElement(Animate, {
      canBegin: Po > 0,
      from: "0px ".concat(Po === -1 ? 1 : Po, "px"),
      to: "".concat(Po, "px 0px"),
      attributeName: "strokeDasharray",
      begin: jo,
      duration: Oo,
      isActive: Do,
      easing: Ao
    }, /* @__PURE__ */ React__default.createElement("path", _extends$e({}, filterProps(ho, !0), {
      className: ko,
      d: getRectanglePath(ti, oi, No, Jo, _o),
      ref: go
    })));
  }) : /* @__PURE__ */ React__default.createElement("path", _extends$e({}, filterProps(ho, !0), {
    className: ko,
    d: getRectanglePath(So, wo, Eo, Ro, _o)
  }));
};
function _extends$d() {
  return _extends$d = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$d.apply(this, arguments);
}
var Dot = function(uo) {
  var ho = uo.cx, go = uo.cy, bo = uo.r, vo = uo.className, Po = clsx("recharts-dot", vo);
  return ho === +ho && go === +go && bo === +bo ? /* @__PURE__ */ React__default.createElement("circle", _extends$d({}, filterProps(uo, !1), adaptEventHandlers(uo), {
    className: Po,
    cx: ho,
    cy: go,
    r: bo
  })) : null;
};
function _typeof$j(Kt) {
  "@babel/helpers - typeof";
  return _typeof$j = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$j(Kt);
}
var _excluded$6 = ["x", "y", "top", "left", "width", "height", "className"];
function _extends$c() {
  return _extends$c = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$c.apply(this, arguments);
}
function ownKeys$f(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$f(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$f(Object(ho), !0).forEach(function(go) {
      _defineProperty$i(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$f(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$i(Kt, uo, ho) {
  return uo = _toPropertyKey$i(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$i(Kt) {
  var uo = _toPrimitive$i(Kt, "string");
  return _typeof$j(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$i(Kt, uo) {
  if (_typeof$j(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$j(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _objectWithoutProperties$6(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$6(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$6(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
var getPath = function(uo, ho, go, bo, vo, Po) {
  return "M".concat(uo, ",").concat(vo, "v").concat(bo, "M").concat(Po, ",").concat(ho, "h").concat(go);
}, Cross = function(uo) {
  var ho = uo.x, go = ho === void 0 ? 0 : ho, bo = uo.y, vo = bo === void 0 ? 0 : bo, Po = uo.top, Co = Po === void 0 ? 0 : Po, So = uo.left, wo = So === void 0 ? 0 : So, Eo = uo.width, Ro = Eo === void 0 ? 0 : Eo, _o = uo.height, Io = _o === void 0 ? 0 : _o, Ao = uo.className, Oo = _objectWithoutProperties$6(uo, _excluded$6), jo = _objectSpread$f({
    x: go,
    y: vo,
    top: Co,
    left: wo,
    width: Ro,
    height: Io
  }, Oo);
  return !isNumber(go) || !isNumber(vo) || !isNumber(Ro) || !isNumber(Io) || !isNumber(Co) || !isNumber(wo) ? null : /* @__PURE__ */ React__default.createElement("path", _extends$c({}, filterProps(jo, !0), {
    className: clsx("recharts-cross", Ao),
    d: getPath(go, vo, Ro, Io, Co, wo)
  }));
}, overArg = _overArg, getPrototype$1 = overArg(Object.getPrototypeOf, Object), _getPrototype = getPrototype$1, baseGetTag$1 = _baseGetTag, getPrototype = _getPrototype, isObjectLike$1 = isObjectLike_1, objectTag = "[object Object]", funcProto = Function.prototype, objectProto = Object.prototype, funcToString = funcProto.toString, hasOwnProperty = objectProto.hasOwnProperty, objectCtorString = funcToString.call(Object);
function isPlainObject(Kt) {
  if (!isObjectLike$1(Kt) || baseGetTag$1(Kt) != objectTag)
    return !1;
  var uo = getPrototype(Kt);
  if (uo === null)
    return !0;
  var ho = hasOwnProperty.call(uo, "constructor") && uo.constructor;
  return typeof ho == "function" && ho instanceof ho && funcToString.call(ho) == objectCtorString;
}
var isPlainObject_1 = isPlainObject;
const isPlainObject$1 = /* @__PURE__ */ getDefaultExportFromCjs(isPlainObject_1);
var baseGetTag = _baseGetTag, isObjectLike = isObjectLike_1, boolTag = "[object Boolean]";
function isBoolean(Kt) {
  return Kt === !0 || Kt === !1 || isObjectLike(Kt) && baseGetTag(Kt) == boolTag;
}
var isBoolean_1 = isBoolean;
const isBoolean$1 = /* @__PURE__ */ getDefaultExportFromCjs(isBoolean_1);
function _typeof$i(Kt) {
  "@babel/helpers - typeof";
  return _typeof$i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$i(Kt);
}
function _extends$b() {
  return _extends$b = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$b.apply(this, arguments);
}
function _slicedToArray$2(Kt, uo) {
  return _arrayWithHoles$2(Kt) || _iterableToArrayLimit$2(Kt, uo) || _unsupportedIterableToArray$3(Kt, uo) || _nonIterableRest$2();
}
function _nonIterableRest$2() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$3(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$3(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$3(Kt, uo);
  }
}
function _arrayLikeToArray$3(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$2(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$2(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function ownKeys$e(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$e(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$e(Object(ho), !0).forEach(function(go) {
      _defineProperty$h(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$e(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$h(Kt, uo, ho) {
  return uo = _toPropertyKey$h(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$h(Kt) {
  var uo = _toPrimitive$h(Kt, "string");
  return _typeof$i(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$h(Kt, uo) {
  if (_typeof$i(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$i(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var getTrapezoidPath = function(uo, ho, go, bo, vo) {
  var Po = go - bo, Co;
  return Co = "M ".concat(uo, ",").concat(ho), Co += "L ".concat(uo + go, ",").concat(ho), Co += "L ".concat(uo + go - Po / 2, ",").concat(ho + vo), Co += "L ".concat(uo + go - Po / 2 - bo, ",").concat(ho + vo), Co += "L ".concat(uo, ",").concat(ho, " Z"), Co;
}, defaultProps$1 = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, Trapezoid = function(uo) {
  var ho = _objectSpread$e(_objectSpread$e({}, defaultProps$1), uo), go = useRef(), bo = useState(-1), vo = _slicedToArray$2(bo, 2), Po = vo[0], Co = vo[1];
  useEffect(function() {
    if (go.current && go.current.getTotalLength)
      try {
        var ko = go.current.getTotalLength();
        ko && Co(ko);
      } catch {
      }
  }, []);
  var So = ho.x, wo = ho.y, Eo = ho.upperWidth, Ro = ho.lowerWidth, _o = ho.height, Io = ho.className, Ao = ho.animationEasing, Oo = ho.animationDuration, jo = ho.animationBegin, Do = ho.isUpdateAnimationActive;
  if (So !== +So || wo !== +wo || Eo !== +Eo || Ro !== +Ro || _o !== +_o || Eo === 0 && Ro === 0 || _o === 0)
    return null;
  var Lo = clsx("recharts-trapezoid", Io);
  return Do ? /* @__PURE__ */ React__default.createElement(Animate, {
    canBegin: Po > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: _o,
      x: So,
      y: wo
    },
    to: {
      upperWidth: Eo,
      lowerWidth: Ro,
      height: _o,
      x: So,
      y: wo
    },
    duration: Oo,
    animationEasing: Ao,
    isActive: Do
  }, function(ko) {
    var Ko = ko.upperWidth, No = ko.lowerWidth, Jo = ko.height, ti = ko.x, oi = ko.y;
    return /* @__PURE__ */ React__default.createElement(Animate, {
      canBegin: Po > 0,
      from: "0px ".concat(Po === -1 ? 1 : Po, "px"),
      to: "".concat(Po, "px 0px"),
      attributeName: "strokeDasharray",
      begin: jo,
      duration: Oo,
      easing: Ao
    }, /* @__PURE__ */ React__default.createElement("path", _extends$b({}, filterProps(ho, !0), {
      className: Lo,
      d: getTrapezoidPath(ti, oi, Ko, No, Jo),
      ref: go
    })));
  }) : /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement("path", _extends$b({}, filterProps(ho, !0), {
    className: Lo,
    d: getTrapezoidPath(So, wo, Eo, Ro, _o)
  })));
}, _excluded$5 = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function _typeof$h(Kt) {
  "@babel/helpers - typeof";
  return _typeof$h = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$h(Kt);
}
function _objectWithoutProperties$5(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$5(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$5(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function ownKeys$d(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$d(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$d(Object(ho), !0).forEach(function(go) {
      _defineProperty$g(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$d(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$g(Kt, uo, ho) {
  return uo = _toPropertyKey$g(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$g(Kt) {
  var uo = _toPrimitive$g(Kt, "string");
  return _typeof$h(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$g(Kt, uo) {
  if (_typeof$h(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$h(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function defaultPropTransformer(Kt, uo) {
  return _objectSpread$d(_objectSpread$d({}, uo), Kt);
}
function isSymbolsProps(Kt, uo) {
  return Kt === "symbols";
}
function ShapeSelector(Kt) {
  var uo = Kt.shapeType, ho = Kt.elementProps;
  switch (uo) {
    case "rectangle":
      return /* @__PURE__ */ React__default.createElement(Rectangle, ho);
    case "trapezoid":
      return /* @__PURE__ */ React__default.createElement(Trapezoid, ho);
    case "sector":
      return /* @__PURE__ */ React__default.createElement(Sector, ho);
    case "symbols":
      if (isSymbolsProps(uo))
        return /* @__PURE__ */ React__default.createElement(Symbols, ho);
      break;
    default:
      return null;
  }
}
function getPropsFromShapeOption(Kt) {
  return /* @__PURE__ */ isValidElement(Kt) ? Kt.props : Kt;
}
function Shape(Kt) {
  var uo = Kt.option, ho = Kt.shapeType, go = Kt.propTransformer, bo = go === void 0 ? defaultPropTransformer : go, vo = Kt.activeClassName, Po = vo === void 0 ? "recharts-active-shape" : vo, Co = Kt.isActive, So = _objectWithoutProperties$5(Kt, _excluded$5), wo;
  if (/* @__PURE__ */ isValidElement(uo))
    wo = /* @__PURE__ */ cloneElement(uo, _objectSpread$d(_objectSpread$d({}, So), getPropsFromShapeOption(uo)));
  else if (isFunction$3(uo))
    wo = uo(So);
  else if (isPlainObject$1(uo) && !isBoolean$1(uo)) {
    var Eo = bo(uo, So);
    wo = /* @__PURE__ */ React__default.createElement(ShapeSelector, {
      shapeType: ho,
      elementProps: Eo
    });
  } else {
    var Ro = So;
    wo = /* @__PURE__ */ React__default.createElement(ShapeSelector, {
      shapeType: ho,
      elementProps: Ro
    });
  }
  return Co ? /* @__PURE__ */ React__default.createElement(Layer, {
    className: Po
  }, wo) : wo;
}
function isFunnel(Kt, uo) {
  return uo != null && "trapezoids" in Kt.props;
}
function isPie(Kt, uo) {
  return uo != null && "sectors" in Kt.props;
}
function isScatter(Kt, uo) {
  return uo != null && "points" in Kt.props;
}
function compareFunnel(Kt, uo) {
  var ho, go, bo = Kt.x === (uo == null || (ho = uo.labelViewBox) === null || ho === void 0 ? void 0 : ho.x) || Kt.x === uo.x, vo = Kt.y === (uo == null || (go = uo.labelViewBox) === null || go === void 0 ? void 0 : go.y) || Kt.y === uo.y;
  return bo && vo;
}
function comparePie(Kt, uo) {
  var ho = Kt.endAngle === uo.endAngle, go = Kt.startAngle === uo.startAngle;
  return ho && go;
}
function compareScatter(Kt, uo) {
  var ho = Kt.x === uo.x, go = Kt.y === uo.y, bo = Kt.z === uo.z;
  return ho && go && bo;
}
function getComparisonFn(Kt, uo) {
  var ho;
  return isFunnel(Kt, uo) ? ho = compareFunnel : isPie(Kt, uo) ? ho = comparePie : isScatter(Kt, uo) && (ho = compareScatter), ho;
}
function getShapeDataKey(Kt, uo) {
  var ho;
  return isFunnel(Kt, uo) ? ho = "trapezoids" : isPie(Kt, uo) ? ho = "sectors" : isScatter(Kt, uo) && (ho = "points"), ho;
}
function getActiveShapeTooltipPayload(Kt, uo) {
  if (isFunnel(Kt, uo)) {
    var ho;
    return (ho = uo.tooltipPayload) === null || ho === void 0 || (ho = ho[0]) === null || ho === void 0 || (ho = ho.payload) === null || ho === void 0 ? void 0 : ho.payload;
  }
  if (isPie(Kt, uo)) {
    var go;
    return (go = uo.tooltipPayload) === null || go === void 0 || (go = go[0]) === null || go === void 0 || (go = go.payload) === null || go === void 0 ? void 0 : go.payload;
  }
  return isScatter(Kt, uo) ? uo.payload : {};
}
function getActiveShapeIndexForTooltip(Kt) {
  var uo = Kt.activeTooltipItem, ho = Kt.graphicalItem, go = Kt.itemData, bo = getShapeDataKey(ho, uo), vo = getActiveShapeTooltipPayload(ho, uo), Po = go.filter(function(So, wo) {
    var Eo = isEqual$1(vo, So), Ro = ho.props[bo].filter(function(Ao) {
      var Oo = getComparisonFn(ho, uo);
      return Oo(Ao, uo);
    }), _o = ho.props[bo].indexOf(Ro[Ro.length - 1]), Io = wo === _o;
    return Eo && Io;
  }), Co = go.indexOf(Po[Po.length - 1]);
  return Co;
}
var nativeCeil = Math.ceil, nativeMax$1 = Math.max;
function baseRange$1(Kt, uo, ho, go) {
  for (var bo = -1, vo = nativeMax$1(nativeCeil((uo - Kt) / (ho || 1)), 0), Po = Array(vo); vo--; )
    Po[go ? vo : ++bo] = Kt, Kt += ho;
  return Po;
}
var _baseRange = baseRange$1, toNumber = toNumber_1, INFINITY = 1 / 0, MAX_INTEGER = 17976931348623157e292;
function toFinite$2(Kt) {
  if (!Kt)
    return Kt === 0 ? Kt : 0;
  if (Kt = toNumber(Kt), Kt === INFINITY || Kt === -INFINITY) {
    var uo = Kt < 0 ? -1 : 1;
    return uo * MAX_INTEGER;
  }
  return Kt === Kt ? Kt : 0;
}
var toFinite_1 = toFinite$2, baseRange = _baseRange, isIterateeCall$2 = _isIterateeCall, toFinite$1 = toFinite_1;
function createRange$1(Kt) {
  return function(uo, ho, go) {
    return go && typeof go != "number" && isIterateeCall$2(uo, ho, go) && (ho = go = void 0), uo = toFinite$1(uo), ho === void 0 ? (ho = uo, uo = 0) : ho = toFinite$1(ho), go = go === void 0 ? uo < ho ? 1 : -1 : toFinite$1(go), baseRange(uo, ho, go, Kt);
  };
}
var _createRange = createRange$1, createRange = _createRange, range = createRange(), range_1 = range;
const range$1 = /* @__PURE__ */ getDefaultExportFromCjs(range_1);
function _typeof$g(Kt) {
  "@babel/helpers - typeof";
  return _typeof$g = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$g(Kt);
}
function ownKeys$c(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$c(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$c(Object(ho), !0).forEach(function(go) {
      _defineProperty$f(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$c(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$f(Kt, uo, ho) {
  return uo = _toPropertyKey$f(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$f(Kt) {
  var uo = _toPrimitive$f(Kt, "string");
  return _typeof$g(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$f(Kt, uo) {
  if (_typeof$g(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$g(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var PREFIX_LIST = ["Webkit", "Moz", "O", "ms"], generatePrefixStyle = function(uo, ho) {
  var go = uo.replace(/(\w)/, function(vo) {
    return vo.toUpperCase();
  }), bo = PREFIX_LIST.reduce(function(vo, Po) {
    return _objectSpread$c(_objectSpread$c({}, vo), {}, _defineProperty$f({}, Po + go, ho));
  }, {});
  return bo[uo] = ho, bo;
};
function _typeof$f(Kt) {
  "@babel/helpers - typeof";
  return _typeof$f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$f(Kt);
}
function _extends$a() {
  return _extends$a = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$a.apply(this, arguments);
}
function ownKeys$b(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$b(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$b(Object(ho), !0).forEach(function(go) {
      _defineProperty$e(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$b(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$a(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$a(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$e(go.key), go);
  }
}
function _createClass$a(Kt, uo, ho) {
  return _defineProperties$a(Kt.prototype, uo), _defineProperties$a(Kt, ho), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$8(Kt, uo, ho) {
  return uo = _getPrototypeOf$8(uo), _possibleConstructorReturn$8(Kt, _isNativeReflectConstruct$8() ? Reflect.construct(uo, ho, _getPrototypeOf$8(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$8(Kt, uo) {
  if (uo && (_typeof$f(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$8(Kt);
}
function _assertThisInitialized$8(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$8() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$8 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$8(Kt) {
  return _getPrototypeOf$8 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$8(Kt);
}
function _inherits$8(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$8(Kt, uo);
}
function _setPrototypeOf$8(Kt, uo) {
  return _setPrototypeOf$8 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$8(Kt, uo);
}
function _defineProperty$e(Kt, uo, ho) {
  return uo = _toPropertyKey$e(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$e(Kt) {
  var uo = _toPrimitive$e(Kt, "string");
  return _typeof$f(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$e(Kt, uo) {
  if (_typeof$f(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$f(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var createScale = function(uo) {
  var ho = uo.data, go = uo.startIndex, bo = uo.endIndex, vo = uo.x, Po = uo.width, Co = uo.travellerWidth;
  if (!ho || !ho.length)
    return {};
  var So = ho.length, wo = point().domain(range$1(0, So)).range([vo, vo + Po - Co]), Eo = wo.domain().map(function(Ro) {
    return wo(Ro);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: wo(go),
    endX: wo(bo),
    scale: wo,
    scaleValues: Eo
  };
}, isTouch = function(uo) {
  return uo.changedTouches && !!uo.changedTouches.length;
}, Brush = /* @__PURE__ */ function(Kt) {
  function uo(ho) {
    var go;
    return _classCallCheck$a(this, uo), go = _callSuper$8(this, uo, [ho]), _defineProperty$e(go, "handleDrag", function(bo) {
      go.leaveTimer && (clearTimeout(go.leaveTimer), go.leaveTimer = null), go.state.isTravellerMoving ? go.handleTravellerMove(bo) : go.state.isSlideMoving && go.handleSlideDrag(bo);
    }), _defineProperty$e(go, "handleTouchMove", function(bo) {
      bo.changedTouches != null && bo.changedTouches.length > 0 && go.handleDrag(bo.changedTouches[0]);
    }), _defineProperty$e(go, "handleDragEnd", function() {
      go.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var bo = go.props, vo = bo.endIndex, Po = bo.onDragEnd, Co = bo.startIndex;
        Po == null || Po({
          endIndex: vo,
          startIndex: Co
        });
      }), go.detachDragEndListener();
    }), _defineProperty$e(go, "handleLeaveWrapper", function() {
      (go.state.isTravellerMoving || go.state.isSlideMoving) && (go.leaveTimer = window.setTimeout(go.handleDragEnd, go.props.leaveTimeOut));
    }), _defineProperty$e(go, "handleEnterSlideOrTraveller", function() {
      go.setState({
        isTextActive: !0
      });
    }), _defineProperty$e(go, "handleLeaveSlideOrTraveller", function() {
      go.setState({
        isTextActive: !1
      });
    }), _defineProperty$e(go, "handleSlideDragStart", function(bo) {
      var vo = isTouch(bo) ? bo.changedTouches[0] : bo;
      go.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: vo.pageX
      }), go.attachDragEndListener();
    }), go.travellerDragStartHandlers = {
      startX: go.handleTravellerDragStart.bind(go, "startX"),
      endX: go.handleTravellerDragStart.bind(go, "endX")
    }, go.state = {}, go;
  }
  return _inherits$8(uo, Kt), _createClass$a(uo, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(go) {
      var bo = go.startX, vo = go.endX, Po = this.state.scaleValues, Co = this.props, So = Co.gap, wo = Co.data, Eo = wo.length - 1, Ro = Math.min(bo, vo), _o = Math.max(bo, vo), Io = uo.getIndexInRange(Po, Ro), Ao = uo.getIndexInRange(Po, _o);
      return {
        startIndex: Io - Io % So,
        endIndex: Ao === Eo ? Eo : Ao - Ao % So
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(go) {
      var bo = this.props, vo = bo.data, Po = bo.tickFormatter, Co = bo.dataKey, So = getValueByDataKey(vo[go], Co, go);
      return isFunction$3(Po) ? Po(So, go) : So;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(go) {
      var bo = this.state, vo = bo.slideMoveStartX, Po = bo.startX, Co = bo.endX, So = this.props, wo = So.x, Eo = So.width, Ro = So.travellerWidth, _o = So.startIndex, Io = So.endIndex, Ao = So.onChange, Oo = go.pageX - vo;
      Oo > 0 ? Oo = Math.min(Oo, wo + Eo - Ro - Co, wo + Eo - Ro - Po) : Oo < 0 && (Oo = Math.max(Oo, wo - Po, wo - Co));
      var jo = this.getIndex({
        startX: Po + Oo,
        endX: Co + Oo
      });
      (jo.startIndex !== _o || jo.endIndex !== Io) && Ao && Ao(jo), this.setState({
        startX: Po + Oo,
        endX: Co + Oo,
        slideMoveStartX: go.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(go, bo) {
      var vo = isTouch(bo) ? bo.changedTouches[0] : bo;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: go,
        brushMoveStartX: vo.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(go) {
      var bo = this.state, vo = bo.brushMoveStartX, Po = bo.movingTravellerId, Co = bo.endX, So = bo.startX, wo = this.state[Po], Eo = this.props, Ro = Eo.x, _o = Eo.width, Io = Eo.travellerWidth, Ao = Eo.onChange, Oo = Eo.gap, jo = Eo.data, Do = {
        startX: this.state.startX,
        endX: this.state.endX
      }, Lo = go.pageX - vo;
      Lo > 0 ? Lo = Math.min(Lo, Ro + _o - Io - wo) : Lo < 0 && (Lo = Math.max(Lo, Ro - wo)), Do[Po] = wo + Lo;
      var ko = this.getIndex(Do), Ko = ko.startIndex, No = ko.endIndex, Jo = function() {
        var oi = jo.length - 1;
        return Po === "startX" && (Co > So ? Ko % Oo === 0 : No % Oo === 0) || Co < So && No === oi || Po === "endX" && (Co > So ? No % Oo === 0 : Ko % Oo === 0) || Co > So && No === oi;
      };
      this.setState(_defineProperty$e(_defineProperty$e({}, Po, wo + Lo), "brushMoveStartX", go.pageX), function() {
        Ao && Jo() && Ao(ko);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(go, bo) {
      var vo = this, Po = this.state, Co = Po.scaleValues, So = Po.startX, wo = Po.endX, Eo = this.state[bo], Ro = Co.indexOf(Eo);
      if (Ro !== -1) {
        var _o = Ro + go;
        if (!(_o === -1 || _o >= Co.length)) {
          var Io = Co[_o];
          bo === "startX" && Io >= wo || bo === "endX" && Io <= So || this.setState(_defineProperty$e({}, bo, Io), function() {
            vo.props.onChange(vo.getIndex({
              startX: vo.state.startX,
              endX: vo.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var go = this.props, bo = go.x, vo = go.y, Po = go.width, Co = go.height, So = go.fill, wo = go.stroke;
      return /* @__PURE__ */ React__default.createElement("rect", {
        stroke: wo,
        fill: So,
        x: bo,
        y: vo,
        width: Po,
        height: Co
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var go = this.props, bo = go.x, vo = go.y, Po = go.width, Co = go.height, So = go.data, wo = go.children, Eo = go.padding, Ro = Children.only(wo);
      return Ro ? /* @__PURE__ */ React__default.cloneElement(Ro, {
        x: bo,
        y: vo,
        width: Po,
        height: Co,
        margin: Eo,
        compact: !0,
        data: So
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(go, bo) {
      var vo, Po, Co = this, So = this.props, wo = So.y, Eo = So.travellerWidth, Ro = So.height, _o = So.traveller, Io = So.ariaLabel, Ao = So.data, Oo = So.startIndex, jo = So.endIndex, Do = Math.max(go, this.props.x), Lo = _objectSpread$b(_objectSpread$b({}, filterProps(this.props, !1)), {}, {
        x: Do,
        y: wo,
        width: Eo,
        height: Ro
      }), ko = Io || "Min value: ".concat((vo = Ao[Oo]) === null || vo === void 0 ? void 0 : vo.name, ", Max value: ").concat((Po = Ao[jo]) === null || Po === void 0 ? void 0 : Po.name);
      return /* @__PURE__ */ React__default.createElement(Layer, {
        tabIndex: 0,
        role: "slider",
        "aria-label": ko,
        "aria-valuenow": go,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[bo],
        onTouchStart: this.travellerDragStartHandlers[bo],
        onKeyDown: function(No) {
          ["ArrowLeft", "ArrowRight"].includes(No.key) && (No.preventDefault(), No.stopPropagation(), Co.handleTravellerMoveKeyboard(No.key === "ArrowRight" ? 1 : -1, bo));
        },
        onFocus: function() {
          Co.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          Co.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, uo.renderTraveller(_o, Lo));
    }
  }, {
    key: "renderSlide",
    value: function(go, bo) {
      var vo = this.props, Po = vo.y, Co = vo.height, So = vo.stroke, wo = vo.travellerWidth, Eo = Math.min(go, bo) + wo, Ro = Math.max(Math.abs(bo - go) - wo, 0);
      return /* @__PURE__ */ React__default.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: So,
        fillOpacity: 0.2,
        x: Eo,
        y: Po,
        width: Ro,
        height: Co
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var go = this.props, bo = go.startIndex, vo = go.endIndex, Po = go.y, Co = go.height, So = go.travellerWidth, wo = go.stroke, Eo = this.state, Ro = Eo.startX, _o = Eo.endX, Io = 5, Ao = {
        pointerEvents: "none",
        fill: wo
      };
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ React__default.createElement(Text, _extends$a({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(Ro, _o) - Io,
        y: Po + Co / 2
      }, Ao), this.getTextOfTick(bo)), /* @__PURE__ */ React__default.createElement(Text, _extends$a({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(Ro, _o) + So + Io,
        y: Po + Co / 2
      }, Ao), this.getTextOfTick(vo)));
    }
  }, {
    key: "render",
    value: function() {
      var go = this.props, bo = go.data, vo = go.className, Po = go.children, Co = go.x, So = go.y, wo = go.width, Eo = go.height, Ro = go.alwaysShowText, _o = this.state, Io = _o.startX, Ao = _o.endX, Oo = _o.isTextActive, jo = _o.isSlideMoving, Do = _o.isTravellerMoving, Lo = _o.isTravellerFocused;
      if (!bo || !bo.length || !isNumber(Co) || !isNumber(So) || !isNumber(wo) || !isNumber(Eo) || wo <= 0 || Eo <= 0)
        return null;
      var ko = clsx("recharts-brush", vo), Ko = React__default.Children.count(Po) === 1, No = generatePrefixStyle("userSelect", "none");
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: ko,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: No
      }, this.renderBackground(), Ko && this.renderPanorama(), this.renderSlide(Io, Ao), this.renderTravellerLayer(Io, "startX"), this.renderTravellerLayer(Ao, "endX"), (Oo || jo || Do || Lo || Ro) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(go) {
      var bo = go.x, vo = go.y, Po = go.width, Co = go.height, So = go.stroke, wo = Math.floor(vo + Co / 2) - 1;
      return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("rect", {
        x: bo,
        y: vo,
        width: Po,
        height: Co,
        fill: So,
        stroke: "none"
      }), /* @__PURE__ */ React__default.createElement("line", {
        x1: bo + 1,
        y1: wo,
        x2: bo + Po - 1,
        y2: wo,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ React__default.createElement("line", {
        x1: bo + 1,
        y1: wo + 2,
        x2: bo + Po - 1,
        y2: wo + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(go, bo) {
      var vo;
      return /* @__PURE__ */ React__default.isValidElement(go) ? vo = /* @__PURE__ */ React__default.cloneElement(go, bo) : isFunction$3(go) ? vo = go(bo) : vo = uo.renderDefaultTraveller(bo), vo;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(go, bo) {
      var vo = go.data, Po = go.width, Co = go.x, So = go.travellerWidth, wo = go.updateId, Eo = go.startIndex, Ro = go.endIndex;
      if (vo !== bo.prevData || wo !== bo.prevUpdateId)
        return _objectSpread$b({
          prevData: vo,
          prevTravellerWidth: So,
          prevUpdateId: wo,
          prevX: Co,
          prevWidth: Po
        }, vo && vo.length ? createScale({
          data: vo,
          width: Po,
          x: Co,
          travellerWidth: So,
          startIndex: Eo,
          endIndex: Ro
        }) : {
          scale: null,
          scaleValues: null
        });
      if (bo.scale && (Po !== bo.prevWidth || Co !== bo.prevX || So !== bo.prevTravellerWidth)) {
        bo.scale.range([Co, Co + Po - So]);
        var _o = bo.scale.domain().map(function(Io) {
          return bo.scale(Io);
        });
        return {
          prevData: vo,
          prevTravellerWidth: So,
          prevUpdateId: wo,
          prevX: Co,
          prevWidth: Po,
          startX: bo.scale(go.startIndex),
          endX: bo.scale(go.endIndex),
          scaleValues: _o
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(go, bo) {
      for (var vo = go.length, Po = 0, Co = vo - 1; Co - Po > 1; ) {
        var So = Math.floor((Po + Co) / 2);
        go[So] > bo ? Co = So : Po = So;
      }
      return bo >= go[Co] ? Co : Po;
    }
  }]);
}(PureComponent);
_defineProperty$e(Brush, "displayName", "Brush");
_defineProperty$e(Brush, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var baseEach$1 = _baseEach;
function baseSome$1(Kt, uo) {
  var ho;
  return baseEach$1(Kt, function(go, bo, vo) {
    return ho = uo(go, bo, vo), !ho;
  }), !!ho;
}
var _baseSome = baseSome$1, arraySome = _arraySome, baseIteratee$4 = _baseIteratee, baseSome = _baseSome, isArray$1 = isArray_1, isIterateeCall$1 = _isIterateeCall;
function some(Kt, uo, ho) {
  var go = isArray$1(Kt) ? arraySome : baseSome;
  return ho && isIterateeCall$1(Kt, uo, ho) && (uo = void 0), go(Kt, baseIteratee$4(uo));
}
var some_1 = some;
const some$1 = /* @__PURE__ */ getDefaultExportFromCjs(some_1);
var ifOverflowMatches = function(uo, ho) {
  var go = uo.alwaysShow, bo = uo.ifOverflow;
  return go && (bo = "extendDomain"), bo === ho;
}, defineProperty = _defineProperty$B;
function baseAssignValue$1(Kt, uo, ho) {
  uo == "__proto__" && defineProperty ? defineProperty(Kt, uo, {
    configurable: !0,
    enumerable: !0,
    value: ho,
    writable: !0
  }) : Kt[uo] = ho;
}
var _baseAssignValue = baseAssignValue$1, baseAssignValue = _baseAssignValue, baseForOwn = _baseForOwn, baseIteratee$3 = _baseIteratee;
function mapValues(Kt, uo) {
  var ho = {};
  return uo = baseIteratee$3(uo), baseForOwn(Kt, function(go, bo, vo) {
    baseAssignValue(ho, bo, uo(go, bo, vo));
  }), ho;
}
var mapValues_1 = mapValues;
const mapValues$1 = /* @__PURE__ */ getDefaultExportFromCjs(mapValues_1);
function arrayEvery$1(Kt, uo) {
  for (var ho = -1, go = Kt == null ? 0 : Kt.length; ++ho < go; )
    if (!uo(Kt[ho], ho, Kt))
      return !1;
  return !0;
}
var _arrayEvery = arrayEvery$1, baseEach = _baseEach;
function baseEvery$1(Kt, uo) {
  var ho = !0;
  return baseEach(Kt, function(go, bo, vo) {
    return ho = !!uo(go, bo, vo), ho;
  }), ho;
}
var _baseEvery = baseEvery$1, arrayEvery = _arrayEvery, baseEvery = _baseEvery, baseIteratee$2 = _baseIteratee, isArray = isArray_1, isIterateeCall = _isIterateeCall;
function every(Kt, uo, ho) {
  var go = isArray(Kt) ? arrayEvery : baseEvery;
  return ho && isIterateeCall(Kt, uo, ho) && (uo = void 0), go(Kt, baseIteratee$2(uo));
}
var every_1 = every;
const every$1 = /* @__PURE__ */ getDefaultExportFromCjs(every_1);
var _excluded$4 = ["x", "y"];
function _typeof$e(Kt) {
  "@babel/helpers - typeof";
  return _typeof$e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$e(Kt);
}
function _extends$9() {
  return _extends$9 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$9.apply(this, arguments);
}
function ownKeys$a(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$a(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$a(Object(ho), !0).forEach(function(go) {
      _defineProperty$d(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$a(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$d(Kt, uo, ho) {
  return uo = _toPropertyKey$d(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$d(Kt) {
  var uo = _toPrimitive$d(Kt, "string");
  return _typeof$e(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$d(Kt, uo) {
  if (_typeof$e(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$e(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _objectWithoutProperties$4(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$4(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$4(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function typeguardBarRectangleProps(Kt, uo) {
  var ho = Kt.x, go = Kt.y, bo = _objectWithoutProperties$4(Kt, _excluded$4), vo = "".concat(ho), Po = parseInt(vo, 10), Co = "".concat(go), So = parseInt(Co, 10), wo = "".concat(uo.height || bo.height), Eo = parseInt(wo, 10), Ro = "".concat(uo.width || bo.width), _o = parseInt(Ro, 10);
  return _objectSpread$a(_objectSpread$a(_objectSpread$a(_objectSpread$a(_objectSpread$a({}, uo), bo), Po ? {
    x: Po
  } : {}), So ? {
    y: So
  } : {}), {}, {
    height: Eo,
    width: _o,
    name: uo.name,
    radius: uo.radius
  });
}
function BarRectangle(Kt) {
  return /* @__PURE__ */ React__default.createElement(Shape, _extends$9({
    shapeType: "rectangle",
    propTransformer: typeguardBarRectangleProps,
    activeClassName: "recharts-active-bar"
  }, Kt));
}
var minPointSizeCallback = function(uo) {
  var ho = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(go, bo) {
    if (typeof uo == "number") return uo;
    var vo = typeof go == "number";
    return vo ? uo(go, bo) : (vo || (process.env.NODE_ENV !== "production" ? invariant(!1, "minPointSize callback function received a value with type of ".concat(_typeof$e(go), ". Currently only numbers are supported.")) : invariant()), ho);
  };
}, _excluded$3 = ["value", "background"], _Bar;
function _typeof$d(Kt) {
  "@babel/helpers - typeof";
  return _typeof$d = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$d(Kt);
}
function _objectWithoutProperties$3(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$3(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$3(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function _extends$8() {
  return _extends$8 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$8.apply(this, arguments);
}
function ownKeys$9(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$9(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$9(Object(ho), !0).forEach(function(go) {
      _defineProperty$c(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$9(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$9(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$9(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$c(go.key), go);
  }
}
function _createClass$9(Kt, uo, ho) {
  return _defineProperties$9(Kt.prototype, uo), _defineProperties$9(Kt, ho), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$7(Kt, uo, ho) {
  return uo = _getPrototypeOf$7(uo), _possibleConstructorReturn$7(Kt, _isNativeReflectConstruct$7() ? Reflect.construct(uo, ho, _getPrototypeOf$7(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$7(Kt, uo) {
  if (uo && (_typeof$d(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$7(Kt);
}
function _assertThisInitialized$7(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$7() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$7 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$7(Kt) {
  return _getPrototypeOf$7 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$7(Kt);
}
function _inherits$7(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$7(Kt, uo);
}
function _setPrototypeOf$7(Kt, uo) {
  return _setPrototypeOf$7 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$7(Kt, uo);
}
function _defineProperty$c(Kt, uo, ho) {
  return uo = _toPropertyKey$c(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$c(Kt) {
  var uo = _toPrimitive$c(Kt, "string");
  return _typeof$d(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$c(Kt, uo) {
  if (_typeof$d(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$d(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var Bar = /* @__PURE__ */ function(Kt) {
  function uo() {
    var ho;
    _classCallCheck$9(this, uo);
    for (var go = arguments.length, bo = new Array(go), vo = 0; vo < go; vo++)
      bo[vo] = arguments[vo];
    return ho = _callSuper$7(this, uo, [].concat(bo)), _defineProperty$c(ho, "state", {
      isAnimationFinished: !1
    }), _defineProperty$c(ho, "id", uniqueId("recharts-bar-")), _defineProperty$c(ho, "handleAnimationEnd", function() {
      var Po = ho.props.onAnimationEnd;
      ho.setState({
        isAnimationFinished: !0
      }), Po && Po();
    }), _defineProperty$c(ho, "handleAnimationStart", function() {
      var Po = ho.props.onAnimationStart;
      ho.setState({
        isAnimationFinished: !1
      }), Po && Po();
    }), ho;
  }
  return _inherits$7(uo, Kt), _createClass$9(uo, [{
    key: "renderRectanglesStatically",
    value: function(go) {
      var bo = this, vo = this.props, Po = vo.shape, Co = vo.dataKey, So = vo.activeIndex, wo = vo.activeBar, Eo = filterProps(this.props, !1);
      return go && go.map(function(Ro, _o) {
        var Io = _o === So, Ao = Io ? wo : Po, Oo = _objectSpread$9(_objectSpread$9(_objectSpread$9({}, Eo), Ro), {}, {
          isActive: Io,
          option: Ao,
          index: _o,
          dataKey: Co,
          onAnimationStart: bo.handleAnimationStart,
          onAnimationEnd: bo.handleAnimationEnd
        });
        return /* @__PURE__ */ React__default.createElement(Layer, _extends$8({
          className: "recharts-bar-rectangle"
        }, adaptEventsOfChild(bo.props, Ro, _o), {
          key: "rectangle-".concat(Ro == null ? void 0 : Ro.x, "-").concat(Ro == null ? void 0 : Ro.y, "-").concat(Ro == null ? void 0 : Ro.value)
        }), /* @__PURE__ */ React__default.createElement(BarRectangle, Oo));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var go = this, bo = this.props, vo = bo.data, Po = bo.layout, Co = bo.isAnimationActive, So = bo.animationBegin, wo = bo.animationDuration, Eo = bo.animationEasing, Ro = bo.animationId, _o = this.state.prevData;
      return /* @__PURE__ */ React__default.createElement(Animate, {
        begin: So,
        duration: wo,
        isActive: Co,
        easing: Eo,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(Ro),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(Io) {
        var Ao = Io.t, Oo = vo.map(function(jo, Do) {
          var Lo = _o && _o[Do];
          if (Lo) {
            var ko = interpolateNumber$2(Lo.x, jo.x), Ko = interpolateNumber$2(Lo.y, jo.y), No = interpolateNumber$2(Lo.width, jo.width), Jo = interpolateNumber$2(Lo.height, jo.height);
            return _objectSpread$9(_objectSpread$9({}, jo), {}, {
              x: ko(Ao),
              y: Ko(Ao),
              width: No(Ao),
              height: Jo(Ao)
            });
          }
          if (Po === "horizontal") {
            var ti = interpolateNumber$2(0, jo.height), oi = ti(Ao);
            return _objectSpread$9(_objectSpread$9({}, jo), {}, {
              y: jo.y + jo.height - oi,
              height: oi
            });
          }
          var Qo = interpolateNumber$2(0, jo.width), Zo = Qo(Ao);
          return _objectSpread$9(_objectSpread$9({}, jo), {}, {
            width: Zo
          });
        });
        return /* @__PURE__ */ React__default.createElement(Layer, null, go.renderRectanglesStatically(Oo));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var go = this.props, bo = go.data, vo = go.isAnimationActive, Po = this.state.prevData;
      return vo && bo && bo.length && (!Po || !isEqual$1(Po, bo)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(bo);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var go = this, bo = this.props, vo = bo.data, Po = bo.dataKey, Co = bo.activeIndex, So = filterProps(this.props.background, !1);
      return vo.map(function(wo, Eo) {
        wo.value;
        var Ro = wo.background, _o = _objectWithoutProperties$3(wo, _excluded$3);
        if (!Ro)
          return null;
        var Io = _objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9(_objectSpread$9({}, _o), {}, {
          fill: "#eee"
        }, Ro), So), adaptEventsOfChild(go.props, wo, Eo)), {}, {
          onAnimationStart: go.handleAnimationStart,
          onAnimationEnd: go.handleAnimationEnd,
          dataKey: Po,
          index: Eo,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ React__default.createElement(BarRectangle, _extends$8({
          key: "background-bar-".concat(Eo),
          option: go.props.background,
          isActive: Eo === Co
        }, Io));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(go, bo) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var vo = this.props, Po = vo.data, Co = vo.xAxis, So = vo.yAxis, wo = vo.layout, Eo = vo.children, Ro = findAllByType(Eo, ErrorBar);
      if (!Ro)
        return null;
      var _o = wo === "vertical" ? Po[0].height / 2 : Po[0].width / 2, Io = function(jo, Do) {
        var Lo = Array.isArray(jo.value) ? jo.value[1] : jo.value;
        return {
          x: jo.x,
          y: jo.y,
          value: Lo,
          errorVal: getValueByDataKey(jo, Do)
        };
      }, Ao = {
        clipPath: go ? "url(#clipPath-".concat(bo, ")") : null
      };
      return /* @__PURE__ */ React__default.createElement(Layer, Ao, Ro.map(function(Oo) {
        return /* @__PURE__ */ React__default.cloneElement(Oo, {
          key: "error-bar-".concat(bo, "-").concat(Oo.props.dataKey),
          data: Po,
          xAxis: Co,
          yAxis: So,
          layout: wo,
          offset: _o,
          dataPointFormatter: Io
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var go = this.props, bo = go.hide, vo = go.data, Po = go.className, Co = go.xAxis, So = go.yAxis, wo = go.left, Eo = go.top, Ro = go.width, _o = go.height, Io = go.isAnimationActive, Ao = go.background, Oo = go.id;
      if (bo || !vo || !vo.length)
        return null;
      var jo = this.state.isAnimationFinished, Do = clsx("recharts-bar", Po), Lo = Co && Co.allowDataOverflow, ko = So && So.allowDataOverflow, Ko = Lo || ko, No = isNil$1(Oo) ? this.id : Oo;
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: Do
      }, Lo || ko ? /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
        id: "clipPath-".concat(No)
      }, /* @__PURE__ */ React__default.createElement("rect", {
        x: Lo ? wo : wo - Ro / 2,
        y: ko ? Eo : Eo - _o / 2,
        width: Lo ? Ro : Ro * 2,
        height: ko ? _o : _o * 2
      }))) : null, /* @__PURE__ */ React__default.createElement(Layer, {
        className: "recharts-bar-rectangles",
        clipPath: Ko ? "url(#clipPath-".concat(No, ")") : null
      }, Ao ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(Ko, No), (!Io || jo) && LabelList.renderCallByParent(this.props, vo));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(go, bo) {
      return go.animationId !== bo.prevAnimationId ? {
        prevAnimationId: go.animationId,
        curData: go.data,
        prevData: bo.curData
      } : go.data !== bo.curData ? {
        curData: go.data
      } : null;
    }
  }]);
}(PureComponent);
_Bar = Bar;
_defineProperty$c(Bar, "displayName", "Bar");
_defineProperty$c(Bar, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Global.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
_defineProperty$c(Bar, "getComposedData", function(Kt) {
  var uo = Kt.props, ho = Kt.item, go = Kt.barPosition, bo = Kt.bandSize, vo = Kt.xAxis, Po = Kt.yAxis, Co = Kt.xAxisTicks, So = Kt.yAxisTicks, wo = Kt.stackedData, Eo = Kt.dataStartIndex, Ro = Kt.displayedData, _o = Kt.offset, Io = findPositionOfBar(go, ho);
  if (!Io)
    return null;
  var Ao = uo.layout, Oo = ho.type.defaultProps, jo = Oo !== void 0 ? _objectSpread$9(_objectSpread$9({}, Oo), ho.props) : ho.props, Do = jo.dataKey, Lo = jo.children, ko = jo.minPointSize, Ko = Ao === "horizontal" ? Po : vo, No = wo ? Ko.scale.domain() : null, Jo = getBaseValueOfBar({
    numericAxis: Ko
  }), ti = findAllByType(Lo, Cell), oi = Ro.map(function(Qo, Zo) {
    var ei, ii, ai, ri, ni, si;
    wo ? ei = truncateByDomain(wo[Eo + Zo], No) : (ei = getValueByDataKey(Qo, Do), Array.isArray(ei) || (ei = [Jo, ei]));
    var li = minPointSizeCallback(ko, _Bar.defaultProps.minPointSize)(ei[1], Zo);
    if (Ao === "horizontal") {
      var ui, ci = [Po.scale(ei[0]), Po.scale(ei[1])], fi = ci[0], yi = ci[1];
      ii = getCateCoordinateOfBar({
        axis: vo,
        ticks: Co,
        bandSize: bo,
        offset: Io.offset,
        entry: Qo,
        index: Zo
      }), ai = (ui = yi ?? fi) !== null && ui !== void 0 ? ui : void 0, ri = Io.size;
      var hi = fi - yi;
      if (ni = Number.isNaN(hi) ? 0 : hi, si = {
        x: ii,
        y: Po.y,
        width: ri,
        height: Po.height
      }, Math.abs(li) > 0 && Math.abs(ni) < Math.abs(li)) {
        var mi = mathSign(ni || li) * (Math.abs(li) - Math.abs(ni));
        ai -= mi, ni += mi;
      }
    } else {
      var bi = [vo.scale(ei[0]), vo.scale(ei[1])], xi = bi[0], $i = bi[1];
      if (ii = xi, ai = getCateCoordinateOfBar({
        axis: Po,
        ticks: So,
        bandSize: bo,
        offset: Io.offset,
        entry: Qo,
        index: Zo
      }), ri = $i - xi, ni = Io.size, si = {
        x: vo.x,
        y: ai,
        width: vo.width,
        height: ni
      }, Math.abs(li) > 0 && Math.abs(ri) < Math.abs(li)) {
        var Ci = mathSign(ri || li) * (Math.abs(li) - Math.abs(ri));
        ri += Ci;
      }
    }
    return _objectSpread$9(_objectSpread$9(_objectSpread$9({}, Qo), {}, {
      x: ii,
      y: ai,
      width: ri,
      height: ni,
      value: wo ? ei : ei[1],
      payload: Qo,
      background: si
    }, ti[Zo] && ti[Zo].props), {}, {
      tooltipPayload: [getTooltipItem(ho, Qo)],
      tooltipPosition: {
        x: ii + ri / 2,
        y: ai + ni / 2
      }
    });
  });
  return _objectSpread$9({
    data: oi,
    layout: Ao
  }, _o);
});
function _typeof$c(Kt) {
  "@babel/helpers - typeof";
  return _typeof$c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$c(Kt);
}
function _classCallCheck$8(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$8(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$b(go.key), go);
  }
}
function _createClass$8(Kt, uo, ho) {
  return _defineProperties$8(Kt.prototype, uo), _defineProperties$8(Kt, ho), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function ownKeys$8(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$8(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$8(Object(ho), !0).forEach(function(go) {
      _defineProperty$b(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$8(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$b(Kt, uo, ho) {
  return uo = _toPropertyKey$b(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$b(Kt) {
  var uo = _toPrimitive$b(Kt, "string");
  return _typeof$c(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$b(Kt, uo) {
  if (_typeof$c(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$c(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var formatAxisMap = function(uo, ho, go, bo, vo) {
  var Po = uo.width, Co = uo.height, So = uo.layout, wo = uo.children, Eo = Object.keys(ho), Ro = {
    left: go.left,
    leftMirror: go.left,
    right: Po - go.right,
    rightMirror: Po - go.right,
    top: go.top,
    topMirror: go.top,
    bottom: Co - go.bottom,
    bottomMirror: Co - go.bottom
  }, _o = !!findChildByType(wo, Bar);
  return Eo.reduce(function(Io, Ao) {
    var Oo = ho[Ao], jo = Oo.orientation, Do = Oo.domain, Lo = Oo.padding, ko = Lo === void 0 ? {} : Lo, Ko = Oo.mirror, No = Oo.reversed, Jo = "".concat(jo).concat(Ko ? "Mirror" : ""), ti, oi, Qo, Zo, ei;
    if (Oo.type === "number" && (Oo.padding === "gap" || Oo.padding === "no-gap")) {
      var ii = Do[1] - Do[0], ai = 1 / 0, ri = Oo.categoricalDomain.sort();
      if (ri.forEach(function(bi, xi) {
        xi > 0 && (ai = Math.min((bi || 0) - (ri[xi - 1] || 0), ai));
      }), Number.isFinite(ai)) {
        var ni = ai / ii, si = Oo.layout === "vertical" ? go.height : go.width;
        if (Oo.padding === "gap" && (ti = ni * si / 2), Oo.padding === "no-gap") {
          var li = getPercentValue(uo.barCategoryGap, ni * si), ui = ni * si / 2;
          ti = ui - li - (ui - li) / si * li;
        }
      }
    }
    bo === "xAxis" ? oi = [go.left + (ko.left || 0) + (ti || 0), go.left + go.width - (ko.right || 0) - (ti || 0)] : bo === "yAxis" ? oi = So === "horizontal" ? [go.top + go.height - (ko.bottom || 0), go.top + (ko.top || 0)] : [go.top + (ko.top || 0) + (ti || 0), go.top + go.height - (ko.bottom || 0) - (ti || 0)] : oi = Oo.range, No && (oi = [oi[1], oi[0]]);
    var ci = parseScale(Oo, vo, _o), fi = ci.scale, yi = ci.realScaleType;
    fi.domain(Do).range(oi), checkDomainOfScale(fi);
    var hi = getTicksOfScale(fi, _objectSpread$8(_objectSpread$8({}, Oo), {}, {
      realScaleType: yi
    }));
    bo === "xAxis" ? (ei = jo === "top" && !Ko || jo === "bottom" && Ko, Qo = go.left, Zo = Ro[Jo] - ei * Oo.height) : bo === "yAxis" && (ei = jo === "left" && !Ko || jo === "right" && Ko, Qo = Ro[Jo] - ei * Oo.width, Zo = go.top);
    var mi = _objectSpread$8(_objectSpread$8(_objectSpread$8({}, Oo), hi), {}, {
      realScaleType: yi,
      x: Qo,
      y: Zo,
      scale: fi,
      width: bo === "xAxis" ? go.width : Oo.width,
      height: bo === "yAxis" ? go.height : Oo.height
    });
    return mi.bandSize = getBandSizeOfAxis(mi, hi), !Oo.hide && bo === "xAxis" ? Ro[Jo] += (ei ? -1 : 1) * mi.height : Oo.hide || (Ro[Jo] += (ei ? -1 : 1) * mi.width), _objectSpread$8(_objectSpread$8({}, Io), {}, _defineProperty$b({}, Ao, mi));
  }, {});
}, rectWithPoints = function(uo, ho) {
  var go = uo.x, bo = uo.y, vo = ho.x, Po = ho.y;
  return {
    x: Math.min(go, vo),
    y: Math.min(bo, Po),
    width: Math.abs(vo - go),
    height: Math.abs(Po - bo)
  };
}, rectWithCoords = function(uo) {
  var ho = uo.x1, go = uo.y1, bo = uo.x2, vo = uo.y2;
  return rectWithPoints({
    x: ho,
    y: go
  }, {
    x: bo,
    y: vo
  });
}, ScaleHelper = /* @__PURE__ */ function() {
  function Kt(uo) {
    _classCallCheck$8(this, Kt), this.scale = uo;
  }
  return _createClass$8(Kt, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(ho) {
      var go = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, bo = go.bandAware, vo = go.position;
      if (ho !== void 0) {
        if (vo)
          switch (vo) {
            case "start":
              return this.scale(ho);
            case "middle": {
              var Po = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(ho) + Po;
            }
            case "end": {
              var Co = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(ho) + Co;
            }
            default:
              return this.scale(ho);
          }
        if (bo) {
          var So = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(ho) + So;
        }
        return this.scale(ho);
      }
    }
  }, {
    key: "isInRange",
    value: function(ho) {
      var go = this.range(), bo = go[0], vo = go[go.length - 1];
      return bo <= vo ? ho >= bo && ho <= vo : ho >= vo && ho <= bo;
    }
  }], [{
    key: "create",
    value: function(ho) {
      return new Kt(ho);
    }
  }]);
}();
_defineProperty$b(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = function(uo) {
  var ho = Object.keys(uo).reduce(function(go, bo) {
    return _objectSpread$8(_objectSpread$8({}, go), {}, _defineProperty$b({}, bo, ScaleHelper.create(uo[bo])));
  }, {});
  return _objectSpread$8(_objectSpread$8({}, ho), {}, {
    apply: function(bo) {
      var vo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Po = vo.bandAware, Co = vo.position;
      return mapValues$1(bo, function(So, wo) {
        return ho[wo].apply(So, {
          bandAware: Po,
          position: Co
        });
      });
    },
    isInRange: function(bo) {
      return every$1(bo, function(vo, Po) {
        return ho[Po].isInRange(vo);
      });
    }
  });
};
function normalizeAngle(Kt) {
  return (Kt % 180 + 180) % 180;
}
var getAngledRectangleWidth = function(uo) {
  var ho = uo.width, go = uo.height, bo = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, vo = normalizeAngle(bo), Po = vo * Math.PI / 180, Co = Math.atan(go / ho), So = Po > Co && Po < Math.PI - Co ? go / Math.sin(Po) : ho / Math.cos(Po);
  return Math.abs(So);
}, baseIteratee$1 = _baseIteratee, isArrayLike = isArrayLike_1, keys = keys_1;
function createFind$1(Kt) {
  return function(uo, ho, go) {
    var bo = Object(uo);
    if (!isArrayLike(uo)) {
      var vo = baseIteratee$1(ho);
      uo = keys(uo), ho = function(Co) {
        return vo(bo[Co], Co, bo);
      };
    }
    var Po = Kt(uo, ho, go);
    return Po > -1 ? bo[vo ? uo[Po] : Po] : void 0;
  };
}
var _createFind = createFind$1, toFinite = toFinite_1;
function toInteger$1(Kt) {
  var uo = toFinite(Kt), ho = uo % 1;
  return uo === uo ? ho ? uo - ho : uo : 0;
}
var toInteger_1 = toInteger$1, baseFindIndex = _baseFindIndex, baseIteratee = _baseIteratee, toInteger = toInteger_1, nativeMax = Math.max;
function findIndex$1(Kt, uo, ho) {
  var go = Kt == null ? 0 : Kt.length;
  if (!go)
    return -1;
  var bo = ho == null ? 0 : toInteger(ho);
  return bo < 0 && (bo = nativeMax(go + bo, 0)), baseFindIndex(Kt, baseIteratee(uo), bo);
}
var findIndex_1 = findIndex$1, createFind = _createFind, findIndex = findIndex_1, find = createFind(findIndex), find_1 = find;
const find$1 = /* @__PURE__ */ getDefaultExportFromCjs(find_1);
var calculateViewBox = memoize$3(function(Kt) {
  return {
    x: Kt.left,
    y: Kt.top,
    width: Kt.width,
    height: Kt.height
  };
}, function(Kt) {
  return ["l", Kt.left, "t", Kt.top, "w", Kt.width, "h", Kt.height].join("");
});
function _typeof$b(Kt) {
  "@babel/helpers - typeof";
  return _typeof$b = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$b(Kt);
}
var XAxisContext = /* @__PURE__ */ createContext(void 0), YAxisContext = /* @__PURE__ */ createContext(void 0), ViewBoxContext = /* @__PURE__ */ createContext(void 0), OffsetContext = /* @__PURE__ */ createContext({}), ClipPathIdContext = /* @__PURE__ */ createContext(void 0), ChartHeightContext = /* @__PURE__ */ createContext(0), ChartWidthContext = /* @__PURE__ */ createContext(0), ChartLayoutContextProvider = function(uo) {
  var ho = uo.state, go = ho.xAxisMap, bo = ho.yAxisMap, vo = ho.offset, Po = uo.clipPathId, Co = uo.children, So = uo.width, wo = uo.height, Eo = calculateViewBox(vo);
  return /* @__PURE__ */ React__default.createElement(XAxisContext.Provider, {
    value: go
  }, /* @__PURE__ */ React__default.createElement(YAxisContext.Provider, {
    value: bo
  }, /* @__PURE__ */ React__default.createElement(OffsetContext.Provider, {
    value: vo
  }, /* @__PURE__ */ React__default.createElement(ViewBoxContext.Provider, {
    value: Eo
  }, /* @__PURE__ */ React__default.createElement(ClipPathIdContext.Provider, {
    value: Po
  }, /* @__PURE__ */ React__default.createElement(ChartHeightContext.Provider, {
    value: wo
  }, /* @__PURE__ */ React__default.createElement(ChartWidthContext.Provider, {
    value: So
  }, Co)))))));
}, useClipPathId = function() {
  return useContext(ClipPathIdContext);
};
function getKeysForDebug(Kt) {
  var uo = Object.keys(Kt);
  return uo.length === 0 ? "There are no available ids." : "Available ids are: ".concat(uo, ".");
}
var useXAxisOrThrow = function(uo) {
  var ho = useContext(XAxisContext);
  ho == null && (process.env.NODE_ENV !== "production" ? invariant(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant());
  var go = ho[uo];
  return go == null && (process.env.NODE_ENV !== "production" ? invariant(!1, 'Could not find xAxis by id "'.concat(uo, '" [').concat(_typeof$b(uo), "]. ").concat(getKeysForDebug(ho))) : invariant()), go;
}, useArbitraryXAxis = function() {
  var uo = useContext(XAxisContext);
  return getAnyElementOfObject(uo);
}, useYAxisWithFiniteDomainOrRandom = function() {
  var uo = useContext(YAxisContext), ho = find$1(uo, function(go) {
    return every$1(go.domain, Number.isFinite);
  });
  return ho || getAnyElementOfObject(uo);
}, useYAxisOrThrow = function(uo) {
  var ho = useContext(YAxisContext);
  ho == null && (process.env.NODE_ENV !== "production" ? invariant(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : invariant());
  var go = ho[uo];
  return go == null && (process.env.NODE_ENV !== "production" ? invariant(!1, 'Could not find yAxis by id "'.concat(uo, '" [').concat(_typeof$b(uo), "]. ").concat(getKeysForDebug(ho))) : invariant()), go;
}, useViewBox = function() {
  var uo = useContext(ViewBoxContext);
  return uo;
}, useOffset = function() {
  return useContext(OffsetContext);
}, useChartWidth = function() {
  return useContext(ChartWidthContext);
}, useChartHeight = function() {
  return useContext(ChartHeightContext);
};
function _typeof$a(Kt) {
  "@babel/helpers - typeof";
  return _typeof$a = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$a(Kt);
}
function _classCallCheck$7(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$7(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$a(go.key), go);
  }
}
function _createClass$7(Kt, uo, ho) {
  return _defineProperties$7(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$6(Kt, uo, ho) {
  return uo = _getPrototypeOf$6(uo), _possibleConstructorReturn$6(Kt, _isNativeReflectConstruct$6() ? Reflect.construct(uo, ho || [], _getPrototypeOf$6(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$6(Kt, uo) {
  if (uo && (_typeof$a(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$6(Kt);
}
function _assertThisInitialized$6(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$6() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$6 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$6(Kt) {
  return _getPrototypeOf$6 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$6(Kt);
}
function _inherits$6(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$6(Kt, uo);
}
function _setPrototypeOf$6(Kt, uo) {
  return _setPrototypeOf$6 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$6(Kt, uo);
}
function ownKeys$7(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$7(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$7(Object(ho), !0).forEach(function(go) {
      _defineProperty$a(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$7(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$a(Kt, uo, ho) {
  return uo = _toPropertyKey$a(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$a(Kt) {
  var uo = _toPrimitive$a(Kt, "string");
  return _typeof$a(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$a(Kt, uo) {
  if (_typeof$a(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$a(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _slicedToArray$1(Kt, uo) {
  return _arrayWithHoles$1(Kt) || _iterableToArrayLimit$1(Kt, uo) || _unsupportedIterableToArray$2(Kt, uo) || _nonIterableRest$1();
}
function _nonIterableRest$1() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$2(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$2(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$2(Kt, uo);
  }
}
function _arrayLikeToArray$2(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function _iterableToArrayLimit$1(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles$1(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function _extends$7() {
  return _extends$7 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$7.apply(this, arguments);
}
var renderLine = function(uo, ho) {
  var go;
  return /* @__PURE__ */ React__default.isValidElement(uo) ? go = /* @__PURE__ */ React__default.cloneElement(uo, ho) : isFunction$3(uo) ? go = uo(ho) : go = /* @__PURE__ */ React__default.createElement("line", _extends$7({}, ho, {
    className: "recharts-reference-line-line"
  })), go;
}, getEndPoints = function(uo, ho, go, bo, vo, Po, Co, So, wo) {
  var Eo = vo.x, Ro = vo.y, _o = vo.width, Io = vo.height;
  if (go) {
    var Ao = wo.y, Oo = uo.y.apply(Ao, {
      position: Po
    });
    if (ifOverflowMatches(wo, "discard") && !uo.y.isInRange(Oo))
      return null;
    var jo = [{
      x: Eo + _o,
      y: Oo
    }, {
      x: Eo,
      y: Oo
    }];
    return So === "left" ? jo.reverse() : jo;
  }
  if (ho) {
    var Do = wo.x, Lo = uo.x.apply(Do, {
      position: Po
    });
    if (ifOverflowMatches(wo, "discard") && !uo.x.isInRange(Lo))
      return null;
    var ko = [{
      x: Lo,
      y: Ro + Io
    }, {
      x: Lo,
      y: Ro
    }];
    return Co === "top" ? ko.reverse() : ko;
  }
  if (bo) {
    var Ko = wo.segment, No = Ko.map(function(Jo) {
      return uo.apply(Jo, {
        position: Po
      });
    });
    return ifOverflowMatches(wo, "discard") && some$1(No, function(Jo) {
      return !uo.isInRange(Jo);
    }) ? null : No;
  }
  return null;
};
function ReferenceLineImpl(Kt) {
  var uo = Kt.x, ho = Kt.y, go = Kt.segment, bo = Kt.xAxisId, vo = Kt.yAxisId, Po = Kt.shape, Co = Kt.className, So = Kt.alwaysShow, wo = useClipPathId(), Eo = useXAxisOrThrow(bo), Ro = useYAxisOrThrow(vo), _o = useViewBox();
  if (!wo || !_o)
    return null;
  warn$1(So === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var Io = createLabeledScales({
    x: Eo.scale,
    y: Ro.scale
  }), Ao = isNumOrStr(uo), Oo = isNumOrStr(ho), jo = go && go.length === 2, Do = getEndPoints(Io, Ao, Oo, jo, _o, Kt.position, Eo.orientation, Ro.orientation, Kt);
  if (!Do)
    return null;
  var Lo = _slicedToArray$1(Do, 2), ko = Lo[0], Ko = ko.x, No = ko.y, Jo = Lo[1], ti = Jo.x, oi = Jo.y, Qo = ifOverflowMatches(Kt, "hidden") ? "url(#".concat(wo, ")") : void 0, Zo = _objectSpread$7(_objectSpread$7({
    clipPath: Qo
  }, filterProps(Kt, !0)), {}, {
    x1: Ko,
    y1: No,
    x2: ti,
    y2: oi
  });
  return /* @__PURE__ */ React__default.createElement(Layer, {
    className: clsx("recharts-reference-line", Co)
  }, renderLine(Po, Zo), Label.renderCallByParent(Kt, rectWithCoords({
    x1: Ko,
    y1: No,
    x2: ti,
    y2: oi
  })));
}
var ReferenceLine = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$7(this, uo), _callSuper$6(this, uo, arguments);
  }
  return _inherits$6(uo, Kt), _createClass$7(uo, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ React__default.createElement(ReferenceLineImpl, this.props);
    }
  }]);
}(React__default.Component);
_defineProperty$a(ReferenceLine, "displayName", "ReferenceLine");
_defineProperty$a(ReferenceLine, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function _extends$6() {
  return _extends$6 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$6.apply(this, arguments);
}
function _typeof$9(Kt) {
  "@babel/helpers - typeof";
  return _typeof$9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$9(Kt);
}
function ownKeys$6(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$6(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$6(Object(ho), !0).forEach(function(go) {
      _defineProperty$9(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$6(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$6(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$6(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$9(go.key), go);
  }
}
function _createClass$6(Kt, uo, ho) {
  return _defineProperties$6(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$5(Kt, uo, ho) {
  return uo = _getPrototypeOf$5(uo), _possibleConstructorReturn$5(Kt, _isNativeReflectConstruct$5() ? Reflect.construct(uo, ho || [], _getPrototypeOf$5(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$5(Kt, uo) {
  if (uo && (_typeof$9(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$5(Kt);
}
function _assertThisInitialized$5(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$5() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$5 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$5(Kt) {
  return _getPrototypeOf$5 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$5(Kt);
}
function _inherits$5(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$5(Kt, uo);
}
function _setPrototypeOf$5(Kt, uo) {
  return _setPrototypeOf$5 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$5(Kt, uo);
}
function _defineProperty$9(Kt, uo, ho) {
  return uo = _toPropertyKey$9(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$9(Kt) {
  var uo = _toPrimitive$9(Kt, "string");
  return _typeof$9(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$9(Kt, uo) {
  if (_typeof$9(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$9(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var getCoordinate = function(uo) {
  var ho = uo.x, go = uo.y, bo = uo.xAxis, vo = uo.yAxis, Po = createLabeledScales({
    x: bo.scale,
    y: vo.scale
  }), Co = Po.apply({
    x: ho,
    y: go
  }, {
    bandAware: !0
  });
  return ifOverflowMatches(uo, "discard") && !Po.isInRange(Co) ? null : Co;
}, ReferenceDot = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$6(this, uo), _callSuper$5(this, uo, arguments);
  }
  return _inherits$5(uo, Kt), _createClass$6(uo, [{
    key: "render",
    value: function() {
      var go = this.props, bo = go.x, vo = go.y, Po = go.r, Co = go.alwaysShow, So = go.clipPathId, wo = isNumOrStr(bo), Eo = isNumOrStr(vo);
      if (warn$1(Co === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !wo || !Eo)
        return null;
      var Ro = getCoordinate(this.props);
      if (!Ro)
        return null;
      var _o = Ro.x, Io = Ro.y, Ao = this.props, Oo = Ao.shape, jo = Ao.className, Do = ifOverflowMatches(this.props, "hidden") ? "url(#".concat(So, ")") : void 0, Lo = _objectSpread$6(_objectSpread$6({
        clipPath: Do
      }, filterProps(this.props, !0)), {}, {
        cx: _o,
        cy: Io
      });
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-reference-dot", jo)
      }, uo.renderDot(Oo, Lo), Label.renderCallByParent(this.props, {
        x: _o - Po,
        y: Io - Po,
        width: 2 * Po,
        height: 2 * Po
      }));
    }
  }]);
}(React__default.Component);
_defineProperty$9(ReferenceDot, "displayName", "ReferenceDot");
_defineProperty$9(ReferenceDot, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
_defineProperty$9(ReferenceDot, "renderDot", function(Kt, uo) {
  var ho;
  return /* @__PURE__ */ React__default.isValidElement(Kt) ? ho = /* @__PURE__ */ React__default.cloneElement(Kt, uo) : isFunction$3(Kt) ? ho = Kt(uo) : ho = /* @__PURE__ */ React__default.createElement(Dot, _extends$6({}, uo, {
    cx: uo.cx,
    cy: uo.cy,
    className: "recharts-reference-dot-dot"
  })), ho;
});
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$5.apply(this, arguments);
}
function _typeof$8(Kt) {
  "@babel/helpers - typeof";
  return _typeof$8 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$8(Kt);
}
function ownKeys$5(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$5(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$5(Object(ho), !0).forEach(function(go) {
      _defineProperty$8(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$5(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _classCallCheck$5(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$5(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$8(go.key), go);
  }
}
function _createClass$5(Kt, uo, ho) {
  return _defineProperties$5(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$4(Kt, uo, ho) {
  return uo = _getPrototypeOf$4(uo), _possibleConstructorReturn$4(Kt, _isNativeReflectConstruct$4() ? Reflect.construct(uo, ho || [], _getPrototypeOf$4(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$4(Kt, uo) {
  if (uo && (_typeof$8(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$4(Kt);
}
function _assertThisInitialized$4(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$4() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$4 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$4(Kt) {
  return _getPrototypeOf$4 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$4(Kt);
}
function _inherits$4(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$4(Kt, uo);
}
function _setPrototypeOf$4(Kt, uo) {
  return _setPrototypeOf$4 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$4(Kt, uo);
}
function _defineProperty$8(Kt, uo, ho) {
  return uo = _toPropertyKey$8(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$8(Kt) {
  var uo = _toPrimitive$8(Kt, "string");
  return _typeof$8(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$8(Kt, uo) {
  if (_typeof$8(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$8(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var getRect = function(uo, ho, go, bo, vo) {
  var Po = vo.x1, Co = vo.x2, So = vo.y1, wo = vo.y2, Eo = vo.xAxis, Ro = vo.yAxis;
  if (!Eo || !Ro) return null;
  var _o = createLabeledScales({
    x: Eo.scale,
    y: Ro.scale
  }), Io = {
    x: uo ? _o.x.apply(Po, {
      position: "start"
    }) : _o.x.rangeMin,
    y: go ? _o.y.apply(So, {
      position: "start"
    }) : _o.y.rangeMin
  }, Ao = {
    x: ho ? _o.x.apply(Co, {
      position: "end"
    }) : _o.x.rangeMax,
    y: bo ? _o.y.apply(wo, {
      position: "end"
    }) : _o.y.rangeMax
  };
  return ifOverflowMatches(vo, "discard") && (!_o.isInRange(Io) || !_o.isInRange(Ao)) ? null : rectWithPoints(Io, Ao);
}, ReferenceArea = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$5(this, uo), _callSuper$4(this, uo, arguments);
  }
  return _inherits$4(uo, Kt), _createClass$5(uo, [{
    key: "render",
    value: function() {
      var go = this.props, bo = go.x1, vo = go.x2, Po = go.y1, Co = go.y2, So = go.className, wo = go.alwaysShow, Eo = go.clipPathId;
      warn$1(wo === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var Ro = isNumOrStr(bo), _o = isNumOrStr(vo), Io = isNumOrStr(Po), Ao = isNumOrStr(Co), Oo = this.props.shape;
      if (!Ro && !_o && !Io && !Ao && !Oo)
        return null;
      var jo = getRect(Ro, _o, Io, Ao, this.props);
      if (!jo && !Oo)
        return null;
      var Do = ifOverflowMatches(this.props, "hidden") ? "url(#".concat(Eo, ")") : void 0;
      return /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-reference-area", So)
      }, uo.renderRect(Oo, _objectSpread$5(_objectSpread$5({
        clipPath: Do
      }, filterProps(this.props, !0)), jo)), Label.renderCallByParent(this.props, jo));
    }
  }]);
}(React__default.Component);
_defineProperty$8(ReferenceArea, "displayName", "ReferenceArea");
_defineProperty$8(ReferenceArea, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
_defineProperty$8(ReferenceArea, "renderRect", function(Kt, uo) {
  var ho;
  return /* @__PURE__ */ React__default.isValidElement(Kt) ? ho = /* @__PURE__ */ React__default.cloneElement(Kt, uo) : isFunction$3(Kt) ? ho = Kt(uo) : ho = /* @__PURE__ */ React__default.createElement(Rectangle, _extends$5({}, uo, {
    className: "recharts-reference-area-rect"
  })), ho;
});
function getEveryNthWithCondition(Kt, uo, ho) {
  if (uo < 1)
    return [];
  if (uo === 1 && ho === void 0)
    return Kt;
  for (var go = [], bo = 0; bo < Kt.length; bo += uo)
    go.push(Kt[bo]);
  return go;
}
function getAngledTickWidth(Kt, uo, ho) {
  var go = {
    width: Kt.width + uo.width,
    height: Kt.height + uo.height
  };
  return getAngledRectangleWidth(go, ho);
}
function getTickBoundaries(Kt, uo, ho) {
  var go = ho === "width", bo = Kt.x, vo = Kt.y, Po = Kt.width, Co = Kt.height;
  return uo === 1 ? {
    start: go ? bo : vo,
    end: go ? bo + Po : vo + Co
  } : {
    start: go ? bo + Po : vo + Co,
    end: go ? bo : vo
  };
}
function isVisible(Kt, uo, ho, go, bo) {
  if (Kt * uo < Kt * go || Kt * uo > Kt * bo)
    return !1;
  var vo = ho();
  return Kt * (uo - Kt * vo / 2 - go) >= 0 && Kt * (uo + Kt * vo / 2 - bo) <= 0;
}
function getNumberIntervalTicks(Kt, uo) {
  return getEveryNthWithCondition(Kt, uo + 1);
}
function getEquidistantTicks(Kt, uo, ho, go, bo) {
  for (var vo = (go || []).slice(), Po = uo.start, Co = uo.end, So = 0, wo = 1, Eo = Po, Ro = function() {
    var Ao = go == null ? void 0 : go[So];
    if (Ao === void 0)
      return {
        v: getEveryNthWithCondition(go, wo)
      };
    var Oo = So, jo, Do = function() {
      return jo === void 0 && (jo = ho(Ao, Oo)), jo;
    }, Lo = Ao.coordinate, ko = So === 0 || isVisible(Kt, Lo, Do, Eo, Co);
    ko || (So = 0, Eo = Po, wo += 1), ko && (Eo = Lo + Kt * (Do() / 2 + bo), So += wo);
  }, _o; wo <= vo.length; )
    if (_o = Ro(), _o) return _o.v;
  return [];
}
function _typeof$7(Kt) {
  "@babel/helpers - typeof";
  return _typeof$7 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$7(Kt);
}
function ownKeys$4(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$4(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$4(Object(ho), !0).forEach(function(go) {
      _defineProperty$7(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$4(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$7(Kt, uo, ho) {
  return uo = _toPropertyKey$7(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$7(Kt) {
  var uo = _toPrimitive$7(Kt, "string");
  return _typeof$7(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$7(Kt, uo) {
  if (_typeof$7(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$7(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function getTicksEnd(Kt, uo, ho, go, bo) {
  for (var vo = (go || []).slice(), Po = vo.length, Co = uo.start, So = uo.end, wo = function(_o) {
    var Io = vo[_o], Ao, Oo = function() {
      return Ao === void 0 && (Ao = ho(Io, _o)), Ao;
    };
    if (_o === Po - 1) {
      var jo = Kt * (Io.coordinate + Kt * Oo() / 2 - So);
      vo[_o] = Io = _objectSpread$4(_objectSpread$4({}, Io), {}, {
        tickCoord: jo > 0 ? Io.coordinate - jo * Kt : Io.coordinate
      });
    } else
      vo[_o] = Io = _objectSpread$4(_objectSpread$4({}, Io), {}, {
        tickCoord: Io.coordinate
      });
    var Do = isVisible(Kt, Io.tickCoord, Oo, Co, So);
    Do && (So = Io.tickCoord - Kt * (Oo() / 2 + bo), vo[_o] = _objectSpread$4(_objectSpread$4({}, Io), {}, {
      isShow: !0
    }));
  }, Eo = Po - 1; Eo >= 0; Eo--)
    wo(Eo);
  return vo;
}
function getTicksStart(Kt, uo, ho, go, bo, vo) {
  var Po = (go || []).slice(), Co = Po.length, So = uo.start, wo = uo.end;
  if (vo) {
    var Eo = go[Co - 1], Ro = ho(Eo, Co - 1), _o = Kt * (Eo.coordinate + Kt * Ro / 2 - wo);
    Po[Co - 1] = Eo = _objectSpread$4(_objectSpread$4({}, Eo), {}, {
      tickCoord: _o > 0 ? Eo.coordinate - _o * Kt : Eo.coordinate
    });
    var Io = isVisible(Kt, Eo.tickCoord, function() {
      return Ro;
    }, So, wo);
    Io && (wo = Eo.tickCoord - Kt * (Ro / 2 + bo), Po[Co - 1] = _objectSpread$4(_objectSpread$4({}, Eo), {}, {
      isShow: !0
    }));
  }
  for (var Ao = vo ? Co - 1 : Co, Oo = function(Lo) {
    var ko = Po[Lo], Ko, No = function() {
      return Ko === void 0 && (Ko = ho(ko, Lo)), Ko;
    };
    if (Lo === 0) {
      var Jo = Kt * (ko.coordinate - Kt * No() / 2 - So);
      Po[Lo] = ko = _objectSpread$4(_objectSpread$4({}, ko), {}, {
        tickCoord: Jo < 0 ? ko.coordinate - Jo * Kt : ko.coordinate
      });
    } else
      Po[Lo] = ko = _objectSpread$4(_objectSpread$4({}, ko), {}, {
        tickCoord: ko.coordinate
      });
    var ti = isVisible(Kt, ko.tickCoord, No, So, wo);
    ti && (So = ko.tickCoord + Kt * (No() / 2 + bo), Po[Lo] = _objectSpread$4(_objectSpread$4({}, ko), {}, {
      isShow: !0
    }));
  }, jo = 0; jo < Ao; jo++)
    Oo(jo);
  return Po;
}
function getTicks(Kt, uo, ho) {
  var go = Kt.tick, bo = Kt.ticks, vo = Kt.viewBox, Po = Kt.minTickGap, Co = Kt.orientation, So = Kt.interval, wo = Kt.tickFormatter, Eo = Kt.unit, Ro = Kt.angle;
  if (!bo || !bo.length || !go)
    return [];
  if (isNumber(So) || Global.isSsr)
    return getNumberIntervalTicks(bo, typeof So == "number" && isNumber(So) ? So : 0);
  var _o = [], Io = Co === "top" || Co === "bottom" ? "width" : "height", Ao = Eo && Io === "width" ? getStringSize(Eo, {
    fontSize: uo,
    letterSpacing: ho
  }) : {
    width: 0,
    height: 0
  }, Oo = function(ko, Ko) {
    var No = isFunction$3(wo) ? wo(ko.value, Ko) : ko.value;
    return Io === "width" ? getAngledTickWidth(getStringSize(No, {
      fontSize: uo,
      letterSpacing: ho
    }), Ao, Ro) : getStringSize(No, {
      fontSize: uo,
      letterSpacing: ho
    })[Io];
  }, jo = bo.length >= 2 ? mathSign(bo[1].coordinate - bo[0].coordinate) : 1, Do = getTickBoundaries(vo, jo, Io);
  return So === "equidistantPreserveStart" ? getEquidistantTicks(jo, Do, Oo, bo, Po) : (So === "preserveStart" || So === "preserveStartEnd" ? _o = getTicksStart(jo, Do, Oo, bo, Po, So === "preserveStartEnd") : _o = getTicksEnd(jo, Do, Oo, bo, Po), _o.filter(function(Lo) {
    return Lo.isShow;
  }));
}
var _excluded$2 = ["viewBox"], _excluded2$2 = ["viewBox"], _excluded3 = ["ticks"];
function _typeof$6(Kt) {
  "@babel/helpers - typeof";
  return _typeof$6 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$6(Kt);
}
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$4.apply(this, arguments);
}
function ownKeys$3(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$3(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$3(Object(ho), !0).forEach(function(go) {
      _defineProperty$6(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$3(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _objectWithoutProperties$2(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$2(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$2(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function _classCallCheck$4(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$4(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$6(go.key), go);
  }
}
function _createClass$4(Kt, uo, ho) {
  return _defineProperties$4(Kt.prototype, uo), _defineProperties$4(Kt, ho), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$3(Kt, uo, ho) {
  return uo = _getPrototypeOf$3(uo), _possibleConstructorReturn$3(Kt, _isNativeReflectConstruct$3() ? Reflect.construct(uo, ho, _getPrototypeOf$3(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$3(Kt, uo) {
  if (uo && (_typeof$6(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$3(Kt);
}
function _assertThisInitialized$3(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$3() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$3 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$3(Kt) {
  return _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$3(Kt);
}
function _inherits$3(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$3(Kt, uo);
}
function _setPrototypeOf$3(Kt, uo) {
  return _setPrototypeOf$3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$3(Kt, uo);
}
function _defineProperty$6(Kt, uo, ho) {
  return uo = _toPropertyKey$6(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$6(Kt) {
  var uo = _toPrimitive$6(Kt, "string");
  return _typeof$6(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$6(Kt, uo) {
  if (_typeof$6(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$6(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var CartesianAxis = /* @__PURE__ */ function(Kt) {
  function uo(ho) {
    var go;
    return _classCallCheck$4(this, uo), go = _callSuper$3(this, uo, [ho]), go.state = {
      fontSize: "",
      letterSpacing: ""
    }, go;
  }
  return _inherits$3(uo, Kt), _createClass$4(uo, [{
    key: "shouldComponentUpdate",
    value: function(go, bo) {
      var vo = go.viewBox, Po = _objectWithoutProperties$2(go, _excluded$2), Co = this.props, So = Co.viewBox, wo = _objectWithoutProperties$2(Co, _excluded2$2);
      return !shallowEqual(vo, So) || !shallowEqual(Po, wo) || !shallowEqual(bo, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var go = this.layerReference;
      if (go) {
        var bo = go.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        bo && this.setState({
          fontSize: window.getComputedStyle(bo).fontSize,
          letterSpacing: window.getComputedStyle(bo).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(go) {
      var bo = this.props, vo = bo.x, Po = bo.y, Co = bo.width, So = bo.height, wo = bo.orientation, Eo = bo.tickSize, Ro = bo.mirror, _o = bo.tickMargin, Io, Ao, Oo, jo, Do, Lo, ko = Ro ? -1 : 1, Ko = go.tickSize || Eo, No = isNumber(go.tickCoord) ? go.tickCoord : go.coordinate;
      switch (wo) {
        case "top":
          Io = Ao = go.coordinate, jo = Po + +!Ro * So, Oo = jo - ko * Ko, Lo = Oo - ko * _o, Do = No;
          break;
        case "left":
          Oo = jo = go.coordinate, Ao = vo + +!Ro * Co, Io = Ao - ko * Ko, Do = Io - ko * _o, Lo = No;
          break;
        case "right":
          Oo = jo = go.coordinate, Ao = vo + +Ro * Co, Io = Ao + ko * Ko, Do = Io + ko * _o, Lo = No;
          break;
        default:
          Io = Ao = go.coordinate, jo = Po + +Ro * So, Oo = jo + ko * Ko, Lo = Oo + ko * _o, Do = No;
          break;
      }
      return {
        line: {
          x1: Io,
          y1: Oo,
          x2: Ao,
          y2: jo
        },
        tick: {
          x: Do,
          y: Lo
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var go = this.props, bo = go.orientation, vo = go.mirror, Po;
      switch (bo) {
        case "left":
          Po = vo ? "start" : "end";
          break;
        case "right":
          Po = vo ? "end" : "start";
          break;
        default:
          Po = "middle";
          break;
      }
      return Po;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var go = this.props, bo = go.orientation, vo = go.mirror, Po = "end";
      switch (bo) {
        case "left":
        case "right":
          Po = "middle";
          break;
        case "top":
          Po = vo ? "start" : "end";
          break;
        default:
          Po = vo ? "end" : "start";
          break;
      }
      return Po;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var go = this.props, bo = go.x, vo = go.y, Po = go.width, Co = go.height, So = go.orientation, wo = go.mirror, Eo = go.axisLine, Ro = _objectSpread$3(_objectSpread$3(_objectSpread$3({}, filterProps(this.props, !1)), filterProps(Eo, !1)), {}, {
        fill: "none"
      });
      if (So === "top" || So === "bottom") {
        var _o = +(So === "top" && !wo || So === "bottom" && wo);
        Ro = _objectSpread$3(_objectSpread$3({}, Ro), {}, {
          x1: bo,
          y1: vo + _o * Co,
          x2: bo + Po,
          y2: vo + _o * Co
        });
      } else {
        var Io = +(So === "left" && !wo || So === "right" && wo);
        Ro = _objectSpread$3(_objectSpread$3({}, Ro), {}, {
          x1: bo + Io * Po,
          y1: vo,
          x2: bo + Io * Po,
          y2: vo + Co
        });
      }
      return /* @__PURE__ */ React__default.createElement("line", _extends$4({}, Ro, {
        className: clsx("recharts-cartesian-axis-line", get$2(Eo, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(go, bo, vo) {
        var Po = this, Co = this.props, So = Co.tickLine, wo = Co.stroke, Eo = Co.tick, Ro = Co.tickFormatter, _o = Co.unit, Io = getTicks(_objectSpread$3(_objectSpread$3({}, this.props), {}, {
          ticks: go
        }), bo, vo), Ao = this.getTickTextAnchor(), Oo = this.getTickVerticalAnchor(), jo = filterProps(this.props, !1), Do = filterProps(Eo, !1), Lo = _objectSpread$3(_objectSpread$3({}, jo), {}, {
          fill: "none"
        }, filterProps(So, !1)), ko = Io.map(function(Ko, No) {
          var Jo = Po.getTickLineCoord(Ko), ti = Jo.line, oi = Jo.tick, Qo = _objectSpread$3(_objectSpread$3(_objectSpread$3(_objectSpread$3({
            textAnchor: Ao,
            verticalAnchor: Oo
          }, jo), {}, {
            stroke: "none",
            fill: wo
          }, Do), oi), {}, {
            index: No,
            payload: Ko,
            visibleTicksCount: Io.length,
            tickFormatter: Ro
          });
          return /* @__PURE__ */ React__default.createElement(Layer, _extends$4({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(Ko.value, "-").concat(Ko.coordinate, "-").concat(Ko.tickCoord)
          }, adaptEventsOfChild(Po.props, Ko, No)), So && /* @__PURE__ */ React__default.createElement("line", _extends$4({}, Lo, ti, {
            className: clsx("recharts-cartesian-axis-tick-line", get$2(So, "className"))
          })), Eo && uo.renderTickItem(Eo, Qo, "".concat(isFunction$3(Ro) ? Ro(Ko.value, No) : Ko.value).concat(_o || "")));
        });
        return /* @__PURE__ */ React__default.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, ko);
      }
    )
  }, {
    key: "render",
    value: function() {
      var go = this, bo = this.props, vo = bo.axisLine, Po = bo.width, Co = bo.height, So = bo.ticksGenerator, wo = bo.className, Eo = bo.hide;
      if (Eo)
        return null;
      var Ro = this.props, _o = Ro.ticks, Io = _objectWithoutProperties$2(Ro, _excluded3), Ao = _o;
      return isFunction$3(So) && (Ao = _o && _o.length > 0 ? So(this.props) : So(Io)), Po <= 0 || Co <= 0 || !Ao || !Ao.length ? null : /* @__PURE__ */ React__default.createElement(Layer, {
        className: clsx("recharts-cartesian-axis", wo),
        ref: function(jo) {
          go.layerReference = jo;
        }
      }, vo && this.renderAxisLine(), this.renderTicks(Ao, this.state.fontSize, this.state.letterSpacing), Label.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(go, bo, vo) {
      var Po;
      return /* @__PURE__ */ React__default.isValidElement(go) ? Po = /* @__PURE__ */ React__default.cloneElement(go, bo) : isFunction$3(go) ? Po = go(bo) : Po = /* @__PURE__ */ React__default.createElement(Text, _extends$4({}, bo, {
        className: "recharts-cartesian-axis-tick-value"
      }), vo), Po;
    }
  }]);
}(Component);
_defineProperty$6(CartesianAxis, "displayName", "CartesianAxis");
_defineProperty$6(CartesianAxis, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var _excluded$1 = ["x1", "y1", "x2", "y2", "key"], _excluded2$1 = ["offset"];
function _typeof$5(Kt) {
  "@babel/helpers - typeof";
  return _typeof$5 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$5(Kt);
}
function ownKeys$2(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$2(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$2(Object(ho), !0).forEach(function(go) {
      _defineProperty$5(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$2(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$5(Kt, uo, ho) {
  return uo = _toPropertyKey$5(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$5(Kt) {
  var uo = _toPrimitive$5(Kt, "string");
  return _typeof$5(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$5(Kt, uo) {
  if (_typeof$5(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$5(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$3.apply(this, arguments);
}
function _objectWithoutProperties$1(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose$1(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose$1(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
var Background = function(uo) {
  var ho = uo.fill;
  if (!ho || ho === "none")
    return null;
  var go = uo.fillOpacity, bo = uo.x, vo = uo.y, Po = uo.width, Co = uo.height, So = uo.ry;
  return /* @__PURE__ */ React__default.createElement("rect", {
    x: bo,
    y: vo,
    ry: So,
    width: Po,
    height: Co,
    stroke: "none",
    fill: ho,
    fillOpacity: go,
    className: "recharts-cartesian-grid-bg"
  });
};
function renderLineItem(Kt, uo) {
  var ho;
  if (/* @__PURE__ */ React__default.isValidElement(Kt))
    ho = /* @__PURE__ */ React__default.cloneElement(Kt, uo);
  else if (isFunction$3(Kt))
    ho = Kt(uo);
  else {
    var go = uo.x1, bo = uo.y1, vo = uo.x2, Po = uo.y2, Co = uo.key, So = _objectWithoutProperties$1(uo, _excluded$1), wo = filterProps(So, !1);
    wo.offset;
    var Eo = _objectWithoutProperties$1(wo, _excluded2$1);
    ho = /* @__PURE__ */ React__default.createElement("line", _extends$3({}, Eo, {
      x1: go,
      y1: bo,
      x2: vo,
      y2: Po,
      fill: "none",
      key: Co
    }));
  }
  return ho;
}
function HorizontalGridLines(Kt) {
  var uo = Kt.x, ho = Kt.width, go = Kt.horizontal, bo = go === void 0 ? !0 : go, vo = Kt.horizontalPoints;
  if (!bo || !vo || !vo.length)
    return null;
  var Po = vo.map(function(Co, So) {
    var wo = _objectSpread$2(_objectSpread$2({}, Kt), {}, {
      x1: uo,
      y1: Co,
      x2: uo + ho,
      y2: Co,
      key: "line-".concat(So),
      index: So
    });
    return renderLineItem(bo, wo);
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, Po);
}
function VerticalGridLines(Kt) {
  var uo = Kt.y, ho = Kt.height, go = Kt.vertical, bo = go === void 0 ? !0 : go, vo = Kt.verticalPoints;
  if (!bo || !vo || !vo.length)
    return null;
  var Po = vo.map(function(Co, So) {
    var wo = _objectSpread$2(_objectSpread$2({}, Kt), {}, {
      x1: Co,
      y1: uo,
      x2: Co,
      y2: uo + ho,
      key: "line-".concat(So),
      index: So
    });
    return renderLineItem(bo, wo);
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, Po);
}
function HorizontalStripes(Kt) {
  var uo = Kt.horizontalFill, ho = Kt.fillOpacity, go = Kt.x, bo = Kt.y, vo = Kt.width, Po = Kt.height, Co = Kt.horizontalPoints, So = Kt.horizontal, wo = So === void 0 ? !0 : So;
  if (!wo || !uo || !uo.length)
    return null;
  var Eo = Co.map(function(_o) {
    return Math.round(_o + bo - bo);
  }).sort(function(_o, Io) {
    return _o - Io;
  });
  bo !== Eo[0] && Eo.unshift(0);
  var Ro = Eo.map(function(_o, Io) {
    var Ao = !Eo[Io + 1], Oo = Ao ? bo + Po - _o : Eo[Io + 1] - _o;
    if (Oo <= 0)
      return null;
    var jo = Io % uo.length;
    return /* @__PURE__ */ React__default.createElement("rect", {
      key: "react-".concat(Io),
      y: _o,
      x: go,
      height: Oo,
      width: vo,
      stroke: "none",
      fill: uo[jo],
      fillOpacity: ho,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, Ro);
}
function VerticalStripes(Kt) {
  var uo = Kt.vertical, ho = uo === void 0 ? !0 : uo, go = Kt.verticalFill, bo = Kt.fillOpacity, vo = Kt.x, Po = Kt.y, Co = Kt.width, So = Kt.height, wo = Kt.verticalPoints;
  if (!ho || !go || !go.length)
    return null;
  var Eo = wo.map(function(_o) {
    return Math.round(_o + vo - vo);
  }).sort(function(_o, Io) {
    return _o - Io;
  });
  vo !== Eo[0] && Eo.unshift(0);
  var Ro = Eo.map(function(_o, Io) {
    var Ao = !Eo[Io + 1], Oo = Ao ? vo + Co - _o : Eo[Io + 1] - _o;
    if (Oo <= 0)
      return null;
    var jo = Io % go.length;
    return /* @__PURE__ */ React__default.createElement("rect", {
      key: "react-".concat(Io),
      x: _o,
      y: Po,
      width: Oo,
      height: So,
      stroke: "none",
      fill: go[jo],
      fillOpacity: bo,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, Ro);
}
var defaultVerticalCoordinatesGenerator = function(uo, ho) {
  var go = uo.xAxis, bo = uo.width, vo = uo.height, Po = uo.offset;
  return getCoordinatesOfGrid(getTicks(_objectSpread$2(_objectSpread$2(_objectSpread$2({}, CartesianAxis.defaultProps), go), {}, {
    ticks: getTicksOfAxis(go, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: bo,
      height: vo
    }
  })), Po.left, Po.left + Po.width, ho);
}, defaultHorizontalCoordinatesGenerator = function(uo, ho) {
  var go = uo.yAxis, bo = uo.width, vo = uo.height, Po = uo.offset;
  return getCoordinatesOfGrid(getTicks(_objectSpread$2(_objectSpread$2(_objectSpread$2({}, CartesianAxis.defaultProps), go), {}, {
    ticks: getTicksOfAxis(go, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: bo,
      height: vo
    }
  })), Po.top, Po.top + Po.height, ho);
}, defaultProps = {
  horizontal: !0,
  vertical: !0,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function CartesianGrid(Kt) {
  var uo, ho, go, bo, vo, Po, Co = useChartWidth(), So = useChartHeight(), wo = useOffset(), Eo = _objectSpread$2(_objectSpread$2({}, Kt), {}, {
    stroke: (uo = Kt.stroke) !== null && uo !== void 0 ? uo : defaultProps.stroke,
    fill: (ho = Kt.fill) !== null && ho !== void 0 ? ho : defaultProps.fill,
    horizontal: (go = Kt.horizontal) !== null && go !== void 0 ? go : defaultProps.horizontal,
    horizontalFill: (bo = Kt.horizontalFill) !== null && bo !== void 0 ? bo : defaultProps.horizontalFill,
    vertical: (vo = Kt.vertical) !== null && vo !== void 0 ? vo : defaultProps.vertical,
    verticalFill: (Po = Kt.verticalFill) !== null && Po !== void 0 ? Po : defaultProps.verticalFill,
    x: isNumber(Kt.x) ? Kt.x : wo.left,
    y: isNumber(Kt.y) ? Kt.y : wo.top,
    width: isNumber(Kt.width) ? Kt.width : wo.width,
    height: isNumber(Kt.height) ? Kt.height : wo.height
  }), Ro = Eo.x, _o = Eo.y, Io = Eo.width, Ao = Eo.height, Oo = Eo.syncWithTicks, jo = Eo.horizontalValues, Do = Eo.verticalValues, Lo = useArbitraryXAxis(), ko = useYAxisWithFiniteDomainOrRandom();
  if (!isNumber(Io) || Io <= 0 || !isNumber(Ao) || Ao <= 0 || !isNumber(Ro) || Ro !== +Ro || !isNumber(_o) || _o !== +_o)
    return null;
  var Ko = Eo.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator, No = Eo.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator, Jo = Eo.horizontalPoints, ti = Eo.verticalPoints;
  if ((!Jo || !Jo.length) && isFunction$3(No)) {
    var oi = jo && jo.length, Qo = No({
      yAxis: ko ? _objectSpread$2(_objectSpread$2({}, ko), {}, {
        ticks: oi ? jo : ko.ticks
      }) : void 0,
      width: Co,
      height: So,
      offset: wo
    }, oi ? !0 : Oo);
    warn$1(Array.isArray(Qo), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof$5(Qo), "]")), Array.isArray(Qo) && (Jo = Qo);
  }
  if ((!ti || !ti.length) && isFunction$3(Ko)) {
    var Zo = Do && Do.length, ei = Ko({
      xAxis: Lo ? _objectSpread$2(_objectSpread$2({}, Lo), {}, {
        ticks: Zo ? Do : Lo.ticks
      }) : void 0,
      width: Co,
      height: So,
      offset: wo
    }, Zo ? !0 : Oo);
    warn$1(Array.isArray(ei), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(_typeof$5(ei), "]")), Array.isArray(ei) && (ti = ei);
  }
  return /* @__PURE__ */ React__default.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ React__default.createElement(Background, {
    fill: Eo.fill,
    fillOpacity: Eo.fillOpacity,
    x: Eo.x,
    y: Eo.y,
    width: Eo.width,
    height: Eo.height,
    ry: Eo.ry
  }), /* @__PURE__ */ React__default.createElement(HorizontalGridLines, _extends$3({}, Eo, {
    offset: wo,
    horizontalPoints: Jo,
    xAxis: Lo,
    yAxis: ko
  })), /* @__PURE__ */ React__default.createElement(VerticalGridLines, _extends$3({}, Eo, {
    offset: wo,
    verticalPoints: ti,
    xAxis: Lo,
    yAxis: ko
  })), /* @__PURE__ */ React__default.createElement(HorizontalStripes, _extends$3({}, Eo, {
    horizontalPoints: Jo
  })), /* @__PURE__ */ React__default.createElement(VerticalStripes, _extends$3({}, Eo, {
    verticalPoints: ti
  })));
}
CartesianGrid.displayName = "CartesianGrid";
function _typeof$4(Kt) {
  "@babel/helpers - typeof";
  return _typeof$4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$4(Kt);
}
function _classCallCheck$3(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$3(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$4(go.key), go);
  }
}
function _createClass$3(Kt, uo, ho) {
  return _defineProperties$3(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$2(Kt, uo, ho) {
  return uo = _getPrototypeOf$2(uo), _possibleConstructorReturn$2(Kt, _isNativeReflectConstruct$2() ? Reflect.construct(uo, ho || [], _getPrototypeOf$2(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$2(Kt, uo) {
  if (uo && (_typeof$4(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(Kt);
}
function _assertThisInitialized$2(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$2() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$2 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$2(Kt) {
  return _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$2(Kt);
}
function _inherits$2(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$2(Kt, uo);
}
function _setPrototypeOf$2(Kt, uo) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$2(Kt, uo);
}
function _defineProperty$4(Kt, uo, ho) {
  return uo = _toPropertyKey$4(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$4(Kt) {
  var uo = _toPrimitive$4(Kt, "string");
  return _typeof$4(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$4(Kt, uo) {
  if (_typeof$4(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$4(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$2.apply(this, arguments);
}
function XAxisImpl(Kt) {
  var uo = Kt.xAxisId, ho = useChartWidth(), go = useChartHeight(), bo = useXAxisOrThrow(uo);
  return bo == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ React__default.createElement(CartesianAxis, _extends$2({}, bo, {
      className: clsx("recharts-".concat(bo.axisType, " ").concat(bo.axisType), bo.className),
      viewBox: {
        x: 0,
        y: 0,
        width: ho,
        height: go
      },
      ticksGenerator: function(Po) {
        return getTicksOfAxis(Po, !0);
      }
    }))
  );
}
var XAxis = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$3(this, uo), _callSuper$2(this, uo, arguments);
  }
  return _inherits$2(uo, Kt), _createClass$3(uo, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ React__default.createElement(XAxisImpl, this.props);
    }
  }]);
}(React__default.Component);
_defineProperty$4(XAxis, "displayName", "XAxis");
_defineProperty$4(XAxis, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function _typeof$3(Kt) {
  "@babel/helpers - typeof";
  return _typeof$3 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$3(Kt);
}
function _classCallCheck$2(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$2(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$3(go.key), go);
  }
}
function _createClass$2(Kt, uo, ho) {
  return _defineProperties$2(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper$1(Kt, uo, ho) {
  return uo = _getPrototypeOf$1(uo), _possibleConstructorReturn$1(Kt, _isNativeReflectConstruct$1() ? Reflect.construct(uo, ho || [], _getPrototypeOf$1(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn$1(Kt, uo) {
  if (uo && (_typeof$3(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$1(Kt);
}
function _assertThisInitialized$1(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct$1() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct$1 = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf$1(Kt) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf$1(Kt);
}
function _inherits$1(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf$1(Kt, uo);
}
function _setPrototypeOf$1(Kt, uo) {
  return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf$1(Kt, uo);
}
function _defineProperty$3(Kt, uo, ho) {
  return uo = _toPropertyKey$3(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$3(Kt) {
  var uo = _toPrimitive$3(Kt, "string");
  return _typeof$3(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$3(Kt, uo) {
  if (_typeof$3(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$3(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends$1.apply(this, arguments);
}
var YAxisImpl = function(uo) {
  var ho = uo.yAxisId, go = useChartWidth(), bo = useChartHeight(), vo = useYAxisOrThrow(ho);
  return vo == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ React__default.createElement(CartesianAxis, _extends$1({}, vo, {
      className: clsx("recharts-".concat(vo.axisType, " ").concat(vo.axisType), vo.className),
      viewBox: {
        x: 0,
        y: 0,
        width: go,
        height: bo
      },
      ticksGenerator: function(Co) {
        return getTicksOfAxis(Co, !0);
      }
    }))
  );
}, YAxis = /* @__PURE__ */ function(Kt) {
  function uo() {
    return _classCallCheck$2(this, uo), _callSuper$1(this, uo, arguments);
  }
  return _inherits$1(uo, Kt), _createClass$2(uo, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ React__default.createElement(YAxisImpl, this.props);
    }
  }]);
}(React__default.Component);
_defineProperty$3(YAxis, "displayName", "YAxis");
_defineProperty$3(YAxis, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function _toConsumableArray$1(Kt) {
  return _arrayWithoutHoles$1(Kt) || _iterableToArray$1(Kt) || _unsupportedIterableToArray$1(Kt) || _nonIterableSpread$1();
}
function _nonIterableSpread$1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray$1(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray$1(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray$1(Kt, uo);
  }
}
function _iterableToArray$1(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles$1(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray$1(Kt);
}
function _arrayLikeToArray$1(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
var detectReferenceElementsDomain = function(uo, ho, go, bo, vo) {
  var Po = findAllByType(uo, ReferenceLine), Co = findAllByType(uo, ReferenceDot), So = [].concat(_toConsumableArray$1(Po), _toConsumableArray$1(Co)), wo = findAllByType(uo, ReferenceArea), Eo = "".concat(bo, "Id"), Ro = bo[0], _o = ho;
  if (So.length && (_o = So.reduce(function(Oo, jo) {
    if (jo.props[Eo] === go && ifOverflowMatches(jo.props, "extendDomain") && isNumber(jo.props[Ro])) {
      var Do = jo.props[Ro];
      return [Math.min(Oo[0], Do), Math.max(Oo[1], Do)];
    }
    return Oo;
  }, _o)), wo.length) {
    var Io = "".concat(Ro, "1"), Ao = "".concat(Ro, "2");
    _o = wo.reduce(function(Oo, jo) {
      if (jo.props[Eo] === go && ifOverflowMatches(jo.props, "extendDomain") && isNumber(jo.props[Io]) && isNumber(jo.props[Ao])) {
        var Do = jo.props[Io], Lo = jo.props[Ao];
        return [Math.min(Oo[0], Do, Lo), Math.max(Oo[1], Do, Lo)];
      }
      return Oo;
    }, _o);
  }
  return vo && vo.length && (_o = vo.reduce(function(Oo, jo) {
    return isNumber(jo) ? [Math.min(Oo[0], jo), Math.max(Oo[1], jo)] : Oo;
  }, _o)), _o;
}, eventemitter3 = { exports: {} };
(function(Kt) {
  var uo = Object.prototype.hasOwnProperty, ho = "~";
  function go() {
  }
  Object.create && (go.prototype = /* @__PURE__ */ Object.create(null), new go().__proto__ || (ho = !1));
  function bo(So, wo, Eo) {
    this.fn = So, this.context = wo, this.once = Eo || !1;
  }
  function vo(So, wo, Eo, Ro, _o) {
    if (typeof Eo != "function")
      throw new TypeError("The listener must be a function");
    var Io = new bo(Eo, Ro || So, _o), Ao = ho ? ho + wo : wo;
    return So._events[Ao] ? So._events[Ao].fn ? So._events[Ao] = [So._events[Ao], Io] : So._events[Ao].push(Io) : (So._events[Ao] = Io, So._eventsCount++), So;
  }
  function Po(So, wo) {
    --So._eventsCount === 0 ? So._events = new go() : delete So._events[wo];
  }
  function Co() {
    this._events = new go(), this._eventsCount = 0;
  }
  Co.prototype.eventNames = function() {
    var wo = [], Eo, Ro;
    if (this._eventsCount === 0) return wo;
    for (Ro in Eo = this._events)
      uo.call(Eo, Ro) && wo.push(ho ? Ro.slice(1) : Ro);
    return Object.getOwnPropertySymbols ? wo.concat(Object.getOwnPropertySymbols(Eo)) : wo;
  }, Co.prototype.listeners = function(wo) {
    var Eo = ho ? ho + wo : wo, Ro = this._events[Eo];
    if (!Ro) return [];
    if (Ro.fn) return [Ro.fn];
    for (var _o = 0, Io = Ro.length, Ao = new Array(Io); _o < Io; _o++)
      Ao[_o] = Ro[_o].fn;
    return Ao;
  }, Co.prototype.listenerCount = function(wo) {
    var Eo = ho ? ho + wo : wo, Ro = this._events[Eo];
    return Ro ? Ro.fn ? 1 : Ro.length : 0;
  }, Co.prototype.emit = function(wo, Eo, Ro, _o, Io, Ao) {
    var Oo = ho ? ho + wo : wo;
    if (!this._events[Oo]) return !1;
    var jo = this._events[Oo], Do = arguments.length, Lo, ko;
    if (jo.fn) {
      switch (jo.once && this.removeListener(wo, jo.fn, void 0, !0), Do) {
        case 1:
          return jo.fn.call(jo.context), !0;
        case 2:
          return jo.fn.call(jo.context, Eo), !0;
        case 3:
          return jo.fn.call(jo.context, Eo, Ro), !0;
        case 4:
          return jo.fn.call(jo.context, Eo, Ro, _o), !0;
        case 5:
          return jo.fn.call(jo.context, Eo, Ro, _o, Io), !0;
        case 6:
          return jo.fn.call(jo.context, Eo, Ro, _o, Io, Ao), !0;
      }
      for (ko = 1, Lo = new Array(Do - 1); ko < Do; ko++)
        Lo[ko - 1] = arguments[ko];
      jo.fn.apply(jo.context, Lo);
    } else {
      var Ko = jo.length, No;
      for (ko = 0; ko < Ko; ko++)
        switch (jo[ko].once && this.removeListener(wo, jo[ko].fn, void 0, !0), Do) {
          case 1:
            jo[ko].fn.call(jo[ko].context);
            break;
          case 2:
            jo[ko].fn.call(jo[ko].context, Eo);
            break;
          case 3:
            jo[ko].fn.call(jo[ko].context, Eo, Ro);
            break;
          case 4:
            jo[ko].fn.call(jo[ko].context, Eo, Ro, _o);
            break;
          default:
            if (!Lo) for (No = 1, Lo = new Array(Do - 1); No < Do; No++)
              Lo[No - 1] = arguments[No];
            jo[ko].fn.apply(jo[ko].context, Lo);
        }
    }
    return !0;
  }, Co.prototype.on = function(wo, Eo, Ro) {
    return vo(this, wo, Eo, Ro, !1);
  }, Co.prototype.once = function(wo, Eo, Ro) {
    return vo(this, wo, Eo, Ro, !0);
  }, Co.prototype.removeListener = function(wo, Eo, Ro, _o) {
    var Io = ho ? ho + wo : wo;
    if (!this._events[Io]) return this;
    if (!Eo)
      return Po(this, Io), this;
    var Ao = this._events[Io];
    if (Ao.fn)
      Ao.fn === Eo && (!_o || Ao.once) && (!Ro || Ao.context === Ro) && Po(this, Io);
    else {
      for (var Oo = 0, jo = [], Do = Ao.length; Oo < Do; Oo++)
        (Ao[Oo].fn !== Eo || _o && !Ao[Oo].once || Ro && Ao[Oo].context !== Ro) && jo.push(Ao[Oo]);
      jo.length ? this._events[Io] = jo.length === 1 ? jo[0] : jo : Po(this, Io);
    }
    return this;
  }, Co.prototype.removeAllListeners = function(wo) {
    var Eo;
    return wo ? (Eo = ho ? ho + wo : wo, this._events[Eo] && Po(this, Eo)) : (this._events = new go(), this._eventsCount = 0), this;
  }, Co.prototype.off = Co.prototype.removeListener, Co.prototype.addListener = Co.prototype.on, Co.prefixed = ho, Co.EventEmitter = Co, Kt.exports = Co;
})(eventemitter3);
var eventemitter3Exports = eventemitter3.exports;
const EventEmitter = /* @__PURE__ */ getDefaultExportFromCjs(eventemitter3Exports);
var eventCenter = new EventEmitter(), SYNC_EVENT = "recharts.syncMouseEvents";
function _typeof$2(Kt) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$2(Kt);
}
function _classCallCheck$1(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties$1(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey$2(go.key), go);
  }
}
function _createClass$1(Kt, uo, ho) {
  return _defineProperties$1(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _defineProperty$2(Kt, uo, ho) {
  return uo = _toPropertyKey$2(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$2(Kt) {
  var uo = _toPrimitive$2(Kt, "string");
  return _typeof$2(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$2(Kt, uo) {
  if (_typeof$2(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo);
    if (_typeof$2(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(Kt);
}
var AccessibilityManager = /* @__PURE__ */ function() {
  function Kt() {
    _classCallCheck$1(this, Kt), _defineProperty$2(this, "activeIndex", 0), _defineProperty$2(this, "coordinateList", []), _defineProperty$2(this, "layout", "horizontal");
  }
  return _createClass$1(Kt, [{
    key: "setDetails",
    value: function(ho) {
      var go, bo = ho.coordinateList, vo = bo === void 0 ? null : bo, Po = ho.container, Co = Po === void 0 ? null : Po, So = ho.layout, wo = So === void 0 ? null : So, Eo = ho.offset, Ro = Eo === void 0 ? null : Eo, _o = ho.mouseHandlerCallback, Io = _o === void 0 ? null : _o;
      this.coordinateList = (go = vo ?? this.coordinateList) !== null && go !== void 0 ? go : [], this.container = Co ?? this.container, this.layout = wo ?? this.layout, this.offset = Ro ?? this.offset, this.mouseHandlerCallback = Io ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(ho) {
      if (this.coordinateList.length !== 0)
        switch (ho.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(ho) {
      this.activeIndex = ho;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var ho, go;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var bo = this.container.getBoundingClientRect(), vo = bo.x, Po = bo.y, Co = bo.height, So = this.coordinateList[this.activeIndex].coordinate, wo = ((ho = window) === null || ho === void 0 ? void 0 : ho.scrollX) || 0, Eo = ((go = window) === null || go === void 0 ? void 0 : go.scrollY) || 0, Ro = vo + So + wo, _o = Po + this.offset.top + Co / 2 + Eo;
        this.mouseHandlerCallback({
          pageX: Ro,
          pageY: _o
        });
      }
    }
  }]);
}();
function isDomainSpecifiedByUser(Kt, uo, ho) {
  if (ho === "number" && uo === !0 && Array.isArray(Kt)) {
    var go = Kt == null ? void 0 : Kt[0], bo = Kt == null ? void 0 : Kt[1];
    if (go && bo && isNumber(go) && isNumber(bo))
      return !0;
  }
  return !1;
}
function getCursorRectangle(Kt, uo, ho, go) {
  var bo = go / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: Kt === "horizontal" ? uo.x - bo : ho.left + 0.5,
    y: Kt === "horizontal" ? ho.top + 0.5 : uo.y - bo,
    width: Kt === "horizontal" ? go : ho.width - 1,
    height: Kt === "horizontal" ? ho.height - 1 : go
  };
}
function getRadialCursorPoints(Kt) {
  var uo = Kt.cx, ho = Kt.cy, go = Kt.radius, bo = Kt.startAngle, vo = Kt.endAngle, Po = polarToCartesian(uo, ho, go, bo), Co = polarToCartesian(uo, ho, go, vo);
  return {
    points: [Po, Co],
    cx: uo,
    cy: ho,
    radius: go,
    startAngle: bo,
    endAngle: vo
  };
}
function getCursorPoints(Kt, uo, ho) {
  var go, bo, vo, Po;
  if (Kt === "horizontal")
    go = uo.x, vo = go, bo = ho.top, Po = ho.top + ho.height;
  else if (Kt === "vertical")
    bo = uo.y, Po = bo, go = ho.left, vo = ho.left + ho.width;
  else if (uo.cx != null && uo.cy != null)
    if (Kt === "centric") {
      var Co = uo.cx, So = uo.cy, wo = uo.innerRadius, Eo = uo.outerRadius, Ro = uo.angle, _o = polarToCartesian(Co, So, wo, Ro), Io = polarToCartesian(Co, So, Eo, Ro);
      go = _o.x, bo = _o.y, vo = Io.x, Po = Io.y;
    } else
      return getRadialCursorPoints(uo);
  return [{
    x: go,
    y: bo
  }, {
    x: vo,
    y: Po
  }];
}
function _typeof$1(Kt) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof$1(Kt);
}
function ownKeys$1(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread$1(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys$1(Object(ho), !0).forEach(function(go) {
      _defineProperty$1(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys$1(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty$1(Kt, uo, ho) {
  return uo = _toPropertyKey$1(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey$1(Kt) {
  var uo = _toPrimitive$1(Kt, "string");
  return _typeof$1(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive$1(Kt, uo) {
  if (_typeof$1(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof$1(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
function Cursor(Kt) {
  var uo, ho, go = Kt.element, bo = Kt.tooltipEventType, vo = Kt.isActive, Po = Kt.activeCoordinate, Co = Kt.activePayload, So = Kt.offset, wo = Kt.activeTooltipIndex, Eo = Kt.tooltipAxisBandSize, Ro = Kt.layout, _o = Kt.chartName, Io = (uo = go.props.cursor) !== null && uo !== void 0 ? uo : (ho = go.type.defaultProps) === null || ho === void 0 ? void 0 : ho.cursor;
  if (!go || !Io || !vo || !Po || _o !== "ScatterChart" && bo !== "axis")
    return null;
  var Ao, Oo = Curve;
  if (_o === "ScatterChart")
    Ao = Po, Oo = Cross;
  else if (_o === "BarChart")
    Ao = getCursorRectangle(Ro, Po, So, Eo), Oo = Rectangle;
  else if (Ro === "radial") {
    var jo = getRadialCursorPoints(Po), Do = jo.cx, Lo = jo.cy, ko = jo.radius, Ko = jo.startAngle, No = jo.endAngle;
    Ao = {
      cx: Do,
      cy: Lo,
      startAngle: Ko,
      endAngle: No,
      innerRadius: ko,
      outerRadius: ko
    }, Oo = Sector;
  } else
    Ao = {
      points: getCursorPoints(Ro, Po, So)
    }, Oo = Curve;
  var Jo = _objectSpread$1(_objectSpread$1(_objectSpread$1(_objectSpread$1({
    stroke: "#ccc",
    pointerEvents: "none"
  }, So), Ao), filterProps(Io, !1)), {}, {
    payload: Co,
    payloadIndex: wo,
    className: clsx("recharts-tooltip-cursor", Io.className)
  });
  return /* @__PURE__ */ isValidElement(Io) ? /* @__PURE__ */ cloneElement(Io, Jo) : /* @__PURE__ */ createElement(Oo, Jo);
}
var _excluded = ["item"], _excluded2 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function _typeof(Kt) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(uo) {
    return typeof uo;
  } : function(uo) {
    return uo && typeof Symbol == "function" && uo.constructor === Symbol && uo !== Symbol.prototype ? "symbol" : typeof uo;
  }, _typeof(Kt);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(Kt) {
    for (var uo = 1; uo < arguments.length; uo++) {
      var ho = arguments[uo];
      for (var go in ho)
        Object.prototype.hasOwnProperty.call(ho, go) && (Kt[go] = ho[go]);
    }
    return Kt;
  }, _extends.apply(this, arguments);
}
function _slicedToArray(Kt, uo) {
  return _arrayWithHoles(Kt) || _iterableToArrayLimit(Kt, uo) || _unsupportedIterableToArray(Kt, uo) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _iterableToArrayLimit(Kt, uo) {
  var ho = Kt == null ? null : typeof Symbol < "u" && Kt[Symbol.iterator] || Kt["@@iterator"];
  if (ho != null) {
    var go, bo, vo, Po, Co = [], So = !0, wo = !1;
    try {
      if (vo = (ho = ho.call(Kt)).next, uo !== 0) for (; !(So = (go = vo.call(ho)).done) && (Co.push(go.value), Co.length !== uo); So = !0) ;
    } catch (Eo) {
      wo = !0, bo = Eo;
    } finally {
      try {
        if (!So && ho.return != null && (Po = ho.return(), Object(Po) !== Po)) return;
      } finally {
        if (wo) throw bo;
      }
    }
    return Co;
  }
}
function _arrayWithHoles(Kt) {
  if (Array.isArray(Kt)) return Kt;
}
function _objectWithoutProperties(Kt, uo) {
  if (Kt == null) return {};
  var ho = _objectWithoutPropertiesLoose(Kt, uo), go, bo;
  if (Object.getOwnPropertySymbols) {
    var vo = Object.getOwnPropertySymbols(Kt);
    for (bo = 0; bo < vo.length; bo++)
      go = vo[bo], !(uo.indexOf(go) >= 0) && Object.prototype.propertyIsEnumerable.call(Kt, go) && (ho[go] = Kt[go]);
  }
  return ho;
}
function _objectWithoutPropertiesLoose(Kt, uo) {
  if (Kt == null) return {};
  var ho = {};
  for (var go in Kt)
    if (Object.prototype.hasOwnProperty.call(Kt, go)) {
      if (uo.indexOf(go) >= 0) continue;
      ho[go] = Kt[go];
    }
  return ho;
}
function _classCallCheck(Kt, uo) {
  if (!(Kt instanceof uo))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(Kt, uo) {
  for (var ho = 0; ho < uo.length; ho++) {
    var go = uo[ho];
    go.enumerable = go.enumerable || !1, go.configurable = !0, "value" in go && (go.writable = !0), Object.defineProperty(Kt, _toPropertyKey(go.key), go);
  }
}
function _createClass(Kt, uo, ho) {
  return _defineProperties(Kt.prototype, uo), Object.defineProperty(Kt, "prototype", { writable: !1 }), Kt;
}
function _callSuper(Kt, uo, ho) {
  return uo = _getPrototypeOf(uo), _possibleConstructorReturn(Kt, _isNativeReflectConstruct() ? Reflect.construct(uo, ho, _getPrototypeOf(Kt).constructor) : uo.apply(Kt, ho));
}
function _possibleConstructorReturn(Kt, uo) {
  if (uo && (_typeof(uo) === "object" || typeof uo == "function"))
    return uo;
  if (uo !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(Kt);
}
function _assertThisInitialized(Kt) {
  if (Kt === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return Kt;
}
function _isNativeReflectConstruct() {
  try {
    var Kt = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (_isNativeReflectConstruct = function() {
    return !!Kt;
  })();
}
function _getPrototypeOf(Kt) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(ho) {
    return ho.__proto__ || Object.getPrototypeOf(ho);
  }, _getPrototypeOf(Kt);
}
function _inherits(Kt, uo) {
  if (typeof uo != "function" && uo !== null)
    throw new TypeError("Super expression must either be null or a function");
  Kt.prototype = Object.create(uo && uo.prototype, { constructor: { value: Kt, writable: !0, configurable: !0 } }), Object.defineProperty(Kt, "prototype", { writable: !1 }), uo && _setPrototypeOf(Kt, uo);
}
function _setPrototypeOf(Kt, uo) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(go, bo) {
    return go.__proto__ = bo, go;
  }, _setPrototypeOf(Kt, uo);
}
function _toConsumableArray(Kt) {
  return _arrayWithoutHoles(Kt) || _iterableToArray(Kt) || _unsupportedIterableToArray(Kt) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _unsupportedIterableToArray(Kt, uo) {
  if (Kt) {
    if (typeof Kt == "string") return _arrayLikeToArray(Kt, uo);
    var ho = Object.prototype.toString.call(Kt).slice(8, -1);
    if (ho === "Object" && Kt.constructor && (ho = Kt.constructor.name), ho === "Map" || ho === "Set") return Array.from(Kt);
    if (ho === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(ho)) return _arrayLikeToArray(Kt, uo);
  }
}
function _iterableToArray(Kt) {
  if (typeof Symbol < "u" && Kt[Symbol.iterator] != null || Kt["@@iterator"] != null) return Array.from(Kt);
}
function _arrayWithoutHoles(Kt) {
  if (Array.isArray(Kt)) return _arrayLikeToArray(Kt);
}
function _arrayLikeToArray(Kt, uo) {
  (uo == null || uo > Kt.length) && (uo = Kt.length);
  for (var ho = 0, go = new Array(uo); ho < uo; ho++) go[ho] = Kt[ho];
  return go;
}
function ownKeys(Kt, uo) {
  var ho = Object.keys(Kt);
  if (Object.getOwnPropertySymbols) {
    var go = Object.getOwnPropertySymbols(Kt);
    uo && (go = go.filter(function(bo) {
      return Object.getOwnPropertyDescriptor(Kt, bo).enumerable;
    })), ho.push.apply(ho, go);
  }
  return ho;
}
function _objectSpread(Kt) {
  for (var uo = 1; uo < arguments.length; uo++) {
    var ho = arguments[uo] != null ? arguments[uo] : {};
    uo % 2 ? ownKeys(Object(ho), !0).forEach(function(go) {
      _defineProperty(Kt, go, ho[go]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(Kt, Object.getOwnPropertyDescriptors(ho)) : ownKeys(Object(ho)).forEach(function(go) {
      Object.defineProperty(Kt, go, Object.getOwnPropertyDescriptor(ho, go));
    });
  }
  return Kt;
}
function _defineProperty(Kt, uo, ho) {
  return uo = _toPropertyKey(uo), uo in Kt ? Object.defineProperty(Kt, uo, { value: ho, enumerable: !0, configurable: !0, writable: !0 }) : Kt[uo] = ho, Kt;
}
function _toPropertyKey(Kt) {
  var uo = _toPrimitive(Kt, "string");
  return _typeof(uo) == "symbol" ? uo : uo + "";
}
function _toPrimitive(Kt, uo) {
  if (_typeof(Kt) != "object" || !Kt) return Kt;
  var ho = Kt[Symbol.toPrimitive];
  if (ho !== void 0) {
    var go = ho.call(Kt, uo || "default");
    if (_typeof(go) != "object") return go;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (uo === "string" ? String : Number)(Kt);
}
var ORIENT_MAP = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, FULL_WIDTH_AND_HEIGHT = {
  width: "100%",
  height: "100%"
}, originCoordinate = {
  x: 0,
  y: 0
};
function renderAsIs(Kt) {
  return Kt;
}
var calculateTooltipPos = function(uo, ho) {
  return ho === "horizontal" ? uo.x : ho === "vertical" ? uo.y : ho === "centric" ? uo.angle : uo.radius;
}, getActiveCoordinate = function(uo, ho, go, bo) {
  var vo = ho.find(function(Eo) {
    return Eo && Eo.index === go;
  });
  if (vo) {
    if (uo === "horizontal")
      return {
        x: vo.coordinate,
        y: bo.y
      };
    if (uo === "vertical")
      return {
        x: bo.x,
        y: vo.coordinate
      };
    if (uo === "centric") {
      var Po = vo.coordinate, Co = bo.radius;
      return _objectSpread(_objectSpread(_objectSpread({}, bo), polarToCartesian(bo.cx, bo.cy, Co, Po)), {}, {
        angle: Po,
        radius: Co
      });
    }
    var So = vo.coordinate, wo = bo.angle;
    return _objectSpread(_objectSpread(_objectSpread({}, bo), polarToCartesian(bo.cx, bo.cy, So, wo)), {}, {
      angle: wo,
      radius: So
    });
  }
  return originCoordinate;
}, getDisplayedData = function(uo, ho) {
  var go = ho.graphicalItems, bo = ho.dataStartIndex, vo = ho.dataEndIndex, Po = (go ?? []).reduce(function(Co, So) {
    var wo = So.props.data;
    return wo && wo.length ? [].concat(_toConsumableArray(Co), _toConsumableArray(wo)) : Co;
  }, []);
  return Po.length > 0 ? Po : uo && uo.length && isNumber(bo) && isNumber(vo) ? uo.slice(bo, vo + 1) : [];
};
function getDefaultDomainByAxisType(Kt) {
  return Kt === "number" ? [0, "auto"] : void 0;
}
var getTooltipContent = function(uo, ho, go, bo) {
  var vo = uo.graphicalItems, Po = uo.tooltipAxis, Co = getDisplayedData(ho, uo);
  return go < 0 || !vo || !vo.length || go >= Co.length ? null : vo.reduce(function(So, wo) {
    var Eo, Ro = (Eo = wo.props.data) !== null && Eo !== void 0 ? Eo : ho;
    Ro && uo.dataStartIndex + uo.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    uo.dataEndIndex - uo.dataStartIndex >= go && (Ro = Ro.slice(uo.dataStartIndex, uo.dataEndIndex + 1));
    var _o;
    if (Po.dataKey && !Po.allowDuplicatedCategory) {
      var Io = Ro === void 0 ? Co : Ro;
      _o = findEntryInArray(Io, Po.dataKey, bo);
    } else
      _o = Ro && Ro[go] || Co[go];
    return _o ? [].concat(_toConsumableArray(So), [getTooltipItem(wo, _o)]) : So;
  }, []);
}, getTooltipData = function(uo, ho, go, bo) {
  var vo = bo || {
    x: uo.chartX,
    y: uo.chartY
  }, Po = calculateTooltipPos(vo, go), Co = uo.orderedTooltipTicks, So = uo.tooltipAxis, wo = uo.tooltipTicks, Eo = calculateActiveTickIndex(Po, Co, wo, So);
  if (Eo >= 0 && wo) {
    var Ro = wo[Eo] && wo[Eo].value, _o = getTooltipContent(uo, ho, Eo, Ro), Io = getActiveCoordinate(go, Co, Eo, vo);
    return {
      activeTooltipIndex: Eo,
      activeLabel: Ro,
      activePayload: _o,
      activeCoordinate: Io
    };
  }
  return null;
}, getAxisMapByAxes = function(uo, ho) {
  var go = ho.axes, bo = ho.graphicalItems, vo = ho.axisType, Po = ho.axisIdKey, Co = ho.stackGroups, So = ho.dataStartIndex, wo = ho.dataEndIndex, Eo = uo.layout, Ro = uo.children, _o = uo.stackOffset, Io = isCategoricalAxis(Eo, vo);
  return go.reduce(function(Ao, Oo) {
    var jo, Do = Oo.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, Oo.type.defaultProps), Oo.props) : Oo.props, Lo = Do.type, ko = Do.dataKey, Ko = Do.allowDataOverflow, No = Do.allowDuplicatedCategory, Jo = Do.scale, ti = Do.ticks, oi = Do.includeHidden, Qo = Do[Po];
    if (Ao[Qo])
      return Ao;
    var Zo = getDisplayedData(uo.data, {
      graphicalItems: bo.filter(function(hi) {
        var mi, bi = Po in hi.props ? hi.props[Po] : (mi = hi.type.defaultProps) === null || mi === void 0 ? void 0 : mi[Po];
        return bi === Qo;
      }),
      dataStartIndex: So,
      dataEndIndex: wo
    }), ei = Zo.length, ii, ai, ri;
    isDomainSpecifiedByUser(Do.domain, Ko, Lo) && (ii = parseSpecifiedDomain(Do.domain, null, Ko), Io && (Lo === "number" || Jo !== "auto") && (ri = getDomainOfDataByKey(Zo, ko, "category")));
    var ni = getDefaultDomainByAxisType(Lo);
    if (!ii || ii.length === 0) {
      var si, li = (si = Do.domain) !== null && si !== void 0 ? si : ni;
      if (ko) {
        if (ii = getDomainOfDataByKey(Zo, ko, Lo), Lo === "category" && Io) {
          var ui = hasDuplicate(ii);
          No && ui ? (ai = ii, ii = range$1(0, ei)) : No || (ii = parseDomainOfCategoryAxis(li, ii, Oo).reduce(function(hi, mi) {
            return hi.indexOf(mi) >= 0 ? hi : [].concat(_toConsumableArray(hi), [mi]);
          }, []));
        } else if (Lo === "category")
          No ? ii = ii.filter(function(hi) {
            return hi !== "" && !isNil$1(hi);
          }) : ii = parseDomainOfCategoryAxis(li, ii, Oo).reduce(function(hi, mi) {
            return hi.indexOf(mi) >= 0 || mi === "" || isNil$1(mi) ? hi : [].concat(_toConsumableArray(hi), [mi]);
          }, []);
        else if (Lo === "number") {
          var ci = parseErrorBarsOfAxis(Zo, bo.filter(function(hi) {
            var mi, bi, xi = Po in hi.props ? hi.props[Po] : (mi = hi.type.defaultProps) === null || mi === void 0 ? void 0 : mi[Po], $i = "hide" in hi.props ? hi.props.hide : (bi = hi.type.defaultProps) === null || bi === void 0 ? void 0 : bi.hide;
            return xi === Qo && (oi || !$i);
          }), ko, vo, Eo);
          ci && (ii = ci);
        }
        Io && (Lo === "number" || Jo !== "auto") && (ri = getDomainOfDataByKey(Zo, ko, "category"));
      } else Io ? ii = range$1(0, ei) : Co && Co[Qo] && Co[Qo].hasStack && Lo === "number" ? ii = _o === "expand" ? [0, 1] : getDomainOfStackGroups(Co[Qo].stackGroups, So, wo) : ii = getDomainOfItemsWithSameAxis(Zo, bo.filter(function(hi) {
        var mi = Po in hi.props ? hi.props[Po] : hi.type.defaultProps[Po], bi = "hide" in hi.props ? hi.props.hide : hi.type.defaultProps.hide;
        return mi === Qo && (oi || !bi);
      }), Lo, Eo, !0);
      if (Lo === "number")
        ii = detectReferenceElementsDomain(Ro, ii, Qo, vo, ti), li && (ii = parseSpecifiedDomain(li, ii, Ko));
      else if (Lo === "category" && li) {
        var fi = li, yi = ii.every(function(hi) {
          return fi.indexOf(hi) >= 0;
        });
        yi && (ii = fi);
      }
    }
    return _objectSpread(_objectSpread({}, Ao), {}, _defineProperty({}, Qo, _objectSpread(_objectSpread({}, Do), {}, {
      axisType: vo,
      domain: ii,
      categoricalDomain: ri,
      duplicateDomain: ai,
      originalDomain: (jo = Do.domain) !== null && jo !== void 0 ? jo : ni,
      isCategorical: Io,
      layout: Eo
    })));
  }, {});
}, getAxisMapByItems = function(uo, ho) {
  var go = ho.graphicalItems, bo = ho.Axis, vo = ho.axisType, Po = ho.axisIdKey, Co = ho.stackGroups, So = ho.dataStartIndex, wo = ho.dataEndIndex, Eo = uo.layout, Ro = uo.children, _o = getDisplayedData(uo.data, {
    graphicalItems: go,
    dataStartIndex: So,
    dataEndIndex: wo
  }), Io = _o.length, Ao = isCategoricalAxis(Eo, vo), Oo = -1;
  return go.reduce(function(jo, Do) {
    var Lo = Do.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, Do.type.defaultProps), Do.props) : Do.props, ko = Lo[Po], Ko = getDefaultDomainByAxisType("number");
    if (!jo[ko]) {
      Oo++;
      var No;
      return Ao ? No = range$1(0, Io) : Co && Co[ko] && Co[ko].hasStack ? (No = getDomainOfStackGroups(Co[ko].stackGroups, So, wo), No = detectReferenceElementsDomain(Ro, No, ko, vo)) : (No = parseSpecifiedDomain(Ko, getDomainOfItemsWithSameAxis(_o, go.filter(function(Jo) {
        var ti, oi, Qo = Po in Jo.props ? Jo.props[Po] : (ti = Jo.type.defaultProps) === null || ti === void 0 ? void 0 : ti[Po], Zo = "hide" in Jo.props ? Jo.props.hide : (oi = Jo.type.defaultProps) === null || oi === void 0 ? void 0 : oi.hide;
        return Qo === ko && !Zo;
      }), "number", Eo), bo.defaultProps.allowDataOverflow), No = detectReferenceElementsDomain(Ro, No, ko, vo)), _objectSpread(_objectSpread({}, jo), {}, _defineProperty({}, ko, _objectSpread(_objectSpread({
        axisType: vo
      }, bo.defaultProps), {}, {
        hide: !0,
        orientation: get$2(ORIENT_MAP, "".concat(vo, ".").concat(Oo % 2), null),
        domain: No,
        originalDomain: Ko,
        isCategorical: Ao,
        layout: Eo
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return jo;
  }, {});
}, getAxisMap = function(uo, ho) {
  var go = ho.axisType, bo = go === void 0 ? "xAxis" : go, vo = ho.AxisComp, Po = ho.graphicalItems, Co = ho.stackGroups, So = ho.dataStartIndex, wo = ho.dataEndIndex, Eo = uo.children, Ro = "".concat(bo, "Id"), _o = findAllByType(Eo, vo), Io = {};
  return _o.length ? Io = getAxisMapByAxes(uo, {
    axes: _o,
    graphicalItems: Po,
    axisType: bo,
    axisIdKey: Ro,
    stackGroups: Co,
    dataStartIndex: So,
    dataEndIndex: wo
  }) : Po && Po.length && (Io = getAxisMapByItems(uo, {
    Axis: vo,
    graphicalItems: Po,
    axisType: bo,
    axisIdKey: Ro,
    stackGroups: Co,
    dataStartIndex: So,
    dataEndIndex: wo
  })), Io;
}, tooltipTicksGenerator = function(uo) {
  var ho = getAnyElementOfObject(uo), go = getTicksOfAxis(ho, !1, !0);
  return {
    tooltipTicks: go,
    orderedTooltipTicks: sortBy$1(go, function(bo) {
      return bo.coordinate;
    }),
    tooltipAxis: ho,
    tooltipAxisBandSize: getBandSizeOfAxis(ho, go)
  };
}, createDefaultState = function(uo) {
  var ho = uo.children, go = uo.defaultShowTooltip, bo = findChildByType(ho, Brush), vo = 0, Po = 0;
  return uo.data && uo.data.length !== 0 && (Po = uo.data.length - 1), bo && bo.props && (bo.props.startIndex >= 0 && (vo = bo.props.startIndex), bo.props.endIndex >= 0 && (Po = bo.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: vo,
    dataEndIndex: Po,
    activeTooltipIndex: -1,
    isTooltipActive: !!go
  };
}, hasGraphicalBarItem = function(uo) {
  return !uo || !uo.length ? !1 : uo.some(function(ho) {
    var go = getDisplayName(ho && ho.type);
    return go && go.indexOf("Bar") >= 0;
  });
}, getAxisNameByLayout = function(uo) {
  return uo === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : uo === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : uo === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, calculateOffset = function(uo, ho) {
  var go = uo.props, bo = uo.graphicalItems, vo = uo.xAxisMap, Po = vo === void 0 ? {} : vo, Co = uo.yAxisMap, So = Co === void 0 ? {} : Co, wo = go.width, Eo = go.height, Ro = go.children, _o = go.margin || {}, Io = findChildByType(Ro, Brush), Ao = findChildByType(Ro, Legend), Oo = Object.keys(So).reduce(function(No, Jo) {
    var ti = So[Jo], oi = ti.orientation;
    return !ti.mirror && !ti.hide ? _objectSpread(_objectSpread({}, No), {}, _defineProperty({}, oi, No[oi] + ti.width)) : No;
  }, {
    left: _o.left || 0,
    right: _o.right || 0
  }), jo = Object.keys(Po).reduce(function(No, Jo) {
    var ti = Po[Jo], oi = ti.orientation;
    return !ti.mirror && !ti.hide ? _objectSpread(_objectSpread({}, No), {}, _defineProperty({}, oi, get$2(No, "".concat(oi)) + ti.height)) : No;
  }, {
    top: _o.top || 0,
    bottom: _o.bottom || 0
  }), Do = _objectSpread(_objectSpread({}, jo), Oo), Lo = Do.bottom;
  Io && (Do.bottom += Io.props.height || Brush.defaultProps.height), Ao && ho && (Do = appendOffsetOfLegend(Do, bo, go, ho));
  var ko = wo - Do.left - Do.right, Ko = Eo - Do.top - Do.bottom;
  return _objectSpread(_objectSpread({
    brushBottom: Lo
  }, Do), {}, {
    // never return negative values for height and width
    width: Math.max(ko, 0),
    height: Math.max(Ko, 0)
  });
}, getCartesianAxisSize = function(uo, ho) {
  if (ho === "xAxis")
    return uo[ho].width;
  if (ho === "yAxis")
    return uo[ho].height;
}, generateCategoricalChart = function(uo) {
  var ho = uo.chartName, go = uo.GraphicalChild, bo = uo.defaultTooltipEventType, vo = bo === void 0 ? "axis" : bo, Po = uo.validateTooltipEventTypes, Co = Po === void 0 ? ["axis"] : Po, So = uo.axisComponents, wo = uo.legendContent, Eo = uo.formatAxisMap, Ro = uo.defaultProps, _o = function(Do, Lo) {
    var ko = Lo.graphicalItems, Ko = Lo.stackGroups, No = Lo.offset, Jo = Lo.updateId, ti = Lo.dataStartIndex, oi = Lo.dataEndIndex, Qo = Do.barSize, Zo = Do.layout, ei = Do.barGap, ii = Do.barCategoryGap, ai = Do.maxBarSize, ri = getAxisNameByLayout(Zo), ni = ri.numericAxisName, si = ri.cateAxisName, li = hasGraphicalBarItem(ko), ui = [];
    return ko.forEach(function(ci, fi) {
      var yi = getDisplayedData(Do.data, {
        graphicalItems: [ci],
        dataStartIndex: ti,
        dataEndIndex: oi
      }), hi = ci.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, ci.type.defaultProps), ci.props) : ci.props, mi = hi.dataKey, bi = hi.maxBarSize, xi = hi["".concat(ni, "Id")], $i = hi["".concat(si, "Id")], Ci = {}, Si = So.reduce(function(Ti, _i) {
        var Vi, Bi, Ji = Lo["".concat(_i.axisType, "Map")], Ki = hi["".concat(_i.axisType, "Id")];
        Ji && Ji[Ki] || _i.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? invariant(!1, "Specifying a(n) ".concat(_i.axisType, "Id requires a corresponding ").concat(
          _i.axisType,
          "Id on the targeted graphical component "
        ).concat((Vi = ci == null || (Bi = ci.type) === null || Bi === void 0 ? void 0 : Bi.displayName) !== null && Vi !== void 0 ? Vi : "")) : invariant());
        var qi = Ji[Ki];
        return _objectSpread(_objectSpread({}, Ti), {}, _defineProperty(_defineProperty({}, _i.axisType, qi), "".concat(_i.axisType, "Ticks"), getTicksOfAxis(qi)));
      }, Ci), vi = Si[si], Pi = Si["".concat(si, "Ticks")], wi = Ko && Ko[xi] && Ko[xi].hasStack && getStackedDataOfItem(ci, Ko[xi].stackGroups), gi = getDisplayName(ci.type).indexOf("Bar") >= 0, Ri = getBandSizeOfAxis(vi, Pi), Ei = [], Ni = li && getBarSizeList({
        barSize: Qo,
        stackGroups: Ko,
        totalSize: getCartesianAxisSize(Si, si)
      });
      if (gi) {
        var Ai, Yi, Ui = isNil$1(bi) ? ai : bi, us = (Ai = (Yi = getBandSizeOfAxis(vi, Pi, !0)) !== null && Yi !== void 0 ? Yi : Ui) !== null && Ai !== void 0 ? Ai : 0;
        Ei = getBarPosition({
          barGap: ei,
          barCategoryGap: ii,
          bandSize: us !== Ri ? us : Ri,
          sizeList: Ni[$i],
          maxBarSize: Ui
        }), us !== Ri && (Ei = Ei.map(function(Ti) {
          return _objectSpread(_objectSpread({}, Ti), {}, {
            position: _objectSpread(_objectSpread({}, Ti.position), {}, {
              offset: Ti.position.offset - us / 2
            })
          });
        }));
      }
      var ns = ci && ci.type && ci.type.getComposedData;
      ns && ui.push({
        props: _objectSpread(_objectSpread({}, ns(_objectSpread(_objectSpread({}, Si), {}, {
          displayedData: yi,
          props: Do,
          dataKey: mi,
          item: ci,
          bandSize: Ri,
          barPosition: Ei,
          offset: No,
          stackedData: wi,
          layout: Zo,
          dataStartIndex: ti,
          dataEndIndex: oi
        }))), {}, _defineProperty(_defineProperty(_defineProperty({
          key: ci.key || "item-".concat(fi)
        }, ni, Si[ni]), si, Si[si]), "animationId", Jo)),
        childIndex: parseChildIndex(ci, Do.children),
        item: ci
      });
    }), ui;
  }, Io = function(Do, Lo) {
    var ko = Do.props, Ko = Do.dataStartIndex, No = Do.dataEndIndex, Jo = Do.updateId;
    if (!validateWidthHeight({
      props: ko
    }))
      return null;
    var ti = ko.children, oi = ko.layout, Qo = ko.stackOffset, Zo = ko.data, ei = ko.reverseStackOrder, ii = getAxisNameByLayout(oi), ai = ii.numericAxisName, ri = ii.cateAxisName, ni = findAllByType(ti, go), si = getStackGroupsByAxisId(Zo, ni, "".concat(ai, "Id"), "".concat(ri, "Id"), Qo, ei), li = So.reduce(function(hi, mi) {
      var bi = "".concat(mi.axisType, "Map");
      return _objectSpread(_objectSpread({}, hi), {}, _defineProperty({}, bi, getAxisMap(ko, _objectSpread(_objectSpread({}, mi), {}, {
        graphicalItems: ni,
        stackGroups: mi.axisType === ai && si,
        dataStartIndex: Ko,
        dataEndIndex: No
      }))));
    }, {}), ui = calculateOffset(_objectSpread(_objectSpread({}, li), {}, {
      props: ko,
      graphicalItems: ni
    }), Lo == null ? void 0 : Lo.legendBBox);
    Object.keys(li).forEach(function(hi) {
      li[hi] = Eo(ko, li[hi], ui, hi.replace("Map", ""), ho);
    });
    var ci = li["".concat(ri, "Map")], fi = tooltipTicksGenerator(ci), yi = _o(ko, _objectSpread(_objectSpread({}, li), {}, {
      dataStartIndex: Ko,
      dataEndIndex: No,
      updateId: Jo,
      graphicalItems: ni,
      stackGroups: si,
      offset: ui
    }));
    return _objectSpread(_objectSpread({
      formattedGraphicalItems: yi,
      graphicalItems: ni,
      offset: ui,
      stackGroups: si
    }, fi), li);
  }, Ao = /* @__PURE__ */ function(jo) {
    function Do(Lo) {
      var ko, Ko, No;
      return _classCallCheck(this, Do), No = _callSuper(this, Do, [Lo]), _defineProperty(No, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), _defineProperty(No, "accessibilityManager", new AccessibilityManager()), _defineProperty(No, "handleLegendBBoxUpdate", function(Jo) {
        if (Jo) {
          var ti = No.state, oi = ti.dataStartIndex, Qo = ti.dataEndIndex, Zo = ti.updateId;
          No.setState(_objectSpread({
            legendBBox: Jo
          }, Io({
            props: No.props,
            dataStartIndex: oi,
            dataEndIndex: Qo,
            updateId: Zo
          }, _objectSpread(_objectSpread({}, No.state), {}, {
            legendBBox: Jo
          }))));
        }
      }), _defineProperty(No, "handleReceiveSyncEvent", function(Jo, ti, oi) {
        if (No.props.syncId === Jo) {
          if (oi === No.eventEmitterSymbol && typeof No.props.syncMethod != "function")
            return;
          No.applySyncEvent(ti);
        }
      }), _defineProperty(No, "handleBrushChange", function(Jo) {
        var ti = Jo.startIndex, oi = Jo.endIndex;
        if (ti !== No.state.dataStartIndex || oi !== No.state.dataEndIndex) {
          var Qo = No.state.updateId;
          No.setState(function() {
            return _objectSpread({
              dataStartIndex: ti,
              dataEndIndex: oi
            }, Io({
              props: No.props,
              dataStartIndex: ti,
              dataEndIndex: oi,
              updateId: Qo
            }, No.state));
          }), No.triggerSyncEvent({
            dataStartIndex: ti,
            dataEndIndex: oi
          });
        }
      }), _defineProperty(No, "handleMouseEnter", function(Jo) {
        var ti = No.getMouseInfo(Jo);
        if (ti) {
          var oi = _objectSpread(_objectSpread({}, ti), {}, {
            isTooltipActive: !0
          });
          No.setState(oi), No.triggerSyncEvent(oi);
          var Qo = No.props.onMouseEnter;
          isFunction$3(Qo) && Qo(oi, Jo);
        }
      }), _defineProperty(No, "triggeredAfterMouseMove", function(Jo) {
        var ti = No.getMouseInfo(Jo), oi = ti ? _objectSpread(_objectSpread({}, ti), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        No.setState(oi), No.triggerSyncEvent(oi);
        var Qo = No.props.onMouseMove;
        isFunction$3(Qo) && Qo(oi, Jo);
      }), _defineProperty(No, "handleItemMouseEnter", function(Jo) {
        No.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: Jo,
            activePayload: Jo.tooltipPayload,
            activeCoordinate: Jo.tooltipPosition || {
              x: Jo.cx,
              y: Jo.cy
            }
          };
        });
      }), _defineProperty(No, "handleItemMouseLeave", function() {
        No.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), _defineProperty(No, "handleMouseMove", function(Jo) {
        Jo.persist(), No.throttleTriggeredAfterMouseMove(Jo);
      }), _defineProperty(No, "handleMouseLeave", function(Jo) {
        No.throttleTriggeredAfterMouseMove.cancel();
        var ti = {
          isTooltipActive: !1
        };
        No.setState(ti), No.triggerSyncEvent(ti);
        var oi = No.props.onMouseLeave;
        isFunction$3(oi) && oi(ti, Jo);
      }), _defineProperty(No, "handleOuterEvent", function(Jo) {
        var ti = getReactEventByType(Jo), oi = get$2(No.props, "".concat(ti));
        if (ti && isFunction$3(oi)) {
          var Qo, Zo;
          /.*touch.*/i.test(ti) ? Zo = No.getMouseInfo(Jo.changedTouches[0]) : Zo = No.getMouseInfo(Jo), oi((Qo = Zo) !== null && Qo !== void 0 ? Qo : {}, Jo);
        }
      }), _defineProperty(No, "handleClick", function(Jo) {
        var ti = No.getMouseInfo(Jo);
        if (ti) {
          var oi = _objectSpread(_objectSpread({}, ti), {}, {
            isTooltipActive: !0
          });
          No.setState(oi), No.triggerSyncEvent(oi);
          var Qo = No.props.onClick;
          isFunction$3(Qo) && Qo(oi, Jo);
        }
      }), _defineProperty(No, "handleMouseDown", function(Jo) {
        var ti = No.props.onMouseDown;
        if (isFunction$3(ti)) {
          var oi = No.getMouseInfo(Jo);
          ti(oi, Jo);
        }
      }), _defineProperty(No, "handleMouseUp", function(Jo) {
        var ti = No.props.onMouseUp;
        if (isFunction$3(ti)) {
          var oi = No.getMouseInfo(Jo);
          ti(oi, Jo);
        }
      }), _defineProperty(No, "handleTouchMove", function(Jo) {
        Jo.changedTouches != null && Jo.changedTouches.length > 0 && No.throttleTriggeredAfterMouseMove(Jo.changedTouches[0]);
      }), _defineProperty(No, "handleTouchStart", function(Jo) {
        Jo.changedTouches != null && Jo.changedTouches.length > 0 && No.handleMouseDown(Jo.changedTouches[0]);
      }), _defineProperty(No, "handleTouchEnd", function(Jo) {
        Jo.changedTouches != null && Jo.changedTouches.length > 0 && No.handleMouseUp(Jo.changedTouches[0]);
      }), _defineProperty(No, "handleDoubleClick", function(Jo) {
        var ti = No.props.onDoubleClick;
        if (isFunction$3(ti)) {
          var oi = No.getMouseInfo(Jo);
          ti(oi, Jo);
        }
      }), _defineProperty(No, "handleContextMenu", function(Jo) {
        var ti = No.props.onContextMenu;
        if (isFunction$3(ti)) {
          var oi = No.getMouseInfo(Jo);
          ti(oi, Jo);
        }
      }), _defineProperty(No, "triggerSyncEvent", function(Jo) {
        No.props.syncId !== void 0 && eventCenter.emit(SYNC_EVENT, No.props.syncId, Jo, No.eventEmitterSymbol);
      }), _defineProperty(No, "applySyncEvent", function(Jo) {
        var ti = No.props, oi = ti.layout, Qo = ti.syncMethod, Zo = No.state.updateId, ei = Jo.dataStartIndex, ii = Jo.dataEndIndex;
        if (Jo.dataStartIndex !== void 0 || Jo.dataEndIndex !== void 0)
          No.setState(_objectSpread({
            dataStartIndex: ei,
            dataEndIndex: ii
          }, Io({
            props: No.props,
            dataStartIndex: ei,
            dataEndIndex: ii,
            updateId: Zo
          }, No.state)));
        else if (Jo.activeTooltipIndex !== void 0) {
          var ai = Jo.chartX, ri = Jo.chartY, ni = Jo.activeTooltipIndex, si = No.state, li = si.offset, ui = si.tooltipTicks;
          if (!li)
            return;
          if (typeof Qo == "function")
            ni = Qo(ui, Jo);
          else if (Qo === "value") {
            ni = -1;
            for (var ci = 0; ci < ui.length; ci++)
              if (ui[ci].value === Jo.activeLabel) {
                ni = ci;
                break;
              }
          }
          var fi = _objectSpread(_objectSpread({}, li), {}, {
            x: li.left,
            y: li.top
          }), yi = Math.min(ai, fi.x + fi.width), hi = Math.min(ri, fi.y + fi.height), mi = ui[ni] && ui[ni].value, bi = getTooltipContent(No.state, No.props.data, ni), xi = ui[ni] ? {
            x: oi === "horizontal" ? ui[ni].coordinate : yi,
            y: oi === "horizontal" ? hi : ui[ni].coordinate
          } : originCoordinate;
          No.setState(_objectSpread(_objectSpread({}, Jo), {}, {
            activeLabel: mi,
            activeCoordinate: xi,
            activePayload: bi,
            activeTooltipIndex: ni
          }));
        } else
          No.setState(Jo);
      }), _defineProperty(No, "renderCursor", function(Jo) {
        var ti, oi = No.state, Qo = oi.isTooltipActive, Zo = oi.activeCoordinate, ei = oi.activePayload, ii = oi.offset, ai = oi.activeTooltipIndex, ri = oi.tooltipAxisBandSize, ni = No.getTooltipEventType(), si = (ti = Jo.props.active) !== null && ti !== void 0 ? ti : Qo, li = No.props.layout, ui = Jo.key || "_recharts-cursor";
        return /* @__PURE__ */ React__default.createElement(Cursor, {
          key: ui,
          activeCoordinate: Zo,
          activePayload: ei,
          activeTooltipIndex: ai,
          chartName: ho,
          element: Jo,
          isActive: si,
          layout: li,
          offset: ii,
          tooltipAxisBandSize: ri,
          tooltipEventType: ni
        });
      }), _defineProperty(No, "renderPolarAxis", function(Jo, ti, oi) {
        var Qo = get$2(Jo, "type.axisType"), Zo = get$2(No.state, "".concat(Qo, "Map")), ei = Jo.type.defaultProps, ii = ei !== void 0 ? _objectSpread(_objectSpread({}, ei), Jo.props) : Jo.props, ai = Zo && Zo[ii["".concat(Qo, "Id")]];
        return /* @__PURE__ */ cloneElement(Jo, _objectSpread(_objectSpread({}, ai), {}, {
          className: clsx(Qo, ai.className),
          key: Jo.key || "".concat(ti, "-").concat(oi),
          ticks: getTicksOfAxis(ai, !0)
        }));
      }), _defineProperty(No, "renderPolarGrid", function(Jo) {
        var ti = Jo.props, oi = ti.radialLines, Qo = ti.polarAngles, Zo = ti.polarRadius, ei = No.state, ii = ei.radiusAxisMap, ai = ei.angleAxisMap, ri = getAnyElementOfObject(ii), ni = getAnyElementOfObject(ai), si = ni.cx, li = ni.cy, ui = ni.innerRadius, ci = ni.outerRadius;
        return /* @__PURE__ */ cloneElement(Jo, {
          polarAngles: Array.isArray(Qo) ? Qo : getTicksOfAxis(ni, !0).map(function(fi) {
            return fi.coordinate;
          }),
          polarRadius: Array.isArray(Zo) ? Zo : getTicksOfAxis(ri, !0).map(function(fi) {
            return fi.coordinate;
          }),
          cx: si,
          cy: li,
          innerRadius: ui,
          outerRadius: ci,
          key: Jo.key || "polar-grid",
          radialLines: oi
        });
      }), _defineProperty(No, "renderLegend", function() {
        var Jo = No.state.formattedGraphicalItems, ti = No.props, oi = ti.children, Qo = ti.width, Zo = ti.height, ei = No.props.margin || {}, ii = Qo - (ei.left || 0) - (ei.right || 0), ai = getLegendProps({
          children: oi,
          formattedGraphicalItems: Jo,
          legendWidth: ii,
          legendContent: wo
        });
        if (!ai)
          return null;
        var ri = ai.item, ni = _objectWithoutProperties(ai, _excluded);
        return /* @__PURE__ */ cloneElement(ri, _objectSpread(_objectSpread({}, ni), {}, {
          chartWidth: Qo,
          chartHeight: Zo,
          margin: ei,
          onBBoxUpdate: No.handleLegendBBoxUpdate
        }));
      }), _defineProperty(No, "renderTooltip", function() {
        var Jo, ti = No.props, oi = ti.children, Qo = ti.accessibilityLayer, Zo = findChildByType(oi, Tooltip$1);
        if (!Zo)
          return null;
        var ei = No.state, ii = ei.isTooltipActive, ai = ei.activeCoordinate, ri = ei.activePayload, ni = ei.activeLabel, si = ei.offset, li = (Jo = Zo.props.active) !== null && Jo !== void 0 ? Jo : ii;
        return /* @__PURE__ */ cloneElement(Zo, {
          viewBox: _objectSpread(_objectSpread({}, si), {}, {
            x: si.left,
            y: si.top
          }),
          active: li,
          label: ni,
          payload: li ? ri : [],
          coordinate: ai,
          accessibilityLayer: Qo
        });
      }), _defineProperty(No, "renderBrush", function(Jo) {
        var ti = No.props, oi = ti.margin, Qo = ti.data, Zo = No.state, ei = Zo.offset, ii = Zo.dataStartIndex, ai = Zo.dataEndIndex, ri = Zo.updateId;
        return /* @__PURE__ */ cloneElement(Jo, {
          key: Jo.key || "_recharts-brush",
          onChange: combineEventHandlers(No.handleBrushChange, Jo.props.onChange),
          data: Qo,
          x: isNumber(Jo.props.x) ? Jo.props.x : ei.left,
          y: isNumber(Jo.props.y) ? Jo.props.y : ei.top + ei.height + ei.brushBottom - (oi.bottom || 0),
          width: isNumber(Jo.props.width) ? Jo.props.width : ei.width,
          startIndex: ii,
          endIndex: ai,
          updateId: "brush-".concat(ri)
        });
      }), _defineProperty(No, "renderReferenceElement", function(Jo, ti, oi) {
        if (!Jo)
          return null;
        var Qo = No, Zo = Qo.clipPathId, ei = No.state, ii = ei.xAxisMap, ai = ei.yAxisMap, ri = ei.offset, ni = Jo.type.defaultProps || {}, si = Jo.props, li = si.xAxisId, ui = li === void 0 ? ni.xAxisId : li, ci = si.yAxisId, fi = ci === void 0 ? ni.yAxisId : ci;
        return /* @__PURE__ */ cloneElement(Jo, {
          key: Jo.key || "".concat(ti, "-").concat(oi),
          xAxis: ii[ui],
          yAxis: ai[fi],
          viewBox: {
            x: ri.left,
            y: ri.top,
            width: ri.width,
            height: ri.height
          },
          clipPathId: Zo
        });
      }), _defineProperty(No, "renderActivePoints", function(Jo) {
        var ti = Jo.item, oi = Jo.activePoint, Qo = Jo.basePoint, Zo = Jo.childIndex, ei = Jo.isRange, ii = [], ai = ti.props.key, ri = ti.item.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, ti.item.type.defaultProps), ti.item.props) : ti.item.props, ni = ri.activeDot, si = ri.dataKey, li = _objectSpread(_objectSpread({
          index: Zo,
          dataKey: si,
          cx: oi.x,
          cy: oi.y,
          r: 4,
          fill: getMainColorOfGraphicItem(ti.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: oi.payload,
          value: oi.value
        }, filterProps(ni, !1)), adaptEventHandlers(ni));
        return ii.push(Do.renderActiveDot(ni, li, "".concat(ai, "-activePoint-").concat(Zo))), Qo ? ii.push(Do.renderActiveDot(ni, _objectSpread(_objectSpread({}, li), {}, {
          cx: Qo.x,
          cy: Qo.y
        }), "".concat(ai, "-basePoint-").concat(Zo))) : ei && ii.push(null), ii;
      }), _defineProperty(No, "renderGraphicChild", function(Jo, ti, oi) {
        var Qo = No.filterFormatItem(Jo, ti, oi);
        if (!Qo)
          return null;
        var Zo = No.getTooltipEventType(), ei = No.state, ii = ei.isTooltipActive, ai = ei.tooltipAxis, ri = ei.activeTooltipIndex, ni = ei.activeLabel, si = No.props.children, li = findChildByType(si, Tooltip$1), ui = Qo.props, ci = ui.points, fi = ui.isRange, yi = ui.baseLine, hi = Qo.item.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, Qo.item.type.defaultProps), Qo.item.props) : Qo.item.props, mi = hi.activeDot, bi = hi.hide, xi = hi.activeBar, $i = hi.activeShape, Ci = !!(!bi && ii && li && (mi || xi || $i)), Si = {};
        Zo !== "axis" && li && li.props.trigger === "click" ? Si = {
          onClick: combineEventHandlers(No.handleItemMouseEnter, Jo.props.onClick)
        } : Zo !== "axis" && (Si = {
          onMouseLeave: combineEventHandlers(No.handleItemMouseLeave, Jo.props.onMouseLeave),
          onMouseEnter: combineEventHandlers(No.handleItemMouseEnter, Jo.props.onMouseEnter)
        });
        var vi = /* @__PURE__ */ cloneElement(Jo, _objectSpread(_objectSpread({}, Qo.props), Si));
        function Pi(_i) {
          return typeof ai.dataKey == "function" ? ai.dataKey(_i.payload) : null;
        }
        if (Ci)
          if (ri >= 0) {
            var wi, gi;
            if (ai.dataKey && !ai.allowDuplicatedCategory) {
              var Ri = typeof ai.dataKey == "function" ? Pi : "payload.".concat(ai.dataKey.toString());
              wi = findEntryInArray(ci, Ri, ni), gi = fi && yi && findEntryInArray(yi, Ri, ni);
            } else
              wi = ci == null ? void 0 : ci[ri], gi = fi && yi && yi[ri];
            if ($i || xi) {
              var Ei = Jo.props.activeIndex !== void 0 ? Jo.props.activeIndex : ri;
              return [/* @__PURE__ */ cloneElement(Jo, _objectSpread(_objectSpread(_objectSpread({}, Qo.props), Si), {}, {
                activeIndex: Ei
              })), null, null];
            }
            if (!isNil$1(wi))
              return [vi].concat(_toConsumableArray(No.renderActivePoints({
                item: Qo,
                activePoint: wi,
                basePoint: gi,
                childIndex: ri,
                isRange: fi
              })));
          } else {
            var Ni, Ai = (Ni = No.getItemByXY(No.state.activeCoordinate)) !== null && Ni !== void 0 ? Ni : {
              graphicalItem: vi
            }, Yi = Ai.graphicalItem, Ui = Yi.item, us = Ui === void 0 ? Jo : Ui, ns = Yi.childIndex, Ti = _objectSpread(_objectSpread(_objectSpread({}, Qo.props), Si), {}, {
              activeIndex: ns
            });
            return [/* @__PURE__ */ cloneElement(us, Ti), null, null];
          }
        return fi ? [vi, null, null] : [vi, null];
      }), _defineProperty(No, "renderCustomized", function(Jo, ti, oi) {
        return /* @__PURE__ */ cloneElement(Jo, _objectSpread(_objectSpread({
          key: "recharts-customized-".concat(oi)
        }, No.props), No.state));
      }), _defineProperty(No, "renderMap", {
        CartesianGrid: {
          handler: renderAsIs,
          once: !0
        },
        ReferenceArea: {
          handler: No.renderReferenceElement
        },
        ReferenceLine: {
          handler: renderAsIs
        },
        ReferenceDot: {
          handler: No.renderReferenceElement
        },
        XAxis: {
          handler: renderAsIs
        },
        YAxis: {
          handler: renderAsIs
        },
        Brush: {
          handler: No.renderBrush,
          once: !0
        },
        Bar: {
          handler: No.renderGraphicChild
        },
        Line: {
          handler: No.renderGraphicChild
        },
        Area: {
          handler: No.renderGraphicChild
        },
        Radar: {
          handler: No.renderGraphicChild
        },
        RadialBar: {
          handler: No.renderGraphicChild
        },
        Scatter: {
          handler: No.renderGraphicChild
        },
        Pie: {
          handler: No.renderGraphicChild
        },
        Funnel: {
          handler: No.renderGraphicChild
        },
        Tooltip: {
          handler: No.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: No.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: No.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: No.renderPolarAxis
        },
        Customized: {
          handler: No.renderCustomized
        }
      }), No.clipPathId = "".concat((ko = Lo.id) !== null && ko !== void 0 ? ko : uniqueId("recharts"), "-clip"), No.throttleTriggeredAfterMouseMove = throttle$1(No.triggeredAfterMouseMove, (Ko = Lo.throttleDelay) !== null && Ko !== void 0 ? Ko : 1e3 / 60), No.state = {}, No;
    }
    return _inherits(Do, jo), _createClass(Do, [{
      key: "componentDidMount",
      value: function() {
        var ko, Ko;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (ko = this.props.margin.left) !== null && ko !== void 0 ? ko : 0,
            top: (Ko = this.props.margin.top) !== null && Ko !== void 0 ? Ko : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var ko = this.props, Ko = ko.children, No = ko.data, Jo = ko.height, ti = ko.layout, oi = findChildByType(Ko, Tooltip$1);
        if (oi) {
          var Qo = oi.props.defaultIndex;
          if (!(typeof Qo != "number" || Qo < 0 || Qo > this.state.tooltipTicks.length - 1)) {
            var Zo = this.state.tooltipTicks[Qo] && this.state.tooltipTicks[Qo].value, ei = getTooltipContent(this.state, No, Qo, Zo), ii = this.state.tooltipTicks[Qo].coordinate, ai = (this.state.offset.top + Jo) / 2, ri = ti === "horizontal", ni = ri ? {
              x: ii,
              y: ai
            } : {
              y: ii,
              x: ai
            }, si = this.state.formattedGraphicalItems.find(function(ui) {
              var ci = ui.item;
              return ci.type.name === "Scatter";
            });
            si && (ni = _objectSpread(_objectSpread({}, ni), si.props.points[Qo].tooltipPosition), ei = si.props.points[Qo].tooltipPayload);
            var li = {
              activeTooltipIndex: Qo,
              isTooltipActive: !0,
              activeLabel: Zo,
              activePayload: ei,
              activeCoordinate: ni
            };
            this.setState(li), this.renderCursor(oi), this.accessibilityManager.setIndex(Qo);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(ko, Ko) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== Ko.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== ko.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== ko.margin) {
          var No, Jo;
          this.accessibilityManager.setDetails({
            offset: {
              left: (No = this.props.margin.left) !== null && No !== void 0 ? No : 0,
              top: (Jo = this.props.margin.top) !== null && Jo !== void 0 ? Jo : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(ko) {
        isChildrenEqual([findChildByType(ko.children, Tooltip$1)], [findChildByType(this.props.children, Tooltip$1)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var ko = findChildByType(this.props.children, Tooltip$1);
        if (ko && typeof ko.props.shared == "boolean") {
          var Ko = ko.props.shared ? "axis" : "item";
          return Co.indexOf(Ko) >= 0 ? Ko : vo;
        }
        return vo;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(ko) {
        if (!this.container)
          return null;
        var Ko = this.container, No = Ko.getBoundingClientRect(), Jo = getOffset(No), ti = {
          chartX: Math.round(ko.pageX - Jo.left),
          chartY: Math.round(ko.pageY - Jo.top)
        }, oi = No.width / Ko.offsetWidth || 1, Qo = this.inRange(ti.chartX, ti.chartY, oi);
        if (!Qo)
          return null;
        var Zo = this.state, ei = Zo.xAxisMap, ii = Zo.yAxisMap, ai = this.getTooltipEventType();
        if (ai !== "axis" && ei && ii) {
          var ri = getAnyElementOfObject(ei).scale, ni = getAnyElementOfObject(ii).scale, si = ri && ri.invert ? ri.invert(ti.chartX) : null, li = ni && ni.invert ? ni.invert(ti.chartY) : null;
          return _objectSpread(_objectSpread({}, ti), {}, {
            xValue: si,
            yValue: li
          });
        }
        var ui = getTooltipData(this.state, this.props.data, this.props.layout, Qo);
        return ui ? _objectSpread(_objectSpread({}, ti), ui) : null;
      }
    }, {
      key: "inRange",
      value: function(ko, Ko) {
        var No = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, Jo = this.props.layout, ti = ko / No, oi = Ko / No;
        if (Jo === "horizontal" || Jo === "vertical") {
          var Qo = this.state.offset, Zo = ti >= Qo.left && ti <= Qo.left + Qo.width && oi >= Qo.top && oi <= Qo.top + Qo.height;
          return Zo ? {
            x: ti,
            y: oi
          } : null;
        }
        var ei = this.state, ii = ei.angleAxisMap, ai = ei.radiusAxisMap;
        if (ii && ai) {
          var ri = getAnyElementOfObject(ii);
          return inRangeOfSector({
            x: ti,
            y: oi
          }, ri);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var ko = this.props.children, Ko = this.getTooltipEventType(), No = findChildByType(ko, Tooltip$1), Jo = {};
        No && Ko === "axis" && (No.props.trigger === "click" ? Jo = {
          onClick: this.handleClick
        } : Jo = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var ti = adaptEventHandlers(this.props, this.handleOuterEvent);
        return _objectSpread(_objectSpread({}, ti), Jo);
      }
    }, {
      key: "addListener",
      value: function() {
        eventCenter.on(SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        eventCenter.removeListener(SYNC_EVENT, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(ko, Ko, No) {
        for (var Jo = this.state.formattedGraphicalItems, ti = 0, oi = Jo.length; ti < oi; ti++) {
          var Qo = Jo[ti];
          if (Qo.item === ko || Qo.props.key === ko.key || Ko === getDisplayName(Qo.item.type) && No === Qo.childIndex)
            return Qo;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var ko = this.clipPathId, Ko = this.state.offset, No = Ko.left, Jo = Ko.top, ti = Ko.height, oi = Ko.width;
        return /* @__PURE__ */ React__default.createElement("defs", null, /* @__PURE__ */ React__default.createElement("clipPath", {
          id: ko
        }, /* @__PURE__ */ React__default.createElement("rect", {
          x: No,
          y: Jo,
          height: ti,
          width: oi
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var ko = this.state.xAxisMap;
        return ko ? Object.entries(ko).reduce(function(Ko, No) {
          var Jo = _slicedToArray(No, 2), ti = Jo[0], oi = Jo[1];
          return _objectSpread(_objectSpread({}, Ko), {}, _defineProperty({}, ti, oi.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var ko = this.state.yAxisMap;
        return ko ? Object.entries(ko).reduce(function(Ko, No) {
          var Jo = _slicedToArray(No, 2), ti = Jo[0], oi = Jo[1];
          return _objectSpread(_objectSpread({}, Ko), {}, _defineProperty({}, ti, oi.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(ko) {
        var Ko;
        return (Ko = this.state.xAxisMap) === null || Ko === void 0 || (Ko = Ko[ko]) === null || Ko === void 0 ? void 0 : Ko.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(ko) {
        var Ko;
        return (Ko = this.state.yAxisMap) === null || Ko === void 0 || (Ko = Ko[ko]) === null || Ko === void 0 ? void 0 : Ko.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(ko) {
        var Ko = this.state, No = Ko.formattedGraphicalItems, Jo = Ko.activeItem;
        if (No && No.length)
          for (var ti = 0, oi = No.length; ti < oi; ti++) {
            var Qo = No[ti], Zo = Qo.props, ei = Qo.item, ii = ei.type.defaultProps !== void 0 ? _objectSpread(_objectSpread({}, ei.type.defaultProps), ei.props) : ei.props, ai = getDisplayName(ei.type);
            if (ai === "Bar") {
              var ri = (Zo.data || []).find(function(ui) {
                return isInRectangle(ko, ui);
              });
              if (ri)
                return {
                  graphicalItem: Qo,
                  payload: ri
                };
            } else if (ai === "RadialBar") {
              var ni = (Zo.data || []).find(function(ui) {
                return inRangeOfSector(ko, ui);
              });
              if (ni)
                return {
                  graphicalItem: Qo,
                  payload: ni
                };
            } else if (isFunnel(Qo, Jo) || isPie(Qo, Jo) || isScatter(Qo, Jo)) {
              var si = getActiveShapeIndexForTooltip({
                graphicalItem: Qo,
                activeTooltipItem: Jo,
                itemData: ii.data
              }), li = ii.activeIndex === void 0 ? si : ii.activeIndex;
              return {
                graphicalItem: _objectSpread(_objectSpread({}, Qo), {}, {
                  childIndex: li
                }),
                payload: isScatter(Qo, Jo) ? ii.data[si] : Qo.props.data[si]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var ko = this;
        if (!validateWidthHeight(this))
          return null;
        var Ko = this.props, No = Ko.children, Jo = Ko.className, ti = Ko.width, oi = Ko.height, Qo = Ko.style, Zo = Ko.compact, ei = Ko.title, ii = Ko.desc, ai = _objectWithoutProperties(Ko, _excluded2), ri = filterProps(ai, !1);
        if (Zo)
          return /* @__PURE__ */ React__default.createElement(ChartLayoutContextProvider, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ React__default.createElement(Surface, _extends({}, ri, {
            width: ti,
            height: oi,
            title: ei,
            desc: ii
          }), this.renderClipPath(), renderByOrder(No, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var ni, si;
          ri.tabIndex = (ni = this.props.tabIndex) !== null && ni !== void 0 ? ni : 0, ri.role = (si = this.props.role) !== null && si !== void 0 ? si : "application", ri.onKeyDown = function(ui) {
            ko.accessibilityManager.keyboardEvent(ui);
          }, ri.onFocus = function() {
            ko.accessibilityManager.focus();
          };
        }
        var li = this.parseEventsOfWrapper();
        return /* @__PURE__ */ React__default.createElement(ChartLayoutContextProvider, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ React__default.createElement("div", _extends({
          className: clsx("recharts-wrapper", Jo),
          style: _objectSpread({
            position: "relative",
            cursor: "default",
            width: ti,
            height: oi
          }, Qo)
        }, li, {
          ref: function(ci) {
            ko.container = ci;
          }
        }), /* @__PURE__ */ React__default.createElement(Surface, _extends({}, ri, {
          width: ti,
          height: oi,
          title: ei,
          desc: ii,
          style: FULL_WIDTH_AND_HEIGHT
        }), this.renderClipPath(), renderByOrder(No, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  }(Component);
  _defineProperty(Ao, "displayName", ho), _defineProperty(Ao, "defaultProps", _objectSpread({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, Ro)), _defineProperty(Ao, "getDerivedStateFromProps", function(jo, Do) {
    var Lo = jo.dataKey, ko = jo.data, Ko = jo.children, No = jo.width, Jo = jo.height, ti = jo.layout, oi = jo.stackOffset, Qo = jo.margin, Zo = Do.dataStartIndex, ei = Do.dataEndIndex;
    if (Do.updateId === void 0) {
      var ii = createDefaultState(jo);
      return _objectSpread(_objectSpread(_objectSpread({}, ii), {}, {
        updateId: 0
      }, Io(_objectSpread(_objectSpread({
        props: jo
      }, ii), {}, {
        updateId: 0
      }), Do)), {}, {
        prevDataKey: Lo,
        prevData: ko,
        prevWidth: No,
        prevHeight: Jo,
        prevLayout: ti,
        prevStackOffset: oi,
        prevMargin: Qo,
        prevChildren: Ko
      });
    }
    if (Lo !== Do.prevDataKey || ko !== Do.prevData || No !== Do.prevWidth || Jo !== Do.prevHeight || ti !== Do.prevLayout || oi !== Do.prevStackOffset || !shallowEqual(Qo, Do.prevMargin)) {
      var ai = createDefaultState(jo), ri = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: Do.chartX,
        chartY: Do.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: Do.isTooltipActive
      }, ni = _objectSpread(_objectSpread({}, getTooltipData(Do, ko, ti)), {}, {
        updateId: Do.updateId + 1
      }), si = _objectSpread(_objectSpread(_objectSpread({}, ai), ri), ni);
      return _objectSpread(_objectSpread(_objectSpread({}, si), Io(_objectSpread({
        props: jo
      }, si), Do)), {}, {
        prevDataKey: Lo,
        prevData: ko,
        prevWidth: No,
        prevHeight: Jo,
        prevLayout: ti,
        prevStackOffset: oi,
        prevMargin: Qo,
        prevChildren: Ko
      });
    }
    if (!isChildrenEqual(Ko, Do.prevChildren)) {
      var li, ui, ci, fi, yi = findChildByType(Ko, Brush), hi = yi && (li = (ui = yi.props) === null || ui === void 0 ? void 0 : ui.startIndex) !== null && li !== void 0 ? li : Zo, mi = yi && (ci = (fi = yi.props) === null || fi === void 0 ? void 0 : fi.endIndex) !== null && ci !== void 0 ? ci : ei, bi = hi !== Zo || mi !== ei, xi = !isNil$1(ko), $i = xi && !bi ? Do.updateId : Do.updateId + 1;
      return _objectSpread(_objectSpread({
        updateId: $i
      }, Io(_objectSpread(_objectSpread({
        props: jo
      }, Do), {}, {
        updateId: $i,
        dataStartIndex: hi,
        dataEndIndex: mi
      }), Do)), {}, {
        prevChildren: Ko,
        dataStartIndex: hi,
        dataEndIndex: mi
      });
    }
    return null;
  }), _defineProperty(Ao, "renderActiveDot", function(jo, Do, Lo) {
    var ko;
    return /* @__PURE__ */ isValidElement(jo) ? ko = /* @__PURE__ */ cloneElement(jo, Do) : isFunction$3(jo) ? ko = jo(Do) : ko = /* @__PURE__ */ React__default.createElement(Dot, Do), /* @__PURE__ */ React__default.createElement(Layer, {
      className: "recharts-active-dot",
      key: Lo
    }, ko);
  });
  var Oo = /* @__PURE__ */ forwardRef$1(function(Do, Lo) {
    return /* @__PURE__ */ React__default.createElement(Ao, _extends({}, Do, {
      ref: Lo
    }));
  });
  return Oo.displayName = Ao.displayName, Oo;
}, BarChart = generateCategoricalChart({
  chartName: "BarChart",
  GraphicalChild: Bar,
  defaultTooltipEventType: "axis",
  validateTooltipEventTypes: ["axis", "item"],
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: XAxis
  }, {
    axisType: "yAxis",
    AxisComp: YAxis
  }],
  formatAxisMap
});
const isHexColor = (Kt, uo, ho) => {
  const go = /^#(?:[A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/, bo = Kt[uo];
  return bo ? go.test(bo) ? null : new Error(`Invalid value passed to attribute ${uo} in ${ho}. Expected valid hex-color notation.`) : null;
}, formatLegendText = (Kt) => Kt.replace(/[-_]/g, " "), formatLegend = (Kt) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
  color: "var(--vp-dark-blue)",
  display: "inline-block",
  marginLeft: "0.15em",
  whiteSpace: "nowrap",
  fontSize: "1.3em",
  fontFamily: "var(--vp-font-open-sans-condensed-semibold)"
}, children: formatLegendText(Kt) }), CustomYAxisTick = ({
  x: Kt,
  y: uo,
  payload: ho
}) => {
  const go = ho.value.length > 18 ? `${ho.value.slice(0, 18)}...` : ho.value;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsxRuntimeExports.jsxs("text", { x: Kt - 10, y: uo, textAnchor: "end", fill: "#666", dy: 5, "aria-hidden": "false", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("title", { children: ho.value }),
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx("tspan", { "aria-label": ho.value, children: go }),
    " "
  ] }) });
};
CustomYAxisTick.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  payload: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
};
const Tooltip = ({
  active: Kt,
  payload: uo,
  label: ho,
  colors: go
}) => Kt && uo ? /* @__PURE__ */ jsxRuntimeExports.jsxs("custom-tooltip", { children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx("h2", { children: `${ho}` }),
  /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: uo.map((bo, vo) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
      backgroundColor: go[vo]
    } }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("i", { children: [
      formatLegendText(bo.name),
      ":"
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: bo.value })
  ] }, vo)) })
] }) : null;
Tooltip.propTypes = {
  /**
   * Whether the tooltip is active/visible.
   */
  active: PropTypes.bool,
  /**
   * The data passed to the tooltip, typically an array of objects.
   * Each object contains name and value for each data point.
   */
  payload: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
  })),
  /**
   * The label to be displayed in the tooltip.
   */
  label: PropTypes.string,
  /**
   * The colors used for each data point in the tooltip.
   * This should be an array of hex color strings.
   */
  colors: PropTypes.arrayOf(PropTypes.string)
};
const HorizontalBar = (Kt) => {
  const {
    width: uo = "100%",
    yDataKey: ho = "yAxis",
    yStrokeColor: go = "#112E51",
    slots: bo,
    data: vo = [
      { xAxis: 10, yAxis: "Item 1" },
      { xAxis: 20, yAxis: "Item 2" },
      { xAxis: 30, yAxis: "Item 3" }
    ],
    dataKeys: Po = ["xAxis"],
    colors: Co = [
      "#00C69E",
      "#21528C",
      "#0071BC",
      "#FFA100",
      "#5B616B"
    ],
    addLegend: So = !0,
    addTooltip: wo = !0,
    xAxisDataType: Eo = "number",
    title: Ro,
    barHeight: _o = 45
  } = Kt || {}, {
    chart: Io = {},
    yAxis: Ao = {},
    xAxis: Oo = {},
    bars: jo = {},
    legend: Do = {},
    title: Lo = {},
    root: ko = {}
  } = bo || {}, No = vo.length * _o + 38;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-horizontal-bar", { ...ko, role: "presentation", children: [
    is_1.string(Ro) && Ro.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { title: Ro, ...Lo }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ResponsiveContainer, { height: No, width: uo, style: { height: No }, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      BarChart,
      {
        ...Io,
        data: vo,
        layout: "vertical",
        height: No,
        margin: {
          top: 16,
          right: 16,
          bottom: -60,
          left: 120
        },
        role: "img",
        "aria-label": `Bar chart showing ${Ro}.`,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(CartesianGrid, { horizontal: !1, vertical: !0 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            YAxis,
            {
              ...Ao,
              type: "category",
              dataKey: ho,
              stroke: go,
              tick: /* @__PURE__ */ jsxRuntimeExports.jsx(CustomYAxisTick, {}),
              "aria-label": "Y Axis"
            }
          ),
          wo && /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip$1, { content: /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { colors: Co }) }),
          is_1.array(Po) && Po.map((Jo, ti) => /* @__PURE__ */ createElement(
            Bar,
            {
              ...jo,
              key: Jo,
              dataKey: Jo,
              fill: Co[ti],
              role: "graphics-symbol",
              "aria-label": `Bar representing ${formatLegendText(Jo)}.`,
              tabIndex: 0
            }
          )),
          So && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Legend,
            {
              ...Do,
              formatter: formatLegend,
              role: "list",
              "aria-label": "Legend",
              wrapperStyle: {
                position: "sticky",
                bottom: "0",
                width: "100%",
                left: "120px",
                paddingLeft: "180px"
              },
              payload: Po.map((Jo, ti) => ({
                value: Jo,
                type: "rect",
                color: Co[ti]
              }))
            }
          ),
          Po.length > 0 && /* @__PURE__ */ jsxRuntimeExports.jsx(
            XAxis,
            {
              ...Oo,
              type: Eo,
              orientation: "bottom",
              xAxisId: 0,
              stroke: "#000"
            }
          )
        ]
      }
    ) })
  ] });
};
HorizontalBar.propTypes = {
  /**
   * The width to make the secondary container.
   *
   * Defaults to '100%'.
   */
  width: PropTypes.string,
  /**
   * The height to make the secondary container.
   *
   * Defaults to '100%'.
   */
  height: PropTypes.string,
  /**
   * The property name in a record which corresponds to the data to show along the y-axis.
   */
  yDataKey: PropTypes.string.isRequired,
  /**
   * The color for the text and ticks making up the y-axis.
   *
   * Must be a valid HTML hex-color.
   */
  yStrokeColor: isHexColor,
  /**
   * Indicates what kind of data is being represented by the x-axis.
   *
   * Defaults to 'number'.
   */
  xAxisDataType: PropTypes.oneOf(["number", "category"]),
  /**
   * A list of colors to use when rendering the individual bars.
   */
  colors: PropTypes.arrayOf(isHexColor),
  /**
   * A list of objects representing the record data to display.
   */
  data: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  /**
   * A list of keys to use to pull the y-axis information.
   */
  dataKeys: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  /**
   * Indicates that a Legend component should be displayed
   *
   * Defaults to true.
   */
  addLegend: PropTypes.bool,
  /**
   * Indicates that Tooltips will be displayed when hovering over a bar.
   *
   * Defaults to true.
   */
  addTooltip: PropTypes.bool,
  /**
   * Extra attributes to add to specific sections of the component.
   * Possible properties are:
   * - chart: a set of attributes to apply to the BarChart component
   * - yAxis: a set of attributes to apply to the y-axis component
   * - xAxis: a set of attributes to apply to the x-axis component
   * - bar: a set of attributes to apply to each Bar component
   * - tooltip: a set of attributes to apply to the Tooltip component
   * - legend: a set of attributes to apply to the Legend component
   * - title: a set of attributes to apply to the Title component
   * - root: a set of attributes to apply to the root container
   */
  slots: PropTypes.shape({
    chart: PropTypes.object,
    xAxis: PropTypes.object,
    yAxis: PropTypes.object,
    bars: PropTypes.object,
    legend: PropTypes.object,
    tooltip: PropTypes.object,
    title: PropTypes.object,
    root: PropTypes.object
  }),
  /**
   * The title to display above the chart.
   */
  title: PropTypes.string,
  /**
   * The height each item in the chart should be.
   */
  barHeight: PropTypes.number
};
const Badge = (Kt) => {
  const {
    anchorOrigin: uo = {
      vertical: "top",
      horizontal: "right"
    },
    badge: ho,
    badgeColor: go,
    badgeTextColor: bo,
    baseColor: vo,
    duoTone: Po,
    children: Co,
    label: So,
    max: wo,
    showZero: Eo = !0,
    type: Ro,
    ..._o
  } = Kt, Io = Po ? {
    "--fa-primary-color": Po,
    "--fa-secondary-color": go,
    "--fa-secondary-opacity": 1
  } : {
    backgroundColor: go,
    color: bo
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-badge", { role: "img", "aria-label": So, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    Badge$1,
    {
      role: "img",
      "aria-hidden": !0,
      anchorOrigin: {
        ...uo
      },
      badgeContent: ho,
      max: wo,
      showZero: Eo,
      slotProps: {
        root: {
          style: {
            color: vo
          },
          className: Ro
        },
        badge: {
          style: {
            ...Io
          },
          className: Ro
        }
      },
      ..._o,
      children: Ro !== "single" && Ro !== "single-square" && Co.length > 0 && Co
    }
  ) });
};
Badge.propTypes = {
  /**
   * Placement of the badge on the base icon. Utilized for styles other than 'single' and 'single-square'
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(["left", "right"]),
    vertical: PropTypes.oneOf(["bottom", "top"])
  }),
  /**
   * The text/element that is shown as the badge -- making not required for the time
   * being because we are using this component in stream admin and are not adding the badges for MVP
  */
  badge: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.string,
    PropTypes.number,
    PropTypes.element
  ]),
  /**
   * The color of the badge
  */
  badgeColor: PropTypes.string.isRequired,
  /**
   * The color of the text within the badge, if any
  */
  badgeTextColor: PropTypes.string,
  /**
  * The color of the base icon. Required if any elements are passed in as children
   */
  baseColor: PropTypes.string,
  /**
  * The content passed as children (slots)
  */
  children: PropTypes.node,
  /**
  * Color for the fill in the fontawesome icon.
  * Used for type 'double' and when the badge is a fontawesome icon with duotone styles (i.e. color filled in)
  * Note: the badge must have the class 'fa-duotone' for the styles to take effect.
  * Refer to each fontawesome  icon's documentation for details
  */
  duoTone: PropTypes.string,
  /**
  * Accessible name to give to the element + badge
  */
  label: PropTypes.string,
  /**
  * Max number to show when the badge has numerical content.
  * Numbers will show as <max>+ if the content is over the max number
  */
  max: PropTypes.number,
  /**
  * Whether to show badge when the numerical content in the badge is 0
  */
  showZero: PropTypes.bool,
  /**
  * Styling type for the base + badge
  */
  type: PropTypes.oneOf([
    "single",
    "single-square",
    "double",
    "doubleWithText",
    "doubleWithText-square"
  ])
};
var u$2 = Object.defineProperty, a$1 = (Kt, uo) => u$2(Kt, "name", { value: uo, configurable: !0 }), y$1 = (() => {
  let Kt;
  return typeof window < "u" ? Kt = window : typeof globalThis < "u" ? Kt = globalThis : typeof global < "u" ? Kt = global : typeof self < "u" ? Kt = self : Kt = {}, Kt;
})(), { LOGLEVEL: b$3 } = y$1, t$2 = {
  trace: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
  silent: 10
}, L$3 = b$3, i$2 = t$2[L$3] || t$2.info, s$2 = {
  trace: /* @__PURE__ */ a$1((Kt, ...uo) => {
    i$2 <= t$2.trace && console.trace(Kt, ...uo);
  }, "trace"),
  debug: /* @__PURE__ */ a$1((Kt, ...uo) => {
    i$2 <= t$2.debug && console.debug(Kt, ...uo);
  }, "debug"),
  info: /* @__PURE__ */ a$1((Kt, ...uo) => {
    i$2 <= t$2.info && console.info(Kt, ...uo);
  }, "info"),
  warn: /* @__PURE__ */ a$1((Kt, ...uo) => {
    i$2 <= t$2.warn && console.warn(Kt, ...uo);
  }, "warn"),
  error: /* @__PURE__ */ a$1((Kt, ...uo) => {
    i$2 <= t$2.error && console.error(Kt, ...uo);
  }, "error"),
  log: /* @__PURE__ */ a$1((Kt, ...uo) => {
    i$2 < t$2.silent && console.log(Kt, ...uo);
  }, "log")
}, c$1 = /* @__PURE__ */ new Set(), n$1 = /* @__PURE__ */ a$1((Kt) => (uo, ...ho) => {
  if (!c$1.has(uo))
    return c$1.add(uo), s$2[Kt](uo, ...ho);
}, "once");
n$1.clear = () => c$1.clear();
n$1.trace = n$1("trace");
n$1.debug = n$1("debug");
n$1.info = n$1("info");
n$1.warn = n$1("warn");
n$1.error = n$1("error");
n$1.log = n$1("log");
var m$2 = n$1("warn"), r$2 = /* @__PURE__ */ a$1((Kt) => (...uo) => {
  let ho = [];
  if (uo.length) {
    let go = /<span\s+style=(['"])([^'"]*)\1\s*>/gi, bo = /<\/span>/gi, vo;
    for (ho.push(uo[0].replace(go, "%c").replace(bo, "%c")); vo = go.exec(uo[0]); )
      ho.push(vo[2]), ho.push("");
    for (let Po = 1; Po < uo.length; Po++)
      ho.push(uo[Po]);
  }
  s$2[Kt].apply(s$2, ho);
}, "pretty");
r$2.trace = r$2("trace");
r$2.debug = r$2("debug");
r$2.info = r$2("info");
r$2.warn = r$2("warn");
r$2.error = r$2("error");
var _$1 = /* @__PURE__ */ ((Kt) => (Kt.CHANNEL_WS_DISCONNECT = "channelWSDisconnect", Kt.CHANNEL_CREATED = "channelCreated", Kt.CONFIG_ERROR = "configError", Kt.STORY_INDEX_INVALIDATED = "storyIndexInvalidated", Kt.STORY_SPECIFIED = "storySpecified", Kt.SET_CONFIG = "setConfig", Kt.SET_STORIES = "setStories", Kt.SET_INDEX = "setIndex", Kt.SET_CURRENT_STORY = "setCurrentStory", Kt.CURRENT_STORY_WAS_SET = "currentStoryWasSet", Kt.FORCE_RE_RENDER = "forceReRender", Kt.FORCE_REMOUNT = "forceRemount", Kt.PRELOAD_ENTRIES = "preloadStories", Kt.STORY_PREPARED = "storyPrepared", Kt.DOCS_PREPARED = "docsPrepared", Kt.STORY_CHANGED = "storyChanged", Kt.STORY_UNCHANGED = "storyUnchanged", Kt.STORY_RENDERED = "storyRendered", Kt.STORY_MISSING = "storyMissing", Kt.STORY_ERRORED = "storyErrored", Kt.STORY_THREW_EXCEPTION = "storyThrewException", Kt.STORY_RENDER_PHASE_CHANGED = "storyRenderPhaseChanged", Kt.PLAY_FUNCTION_THREW_EXCEPTION = "playFunctionThrewException", Kt.UNHANDLED_ERRORS_WHILE_PLAYING = "unhandledErrorsWhilePlaying", Kt.UPDATE_STORY_ARGS = "updateStoryArgs", Kt.STORY_ARGS_UPDATED = "storyArgsUpdated", Kt.RESET_STORY_ARGS = "resetStoryArgs", Kt.SET_FILTER = "setFilter", Kt.SET_GLOBALS = "setGlobals", Kt.UPDATE_GLOBALS = "updateGlobals", Kt.GLOBALS_UPDATED = "globalsUpdated", Kt.REGISTER_SUBSCRIPTION = "registerSubscription", Kt.PREVIEW_KEYDOWN = "previewKeydown", Kt.PREVIEW_BUILDER_PROGRESS = "preview_builder_progress", Kt.SELECT_STORY = "selectStory", Kt.STORIES_COLLAPSE_ALL = "storiesCollapseAll", Kt.STORIES_EXPAND_ALL = "storiesExpandAll", Kt.DOCS_RENDERED = "docsRendered", Kt.SHARED_STATE_CHANGED = "sharedStateChanged", Kt.SHARED_STATE_SET = "sharedStateSet", Kt.NAVIGATE_URL = "navigateUrl", Kt.UPDATE_QUERY_PARAMS = "updateQueryParams", Kt.REQUEST_WHATS_NEW_DATA = "requestWhatsNewData", Kt.RESULT_WHATS_NEW_DATA = "resultWhatsNewData", Kt.SET_WHATS_NEW_CACHE = "setWhatsNewCache", Kt.TOGGLE_WHATS_NEW_NOTIFICATIONS = "toggleWhatsNewNotifications", Kt.TELEMETRY_ERROR = "telemetryError", Kt.FILE_COMPONENT_SEARCH_REQUEST = "fileComponentSearchRequest", Kt.FILE_COMPONENT_SEARCH_RESPONSE = "fileComponentSearchResponse", Kt.SAVE_STORY_REQUEST = "saveStoryRequest", Kt.SAVE_STORY_RESPONSE = "saveStoryResponse", Kt.ARGTYPES_INFO_REQUEST = "argtypesInfoRequest", Kt.ARGTYPES_INFO_RESPONSE = "argtypesInfoResponse", Kt.CREATE_NEW_STORYFILE_REQUEST = "createNewStoryfileRequest", Kt.CREATE_NEW_STORYFILE_RESPONSE = "createNewStoryfileResponse", Kt.TESTING_MODULE_CRASH_REPORT = "testingModuleCrashReport", Kt.TESTING_MODULE_PROGRESS_REPORT = "testingModuleProgressReport", Kt.TESTING_MODULE_RUN_REQUEST = "testingModuleRunRequest", Kt.TESTING_MODULE_RUN_ALL_REQUEST = "testingModuleRunAllRequest", Kt.TESTING_MODULE_CANCEL_TEST_RUN_REQUEST = "testingModuleCancelTestRunRequest", Kt.TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE = "testingModuleCancelTestRunResponse", Kt.TESTING_MODULE_WATCH_MODE_REQUEST = "testingModuleWatchModeRequest", Kt))(_$1 || {}), R$2 = _$1, {
  CHANNEL_WS_DISCONNECT: S$2,
  CHANNEL_CREATED: T$1,
  CONFIG_ERROR: N$2,
  CREATE_NEW_STORYFILE_REQUEST: O$3,
  CREATE_NEW_STORYFILE_RESPONSE: A$1,
  CURRENT_STORY_WAS_SET: r$1,
  DOCS_PREPARED: D$3,
  DOCS_RENDERED: I$2,
  FILE_COMPONENT_SEARCH_REQUEST: C$2,
  FILE_COMPONENT_SEARCH_RESPONSE: o$1,
  FORCE_RE_RENDER: L$2,
  FORCE_REMOUNT: P$3,
  GLOBALS_UPDATED: U$3,
  NAVIGATE_URL: G$3,
  PLAY_FUNCTION_THREW_EXCEPTION: a,
  UNHANDLED_ERRORS_WHILE_PLAYING: Y$2,
  PRELOAD_ENTRIES: t$1,
  PREVIEW_BUILDER_PROGRESS: e,
  PREVIEW_KEYDOWN: W$2,
  REGISTER_SUBSCRIPTION: d,
  RESET_STORY_ARGS: H$2,
  SELECT_STORY: l$1,
  SET_CONFIG: i$1,
  SET_CURRENT_STORY: p$1,
  SET_FILTER: M$4,
  SET_GLOBALS: u$1,
  SET_INDEX: F$3,
  SET_STORIES: s$1,
  SHARED_STATE_CHANGED: c,
  SHARED_STATE_SET: g,
  STORIES_COLLAPSE_ALL: y,
  STORIES_EXPAND_ALL: h$1,
  STORY_ARGS_UPDATED: Q,
  STORY_CHANGED: f$2,
  STORY_ERRORED: x$3,
  STORY_INDEX_INVALIDATED: m$1,
  STORY_MISSING: V$1,
  STORY_PREPARED: w$2,
  STORY_RENDER_PHASE_CHANGED: B$2,
  STORY_RENDERED: X$2,
  STORY_SPECIFIED: q$3,
  STORY_THREW_EXCEPTION: b$2,
  STORY_UNCHANGED: K$2,
  UPDATE_GLOBALS: j$1,
  UPDATE_QUERY_PARAMS: k$4,
  UPDATE_STORY_ARGS: n,
  REQUEST_WHATS_NEW_DATA: z$3,
  RESULT_WHATS_NEW_DATA: J$2,
  SET_WHATS_NEW_CACHE: Z,
  TOGGLE_WHATS_NEW_NOTIFICATIONS: $$3,
  TELEMETRY_ERROR: v$3,
  SAVE_STORY_REQUEST: EE,
  SAVE_STORY_RESPONSE: _E,
  ARGTYPES_INFO_REQUEST: RE,
  ARGTYPES_INFO_RESPONSE: SE,
  TESTING_MODULE_CRASH_REPORT: TE,
  TESTING_MODULE_PROGRESS_REPORT: NE,
  TESTING_MODULE_RUN_REQUEST: OE,
  TESTING_MODULE_RUN_ALL_REQUEST: AE,
  TESTING_MODULE_CANCEL_TEST_RUN_REQUEST: rE,
  TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE: DE,
  TESTING_MODULE_WATCH_MODE_REQUEST: IE
} = _$1;
const Qn$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ARGTYPES_INFO_REQUEST: RE,
  ARGTYPES_INFO_RESPONSE: SE,
  CHANNEL_CREATED: T$1,
  CHANNEL_WS_DISCONNECT: S$2,
  CONFIG_ERROR: N$2,
  CREATE_NEW_STORYFILE_REQUEST: O$3,
  CREATE_NEW_STORYFILE_RESPONSE: A$1,
  CURRENT_STORY_WAS_SET: r$1,
  DOCS_PREPARED: D$3,
  DOCS_RENDERED: I$2,
  FILE_COMPONENT_SEARCH_REQUEST: C$2,
  FILE_COMPONENT_SEARCH_RESPONSE: o$1,
  FORCE_REMOUNT: P$3,
  FORCE_RE_RENDER: L$2,
  GLOBALS_UPDATED: U$3,
  NAVIGATE_URL: G$3,
  PLAY_FUNCTION_THREW_EXCEPTION: a,
  PRELOAD_ENTRIES: t$1,
  PREVIEW_BUILDER_PROGRESS: e,
  PREVIEW_KEYDOWN: W$2,
  REGISTER_SUBSCRIPTION: d,
  REQUEST_WHATS_NEW_DATA: z$3,
  RESET_STORY_ARGS: H$2,
  RESULT_WHATS_NEW_DATA: J$2,
  SAVE_STORY_REQUEST: EE,
  SAVE_STORY_RESPONSE: _E,
  SELECT_STORY: l$1,
  SET_CONFIG: i$1,
  SET_CURRENT_STORY: p$1,
  SET_FILTER: M$4,
  SET_GLOBALS: u$1,
  SET_INDEX: F$3,
  SET_STORIES: s$1,
  SET_WHATS_NEW_CACHE: Z,
  SHARED_STATE_CHANGED: c,
  SHARED_STATE_SET: g,
  STORIES_COLLAPSE_ALL: y,
  STORIES_EXPAND_ALL: h$1,
  STORY_ARGS_UPDATED: Q,
  STORY_CHANGED: f$2,
  STORY_ERRORED: x$3,
  STORY_INDEX_INVALIDATED: m$1,
  STORY_MISSING: V$1,
  STORY_PREPARED: w$2,
  STORY_RENDERED: X$2,
  STORY_RENDER_PHASE_CHANGED: B$2,
  STORY_SPECIFIED: q$3,
  STORY_THREW_EXCEPTION: b$2,
  STORY_UNCHANGED: K$2,
  TELEMETRY_ERROR: v$3,
  TESTING_MODULE_CANCEL_TEST_RUN_REQUEST: rE,
  TESTING_MODULE_CANCEL_TEST_RUN_RESPONSE: DE,
  TESTING_MODULE_CRASH_REPORT: TE,
  TESTING_MODULE_PROGRESS_REPORT: NE,
  TESTING_MODULE_RUN_ALL_REQUEST: AE,
  TESTING_MODULE_RUN_REQUEST: OE,
  TESTING_MODULE_WATCH_MODE_REQUEST: IE,
  TOGGLE_WHATS_NEW_NOTIFICATIONS: $$3,
  UNHANDLED_ERRORS_WHILE_PLAYING: Y$2,
  UPDATE_GLOBALS: j$1,
  UPDATE_QUERY_PARAMS: k$4,
  UPDATE_STORY_ARGS: n,
  default: R$2
}, Symbol.toStringTag, { value: "Module" }));
var Qt$1 = Object.create, st$1 = Object.defineProperty, te$1 = Object.getOwnPropertyDescriptor, ee$1 = Object.getOwnPropertyNames, re$1 = Object.getPrototypeOf, ne$1 = Object.prototype.hasOwnProperty, i = (Kt, uo) => st$1(Kt, "name", { value: uo, configurable: !0 }), U$2 = /* @__PURE__ */ ((Kt) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(Kt, {
  get: (uo, ho) => (typeof require < "u" ? require : uo)[ho]
}) : Kt)(function(Kt) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + Kt + '" is not supported');
}), oe$2 = (Kt, uo) => () => (uo || Kt((uo = { exports: {} }).exports, uo), uo.exports), ae = (Kt, uo, ho, go) => {
  if (uo && typeof uo == "object" || typeof uo == "function")
    for (let bo of ee$1(uo))
      !ne$1.call(Kt, bo) && bo !== ho && st$1(Kt, bo, { get: () => uo[bo], enumerable: !(go = te$1(uo, bo)) || go.enumerable });
  return Kt;
}, ie = (Kt, uo, ho) => (ho = Kt != null ? Qt$1(re$1(Kt)) : {}, ae(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  st$1(ho, "default", { value: Kt, enumerable: !0 }),
  Kt
)), At$1 = oe$2((Kt, uo) => {
  (function(ho) {
    if (typeof Kt == "object" && typeof uo < "u")
      uo.exports = ho();
    else if (typeof define == "function" && define.amd)
      define([], ho);
    else {
      var go;
      typeof window < "u" ? go = window : typeof global < "u" ? go = global : typeof self < "u" ? go = self : go = this, go.memoizerific = ho();
    }
  })(function() {
    return (/* @__PURE__ */ i(function ho(go, bo, vo) {
      function Po(wo, Eo) {
        if (!bo[wo]) {
          if (!go[wo]) {
            var Ro = typeof U$2 == "function" && U$2;
            if (!Eo && Ro) return Ro(wo, !0);
            if (Co) return Co(wo, !0);
            var _o = new Error("Cannot find module '" + wo + "'");
            throw _o.code = "MODULE_NOT_FOUND", _o;
          }
          var Io = bo[wo] = { exports: {} };
          go[wo][0].call(Io.exports, function(Ao) {
            var Oo = go[wo][1][Ao];
            return Po(Oo || Ao);
          }, Io, Io.exports, ho, go, bo, vo);
        }
        return bo[wo].exports;
      }
      i(Po, "s");
      for (var Co = typeof U$2 == "function" && U$2, So = 0; So < vo.length; So++) Po(vo[So]);
      return Po;
    }, "e"))({ 1: [function(ho, go, bo) {
      go.exports = function(vo) {
        if (typeof Map != "function" || vo) {
          var Po = ho("./similar");
          return new Po();
        } else
          return /* @__PURE__ */ new Map();
      };
    }, { "./similar": 2 }], 2: [function(ho, go, bo) {
      function vo() {
        return this.list = [], this.lastItem = void 0, this.size = 0, this;
      }
      i(vo, "Similar"), vo.prototype.get = function(Po) {
        var Co;
        if (this.lastItem && this.isEqual(this.lastItem.key, Po))
          return this.lastItem.val;
        if (Co = this.indexOf(Po), Co >= 0)
          return this.lastItem = this.list[Co], this.list[Co].val;
      }, vo.prototype.set = function(Po, Co) {
        var So;
        return this.lastItem && this.isEqual(this.lastItem.key, Po) ? (this.lastItem.val = Co, this) : (So = this.indexOf(Po), So >= 0 ? (this.lastItem = this.list[So], this.list[So].val = Co, this) : (this.lastItem = { key: Po, val: Co }, this.list.push(this.lastItem), this.size++, this));
      }, vo.prototype.delete = function(Po) {
        var Co;
        if (this.lastItem && this.isEqual(this.lastItem.key, Po) && (this.lastItem = void 0), Co = this.indexOf(Po), Co >= 0)
          return this.size--, this.list.splice(Co, 1)[0];
      }, vo.prototype.has = function(Po) {
        var Co;
        return this.lastItem && this.isEqual(this.lastItem.key, Po) ? !0 : (Co = this.indexOf(Po), Co >= 0 ? (this.lastItem = this.list[Co], !0) : !1);
      }, vo.prototype.forEach = function(Po, Co) {
        var So;
        for (So = 0; So < this.size; So++)
          Po.call(Co || this, this.list[So].val, this.list[So].key, this);
      }, vo.prototype.indexOf = function(Po) {
        var Co;
        for (Co = 0; Co < this.size; Co++)
          if (this.isEqual(this.list[Co].key, Po))
            return Co;
        return -1;
      }, vo.prototype.isEqual = function(Po, Co) {
        return Po === Co || Po !== Po && Co !== Co;
      }, go.exports = vo;
    }, {}], 3: [function(ho, go, bo) {
      var vo = ho("map-or-similar");
      go.exports = function(wo) {
        var Eo = new vo(!1), Ro = [];
        return function(_o) {
          var Io = /* @__PURE__ */ i(function() {
            var Ao = Eo, Oo, jo, Do = arguments.length - 1, Lo = Array(Do + 1), ko = !0, Ko;
            if ((Io.numArgs || Io.numArgs === 0) && Io.numArgs !== Do + 1)
              throw new Error("Memoizerific functions should always be called with the same number of arguments");
            for (Ko = 0; Ko < Do; Ko++) {
              if (Lo[Ko] = {
                cacheItem: Ao,
                arg: arguments[Ko]
              }, Ao.has(arguments[Ko])) {
                Ao = Ao.get(arguments[Ko]);
                continue;
              }
              ko = !1, Oo = new vo(!1), Ao.set(arguments[Ko], Oo), Ao = Oo;
            }
            return ko && (Ao.has(arguments[Do]) ? jo = Ao.get(arguments[Do]) : ko = !1), ko || (jo = _o.apply(null, arguments), Ao.set(arguments[Do], jo)), wo > 0 && (Lo[Do] = {
              cacheItem: Ao,
              arg: arguments[Do]
            }, ko ? Po(Ro, Lo) : Ro.push(Lo), Ro.length > wo && Co(Ro.shift())), Io.wasMemoized = ko, Io.numArgs = Do + 1, jo;
          }, "memoizerific");
          return Io.limit = wo, Io.wasMemoized = !1, Io.cache = Eo, Io.lru = Ro, Io;
        };
      };
      function Po(wo, Eo) {
        var Ro = wo.length, _o = Eo.length, Io, Ao, Oo;
        for (Ao = 0; Ao < Ro; Ao++) {
          for (Io = !0, Oo = 0; Oo < _o; Oo++)
            if (!So(wo[Ao][Oo].arg, Eo[Oo].arg)) {
              Io = !1;
              break;
            }
          if (Io)
            break;
        }
        wo.push(wo.splice(Ao, 1)[0]);
      }
      i(Po, "moveToMostRecentLru");
      function Co(wo) {
        var Eo = wo.length, Ro = wo[Eo - 1], _o, Io;
        for (Ro.cacheItem.delete(Ro.arg), Io = Eo - 2; Io >= 0 && (Ro = wo[Io], _o = Ro.cacheItem.get(Ro.arg), !_o || !_o.size); Io--)
          Ro.cacheItem.delete(Ro.arg);
      }
      i(Co, "removeCachedResult");
      function So(wo, Eo) {
        return wo === Eo || wo !== wo && Eo !== Eo;
      }
      i(So, "isEqual");
    }, { "map-or-similar": 1 }] }, {}, [3])(3);
  });
}), b$1 = (() => {
  let Kt;
  return typeof window < "u" ? Kt = window : typeof globalThis < "u" ? Kt = globalThis : typeof global < "u" ? Kt = global : typeof self < "u" ? Kt = self : Kt = {}, Kt;
})(), se = /* @__PURE__ */ i((Kt) => Kt.transports !== void 0, "isMulti"), le$1 = /* @__PURE__ */ i(() => Math.random().toString(16).slice(2), "generateRandomId"), lt$1 = class {
  constructor(uo = {}) {
    this.sender = le$1(), this.events = {}, this.data = {}, this.transports = [], this.isAsync = uo.async || !1, se(uo) ? (this.transports = uo.transports || [], this.transports.forEach((ho) => {
      ho.setHandler((go) => this.handleEvent(go));
    })) : this.transports = uo.transport ? [uo.transport] : [], this.transports.forEach((ho) => {
      ho.setHandler((go) => this.handleEvent(go));
    });
  }
  get hasTransport() {
    return this.transports.length > 0;
  }
  addListener(uo, ho) {
    this.events[uo] = this.events[uo] || [], this.events[uo].push(ho);
  }
  emit(uo, ...ho) {
    let go = { type: uo, args: ho, from: this.sender }, bo = {};
    ho.length >= 1 && ho[0] && ho[0].options && (bo = ho[0].options);
    let vo = /* @__PURE__ */ i(() => {
      this.transports.forEach((Po) => {
        Po.send(go, bo);
      }), this.handleEvent(go);
    }, "handler");
    this.isAsync ? setImmediate(vo) : vo();
  }
  last(uo) {
    return this.data[uo];
  }
  eventNames() {
    return Object.keys(this.events);
  }
  listenerCount(uo) {
    let ho = this.listeners(uo);
    return ho ? ho.length : 0;
  }
  listeners(uo) {
    return this.events[uo] || void 0;
  }
  once(uo, ho) {
    let go = this.onceListener(uo, ho);
    this.addListener(uo, go);
  }
  removeAllListeners(uo) {
    uo ? this.events[uo] && delete this.events[uo] : this.events = {};
  }
  removeListener(uo, ho) {
    let go = this.listeners(uo);
    go && (this.events[uo] = go.filter((bo) => bo !== ho));
  }
  on(uo, ho) {
    this.addListener(uo, ho);
  }
  off(uo, ho) {
    this.removeListener(uo, ho);
  }
  handleEvent(uo) {
    let ho = this.listeners(uo.type);
    ho && ho.length && ho.forEach((go) => {
      go.apply(uo, uo.args);
    }), this.data[uo.type] = uo.args;
  }
  onceListener(uo, ho) {
    let go = /* @__PURE__ */ i((...bo) => (this.removeListener(uo, go), ho(...bo)), "onceListener");
    return go;
  }
};
i(lt$1, "Channel");
var z$2 = lt$1, ce$1 = Object.create, St = Object.defineProperty, fe$1 = Object.getOwnPropertyDescriptor, wt$1 = Object.getOwnPropertyNames, ue$1 = Object.getPrototypeOf, pe$1 = Object.prototype.hasOwnProperty, x$2 = /* @__PURE__ */ i((Kt, uo) => /* @__PURE__ */ i(function() {
  return uo || (0, Kt[wt$1(Kt)[0]])((uo = { exports: {} }).exports, uo), uo.exports;
}, "__require"), "__commonJS"), ye$1 = /* @__PURE__ */ i((Kt, uo, ho, go) => {
  if (uo && typeof uo == "object" || typeof uo == "function")
    for (let bo of wt$1(uo))
      !pe$1.call(Kt, bo) && bo !== ho && St(Kt, bo, { get: /* @__PURE__ */ i(() => uo[bo], "get"), enumerable: !(go = fe$1(uo, bo)) || go.enumerable });
  return Kt;
}, "__copyProps"), tt$1 = /* @__PURE__ */ i((Kt, uo, ho) => (ho = Kt != null ? ce$1(ue$1(Kt)) : {}, ye$1(
  uo || !Kt || !Kt.__esModule ? St(ho, "default", { value: Kt, enumerable: !0 }) : ho,
  Kt
)), "__toESM"), de$1 = [
  "bubbles",
  "cancelBubble",
  "cancelable",
  "composed",
  "currentTarget",
  "defaultPrevented",
  "eventPhase",
  "isTrusted",
  "returnValue",
  "srcElement",
  "target",
  "timeStamp",
  "type"
], he$1 = ["detail"];
function Et$1(Kt) {
  let uo = de$1.filter((ho) => Kt[ho] !== void 0).reduce((ho, go) => ({ ...ho, [go]: Kt[go] }), {});
  return Kt instanceof CustomEvent && he$1.filter((ho) => Kt[ho] !== void 0).forEach((ho) => {
    uo[ho] = Kt[ho];
  }), uo;
}
i(Et$1, "extractEventHiddenProperties");
var Ut$1 = ie(At$1()), Tt$1 = x$2({
  "node_modules/has-symbols/shams.js"(Kt, uo) {
    uo.exports = /* @__PURE__ */ i(function() {
      if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
        return !1;
      if (typeof Symbol.iterator == "symbol")
        return !0;
      var ho = {}, go = Symbol("test"), bo = Object(go);
      if (typeof go == "string" || Object.prototype.toString.call(go) !== "[object Symbol]" || Object.prototype.toString.call(bo) !== "[object Symbol]")
        return !1;
      var vo = 42;
      ho[go] = vo;
      for (go in ho)
        return !1;
      if (typeof Object.keys == "function" && Object.keys(ho).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(
        ho
      ).length !== 0)
        return !1;
      var Po = Object.getOwnPropertySymbols(ho);
      if (Po.length !== 1 || Po[0] !== go || !Object.prototype.propertyIsEnumerable.call(ho, go))
        return !1;
      if (typeof Object.getOwnPropertyDescriptor == "function") {
        var Co = Object.getOwnPropertyDescriptor(ho, go);
        if (Co.value !== vo || Co.enumerable !== !0)
          return !1;
      }
      return !0;
    }, "hasSymbols");
  }
}), Ft$1 = x$2({
  "node_modules/has-symbols/index.js"(Kt, uo) {
    var ho = typeof Symbol < "u" && Symbol, go = Tt$1();
    uo.exports = /* @__PURE__ */ i(function() {
      return typeof ho != "function" || typeof Symbol != "function" || typeof ho("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : go();
    }, "hasNativeSymbols");
  }
}), ge$1 = x$2({
  "node_modules/function-bind/implementation.js"(Kt, uo) {
    var ho = "Function.prototype.bind called on incompatible ", go = Array.prototype.slice, bo = Object.prototype.toString, vo = "[object Function]";
    uo.exports = /* @__PURE__ */ i(function(Po) {
      var Co = this;
      if (typeof Co != "function" || bo.call(Co) !== vo)
        throw new TypeError(ho + Co);
      for (var So = go.call(arguments, 1), wo, Eo = /* @__PURE__ */ i(function() {
        if (this instanceof wo) {
          var Oo = Co.apply(
            this,
            So.concat(go.call(arguments))
          );
          return Object(Oo) === Oo ? Oo : this;
        } else
          return Co.apply(
            Po,
            So.concat(go.call(arguments))
          );
      }, "binder"), Ro = Math.max(0, Co.length - So.length), _o = [], Io = 0; Io < Ro; Io++)
        _o.push("$" + Io);
      if (wo = Function("binder", "return function (" + _o.join(",") + "){ return binder.apply(this,arguments); }")(Eo), Co.prototype) {
        var Ao = /* @__PURE__ */ i(function() {
        }, "Empty2");
        Ao.prototype = Co.prototype, wo.prototype = new Ao(), Ao.prototype = null;
      }
      return wo;
    }, "bind");
  }
}), ut = x$2({
  "node_modules/function-bind/index.js"(Kt, uo) {
    var ho = ge$1();
    uo.exports = Function.prototype.bind || ho;
  }
}), me$1 = x$2({
  "node_modules/has/src/index.js"(Kt, uo) {
    var ho = ut();
    uo.exports = ho.call(Function.call, Object.prototype.hasOwnProperty);
  }
}), Nt$1 = x$2({
  "node_modules/get-intrinsic/index.js"(Kt, uo) {
    var ho, go = SyntaxError, bo = Function, vo = TypeError, Po = /* @__PURE__ */ i(function(ii) {
      try {
        return bo('"use strict"; return (' + ii + ").constructor;")();
      } catch {
      }
    }, "getEvalledConstructor"), Co = Object.getOwnPropertyDescriptor;
    if (Co)
      try {
        Co({}, "");
      } catch {
        Co = null;
      }
    var So = /* @__PURE__ */ i(function() {
      throw new vo();
    }, "throwTypeError"), wo = Co ? function() {
      try {
        return arguments.callee, So;
      } catch {
        try {
          return Co(arguments, "callee").get;
        } catch {
          return So;
        }
      }
    }() : So, Eo = Ft$1()(), Ro = Object.getPrototypeOf || function(ii) {
      return ii.__proto__;
    }, _o = {}, Io = typeof Uint8Array > "u" ? ho : Ro(Uint8Array), Ao = {
      "%AggregateError%": typeof AggregateError > "u" ? ho : AggregateError,
      "%Array%": Array,
      "%ArrayBuffer%": typeof ArrayBuffer > "u" ? ho : ArrayBuffer,
      "%ArrayIteratorPrototype%": Eo ? Ro([][Symbol.iterator]()) : ho,
      "%AsyncFromSyncIteratorPrototype%": ho,
      "%AsyncFunction%": _o,
      "%AsyncGenerator%": _o,
      "%AsyncGeneratorFunction%": _o,
      "%AsyncIteratorPrototype%": _o,
      "%Atomics%": typeof Atomics > "u" ? ho : Atomics,
      "%BigInt%": typeof BigInt > "u" ? ho : BigInt,
      "%Boolean%": Boolean,
      "%DataView%": typeof DataView > "u" ? ho : DataView,
      "%Date%": Date,
      "%decodeURI%": decodeURI,
      "%decodeURIComponent%": decodeURIComponent,
      "%encodeURI%": encodeURI,
      "%encodeURIComponent%": encodeURIComponent,
      "%Error%": Error,
      "%eval%": eval,
      "%EvalError%": EvalError,
      "%Float32Array%": typeof Float32Array > "u" ? ho : Float32Array,
      "%Float64Array%": typeof Float64Array > "u" ? ho : Float64Array,
      "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? ho : FinalizationRegistry,
      "%Function%": bo,
      "%GeneratorFunction%": _o,
      "%Int8Array%": typeof Int8Array > "u" ? ho : Int8Array,
      "%Int16Array%": typeof Int16Array > "u" ? ho : Int16Array,
      "%Int32Array%": typeof Int32Array > "u" ? ho : Int32Array,
      "%isFinite%": isFinite,
      "%isNaN%": isNaN,
      "%IteratorPrototype%": Eo ? Ro(Ro([][Symbol.iterator]())) : ho,
      "%JSON%": typeof JSON == "object" ? JSON : ho,
      "%Map%": typeof Map > "u" ? ho : Map,
      "%MapIteratorPrototype%": typeof Map > "u" || !Eo ? ho : Ro((/* @__PURE__ */ new Map())[Symbol.iterator]()),
      "%Math%": Math,
      "%Number%": Number,
      "%Object%": Object,
      "%parseFloat%": parseFloat,
      "%parseInt%": parseInt,
      "%Promise%": typeof Promise > "u" ? ho : Promise,
      "%Proxy%": typeof Proxy > "u" ? ho : Proxy,
      "%RangeError%": RangeError,
      "%ReferenceError%": ReferenceError,
      "%Reflect%": typeof Reflect > "u" ? ho : Reflect,
      "%RegExp%": RegExp,
      "%Set%": typeof Set > "u" ? ho : Set,
      "%SetIteratorPrototype%": typeof Set > "u" || !Eo ? ho : Ro((/* @__PURE__ */ new Set())[Symbol.iterator]()),
      "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? ho : SharedArrayBuffer,
      "%String%": String,
      "%StringIteratorPrototype%": Eo ? Ro(""[Symbol.iterator]()) : ho,
      "%Symbol%": Eo ? Symbol : ho,
      "%SyntaxError%": go,
      "%ThrowTypeError%": wo,
      "%TypedArray%": Io,
      "%TypeError%": vo,
      "%Uint8Array%": typeof Uint8Array > "u" ? ho : Uint8Array,
      "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? ho : Uint8ClampedArray,
      "%Uint16Array%": typeof Uint16Array > "u" ? ho : Uint16Array,
      "%Uint32Array%": typeof Uint32Array > "u" ? ho : Uint32Array,
      "%URIError%": URIError,
      "%WeakMap%": typeof WeakMap > "u" ? ho : WeakMap,
      "%WeakRef%": typeof WeakRef > "u" ? ho : WeakRef,
      "%WeakSet%": typeof WeakSet > "u" ? ho : WeakSet
    }, Oo = /* @__PURE__ */ i(function ii(ai) {
      var ri;
      if (ai === "%AsyncFunction%")
        ri = Po("async function () {}");
      else if (ai === "%GeneratorFunction%")
        ri = Po("function* () {}");
      else if (ai === "%AsyncGeneratorFunction%")
        ri = Po("async function* () {}");
      else if (ai === "%AsyncGenerator%") {
        var ni = ii("%AsyncGeneratorFunction%");
        ni && (ri = ni.prototype);
      } else if (ai === "%AsyncIteratorPrototype%") {
        var si = ii("%AsyncGenerator%");
        si && (ri = Ro(si.prototype));
      }
      return Ao[ai] = ri, ri;
    }, "doEval2"), jo = {
      "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
      "%ArrayPrototype%": ["Array", "prototype"],
      "%ArrayProto_entries%": ["Array", "prototype", "entries"],
      "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
      "%ArrayProto_keys%": ["Array", "prototype", "keys"],
      "%ArrayProto_values%": ["Array", "prototype", "values"],
      "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
      "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
      "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
      "%BooleanPrototype%": ["Boolean", "prototype"],
      "%DataViewPrototype%": ["DataView", "prototype"],
      "%DatePrototype%": ["Date", "prototype"],
      "%ErrorPrototype%": ["Error", "prototype"],
      "%EvalErrorPrototype%": ["EvalError", "prototype"],
      "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
      "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
      "%FunctionPrototype%": ["Function", "prototype"],
      "%Generator%": ["GeneratorFunction", "prototype"],
      "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
      "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
      "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
      "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
      "%JSONParse%": ["JSON", "parse"],
      "%JSONStringify%": ["JSON", "stringify"],
      "%MapPrototype%": ["Map", "prototype"],
      "%NumberPrototype%": ["Number", "prototype"],
      "%ObjectPrototype%": ["Object", "prototype"],
      "%ObjProto_toString%": ["Object", "prototype", "toString"],
      "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
      "%PromisePrototype%": ["Promise", "prototype"],
      "%PromiseProto_then%": ["Promise", "prototype", "then"],
      "%Promise_all%": ["Promise", "all"],
      "%Promise_reject%": ["Promise", "reject"],
      "%Promise_resolve%": ["Promise", "resolve"],
      "%RangeErrorPrototype%": ["RangeError", "prototype"],
      "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
      "%RegExpPrototype%": ["RegExp", "prototype"],
      "%SetPrototype%": ["Set", "prototype"],
      "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
      "%StringPrototype%": ["String", "prototype"],
      "%SymbolPrototype%": ["Symbol", "prototype"],
      "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
      "%TypedArrayPrototype%": ["TypedArray", "prototype"],
      "%TypeErrorPrototype%": ["TypeError", "prototype"],
      "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
      "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
      "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
      "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
      "%URIErrorPrototype%": ["URIError", "prototype"],
      "%WeakMapPrototype%": ["WeakMap", "prototype"],
      "%WeakSetPrototype%": ["WeakSet", "prototype"]
    }, Do = ut(), Lo = me$1(), ko = Do.call(Function.call, Array.prototype.concat), Ko = Do.call(Function.apply, Array.prototype.splice), No = Do.call(
      Function.call,
      String.prototype.replace
    ), Jo = Do.call(Function.call, String.prototype.slice), ti = Do.call(Function.call, RegExp.prototype.exec), oi = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, Qo = /\\(\\)?/g, Zo = /* @__PURE__ */ i(
      function(ii) {
        var ai = Jo(ii, 0, 1), ri = Jo(ii, -1);
        if (ai === "%" && ri !== "%")
          throw new go("invalid intrinsic syntax, expected closing `%`");
        if (ri === "%" && ai !== "%")
          throw new go("invalid intrinsic syntax, expected opening `%`");
        var ni = [];
        return No(ii, oi, function(si, li, ui, ci) {
          ni[ni.length] = ui ? No(ci, Qo, "$1") : li || si;
        }), ni;
      },
      "stringToPath3"
    ), ei = /* @__PURE__ */ i(function(ii, ai) {
      var ri = ii, ni;
      if (Lo(jo, ri) && (ni = jo[ri], ri = "%" + ni[0] + "%"), Lo(Ao, ri)) {
        var si = Ao[ri];
        if (si === _o && (si = Oo(ri)), typeof si > "u" && !ai)
          throw new vo("intrinsic " + ii + " exists, but is not available. Please file an issue!");
        return {
          alias: ni,
          name: ri,
          value: si
        };
      }
      throw new go("intrinsic " + ii + " does not exist!");
    }, "getBaseIntrinsic2");
    uo.exports = /* @__PURE__ */ i(function(ii, ai) {
      if (typeof ii != "string" || ii.length === 0)
        throw new vo("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && typeof ai != "boolean")
        throw new vo('"allowMissing" argument must be a boolean');
      if (ti(/^%?[^%]*%?$/, ii) === null)
        throw new go("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      var ri = Zo(ii), ni = ri.length > 0 ? ri[0] : "", si = ei("%" + ni + "%", ai), li = si.name, ui = si.value, ci = !1, fi = si.alias;
      fi && (ni = fi[0], Ko(ri, ko([0, 1], fi)));
      for (var yi = 1, hi = !0; yi < ri.length; yi += 1) {
        var mi = ri[yi], bi = Jo(mi, 0, 1), xi = Jo(mi, -1);
        if ((bi === '"' || bi === "'" || bi === "`" || xi === '"' || xi === "'" || xi === "`") && bi !== xi)
          throw new go("property names with quotes must have matching quotes");
        if ((mi === "constructor" || !hi) && (ci = !0), ni += "." + mi, li = "%" + ni + "%", Lo(Ao, li))
          ui = Ao[li];
        else if (ui != null) {
          if (!(mi in ui)) {
            if (!ai)
              throw new vo("base intrinsic for " + ii + " exists, but the property is not available.");
            return;
          }
          if (Co && yi + 1 >= ri.length) {
            var $i = Co(ui, mi);
            hi = !!$i, hi && "get" in $i && !("originalValue" in $i.get) ? ui = $i.get : ui = ui[mi];
          } else
            hi = Lo(ui, mi), ui = ui[mi];
          hi && !ci && (Ao[li] = ui);
        }
      }
      return ui;
    }, "GetIntrinsic");
  }
}), ve$1 = x$2({
  "node_modules/call-bind/index.js"(Kt, uo) {
    var ho = ut(), go = Nt$1(), bo = go("%Function.prototype.apply%"), vo = go("%Function.prototype.call%"), Po = go("%Reflect.apply%", !0) || ho.call(
      vo,
      bo
    ), Co = go("%Object.getOwnPropertyDescriptor%", !0), So = go("%Object.defineProperty%", !0), wo = go("%Math.max%");
    if (So)
      try {
        So({}, "a", { value: 1 });
      } catch {
        So = null;
      }
    uo.exports = /* @__PURE__ */ i(function(Ro) {
      var _o = Po(ho, vo, arguments);
      if (Co && So) {
        var Io = Co(_o, "length");
        Io.configurable && So(
          _o,
          "length",
          { value: 1 + wo(0, Ro.length - (arguments.length - 1)) }
        );
      }
      return _o;
    }, "callBind");
    var Eo = /* @__PURE__ */ i(function() {
      return Po(ho, bo, arguments);
    }, "applyBind2");
    So ? So(uo.exports, "apply", { value: Eo }) : uo.exports.apply = Eo;
  }
}), _e = x$2({
  "node_modules/call-bind/callBound.js"(Kt, uo) {
    var ho = Nt$1(), go = ve$1(), bo = go(ho("String.prototype.indexOf"));
    uo.exports = /* @__PURE__ */ i(function(vo, Po) {
      var Co = ho(vo, !!Po);
      return typeof Co == "function" && bo(vo, ".prototype.") > -1 ? go(Co) : Co;
    }, "callBoundIntrinsic");
  }
}), be$1 = x$2({
  "node_modules/has-tostringtag/shams.js"(Kt, uo) {
    var ho = Tt$1();
    uo.exports = /* @__PURE__ */ i(function() {
      return ho() && !!Symbol.toStringTag;
    }, "hasToStringTagShams");
  }
}), Se = x$2({
  "node_modules/is-regex/index.js"(Kt, uo) {
    var ho = _e(), go = be$1()(), bo, vo, Po, Co;
    go && (bo = ho("Object.prototype.hasOwnProperty"), vo = ho("RegExp.prototype.exec"), Po = {}, So = /* @__PURE__ */ i(function() {
      throw Po;
    }, "throwRegexMarker"), Co = {
      toString: So,
      valueOf: So
    }, typeof Symbol.toPrimitive == "symbol" && (Co[Symbol.toPrimitive] = So));
    var So, wo = ho("Object.prototype.toString"), Eo = Object.getOwnPropertyDescriptor, Ro = "[object RegExp]";
    uo.exports = /* @__PURE__ */ i(go ? function(_o) {
      if (!_o || typeof _o != "object")
        return !1;
      var Io = Eo(_o, "lastIndex"), Ao = Io && bo(Io, "value");
      if (!Ao)
        return !1;
      try {
        vo(_o, Co);
      } catch (Oo) {
        return Oo === Po;
      }
    } : function(_o) {
      return !_o || typeof _o != "object" && typeof _o != "function" ? !1 : wo(_o) === Ro;
    }, "isRegex");
  }
}), we = x$2({
  "node_modules/is-function/index.js"(Kt, uo) {
    uo.exports = go;
    var ho = Object.prototype.toString;
    function go(bo) {
      if (!bo)
        return !1;
      var vo = ho.call(bo);
      return vo === "[object Function]" || typeof bo == "function" && vo !== "[object RegExp]" || typeof window < "u" && (bo === window.setTimeout || bo === window.alert || bo === window.confirm || bo === window.prompt);
    }
    i(go, "isFunction3");
  }
}), Ee$1 = x$2({
  "node_modules/is-symbol/index.js"(Kt, uo) {
    var ho = Object.prototype.toString, go = Ft$1()();
    go ? (bo = Symbol.prototype.toString, vo = /^Symbol\(.*\)$/, Po = /* @__PURE__ */ i(function(Co) {
      return typeof Co.valueOf() != "symbol" ? !1 : vo.test(bo.call(Co));
    }, "isRealSymbolObject"), uo.exports = /* @__PURE__ */ i(function(Co) {
      if (typeof Co == "symbol")
        return !0;
      if (ho.call(Co) !== "[object Symbol]")
        return !1;
      try {
        return Po(Co);
      } catch {
        return !1;
      }
    }, "isSymbol3")) : uo.exports = /* @__PURE__ */ i(function(Co) {
      return !1;
    }, "isSymbol3");
    var bo, vo, Po;
  }
}), Oe$1 = tt$1(Se()), Ae$1 = tt$1(we()), Pe$1 = tt$1(Ee$1());
function xe(Kt) {
  return Kt != null && typeof Kt == "object" && Array.isArray(Kt) === !1;
}
i(xe, "isObject");
var Ce$1 = typeof global == "object" && global && global.Object === Object && global, Ie$1 = Ce$1, je$1 = typeof self == "object" && self && self.Object === Object && self, Te = Ie$1 || je$1 || Function("return this")(), pt$1 = Te, Fe$1 = pt$1.Symbol, M$3 = Fe$1, Rt$1 = Object.prototype, Ne = Rt$1.hasOwnProperty, Re$1 = Rt$1.toString, W$1 = M$3 ? M$3.toStringTag : void 0;
function Me$1(Kt) {
  var uo = Ne.call(Kt, W$1), ho = Kt[W$1];
  try {
    Kt[W$1] = void 0;
    var go = !0;
  } catch {
  }
  var bo = Re$1.call(Kt);
  return go && (uo ? Kt[W$1] = ho : delete Kt[W$1]), bo;
}
i(Me$1, "getRawTag");
var $e$1 = Me$1, ke$1 = Object.prototype, De$1 = ke$1.toString;
function Le(Kt) {
  return De$1.call(Kt);
}
i(Le, "objectToString");
var Ue$1 = Le, ze$1 = "[object Null]", We$1 = "[object Undefined]", Pt$1 = M$3 ? M$3.toStringTag : void 0;
function Be$1(Kt) {
  return Kt == null ? Kt === void 0 ? We$1 : ze$1 : Pt$1 && Pt$1 in Object(Kt) ? $e$1(Kt) : Ue$1(Kt);
}
i(Be$1, "baseGetTag");
var Mt$1 = Be$1;
function He$1(Kt) {
  return Kt != null && typeof Kt == "object";
}
i(He$1, "isObjectLike");
var qe$1 = He$1, Ge$1 = "[object Symbol]";
function Je(Kt) {
  return typeof Kt == "symbol" || qe$1(Kt) && Mt$1(Kt) == Ge$1;
}
i(Je, "isSymbol");
var yt$1 = Je;
function Ve$1(Kt, uo) {
  for (var ho = -1, go = Kt == null ? 0 : Kt.length, bo = Array(go); ++ho < go; )
    bo[ho] = uo(Kt[ho], ho, Kt);
  return bo;
}
i(Ve$1, "arrayMap");
var Ke$1 = Ve$1, Ye$1 = Array.isArray, dt = Ye$1, Ze = 1 / 0, xt$1 = M$3 ? M$3.prototype : void 0, Ct$1 = xt$1 ? xt$1.toString : void 0;
function $t$1(Kt) {
  if (typeof Kt == "string")
    return Kt;
  if (dt(Kt))
    return Ke$1(Kt, $t$1) + "";
  if (yt$1(Kt))
    return Ct$1 ? Ct$1.call(Kt) : "";
  var uo = Kt + "";
  return uo == "0" && 1 / Kt == -Ze ? "-0" : uo;
}
i($t$1, "baseToString");
var Xe$1 = $t$1;
function Qe$1(Kt) {
  var uo = typeof Kt;
  return Kt != null && (uo == "object" || uo == "function");
}
i(Qe$1, "isObject2");
var kt$1 = Qe$1, tr$1 = "[object AsyncFunction]", er = "[object Function]", rr = "[object GeneratorFunction]", nr = "[object Proxy]";
function or(Kt) {
  if (!kt$1(Kt))
    return !1;
  var uo = Mt$1(Kt);
  return uo == er || uo == rr || uo == tr$1 || uo == nr;
}
i(or, "isFunction");
var ar = or, ir = pt$1["__core-js_shared__"], ft$1 = ir, It$1 = function() {
  var Kt = /[^.]+$/.exec(ft$1 && ft$1.keys && ft$1.keys.IE_PROTO || "");
  return Kt ? "Symbol(src)_1." + Kt : "";
}();
function sr(Kt) {
  return !!It$1 && It$1 in Kt;
}
i(sr, "isMasked");
var lr = sr, cr = Function.prototype, fr$1 = cr.toString;
function ur$1(Kt) {
  if (Kt != null) {
    try {
      return fr$1.call(Kt);
    } catch {
    }
    try {
      return Kt + "";
    } catch {
    }
  }
  return "";
}
i(ur$1, "toSource");
var pr$1 = ur$1, yr$1 = /[\\^$.*+?()[\]{}|]/g, dr = /^\[object .+?Constructor\]$/, hr$1 = Function.prototype, gr$1 = Object.prototype, mr$1 = hr$1.toString, vr$1 = gr$1.hasOwnProperty, _r$1 = RegExp(
  "^" + mr$1.call(vr$1).replace(yr$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function br$1(Kt) {
  if (!kt$1(Kt) || lr(Kt))
    return !1;
  var uo = ar(Kt) ? _r$1 : dr;
  return uo.test(pr$1(Kt));
}
i(br$1, "baseIsNative");
var Sr$1 = br$1;
function wr$1(Kt, uo) {
  return Kt == null ? void 0 : Kt[uo];
}
i(wr$1, "getValue");
var Er$1 = wr$1;
function Or(Kt, uo) {
  var ho = Er$1(Kt, uo);
  return Sr$1(ho) ? ho : void 0;
}
i(Or, "getNative");
var Dt$1 = Or;
function Ar$1(Kt, uo) {
  return Kt === uo || Kt !== Kt && uo !== uo;
}
i(Ar$1, "eq");
var Pr$1 = Ar$1, xr$1 = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Cr$1 = /^\w*$/;
function Ir$1(Kt, uo) {
  if (dt(Kt))
    return !1;
  var ho = typeof Kt;
  return ho == "number" || ho == "symbol" || ho == "boolean" || Kt == null || yt$1(Kt) ? !0 : Cr$1.test(Kt) || !xr$1.test(Kt) || uo != null && Kt in Object(
    uo
  );
}
i(Ir$1, "isKey");
var jr$1 = Ir$1, Tr$1 = Dt$1(Object, "create"), B$1 = Tr$1;
function Fr() {
  this.__data__ = B$1 ? B$1(null) : {}, this.size = 0;
}
i(Fr, "hashClear");
var Nr$1 = Fr;
function Rr$1(Kt) {
  var uo = this.has(Kt) && delete this.__data__[Kt];
  return this.size -= uo ? 1 : 0, uo;
}
i(Rr$1, "hashDelete");
var Mr$1 = Rr$1, $r$1 = "__lodash_hash_undefined__", kr$1 = Object.prototype, Dr$1 = kr$1.hasOwnProperty;
function Lr$1(Kt) {
  var uo = this.__data__;
  if (B$1) {
    var ho = uo[Kt];
    return ho === $r$1 ? void 0 : ho;
  }
  return Dr$1.call(uo, Kt) ? uo[Kt] : void 0;
}
i(Lr$1, "hashGet");
var Ur$1 = Lr$1, zr$1 = Object.prototype, Wr$1 = zr$1.hasOwnProperty;
function Br$1(Kt) {
  var uo = this.__data__;
  return B$1 ? uo[Kt] !== void 0 : Wr$1.call(uo, Kt);
}
i(Br$1, "hashHas");
var Hr$1 = Br$1, qr$1 = "__lodash_hash_undefined__";
function Gr$1(Kt, uo) {
  var ho = this.__data__;
  return this.size += this.has(Kt) ? 0 : 1, ho[Kt] = B$1 && uo === void 0 ? qr$1 : uo, this;
}
i(Gr$1, "hashSet");
var Jr$1 = Gr$1;
function $$2(Kt) {
  var uo = -1, ho = Kt == null ? 0 : Kt.length;
  for (this.clear(); ++uo < ho; ) {
    var go = Kt[uo];
    this.set(go[0], go[1]);
  }
}
i($$2, "Hash");
$$2.prototype.clear = Nr$1;
$$2.prototype.delete = Mr$1;
$$2.prototype.get = Ur$1;
$$2.prototype.has = Hr$1;
$$2.prototype.set = Jr$1;
var jt$1 = $$2;
function Vr$1() {
  this.__data__ = [], this.size = 0;
}
i(Vr$1, "listCacheClear");
var Kr$1 = Vr$1;
function Yr$1(Kt, uo) {
  for (var ho = Kt.length; ho--; )
    if (Pr$1(Kt[ho][0], uo))
      return ho;
  return -1;
}
i(Yr$1, "assocIndexOf");
var rt = Yr$1, Zr = Array.prototype, Xr = Zr.splice;
function Qr$1(Kt) {
  var uo = this.__data__, ho = rt(uo, Kt);
  if (ho < 0)
    return !1;
  var go = uo.length - 1;
  return ho == go ? uo.pop() : Xr.call(uo, ho, 1), --this.size, !0;
}
i(Qr$1, "listCacheDelete");
var tn = Qr$1;
function en(Kt) {
  var uo = this.__data__, ho = rt(uo, Kt);
  return ho < 0 ? void 0 : uo[ho][1];
}
i(en, "listCacheGet");
var rn = en;
function nn(Kt) {
  return rt(this.__data__, Kt) > -1;
}
i(nn, "listCacheHas");
var on = nn;
function an(Kt, uo) {
  var ho = this.__data__, go = rt(ho, Kt);
  return go < 0 ? (++this.size, ho.push([Kt, uo])) : ho[go][1] = uo, this;
}
i(an, "listCacheSet");
var sn = an;
function k$3(Kt) {
  var uo = -1, ho = Kt == null ? 0 : Kt.length;
  for (this.clear(); ++uo < ho; ) {
    var go = Kt[uo];
    this.set(go[0], go[1]);
  }
}
i(k$3, "ListCache");
k$3.prototype.clear = Kr$1;
k$3.prototype.delete = tn;
k$3.prototype.get = rn;
k$3.prototype.has = on;
k$3.prototype.set = sn;
var ln = k$3, cn = Dt$1(pt$1, "Map"), fn = cn;
function un() {
  this.size = 0, this.__data__ = {
    hash: new jt$1(),
    map: new (fn || ln)(),
    string: new jt$1()
  };
}
i(un, "mapCacheClear");
var pn$1 = un;
function yn(Kt) {
  var uo = typeof Kt;
  return uo == "string" || uo == "number" || uo == "symbol" || uo == "boolean" ? Kt !== "__proto__" : Kt === null;
}
i(yn, "isKeyable");
var dn = yn;
function hn(Kt, uo) {
  var ho = Kt.__data__;
  return dn(uo) ? ho[typeof uo == "string" ? "string" : "hash"] : ho.map;
}
i(hn, "getMapData");
var nt = hn;
function gn(Kt) {
  var uo = nt(this, Kt).delete(Kt);
  return this.size -= uo ? 1 : 0, uo;
}
i(gn, "mapCacheDelete");
var mn = gn;
function vn$1(Kt) {
  return nt(this, Kt).get(Kt);
}
i(vn$1, "mapCacheGet");
var _n$1 = vn$1;
function bn(Kt) {
  return nt(this, Kt).has(Kt);
}
i(bn, "mapCacheHas");
var Sn = bn;
function wn$1(Kt, uo) {
  var ho = nt(this, Kt), go = ho.size;
  return ho.set(Kt, uo), this.size += ho.size == go ? 0 : 1, this;
}
i(wn$1, "mapCacheSet");
var En$1 = wn$1;
function D$2(Kt) {
  var uo = -1, ho = Kt == null ? 0 : Kt.length;
  for (this.clear(); ++uo < ho; ) {
    var go = Kt[uo];
    this.set(go[0], go[1]);
  }
}
i(D$2, "MapCache");
D$2.prototype.clear = pn$1;
D$2.prototype.delete = mn;
D$2.prototype.get = _n$1;
D$2.prototype.has = Sn;
D$2.prototype.set = En$1;
var Lt$1 = D$2, On$1 = "Expected a function";
function ht$1(Kt, uo) {
  if (typeof Kt != "function" || uo != null && typeof uo != "function")
    throw new TypeError(On$1);
  var ho = /* @__PURE__ */ i(function() {
    var go = arguments, bo = uo ? uo.apply(this, go) : go[0], vo = ho.cache;
    if (vo.has(bo))
      return vo.get(bo);
    var Po = Kt.apply(this, go);
    return ho.cache = vo.set(bo, Po) || vo, Po;
  }, "memoized");
  return ho.cache = new (ht$1.Cache || Lt$1)(), ho;
}
i(ht$1, "memoize");
ht$1.Cache = Lt$1;
var An$1 = ht$1, Pn$1 = 500;
function xn(Kt) {
  var uo = An$1(Kt, function(go) {
    return ho.size === Pn$1 && ho.clear(), go;
  }), ho = uo.cache;
  return uo;
}
i(xn, "memoizeCapped");
var Cn$1 = xn, In$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, jn$1 = /\\(\\)?/g, Tn = Cn$1(
  function(Kt) {
    var uo = [];
    return Kt.charCodeAt(0) === 46 && uo.push(""), Kt.replace(In$1, function(ho, go, bo, vo) {
      uo.push(bo ? vo.replace(jn$1, "$1") : go || ho);
    }), uo;
  }
), Fn$1 = Tn;
function Nn$1(Kt) {
  return Kt == null ? "" : Xe$1(Kt);
}
i(Nn$1, "toString");
var Rn$1 = Nn$1;
function Mn$1(Kt, uo) {
  return dt(Kt) ? Kt : jr$1(Kt, uo) ? [Kt] : Fn$1(Rn$1(Kt));
}
i(Mn$1, "castPath");
var $n$1 = Mn$1, kn$1 = 1 / 0;
function Dn$1(Kt) {
  if (typeof Kt == "string" || yt$1(Kt))
    return Kt;
  var uo = Kt + "";
  return uo == "0" && 1 / Kt == -kn$1 ? "-0" : uo;
}
i(Dn$1, "toKey");
var Ln = Dn$1;
function Un$1(Kt, uo) {
  uo = $n$1(uo, Kt);
  for (var ho = 0, go = uo.length; Kt != null && ho < go; )
    Kt = Kt[Ln(uo[ho++])];
  return ho && ho == go ? Kt : void 0;
}
i(Un$1, "baseGet");
var zn = Un$1;
function Wn$1(Kt, uo, ho) {
  var go = Kt == null ? void 0 : zn(Kt, uo);
  return go === void 0 ? ho : go;
}
i(Wn$1, "get");
var Bn = Wn$1, et$1 = xe, Hn$1 = /* @__PURE__ */ i((Kt) => {
  let uo = null, ho = !1, go = !1, bo = !1, vo = "";
  if (Kt.indexOf("//") >= 0 || Kt.indexOf("/*") >= 0)
    for (let Po = 0; Po < Kt.length; Po += 1)
      !uo && !ho && !go && !bo ? Kt[Po] === '"' || Kt[Po] === "'" || Kt[Po] === "`" ? uo = Kt[Po] : Kt[Po] === "/" && Kt[Po + 1] === "*" ? ho = !0 : Kt[Po] === "/" && Kt[Po + 1] === "/" ? go = !0 : Kt[Po] === "/" && Kt[Po + 1] !== "/" && (bo = !0) : (uo && (Kt[Po] === uo && Kt[Po - 1] !== "\\" || Kt[Po] === `
` && uo !== "`") && (uo = null), bo && (Kt[Po] === "/" && Kt[Po - 1] !== "\\" || Kt[Po] === `
`) && (bo = !1), ho && Kt[Po - 1] === "/" && Kt[Po - 2] === "*" && (ho = !1), go && Kt[Po] === `
` && (go = !1)), !ho && !go && (vo += Kt[Po]);
  else
    vo = Kt;
  return vo;
}, "removeCodeComments"), qn = (0, Ut$1.default)(1e4)(
  (Kt) => Hn$1(Kt).replace(/\n\s*/g, "").trim()
), Gn = /* @__PURE__ */ i(function(Kt, uo) {
  let ho = uo.slice(0, uo.indexOf("{")), go = uo.slice(uo.indexOf("{"));
  if (ho.includes("=>") || ho.includes("function"))
    return uo;
  let bo = ho;
  return bo = bo.replace(Kt, "function"), bo + go;
}, "convertShorthandMethods2"), Jn$1 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/, H$1 = /* @__PURE__ */ i(
  (Kt) => Kt.match(/^[\[\{\"\}].*[\]\}\"]$/),
  "isJSON"
);
function zt$1(Kt) {
  if (!et$1(Kt))
    return Kt;
  let uo = Kt, ho = !1;
  return typeof Event < "u" && Kt instanceof Event && (uo = Et$1(uo), ho = !0), uo = Object.keys(uo).reduce((go, bo) => {
    try {
      uo[bo] && uo[bo].toJSON, go[bo] = uo[bo];
    } catch {
      ho = !0;
    }
    return go;
  }, {}), ho ? uo : Kt;
}
i(zt$1, "convertUnconventionalData");
var Vn$1 = /* @__PURE__ */ i(function(Kt) {
  let uo, ho, go, bo;
  return /* @__PURE__ */ i(function(vo, Po) {
    try {
      if (vo === "")
        return bo = [], uo = /* @__PURE__ */ new Map([[Po, "[]"]]), ho = /* @__PURE__ */ new Map(), go = [], Po;
      let Co = ho.get(this) || this;
      for (; go.length && Co !== go[0]; )
        go.shift(), bo.pop();
      if (typeof Po == "boolean")
        return Po;
      if (Po === void 0)
        return Kt.allowUndefined ? "_undefined_" : void 0;
      if (Po === null)
        return null;
      if (typeof Po == "number")
        return Po === -1 / 0 ? "_-Infinity_" : Po === 1 / 0 ? "_Infinity_" : Number.isNaN(Po) ? "_NaN_" : Po;
      if (typeof Po == "bigint")
        return `_bigint_${Po.toString()}`;
      if (typeof Po == "string")
        return Jn$1.test(Po) ? Kt.allowDate ? `_date_${Po}` : void 0 : Po;
      if ((0, Oe$1.default)(Po))
        return Kt.allowRegExp ? `_regexp_${Po.flags}|${Po.source}` : void 0;
      if ((0, Ae$1.default)(Po)) {
        if (!Kt.allowFunction)
          return;
        let { name: wo } = Po, Eo = Po.toString();
        return Eo.match(
          /(\[native code\]|WEBPACK_IMPORTED_MODULE|__webpack_exports__|__webpack_require__)/
        ) ? `_function_${wo}|${(() => {
        }).toString()}` : `_function_${wo}|${qn(Gn(vo, Eo))}`;
      }
      if ((0, Pe$1.default)(Po)) {
        if (!Kt.allowSymbol)
          return;
        let wo = Symbol.keyFor(Po);
        return wo !== void 0 ? `_gsymbol_${wo}` : `_symbol_${Po.toString().slice(7, -1)}`;
      }
      if (go.length >= Kt.maxDepth)
        return Array.isArray(Po) ? `[Array(${Po.length})]` : "[Object]";
      if (Po === this)
        return `_duplicate_${JSON.stringify(bo)}`;
      if (Po instanceof Error && Kt.allowError)
        return {
          __isConvertedError__: !0,
          errorProperties: {
            ...Po.cause ? { cause: Po.cause } : {},
            ...Po,
            name: Po.name,
            message: Po.message,
            stack: Po.stack,
            "_constructor-name_": Po.constructor.name
          }
        };
      if (Po.constructor && Po.constructor.name && Po.constructor.name !== "Object" && !Array.isArray(Po) && !Kt.allowClass)
        return;
      let So = uo.get(Po);
      if (!So) {
        let wo = Array.isArray(Po) ? Po : zt$1(Po);
        if (Po.constructor && Po.constructor.name && Po.constructor.name !== "Object" && !Array.isArray(Po) && Kt.allowClass)
          try {
            Object.assign(wo, { "_constructor-name_": Po.constructor.name });
          } catch {
          }
        return bo.push(vo), go.unshift(wo), uo.set(Po, JSON.stringify(bo)), Po !== wo && ho.set(Po, wo), wo;
      }
      return `_duplicate_${So}`;
    } catch {
      return;
    }
  }, "replace");
}, "replacer2"), Kn$1 = /* @__PURE__ */ i(function reviver(options) {
  let refs = [], root;
  return /* @__PURE__ */ i(function revive(key, value) {
    if (key === "" && (root = value, refs.forEach(({ target: Kt, container: uo, replacement: ho }) => {
      let go = H$1(ho) ? JSON.parse(ho) : ho.split(".");
      go.length === 0 ? uo[Kt] = root : uo[Kt] = Bn(root, go);
    })), key === "_constructor-name_")
      return value;
    if (et$1(value) && value.__isConvertedError__) {
      let { message: Kt, ...uo } = value.errorProperties, ho = new Error(Kt);
      return Object.assign(ho, uo), ho;
    }
    if (et$1(value) && value["_constructor-name_"] && options.allowFunction) {
      let Kt = value["_constructor-name_"];
      if (Kt !== "Object") {
        let uo = new Function(`return function ${Kt.replace(/[^a-zA-Z0-9$_]+/g, "")}(){}`)();
        Object.setPrototypeOf(value, new uo());
      }
      return delete value["_constructor-name_"], value;
    }
    if (typeof value == "string" && value.startsWith("_function_") && options.allowFunction) {
      let [, name, source] = value.match(/_function_([^|]*)\|(.*)/) || [], sourceSanitized = source.replace(/[(\(\))|\\| |\]|`]*$/, "");
      if (!options.lazyEval)
        return eval(`(${sourceSanitized})`);
      let result = /* @__PURE__ */ i((...args) => {
        let f = eval(`(${sourceSanitized})`);
        return f(...args);
      }, "result");
      return Object.defineProperty(result, "toString", {
        value: /* @__PURE__ */ i(() => sourceSanitized, "value")
      }), Object.defineProperty(result, "name", {
        value: name
      }), result;
    }
    if (typeof value == "string" && value.startsWith("_regexp_") && options.allowRegExp) {
      let [, Kt, uo] = value.match(/_regexp_([^|]*)\|(.*)/) || [];
      return new RegExp(uo, Kt);
    }
    return typeof value == "string" && value.startsWith("_date_") && options.allowDate ? new Date(value.replace("_date_", "")) : typeof value == "string" && value.startsWith("_duplicate_") ? (refs.push({ target: key, container: this, replacement: value.replace(/^_duplicate_/, "") }), null) : typeof value == "string" && value.startsWith("_symbol_") && options.allowSymbol ? Symbol(value.replace("_symbol_", "")) : typeof value == "string" && value.startsWith("_gsymbol_") && options.allowSymbol ? Symbol.for(value.replace("_gsymbol_", "")) : typeof value == "string" && value === "_-Infinity_" ? -1 / 0 : typeof value == "string" && value === "_Infinity_" ? 1 / 0 : typeof value == "string" && value === "_NaN_" ? NaN : typeof value == "string" && value.startsWith("_bigint_") && typeof BigInt == "function" ? BigInt(value.replace("_bigint_", "")) : value;
  }, "revive");
}, "reviver"), Wt$1 = {
  maxDepth: 10,
  space: void 0,
  allowFunction: !0,
  allowRegExp: !0,
  allowDate: !0,
  allowClass: !0,
  allowError: !0,
  allowUndefined: !0,
  allowSymbol: !0,
  lazyEval: !0
}, ot = /* @__PURE__ */ i((Kt, uo = {}) => {
  let ho = { ...Wt$1, ...uo };
  return JSON.stringify(zt$1(Kt), Vn$1(ho), uo.space);
}, "stringify"), Yn$1 = /* @__PURE__ */ i(() => {
  let Kt = /* @__PURE__ */ new Map();
  return /* @__PURE__ */ i(function uo(ho) {
    et$1(ho) && Object.entries(ho).forEach(([go, bo]) => {
      bo === "_undefined_" ? ho[go] = void 0 : Kt.get(bo) || (Kt.set(bo, !0), uo(bo));
    }), Array.isArray(ho) && ho.forEach((go, bo) => {
      go === "_undefined_" ? (Kt.set(go, !0), ho[bo] = void 0) : Kt.get(go) || (Kt.set(go, !0), uo(go));
    });
  }, "mutateUndefined");
}, "mutator"), at$1 = /* @__PURE__ */ i((Kt, uo = {}) => {
  let ho = { ...Wt$1, ...uo }, go = JSON.parse(Kt, Kn$1(ho));
  return Yn$1()(go), go;
}, "parse"), gt$1 = "Invariant failed";
function q$2(Kt, uo) {
  if (!Kt) {
    var ho = typeof uo == "function" ? uo() : uo, go = ho ? "".concat(gt$1, ": ").concat(ho) : gt$1;
    throw new Error(go);
  }
}
i(q$2, "invariant");
var Bt$1 = /* @__PURE__ */ i((Kt) => {
  let uo = Array.from(
    document.querySelectorAll("iframe[data-is-storybook]")
  ), [ho, ...go] = uo.filter((vo) => {
    var So, wo;
    try {
      return ((So = vo.contentWindow) == null ? void 0 : So.location.origin) === Kt.source.location.origin && ((wo = vo.contentWindow) == null ? void 0 : wo.location.pathname) === Kt.source.location.pathname;
    } catch {
    }
    try {
      return vo.contentWindow === Kt.source;
    } catch {
    }
    let Po = vo.getAttribute("src"), Co;
    try {
      if (!Po)
        return !1;
      ({ origin: Co } = new URL(Po, document.location.toString()));
    } catch {
      return !1;
    }
    return Co === Kt.origin;
  }), bo = ho == null ? void 0 : ho.getAttribute("src");
  if (bo && go.length === 0) {
    let { protocol: vo, host: Po, pathname: Co } = new URL(bo, document.location.toString());
    return `${vo}//${Po}${Co}`;
  }
  return go.length > 0 && s$2.error("found multiple candidates for event source"), null;
}, "getEventSourceUrl"), { document: mt$1, location: vt$1 } = b$1, Gt$1 = "storybook-channel", to$1 = { allowFunction: !1, maxDepth: 25 }, _t$1 = class {
  constructor(uo) {
    if (this.config = uo, this.connected = !1, this.buffer = [], typeof (b$1 == null ? void 0 : b$1.addEventListener) == "function" && b$1.addEventListener("message", this.handleEvent.bind(this), !1), uo.page !== "manager" && uo.page !== "preview")
      throw new Error(`postmsg-channel: "config.page" cannot be "${uo.page}"`);
  }
  setHandler(uo) {
    this.handler = (...ho) => {
      uo.apply(this, ho), !this.connected && this.getLocalFrame().length && (this.flush(), this.connected = !0);
    };
  }
  /**
   * Sends `event` to the associated window. If the window does not yet exist the event will be
   * stored in a buffer and sent when the window exists.
   *
   * @param event
   */
  send(uo, ho) {
    let {
      target: go,
      // telejson options
      allowRegExp: bo,
      allowFunction: vo,
      allowSymbol: Po,
      allowDate: Co,
      allowError: So,
      allowUndefined: wo,
      allowClass: Eo,
      maxDepth: Ro,
      space: _o,
      lazyEval: Io
    } = ho || {}, Ao = Object.fromEntries(
      Object.entries({
        allowRegExp: bo,
        allowFunction: vo,
        allowSymbol: Po,
        allowDate: Co,
        allowError: So,
        allowUndefined: wo,
        allowClass: Eo,
        maxDepth: Ro,
        space: _o,
        lazyEval: Io
      }).filter(([ko, Ko]) => typeof Ko < "u")
    ), Oo = {
      ...to$1,
      ...b$1.CHANNEL_OPTIONS || {},
      ...Ao
    }, jo = this.getFrames(go), Do = new URLSearchParams((vt$1 == null ? void 0 : vt$1.search) || ""), Lo = ot(
      {
        key: Gt$1,
        event: uo,
        refId: Do.get("refId")
      },
      Oo
    );
    return jo.length ? (this.buffer.length && this.flush(), jo.forEach((ko) => {
      try {
        ko.postMessage(Lo, "*");
      } catch {
        s$2.error("sending over postmessage fail");
      }
    }), Promise.resolve(null)) : new Promise((ko, Ko) => {
      this.buffer.push({ event: uo, resolve: ko, reject: Ko });
    });
  }
  flush() {
    let { buffer: uo } = this;
    this.buffer = [], uo.forEach((ho) => {
      this.send(ho.event).then(ho.resolve).catch(ho.reject);
    });
  }
  getFrames(uo) {
    if (this.config.page === "manager") {
      let ho = Array.from(
        mt$1.querySelectorAll("iframe[data-is-storybook][data-is-loaded]")
      ).flatMap((go) => {
        try {
          return go.contentWindow && go.dataset.isStorybook !== void 0 && go.id === uo ? [go.contentWindow] : [];
        } catch {
          return [];
        }
      });
      return ho != null && ho.length ? ho : this.getCurrentFrames();
    }
    return b$1 && b$1.parent && b$1.parent !== b$1.self ? [b$1.parent] : [];
  }
  getCurrentFrames() {
    return this.config.page === "manager" ? Array.from(
      mt$1.querySelectorAll('[data-is-storybook="true"]')
    ).flatMap((uo) => uo.contentWindow ? [uo.contentWindow] : []) : b$1 && b$1.parent ? [b$1.parent] : [];
  }
  getLocalFrame() {
    return this.config.page === "manager" ? Array.from(
      mt$1.querySelectorAll("#storybook-preview-iframe")
    ).flatMap((uo) => uo.contentWindow ? [uo.contentWindow] : []) : b$1 && b$1.parent ? [b$1.parent] : [];
  }
  handleEvent(uo) {
    try {
      let { data: ho } = uo, { key: go, event: bo, refId: vo } = typeof ho == "string" && H$1(ho) ? at$1(ho, b$1.CHANNEL_OPTIONS || {}) : ho;
      if (go === Gt$1) {
        let Po = this.config.page === "manager" ? '<span style="color: #37D5D3; background: black"> manager </span>' : '<span style="color: #1EA7FD; background: black"> preview </span>', Co = Object.values(Qn$1).includes(bo.type) ? `<span style="color: #FF4785">${bo.type}</span>` : `<span style="color: #FFAE00">${bo.type}</span>`;
        if (vo && (bo.refId = vo), bo.source = this.config.page === "preview" ? uo.origin : Bt$1(uo), !bo.source) {
          r$2.error(
            `${Po} received ${Co} but was unable to determine the source of the event`
          );
          return;
        }
        let So = `${Po} received ${Co} (${ho.length})`;
        r$2.debug(
          vt$1.origin !== bo.source ? So : `${So} <span style="color: gray">(on ${vt$1.origin} from ${bo.source})</span>`,
          ...bo.args
        ), q$2(this.handler, "ChannelHandler should be set"), this.handler(bo);
      }
    } catch (ho) {
      s$2.error(ho);
    }
  }
};
i(_t$1, "PostMessageTransport");
var G$2 = _t$1, { WebSocket: eo$1 } = b$1, bt = class {
  constructor({ url: uo, onError: ho, page: go }) {
    this.buffer = [], this.isReady = !1, this.socket = new eo$1(uo), this.socket.onopen = () => {
      this.isReady = !0, this.flush();
    }, this.socket.onmessage = ({ data: bo }) => {
      let vo = typeof bo == "string" && H$1(bo) ? at$1(bo) : bo;
      q$2(this.handler, "WebsocketTransport handler should be set"), this.handler(vo);
    }, this.socket.onerror = (bo) => {
      ho && ho(bo);
    }, this.socket.onclose = () => {
      q$2(this.handler, "WebsocketTransport handler should be set"), this.handler({ type: S$2, args: [], from: go || "preview" });
    };
  }
  setHandler(uo) {
    this.handler = uo;
  }
  send(uo) {
    this.isReady ? this.sendNow(uo) : this.sendLater(uo);
  }
  sendLater(uo) {
    this.buffer.push(uo);
  }
  sendNow(uo) {
    let ho = ot(uo, {
      maxDepth: 15,
      allowFunction: !1,
      ...b$1.CHANNEL_OPTIONS
    });
    this.socket.send(ho);
  }
  flush() {
    let { buffer: uo } = this;
    this.buffer = [], uo.forEach((ho) => this.send(ho));
  }
};
i(bt, "WebsocketTransport");
var J$1 = bt, { CONFIG_TYPE: ro } = b$1;
function $o$1({ page: Kt, extraTransports: uo = [] }) {
  let ho = [new G$2({ page: Kt }), ...uo];
  if (ro === "DEVELOPMENT") {
    let go = window.location.protocol === "http:" ? "ws" : "wss", { hostname: bo, port: vo } = window.location, Po = `${go}://${bo}:${vo}/storybook-server-channel`;
    ho.push(new J$1({ url: Po, onError: /* @__PURE__ */ i(() => {
    }, "onError"), page: Kt }));
  }
  return new z$2({ transports: ho });
}
i($o$1, "createBrowserChannel");
var oe$1 = Object.defineProperty, t = (Kt, uo) => oe$1(Kt, "name", { value: uo, configurable: !0 });
function r(Kt) {
  for (var uo = [], ho = 1; ho < arguments.length; ho++)
    uo[ho - 1] = arguments[ho];
  var go = Array.from(typeof Kt == "string" ? [Kt] : Kt);
  go[go.length - 1] = go[go.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var bo = go.reduce(function(Co, So) {
    var wo = So.match(/\n([\t ]+|(?!\s).)/g);
    return wo ? Co.concat(wo.map(function(Eo) {
      var Ro, _o;
      return (_o = (Ro = Eo.match(/[\t ]/g)) === null || Ro === void 0 ? void 0 : Ro.length) !== null && _o !== void 0 ? _o : 0;
    })) : Co;
  }, []);
  if (bo.length) {
    var vo = new RegExp(`
[	 ]{` + Math.min.apply(Math, bo) + "}", "g");
    go = go.map(function(Co) {
      return Co.replace(vo, `
`);
    });
  }
  go[0] = go[0].replace(/^\r?\n/, "");
  var Po = go[0];
  return uo.forEach(function(Co, So) {
    var wo = Po.match(/(?:^|\n)( *)$/), Eo = wo ? wo[1] : "", Ro = Co;
    typeof Co == "string" && Co.includes(`
`) && (Ro = String(Co).split(`
`).map(function(_o, Io) {
      return Io === 0 ? _o : "" + Eo + _o;
    }).join(`
`)), Po += Ro + go[So + 1];
  }), Po;
}
t(r, "dedent");
function C$1({
  code: Kt,
  category: uo
}) {
  let ho = String(Kt).padStart(4, "0");
  return `SB_${uo}_${ho}`;
}
t(C$1, "parseErrorCode");
var p = class Ia extends Error {
  constructor(uo) {
    super(Ia.getFullMessage(uo)), this.data = {}, this.fromStorybook = !0, this.category = uo.category, this.documentation = uo.documentation ?? !1, this.code = uo.code;
  }
  get fullErrorCode() {
    return C$1({ code: this.code, category: this.category });
  }
  /** Overrides the default `Error.name` property in the format: SB_<CATEGORY>_<CODE>. */
  get name() {
    let uo = this.constructor.name;
    return `${this.fullErrorCode} (${uo})`;
  }
  /** Generates the error message along with additional documentation link (if applicable). */
  static getFullMessage({
    documentation: uo,
    code: ho,
    category: go,
    message: bo
  }) {
    let vo;
    return uo === !0 ? vo = `https://storybook.js.org/error/${C$1({ code: ho, category: go })}` : typeof uo == "string" ? vo = uo : Array.isArray(uo) && (vo = `
${uo.map((Po) => `	- ${Po}`).join(`
`)}`), `${bo}${vo != null ? `

More info: ${vo}
` : ""}`;
  }
};
t(p, "StorybookError");
var o = p, f$1 = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 1,
      message: r`
        Couldn't find story matching id '${uo.storyId}' after HMR.
        - Did you just rename a story?
        - Did you remove it from your CSF file?
        - Are you sure a story with the id '${uo.storyId}' exists?
        - Please check the values in the stories field of your main.js config and see if they would match your CSF File.
        - Also check the browser console and terminal for potential error messages.`
    }), this.data = uo;
  }
};
t(f$1, "MissingStoryAfterHmrError");
var D$1 = f$1, R$1 = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 2,
      documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#using-implicit-actions-during-rendering-is-deprecated-for-example-in-the-play-function",
      message: r`
        We detected that you use an implicit action arg while ${uo.phase} of your story.  
        ${uo.deprecated ? `
This is deprecated and won't work in Storybook 8 anymore.
` : ""}
        Please provide an explicit spy to your args like this:
          import { fn } from '@storybook/test';
          ... 
          args: {
           ${uo.name}: fn()
          }`
    }), this.data = uo;
  }
};
t(R$1, "ImplicitActionsDuringRendering");
var j = R$1, b = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 3,
      message: r`
        Cannot call \`storyStore.extract()\` without calling \`storyStore.cacheAllCsfFiles()\` first.

        You probably meant to call \`await preview.extract()\` which does the above for you.`
    });
  }
};
t(b, "CalledExtractOnStoreError");
var L$1 = b, I$1 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 4,
      message: r`
        Expected your framework's preset to export a \`renderToCanvas\` field.

        Perhaps it needs to be upgraded for Storybook 7.0?`,
      documentation: "https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#mainjs-framework-field"
    });
  }
};
t(I$1, "MissingRenderToCanvasError");
var G$1 = I$1, P$2 = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 5,
      message: r`
        Called \`Preview.${uo.methodName}()\` before initialization.
        
        The preview needs to load the story index before most methods can be called. If you want
        to call \`${uo.methodName}\`, try \`await preview.initializationPromise;\` first.
        
        If you didn't call the above code, then likely it was called by an addon that needs to
        do the above.`
    }), this.data = uo;
  }
};
t(P$2, "CalledPreviewMethodBeforeInitializationError");
var Y$1 = P$2, x$1 = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 6,
      message: r`
        Error fetching \`/index.json\`:
        
        ${uo.text}

        If you are in development, this likely indicates a problem with your Storybook process,
        check the terminal for errors.

        If you are in a deployed Storybook, there may have been an issue deploying the full Storybook
        build.`
    }), this.data = uo;
  }
};
t(x$1, "StoryIndexFetchError");
var M$2 = x$1, T = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 7,
      message: r`
        Tried to render docs entry ${uo.storyId} but it is a MDX file that has no CSF
        references, or autodocs for a CSF file that some doesn't refer to itself.
        
        This likely is an internal error in Storybook's indexing, or you've attached the
        \`attached-mdx\` tag to an MDX file that is not attached.`
    }), this.data = uo;
  }
};
t(T, "MdxFileWithNoCsfReferencesError");
var H = T, w$1 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 8,
      message: r`
        Couldn't find any stories in your Storybook.

        - Please check your stories field of your main.js config: does it match correctly?
        - Also check the browser console and terminal for error messages.`
    });
  }
};
t(w$1, "EmptyIndexError");
var F$2 = w$1, k$2 = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 9,
      message: r`
        Couldn't find story matching '${uo.storySpecifier}'.

        - Are you sure a story with that id exists?
        - Please check your stories field of your main.js config.
        - Also check the browser console and terminal for error messages.`
    }), this.data = uo;
  }
};
t(k$2, "NoStoryMatchError");
var K$1 = k$2, S$1 = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 10,
      message: r`
        Couldn't find story matching id '${uo.storyId}' after importing a CSF file.

        The file was indexed as if the story was there, but then after importing the file in the browser
        we didn't find the story. Possible reasons:
        - You are using a custom story indexer that is misbehaving.
        - You have a custom file loader that is removing or renaming exports.

        Please check your browser console and terminal for errors that may explain the issue.`
    }), this.data = uo;
  }
};
t(S$1, "MissingStoryFromCsfFileError");
var X$1 = S$1, v$2 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 11,
      message: r`
        Cannot access the Story Store until the index is ready.

        It is not recommended to use methods directly on the Story Store anyway, in Storybook 9 we will
        remove access to the store entirely`
    });
  }
};
t(v$2, "StoryStoreAccessedBeforeInitializationError");
var U$1 = v$2, _ = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 12,
      message: r`
      Incorrect use of mount in the play function.
      
      To use mount in the play function, you must satisfy the following two requirements: 
      
      1. You *must* destructure the mount property from the \`context\` (the argument passed to your play function). 
         This makes sure that Storybook does not start rendering the story before the play function begins.
      
      2. Your Storybook framework or builder must be configured to transpile to ES2017 or newer. 
         This is because destructuring statements and async/await usages are otherwise transpiled away, 
         which prevents Storybook from recognizing your usage of \`mount\`.
      
      Note that Angular is not supported. As async/await is transpiled to support the zone.js polyfill. 
      
      More info: https://storybook.js.org/docs/writing-tests/interaction-testing#run-code-before-the-component-gets-rendered
      
      Received the following play function:
      ${uo.playFunction}`
    }), this.data = uo;
  }
};
t(_, "MountMustBeDestructuredError");
var J = _, V = class extends o {
  constructor(uo) {
    super({
      category: "PREVIEW_API",
      code: 14,
      message: r`
        No render function available for storyId '${uo.id}'
      `
    }), this.data = uo;
  }
};
t(V, "NoRenderFunctionError");
var q$1 = V, N$1 = class extends o {
  constructor() {
    super({
      category: "PREVIEW_API",
      code: 15,
      message: r`
        No component is mounted in your story.
        
        This usually occurs when you destructure mount in the play function, but forget to call it.
        
        For example:

        async play({ mount, canvasElement }) {
          // 👈 mount should be called: await mount(); 
          const canvas = within(canvasElement);
          const button = await canvas.findByRole('button');
          await userEvent.click(button);
        };

        Make sure to either remove it or call mount in your play function.
      `
    });
  }
};
t(N$1, "NoStoryMountedError");
var z$1 = N$1, A = class extends o {
  constructor() {
    super({
      category: "FRAMEWORK_NEXTJS",
      code: 1,
      documentation: "https://storybook.js.org/docs/get-started/nextjs#faq",
      message: r`
      You are importing avif images, but you don't have sharp installed.

      You have to install sharp in order to use image optimization features in Next.js.
      `
    });
  }
};
t(A, "NextJsSharpError");
var W = class extends o {
  constructor(uo) {
    super({
      category: "FRAMEWORK_NEXTJS",
      code: 2,
      message: r`
        Tried to access router mocks from "${uo.importType}" but they were not created yet. You might be running code in an unsupported environment.
      `
    }), this.data = uo;
  }
};
t(W, "NextjsRouterMocksNotAvailable");
var $$1 = class extends o {
  constructor(uo) {
    super({
      category: "DOCS-TOOLS",
      code: 1,
      documentation: "https://github.com/storybookjs/storybook/issues/26606",
      message: r`
        There was a failure when generating detailed ArgTypes in ${uo.language} for:
        ${JSON.stringify(uo.type, null, 2)} 
        
        Storybook will fall back to use a generic type description instead.

        This type is either not supported or it is a bug in the docgen generation in Storybook.
        If you think this is a bug, please detail it as much as possible in the Github issue.
      `
    }), this.data = uo;
  }
};
t($$1, "UnknownArgTypesError");
var O$2 = class extends o {
  constructor(uo) {
    super({
      category: "ADDON_VITEST",
      code: 1,
      // TODO: Add documentation about viewports support
      // documentation: '',
      message: r`
        Encountered an unsupported value "${uo.value}" when setting the viewport ${uo.dimension} dimension.
        
        The Storybook plugin only supports values in the following units:
        - px, vh, vw, em, rem and %.
        
        You can either change the viewport for this story to use one of the supported units or skip the test by adding '!test' to the story's tags per https://storybook.js.org/docs/writing-stories/tags
      `
    }), this.data = uo;
  }
};
t(O$2, "UnsupportedViewportDimensionError");
var C = Object.create, u = Object.defineProperty, B = Object.getOwnPropertyDescriptor, F$1 = Object.getOwnPropertyNames, h = Object.getPrototypeOf, w = Object.prototype.hasOwnProperty, E = (Kt, uo) => () => (uo || Kt((uo = { exports: {} }).exports, uo), uo.exports), v$1 = (Kt, uo, ho, go) => {
  if (uo && typeof uo == "object" || typeof uo == "function") for (let bo of F$1(uo)) !w.call(Kt, bo) && bo !== ho && u(Kt, bo, { get: () => uo[bo], enumerable: !(go = B(uo, bo)) || go.enumerable });
  return Kt;
}, I = (Kt, uo, ho) => (ho = Kt != null ? C(h(Kt)) : {}, v$1(!Kt || !Kt.__esModule ? u(ho, "default", { value: Kt, enumerable: !0 }) : ho, Kt)), x = E((Kt) => {
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.isEqual = /* @__PURE__ */ function() {
    var uo = Object.prototype.toString, ho = Object.getPrototypeOf, go = Object.getOwnPropertySymbols ? function(bo) {
      return Object.keys(bo).concat(Object.getOwnPropertySymbols(bo));
    } : Object.keys;
    return function(bo, vo) {
      return function Po(Co, So, wo) {
        var Eo, Ro, _o, Io = uo.call(Co), Ao = uo.call(So);
        if (Co === So) return !0;
        if (Co == null || So == null) return !1;
        if (wo.indexOf(Co) > -1 && wo.indexOf(So) > -1) return !0;
        if (wo.push(Co, So), Io != Ao || (Eo = go(Co), Ro = go(So), Eo.length != Ro.length || Eo.some(function(Oo) {
          return !Po(Co[Oo], So[Oo], wo);
        }))) return !1;
        switch (Io.slice(8, -1)) {
          case "Symbol":
            return Co.valueOf() == So.valueOf();
          case "Date":
          case "Number":
            return +Co == +So || +Co != +Co && +So != +So;
          case "RegExp":
          case "Function":
          case "String":
          case "Boolean":
            return "" + Co == "" + So;
          case "Set":
          case "Map":
            Eo = Co.entries(), Ro = So.entries();
            do
              if (!Po((_o = Eo.next()).value, Ro.next().value, wo)) return !1;
            while (!_o.done);
            return !0;
          case "ArrayBuffer":
            Co = new Uint8Array(Co), So = new Uint8Array(So);
          case "DataView":
            Co = new Uint8Array(Co.buffer), So = new Uint8Array(So.buffer);
          case "Float32Array":
          case "Float64Array":
          case "Int8Array":
          case "Int16Array":
          case "Int32Array":
          case "Uint8Array":
          case "Uint16Array":
          case "Uint32Array":
          case "Uint8ClampedArray":
          case "Arguments":
          case "Array":
            if (Co.length != So.length) return !1;
            for (_o = 0; _o < Co.length; _o++) if ((_o in Co || _o in So) && (_o in Co != _o in So || !Po(Co[_o], So[_o], wo))) return !1;
            return !0;
          case "Object":
            return Po(ho(Co), ho(So), wo);
          default:
            return !1;
        }
      }(bo, vo, []);
    };
  }();
});
function R(Kt) {
  return Kt.replace(/_/g, " ").replace(/-/g, " ").replace(/\./g, " ").replace(/([^\n])([A-Z])([a-z])/g, (uo, ho, go, bo) => `${ho} ${go}${bo}`).replace(/([a-z])([A-Z])/g, (uo, ho, go) => `${ho} ${go}`).replace(/([a-z])([0-9])/gi, (uo, ho, go) => `${ho} ${go}`).replace(/([0-9])([a-z])/gi, (uo, ho, go) => `${ho} ${go}`).replace(/(\s|^)(\w)/g, (uo, ho, go) => `${ho}${go.toUpperCase()}`).replace(/ +/g, " ").trim();
}
var l = I(x()), S = (Kt) => Kt.map((uo) => typeof uo < "u").filter(Boolean).length, k$1 = (Kt, uo) => {
  let { exists: ho, eq: go, neq: bo, truthy: vo } = Kt;
  if (S([ho, go, bo, vo]) > 1) throw new Error(`Invalid conditional test ${JSON.stringify({ exists: ho, eq: go, neq: bo })}`);
  if (typeof go < "u") return (0, l.isEqual)(uo, go);
  if (typeof bo < "u") return !(0, l.isEqual)(uo, bo);
  if (typeof ho < "u") {
    let Po = typeof uo < "u";
    return ho ? Po : !Po;
  }
  return typeof vo > "u" || vo ? !!uo : !uo;
}, P$1 = (Kt, uo, ho) => {
  if (!Kt.if) return !0;
  let { arg: go, global: bo } = Kt.if;
  if (S([go, bo]) !== 1) throw new Error(`Invalid conditional value ${JSON.stringify({ arg: go, global: bo })}`);
  let vo = go ? uo[go] : ho[bo];
  return k$1(Kt.if, vo);
}, O$1 = (Kt) => Kt.toLowerCase().replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, "-").replace(/-+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), f = (Kt, uo) => {
  let ho = O$1(Kt);
  if (ho === "") throw new Error(`Invalid ${uo} '${Kt}', must include alphanumeric characters`);
  return ho;
}, G = (Kt, uo) => `${f(Kt, "kind")}${uo ? `--${f(uo, "name")}` : ""}`, N = (Kt) => R(Kt);
function m(Kt, uo) {
  return Array.isArray(uo) ? uo.includes(Kt) : Kt.match(uo);
}
function M$1(Kt, { includeStories: uo, excludeStories: ho }) {
  return Kt !== "__esModule" && (!uo || m(Kt, uo)) && (!ho || !m(Kt, ho));
}
var z = (...Kt) => {
  let uo = Kt.reduce((ho, go) => (go.startsWith("!") ? ho.delete(go.slice(1)) : ho.add(go), ho), /* @__PURE__ */ new Set());
  return Array.from(uo);
}, On = Object.create, ur = Object.defineProperty, Dn = Object.getOwnPropertyDescriptor, kn = Object.getOwnPropertyNames, jn = Object.getPrototypeOf, Mn = Object.prototype.hasOwnProperty, s = (Kt, uo) => ur(Kt, "name", { value: uo, configurable: !0 }), Re = /* @__PURE__ */ ((Kt) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(Kt, {
  get: (uo, ho) => (typeof require < "u" ? require : uo)[ho]
}) : Kt)(function(Kt) {
  if (typeof require < "u") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + Kt + '" is not supported');
}), O = (Kt, uo) => () => (uo || Kt((uo = { exports: {} }).exports, uo), uo.exports), _n = (Kt, uo, ho, go) => {
  if (uo && typeof uo == "object" || typeof uo == "function")
    for (let bo of kn(uo))
      !Mn.call(Kt, bo) && bo !== ho && ur(Kt, bo, { get: () => uo[bo], enumerable: !(go = Dn(uo, bo)) || go.enumerable });
  return Kt;
}, ce = (Kt, uo, ho) => (ho = Kt != null ? On(jn(Kt)) : {}, _n(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  ur(ho, "default", { value: Kt, enumerable: !0 }),
  Kt
)), Ir = O((Kt, uo) => {
  (function(ho) {
    if (typeof Kt == "object" && typeof uo < "u")
      uo.exports = ho();
    else if (typeof define == "function" && define.amd)
      define([], ho);
    else {
      var go;
      typeof window < "u" ? go = window : typeof global < "u" ? go = global : typeof self < "u" ? go = self : go = this, go.memoizerific = ho();
    }
  })(function() {
    return (/* @__PURE__ */ s(function ho(go, bo, vo) {
      function Po(wo, Eo) {
        if (!bo[wo]) {
          if (!go[wo]) {
            var Ro = typeof Re == "function" && Re;
            if (!Eo && Ro) return Ro(wo, !0);
            if (Co) return Co(wo, !0);
            var _o = new Error("Cannot find module '" + wo + "'");
            throw _o.code = "MODULE_NOT_FOUND", _o;
          }
          var Io = bo[wo] = { exports: {} };
          go[wo][0].call(Io.exports, function(Ao) {
            var Oo = go[wo][1][Ao];
            return Po(Oo || Ao);
          }, Io, Io.exports, ho, go, bo, vo);
        }
        return bo[wo].exports;
      }
      s(Po, "s");
      for (var Co = typeof Re == "function" && Re, So = 0; So < vo.length; So++) Po(vo[So]);
      return Po;
    }, "e"))({ 1: [function(ho, go, bo) {
      go.exports = function(vo) {
        if (typeof Map != "function" || vo) {
          var Po = ho("./similar");
          return new Po();
        } else
          return /* @__PURE__ */ new Map();
      };
    }, { "./similar": 2 }], 2: [function(ho, go, bo) {
      function vo() {
        return this.list = [], this.lastItem = void 0, this.size = 0, this;
      }
      s(vo, "Similar"), vo.prototype.get = function(Po) {
        var Co;
        if (this.lastItem && this.isEqual(this.lastItem.key, Po))
          return this.lastItem.val;
        if (Co = this.indexOf(Po), Co >= 0)
          return this.lastItem = this.list[Co], this.list[Co].val;
      }, vo.prototype.set = function(Po, Co) {
        var So;
        return this.lastItem && this.isEqual(this.lastItem.key, Po) ? (this.lastItem.val = Co, this) : (So = this.indexOf(Po), So >= 0 ? (this.lastItem = this.list[So], this.list[So].val = Co, this) : (this.lastItem = { key: Po, val: Co }, this.list.push(this.lastItem), this.size++, this));
      }, vo.prototype.delete = function(Po) {
        var Co;
        if (this.lastItem && this.isEqual(this.lastItem.key, Po) && (this.lastItem = void 0), Co = this.indexOf(Po), Co >= 0)
          return this.size--, this.list.splice(Co, 1)[0];
      }, vo.prototype.has = function(Po) {
        var Co;
        return this.lastItem && this.isEqual(this.lastItem.key, Po) ? !0 : (Co = this.indexOf(Po), Co >= 0 ? (this.lastItem = this.list[Co], !0) : !1);
      }, vo.prototype.forEach = function(Po, Co) {
        var So;
        for (So = 0; So < this.size; So++)
          Po.call(Co || this, this.list[So].val, this.list[So].key, this);
      }, vo.prototype.indexOf = function(Po) {
        var Co;
        for (Co = 0; Co < this.size; Co++)
          if (this.isEqual(this.list[Co].key, Po))
            return Co;
        return -1;
      }, vo.prototype.isEqual = function(Po, Co) {
        return Po === Co || Po !== Po && Co !== Co;
      }, go.exports = vo;
    }, {}], 3: [function(ho, go, bo) {
      var vo = ho("map-or-similar");
      go.exports = function(wo) {
        var Eo = new vo(!1), Ro = [];
        return function(_o) {
          var Io = /* @__PURE__ */ s(function() {
            var Ao = Eo, Oo, jo, Do = arguments.length - 1, Lo = Array(Do + 1), ko = !0, Ko;
            if ((Io.numArgs || Io.numArgs === 0) && Io.numArgs !== Do + 1)
              throw new Error("Memoizerific functions should always be called with the same number of arguments");
            for (Ko = 0; Ko < Do; Ko++) {
              if (Lo[Ko] = {
                cacheItem: Ao,
                arg: arguments[Ko]
              }, Ao.has(arguments[Ko])) {
                Ao = Ao.get(arguments[Ko]);
                continue;
              }
              ko = !1, Oo = new vo(!1), Ao.set(arguments[Ko], Oo), Ao = Oo;
            }
            return ko && (Ao.has(arguments[Do]) ? jo = Ao.get(arguments[Do]) : ko = !1), ko || (jo = _o.apply(null, arguments), Ao.set(arguments[Do], jo)), wo > 0 && (Lo[Do] = {
              cacheItem: Ao,
              arg: arguments[Do]
            }, ko ? Po(Ro, Lo) : Ro.push(Lo), Ro.length > wo && Co(Ro.shift())), Io.wasMemoized = ko, Io.numArgs = Do + 1, jo;
          }, "memoizerific");
          return Io.limit = wo, Io.wasMemoized = !1, Io.cache = Eo, Io.lru = Ro, Io;
        };
      };
      function Po(wo, Eo) {
        var Ro = wo.length, _o = Eo.length, Io, Ao, Oo;
        for (Ao = 0; Ao < Ro; Ao++) {
          for (Io = !0, Oo = 0; Oo < _o; Oo++)
            if (!So(wo[Ao][Oo].arg, Eo[Oo].arg)) {
              Io = !1;
              break;
            }
          if (Io)
            break;
        }
        wo.push(wo.splice(Ao, 1)[0]);
      }
      s(Po, "moveToMostRecentLru");
      function Co(wo) {
        var Eo = wo.length, Ro = wo[Eo - 1], _o, Io;
        for (Ro.cacheItem.delete(Ro.arg), Io = Eo - 2; Io >= 0 && (Ro = wo[Io], _o = Ro.cacheItem.get(Ro.arg), !_o || !_o.size); Io--)
          Ro.cacheItem.delete(Ro.arg);
      }
      s(Co, "removeCachedResult");
      function So(wo, Eo) {
        return wo === Eo || wo !== wo && Eo !== Eo;
      }
      s(So, "isEqual");
    }, { "map-or-similar": 1 }] }, {}, [3])(3);
  });
}), et = O((Kt) => {
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.encodeString = go;
  var uo = Array.from({ length: 256 }, (bo, vo) => "%" + ((vo < 16 ? "0" : "") + vo.toString(16)).toUpperCase()), ho = new Int8Array([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0
  ]);
  function go(bo) {
    let vo = bo.length;
    if (vo === 0)
      return "";
    let Po = "", Co = 0, So = 0;
    e: for (; So < vo; So++) {
      let wo = bo.charCodeAt(So);
      for (; wo < 128; ) {
        if (ho[wo] !== 1 && (Co < So && (Po += bo.slice(Co, So)), Co = So + 1, Po += uo[wo]), ++So === vo)
          break e;
        wo = bo.charCodeAt(So);
      }
      if (Co < So && (Po += bo.slice(Co, So)), wo < 2048) {
        Co = So + 1, Po += uo[192 | wo >> 6] + uo[128 | wo & 63];
        continue;
      }
      if (wo < 55296 || wo >= 57344) {
        Co = So + 1, Po += uo[224 | wo >> 12] + uo[128 | wo >> 6 & 63] + uo[128 | wo & 63];
        continue;
      }
      if (++So, So >= vo)
        throw new Error("URI malformed");
      let Eo = bo.charCodeAt(So) & 1023;
      Co = So + 1, wo = 65536 + ((wo & 1023) << 10 | Eo), Po += uo[240 | wo >> 18] + uo[128 | wo >> 12 & 63] + uo[128 | wo >> 6 & 63] + uo[128 | wo & 63];
    }
    return Co === 0 ? bo : Co < vo ? Po + bo.slice(Co) : Po;
  }
  s(go, "encodeString");
}), Qe = O((Kt) => {
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.defaultOptions = Kt.defaultShouldSerializeObject = Kt.defaultValueSerializer = void 0;
  var uo = et(), ho = /* @__PURE__ */ s((vo) => {
    switch (typeof vo) {
      case "string":
        return (0, uo.encodeString)(vo);
      case "bigint":
      case "boolean":
        return "" + vo;
      case "number":
        if (Number.isFinite(vo))
          return vo < 1e21 ? "" + vo : (0, uo.encodeString)("" + vo);
        break;
    }
    return vo instanceof Date ? (0, uo.encodeString)(vo.toISOString()) : "";
  }, "defaultValueSerializer");
  Kt.defaultValueSerializer = ho;
  var go = /* @__PURE__ */ s((vo) => vo instanceof Date, "defaultShouldSerializeObject");
  Kt.defaultShouldSerializeObject = go;
  var bo = /* @__PURE__ */ s((vo) => vo, "identityFunc");
  Kt.defaultOptions = {
    nesting: !0,
    nestingSyntax: "dot",
    arrayRepeat: !1,
    arrayRepeatSyntax: "repeat",
    delimiter: 38,
    valueDeserializer: bo,
    valueSerializer: Kt.defaultValueSerializer,
    keyDeserializer: bo,
    shouldSerializeObject: Kt.defaultShouldSerializeObject
  };
}), tt = O((Kt) => {
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.getDeepObject = bo, Kt.stringifyObject = Eo;
  var uo = Qe(), ho = et();
  function go(Ro) {
    return Ro === "__proto__" || Ro === "constructor" || Ro === "prototype";
  }
  s(go, "isPrototypeKey");
  function bo(Ro, _o, Io, Ao, Oo) {
    if (go(_o))
      return Ro;
    let jo = Ro[_o];
    return typeof jo == "object" && jo !== null ? jo : !Ao && (Oo || typeof Io == "number" || typeof Io == "string" && Io * 0 === 0 && Io.indexOf(".") === -1) ? Ro[_o] = [] : Ro[_o] = {};
  }
  s(bo, "getDeepObject");
  var vo = 20, Po = "[]", Co = "[", So = "]", wo = ".";
  function Eo(Ro, _o, Io = 0, Ao, Oo) {
    let { nestingSyntax: jo = uo.defaultOptions.nestingSyntax, arrayRepeat: Do = uo.defaultOptions.arrayRepeat, arrayRepeatSyntax: Lo = uo.defaultOptions.arrayRepeatSyntax, nesting: ko = uo.defaultOptions.nesting, delimiter: Ko = uo.defaultOptions.delimiter, valueSerializer: No = uo.defaultOptions.valueSerializer, shouldSerializeObject: Jo = uo.defaultOptions.shouldSerializeObject } = _o, ti = typeof Ko == "number" ? String.fromCharCode(
      Ko
    ) : Ko, oi = Oo === !0 && Do, Qo = jo === "dot" || jo === "js" && !Oo;
    if (Io > vo)
      return "";
    let Zo = "", ei = !0, ii = !1;
    for (let ai in Ro) {
      let ri = Ro[ai], ni;
      Ao ? (ni = Ao, oi ? Lo === "bracket" && (ni += Po) : Qo ? (ni += wo, ni += ai) : (ni += Co, ni += ai, ni += So)) : ni = ai, ei || (Zo += ti), typeof ri == "object" && ri !== null && !Jo(ri) ? (ii = ri.pop !== void 0, (ko || Do && ii) && (Zo += Eo(ri, _o, Io + 1, ni, ii))) : (Zo += (0, ho.encodeString)(ni), Zo += "=", Zo += No(ri, ai)), ei && (ei = !1);
    }
    return Zo;
  }
  s(Eo, "stringifyObject");
}), Mo = O((Kt, uo) => {
  var ho = 12, go = 0, bo = [
    // The first part of the table maps bytes to character to a transition.
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    7,
    8,
    7,
    7,
    10,
    9,
    9,
    9,
    11,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    // The second part of the table maps a state to a new state when adding a
    // transition.
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    12,
    0,
    0,
    0,
    0,
    24,
    36,
    48,
    60,
    72,
    84,
    96,
    0,
    12,
    12,
    12,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    24,
    24,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    48,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    48,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    // The third part maps the current transition to a mask that needs to apply
    // to the byte.
    127,
    63,
    63,
    63,
    0,
    31,
    15,
    15,
    15,
    7,
    7,
    7
  ];
  function vo(So) {
    var wo = So.indexOf("%");
    if (wo === -1) return So;
    for (var Eo = So.length, Ro = "", _o = 0, Io = 0, Ao = wo, Oo = ho; wo > -1 && wo < Eo; ) {
      var jo = Co(So[wo + 1], 4), Do = Co(So[wo + 2], 0), Lo = jo | Do, ko = bo[Lo];
      if (Oo = bo[256 + Oo + ko], Io = Io << 6 | Lo & bo[364 + ko], Oo === ho)
        Ro += So.slice(_o, Ao), Ro += Io <= 65535 ? String.fromCharCode(Io) : String.fromCharCode(
          55232 + (Io >> 10),
          56320 + (Io & 1023)
        ), Io = 0, _o = wo + 3, wo = Ao = So.indexOf("%", _o);
      else {
        if (Oo === go)
          return null;
        if (wo += 3, wo < Eo && So.charCodeAt(wo) === 37) continue;
        return null;
      }
    }
    return Ro + So.slice(_o);
  }
  s(vo, "decodeURIComponent");
  var Po = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    a: 10,
    A: 10,
    b: 11,
    B: 11,
    c: 12,
    C: 12,
    d: 13,
    D: 13,
    e: 14,
    E: 14,
    f: 15,
    F: 15
  };
  function Co(So, wo) {
    var Eo = Po[So];
    return Eo === void 0 ? 255 : Eo << wo;
  }
  s(Co, "hexCodeToInt"), uo.exports = vo;
}), qo = O((Kt) => {
  var uo = Kt && Kt.__importDefault || function(Ro) {
    return Ro && Ro.__esModule ? Ro : { default: Ro };
  };
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.numberValueDeserializer = Kt.numberKeyDeserializer = void 0, Kt.parse = Eo;
  var ho = tt(), go = Qe(), bo = uo(Mo()), vo = /* @__PURE__ */ s((Ro) => {
    let _o = Number(Ro);
    return Number.isNaN(_o) ? Ro : _o;
  }, "numberKeyDeserializer");
  Kt.numberKeyDeserializer = vo;
  var Po = /* @__PURE__ */ s((Ro) => {
    let _o = Number(Ro);
    return Number.isNaN(_o) ? Ro : _o;
  }, "numberValueDeserializer");
  Kt.numberValueDeserializer = Po;
  var Co = /\+/g, So = /* @__PURE__ */ s(function() {
  }, "Empty");
  So.prototype = /* @__PURE__ */ Object.create(null);
  function wo(Ro, _o, Io, Ao, Oo) {
    let jo = Ro.substring(_o, Io);
    return Ao && (jo = jo.replace(Co, " ")), Oo && (jo = (0, bo.default)(jo) || jo), jo;
  }
  s(wo, "computeKeySlice");
  function Eo(Ro, _o) {
    let { valueDeserializer: Io = go.defaultOptions.valueDeserializer, keyDeserializer: Ao = go.defaultOptions.keyDeserializer, arrayRepeatSyntax: Oo = go.defaultOptions.arrayRepeatSyntax, nesting: jo = go.defaultOptions.nesting, arrayRepeat: Do = go.defaultOptions.arrayRepeat, nestingSyntax: Lo = go.defaultOptions.nestingSyntax, delimiter: ko = go.defaultOptions.delimiter } = _o ?? {}, Ko = typeof ko == "string" ? ko.charCodeAt(0) : ko, No = Lo === "js", Jo = new So();
    if (typeof Ro != "string")
      return Jo;
    let ti = Ro.length, oi = "", Qo = -1, Zo = -1, ei = -1, ii = Jo, ai, ri = "", ni = "", si = !1, li = !1, ui = !1, ci = !1, fi = !1, yi = !1, hi = !1, mi = 0, bi = -1, xi = -1, $i = -1;
    for (let Ci = 0; Ci < ti + 1; Ci++) {
      if (mi = Ci !== ti ? Ro.charCodeAt(Ci) : Ko, mi === Ko) {
        if (hi = Zo > Qo, hi || (Zo = Ci), ei !== Zo - 1 && (ni = wo(Ro, ei + 1, bi > -1 ? bi : Zo, ui, si), ri = Ao(ni), ai !== void 0 && (ii = (0, ho.getDeepObject)(
          ii,
          ai,
          ri,
          No && fi,
          No && yi
        ))), hi || ri !== "") {
          hi && (oi = Ro.slice(Zo + 1, Ci), ci && (oi = oi.replace(Co, " ")), li && (oi = (0, bo.default)(oi) || oi));
          let Si = Io(oi, ri);
          if (Do) {
            let vi = ii[ri];
            vi === void 0 ? bi > -1 ? ii[ri] = [Si] : ii[ri] = Si : vi.pop ? vi.push(Si) : ii[ri] = [vi, Si];
          } else
            ii[ri] = Si;
        }
        oi = "", Qo = Ci, Zo = Ci, si = !1, li = !1, ui = !1, ci = !1, fi = !1, yi = !1, bi = -1, ei = Ci, ii = Jo, ai = void 0, ri = "";
      } else mi === 93 ? (Do && Oo === "bracket" && $i === 91 && (bi = xi), jo && (Lo === "index" || No) && Zo <= Qo && (ei !== xi && (ni = wo(
        Ro,
        ei + 1,
        Ci,
        ui,
        si
      ), ri = Ao(ni), ai !== void 0 && (ii = (0, ho.getDeepObject)(ii, ai, ri, void 0, No)), ai = ri, ui = !1, si = !1), ei = Ci, yi = !0, fi = !1)) : mi === 46 ? jo && (Lo === "dot" || No) && Zo <= Qo && (ei !== xi && (ni = wo(Ro, ei + 1, Ci, ui, si), ri = Ao(ni), ai !== void 0 && (ii = (0, ho.getDeepObject)(
        ii,
        ai,
        ri,
        No
      )), ai = ri, ui = !1, si = !1), fi = !0, yi = !1, ei = Ci) : mi === 91 ? jo && (Lo === "index" || No) && Zo <= Qo && (ei !== xi && (ni = wo(
        Ro,
        ei + 1,
        Ci,
        ui,
        si
      ), ri = Ao(ni), No && ai !== void 0 && (ii = (0, ho.getDeepObject)(ii, ai, ri, No)), ai = ri, ui = !1, si = !1, fi = !1, yi = !0), ei = Ci) : mi === 61 ? Zo <= Qo ? Zo = Ci : li = !0 : mi === 43 ? Zo > Qo ? ci = !0 : ui = !0 : mi === 37 && (Zo > Qo ? li = !0 : si = !0);
      xi = Ci, $i = mi;
    }
    return Jo;
  }
  s(Eo, "parse");
}), Bo = O((Kt) => {
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.stringify = ho;
  var uo = tt();
  function ho(go, bo) {
    if (go === null || typeof go != "object")
      return "";
    let vo = bo ?? {};
    return (0, uo.stringifyObject)(go, vo);
  }
  s(ho, "stringify");
}), tr = O((Kt) => {
  var uo = Kt && Kt.__createBinding || (Object.create ? function(vo, Po, Co, So) {
    So === void 0 && (So = Co);
    var wo = Object.getOwnPropertyDescriptor(Po, Co);
    (!wo || ("get" in wo ? !Po.__esModule : wo.writable || wo.configurable)) && (wo = { enumerable: !0, get: /* @__PURE__ */ s(function() {
      return Po[Co];
    }, "get") }), Object.defineProperty(vo, So, wo);
  } : function(vo, Po, Co, So) {
    So === void 0 && (So = Co), vo[So] = Po[Co];
  }), ho = Kt && Kt.__exportStar || function(vo, Po) {
    for (var Co in vo) Co !== "default" && !Object.prototype.hasOwnProperty.call(Po, Co) && uo(Po, vo, Co);
  };
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.stringify = Kt.parse = void 0;
  var go = qo();
  Object.defineProperty(Kt, "parse", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return go.parse;
  }, "get") });
  var bo = Bo();
  Object.defineProperty(Kt, "stringify", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return bo.stringify;
  }, "get") }), ho(Qe(), Kt);
}), lt = O((Kt, uo) => {
  uo.exports = {
    Aacute: "Á",
    aacute: "á",
    Abreve: "Ă",
    abreve: "ă",
    ac: "∾",
    acd: "∿",
    acE: "∾̳",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    Acy: "А",
    acy: "а",
    AElig: "Æ",
    aelig: "æ",
    af: "⁡",
    Afr: "𝔄",
    afr: "𝔞",
    Agrave: "À",
    agrave: "à",
    alefsym: "ℵ",
    aleph: "ℵ",
    Alpha: "Α",
    alpha: "α",
    Amacr: "Ā",
    amacr: "ā",
    amalg: "⨿",
    amp: "&",
    AMP: "&",
    andand: "⩕",
    And: "⩓",
    and: "∧",
    andd: "⩜",
    andslope: "⩘",
    andv: "⩚",
    ang: "∠",
    ange: "⦤",
    angle: "∠",
    angmsdaa: "⦨",
    angmsdab: "⦩",
    angmsdac: "⦪",
    angmsdad: "⦫",
    angmsdae: "⦬",
    angmsdaf: "⦭",
    angmsdag: "⦮",
    angmsdah: "⦯",
    angmsd: "∡",
    angrt: "∟",
    angrtvb: "⊾",
    angrtvbd: "⦝",
    angsph: "∢",
    angst: "Å",
    angzarr: "⍼",
    Aogon: "Ą",
    aogon: "ą",
    Aopf: "𝔸",
    aopf: "𝕒",
    apacir: "⩯",
    ap: "≈",
    apE: "⩰",
    ape: "≊",
    apid: "≋",
    apos: "'",
    ApplyFunction: "⁡",
    approx: "≈",
    approxeq: "≊",
    Aring: "Å",
    aring: "å",
    Ascr: "𝒜",
    ascr: "𝒶",
    Assign: "≔",
    ast: "*",
    asymp: "≈",
    asympeq: "≍",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    awconint: "∳",
    awint: "⨑",
    backcong: "≌",
    backepsilon: "϶",
    backprime: "‵",
    backsim: "∽",
    backsimeq: "⋍",
    Backslash: "∖",
    Barv: "⫧",
    barvee: "⊽",
    barwed: "⌅",
    Barwed: "⌆",
    barwedge: "⌅",
    bbrk: "⎵",
    bbrktbrk: "⎶",
    bcong: "≌",
    Bcy: "Б",
    bcy: "б",
    bdquo: "„",
    becaus: "∵",
    because: "∵",
    Because: "∵",
    bemptyv: "⦰",
    bepsi: "϶",
    bernou: "ℬ",
    Bernoullis: "ℬ",
    Beta: "Β",
    beta: "β",
    beth: "ℶ",
    between: "≬",
    Bfr: "𝔅",
    bfr: "𝔟",
    bigcap: "⋂",
    bigcirc: "◯",
    bigcup: "⋃",
    bigodot: "⨀",
    bigoplus: "⨁",
    bigotimes: "⨂",
    bigsqcup: "⨆",
    bigstar: "★",
    bigtriangledown: "▽",
    bigtriangleup: "△",
    biguplus: "⨄",
    bigvee: "⋁",
    bigwedge: "⋀",
    bkarow: "⤍",
    blacklozenge: "⧫",
    blacksquare: "▪",
    blacktriangle: "▴",
    blacktriangledown: "▾",
    blacktriangleleft: "◂",
    blacktriangleright: "▸",
    blank: "␣",
    blk12: "▒",
    blk14: "░",
    blk34: "▓",
    block: "█",
    bne: "=⃥",
    bnequiv: "≡⃥",
    bNot: "⫭",
    bnot: "⌐",
    Bopf: "𝔹",
    bopf: "𝕓",
    bot: "⊥",
    bottom: "⊥",
    bowtie: "⋈",
    boxbox: "⧉",
    boxdl: "┐",
    boxdL: "╕",
    boxDl: "╖",
    boxDL: "╗",
    boxdr: "┌",
    boxdR: "╒",
    boxDr: "╓",
    boxDR: "╔",
    boxh: "─",
    boxH: "═",
    boxhd: "┬",
    boxHd: "╤",
    boxhD: "╥",
    boxHD: "╦",
    boxhu: "┴",
    boxHu: "╧",
    boxhU: "╨",
    boxHU: "╩",
    boxminus: "⊟",
    boxplus: "⊞",
    boxtimes: "⊠",
    boxul: "┘",
    boxuL: "╛",
    boxUl: "╜",
    boxUL: "╝",
    boxur: "└",
    boxuR: "╘",
    boxUr: "╙",
    boxUR: "╚",
    boxv: "│",
    boxV: "║",
    boxvh: "┼",
    boxvH: "╪",
    boxVh: "╫",
    boxVH: "╬",
    boxvl: "┤",
    boxvL: "╡",
    boxVl: "╢",
    boxVL: "╣",
    boxvr: "├",
    boxvR: "╞",
    boxVr: "╟",
    boxVR: "╠",
    bprime: "‵",
    breve: "˘",
    Breve: "˘",
    brvbar: "¦",
    bscr: "𝒷",
    Bscr: "ℬ",
    bsemi: "⁏",
    bsim: "∽",
    bsime: "⋍",
    bsolb: "⧅",
    bsol: "\\",
    bsolhsub: "⟈",
    bull: "•",
    bullet: "•",
    bump: "≎",
    bumpE: "⪮",
    bumpe: "≏",
    Bumpeq: "≎",
    bumpeq: "≏",
    Cacute: "Ć",
    cacute: "ć",
    capand: "⩄",
    capbrcup: "⩉",
    capcap: "⩋",
    cap: "∩",
    Cap: "⋒",
    capcup: "⩇",
    capdot: "⩀",
    CapitalDifferentialD: "ⅅ",
    caps: "∩︀",
    caret: "⁁",
    caron: "ˇ",
    Cayleys: "ℭ",
    ccaps: "⩍",
    Ccaron: "Č",
    ccaron: "č",
    Ccedil: "Ç",
    ccedil: "ç",
    Ccirc: "Ĉ",
    ccirc: "ĉ",
    Cconint: "∰",
    ccups: "⩌",
    ccupssm: "⩐",
    Cdot: "Ċ",
    cdot: "ċ",
    cedil: "¸",
    Cedilla: "¸",
    cemptyv: "⦲",
    cent: "¢",
    centerdot: "·",
    CenterDot: "·",
    cfr: "𝔠",
    Cfr: "ℭ",
    CHcy: "Ч",
    chcy: "ч",
    check: "✓",
    checkmark: "✓",
    Chi: "Χ",
    chi: "χ",
    circ: "ˆ",
    circeq: "≗",
    circlearrowleft: "↺",
    circlearrowright: "↻",
    circledast: "⊛",
    circledcirc: "⊚",
    circleddash: "⊝",
    CircleDot: "⊙",
    circledR: "®",
    circledS: "Ⓢ",
    CircleMinus: "⊖",
    CirclePlus: "⊕",
    CircleTimes: "⊗",
    cir: "○",
    cirE: "⧃",
    cire: "≗",
    cirfnint: "⨐",
    cirmid: "⫯",
    cirscir: "⧂",
    ClockwiseContourIntegral: "∲",
    CloseCurlyDoubleQuote: "”",
    CloseCurlyQuote: "’",
    clubs: "♣",
    clubsuit: "♣",
    colon: ":",
    Colon: "∷",
    Colone: "⩴",
    colone: "≔",
    coloneq: "≔",
    comma: ",",
    commat: "@",
    comp: "∁",
    compfn: "∘",
    complement: "∁",
    complexes: "ℂ",
    cong: "≅",
    congdot: "⩭",
    Congruent: "≡",
    conint: "∮",
    Conint: "∯",
    ContourIntegral: "∮",
    copf: "𝕔",
    Copf: "ℂ",
    coprod: "∐",
    Coproduct: "∐",
    copy: "©",
    COPY: "©",
    copysr: "℗",
    CounterClockwiseContourIntegral: "∳",
    crarr: "↵",
    cross: "✗",
    Cross: "⨯",
    Cscr: "𝒞",
    cscr: "𝒸",
    csub: "⫏",
    csube: "⫑",
    csup: "⫐",
    csupe: "⫒",
    ctdot: "⋯",
    cudarrl: "⤸",
    cudarrr: "⤵",
    cuepr: "⋞",
    cuesc: "⋟",
    cularr: "↶",
    cularrp: "⤽",
    cupbrcap: "⩈",
    cupcap: "⩆",
    CupCap: "≍",
    cup: "∪",
    Cup: "⋓",
    cupcup: "⩊",
    cupdot: "⊍",
    cupor: "⩅",
    cups: "∪︀",
    curarr: "↷",
    curarrm: "⤼",
    curlyeqprec: "⋞",
    curlyeqsucc: "⋟",
    curlyvee: "⋎",
    curlywedge: "⋏",
    curren: "¤",
    curvearrowleft: "↶",
    curvearrowright: "↷",
    cuvee: "⋎",
    cuwed: "⋏",
    cwconint: "∲",
    cwint: "∱",
    cylcty: "⌭",
    dagger: "†",
    Dagger: "‡",
    daleth: "ℸ",
    darr: "↓",
    Darr: "↡",
    dArr: "⇓",
    dash: "‐",
    Dashv: "⫤",
    dashv: "⊣",
    dbkarow: "⤏",
    dblac: "˝",
    Dcaron: "Ď",
    dcaron: "ď",
    Dcy: "Д",
    dcy: "д",
    ddagger: "‡",
    ddarr: "⇊",
    DD: "ⅅ",
    dd: "ⅆ",
    DDotrahd: "⤑",
    ddotseq: "⩷",
    deg: "°",
    Del: "∇",
    Delta: "Δ",
    delta: "δ",
    demptyv: "⦱",
    dfisht: "⥿",
    Dfr: "𝔇",
    dfr: "𝔡",
    dHar: "⥥",
    dharl: "⇃",
    dharr: "⇂",
    DiacriticalAcute: "´",
    DiacriticalDot: "˙",
    DiacriticalDoubleAcute: "˝",
    DiacriticalGrave: "`",
    DiacriticalTilde: "˜",
    diam: "⋄",
    diamond: "⋄",
    Diamond: "⋄",
    diamondsuit: "♦",
    diams: "♦",
    die: "¨",
    DifferentialD: "ⅆ",
    digamma: "ϝ",
    disin: "⋲",
    div: "÷",
    divide: "÷",
    divideontimes: "⋇",
    divonx: "⋇",
    DJcy: "Ђ",
    djcy: "ђ",
    dlcorn: "⌞",
    dlcrop: "⌍",
    dollar: "$",
    Dopf: "𝔻",
    dopf: "𝕕",
    Dot: "¨",
    dot: "˙",
    DotDot: "⃜",
    doteq: "≐",
    doteqdot: "≑",
    DotEqual: "≐",
    dotminus: "∸",
    dotplus: "∔",
    dotsquare: "⊡",
    doublebarwedge: "⌆",
    DoubleContourIntegral: "∯",
    DoubleDot: "¨",
    DoubleDownArrow: "⇓",
    DoubleLeftArrow: "⇐",
    DoubleLeftRightArrow: "⇔",
    DoubleLeftTee: "⫤",
    DoubleLongLeftArrow: "⟸",
    DoubleLongLeftRightArrow: "⟺",
    DoubleLongRightArrow: "⟹",
    DoubleRightArrow: "⇒",
    DoubleRightTee: "⊨",
    DoubleUpArrow: "⇑",
    DoubleUpDownArrow: "⇕",
    DoubleVerticalBar: "∥",
    DownArrowBar: "⤓",
    downarrow: "↓",
    DownArrow: "↓",
    Downarrow: "⇓",
    DownArrowUpArrow: "⇵",
    DownBreve: "̑",
    downdownarrows: "⇊",
    downharpoonleft: "⇃",
    downharpoonright: "⇂",
    DownLeftRightVector: "⥐",
    DownLeftTeeVector: "⥞",
    DownLeftVectorBar: "⥖",
    DownLeftVector: "↽",
    DownRightTeeVector: "⥟",
    DownRightVectorBar: "⥗",
    DownRightVector: "⇁",
    DownTeeArrow: "↧",
    DownTee: "⊤",
    drbkarow: "⤐",
    drcorn: "⌟",
    drcrop: "⌌",
    Dscr: "𝒟",
    dscr: "𝒹",
    DScy: "Ѕ",
    dscy: "ѕ",
    dsol: "⧶",
    Dstrok: "Đ",
    dstrok: "đ",
    dtdot: "⋱",
    dtri: "▿",
    dtrif: "▾",
    duarr: "⇵",
    duhar: "⥯",
    dwangle: "⦦",
    DZcy: "Џ",
    dzcy: "џ",
    dzigrarr: "⟿",
    Eacute: "É",
    eacute: "é",
    easter: "⩮",
    Ecaron: "Ě",
    ecaron: "ě",
    Ecirc: "Ê",
    ecirc: "ê",
    ecir: "≖",
    ecolon: "≕",
    Ecy: "Э",
    ecy: "э",
    eDDot: "⩷",
    Edot: "Ė",
    edot: "ė",
    eDot: "≑",
    ee: "ⅇ",
    efDot: "≒",
    Efr: "𝔈",
    efr: "𝔢",
    eg: "⪚",
    Egrave: "È",
    egrave: "è",
    egs: "⪖",
    egsdot: "⪘",
    el: "⪙",
    Element: "∈",
    elinters: "⏧",
    ell: "ℓ",
    els: "⪕",
    elsdot: "⪗",
    Emacr: "Ē",
    emacr: "ē",
    empty: "∅",
    emptyset: "∅",
    EmptySmallSquare: "◻",
    emptyv: "∅",
    EmptyVerySmallSquare: "▫",
    emsp13: " ",
    emsp14: " ",
    emsp: " ",
    ENG: "Ŋ",
    eng: "ŋ",
    ensp: " ",
    Eogon: "Ę",
    eogon: "ę",
    Eopf: "𝔼",
    eopf: "𝕖",
    epar: "⋕",
    eparsl: "⧣",
    eplus: "⩱",
    epsi: "ε",
    Epsilon: "Ε",
    epsilon: "ε",
    epsiv: "ϵ",
    eqcirc: "≖",
    eqcolon: "≕",
    eqsim: "≂",
    eqslantgtr: "⪖",
    eqslantless: "⪕",
    Equal: "⩵",
    equals: "=",
    EqualTilde: "≂",
    equest: "≟",
    Equilibrium: "⇌",
    equiv: "≡",
    equivDD: "⩸",
    eqvparsl: "⧥",
    erarr: "⥱",
    erDot: "≓",
    escr: "ℯ",
    Escr: "ℰ",
    esdot: "≐",
    Esim: "⩳",
    esim: "≂",
    Eta: "Η",
    eta: "η",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    euro: "€",
    excl: "!",
    exist: "∃",
    Exists: "∃",
    expectation: "ℰ",
    exponentiale: "ⅇ",
    ExponentialE: "ⅇ",
    fallingdotseq: "≒",
    Fcy: "Ф",
    fcy: "ф",
    female: "♀",
    ffilig: "ﬃ",
    fflig: "ﬀ",
    ffllig: "ﬄ",
    Ffr: "𝔉",
    ffr: "𝔣",
    filig: "ﬁ",
    FilledSmallSquare: "◼",
    FilledVerySmallSquare: "▪",
    fjlig: "fj",
    flat: "♭",
    fllig: "ﬂ",
    fltns: "▱",
    fnof: "ƒ",
    Fopf: "𝔽",
    fopf: "𝕗",
    forall: "∀",
    ForAll: "∀",
    fork: "⋔",
    forkv: "⫙",
    Fouriertrf: "ℱ",
    fpartint: "⨍",
    frac12: "½",
    frac13: "⅓",
    frac14: "¼",
    frac15: "⅕",
    frac16: "⅙",
    frac18: "⅛",
    frac23: "⅔",
    frac25: "⅖",
    frac34: "¾",
    frac35: "⅗",
    frac38: "⅜",
    frac45: "⅘",
    frac56: "⅚",
    frac58: "⅝",
    frac78: "⅞",
    frasl: "⁄",
    frown: "⌢",
    fscr: "𝒻",
    Fscr: "ℱ",
    gacute: "ǵ",
    Gamma: "Γ",
    gamma: "γ",
    Gammad: "Ϝ",
    gammad: "ϝ",
    gap: "⪆",
    Gbreve: "Ğ",
    gbreve: "ğ",
    Gcedil: "Ģ",
    Gcirc: "Ĝ",
    gcirc: "ĝ",
    Gcy: "Г",
    gcy: "г",
    Gdot: "Ġ",
    gdot: "ġ",
    ge: "≥",
    gE: "≧",
    gEl: "⪌",
    gel: "⋛",
    geq: "≥",
    geqq: "≧",
    geqslant: "⩾",
    gescc: "⪩",
    ges: "⩾",
    gesdot: "⪀",
    gesdoto: "⪂",
    gesdotol: "⪄",
    gesl: "⋛︀",
    gesles: "⪔",
    Gfr: "𝔊",
    gfr: "𝔤",
    gg: "≫",
    Gg: "⋙",
    ggg: "⋙",
    gimel: "ℷ",
    GJcy: "Ѓ",
    gjcy: "ѓ",
    gla: "⪥",
    gl: "≷",
    glE: "⪒",
    glj: "⪤",
    gnap: "⪊",
    gnapprox: "⪊",
    gne: "⪈",
    gnE: "≩",
    gneq: "⪈",
    gneqq: "≩",
    gnsim: "⋧",
    Gopf: "𝔾",
    gopf: "𝕘",
    grave: "`",
    GreaterEqual: "≥",
    GreaterEqualLess: "⋛",
    GreaterFullEqual: "≧",
    GreaterGreater: "⪢",
    GreaterLess: "≷",
    GreaterSlantEqual: "⩾",
    GreaterTilde: "≳",
    Gscr: "𝒢",
    gscr: "ℊ",
    gsim: "≳",
    gsime: "⪎",
    gsiml: "⪐",
    gtcc: "⪧",
    gtcir: "⩺",
    gt: ">",
    GT: ">",
    Gt: "≫",
    gtdot: "⋗",
    gtlPar: "⦕",
    gtquest: "⩼",
    gtrapprox: "⪆",
    gtrarr: "⥸",
    gtrdot: "⋗",
    gtreqless: "⋛",
    gtreqqless: "⪌",
    gtrless: "≷",
    gtrsim: "≳",
    gvertneqq: "≩︀",
    gvnE: "≩︀",
    Hacek: "ˇ",
    hairsp: " ",
    half: "½",
    hamilt: "ℋ",
    HARDcy: "Ъ",
    hardcy: "ъ",
    harrcir: "⥈",
    harr: "↔",
    hArr: "⇔",
    harrw: "↭",
    Hat: "^",
    hbar: "ℏ",
    Hcirc: "Ĥ",
    hcirc: "ĥ",
    hearts: "♥",
    heartsuit: "♥",
    hellip: "…",
    hercon: "⊹",
    hfr: "𝔥",
    Hfr: "ℌ",
    HilbertSpace: "ℋ",
    hksearow: "⤥",
    hkswarow: "⤦",
    hoarr: "⇿",
    homtht: "∻",
    hookleftarrow: "↩",
    hookrightarrow: "↪",
    hopf: "𝕙",
    Hopf: "ℍ",
    horbar: "―",
    HorizontalLine: "─",
    hscr: "𝒽",
    Hscr: "ℋ",
    hslash: "ℏ",
    Hstrok: "Ħ",
    hstrok: "ħ",
    HumpDownHump: "≎",
    HumpEqual: "≏",
    hybull: "⁃",
    hyphen: "‐",
    Iacute: "Í",
    iacute: "í",
    ic: "⁣",
    Icirc: "Î",
    icirc: "î",
    Icy: "И",
    icy: "и",
    Idot: "İ",
    IEcy: "Е",
    iecy: "е",
    iexcl: "¡",
    iff: "⇔",
    ifr: "𝔦",
    Ifr: "ℑ",
    Igrave: "Ì",
    igrave: "ì",
    ii: "ⅈ",
    iiiint: "⨌",
    iiint: "∭",
    iinfin: "⧜",
    iiota: "℩",
    IJlig: "Ĳ",
    ijlig: "ĳ",
    Imacr: "Ī",
    imacr: "ī",
    image: "ℑ",
    ImaginaryI: "ⅈ",
    imagline: "ℐ",
    imagpart: "ℑ",
    imath: "ı",
    Im: "ℑ",
    imof: "⊷",
    imped: "Ƶ",
    Implies: "⇒",
    incare: "℅",
    in: "∈",
    infin: "∞",
    infintie: "⧝",
    inodot: "ı",
    intcal: "⊺",
    int: "∫",
    Int: "∬",
    integers: "ℤ",
    Integral: "∫",
    intercal: "⊺",
    Intersection: "⋂",
    intlarhk: "⨗",
    intprod: "⨼",
    InvisibleComma: "⁣",
    InvisibleTimes: "⁢",
    IOcy: "Ё",
    iocy: "ё",
    Iogon: "Į",
    iogon: "į",
    Iopf: "𝕀",
    iopf: "𝕚",
    Iota: "Ι",
    iota: "ι",
    iprod: "⨼",
    iquest: "¿",
    iscr: "𝒾",
    Iscr: "ℐ",
    isin: "∈",
    isindot: "⋵",
    isinE: "⋹",
    isins: "⋴",
    isinsv: "⋳",
    isinv: "∈",
    it: "⁢",
    Itilde: "Ĩ",
    itilde: "ĩ",
    Iukcy: "І",
    iukcy: "і",
    Iuml: "Ï",
    iuml: "ï",
    Jcirc: "Ĵ",
    jcirc: "ĵ",
    Jcy: "Й",
    jcy: "й",
    Jfr: "𝔍",
    jfr: "𝔧",
    jmath: "ȷ",
    Jopf: "𝕁",
    jopf: "𝕛",
    Jscr: "𝒥",
    jscr: "𝒿",
    Jsercy: "Ј",
    jsercy: "ј",
    Jukcy: "Є",
    jukcy: "є",
    Kappa: "Κ",
    kappa: "κ",
    kappav: "ϰ",
    Kcedil: "Ķ",
    kcedil: "ķ",
    Kcy: "К",
    kcy: "к",
    Kfr: "𝔎",
    kfr: "𝔨",
    kgreen: "ĸ",
    KHcy: "Х",
    khcy: "х",
    KJcy: "Ќ",
    kjcy: "ќ",
    Kopf: "𝕂",
    kopf: "𝕜",
    Kscr: "𝒦",
    kscr: "𝓀",
    lAarr: "⇚",
    Lacute: "Ĺ",
    lacute: "ĺ",
    laemptyv: "⦴",
    lagran: "ℒ",
    Lambda: "Λ",
    lambda: "λ",
    lang: "⟨",
    Lang: "⟪",
    langd: "⦑",
    langle: "⟨",
    lap: "⪅",
    Laplacetrf: "ℒ",
    laquo: "«",
    larrb: "⇤",
    larrbfs: "⤟",
    larr: "←",
    Larr: "↞",
    lArr: "⇐",
    larrfs: "⤝",
    larrhk: "↩",
    larrlp: "↫",
    larrpl: "⤹",
    larrsim: "⥳",
    larrtl: "↢",
    latail: "⤙",
    lAtail: "⤛",
    lat: "⪫",
    late: "⪭",
    lates: "⪭︀",
    lbarr: "⤌",
    lBarr: "⤎",
    lbbrk: "❲",
    lbrace: "{",
    lbrack: "[",
    lbrke: "⦋",
    lbrksld: "⦏",
    lbrkslu: "⦍",
    Lcaron: "Ľ",
    lcaron: "ľ",
    Lcedil: "Ļ",
    lcedil: "ļ",
    lceil: "⌈",
    lcub: "{",
    Lcy: "Л",
    lcy: "л",
    ldca: "⤶",
    ldquo: "“",
    ldquor: "„",
    ldrdhar: "⥧",
    ldrushar: "⥋",
    ldsh: "↲",
    le: "≤",
    lE: "≦",
    LeftAngleBracket: "⟨",
    LeftArrowBar: "⇤",
    leftarrow: "←",
    LeftArrow: "←",
    Leftarrow: "⇐",
    LeftArrowRightArrow: "⇆",
    leftarrowtail: "↢",
    LeftCeiling: "⌈",
    LeftDoubleBracket: "⟦",
    LeftDownTeeVector: "⥡",
    LeftDownVectorBar: "⥙",
    LeftDownVector: "⇃",
    LeftFloor: "⌊",
    leftharpoondown: "↽",
    leftharpoonup: "↼",
    leftleftarrows: "⇇",
    leftrightarrow: "↔",
    LeftRightArrow: "↔",
    Leftrightarrow: "⇔",
    leftrightarrows: "⇆",
    leftrightharpoons: "⇋",
    leftrightsquigarrow: "↭",
    LeftRightVector: "⥎",
    LeftTeeArrow: "↤",
    LeftTee: "⊣",
    LeftTeeVector: "⥚",
    leftthreetimes: "⋋",
    LeftTriangleBar: "⧏",
    LeftTriangle: "⊲",
    LeftTriangleEqual: "⊴",
    LeftUpDownVector: "⥑",
    LeftUpTeeVector: "⥠",
    LeftUpVectorBar: "⥘",
    LeftUpVector: "↿",
    LeftVectorBar: "⥒",
    LeftVector: "↼",
    lEg: "⪋",
    leg: "⋚",
    leq: "≤",
    leqq: "≦",
    leqslant: "⩽",
    lescc: "⪨",
    les: "⩽",
    lesdot: "⩿",
    lesdoto: "⪁",
    lesdotor: "⪃",
    lesg: "⋚︀",
    lesges: "⪓",
    lessapprox: "⪅",
    lessdot: "⋖",
    lesseqgtr: "⋚",
    lesseqqgtr: "⪋",
    LessEqualGreater: "⋚",
    LessFullEqual: "≦",
    LessGreater: "≶",
    lessgtr: "≶",
    LessLess: "⪡",
    lesssim: "≲",
    LessSlantEqual: "⩽",
    LessTilde: "≲",
    lfisht: "⥼",
    lfloor: "⌊",
    Lfr: "𝔏",
    lfr: "𝔩",
    lg: "≶",
    lgE: "⪑",
    lHar: "⥢",
    lhard: "↽",
    lharu: "↼",
    lharul: "⥪",
    lhblk: "▄",
    LJcy: "Љ",
    ljcy: "љ",
    llarr: "⇇",
    ll: "≪",
    Ll: "⋘",
    llcorner: "⌞",
    Lleftarrow: "⇚",
    llhard: "⥫",
    lltri: "◺",
    Lmidot: "Ŀ",
    lmidot: "ŀ",
    lmoustache: "⎰",
    lmoust: "⎰",
    lnap: "⪉",
    lnapprox: "⪉",
    lne: "⪇",
    lnE: "≨",
    lneq: "⪇",
    lneqq: "≨",
    lnsim: "⋦",
    loang: "⟬",
    loarr: "⇽",
    lobrk: "⟦",
    longleftarrow: "⟵",
    LongLeftArrow: "⟵",
    Longleftarrow: "⟸",
    longleftrightarrow: "⟷",
    LongLeftRightArrow: "⟷",
    Longleftrightarrow: "⟺",
    longmapsto: "⟼",
    longrightarrow: "⟶",
    LongRightArrow: "⟶",
    Longrightarrow: "⟹",
    looparrowleft: "↫",
    looparrowright: "↬",
    lopar: "⦅",
    Lopf: "𝕃",
    lopf: "𝕝",
    loplus: "⨭",
    lotimes: "⨴",
    lowast: "∗",
    lowbar: "_",
    LowerLeftArrow: "↙",
    LowerRightArrow: "↘",
    loz: "◊",
    lozenge: "◊",
    lozf: "⧫",
    lpar: "(",
    lparlt: "⦓",
    lrarr: "⇆",
    lrcorner: "⌟",
    lrhar: "⇋",
    lrhard: "⥭",
    lrm: "‎",
    lrtri: "⊿",
    lsaquo: "‹",
    lscr: "𝓁",
    Lscr: "ℒ",
    lsh: "↰",
    Lsh: "↰",
    lsim: "≲",
    lsime: "⪍",
    lsimg: "⪏",
    lsqb: "[",
    lsquo: "‘",
    lsquor: "‚",
    Lstrok: "Ł",
    lstrok: "ł",
    ltcc: "⪦",
    ltcir: "⩹",
    lt: "<",
    LT: "<",
    Lt: "≪",
    ltdot: "⋖",
    lthree: "⋋",
    ltimes: "⋉",
    ltlarr: "⥶",
    ltquest: "⩻",
    ltri: "◃",
    ltrie: "⊴",
    ltrif: "◂",
    ltrPar: "⦖",
    lurdshar: "⥊",
    luruhar: "⥦",
    lvertneqq: "≨︀",
    lvnE: "≨︀",
    macr: "¯",
    male: "♂",
    malt: "✠",
    maltese: "✠",
    Map: "⤅",
    map: "↦",
    mapsto: "↦",
    mapstodown: "↧",
    mapstoleft: "↤",
    mapstoup: "↥",
    marker: "▮",
    mcomma: "⨩",
    Mcy: "М",
    mcy: "м",
    mdash: "—",
    mDDot: "∺",
    measuredangle: "∡",
    MediumSpace: " ",
    Mellintrf: "ℳ",
    Mfr: "𝔐",
    mfr: "𝔪",
    mho: "℧",
    micro: "µ",
    midast: "*",
    midcir: "⫰",
    mid: "∣",
    middot: "·",
    minusb: "⊟",
    minus: "−",
    minusd: "∸",
    minusdu: "⨪",
    MinusPlus: "∓",
    mlcp: "⫛",
    mldr: "…",
    mnplus: "∓",
    models: "⊧",
    Mopf: "𝕄",
    mopf: "𝕞",
    mp: "∓",
    mscr: "𝓂",
    Mscr: "ℳ",
    mstpos: "∾",
    Mu: "Μ",
    mu: "μ",
    multimap: "⊸",
    mumap: "⊸",
    nabla: "∇",
    Nacute: "Ń",
    nacute: "ń",
    nang: "∠⃒",
    nap: "≉",
    napE: "⩰̸",
    napid: "≋̸",
    napos: "ŉ",
    napprox: "≉",
    natural: "♮",
    naturals: "ℕ",
    natur: "♮",
    nbsp: " ",
    nbump: "≎̸",
    nbumpe: "≏̸",
    ncap: "⩃",
    Ncaron: "Ň",
    ncaron: "ň",
    Ncedil: "Ņ",
    ncedil: "ņ",
    ncong: "≇",
    ncongdot: "⩭̸",
    ncup: "⩂",
    Ncy: "Н",
    ncy: "н",
    ndash: "–",
    nearhk: "⤤",
    nearr: "↗",
    neArr: "⇗",
    nearrow: "↗",
    ne: "≠",
    nedot: "≐̸",
    NegativeMediumSpace: "​",
    NegativeThickSpace: "​",
    NegativeThinSpace: "​",
    NegativeVeryThinSpace: "​",
    nequiv: "≢",
    nesear: "⤨",
    nesim: "≂̸",
    NestedGreaterGreater: "≫",
    NestedLessLess: "≪",
    NewLine: `
`,
    nexist: "∄",
    nexists: "∄",
    Nfr: "𝔑",
    nfr: "𝔫",
    ngE: "≧̸",
    nge: "≱",
    ngeq: "≱",
    ngeqq: "≧̸",
    ngeqslant: "⩾̸",
    nges: "⩾̸",
    nGg: "⋙̸",
    ngsim: "≵",
    nGt: "≫⃒",
    ngt: "≯",
    ngtr: "≯",
    nGtv: "≫̸",
    nharr: "↮",
    nhArr: "⇎",
    nhpar: "⫲",
    ni: "∋",
    nis: "⋼",
    nisd: "⋺",
    niv: "∋",
    NJcy: "Њ",
    njcy: "њ",
    nlarr: "↚",
    nlArr: "⇍",
    nldr: "‥",
    nlE: "≦̸",
    nle: "≰",
    nleftarrow: "↚",
    nLeftarrow: "⇍",
    nleftrightarrow: "↮",
    nLeftrightarrow: "⇎",
    nleq: "≰",
    nleqq: "≦̸",
    nleqslant: "⩽̸",
    nles: "⩽̸",
    nless: "≮",
    nLl: "⋘̸",
    nlsim: "≴",
    nLt: "≪⃒",
    nlt: "≮",
    nltri: "⋪",
    nltrie: "⋬",
    nLtv: "≪̸",
    nmid: "∤",
    NoBreak: "⁠",
    NonBreakingSpace: " ",
    nopf: "𝕟",
    Nopf: "ℕ",
    Not: "⫬",
    not: "¬",
    NotCongruent: "≢",
    NotCupCap: "≭",
    NotDoubleVerticalBar: "∦",
    NotElement: "∉",
    NotEqual: "≠",
    NotEqualTilde: "≂̸",
    NotExists: "∄",
    NotGreater: "≯",
    NotGreaterEqual: "≱",
    NotGreaterFullEqual: "≧̸",
    NotGreaterGreater: "≫̸",
    NotGreaterLess: "≹",
    NotGreaterSlantEqual: "⩾̸",
    NotGreaterTilde: "≵",
    NotHumpDownHump: "≎̸",
    NotHumpEqual: "≏̸",
    notin: "∉",
    notindot: "⋵̸",
    notinE: "⋹̸",
    notinva: "∉",
    notinvb: "⋷",
    notinvc: "⋶",
    NotLeftTriangleBar: "⧏̸",
    NotLeftTriangle: "⋪",
    NotLeftTriangleEqual: "⋬",
    NotLess: "≮",
    NotLessEqual: "≰",
    NotLessGreater: "≸",
    NotLessLess: "≪̸",
    NotLessSlantEqual: "⩽̸",
    NotLessTilde: "≴",
    NotNestedGreaterGreater: "⪢̸",
    NotNestedLessLess: "⪡̸",
    notni: "∌",
    notniva: "∌",
    notnivb: "⋾",
    notnivc: "⋽",
    NotPrecedes: "⊀",
    NotPrecedesEqual: "⪯̸",
    NotPrecedesSlantEqual: "⋠",
    NotReverseElement: "∌",
    NotRightTriangleBar: "⧐̸",
    NotRightTriangle: "⋫",
    NotRightTriangleEqual: "⋭",
    NotSquareSubset: "⊏̸",
    NotSquareSubsetEqual: "⋢",
    NotSquareSuperset: "⊐̸",
    NotSquareSupersetEqual: "⋣",
    NotSubset: "⊂⃒",
    NotSubsetEqual: "⊈",
    NotSucceeds: "⊁",
    NotSucceedsEqual: "⪰̸",
    NotSucceedsSlantEqual: "⋡",
    NotSucceedsTilde: "≿̸",
    NotSuperset: "⊃⃒",
    NotSupersetEqual: "⊉",
    NotTilde: "≁",
    NotTildeEqual: "≄",
    NotTildeFullEqual: "≇",
    NotTildeTilde: "≉",
    NotVerticalBar: "∤",
    nparallel: "∦",
    npar: "∦",
    nparsl: "⫽⃥",
    npart: "∂̸",
    npolint: "⨔",
    npr: "⊀",
    nprcue: "⋠",
    nprec: "⊀",
    npreceq: "⪯̸",
    npre: "⪯̸",
    nrarrc: "⤳̸",
    nrarr: "↛",
    nrArr: "⇏",
    nrarrw: "↝̸",
    nrightarrow: "↛",
    nRightarrow: "⇏",
    nrtri: "⋫",
    nrtrie: "⋭",
    nsc: "⊁",
    nsccue: "⋡",
    nsce: "⪰̸",
    Nscr: "𝒩",
    nscr: "𝓃",
    nshortmid: "∤",
    nshortparallel: "∦",
    nsim: "≁",
    nsime: "≄",
    nsimeq: "≄",
    nsmid: "∤",
    nspar: "∦",
    nsqsube: "⋢",
    nsqsupe: "⋣",
    nsub: "⊄",
    nsubE: "⫅̸",
    nsube: "⊈",
    nsubset: "⊂⃒",
    nsubseteq: "⊈",
    nsubseteqq: "⫅̸",
    nsucc: "⊁",
    nsucceq: "⪰̸",
    nsup: "⊅",
    nsupE: "⫆̸",
    nsupe: "⊉",
    nsupset: "⊃⃒",
    nsupseteq: "⊉",
    nsupseteqq: "⫆̸",
    ntgl: "≹",
    Ntilde: "Ñ",
    ntilde: "ñ",
    ntlg: "≸",
    ntriangleleft: "⋪",
    ntrianglelefteq: "⋬",
    ntriangleright: "⋫",
    ntrianglerighteq: "⋭",
    Nu: "Ν",
    nu: "ν",
    num: "#",
    numero: "№",
    numsp: " ",
    nvap: "≍⃒",
    nvdash: "⊬",
    nvDash: "⊭",
    nVdash: "⊮",
    nVDash: "⊯",
    nvge: "≥⃒",
    nvgt: ">⃒",
    nvHarr: "⤄",
    nvinfin: "⧞",
    nvlArr: "⤂",
    nvle: "≤⃒",
    nvlt: "<⃒",
    nvltrie: "⊴⃒",
    nvrArr: "⤃",
    nvrtrie: "⊵⃒",
    nvsim: "∼⃒",
    nwarhk: "⤣",
    nwarr: "↖",
    nwArr: "⇖",
    nwarrow: "↖",
    nwnear: "⤧",
    Oacute: "Ó",
    oacute: "ó",
    oast: "⊛",
    Ocirc: "Ô",
    ocirc: "ô",
    ocir: "⊚",
    Ocy: "О",
    ocy: "о",
    odash: "⊝",
    Odblac: "Ő",
    odblac: "ő",
    odiv: "⨸",
    odot: "⊙",
    odsold: "⦼",
    OElig: "Œ",
    oelig: "œ",
    ofcir: "⦿",
    Ofr: "𝔒",
    ofr: "𝔬",
    ogon: "˛",
    Ograve: "Ò",
    ograve: "ò",
    ogt: "⧁",
    ohbar: "⦵",
    ohm: "Ω",
    oint: "∮",
    olarr: "↺",
    olcir: "⦾",
    olcross: "⦻",
    oline: "‾",
    olt: "⧀",
    Omacr: "Ō",
    omacr: "ō",
    Omega: "Ω",
    omega: "ω",
    Omicron: "Ο",
    omicron: "ο",
    omid: "⦶",
    ominus: "⊖",
    Oopf: "𝕆",
    oopf: "𝕠",
    opar: "⦷",
    OpenCurlyDoubleQuote: "“",
    OpenCurlyQuote: "‘",
    operp: "⦹",
    oplus: "⊕",
    orarr: "↻",
    Or: "⩔",
    or: "∨",
    ord: "⩝",
    order: "ℴ",
    orderof: "ℴ",
    ordf: "ª",
    ordm: "º",
    origof: "⊶",
    oror: "⩖",
    orslope: "⩗",
    orv: "⩛",
    oS: "Ⓢ",
    Oscr: "𝒪",
    oscr: "ℴ",
    Oslash: "Ø",
    oslash: "ø",
    osol: "⊘",
    Otilde: "Õ",
    otilde: "õ",
    otimesas: "⨶",
    Otimes: "⨷",
    otimes: "⊗",
    Ouml: "Ö",
    ouml: "ö",
    ovbar: "⌽",
    OverBar: "‾",
    OverBrace: "⏞",
    OverBracket: "⎴",
    OverParenthesis: "⏜",
    para: "¶",
    parallel: "∥",
    par: "∥",
    parsim: "⫳",
    parsl: "⫽",
    part: "∂",
    PartialD: "∂",
    Pcy: "П",
    pcy: "п",
    percnt: "%",
    period: ".",
    permil: "‰",
    perp: "⊥",
    pertenk: "‱",
    Pfr: "𝔓",
    pfr: "𝔭",
    Phi: "Φ",
    phi: "φ",
    phiv: "ϕ",
    phmmat: "ℳ",
    phone: "☎",
    Pi: "Π",
    pi: "π",
    pitchfork: "⋔",
    piv: "ϖ",
    planck: "ℏ",
    planckh: "ℎ",
    plankv: "ℏ",
    plusacir: "⨣",
    plusb: "⊞",
    pluscir: "⨢",
    plus: "+",
    plusdo: "∔",
    plusdu: "⨥",
    pluse: "⩲",
    PlusMinus: "±",
    plusmn: "±",
    plussim: "⨦",
    plustwo: "⨧",
    pm: "±",
    Poincareplane: "ℌ",
    pointint: "⨕",
    popf: "𝕡",
    Popf: "ℙ",
    pound: "£",
    prap: "⪷",
    Pr: "⪻",
    pr: "≺",
    prcue: "≼",
    precapprox: "⪷",
    prec: "≺",
    preccurlyeq: "≼",
    Precedes: "≺",
    PrecedesEqual: "⪯",
    PrecedesSlantEqual: "≼",
    PrecedesTilde: "≾",
    preceq: "⪯",
    precnapprox: "⪹",
    precneqq: "⪵",
    precnsim: "⋨",
    pre: "⪯",
    prE: "⪳",
    precsim: "≾",
    prime: "′",
    Prime: "″",
    primes: "ℙ",
    prnap: "⪹",
    prnE: "⪵",
    prnsim: "⋨",
    prod: "∏",
    Product: "∏",
    profalar: "⌮",
    profline: "⌒",
    profsurf: "⌓",
    prop: "∝",
    Proportional: "∝",
    Proportion: "∷",
    propto: "∝",
    prsim: "≾",
    prurel: "⊰",
    Pscr: "𝒫",
    pscr: "𝓅",
    Psi: "Ψ",
    psi: "ψ",
    puncsp: " ",
    Qfr: "𝔔",
    qfr: "𝔮",
    qint: "⨌",
    qopf: "𝕢",
    Qopf: "ℚ",
    qprime: "⁗",
    Qscr: "𝒬",
    qscr: "𝓆",
    quaternions: "ℍ",
    quatint: "⨖",
    quest: "?",
    questeq: "≟",
    quot: '"',
    QUOT: '"',
    rAarr: "⇛",
    race: "∽̱",
    Racute: "Ŕ",
    racute: "ŕ",
    radic: "√",
    raemptyv: "⦳",
    rang: "⟩",
    Rang: "⟫",
    rangd: "⦒",
    range: "⦥",
    rangle: "⟩",
    raquo: "»",
    rarrap: "⥵",
    rarrb: "⇥",
    rarrbfs: "⤠",
    rarrc: "⤳",
    rarr: "→",
    Rarr: "↠",
    rArr: "⇒",
    rarrfs: "⤞",
    rarrhk: "↪",
    rarrlp: "↬",
    rarrpl: "⥅",
    rarrsim: "⥴",
    Rarrtl: "⤖",
    rarrtl: "↣",
    rarrw: "↝",
    ratail: "⤚",
    rAtail: "⤜",
    ratio: "∶",
    rationals: "ℚ",
    rbarr: "⤍",
    rBarr: "⤏",
    RBarr: "⤐",
    rbbrk: "❳",
    rbrace: "}",
    rbrack: "]",
    rbrke: "⦌",
    rbrksld: "⦎",
    rbrkslu: "⦐",
    Rcaron: "Ř",
    rcaron: "ř",
    Rcedil: "Ŗ",
    rcedil: "ŗ",
    rceil: "⌉",
    rcub: "}",
    Rcy: "Р",
    rcy: "р",
    rdca: "⤷",
    rdldhar: "⥩",
    rdquo: "”",
    rdquor: "”",
    rdsh: "↳",
    real: "ℜ",
    realine: "ℛ",
    realpart: "ℜ",
    reals: "ℝ",
    Re: "ℜ",
    rect: "▭",
    reg: "®",
    REG: "®",
    ReverseElement: "∋",
    ReverseEquilibrium: "⇋",
    ReverseUpEquilibrium: "⥯",
    rfisht: "⥽",
    rfloor: "⌋",
    rfr: "𝔯",
    Rfr: "ℜ",
    rHar: "⥤",
    rhard: "⇁",
    rharu: "⇀",
    rharul: "⥬",
    Rho: "Ρ",
    rho: "ρ",
    rhov: "ϱ",
    RightAngleBracket: "⟩",
    RightArrowBar: "⇥",
    rightarrow: "→",
    RightArrow: "→",
    Rightarrow: "⇒",
    RightArrowLeftArrow: "⇄",
    rightarrowtail: "↣",
    RightCeiling: "⌉",
    RightDoubleBracket: "⟧",
    RightDownTeeVector: "⥝",
    RightDownVectorBar: "⥕",
    RightDownVector: "⇂",
    RightFloor: "⌋",
    rightharpoondown: "⇁",
    rightharpoonup: "⇀",
    rightleftarrows: "⇄",
    rightleftharpoons: "⇌",
    rightrightarrows: "⇉",
    rightsquigarrow: "↝",
    RightTeeArrow: "↦",
    RightTee: "⊢",
    RightTeeVector: "⥛",
    rightthreetimes: "⋌",
    RightTriangleBar: "⧐",
    RightTriangle: "⊳",
    RightTriangleEqual: "⊵",
    RightUpDownVector: "⥏",
    RightUpTeeVector: "⥜",
    RightUpVectorBar: "⥔",
    RightUpVector: "↾",
    RightVectorBar: "⥓",
    RightVector: "⇀",
    ring: "˚",
    risingdotseq: "≓",
    rlarr: "⇄",
    rlhar: "⇌",
    rlm: "‏",
    rmoustache: "⎱",
    rmoust: "⎱",
    rnmid: "⫮",
    roang: "⟭",
    roarr: "⇾",
    robrk: "⟧",
    ropar: "⦆",
    ropf: "𝕣",
    Ropf: "ℝ",
    roplus: "⨮",
    rotimes: "⨵",
    RoundImplies: "⥰",
    rpar: ")",
    rpargt: "⦔",
    rppolint: "⨒",
    rrarr: "⇉",
    Rrightarrow: "⇛",
    rsaquo: "›",
    rscr: "𝓇",
    Rscr: "ℛ",
    rsh: "↱",
    Rsh: "↱",
    rsqb: "]",
    rsquo: "’",
    rsquor: "’",
    rthree: "⋌",
    rtimes: "⋊",
    rtri: "▹",
    rtrie: "⊵",
    rtrif: "▸",
    rtriltri: "⧎",
    RuleDelayed: "⧴",
    ruluhar: "⥨",
    rx: "℞",
    Sacute: "Ś",
    sacute: "ś",
    sbquo: "‚",
    scap: "⪸",
    Scaron: "Š",
    scaron: "š",
    Sc: "⪼",
    sc: "≻",
    sccue: "≽",
    sce: "⪰",
    scE: "⪴",
    Scedil: "Ş",
    scedil: "ş",
    Scirc: "Ŝ",
    scirc: "ŝ",
    scnap: "⪺",
    scnE: "⪶",
    scnsim: "⋩",
    scpolint: "⨓",
    scsim: "≿",
    Scy: "С",
    scy: "с",
    sdotb: "⊡",
    sdot: "⋅",
    sdote: "⩦",
    searhk: "⤥",
    searr: "↘",
    seArr: "⇘",
    searrow: "↘",
    sect: "§",
    semi: ";",
    seswar: "⤩",
    setminus: "∖",
    setmn: "∖",
    sext: "✶",
    Sfr: "𝔖",
    sfr: "𝔰",
    sfrown: "⌢",
    sharp: "♯",
    SHCHcy: "Щ",
    shchcy: "щ",
    SHcy: "Ш",
    shcy: "ш",
    ShortDownArrow: "↓",
    ShortLeftArrow: "←",
    shortmid: "∣",
    shortparallel: "∥",
    ShortRightArrow: "→",
    ShortUpArrow: "↑",
    shy: "­",
    Sigma: "Σ",
    sigma: "σ",
    sigmaf: "ς",
    sigmav: "ς",
    sim: "∼",
    simdot: "⩪",
    sime: "≃",
    simeq: "≃",
    simg: "⪞",
    simgE: "⪠",
    siml: "⪝",
    simlE: "⪟",
    simne: "≆",
    simplus: "⨤",
    simrarr: "⥲",
    slarr: "←",
    SmallCircle: "∘",
    smallsetminus: "∖",
    smashp: "⨳",
    smeparsl: "⧤",
    smid: "∣",
    smile: "⌣",
    smt: "⪪",
    smte: "⪬",
    smtes: "⪬︀",
    SOFTcy: "Ь",
    softcy: "ь",
    solbar: "⌿",
    solb: "⧄",
    sol: "/",
    Sopf: "𝕊",
    sopf: "𝕤",
    spades: "♠",
    spadesuit: "♠",
    spar: "∥",
    sqcap: "⊓",
    sqcaps: "⊓︀",
    sqcup: "⊔",
    sqcups: "⊔︀",
    Sqrt: "√",
    sqsub: "⊏",
    sqsube: "⊑",
    sqsubset: "⊏",
    sqsubseteq: "⊑",
    sqsup: "⊐",
    sqsupe: "⊒",
    sqsupset: "⊐",
    sqsupseteq: "⊒",
    square: "□",
    Square: "□",
    SquareIntersection: "⊓",
    SquareSubset: "⊏",
    SquareSubsetEqual: "⊑",
    SquareSuperset: "⊐",
    SquareSupersetEqual: "⊒",
    SquareUnion: "⊔",
    squarf: "▪",
    squ: "□",
    squf: "▪",
    srarr: "→",
    Sscr: "𝒮",
    sscr: "𝓈",
    ssetmn: "∖",
    ssmile: "⌣",
    sstarf: "⋆",
    Star: "⋆",
    star: "☆",
    starf: "★",
    straightepsilon: "ϵ",
    straightphi: "ϕ",
    strns: "¯",
    sub: "⊂",
    Sub: "⋐",
    subdot: "⪽",
    subE: "⫅",
    sube: "⊆",
    subedot: "⫃",
    submult: "⫁",
    subnE: "⫋",
    subne: "⊊",
    subplus: "⪿",
    subrarr: "⥹",
    subset: "⊂",
    Subset: "⋐",
    subseteq: "⊆",
    subseteqq: "⫅",
    SubsetEqual: "⊆",
    subsetneq: "⊊",
    subsetneqq: "⫋",
    subsim: "⫇",
    subsub: "⫕",
    subsup: "⫓",
    succapprox: "⪸",
    succ: "≻",
    succcurlyeq: "≽",
    Succeeds: "≻",
    SucceedsEqual: "⪰",
    SucceedsSlantEqual: "≽",
    SucceedsTilde: "≿",
    succeq: "⪰",
    succnapprox: "⪺",
    succneqq: "⪶",
    succnsim: "⋩",
    succsim: "≿",
    SuchThat: "∋",
    sum: "∑",
    Sum: "∑",
    sung: "♪",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    sup: "⊃",
    Sup: "⋑",
    supdot: "⪾",
    supdsub: "⫘",
    supE: "⫆",
    supe: "⊇",
    supedot: "⫄",
    Superset: "⊃",
    SupersetEqual: "⊇",
    suphsol: "⟉",
    suphsub: "⫗",
    suplarr: "⥻",
    supmult: "⫂",
    supnE: "⫌",
    supne: "⊋",
    supplus: "⫀",
    supset: "⊃",
    Supset: "⋑",
    supseteq: "⊇",
    supseteqq: "⫆",
    supsetneq: "⊋",
    supsetneqq: "⫌",
    supsim: "⫈",
    supsub: "⫔",
    supsup: "⫖",
    swarhk: "⤦",
    swarr: "↙",
    swArr: "⇙",
    swarrow: "↙",
    swnwar: "⤪",
    szlig: "ß",
    Tab: "	",
    target: "⌖",
    Tau: "Τ",
    tau: "τ",
    tbrk: "⎴",
    Tcaron: "Ť",
    tcaron: "ť",
    Tcedil: "Ţ",
    tcedil: "ţ",
    Tcy: "Т",
    tcy: "т",
    tdot: "⃛",
    telrec: "⌕",
    Tfr: "𝔗",
    tfr: "𝔱",
    there4: "∴",
    therefore: "∴",
    Therefore: "∴",
    Theta: "Θ",
    theta: "θ",
    thetasym: "ϑ",
    thetav: "ϑ",
    thickapprox: "≈",
    thicksim: "∼",
    ThickSpace: "  ",
    ThinSpace: " ",
    thinsp: " ",
    thkap: "≈",
    thksim: "∼",
    THORN: "Þ",
    thorn: "þ",
    tilde: "˜",
    Tilde: "∼",
    TildeEqual: "≃",
    TildeFullEqual: "≅",
    TildeTilde: "≈",
    timesbar: "⨱",
    timesb: "⊠",
    times: "×",
    timesd: "⨰",
    tint: "∭",
    toea: "⤨",
    topbot: "⌶",
    topcir: "⫱",
    top: "⊤",
    Topf: "𝕋",
    topf: "𝕥",
    topfork: "⫚",
    tosa: "⤩",
    tprime: "‴",
    trade: "™",
    TRADE: "™",
    triangle: "▵",
    triangledown: "▿",
    triangleleft: "◃",
    trianglelefteq: "⊴",
    triangleq: "≜",
    triangleright: "▹",
    trianglerighteq: "⊵",
    tridot: "◬",
    trie: "≜",
    triminus: "⨺",
    TripleDot: "⃛",
    triplus: "⨹",
    trisb: "⧍",
    tritime: "⨻",
    trpezium: "⏢",
    Tscr: "𝒯",
    tscr: "𝓉",
    TScy: "Ц",
    tscy: "ц",
    TSHcy: "Ћ",
    tshcy: "ћ",
    Tstrok: "Ŧ",
    tstrok: "ŧ",
    twixt: "≬",
    twoheadleftarrow: "↞",
    twoheadrightarrow: "↠",
    Uacute: "Ú",
    uacute: "ú",
    uarr: "↑",
    Uarr: "↟",
    uArr: "⇑",
    Uarrocir: "⥉",
    Ubrcy: "Ў",
    ubrcy: "ў",
    Ubreve: "Ŭ",
    ubreve: "ŭ",
    Ucirc: "Û",
    ucirc: "û",
    Ucy: "У",
    ucy: "у",
    udarr: "⇅",
    Udblac: "Ű",
    udblac: "ű",
    udhar: "⥮",
    ufisht: "⥾",
    Ufr: "𝔘",
    ufr: "𝔲",
    Ugrave: "Ù",
    ugrave: "ù",
    uHar: "⥣",
    uharl: "↿",
    uharr: "↾",
    uhblk: "▀",
    ulcorn: "⌜",
    ulcorner: "⌜",
    ulcrop: "⌏",
    ultri: "◸",
    Umacr: "Ū",
    umacr: "ū",
    uml: "¨",
    UnderBar: "_",
    UnderBrace: "⏟",
    UnderBracket: "⎵",
    UnderParenthesis: "⏝",
    Union: "⋃",
    UnionPlus: "⊎",
    Uogon: "Ų",
    uogon: "ų",
    Uopf: "𝕌",
    uopf: "𝕦",
    UpArrowBar: "⤒",
    uparrow: "↑",
    UpArrow: "↑",
    Uparrow: "⇑",
    UpArrowDownArrow: "⇅",
    updownarrow: "↕",
    UpDownArrow: "↕",
    Updownarrow: "⇕",
    UpEquilibrium: "⥮",
    upharpoonleft: "↿",
    upharpoonright: "↾",
    uplus: "⊎",
    UpperLeftArrow: "↖",
    UpperRightArrow: "↗",
    upsi: "υ",
    Upsi: "ϒ",
    upsih: "ϒ",
    Upsilon: "Υ",
    upsilon: "υ",
    UpTeeArrow: "↥",
    UpTee: "⊥",
    upuparrows: "⇈",
    urcorn: "⌝",
    urcorner: "⌝",
    urcrop: "⌎",
    Uring: "Ů",
    uring: "ů",
    urtri: "◹",
    Uscr: "𝒰",
    uscr: "𝓊",
    utdot: "⋰",
    Utilde: "Ũ",
    utilde: "ũ",
    utri: "▵",
    utrif: "▴",
    uuarr: "⇈",
    Uuml: "Ü",
    uuml: "ü",
    uwangle: "⦧",
    vangrt: "⦜",
    varepsilon: "ϵ",
    varkappa: "ϰ",
    varnothing: "∅",
    varphi: "ϕ",
    varpi: "ϖ",
    varpropto: "∝",
    varr: "↕",
    vArr: "⇕",
    varrho: "ϱ",
    varsigma: "ς",
    varsubsetneq: "⊊︀",
    varsubsetneqq: "⫋︀",
    varsupsetneq: "⊋︀",
    varsupsetneqq: "⫌︀",
    vartheta: "ϑ",
    vartriangleleft: "⊲",
    vartriangleright: "⊳",
    vBar: "⫨",
    Vbar: "⫫",
    vBarv: "⫩",
    Vcy: "В",
    vcy: "в",
    vdash: "⊢",
    vDash: "⊨",
    Vdash: "⊩",
    VDash: "⊫",
    Vdashl: "⫦",
    veebar: "⊻",
    vee: "∨",
    Vee: "⋁",
    veeeq: "≚",
    vellip: "⋮",
    verbar: "|",
    Verbar: "‖",
    vert: "|",
    Vert: "‖",
    VerticalBar: "∣",
    VerticalLine: "|",
    VerticalSeparator: "❘",
    VerticalTilde: "≀",
    VeryThinSpace: " ",
    Vfr: "𝔙",
    vfr: "𝔳",
    vltri: "⊲",
    vnsub: "⊂⃒",
    vnsup: "⊃⃒",
    Vopf: "𝕍",
    vopf: "𝕧",
    vprop: "∝",
    vrtri: "⊳",
    Vscr: "𝒱",
    vscr: "𝓋",
    vsubnE: "⫋︀",
    vsubne: "⊊︀",
    vsupnE: "⫌︀",
    vsupne: "⊋︀",
    Vvdash: "⊪",
    vzigzag: "⦚",
    Wcirc: "Ŵ",
    wcirc: "ŵ",
    wedbar: "⩟",
    wedge: "∧",
    Wedge: "⋀",
    wedgeq: "≙",
    weierp: "℘",
    Wfr: "𝔚",
    wfr: "𝔴",
    Wopf: "𝕎",
    wopf: "𝕨",
    wp: "℘",
    wr: "≀",
    wreath: "≀",
    Wscr: "𝒲",
    wscr: "𝓌",
    xcap: "⋂",
    xcirc: "◯",
    xcup: "⋃",
    xdtri: "▽",
    Xfr: "𝔛",
    xfr: "𝔵",
    xharr: "⟷",
    xhArr: "⟺",
    Xi: "Ξ",
    xi: "ξ",
    xlarr: "⟵",
    xlArr: "⟸",
    xmap: "⟼",
    xnis: "⋻",
    xodot: "⨀",
    Xopf: "𝕏",
    xopf: "𝕩",
    xoplus: "⨁",
    xotime: "⨂",
    xrarr: "⟶",
    xrArr: "⟹",
    Xscr: "𝒳",
    xscr: "𝓍",
    xsqcup: "⨆",
    xuplus: "⨄",
    xutri: "△",
    xvee: "⋁",
    xwedge: "⋀",
    Yacute: "Ý",
    yacute: "ý",
    YAcy: "Я",
    yacy: "я",
    Ycirc: "Ŷ",
    ycirc: "ŷ",
    Ycy: "Ы",
    ycy: "ы",
    yen: "¥",
    Yfr: "𝔜",
    yfr: "𝔶",
    YIcy: "Ї",
    yicy: "ї",
    Yopf: "𝕐",
    yopf: "𝕪",
    Yscr: "𝒴",
    yscr: "𝓎",
    YUcy: "Ю",
    yucy: "ю",
    yuml: "ÿ",
    Yuml: "Ÿ",
    Zacute: "Ź",
    zacute: "ź",
    Zcaron: "Ž",
    zcaron: "ž",
    Zcy: "З",
    zcy: "з",
    Zdot: "Ż",
    zdot: "ż",
    zeetrf: "ℨ",
    ZeroWidthSpace: "​",
    Zeta: "Ζ",
    zeta: "ζ",
    zfr: "𝔷",
    Zfr: "ℨ",
    ZHcy: "Ж",
    zhcy: "ж",
    zigrarr: "⇝",
    zopf: "𝕫",
    Zopf: "ℤ",
    Zscr: "𝒵",
    zscr: "𝓏",
    zwj: "‍",
    zwnj: "‌"
  };
}), $o = O((Kt, uo) => {
  uo.exports = {
    Aacute: "Á",
    aacute: "á",
    Acirc: "Â",
    acirc: "â",
    acute: "´",
    AElig: "Æ",
    aelig: "æ",
    Agrave: "À",
    agrave: "à",
    amp: "&",
    AMP: "&",
    Aring: "Å",
    aring: "å",
    Atilde: "Ã",
    atilde: "ã",
    Auml: "Ä",
    auml: "ä",
    brvbar: "¦",
    Ccedil: "Ç",
    ccedil: "ç",
    cedil: "¸",
    cent: "¢",
    copy: "©",
    COPY: "©",
    curren: "¤",
    deg: "°",
    divide: "÷",
    Eacute: "É",
    eacute: "é",
    Ecirc: "Ê",
    ecirc: "ê",
    Egrave: "È",
    egrave: "è",
    ETH: "Ð",
    eth: "ð",
    Euml: "Ë",
    euml: "ë",
    frac12: "½",
    frac14: "¼",
    frac34: "¾",
    gt: ">",
    GT: ">",
    Iacute: "Í",
    iacute: "í",
    Icirc: "Î",
    icirc: "î",
    iexcl: "¡",
    Igrave: "Ì",
    igrave: "ì",
    iquest: "¿",
    Iuml: "Ï",
    iuml: "ï",
    laquo: "«",
    lt: "<",
    LT: "<",
    macr: "¯",
    micro: "µ",
    middot: "·",
    nbsp: " ",
    not: "¬",
    Ntilde: "Ñ",
    ntilde: "ñ",
    Oacute: "Ó",
    oacute: "ó",
    Ocirc: "Ô",
    ocirc: "ô",
    Ograve: "Ò",
    ograve: "ò",
    ordf: "ª",
    ordm: "º",
    Oslash: "Ø",
    oslash: "ø",
    Otilde: "Õ",
    otilde: "õ",
    Ouml: "Ö",
    ouml: "ö",
    para: "¶",
    plusmn: "±",
    pound: "£",
    quot: '"',
    QUOT: '"',
    raquo: "»",
    reg: "®",
    REG: "®",
    sect: "§",
    shy: "­",
    sup1: "¹",
    sup2: "²",
    sup3: "³",
    szlig: "ß",
    THORN: "Þ",
    thorn: "þ",
    times: "×",
    Uacute: "Ú",
    uacute: "ú",
    Ucirc: "Û",
    ucirc: "û",
    Ugrave: "Ù",
    ugrave: "ù",
    uml: "¨",
    Uuml: "Ü",
    uuml: "ü",
    Yacute: "Ý",
    yacute: "ý",
    yen: "¥",
    yuml: "ÿ"
  };
}), ct = O((Kt, uo) => {
  uo.exports = { amp: "&", apos: "'", gt: ">", lt: "<", quot: '"' };
}), Yo = O((Kt, uo) => {
  uo.exports = {
    0: 65533,
    128: 8364,
    130: 8218,
    131: 402,
    132: 8222,
    133: 8230,
    134: 8224,
    135: 8225,
    136: 710,
    137: 8240,
    138: 352,
    139: 8249,
    140: 338,
    142: 381,
    145: 8216,
    146: 8217,
    147: 8220,
    148: 8221,
    149: 8226,
    150: 8211,
    151: 8212,
    152: 732,
    153: 8482,
    154: 353,
    155: 8250,
    156: 339,
    158: 382,
    159: 376
  };
}), Xo = O((Kt) => {
  var uo = Kt && Kt.__importDefault || function(vo) {
    return vo && vo.__esModule ? vo : { default: vo };
  };
  Object.defineProperty(Kt, "__esModule", { value: !0 });
  var ho = uo(Yo()), go = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.fromCodePoint || function(vo) {
      var Po = "";
      return vo > 65535 && (vo -= 65536, Po += String.fromCharCode(vo >>> 10 & 1023 | 55296), vo = 56320 | vo & 1023), Po += String.fromCharCode(vo), Po;
    }
  );
  function bo(vo) {
    return vo >= 55296 && vo <= 57343 || vo > 1114111 ? "�" : (vo in ho.default && (vo = ho.default[vo]), go(vo));
  }
  s(bo, "decodeCodePoint"), Kt.default = bo;
}), pt = O((Kt) => {
  var uo = Kt && Kt.__importDefault || function(Eo) {
    return Eo && Eo.__esModule ? Eo : { default: Eo };
  };
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.decodeHTML = Kt.decodeHTMLStrict = Kt.decodeXML = void 0;
  var ho = uo(lt()), go = uo($o()), bo = uo(ct()), vo = uo(Xo()), Po = /&(?:[a-zA-Z0-9]+|#[xX][\da-fA-F]+|#\d+);/g;
  Kt.decodeXML = Co(bo.default), Kt.decodeHTMLStrict = Co(ho.default);
  function Co(Eo) {
    var Ro = wo(Eo);
    return function(_o) {
      return String(_o).replace(Po, Ro);
    };
  }
  s(Co, "getStrictDecoder");
  var So = /* @__PURE__ */ s(function(Eo, Ro) {
    return Eo < Ro ? 1 : -1;
  }, "sorter");
  Kt.decodeHTML = function() {
    for (var Eo = Object.keys(go.default).sort(So), Ro = Object.keys(ho.default).sort(So), _o = 0, Io = 0; _o < Ro.length; _o++)
      Eo[Io] === Ro[_o] ? (Ro[_o] += ";?", Io++) : Ro[_o] += ";";
    var Ao = new RegExp("&(?:" + Ro.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"), Oo = wo(ho.default);
    function jo(Do) {
      return Do.substr(-1) !== ";" && (Do += ";"), Oo(Do);
    }
    return s(jo, "replacer"), function(Do) {
      return String(Do).replace(Ao, jo);
    };
  }();
  function wo(Eo) {
    return /* @__PURE__ */ s(function(Ro) {
      if (Ro.charAt(1) === "#") {
        var _o = Ro.charAt(2);
        return _o === "X" || _o === "x" ? vo.default(parseInt(Ro.substr(3), 16)) : vo.default(parseInt(Ro.substr(2), 10));
      }
      return Eo[Ro.slice(1, -1)] || Ro;
    }, "replace");
  }
  s(wo, "getReplacer");
}), ft = O((Kt) => {
  var uo = Kt && Kt.__importDefault || function(Lo) {
    return Lo && Lo.__esModule ? Lo : { default: Lo };
  };
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.escapeUTF8 = Kt.escape = Kt.encodeNonAsciiHTML = Kt.encodeHTML = Kt.encodeXML = void 0;
  var ho = uo(ct()), go = So(ho.default), bo = wo(go);
  Kt.encodeXML = Do(go);
  var vo = uo(lt()), Po = So(vo.default), Co = wo(Po);
  Kt.encodeHTML = Io(Po, Co), Kt.encodeNonAsciiHTML = Do(Po);
  function So(Lo) {
    return Object.keys(Lo).sort().reduce(function(ko, Ko) {
      return ko[Lo[Ko]] = "&" + Ko + ";", ko;
    }, {});
  }
  s(So, "getInverseObj");
  function wo(Lo) {
    for (var ko = [], Ko = [], No = 0, Jo = Object.keys(Lo); No < Jo.length; No++) {
      var ti = Jo[No];
      ti.length === 1 ? ko.push("\\" + ti) : Ko.push(ti);
    }
    ko.sort();
    for (var oi = 0; oi < ko.length - 1; oi++) {
      for (var Qo = oi; Qo < ko.length - 1 && ko[Qo].charCodeAt(1) + 1 === ko[Qo + 1].charCodeAt(1); )
        Qo += 1;
      var Zo = 1 + Qo - oi;
      Zo < 3 || ko.splice(oi, Zo, ko[oi] + "-" + ko[Qo]);
    }
    return Ko.unshift("[" + ko.join("") + "]"), new RegExp(Ko.join("|"), "g");
  }
  s(wo, "getInverseReplacer");
  var Eo = /(?:[\x80-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, Ro = (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    String.prototype.codePointAt != null ? (
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      function(Lo) {
        return Lo.codePointAt(0);
      }
    ) : (
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      function(Lo) {
        return (Lo.charCodeAt(0) - 55296) * 1024 + Lo.charCodeAt(1) - 56320 + 65536;
      }
    )
  );
  function _o(Lo) {
    return "&#x" + (Lo.length > 1 ? Ro(Lo) : Lo.charCodeAt(0)).toString(16).toUpperCase() + ";";
  }
  s(_o, "singleCharReplacer");
  function Io(Lo, ko) {
    return function(Ko) {
      return Ko.replace(ko, function(No) {
        return Lo[No];
      }).replace(Eo, _o);
    };
  }
  s(Io, "getInverse");
  var Ao = new RegExp(bo.source + "|" + Eo.source, "g");
  function Oo(Lo) {
    return Lo.replace(Ao, _o);
  }
  s(Oo, "escape"), Kt.escape = Oo;
  function jo(Lo) {
    return Lo.replace(bo, _o);
  }
  s(jo, "escapeUTF8"), Kt.escapeUTF8 = jo;
  function Do(Lo) {
    return function(ko) {
      return ko.replace(Ao, function(Ko) {
        return Lo[Ko] || _o(Ko);
      });
    };
  }
  s(Do, "getASCIIEncoder");
}), pn = O((Kt) => {
  Object.defineProperty(Kt, "__esModule", { value: !0 }), Kt.decodeXMLStrict = Kt.decodeHTML5Strict = Kt.decodeHTML4Strict = Kt.decodeHTML5 = Kt.decodeHTML4 = Kt.decodeHTMLStrict = Kt.decodeHTML = Kt.decodeXML = Kt.encodeHTML5 = Kt.encodeHTML4 = Kt.escapeUTF8 = Kt.escape = Kt.encodeNonAsciiHTML = Kt.encodeHTML = Kt.encodeXML = Kt.encode = Kt.decodeStrict = Kt.decode = void 0;
  var uo = pt(), ho = ft();
  function go(So, wo) {
    return (!wo || wo <= 0 ? uo.decodeXML : uo.decodeHTML)(So);
  }
  s(go, "decode"), Kt.decode = go;
  function bo(So, wo) {
    return (!wo || wo <= 0 ? uo.decodeXML : uo.decodeHTMLStrict)(So);
  }
  s(bo, "decodeStrict"), Kt.decodeStrict = bo;
  function vo(So, wo) {
    return (!wo || wo <= 0 ? ho.encodeXML : ho.encodeHTML)(So);
  }
  s(vo, "encode"), Kt.encode = vo;
  var Po = ft();
  Object.defineProperty(Kt, "encodeXML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Po.encodeXML;
  }, "get") }), Object.defineProperty(Kt, "encodeHTML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Po.encodeHTML;
  }, "get") }), Object.defineProperty(Kt, "encodeNonAsciiHTML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Po.encodeNonAsciiHTML;
  }, "get") }), Object.defineProperty(Kt, "escape", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Po.escape;
  }, "get") }), Object.defineProperty(Kt, "escapeUTF8", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Po.escapeUTF8;
  }, "get") }), Object.defineProperty(Kt, "encodeHTML4", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Po.encodeHTML;
  }, "get") }), Object.defineProperty(Kt, "encodeHTML5", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Po.encodeHTML;
  }, "get") });
  var Co = pt();
  Object.defineProperty(Kt, "decodeXML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeXML;
  }, "get") }), Object.defineProperty(Kt, "decodeHTML", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeHTML;
  }, "get") }), Object.defineProperty(Kt, "decodeHTMLStrict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeHTMLStrict;
  }, "get") }), Object.defineProperty(Kt, "decodeHTML4", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeHTML;
  }, "get") }), Object.defineProperty(Kt, "decodeHTML5", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeHTML;
  }, "get") }), Object.defineProperty(Kt, "decodeHTML4Strict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeHTMLStrict;
  }, "get") }), Object.defineProperty(Kt, "decodeHTML5Strict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeHTMLStrict;
  }, "get") }), Object.defineProperty(Kt, "decodeXMLStrict", { enumerable: !0, get: /* @__PURE__ */ s(function() {
    return Co.decodeXML;
  }, "get") });
}), Rn = O((Kt, uo) => {
  function ho(ri, ni) {
    if (!(ri instanceof ni))
      throw new TypeError("Cannot call a class as a function");
  }
  s(ho, "_classCallCheck");
  function go(ri, ni) {
    for (var si = 0; si < ni.length; si++) {
      var li = ni[si];
      li.enumerable = li.enumerable || !1, li.configurable = !0, "value" in li && (li.writable = !0), Object.defineProperty(ri, li.key, li);
    }
  }
  s(go, "_defineProperties");
  function bo(ri, ni, si) {
    return ni && go(ri.prototype, ni), si && go(ri, si), ri;
  }
  s(bo, "_createClass");
  function vo(ri, ni) {
    var si = typeof Symbol < "u" && ri[Symbol.iterator] || ri["@@iterator"];
    if (!si) {
      if (Array.isArray(ri) || (si = Po(ri)) || ni && ri && typeof ri.length == "number") {
        si && (ri = si);
        var li = 0, ui = /* @__PURE__ */ s(function() {
        }, "F");
        return { s: ui, n: /* @__PURE__ */ s(function() {
          return li >= ri.length ? { done: !0 } : { done: !1, value: ri[li++] };
        }, "n"), e: /* @__PURE__ */ s(function(hi) {
          throw hi;
        }, "e"), f: ui };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var ci = !0, fi = !1, yi;
    return { s: /* @__PURE__ */ s(function() {
      si = si.call(ri);
    }, "s"), n: /* @__PURE__ */ s(function() {
      var hi = si.next();
      return ci = hi.done, hi;
    }, "n"), e: /* @__PURE__ */ s(function(hi) {
      fi = !0, yi = hi;
    }, "e"), f: /* @__PURE__ */ s(function() {
      try {
        !ci && si.return != null && si.return();
      } finally {
        if (fi) throw yi;
      }
    }, "f") };
  }
  s(vo, "_createForOfIteratorHelper");
  function Po(ri, ni) {
    if (ri) {
      if (typeof ri == "string") return Co(ri, ni);
      var si = Object.prototype.toString.call(ri).slice(8, -1);
      if (si === "Object" && ri.constructor && (si = ri.constructor.name), si === "Map" || si === "Set") return Array.from(ri);
      if (si === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(si)) return Co(ri, ni);
    }
  }
  s(Po, "_unsupportedIterableToArray");
  function Co(ri, ni) {
    (ni == null || ni > ri.length) && (ni = ri.length);
    for (var si = 0, li = new Array(ni); si < ni; si++)
      li[si] = ri[si];
    return li;
  }
  s(Co, "_arrayLikeToArray");
  var So = pn(), wo = {
    fg: "#FFF",
    bg: "#000",
    newline: !1,
    escapeXML: !1,
    stream: !1,
    colors: Eo()
  };
  function Eo() {
    var ri = {
      0: "#000",
      1: "#A00",
      2: "#0A0",
      3: "#A50",
      4: "#00A",
      5: "#A0A",
      6: "#0AA",
      7: "#AAA",
      8: "#555",
      9: "#F55",
      10: "#5F5",
      11: "#FF5",
      12: "#55F",
      13: "#F5F",
      14: "#5FF",
      15: "#FFF"
    };
    return Lo(0, 5).forEach(function(ni) {
      Lo(0, 5).forEach(function(si) {
        Lo(0, 5).forEach(function(li) {
          return Ro(ni, si, li, ri);
        });
      });
    }), Lo(0, 23).forEach(function(ni) {
      var si = ni + 232, li = _o(ni * 10 + 8);
      ri[si] = "#" + li + li + li;
    }), ri;
  }
  s(Eo, "getDefaultColors");
  function Ro(ri, ni, si, li) {
    var ui = 16 + ri * 36 + ni * 6 + si, ci = ri > 0 ? ri * 40 + 55 : 0, fi = ni > 0 ? ni * 40 + 55 : 0, yi = si > 0 ? si * 40 + 55 : 0;
    li[ui] = Io([ci, fi, yi]);
  }
  s(Ro, "setStyleColor");
  function _o(ri) {
    for (var ni = ri.toString(16); ni.length < 2; )
      ni = "0" + ni;
    return ni;
  }
  s(_o, "toHexString");
  function Io(ri) {
    var ni = [], si = vo(ri), li;
    try {
      for (si.s(); !(li = si.n()).done; ) {
        var ui = li.value;
        ni.push(_o(ui));
      }
    } catch (ci) {
      si.e(ci);
    } finally {
      si.f();
    }
    return "#" + ni.join("");
  }
  s(Io, "toColorHexString");
  function Ao(ri, ni, si, li) {
    var ui;
    return ni === "text" ? ui = No(si, li) : ni === "display" ? ui = jo(ri, si, li) : ni === "xterm256Foreground" ? ui = oi(ri, li.colors[si]) : ni === "xterm256Background" ? ui = Qo(ri, li.colors[si]) : ni === "rgb" && (ui = Oo(ri, si)), ui;
  }
  s(Ao, "generateOutput");
  function Oo(ri, ni) {
    ni = ni.substring(2).slice(0, -1);
    var si = +ni.substr(0, 2), li = ni.substring(5).split(";"), ui = li.map(function(ci) {
      return ("0" + Number(ci).toString(16)).substr(-2);
    }).join("");
    return ti(ri, (si === 38 ? "color:#" : "background-color:#") + ui);
  }
  s(Oo, "handleRgb");
  function jo(ri, ni, si) {
    ni = parseInt(ni, 10);
    var li = {
      "-1": /* @__PURE__ */ s(function() {
        return "<br/>";
      }, "_"),
      0: /* @__PURE__ */ s(function() {
        return ri.length && Do(ri);
      }, "_"),
      1: /* @__PURE__ */ s(function() {
        return Jo(ri, "b");
      }, "_"),
      3: /* @__PURE__ */ s(function() {
        return Jo(ri, "i");
      }, "_"),
      4: /* @__PURE__ */ s(function() {
        return Jo(ri, "u");
      }, "_"),
      8: /* @__PURE__ */ s(function() {
        return ti(ri, "display:none");
      }, "_"),
      9: /* @__PURE__ */ s(function() {
        return Jo(ri, "strike");
      }, "_"),
      22: /* @__PURE__ */ s(function() {
        return ti(ri, "font-weight:normal;text-decoration:none;font-style:normal");
      }, "_"),
      23: /* @__PURE__ */ s(function() {
        return Zo(ri, "i");
      }, "_"),
      24: /* @__PURE__ */ s(function() {
        return Zo(ri, "u");
      }, "_"),
      39: /* @__PURE__ */ s(function() {
        return oi(ri, si.fg);
      }, "_"),
      49: /* @__PURE__ */ s(function() {
        return Qo(ri, si.bg);
      }, "_"),
      53: /* @__PURE__ */ s(function() {
        return ti(ri, "text-decoration:overline");
      }, "_")
    }, ui;
    return li[ni] ? ui = li[ni]() : 4 < ni && ni < 7 ? ui = Jo(ri, "blink") : 29 < ni && ni < 38 ? ui = oi(ri, si.colors[ni - 30]) : 39 < ni && ni < 48 ? ui = Qo(
      ri,
      si.colors[ni - 40]
    ) : 89 < ni && ni < 98 ? ui = oi(ri, si.colors[8 + (ni - 90)]) : 99 < ni && ni < 108 && (ui = Qo(ri, si.colors[8 + (ni - 100)])), ui;
  }
  s(jo, "handleDisplay");
  function Do(ri) {
    var ni = ri.slice(0);
    return ri.length = 0, ni.reverse().map(function(si) {
      return "</" + si + ">";
    }).join("");
  }
  s(Do, "resetStyles");
  function Lo(ri, ni) {
    for (var si = [], li = ri; li <= ni; li++)
      si.push(li);
    return si;
  }
  s(Lo, "range");
  function ko(ri) {
    return function(ni) {
      return (ri === null || ni.category !== ri) && ri !== "all";
    };
  }
  s(ko, "notCategory");
  function Ko(ri) {
    ri = parseInt(ri, 10);
    var ni = null;
    return ri === 0 ? ni = "all" : ri === 1 ? ni = "bold" : 2 < ri && ri < 5 ? ni = "underline" : 4 < ri && ri < 7 ? ni = "blink" : ri === 8 ? ni = "hide" : ri === 9 ? ni = "strike" : 29 < ri && ri < 38 || ri === 39 || 89 < ri && ri < 98 ? ni = "foreground-color" : (39 < ri && ri < 48 || ri === 49 || 99 < ri && ri < 108) && (ni = "background-color"), ni;
  }
  s(Ko, "categoryForCode");
  function No(ri, ni) {
    return ni.escapeXML ? So.encodeXML(ri) : ri;
  }
  s(No, "pushText");
  function Jo(ri, ni, si) {
    return si || (si = ""), ri.push(ni), "<".concat(ni).concat(si ? ' style="'.concat(si, '"') : "", ">");
  }
  s(Jo, "pushTag");
  function ti(ri, ni) {
    return Jo(ri, "span", ni);
  }
  s(ti, "pushStyle");
  function oi(ri, ni) {
    return Jo(ri, "span", "color:" + ni);
  }
  s(oi, "pushForegroundColor");
  function Qo(ri, ni) {
    return Jo(ri, "span", "background-color:" + ni);
  }
  s(Qo, "pushBackgroundColor");
  function Zo(ri, ni) {
    var si;
    if (ri.slice(-1)[0] === ni && (si = ri.pop()), si)
      return "</" + ni + ">";
  }
  s(Zo, "closeTag");
  function ei(ri, ni, si) {
    var li = !1, ui = 3;
    function ci() {
      return "";
    }
    s(ci, "remove");
    function fi(Ni, Ai) {
      return si("xterm256Foreground", Ai), "";
    }
    s(fi, "removeXterm256Foreground");
    function yi(Ni, Ai) {
      return si("xterm256Background", Ai), "";
    }
    s(yi, "removeXterm256Background");
    function hi(Ni) {
      return ni.newline ? si("display", -1) : si("text", Ni), "";
    }
    s(hi, "newline");
    function mi(Ni, Ai) {
      li = !0, Ai.trim().length === 0 && (Ai = "0"), Ai = Ai.trimRight(";").split(";");
      var Yi = vo(Ai), Ui;
      try {
        for (Yi.s(); !(Ui = Yi.n()).done; ) {
          var us = Ui.value;
          si("display", us);
        }
      } catch (ns) {
        Yi.e(ns);
      } finally {
        Yi.f();
      }
      return "";
    }
    s(mi, "ansiMess");
    function bi(Ni) {
      return si("text", Ni), "";
    }
    s(bi, "realText");
    function xi(Ni) {
      return si("rgb", Ni), "";
    }
    s(xi, "rgb");
    var $i = [{
      pattern: /^\x08+/,
      sub: ci
    }, {
      pattern: /^\x1b\[[012]?K/,
      sub: ci
    }, {
      pattern: /^\x1b\[\(B/,
      sub: ci
    }, {
      pattern: /^\x1b\[[34]8;2;\d+;\d+;\d+m/,
      sub: xi
    }, {
      pattern: /^\x1b\[38;5;(\d+)m/,
      sub: fi
    }, {
      pattern: /^\x1b\[48;5;(\d+)m/,
      sub: yi
    }, {
      pattern: /^\n/,
      sub: hi
    }, {
      pattern: /^\r+\n/,
      sub: hi
    }, {
      pattern: /^\r/,
      sub: hi
    }, {
      pattern: /^\x1b\[((?:\d{1,3};?)+|)m/,
      sub: mi
    }, {
      // CSI n J
      // ED - Erase in Display Clears part of the screen.
      // If n is 0 (or missing), clear from cursor to end of screen.
      // If n is 1, clear from cursor to beginning of the screen.
      // If n is 2, clear entire screen (and moves cursor to upper left on DOS ANSI.SYS).
      // If n is 3, clear entire screen and delete all lines saved in the scrollback buffer
      //   (this feature was added for xterm and is supported by other terminal applications).
      pattern: /^\x1b\[\d?J/,
      sub: ci
    }, {
      // CSI n ; m f
      // HVP - Horizontal Vertical Position Same as CUP
      pattern: /^\x1b\[\d{0,3};\d{0,3}f/,
      sub: ci
    }, {
      // catch-all for CSI sequences?
      pattern: /^\x1b\[?[\d;]{0,3}/,
      sub: ci
    }, {
      /**
       * extracts real text - not containing:
       * - `\x1b' - ESC - escape (Ascii 27)
       * - '\x08' - BS - backspace (Ascii 8)
       * - `\n` - Newline - linefeed (LF) (ascii 10)
       * - `\r` - Windows Carriage Return (CR)
       */
      pattern: /^(([^\x1b\x08\r\n])+)/,
      sub: bi
    }];
    function Ci(Ni, Ai) {
      Ai > ui && li || (li = !1, ri = ri.replace(Ni.pattern, Ni.sub));
    }
    s(Ci, "process");
    var Si = [], vi = ri, Pi = vi.length;
    e: for (; Pi > 0; ) {
      for (var wi = 0, gi = 0, Ri = $i.length; gi < Ri; wi = ++gi) {
        var Ei = $i[wi];
        if (Ci(Ei, wi), ri.length !== Pi) {
          Pi = ri.length;
          continue e;
        }
      }
      if (ri.length === Pi)
        break;
      Si.push(0), Pi = ri.length;
    }
    return Si;
  }
  s(ei, "tokenize");
  function ii(ri, ni, si) {
    return ni !== "text" && (ri = ri.filter(ko(Ko(si))), ri.push({
      token: ni,
      data: si,
      category: Ko(si)
    })), ri;
  }
  s(ii, "updateStickyStack");
  var ai = /* @__PURE__ */ function() {
    function ri(ni) {
      ho(this, ri), ni = ni || {}, ni.colors && (ni.colors = Object.assign({}, wo.colors, ni.colors)), this.options = Object.assign({}, wo, ni), this.stack = [], this.stickyStack = [];
    }
    return s(ri, "Filter"), bo(ri, [{
      key: "toHtml",
      value: /* @__PURE__ */ s(function(ni) {
        var si = this;
        ni = typeof ni == "string" ? [ni] : ni;
        var li = this.stack, ui = this.options, ci = [];
        return this.stickyStack.forEach(function(fi) {
          var yi = Ao(li, fi.token, fi.data, ui);
          yi && ci.push(yi);
        }), ei(ni.join(""), ui, function(fi, yi) {
          var hi = Ao(li, fi, yi, ui);
          hi && ci.push(hi), ui.stream && (si.stickyStack = ii(si.stickyStack, fi, yi));
        }), li.length && ci.push(Do(li)), ci.join("");
      }, "toHtml")
    }]), ri;
  }();
  uo.exports = ai;
}), v = (() => {
  let Kt;
  return typeof window < "u" ? Kt = window : typeof globalThis < "u" ? Kt = globalThis : typeof global < "u" ? Kt = global : typeof self < "u" ? Kt = self : Kt = {}, Kt;
})();
function fr() {
  let Kt = {
    setHandler: /* @__PURE__ */ s(() => {
    }, "setHandler"),
    send: /* @__PURE__ */ s(() => {
    }, "send")
  };
  return new z$2({ transport: Kt });
}
s(fr, "mockChannel");
var hr = class {
  constructor() {
    this.getChannel = /* @__PURE__ */ s(() => {
      if (!this.channel) {
        let uo = fr();
        return this.setChannel(uo), uo;
      }
      return this.channel;
    }, "getChannel"), this.ready = /* @__PURE__ */ s(() => this.promise, "ready"), this.hasChannel = /* @__PURE__ */ s(() => !!this.channel, "hasChannel"), this.setChannel = /* @__PURE__ */ s((uo) => {
      this.channel = uo, this.resolve();
    }, "setChannel"), this.promise = new Promise((uo) => {
      this.resolve = () => uo(this.getChannel());
    });
  }
};
s(hr, "AddonStore");
var mr = hr, yr = "__STORYBOOK_ADDONS_PREVIEW";
function Nn() {
  return v[yr] || (v[yr] = new mr()), v[yr];
}
s(Nn, "getAddonsStore");
var q = Nn(), xr = class {
  constructor() {
    this.hookListsMap = void 0, this.mountedDecorators = void 0, this.prevMountedDecorators = void 0, this.currentHooks = void 0, this.nextHookIndex = void 0, this.currentPhase = void 0, this.currentEffects = void 0, this.prevEffects = void 0, this.currentDecoratorName = void 0, this.hasUpdates = void 0, this.currentContext = void 0, this.renderListener = /* @__PURE__ */ s((uo) => {
      var ho;
      uo === ((ho = this.currentContext) == null ? void 0 : ho.id) && (this.triggerEffects(), this.currentContext = null, this.removeRenderListeners());
    }, "renderListener"), this.init();
  }
  init() {
    this.hookListsMap = /* @__PURE__ */ new WeakMap(), this.mountedDecorators = /* @__PURE__ */ new Set(), this.prevMountedDecorators = /* @__PURE__ */ new Set(), this.currentHooks = [], this.nextHookIndex = 0, this.currentPhase = "NONE", this.currentEffects = [], this.prevEffects = [], this.currentDecoratorName = null, this.hasUpdates = !1, this.currentContext = null;
  }
  clean() {
    this.prevEffects.forEach((uo) => {
      uo.destroy && uo.destroy();
    }), this.init(), this.removeRenderListeners();
  }
  getNextHook() {
    let uo = this.currentHooks[this.nextHookIndex];
    return this.nextHookIndex += 1, uo;
  }
  triggerEffects() {
    this.prevEffects.forEach((uo) => {
      !this.currentEffects.includes(uo) && uo.destroy && uo.destroy();
    }), this.currentEffects.forEach((uo) => {
      this.prevEffects.includes(uo) || (uo.destroy = uo.create());
    }), this.prevEffects = this.currentEffects, this.currentEffects = [];
  }
  addRenderListeners() {
    this.removeRenderListeners(), q.getChannel().on(X$2, this.renderListener);
  }
  removeRenderListeners() {
    q.getChannel().removeListener(X$2, this.renderListener);
  }
};
s(xr, "HooksContext");
var ee = xr;
function Tt(Kt) {
  let uo = /* @__PURE__ */ s((...ho) => {
    let { hooks: go } = typeof ho[0] == "function" ? ho[1] : ho[0], bo = go.currentPhase, vo = go.currentHooks, Po = go.nextHookIndex, Co = go.currentDecoratorName;
    go.currentDecoratorName = Kt.name, go.prevMountedDecorators.has(Kt) ? (go.currentPhase = "UPDATE", go.currentHooks = go.hookListsMap.get(Kt) || []) : (go.currentPhase = "MOUNT", go.currentHooks = [], go.hookListsMap.set(Kt, go.currentHooks), go.prevMountedDecorators.add(Kt)), go.nextHookIndex = 0;
    let So = v.STORYBOOK_HOOKS_CONTEXT;
    v.STORYBOOK_HOOKS_CONTEXT = go;
    let wo = Kt(...ho);
    if (v.STORYBOOK_HOOKS_CONTEXT = So, go.currentPhase === "UPDATE" && go.getNextHook() != null)
      throw new Error(
        "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
      );
    return go.currentPhase = bo, go.currentHooks = vo, go.nextHookIndex = Po, go.currentDecoratorName = Co, wo;
  }, "hookified");
  return uo.originalFn = Kt, uo;
}
s(Tt, "hookify");
var gr = 0, Vn = 25, br = /* @__PURE__ */ s((Kt) => (uo, ho) => {
  let go = Kt(
    Tt(uo),
    ho.map((bo) => Tt(bo))
  );
  return (bo) => {
    let { hooks: vo } = bo;
    vo.prevMountedDecorators ?? (vo.prevMountedDecorators = /* @__PURE__ */ new Set()), vo.mountedDecorators = /* @__PURE__ */ new Set([uo, ...ho]), vo.currentContext = bo, vo.hasUpdates = !1;
    let Po = go(bo);
    for (gr = 1; vo.hasUpdates; )
      if (vo.hasUpdates = !1, vo.currentEffects = [], Po = go(bo), gr += 1, gr > Vn)
        throw new Error(
          "Too many re-renders. Storybook limits the number of renders to prevent an infinite loop."
        );
    return vo.addRenderListeners(), Po;
  };
}, "applyHooks"), Un = /* @__PURE__ */ s((Kt, uo) => Kt.length === uo.length && Kt.every((ho, go) => ho === uo[go]), "areDepsEqual"), Sr = /* @__PURE__ */ s(
  () => new Error("Storybook preview hooks can only be called inside decorators and story functions."),
  "invalidHooksError"
);
function xt() {
  return v.STORYBOOK_HOOKS_CONTEXT || null;
}
s(xt, "getHooksContextOrNull");
function Tr() {
  let Kt = xt();
  if (Kt == null)
    throw Sr();
  return Kt;
}
s(Tr, "getHooksContextOrThrow");
function Hn(Kt, uo, ho) {
  let go = Tr();
  if (go.currentPhase === "MOUNT") {
    ho != null && !Array.isArray(ho) && s$2.warn(
      `${Kt} received a final argument that is not an array (instead, received ${ho}). When specified, the final argument must be an array.`
    );
    let bo = { name: Kt, deps: ho };
    return go.currentHooks.push(bo), uo(bo), bo;
  }
  if (go.currentPhase === "UPDATE") {
    let bo = go.getNextHook();
    if (bo == null)
      throw new Error("Rendered more hooks than during the previous render.");
    return bo.name !== Kt && s$2.warn(
      `Storybook has detected a change in the order of Hooks${go.currentDecoratorName ? ` called by ${go.currentDecoratorName}` : ""}. This will lead to bugs and errors if not fixed.`
    ), ho != null && bo.deps == null && s$2.warn(
      `${Kt} received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.`
    ), ho != null && bo.deps != null && ho.length !== bo.deps.length && s$2.warn(`The final argument passed to ${Kt} changed size between renders. The order and size of this array must remain constant.
Previous: ${bo.deps}
Incoming: ${ho}`), (ho == null || bo.deps == null || !Un(ho, bo.deps)) && (uo(bo), bo.deps = ho), bo;
  }
  throw Sr();
}
s(Hn, "useHook");
function qe(Kt, uo, ho) {
  let { memoizedState: go } = Hn(
    Kt,
    (bo) => {
      bo.memoizedState = uo();
    },
    ho
  );
  return go;
}
s(qe, "useMemoLike");
function Wn(Kt, uo) {
  return qe("useMemo", Kt, uo);
}
s(Wn, "useMemo");
function Ee(Kt, uo) {
  return qe("useCallback", () => Kt, uo);
}
s(Ee, "useCallback");
function Rt(Kt, uo) {
  return qe(Kt, () => ({ current: uo }), []);
}
s(Rt, "useRefLike");
function $n(Kt) {
  return Rt("useRef", Kt);
}
s($n, "useRef");
function Yn() {
  let Kt = xt();
  if (Kt != null && Kt.currentPhase !== "NONE")
    Kt.hasUpdates = !0;
  else
    try {
      q.getChannel().emit(L$2);
    } catch {
      s$2.warn("State updates of Storybook preview hooks work only in browser");
    }
}
s(Yn, "triggerUpdate");
function wt(Kt, uo) {
  let ho = Rt(
    Kt,
    // @ts-expect-error S type should never be function, but there's no way to tell that to TypeScript
    typeof uo == "function" ? uo() : uo
  ), go = /* @__PURE__ */ s((bo) => {
    ho.current = typeof bo == "function" ? bo(ho.current) : bo, Yn();
  }, "setState");
  return [ho.current, go];
}
s(wt, "useStateLike");
function Kn(Kt) {
  return wt("useState", Kt);
}
s(Kn, "useState");
function Xn(Kt, uo, ho) {
  let go = ho != null ? () => ho(uo) : uo, [bo, vo] = wt("useReducer", go);
  return [bo, /* @__PURE__ */ s((Po) => vo((Co) => Kt(Co, Po)), "dispatch")];
}
s(Xn, "useReducer");
function Et(Kt, uo) {
  let ho = Tr(), go = qe("useEffect", () => ({ create: Kt }), uo);
  ho.currentEffects.includes(go) || ho.currentEffects.push(go);
}
s(Et, "useEffect");
function Jn(Kt, uo = []) {
  let ho = q.getChannel();
  return Et(() => (Object.entries(Kt).forEach(([go, bo]) => ho.on(go, bo)), () => {
    Object.entries(Kt).forEach(
      ([go, bo]) => ho.removeListener(go, bo)
    );
  }), [...Object.keys(Kt), ...uo]), Ee(ho.emit.bind(ho), [ho]);
}
s(Jn, "useChannel");
function Be() {
  let { currentContext: Kt } = Tr();
  if (Kt == null)
    throw Sr();
  return Kt;
}
s(Be, "useStoryContext");
function Qn(Kt, uo) {
  let { parameters: ho } = Be();
  if (Kt)
    return ho[Kt] ?? uo;
}
s(Qn, "useParameter");
function Zn() {
  let Kt = q.getChannel(), { id: uo, args: ho } = Be(), go = Ee(
    (vo) => Kt.emit(n, { storyId: uo, updatedArgs: vo }),
    [Kt, uo]
  ), bo = Ee(
    (vo) => Kt.emit(H$2, { storyId: uo, argNames: vo }),
    [Kt, uo]
  );
  return [ho, go, bo];
}
s(Zn, "useArgs");
function es() {
  let Kt = q.getChannel(), { globals: uo } = Be(), ho = Ee(
    (go) => Kt.emit(j$1, { globals: go }),
    [Kt]
  );
  return [uo, ho];
}
s(es, "useGlobals");
function Rr(Kt, uo) {
  let ho = {}, go = Object.entries(Kt);
  for (let bo = 0; bo < go.length; bo++) {
    let [vo, Po] = go[bo];
    uo(Po, vo) || (ho[vo] = Po);
  }
  return ho;
}
s(Rr, "omitBy");
function wr(Kt, uo) {
  let ho = {};
  for (let go = 0; go < uo.length; go++) {
    let bo = uo[go];
    Object.prototype.hasOwnProperty.call(Kt, bo) && (ho[bo] = Kt[bo]);
  }
  return ho;
}
s(wr, "pick");
function Er(Kt, uo) {
  let ho = {}, go = Object.entries(Kt);
  for (let bo = 0; bo < go.length; bo++) {
    let [vo, Po] = go[bo];
    uo(Po, vo) && (ho[vo] = Po);
  }
  return ho;
}
s(Er, "pickBy");
function k(Kt) {
  if (typeof Kt != "object" || Kt == null)
    return !1;
  if (Object.getPrototypeOf(Kt) === null)
    return !0;
  if (Kt.toString() !== "[object Object]")
    return !1;
  let uo = Kt;
  for (; Object.getPrototypeOf(uo) !== null; )
    uo = Object.getPrototypeOf(uo);
  return Object.getPrototypeOf(Kt) === uo;
}
s(k, "isPlainObject");
function L(Kt, uo) {
  let ho = {}, go = Object.keys(Kt);
  for (let bo = 0; bo < go.length; bo++) {
    let vo = go[bo], Po = Kt[vo];
    ho[vo] = uo(Po, vo, Kt);
  }
  return ho;
}
s(L, "mapValues");
var At = "[object RegExp]", vt = "[object String]", Ct = "[object Number]", Pt = "[object Boolean]", Ar = "[object Arguments]", Ft = "[object Symbol]", It = "[object Date]", Ot = "[object Map]", Dt = "[object Set]", kt = "[object Array]", jt = "[object Function]", Mt = "[object ArrayBuffer]", ze = "[object Object]", _t = "[object Error]", Lt = "[object DataView]", Nt = "[object Uint8Array]", qt = "[object Uint8ClampedArray]", Bt = "[object Uint16Array]", zt = "[object Uint32Array]", Gt = "[object BigUint64Array]", Vt = "[object Int8Array]", Ut = "[object Int16Array]", Ht = "[object Int32Array]", Wt = "[object BigInt64Array]", $t = "[object Float32Array]", Yt = "[object Float64Array]";
function vr(Kt) {
  return Object.getOwnPropertySymbols(Kt).filter((uo) => Object.prototype.propertyIsEnumerable.call(Kt, uo));
}
s(vr, "getSymbols");
function Cr(Kt) {
  return Kt == null ? Kt === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(Kt);
}
s(Cr, "getTag");
function Pr(Kt, uo) {
  if (typeof Kt == typeof uo)
    switch (typeof Kt) {
      case "bigint":
      case "string":
      case "boolean":
      case "symbol":
      case "undefined":
        return Kt === uo;
      case "number":
        return Kt === uo || Object.is(Kt, uo);
      case "function":
        return Kt === uo;
      case "object":
        return U(Kt, uo);
    }
  return U(Kt, uo);
}
s(Pr, "isEqual");
function U(Kt, uo, ho) {
  if (Object.is(Kt, uo))
    return !0;
  let go = Cr(Kt), bo = Cr(uo);
  if (go === Ar && (go = ze), bo === Ar && (bo = ze), go !== bo)
    return !1;
  switch (go) {
    case vt:
      return Kt.toString() === uo.toString();
    case Ct: {
      let Co = Kt.valueOf(), So = uo.valueOf();
      return Co === So || Number.isNaN(Co) && Number.isNaN(So);
    }
    case Pt:
    case It:
    case Ft:
      return Object.is(Kt.valueOf(), uo.valueOf());
    case At:
      return Kt.source === uo.source && Kt.flags === uo.flags;
    case jt:
      return Kt === uo;
  }
  ho = ho ?? /* @__PURE__ */ new Map();
  let vo = ho.get(Kt), Po = ho.get(uo);
  if (vo != null && Po != null)
    return vo === uo;
  ho.set(Kt, uo), ho.set(uo, Kt);
  try {
    switch (go) {
      case Ot: {
        if (Kt.size !== uo.size)
          return !1;
        for (let [Co, So] of Kt.entries())
          if (!uo.has(Co) || !U(So, uo.get(Co), ho))
            return !1;
        return !0;
      }
      case Dt: {
        if (Kt.size !== uo.size)
          return !1;
        let Co = Array.from(Kt.values()), So = Array.from(uo.values());
        for (let wo = 0; wo < Co.length; wo++) {
          let Eo = Co[wo], Ro = So.findIndex((_o) => U(Eo, _o, ho));
          if (Ro === -1)
            return !1;
          So.splice(Ro, 1);
        }
        return !0;
      }
      case kt:
      case Nt:
      case qt:
      case Bt:
      case zt:
      case Gt:
      case Vt:
      case Ut:
      case Ht:
      case Wt:
      case $t:
      case Yt: {
        if (typeof Buffer < "u" && Buffer.isBuffer(Kt) !== Buffer.isBuffer(uo) || Kt.length !== uo.length)
          return !1;
        for (let Co = 0; Co < Kt.length; Co++)
          if (!U(Kt[Co], uo[Co], ho))
            return !1;
        return !0;
      }
      case Mt:
        return Kt.byteLength !== uo.byteLength ? !1 : U(new Uint8Array(Kt), new Uint8Array(uo), ho);
      case Lt:
        return Kt.byteLength !== uo.byteLength || Kt.byteOffset !== uo.byteOffset ? !1 : U(Kt.buffer, uo.buffer, ho);
      case _t:
        return Kt.name === uo.name && Kt.message === uo.message;
      case ze: {
        if (!(U(Kt.constructor, uo.constructor, ho) || k(Kt) && k(uo)))
          return !1;
        let Co = [...Object.keys(Kt), ...vr(Kt)], So = [...Object.keys(uo), ...vr(uo)];
        if (Co.length !== So.length)
          return !1;
        for (let wo = 0; wo < Co.length; wo++) {
          let Eo = Co[wo], Ro = Kt[Eo];
          if (!Object.prototype.hasOwnProperty.call(uo, Eo))
            return !1;
          let _o = uo[Eo];
          if (!U(Ro, _o, ho))
            return !1;
        }
        return !0;
      }
      default:
        return !1;
    }
  } finally {
    ho.delete(Kt), ho.delete(uo);
  }
}
s(U, "areObjectsEqual");
var Ke = ce(Ir());
function F(Kt) {
  for (var uo = [], ho = 1; ho < arguments.length; ho++)
    uo[ho - 1] = arguments[ho];
  var go = Array.from(typeof Kt == "string" ? [Kt] : Kt);
  go[go.length - 1] = go[go.length - 1].replace(/\r?\n([\t ]*)$/, "");
  var bo = go.reduce(function(Co, So) {
    var wo = So.match(/\n([\t ]+|(?!\s).)/g);
    return wo ? Co.concat(wo.map(function(Eo) {
      var Ro, _o;
      return (_o = (Ro = Eo.match(/[\t ]/g)) === null || Ro === void 0 ? void 0 : Ro.length) !== null && _o !== void 0 ? _o : 0;
    })) : Co;
  }, []);
  if (bo.length) {
    var vo = new RegExp(`
[	 ]{` + Math.min.apply(Math, bo) + "}", "g");
    go = go.map(function(Co) {
      return Co.replace(vo, `
`);
    });
  }
  go[0] = go[0].replace(/^\r?\n/, "");
  var Po = go[0];
  return uo.forEach(function(Co, So) {
    var wo = Po.match(/(?:^|\n)( *)$/), Eo = wo ? wo[1] : "", Ro = Co;
    typeof Co == "string" && Co.includes(`
`) && (Ro = String(Co).split(`
`).map(function(_o, Io) {
      return Io === 0 ? _o : "" + Eo + _o;
    }).join(`
`)), Po += Ro + go[So + 1];
  }), Po;
}
s(F, "dedent");
var de = Symbol("incompatible"), Dr = /* @__PURE__ */ s((Kt, uo) => {
  let ho = uo.type;
  if (Kt == null || !ho || uo.mapping)
    return Kt;
  switch (ho.name) {
    case "string":
      return String(Kt);
    case "enum":
      return Kt;
    case "number":
      return Number(Kt);
    case "boolean":
      return String(Kt) === "true";
    case "array":
      return !ho.value || !Array.isArray(Kt) ? de : Kt.reduce((go, bo, vo) => {
        let Po = Dr(bo, { type: ho.value });
        return Po !== de && (go[vo] = Po), go;
      }, new Array(Kt.length));
    case "object":
      return typeof Kt == "string" || typeof Kt == "number" ? Kt : !ho.value || typeof Kt != "object" ? de : Object.entries(Kt).reduce((go, [bo, vo]) => {
        let Po = Dr(vo, { type: ho.value[bo] });
        return Po === de ? go : Object.assign(go, { [bo]: Po });
      }, {});
    default:
      return de;
  }
}, "map"), Xt = /* @__PURE__ */ s((Kt, uo) => Object.entries(Kt).reduce((ho, [go, bo]) => {
  if (!uo[go])
    return ho;
  let vo = Dr(bo, uo[go]);
  return vo === de ? ho : Object.assign(ho, { [go]: vo });
}, {}), "mapArgsToTypes"), Ae = /* @__PURE__ */ s((Kt, uo) => Array.isArray(Kt) && Array.isArray(uo) ? uo.reduce(
  (ho, go, bo) => (ho[bo] = Ae(Kt[bo], uo[bo]), ho),
  [...Kt]
).filter((ho) => ho !== void 0) : !k(Kt) || !k(uo) ? uo : Object.keys({ ...Kt, ...uo }).reduce((ho, go) => {
  if (go in uo) {
    let bo = Ae(Kt[go], uo[go]);
    bo !== void 0 && (ho[go] = bo);
  } else
    ho[go] = Kt[go];
  return ho;
}, {}), "combineArgs"), Jt = /* @__PURE__ */ s((Kt, uo) => Object.entries(uo).reduce((ho, [go, { options: bo }]) => {
  function vo() {
    return go in Kt && (ho[go] = Kt[go]), ho;
  }
  if (s(vo, "allowArg"), !bo)
    return vo();
  if (!Array.isArray(bo))
    return n$1.error(F`
        Invalid argType: '${go}.options' should be an array.

        More info: https://storybook.js.org/docs/api/arg-types
      `), vo();
  if (bo.some((Ro) => Ro && ["object", "function"].includes(typeof Ro)))
    return n$1.error(F`
        Invalid argType: '${go}.options' should only contain primitives. Use a 'mapping' for complex values.

        More info: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
      `), vo();
  let Po = Array.isArray(Kt[go]), Co = Po && Kt[go].findIndex((Ro) => !bo.includes(Ro)), So = Po && Co === -1;
  if (Kt[go] === void 0 || bo.includes(Kt[go]) || So)
    return vo();
  let wo = Po ? `${go}[${Co}]` : go, Eo = bo.map((Ro) => typeof Ro == "string" ? `'${Ro}'` : String(Ro)).join(", ");
  return n$1.warn(`Received illegal value for '${wo}'. Supported options: ${Eo}`), ho;
}, {}), "validateOptions"), re = Symbol("Deeply equal"), pe = /* @__PURE__ */ s((Kt, uo) => {
  if (typeof Kt != typeof uo)
    return uo;
  if (Pr(Kt, uo))
    return re;
  if (Array.isArray(Kt) && Array.isArray(uo)) {
    let ho = uo.reduce((go, bo, vo) => {
      let Po = pe(Kt[vo], bo);
      return Po !== re && (go[vo] = Po), go;
    }, new Array(uo.length));
    return uo.length >= Kt.length ? ho : ho.concat(new Array(Kt.length - uo.length).fill(void 0));
  }
  return k(Kt) && k(uo) ? Object.keys({ ...Kt, ...uo }).reduce((ho, go) => {
    let bo = pe(Kt == null ? void 0 : Kt[go], uo == null ? void 0 : uo[go]);
    return bo === re ? ho : Object.assign(ho, { [go]: bo });
  }, {}) : uo;
}, "deepDiff"), kr = "UNTARGETED";
function Qt({
  args: Kt,
  argTypes: uo
}) {
  let ho = {};
  return Object.entries(Kt).forEach(([go, bo]) => {
    let { target: vo = kr } = uo[go] || {};
    ho[vo] = ho[vo] || {}, ho[vo][go] = bo;
  }), ho;
}
s(Qt, "groupArgsByTarget");
function ts(Kt) {
  return Object.keys(Kt).forEach((uo) => Kt[uo] === void 0 && delete Kt[uo]), Kt;
}
s(ts, "deleteUndefined");
var jr = class {
  constructor() {
    this.initialArgsByStoryId = {}, this.argsByStoryId = {};
  }
  get(uo) {
    if (!(uo in this.argsByStoryId))
      throw new Error(`No args known for ${uo} -- has it been rendered yet?`);
    return this.argsByStoryId[uo];
  }
  setInitial(uo) {
    if (!this.initialArgsByStoryId[uo.id])
      this.initialArgsByStoryId[uo.id] = uo.initialArgs, this.argsByStoryId[uo.id] = uo.initialArgs;
    else if (this.initialArgsByStoryId[uo.id] !== uo.initialArgs) {
      let ho = pe(this.initialArgsByStoryId[uo.id], this.argsByStoryId[uo.id]);
      this.initialArgsByStoryId[uo.id] = uo.initialArgs, this.argsByStoryId[uo.id] = uo.initialArgs, ho !== re && this.updateFromDelta(uo, ho);
    }
  }
  updateFromDelta(uo, ho) {
    let go = Jt(ho, uo.argTypes);
    this.argsByStoryId[uo.id] = Ae(this.argsByStoryId[uo.id], go);
  }
  updateFromPersisted(uo, ho) {
    let go = Xt(ho, uo.argTypes);
    return this.updateFromDelta(uo, go);
  }
  update(uo, ho) {
    if (!(uo in this.argsByStoryId))
      throw new Error(`No args known for ${uo} -- has it been rendered yet?`);
    this.argsByStoryId[uo] = ts({
      ...this.argsByStoryId[uo],
      ...ho
    });
  }
};
s(jr, "ArgsStore");
var Ge = jr, Ve = /* @__PURE__ */ s((Kt = {}) => Object.entries(Kt).reduce((uo, [ho, { defaultValue: go }]) => (typeof go < "u" && (uo[ho] = go), uo), {}), "getValuesFromArgTypes"), Mr = class {
  constructor({
    globals: uo = {},
    globalTypes: ho = {}
  }) {
    this.set({ globals: uo, globalTypes: ho });
  }
  set({ globals: uo = {}, globalTypes: ho = {} }) {
    let go = this.initialGlobals && pe(this.initialGlobals, this.globals);
    this.allowedGlobalNames = /* @__PURE__ */ new Set([...Object.keys(uo), ...Object.keys(ho)]);
    let bo = Ve(ho);
    this.initialGlobals = { ...bo, ...uo }, this.globals = this.initialGlobals, go && go !== re && this.updateFromPersisted(go);
  }
  filterAllowedGlobals(uo) {
    return Object.entries(uo).reduce((ho, [go, bo]) => (this.allowedGlobalNames.has(go) ? ho[go] = bo : s$2.warn(
      `Attempted to set a global (${go}) that is not defined in initial globals or globalTypes`
    ), ho), {});
  }
  updateFromPersisted(uo) {
    let ho = this.filterAllowedGlobals(uo);
    this.globals = { ...this.globals, ...ho };
  }
  get() {
    return this.globals;
  }
  update(uo) {
    this.globals = { ...this.globals, ...this.filterAllowedGlobals(uo) };
  }
};
s(Mr, "GlobalsStore");
var Ue = Mr, Zt = ce(Ir()), ss = (0, Zt.default)(1)(
  (Kt) => Object.values(Kt).reduce(
    (uo, ho) => (uo[ho.importPath] = uo[ho.importPath] || ho, uo),
    {}
  )
), _r = class {
  constructor({ entries: uo } = { v: 5, entries: {} }) {
    this.entries = uo;
  }
  entryFromSpecifier(uo) {
    let ho = Object.values(this.entries);
    if (uo === "*")
      return ho[0];
    if (typeof uo == "string")
      return this.entries[uo] ? this.entries[uo] : ho.find((vo) => vo.id.startsWith(uo));
    let { name: go, title: bo } = uo;
    return ho.find((vo) => vo.name === go && vo.title === bo);
  }
  storyIdToEntry(uo) {
    let ho = this.entries[uo];
    if (!ho)
      throw new D$1({ storyId: uo });
    return ho;
  }
  importPathToEntry(uo) {
    return ss(this.entries)[uo];
  }
};
s(_r, "StoryIndexStore");
var He = _r, is = /* @__PURE__ */ s((Kt) => typeof Kt == "string" ? { name: Kt } : Kt, "normalizeType"), as = /* @__PURE__ */ s((Kt) => typeof Kt == "string" ? { type: Kt } : Kt, "normalizeControl"), ls = /* @__PURE__ */ s((Kt, uo) => {
  let { type: ho, control: go, ...bo } = Kt, vo = {
    name: uo,
    ...bo
  };
  return ho && (vo.type = is(ho)), go ? vo.control = as(go) : go === !1 && (vo.control = { disable: !0 }), vo;
}, "normalizeInputType"), te = /* @__PURE__ */ s((Kt) => L(Kt, ls), "normalizeInputTypes"), P = /* @__PURE__ */ s((Kt) => Array.isArray(Kt) ? Kt : Kt ? [Kt] : [], "normalizeArrays"), fs = F`
CSF .story annotations deprecated; annotate story functions directly:
- StoryFn.story.name => StoryFn.storyName
- StoryFn.story.(parameters|decorators) => StoryFn.(parameters|decorators)
See https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#hoisted-csf-annotations for details and codemod.
`;
function ve(Kt, uo, ho) {
  let go = uo, bo = typeof uo == "function" ? uo : null, { story: vo } = go;
  vo && (s$2.debug("deprecated story", vo), m$2(fs));
  let Po = N(Kt), Co = typeof go != "function" && go.name || go.storyName || (vo == null ? void 0 : vo.name) || Po, So = [
    ...P(go.decorators),
    ...P(vo == null ? void 0 : vo.decorators)
  ], wo = { ...vo == null ? void 0 : vo.parameters, ...go.parameters }, Eo = { ...vo == null ? void 0 : vo.args, ...go.args }, Ro = { ...vo == null ? void 0 : vo.argTypes, ...go.argTypes }, _o = [...P(go.loaders), ...P(
    vo == null ? void 0 : vo.loaders
  )], Io = [
    ...P(go.beforeEach),
    ...P(vo == null ? void 0 : vo.beforeEach)
  ], { render: Ao, play: Oo, tags: jo = [], globals: Do = {} } = go, Lo = wo.__id || G(ho.id, Po);
  return {
    moduleExport: uo,
    id: Lo,
    name: Co,
    tags: jo,
    decorators: So,
    parameters: wo,
    args: Eo,
    argTypes: te(Ro),
    loaders: _o,
    beforeEach: Io,
    globals: Do,
    ...Ao && { render: Ao },
    ...bo && { userStoryFn: bo },
    ...Oo && { play: Oo }
  };
}
s(ve, "normalizeStory");
function We(Kt, uo = Kt.title, ho) {
  let { id: go, argTypes: bo } = Kt;
  return {
    id: O$1(go || uo),
    ...Kt,
    title: uo,
    ...bo && { argTypes: te(bo) },
    parameters: {
      fileName: ho,
      ...Kt.parameters
    }
  };
}
s(We, "normalizeComponentAnnotations");
var hs = /* @__PURE__ */ s((Kt) => {
  let { globals: uo, globalTypes: ho } = Kt;
  (uo || ho) && s$2.error(
    "Global args/argTypes can only be set globally",
    JSON.stringify({
      globals: uo,
      globalTypes: ho
    })
  );
}, "checkGlobals"), gs = /* @__PURE__ */ s((Kt) => {
  let { options: uo } = Kt;
  uo != null && uo.storySort && s$2.error("The storySort option parameter can only be set globally");
}, "checkStorySort"), eo = /* @__PURE__ */ s((Kt) => {
  Kt && (hs(Kt), gs(Kt));
}, "checkDisallowedParameters");
function to(Kt, uo, ho) {
  let { default: go, __namedExportsOrder: bo, ...vo } = Kt, Po = We(
    go,
    ho,
    uo
  );
  eo(Po.parameters);
  let Co = { meta: Po, stories: {}, moduleExports: Kt };
  return Object.keys(vo).forEach((So) => {
    if (M$1(So, Po)) {
      let wo = ve(So, vo[So], Po);
      eo(wo.parameters), Co.stories[wo.id] = wo;
    }
  }), Co;
}
s(to, "processCSFFile");
function no(Kt) {
  return Kt != null && bs(Kt).includes("mount");
}
s(no, "mountDestructured");
function bs(Kt) {
  let uo = Kt.toString().match(/[^(]*\(([^)]*)/);
  if (!uo)
    return [];
  let ho = oo(uo[1]);
  if (!ho.length)
    return [];
  let go = ho[0];
  return go.startsWith("{") && go.endsWith("}") ? oo(go.slice(1, -1).replace(/\s/g, "")).map((bo) => bo.replace(/:.*|=.*/g, "")) : [];
}
s(bs, "getUsedProps");
function oo(Kt) {
  let uo = [], ho = [], go = 0;
  for (let vo = 0; vo < Kt.length; vo++)
    if (Kt[vo] === "{" || Kt[vo] === "[")
      ho.push(Kt[vo] === "{" ? "}" : "]");
    else if (Kt[vo] === ho[ho.length - 1])
      ho.pop();
    else if (!ho.length && Kt[vo] === ",") {
      let Po = Kt.substring(go, vo).trim();
      Po && uo.push(Po), go = vo + 1;
    }
  let bo = Kt.substring(go).trim();
  return bo && uo.push(bo), uo;
}
s(oo, "splitByComma");
function so(Kt, uo, ho) {
  let go = ho(Kt);
  return (bo) => uo(go, bo);
}
s(so, "decorateStory");
function io({
  componentId: Kt,
  title: uo,
  kind: ho,
  id: go,
  name: bo,
  story: vo,
  parameters: Po,
  initialArgs: Co,
  argTypes: So,
  ...wo
} = {}) {
  return wo;
}
s(io, "sanitizeStoryContextUpdate");
function Lr(Kt, uo) {
  let ho = {}, go = /* @__PURE__ */ s((vo) => (Po) => {
    if (!ho.value)
      throw new Error("Decorated function called without init");
    return ho.value = {
      ...ho.value,
      ...io(Po)
    }, vo(ho.value);
  }, "bindWithContext"), bo = uo.reduce(
    (vo, Po) => so(vo, Po, go),
    Kt
  );
  return (vo) => (ho.value = vo, bo(vo));
}
s(Lr, "defaultDecorateStory");
var M = /* @__PURE__ */ s((...Kt) => {
  let uo = {}, ho = Kt.filter(Boolean), go = ho.reduce((bo, vo) => (Object.entries(vo).forEach(([Po, Co]) => {
    let So = bo[Po];
    Array.isArray(Co) || typeof So > "u" ? bo[Po] = Co : k(Co) && k(So) ? uo[Po] = !0 : typeof Co < "u" && (bo[Po] = Co);
  }), bo), {});
  return Object.keys(uo).forEach((bo) => {
    let vo = ho.filter(Boolean).map((Po) => Po[bo]).filter((Po) => typeof Po < "u");
    vo.every((Po) => k(Po)) ? go[bo] = M(...vo) : go[bo] = vo[vo.length - 1];
  }), go;
}, "combineParameters");
function Ce(Kt, uo, ho) {
  let { moduleExport: go, id: bo, name: vo } = Kt || {}, Po = ao(
    Kt,
    uo,
    ho
  ), Co = /* @__PURE__ */ s(async (No) => {
    let Jo = {};
    for (let ti of [
      ..."__STORYBOOK_TEST_LOADERS__" in v && Array.isArray(v.__STORYBOOK_TEST_LOADERS__) ? [v.__STORYBOOK_TEST_LOADERS__] : [],
      P(ho.loaders),
      P(uo.loaders),
      P(Kt.loaders)
    ]) {
      if (No.abortSignal.aborted)
        return Jo;
      let oi = await Promise.all(ti.map((Qo) => Qo(No)));
      Object.assign(Jo, ...oi);
    }
    return Jo;
  }, "applyLoaders"), So = /* @__PURE__ */ s(async (No) => {
    let Jo = new Array();
    for (let ti of [
      ...P(ho.beforeEach),
      ...P(uo.beforeEach),
      ...P(Kt.beforeEach)
    ]) {
      if (No.abortSignal.aborted)
        return Jo;
      let oi = await ti(No);
      oi && Jo.push(oi);
    }
    return Jo;
  }, "applyBeforeEach"), wo = /* @__PURE__ */ s((No) => No.originalStoryFn(No.args, No), "undecoratedStoryFn"), { applyDecorators: Eo = Lr, runStep: Ro } = ho, _o = [
    ...P(Kt == null ? void 0 : Kt.decorators),
    ...P(uo == null ? void 0 : uo.decorators),
    ...P(ho == null ? void 0 : ho.decorators)
  ], Io = (Kt == null ? void 0 : Kt.userStoryFn) || (Kt == null ? void 0 : Kt.render) || uo.render || ho.render, Ao = br(Eo)(wo, _o), Oo = /* @__PURE__ */ s((No) => Ao(No), "unboundStoryFn"), jo = (Kt == null ? void 0 : Kt.play) ?? (uo == null ? void 0 : uo.play), Do = no(jo);
  if (!Io && !Do)
    throw new q$1({ id: bo });
  let Lo = /* @__PURE__ */ s((No) => async () => (await No.renderToCanvas(), No.canvas), "defaultMount"), ko = Kt.mount ?? uo.mount ?? ho.mount ?? Lo, Ko = ho.testingLibraryRender;
  return {
    storyGlobals: {},
    ...Po,
    moduleExport: go,
    id: bo,
    name: vo,
    story: vo,
    originalStoryFn: Io,
    undecoratedStoryFn: wo,
    unboundStoryFn: Oo,
    applyLoaders: Co,
    applyBeforeEach: So,
    playFunction: jo,
    runStep: Ro,
    mount: ko,
    testingLibraryRender: Ko,
    renderToCanvas: ho.renderToCanvas,
    usesMount: Do
  };
}
s(Ce, "prepareStory");
function Nr(Kt, uo, ho) {
  return {
    ...ao(void 0, Kt, uo),
    moduleExport: ho
  };
}
s(Nr, "prepareMeta");
function ao(Kt, uo, ho) {
  var Do;
  let go = ["dev", "test"], bo = ((Do = v.DOCS_OPTIONS) == null ? void 0 : Do.autodocs) === !0 ? ["autodocs"] : [], vo = z(
    ...go,
    ...bo,
    ...ho.tags ?? [],
    ...uo.tags ?? [],
    ...(Kt == null ? void 0 : Kt.tags) ?? []
  ), Po = M(
    ho.parameters,
    uo.parameters,
    Kt == null ? void 0 : Kt.parameters
  ), { argTypesEnhancers: Co = [], argsEnhancers: So = [] } = ho, wo = M(
    ho.argTypes,
    uo.argTypes,
    Kt == null ? void 0 : Kt.argTypes
  );
  if (Kt) {
    let Lo = (Kt == null ? void 0 : Kt.userStoryFn) || (Kt == null ? void 0 : Kt.render) || uo.render || ho.render;
    Po.__isArgsStory = Lo && Lo.length > 0;
  }
  let Eo = {
    ...ho.args,
    ...uo.args,
    ...Kt == null ? void 0 : Kt.args
  }, Ro = {
    ...uo.globals,
    ...Kt == null ? void 0 : Kt.globals
  }, _o = {
    componentId: uo.id,
    title: uo.title,
    kind: uo.title,
    // Back compat
    id: (Kt == null ? void 0 : Kt.id) || uo.id,
    // if there's no story name, we create a fake one since enhancers expect a name
    name: (Kt == null ? void 0 : Kt.name) || "__meta",
    story: (Kt == null ? void 0 : Kt.name) || "__meta",
    // Back compat
    component: uo.component,
    subcomponents: uo.subcomponents,
    tags: vo,
    parameters: Po,
    initialArgs: Eo,
    argTypes: wo,
    storyGlobals: Ro
  };
  _o.argTypes = Co.reduce(
    (Lo, ko) => ko({ ..._o, argTypes: Lo }),
    _o.argTypes
  );
  let Io = { ...Eo };
  _o.initialArgs = So.reduce(
    (Lo, ko) => ({
      ...Lo,
      ...ko({
        ..._o,
        initialArgs: Lo
      })
    }),
    Io
  );
  let { name: Ao, story: Oo, ...jo } = _o;
  return jo;
}
s(ao, "preparePartialAnnotations");
function $e(Kt) {
  var vo;
  let { args: uo } = Kt, ho = {
    ...Kt,
    allArgs: void 0,
    argsByTarget: void 0
  };
  if ((vo = v.FEATURES) != null && vo.argTypeTargetsV7) {
    let Po = Qt(Kt);
    ho = {
      ...Kt,
      allArgs: Kt.args,
      argsByTarget: Po,
      args: Po[kr] || {}
    };
  }
  let go = Object.entries(ho.args).reduce((Po, [Co, So]) => {
    var Eo;
    if (!((Eo = ho.argTypes[Co]) != null && Eo.mapping))
      return Po[Co] = So, Po;
    let wo = /* @__PURE__ */ s((Ro) => {
      let _o = ho.argTypes[Co].mapping;
      return _o && Ro in _o ? _o[Ro] : Ro;
    }, "mappingFn");
    return Po[Co] = Array.isArray(So) ? So.map(wo) : wo(So), Po;
  }, {}), bo = Object.entries(go).reduce((Po, [Co, So]) => {
    let wo = ho.argTypes[Co] || {};
    return P$1(wo, go, ho.globals) && (Po[Co] = So), Po;
  }, {});
  return { ...ho, unmappedArgs: uo, args: bo };
}
s($e, "prepareContext");
var qr = /* @__PURE__ */ s((Kt, uo, ho) => {
  let go = typeof Kt;
  switch (go) {
    case "boolean":
    case "string":
    case "number":
    case "function":
    case "symbol":
      return { name: go };
  }
  return Kt ? ho.has(Kt) ? (s$2.warn(F`
        We've detected a cycle in arg '${uo}'. Args should be JSON-serializable.

        Consider using the mapping feature or fully custom args:
        - Mapping: https://storybook.js.org/docs/writing-stories/args#mapping-to-complex-arg-values
        - Custom args: https://storybook.js.org/docs/essentials/controls#fully-custom-args
      `), { name: "other", value: "cyclic object" }) : (ho.add(Kt), Array.isArray(Kt) ? { name: "array", value: Kt.length > 0 ? qr(Kt[0], uo, new Set(
    ho
  )) : { name: "other", value: "unknown" } } : { name: "object", value: L(Kt, (bo) => qr(bo, uo, new Set(ho))) }) : { name: "object", value: {} };
}, "inferType"), Br = /* @__PURE__ */ s((Kt) => {
  let { id: uo, argTypes: ho = {}, initialArgs: go = {} } = Kt, bo = L(go, (Po, Co) => ({
    name: Co,
    type: qr(Po, `${uo}.${Co}`, /* @__PURE__ */ new Set())
  })), vo = L(ho, (Po, Co) => ({
    name: Co
  }));
  return M(bo, vo, ho);
}, "inferArgTypes");
Br.secondPass = !0;
var lo = /* @__PURE__ */ s((Kt, uo) => Array.isArray(uo) ? uo.includes(Kt) : Kt.match(uo), "matches"), Ye = /* @__PURE__ */ s((Kt, uo, ho) => !uo && !ho ? Kt : Kt && Er(Kt, (go, bo) => {
  let vo = go.name || bo.toString();
  return !!(!uo || lo(vo, uo)) && (!ho || !lo(vo, ho));
}), "filterArgTypes"), Es = /* @__PURE__ */ s((Kt, uo, ho) => {
  let { type: go, options: bo } = Kt;
  if (go) {
    if (ho.color && ho.color.test(uo)) {
      let vo = go.name;
      if (vo === "string")
        return { control: { type: "color" } };
      vo !== "enum" && s$2.warn(
        `Addon controls: Control of type color only supports string, received "${vo}" instead`
      );
    }
    if (ho.date && ho.date.test(uo))
      return { control: { type: "date" } };
    switch (go.name) {
      case "array":
        return { control: { type: "object" } };
      case "boolean":
        return { control: { type: "boolean" } };
      case "string":
        return { control: { type: "text" } };
      case "number":
        return { control: { type: "number" } };
      case "enum": {
        let { value: vo } = go;
        return { control: { type: (vo == null ? void 0 : vo.length) <= 5 ? "radio" : "select" }, options: vo };
      }
      case "function":
      case "symbol":
        return null;
      default:
        return { control: { type: bo ? "select" : "object" } };
    }
  }
}, "inferControl"), Pe = /* @__PURE__ */ s((Kt) => {
  let {
    argTypes: uo,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    parameters: { __isArgsStory: ho, controls: { include: go = null, exclude: bo = null, matchers: vo = {} } = {} }
  } = Kt;
  if (!ho)
    return uo;
  let Po = Ye(uo, go, bo), Co = L(Po, (So, wo) => (So == null ? void 0 : So.type) && Es(So, wo.toString(), vo));
  return M(Co, Po);
}, "inferControls");
Pe.secondPass = !0;
function Fe({
  argTypes: Kt,
  globalTypes: uo,
  argTypesEnhancers: ho,
  decorators: go,
  loaders: bo,
  beforeEach: vo,
  globals: Po,
  initialGlobals: Co,
  ...So
}) {
  return Po && Object.keys(Po).length > 0 && m$2(F`
      The preview.js 'globals' field is deprecated and will be removed in Storybook 9.0.
      Please use 'initialGlobals' instead. Learn more:

      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#previewjs-globals-renamed-to-initialglobals
    `), {
    ...Kt && { argTypes: te(Kt) },
    ...uo && { globalTypes: te(uo) },
    decorators: P(go),
    loaders: P(bo),
    beforeEach: P(vo),
    argTypesEnhancers: [
      ...ho || [],
      Br,
      // inferControls technically should only run if the user is using the controls addon,
      // and so should be added by a preset there. However, as it seems some code relies on controls
      // annotations (in particular the angular implementation's `cleanArgsDecorator`), for backwards
      // compatibility reasons, we will leave this in the store until 7.0
      Pe
    ],
    initialGlobals: M(Co, Po),
    ...So
  };
}
s(Fe, "normalizeProjectAnnotations");
var co = /* @__PURE__ */ s((Kt) => async () => {
  let uo = [];
  for (let ho of Kt) {
    let go = await ho();
    go && uo.unshift(go);
  }
  return async () => {
    for (let ho of uo)
      await ho();
  };
}, "composeBeforeAllHooks");
function zr(Kt) {
  return async (uo, ho, go) => {
    await Kt.reduceRight(
      (bo, vo) => async () => vo(uo, bo, go),
      async () => ho(go)
    )();
  };
}
s(zr, "composeStepRunners");
function Oe(Kt, uo) {
  return Kt.map((ho) => {
    var go;
    return ((go = ho.default) == null ? void 0 : go[uo]) ?? ho[uo];
  }).filter(Boolean);
}
s(Oe, "getField");
function oe(Kt, uo, ho = {}) {
  return Oe(Kt, uo).reduce((go, bo) => {
    let vo = P(bo);
    return ho.reverseFileOrder ? [...vo, ...go] : [...go, ...vo];
  }, []);
}
s(oe, "getArrayField");
function Ie(Kt, uo) {
  return Object.assign({}, ...Oe(Kt, uo));
}
s(Ie, "getObjectField");
function ue(Kt, uo) {
  return Oe(Kt, uo).pop();
}
s(ue, "getSingletonField");
function fe(Kt) {
  var bo;
  let uo = oe(Kt, "argTypesEnhancers"), ho = Oe(Kt, "runStep"), go = oe(Kt, "beforeAll");
  return {
    parameters: M(...Oe(Kt, "parameters")),
    decorators: oe(Kt, "decorators", {
      reverseFileOrder: !(((bo = v.FEATURES) == null ? void 0 : bo.legacyDecoratorFileOrder) ?? !1)
    }),
    args: Ie(Kt, "args"),
    argsEnhancers: oe(Kt, "argsEnhancers"),
    argTypes: Ie(Kt, "argTypes"),
    argTypesEnhancers: [
      ...uo.filter((vo) => !vo.secondPass),
      ...uo.filter((vo) => vo.secondPass)
    ],
    globals: Ie(Kt, "globals"),
    initialGlobals: Ie(Kt, "initialGlobals"),
    globalTypes: Ie(Kt, "globalTypes"),
    loaders: oe(Kt, "loaders"),
    beforeAll: co(go),
    beforeEach: oe(Kt, "beforeEach"),
    render: ue(Kt, "render"),
    renderToCanvas: ue(Kt, "renderToCanvas"),
    renderToDOM: ue(Kt, "renderToDOM"),
    // deprecated
    applyDecorators: ue(Kt, "applyDecorators"),
    runStep: zr(ho),
    tags: oe(Kt, "tags"),
    mount: ue(Kt, "mount"),
    testingLibraryRender: ue(Kt, "testingLibraryRender")
  };
}
s(fe, "composeConfigs");
function Ps(Kt) {
  globalThis.defaultProjectAnnotations = Kt;
}
s(Ps, "setDefaultProjectAnnotations");
var Fs = "ComposedStory", Is = "Unnamed Story";
function Os(Kt) {
  return Kt ? fe([Kt]) : {};
}
s(Os, "extractAnnotation");
function Ds(Kt) {
  let uo = Array.isArray(Kt) ? Kt : [Kt];
  return globalThis.globalProjectAnnotations = fe(uo.map(Os)), fe([
    globalThis.defaultProjectAnnotations ?? {},
    globalThis.globalProjectAnnotations ?? {}
  ]);
}
s(Ds, "setProjectAnnotations");
var $ = [];
function po(Kt, uo, ho, go, bo) {
  var jo;
  if (Kt === void 0)
    throw new Error("Expected a story but received undefined.");
  uo.title = uo.title ?? Fs;
  let vo = We(uo), Po = bo || Kt.storyName || ((jo = Kt.story) == null ? void 0 : jo.name) || Kt.name || Is, Co = ve(
    Po,
    Kt,
    vo
  ), So = Fe(
    fe([
      go && Object.keys(go).length > 0 ? go : globalThis.defaultProjectAnnotations ?? {},
      globalThis.globalProjectAnnotations ?? {},
      ho ?? {}
    ])
  ), wo = Ce(
    Co,
    vo,
    So
  ), Eo = {
    // TODO: remove loading from globalTypes in 9.0
    ...Ve(So.globalTypes),
    ...So.initialGlobals,
    ...wo.storyGlobals
  }, Ro = /* @__PURE__ */ s(() => {
    let Do = $e({
      hooks: new ee(),
      globals: Eo,
      args: { ...wo.initialArgs },
      viewMode: "story",
      loaded: {},
      abortSignal: new AbortController().signal,
      step: /* @__PURE__ */ s((Lo, ko) => wo.runStep(Lo, ko, Do), "step"),
      canvasElement: null,
      canvas: {},
      globalTypes: So.globalTypes,
      ...wo,
      context: null,
      mount: null
    });
    return Do.context = Do, wo.renderToCanvas && (Do.renderToCanvas = async () => {
      var ko;
      let Lo = await ((ko = wo.renderToCanvas) == null ? void 0 : ko.call(
        wo,
        {
          componentId: wo.componentId,
          title: wo.title,
          id: wo.id,
          name: wo.name,
          tags: wo.tags,
          showMain: /* @__PURE__ */ s(() => {
          }, "showMain"),
          showError: /* @__PURE__ */ s((Ko) => {
            throw new Error(`${Ko.title}
${Ko.description}`);
          }, "showError"),
          showException: /* @__PURE__ */ s((Ko) => {
            throw Ko;
          }, "showException"),
          forceRemount: !0,
          storyContext: Do,
          storyFn: /* @__PURE__ */ s(() => wo.unboundStoryFn(Do), "storyFn"),
          unboundStoryFn: wo.unboundStoryFn
        },
        Do.canvasElement
      ));
      Lo && $.push(Lo);
    }), Do.mount = wo.mount(Do), Do;
  }, "initializeContext"), _o, Io = /* @__PURE__ */ s(async (Do) => {
    var ko;
    let Lo = Ro();
    return Lo.canvasElement ?? (Lo.canvasElement = (ko = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : ko.body), _o && (Lo.loaded = _o.loaded), Object.assign(Lo, Do), wo.playFunction(Lo);
  }, "play"), Ao = /* @__PURE__ */ s((Do) => {
    let Lo = Ro();
    return Object.assign(Lo, Do), _s(wo, Lo);
  }, "run"), Oo = wo.playFunction ? Io : void 0;
  return Object.assign(
    /* @__PURE__ */ s(function(Do) {
      let Lo = Ro();
      return _o && (Lo.loaded = _o.loaded), Lo.args = {
        ...Lo.initialArgs,
        ...Do
      }, wo.unboundStoryFn(Lo);
    }, "storyFn"),
    {
      id: wo.id,
      storyName: Po,
      load: /* @__PURE__ */ s(async () => {
        for (let Lo of [...$].reverse())
          await Lo();
        $.length = 0;
        let Do = Ro();
        Do.loaded = await wo.applyLoaders(Do), $.push(...(await wo.applyBeforeEach(Do)).filter(Boolean)), _o = Do;
      }, "load"),
      globals: Eo,
      args: wo.initialArgs,
      parameters: wo.parameters,
      argTypes: wo.argTypes,
      play: Oo,
      run: Ao,
      tags: wo.tags
    }
  );
}
s(po, "composeStory");
var ks = /* @__PURE__ */ s((Kt, uo, ho, go) => po(Kt, uo, ho, {}, go), "defaultComposeStory");
function js(Kt, uo, ho = ks) {
  let { default: go, __esModule: bo, __namedExportsOrder: vo, ...Po } = Kt;
  return Object.entries(Po).reduce((Co, [So, wo]) => M$1(So, go) ? Object.assign(Co, {
    [So]: ho(
      wo,
      go,
      uo,
      So
    )
  }) : Co, {});
}
s(js, "composeStories");
function Ms(Kt) {
  return Kt.extend({
    mount: /* @__PURE__ */ s(async ({ mount: uo, page: ho }, go) => {
      await go(async (bo, ...vo) => {
        if (!("__pw_type" in bo) || "__pw_type" in bo && bo.__pw_type !== "jsx")
          throw new Error(F`
              Portable stories in Playwright CT only work when referencing JSX elements.
              Please use JSX format for your components such as:

              instead of:
              await mount(MyComponent, { props: { foo: 'bar' } })

              do:
              await mount(<MyComponent foo="bar"/>)

              More info: https://storybook.js.org/docs/api/portable-stories-playwright
            `);
        await ho.evaluate(async (Co) => {
          var wo, Eo, Ro;
          let So = await ((wo = globalThis.__pwUnwrapObject) == null ? void 0 : wo.call(globalThis, Co));
          return (Ro = (Eo = "__pw_type" in So ? So.type : So) == null ? void 0 : Eo.load) == null ? void 0 : Ro.call(Eo);
        }, bo);
        let Po = await uo(bo, ...vo);
        return await ho.evaluate(async (Co) => {
          var Ro, _o;
          let So = await ((Ro = globalThis.__pwUnwrapObject) == null ? void 0 : Ro.call(globalThis, Co)), wo = "__pw_type" in So ? So.type : So, Eo = document.querySelector("#root");
          return (_o = wo == null ? void 0 : wo.play) == null ? void 0 : _o.call(wo, { canvasElement: Eo });
        }, bo), Po;
      });
    }, "mount")
  });
}
s(Ms, "createPlaywrightTest");
async function _s(Kt, uo) {
  var bo, vo;
  for (let Po of [...$].reverse())
    await Po();
  if ($.length = 0, !uo.canvasElement) {
    let Po = document.createElement("div");
    (vo = (bo = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : bo.body) == null || vo.appendChild(Po), uo.canvasElement = Po, $.push(() => {
      var Co, So, wo, Eo;
      (So = (Co = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : Co.body) != null && So.contains(Po) && ((Eo = (wo = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : wo.body) == null || Eo.removeChild(Po));
    });
  }
  if (uo.loaded = await Kt.applyLoaders(uo), uo.abortSignal.aborted)
    return;
  $.push(...(await Kt.applyBeforeEach(uo)).filter(Boolean));
  let ho = Kt.playFunction, go = Kt.usesMount;
  go || await uo.mount(), !uo.abortSignal.aborted && ho && (go || (uo.mount = async () => {
    throw new J({ playFunction: ho.toString() });
  }), await ho(uo));
}
s(_s, "runStory");
function fo(Kt, uo) {
  return Rr(wr(Kt, uo), (ho) => ho === void 0);
}
s(fo, "picky");
var yo = 1e3, qs = 1e4, Gr = class {
  constructor(uo, ho, go) {
    this.importFn = ho, this.getStoriesJsonData = /* @__PURE__ */ s(() => {
      let Po = this.getSetStoriesPayload(), Co = ["fileName", "docsOnly", "framework", "__id", "__isArgsStory"];
      return {
        v: 3,
        stories: L(Po.stories, (So) => {
          let { importPath: wo } = this.storyIndex.entries[So.id];
          return {
            ...fo(So, ["id", "name", "title"]),
            importPath: wo,
            // These 3 fields were going to be dropped in v7, but instead we will keep them for the
            // 7.x cycle so that v7 Storybooks can be composed successfully in v6 Storybook.
            // In v8 we will (likely) completely drop support for `extract` and `getStoriesJsonData`
            kind: So.title,
            story: So.name,
            parameters: {
              ...fo(So.parameters, Co),
              fileName: wo
            }
          };
        })
      };
    }, "getStoriesJsonData"), this.storyIndex = new He(uo), this.projectAnnotations = Fe(go);
    let { initialGlobals: bo, globalTypes: vo } = this.projectAnnotations;
    this.args = new Ge(), this.userGlobals = new Ue({ globals: bo, globalTypes: vo }), this.hooks = {}, this.cleanupCallbacks = {}, this.processCSFFileWithCache = (0, Ke.default)(yo)(to), this.prepareMetaWithCache = (0, Ke.default)(yo)(Nr), this.prepareStoryWithCache = (0, Ke.default)(qs)(Ce);
  }
  setProjectAnnotations(uo) {
    this.projectAnnotations = Fe(uo);
    let { initialGlobals: ho, globalTypes: go } = uo;
    this.userGlobals.set({ globals: ho, globalTypes: go });
  }
  // This means that one of the CSF files has changed.
  // If the `importFn` has changed, we will invalidate both caches.
  // If the `storyIndex` data has changed, we may or may not invalidate the caches, depending
  // on whether we've loaded the relevant files yet.
  async onStoriesChanged({
    importFn: uo,
    storyIndex: ho
  }) {
    uo && (this.importFn = uo), ho && (this.storyIndex.entries = ho.entries), this.cachedCSFFiles && await this.cacheAllCSFFiles();
  }
  // Get an entry from the index, waiting on initialization if necessary
  async storyIdToEntry(uo) {
    return this.storyIndex.storyIdToEntry(uo);
  }
  // To load a single CSF file to service a story we need to look up the importPath in the index
  async loadCSFFileByStoryId(uo) {
    let { importPath: ho, title: go } = this.storyIndex.storyIdToEntry(uo), bo = await this.importFn(ho);
    return this.processCSFFileWithCache(bo, ho, go);
  }
  async loadAllCSFFiles() {
    let uo = {};
    return Object.entries(this.storyIndex.entries).forEach(([ho, { importPath: go }]) => {
      uo[go] = ho;
    }), (await Promise.all(
      Object.entries(uo).map(async ([ho, go]) => ({
        importPath: ho,
        csfFile: await this.loadCSFFileByStoryId(go)
      }))
    )).reduce(
      (ho, { importPath: go, csfFile: bo }) => (ho[go] = bo, ho),
      {}
    );
  }
  async cacheAllCSFFiles() {
    this.cachedCSFFiles = await this.loadAllCSFFiles();
  }
  preparedMetaFromCSFFile({ csfFile: uo }) {
    let ho = uo.meta;
    return this.prepareMetaWithCache(
      ho,
      this.projectAnnotations,
      uo.moduleExports.default
    );
  }
  // Load the CSF file for a story and prepare the story from it and the project annotations.
  async loadStory({ storyId: uo }) {
    let ho = await this.loadCSFFileByStoryId(uo);
    return this.storyFromCSFFile({ storyId: uo, csfFile: ho });
  }
  // This function is synchronous for convenience -- often times if you have a CSF file already
  // it is easier not to have to await `loadStory`.
  storyFromCSFFile({
    storyId: uo,
    csfFile: ho
  }) {
    let go = ho.stories[uo];
    if (!go)
      throw new X$1({ storyId: uo });
    let bo = ho.meta, vo = this.prepareStoryWithCache(
      go,
      bo,
      this.projectAnnotations
    );
    return this.args.setInitial(vo), this.hooks[vo.id] = this.hooks[vo.id] || new ee(), vo;
  }
  // If we have a CSF file we can get all the stories from it synchronously
  componentStoriesFromCSFFile({
    csfFile: uo
  }) {
    return Object.keys(this.storyIndex.entries).filter((ho) => !!uo.stories[ho]).map((ho) => this.storyFromCSFFile({ storyId: ho, csfFile: uo }));
  }
  async loadEntry(uo) {
    let ho = await this.storyIdToEntry(uo), go = ho.type === "docs" ? ho.storiesImports : [], [bo, ...vo] = await Promise.all([
      this.importFn(ho.importPath),
      ...go.map((Po) => {
        let Co = this.storyIndex.importPathToEntry(Po);
        return this.loadCSFFileByStoryId(Co.id);
      })
    ]);
    return { entryExports: bo, csfFiles: vo };
  }
  // A prepared story does not include args, globals or hooks. These are stored in the story store
  // and updated separtely to the (immutable) story.
  getStoryContext(uo, { forceInitialArgs: ho = !1 } = {}) {
    let go = this.userGlobals.get(), { initialGlobals: bo } = this.userGlobals;
    return $e({
      ...uo,
      args: ho ? uo.initialArgs : this.args.get(uo.id),
      initialGlobals: bo,
      globalTypes: this.projectAnnotations.globalTypes,
      userGlobals: go,
      globals: {
        ...go,
        ...uo.storyGlobals
      },
      hooks: this.hooks[uo.id]
    });
  }
  addCleanupCallbacks(uo, ho) {
    this.cleanupCallbacks[uo.id] = ho;
  }
  async cleanupStory(uo) {
    this.hooks[uo.id].clean();
    let ho = this.cleanupCallbacks[uo.id];
    if (ho)
      for (let go of [...ho].reverse())
        await go();
    delete this.cleanupCallbacks[uo.id];
  }
  extract(uo = { includeDocsOnly: !1 }) {
    let { cachedCSFFiles: ho } = this;
    if (!ho)
      throw new L$1();
    return Object.entries(this.storyIndex.entries).reduce(
      (go, [bo, { type: vo, importPath: Po }]) => {
        if (vo === "docs")
          return go;
        let Co = ho[Po], So = this.storyFromCSFFile({ storyId: bo, csfFile: Co });
        return !uo.includeDocsOnly && So.parameters.docsOnly || (go[bo] = Object.entries(So).reduce(
          (wo, [Eo, Ro]) => Eo === "moduleExport" || typeof Ro == "function" ? wo : Array.isArray(Ro) ? Object.assign(wo, { [Eo]: Ro.slice().sort() }) : Object.assign(wo, { [Eo]: Ro }),
          { args: So.initialArgs }
        )), go;
      },
      {}
    );
  }
  // TODO: Remove in 9.0
  getSetStoriesPayload() {
    let uo = this.extract({ includeDocsOnly: !0 }), ho = Object.values(uo).reduce(
      (go, { title: bo }) => (go[bo] = {}, go),
      {}
    );
    return {
      v: 2,
      globals: this.userGlobals.get(),
      globalParameters: {},
      kindParameters: ho,
      stories: uo
    };
  }
  raw() {
    return m$2(
      "StoryStore.raw() is deprecated and will be removed in 9.0, please use extract() instead"
    ), Object.values(this.extract()).map(({ id: uo }) => this.fromId(uo)).filter(Boolean);
  }
  fromId(uo) {
    if (m$2(
      "StoryStore.fromId() is deprecated and will be removed in 9.0, please use loadStory() instead"
    ), !this.cachedCSFFiles)
      throw new Error("Cannot call fromId/raw() unless you call cacheAllCSFFiles() first.");
    let ho;
    try {
      ({ importPath: ho } = this.storyIndex.storyIdToEntry(uo));
    } catch {
      return null;
    }
    let go = this.cachedCSFFiles[ho], bo = this.storyFromCSFFile({ storyId: uo, csfFile: go });
    return {
      ...bo,
      storyFn: /* @__PURE__ */ s((vo) => {
        let Po = {
          ...this.getStoryContext(bo),
          abortSignal: new AbortController().signal,
          canvasElement: null,
          loaded: {},
          step: /* @__PURE__ */ s((Co, So) => bo.runStep(Co, So, Po), "step"),
          context: null,
          mount: null,
          canvas: {},
          viewMode: "story"
        };
        return bo.unboundStoryFn({ ...Po, ...vo });
      }, "storyFn")
    };
  }
};
s(Gr, "StoryStore");
var ye = Gr;
function Vr(Kt) {
  return Kt.startsWith("\\\\?\\") ? Kt : Kt.replace(/\\/g, "/");
}
s(Vr, "slash");
function mo(Kt) {
  return Kt.flatMap((uo) => uo.split("/")).filter(Boolean).join("/");
}
s(mo, "pathJoin");
var Y = new Error("prepareAborted"), { AbortController: To } = globalThis;
function xo(Kt) {
  try {
    let { name: uo = "Error", message: ho = String(Kt), stack: go } = Kt;
    return { name: uo, message: ho, stack: go };
  } catch {
    return { name: "Error", message: String(Kt) };
  }
}
s(xo, "serializeError");
var Ur = class {
  constructor(uo, ho, go, bo, vo, Po, Co = { autoplay: !0, forceInitialArgs: !1 }, So) {
    this.channel = uo, this.store = ho, this.renderToScreen = go, this.callbacks = bo, this.id = vo, this.viewMode = Po, this.renderOptions = Co, this.type = "story", this.notYetRendered = !0, this.rerenderEnqueued = !1, this.disableKeyListeners = !1, this.teardownRender = /* @__PURE__ */ s(() => {
    }, "teardownRender"), this.torndown = !1, this.abortController = new To(), So && (this.story = So, this.phase = "preparing");
  }
  async runPhase(uo, ho, go) {
    this.phase = ho, this.channel.emit(B$2, { newPhase: this.phase, storyId: this.id }), go && (await go(), this.checkIfAborted(uo));
  }
  checkIfAborted(uo) {
    return uo.aborted ? (this.phase = "aborted", this.channel.emit(B$2, { newPhase: this.phase, storyId: this.id }), !0) : !1;
  }
  async prepare() {
    if (await this.runPhase(this.abortController.signal, "preparing", async () => {
      this.story = await this.store.loadStory({ storyId: this.id });
    }), this.abortController.signal.aborted)
      throw await this.store.cleanupStory(this.story), Y;
  }
  // The two story "renders" are equal and have both loaded the same story
  isEqual(uo) {
    return !!(this.id === uo.id && this.story && this.story === uo.story);
  }
  isPreparing() {
    return ["preparing"].includes(this.phase);
  }
  isPending() {
    return ["loading", "beforeEach", "rendering", "playing"].includes(this.phase);
  }
  async renderToElement(uo) {
    return this.canvasElement = uo, this.render({ initial: !0, forceRemount: !0 });
  }
  storyContext() {
    if (!this.story)
      throw new Error("Cannot call storyContext before preparing");
    let { forceInitialArgs: uo } = this.renderOptions;
    return this.store.getStoryContext(this.story, { forceInitialArgs: uo });
  }
  async render({
    initial: uo = !1,
    forceRemount: ho = !1
  } = {}) {
    var Lo, ko, Ko, No;
    let { canvasElement: go } = this;
    if (!this.story)
      throw new Error("cannot render when not prepared");
    let bo = this.story;
    if (!go)
      throw new Error("cannot render when canvasElement is unset");
    let {
      id: vo,
      componentId: Po,
      title: Co,
      name: So,
      tags: wo,
      applyLoaders: Eo,
      applyBeforeEach: Ro,
      unboundStoryFn: _o,
      playFunction: Io,
      runStep: Ao
    } = bo;
    ho && !uo && (this.cancelRender(), this.abortController = new To());
    let Oo = this.abortController.signal, jo = !1, Do = bo.usesMount;
    try {
      let Jo = {
        ...this.storyContext(),
        viewMode: this.viewMode,
        abortSignal: Oo,
        canvasElement: go,
        loaded: {},
        step: /* @__PURE__ */ s((ii, ai) => Ao(ii, ai, Jo), "step"),
        context: null,
        canvas: {},
        renderToCanvas: /* @__PURE__ */ s(async () => {
          let ii = await this.renderToScreen(ti, go);
          this.teardownRender = ii || (() => {
          }), jo = !0;
        }, "renderToCanvas"),
        // The story provides (set in a renderer) a mount function that is a higher order function
        // (context) => (...args) => Canvas
        //
        // Before assigning it to the context, we resolve the context dependency,
        // so that a user can just call it as await mount(...args) in their play function.
        mount: /* @__PURE__ */ s(async (...ii) => {
          var ri, ni;
          (ni = (ri = this.callbacks).showStoryDuringRender) == null || ni.call(ri);
          let ai = null;
          return await this.runPhase(Oo, "rendering", async () => {
            ai = await bo.mount(Jo)(...ii);
          }), Do && await this.runPhase(Oo, "playing"), ai;
        }, "mount")
      };
      Jo.context = Jo;
      let ti = {
        componentId: Po,
        title: Co,
        kind: Co,
        id: vo,
        name: So,
        story: So,
        tags: wo,
        ...this.callbacks,
        showError: /* @__PURE__ */ s((ii) => (this.phase = "errored", this.callbacks.showError(ii)), "showError"),
        showException: /* @__PURE__ */ s((ii) => (this.phase = "errored", this.callbacks.showException(ii)), "showException"),
        forceRemount: ho || this.notYetRendered,
        storyContext: Jo,
        storyFn: /* @__PURE__ */ s(() => _o(Jo), "storyFn"),
        unboundStoryFn: _o
      };
      if (await this.runPhase(Oo, "loading", async () => {
        Jo.loaded = await Eo(Jo);
      }), Oo.aborted)
        return;
      let oi = await Ro(Jo);
      if (this.store.addCleanupCallbacks(bo, oi), this.checkIfAborted(Oo) || (!jo && !Do && await Jo.mount(), this.notYetRendered = !1, Oo.aborted))
        return;
      let Qo = ((ko = (Lo = this.story.parameters) == null ? void 0 : Lo.test) == null ? void 0 : ko.dangerouslyIgnoreUnhandledErrors) === !0, Zo = /* @__PURE__ */ new Set(), ei = /* @__PURE__ */ s((ii) => Zo.add("error" in ii ? ii.error : ii.reason), "onError");
      if (this.renderOptions.autoplay && ho && Io && this.phase !== "errored") {
        window.addEventListener("error", ei), window.addEventListener("unhandledrejection", ei), this.disableKeyListeners = !0;
        try {
          if (Do ? await Io(Jo) : (Jo.mount = async () => {
            throw new J({ playFunction: Io.toString() });
          }, await this.runPhase(Oo, "playing", async () => Io(Jo))), !jo)
            throw new z$1();
          this.checkIfAborted(Oo), !Qo && Zo.size > 0 ? await this.runPhase(Oo, "errored") : await this.runPhase(Oo, "played");
        } catch (ii) {
          if ((No = (Ko = this.callbacks).showStoryDuringRender) == null || No.call(Ko), await this.runPhase(Oo, "errored", async () => {
            this.channel.emit(a, xo(ii));
          }), this.story.parameters.throwPlayFunctionExceptions !== !1)
            throw ii;
          console.error(ii);
        }
        if (!Qo && Zo.size > 0 && this.channel.emit(
          Y$2,
          Array.from(Zo).map(xo)
        ), this.disableKeyListeners = !1, window.removeEventListener("unhandledrejection", ei), window.removeEventListener("error", ei), Oo.aborted)
          return;
      }
      await this.runPhase(
        Oo,
        "completed",
        async () => this.channel.emit(X$2, vo)
      );
    } catch (Jo) {
      this.phase = "errored", this.callbacks.showException(Jo);
    }
    this.rerenderEnqueued && (this.rerenderEnqueued = !1, this.render());
  }
  /**
   * Rerender the story. If the story is currently pending (loading/rendering), the rerender will be
   * enqueued, and will be executed after the current render is completed. Rerendering while playing
   * will not be enqueued, and will be executed immediately, to support rendering args changes while
   * playing.
   */
  async rerender() {
    if (this.isPending() && this.phase !== "playing")
      this.rerenderEnqueued = !0;
    else
      return this.render();
  }
  async remount() {
    return await this.teardown(), this.render({ forceRemount: !0 });
  }
  // If the story is torn down (either a new story is rendered or the docs page removes it)
  // we need to consider the fact that the initial render may not be finished
  // (possibly the loaders or the play function are still running). We use the controller
  // as a method to abort them, ASAP, but this is not foolproof as we cannot control what
  // happens inside the user's code.
  cancelRender() {
    var uo;
    (uo = this.abortController) == null || uo.abort();
  }
  async teardown() {
    this.torndown = !0, this.cancelRender(), this.story && await this.store.cleanupStory(this.story);
    for (let uo = 0; uo < 3; uo += 1) {
      if (!this.isPending()) {
        await this.teardownRender();
        return;
      }
      await new Promise((ho) => setTimeout(ho, 0));
    }
    window.location.reload(), await new Promise(() => {
    });
  }
};
s(Ur, "StoryRender");
var ne = Ur, { fetch: di } = v, pi = "./index.json", Hr = class {
  constructor(uo, ho, go = q.getChannel(), bo = !0) {
    this.importFn = uo, this.getProjectAnnotations = ho, this.channel = go, this.storyRenders = [], this.storeInitializationPromise = new Promise((vo, Po) => {
      this.resolveStoreInitializationPromise = vo, this.rejectStoreInitializationPromise = Po;
    }), bo && this.initialize();
  }
  // Create a proxy object for `__STORYBOOK_STORY_STORE__` and `__STORYBOOK_PREVIEW__.storyStore`
  // That proxies through to the store once ready, and errors beforehand. This means we can set
  // `__STORYBOOK_STORY_STORE__ = __STORYBOOK_PREVIEW__.storyStore` without having to wait, and
  // similarly integrators can access the `storyStore` on the preview at any time, although
  // it is considered deprecated and we will no longer allow access in 9.0
  get storyStore() {
    return new Proxy(
      {},
      {
        get: /* @__PURE__ */ s((uo, ho) => {
          if (this.storyStoreValue)
            return m$2("Accessing the Story Store is deprecated and will be removed in 9.0"), this.storyStoreValue[ho];
          throw new U$1();
        }, "get")
      }
    );
  }
  // INITIALIZATION
  async initialize() {
    this.setupListeners();
    try {
      let uo = await this.getProjectAnnotationsOrRenderError();
      await this.runBeforeAllHook(uo), await this.initializeWithProjectAnnotations(uo);
    } catch (uo) {
      this.rejectStoreInitializationPromise(uo);
    }
  }
  ready() {
    return this.storeInitializationPromise;
  }
  setupListeners() {
    this.channel.on(m$1, this.onStoryIndexChanged.bind(this)), this.channel.on(j$1, this.onUpdateGlobals.bind(this)), this.channel.on(n, this.onUpdateArgs.bind(this)), this.channel.on(RE, this.onRequestArgTypesInfo.bind(this)), this.channel.on(H$2, this.onResetArgs.bind(this)), this.channel.on(L$2, this.onForceReRender.bind(this)), this.channel.on(P$3, this.onForceRemount.bind(this));
  }
  async getProjectAnnotationsOrRenderError() {
    try {
      let uo = await this.getProjectAnnotations();
      if (this.renderToCanvas = uo.renderToCanvas, !this.renderToCanvas)
        throw new G$1();
      return uo;
    } catch (uo) {
      throw this.renderPreviewEntryError("Error reading preview.js:", uo), uo;
    }
  }
  // If initialization gets as far as project annotations, this function runs.
  async initializeWithProjectAnnotations(uo) {
    this.projectAnnotationsBeforeInitialization = uo;
    try {
      let ho = await this.getStoryIndexFromServer();
      return this.initializeWithStoryIndex(ho);
    } catch (ho) {
      throw this.renderPreviewEntryError("Error loading story index:", ho), ho;
    }
  }
  async runBeforeAllHook(uo) {
    var ho, go;
    try {
      await ((ho = this.beforeAllCleanup) == null ? void 0 : ho.call(this)), this.beforeAllCleanup = await ((go = uo.beforeAll) == null ? void 0 : go.call(uo));
    } catch (bo) {
      throw this.renderPreviewEntryError("Error in beforeAll hook:", bo), bo;
    }
  }
  async getStoryIndexFromServer() {
    let uo = await di(pi);
    if (uo.status === 200)
      return uo.json();
    throw new M$2({ text: await uo.text() });
  }
  // If initialization gets as far as the story index, this function runs.
  initializeWithStoryIndex(uo) {
    if (!this.projectAnnotationsBeforeInitialization)
      throw new Error("Cannot call initializeWithStoryIndex until project annotations resolve");
    this.storyStoreValue = new ye(
      uo,
      this.importFn,
      this.projectAnnotationsBeforeInitialization
    ), delete this.projectAnnotationsBeforeInitialization, this.setInitialGlobals(), this.resolveStoreInitializationPromise();
  }
  async setInitialGlobals() {
    this.emitGlobals();
  }
  emitGlobals() {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "emitGlobals" });
    let uo = {
      globals: this.storyStoreValue.userGlobals.get() || {},
      globalTypes: this.storyStoreValue.projectAnnotations.globalTypes || {}
    };
    this.channel.emit(u$1, uo);
  }
  // EVENT HANDLERS
  // This happens when a config file gets reloaded
  async onGetProjectAnnotationsChanged({
    getProjectAnnotations: uo
  }) {
    delete this.previewEntryError, this.getProjectAnnotations = uo;
    let ho = await this.getProjectAnnotationsOrRenderError();
    if (await this.runBeforeAllHook(ho), !this.storyStoreValue) {
      await this.initializeWithProjectAnnotations(ho);
      return;
    }
    this.storyStoreValue.setProjectAnnotations(ho), this.emitGlobals();
  }
  async onStoryIndexChanged() {
    if (delete this.previewEntryError, !(!this.storyStoreValue && !this.projectAnnotationsBeforeInitialization))
      try {
        let uo = await this.getStoryIndexFromServer();
        if (this.projectAnnotationsBeforeInitialization) {
          this.initializeWithStoryIndex(uo);
          return;
        }
        await this.onStoriesChanged({ storyIndex: uo });
      } catch (uo) {
        throw this.renderPreviewEntryError("Error loading story index:", uo), uo;
      }
  }
  // This happens when a glob gets HMR-ed
  async onStoriesChanged({
    importFn: uo,
    storyIndex: ho
  }) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "onStoriesChanged" });
    await this.storyStoreValue.onStoriesChanged({ importFn: uo, storyIndex: ho });
  }
  async onUpdateGlobals({
    globals: uo,
    currentStory: ho
  }) {
    if (this.storyStoreValue || await this.storeInitializationPromise, !this.storyStoreValue)
      throw new Y$1({ methodName: "onUpdateGlobals" });
    if (this.storyStoreValue.userGlobals.update(uo), ho) {
      let { initialGlobals: go, storyGlobals: bo, userGlobals: vo, globals: Po } = this.storyStoreValue.getStoryContext(ho);
      this.channel.emit(U$3, {
        initialGlobals: go,
        userGlobals: vo,
        storyGlobals: bo,
        globals: Po
      });
    } else {
      let { initialGlobals: go, globals: bo } = this.storyStoreValue.userGlobals;
      this.channel.emit(U$3, {
        initialGlobals: go,
        userGlobals: bo,
        storyGlobals: {},
        globals: bo
      });
    }
    await Promise.all(this.storyRenders.map((go) => go.rerender()));
  }
  async onUpdateArgs({ storyId: uo, updatedArgs: ho }) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "onUpdateArgs" });
    this.storyStoreValue.args.update(uo, ho), await Promise.all(
      this.storyRenders.filter((go) => go.id === uo && !go.renderOptions.forceInitialArgs).map(
        (go) => (
          // We only run the play function, with in a force remount.
          // But when mount is destructured, the rendering happens inside of the play function.
          go.story && go.story.usesMount ? go.remount() : go.rerender()
        )
      )
    ), this.channel.emit(Q, {
      storyId: uo,
      args: this.storyStoreValue.args.get(uo)
    });
  }
  async onRequestArgTypesInfo({ id: uo, payload: ho }) {
    var go;
    try {
      await this.storeInitializationPromise;
      let bo = await ((go = this.storyStoreValue) == null ? void 0 : go.loadStory(ho));
      this.channel.emit(SE, {
        id: uo,
        success: !0,
        payload: { argTypes: (bo == null ? void 0 : bo.argTypes) || {} },
        error: null
      });
    } catch (bo) {
      this.channel.emit(SE, {
        id: uo,
        success: !1,
        error: bo == null ? void 0 : bo.message
      });
    }
  }
  async onResetArgs({ storyId: uo, argNames: ho }) {
    var vo;
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "onResetArgs" });
    let go = ((vo = this.storyRenders.find((Po) => Po.id === uo)) == null ? void 0 : vo.story) || await this.storyStoreValue.loadStory({ storyId: uo }), bo = (ho || [
      .../* @__PURE__ */ new Set([
        ...Object.keys(go.initialArgs),
        ...Object.keys(this.storyStoreValue.args.get(uo))
      ])
    ]).reduce((Po, Co) => (Po[Co] = go.initialArgs[Co], Po), {});
    await this.onUpdateArgs({ storyId: uo, updatedArgs: bo });
  }
  // ForceReRender does not include a story id, so we simply must
  // re-render all stories in case they are relevant
  async onForceReRender() {
    await Promise.all(this.storyRenders.map((uo) => uo.rerender()));
  }
  async onForceRemount({ storyId: uo }) {
    await Promise.all(this.storyRenders.filter((ho) => ho.id === uo).map((ho) => ho.remount()));
  }
  // Used by docs to render a story to a given element
  // Note this short-circuits the `prepare()` phase of the StoryRender,
  // main to be consistent with the previous behaviour. In the future,
  // we will change it to go ahead and load the story, which will end up being
  // "instant", although async.
  renderStoryToElement(uo, ho, go, bo) {
    if (!this.renderToCanvas || !this.storyStoreValue)
      throw new Y$1({
        methodName: "renderStoryToElement"
      });
    let vo = new ne(
      this.channel,
      this.storyStoreValue,
      this.renderToCanvas,
      go,
      uo.id,
      "docs",
      bo,
      uo
    );
    return vo.renderToElement(ho), this.storyRenders.push(vo), async () => {
      await this.teardownRender(vo);
    };
  }
  async teardownRender(uo, { viewModeChanged: ho } = {}) {
    var go;
    this.storyRenders = this.storyRenders.filter((bo) => bo !== uo), await ((go = uo == null ? void 0 : uo.teardown) == null ? void 0 : go.call(uo, { viewModeChanged: ho }));
  }
  // API
  async loadStory({ storyId: uo }) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "loadStory" });
    return this.storyStoreValue.loadStory({ storyId: uo });
  }
  getStoryContext(uo, { forceInitialArgs: ho = !1 } = {}) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "getStoryContext" });
    return this.storyStoreValue.getStoryContext(uo, { forceInitialArgs: ho });
  }
  async extract(uo) {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "extract" });
    if (this.previewEntryError)
      throw this.previewEntryError;
    return await this.storyStoreValue.cacheAllCSFFiles(), this.storyStoreValue.extract(uo);
  }
  // UTILITIES
  renderPreviewEntryError(uo, ho) {
    this.previewEntryError = ho, s$2.error(uo), s$2.error(ho), this.channel.emit(N$2, ho);
  }
};
s(Hr, "Preview");
var me = Hr, Wr = "Invariant failed";
function Xe(Kt, uo) {
  if (!Kt) {
    var ho = typeof uo == "function" ? uo() : uo, go = ho ? "".concat(Wr, ": ").concat(ho) : Wr;
    throw new Error(go);
  }
}
s(Xe, "invariant");
var $r = class {
  constructor(uo, ho, go, bo) {
    this.channel = uo, this.store = ho, this.renderStoryToElement = go, this.storyIdByName = /* @__PURE__ */ s((vo) => {
      let Po = this.nameToStoryId.get(vo);
      if (Po)
        return Po;
      throw new Error(`No story found with that name: ${vo}`);
    }, "storyIdByName"), this.componentStories = /* @__PURE__ */ s(() => this.componentStoriesValue, "componentStories"), this.componentStoriesFromCSFFile = /* @__PURE__ */ s((vo) => this.store.componentStoriesFromCSFFile({ csfFile: vo }), "componentStoriesFromCSFFile"), this.storyById = /* @__PURE__ */ s((vo) => {
      if (!vo) {
        if (!this.primaryStory)
          throw new Error(
            "No primary story defined for docs entry. Did you forget to use `<Meta>`?"
          );
        return this.primaryStory;
      }
      let Po = this.storyIdToCSFFile.get(vo);
      if (!Po)
        throw new Error(`Called \`storyById\` for story that was never loaded: ${vo}`);
      return this.store.storyFromCSFFile({ storyId: vo, csfFile: Po });
    }, "storyById"), this.getStoryContext = /* @__PURE__ */ s((vo) => ({
      ...this.store.getStoryContext(vo),
      loaded: {},
      viewMode: "docs"
    }), "getStoryContext"), this.loadStory = /* @__PURE__ */ s((vo) => this.store.loadStory({ storyId: vo }), "loadStory"), this.componentStoriesValue = [], this.storyIdToCSFFile = /* @__PURE__ */ new Map(), this.exportToStory = /* @__PURE__ */ new Map(), this.exportsToCSFFile = /* @__PURE__ */ new Map(), this.nameToStoryId = /* @__PURE__ */ new Map(), this.attachedCSFFiles = /* @__PURE__ */ new Set(), bo.forEach((vo, Po) => {
      this.referenceCSFFile(vo);
    });
  }
  // This docs entry references this CSF file and can synchronously load the stories, as well
  // as reference them by module export. If the CSF is part of the "component" stories, they
  // can also be referenced by name and are in the componentStories list.
  referenceCSFFile(uo) {
    this.exportsToCSFFile.set(uo.moduleExports, uo), this.exportsToCSFFile.set(uo.moduleExports.default, uo), this.store.componentStoriesFromCSFFile(
      { csfFile: uo }
    ).forEach((ho) => {
      let go = uo.stories[ho.id];
      this.storyIdToCSFFile.set(go.id, uo), this.exportToStory.set(go.moduleExport, ho);
    });
  }
  attachCSFFile(uo) {
    if (!this.exportsToCSFFile.has(uo.moduleExports))
      throw new Error("Cannot attach a CSF file that has not been referenced");
    this.attachedCSFFiles.has(uo) || (this.attachedCSFFiles.add(uo), this.store.componentStoriesFromCSFFile({ csfFile: uo }).forEach((ho) => {
      this.nameToStoryId.set(ho.name, ho.id), this.componentStoriesValue.push(ho), this.primaryStory || (this.primaryStory = ho);
    }));
  }
  referenceMeta(uo, ho) {
    let go = this.resolveModuleExport(uo);
    if (go.type !== "meta")
      throw new Error(
        "<Meta of={} /> must reference a CSF file module export or meta export. Did you mistakenly reference your component instead of your CSF file?"
      );
    ho && this.attachCSFFile(go.csfFile);
  }
  get projectAnnotations() {
    let { projectAnnotations: uo } = this.store;
    if (!uo)
      throw new Error("Can't get projectAnnotations from DocsContext before they are initialized");
    return uo;
  }
  resolveAttachedModuleExportType(uo) {
    if (uo === "story") {
      if (!this.primaryStory)
        throw new Error(
          "No primary story attached to this docs file, did you forget to use <Meta of={} />?"
        );
      return { type: "story", story: this.primaryStory };
    }
    if (this.attachedCSFFiles.size === 0)
      throw new Error(
        "No CSF file attached to this docs file, did you forget to use <Meta of={} />?"
      );
    let ho = Array.from(this.attachedCSFFiles)[0];
    if (uo === "meta")
      return { type: "meta", csfFile: ho };
    let { component: go } = ho.meta;
    if (!go)
      throw new Error(
        "Attached CSF file does not defined a component, did you forget to export one?"
      );
    return { type: "component", component: go };
  }
  resolveModuleExport(uo) {
    let ho = this.exportsToCSFFile.get(uo);
    if (ho)
      return { type: "meta", csfFile: ho };
    let go = this.exportToStory.get(uo);
    return go ? { type: "story", story: go } : { type: "component", component: uo };
  }
  resolveOf(uo, ho = []) {
    let go;
    if (["component", "meta", "story"].includes(uo)) {
      let bo = uo;
      go = this.resolveAttachedModuleExportType(bo);
    } else
      go = this.resolveModuleExport(uo);
    if (ho.length && !ho.includes(go.type)) {
      let bo = go.type === "component" ? "component or unknown" : go.type;
      throw new Error(F`Invalid value passed to the 'of' prop. The value was resolved to a '${bo}' type but the only types for this block are: ${ho.join(
        ", "
      )}.
        - Did you pass a component to the 'of' prop when the block only supports a story or a meta?
        - ... or vice versa?
        - Did you pass a story, CSF file or meta to the 'of' prop that is not indexed, ie. is not targeted by the 'stories' globs in the main configuration?`);
    }
    switch (go.type) {
      case "component":
        return {
          ...go,
          projectAnnotations: this.projectAnnotations
        };
      case "meta":
        return {
          ...go,
          preparedMeta: this.store.preparedMetaFromCSFFile({ csfFile: go.csfFile })
        };
      case "story":
      default:
        return go;
    }
  }
};
s($r, "DocsContext");
var K = $r, Yr = class {
  constructor(uo, ho, go, bo) {
    this.channel = uo, this.store = ho, this.entry = go, this.callbacks = bo, this.type = "docs", this.subtype = "csf", this.torndown = !1, this.disableKeyListeners = !1, this.preparing = !1, this.id = go.id;
  }
  isPreparing() {
    return this.preparing;
  }
  async prepare() {
    this.preparing = !0;
    let { entryExports: uo, csfFiles: ho = [] } = await this.store.loadEntry(this.id);
    if (this.torndown)
      throw Y;
    let { importPath: go, title: bo } = this.entry, vo = this.store.processCSFFileWithCache(
      uo,
      go,
      bo
    ), Po = Object.keys(vo.stories)[0];
    this.story = this.store.storyFromCSFFile({ storyId: Po, csfFile: vo }), this.csfFiles = [vo, ...ho], this.preparing = !1;
  }
  isEqual(uo) {
    return !!(this.id === uo.id && this.story && this.story === uo.story);
  }
  docsContext(uo) {
    if (!this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    let ho = new K(
      this.channel,
      this.store,
      uo,
      this.csfFiles
    );
    return this.csfFiles.forEach((go) => ho.attachCSFFile(go)), ho;
  }
  async renderToElement(uo, ho) {
    if (!this.story || !this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    let go = this.docsContext(ho), { docs: bo } = this.story.parameters || {};
    if (!bo)
      throw new Error(
        "Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed"
      );
    let vo = await bo.renderer(), { render: Po } = vo, Co = /* @__PURE__ */ s(async () => {
      try {
        await Po(go, bo, uo), this.channel.emit(I$2, this.id);
      } catch (So) {
        this.callbacks.showException(So);
      }
    }, "renderDocs");
    return this.rerender = async () => Co(), this.teardownRender = async ({ viewModeChanged: So }) => {
      !So || !uo || vo.unmount(uo);
    }, Co();
  }
  async teardown({ viewModeChanged: uo } = {}) {
    var ho;
    (ho = this.teardownRender) == null || ho.call(this, { viewModeChanged: uo }), this.torndown = !0;
  }
};
s(Yr, "CsfDocsRender");
var De = Yr, Kr = class {
  constructor(uo, ho, go, bo) {
    this.channel = uo, this.store = ho, this.entry = go, this.callbacks = bo, this.type = "docs", this.subtype = "mdx", this.torndown = !1, this.disableKeyListeners = !1, this.preparing = !1, this.id = go.id;
  }
  isPreparing() {
    return this.preparing;
  }
  async prepare() {
    this.preparing = !0;
    let { entryExports: uo, csfFiles: ho = [] } = await this.store.loadEntry(this.id);
    if (this.torndown)
      throw Y;
    this.csfFiles = ho, this.exports = uo, this.preparing = !1;
  }
  isEqual(uo) {
    return !!(this.id === uo.id && this.exports && this.exports === uo.exports);
  }
  docsContext(uo) {
    if (!this.csfFiles)
      throw new Error("Cannot render docs before preparing");
    return new K(
      this.channel,
      this.store,
      uo,
      this.csfFiles
    );
  }
  async renderToElement(uo, ho) {
    if (!this.exports || !this.csfFiles || !this.store.projectAnnotations)
      throw new Error("Cannot render docs before preparing");
    let go = this.docsContext(ho), { docs: bo } = this.store.projectAnnotations.parameters || {};
    if (!bo)
      throw new Error(
        "Cannot render a story in viewMode=docs if `@storybook/addon-docs` is not installed"
      );
    let vo = { ...bo, page: this.exports.default }, Po = await bo.renderer(), { render: Co } = Po, So = /* @__PURE__ */ s(async () => {
      try {
        await Co(go, vo, uo), this.channel.emit(I$2, this.id);
      } catch (wo) {
        this.callbacks.showException(wo);
      }
    }, "renderDocs");
    return this.rerender = async () => So(), this.teardownRender = async ({ viewModeChanged: wo } = {}) => {
      !wo || !uo || (Po.unmount(uo), this.torndown = !0);
    }, So();
  }
  async teardown({ viewModeChanged: uo } = {}) {
    var ho;
    (ho = this.teardownRender) == null || ho.call(this, { viewModeChanged: uo }), this.torndown = !0;
  }
};
s(Kr, "MdxDocsRender");
var ke = Kr, Fi = globalThis;
function Ii(Kt) {
  let uo = Kt.composedPath && Kt.composedPath()[0] || Kt.target;
  return /input|textarea/i.test(uo.tagName) || uo.getAttribute("contenteditable") !== null;
}
s(Ii, "focusInInput");
var Fo = "attached-mdx", Oi = "unattached-mdx";
function Di({ tags: Kt }) {
  return (Kt == null ? void 0 : Kt.includes(Oi)) || (Kt == null ? void 0 : Kt.includes(Fo));
}
s(Di, "isMdxEntry");
function Jr(Kt) {
  return Kt.type === "story";
}
s(Jr, "isStoryRender");
function ki(Kt) {
  return Kt.type === "docs";
}
s(ki, "isDocsRender");
function ji(Kt) {
  return ki(Kt) && Kt.subtype === "csf";
}
s(ji, "isCsfDocsRender");
var Qr = class extends me {
  constructor(uo, ho, go, bo) {
    super(uo, ho, void 0, !1), this.importFn = uo, this.getProjectAnnotations = ho, this.selectionStore = go, this.view = bo, this.initialize();
  }
  setupListeners() {
    super.setupListeners(), Fi.onkeydown = this.onKeydown.bind(this), this.channel.on(p$1, this.onSetCurrentStory.bind(this)), this.channel.on(
      k$4,
      this.onUpdateQueryParams.bind(this)
    ), this.channel.on(t$1, this.onPreloadStories.bind(this));
  }
  async setInitialGlobals() {
    if (!this.storyStoreValue)
      throw new Y$1({ methodName: "setInitialGlobals" });
    let { globals: uo } = this.selectionStore.selectionSpecifier || {};
    uo && this.storyStoreValue.userGlobals.updateFromPersisted(uo), this.emitGlobals();
  }
  // If initialization gets as far as the story index, this function runs.
  async initializeWithStoryIndex(uo) {
    return await super.initializeWithStoryIndex(uo), this.selectSpecifiedStory();
  }
  // Use the selection specifier to choose a story, then render it
  async selectSpecifiedStory() {
    if (!this.storyStoreValue)
      throw new Y$1({
        methodName: "selectSpecifiedStory"
      });
    if (this.selectionStore.selection) {
      await this.renderSelection();
      return;
    }
    if (!this.selectionStore.selectionSpecifier) {
      this.renderMissingStory();
      return;
    }
    let { storySpecifier: uo, args: ho } = this.selectionStore.selectionSpecifier, go = this.storyStoreValue.storyIndex.entryFromSpecifier(uo);
    if (!go) {
      uo === "*" ? this.renderStoryLoadingException(uo, new F$2()) : this.renderStoryLoadingException(
        uo,
        new K$1({ storySpecifier: uo.toString() })
      );
      return;
    }
    let { id: bo, type: vo } = go;
    this.selectionStore.setSelection({ storyId: bo, viewMode: vo }), this.channel.emit(q$3, this.selectionStore.selection), this.channel.emit(
      r$1,
      this.selectionStore.selection
    ), await this.renderSelection({ persistedArgs: ho });
  }
  // EVENT HANDLERS
  // This happens when a config file gets reloaded
  async onGetProjectAnnotationsChanged({
    getProjectAnnotations: uo
  }) {
    await super.onGetProjectAnnotationsChanged({ getProjectAnnotations: uo }), this.selectionStore.selection && this.renderSelection();
  }
  // This happens when a glob gets HMR-ed
  async onStoriesChanged({
    importFn: uo,
    storyIndex: ho
  }) {
    await super.onStoriesChanged({ importFn: uo, storyIndex: ho }), this.selectionStore.selection ? await this.renderSelection() : await this.selectSpecifiedStory();
  }
  onKeydown(uo) {
    if (!this.storyRenders.find((ho) => ho.disableKeyListeners) && !Ii(uo)) {
      let { altKey: ho, ctrlKey: go, metaKey: bo, shiftKey: vo, key: Po, code: Co, keyCode: So } = uo;
      this.channel.emit(W$2, {
        event: { altKey: ho, ctrlKey: go, metaKey: bo, shiftKey: vo, key: Po, code: Co, keyCode: So }
      });
    }
  }
  async onSetCurrentStory(uo) {
    this.selectionStore.setSelection({ viewMode: "story", ...uo }), await this.storeInitializationPromise, this.channel.emit(r$1, this.selectionStore.selection), this.renderSelection();
  }
  onUpdateQueryParams(uo) {
    this.selectionStore.setQueryParams(uo);
  }
  async onUpdateGlobals({ globals: uo }) {
    var go, bo;
    let ho = this.currentRender instanceof ne && this.currentRender.story || void 0;
    super.onUpdateGlobals({ globals: uo, currentStory: ho }), (this.currentRender instanceof ke || this.currentRender instanceof De) && await ((bo = (go = this.currentRender).rerender) == null ? void 0 : bo.call(go));
  }
  async onUpdateArgs({ storyId: uo, updatedArgs: ho }) {
    super.onUpdateArgs({ storyId: uo, updatedArgs: ho });
  }
  async onPreloadStories({ ids: uo }) {
    await this.storeInitializationPromise, this.storyStoreValue && await Promise.allSettled(uo.map((ho) => {
      var go;
      return (go = this.storyStoreValue) == null ? void 0 : go.loadEntry(ho);
    }));
  }
  // RENDERING
  // We can either have:
  // - a story selected in "story" viewMode,
  //     in which case we render it to the root element, OR
  // - a story selected in "docs" viewMode,
  //     in which case we render the docsPage for that story
  async renderSelection({ persistedArgs: uo } = {}) {
    var _o, Io, Ao, Oo;
    let { renderToCanvas: ho } = this;
    if (!this.storyStoreValue || !ho)
      throw new Y$1({ methodName: "renderSelection" });
    let { selection: go } = this.selectionStore;
    if (!go)
      throw new Error("Cannot call renderSelection as no selection was made");
    let { storyId: bo } = go, vo;
    try {
      vo = await this.storyStoreValue.storyIdToEntry(bo);
    } catch (jo) {
      this.currentRender && await this.teardownRender(this.currentRender), this.renderStoryLoadingException(bo, jo);
      return;
    }
    let Po = ((_o = this.currentSelection) == null ? void 0 : _o.storyId) !== bo, Co = ((Io = this.currentRender) == null ? void 0 : Io.type) !== vo.type;
    vo.type === "story" ? this.view.showPreparingStory({ immediate: Co }) : this.view.showPreparingDocs({ immediate: Co }), (Ao = this.currentRender) != null && Ao.isPreparing() && await this.teardownRender(this.currentRender);
    let So;
    vo.type === "story" ? So = new ne(
      this.channel,
      this.storyStoreValue,
      ho,
      this.mainStoryCallbacks(bo),
      bo,
      "story"
    ) : Di(vo) ? So = new ke(
      this.channel,
      this.storyStoreValue,
      vo,
      this.mainStoryCallbacks(bo)
    ) : So = new De(
      this.channel,
      this.storyStoreValue,
      vo,
      this.mainStoryCallbacks(bo)
    );
    let wo = this.currentSelection;
    this.currentSelection = go;
    let Eo = this.currentRender;
    this.currentRender = So;
    try {
      await So.prepare();
    } catch (jo) {
      Eo && await this.teardownRender(Eo), jo !== Y && this.renderStoryLoadingException(bo, jo);
      return;
    }
    let Ro = !Po && Eo && !So.isEqual(Eo);
    if (uo && Jr(So) && (Xe(!!So.story), this.storyStoreValue.args.updateFromPersisted(So.story, uo)), Eo && !Eo.torndown && !Po && !Ro && !Co) {
      this.currentRender = Eo, this.channel.emit(K$2, bo), this.view.showMain();
      return;
    }
    if (Eo && await this.teardownRender(Eo, { viewModeChanged: Co }), wo && (Po || Co) && this.channel.emit(f$2, bo), Jr(So)) {
      Xe(!!So.story);
      let {
        parameters: jo,
        initialArgs: Do,
        argTypes: Lo,
        unmappedArgs: ko,
        initialGlobals: Ko,
        userGlobals: No,
        storyGlobals: Jo,
        globals: ti
      } = this.storyStoreValue.getStoryContext(So.story);
      this.channel.emit(w$2, {
        id: bo,
        parameters: jo,
        initialArgs: Do,
        argTypes: Lo,
        args: ko
      }), this.channel.emit(U$3, { userGlobals: No, storyGlobals: Jo, globals: ti, initialGlobals: Ko });
    } else {
      let { parameters: jo } = this.storyStoreValue.projectAnnotations, { initialGlobals: Do, globals: Lo } = this.storyStoreValue.userGlobals;
      if (this.channel.emit(U$3, {
        globals: Lo,
        initialGlobals: Do,
        storyGlobals: {},
        userGlobals: Lo
      }), ji(So) || ((Oo = So.entry.tags) == null ? void 0 : Oo.includes(Fo))) {
        if (!So.csfFiles)
          throw new H({ storyId: bo });
        ({ parameters: jo } = this.storyStoreValue.preparedMetaFromCSFFile({
          csfFile: So.csfFiles[0]
        }));
      }
      this.channel.emit(D$3, {
        id: bo,
        parameters: jo
      });
    }
    Jr(So) ? (Xe(!!So.story), this.storyRenders.push(So), this.currentRender.renderToElement(
      this.view.prepareForStory(So.story)
    )) : this.currentRender.renderToElement(
      this.view.prepareForDocs(),
      // This argument is used for docs, which is currently only compatible with HTMLElements
      this.renderStoryToElement.bind(this)
    );
  }
  async teardownRender(uo, { viewModeChanged: ho = !1 } = {}) {
    var go;
    this.storyRenders = this.storyRenders.filter((bo) => bo !== uo), await ((go = uo == null ? void 0 : uo.teardown) == null ? void 0 : go.call(uo, { viewModeChanged: ho }));
  }
  // UTILITIES
  mainStoryCallbacks(uo) {
    return {
      showStoryDuringRender: /* @__PURE__ */ s(() => this.view.showStoryDuringRender(), "showStoryDuringRender"),
      showMain: /* @__PURE__ */ s(() => this.view.showMain(), "showMain"),
      showError: /* @__PURE__ */ s((ho) => this.renderError(uo, ho), "showError"),
      showException: /* @__PURE__ */ s((ho) => this.renderException(uo, ho), "showException")
    };
  }
  renderPreviewEntryError(uo, ho) {
    super.renderPreviewEntryError(uo, ho), this.view.showErrorDisplay(ho);
  }
  renderMissingStory() {
    this.view.showNoPreview(), this.channel.emit(V$1);
  }
  renderStoryLoadingException(uo, ho) {
    s$2.error(ho), this.view.showErrorDisplay(ho), this.channel.emit(V$1, uo);
  }
  // renderException is used if we fail to render the story and it is uncaught by the app layer
  renderException(uo, ho) {
    let { name: go = "Error", message: bo = String(ho), stack: vo } = ho;
    this.channel.emit(b$2, { name: go, message: bo, stack: vo }), this.channel.emit(B$2, { newPhase: "errored", storyId: uo }), this.view.showErrorDisplay(
      ho
    ), s$2.error(`Error rendering story '${uo}':`), s$2.error(ho);
  }
  // renderError is used by the various app layers to inform the user they have done something
  // wrong -- for instance returned the wrong thing from a story
  renderError(uo, { title: ho, description: go }) {
    s$2.error(`Error rendering story ${ho}: ${go}`), this.channel.emit(x$3, { title: ho, description: go }), this.channel.emit(B$2, { newPhase: "errored", storyId: uo }), this.view.showErrorDisplay({
      message: ho,
      stack: go
    });
  }
};
s(Qr, "PreviewWithSelection");
var he = Qr, Me = ce(tr()), Go = ce(tr()), zo = /^[a-zA-Z0-9 _-]*$/, Vo = /^-?[0-9]+(\.[0-9]+)?$/, aa = /^#([a-f0-9]{3,4}|[a-f0-9]{6}|[a-f0-9]{8})$/i, Uo = /^(rgba?|hsla?)\(([0-9]{1,3}),\s?([0-9]{1,3})%?,\s?([0-9]{1,3})%?,?\s?([0-9](\.[0-9]{1,2})?)?\)$/i, st = /* @__PURE__ */ s((Kt = "", uo) => Kt === null || Kt === "" || !zo.test(Kt) ? !1 : uo == null || uo instanceof Date || typeof uo == "number" || typeof uo == "boolean" ? !0 : typeof uo == "string" ? zo.test(uo) || Vo.test(uo) || aa.test(uo) || Uo.test(uo) : Array.isArray(uo) ? uo.every((ho) => st(
  Kt,
  ho
)) : k(uo) ? Object.entries(uo).every(([ho, go]) => st(ho, go)) : !1, "validateArgs"), la = {
  delimiter: ";",
  // we're parsing a single query param
  nesting: !0,
  arrayRepeat: !0,
  arrayRepeatSyntax: "bracket",
  nestingSyntax: "js",
  // objects are encoded using dot notation
  valueDeserializer(Kt) {
    if (Kt.startsWith("!")) {
      if (Kt === "!undefined")
        return;
      if (Kt === "!null")
        return null;
      if (Kt === "!true")
        return !0;
      if (Kt === "!false")
        return !1;
      if (Kt.startsWith("!date(") && Kt.endsWith(")"))
        return new Date(Kt.replaceAll(" ", "+").slice(6, -1));
      if (Kt.startsWith("!hex(") && Kt.endsWith(")"))
        return `#${Kt.slice(5, -1)}`;
      let uo = Kt.slice(1).match(Uo);
      if (uo)
        return Kt.startsWith("!rgba") || Kt.startsWith("!RGBA") ? `${uo[1]}(${uo[2]}, ${uo[3]}, ${uo[4]}, ${uo[5]})` : Kt.startsWith("!hsla") || Kt.startsWith(
          "!HSLA"
        ) ? `${uo[1]}(${uo[2]}, ${uo[3]}%, ${uo[4]}%, ${uo[5]})` : Kt.startsWith("!rgb") || Kt.startsWith("!RGB") ? `${uo[1]}(${uo[2]}, ${uo[3]}, ${uo[4]})` : `${uo[1]}(${uo[2]}, ${uo[3]}%, ${uo[4]}%)`;
    }
    return Vo.test(Kt) ? Number(Kt) : Kt;
  }
}, it = /* @__PURE__ */ s((Kt) => {
  let uo = Kt.split(";").map((ho) => ho.replace("=", "~").replace(":", "="));
  return Object.entries((0, Go.parse)(uo.join(";"), la)).reduce((ho, [go, bo]) => st(go, bo) ? Object.assign(ho, { [go]: bo }) : (n$1.warn(F`
      Omitted potentially unsafe URL args.

      More info: https://storybook.js.org/docs/writing-stories/args#setting-args-through-the-url
    `), ho), {});
}, "parseArgsParam"), { history: Ho, document: X } = v;
function ca(Kt) {
  let uo = (Kt || "").match(/^\/story\/(.+)/);
  if (!uo)
    throw new Error(`Invalid path '${Kt}',  must start with '/story/'`);
  return uo[1];
}
s(ca, "pathToId");
var Wo = /* @__PURE__ */ s(({
  selection: Kt,
  extraParams: uo
}) => {
  let ho = X == null ? void 0 : X.location.search.slice(1), { path: go, selectedKind: bo, selectedStory: vo, ...Po } = (0, Me.parse)(ho);
  return `?${(0, Me.stringify)({
    ...Po,
    ...uo,
    ...Kt && { id: Kt.storyId, viewMode: Kt.viewMode }
  })}`;
}, "getQueryString"), da = /* @__PURE__ */ s((Kt) => {
  if (!Kt)
    return;
  let uo = Wo({ selection: Kt }), { hash: ho = "" } = X.location;
  X.title = Kt.storyId, Ho.replaceState({}, "", `${X.location.pathname}${uo}${ho}`);
}, "setPath"), pa = /* @__PURE__ */ s((Kt) => Kt != null && typeof Kt == "object" && Array.isArray(Kt) === !1, "isObject"), je = /* @__PURE__ */ s(
  (Kt) => {
    if (Kt !== void 0) {
      if (typeof Kt == "string")
        return Kt;
      if (Array.isArray(Kt))
        return je(Kt[0]);
      if (pa(Kt))
        return je(
          Object.values(Kt).filter(Boolean)
        );
    }
  },
  "getFirstString"
), ua = /* @__PURE__ */ s(() => {
  if (typeof X < "u") {
    let Kt = X.location.search.slice(1), uo = (0, Me.parse)(Kt), ho = typeof uo.args == "string" ? it(uo.args) : void 0, go = typeof uo.globals == "string" ? it(uo.globals) : void 0, bo = je(uo.viewMode);
    (typeof bo != "string" || !bo.match(/docs|story/)) && (bo = "story");
    let vo = je(uo.path), Po = vo ? ca(vo) : je(uo.id);
    if (Po)
      return { storySpecifier: Po, args: ho, globals: go, viewMode: bo };
  }
  return null;
}, "getSelectionSpecifierFromPath"), at = class {
  constructor() {
    this.selectionSpecifier = ua();
  }
  setSelection(uo) {
    this.selection = uo, da(this.selection);
  }
  setQueryParams(uo) {
    let ho = Wo({ extraParams: uo }), { hash: go = "" } = X.location;
    Ho.replaceState({}, "", `${X.location.pathname}${ho}${go}`);
  }
};
s(at, "UrlStore");
var ge = at, An = ce(Rn()), vn = ce(tr()), { document: D } = v, wn = 100, Cn = /* @__PURE__ */ ((Kt) => (Kt.MAIN = "MAIN", Kt.NOPREVIEW = "NOPREVIEW", Kt.PREPARING_STORY = "PREPARING_STORY", Kt.PREPARING_DOCS = "PREPARING_DOCS", Kt.ERROR = "ERROR", Kt))(Cn || {}), yt = {
  PREPARING_STORY: "sb-show-preparing-story",
  PREPARING_DOCS: "sb-show-preparing-docs",
  MAIN: "sb-show-main",
  NOPREVIEW: "sb-show-nopreview",
  ERROR: "sb-show-errordisplay"
}, mt = {
  centered: "sb-main-centered",
  fullscreen: "sb-main-fullscreen",
  padded: "sb-main-padded"
}, En = new An.default({
  escapeXML: !0
}), ht = class {
  constructor() {
    if (this.testing = !1, typeof D < "u") {
      let { __SPECIAL_TEST_PARAMETER__: uo } = (0, vn.parse)(D.location.search.slice(1));
      switch (uo) {
        case "preparing-story": {
          this.showPreparingStory(), this.testing = !0;
          break;
        }
        case "preparing-docs": {
          this.showPreparingDocs(), this.testing = !0;
          break;
        }
      }
    }
  }
  // Get ready to render a story, returning the element to render to
  prepareForStory(uo) {
    return this.showStory(), this.applyLayout(uo.parameters.layout), D.documentElement.scrollTop = 0, D.documentElement.scrollLeft = 0, this.storyRoot();
  }
  storyRoot() {
    return D.getElementById("storybook-root");
  }
  prepareForDocs() {
    return this.showMain(), this.showDocs(), this.applyLayout("fullscreen"), D.documentElement.scrollTop = 0, D.documentElement.scrollLeft = 0, this.docsRoot();
  }
  docsRoot() {
    return D.getElementById("storybook-docs");
  }
  applyLayout(uo = "padded") {
    if (uo === "none") {
      D.body.classList.remove(this.currentLayoutClass), this.currentLayoutClass = null;
      return;
    }
    this.checkIfLayoutExists(uo);
    let ho = mt[uo];
    D.body.classList.remove(this.currentLayoutClass), D.body.classList.add(ho), this.currentLayoutClass = ho;
  }
  checkIfLayoutExists(uo) {
    mt[uo] || s$2.warn(
      F`
          The desired layout: ${uo} is not a valid option.
          The possible options are: ${Object.keys(mt).join(", ")}, none.
        `
    );
  }
  showMode(uo) {
    clearTimeout(this.preparingTimeout), Object.keys(Cn).forEach((ho) => {
      ho === uo ? D.body.classList.add(yt[ho]) : D.body.classList.remove(yt[ho]);
    });
  }
  showErrorDisplay({ message: uo = "", stack: ho = "" }) {
    let go = uo, bo = ho, vo = uo.split(`
`);
    vo.length > 1 && ([go] = vo, bo = vo.slice(1).join(`
`).replace(/^\n/, "")), D.getElementById("error-message").innerHTML = En.toHtml(go), D.getElementById("error-stack").innerHTML = En.toHtml(bo), this.showMode("ERROR");
  }
  showNoPreview() {
    var uo, ho;
    this.testing || (this.showMode("NOPREVIEW"), (uo = this.storyRoot()) == null || uo.setAttribute("hidden", "true"), (ho = this.docsRoot()) == null || ho.setAttribute("hidden", "true"));
  }
  showPreparingStory({ immediate: uo = !1 } = {}) {
    clearTimeout(this.preparingTimeout), uo ? this.showMode("PREPARING_STORY") : this.preparingTimeout = setTimeout(
      () => this.showMode("PREPARING_STORY"),
      wn
    );
  }
  showPreparingDocs({ immediate: uo = !1 } = {}) {
    clearTimeout(this.preparingTimeout), uo ? this.showMode("PREPARING_DOCS") : this.preparingTimeout = setTimeout(() => this.showMode("PREPARING_DOCS"), wn);
  }
  showMain() {
    this.showMode("MAIN");
  }
  showDocs() {
    this.storyRoot().setAttribute("hidden", "true"), this.docsRoot().removeAttribute("hidden");
  }
  showStory() {
    this.docsRoot().setAttribute("hidden", "true"), this.storyRoot().removeAttribute("hidden");
  }
  showStoryDuringRender() {
    D.body.classList.add(yt.MAIN);
  }
};
s(ht, "WebView");
var be = ht, gt = class extends he {
  constructor(uo, ho) {
    super(uo, ho, new ge(), new be()), this.importFn = uo, this.getProjectAnnotations = ho, v.__STORYBOOK_PREVIEW__ = this;
  }
};
s(gt, "PreviewWeb");
var { document: le } = v, Ya = [
  "application/javascript",
  "application/ecmascript",
  "application/x-ecmascript",
  "application/x-javascript",
  "text/ecmascript",
  "text/javascript",
  "text/javascript1.0",
  "text/javascript1.1",
  "text/javascript1.2",
  "text/javascript1.3",
  "text/javascript1.4",
  "text/javascript1.5",
  "text/jscript",
  "text/livescript",
  "text/x-ecmascript",
  "text/x-javascript",
  // Support modern javascript
  "module"
], Ka = "script", Pn = "scripts-root";
function pr() {
  let Kt = le.createEvent("Event");
  Kt.initEvent("DOMContentLoaded", !0, !0), le.dispatchEvent(Kt);
}
s(pr, "simulateDOMContentLoaded");
function Xa(Kt, uo, ho) {
  let go = le.createElement("script");
  go.type = Kt.type === "module" ? "module" : "text/javascript", Kt.src ? (go.onload = uo, go.onerror = uo, go.src = Kt.src) : go.textContent = Kt.innerText, ho ? ho.appendChild(go) : le.head.appendChild(go), Kt.parentNode.removeChild(Kt), Kt.src || uo();
}
s(Xa, "insertScript");
function Fn(Kt, uo, ho = 0) {
  Kt[ho](() => {
    ho++, ho === Kt.length ? uo() : Fn(Kt, uo, ho);
  });
}
s(Fn, "insertScriptsSequentially");
function In(Kt) {
  let uo = le.getElementById(Pn);
  uo ? uo.innerHTML = "" : (uo = le.createElement("div"), uo.id = Pn, le.body.appendChild(uo));
  let ho = Array.from(Kt.querySelectorAll(Ka));
  if (ho.length) {
    let go = [];
    ho.forEach((bo) => {
      let vo = bo.getAttribute("type");
      (!vo || Ya.includes(vo)) && go.push((Po) => Xa(bo, Po, uo));
    }), go.length && Fn(go, pr, void 0);
  } else
    pr();
}
s(In, "simulatePageLoad");
var scope = (() => {
  let Kt;
  return typeof window < "u" ? Kt = window : typeof globalThis < "u" ? Kt = globalThis : typeof global < "u" ? Kt = global : typeof self < "u" ? Kt = self : Kt = {}, Kt;
})();
let getRandomValues;
const rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const byteToHex = [];
for (let Kt = 0; Kt < 256; ++Kt)
  byteToHex.push((Kt + 256).toString(16).slice(1));
function unsafeStringify(Kt, uo = 0) {
  return byteToHex[Kt[uo + 0]] + byteToHex[Kt[uo + 1]] + byteToHex[Kt[uo + 2]] + byteToHex[Kt[uo + 3]] + "-" + byteToHex[Kt[uo + 4]] + byteToHex[Kt[uo + 5]] + "-" + byteToHex[Kt[uo + 6]] + byteToHex[Kt[uo + 7]] + "-" + byteToHex[Kt[uo + 8]] + byteToHex[Kt[uo + 9]] + "-" + byteToHex[Kt[uo + 10]] + byteToHex[Kt[uo + 11]] + byteToHex[Kt[uo + 12]] + byteToHex[Kt[uo + 13]] + byteToHex[Kt[uo + 14]] + byteToHex[Kt[uo + 15]];
}
const randomUUID = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), native = {
  randomUUID
};
function v4(Kt, uo, ho) {
  if (native.randomUUID && !uo && !Kt)
    return native.randomUUID();
  Kt = Kt || {};
  const go = Kt.random || (Kt.rng || rng)();
  return go[6] = go[6] & 15 | 64, go[8] = go[8] & 63 | 128, unsafeStringify(go);
}
var ADDON_ID = "storybook/actions", EVENT_ID = `${ADDON_ID}/action-event`, config = { depth: 10, clearOnStoryChange: !0, limit: 50 }, findProto = (Kt, uo) => {
  let ho = Object.getPrototypeOf(Kt);
  return !ho || uo(ho) ? ho : findProto(ho, uo);
}, isReactSyntheticEvent = (Kt) => !!(typeof Kt == "object" && Kt && findProto(Kt, (uo) => /^Synthetic(?:Base)?Event$/.test(uo.constructor.name)) && typeof Kt.persist == "function"), serializeArg = (Kt) => {
  if (isReactSyntheticEvent(Kt)) {
    let uo = Object.create(Kt.constructor.prototype, Object.getOwnPropertyDescriptors(Kt));
    uo.persist();
    let ho = Object.getOwnPropertyDescriptor(uo, "view"), go = ho == null ? void 0 : ho.value;
    return typeof go == "object" && (go == null ? void 0 : go.constructor.name) === "Window" && Object.defineProperty(uo, "view", { ...ho, value: Object.create(go.constructor.prototype) }), uo;
  }
  return Kt;
}, generateId = () => typeof crypto == "object" && typeof crypto.getRandomValues == "function" ? v4() : Date.now().toString(36) + Math.random().toString(36).substring(2);
function action(Kt, uo = {}) {
  let ho = { ...config, ...uo }, go = function(...bo) {
    var Ro, _o;
    if (uo.implicit) {
      let Io = (Ro = "__STORYBOOK_PREVIEW__" in scope ? scope.__STORYBOOK_PREVIEW__ : void 0) == null ? void 0 : Ro.storyRenders.find((Ao) => Ao.phase === "playing" || Ao.phase === "rendering");
      if (Io) {
        let Ao = !((_o = window == null ? void 0 : window.FEATURES) != null && _o.disallowImplicitActionsInRenderV8), Oo = new j({ phase: Io.phase, name: Kt, deprecated: Ao });
        if (Ao) console.warn(Oo);
        else throw Oo;
      }
    }
    let vo = q.getChannel(), Po = generateId(), Co = 5, So = bo.map(serializeArg), wo = bo.length > 1 ? So : So[0], Eo = { id: Po, count: 0, data: { name: Kt, args: wo }, options: { ...ho, maxDepth: Co + (ho.depth || 3), allowFunction: ho.allowFunction || !1 } };
    vo.emit(EVENT_ID, Eo);
  };
  return go.isAction = !0, go.implicit = uo.implicit, go;
}
const logAction = action("console-log"), logger = {
  log: (...Kt) => logAction(`LOG: ${Kt.join(" ")}`),
  info: (...Kt) => logAction(`INFO: ${Kt.join(" ")}`),
  warn: (...Kt) => logAction(`WARN: ${Kt.join(" ")}`),
  error: (...Kt) => logAction(`ERROR: ${Kt.join(" ")}`)
}, CLSPPlayer = (Kt) => {
  const {
    type: uo = "clsp",
    src: ho,
    title: go,
    port: bo = uo === "clsp" ? 80 : uo === "clsps" ? 443 : void 0
  } = Kt, vo = useRef(null), [Po, Co] = useState(null), So = async () => {
    try {
      bo && utils.setDefaultStreamPort(uo, bo);
      const Eo = (() => IovCollection.asSingleton())(bo).create({
        videoElement: vo.current
        // Use the actual video DOM element here
      });
      return await Eo.changeSrc(ho), Eo;
    } catch (wo) {
      return logger.error("Unable to load clsp player", wo), null;
    }
  };
  return useEffect(() => {
    let wo;
    return (async () => {
      vo.current && (wo = await So(), Co(wo ? null : "Unable to load player: please check console for error."));
    })(), () => {
      wo && wo.destroy(vo.current);
    };
  }, [uo, ho]), /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "alc-clspplayer",
    {
      id: `${go.trim().split(" ").join("-")}-container`,
      title: go,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("video", { ref: vo, className: "video" }),
        " ",
        Po && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: "error", children: Po })
      ]
    }
  );
};
CLSPPlayer.propTypes = {
  /**
   * The port the clsp player will use. Defaults to 80 for clsp and 443 for clsps
   */
  port: PropTypes.number,
  /**
   * The source url to use for video playback.
   */
  src: PropTypes.string.isRequired,
  /**
   * The name of the stream
   */
  title: PropTypes.string.isRequired,
  /**
   * Protocol of the video stream
   */
  type: PropTypes.oneOf(["clsp", "clsps"])
};
const HLSPlayer = (Kt) => {
  const {
    src: uo,
    autoplay: ho = !0,
    controls: go = !1,
    config: bo = {},
    width: vo = "auto",
    height: Po = "auto",
    title: Co,
    slots: So = {},
    childPlacement: wo = "overlay",
    children: Eo
  } = Kt || {}, {
    title: Ro = {}
  } = So || {};
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-hlsplayer", { "data-testid": "alc-hlsplayer", children: [
    is_1.string(Co) && !is_1.empty(Co) && /* @__PURE__ */ jsxRuntimeExports.jsx(Title, { ...Ro, title: Co }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-hlsplayer-video-container", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        ReactHlsPlayer,
        {
          src: uo,
          autoPlay: ho,
          controls: go,
          hlsConfig: bo,
          width: vo,
          height: Po
        }
      ),
      !is_1.undefined(Eo) && !is_1.empty(Eo) && wo === "overlay" && /* @__PURE__ */ jsxRuntimeExports.jsx("alc-hlsplayer-overlay", { children: Eo })
    ] }),
    !is_1.undefined(Eo) && !is_1.empty(Eo) && wo === "bottom" && Eo
  ] });
};
HLSPlayer.propTypes = {
  /**
   * The source url to use for video playback.
   */
  src: PropTypes.string.isRequired,
  /**
   * Indicates that the video should play immediately when it's available.
   *
   * Defaults to true.
   */
  autoplay: PropTypes.bool,
  /**
   * Determines if video controls will be shown.
   *
   * Defaults to false.
   */
  controls: PropTypes.bool,
  /**
   * Fine-tuning configurations to pass to the player.
   *
   * See https://github.com/video-dev/hls.js/blob/master/docs/API.md#autostartload for details.
   * Defaults to {}.
   */
  config: PropTypes.object,
  /**
   * The height for the player.
   *
   * Defaults to 'auto'.
   */
  height: PropTypes.string,
  /**
   * The width for the player.
   *
   * Defaults to 'auto'.
   */
  width: PropTypes.string,
  /**
   * A title to display over the video.
   */
  title: PropTypes.string,
  /**
   * Indicates where children should be placed when rendered.
   */
  childPlacement: PropTypes.oneOf(["overlay", "bottom"]),
  /**
   * Attributes to pass to inner components.
   * - title: Attributes to pass to the Title component.
   */
  slots: PropTypes.shape({
    title: PropTypes.object
  })
};
const Video = (Kt) => {
  const {
    type: uo,
    ...ho
  } = Kt, go = (bo) => {
    switch (bo) {
      case "hls":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(HLSPlayer, { ...ho });
      case "clsp":
      case "clsps":
        return /* @__PURE__ */ jsxRuntimeExports.jsx(CLSPPlayer, { ...ho });
      default:
        return null;
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-video", { children: go(uo) });
};
Video.propTypes = {
  /**
   * The source url to use for video playback.
  */
  src: PropTypes.string.isRequired,
  /**
    * Title of the video
  */
  title: PropTypes.string,
  /**
    * Protocol of the video stream.
    * Depending on the type selected, additional props required for each player is required.
    * See each player component docs for details
  */
  type: PropTypes.oneOf([
    "clsp",
    "clsps",
    "hls"
  ]).isRequired
};
const VideoContainer = (Kt) => {
  const {
    badge: uo = !0,
    children: ho,
    closeIcon: go = !0,
    containerColor: bo = "var(--vp-dark-blue)",
    handleClose: vo,
    textColor: Po = "var(--vp-white)",
    textFont: Co = "var(--vp-font-open-sans-condensed-bold)",
    title: So,
    videoNumber: wo
  } = Kt;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(
    "alc-video-container",
    {
      "data-testid": "video-container",
      style: {
        backgroundColor: bo,
        color: Po,
        fontFamily: Co
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("header", { children: [
          uo && /* @__PURE__ */ jsxRuntimeExports.jsx(
            Badge,
            {
              type: "single-square",
              badgeTextColor: "var(--vp-dark-blue)",
              badgeColor: "var(--vp-secondary-orange)",
              badge: wo,
              label: `Video Number ${wo}`
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: So }),
          go && /* @__PURE__ */ jsxRuntimeExports.jsx(
            "button",
            {
              "aria-label": `Close Video: ${So}`,
              title: `Close Video: ${So}`,
              onClick: vo,
              children: /* @__PURE__ */ jsxRuntimeExports.jsx("i", { className: "fa-solid fa-circle-x", style: { color: Po } })
            }
          )
        ] }),
        ho
      ]
    }
  );
};
VideoContainer.propTypes = {
  /**
   * Set if badge icon is displayed
   */
  badge: PropTypes.bool,
  /**
   * The content passed as children (slots)
   */
  children: PropTypes.node,
  /**
   * Set if X icon renders in top right
   */
  closeIcon: PropTypes.bool,
  /**
   * The background color for the container
   */
  containerColor: PropTypes.string,
  /**
   * Callback when the close button is clicked
   */
  handleClose: PropTypes.func,
  /**
   * The text color of the header of the container
   */
  textColor: PropTypes.string,
  /**
   * The text font of the header of the container
   */
  textFont: PropTypes.string,
  /**
  * The title of the video
  */
  title: PropTypes.string,
  /**
  * The number shown in the badge. Meant to tie the video stream with the corresponding video title in a list
  */
  videoNumber: PropTypes.number
};
function getSwitchUtilityClass(Kt) {
  return generateUtilityClass$1("MuiSwitch", Kt);
}
const switchClasses = generateUtilityClasses$1("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), useUtilityClasses$5 = (Kt) => {
  const {
    classes: uo,
    edge: ho,
    size: go,
    color: bo,
    checked: vo,
    disabled: Po
  } = Kt, Co = {
    root: ["root", ho && `edge${capitalize(ho)}`, `size${capitalize(go)}`],
    switchBase: ["switchBase", `color${capitalize(bo)}`, vo && "checked", Po && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, So = composeClasses(Co, getSwitchUtilityClass, uo);
  return {
    ...uo,
    // forward the disabled and checked classes to the SwitchBase
    ...So
  };
}, SwitchRoot = styled("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, ho.edge && uo[`edge${capitalize(ho.edge)}`], uo[`size${capitalize(ho.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${switchClasses.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${switchClasses.switchBase}`]: {
        padding: 4,
        [`&.${switchClasses.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), SwitchSwitchBase = styled(SwitchBase, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.switchBase, {
      [`& .${switchClasses.input}`]: uo.input
    }, ho.color !== "default" && uo[`color${capitalize(ho.color)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: Kt.vars ? Kt.vars.palette.Switch.defaultColor : `${Kt.palette.mode === "light" ? Kt.palette.common.white : Kt.palette.grey[300]}`,
  transition: Kt.transitions.create(["left", "transform"], {
    duration: Kt.transitions.duration.shortest
  }),
  [`&.${switchClasses.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${switchClasses.disabled}`]: {
    color: Kt.vars ? Kt.vars.palette.Switch.defaultDisabledColor : `${Kt.palette.mode === "light" ? Kt.palette.grey[100] : Kt.palette.grey[600]}`
  },
  [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses.disabled} + .${switchClasses.track}`]: {
    opacity: Kt.vars ? Kt.vars.opacity.switchTrackDisabled : `${Kt.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${switchClasses.input}`]: {
    left: "-100%",
    width: "300%"
  }
})), memoTheme(({
  theme: Kt
}) => ({
  "&:hover": {
    backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette.action.activeChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette.action.active, Kt.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(Kt.palette).filter(createSimplePaletteValueFilter(["light"])).map(([uo]) => ({
    props: {
      color: uo
    },
    style: {
      [`&.${switchClasses.checked}`]: {
        color: (Kt.vars || Kt).palette[uo].main,
        "&:hover": {
          backgroundColor: Kt.vars ? `rgba(${Kt.vars.palette[uo].mainChannel} / ${Kt.vars.palette.action.hoverOpacity})` : alpha$1(Kt.palette[uo].main, Kt.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${switchClasses.disabled}`]: {
          color: Kt.vars ? Kt.vars.palette.Switch[`${uo}DisabledColor`] : `${Kt.palette.mode === "light" ? lighten(Kt.palette[uo].main, 0.62) : darken(Kt.palette[uo].main, 0.55)}`
        }
      },
      [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
        backgroundColor: (Kt.vars || Kt).palette[uo].main
      }
    }
  }))]
}))), SwitchTrack = styled("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (Kt, uo) => uo.track
})(memoTheme(({
  theme: Kt
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: Kt.transitions.create(["opacity", "background-color"], {
    duration: Kt.transitions.duration.shortest
  }),
  backgroundColor: Kt.vars ? Kt.vars.palette.common.onBackground : `${Kt.palette.mode === "light" ? Kt.palette.common.black : Kt.palette.common.white}`,
  opacity: Kt.vars ? Kt.vars.opacity.switchTrack : `${Kt.palette.mode === "light" ? 0.38 : 0.3}`
}))), SwitchThumb = styled("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (Kt, uo) => uo.thumb
})(memoTheme(({
  theme: Kt
}) => ({
  boxShadow: (Kt.vars || Kt).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
}))), Switch = /* @__PURE__ */ React$1.forwardRef(function Kt(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiSwitch"
  }), {
    className: bo,
    color: vo = "primary",
    edge: Po = !1,
    size: Co = "medium",
    sx: So,
    ...wo
  } = go, Eo = {
    ...go,
    color: vo,
    edge: Po,
    size: Co
  }, Ro = useUtilityClasses$5(Eo), _o = /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchThumb, {
    className: Ro.thumb,
    ownerState: Eo
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(SwitchRoot, {
    className: clsx(Ro.root, bo),
    sx: So,
    ownerState: Eo,
    children: [/* @__PURE__ */ jsxRuntimeExports.jsx(SwitchSwitchBase, {
      type: "checkbox",
      icon: _o,
      checkedIcon: _o,
      ref: ho,
      ownerState: Eo,
      ...wo,
      classes: {
        ...Ro,
        root: Ro.switchBase
      }
    }), /* @__PURE__ */ jsxRuntimeExports.jsx(SwitchTrack, {
      className: Ro.track,
      ownerState: Eo
    })]
  });
});
process.env.NODE_ENV !== "production" && (Switch.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: PropTypes.oneOfType([PropTypes.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), PropTypes.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: PropTypes.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: PropTypes.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: PropTypes.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: PropTypes.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,
  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: PropTypes.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: PropTypes.oneOfType([PropTypes.oneOf(["medium", "small"]), PropTypes.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: PropTypes.any
});
const Toggle = (Kt) => {
  const {
    checked: uo,
    disabled: ho = !1,
    handleChange: go,
    label: bo,
    labelColor: vo = "var(--vp-skyline-blue)",
    labelPlacement: Po = "start",
    noText: Co = !1,
    ...So
  } = Kt;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-toggle", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    FormControlLabel,
    {
      className: Co ? "no-text" : "",
      label: bo,
      labelPlacement: Po,
      style: {
        color: vo
      },
      control: /* @__PURE__ */ jsxRuntimeExports.jsx(
        Switch,
        {
          checked: uo,
          onChange: go,
          disabled: ho,
          ...So,
          "data-testid": "toggle"
        }
      )
    }
  ) });
};
Toggle.propTypes = {
  /**
   * Tracks checked state of the toggle
   */
  checked: PropTypes.bool,
  /**
   * Sets if the toggle is disabled
   */
  disabled: PropTypes.bool,
  /**
   * Callback function when state of toggle changes
   */
  handleChange: PropTypes.func,
  /**
   * Rendered label for the toggle
   */
  label: PropTypes.string,
  /**
   * Color of the label
   */
  labelColor: PropTypes.string,
  /**
   * Positioning of label
   */
  labelPlacement: PropTypes.oneOf([
    "top",
    "start",
    "bottom",
    "end"
  ]),
  /**
   * Sets if On/Off text is rendered within the track
   */
  noText: PropTypes.bool
};
const DetailList = (Kt) => {
  const {
    keyValuePair: uo
  } = Kt, ho = (go) => {
    const bo = [];
    for (const [vo, Po] of Object.entries(go))
      bo.push(
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs("dt", { id: vo.replace(/ /g, "-"), children: [
            vo,
            ":"
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("dd", { "aria-labelledby": vo.replace(/ /g, "-"), children: Po })
        ] }, `${vo}-${Po}`)
      );
    return bo;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-detail-list", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("dl", { children: ho(uo) }) });
};
DetailList.propTypes = {
  /**
   * An object containing the item label as keys and the details as the value.
   * The details can either be a string or an element/node.
   */
  keyValuePair: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  ).isRequired
};
const StepperContext = /* @__PURE__ */ React$1.createContext({});
process.env.NODE_ENV !== "production" && (StepperContext.displayName = "StepperContext");
const StepContext = /* @__PURE__ */ React$1.createContext({});
process.env.NODE_ENV !== "production" && (StepContext.displayName = "StepContext");
function getStepUtilityClass(Kt) {
  return generateUtilityClass$1("MuiStep", Kt);
}
generateUtilityClasses$1("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]);
const useUtilityClasses$4 = (Kt) => {
  const {
    classes: uo,
    orientation: ho,
    alternativeLabel: go,
    completed: bo
  } = Kt;
  return composeClasses({
    root: ["root", ho, go && "alternativeLabel", bo && "completed"]
  }, getStepUtilityClass, uo);
}, StepRoot = styled("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.orientation], ho.alternativeLabel && uo.alternativeLabel, ho.completed && uo.completed];
  }
})({
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      paddingLeft: 8,
      paddingRight: 8
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      flex: 1,
      position: "relative"
    }
  }]
}), Step = /* @__PURE__ */ React$1.forwardRef(function Kt(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiStep"
  }), {
    active: bo,
    children: vo,
    className: Po,
    component: Co = "div",
    completed: So,
    disabled: wo,
    expanded: Eo = !1,
    index: Ro,
    last: _o,
    ...Io
  } = go, {
    activeStep: Ao,
    connector: Oo,
    alternativeLabel: jo,
    orientation: Do,
    nonLinear: Lo
  } = React$1.useContext(StepperContext);
  let [ko = !1, Ko = !1, No = !1] = [bo, So, wo];
  Ao === Ro ? ko = bo !== void 0 ? bo : !0 : !Lo && Ao > Ro ? Ko = So !== void 0 ? So : !0 : !Lo && Ao < Ro && (No = wo !== void 0 ? wo : !0);
  const Jo = React$1.useMemo(() => ({
    index: Ro,
    last: _o,
    expanded: Eo,
    icon: Ro + 1,
    active: ko,
    completed: Ko,
    disabled: No
  }), [Ro, _o, Eo, ko, Ko, No]), ti = {
    ...go,
    active: ko,
    orientation: Do,
    alternativeLabel: jo,
    completed: Ko,
    disabled: No,
    expanded: Eo,
    component: Co
  }, oi = useUtilityClasses$4(ti), Qo = /* @__PURE__ */ jsxRuntimeExports.jsxs(StepRoot, {
    as: Co,
    className: clsx(oi.root, Po),
    ref: ho,
    ownerState: ti,
    ...Io,
    children: [Oo && jo && Ro !== 0 ? Oo : null, vo]
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepContext.Provider, {
    value: Jo,
    children: Oo && !jo && Ro !== 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs(React$1.Fragment, {
      children: [Oo, Qo]
    }) : Qo
  });
});
process.env.NODE_ENV !== "production" && (Step.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: PropTypes.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: PropTypes.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: integerPropType,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const CheckCircle = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), Warning = createSvgIcon(/* @__PURE__ */ jsxRuntimeExports.jsx("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function getStepIconUtilityClass(Kt) {
  return generateUtilityClass$1("MuiStepIcon", Kt);
}
const stepIconClasses = generateUtilityClasses$1("MuiStepIcon", ["root", "active", "completed", "error", "text"]);
var _circle;
const useUtilityClasses$3 = (Kt) => {
  const {
    classes: uo,
    active: ho,
    completed: go,
    error: bo
  } = Kt;
  return composeClasses({
    root: ["root", ho && "active", go && "completed", bo && "error"],
    text: ["text"]
  }, getStepIconUtilityClass, uo);
}, StepIconRoot = styled(SvgIcon, {
  name: "MuiStepIcon",
  slot: "Root",
  overridesResolver: (Kt, uo) => uo.root
})(memoTheme(({
  theme: Kt
}) => ({
  display: "block",
  transition: Kt.transitions.create("color", {
    duration: Kt.transitions.duration.shortest
  }),
  color: (Kt.vars || Kt).palette.text.disabled,
  [`&.${stepIconClasses.completed}`]: {
    color: (Kt.vars || Kt).palette.primary.main
  },
  [`&.${stepIconClasses.active}`]: {
    color: (Kt.vars || Kt).palette.primary.main
  },
  [`&.${stepIconClasses.error}`]: {
    color: (Kt.vars || Kt).palette.error.main
  }
}))), StepIconText = styled("text", {
  name: "MuiStepIcon",
  slot: "Text",
  overridesResolver: (Kt, uo) => uo.text
})(memoTheme(({
  theme: Kt
}) => ({
  fill: (Kt.vars || Kt).palette.primary.contrastText,
  fontSize: Kt.typography.caption.fontSize,
  fontFamily: Kt.typography.fontFamily
}))), StepIcon = /* @__PURE__ */ React$1.forwardRef(function Kt(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiStepIcon"
  }), {
    active: bo = !1,
    className: vo,
    completed: Po = !1,
    error: Co = !1,
    icon: So,
    ...wo
  } = go, Eo = {
    ...go,
    active: bo,
    completed: Po,
    error: Co
  }, Ro = useUtilityClasses$3(Eo);
  if (typeof So == "number" || typeof So == "string") {
    const _o = clsx(vo, Ro.root);
    return Co ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepIconRoot, {
      as: Warning,
      className: _o,
      ref: ho,
      ownerState: Eo,
      ...wo
    }) : Po ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepIconRoot, {
      as: CheckCircle,
      className: _o,
      ref: ho,
      ownerState: Eo,
      ...wo
    }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(StepIconRoot, {
      className: _o,
      ref: ho,
      ownerState: Eo,
      ...wo,
      children: [_circle || (_circle = /* @__PURE__ */ jsxRuntimeExports.jsx("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ jsxRuntimeExports.jsx(StepIconText, {
        className: Ro.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: Eo,
        children: So
      })]
    });
  }
  return So;
});
process.env.NODE_ENV !== "production" && (StepIcon.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getStepLabelUtilityClass(Kt) {
  return generateUtilityClass$1("MuiStepLabel", Kt);
}
const stepLabelClasses = generateUtilityClasses$1("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), useUtilityClasses$2 = (Kt) => {
  const {
    classes: uo,
    orientation: ho,
    active: go,
    completed: bo,
    error: vo,
    disabled: Po,
    alternativeLabel: Co
  } = Kt;
  return composeClasses({
    root: ["root", ho, vo && "error", Po && "disabled", Co && "alternativeLabel"],
    label: ["label", go && "active", bo && "completed", vo && "error", Po && "disabled", Co && "alternativeLabel"],
    iconContainer: ["iconContainer", go && "active", bo && "completed", vo && "error", Po && "disabled", Co && "alternativeLabel"],
    labelContainer: ["labelContainer", Co && "alternativeLabel"]
  }, getStepLabelUtilityClass, uo);
}, StepLabelRoot = styled("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.orientation]];
  }
})({
  display: "flex",
  alignItems: "center",
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${stepLabelClasses.disabled}`]: {
    cursor: "default"
  },
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      textAlign: "left",
      padding: "8px 0"
    }
  }]
}), StepLabelLabel = styled("span", {
  name: "MuiStepLabel",
  slot: "Label",
  overridesResolver: (Kt, uo) => uo.label
})(memoTheme(({
  theme: Kt
}) => ({
  ...Kt.typography.body2,
  display: "block",
  transition: Kt.transitions.create("color", {
    duration: Kt.transitions.duration.shortest
  }),
  [`&.${stepLabelClasses.active}`]: {
    color: (Kt.vars || Kt).palette.text.primary,
    fontWeight: 500
  },
  [`&.${stepLabelClasses.completed}`]: {
    color: (Kt.vars || Kt).palette.text.primary,
    fontWeight: 500
  },
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${stepLabelClasses.error}`]: {
    color: (Kt.vars || Kt).palette.error.main
  }
}))), StepLabelIconContainer = styled("span", {
  name: "MuiStepLabel",
  slot: "IconContainer",
  overridesResolver: (Kt, uo) => uo.iconContainer
})({
  flexShrink: 0,
  display: "flex",
  paddingRight: 8,
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    paddingRight: 0
  }
}), StepLabelLabelContainer = styled("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer",
  overridesResolver: (Kt, uo) => uo.labelContainer
})(memoTheme(({
  theme: Kt
}) => ({
  width: "100%",
  color: (Kt.vars || Kt).palette.text.secondary,
  [`&.${stepLabelClasses.alternativeLabel}`]: {
    textAlign: "center"
  }
}))), StepLabel = /* @__PURE__ */ React$1.forwardRef(function Kt(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiStepLabel"
  }), {
    children: bo,
    className: vo,
    componentsProps: Po = {},
    error: Co = !1,
    icon: So,
    optional: wo,
    slots: Eo = {},
    slotProps: Ro = {},
    StepIconComponent: _o,
    StepIconProps: Io,
    ...Ao
  } = go, {
    alternativeLabel: Oo,
    orientation: jo
  } = React$1.useContext(StepperContext), {
    active: Do,
    disabled: Lo,
    completed: ko,
    icon: Ko
  } = React$1.useContext(StepContext), No = So || Ko;
  let Jo = _o;
  No && !Jo && (Jo = StepIcon);
  const ti = {
    ...go,
    active: Do,
    alternativeLabel: Oo,
    completed: ko,
    disabled: Lo,
    error: Co,
    orientation: jo
  }, oi = useUtilityClasses$2(ti), Qo = {
    slots: Eo,
    slotProps: {
      stepIcon: Io,
      ...Po,
      ...Ro
    }
  }, [Zo, ei] = useSlot("label", {
    elementType: StepLabelLabel,
    externalForwardedProps: Qo,
    ownerState: ti
  }), [ii, ai] = useSlot("stepIcon", {
    elementType: Jo,
    externalForwardedProps: Qo,
    ownerState: ti
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StepLabelRoot, {
    className: clsx(oi.root, vo),
    ref: ho,
    ownerState: ti,
    ...Ao,
    children: [No || ii ? /* @__PURE__ */ jsxRuntimeExports.jsx(StepLabelIconContainer, {
      className: oi.iconContainer,
      ownerState: ti,
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(ii, {
        completed: ko,
        active: Do,
        error: Co,
        icon: No,
        ...ai
      })
    }) : null, /* @__PURE__ */ jsxRuntimeExports.jsxs(StepLabelLabelContainer, {
      className: oi.labelContainer,
      ownerState: ti,
      children: [bo ? /* @__PURE__ */ jsxRuntimeExports.jsx(Zo, {
        ...ei,
        className: clsx(oi.label, ei == null ? void 0 : ei.className),
        children: bo
      }) : null, wo]
    })]
  });
});
process.env.NODE_ENV !== "production" && (StepLabel.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The props used for each slot inside.
   * @default {}
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  componentsProps: PropTypes.shape({
    label: PropTypes.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: PropTypes.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: PropTypes.node,
  /**
   * The optional node to display.
   */
  optional: PropTypes.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
    stepIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: PropTypes.shape({
    label: PropTypes.elementType,
    stepIcon: PropTypes.elementType
  }),
  /**
   * The component to render in place of the [`StepIcon`](https://mui.com/material-ui/api/step-icon/).
   * @deprecated Use `slots.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconComponent: PropTypes.elementType,
  /**
   * Props applied to the [`StepIcon`](https://mui.com/material-ui/api/step-icon/) element.
   * @deprecated Use `slotProps.stepIcon` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */
  StepIconProps: PropTypes.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
StepLabel.muiName = "StepLabel";
function getStepConnectorUtilityClass(Kt) {
  return generateUtilityClass$1("MuiStepConnector", Kt);
}
generateUtilityClasses$1("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]);
const useUtilityClasses$1 = (Kt) => {
  const {
    classes: uo,
    orientation: ho,
    alternativeLabel: go,
    active: bo,
    completed: vo,
    disabled: Po
  } = Kt, Co = {
    root: ["root", ho, go && "alternativeLabel", bo && "active", vo && "completed", Po && "disabled"],
    line: ["line", `line${capitalize(ho)}`]
  };
  return composeClasses(Co, getStepConnectorUtilityClass, uo);
}, StepConnectorRoot = styled("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.orientation], ho.alternativeLabel && uo.alternativeLabel, ho.completed && uo.completed];
  }
})({
  flex: "1 1 auto",
  variants: [{
    props: {
      orientation: "vertical"
    },
    style: {
      marginLeft: 12
      // half icon
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      position: "absolute",
      top: 12,
      left: "calc(-50% + 20px)",
      right: "calc(50% + 20px)"
    }
  }]
}), StepConnectorLine = styled("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.line, uo[`line${capitalize(ho.orientation)}`]];
  }
})(memoTheme(({
  theme: Kt
}) => {
  const uo = Kt.palette.mode === "light" ? Kt.palette.grey[400] : Kt.palette.grey[600];
  return {
    display: "block",
    borderColor: Kt.vars ? Kt.vars.palette.StepConnector.border : uo,
    variants: [{
      props: {
        orientation: "horizontal"
      },
      style: {
        borderTopStyle: "solid",
        borderTopWidth: 1
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
      }
    }]
  };
})), StepConnector = /* @__PURE__ */ React$1.forwardRef(function Kt(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiStepConnector"
  }), {
    className: bo,
    ...vo
  } = go, {
    alternativeLabel: Po,
    orientation: Co = "horizontal"
  } = React$1.useContext(StepperContext), {
    active: So,
    disabled: wo,
    completed: Eo
  } = React$1.useContext(StepContext), Ro = {
    ...go,
    alternativeLabel: Po,
    orientation: Co,
    active: So,
    completed: Eo,
    disabled: wo
  }, _o = useUtilityClasses$1(Ro);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepConnectorRoot, {
    className: clsx(_o.root, bo),
    ref: ho,
    ownerState: Ro,
    ...vo,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(StepConnectorLine, {
      className: _o.line,
      ownerState: Ro
    })
  });
});
process.env.NODE_ENV !== "production" && (StepConnector.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
function getStepperUtilityClass(Kt) {
  return generateUtilityClass$1("MuiStepper", Kt);
}
generateUtilityClasses$1("MuiStepper", ["root", "horizontal", "vertical", "nonLinear", "alternativeLabel"]);
const useUtilityClasses = (Kt) => {
  const {
    orientation: uo,
    nonLinear: ho,
    alternativeLabel: go,
    classes: bo
  } = Kt;
  return composeClasses({
    root: ["root", uo, ho && "nonLinear", go && "alternativeLabel"]
  }, getStepperUtilityClass, bo);
}, StepperRoot = styled("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (Kt, uo) => {
    const {
      ownerState: ho
    } = Kt;
    return [uo.root, uo[ho.orientation], ho.alternativeLabel && uo.alternativeLabel, ho.nonLinear && uo.nonLinear];
  }
})({
  display: "flex",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      flexDirection: "row",
      alignItems: "center"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      flexDirection: "column"
    }
  }, {
    props: {
      alternativeLabel: !0
    },
    style: {
      alignItems: "flex-start"
    }
  }]
}), defaultConnector = /* @__PURE__ */ jsxRuntimeExports.jsx(StepConnector, {}), Stepper$1 = /* @__PURE__ */ React$1.forwardRef(function Kt(uo, ho) {
  const go = useDefaultProps({
    props: uo,
    name: "MuiStepper"
  }), {
    activeStep: bo = 0,
    alternativeLabel: vo = !1,
    children: Po,
    className: Co,
    component: So = "div",
    connector: wo = defaultConnector,
    nonLinear: Eo = !1,
    orientation: Ro = "horizontal",
    ..._o
  } = go, Io = {
    ...go,
    nonLinear: Eo,
    alternativeLabel: vo,
    orientation: Ro,
    component: So
  }, Ao = useUtilityClasses(Io), Oo = React$1.Children.toArray(Po).filter(Boolean), jo = Oo.map((Lo, ko) => /* @__PURE__ */ React$1.cloneElement(Lo, {
    index: ko,
    last: ko + 1 === Oo.length,
    ...Lo.props
  })), Do = React$1.useMemo(() => ({
    activeStep: bo,
    alternativeLabel: vo,
    connector: wo,
    nonLinear: Eo,
    orientation: Ro
  }), [bo, vo, wo, Eo, Ro]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(StepperContext.Provider, {
    value: Do,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(StepperRoot, {
      as: So,
      ownerState: Io,
      className: clsx(Ao.root, Co),
      ref: ho,
      ..._o,
      children: jo
    })
  });
});
process.env.NODE_ENV !== "production" && (Stepper$1.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: integerPropType,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: PropTypes.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: PropTypes.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: PropTypes.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
});
const Stepper = (Kt) => {
  const {
    cancelButton: uo,
    finalButton: ho,
    hasSummaryStep: go = !0,
    showLabel: bo,
    steps: vo,
    isDisabled: Po,
    onStepChange: Co
  } = Kt, [So, wo] = useState(0), Eo = () => {
    document.activeElement.blur();
    const Io = So + 1;
    wo(Io), Co(Io);
  }, Ro = () => {
    document.activeElement.blur();
    const Io = So - 1;
    wo(Io), Co(Io);
  }, _o = go ? vo.length - 1 : vo.length;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("alc-stepper", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Stepper$1, { activeStep: So, alternativeLabel: !0, children: vo.slice(0, _o).map((Io, Ao) => /* @__PURE__ */ jsxRuntimeExports.jsx(Step, { "data-testid": "step", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(StepLabel, { children: [
      " ",
      bo && Io.label,
      " "
    ] }) }, Ao)) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "step-content", children: vo[So].component }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("nav", { children: [
      So === 0 ? uo : /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          onClick: Ro,
          type: "outlined",
          label: "Back"
        }
      ),
      So === vo.length - 1 ? ho : /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          state: Po ? "disabled" : "default",
          variant: "contained",
          onClick: Eo,
          type: "filled",
          label: "Next"
        }
      )
    ] })
  ] });
};
Stepper.propTypes = {
  /**
   * The button that is used to stop stepper
   */
  cancelButton: PropTypes.node,
  /**
   * The button that is used for the final step
   */
  finalButton: PropTypes.node,
  /**
   * If current steps next button is disabled
   */
  isDisabled: PropTypes.bool,
  /**
   * Whether the last step is a summary page or just last step
   */
  hasSummaryStep: PropTypes.bool,
  /**
   * The function on when the step has changed
   */
  onStepChange: PropTypes.func,
  /**
   * Whether to show label under step
   */
  showLabel: PropTypes.bool,
  /**
   * The steps that is being passed with step name and component name
   */
  steps: PropTypes.arrayOf(PropTypes.shape({
    /**
     * The content that is in the step
     */
    component: PropTypes.node,
    /**
     * Name displayed under the steps progress bar
     */
    label: PropTypes.string
  }))
};
const usePagination = () => {
  const Kt = useRef(Number.NaN), uo = useRef(), ho = useRef({});
  return useRef({
    /**
     * Performs the calculations for creating the pages array and sets the array up.
     * 
     * @param {object} options An object to assist in configure the walker.
     * @param {number} totalPages The number of pages to generate.
     * @param {number} viewportSize The size / width of the viewport.
     */
    setup(bo = {}) {
      let {
        totalPages: vo,
        viewportSize: Po = 5
      } = bo ?? {};
      vo = ensureIsNumber(vo, 0), ho.current.walker = null, ho.current.walker = new ArrayWalker();
      const Co = range$4({ endAt: vo });
      ho.current.walker.setArray(Co, !0), ho.current.size = ensureIsOddNumber(ensureIsNumber(Po, 5)), ho.current.viewportMiddleIndex = Math.floor(ho.current.size / 2), ho.current.indexBreakPoint = ho.current.walker.size - 1 - ho.current.viewportMiddleIndex, ho.current.viewport = ho.current.walker.viewport(ho.current.size), ho.current.pages = Co, ho.current.lastPage = vo;
    },
    /**
     * Returns the viewport array.
     * 
     * If the current walker index pointer has not exceeded the middle of the viewport index, then the viewport
     * does not change. If the pointer is beyond the middle of the viewport index, and has changed, then get a new
     * viewport. If the pointer is beyond the middle of the viewport index but the pointer has not changed, then
     * return the latest viewport.
     * 
     * @returns {any[]}
     */
    getViewport() {
      const {
        walker: bo,
        viewport: vo,
        indexBreakPoint: Po,
        viewportMiddleIndex: Co,
        size: So
      } = ho.current;
      if (bo.size <= So)
        return vo;
      if (bo.pointer < Co)
        return ho.current.viewport = bo.viewport(So, { adjustPointer: -bo.pointer }), ho.current.viewport;
      if (bo.pointer < Po)
        return ho.current.viewport = bo.viewport(So, { adjustPointer: -Co }), ho.current.viewport;
      const wo = bo.pointer - Po;
      return wo > -1 ? (ho.current.viewport = bo.viewport(So, { adjustPointer: -(Co + wo) }), ho.current.viewport) : vo;
    },
    /**
     * Move the walker internal pointer to point to the requested page.
     * 
     * @returns {void}
     */
    goToPage(bo) {
      ho.current.walker.goToIndex(Math.max(ensureIsNumber(bo, 1) - 1, 0));
    },
    /**
     * Returns the page number currently pointed at by the walker internal index pointer.
     * 
     * @returns {number}
     */
    getPage() {
      return ho.current.walker.value;
    },
    /**
     * Accessor.
     * 
     * Returns the value of the lastPage reference.
     * 
     * @returns {number}
     */
    lastPage() {
      return ho.current.lastPage;
    },
    /**
     * Setter.
     * 
     * Sets the value of the lastPage reference.
     * If the value passed in is not a number, the value of the lastPage reference will be set to Number.NaN.
     * 
     * @property
     * @param {number} value The value to set the lastPage reference.
     */
    setlastPage(bo) {
      if (!is_1.number(bo)) {
        Kt.current = Number.NaN;
        return;
      }
      Kt.current = Math.max(bo, 1);
    },
    /**
     * Accessor.
     * 
     * Returns the current value for the items reference.
     * 
     * @returns {any[] | null}
     */
    get items() {
      return uo.current;
    },
    /**
     * Setter.
     * 
     * Sets the value for the items reference.
     * 
     * The property expects an array. If an array is not provided, then the value for the items reference is set to
     * null.
     * 
     * @param {array} value The array to store in the items reference.
     * @returns {void}
     */
    set items(bo) {
      if (!is_1.array(bo)) {
        uo.current = null;
        return;
      }
      uo.current = bo;
    }
  }).current;
}, log = new Logger({ name: "useClientSideSearch " }), useClientSideSearch = (Kt, uo, ho) => {
  const go = usePagination(), bo = useRef({}), vo = useRef([]), Po = useRef(null), [Co, So] = useState(null);
  if (bo.current.results = Co, bo.current.setLocalStore = (wo) => {
    if (is_1.array(wo)) {
      vo.current = wo;
      return;
    }
    vo.current = [];
  }, ho != null && ho.enabled && (ho.onPageChange = (wo, Eo) => {
    if (is_1.nil(wo)) {
      So([]);
      return;
    }
    const Ro = Po.current.slice(wo, Eo);
    So(Ro);
  }, ho.pagination = go), !is_1.function(bo.current.doHandleSearch)) {
    let wo = function(Ro, _o) {
      var Oo;
      const Io = is_1.undefined((Oo = _o == null ? void 0 : _o.target) == null ? void 0 : Oo.value) ? Ro : _o.target.value;
      if (is_1.undefined(Io) || is_1.empty(Io)) {
        So(null);
        return;
      }
      const Ao = eventEnterKeyReleased(_o) && is_1.function(Kt) ? Kt(Io) : vo.current.filter((jo) => uo(jo, Io));
      if (is_1.function(Ao == null ? void 0 : Ao.then)) {
        Ao.then((jo) => {
          vo.current = jo, bo.current.totalResults = is_1.array(jo) ? jo.length : 0, Eo(jo);
        });
        return;
      }
      bo.current.totalResults = is_1.array(Ao) ? Ao.length : 0, Eo(Ao);
    }, Eo = function(Ro) {
      if (!(ho != null && ho.enabled)) {
        if (is_1.array(Ro)) {
          So(Ro);
          return;
        }
        So(Ro);
        return;
      }
      if (!is_1.array(Ro) | is_1.empty(Ro)) {
        log.warn("Did not receive an array from search result or did not receive any matches."), ho == null || ho.onPageChange(null);
        return;
      }
      Po.current = Ro;
      const _o = clamp(ensureIsNumber(ho == null ? void 0 : ho.itemsPerPage, 5), { minimum: 1 }), Io = Math.ceil(Ro.length / _o), Ao = clamp(ensureIsNumber(ho == null ? void 0 : ho.viewportSize, 5), { minimum: 1 });
      go.setup({ totalPages: Io, viewportSize: Ao }, !0);
      const Oo = go.getPage(), jo = (Oo - 1) * _o, Do = jo + _o;
      ho == null || ho.onPageChange(jo, Do, Oo);
    };
    bo.current.doHandleSearch = wo;
  }
  return bo.current;
}, SearchExistingField = ({
  fieldName: Kt,
  newFieldForm: uo,
  formData: ho,
  setFormData: go,
  required: bo,
  fetchData: vo,
  modalHeader: Po,
  ...Co
}) => {
  const [So, wo] = useState(!0), [Eo, Ro] = useState(() => ho || {}), _o = () => !!(is_1.object(Eo) && Eo.name && Eo.id), Io = _o(), Ao = useRef([]), Oo = {
    alignment: "right-aligned",
    enabled: !0,
    itemsPerPage: 5,
    viewportSize: 5
  };
  useEffect(() => {
    (async () => {
      try {
        const Zo = await vo();
        if (Zo && Zo.data) {
          const { data: ei, error: ii } = Zo;
          Ao.current.length == 0 && Ao.current.push(...ei), ii && console.warn(ii);
        }
      } catch (Zo) {
        console.error("Error fetching data:", Zo);
      }
    })();
    const Qo = _o();
    go(Eo, Qo);
  }, [Eo]), useEffect(() => {
    !is_1.empty(Co.newlyCreatedItem) && !is_1.null(Co.newlyCreatedItem) && (Ro(Co.newlyCreatedItem), wo(!1));
  }, [Co.newlyCreatedItem]);
  const jo = (oi) => {
    ti(oi), wo(!1);
  }, Do = (oi) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "list-item", children: oi.name }), {
    results: Lo,
    doHandleSearch: ko,
    totalResults: Ko,
    setLocalStore: No
  } = useClientSideSearch(
    null,
    (oi, Qo) => {
      var ei;
      wo(!0);
      const Zo = (ei = oi.name) == null ? void 0 : ei.toLowerCase();
      return Qo ? Zo.includes(Qo.toLowerCase()) : !1;
    },
    Oo
  ), Jo = () => Ro({}), ti = (oi) => Ro(oi);
  return useEffect(() => {
    No ? No(Ao.current) : console.warn("setLocalStore is not available on the server");
  }, [No]), /* @__PURE__ */ jsxRuntimeExports.jsx(
    SearchBar,
    {
      identifier: toCamelCase(Kt),
      enableFilterOnInput: !0,
      filterStartLength: 0,
      handleSearch: ko,
      placeholder: `Search Existing ${Kt}s`,
      noResultsText: "No matching records found",
      required: bo,
      results: So ? Lo : null,
      resultsItem: Do,
      searchDelay: 0,
      gridElement: !is_1.undefined(Eo) && is_1.undefined(Eo.id) && is_1.undefined(Eo.name) && !is_1.undefined(uo) && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "create-new-field", children: [
        "Or ",
        " ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          Modal,
          {
            className: `new${Kt}Modal`,
            closeIcon: !0,
            header: Po ?? `Create New ${Kt}`,
            trigger: ({ handleOpen: oi }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
              Button$1,
              {
                iconLeft: "fa-solid fa-circle-plus",
                label: `Create New ${Kt}`,
                state: "default",
                type: "text",
                onClick: oi
              }
            ),
            slots: {
              content: (oi) => uo(oi)
            },
            disableBackdropClick: !0
          }
        )
      ] }),
      slots: {
        resultsTitle: {
          className: "results-title"
        }
      },
      endAdornment: Io ? {
        label: `Click to Remove Selected ${Kt}`,
        title: `Remove Selected ${Kt}`,
        handleAdornmentClick: (oi) => {
          oi.preventDefault(), Jo(), ko("");
        },
        iconName: "fa-solid fa-trash-can"
      } : null,
      totalResults: Ko,
      disabled: Io,
      selectedResult: Eo.name,
      inputBackgroundColor: Io ? "var(--vp-bg-soft-blue)" : "var(--vp-bg-grey-blue)",
      onClickResultsItem: jo,
      paginationConfig: Oo,
      resultsMessage: Lo && Lo.length > 1 ? "(Continue typing to further refine the results.)" : "",
      children: Kt
    }
  );
};
SearchExistingField.propTypes = {
  /**
   * Api call to populate the available items used to filter on as the user types
   */
  fetchData: PropTypes.func,
  /**
   * Controls the input label, placeholder message, and Create New button
   */
  fieldName: PropTypes.string,
  /**
   * Form data stored in state other than the item being searched
   */
  formData: PropTypes.object,
  /**
   * The title of the modal
   */
  modalHeader: PropTypes.string,
  /**
   * The item to be displayed on the 'Create New' button click if Create New button is there
  */
  newFieldForm: PropTypes.func,
  /**
   * Whether the input is required or not
   */
  required: PropTypes.bool,
  /**
   * The item selected from the results dropdown
   */
  selectedResult: PropTypes.node,
  /**
   * The setState function
   */
  setFormData: PropTypes.func
};
const ConfirmationModal = (Kt) => {
  const {
    alert: uo = !1,
    cancelText: ho = "No",
    confirmText: go = "Yes",
    content: bo,
    icon: vo,
    handleClose: Po,
    handleConfirm: Co,
    header: So
  } = Kt, wo = (Eo) => {
    const Ro = Eo.split(/(<strong>.*?<\/strong>)/g);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: Ro.map((_o, Io) => {
      if (_o.startsWith("<strong>") && _o.endsWith("</strong>")) {
        const Ao = _o.substring(8, _o.length - 9);
        return /* @__PURE__ */ jsxRuntimeExports.jsx("strong", { children: Ao }, Io);
      } else
        return _o;
    }) });
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("alc-confirm-modal", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "modalContainer", role: "dialog", "aria-modal": "true", tabIndex: -1, children: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: "modal", children: [
    So && /* @__PURE__ */ jsxRuntimeExports.jsxs("h2", { className: "header", children: [
      vo && /* @__PURE__ */ jsxRuntimeExports.jsx("i", { "aria-hidden": "true", className: `$'modalIcon' ${vo}` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: So }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "button",
        {
          onClick: Po,
          className: "closeButton fa-solid fa-circle-xmark",
          "aria-label": "Close"
        }
      )
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: "content", children: typeof bo == "string" ? wo(bo) : bo }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: `footer ${uo && "alertConfirm"}`, children: [
      Po && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          handleClick: Po,
          label: ho
        }
      ),
      Co && /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button$1,
        {
          handleClick: Co,
          label: go,
          type: "filled"
        }
      )
    ] })
  ] }) }) });
};
ConfirmationModal.propTypes = {
  /**
  * Boolean to indicate whether the modal is a type of alert. If true, the confirm button,
  * if provided, will have a red color
  */
  alert: PropTypes.bool,
  /**
  * Text to display for the Cancel Button
  */
  cancelText: PropTypes.string,
  /**
  * Text to display for the Confirm Button
  */
  confirmText: PropTypes.string,
  /**
  * Text to display in the modal content. If bold text is needed, add <strong></strong> around the
  * text the requires boldening
  */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
  * Icon to display in the header
  */
  icon: PropTypes.string,
  /**
  * Callback on a cancel
  */
  handleClose: PropTypes.func,
  /**
  * Callback on a confirm
  */
  handleConfirm: PropTypes.func,
  /**
  * Text to display for the header
  */
  header: PropTypes.string
};
export {
  ActionsMenu,
  Badge,
  Button$1 as Button,
  CLSPPlayer,
  ConfirmationModal,
  DetailList,
  Form,
  HorizontalBar,
  Input$1 as Input,
  Modal,
  SearchBar,
  SearchExistingField,
  Select,
  Slot,
  Stepper,
  TabList,
  Table,
  Title,
  Toggle,
  Video,
  VideoContainer,
  useClientSideSearch,
  usePagination
};
//# sourceMappingURL=alchemy.es.js.map
